/* "use strict"; */
angular.module("ngModules", [
  "ngCookies",
  "ngSanitize",
  "ngMessages",
  "ngResource",
  "ngAnimate"
]);
angular.module("ui.bootstap.fam", ["ui.bootstrap", "ui.bootstrap.position"]);
angular.module("minovate", [
  "ngTouch",
  "picardy.fontawesome",
  "angular-loading-bar",
  "angular-momentjs",
  "FBAngular",
  "angularBootstrapNavTree",
  "oc.lazyLoad",
  "ui.select",
  "ui.tree",
  /* "textAngular", */
  "colorpicker.module",
  "angularFileUpload",
  "ngImgCrop",
/*   "datatables",
  "datatables.bootstrap",
  "datatables.colreorder",
  "datatables.colvis",
  "datatables.tabletools",
  "datatables.scroller",
  "datatables.columnfilter", */
  "ui.grid",
  "ui.grid.resizeColumns",
  "ui.grid.edit",
  "ui.grid.moveColumns",
  /* "ngTable", */
  /* "smart-table", */
  "angular-flot",
  /* "angular-rickshaw", */
  "easypiechart",
/*   "uiGmapgoogle-maps", */
  "ui.calendar",
  "ngTagsInput",
  "ngMaterial",
  "localytics.directives",
  "leaflet-directive",
/*   "wu.masonry", */
  "ipsum",
  "angular-intro",
  "dragularModule",
  "ngDraggable",

  "formly",
  "formlyBootstrap",
  "chart.js",
  "treeGrid"
]);
angular.module("utils", [
  "ui.router",
  "ui.router.state.events",
  "toastr",
  "pascalprecht.translate",
  "ui.utils"
]);

var webapp = angular.module("salevis4-web", [
  "ngModules",
  "ui.bootstap.fam",
  "minovate",
  "utils",
  "AuthServices",
  "as.sortable",
  "fa.directive.borderLayout"
]);


webapp
  .run([
    "$rootScope",
    "$state",
    "$stateParams",
    "$window",
    "$translate",
    "$http",
    "$transitions",
    "Auth",
    "$filter",
    function($rootScope, $state, $stateParams, $window, $translate, $http, $transitions, Auth, $filter) {
      $rootScope.$state = $state;
      $rootScope.$stateParams = $stateParams;
      $rootScope.safeApply = safeApply;

      if (!$window.sessionStorage.getItem("layoutBoard")) {
        $window.sessionStorage.setItem("layoutBoard", 'N');// Layout 기본을 N에서 H로 변경
      }

      if (!$window.sessionStorage.getItem("layoutBoardSize")) {
        $window.sessionStorage.setItem("layoutBoardSize", "40% + 2px");
      }

      $rootScope.gVariable = {
        totalItemChatComm: 0,
        totalItemTaskComm: 0,
        totalItemNotiComm: 0,
        totalItemComm: 0,
        alertMessage: "",
        UserId: $window.sessionStorage.getItem("loginUserIdx"),
        UserName: $window.sessionStorage.getItem("loginUserName"),
        TenantId: $window.sessionStorage.getItem("loginTenantId"),
        DeptId: $window.sessionStorage.getItem("loginUserDeptId"),
        DeptNm: $window.sessionStorage.getItem("loginUserDeptNm"),
        SysAdminYN: $window.sessionStorage.getItem("loginSysAdminYN"),
        TenantName: $window.sessionStorage.getItem("loginTenantName"),
        TenantDir: $window.sessionStorage.getItem("loginTenantDir"),
        Email: $window.sessionStorage.getItem("loginEmail"),
        Mobile: $window.sessionStorage.getItem("loginMobile"),
        TelNo: $window.sessionStorage.getItem("loginTelNo"),
        userType: $window.sessionStorage.getItem("loginUserType"),
        userKey: $window.sessionStorage.getItem("userkey") + '-' + $window.sessionStorage.getItem("loginTenantId"),
        autoUpdate: false,
        selectedShop: null,
        srchTenantId: $window.sessionStorage.getItem("srchTenantId"),
        srchTenantName: $window.sessionStorage.getItem("srchTenantName"),
        layoutBoard:$window.sessionStorage.getItem("layoutBoard"),
        layoutBoardSize:$window.sessionStorage.getItem("layoutBoardSize"),
        dataGroupId: $window.sessionStorage.getItem("dataGroupId"),
        dataGroupNm: $window.sessionStorage.getItem("dataGroupNm"),
        dataActionId: $window.sessionStorage.getItem("dataActionId"),
        dataActionNm: $window.sessionStorage.getItem("dataActionNm"),
        noHeader: $window.sessionStorage.getItem("noHeader"),
        mainPage: $window.sessionStorage.getItem("mainPage"),
        listKeyId : null
      };

      $rootScope.getSelectShopDescription = function() {
        if ($rootScope.gVariable.selectedShop) {
          return $rootScope.gVariable.selectedShop.DatagroupNm + ':' + $filter('utcToLocal')($rootScope.gVariable.selectedShop.BeginDate,'yyyy-MM-dd h:mm a') + '~' + $filter('utcToLocal')($rootScope.gVariable.selectedShop.EndDate,'yyyy-MM-dd h:mm a');
        }

        return "";
      };

      $rootScope.dataloader = false;

      $rootScope.$on('$viewContentLoaded', function(event, viewName, viewContent){
        angular.element("html, body, #content").animate({
            scrollTop: 0
          }, 200);

        setTimeout(function() {
          angular.element("#wrap").css("visibility", "visible");

          if (!angular.element(".dropdown").hasClass("open")) {
            angular.element(".dropdown").find(">ul").slideUp();
          }
        }, 200);
      });

      $transitions.onSuccess({}, function(event, toState) {
        $http.defaults.headers.common["Content-Type"] = "application/json; charset=utf-8";
        $http.defaults.headers.common["Accept"] = "application/json, text/html";
      });

      $rootScope.$on("$stateChangeSuccess", function(event, toState) {
        //console.log('$stateChangeSuccess toState=', toState);
      });

      $rootScope.$on("$locationChangeStart", function(event, next) {
        //console.log('$locationChangeStart next=', next);
      });

      $rootScope.$on('$stateChangeStart', function(event, next, current) {
        //console.log('$stateChangeStart next=', next);
        // 모바일 중간보고를 위한 임시 처리
        // 모바일 경우 세션이 없을 경우에도 페이지를 열어야하기 때문에
        // 방법을 모색해야함
        if(!checkMobile()) {
          var URL = location.href.toString();
          if(URL.indexOf("#/m/") == -1 && URL.indexOf("#/apps/") == -1) {
            if (!Auth.checkPermissionForView(next)){
              event.preventDefault();
              //alert('cannot access : ' + next.name);
              alert('접근 권한이 없습니다');
            }
          }
        }
      });

      $rootScope.changeLanguage = function(langKey) {
        $translate.use(langKey);
        $rootScope.currentLanguage = langKey;
        $window.sessionStorage.setItem("currentLanguage", langKey);
      };
      $rootScope.currentLanguage =
        $translate.proposedLanguage() ||
        $translate.use() ||
        $window.sessionStorage.getItem("currentLanguage");

      if ($rootScope.currentLanguage == null || $rootScope.currentLanguage == "") {
        $rootScope.changeLanguage("ko");
      }

      $rootScope.changeLayout = function(layout) {
        $window.sessionStorage.setItem("layoutBoard", layout);
        $rootScope.gVariable.layoutBoard = layout;
        $window.sessionStorage.setItem("layoutBoardSize", "40% + 2px");
        $rootScope.gVariable.layoutBoardSize = "40% + 2px";
      };

      $rootScope.setGVariable = function(key, value) {
        $window.sessionStorage.setItem(key, value);
        $rootScope.gVariable[key] = value;
      };

      function safeApply(fn) {
        var phase = this.$root.$$phase;
        if (phase !== "$digest" && phase !== "$apply") {
          this.$apply(fn);
          return;
        }
        if (fn && typeof fn === "function") fn();
      }

      $rootScope.getImageUrl = function(fileName, tenantId, filePath) {
        console.log(fileName);
        
        if (!fileName) return "";

        return API_HTTP_PROTOCOL + '//' + API_SERVER_DOMAIN + ':' +
          API_SERVER_PORT + '/openapi/attach/' + tenantId + '/' + filePath + '/' + fileName + '/image.do';
      };

      // 엑셀 설정
      // 다중 시트 기능 추가 2020-01-20 hansol
      $rootScope.excelDown = function(exportData, fileName, sheetNames) {
        function datenum(v, date1904) {

          if (date1904) v+=1462;
          var epoch = Date.parse(v);
          var gmt = 0.375;

          return ((epoch - new Date(Date.UTC(1899, 11, 30))) / (24 * 60 * 60 * 1000))+gmt;
        }

        function getSheet(data) {
          var ws = {};
          var range = {s: {c:10000000, r:10000000}, e: {c:0, r:0 }};
          var mergeList = [];
      
          for (var R = 0; R != data.length; ++R) {
              for (var C = 0; C != data[R].length; ++C) {
                  if(range.s.r > R) range.s.r = R;
                  if(range.s.c > C) range.s.c = C;
                  if(range.e.r < R) range.e.r = R;
                  if(range.e.c < C) range.e.c = C;
                  var cell = {v: data[R][C] };
                  if(cell.v == null) continue;
                  var cell_ref = XLSX.utils.encode_cell({c:C,r:R});
      
                  // 셀병합 기능 추가 2020-01-22 hansol
                  var doMerge = false;
                  var chgVal = false;
                  var sR = R, sC = C, eR = R, eC = C;
                  switch(cell.v){
                      case 'rspan_up' : doMerge = (R > 0); sR = R-1; break;
                      case 'rspan_dw' : doMerge = (R < data.length);  chgVal = true; eR = R+1; break;
                      case 'cspan_lf' : doMerge = (C > 0); sC = C-1; break;
                      case 'cspan_rt' : doMerge = (C < data[R].length); chgVal = true; break;
                  }
                  if(cell.v == 'cspan_lf' || cell.v == 'cspan_rt') {
                      for(var col = C+1; col != data[R].length; ++col){
                          if(data[R][col] == 'cspan_lf') {
                              ++eC;
                              data[R][col] = ''; // 값을 비우지 않으면 엑셀 다운로드시 오류 발생
                          }
                          else break;
                      }
                  }
                  if(doMerge) mergeList.push({s: {r:sR, c:sC}, e: {r:eR, c:eC}});
                  if(chgVal) cell.v = data[eR][eC];
      
                  if(typeof cell.v === 'number') cell.t = 'n';
                  else if(typeof cell.v === 'boolean') cell.t = 'b';
                  else if(cell.v instanceof Date) {
                      cell.t = 'n'; cell.z = XLSX.SSF._table[14];
                      cell.v = datenum(cell.v);
                  }
                  else cell.t = 's';     
      
                  ws[cell_ref] = cell;
              }
          }
      
          // 셀병합 기능 추가 2020-01-22 hansol
          // 시트 생성 후 병합 정보 추가
          if(mergeList.length > 0){ 
              mergeList.forEach(function (m){
                  if ( ! ws['!merges']) ws['!merges'] = [];
                  ws['!merges'].push(m);
              });
          }
      
          if(range.s.c < 10000000) ws['!ref'] = XLSX.utils.encode_range(range);
          return ws;
      }

         function Workbook() {
            if(!(this instanceof Workbook)) return new Workbook();
            this.SheetNames = [];
            this.Sheets = [];
          }

          var wb = new Workbook();
          var ws;

          /* add worksheet to workbook */

          // 시트가 여러개인 경우
          if (exportData.length > 1 && sheetNames != null && sheetNames.length > 1) {
            wb.SheetNames = sheetNames;
            exportData.forEach(function(d,i){
              ws = getSheet(d);
              wb.Sheets[sheetNames[i]] = ws;
            });
          }
          // 시트가 하나인 경우
          else {
            wb.SheetNames.push(fileName);
            ws = getSheet(exportData);
            wb.Sheets[fileName] = ws;
          }

          var wbout = XLSX.write(wb, {bookType:'xlsx', bookSST:true, type: 'binary'});

          function s2ab(s) {
            var buf = new ArrayBuffer(s.length);
            var view = new Uint8Array(buf);
            for (var i=0; i!=s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
            return buf;
          }

        saveAs(new Blob([s2ab(wbout)],{type:"application/octet-stream"}), fileName+'.xlsx');

      };
    }
  ])

  .config([
    "uiSelectConfig",
    function(uiSelectConfig) {
      uiSelectConfig.theme = "bootstrap";
    }
  ])

  .config([
    "$mdThemingProvider",
    function($mdThemingProvider) {
      var agent = navigator.userAgent.toLowerCase();
      if ( (navigator.appName == 'Netscape' && agent.indexOf('trident') != -1) || (agent.indexOf("msie") != -1)) {
        $mdThemingProvider.alwaysWatchTheme(false);    // ie일 경우
        $mdThemingProvider.disableTheming(true);
      }

    }
  ])

  .config(function inputDirectiveConfig($provide) {
    //키 입력 이벤트는 compostionstart->compostionupdate->compositonend로 진행된다.
    $provide.decorator('inputDirective', function($delegate, $log) {
      var directive = $delegate[0];
      angular.extend(directive.link, {
        post : function(scope, element, attr, ctrls) {
          element.on('compositionupdate', function(event) {
            //                  $log.debug('composition update 이벤트 발생, 강제 종료');
            element.triggerHandler('compositionend');
          });
        }
      });
      return $delegate;
    });
  })

  //angular-language
  .config([
    "$translateProvider",
    function($translateProvider) {
      $translateProvider.useStaticFilesLoader({
        prefix: "languages/",
        suffix: ".data"
      });
      $translateProvider.useLocalStorage();
      $translateProvider.preferredLanguage("ko");
      $translateProvider.useSanitizeValueStrategy(null);
    }
  ])
  ;

webapp.directive("krInput", ["$parse", function($parse) {
    return {
      priority: 2,
      restrict: "A",
      compile: function(element) {
        element.on("compositionstart", function(e) {
          e.stopImmediatePropagation();
        });
      }
    };
  }
]);

/**
 * 숫자와 하이픈(-)만 입력 가능하도록 처리 (e.g. 전화번호)
 *
 * @param {string} - 사용자 입력값
 * @return {boolean} - 숫자와 하이픈 값만 추출하여 반환
 */
webapp.directive('numbersHyphen', function () {
  return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModelCtrl) {
      function fromUser(text) {
        if (text) {
          var transformedInput = text.replace(/[^0-9_-]/g, "");
          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        return undefined;
      }

      ngModelCtrl.$parsers.push(fromUser);
    }
  };
});

/**
 * 숫자만 입력 가능하도록 처리 (e.g. 금액)
 *
 * @param {string} - 사용자 입력값
 * @return {boolean} - 숫자 값만 추출하여 반환
 */
webapp.directive('numbersOnly', function () {
  return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModelCtrl) {
      function fromUser(text) {
        if (text) {
          var transformedInput = text.replace(/[^0-9]/g, '');

          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        return undefined;
      }

      ngModelCtrl.$parsers.push(fromUser);
    }
  };
});

/**
 * 숫자 입력시 3자리 마다 콤마 처리 (e.g. 금액)
 *
 * @param {string} - 사용자 입력값
 * @return {boolean} - 숫자 값에 콤마처리 하여 반환
 */
webapp.directive('comma', function ($filter) {
  'use strict';
  return {
    scope: {
      ngModel: "=",
      ngBind: "="
    },
    require: 'ngModel',
    link: function (scope, elem, attrs, ctrl) {
      if (!ctrl) return;

      function checkValidate(P) {
        var splitSize = P.split(".").length;
        if (splitSize > 2) return false;

        var diff = P.replaceAll(".", "").replaceAll(",", "");
        var transformedInput = P.replace(/[^0-9]/g, '');

        if (transformedInput !== diff) return false;
        else return true;
      }

      function nf(T) {
        T = T.replace(/[^0-9]/g, '').toString();
        //T = Number(T)
        return T.toString();
      }

      function setComma(T) {
        return T.replace(/[^\d]+/g, '').replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,').toString();
      }

      ctrl.$formatters.unshift(function (viewValue) {

        if (viewValue) {
          var checkMinus = false;
          if (viewValue.toString().charAt(0) == "-") checkMinus = true;

          var result, parts;
          parts = viewValue.split(".");
          result = nf(parts[0]);
          result = setComma(result);
          if (parts.length > 1) {

            result += "." + nf(parts[1]).substring(0, 2);
            //result +=  "." + parts[1].substring(0,2);
          }

          if (checkMinus) result = "-" + result;

          var b = result;
          elem.val(b);
          return result;
        }
      });

      ctrl.$parsers.unshift(function (viewValue) {
        var temp, result = "", parts;
        parts = viewValue.split(".");
        temp = nf(parts[0]);
        temp = setComma(temp);
        if (parts.length > 1) temp += "." + nf(parts[1]).substring(0, 2);
        for (var i = 0; i < temp.length; i++) {
          var atChar = temp.charAt(i);
          if (atChar == "," || atChar == "." || !isNaN(atChar)) {
            result += "" + atChar;
          }
        }

        var b = result;
        elem.val(b);
        return result.replaceAll(",", "");
      });
    }
  };
}).directive('numberonly', function ($filter) {
  'use strict';
  return {
    scope: {
      ngModel: "=",
      ngBind: "="
    },
    require: 'ngModel',
    link: function (scope, elem, attrs, ctrl) {
      if (!ctrl) return;

      function nf(T) {
        T = T.replace(/[^0-9]/g, '').toString();
        return T.toString();
      }

      ctrl.$formatters.unshift(function (viewValue) {
        if (viewValue) {
          var result = nf(viewValue);
          var b = result;
          elem.val(b);
          return result;
        }
      });

      ctrl.$parsers.unshift(function (viewValue) {
        var temp, result = "";
        temp = nf(viewValue);
        for (var i = 0; i < temp.length; i++) {
          var atChar = temp.charAt(i);
          if (!isNaN(atChar)) {
            result += "" + atChar;
          }
        }

        var b = result;
        elem.val(b);
        return result;
      });
    }
  };
}).directive('commaBind', function () {
  'use strict';
  return {
    restrict: 'A',
    scope: {
      ngBind: '='
    },
    link: function (scope, elem) {

      function checkValidate(P) {

        var splitSize = P.split(".").length;
        if (splitSize > 2) return false;

        var diff = P.replaceAll(".", "").replaceAll(",", "");
        var transformedInput = P.replace(/[^0-9]/g, '');

        if (transformedInput !== diff) return false;
        else return true;
      }

      function nf(T) {
        return T.replace(/[^0-9]/g, '').toString();
      }

      function setComma(T) {
        return T.replace(/[^\d]+/g, '').replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,').toString();
      }

      scope.$watch('ngBind', function (newVal) {

        if (newVal !== undefined && newVal !== null) {

          var checkMinus = false;
          if (newVal.toString().charAt(0) == "-") checkMinus = true;
          var parts;
          parts = newVal.toString().split(".");
          var temp = parts[0].toString().replace(/[^\d]+/g, '').replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
          if (parts.length > 1) temp += '.' + nf(parts[1]).substring(0, 2);
          if (checkMinus) temp = "-" + temp;
          if ($(elem).is("input")) angular.element(elem).val(temp);
          else angular.element(elem).html(temp);
        }
      });
    }
  };
});

/**
 * 자동 하이픈 처리 (e.g. 휴대번호 / 전화번호 - 02 예외처리)
 *
 * @param {string} - 사용자 입력값
 * @return {boolean} - 숫자 값에 하이픈처리 하여 반환
 */
webapp.directive('autoHyphen', function ($filter) {
  'use strict';
  return {
    scope: {
      ngModel: "=",
      ngBind: "="
    },
    require: 'ngModel',
    link: function (scope, elem, attrs, ctrl) {
      if (!ctrl) return;

      function checkValidate(P) {
        var splitSize = P.length;
        if (splitSize > 14) return false;

        var diff = P.replaceAll("-", "");
        var transformedInput = P.replace(/[^0-9]/g, '');

        if (transformedInput !== diff) return false;
        else return true;
      }

      function nf(str) {
        str = str.replace(/[^0-9]/g, '').toString();
        return str.toString();
      }

      function autoHypenTel(str){

        str = str.replace(/[^0-9]/g, '');
        var tmp = '';
        
        if (str.substring(0, 1) == '1') {
          if (str.length < 5) {
            return str;
          } else {
            tmp += str.substr(0, 4);
            tmp += '-';
            tmp += str.substr(4, 4);
            return tmp;
          }
        } else if (str.substring(0, 2) == '02') {
          if (str.length < 3) {
            return str;
          } else if (str.length < 6) {
            tmp += str.substr(0, 2);
            tmp += '-';
            tmp += str.substr(2);
            return tmp;
          } else if (str.length < 10) {
            tmp += str.substr(0, 2);
            tmp += '-';
            tmp += str.substr(2, 3);
            tmp += '-';
            tmp += str.substr(5);
            return tmp;
          } else {
            tmp += str.substr(0, 2);
            tmp += '-';
            tmp += str.substr(2, 4);
            tmp += '-';
            tmp += str.substr(6, 4);
            return tmp;
          }
        } else if (str.substring(0, 4) == '0505') {
          if (str.length < 5) {
            return str;
          } else if (str.length < 9) {
            tmp += str.substr(0, 4);
            tmp += '-';
            tmp += str.substr(4, 4);
            return tmp;
          } else { 
            tmp += str.substr(0, 4);
            tmp += '-';
            tmp += str.substr(4, 4);
            tmp += '-';
            tmp += str.substr(8);
            return tmp;
          }
        } else {
          if (str.length < 4) {
            return str;
          } else if (str.length < 7) {
            tmp += str.substr(0, 3);
            tmp += '-';
            tmp += str.substr(3);
            return tmp;
          } else if (str.length < 11) {
            tmp += str.substr(0, 3);
            tmp += '-';
            tmp += str.substr(3, 3);
            tmp += '-';
            tmp += str.substr(6, 4);
            return tmp;
          } else if (str.length < 12) {
            tmp += str.substr(0, 3);
            tmp += '-';
            tmp += str.substr(3, 4);
            tmp += '-';
            tmp += str.substr(7);
            return tmp;
          } else {
            return str;
          }
        }
      }

      ctrl.$formatters.unshift(function (viewValue) {
        if (viewValue) {
          var result;
          result = nf(viewValue);
          result = autoHypenTel(result);

          var b = result;
          elem.val(b);

          $(elem).attr('maxlength', 20);
          
          return result;
        }
      });

      ctrl.$parsers.unshift(function (viewValue) {
        var temp, result = "";
        temp = nf(viewValue);
        temp = autoHypenTel(temp);
        for (var i = 0; i < temp.length; i++) {
          var atChar = temp.charAt(i);
          if (atChar == "-" || !isNaN(atChar)) {
            result += "" + atChar;
          }
        }

        var b = result;
        elem.val(b);
        return result.replaceAll("-", "");
      });
    }
  };
});



webapp.run(function ($rootScope, $window, $resource, StaticVariable, GLOBAL_CONSTANT, $mdToast, $filter) {
  $rootScope.windowOpen = function (url, name, w, h) {
    //TODO : your custom code here.
    if (angular.isUndefined(w)) w = 1000;
    if (angular.isUndefined(h)) h = 800;

    var dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
    var dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

    var width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    var height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    var left = ((width / 2) - (w / 2)) + dualScreenLeft;
    var top = ((height / 2) - (h / 2)) + dualScreenTop;

    if (left < 0) left = 0;
    if (top < 0) top = 0;

    console.log('$window.open(', 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left + ')');
    $window.open(url, name, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);
  };

//yyyy-mm-dd > new Date 형태로 변환
  $rootScope.getDateFormat = function(dateStr) {
    var dateArr;

    if (typeof(dateStr) == "undefined") {
      return null;
    }
    else {
      dateArr = dateStr.split("-");
    }

    if (dateArr.length == 3) {
      return new Date(dateArr[0], parseInt(dateArr[1]) - 1, dateArr[2]);
    }
    else {
      return null;
    }
  };

  $rootScope.getDate = function(date) {
    if (!date) return null;

    return new Date(date);
  };

  $rootScope.setUserSession = function(data) {
    $window.sessionStorage['isLoggedIn'] = 'Y';
    $window.sessionStorage['loginUserId'] = data.loginId;
    $window.sessionStorage['loginUserIdx'] = data.userId;
    $window.sessionStorage['loginSysAdminYN'] = data.sysAdminYN;
    $window.sessionStorage['loginUserName'] = data.userName;
    $window.sessionStorage['loginUserGbn'] = data.userGroupId;
    $window.sessionStorage['loginUserDeptNm'] = data.DeptNm;
    $window.sessionStorage['loginUserDeptId'] = data.DeptId;
    $window.sessionStorage['loginComGbn'] = data.company;
    $window.sessionStorage['loginUserType'] = data.userType;
    $window.sessionStorage['loginUserEmail'] = data.email;
    $window.sessionStorage['loginTenantId'] = data.TenantId == null ? 0 : data.TenantId;
    $window.sessionStorage['loginTenantName'] = data.TenantName;
    $window.sessionStorage['loginTenantDir'] = data.TenantDir == null ? null : data.TenantDir;
    $window.sessionStorage['loginEmail'] = data.Email;
    $window.sessionStorage['loginTelNo'] = data.TelNo;
    $window.sessionStorage['loginMobile'] = data.Mobile;
    $window.sessionStorage['noHeader'] = data.noHeader == null ? false : data.noHeader;
    $window.sessionStorage['mainPage'] = data.mainpage == null ? 'app.dashboard' : data.mainpage;
    $window.sessionStorage['loginTenantType'] = data.MenuTypes == null ? '' : data.MenuTypes;
    $window.sessionStorage['loginUserCityCodeList'] = data.CityCodeList;
    $window.sessionStorage['loginUserAdminType'] = data.AdminType;
    $window.sessionStorage['isCommentAdmin'] = data.CommentAdminYN;
    $window.sessionStorage['loginUserAiAdminYN'] = data.AiAdminYN;
    $window.sessionStorage['loginUserEvalAdminYN'] = data.EvalAdminYN;

    $rootScope.gVariable.UserId = $window.sessionStorage['loginUserIdx'];
    $rootScope.gVariable.TenantId = $window.sessionStorage['loginTenantId'];
    $rootScope.gVariable.TenantName = $window.sessionStorage['loginTenantName'];
    $rootScope.gVariable.TenantDir = $window.sessionStorage['loginTenantDir'];
    $rootScope.gVariable.SysAdminYN = $window.sessionStorage['loginSysAdminYN'];
    $rootScope.gVariable.Email = $window.sessionStorage['loginEmail'];
    $rootScope.gVariable.TelNo = $window.sessionStorage['loginTelNo'];
    $rootScope.gVariable.UserName = $window.sessionStorage['loginUserName'];
    $rootScope.gVariable.userType = $window.sessionStorage['loginUserType'];
    $rootScope.gVariable.DeptNm = $window.sessionStorage['loginUserDeptNm'];
    $rootScope.gVariable.DeptId = $window.sessionStorage['loginUserDeptId'];
    $rootScope.gVariable.Mobile = $window.sessionStorage['loginMobile'];
    $rootScope.gVariable.noHeader = $window.sessionStorage['noHeader'];
    $rootScope.gVariable.mainPage = $window.sessionStorage['mainPage'];
    $rootScope.gVariable.TenantType = $window.sessionStorage['loginTenantType'];
    $rootScope.gVariable.CityCodeList = $window.sessionStorage['loginUserCityCodeList'];
    $rootScope.gVariable.AdminType = $window.sessionStorage['loginUserAdminType'];
    $rootScope.gVariable.CommentAdminYN = $window.sessionStorage['isCommentAdmin'];
    $rootScope.gVariable.AiAdminYN = $window.sessionStorage['loginUserAiAdminYN'];
    $rootScope.gVariable.EvalAdminYN = $window.sessionStorage['loginUserEvalAdminYN'];


    if (data.userkey) {
      $window.sessionStorage['userkey'] = data.userkey;
      $rootScope.gVariable.userKey = $window.sessionStorage['userkey'] + '-' + $window.sessionStorage['loginTenantId'];
    }
    //console.log($window.sessionStorage);
  };

  $rootScope.setDefaultSelectedShop = function() {
    var srch = {viewSize:1, page:1, UseYN:'Y'};

    var prms = $resource(StaticVariable.getUrl('/select/MaDatagroup.getDatagroupList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction()).post(srch).$promise;

    prms.then(
    function(data) {
      if (data.responseVO.header.status == GLOBAL_CONSTANT.HttpStatus.OK) {
        // select한 datatable 바인딩
        $rootScope.gVariable.selectedShop = data.responseVO.body.docs[0];
      }
    },
    function(error) {
      //console.error('fail', status, data);
      console.error("Error> setDefaultSelectedShop()");
      console.table(error);
    });
  };

  $rootScope.showSimpleToast = function(msg, p1, p2) {
    var position = "";
    var delay = 1200;
    if(p1 == undefined) {
      var classTx = "header-toast";
      $mdToast.show(
        $mdToast.simple({
          template: '<md-toast class="md-toast ' + classTx +'">' +
          '<div class="md-toast-content">' + msg + '</div></md-toast>',
          position: "top left",
          hideDelay : delay
        })
      );
    } else if(p1.indexOf("#") > -1) {
      if(p2 != undefined) p2 = position;
      else p2 = "top left";
      $mdToast.show(
        $mdToast.simple()
        .parent(angular.element(document.querySelector(p1)))
        .content(msg)
        .position(p2)
        .hideDelay(delay)
      );
    } else {
      var classTx = "";
      if (p1 == undefined) {
        classTx = "header";
      } else if(p1.toLowerCase() == "header" || p1.toLowerCase() == "footer") {
        classTx = p1 + "-toast";
      } else {
        position = p1;
      }

      if(classTx == "") {
        $mdToast.show(
          $mdToast.simple()
          .content(msg)
          .position(position)
          .hideDelay(delay)
        );
      } else {
        var position = "";
        if(p1.toLowerCase() == "footer") position = "bottom left";
        else position = "top left";
        $mdToast.show(
          $mdToast.simple({
            template: '<md-toast class="md-toast ' + classTx +'">' +
            '<div class="md-toast-content">' + msg + '</div></md-toast>',
            position: position,
            hideDelay : delay
          })
        );
      }
    }
  };

  $rootScope.listColumFilter = function(liCol) {
    if (liCol.ListColumnShowLevel == 'showlevel0') {
      return false;
    }

    return true;
  };

  $rootScope.listColumnCount = function(listColumns) {
    var l = 0;
    angular.forEach(listColumns, function(item) {
      if (item.ListColumnShowLevel != 'showlevel0') {
        l++;
      }
    });

    return l;
  };

  $rootScope.getCodeValue = function(CodeList, CodeValue) {
    if (CodeList == null || CodeValue == null) {
      return "";
    }

    for (var i = 0; i < CodeList.length; i++) {
      if (CodeList[i].Code == CodeValue) {
        return CodeList[i].CodeValue;
      }
    }

    return "";
  };

  $rootScope.$on('$locationChangeSuccess', function () {
    if (typeof resetChatBotPosition === 'function') {
      resetChatBotPosition();
    }
  });
});

(function () {
  'use strict';

  angular
    .module('salevis4-web')
    .config(toastrConfig)
    .config(translateConfig)
    .config(formlyConfig);

  /** @ngInject */
  function toastrConfig($logProvider, toastrConfig) {
    // Enable log
    $logProvider.debugEnabled(true);

    // Set options third-party lib
    toastrConfig.allowHtml = true;
    toastrConfig.timeOut = 3000;
    toastrConfig.positionClass = 'toast-top-right';
    toastrConfig.preventDuplicates = true;
    toastrConfig.progressBar = true;
  }

  /** @ngInject */
  function translateConfig($translateProvider) {
    $translateProvider.useSanitizeValueStrategy('sanitizeParameters');
    $translateProvider.useStaticFilesLoader({
      prefix: '/assets/i18n/lang-',
      suffix: '.data'
    });
    $translateProvider.preferredLanguage('ko');
  }
   /** @ngInject */
  function formlyConfig(formlyConfigProvider) {
    // Replace formlyBootstrap bootstrapLabel wrapper to implement horizontal forms
    formlyConfigProvider.removeWrapperByName('bootstrapLabel');
    formlyConfigProvider.setWrapper({
      name : 'bootstrapLabel',
      templateUrl : 'label-wrapper.html'
    });

    // Replace formlyBootstrap input field type to implement read-only forms
    formlyConfigProvider.setType({
      name : 'readOnly',
      templateUrl : 'input-template.html',
      wrapper : [ 'bootstrapLabel', 'bootstrapHasError' ],
      overwriteOk : true
    });
  }

})();

(function() {
  "use strict";

  webapp.constant("MAIN", {
    APP_NAME: "Salevis4-web Manager"
  });
})();

(function () {
  "use strict";

  //var checkdTarget = window.location.href.split('//')[1].split("/")[1].replace("#","");
  var checkdTarget;
  var checkMobile = false;

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider, $windowProvider, $locationProvider) {
    var $window = $windowProvider.$get();
    if(location.href.indexOf("/apps/") == -1) {
      if (!angular.isUndefined($window.sessionStorage['isLoggedIn']) && $window.sessionStorage['isLoggedIn'] === 'Y') {
        var mainPage = $window.sessionStorage.getItem("mainPage");
        $urlRouterProvider.otherwise(function($injector, $location) {
          $injector.get('$state').go(mainPage);
        });
      } else {
        $urlRouterProvider.otherwise('/login');
      }
    } else {
      var targetApp = location.href.split("#/apps/")[1];
      $window.sessionStorage['USE_APPTYPE'] = targetApp;
    }

    $stateProvider
      .state("app",     { url: "/app", component: "app"})
      .state("m",       { url: "/m", component: "mApp"})
      .state("login",   { url: "/login", component: "login"})
      .state("logout",   { url: "/logout", component: "logout"})
      .state("signup",  { url: "/signup", component: "signupStepOne"})
      .state("signup2", { url: "/signup/:srch", component: "signupStepTwo"})
      .state("reserve", { url: "/reserve", component: "reserve"})
      .state("apps",    { url: "/apps/:targetApp", component: "branchApps" })
      .state("signupTenant",    { url: "/signupTenant", component: "signupTenant" })
      .state("signupFirst",    { url: "/signupFirst/:srch", component: "signupFirst" })
      .state("signupSecond",    { url: "/signupSecond/:srch", component: "signupSecond" })
      .state("login.notice",   { url: "/notice?srch", component: "notice"})
      .state("login.faq",   { url: "/faq?srch", component: "faq"})
      .state("login.qna",   { url: "/qna?srch", component: "qna"})
      .state("print-take",   { url: "/print-take?keyId", component: "printTake"})
      .state("login.termsOfService2021",   { url: "/termsOfService_2021?srch", component: "termsOfService2021"})
      .state("login.termsOfService",   { url: "/termsOfService?srch", component: "termsOfService"})
      .state("login.privacyPolicy2021",   { url: "/privacyPolicy_2021?srch", component: "privacyPolicy2021"})
      .state("login.privacyPolicy2022",   { url: "/privacyPolicy_2022?srch", component: "privacyPolicy2022"})
      .state("login.privacyPolicy",   { url: "/privacyPolicy?srch", component: "privacyPolicy"})
      .state("login.emailCollection",   { url: "/emailCollection?srch", component: "emailCollection"});
  }
})();

(function() {
  "use strict";

  webapp.run(runBlock);

  /** @ngInject */
  function runBlock($log, $rootScope, $translate, $transitions, $http, $timeout) {
    // $http.defaults.withCredentials = true;
    $http.defaults.headers.common["Content-Type"] =
      "application/json; charset=utf-8";
    $http.defaults.headers.common.Accept = "application/json, text/html";

    $transitions.onStart({}, onStart);
    $transitions.onSuccess({}, onSuccess);

    /** @ngInject */
    function onStart(trans) {
      var $state = trans.router.stateService;
      //$log.info("[onStart name]::", $state.current.name);
      $rootScope.dataloader = true;
      //console.log('onStart');
    }

    /** @ngInject */
    function onSuccess(trans) {
      var $state = trans.router.stateService;
      $state.getCurrentPath().forEach(function(element) {
       // $log.info("[onSuccess name]::", element.state.name);
      });

      if(appConfigData.menuPoisition == undefined) {
        $("html").addClass("sidebar-default");
      } else {
        if(appConfigData.menuPoisition == "default") {
          $("html").addClass("sidebar-default");
        } else if(appConfigData.menuPoisition == "top1") {
          $("html").addClass("sidebar-on-top1");
        } else if(appConfigData.menuPoisition == "top2") {
          $("html").addClass("sidebar-on-top2");
        }
      }


      if($("body").attr("nav-state") == undefined) {
        if( !$("html").hasClass("isOnlyDevice") )
        initPageNavState();
      }

      $timeout(function(){
        initViewLoadedInputBoxStyle();
        initPageContentMinHeight();
        initLabelTitle();
        // initSzRequired();
      });

      setTimeout(function() {
        $rootScope.dataloader = false;
        $rootScope.title = $translate.instant('PRODUCT.TITLE');
      }, 200);

      //console.log('onStop');
    }
  }

  function initPageNavState() {
    var winWidth = $(window).width();
    if (winWidth < 560) $("body").attr("nav-state", "xs-off");
    else if (winWidth < 768) $("body").attr("nav-state", "sm-off");
    else if (winWidth > 767 ) {
      var localStorage = window.localStorage;
      var navState = localStorage.getItem("navMenuMdSizeState");

      if(navState == null || navState == undefined || navState == "on" || navState == "off") {
        navState = "l";
        localStorage.setItem('navMenuMdSizeState', navState);
      }
      $("body").attr("nav-state", "md-" + navState);
    }
    //setToggleImage();
  }
})();
// ui-router login example
// $transitions.onStart( { to: 'auth.**' }, function(trans) {
//     var $state = trans.router.stateService;
//     var MyAuthService = trans.injector().get('MyAuthService');
//     // If the user is not authenticated
//     if (!MyAuthService.isAuthenticated()) {
//       // Then return a promise for a successful login.
//       // The transition will wait for this promise to settle
//       return MyAuthService.authenticate().catch(function() {
//         // If the authenticate() method failed for whatever reason,
//         // redirect to a 'guest' state which doesn't require auth.
//         return $state.target("guest");
//       });
//     }
//   });

!function(i){"use strict";"function"==typeof define&&define.amd?define(["jquery"],i):"undefined"!=typeof exports?module.exports=i(require("jquery")):i(jQuery)}(function(i){"use strict";var e=window.Slick||{};(e=function(){var e=0;return function(t,o){var s,n=this;n.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:i(t),appendDots:i(t),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return i('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},n.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},i.extend(n,n.initials),n.activeBreakpoint=null,n.animType=null,n.animProp=null,n.breakpoints=[],n.breakpointSettings=[],n.cssTransitions=!1,n.focussed=!1,n.interrupted=!1,n.hidden="hidden",n.paused=!0,n.positionProp=null,n.respondTo=null,n.rowCount=1,n.shouldClick=!0,n.$slider=i(t),n.$slidesCache=null,n.transformType=null,n.transitionType=null,n.visibilityChange="visibilitychange",n.windowWidth=0,n.windowTimer=null,s=i(t).data("slick")||{},n.options=i.extend({},n.defaults,o,s),n.currentSlide=n.options.initialSlide,n.originalSettings=n.options,void 0!==document.mozHidden?(n.hidden="mozHidden",n.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(n.hidden="webkitHidden",n.visibilityChange="webkitvisibilitychange"),n.autoPlay=i.proxy(n.autoPlay,n),n.autoPlayClear=i.proxy(n.autoPlayClear,n),n.autoPlayIterator=i.proxy(n.autoPlayIterator,n),n.changeSlide=i.proxy(n.changeSlide,n),n.clickHandler=i.proxy(n.clickHandler,n),n.selectHandler=i.proxy(n.selectHandler,n),n.setPosition=i.proxy(n.setPosition,n),n.swipeHandler=i.proxy(n.swipeHandler,n),n.dragHandler=i.proxy(n.dragHandler,n),n.keyHandler=i.proxy(n.keyHandler,n),n.instanceUid=e++,n.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,n.registerBreakpoints(),n.init(!0)}}()).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},e.prototype.addSlide=e.prototype.slickAdd=function(e,t,o){var s=this;if("boolean"==typeof t)o=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?i(e).appendTo(s.$slideTrack):o?i(e).insertBefore(s.$slides.eq(t)):i(e).insertAfter(s.$slides.eq(t)):!0===o?i(e).prependTo(s.$slideTrack):i(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){i(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},e.prototype.animateHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.animate({height:e},i.options.speed)}},e.prototype.animateSlide=function(e,t){var o={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),i({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(i){i=Math.ceil(i),!1===s.options.vertical?(o[s.animType]="translate("+i+"px, 0px)",s.$slideTrack.css(o)):(o[s.animType]="translate(0px,"+i+"px)",s.$slideTrack.css(o))},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?o[s.animType]="translate3d("+e+"px, 0px, 0px)":o[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(o),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},e.prototype.getNavTarget=function(){var e=this,t=e.options.asNavFor;return t&&null!==t&&(t=i(t).not(e.$slider)),t},e.prototype.asNavFor=function(e){var t=this.getNavTarget();null!==t&&"object"==typeof t&&t.each(function(){var t=i(this).slick("getSlick");t.unslicked||t.slideHandler(e,!0)})},e.prototype.applyTransition=function(i){var e=this,t={};!1===e.options.fade?t[e.transitionType]=e.transformType+" "+e.options.speed+"ms "+e.options.cssEase:t[e.transitionType]="opacity "+e.options.speed+"ms "+e.options.cssEase,!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.autoPlay=function(){var i=this;i.autoPlayClear(),i.slideCount>i.options.slidesToShow&&(i.autoPlayTimer=setInterval(i.autoPlayIterator,i.options.autoplaySpeed))},e.prototype.autoPlayClear=function(){var i=this;i.autoPlayTimer&&clearInterval(i.autoPlayTimer)},e.prototype.autoPlayIterator=function(){var i=this,e=i.currentSlide+i.options.slidesToScroll;i.paused||i.interrupted||i.focussed||(!1===i.options.infinite&&(1===i.direction&&i.currentSlide+1===i.slideCount-1?i.direction=0:0===i.direction&&(e=i.currentSlide-i.options.slidesToScroll,i.currentSlide-1==0&&(i.direction=1))),i.slideHandler(e))},e.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=i(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=i(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},e.prototype.buildDots=function(){var e,t,o=this;if(!0===o.options.dots){for(o.$slider.addClass("slick-dotted"),t=i("<ul />").addClass(o.options.dotsClass),e=0;e<=o.getDotCount();e+=1)t.append(i("<li />").append(o.options.customPaging.call(this,o,e)));o.$dots=t.appendTo(o.options.appendDots),o.$dots.find("li").first().addClass("slick-active")}},e.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){i(t).attr("data-slick-index",e).data("originalStyling",i(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?i('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),i("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},e.prototype.buildRows=function(){var i,e,t,o,s,n,r,l=this;if(o=document.createDocumentFragment(),n=l.$slider.children(),l.options.rows>1){for(r=l.options.slidesPerRow*l.options.rows,s=Math.ceil(n.length/r),i=0;i<s;i++){var d=document.createElement("div");for(e=0;e<l.options.rows;e++){var a=document.createElement("div");for(t=0;t<l.options.slidesPerRow;t++){var c=i*r+(e*l.options.slidesPerRow+t);n.get(c)&&a.appendChild(n.get(c))}d.appendChild(a)}o.appendChild(d)}l.$slider.empty().append(o),l.$slider.children().children().children().css({width:100/l.options.slidesPerRow+"%",display:"inline-block"})}},e.prototype.checkResponsive=function(e,t){var o,s,n,r=this,l=!1,d=r.$slider.width(),a=window.innerWidth||i(window).width();if("window"===r.respondTo?n=a:"slider"===r.respondTo?n=d:"min"===r.respondTo&&(n=Math.min(a,d)),r.options.responsive&&r.options.responsive.length&&null!==r.options.responsive){s=null;for(o in r.breakpoints)r.breakpoints.hasOwnProperty(o)&&(!1===r.originalSettings.mobileFirst?n<r.breakpoints[o]&&(s=r.breakpoints[o]):n>r.breakpoints[o]&&(s=r.breakpoints[o]));null!==s?null!==r.activeBreakpoint?(s!==r.activeBreakpoint||t)&&(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):(r.activeBreakpoint=s,"unslick"===r.breakpointSettings[s]?r.unslick(s):(r.options=i.extend({},r.originalSettings,r.breakpointSettings[s]),!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e)),l=s):null!==r.activeBreakpoint&&(r.activeBreakpoint=null,r.options=r.originalSettings,!0===e&&(r.currentSlide=r.options.initialSlide),r.refresh(e),l=s),e||!1===l||r.$slider.trigger("breakpoint",[r,l])}},e.prototype.changeSlide=function(e,t){var o,s,n,r=this,l=i(e.currentTarget);switch(l.is("a")&&e.preventDefault(),l.is("li")||(l=l.closest("li")),n=r.slideCount%r.options.slidesToScroll!=0,o=n?0:(r.slideCount-r.currentSlide)%r.options.slidesToScroll,e.data.message){case"previous":s=0===o?r.options.slidesToScroll:r.options.slidesToShow-o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide-s,!1,t);break;case"next":s=0===o?r.options.slidesToScroll:o,r.slideCount>r.options.slidesToShow&&r.slideHandler(r.currentSlide+s,!1,t);break;case"index":var d=0===e.data.index?0:e.data.index||l.index()*r.options.slidesToScroll;r.slideHandler(r.checkNavigable(d),!1,t),l.children().trigger("focus");break;default:return}},e.prototype.checkNavigable=function(i){var e,t;if(e=this.getNavigableIndexes(),t=0,i>e[e.length-1])i=e[e.length-1];else for(var o in e){if(i<e[o]){i=t;break}t=e[o]}return i},e.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(i("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",i.proxy(e.interrupt,e,!0)).off("mouseleave.slick",i.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),i(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().off("click.slick",e.selectHandler),i(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),i(window).off("resize.slick.slick-"+e.instanceUid,e.resize),i("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),i(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},e.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.cleanUpRows=function(){var i,e=this;e.options.rows>1&&((i=e.$slides.children().children()).removeAttr("style"),e.$slider.empty().append(i))},e.prototype.clickHandler=function(i){!1===this.shouldClick&&(i.stopImmediatePropagation(),i.stopPropagation(),i.preventDefault())},e.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),i(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){i(this).attr("style",i(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},e.prototype.disableTransition=function(i){var e=this,t={};t[e.transitionType]="",!1===e.options.fade?e.$slideTrack.css(t):e.$slides.eq(i).css(t)},e.prototype.fadeSlide=function(i,e){var t=this;!1===t.cssTransitions?(t.$slides.eq(i).css({zIndex:t.options.zIndex}),t.$slides.eq(i).animate({opacity:1},t.options.speed,t.options.easing,e)):(t.applyTransition(i),t.$slides.eq(i).css({opacity:1,zIndex:t.options.zIndex}),e&&setTimeout(function(){t.disableTransition(i),e.call()},t.options.speed))},e.prototype.fadeSlideOut=function(i){var e=this;!1===e.cssTransitions?e.$slides.eq(i).animate({opacity:0,zIndex:e.options.zIndex-2},e.options.speed,e.options.easing):(e.applyTransition(i),e.$slides.eq(i).css({opacity:0,zIndex:e.options.zIndex-2}))},e.prototype.filterSlides=e.prototype.slickFilter=function(i){var e=this;null!==i&&(e.$slidesCache=e.$slides,e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.filter(i).appendTo(e.$slideTrack),e.reinit())},e.prototype.focusHandler=function(){var e=this;e.$slider.off("focus.slick blur.slick").on("focus.slick blur.slick","*",function(t){t.stopImmediatePropagation();var o=i(this);setTimeout(function(){e.options.pauseOnFocus&&(e.focussed=o.is(":focus"),e.autoPlay())},0)})},e.prototype.getCurrent=e.prototype.slickCurrentSlide=function(){return this.currentSlide},e.prototype.getDotCount=function(){var i=this,e=0,t=0,o=0;if(!0===i.options.infinite)if(i.slideCount<=i.options.slidesToShow)++o;else for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else if(!0===i.options.centerMode)o=i.slideCount;else if(i.options.asNavFor)for(;e<i.slideCount;)++o,e=t+i.options.slidesToScroll,t+=i.options.slidesToScroll<=i.options.slidesToShow?i.options.slidesToScroll:i.options.slidesToShow;else o=1+Math.ceil((i.slideCount-i.options.slidesToShow)/i.options.slidesToScroll);return o-1},e.prototype.getLeft=function(i){var e,t,o,s,n=this,r=0;return n.slideOffset=0,t=n.$slides.first().outerHeight(!0),!0===n.options.infinite?(n.slideCount>n.options.slidesToShow&&(n.slideOffset=n.slideWidth*n.options.slidesToShow*-1,s=-1,!0===n.options.vertical&&!0===n.options.centerMode&&(2===n.options.slidesToShow?s=-1.5:1===n.options.slidesToShow&&(s=-2)),r=t*n.options.slidesToShow*s),n.slideCount%n.options.slidesToScroll!=0&&i+n.options.slidesToScroll>n.slideCount&&n.slideCount>n.options.slidesToShow&&(i>n.slideCount?(n.slideOffset=(n.options.slidesToShow-(i-n.slideCount))*n.slideWidth*-1,r=(n.options.slidesToShow-(i-n.slideCount))*t*-1):(n.slideOffset=n.slideCount%n.options.slidesToScroll*n.slideWidth*-1,r=n.slideCount%n.options.slidesToScroll*t*-1))):i+n.options.slidesToShow>n.slideCount&&(n.slideOffset=(i+n.options.slidesToShow-n.slideCount)*n.slideWidth,r=(i+n.options.slidesToShow-n.slideCount)*t),n.slideCount<=n.options.slidesToShow&&(n.slideOffset=0,r=0),!0===n.options.centerMode&&n.slideCount<=n.options.slidesToShow?n.slideOffset=n.slideWidth*Math.floor(n.options.slidesToShow)/2-n.slideWidth*n.slideCount/2:!0===n.options.centerMode&&!0===n.options.infinite?n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)-n.slideWidth:!0===n.options.centerMode&&(n.slideOffset=0,n.slideOffset+=n.slideWidth*Math.floor(n.options.slidesToShow/2)),e=!1===n.options.vertical?i*n.slideWidth*-1+n.slideOffset:i*t*-1+r,!0===n.options.variableWidth&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,!0===n.options.centerMode&&(o=n.slideCount<=n.options.slidesToShow||!1===n.options.infinite?n.$slideTrack.children(".slick-slide").eq(i):n.$slideTrack.children(".slick-slide").eq(i+n.options.slidesToShow+1),e=!0===n.options.rtl?o[0]?-1*(n.$slideTrack.width()-o[0].offsetLeft-o.width()):0:o[0]?-1*o[0].offsetLeft:0,e+=(n.$list.width()-o.outerWidth())/2)),e},e.prototype.getOption=e.prototype.slickGetOption=function(i){return this.options[i]},e.prototype.getNavigableIndexes=function(){var i,e=this,t=0,o=0,s=[];for(!1===e.options.infinite?i=e.slideCount:(t=-1*e.options.slidesToScroll,o=-1*e.options.slidesToScroll,i=2*e.slideCount);t<i;)s.push(t),t=o+e.options.slidesToScroll,o+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},e.prototype.getSlick=function(){return this},e.prototype.getSlideCount=function(){var e,t,o=this;return t=!0===o.options.centerMode?o.slideWidth*Math.floor(o.options.slidesToShow/2):0,!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(s,n){if(n.offsetLeft-t+i(n).outerWidth()/2>-1*o.swipeLeft)return e=n,!1}),Math.abs(i(e).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},e.prototype.goTo=e.prototype.slickGoTo=function(i,e){this.changeSlide({data:{message:"index",index:parseInt(i)}},e)},e.prototype.init=function(e){var t=this;i(t.$slider).hasClass("slick-initialized")||(i(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},e.prototype.initADA=function(){var e=this,t=Math.ceil(e.slideCount/e.options.slidesToShow),o=e.getNavigableIndexes().filter(function(i){return i>=0&&i<e.slideCount});e.$slides.add(e.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==e.$dots&&(e.$slides.not(e.$slideTrack.find(".slick-cloned")).each(function(t){var s=o.indexOf(t);i(this).attr({role:"tabpanel",id:"slick-slide"+e.instanceUid+t,tabindex:-1}),-1!==s&&i(this).attr({"aria-describedby":"slick-slide-control"+e.instanceUid+s})}),e.$dots.attr("role","tablist").find("li").each(function(s){var n=o[s];i(this).attr({role:"presentation"}),i(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+e.instanceUid+s,"aria-controls":"slick-slide"+e.instanceUid+n,"aria-label":s+1+" of "+t,"aria-selected":null,tabindex:"-1"})}).eq(e.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var s=e.currentSlide,n=s+e.options.slidesToShow;s<n;s++)e.$slides.eq(s).attr("tabindex",0);e.activateADA()},e.prototype.initArrowEvents=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},i.changeSlide),i.$nextArrow.off("click.slick").on("click.slick",{message:"next"},i.changeSlide),!0===i.options.accessibility&&(i.$prevArrow.on("keydown.slick",i.keyHandler),i.$nextArrow.on("keydown.slick",i.keyHandler)))},e.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&(i("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&i("li",e.$dots).on("mouseenter.slick",i.proxy(e.interrupt,e,!0)).on("mouseleave.slick",i.proxy(e.interrupt,e,!1))},e.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",i.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",i.proxy(e.interrupt,e,!1)))},e.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),i(document).on(e.visibilityChange,i.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),i(window).on("orientationchange.slick.slick-"+e.instanceUid,i.proxy(e.orientationChange,e)),i(window).on("resize.slick.slick-"+e.instanceUid,i.proxy(e.resize,e)),i("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),i(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),i(e.setPosition)},e.prototype.initUI=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.show(),i.$nextArrow.show()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.show()},e.prototype.keyHandler=function(i){var e=this;i.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===i.keyCode&&!0===e.options.accessibility?e.changeSlide({data:{message:!0===e.options.rtl?"next":"previous"}}):39===i.keyCode&&!0===e.options.accessibility&&e.changeSlide({data:{message:!0===e.options.rtl?"previous":"next"}}))},e.prototype.lazyLoad=function(){function e(e){i("img[data-lazy]",e).each(function(){var e=i(this),t=i(this).attr("data-lazy"),o=i(this).attr("data-srcset"),s=i(this).attr("data-sizes")||n.$slider.attr("data-sizes"),r=document.createElement("img");r.onload=function(){e.animate({opacity:0},100,function(){o&&(e.attr("srcset",o),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),n.$slider.trigger("lazyLoaded",[n,e,t])})},r.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),n.$slider.trigger("lazyLoadError",[n,e,t])},r.src=t})}var t,o,s,n=this;if(!0===n.options.centerMode?!0===n.options.infinite?s=(o=n.currentSlide+(n.options.slidesToShow/2+1))+n.options.slidesToShow+2:(o=Math.max(0,n.currentSlide-(n.options.slidesToShow/2+1)),s=n.options.slidesToShow/2+1+2+n.currentSlide):(o=n.options.infinite?n.options.slidesToShow+n.currentSlide:n.currentSlide,s=Math.ceil(o+n.options.slidesToShow),!0===n.options.fade&&(o>0&&o--,s<=n.slideCount&&s++)),t=n.$slider.find(".slick-slide").slice(o,s),"anticipated"===n.options.lazyLoad)for(var r=o-1,l=s,d=n.$slider.find(".slick-slide"),a=0;a<n.options.slidesToScroll;a++)r<0&&(r=n.slideCount-1),t=(t=t.add(d.eq(r))).add(d.eq(l)),r--,l++;e(t),n.slideCount<=n.options.slidesToShow?e(n.$slider.find(".slick-slide")):n.currentSlide>=n.slideCount-n.options.slidesToShow?e(n.$slider.find(".slick-cloned").slice(0,n.options.slidesToShow)):0===n.currentSlide&&e(n.$slider.find(".slick-cloned").slice(-1*n.options.slidesToShow))},e.prototype.loadSlider=function(){var i=this;i.setPosition(),i.$slideTrack.css({opacity:1}),i.$slider.removeClass("slick-loading"),i.initUI(),"progressive"===i.options.lazyLoad&&i.progressiveLazyLoad()},e.prototype.next=e.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},e.prototype.orientationChange=function(){var i=this;i.checkResponsive(),i.setPosition()},e.prototype.pause=e.prototype.slickPause=function(){var i=this;i.autoPlayClear(),i.paused=!0},e.prototype.play=e.prototype.slickPlay=function(){var i=this;i.autoPlay(),i.options.autoplay=!0,i.paused=!1,i.focussed=!1,i.interrupted=!1},e.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&i(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},e.prototype.prev=e.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},e.prototype.preventDefault=function(i){i.preventDefault()},e.prototype.progressiveLazyLoad=function(e){e=e||1;var t,o,s,n,r,l=this,d=i("img[data-lazy]",l.$slider);d.length?(t=d.first(),o=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||l.$slider.attr("data-sizes"),(r=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",o).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===l.options.adaptiveHeight&&l.setPosition(),l.$slider.trigger("lazyLoaded",[l,t,o]),l.progressiveLazyLoad()},r.onerror=function(){e<3?setTimeout(function(){l.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),l.$slider.trigger("lazyLoadError",[l,t,o]),l.progressiveLazyLoad())},r.src=o):l.$slider.trigger("allImagesLoaded",[l])},e.prototype.refresh=function(e){var t,o,s=this;o=s.slideCount-s.options.slidesToShow,!s.options.infinite&&s.currentSlide>o&&(s.currentSlide=o),s.slideCount<=s.options.slidesToShow&&(s.currentSlide=0),t=s.currentSlide,s.destroy(!0),i.extend(s,s.initials,{currentSlide:t}),s.init(),e||s.changeSlide({data:{message:"index",index:t}},!1)},e.prototype.registerBreakpoints=function(){var e,t,o,s=this,n=s.options.responsive||null;if("array"===i.type(n)&&n.length){s.respondTo=s.options.respondTo||"window";for(e in n)if(o=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;o>=0;)s.breakpoints[o]&&s.breakpoints[o]===t&&s.breakpoints.splice(o,1),o--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(i,e){return s.options.mobileFirst?i-e:e-i})}},e.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&i(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},e.prototype.resize=function(){var e=this;i(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=i(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},e.prototype.removeSlide=e.prototype.slickRemove=function(i,e,t){var o=this;if(i="boolean"==typeof i?!0===(e=i)?0:o.slideCount-1:!0===e?--i:i,o.slideCount<1||i<0||i>o.slideCount-1)return!1;o.unload(),!0===t?o.$slideTrack.children().remove():o.$slideTrack.children(this.options.slide).eq(i).remove(),o.$slides=o.$slideTrack.children(this.options.slide),o.$slideTrack.children(this.options.slide).detach(),o.$slideTrack.append(o.$slides),o.$slidesCache=o.$slides,o.reinit()},e.prototype.setCSS=function(i){var e,t,o=this,s={};!0===o.options.rtl&&(i=-i),e="left"==o.positionProp?Math.ceil(i)+"px":"0px",t="top"==o.positionProp?Math.ceil(i)+"px":"0px",s[o.positionProp]=i,!1===o.transformsEnabled?o.$slideTrack.css(s):(s={},!1===o.cssTransitions?(s[o.animType]="translate("+e+", "+t+")",o.$slideTrack.css(s)):(s[o.animType]="translate3d("+e+", "+t+", 0px)",o.$slideTrack.css(s)))},e.prototype.setDimensions=function(){var i=this;!1===i.options.vertical?!0===i.options.centerMode&&i.$list.css({padding:"0px "+i.options.centerPadding}):(i.$list.height(i.$slides.first().outerHeight(!0)*i.options.slidesToShow),!0===i.options.centerMode&&i.$list.css({padding:i.options.centerPadding+" 0px"})),i.listWidth=i.$list.width(),i.listHeight=i.$list.height(),!1===i.options.vertical&&!1===i.options.variableWidth?(i.slideWidth=Math.ceil(i.listWidth/i.options.slidesToShow),i.$slideTrack.width(Math.ceil(i.slideWidth*i.$slideTrack.children(".slick-slide").length))):!0===i.options.variableWidth?i.$slideTrack.width(5e3*i.slideCount):(i.slideWidth=Math.ceil(i.listWidth),i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0)*i.$slideTrack.children(".slick-slide").length)));var e=i.$slides.first().outerWidth(!0)-i.$slides.first().width();!1===i.options.variableWidth&&i.$slideTrack.children(".slick-slide").width(i.slideWidth-e)},e.prototype.setFade=function(){var e,t=this;t.$slides.each(function(o,s){e=t.slideWidth*o*-1,!0===t.options.rtl?i(s).css({position:"relative",right:e,top:0,zIndex:t.options.zIndex-2,opacity:0}):i(s).css({position:"relative",left:e,top:0,zIndex:t.options.zIndex-2,opacity:0})}),t.$slides.eq(t.currentSlide).css({zIndex:t.options.zIndex-1,opacity:1})},e.prototype.setHeight=function(){var i=this;if(1===i.options.slidesToShow&&!0===i.options.adaptiveHeight&&!1===i.options.vertical){var e=i.$slides.eq(i.currentSlide).outerHeight(!0);i.$list.css("height",e)}},e.prototype.setOption=e.prototype.slickSetOption=function(){var e,t,o,s,n,r=this,l=!1;if("object"===i.type(arguments[0])?(o=arguments[0],l=arguments[1],n="multiple"):"string"===i.type(arguments[0])&&(o=arguments[0],s=arguments[1],l=arguments[2],"responsive"===arguments[0]&&"array"===i.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)r.options[o]=s;else if("multiple"===n)i.each(o,function(i,e){r.options[i]=e});else if("responsive"===n)for(t in s)if("array"!==i.type(r.options.responsive))r.options.responsive=[s[t]];else{for(e=r.options.responsive.length-1;e>=0;)r.options.responsive[e].breakpoint===s[t].breakpoint&&r.options.responsive.splice(e,1),e--;r.options.responsive.push(s[t])}l&&(r.unload(),r.reinit())},e.prototype.setPosition=function(){var i=this;i.setDimensions(),i.setHeight(),!1===i.options.fade?i.setCSS(i.getLeft(i.currentSlide)):i.setFade(),i.$slider.trigger("setPosition",[i])},e.prototype.setProps=function(){var i=this,e=document.body.style;i.positionProp=!0===i.options.vertical?"top":"left","top"===i.positionProp?i.$slider.addClass("slick-vertical"):i.$slider.removeClass("slick-vertical"),void 0===e.WebkitTransition&&void 0===e.MozTransition&&void 0===e.msTransition||!0===i.options.useCSS&&(i.cssTransitions=!0),i.options.fade&&("number"==typeof i.options.zIndex?i.options.zIndex<3&&(i.options.zIndex=3):i.options.zIndex=i.defaults.zIndex),void 0!==e.OTransform&&(i.animType="OTransform",i.transformType="-o-transform",i.transitionType="OTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.MozTransform&&(i.animType="MozTransform",i.transformType="-moz-transform",i.transitionType="MozTransition",void 0===e.perspectiveProperty&&void 0===e.MozPerspective&&(i.animType=!1)),void 0!==e.webkitTransform&&(i.animType="webkitTransform",i.transformType="-webkit-transform",i.transitionType="webkitTransition",void 0===e.perspectiveProperty&&void 0===e.webkitPerspective&&(i.animType=!1)),void 0!==e.msTransform&&(i.animType="msTransform",i.transformType="-ms-transform",i.transitionType="msTransition",void 0===e.msTransform&&(i.animType=!1)),void 0!==e.transform&&!1!==i.animType&&(i.animType="transform",i.transformType="transform",i.transitionType="transition"),i.transformsEnabled=i.options.useTransform&&null!==i.animType&&!1!==i.animType},e.prototype.setSlideClasses=function(i){var e,t,o,s,n=this;if(t=n.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true"),n.$slides.eq(i).addClass("slick-current"),!0===n.options.centerMode){var r=n.options.slidesToShow%2==0?1:0;e=Math.floor(n.options.slidesToShow/2),!0===n.options.infinite&&(i>=e&&i<=n.slideCount-1-e?n.$slides.slice(i-e+r,i+e+1).addClass("slick-active").attr("aria-hidden","false"):(o=n.options.slidesToShow+i,t.slice(o-e+1+r,o+e+2).addClass("slick-active").attr("aria-hidden","false")),0===i?t.eq(t.length-1-n.options.slidesToShow).addClass("slick-center"):i===n.slideCount-1&&t.eq(n.options.slidesToShow).addClass("slick-center")),n.$slides.eq(i).addClass("slick-center")}else i>=0&&i<=n.slideCount-n.options.slidesToShow?n.$slides.slice(i,i+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):t.length<=n.options.slidesToShow?t.addClass("slick-active").attr("aria-hidden","false"):(s=n.slideCount%n.options.slidesToShow,o=!0===n.options.infinite?n.options.slidesToShow+i:i,n.options.slidesToShow==n.options.slidesToScroll&&n.slideCount-i<n.options.slidesToShow?t.slice(o-(n.options.slidesToShow-s),o+s).addClass("slick-active").attr("aria-hidden","false"):t.slice(o,o+n.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"));"ondemand"!==n.options.lazyLoad&&"anticipated"!==n.options.lazyLoad||n.lazyLoad()},e.prototype.setupInfinite=function(){var e,t,o,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(o=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-o;e-=1)t=e-1,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<o+s.slideCount;e+=1)t=e,i(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){i(this).attr("id","")})}},e.prototype.interrupt=function(i){var e=this;i||e.autoPlay(),e.interrupted=i},e.prototype.selectHandler=function(e){var t=this,o=i(e.target).is(".slick-slide")?i(e.target):i(e.target).parents(".slick-slide"),s=parseInt(o.attr("data-slick-index"));s||(s=0),t.slideCount<=t.options.slidesToShow?t.slideHandler(s,!1,!0):t.slideHandler(s)},e.prototype.slideHandler=function(i,e,t){var o,s,n,r,l,d=null,a=this;if(e=e||!1,!(!0===a.animating&&!0===a.options.waitForAnimate||!0===a.options.fade&&a.currentSlide===i))if(!1===e&&a.asNavFor(i),o=i,d=a.getLeft(o),r=a.getLeft(a.currentSlide),a.currentLeft=null===a.swipeLeft?r:a.swipeLeft,!1===a.options.infinite&&!1===a.options.centerMode&&(i<0||i>a.getDotCount()*a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else if(!1===a.options.infinite&&!0===a.options.centerMode&&(i<0||i>a.slideCount-a.options.slidesToScroll))!1===a.options.fade&&(o=a.currentSlide,!0!==t?a.animateSlide(r,function(){a.postSlide(o)}):a.postSlide(o));else{if(a.options.autoplay&&clearInterval(a.autoPlayTimer),s=o<0?a.slideCount%a.options.slidesToScroll!=0?a.slideCount-a.slideCount%a.options.slidesToScroll:a.slideCount+o:o>=a.slideCount?a.slideCount%a.options.slidesToScroll!=0?0:o-a.slideCount:o,a.animating=!0,a.$slider.trigger("beforeChange",[a,a.currentSlide,s]),n=a.currentSlide,a.currentSlide=s,a.setSlideClasses(a.currentSlide),a.options.asNavFor&&(l=(l=a.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(a.currentSlide),a.updateDots(),a.updateArrows(),!0===a.options.fade)return!0!==t?(a.fadeSlideOut(n),a.fadeSlide(s,function(){a.postSlide(s)})):a.postSlide(s),void a.animateHeight();!0!==t?a.animateSlide(d,function(){a.postSlide(s)}):a.postSlide(s)}},e.prototype.startLoad=function(){var i=this;!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&(i.$prevArrow.hide(),i.$nextArrow.hide()),!0===i.options.dots&&i.slideCount>i.options.slidesToShow&&i.$dots.hide(),i.$slider.addClass("slick-loading")},e.prototype.swipeDirection=function(){var i,e,t,o,s=this;return i=s.touchObject.startX-s.touchObject.curX,e=s.touchObject.startY-s.touchObject.curY,t=Math.atan2(e,i),(o=Math.round(180*t/Math.PI))<0&&(o=360-Math.abs(o)),o<=45&&o>=0?!1===s.options.rtl?"left":"right":o<=360&&o>=315?!1===s.options.rtl?"left":"right":o>=135&&o<=225?!1===s.options.rtl?"right":"left":!0===s.options.verticalSwiping?o>=35&&o<=135?"down":"up":"vertical"},e.prototype.swipeEnd=function(i){var e,t,o=this;if(o.dragging=!1,o.swiping=!1,o.scrolling)return o.scrolling=!1,!1;if(o.interrupted=!1,o.shouldClick=!(o.touchObject.swipeLength>10),void 0===o.touchObject.curX)return!1;if(!0===o.touchObject.edgeHit&&o.$slider.trigger("edge",[o,o.swipeDirection()]),o.touchObject.swipeLength>=o.touchObject.minSwipe){switch(t=o.swipeDirection()){case"left":case"down":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide+o.getSlideCount()):o.currentSlide+o.getSlideCount(),o.currentDirection=0;break;case"right":case"up":e=o.options.swipeToSlide?o.checkNavigable(o.currentSlide-o.getSlideCount()):o.currentSlide-o.getSlideCount(),o.currentDirection=1}"vertical"!=t&&(o.slideHandler(e),o.touchObject={},o.$slider.trigger("swipe",[o,t]))}else o.touchObject.startX!==o.touchObject.curX&&(o.slideHandler(o.currentSlide),o.touchObject={})},e.prototype.swipeHandler=function(i){var e=this;if(!(!1===e.options.swipe||"ontouchend"in document&&!1===e.options.swipe||!1===e.options.draggable&&-1!==i.type.indexOf("mouse")))switch(e.touchObject.fingerCount=i.originalEvent&&void 0!==i.originalEvent.touches?i.originalEvent.touches.length:1,e.touchObject.minSwipe=e.listWidth/e.options.touchThreshold,!0===e.options.verticalSwiping&&(e.touchObject.minSwipe=e.listHeight/e.options.touchThreshold),i.data.action){case"start":e.swipeStart(i);break;case"move":e.swipeMove(i);break;case"end":e.swipeEnd(i)}},e.prototype.swipeMove=function(i){var e,t,o,s,n,r,l=this;return n=void 0!==i.originalEvent?i.originalEvent.touches:null,!(!l.dragging||l.scrolling||n&&1!==n.length)&&(e=l.getLeft(l.currentSlide),l.touchObject.curX=void 0!==n?n[0].pageX:i.clientX,l.touchObject.curY=void 0!==n?n[0].pageY:i.clientY,l.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(l.touchObject.curX-l.touchObject.startX,2))),r=Math.round(Math.sqrt(Math.pow(l.touchObject.curY-l.touchObject.startY,2))),!l.options.verticalSwiping&&!l.swiping&&r>4?(l.scrolling=!0,!1):(!0===l.options.verticalSwiping&&(l.touchObject.swipeLength=r),t=l.swipeDirection(),void 0!==i.originalEvent&&l.touchObject.swipeLength>4&&(l.swiping=!0,i.preventDefault()),s=(!1===l.options.rtl?1:-1)*(l.touchObject.curX>l.touchObject.startX?1:-1),!0===l.options.verticalSwiping&&(s=l.touchObject.curY>l.touchObject.startY?1:-1),o=l.touchObject.swipeLength,l.touchObject.edgeHit=!1,!1===l.options.infinite&&(0===l.currentSlide&&"right"===t||l.currentSlide>=l.getDotCount()&&"left"===t)&&(o=l.touchObject.swipeLength*l.options.edgeFriction,l.touchObject.edgeHit=!0),!1===l.options.vertical?l.swipeLeft=e+o*s:l.swipeLeft=e+o*(l.$list.height()/l.listWidth)*s,!0===l.options.verticalSwiping&&(l.swipeLeft=e+o*s),!0!==l.options.fade&&!1!==l.options.touchMove&&(!0===l.animating?(l.swipeLeft=null,!1):void l.setCSS(l.swipeLeft))))},e.prototype.swipeStart=function(i){var e,t=this;if(t.interrupted=!0,1!==t.touchObject.fingerCount||t.slideCount<=t.options.slidesToShow)return t.touchObject={},!1;void 0!==i.originalEvent&&void 0!==i.originalEvent.touches&&(e=i.originalEvent.touches[0]),t.touchObject.startX=t.touchObject.curX=void 0!==e?e.pageX:i.clientX,t.touchObject.startY=t.touchObject.curY=void 0!==e?e.pageY:i.clientY,t.dragging=!0},e.prototype.unfilterSlides=e.prototype.slickUnfilter=function(){var i=this;null!==i.$slidesCache&&(i.unload(),i.$slideTrack.children(this.options.slide).detach(),i.$slidesCache.appendTo(i.$slideTrack),i.reinit())},e.prototype.unload=function(){var e=this;i(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},e.prototype.unslick=function(i){var e=this;e.$slider.trigger("unslick",[e,i]),e.destroy()},e.prototype.updateArrows=function(){var i=this;Math.floor(i.options.slidesToShow/2),!0===i.options.arrows&&i.slideCount>i.options.slidesToShow&&!i.options.infinite&&(i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===i.currentSlide?(i.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-i.options.slidesToShow&&!1===i.options.centerMode?(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")):i.currentSlide>=i.slideCount-1&&!0===i.options.centerMode&&(i.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},e.prototype.updateDots=function(){var i=this;null!==i.$dots&&(i.$dots.find("li").removeClass("slick-active").end(),i.$dots.find("li").eq(Math.floor(i.currentSlide/i.options.slidesToScroll)).addClass("slick-active"))},e.prototype.visibility=function(){var i=this;i.options.autoplay&&(document[i.hidden]?i.interrupted=!0:i.interrupted=!1)},i.fn.slick=function(){var i,t,o=this,s=arguments[0],n=Array.prototype.slice.call(arguments,1),r=o.length;for(i=0;i<r;i++)if("object"==typeof s||void 0===s?o[i].slick=new e(o[i],s):t=o[i].slick[s].apply(o[i].slick,n),void 0!==t)return t;return o}});

/* 'use strict'; */

var szNavCustomType = "LEFT";
var szNavStyle;

//var SHOP_DOMAIN_ADDRESSS = 'http://m.civasatr4473.godomall.com';
var SHOP_DOMAIN_ADDRESSS = 'https://m.mall.pharmesthetic.com';

(function ($) {

/*   szNavStyle = {

    init : function(){
    }
  };
  szNavStyle.init(); */

})(jQuery);

(function ($) {

  if (typeof String.prototype.replaceAll !== "function") {
    String.prototype.replaceAll = function (target, replacement) {
      return this.split(target).join(replacement);
    };
  }

  if (typeof String.prototype.trim !== "function") {
    String.prototype.trim = function () {
      return this.replace(/(^\s*)|(\s*$)/gi, "");
    };
  }

  if (typeof String.prototype.comma !== "function") {
    String.prototype.comma = function () {
      return this.replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
    };
  }

  if (typeof Number.prototype.comma !== "function") {
    Number.prototype.comma = function () {

      return this.toString().replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
    };
  }

  if (typeof String.prototype.fillStr !== "function") {
    String.prototype.fillStr = function (str, len) {
      var orgStr = this.toString();
      while (orgStr.toString().length < len) {
        orgStr = str + orgStr;
      }
      return orgStr;
    };
  }

  if (typeof String.prototype.left !== "function") {
    String.prototype.left = function (len) {
      var orgStr = this.toString();
      return orgStr.substring(0, len);
    };
  }

  if (typeof String.prototype.right !== "function") {
    String.prototype.right = function (len) {
      var orgStr = this.toString();
      return orgStr.substring(orgStr.length - len, orgStr.length);
    };
  }

  if (typeof String.prototype.isNull !== "function") {

    String.prototype.isNull = function () {
      try {
        var orgStr = this.toString();
        if (orgStr == undefined || orgStr == "undefined" || orgStr == null || orgStr == "null" || orgStr.length == 0 || orgStr == " ") return true;
        else return false;
      } catch (e) {
        return true;
      }
    };
  }

  if (typeof $.prototype.hasAttr !== "function") {
    $.prototype.hasAttr = function (name) {
      try {
        var attr = $(this).attr(name);
        if (typeof attr !== typeof undefined && attr !== false) {
          return true;
        } else {
          return false;
        }
      } catch (e) {
        return false;
      }
    };
  }

  var Base64 = {
    _keyStr: "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
    encode: function (input) {
      var output = "";
      var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
      var i = 0;
      while (i < input.length) {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);
        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;
        if (isNaN(chr2)) {
          enc3 = enc4 = 64;
        }
        else if (isNaN(chr3)) {
          enc4 = 64;
        }
        output = output +
          this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
          this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
      }
      return output;
    },
    decode: function (input) {
      var output = "";
      var chr1, chr2, chr3;
      var enc1, enc2, enc3, enc4;
      var i = 0;
      input = input.replace(/[^A-Za-z0-9+/=]/g, "");
      while (i < input.length) {
        enc1 = this._keyStr.indexOf(input.charAt(i++));
        enc2 = this._keyStr.indexOf(input.charAt(i++));
        enc3 = this._keyStr.indexOf(input.charAt(i++));
        enc4 = this._keyStr.indexOf(input.charAt(i++));
        chr1 = (enc1 << 2) | (enc2 >> 4);
        chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
        chr3 = ((enc3 & 3) << 6) | enc4;
        output = output + String.fromCharCode(chr1);
        if (enc3 != 64) {
          output = output + String.fromCharCode(chr2);
        }
        if (enc4 != 64) {
          output = output + String.fromCharCode(chr3);
        }
      }
      return output;
    }
  };

})(jQuery);

function makeDateUUID() {

  // ex : 14 61 20 90 04 27 72 7; : length = 15
  // [년, 월, 일](4) + 요일(1) + 시간(2) + 분(2) + 초(2) + 밀리세컨드(2) + 랜덤숫자(2);
  var date = new Date();
  var year = date.getFullYear();
  var month = String(date.getMonth()+1);
  var day = String(date.getDate());
  var gday = String(date.getDay());
  var hh = String(date.getHours()).fillStr(0,2);
  var mm = String(date.getMinutes()).fillStr(0,2);
  var dd = String(date.getMinutes()).fillStr(0,2);
  var ss = String(date.getSeconds()).fillStr(0,2);
  var ms = String(date.getMilliseconds()).fillStr(0,2).left(2);
  var rand = String(Math.floor(Math.random() * 100)).fillStr(0,2);
  var uuid = year + Number(month) + Number(day) + gday + hh + dd + ss+ ms + rand;
  if(uuid.length != 15) {
    var size = 15 - uuid.length;
    uuid += String(Math.floor(Math.random() * 10000000)+1111111).left(size);
  }
  return uuid;
}

function replacer(key, value) {
  if (!value)
    return undefined;

  return value;
}

function checkMobile() {

  // 모바일 전용
  //if(navigator.userAgent.match(/Mobile|iP(hone|od)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)){

  // 모바일(태블릿 포함)
  if(navigator.userAgent.match(/Android|Mobile|iP(hone|od|ad)|BlackBerry|IEMobile|Kindle|NetFront|Silk-Accelerated|(hpw|web)OS|Fennec|Minimo|Opera M(obi|ini)|Blazer|Dolfin|Dolphin|Skyfire|Zune/)){
    return true;
  }

  return false;
}

function enableUploadComponent() {
  var word;
  var agent = navigator.userAgent.toLowerCase();
  var result = false;
  // IE old version ( IE 10 or Lower )
  if (navigator.appName == "Microsoft Internet Explorer") word = "msie ";
  // IE 11
  else if (agent.search("trident") > -1) word = "trident/.*rv:";
  // Microsoft Edge
  else if (agent.search("edge/") > -1) word = "edge/";
  // 그외, IE가 아니라면 ( If it's not IE or Edge )
  else return true;

  var reg = new RegExp(word + "([0-9]{1,})(\\.{0,}[0-9]{0,1})");
  if (reg.exec(agent) != null) {
    if (parseFloat(RegExp.$1 + RegExp.$2) > 10) return true;
    else return false;
  }
  return true;
}

function initPageContentMinHeight() {
  var headerHeight = 0;
  if($(".navbar-header").height() == null) headerHeight = 55;
  else headerHeight = $(".navbar-header").height();

  var checkPageInterval = setInterval(function(){
    var offset = $(".page ").eq(0).offset();
    if(offset != undefined) {
      $(".page ").eq(0).css("min-height", $(window).height() - offset.top );
      clearInterval(checkPageInterval);
    }

  }, 300);

}

function initViewLoadedInputBoxStyle() {

  var timerCount = 0;
  var timer = setInterval(function(){
    var input = $(".form-inner-label input");

    if( $(input).length == 0 ) {
      timerCount++;
      if(timerCount == 5) clearInterval(timer);
    } else {
      clearInterval(timer);
      for(var i = 0; i < input.length; i++) {
        var id = $(input).eq(i).attr("id");
        var convId = '';
        if( id == null) id = $(input).eq(i).attr("ng-model");
        if(id == null) continue;
        id = id.split(".");
        for(var j = 0; j < id.length; j++)
          convId += id[j].charAt(0).toUpperCase() + id[j].substring(1, id[j].length);
        convId = convId+ "_" + i;
        if( $(input).eq(i).attr("id")  != "" && $(input).eq(i).attr("id")  != undefined) {
          convId = $(input).eq(i).attr("id") ;
        }
        var placeholder = "";
        if($(input).eq(i).next().length > 0 && $(input).eq(i).next().get(0).tagName.toLowerCase() == "label") {
          $(input).eq(i).next().attr("for", convId);
          $(input).eq(i).attr("id", convId);
          $(input).eq(i).attr("placeholder", " ");
          continue;
        } else if ($(input).eq(i).attr("placeholder") != "" && $(input).eq(i).attr("placeholder") != undefined) {
          placeholder = $(input).eq(i).attr("placeholder");
        } else if($(input).eq(i).prev().get(0) && $(input).eq(i).prev().get(0).tagName.toLowerCase() == "label") {
          placeholder = $(input).eq(i).prev().get(0).textContent;
          $(input).eq(i).prev().detach();
        }
        $(input).eq(i).attr("id", convId);
        $(input).eq(i).attr("placeholder", " ");
        var label = $("<label>" + placeholder + "</label>", {for : convId,class : "ng-binding"});
        $(input).eq(i).after(label.clone());
        $(input).eq(i).next().attr("for", convId);
      }
    }
  }, 500);
}

function initLabelTitle() {
  setTimeout(function(){
    var label = $(".pagecontent label");
    for(var i= 0; i < label.length; i++) {
      if (!$(label).eq(i).attr("title") && $(label).eq(i).attr("title") != '') {
        $(label).eq(i).attr("title", $(label).eq(i).text());
      }
    }
  }, 500);
}

// function initSzRequired() {
//   var timerCount = 0;
//   var timer = setInterval(function(){
//     var label = $("[sz-required]");
//     if( $(label).length == 0 ) {
//       timerCount++;
//       if(timerCount == 5) clearInterval(timer);
//     } else {
//       clearInterval(timer);
//       for(var i = 0; i < label.length; i++) {
//         var $label = $(label).eq(i);
//         var tx = $label.text();
//         if(tx.charAt(0) != "*") {
//           $label.text("*" + tx);
//         }
//       }
//     }
//   }, 800);
// }

function chekValidData() {
  var label = $("[sz-required]");
  var errorMsg = "";
  for(var i = 0; i < label.length; i++) {
    var $at = $(label).eq(i).closest("div");
    var labelNm = $(label).eq(i).text().trim();
    var $input = $at.find("input");
    var $select = $at.find("select");
    var $textarea = $at.find("textarea");
    var type = $input.attr("type");
    if($input.length > 0) {
      if(type == "radio") {
        var name = $input.attr("name");
        var val = $(':radio[name="' + name +'"]:checked').val();
        if(isNullOrEmpty(val)) {
          errorMsg += labelNm + "을 선택하여주세요.</br>";
        }
      } else if(type == "checkbox") {


      } else if(type == "text") {
        var val = $input.val();
        if(isNullOrEmpty(val)) {
          if( $input.hasAttr("uib-datepicker-popup")) {
            errorMsg += labelNm + "를 선택해주세요.</br>";
          } else {
            errorMsg += labelNm + "을 작성하여주세요.</br>";
          }
        }
      }
    } else if($select.length > 0){
      var val =$at.find("select option:selected").val();
      if(isNullOrEmpty(val)) {
        errorMsg += labelNm + "를 선택해주세요.</br>";
      }
    }else if($textarea.length > 0){
      var val = $textarea.val();
      if(isNullOrEmpty(val)) {
        errorMsg += labelNm + "을 작성하여주세요.</br>";
      }
    }
  }

  if(errorMsg == "") {
    var p = {
      result : true
    }
    return p;
  } else {
    var p = {
      result : false,
      errorMsg : errorMsg
    }
    return p;
  }

  return false;
}

function uploadVaultFile(vault) {
  if (vault != null) {
    vault.uploader.send();
//    vault.data.upload();
  }
}

function initVaultComponent (id, callback, bOpenApi, exts, maxCnt) {
  var korean = {
    add: "파일추가",
    browse: "파일찾기",
    cancel: "취소",
    clear: "초기화",
    clearAll: "전체 초기화",
    download: "다운로드",
    dragAndDrop: "",
    filesOrFoldersHere: "여러 개의 첨부 파일을 마우스로 끌어놓으세요.",
    or: "",
    upload: ""
  };
  var sessionStorage = window.sessionStorage;
  var userkey = sessionStorage.getItem("userkey") + '-' + sessionStorage.getItem("loginTenantId");
  var iCheck = 0;

  var checkVaultInterval = setInterval(function() {
    if (iCheck > 10) {
      clearInterval(checkVaultInterval);
      return;
    }
    iCheck++;
    if($('#' + id).length > 0) {
      clearInterval(checkVaultInterval);
      var vault = new dhx.Vault(id, {
          mode: "list",
          uploader: {
              target: API_HTTP_PROTOCOL + "//" + API_SERVER_DOMAIN + ":" + API_SERVER_PORT + (bOpenApi? "/openapi": "") + "/attach/temp/upload.do?userkey=" + userkey,
              autosend: false
          }
      });

      var activeCheck = "mp3, mp4, doc, docx, xls, xlsx, ppt, pptx, hwp, pdf, txt, gul, jpg, gif, png, bmp, dib, tif, tiff, zip, alz, rar, 7z, mm, dwg, dxf";//확장자 제한
      if (exts) {
        activeCheck = exts;
      }
      var sizeLimit = 104857600; // 100mb 제한
      var filesCountValue = document.getElementById("files-count-value");
      var filesSizeValue = document.getElementById("files-size-value");
      var filesSizeText = document.getElementById("files-size-text");
      var maxUploadFileCnt = ( ! maxCnt ? 20 : maxCnt);
      var isErrMaxUploadFileCnt = false;
      vault.events.on("beforeAdd", function (item) {
        if (vault.data.getLength() >= maxUploadFileCnt) {
            if(!isErrMaxUploadFileCnt) {
              alert("파일 첨부는 최대 "+ maxUploadFileCnt +"개 까지만 가능합니다.");
              isErrMaxUploadFileCnt = true;
            }
            return false;
        }
        var extension = item.file.name.split(".").pop();
        var size = item.file.size;
        var predicate = activeCheck.indexOf(extension.toLowerCase()) > -1 && size < sizeLimit;
        if (!predicate) {
          alert(activeCheck + " 파일만 가능합니다.");
          var $obj = $(".dhx-dropable-area.drop-files-here");
          $obj.closest(".layout_y").removeClass('dhx-dragin');
        }
        return predicate;
      });
      vault.events.on("AfterAdd", function(item) {
        vault.toolbar.hide("upload");
      });

      vault.events.on("UploadFile", function (file) {
          // console.log(file);
          //alert(file.fileDuplication);
          //alert(file.file.name);
      });
      vault.events.on("uploadComplete", function (data) {
        if (data != null && data.length > 0) {
          for (var i = 0; i < data.length; i++) {
            if (data[i].responseVO != null) {
              var result = {};
              result.header = data[i].responseVO.header;
              result.body = data[i].responseVO.body;

              callback.onFileUploaded(id, result);
            }
          }
        }

        callback.onFileUploadComplete(id);
        vault.data.removeAll(); // 초기화
      });
      dhx.i18n.setLocale('vault', korean);

      if (callback)
        callback.onLoaded(id, vault);
    }
  }, 100);
}

function setBreakPoint(obj) {
  var size = ['xs', 'sm', 'md', 'lg', 'xl'];
  for(var i = 0; i < size.length; i++) {
    if(obj != "" && size[i] == obj) {
      obj =  "";
      for(var j = 0; j < i; j++) obj +=  size[j] + " ";
    }
  }
  return obj;
}


function initFootableEvent(vm, ft, callback) {
  var $el = ft.$el;
  var key = ft.o.key;
  var row = ft.o.rows;
  var $tr = $el.find("tbody tr");
  var link = ft.o.link;
  var srch = ft.o.srch;
  var FreeBoardId = ft.o.FreeBoardId;
  $tr.find("td").css("cursor", "pointer");
  for(var i = 0; i < $tr.length; i++) {
    $tr.eq(i).attr("data-key", row[i][key]);
    $tr.eq(i).attr("data-idx", i);
  }

  $tr.bind("click", function(){
    if( $(this).find(".footable-toggle").length == 0) {
      srch[key] = $(this).attr("data-key");
      var localStorage = window.localStorage;
      var dockMode = localStorage.getItem("dockMode");

      var type = {v: "vertical", h: "horizon", d: "default"};
      if(dockMode == null || dockMode== type.d) {
//        console.log(location.origin + "/#/app/bbspost/h0102-slist/" + encodeURIComponent(JSON.stringify(srch, replacer)) + "/detail/" + FreeBoardId);
        location.hash = "app/bbspost/h0102-slist/" + encodeURIComponent(JSON.stringify(srch, replacer)) + "/detail/" + FreeBoardId;
//        ft.o.ctrState.go(link, {srch : encodeURIComponent(JSON.stringify(srch, replacer)), FreeBoardId:FreeBoardId });
      } else {

       /*  var e ={}
        e.ft = ft;
        e.dockMode = dockMode;
        e.eventState = "click";
        callback(e); */
        var url = location.origin + "/#/app/bbspost/h0102-slist/" + encodeURIComponent(JSON.stringify(srch, replacer)) + "/" + FreeBoardId;
        if(dockMode == type.v) {

          $("#dockTop iframe").attr("src", url);
        } else {
          //console.log("clci");
          $("#dockbottom iframe").attr("src", url);
        }
      }
    }
  });
}

function setDockView($compile, $scope, mode, callback) {
  // mode 대신 필요한 정보를 object 형식으로 받을 수 있도록 수정 필요
  var setDocViewInterval = setInterval(function() {


    var $docWrap = $("#dockWrap");

    if($docWrap.length > 0) {

      var $docBackup = $("#dockBackupWrap");

      clearInterval(setDocViewInterval);
      var type = {v: "vertical", h: "horizon", d: "default"};
      var localStorage = window.localStorage;
      if(mode.type == null) localStorage.setItem("dockMode", "default");
      else localStorage.setItem("dockMode", mode.type);

      if($docBackup.length == 0) {
        $docWrap.after("<div id='dockBackupWrap'></div>");
        $docBackup = $("#dockBackupWrap");
        $docBackup.append($docWrap.children().clone(true, true, true));
      }
      var $docWrapChild = $docBackup.children().clone(true, true, true);
      $("#dockWrap").empty().html('');
      if(mode.type == null || mode.type == type.d) {
        //$("#dockWrap").append("<div id='dockLeft' dock=\"'left'\"><div class='dock-content'></div></div>");
      } else if(mode.type == type.v) {
        $("#dockWrap").append("<div id='dockLeft' dock=\"'left'\" dock-ref=\"\" dock-resizable ><div class='dock-content'></div></div>");
        $("#dockWrap").append("<div id='dockTop' dock=\"'fill'\" dock-ref=\"\" ><div class='dock-content'><iframe>리스트를 클릭하여주세요.</iframe></div></div>");


      } else {
       // $("#dockWrap").append("<div id='dockLeft' dock=\"'left'\" dock-resizable><div class='dock-content'></div></div>");

        $("#dockWrap").append("<div id='dockbottom' dock=\"'bottom'\" dock-resizable ><div class='dock-content'><iframe>리스트를 클릭하여주세요.</iframe></div></div>");
        $("#dockWrap").append("<div id='dockTop' dock=\"'fill'\" dock-ref=\"\"     ><div class='dock-content'></div></div>");

      }

      var $view = {l: $("#dockLeft"), t: $("#dockTop"), b: $("#dockbottom") };
      var offset = $docWrap.offset();
      var viewHeight =$(window).height() - (offset.top+5);
      if(mode.type == null || mode.type == type.d) {

      } else {

        //console.log(offset.top, $(window).height())

        $docWrap.css("height", viewHeight );
      }
      $docWrap.attr("dock-ref","");

      if(mode.type == null || mode.type == type.d) {
       /*  $view.l.css("width","100%");
        $view.l.css("height","100%"); */
      } else if(mode.type == type.v) {
        $view.l.css("width","50%");
        $view.t.css("height","100%");
      } else {
        $("#dockbottom").css("height",viewHeight/2);
      }

      $compile($docWrap)($scope);

      if(mode.type == null || mode.type == type.d) {
        //$("#dockLeft .dock-content").append($docWrapChild);
        $("#dockWrap").empty().html($docWrapChild);
      } else if(mode.type == type.v) {
        $("#dockLeft .dock-content").append($docWrapChild);
      } else {
        $("#dockTop .dock-content").append($docWrapChild);
      }

      callback();

    }
  }, 500);

}


/**
 * Null or Empty 검사
 * !value 하면 생기는 논리적 오류를 제거하기 위해 명시적으로 value == 사용 [], {} 도 빈값으로 처리
 * @param value - 검사할 값
 * @return true or false
 */
function isNullOrEmpty(value) {
  return value === "" || value === " " || value === '0.00' || value === null || value === undefined || (value != null && typeof value === "object" && !Object.keys(value).length);
}

/**
 * Email 검사
 * @param value - 검사할 값
 * @return true or false
 */
function isValidEmail(value) {
  var regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return regex.test(value);
}

/**
 * 날짜 검사
 * @param value - 검사할 값
 * @return true or false
 */
function isValidDate(value) {
  return value instanceof Date && !isNaN(value) && value != undefined;
}

function fnOpenLayer(width) {
  //console.log($(".search-detail-wrap"));
  var position = $(".search-detail-wrap").css('position');

  var pos = position == 'absolute' ? $(".search_layer").position() : $(".search_layer").offset();
  var h = $(".search_layer").height();

  setTimeout(function(){
    $(".search-detail-wrap").css("left", (pos.left) + 10);
    $(".search-detail-wrap").css("top", (pos.top) + 31);
    if (width) {
      $(".search-detail-wrap").css("width", width);
    }

    if ($(".search-detail-wrap").is(":visible")) {
      $(".search-detail-wrap").hide();
    } else {
      $(".search-detail-wrap").show();
    }
  }, 1);

  return false;
}

function fnCloseLayer() {
  $(".search-detail-wrap").hide();
  return false;
}

function date2str(x, y) {
  var z = {
      M: x.getMonth() + 1,
      d: x.getDate(),
      h: x.getHours(),
      m: x.getMinutes(),
      s: x.getSeconds()
  };
  y = y.replace(/(M+|d+|h+|m+|s+)/g, function(v) {
      return ((v.length > 1 ? "0" : "") + eval('z.' + v.slice(-1))).slice(-2);
  });

  return y.replace(/(y+)/g, function(v) {
      return x.getFullYear().toString().slice(-v.length);
  });
}

function getSearchConditionStr(count, columnMap, srch) {
  var countStr = count? count : 0;

  var searchConditionStr = '<b>검색결과 <font color=red>' + Number(countStr).toLocaleString('en') + '</font>건</b> ';

  var str = [];
  for (var key in srch) {
    if (key == 'page' || key == 'viewSize' || key == 'tableNm' || key == 'sortDirect' || key == 'sortColumn' || key == 'userkey' || key == 'selectType' || key == 'srchTenantId')
      continue;

    var name = key;
    var value = srch[key];
    if (columnMap[key] && srch[key] && value != null && value != '') {
      var valueName = '';
      name = columnMap[key].ColumnLogicalNm;
      if (columnMap[key].ColumnLogicalDataType == "50") {
        if (columnMap[key].CodeList) {
          if (angular.isArray(value)) {
            value.forEach(function(valueE) {
              columnMap[key].CodeList.forEach(function (v) {
                if (v.Code == valueE) {
                  valueName = valueName + (valueName != '' ? '·' : '') + v.CodeValue;
                  return;
                }
              });              
            });
          } else {
            columnMap[key].CodeList.forEach(function (v) {
              if (v.Code == value) {
                valueName = v.CodeValue;
                return;
              }
            });
          }
        }
      } else {
        valueName = value;
      }
      str.push(name + ':' + valueName);
    }
  }

  searchConditionStr += str.join(',');

  return searchConditionStr;
}

var Base64={
  _keyStr:"ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  encode:function(e)
  {
      var t="";
      var n,r,i,s,o,u,a;
      var f=0;
      e=Base64._utf8_encode(e);

      while(f<e.length)
      {
          n=e.charCodeAt(f++);
          r=e.charCodeAt(f++);
          i=e.charCodeAt(f++);
          s=n>>2;
          o=(n&3)<<4|r>>4;
          u=(r&15)<<2|i>>6;
          a=i&63;

          if(isNaN(r))
          {
              u=a=64;
          }
          else if(isNaN(i))
          {
              a=64;
          }

          t=t+this._keyStr.charAt(s) + this._keyStr.charAt(o) + this._keyStr.charAt(u) + this._keyStr.charAt(a);
      }

      return t;
  },
  decode:function(e)
  {
      var t="";
      var n,r,i;
      var s,o,u,a;
      var f=0;
      e=e.replace(/[^A-Za-z0-9+/=]/g,"");

      while(f<e.length)
      {
          s=this._keyStr.indexOf(e.charAt(f++));
          o=this._keyStr.indexOf(e.charAt(f++));
          u=this._keyStr.indexOf(e.charAt(f++));
          a=this._keyStr.indexOf(e.charAt(f++));
          n=s<<2|o>>4;
          r=(o&15)<<4|u>>2;
          i=(u&3)<<6|a;
          t=t+String.fromCharCode(n);

          if(u!=64)
          {
              t=t+String.fromCharCode(r);
          }

          if(a!=64)
          {
              t=t+String.fromCharCode(i);
          }
      }

      t=Base64._utf8_decode(t);

      return t;
  },
  _utf8_encode:function(e)
  {
      e=e.replace(/rn/g,"n");
      var t="";

      for(var n=0;n<e.length;n++)
      {
          var r=e.charCodeAt(n);

          if(r<128)
          {
              t+=String.fromCharCode(r);
          }
          else if(r>127&&r<2048)
          {
              t+=String.fromCharCode(r>>6|192);
              t+=String.fromCharCode(r&63|128);
          }
          else
          {
              t+=String.fromCharCode(r>>12|224);
              t+=String.fromCharCode(r>>6&63|128);
              t+=String.fromCharCode(r&63|128);
          }
      }

      return t;
  },
  _utf8_decode:function(e)
  {
      var t="";
      var n=0;
      var r=c1=c2=0;

      while(n<e.length)
      {
          r=e.charCodeAt(n);
          if(r<128)
          {
              t+=String.fromCharCode(r);
              n++;
          }
          else if(r>191&&r<224)
          {
              c2=e.charCodeAt(n+1);
              t+=String.fromCharCode((r&31)<<6|c2&63);
              n+=2;
          }
          else
          {
              c2=e.charCodeAt(n+1);
              c3=e.charCodeAt(n+2);
              t+=String.fromCharCode((r&15)<<12|(c2&63)<<6|c3&63);
              n+=3;
          }
      }
      return t;
  }
};

function binary2text(encodedString) {
  var word;
  var agent = navigator.userAgent.toLowerCase();
  // IE old version ( IE 10 or Lower )
  if (navigator.appName == "Microsoft Internet Explorer") {
    console.log("Microsoft Internet Explorer (IE 10 or Lower)");
    word = "msie ";
    return Base64.decode(encodedString);
  } else if (agent.search("trident") > -1) {
    word = "trident/.*rv:";
  // Microsoft Edge
  } else if (agent.search("edge/") > -1) {
    word = "edge/";
  // 그외, IE가 아니라면 ( If it's not IE or Edge )
  } else {
  }

//  return atob(encodedString);

  return Base64.decode(encodedString);
}

function drawWordCloud(data, divId) {
  var weight = 3,   // change me
  width = $("#" + divId).width(),
  height = 300;

//  var data = [{text:'word', size:100},{text:'cloud', size:50},{text:'워드', size:50}];

  var fill = d3.scale.category20();
  d3.layout.cloud().size([width, height]).words(data)
    //.rotate(function() { return ~~(Math.random() * 2) * 90; })
    .rotate(0)
    .font("Impact")
    .fontSize(function(d) { return d.size; })
    .on("end", draw)
    .start();

  function draw(words) {
    d3.select("svg").selectAll("text")
      .style("font-size", function(d, i) { });

    d3.select("#" + divId)
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", "translate(" + width/2 + "," + height/2 + ")")
      .selectAll("text")
      .data(words)
      .enter().append("text")
      .style("font-size", function(d) { return d.size + "px"; })
      .style("font-family", "Impact")
      .style("fill", function(d, i) { return fill(i); })
      .attr("text-anchor", "middle")
      .attr("transform", function(d) {
        return "translate(" + [d.x, d.y] + ")rotate(" + d.rotate + ")";
      })
      .text(function(d) { return d.text; });
  }
}

/*
@license

dhtmlxVault v.3.0.0 Professional

This software is covered by DHTMLX Enterprise License.
Usage without proper license is prohibited.

(c) Dinamenta, UAB.

*/
if (window.dhx){ window.dhx_legacy = dhx; delete window.dhx; }(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["dhx"] = factory();
	else
		root["dhx"] = factory();
})(window, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/codebase/";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 27);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom = __webpack_require__(43);
exports.el = dom.defineElement;
exports.sv = dom.defineSvgElement;
exports.view = dom.defineView;
exports.create = dom.createView;
exports.inject = dom.injectView;
function disableHelp() {
    dom.DEVMODE.mutations = false;
    dom.DEVMODE.warnings = false;
    dom.DEVMODE.verbose = false;
    dom.DEVMODE.UNKEYED_INPUT = false;
}
exports.disableHelp = disableHelp;
function resizer(handler) {
    return exports.el("iframe", {
        _hooks: {
            didInsert: function (node) {
                var activeHandler = function () {
                    var height = node.el.offsetHeight;
                    var width = node.el.offsetWidth;
                    handler(width, height);
                };
                node.el.contentWindow.onresize = activeHandler;
                activeHandler();
            }
        },
        style: "position:absolute;left:0;top:-100%;width:100%;height:100%;margin:1px 0 0;border:none;opacity:0;visibility:hidden;pointer-events:none;",
    });
}
exports.resizer = resizer;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(37);
function toNode(node) {
    if (typeof node === "string") {
        node = (document.getElementById(node) || document.querySelector(node));
    }
    return node || document.body;
}
exports.toNode = toNode;
function eventHandler(prepare, hash) {
    var keys = Object.keys(hash);
    return function (ev) {
        var data = prepare(ev);
        var node = ev.target;
        while (node) {
            var cssstring = node.getAttribute ? (node.getAttribute("class") || "") : "";
            if (cssstring.length) {
                var css = cssstring.split(" ");
                for (var j = 0; j < keys.length; j++) {
                    if (css.indexOf(keys[j]) > -1) {
                        return hash[keys[j]](ev, data);
                    }
                }
            }
            node = node.parentNode;
        }
        return true;
    };
}
exports.eventHandler = eventHandler;
function locate(target, attr) {
    if (attr === void 0) { attr = "dhx_id"; }
    var node = locateNode(target, attr);
    return node ? node.getAttribute(attr) : "";
}
exports.locate = locate;
function locateNode(target, attr) {
    if (attr === void 0) { attr = "dhx_id"; }
    if (target instanceof Event) {
        target = target.target;
    }
    while (target && target.getAttribute) {
        if (target.getAttribute(attr)) {
            return target;
        }
        target = target.parentNode;
    }
}
exports.locateNode = locateNode;
function getBox(elem) {
    var box = elem.getBoundingClientRect();
    var body = document.body;
    var scrollTop = window.pageYOffset || body.scrollTop;
    var scrollLeft = window.pageXOffset || body.scrollLeft;
    var top = box.top + scrollTop;
    var left = box.left + scrollLeft;
    var right = body.offsetWidth - box.right;
    var bottom = body.offsetHeight - box.bottom;
    var width = box.right - box.left;
    var height = box.bottom - box.top;
    return { top: top, left: left, right: right, bottom: bottom, width: width, height: height };
}
exports.getBox = getBox;
var scrollWidth = -1;
function getScrollbarWidth() {
    if (scrollWidth > -1) {
        return scrollWidth;
    }
    var scrollDiv = document.createElement("div");
    document.body.appendChild(scrollDiv);
    scrollDiv.style.cssText = "position: absolute;left: -99999px;overflow:scroll;width: 100px;height: 100px;";
    scrollWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollWidth;
}
exports.getScrollbarWidth = getScrollbarWidth;
function fitPosition(target, mode, width, height) {
    var right = target.left + target.width;
    var bottom = target.top + target.height;
    if (mode === "bottom") {
        var left = window.innerWidth < target.left + width ? right - width : target.left;
        var top_1 = bottom + height > window.innerHeight ? target.top - height + window.scrollY : bottom + window.scrollY;
        return {
            position: "absolute",
            left: left,
            top: top_1,
            minWidth: width
        };
    }
    else {
        var overflow = void 0;
        var top_2 = target.top + window.scrollY;
        var left = window.innerWidth < right + width ? target.left - width : right;
        if (bottom + height > window.innerHeight) {
            if (bottom - height > 0) {
                top_2 = bottom - height + window.scrollY;
            }
            else {
                overflow = "scroll";
                height = (window.innerHeight - target.top) * 0.8;
            }
        }
        return {
            position: "absolute",
            left: left,
            top: top_2,
            minWidth: width,
            overflow: overflow,
            height: height
        };
    }
}
exports.fitPosition = fitPosition;
function isIE() {
    var ua = window.navigator.userAgent;
    return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
}
exports.isIE = isIE;


/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var types_1 = __webpack_require__(4);
function getCss(item) {
    var className = "";
    if (item.type !== types_1.ItemType.button && item.size) {
        className += " " + item.size;
    }
    if (item.active) {
        className += " active";
    }
    if (item.$disabled) {
        className += " disabled";
    }
    if (item.css) {
        className += " " + item.css;
    }
    return className;
}
exports.getCss = getCss;
function getButtonCss(item) {
    var className = " ";
    className += item.name === "link" ? "dhx_btn--link" : "dhx_btn--flat";
    className += item.size === "large" ? " dhx_btn--large" : " dhx_btn--small";
    switch (item.usage) {
        case "danger":
            className += " dhx_btn--danger";
            break;
        case "secondary":
            className += " dhx_btn--secondary";
            break;
        case "success":
            className += " dhx_btn--success";
            break;
        case "primary":
        default:
            break;
    }
    return className;
}
exports.getButtonCss = getButtonCss;
function counter(item) {
    if (item.count) {
        return dom_1.el(".counter", item.count);
    }
}
exports.counter = counter;
function icon(iconName) {
    if (iconName === void 0) { iconName = ""; }
    var className = "dhx-icon-block ";
    if (iconName.slice(0, 3) === "dxi") {
        className += "dxi ";
    }
    return dom_1.el("div", {
        class: className + iconName
    });
}
exports.icon = icon;


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var counter = (new Date()).valueOf();
function uid() {
    return "u" + (counter++);
}
exports.uid = uid;
function extend(target, source, deep) {
    if (deep === void 0) { deep = true; }
    if (source) {
        for (var key in source) {
            var sobj = source[key];
            var tobj = target[key];
            if (deep && typeof tobj === "object" && !(tobj instanceof Date) && !(tobj instanceof Array)) {
                extend(tobj, sobj);
            }
            else {
                target[key] = sobj;
            }
        }
    }
    return target;
}
exports.extend = extend;
function copy(source) {
    var result = {};
    for (var key in source) {
        result[key] = source[key];
    }
    return result;
}
exports.copy = copy;
function naturalSort(arr) {
    return arr.sort(function (a, b) {
        var nn = typeof a === "string" ? a.localeCompare(b) : a - b;
        return nn;
    });
}
exports.naturalSort = naturalSort;
function findIndex(arr, predicate) {
    var len = arr.length;
    for (var i = 0; i < len; i++) {
        if (predicate(arr[i])) {
            return i;
        }
    }
    return -1;
}
exports.findIndex = findIndex;
function isEqualString(from, to) {
    if (from.length > to.length) {
        return false;
    }
    for (var i = 0; i < from.length; i++) {
        if (from[i].toLowerCase() !== to[i].toLowerCase()) {
            return false;
        }
    }
    return true;
}
exports.isEqualString = isEqualString;
function singleOuterClick(fn) {
    var click = function (e) {
        if (fn(e)) {
            document.removeEventListener("click", click);
        }
    };
    document.addEventListener("click", click);
}
exports.singleOuterClick = singleOuterClick;


/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(5);
exports.DataEvents = types_1.DataEvents;
var ItemType;
(function (ItemType) {
    ItemType["button"] = "button";
    ItemType["input"] = "input";
    ItemType["separator"] = "separator";
    ItemType["text"] = "text";
    ItemType["iconButton"] = "iconButton";
    ItemType["imageButton"] = "imageButton";
    ItemType["spacer"] = "spacer";
    ItemType["menuItem"] = "menuItem";
    ItemType["imageButtonText"] = "imageButtonText";
    ItemType["block"] = "block";
    ItemType["customHTMLButton"] = "customButton";
    ItemType["selectButton"] = "selectButton";
    ItemType["dhxButton"] = "dhx-button";
})(ItemType = exports.ItemType || (exports.ItemType = {}));
var ToolbarEvents;
(function (ToolbarEvents) {
    ToolbarEvents["inputCreated"] = "inputcreated";
    ToolbarEvents["click"] = "click";
})(ToolbarEvents = exports.ToolbarEvents || (exports.ToolbarEvents = {}));
var NavigationType;
(function (NavigationType) {
    NavigationType["pointer"] = "pointer";
    NavigationType["click"] = "click";
})(NavigationType = exports.NavigationType || (exports.NavigationType = {}));


/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var DataEvents;
(function (DataEvents) {
    DataEvents["afterAdd"] = "afteradd";
    DataEvents["beforeAdd"] = "beforeadd";
    DataEvents["removeAll"] = "removeall";
    DataEvents["beforeRemove"] = "beforeremove";
    DataEvents["afterRemove"] = "afterremove";
    DataEvents["change"] = "change";
    DataEvents["load"] = "load";
})(DataEvents = exports.DataEvents || (exports.DataEvents = {}));
var DragEvents;
(function (DragEvents) {
    DragEvents["beforeDrag"] = "beforedrag";
    DragEvents["beforeDrop"] = "beforeDrop";
    DragEvents["dragStart"] = "dragstart";
    DragEvents["dragEnd"] = "dragend";
    DragEvents["canDrop"] = "candrop";
    DragEvents["cancelDrop"] = "canceldrop";
    DragEvents["dropComplete"] = "dropcomplete";
    DragEvents["dragOut"] = "dragOut";
    DragEvents["dragIn"] = "dragIn";
})(DragEvents = exports.DragEvents || (exports.DragEvents = {}));
var DragMode;
(function (DragMode) {
    DragMode["target"] = "target";
    DragMode["both"] = "both";
    DragMode["source"] = "source";
})(DragMode = exports.DragMode || (exports.DragMode = {}));
var DragBehaviour;
(function (DragBehaviour) {
    DragBehaviour["child"] = "child";
    DragBehaviour["sibling"] = "sibling";
    DragBehaviour["complex"] = "complex";
})(DragBehaviour = exports.DragBehaviour || (exports.DragBehaviour = {}));
var SelectionEvents;
(function (SelectionEvents) {
    SelectionEvents["beforeUnSelect"] = "beforeunselect";
    SelectionEvents["afterUnSelect"] = "afterunselect";
    SelectionEvents["beforeSelect"] = "beforeselect";
    SelectionEvents["afterSelect"] = "afterselect";
})(SelectionEvents = exports.SelectionEvents || (exports.SelectionEvents = {}));


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(5);
exports.DataEvents = types_1.DataEvents;
exports.DragBehaviour = types_1.DragBehaviour;
exports.DragMode = types_1.DragMode;
var TreeFilterType;
(function (TreeFilterType) {
    TreeFilterType[TreeFilterType["all"] = 1] = "all";
    TreeFilterType[TreeFilterType["specific"] = 2] = "specific";
    TreeFilterType[TreeFilterType["leafs"] = 3] = "leafs";
})(TreeFilterType = exports.TreeFilterType || (exports.TreeFilterType = {}));


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dataproxy_1 = __webpack_require__(11);
var CsvDriver_1 = __webpack_require__(21);
var JsonDriver_1 = __webpack_require__(22);
function isEqualObj(a, b) {
    for (var key in a) {
        if (a[key] !== b[key]) {
            return false;
        }
    }
    return true;
}
exports.isEqualObj = isEqualObj;
function naturalCompare(a, b) {
    var ax = [];
    var bx = [];
    a.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { ax.push([$1 || Infinity, $2 || ""]); });
    b.replace(/(\d+)|(\D+)/g, function (_, $1, $2) { bx.push([$1 || Infinity, $2 || ""]); });
    while (ax.length && bx.length) {
        var an = ax.shift();
        var bn = bx.shift();
        var nn = (an[0] - bn[0]) || an[1].localeCompare(bn[1]);
        if (nn) {
            return nn;
        }
    }
    return ax.length - bx.length;
}
exports.naturalCompare = naturalCompare;
function findByConf(item, conf) {
    if (typeof conf === "function") {
        if (conf.call(this, item)) {
            return item;
        }
    }
    else if (conf.by && conf.match) {
        if (item[conf.by] === conf.match) {
            return item;
        }
    }
}
exports.findByConf = findByConf;
function isDebug() {
    var dhx = window.dhx;
    if (typeof dhx !== "undefined") {
        return typeof (dhx.debug) !== "undefined" && dhx.debug;
    }
    // return typeof DHX_DEBUG_MODE !== "undefined" && DHX_DEBUG_MODE;
}
exports.isDebug = isDebug;
function dhxWarning(msg) {
    // tslint:disable-next-line:no-console
    console.warn(msg);
}
exports.dhxWarning = dhxWarning;
function dhxError(msg) {
    throw new Error(msg);
}
exports.dhxError = dhxError;
function toProxy(proxy) {
    var type = typeof proxy;
    if (type === "string") {
        return new dataproxy_1.DataProxy(proxy);
    }
    else if (type === "object") {
        return proxy;
    }
}
exports.toProxy = toProxy;
function toDataDriver(driver) {
    var type = typeof driver;
    if (type === "string") {
        switch (driver) {
            case "csv":
                return new CsvDriver_1.CsvDriver();
            case "json":
                return new JsonDriver_1.JsonDriver();
            default:
                // tslint:disable-next-line:no-console
                console.warn("incorrect driver type", driver);
                break;
        }
    }
    else if (typeof driver === "object") {
        return driver;
    }
}
exports.toDataDriver = toDataDriver;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(6));
__export(__webpack_require__(19));
__export(__webpack_require__(23));
__export(__webpack_require__(36));
__export(__webpack_require__(11));
__export(__webpack_require__(7));
__export(__webpack_require__(21));
__export(__webpack_require__(22));
__export(__webpack_require__(39));


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var EventSystem = /** @class */ (function () {
    function EventSystem(context) {
        this.events = {};
        this.context = context || this;
    }
    EventSystem.prototype.on = function (name, callback, context) {
        var event = name.toLowerCase();
        this.events[event] = this.events[event] || [];
        this.events[event].push({ callback: callback, context: context || this.context });
    };
    EventSystem.prototype.detach = function (name, context) {
        var event = name.toLowerCase();
        var eStack = this.events[event];
        if (context) {
            for (var i = eStack.length - 1; i >= 0; i--) {
                if (eStack[i].context === context) {
                    eStack.splice(i, 1);
                }
            }
        }
        else {
            this.events[event] = [];
        }
    };
    EventSystem.prototype.fire = function (name, args) {
        if (typeof args === "undefined") {
            args = [];
        }
        var event = name.toLowerCase();
        if (this.events[event]) {
            var res = this.events[event].map(function (e) { return e.callback.apply(e.context, args); });
            return res.indexOf(false) < 0;
        }
        return true;
    };
    return EventSystem;
}());
exports.EventSystem = EventSystem;
function EventsMixin(obj) {
    obj = obj || {};
    var eventSystem = new EventSystem(obj);
    obj.detachEvent = eventSystem.detach.bind(eventSystem);
    obj.attachEvent = eventSystem.on.bind(eventSystem);
    obj.callEvent = eventSystem.fire.bind(eventSystem);
}
exports.EventsMixin = EventsMixin;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, setImmediate) {(function () {
  global = this

  var queueId = 1
  var queue = {}
  var isRunningTask = false

  if (!global.setImmediate)
    global.addEventListener('message', function (e) {
      if (e.source == global){
        if (isRunningTask)
          nextTick(queue[e.data])
        else {
          isRunningTask = true
          try {
            queue[e.data]()
          } catch (e) {}

          delete queue[e.data]
          isRunningTask = false
        }
      }
    })

  function nextTick(fn) {
    if (global.setImmediate) setImmediate(fn)
    // if inside of web worker
    else if (global.importScripts) setTimeout(fn)
    else {
      queueId++
      queue[queueId] = fn
      global.postMessage(queueId, '*')
    }
  }

  Deferred.resolve = function (value) {
    if (!(this._d == 1))
      throw TypeError()

    if (value instanceof Deferred)
      return value

    return new Deferred(function (resolve) {
        resolve(value)
    })
  }

  Deferred.reject = function (value) {
    if (!(this._d == 1))
      throw TypeError()

    return new Deferred(function (resolve, reject) {
        reject(value)
    })
  }

  Deferred.all = function (arr) {
    if (!(this._d == 1))
      throw TypeError()

    if (!(arr instanceof Array))
      return Deferred.reject(TypeError())

    var d = new Deferred()

    function done(e, v) {
      if (v)
        return d.resolve(v)

      if (e)
        return d.reject(e)

      var unresolved = arr.reduce(function (cnt, v) {
        if (v && v.then)
          return cnt + 1
        return cnt
      }, 0)

      if(unresolved == 0)
        d.resolve(arr)

      arr.map(function (v, i) {
        if (v && v.then)
          v.then(function (r) {
            arr[i] = r
            done()
            return r
          }, done)
      })
    }

    done()

    return d
  }

  Deferred.race = function (arr) {
    if (!(this._d == 1))
      throw TypeError()

    if (!(arr instanceof Array))
      return Deferred.reject(TypeError())

    if (arr.length == 0)
      return new Deferred()

    var d = new Deferred()

    function done(e, v) {
      if (v)
        return d.resolve(v)

      if (e)
        return d.reject(e)

      var unresolved = arr.reduce(function (cnt, v) {
        if (v && v.then)
          return cnt + 1
        return cnt
      }, 0)

      if(unresolved == 0)
        d.resolve(arr)

      arr.map(function (v, i) {
        if (v && v.then)
          v.then(function (r) {
            done(null, r)
          }, done)
      })
    }

    done()

    return d
  }

  Deferred._d = 1


  /**
   * @constructor
   */
  function Deferred(resolver) {
    'use strict'
    if (typeof resolver != 'function' && resolver != undefined)
      throw TypeError()

    if (typeof this != 'object' || (this && this.then))
      throw TypeError()

    // states
    // 0: pending
    // 1: resolving
    // 2: rejecting
    // 3: resolved
    // 4: rejected
    var self = this,
      state = 0,
      val = 0,
      next = [],
      fn, er;

    self['promise'] = self

    self['resolve'] = function (v) {
      fn = self.fn
      er = self.er
      if (!state) {
        val = v
        state = 1

        nextTick(fire)
      }
      return self
    }

    self['reject'] = function (v) {
      fn = self.fn
      er = self.er
      if (!state) {
        val = v
        state = 2

        nextTick(fire)

      }
      return self
    }

    self['_d'] = 1

    self['then'] = function (_fn, _er) {
      if (!(this._d == 1))
        throw TypeError()

      var d = new Deferred()

      d.fn = _fn
      d.er = _er
      if (state == 3) {
        d.resolve(val)
      }
      else if (state == 4) {
        d.reject(val)
      }
      else {
        next.push(d)
      }

      return d
    }

    self['catch'] = function (_er) {
      return self['then'](null, _er)
    }

    var finish = function (type) {
      state = type || 4
      next.map(function (p) {
        state == 3 && p.resolve(val) || p.reject(val)
      })
    }

    try {
      if (typeof resolver == 'function')
        resolver(self['resolve'], self['reject'])
    } catch (e) {
      self['reject'](e)
    }

    return self

    // ref : reference to 'then' function
    // cb, ec, cn : successCallback, failureCallback, notThennableCallback
    function thennable (ref, cb, ec, cn) {
      // Promises can be rejected with other promises, which should pass through
      if (state == 2) {
        return cn()
      }
      if ((typeof val == 'object' || typeof val == 'function') && typeof ref == 'function') {
        try {

          // cnt protects against abuse calls from spec checker
          var cnt = 0
          ref.call(val, function (v) {
            if (cnt++) return
            val = v
            cb()
          }, function (v) {
            if (cnt++) return
            val = v
            ec()
          })
        } catch (e) {
          val = e
          ec()
        }
      } else {
        cn()
      }
    };

    function fire() {

      // check if it's a thenable
      var ref;
      try {
        ref = val && val.then
      } catch (e) {
        val = e
        state = 2
        return fire()
      }

      thennable(ref, function () {
        state = 1
        fire()
      }, function () {
        state = 2
        fire()
      }, function () {
        try {
          if (state == 1 && typeof fn == 'function') {
            val = fn(val)
          }

          else if (state == 2 && typeof er == 'function') {
            val = er(val)
            state = 1
          }
        } catch (e) {
          val = e
          return finish()
        }

        if (val == self) {
          val = TypeError()
          finish()
        } else thennable(ref, function () {
            finish(3)
          }, finish, function () {
            finish(state == 1 && 3)
          })

      })
    }


  }

  // Export our library object, either for node.js or as a globally scoped variable
  if (true) {
    module['exports'] = Deferred
  } else {}
})()

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(20), __webpack_require__(32).setImmediate))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
Object.defineProperty(exports, "__esModule", { value: true });
var DataProxy = /** @class */ (function () {
    function DataProxy(url) {
        this.url = url;
    }
    DataProxy.prototype.load = function () {
        return this._ajax(this.url);
    };
    DataProxy.prototype.save = function (data, mode) {
        var modes = {
            insert: "POST",
            delete: "DELETE",
            update: "POST"
        };
        return this._ajax(this.url, data, modes[mode] || "POST");
    };
    DataProxy.prototype._ajax = function (url, data, method) {
        if (method === void 0) { method = "GET"; }
        return new Promise(function (resolve, reject) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                if (xhr.status >= 200 && xhr.status < 300) {
                    resolve(xhr.response || xhr.responseText);
                }
                else {
                    reject({
                        status: xhr.status,
                        statusText: xhr.statusText
                    });
                }
            };
            xhr.onerror = function () {
                reject({
                    status: xhr.status,
                    statusText: xhr.statusText
                });
            };
            xhr.open(method, url);
            xhr.setRequestHeader("Content-Type", "application/json");
            switch (method) {
                case "POST":
                case "DELETE":
                case "PUT":
                    xhr.send(JSON.stringify(data));
                    break;
                case "GET":
                    xhr.send();
                    break;
                default:
                    xhr.send();
                    break;
            }
        });
    };
    return DataProxy;
}());
exports.DataProxy = DataProxy;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var html_1 = __webpack_require__(1);
var View = /** @class */ (function () {
    function View(_container, config) {
        this._uid = core_1.uid();
        this.config = config || {};
    }
    View.prototype.mount = function (container, vnode) {
        if (vnode) {
            this._view = vnode;
        }
        if (container && this._view && this._view.mount) {
            // init view inside of HTML container
            this._container = html_1.toNode(container);
            if (this._container.tagName) {
                this._view.mount(this._container);
            }
            else if (this._container.attach) {
                this._container.attach(this);
            }
        }
    };
    View.prototype.getRootView = function () {
        return this._view;
    };
    View.prototype.paint = function () {
        if (this._view && ( // was mounted
        this._view.node || // already rendered node
            this._container || // not rendered, but has container
            !this._view.mount)) { // fake cell node
            this._doNotRepaint = false;
            this._view.redraw();
        }
    };
    return View;
}());
exports.View = View;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getRealPosition(node) {
    var rects = node.getBoundingClientRect();
    return {
        left: rects.left + window.pageXOffset,
        right: rects.right + window.pageXOffset,
        top: rects.top + window.pageYOffset,
        bottom: rects.bottom + window.pageYOffset
    };
}
exports.getRealPosition = getRealPosition;
function calculatePosition(pos, config) {
    var rightBorder = window.pageXOffset + window.innerWidth;
    var bottomBorder = window.pageYOffset + window.innerHeight;
    var style = {
        left: null,
        top: null,
        minWidth: config.width + "px",
        position: "absolute"
    };
    if (config.mode === "bottom") {
        if (pos.left + config.width > rightBorder) {
            style.left = pos.left - config.width + "px";
        }
        else {
            style.left = pos.left + "px";
        }
        if (pos.bottom + config.height > bottomBorder) {
            style.top = pos.top - config.height + "px";
        }
        else {
            style.top = pos.bottom + "px";
        }
    }
    else {
        if (pos.right + config.width > rightBorder) {
            style.left = pos.left - config.width + "px";
        }
        else {
            style.left = pos.right + "px";
        }
        if (pos.top + config.height > bottomBorder) {
            style.top = pos.bottom - config.height + "px";
        }
        else {
            style.top = pos.top + "px";
        }
    }
    return style;
}
exports.calculatePosition = calculatePosition;
function addInGroups(groups, item) {
    if (groups[item.group]) {
        if (item.active) {
            groups[item.group].active = item.id;
        }
        groups[item.group].elements.push(item.id);
    }
    else {
        groups[item.group] = {
            active: item.active ? item.id : null,
            elements: [item.id]
        };
    }
}
exports.addInGroups = addInGroups;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

exports.__esModule = true;
var locale = {
    dragAndDrop: "Drag & drop",
    or: "or",
    browse: "Browse files",
    filesOrFoldersHere: "files or folders here",
    cancel: "Cancel",
    clearAll: "Clear all",
    clear: "Clear",
    add: "Add",
    upload: "Upload",
    download: "Download",
    error: "error",
    byte: "B",
    kilobyte: "KB",
    megabyte: "MB",
    gigabyte: "GB"
};
exports["default"] = locale;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var types_1 = __webpack_require__(5);
var types_2 = __webpack_require__(5);
exports.DataEvents = types_2.DataEvents;
var FileStatus;
(function (FileStatus) {
    FileStatus["queue"] = "queue";
    FileStatus["uploaded"] = "uploaded";
    FileStatus["failed"] = "failed";
    FileStatus["inprogress"] = "inprogress";
})(FileStatus = exports.FileStatus || (exports.FileStatus = {}));
var UploaderEvents;
(function (UploaderEvents) {
    UploaderEvents["uploadBegin"] = "uploadbegin";
    UploaderEvents["beforeUploadFile"] = "beforeuploadfile";
    UploaderEvents["uploadFile"] = "uploadfile";
    UploaderEvents["uploadFail"] = "uploadfail";
    UploaderEvents["uploadComplete"] = "uploadcomplete";
    UploaderEvents["uploadProgress"] = "uploadprogress";
})(UploaderEvents = exports.UploaderEvents || (exports.UploaderEvents = {}));
var ProgressBarEvents;
(function (ProgressBarEvents) {
    ProgressBarEvents["cancel"] = "cancel";
})(ProgressBarEvents = exports.ProgressBarEvents || (exports.ProgressBarEvents = {}));
var VaultMode;
(function (VaultMode) {
    VaultMode["grid"] = "grid";
    VaultMode["list"] = "list";
})(VaultMode = exports.VaultMode || (exports.VaultMode = {}));


/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(24));
__export(__webpack_require__(40));
__export(__webpack_require__(25));


/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var button_1 = __webpack_require__(49);
var customHTMLButton_1 = __webpack_require__(50);
var dhx_button_1 = __webpack_require__(51);
var iconButton_1 = __webpack_require__(52);
var imageButton_1 = __webpack_require__(53);
var imageButtonText_1 = __webpack_require__(54);
var input_1 = __webpack_require__(55);
var menuItem_1 = __webpack_require__(56);
var separator_1 = __webpack_require__(57);
var spacer_1 = __webpack_require__(58);
var text_1 = __webpack_require__(59);
var types_1 = __webpack_require__(4);
function itemfactory(item, events) {
    if (item.$hidden) {
        return null;
    }
    switch (item.type) {
        case types_1.ItemType.button:
            return button_1.button(item);
        case types_1.ItemType.text:
            return text_1.text(item);
        case types_1.ItemType.separator:
            return separator_1.separator(item);
        case types_1.ItemType.spacer:
            return spacer_1.spacer(item);
        case types_1.ItemType.input:
            return input_1.input(item, events);
        case types_1.ItemType.imageButton:
            return imageButton_1.imageButton(item);
        case types_1.ItemType.iconButton:
            return iconButton_1.iconButton(item);
        case types_1.ItemType.selectButton:
        case types_1.ItemType.menuItem:
            return menuItem_1.menuItem(item);
        case types_1.ItemType.imageButtonText:
            return imageButtonText_1.imageButtonText(item);
        case types_1.ItemType.customHTMLButton:
            return customHTMLButton_1.customHTMLButton(item);
        case types_1.ItemType.dhxButton:
            return dhx_button_1.dhx_button(item);
        case types_1.ItemType.block:
        default:
            throw new Error("unknown item type");
    }
}
exports.itemfactory = itemfactory;
function createFactory(defaultType, forbiddenTypes) {
    if (forbiddenTypes === void 0) { forbiddenTypes = []; }
    var forbidden = {};
    forbiddenTypes.forEach(function (type) { return forbidden[type] = true; });
    return function (item, events) {
        item.type = item.type || defaultType;
        if (forbidden[item.type]) {
            item.type = defaultType;
        }
        return itemfactory(item, events);
    };
}
exports.createFactory = createFactory;


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var dom_1 = __webpack_require__(0);
var events_1 = __webpack_require__(9);
var hotkeys_1 = __webpack_require__(60);
var html_1 = __webpack_require__(1);
var view_1 = __webpack_require__(12);
var ts_data_1 = __webpack_require__(8);
var helper_1 = __webpack_require__(13);
var itemfactory_1 = __webpack_require__(17);
var types_1 = __webpack_require__(4);
var MenuBase = /** @class */ (function (_super) {
    __extends(MenuBase, _super);
    function MenuBase(element, config) {
        var _this = _super.call(this, element, core_1.extend({
            popupWidth: 175
        }, config)) || this;
        _this._isContextMenu = false;
        _this._documentHaveListener = false;
        _this.events = new events_1.EventSystem();
        _this.data = new ts_data_1.TreeCollection({}, _this.events);
        _this._documentClick = function (e) {
            if (html_1.locate(e, "dhx_widget_id") !== _this._uid && _this._documentHaveListener) {
                document.removeEventListener("click", _this._documentClick);
                _this._documentHaveListener = false;
                _this._close();
            }
        };
        _this._currentRoot = _this.data.getRoot();
        _this._factory = itemfactory_1.createFactory(types_1.ItemType.menuItem);
        _this._init();
        _this._initHandlers();
        _this._initEvents();
        return _this;
    }
    MenuBase.prototype.paint = function () {
        _super.prototype.paint.call(this);
        this._vpopups.redraw();
    };
    MenuBase.prototype.disable = function (ids) {
        this._setProp(ids, "$disabled", true);
    };
    MenuBase.prototype.enable = function (ids) {
        this._setProp(ids, "$disabled", false);
    };
    MenuBase.prototype.show = function (ids) {
        this._setProp(ids, "$hidden", false);
    };
    MenuBase.prototype.hide = function (ids) {
        this._setProp(ids, "$hidden", true);
    };
    MenuBase.prototype.destructor = function () {
        hotkeys_1.keyManager.removeHotKey(null, this);
    };
    MenuBase.prototype._close = function () {
        if (this.config.navigationType === types_1.NavigationType.click) {
            this._isActive = false;
        }
        clearTimeout(this._currentTimeout);
        this._activeMenu = null;
        this.paint();
    };
    MenuBase.prototype._init = function () {
        var _this = this;
        var render = function () { return dom_1.el("div", __assign({ dhx_widget_id: _this._uid, class: "menu-popups" + (_this._isContextMenu ? " context-menu" : "") }, _this._handlers), _this._drawPopups()); };
        this._vpopups = dom_1.create({
            render: render
        });
        this._vpopups.mount(document.body);
    };
    MenuBase.prototype._initHandlers = function () {
        var _this = this;
        /*
            for navigation type click:
            first click open menu, _isActive = true
            after navigation use mousemove
            can be closed after outer click or menu leaf item click
        */
        this._isActive = this.config.navigationType !== types_1.NavigationType.click;
        this._handlers = {
            onmousemove: function (e) {
                if (!_this._isActive) {
                    return;
                }
                var elem = html_1.locateNode(e);
                if (!elem) {
                    _this._activeItemChange(null);
                    return;
                }
                var id = elem.getAttribute("dhx_id");
                if (_this._activeMenu !== id) {
                    _this._activeMenu = id;
                    if (_this.data.haveChilds(id)) {
                        var position = helper_1.getRealPosition(elem);
                        _this.data.update(id, { $position: position }, false);
                    }
                    _this._activeItemChange(id);
                }
            },
            onmouseleave: function () {
                if (_this.config.navigationType !== types_1.NavigationType.click) { // maybe all time when mouse leave close menu
                    _this._activeItemChange(null);
                }
            },
            onclick: function (e) {
                var element = html_1.locateNode(e);
                if (!element) {
                    return;
                }
                var id = element.getAttribute("dhx_id");
                var item = _this.data.getItem(id);
                switch (item.type) {
                    case types_1.ItemType.selectButton:
                    case types_1.ItemType.menuItem:
                        if (id === _this._currentRoot) {
                            _this._close();
                            return;
                        }
                        if (!_this._isActive) {
                            _this._isActive = true;
                        }
                        _this._setRoot(id);
                        _this._activeMenu = id;
                        if (_this.data.haveChilds(id)) {
                            var position = helper_1.getRealPosition(element);
                            _this.data.update(id, { $position: position }, false);
                            _this._activeItemChange(id);
                        }
                        else {
                            _this._onMenuItemClick(id, e);
                        }
                        break;
                    case types_1.ItemType.dhxButton:
                    case types_1.ItemType.imageButtonText:
                    case types_1.ItemType.iconButton:
                    case types_1.ItemType.imageButton:
                    case types_1.ItemType.button:
                    case types_1.ItemType.customHTMLButton:
                        if (item.twoState) {
                            _this.data.update(item.id, { active: !item.active });
                        }
                        _this.events.fire(types_1.ToolbarEvents.click, [id, e]);
                    case types_1.ItemType.separator:
                    case types_1.ItemType.input:
                    case types_1.ItemType.text:
                    case types_1.ItemType.spacer:
                        _this._close();
                    default:
                        return;
                }
            }
        };
    };
    MenuBase.prototype._initEvents = function () {
        var _this = this;
        var timeout = null;
        this.data.events.on(types_1.DataEvents.change, function () {
            _this.paint();
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                _this._normalizeData();
                _this._resetHotkeys();
                timeout = null;
                _this.paint();
            }, 100);
        });
        this.events.on(types_1.ToolbarEvents.click, function (id) {
            var item = _this.data.getItem(id);
            var parent = _this.data.getItem(item.parent);
            if (parent && parent.type === types_1.ItemType.selectButton) {
                _this.data.update(item.parent, { value: item.value, icon: item.icon });
            }
            if (item.group) {
                var group = _this._groups[item.group];
                if (group.active) {
                    _this.data.update(group.active, { active: false });
                }
                group.active = item.id;
                _this.data.update(item.id, { active: true });
            }
        });
    };
    MenuBase.prototype._drawPopups = function () {
        var _this = this;
        var id = this._activeMenu;
        if (!this._isContextMenu && !id) {
            return null;
        }
        var root = this._currentRoot;
        if (this._isContextMenu && !this._activePosition) {
            return null;
        }
        var parentIds = this._getParents(id, root);
        return parentIds.map(function (itemId) {
            if (!_this.data.haveChilds(itemId)) {
                return null;
            }
            var item = _this.data.getItem(itemId) || {}; // for root item
            var count = 0;
            var separators = 0;
            _this.data.eachChild(itemId, function (child) {
                if (child.$hidden) {
                    return;
                }
                if (child.type === "separator" || child.separator) {
                    separators++;
                }
                else {
                    count++;
                }
            }, false);
            var width = item.width || _this.config.popupWidth;
            var position = (_this._isContextMenu && _this._activePosition && itemId === root) ? _this._activePosition : item.$position;
            var mode = _this._getMode(item, root, position === _this._activePosition);
            var height = (position.bottom - position.top) * count + separators * 5; // separator 5px
            return dom_1.el("div", {
                class: "dhx_widget menu-popup",
                style: helper_1.calculatePosition(position, { mode: mode, width: width, height: height })
            }, _this._drawMenuItems(itemId));
        }).reverse();
    };
    MenuBase.prototype._onMenuItemClick = function (id, e) {
        var item = this.data.getItem(id);
        if (item.$disabled) {
            return;
        }
        this.events.fire(types_1.ToolbarEvents.click, [id, e]);
        this._close();
    };
    MenuBase.prototype._activeItemChange = function (id) {
        var _this = this;
        if (id && !this._documentHaveListener) {
            this._listenOuterClick();
        }
        if (id && this.data.haveChilds(id)) {
            this._activeMenu = id;
            clearTimeout(this._currentTimeout);
            this.paint();
        }
        else {
            this._activeMenu = id;
            clearTimeout(this._currentTimeout);
            this._currentTimeout = setTimeout(function () { return _this.paint(); }, 400);
        }
    };
    MenuBase.prototype._resetHotkeys = function () {
        var _this = this;
        hotkeys_1.keyManager.removeHotKey(null, this);
        this.data.map(function (item) {
            if (item.hotkey) {
                hotkeys_1.keyManager.addHotKey(item.hotkey, function () { return _this._onMenuItemClick(item.id, null); }, _this);
            }
        });
    };
    MenuBase.prototype._listenOuterClick = function () {
        document.addEventListener("click", this._documentClick);
        this._documentHaveListener = true;
    };
    MenuBase.prototype._getMode = function (item, root, _active) {
        if (_active === void 0) { _active = false; }
        return item.parent === root ? "bottom" : "right";
    };
    MenuBase.prototype._drawMenuItems = function (id) {
        var _this = this;
        return this.data.map(function (item) { return _this._factory(item, _this.events); }, id, false);
    };
    MenuBase.prototype._normalizeData = function () {
        var _this = this;
        var root = this.data.getRoot();
        var groups = {};
        this.data.eachChild(root, function (item) {
            if (_this.data.haveChilds(item.id) && item.parent !== _this.data.getRoot()) {
                item.$openIcon = "right";
            }
            if (item.group) {
                helper_1.addInGroups(groups, item);
            }
        }, true);
        this._groups = groups;
    };
    MenuBase.prototype._setRoot = function (_id) {
        return; // need only for toolbar
    };
    MenuBase.prototype._getParents = function (id, root) {
        var parentIds = [];
        var afterRoot = false;
        var currentItem = this.data.getItem(id);
        var disabled = currentItem && currentItem.$disabled;
        this.data.eachParent(id, function (item) {
            if (item.id === root) {
                parentIds.push(item.id);
                afterRoot = true;
            }
            else if (!afterRoot) {
                parentIds.push(item.id);
            }
        }, !disabled);
        if (this._isContextMenu && this._activePosition) {
            parentIds.push(root);
        }
        return parentIds;
    };
    MenuBase.prototype._setProp = function (id, key, value) {
        var _this = this;
        var _a;
        if (Array.isArray(id)) {
            id.forEach(function (itemId) {
                var _a;
                return _this.data.update(itemId, (_a = {}, _a[key] = value, _a));
            });
        }
        else {
            this.data.update(id, (_a = {}, _a[key] = value, _a));
        }
    };
    return MenuBase;
}(view_1.View));
exports.MenuBase = MenuBase;


/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(9);
var loader_1 = __webpack_require__(31);
var sort_1 = __webpack_require__(35);
var dataproxy_1 = __webpack_require__(11);
var helpers_1 = __webpack_require__(7);
var types_1 = __webpack_require__(6);
var core_1 = __webpack_require__(3);
var DataCollection = /** @class */ (function () {
    function DataCollection(config, events) {
        this._order = [];
        this._pull = {};
        this._changes = {
            order: []
        };
        this._initOrder = null;
        this.config = config || {};
        this._sort = new sort_1.Sort();
        this._loader = new loader_1.Loader(this, this._changes);
        this.events = events || new events_1.EventSystem(this);
    }
    DataCollection.prototype.add = function (obj, index) {
        if (!this.events.fire(types_1.DataEvents.beforeAdd, [obj])) {
            return;
        }
        this._addCore(obj, index);
        this._onChange("add", obj.id, obj);
        this.events.fire(types_1.DataEvents.afterAdd, [obj]);
    };
    DataCollection.prototype.remove = function (id) {
        var obj = this._pull[id];
        if (obj) {
            if (!this.events.fire(types_1.DataEvents.beforeRemove, [obj])) {
                return;
            }
            this._removeCore(obj.id);
            this._onChange("remove", id, obj);
        }
        this.events.fire(types_1.DataEvents.afterRemove, [obj]);
    };
    DataCollection.prototype.removeAll = function () {
        this._removeAll();
        this.events.fire(types_1.DataEvents.removeAll);
        this.events.fire(types_1.DataEvents.change);
    };
    DataCollection.prototype.exists = function (id) {
        return !!this._pull[id];
    };
    DataCollection.prototype.getNearId = function (id) {
        var item = this._pull[id];
        if (!item) {
            return this._order[0].id || "";
        }
    };
    DataCollection.prototype.getItem = function (id) {
        return this._pull[id];
    };
    DataCollection.prototype.update = function (id, obj, silent) {
        var item = this.getItem(id);
        if (item) {
            if (helpers_1.isEqualObj(obj, item)) {
                return;
            }
            if (obj.id && id !== obj.id) {
                helpers_1.dhxWarning("this method doesn't allow change id");
                if (helpers_1.isDebug()) {
                    // tslint:disable-next-line:no-debugger
                    debugger;
                }
            }
            else {
                core_1.extend(this._pull[id], obj, false);
                if (this.config.update) {
                    this.config.update(this._pull[id]);
                }
                if (!silent) {
                    this._onChange("update", id, this._pull[id]);
                }
            }
        }
        else {
            helpers_1.dhxWarning("item not found");
        }
    };
    DataCollection.prototype.getIndex = function (id) {
        var res = core_1.findIndex(this._order, function (item) { return item.id === id; });
        if (this._pull[id] && res >= 0) {
            return res;
        }
        return -1;
    };
    DataCollection.prototype.getId = function (index) {
        if (!this._order[index]) {
            return;
        }
        return this._order[index].id;
    };
    DataCollection.prototype.getLength = function () {
        return this._order.length;
    };
    DataCollection.prototype.filter = function (rule, config) {
        var _this = this;
        config = core_1.extend({
            add: false,
            multiple: true
        }, config);
        if (!config.add) {
            this._order = this._initOrder || this._order;
            this._initOrder = null;
        }
        this._filters = this._filters || {};
        if (!config.multiple || !rule) {
            this._filters = {};
        }
        if (rule) {
            if (typeof rule === "function") {
                var f = "_";
                this._filters[f] = {
                    match: f,
                    compare: rule
                };
            }
            else {
                if (!rule.match) {
                    delete this._filters[rule.by];
                }
                else {
                    rule.compare = rule.compare || (function (val, match) { return val === match; });
                    this._filters[rule.by] = rule;
                }
            }
            var fOrder = this._order.filter(function (item) {
                return Object.keys(_this._filters).every(function (key) {
                    return item[key] ?
                        _this._filters[key].compare(item[key], _this._filters[key].match, item)
                        : _this._filters[key].compare(item);
                });
            });
            if (!this._initOrder) {
                this._initOrder = this._order;
                this._order = fOrder;
            }
        }
        this.events.fire(types_1.DataEvents.change);
    };
    DataCollection.prototype.find = function (conf) {
        for (var key in this._pull) {
            var res = helpers_1.findByConf(this._pull[key], conf);
            if (res) {
                return res;
            }
        }
        return null;
    };
    DataCollection.prototype.findAll = function (conf) {
        var res = [];
        for (var key in this._pull) {
            var item = helpers_1.findByConf(this._pull[key], conf);
            if (item) {
                res.push(item);
            }
        }
        return res;
    };
    DataCollection.prototype.sort = function (by) {
        this._sort.sort(this._order, by);
        if (this._initOrder && this._initOrder.length) {
            this._sort.sort(this._initOrder, by);
        }
        this.events.fire(types_1.DataEvents.change);
    };
    DataCollection.prototype.copy = function (id, index, target, targetId) {
        if (!this.exists(id)) {
            return null;
        }
        var newid = core_1.uid();
        if (target) {
            if (targetId) {
                target.add(__assign({}, this.getItem(id)), index, targetId);
                return;
            }
            if (target.exists(id)) {
                target.add(__assign({}, this.getItem(id), { id: newid }), index);
                return newid;
            }
            else {
                target.add(this.getItem(id), index);
                return id;
            }
        }
        this.add(__assign({}, this.getItem(id), { id: newid }), index);
        return newid;
    };
    DataCollection.prototype.move = function (id, index, target, targetId) {
        if (target && target !== this && this.exists(id)) {
            var item = this.getItem(id);
            if (target.exists(id)) {
                item.id = core_1.uid();
            }
            if (targetId) {
                item.parent = targetId;
            }
            target.add(item, index);
            // remove data from original collection
            this.remove(item.id);
            return item.id;
        }
        if (this.getIndex(id) === index) {
            return null;
        }
        // move other elements
        var spliced = this._order.splice(this.getIndex(id), 1)[0];
        if (index === -1) {
            index = this._order.length;
        }
        this._order.splice(index, 0, spliced);
        this.events.fire(types_1.DataEvents.change); // if target not this, it trigger add and remove
        return id;
    };
    DataCollection.prototype.load = function (url, driver) {
        if (typeof url === "string") {
            url = new dataproxy_1.DataProxy(url);
        }
        return this._loader.load(url, driver);
    };
    DataCollection.prototype.parse = function (data, driver) {
        this._removeAll();
        return this._loader.parse(data, driver);
    };
    DataCollection.prototype.$parse = function (data) {
        var apx = this.config.approximate;
        if (apx) {
            data = this._approximate(data, apx.value, apx.maxNum);
        }
        this._parse_data(data);
        this.events.fire(types_1.DataEvents.change);
        this.events.fire(types_1.DataEvents.load);
    };
    DataCollection.prototype.save = function (url) {
        this._loader.save(url);
    };
    // todo: loop through the array and check saved statuses
    DataCollection.prototype.isSaved = function () {
        return !this._changes.order.length; // todo: bad solution, errors and holded elments are missed...
    };
    DataCollection.prototype.map = function (cb) {
        var result = [];
        for (var i = 0; i < this._order.length; i++) {
            result.push(cb.call(this, this._order[i], i));
        }
        return result;
    };
    DataCollection.prototype.reduce = function (cb, acc) {
        for (var i = 0; i < this._order.length; i++) {
            acc = cb.call(this, acc, this._order[i], i);
        }
        return acc;
    };
    DataCollection.prototype.serialize = function () {
        return this.map(function (item) {
            var newItem = __assign({}, item);
            Object.keys(newItem).forEach(function (key) {
                if (key[0] === "$") {
                    delete newItem[key];
                }
            });
            return newItem;
        });
    };
    DataCollection.prototype.getInitialData = function () {
        return this._initOrder;
    };
    DataCollection.prototype._removeAll = function () {
        this._pull = {};
        this._order = [];
        this._changes.order = [];
        this._initOrder = null;
    };
    DataCollection.prototype._addCore = function (obj, index) {
        if (this.config.init) {
            obj = this.config.init(obj);
        }
        obj.id = obj.id ? obj.id.toString() : core_1.uid();
        if (this._pull[obj.id]) {
            helpers_1.dhxError("Item already exist");
        }
        // todo: not ideal solution
        if (this._initOrder && this._initOrder.length) {
            this._addToOrder(this._initOrder, obj, index);
        }
        this._addToOrder(this._order, obj, index);
    };
    DataCollection.prototype._removeCore = function (id) {
        if (this.getIndex(id) >= 0) {
            this._order = this._order.filter(function (el) { return el.id !== id; });
            delete this._pull[id];
        }
        if (this._initOrder && this._initOrder.length) {
            this._initOrder = this._initOrder.filter(function (el) { return el.id !== id; });
        }
    };
    DataCollection.prototype._parse_data = function (data) {
        var index = this._order.length;
        if (this.config.prep) {
            data = this.config.prep(data);
        }
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var obj = data_1[_i];
            if (this.config.init) {
                obj = this.config.init(obj);
            }
            obj.id = obj.id || core_1.uid();
            this._pull[obj.id] = obj;
            this._order[index++] = obj;
        }
    };
    DataCollection.prototype._approximate = function (data, values, maxNum) {
        var len = data.length;
        var vlen = values.length;
        var rlen = Math.floor(len / maxNum);
        var newData = Array(Math.ceil(len / rlen));
        var index = 0;
        for (var i = 0; i < len; i += rlen) {
            var newItem = core_1.copy(data[i]);
            var end = Math.min(len, i + rlen);
            for (var j = 0; j < vlen; j++) {
                var sum = 0;
                for (var z = i; z < end; z++) {
                    sum += data[z][values[j]];
                }
                newItem[values[j]] = sum / (end - i);
            }
            newData[index++] = newItem;
        }
        return newData;
    };
    DataCollection.prototype._onChange = function (status, id, obj) {
        for (var _i = 0, _a = this._changes.order; _i < _a.length; _i++) {
            var item = _a[_i];
            // update pending item if previous state is "saving" or if item not saved yet
            if (item.id === id && !item.saving) {
                // update item
                if (item.error) {
                    item.error = false;
                }
                item = __assign({}, item, { obj: obj, status: status });
                this.events.fire(types_1.DataEvents.change, [id, status, obj]);
                return;
            }
        }
        this._changes.order.push({ id: id, status: status, obj: __assign({}, obj), saving: false });
        this.events.fire(types_1.DataEvents.change, [id, status, obj]);
    };
    DataCollection.prototype._addToOrder = function (array, obj, index) {
        if (index >= 0 && array[index]) {
            this._pull[obj.id] = obj;
            array.splice(index, 0, obj);
        }
        else {
            this._pull[obj.id] = obj;
            array.push(obj);
        }
    };
    return DataCollection;
}());
exports.DataCollection = DataCollection;


/***/ }),
/* 20 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1, eval)("this");
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var CsvDriver = /** @class */ (function () {
    function CsvDriver(config) {
        if (config === void 0) { config = {}; }
        var initConfig = {
            skipHeader: 0,
            nameByHeader: false,
            row: "\n",
            column: ",",
        };
        this.config = __assign({}, initConfig, config);
        if (this.config.nameByHeader) {
            this.config.skipHeader = 1;
        }
    }
    CsvDriver.prototype.getFields = function (row, headers) {
        var parts = row.trim().split(this.config.column);
        var obj = {};
        for (var i = 0; i < parts.length; i++) {
            obj[headers ? headers[i] : i + 1] = parts[i];
        }
        return obj;
    };
    CsvDriver.prototype.getRows = function (data) {
        return data.trim().split(this.config.row);
    };
    CsvDriver.prototype.toJsonArray = function (data) {
        var _this = this;
        var rows = this.getRows(data);
        var names = this.config.names;
        if (this.config.skipHeader) {
            var top_1 = rows.splice(0, this.config.skipHeader);
            if (this.config.nameByHeader) {
                names = top_1[0].trim().split(this.config.column);
            }
        }
        return rows.map(function (row) { return _this.getFields(row, names); });
    };
    return CsvDriver;
}());
exports.CsvDriver = CsvDriver;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var JsonDriver = /** @class */ (function () {
    function JsonDriver() {
    }
    JsonDriver.prototype.toJsonArray = function (data) {
        return this.getRows(data);
    };
    JsonDriver.prototype.getFields = function (row) {
        return row;
    };
    JsonDriver.prototype.getRows = function (data) {
        return typeof data === "string" ? JSON.parse(data) : data;
    };
    return JsonDriver;
}());
exports.JsonDriver = JsonDriver;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var datacollection_1 = __webpack_require__(19);
var dataproxy_1 = __webpack_require__(11);
var helpers_1 = __webpack_require__(7);
var types_1 = __webpack_require__(6);
function addToOrder(store, obj, parent, index) {
    if (index !== undefined && index !== -1 && store[parent] && store[parent][index]) {
        store[parent].splice(index, 0, obj);
    }
    else {
        if (!store[parent]) {
            store[parent] = [];
        }
        store[parent].push(obj);
    }
}
var TreeCollection = /** @class */ (function (_super) {
    __extends(TreeCollection, _super);
    function TreeCollection(config, events) {
        var _a;
        var _this = _super.call(this, config, events) || this;
        var root = _this._root = "_ROOT_" + core_1.uid();
        _this._childs = (_a = {}, _a[root] = [], _a);
        _this._initChilds = null;
        return _this;
    }
    TreeCollection.prototype.add = function (obj, index, parent) {
        if (index === void 0) { index = -1; }
        if (parent === void 0) { parent = this._root; }
        if (typeof obj !== "object") {
            obj = {
                value: obj
            };
        }
        obj.parent = obj.parent ? obj.parent.toString() : parent;
        _super.prototype.add.call(this, obj, index);
    };
    TreeCollection.prototype.getRoot = function () {
        return this._root;
    };
    TreeCollection.prototype.getParent = function (id, asObj) {
        if (asObj === void 0) { asObj = false; }
        if (!this._pull[id]) {
            return null;
        }
        var parent = this._pull[id].parent;
        return asObj ? this._pull[parent] : parent;
    };
    TreeCollection.prototype.getChilds = function (id) {
        if (this._childs && this._childs[id]) {
            return this._childs[id];
        }
        return [];
    };
    TreeCollection.prototype.getLength = function (id) {
        if (id === void 0) { id = this._root; }
        if (!this._childs[id]) {
            return null;
        }
        return this._childs[id].length;
    };
    TreeCollection.prototype.removeAll = function (id) {
        var _a;
        if (id) {
            var childs = this._childs[id].slice();
            for (var _i = 0, childs_1 = childs; _i < childs_1.length; _i++) {
                var child = childs_1[_i];
                this.remove(child.id);
            }
        }
        else {
            _super.prototype.removeAll.call(this);
            var root = this._root;
            this._initChilds = null;
            this._childs = (_a = {}, _a[root] = [], _a);
        }
    };
    TreeCollection.prototype.getIndex = function (id) {
        var parent = this.getParent(id);
        if (!parent || !this._childs[parent]) {
            return -1;
        }
        return core_1.findIndex(this._childs[parent], function (item) { return item.id === id; });
    };
    TreeCollection.prototype.sort = function (conf) {
        var childs = this._childs;
        for (var key in childs) {
            this._sort.sort(childs[key], conf);
        }
        this.events.fire(types_1.DataEvents.change);
    };
    TreeCollection.prototype.map = function (cb, parent, direct) {
        if (parent === void 0) { parent = this._root; }
        if (direct === void 0) { direct = true; }
        var result = [];
        if (!this.haveChilds(parent)) {
            return result;
        }
        for (var i = 0; i < this._childs[parent].length; i++) {
            result.push(cb.call(this, this._childs[parent][i], i));
            if (direct) {
                var childResult = this.map(cb, this._childs[parent][i].id, direct);
                result = result.concat(childResult);
            }
        }
        return result;
    };
    TreeCollection.prototype.filter = function (conf) {
        if (!conf) {
            this.restoreOrder();
            return;
        }
        if (!this._initChilds) {
            this._initChilds = this._childs;
        }
        conf.type = conf.type || types_1.TreeFilterType.all;
        var newChilds = {};
        this._recursiveFilter(conf, this._root, 0, newChilds);
        this._childs = newChilds;
        this.events.fire(types_1.DataEvents.change);
    };
    TreeCollection.prototype.restoreOrder = function () {
        if (this._initChilds) {
            this._childs = this._initChilds;
            this._initChilds = null;
        }
        this.events.fire(types_1.DataEvents.change);
    };
    TreeCollection.prototype.copy = function (id, index, target, targetId) {
        if (target === void 0) { target = this; }
        if (targetId === void 0) { targetId = this._root; }
        if (!this.exists(id)) {
            return null;
        }
        var childs = __assign({}, this._childs);
        var currentChilds = childs[id];
        if (target === this && !this.canCopy(id, targetId)) {
            return null;
        }
        if (!(target instanceof TreeCollection)) { // copy to datacollection
            target.add(this._pull[id]);
            return;
        }
        if (this.exists(id)) {
            var item = __assign({}, this.getItem(id));
            if (target.exists(id)) {
                item.id = core_1.uid();
            }
            else {
                item.id = id;
            }
            item.parent = targetId;
            target.add(item, index);
            id = item.id;
        }
        if (currentChilds) {
            for (var _i = 0, currentChilds_1 = currentChilds; _i < currentChilds_1.length; _i++) {
                var child = currentChilds_1[_i];
                var childId = child.id;
                var childIndex = this.getIndex(childId);
                this.copy(childId, childIndex, target, id);
            }
        }
        return id;
    };
    TreeCollection.prototype.move = function (id, index, target, targetId) {
        if (target === void 0) { target = this; }
        if (targetId === void 0) { targetId = this._root; }
        if (!this.exists(id)) {
            return null;
        }
        if (target !== this) {
            if (!(target instanceof TreeCollection)) { // move to datacollection
                target.add(this._pull[id]);
                this.remove(id);
                return;
            }
            var returnId = this.copy(id, index, target, targetId);
            this.remove(id);
            return returnId;
        }
        // move inside
        if (!this.canCopy(id, targetId)) {
            return null;
        }
        var parent = this.getParent(id);
        var parentIndex = this.getIndex(id);
        // get item from parent array and move to target array
        var spliced = this._childs[parent].splice(parentIndex, 1)[0];
        spliced.parent = targetId; // need for next moving, ... not best solution, may be full method for get item
        if (!this._childs[parent].length) {
            delete this._childs[parent];
        }
        if (!this.haveChilds(targetId)) {
            this._childs[targetId] = [];
        }
        if (index === -1) {
            index = this._childs[targetId].push(spliced);
        }
        else {
            this._childs[targetId].splice(index, 0, spliced);
        }
        this.events.fire(types_1.DataEvents.change);
        return id;
    };
    TreeCollection.prototype.eachChild = function (id, cb, direct) {
        if (direct === void 0) { direct = true; }
        if (!this.haveChilds(id)) {
            return;
        }
        for (var i = 0; i < this._childs[id].length; i++) {
            cb.call(this, this._childs[id][i], i);
            if (direct && this.getItem(this._childs[id][i].id).$opened !== false) {
                this.eachChild(this._childs[id][i].id, cb, direct);
            }
        }
    };
    TreeCollection.prototype.getNearId = function (id) {
        return id; // for selection
    };
    TreeCollection.prototype.loadChilds = function (id, driver) {
        var _this = this;
        if (driver === void 0) { driver = "json"; }
        var url = this.config.autoload + "?id=" + id;
        var proxy = new dataproxy_1.DataProxy(url);
        proxy.load().then(function (data) {
            driver = helpers_1.toDataDriver(driver);
            data = driver.toJsonArray(data);
            _this._parse_data(data, id);
            _this.events.fire(types_1.DataEvents.change);
        });
    };
    TreeCollection.prototype.refreshChilds = function (id, driver) {
        if (driver === void 0) { driver = "json"; }
        this.removeAll(id);
        this.loadChilds(id, driver);
    };
    TreeCollection.prototype.eachParent = function (id, cb, self) {
        if (self === void 0) { self = false; }
        var item = this.getItem(id);
        if (!item) {
            return;
        }
        if (self) {
            cb.call(this, item);
        }
        if (item.parent === this._root) {
            return;
        }
        var parent = this.getItem(item.parent);
        cb.call(this, parent);
        this.eachParent(item.parent, cb);
    };
    TreeCollection.prototype.haveChilds = function (id) {
        return id in this._childs;
    };
    TreeCollection.prototype.canCopy = function (id, target) {
        if (id === target) {
            return false;
        }
        var canCopy = true;
        this.eachParent(target, function (item) { return item.id === id ? canCopy = false : null; }); // locate return string
        return canCopy;
    };
    TreeCollection.prototype.serialize = function (fn) {
        return this._serialize(this._root, fn);
    };
    TreeCollection.prototype.getId = function (index, parent) {
        if (parent === void 0) { parent = this._root; }
        if (!this._childs[parent] || !this._childs[parent][index]) {
            return;
        }
        return this._childs[parent][index].id;
    };
    TreeCollection.prototype._removeAll = function (id) {
        var _a;
        if (id) {
            var childs = this._childs[id].slice();
            for (var _i = 0, childs_2 = childs; _i < childs_2.length; _i++) {
                var child = childs_2[_i];
                this.remove(child.id);
            }
        }
        else {
            _super.prototype._removeAll.call(this);
            var root = this._root;
            this._initChilds = null;
            this._childs = (_a = {}, _a[root] = [], _a);
        }
    };
    TreeCollection.prototype._removeCore = function (id) {
        if (this._pull[id]) {
            var parent_1 = this.getParent(id);
            this._childs[parent_1] = this._childs[parent_1].filter(function (item) { return item.id !== id; });
            if (parent_1 !== this._root && !this._childs[parent_1].length) {
                delete this._childs[parent_1];
            }
            if (this._initChilds && this._initChilds[parent_1]) {
                this._initChilds[parent_1] = this._initChilds[parent_1].filter(function (item) { return item.id !== id; });
                if (parent_1 !== this._root && !this._initChilds[parent_1].length) {
                    delete this._initChilds[parent_1];
                }
            }
            this._fastDeleteChilds(this._childs, id);
            if (this._initChilds) {
                this._fastDeleteChilds(this._initChilds, id);
            }
        }
    };
    TreeCollection.prototype._addToOrder = function (_order, obj, index) {
        var childs = this._childs;
        var initChilds = this._initChilds;
        var parent = obj.parent;
        this._pull[obj.id] = obj;
        addToOrder(childs, obj, parent, index);
        if (initChilds) {
            addToOrder(initChilds, obj, parent, index);
        }
    };
    TreeCollection.prototype._parse_data = function (data, parent) {
        if (parent === void 0) { parent = this._root; }
        for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
            var obj = data_1[_i];
            if (this.config.init) {
                obj = this.config.init(obj);
            }
            if (typeof obj !== "object") {
                obj = {
                    value: obj
                };
            }
            obj.id = obj.id ? obj.id.toString() : core_1.uid();
            obj.parent = obj.parent ? obj.parent.toString() : parent;
            this._pull[obj.id] = obj;
            if (!this._childs[obj.parent]) {
                this._childs[obj.parent] = [];
            }
            this._childs[obj.parent].push(obj);
            if (obj.childs && obj.childs instanceof Object) {
                this._parse_data(obj.childs, obj.id);
            }
        }
    };
    TreeCollection.prototype._fastDeleteChilds = function (target, id) {
        if (this._pull[id]) {
            delete this._pull[id];
        }
        if (!target[id]) {
            return;
        }
        for (var i = 0; i < target[id].length; i++) {
            this._fastDeleteChilds(target, target[id][i].id);
        }
        delete target[id];
    };
    TreeCollection.prototype._recursiveFilter = function (conf, current, level, newChilds) {
        var _this = this;
        var childs = this._childs[current];
        if (!childs) {
            return;
        }
        var condition = function (item) {
            switch (conf.type) {
                case types_1.TreeFilterType.all: {
                    return true;
                }
                case types_1.TreeFilterType.specific: {
                    return level === conf.specific;
                }
                case types_1.TreeFilterType.leafs: {
                    return !_this.haveChilds(item.id);
                }
            }
        };
        if (conf.by && conf.match) {
            var customRule = function (item) { return !condition(item) || item[conf.by].toString().toLowerCase().indexOf(conf.match.toString().toLowerCase()) !== -1; };
            newChilds[current] = childs.filter(customRule);
        }
        else if (conf.rule && typeof conf.rule === "function") {
            var customRule = function (item) { return !condition(item) || conf.rule(item); };
            var filtered = childs.filter(customRule);
            if (filtered.length) {
                newChilds[current] = filtered;
            }
        }
        for (var _i = 0, childs_3 = childs; _i < childs_3.length; _i++) {
            var child = childs_3[_i];
            this._recursiveFilter(conf, child.id, level + 1, newChilds);
        }
    };
    TreeCollection.prototype._serialize = function (parent, fn) {
        var _this = this;
        if (parent === void 0) { parent = this._root; }
        return this.map(function (item) {
            var itemCopy = {};
            for (var key in item) {
                if (key === "parent" || key === "childs") {
                    continue;
                }
                itemCopy[key] = item[key];
            }
            if (fn) {
                itemCopy = fn(itemCopy);
            }
            if (_this.haveChilds(item.id)) {
                itemCopy.childs = _this._serialize(item.id, fn);
            }
            return itemCopy;
        }, parent, false);
    };
    return TreeCollection;
}(datacollection_1.DataCollection));
exports.TreeCollection = TreeCollection;


/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(1);
var tooltip_1 = __webpack_require__(25);
var Position;
(function (Position) {
    Position["right"] = "right";
    Position["bottom"] = "bottom";
    Position["center"] = "center";
})(Position = exports.Position || (exports.Position = {}));
var nodeTimeout = new WeakMap();
var messageStack = [];
var messageContainer = document.createElement("div");
messageContainer.className = "dhx-message-container";
function onExpire(node, fromClick) {
    if (fromClick) {
        clearTimeout(nodeTimeout.get(node));
    }
    var index = messageStack.indexOf(node);
    if (index < 0) { // node in body
        document.body.removeChild(node);
        return;
    }
    messageContainer.removeChild(node);
    messageStack.splice(index, 1);
    if (messageStack.length === 0) {
        document.body.removeChild(messageContainer);
    }
}
function message(props) {
    if (typeof props === "string") {
        props = { text: props };
    }
    var messageBox = document.createElement("div");
    messageBox.className = "dhx-message " + (props.css || "");
    messageBox.innerHTML = "<span class=\"message-text\">" + props.text + "</span> <div class=\"dxi " + props.icon + "\"></div>";
    if (props.at) {
        messageBox.style.position = "absolute";
        var _a = props.at, node = _a.node, position = _a.position;
        var elem = html_1.toNode(node);
        var rects = elem.getBoundingClientRect();
        document.body.appendChild(messageBox); // for calc bounings
        var _b = messageBox.getBoundingClientRect(), width = _b.width, height = _b.height;
        var _c = tooltip_1.findPosition(rects, position, width, height), left = _c.left, top_1 = _c.top, pos = _c.pos;
        messageBox.className += " " + pos;
        messageBox.style.left = left + "px";
        messageBox.style.top = top_1 + "px";
    }
    else {
        if (messageStack.length === 0) {
            document.body.appendChild(messageContainer);
        }
        messageStack.push(messageBox);
        messageContainer.appendChild(messageBox);
    }
    if (props.expire) {
        var timeout = setTimeout(function () { return onExpire(messageBox); }, props.expire);
        nodeTimeout.set(messageBox, timeout);
    }
    messageBox.onclick = function () { return onExpire(messageBox, true); };
}
exports.message = message;


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(1);
var message_1 = __webpack_require__(24);
var RealPosition;
(function (RealPosition) {
    RealPosition["left"] = "left";
    RealPosition["right"] = "right";
    RealPosition["top"] = "top";
    RealPosition["bottom"] = "bottom";
    RealPosition["center"] = "center";
})(RealPosition = exports.RealPosition || (exports.RealPosition = {}));
function findPosition(targetRect, position, width, height) {
    var margin = 8; // margin top/bot, left/right
    var pos;
    var left;
    var top;
    switch (position) {
        case message_1.Position.center:
            left = targetRect.left + window.pageXOffset + (targetRect.width - width) / 2;
            if (left + margin < window.pageXOffset) {
                left = targetRect.left + window.pageXOffset;
            }
            top = targetRect.top + window.pageYOffset + (targetRect.height - height) / 2;
            pos = RealPosition.center;
            return { left: left, top: top, pos: pos };
        case message_1.Position.right:
            pos = RealPosition.right;
            left = targetRect.right + window.pageXOffset;
            if (left + width + margin > window.innerWidth + window.pageXOffset) { // set left
                left = window.pageXOffset + targetRect.left - width;
                pos = RealPosition.left;
            }
            top = window.pageYOffset + targetRect.top + (targetRect.height - height) / 2;
            return { left: left, top: top, pos: pos };
        case message_1.Position.bottom:
            left = window.pageXOffset + targetRect.left + (targetRect.width - width) / 2;
            if (left < window.pageXOffset) {
                left = window.pageXOffset + targetRect.left;
            }
            pos = RealPosition.bottom;
            top = window.pageYOffset + targetRect.bottom;
            if (top + height + margin > window.innerHeight + window.pageYOffset) { // set top
                top = window.pageYOffset + targetRect.top - height;
                pos = RealPosition.top;
            }
            return { left: left, top: top, pos: pos };
    }
}
exports.findPosition = findPosition;
// tooltip init
var tooltipBox = document.createElement("div");
var tooltipText = document.createElement("span");
tooltipText.className = "tooltip-text";
tooltipBox.appendChild(tooltipText);
tooltipBox.style.position = "absolute";
var timeoutId = null;
var lastNode = null;
var isActive = false;
var hideTimeout = null;
function showTooltip(node, text, position, css, force) {
    if (force === void 0) { force = false; }
    var rects = node.getBoundingClientRect();
    tooltipText.textContent = text;
    document.body.appendChild(tooltipBox);
    tooltipBox.className = "dhx-tooltip" + (force ? " forced" : "");
    var _a = tooltipBox.getBoundingClientRect(), width = _a.width, height = _a.height;
    var _b = findPosition(rects, position, width, height), left = _b.left, top = _b.top, pos = _b.pos;
    switch (pos) {
        case RealPosition.bottom:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
        case RealPosition.top:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
        case RealPosition.left:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
        case RealPosition.right:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
        case RealPosition.center:
            tooltipBox.style.left = left + "px";
            tooltipBox.style.top = top + "px";
            break;
    }
    tooltipBox.className += " " + pos + " " + (css || "");
    isActive = true;
    if (!force) {
        setTimeout(function () {
            tooltipBox.className += " animate-tooltip";
        });
    }
}
function hideTooltip() {
    if (lastNode) {
        hideTimeout = setTimeout(function () {
            document.body.removeChild(tooltipBox);
            isActive = false;
            hideTimeout = null;
        }, 200);
    }
}
function addListners(node, text, position, css, force) {
    if (force === void 0) { force = false; }
    var mousemove = function () {
        if (isActive) {
            return;
        }
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        timeoutId = setTimeout(function () {
            showTooltip(node, text, position, css);
        }, 750);
    };
    var mouseout = function () {
        if (isActive) {
            hideTooltip();
        }
        clearTimeout(timeoutId);
        if (!force) {
            document.removeEventListener("mousemove", mousemove);
        }
        document.removeEventListener("mouseout", mouseout);
        document.removeEventListener("click", mouseout);
        lastNode = null;
    };
    if (force) {
        showTooltip(node, text, position, css, force);
    }
    else {
        document.addEventListener("mousemove", mousemove);
    }
    document.addEventListener("mouseout", mouseout);
    document.addEventListener("click", mouseout);
}
// default
function tooltip(text, at) {
    var node = html_1.toNode(at.node);
    if (node === lastNode) {
        return;
    }
    lastNode = node;
    if (hideTimeout) {
        clearTimeout(hideTimeout);
        hideTimeout = null;
        addListners(node, text, at.position, at.css, true);
    }
    else {
        addListners(node, text, at.position || message_1.Position.bottom, at.css);
    }
}
exports.tooltip = tooltip;
function enableTooltip() {
    document.addEventListener("mousemove", _mousemove);
}
exports.enableTooltip = enableTooltip;
function disableTooltip() {
    document.removeEventListener("mousemove", _mousemove);
}
exports.disableTooltip = disableTooltip;
function _mousemove(e) {
    var node = html_1.locateNode(e, "dhx_tooltip_text");
    if (!node) {
        return;
    }
    tooltip(node.getAttribute("dhx_tooltip_text"), {
        position: node.getAttribute("dhx_tooltip_position") || message_1.Position.bottom,
        node: node
    });
}


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var dom_1 = __webpack_require__(0);
var html_1 = __webpack_require__(1);
var ts_message_1 = __webpack_require__(16);
var types_1 = __webpack_require__(4);
var helper_1 = __webpack_require__(13);
var itemfactory_1 = __webpack_require__(17);
var MenuBase_1 = __webpack_require__(18);
var Toolbar = /** @class */ (function (_super) {
    __extends(Toolbar, _super);
    function Toolbar(element, config) {
        var _this = _super.call(this, element, core_1.extend({
            navigationType: "click"
        }, config)) || this;
        _this._currentRoot = null;
        _this._factory = itemfactory_1.createFactory(types_1.ItemType.button);
        var render = function () { return _this._draw(); };
        _this.mount(element, dom_1.create({ render: render }));
        return _this;
    }
    Toolbar.prototype.getValues = function () {
        var state = {};
        this.data.eachChild(this.data.getRoot(), function (item) {
            if (item.twoState) {
                state[item.id] = item.active;
            }
            else if (item.type === types_1.ItemType.input) {
                state[item.id] = item.value;
            }
        }, false);
        for (var key in this._groups) {
            if (this._groups[key].active) {
                state[key] = this._groups[key].active;
            }
        }
        return state;
    };
    Toolbar.prototype.setValues = function (state) {
        for (var key in state) {
            if (this._groups[key]) {
                if (this._groups[key].active) {
                    this.data.update(this._groups[key].active, { active: false });
                    this._groups[key].active = state[key];
                    this.data.update(state[key], { active: true });
                }
            }
            else {
                var item = this.data.getItem(key);
                if (item.type === types_1.ItemType.input) {
                    this.data.update(key, { value: state[key] });
                }
                else {
                    this.data.update(key, { active: state[key] });
                }
            }
        }
    };
    Toolbar.prototype._initHandlers = function () {
        var _this = this;
        _super.prototype._initHandlers.call(this);
        this._onInput = function (e) {
            var id = html_1.locate(e);
            _this.data.update(id, { value: e.target.value });
        };
        this._showTooltip = function (e) {
            var elem = html_1.locateNode(e);
            if (!elem) {
                return;
            }
            var id = elem.getAttribute("dhx_id");
            var item = _this.data.getItem(id);
            if (item.tooltip) {
                ts_message_1.tooltip(item.tooltip, {
                    node: elem,
                    position: ts_message_1.Position.bottom
                });
            }
        };
    };
    Toolbar.prototype._draw = function () {
        var _this = this;
        return dom_1.el(".toolbar.dhx_widget" + (this.config.css ? "." + this.config.css : ""), {
            dhx_widget_id: this._uid,
            onclick: this._handlers.onclick,
            oninput: this._onInput,
            onmouseover: this._showTooltip
        }, this.data.map(function (item) { return _this._factory(item, _this.events); }, this.data.getRoot(), false));
    };
    Toolbar.prototype._getMode = function (item, root) {
        return item.id === root ? "bottom" : "right";
    };
    Toolbar.prototype._close = function () {
        this._activeMenu = null;
        this._activePosition = null;
        this._currentRoot = null;
        this.paint();
    };
    Toolbar.prototype._normalizeData = function () {
        var _this = this;
        var root = this.data.getRoot();
        var groups = {};
        this.data.eachChild(root, function (item) {
            if (item.type === types_1.ItemType.menuItem || item.type === types_1.ItemType.selectButton) {
                if (_this.data.haveChilds(item.id)) {
                    _this.data.eachChild(item.id, function (child) { return child.type = child.type || types_1.ItemType.menuItem; }, false);
                    if (item.parent !== root) {
                        item.$openIcon = "right";
                    }
                    else {
                        item.$openIcon = "bot";
                    }
                }
            }
            if (item.group) {
                helper_1.addInGroups(groups, item);
            }
        }, true);
        this._groups = groups;
    };
    Toolbar.prototype._setRoot = function (id) {
        if (this.data.getParent(id) === this.data.getRoot()) { // if we clicked on item which not belong root, we cant set it as root item
            this._currentRoot = id;
        }
    };
    return Toolbar;
}(MenuBase_1.MenuBase));
exports.Toolbar = Toolbar;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__webpack_require__(28);
var ts_data_1 = __webpack_require__(8);
exports.DataCollection = ts_data_1.DataCollection;
var ts_message_1 = __webpack_require__(16);
exports.message = ts_message_1.message;
__export(__webpack_require__(42));
__export(__webpack_require__(15));
var en_1 = __webpack_require__(14);
exports.i18n = {};
exports.i18n.setLocale = function (component, value) {
    var target = exports.i18n[component];
    for (var key in value) {
        target[key] = value[key];
    }
};
exports.i18n.vault = exports.i18n.vault || en_1.default;


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = __webpack_require__(7);
var Loader = /** @class */ (function () {
    function Loader(parent, changes) {
        this._parent = parent;
        this._changes = changes; // todo: [dirty] mutation
    }
    Loader.prototype.load = function (url, driver) {
        var _this = this;
        return this._parent.loadData = url.load().then(function (data) {
            _this._parent.removeAll();
            _this.parse(data, driver);
        });
    };
    Loader.prototype.parse = function (data, driver) {
        if (driver === void 0) { driver = "json"; }
        driver = helpers_1.toDataDriver(driver);
        data = driver.toJsonArray(data);
        this._parent.$parse(data);
    };
    Loader.prototype.save = function (url) {
        var _this = this;
        var _loop_1 = function (el) {
            if (el.saving || el.pending) {
                helpers_1.dhxWarning("item is saving");
            }
            else {
                var prevEl_1 = this_1._findPrevState(el.id);
                if (prevEl_1 && prevEl_1.saving) {
                    var pending = new Promise(function (res, rej) {
                        prevEl_1.promise.then(function () {
                            el.pending = false;
                            res(_this._setPromise(el, url));
                        }).catch(function (err) {
                            _this._removeFromOrder(prevEl_1);
                            _this._setPromise(el, url);
                            helpers_1.dhxWarning(err);
                            rej(err);
                        });
                    });
                    this_1._addToChain(pending);
                    el.pending = true;
                }
                else {
                    this_1._setPromise(el, url);
                }
            }
        };
        var this_1 = this;
        for (var _i = 0, _a = this._changes.order; _i < _a.length; _i++) {
            var el = _a[_i];
            _loop_1(el);
        }
        this._parent.saveData.then(function () {
            _this._saving = false;
        });
    };
    Loader.prototype._setPromise = function (el, url) {
        var _this = this;
        el.promise = url.save(el.obj, el.status);
        el.promise.then(function () {
            _this._removeFromOrder(el);
        }).catch(function (err) {
            el.saving = false;
            el.error = true;
            helpers_1.dhxError(err);
        });
        el.saving = true;
        this._saving = true;
        this._addToChain(el.promise);
        return el.promise;
    };
    Loader.prototype._addToChain = function (promise) {
        // tslint:disable-next-line:prefer-conditional-expression
        if (this._parent.saveData && this._saving) {
            this._parent.saveData = this._parent.saveData.then(function () { return promise; });
        }
        else {
            this._parent.saveData = promise;
        }
    };
    Loader.prototype._findPrevState = function (id) {
        for (var _i = 0, _a = this._changes.order; _i < _a.length; _i++) {
            var el = _a[_i];
            if (el.id === id) {
                return el;
            }
        }
        return null;
    };
    Loader.prototype._removeFromOrder = function (el) {
        this._changes.order = this._changes.order.filter(function (item) { return !helpers_1.isEqualObj(item, el); });
    };
    return Loader;
}());
exports.Loader = Loader;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(33);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(20), __webpack_require__(34)))

/***/ }),
/* 34 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var helpers_1 = __webpack_require__(7);
var Sort = /** @class */ (function () {
    function Sort() {
    }
    Sort.prototype.sort = function (array, by) {
        var _this = this;
        if (by.rule && typeof by.rule === "function") {
            this._sort(array, by);
        }
        else if (by.by) {
            by.rule = function (a, b) {
                var aa = _this._checkVal(by.as, a[by.by]);
                var bb = _this._checkVal(by.as, b[by.by]);
                return helpers_1.naturalCompare(aa.toString(), bb.toString()); // didnt work with numbers
            };
            this._sort(array, by);
        }
    };
    Sort.prototype._checkVal = function (method, val) {
        return method ? method.call(this, val) : val;
    };
    Sort.prototype._sort = function (arr, conf) {
        var _this = this;
        var dir = {
            asc: 1,
            desc: -1
        };
        return arr.sort(function (a, b) {
            return conf.rule.call(_this, a, b) * (dir[conf.dir] || dir.asc);
        });
    };
    return Sort;
}());
exports.Sort = Sort;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(1);
var types_1 = __webpack_require__(5);
var CollectionStore_1 = __webpack_require__(38);
var treecollection_1 = __webpack_require__(23);
var types_2 = __webpack_require__(6);
var DropPosition;
(function (DropPosition) {
    DropPosition[DropPosition["top"] = 0] = "top";
    DropPosition[DropPosition["bot"] = 1] = "bot";
    DropPosition[DropPosition["in"] = 2] = "in";
})(DropPosition || (DropPosition = {}));
function getParentElement(target) {
    if (target instanceof Event) {
        target = target.target;
    }
    while (target && target.getAttribute) {
        var id = target.getAttribute("dhx_id");
        if (id) {
            return target;
        }
        target = target.parentNode;
    }
}
function getPosition(ev) {
    var y = ev.y;
    var element = getParentElement(ev); // may be use domvm refs
    if (!element) {
        return null;
    }
    var treeLine = element.childNodes[0];
    var _a = treeLine.getBoundingClientRect(), top = _a.top, height = _a.height;
    return (y - top) / height;
}
function dragEventContent(item) {
    var ghost = document.createElement("div");
    ghost.textContent = item.value || item.text;
    ghost.className = "drag-ghost"; // need pointer-events: none
    return ghost;
}
var DragManager = /** @class */ (function () {
    function DragManager() {
        var _this = this;
        this._transferData = {};
        this._canMove = true;
        this._ghostTopPadding = -17;
        this._onMouseMove = function (e) {
            if (!_this._transferData.id) {
                return;
            }
            var pageX = e.pageX, pageY = e.pageY;
            if (!_this._transferData.ghost) {
                if (Math.abs(_this._transferData.x - pageX) < 3 && Math.abs(_this._transferData.y - pageY) < 3) {
                    return;
                }
                else {
                    var ghost = _this._onDragStart(_this._transferData.id, _this._transferData.targetId);
                    if (!ghost) {
                        _this._endDrop();
                        return;
                    }
                    else {
                        _this._transferData.ghost = ghost;
                        document.body.appendChild(_this._transferData.ghost);
                    }
                }
            }
            _this._moveGhost(pageX, pageY);
            _this._onDrag(e);
        };
        this._onMouseUp = function () {
            if (!_this._transferData.x) {
                return;
            }
            if (_this._transferData.ghost) {
                _this._removeGhost();
                _this._onDrop();
            }
            else {
                _this._endDrop();
            }
            document.removeEventListener("mousemove", _this._onMouseMove);
            document.removeEventListener("mouseup", _this._onMouseUp);
        };
    }
    DragManager.prototype.setItem = function (id, item, config) {
        // const collection = document.querySelector(`[dhx_collection_id=${id}]`); // use it for add onmousedown here
        CollectionStore_1.collectionStore.setItem(id, item, config);
    };
    DragManager.prototype.onMouseDown = function (e) {
        if (e.which !== 1) {
            return;
        }
        document.addEventListener("mousemove", this._onMouseMove);
        document.addEventListener("mouseup", this._onMouseUp);
        var id = html_1.locate(e, "dhx_id");
        var targetId = html_1.locate(e, "dhx_collection_id");
        if (id && targetId) {
            this._transferData.x = e.x;
            this._transferData.y = e.y;
            this._transferData.targetId = targetId;
            this._transferData.id = id;
        }
    };
    DragManager.prototype._moveGhost = function (x, y) {
        if (this._transferData.ghost) {
            var width = this._transferData.ghost.offsetWidth / 2;
            this._transferData.ghost.style.left = x - width + "px";
            this._transferData.ghost.style.top = y + this._ghostTopPadding + "px";
        }
    };
    DragManager.prototype._removeGhost = function () {
        document.body.removeChild(this._transferData.ghost);
    };
    DragManager.prototype._onDrop = function () {
        if (!this._canMove) {
            this._endDrop();
            return;
        }
        var target = CollectionStore_1.collectionStore.getItem(this._lastCollectionId);
        var config = CollectionStore_1.collectionStore.getItemConfig(this._lastCollectionId);
        if (!target || config.mode === types_2.DragMode.source) {
            this._endDrop();
            return;
        }
        var to = {
            id: this._lastId,
            target: target
        };
        var from = {
            id: this._transferData.id,
            target: this._transferData.target
        };
        if (from.target.events.fire(types_1.DragEvents.beforeDrop, [from, to])) {
            this._move(from, to);
            to.target.events.fire(types_1.DragEvents.dropComplete, [to.id, this._transferData.dropPosition]);
        }
        this._endDrop();
    };
    DragManager.prototype._onDragStart = function (id, targetId) {
        var target = CollectionStore_1.collectionStore.getItem(targetId);
        var config = CollectionStore_1.collectionStore.getItemConfig(targetId);
        if (config.dragMode === types_2.DragMode.target) {
            return null;
        }
        var item = target.data.getItem(id);
        target.events.fire(types_1.DragEvents.dragStart); // we need it for cancel selection
        var ghost = dragEventContent(item);
        var ans = target.events.fire(types_1.DragEvents.beforeDrag, [item, ghost]);
        if (!ans || !id) {
            return null;
        }
        this._toggleTextSelection(true);
        this._transferData.target = target;
        this._transferData.dragConfig = config;
        return ghost;
    };
    DragManager.prototype._onDrag = function (e) {
        var x = e.x, y = e.y;
        var element = document.elementFromPoint(x, y);
        var id = html_1.locate(element, "dhx_id");
        if (!id) {
            this._cancelCanDrop();
            return;
        }
        var collectionId = html_1.locate(element, "dhx_collection_id");
        if (this._transferData.dragConfig.behaviour === types_2.DragBehaviour.complex) {
            var pos = getPosition(e);
            if (pos <= 0.25) {
                this._transferData.dropPosition = DropPosition.top;
            }
            else if (pos >= 0.75) {
                this._transferData.dropPosition = DropPosition.bot;
            }
            else {
                this._transferData.dropPosition = DropPosition.in;
            }
        }
        else if (this._lastId === id && this._lastCollectionId === collectionId) {
            return;
        }
        var eventArgs;
        var from;
        var targetTo;
        if ((!id || !collectionId) && this._canMove) {
            this._cancelCanDrop();
            return;
        }
        else {
            from = {
                id: this._transferData.id,
                target: this._transferData.target
            };
            targetTo = CollectionStore_1.collectionStore.getItem(collectionId);
            eventArgs = [from, {
                    id: id,
                    target: targetTo
                }];
            from.target.events.fire(types_1.DragEvents.dragOut, eventArgs);
        }
        if (collectionId !== this._transferData.targetId || !(from.target.data instanceof treecollection_1.TreeCollection) ||
            (from.target.data instanceof treecollection_1.TreeCollection && from.target.data.canCopy(from.id, id))) {
            // handle cursor or something, can drop
            this._cancelCanDrop(); // clear last
            this._lastId = id;
            this._lastCollectionId = collectionId;
            eventArgs.push(this._transferData.dropPosition);
            var canMove = from.target.events.fire(types_1.DragEvents.dragIn, eventArgs);
            if (canMove) {
                this._canDrop();
            }
        }
        else {
            this._cancelCanDrop();
        }
    };
    DragManager.prototype._move = function (from, to) {
        var fromData = from.target.data;
        var toData = to.target.data;
        var index = 0;
        var targetId = to.id;
        var behaviour = this._transferData.dragConfig.behaviour;
        switch (behaviour) {
            case types_2.DragBehaviour.child:
                break;
            case types_2.DragBehaviour.sibling:
                targetId = toData.getParent(targetId);
                index = toData.getIndex(to.id) + 1;
                break;
            case types_2.DragBehaviour.complex:
                var dropPosition = this._transferData.dropPosition;
                if (dropPosition === DropPosition.top) {
                    targetId = toData.getParent(targetId);
                    index = toData.getIndex(to.id);
                }
                else if (dropPosition === DropPosition.bot) {
                    targetId = toData.getParent(targetId);
                    index = toData.getIndex(to.id) + 1;
                }
                break;
        }
        if (this._transferData.dragConfig.copy) {
            fromData.copy(from.id, index, toData, targetId);
        }
        else {
            fromData.move(from.id, index, toData, targetId);
        }
    };
    DragManager.prototype._endDrop = function () {
        this._toggleTextSelection(false);
        if (this._transferData.target) {
            this._transferData.target.events.fire(types_1.DragEvents.dragEnd);
        }
        this._cancelCanDrop();
        this._canMove = true;
        this._transferData = {};
        this._lastId = null;
        this._lastCollectionId = null;
    };
    DragManager.prototype._cancelCanDrop = function () {
        this._canMove = false;
        var collection = CollectionStore_1.collectionStore.getItem(this._lastCollectionId);
        if (collection && this._lastId) {
            collection.events.fire(types_1.DragEvents.cancelDrop, [this._lastId]);
        }
    };
    DragManager.prototype._canDrop = function () {
        this._canMove = true;
        var collection = CollectionStore_1.collectionStore.getItem(this._lastCollectionId);
        if (collection && this._lastId) {
            collection.events.fire(types_1.DragEvents.canDrop, [this._lastId, this._transferData.dropPosition]);
        }
    };
    DragManager.prototype._toggleTextSelection = function (add) {
        if (add) {
            document.body.classList.add("dhx-no-select");
        }
        else {
            document.body.classList.remove("dhx-no-select");
        }
    };
    return DragManager;
}());
exports.dragManager = new DragManager();


/***/ }),
/* 37 */
/***/ (function(module, exports) {

if (Element && !Element.prototype.matches) {
    var proto = Element.prototype;
    proto.matches = proto.matchesSelector ||
        proto.mozMatchesSelector || proto.msMatchesSelector ||
        proto.oMatchesSelector || proto.webkitMatchesSelector;
}


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var CollectionStore = /** @class */ (function () {
    function CollectionStore() {
        this._store = {};
    }
    CollectionStore.prototype.setItem = function (id, target, config) {
        this._store[id] = {
            target: target,
            config: config
        };
    };
    CollectionStore.prototype.getItem = function (id) {
        if (!this._store[id]) {
            return null;
        }
        return this._store[id].target;
    };
    CollectionStore.prototype.getItemConfig = function (id) {
        if (!this._store[id]) {
            return null;
        }
        return this._store[id].config;
    };
    return CollectionStore;
}());
exports.collectionStore = new CollectionStore();


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var events_1 = __webpack_require__(9);
var types_1 = __webpack_require__(5);
var types_2 = __webpack_require__(6);
var Selection = /** @class */ (function () {
    function Selection(_config, data, events) {
        var _this = this;
        this.events = events || (new events_1.EventSystem());
        this._data = data;
        this._data.events.on(types_2.DataEvents.removeAll, function () {
            _this._selected = null;
        });
        this._data.events.on(types_2.DataEvents.change, function () {
            if (_this._selected) {
                var near = _this._data.getNearId(_this._selected);
                if (near !== _this._selected) {
                    _this._selected = null;
                    if (near) {
                        _this.add(near);
                    }
                }
            }
        });
    }
    Selection.prototype.getId = function () {
        return this._selected;
    };
    Selection.prototype.getItem = function () {
        if (this._selected) {
            return this._data.getItem(this._selected);
        }
        return null;
    };
    Selection.prototype.remove = function (id) {
        id = id || this._selected;
        if (!id) {
            return true;
        }
        if (this.events.fire(types_1.SelectionEvents.beforeUnSelect, [id])) {
            this._data.update(id, { $selected: false });
            this._selected = null;
            this.events.fire(types_1.SelectionEvents.afterUnSelect, [id]);
            return true;
        }
        return false;
    };
    Selection.prototype.add = function (id) {
        if (this._selected === id) {
            return;
        }
        this.remove();
        if (this.events.fire(types_1.SelectionEvents.beforeSelect, [id])) {
            this._selected = id;
            this._data.update(id, { $selected: true });
            this.events.fire(types_1.SelectionEvents.afterSelect, [id]);
        }
    };
    return Selection;
}());
exports.Selection = Selection;


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
Object.defineProperty(exports, "__esModule", { value: true });
var en_1 = __webpack_require__(41);
function blockKeys(e) {
    var active = document.activeElement;
    if (!active.classList.contains("apply-button") && !active.classList.contains("reject-button")) {
        e.preventDefault();
    }
}
function blockScreen(css) {
    var blocker = document.createElement("div");
    blocker.className = "dhx-blocker " + (css || "");
    document.body.appendChild(blocker);
    document.addEventListener("keydown", blockKeys);
    return function () {
        document.body.removeChild(blocker);
        document.removeEventListener("keydown", blockKeys);
    };
}
exports.blockScreen = blockScreen;
function alert(props) {
    var apply = props.buttons && props.buttons[0] ? props.buttons[0] : en_1.default.apply;
    var unblock = blockScreen(props.blockerCss);
    return new Promise(function (res) {
        var alertBox = document.createElement("div");
        alertBox.className = "dhx-alert " + (props.css || "");
        alertBox.innerHTML = "\n\t\t\t<div class=\"message-box-header\">\n\t\t\t\t<div class=\"mesage-box-title\">" + props.header + "</div>\n\t\t\t</div>\n\t\t\t<div class=\"alert-message\">" + props.text + "</div>\n\t\t\t<div class=\"action-button " + (props.buttonsAlignment ? props.buttonsAlignment : "") + "\">\n\t\t\t\t<button class=\"apply-button alert-btn dhx_btn dhx_btn--flat\">" + apply + "</button>\n\t\t\t</div>";
        document.body.appendChild(alertBox);
        alertBox.querySelector(".apply-button").focus();
        alertBox.querySelector("button").addEventListener("click", function () {
            unblock();
            document.body.removeChild(alertBox);
            res(true);
        });
    });
}
exports.alert = alert;
function confirm(props) {
    var apply = props.buttons && props.buttons[1] ? props.buttons[1] : en_1.default.apply;
    var reject = props.buttons && props.buttons[0] ? props.buttons[0] : en_1.default.reject;
    var unblock = blockScreen(props.blockerCss);
    return new Promise(function (res) {
        var answer = function (val) {
            unblock();
            confirmBox.removeEventListener("click", clickHandler);
            document.body.removeChild(confirmBox);
            res(val);
        };
        var confirmBox = document.createElement("div");
        confirmBox.className = "dhx-confirm " + (props.css || "");
        confirmBox.innerHTML = "\n\t\t\t<div class=\"message-box-header\">\n\t\t\t\t<div class=\"mesage-box-title\">" + props.header + "</div>\n\t\t\t</div>\n\t\t\t<div class=\"confirm-message\">" + props.text + "</div>\n\t\t\t<div class=\"action-button " + (props.buttonsAlignment ? props.buttonsAlignment : "") + "\">\n\t\t\t\t<button class=\"reject-button dhx_btn dhx_btn--link\">" + reject + "</button>\n\t\t\t\t<button class=\"apply-button dhx_btn dhx_btn--flat\">" + apply + "</button>\n\t\t\t</div>";
        document.body.appendChild(confirmBox);
        confirmBox.querySelector(".reject-button").focus();
        var clickHandler = function (e) {
            if (e.target.tagName === "BUTTON") {
                answer(e.target.classList.contains("apply-button"));
            }
        };
        confirmBox.addEventListener("click", clickHandler);
    });
}
exports.confirm = confirm;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var locale = {
    apply: "apply",
    reject: "reject"
};
exports.default = locale;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var dom_1 = __webpack_require__(0);
var events_1 = __webpack_require__(9);
var html_1 = __webpack_require__(1);
var scrollView_1 = __webpack_require__(44);
var view_1 = __webpack_require__(12);
var ts_data_1 = __webpack_require__(8);
var ts_layout_1 = __webpack_require__(45);
var ts_message_1 = __webpack_require__(16);
var ts_toolbar_1 = __webpack_require__(48);
var en_1 = __webpack_require__(14);
var types_1 = __webpack_require__(15);
var Uploader_1 = __webpack_require__(64);
var configs_1 = __webpack_require__(65);
var helper_1 = __webpack_require__(66);
var ProgressBar_1 = __webpack_require__(67);
var ReadStackPreview_1 = __webpack_require__(68);
var Vault = /** @class */ (function (_super) {
    __extends(Vault, _super);
    function Vault(container, config) {
        if (config === void 0) { config = {}; }
        var _this = _super.call(this, null, core_1.extend({
            mode: types_1.VaultMode.list,
            toolbar: true,
            updateFromResponse: true,
            scaleFactor: 4,
            customScroll: true,
            uploader: {},
            progressBar: {}
        }, config)) || this;
        if (!_this.config.toolbar) {
            _this.config.uploader.autosend = true;
        }
        if (config.data) {
            _this.data = config.data;
            _this.events = config.data.events;
            _this.events.context = _this;
        }
        else {
            _this.events = new events_1.EventSystem(_this);
            _this.data = new ts_data_1.DataCollection({}, _this.events);
        }
        _this.data.config.init = function (obj) {
            obj.status = obj.status || types_1.FileStatus.uploaded;
            if (obj.file) {
                obj.size = obj.file.size;
                obj.name = obj.file.name;
            }
            else {
                obj.size = obj.size || 0;
                obj.name = obj.name || "";
            }
            if (_this.config.mode === types_1.VaultMode.grid && obj.file && helper_1.isImage(obj)) {
                _this._readStack.add(obj, _this.uploader.config.autosend);
            }
            return obj;
        };
        _this._readStack = new ReadStackPreview_1.ReadStackPreview(_this.data);
        _this.uploader = new Uploader_1.Uploader(_this.config.uploader, _this.data, _this.events);
        _this._scrollView = new scrollView_1.ScrollView(function () { return _this.getRootView(); });
        _this._progressBar = new ProgressBar_1.ProgressBar(_this.events, _this.config.progressBar);
        _this.events.on(types_1.UploaderEvents.uploadProgress, function (progress, current, total) { return _this._progressBar.setState(progress, { current: current, total: total }); });
        _this._initHandlers();
        _this._initUI(container);
        _this._initEvents();
        return _this;
    }
    Vault.prototype.destructor = function () {
        this.toolbar.destructor();
        this._readStack.stop();
        this.uploader.unlinkDropArea();
        this.uploader.abort();
    };
    Vault.prototype._initUI = function (container) {
        var _this = this;
        var cfg = this.config.toolbar ? configs_1.layoutConfig : configs_1.layoutConfigWithoutTopbar;
        cfg.on = this._getDragEvents();
        var layout = this._layout = new ts_layout_1.Layout(container, cfg);
        var toolbar = this.toolbar = new ts_toolbar_1.Toolbar(null, { css: "vault-toolbar" });
        var defaultButtons = [
            {
                id: "add",
                tooltip: en_1.default.add,
                type: ts_toolbar_1.ItemType.iconButton,
                icon: "dxi-plus"
            },
            {
                id: "upload",
                tooltip: en_1.default.upload,
                type: ts_toolbar_1.ItemType.iconButton,
                icon: "dxi icon-upload" // Custom Web Font Icon
            },
            {
                type: "spacer"
            },
            {
                id: "remove-all",
                tooltip: en_1.default.clearAll,
                type: ts_toolbar_1.ItemType.iconButton,
                icon: "dxi-delete-forever"
            }
        ];
        this.toolbar.data.parse(defaultButtons);
        this._hideUploadAndDeleteButtons();
        var render = function () { return _this._draw(); };
        this.mount(null, dom_1.create({ render: render }));
        if (this.config.toolbar) {
            layout.cell("topbar").attach(toolbar);
        }
        layout.cell("vault").attach(this);
    };
    Vault.prototype._initHandlers = function () {
        var _this = this;
        this._handlers = {
            onclick: {
                ".action-add": function () { return _this.uploader.selectFile(); },
                ".action-remove-file": function (e) {
                    var id = html_1.locate(e);
                    if (!id) {
                        return;
                    }
                    _this.data.update(id, { $toRemove: true });
                    setTimeout(function () {
                        _this.data.update(id, { $toRemove: false }, true);
                        _this.data.remove(id);
                    }, 200);
                }
            },
            onmouseover: {
                ".action-download": function (e) {
                    ts_message_1.tooltip(en_1.default.download, {
                        node: e.target,
                        position: ts_message_1.Position.bottom
                    });
                },
                ".action-remove-file": function (e) {
                    ts_message_1.tooltip(en_1.default.clear, {
                        node: e.target,
                        position: ts_message_1.Position.bottom
                    });
                },
                ".title-content, .dhx-file-name": function (e) {
                    var id = html_1.locate(e);
                    var item = _this.data.getItem(id);
                    ts_message_1.tooltip(item.name, {
                        node: e.target,
                        position: ts_message_1.Position.bottom,
                        css: "tooltip-light"
                    });
                }
            }
        };
    };
    Vault.prototype._getDragEvents = function () {
        var _this = this;
        var rect = {
            left: null,
            top: null,
            width: null,
            height: null
        };
        return {
            dragleave: function (e) {
                if (!_this._canDrop) {
                    return;
                }
                if (e.pageX > rect.left + rect.width - 1 || e.pageX < rect.left || e.pageY > rect.top + rect.height - 1 || e.pageY < rect.top) {
                    _this._canDrop = false;
                    if (_this.config.toolbar) {
                        _this._layout.cell("topbar").show();
                    }
                    _this._layout.config.css = "vault-layout";
                    _this._layout.paint();
                }
            },
            dragenter: function (e) {
                e.preventDefault();
                if (_this.uploader.isActive || _this._canDrop) {
                    return;
                }
                var types = e.dataTransfer.types;
                for (var _i = 0, types_2 = types; _i < types_2.length; _i++) {
                    var type = types_2[_i];
                    if (type !== "Files" && type !== "application/x-moz-file") {
                        _this._canDrop = false;
                        return;
                    }
                }
                _this._canDrop = true;
                var clientRect = _this._layout.getRootView().node.el.getBoundingClientRect();
                rect.left = clientRect.left + window.pageXOffset;
                rect.top = clientRect.top + window.pageYOffset;
                rect.width = clientRect.width;
                rect.height = clientRect.height;
                _this._canDrop = true;
                if (_this.config.toolbar) {
                    _this._layout.cell("topbar").hide();
                }
                _this._layout.config.css = "vault-layout dhx-dragin";
                _this._layout.paint();
            },
            dragover: function (e) {
                e.preventDefault();
            },
            drop: function (e) {
                e.preventDefault();
                if (!_this._canDrop) {
                    return;
                }
                var dataTransfer = e.dataTransfer;
                _this.uploader.parseFiles(dataTransfer);
                _this._canDrop = false;
                if (_this.config.toolbar) {
                    _this._layout.cell("topbar").show();
                }
                _this._layout.config.css = "vault-layout";
                _this._layout.paint();
            }
        };
    };
    Vault.prototype._hideUploadAndDeleteButtons = function () {
        this.toolbar.hide(["upload", "remove-all"]);
    };
    Vault.prototype._showUploadAndDeleteButtons = function () {
        if (this.uploader.config.autosend) {
            this.toolbar.show("remove-all");
        }
        else {
            //this.toolbar.show(["upload", "remove-all"]);
            this.toolbar.show(["remove-all"]);
        }
    };
    Vault.prototype._initEvents = function () {
        var _this = this;
        this.data.events.on(types_1.DataEvents.change, function () {
            if (!_this.data.getLength()) {
                _this._hideUploadAndDeleteButtons();
            }
            else {
                _this._showUploadAndDeleteButtons();
            }
            _this.paint();
        });
        this.events.on(types_1.UploaderEvents.uploadBegin, function () {
            if (_this.config.toolbar) {
                _this._layout.cell("topbar").attach(_this._progressBar);
            }
        });
        this.events.on(types_1.UploaderEvents.uploadComplete, function () {
            if (_this.config.mode === types_1.VaultMode.grid && _this.uploader.config.autosend) {
                _this._readStack.read();
            }
            if (_this.config.toolbar) {
                _this._layout.cell("topbar").attach(_this.toolbar);
            }
        });
        this.toolbar.events.on(ts_toolbar_1.ToolbarEvents.click, function (id) {
            switch (id) {
                case "add":
                    _this.uploader.selectFile();
                    break;
                case "remove-all":
                    _this.data.removeAll();
                    break;
                case "upload":
                    _this.uploader.send();
                    break;
            }
        });
        this.events.on(types_1.ProgressBarEvents.cancel, function () {
            _this.uploader.abort();
            _this.paint();
        });
    };
    Vault.prototype._draw = function () {
        var isEmpty = !this.data.getLength();
        var files = this.config.mode === types_1.VaultMode.grid ? this._drawGrid() : this._drawList();
        return dom_1.el("div", __assign({ class: "vault dhx_widget" + (this._canDrop ? " drop-here" : "") }, this._handlers, { dhx_widget_id: this._uid }), [
            this._canDrop || isEmpty ? this._drawDropableArea() :
                this.config.customScroll ? this._scrollView.render(files) : files
        ]);
    };
    Vault.prototype._getFileActions = function (file) {
        var defaultActions = [];
        var hoverActions = [];
        var actions = [
            dom_1.el(".dhx-default-actions", defaultActions),
            dom_1.el(".dhx-hover-actions", hoverActions)
        ];
        if (file.status === types_1.FileStatus.inprogress) {
            return actions;
        }
        if (file.status !== types_1.FileStatus.failed && file.link) {
            var link = (this.config.downloadURL || "") + file.link;
            var downloadName = link.split("/").pop().split("?")[0];
            var download = dom_1.el("a", {
                download: downloadName,
                class: "download-link",
                href: link
            }, [
                dom_1.el(".icon-btn.dxi.dxi-download.action-download")
            ]);
            hoverActions.push(download);
        }
        var remove = dom_1.el(".icon-btn.dxi.dxi-delete-forever.action-remove-file");
        hoverActions.push(remove);
        if (file.status === types_1.FileStatus.failed) {
            var warn = dom_1.el(".dxi.dxi-alert-circle.warning-status");
            defaultActions.push(warn);
        }
        if (file.status === types_1.FileStatus.uploaded) {
            var uploadComplete = dom_1.el(".dxi.dxi-checkbox-marked-circle.uploaded-status");
            defaultActions.push(uploadComplete);
        }
        return actions;
    };
    Vault.prototype._drawList = function () {
        var _this = this;
        return dom_1.el(".dhx-files-block.dhx-webkit-scroll", this.data.map(function (item) {
            var isError = item.status === types_1.FileStatus.failed && item.request;
            var inProgress = item.status === types_1.FileStatus.inprogress;
            var inQueue = item.status === types_1.FileStatus.queue;
            var notUploaded = item.status !== types_1.FileStatus.uploaded;
            return dom_1.el("div", {
                class: "dhx-file-item" + (item.$toRemove ? " to-remove" : "") + (inQueue ? " in-queue" : ""),
                dhx_id: item.id,
                _key: item.id
            }, [
                dom_1.el(".dhx-file-icon", [
                    dom_1.el("div", {
                        class: "dhx-file-type " + helper_1.getFileClassName(item) + (notUploaded ? " not-loaded" : "")
                    })
                ]),
                dom_1.el(".dhx-file-title", [
                    dom_1.el(".dhx-title-content", item.name),
                    dom_1.el(".dhx-file-info", [
                        isError && dom_1.el(".warn-message", item.request.statusText || en_1.default.error),
                        inProgress ? dom_1.el(".progress-value", (item.progress * 100).toFixed(1) + "%")
                            : dom_1.el(".dhx-size" + (isError && ".dhx-size-error" || ""), helper_1.getBasis(item.size))
                    ])
                ]),
                inProgress && dom_1.el(".dhx-download-progress", {
                    style: {
                        width: (item.progress * 100).toFixed(1) + "%"
                    }
                }),
                !inProgress && dom_1.el(".dhx-file-action", _this._getFileActions(item))
            ]);
        }));
    };
    Vault.prototype._drawDropableArea = function () {
        return dom_1.el(".dhx-dropable-area.drop-files-here", [
            dom_1.el(".dhx-big-icon-block", [
                dom_1.el(".dxi.icon-upload") // Custom Web Font Icon
            ]),
            !this._canDrop && dom_1.el(".drop-area-bold-text", en_1.default.dragAndDrop),
            !this._canDrop && dom_1.el(".drop-area-bold-text", en_1.default.filesOrFoldersHere),
            !this._canDrop && dom_1.el(".drop-area-light-text", en_1.default.or),
            !this._canDrop && dom_1.el("button.dhx_btn.dhx_btn--flat.dhx_btn--small.action-add", en_1.default.browse)
        ]);
    };
    Vault.prototype._drawGrid = function () {
        var _this = this;
        return dom_1.el("div", {
            class: "dhx-files-grid dhx-webkit-scroll"
        }, [
            dom_1.el(".dhx-grid-content", this.data.map(function (item) {
                var inProgress = item.status === types_1.FileStatus.inprogress;
                var inQueue = item.status === types_1.FileStatus.queue;
                var isError = item.status === types_1.FileStatus.failed;
                return dom_1.el("div", {
                    class: "dhx-file-grid-item" + (inProgress ? " in-progress" : "")
                        + (item.$toRemove ? " to-remove" : "") + (inQueue ? " in-queue" : "") + (isError ? " failed" : ""),
                    dhx_id: item.id,
                    _key: item.id
                }, [
                    dom_1.el(".dhx-preview-wrapper", [
                        item.preview ? dom_1.el(".dhx-server-file-preview", [
                            dom_1.el("img", { src: item.preview })
                        ]) :
                            item.image ? dom_1.el("canvas", {
                                width: 98 * _this.config.scaleFactor,
                                height: 98 * _this.config.scaleFactor,
                                _hooks: {
                                    didInsert: function (node) {
                                        var _a = helper_1.calculateCover(item.image), dx = _a.dx, dy = _a.dy, sx = _a.sx, sy = _a.sy, sHeight = _a.sHeight, sWidth = _a.sWidth;
                                        var ctx = node.el.getContext("2d");
                                        ctx.drawImage(item.image, sx, sy, sWidth, sHeight, dx, dy, 98 * _this.config.scaleFactor, 98 * _this.config.scaleFactor);
                                    }
                                }
                            }) : dom_1.el("div", {
                                class: "dhx-file-preview dhx-file-type " + helper_1.getFileClassName(item)
                            }),
                        inProgress && _this._drawCircle(item.progress)
                    ].concat(_this._getFileActions(item), [
                        dom_1.el(".dhx-file-info", [
                            isError && dom_1.el(".warn-message", item.request.statusText || en_1.default.error),
                            !inProgress && dom_1.el(".dhx-size" + (isError && ".dhx-size-error" || ""), helper_1.getBasis(item.size))
                        ])
                    ])),
                    dom_1.el(".dhx-file-name", helper_1.truncateWord(item.name))
                ]);
            }))
        ]);
    };
    Vault.prototype._drawCircle = function (progress) {
        return dom_1.el(".progress-layout", [
            dom_1.el(".progress-amount", (progress * 100).toFixed(1) + "%"),
            dom_1.sv("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                class: "progress-circle",
                viewBox: "0 0 60 60",
            }, [
                dom_1.sv("circle", {
                    "cx": 30,
                    "cy": 30,
                    "r": 28,
                    "stroke-width": 4,
                    "class": "progress-bar-background",
                }),
                dom_1.sv("circle.active-circle", {
                    "cx": 30,
                    "cy": 30,
                    "r": 28,
                    "stroke-width": 4,
                    "stroke-dasharray": "175.9 175.9",
                    "stroke-dashoffset": (1 - progress) * 175.9,
                    "class": "progress-bar-active",
                }),
            ])
        ]);
    };
    return Vault;
}(view_1.View));
exports.Vault = Vault;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

/**
* Copyright (c) 2017, Leon Sorokin
* All rights reserved. (MIT Licensed)
*
* domvm.js (DOM ViewModel)
* A thin, fast, dependency-free vdom view layer
* @preserve https://github.com/leeoniya/domvm (v3.2.6, micro build)
*/

(function (global, factory) {
	 true ? module.exports = factory() :
	undefined;
}(this, (function () { 'use strict';

// NOTE: if adding a new *VNode* type, make it < COMMENT and renumber rest.
// There are some places that test <= COMMENT to assert if node is a VNode

// VNode types
var ELEMENT	= 1;
var TEXT		= 2;
var COMMENT	= 3;

// placeholder types
var VVIEW		= 4;
var VMODEL		= 5;

var ENV_DOM = typeof window !== "undefined";
var win = ENV_DOM ? window : {};
var rAF = win.requestAnimationFrame;

var emptyObj = {};

function noop() {}

var isArr = Array.isArray;

function isSet(val) {
	return val != null;
}

function isPlainObj(val) {
	return val != null && val.constructor === Object;		//  && typeof val === "object"
}

function insertArr(targ, arr, pos, rem) {
	targ.splice.apply(targ, [pos, rem].concat(arr));
}

function isVal(val) {
	var t = typeof val;
	return t === "string" || t === "number";
}

function isFunc(val) {
	return typeof val === "function";
}

function isProm(val) {
	return typeof val === "object" && isFunc(val.then);
}



function assignObj(targ) {
	var args = arguments;

	for (var i = 1; i < args.length; i++)
		{ for (var k in args[i])
			{ targ[k] = args[i][k]; } }

	return targ;
}

// export const defProp = Object.defineProperty;

function deepSet(targ, path, val) {
	var seg;

	while (seg = path.shift()) {
		if (path.length === 0)
			{ targ[seg] = val; }
		else
			{ targ[seg] = targ = targ[seg] || {}; }
	}
}

/*
export function deepUnset(targ, path) {
	var seg;

	while (seg = path.shift()) {
		if (path.length === 0)
			targ[seg] = val;
		else
			targ[seg] = targ = targ[seg] || {};
	}
}
*/

function sliceArgs(args, offs) {
	var arr = [];
	for (var i = offs; i < args.length; i++)
		{ arr.push(args[i]); }
	return arr;
}

function cmpObj(a, b) {
	for (var i in a)
		{ if (a[i] !== b[i])
			{ return false; } }

	return true;
}

function cmpArr(a, b) {
	var alen = a.length;

	if (b.length !== alen)
		{ return false; }

	for (var i = 0; i < alen; i++)
		{ if (a[i] !== b[i])
			{ return false; } }

	return true;
}

// https://github.com/darsain/raft
// rAF throttler, aggregates multiple repeated redraw calls within single animframe
function raft(fn) {
	if (!rAF)
		{ return fn; }

	var id, ctx, args;

	function call() {
		id = 0;
		fn.apply(ctx, args);
	}

	return function() {
		ctx = this;
		args = arguments;
		if (!id) { id = rAF(call); }
	};
}

function curry(fn, args, ctx) {
	return function() {
		return fn.apply(ctx, args);
	};
}

/*
export function prop(val, cb, ctx, args) {
	return function(newVal, execCb) {
		if (newVal !== undefined && newVal !== val) {
			val = newVal;
			execCb !== false && isFunc(cb) && cb.apply(ctx, args);
		}

		return val;
	};
}
*/

/*
// adapted from https://github.com/Olical/binary-search
export function binaryKeySearch(list, item) {
    var min = 0;
    var max = list.length - 1;
    var guess;

	var bitwise = (max <= 2147483647) ? true : false;
	if (bitwise) {
		while (min <= max) {
			guess = (min + max) >> 1;
			if (list[guess].key === item) { return guess; }
			else {
				if (list[guess].key < item) { min = guess + 1; }
				else { max = guess - 1; }
			}
		}
	} else {
		while (min <= max) {
			guess = Math.floor((min + max) / 2);
			if (list[guess].key === item) { return guess; }
			else {
				if (list[guess].key < item) { min = guess + 1; }
				else { max = guess - 1; }
			}
		}
	}

    return -1;
}
*/

// https://en.wikipedia.org/wiki/Longest_increasing_subsequence
// impl borrowed from https://github.com/ivijs/ivi
function longestIncreasingSubsequence(a) {
	var p = a.slice();
	var result = [];
	result.push(0);
	var u;
	var v;

	for (var i = 0, il = a.length; i < il; ++i) {
		var j = result[result.length - 1];
		if (a[j] < a[i]) {
			p[i] = j;
			result.push(i);
			continue;
		}

		u = 0;
		v = result.length - 1;

		while (u < v) {
			var c = ((u + v) / 2) | 0;
			if (a[result[c]] < a[i]) {
				u = c + 1;
			} else {
				v = c;
			}
		}

		if (a[i] < a[result[u]]) {
			if (u > 0) {
				p[i] = result[u - 1];
			}
			result[u] = i;
		}
	}

	u = result.length;
	v = result[u - 1];

	while (u-- > 0) {
		result[u] = v;
		v = p[v];
	}

	return result;
}

// based on https://github.com/Olical/binary-search
function binaryFindLarger(item, list) {
	var min = 0;
	var max = list.length - 1;
	var guess;

	var bitwise = (max <= 2147483647) ? true : false;
	if (bitwise) {
		while (min <= max) {
			guess = (min + max) >> 1;
			if (list[guess] === item) { return guess; }
			else {
				if (list[guess] < item) { min = guess + 1; }
				else { max = guess - 1; }
			}
		}
	} else {
		while (min <= max) {
			guess = Math.floor((min + max) / 2);
			if (list[guess] === item) { return guess; }
			else {
				if (list[guess] < item) { min = guess + 1; }
				else { max = guess - 1; }
			}
		}
	}

	return (min == list.length) ? null : min;

//	return -1;
}

function isEvProp(name) {
	return name[0] === "o" && name[1] === "n";
}

function isSplProp(name) {
	return name[0] === "_";
}

function isStyleProp(name) {
	return name === "style";
}

function repaint(node) {
	node && node.el && node.el.offsetHeight;
}

function isHydrated(vm) {
	return vm.node != null && vm.node.el != null;
}

// tests interactive props where real val should be compared
function isDynProp(tag, attr) {
//	switch (tag) {
//		case "input":
//		case "textarea":
//		case "select":
//		case "option":
			switch (attr) {
				case "value":
				case "checked":
				case "selected":
//				case "selectedIndex":
					return true;
			}
//	}

	return false;
}

function getVm(n) {
	n = n || emptyObj;
	while (n.vm == null && n.parent)
		{ n = n.parent; }
	return n.vm;
}

function VNode() {}

var VNodeProto = VNode.prototype = {
	constructor: VNode,

	type:	null,

	vm:		null,

	// all this stuff can just live in attrs (as defined) just have getters here for it
	key:	null,
	ref:	null,
	data:	null,
	hooks:	null,
	ns:		null,

	el:		null,

	tag:	null,
	attrs:	null,
	body:	null,

	flags:	0,

	_class:	null,
	_diff:	null,

	// pending removal on promise resolution
	_dead:	false,
	// part of longest increasing subsequence?
	_lis:	false,

	idx:	null,
	parent:	null,

	/*
	// break out into optional fluent module
	key:	function(val) { this.key	= val; return this; },
	ref:	function(val) { this.ref	= val; return this; },		// deep refs
	data:	function(val) { this.data	= val; return this; },
	hooks:	function(val) { this.hooks	= val; return this; },		// h("div").hooks()
	html:	function(val) { this.html	= true; return this.body(val); },

	body:	function(val) { this.body	= val; return this; },
	*/
};

function defineText(body) {
	var node = new VNode;
	node.type = TEXT;
	node.body = body;
	return node;
}

// creates a one-shot self-ending stream that redraws target vm
// TODO: if it's already registered by any parent vm, then ignore to avoid simultaneous parent & child refresh

var tagCache = {};

var RE_ATTRS = /\[(\w+)(?:=(\w+))?\]/g;

function cssTag(raw) {
	{
		var cached = tagCache[raw];

		if (cached == null) {
			var tag, id, cls, attr;

			tagCache[raw] = cached = {
				tag:	(tag	= raw.match( /^[-\w]+/))		?	tag[0]						: "div",
				id:		(id		= raw.match( /#([-\w]+)/))		? 	id[1]						: null,
				class:	(cls	= raw.match(/\.([-\w.]+)/))		?	cls[1].replace(/\./g, " ")	: null,
				attrs:	null,
			};

			while (attr = RE_ATTRS.exec(raw)) {
				if (cached.attrs == null)
					{ cached.attrs = {}; }
				cached.attrs[attr[1]] = attr[2] || "";
			}
		}

		return cached;
	}
}

// (de)optimization flags

// forces slow bottom-up removeChild to fire deep willRemove/willUnmount hooks,
var DEEP_REMOVE = 1;
// prevents inserting/removing/reordering of children
var FIXED_BODY = 2;
// enables fast keyed lookup of children via binary search, expects homogeneous keyed body
var KEYED_LIST = 4;
// indicates an vnode match/diff/recycler function for body
var LAZY_LIST = 8;

function initElementNode(tag, attrs, body, flags) {
	var node = new VNode;

	node.type = ELEMENT;

	if (isSet(flags))
		{ node.flags = flags; }

	node.attrs = attrs;

	var parsed = cssTag(tag);

	node.tag = parsed.tag;

	// meh, weak assertion, will fail for id=0, etc.
	if (parsed.id || parsed.class || parsed.attrs) {
		var p = node.attrs || {};

		if (parsed.id && !isSet(p.id))
			{ p.id = parsed.id; }

		if (parsed.class) {
			node._class = parsed.class;		// static class
			p.class = parsed.class + (isSet(p.class) ? (" " + p.class) : "");
		}
		if (parsed.attrs) {
			for (var key in parsed.attrs)
				{ if (!isSet(p[key]))
					{ p[key] = parsed.attrs[key]; } }
		}

//		if (node.attrs !== p)
			node.attrs = p;
	}

	var mergedAttrs = node.attrs;

	if (isSet(mergedAttrs)) {
		if (isSet(mergedAttrs._key))
			{ node.key = mergedAttrs._key; }

		if (isSet(mergedAttrs._ref))
			{ node.ref = mergedAttrs._ref; }

		if (isSet(mergedAttrs._hooks))
			{ node.hooks = mergedAttrs._hooks; }

		if (isSet(mergedAttrs._data))
			{ node.data = mergedAttrs._data; }

		if (isSet(mergedAttrs._flags))
			{ node.flags = mergedAttrs._flags; }

		if (!isSet(node.key)) {
			if (isSet(node.ref))
				{ node.key = node.ref; }
			else if (isSet(mergedAttrs.id))
				{ node.key = mergedAttrs.id; }
			else if (isSet(mergedAttrs.name))
				{ node.key = mergedAttrs.name + (mergedAttrs.type === "radio" || mergedAttrs.type === "checkbox" ? mergedAttrs.value : ""); }
		}
	}

	if (body != null)
		{ node.body = body; }

	return node;
}

function setRef(vm, name, node) {
	var path = ["refs"].concat(name.split("."));
	deepSet(vm, path, node);
}

function setDeepRemove(node) {
	while (node = node.parent)
		{ node.flags |= DEEP_REMOVE; }
}

// vnew, vold
function preProc(vnew, parent, idx, ownVm) {
	if (vnew.type === VMODEL || vnew.type === VVIEW)
		{ return; }

	vnew.parent = parent;
	vnew.idx = idx;
	vnew.vm = ownVm;

	if (vnew.ref != null)
		{ setRef(getVm(vnew), vnew.ref, vnew); }

	var nh = vnew.hooks,
		vh = ownVm && ownVm.hooks;

	if (nh && (nh.willRemove || nh.didRemove) ||
		vh && (vh.willUnmount || vh.didUnmount))
		{ setDeepRemove(vnew); }

	if (isArr(vnew.body))
		{ preProcBody(vnew); }
	else {}
}

function preProcBody(vnew) {
	var body = vnew.body;

	for (var i = 0; i < body.length; i++) {
		var node2 = body[i];

		// remove false/null/undefined
		if (node2 === false || node2 == null)
			{ body.splice(i--, 1); }
		// flatten arrays
		else if (isArr(node2)) {
			insertArr(body, node2, i--, 1);
		}
		else {
			if (node2.type == null)
				{ body[i] = node2 = defineText(""+node2); }

			if (node2.type === TEXT) {
				// remove empty text nodes
				if (node2.body == null || node2.body === "")
					{ body.splice(i--, 1); }
				// merge with previous text node
				else if (i > 0 && body[i-1].type === TEXT) {
					body[i-1].body += node2.body;
					body.splice(i--, 1);
				}
				else
					{ preProc(node2, vnew, i, null); }
			}
			else
				{ preProc(node2, vnew, i, null); }
		}
	}
}

var unitlessProps = {
	animationIterationCount: true,
	boxFlex: true,
	boxFlexGroup: true,
	boxOrdinalGroup: true,
	columnCount: true,
	flex: true,
	flexGrow: true,
	flexPositive: true,
	flexShrink: true,
	flexNegative: true,
	flexOrder: true,
	gridRow: true,
	gridColumn: true,
	order: true,
	lineClamp: true,

	borderImageOutset: true,
	borderImageSlice: true,
	borderImageWidth: true,
	fontWeight: true,
	lineHeight: true,
	opacity: true,
	orphans: true,
	tabSize: true,
	widows: true,
	zIndex: true,
	zoom: true,

	fillOpacity: true,
	floodOpacity: true,
	stopOpacity: true,
	strokeDasharray: true,
	strokeDashoffset: true,
	strokeMiterlimit: true,
	strokeOpacity: true,
	strokeWidth: true
};

function autoPx(name, val) {
	{
		// typeof val === 'number' is faster but fails for numeric strings
		return !isNaN(val) && !unitlessProps[name] ? (val + "px") : val;
	}
}

// assumes if styles exist both are objects or both are strings
function patchStyle(n, o) {
	var ns =     (n.attrs || emptyObj).style;
	var os = o ? (o.attrs || emptyObj).style : null;

	// replace or remove in full
	if (ns == null || isVal(ns))
		{ n.el.style.cssText = ns; }
	else {
		for (var nn in ns) {
			var nv = ns[nn];

			if (os == null || nv != null && nv !== os[nn])
				{ n.el.style[nn] = autoPx(nn, nv); }
		}

		// clean old
		if (os) {
			for (var on in os) {
				if (ns[on] == null)
					{ n.el.style[on] = ""; }
			}
		}
	}
}

var didQueue = [];

function fireHook(hooks, name, o, n, immediate) {
	if (hooks != null) {
		var fn = o.hooks[name];

		if (fn) {
			if (name[0] === "d" && name[1] === "i" && name[2] === "d") {	// did*
				//	console.log(name + " should queue till repaint", o, n);
				immediate ? repaint(o.parent) && fn(o, n) : didQueue.push([fn, o, n]);
			}
			else {		// will*
				//	console.log(name + " may delay by promise", o, n);
				return fn(o, n);		// or pass  done() resolver
			}
		}
	}
}

function drainDidHooks(vm) {
	if (didQueue.length) {
		repaint(vm.node);

		var item;
		while (item = didQueue.shift())
			{ item[0](item[1], item[2]); }
	}
}

var doc = ENV_DOM ? document : null;

function closestVNode(el) {
	while (el._node == null)
		{ el = el.parentNode; }
	return el._node;
}

function createElement(tag, ns) {
	if (ns != null)
		{ return doc.createElementNS(ns, tag); }
	return doc.createElement(tag);
}

function createTextNode(body) {
	return doc.createTextNode(body);
}

function createComment(body) {
	return doc.createComment(body);
}

// ? removes if !recycled
function nextSib(sib) {
	return sib.nextSibling;
}

// ? removes if !recycled
function prevSib(sib) {
	return sib.previousSibling;
}

// TODO: this should collect all deep proms from all hooks and return Promise.all()
function deepNotifyRemove(node) {
	var vm = node.vm;

	var wuRes = vm != null && fireHook(vm.hooks, "willUnmount", vm, vm.data);

	var wrRes = fireHook(node.hooks, "willRemove", node);

	if ((node.flags & DEEP_REMOVE) === DEEP_REMOVE && isArr(node.body)) {
		for (var i = 0; i < node.body.length; i++)
			{ deepNotifyRemove(node.body[i]); }
	}

	return wuRes || wrRes;
}

function _removeChild(parEl, el, immediate) {
	var node = el._node, vm = node.vm;

	if (isArr(node.body)) {
		if ((node.flags & DEEP_REMOVE) === DEEP_REMOVE) {
			for (var i = 0; i < node.body.length; i++)
				{ _removeChild(el, node.body[i].el); }
		}
		else
			{ deepUnref(node); }
	}

	delete el._node;

	parEl.removeChild(el);

	fireHook(node.hooks, "didRemove", node, null, immediate);

	if (vm != null) {
		fireHook(vm.hooks, "didUnmount", vm, vm.data, immediate);
		vm.node = null;
	}
}

// todo: should delay parent unmount() by returning res prom?
function removeChild(parEl, el) {
	var node = el._node;

	// already marked for removal
	if (node._dead) { return; }

	var res = deepNotifyRemove(node);

	if (res != null && isProm(res)) {
		node._dead = true;
		res.then(curry(_removeChild, [parEl, el, true]));
	}
	else
		{ _removeChild(parEl, el); }
}

function deepUnref(node) {
	var obody = node.body;

	for (var i = 0; i < obody.length; i++) {
		var o2 = obody[i];
		delete o2.el._node;

		if (o2.vm != null)
			{ o2.vm.node = null; }

		if (isArr(o2.body))
			{ deepUnref(o2); }
	}
}

function clearChildren(parent) {
	var parEl = parent.el;

	if ((parent.flags & DEEP_REMOVE) === 0) {
		isArr(parent.body) && deepUnref(parent);
		parEl.textContent = null;
	}
	else {
		var el = parEl.firstChild;

		do {
			var next = nextSib(el);
			removeChild(parEl, el);
		} while (el = next);
	}
}

// todo: hooks
function insertBefore(parEl, el, refEl) {
	var node = el._node, inDom = el.parentNode != null;

	// el === refEl is asserted as a no-op insert called to fire hooks
	var vm = (el === refEl || !inDom) ? node.vm : null;

	if (vm != null)
		{ fireHook(vm.hooks, "willMount", vm, vm.data); }

	fireHook(node.hooks, inDom ? "willReinsert" : "willInsert", node);
	parEl.insertBefore(el, refEl);
	fireHook(node.hooks, inDom ? "didReinsert" : "didInsert", node);

	if (vm != null)
		{ fireHook(vm.hooks, "didMount", vm, vm.data); }
}

function insertAfter(parEl, el, refEl) {
	insertBefore(parEl, el, refEl ? nextSib(refEl) : null);
}

var onemit = {};

function emitCfg(cfg) {
	assignObj(onemit, cfg);
}

function emit(evName) {
	var targ = this,
		src = targ;

	var args = sliceArgs(arguments, 1).concat(src, src.data);

	do {
		var evs = targ.onemit;
		var fn = evs ? evs[evName] : null;

		if (fn) {
			fn.apply(targ, args);
			break;
		}
	} while (targ = targ.parent());

	if (onemit[evName])
		{ onemit[evName].apply(targ, args); }
}

var onevent = noop;

function config(newCfg) {
	onevent = newCfg.onevent || onevent;

	{
		if (newCfg.onemit)
			{ emitCfg(newCfg.onemit); }
	}


}

function bindEv(el, type, fn) {
	el[type] = fn;
}

function exec(fn, args, e, node, vm) {
	var out = fn.apply(vm, args.concat([e, node, vm, vm.data]));

	// should these respect out === false?
	vm.onevent(e, node, vm, vm.data, args);
	onevent.call(null, e, node, vm, vm.data, args);

	if (out === false) {
		e.preventDefault();
		e.stopPropagation();
	}
}

function handle(e) {
	var node = closestVNode(e.target);
	var vm = getVm(node);

	var evDef = e.currentTarget._node.attrs["on" + e.type], fn, args;

	if (isArr(evDef)) {
		fn = evDef[0];
		args = evDef.slice(1);
		exec(fn, args, e, node, vm);
	}
	else {
		for (var sel in evDef) {
			if (e.target.matches(sel)) {
				var evDef2 = evDef[sel];

				if (isArr(evDef2)) {
					fn = evDef2[0];
					args = evDef2.slice(1);
				}
				else {
					fn = evDef2;
					args = [];
				}

				exec(fn, args, e, node, vm);
			}
		}
	}
}

function patchEvent(node, name, nval, oval) {
	if (nval === oval)
		{ return; }

	var el = node.el;

	if (nval == null || isFunc(nval))
		{ bindEv(el, name, nval); }
	else if (oval == null)
		{ bindEv(el, name, handle); }
}

function remAttr(node, name, asProp) {
	if (name[0] === ".") {
		name = name.substr(1);
		asProp = true;
	}

	if (asProp)
		{ node.el[name] = ""; }
	else
		{ node.el.removeAttribute(name); }
}

// setAttr
// diff, ".", "on*", bool vals, skip _*, value/checked/selected selectedIndex
function setAttr(node, name, val, asProp, initial) {
	var el = node.el;

	if (val == null)
		{ !initial && remAttr(node, name, false); }		// will also removeAttr of style: null
	else if (node.ns != null)
		{ el.setAttribute(name, val); }
	else if (name === "class")
		{ el.className = val; }
	else if (name === "id" || typeof val === "boolean" || asProp)
		{ el[name] = val; }
	else if (name[0] === ".")
		{ el[name.substr(1)] = val; }
	else
		{ el.setAttribute(name, val); }
}

function patchAttrs(vnode, donor, initial) {
	var nattrs = vnode.attrs || emptyObj;
	var oattrs = donor.attrs || emptyObj;

	if (nattrs === oattrs) {

	}
	else {
		for (var key in nattrs) {
			var nval = nattrs[key];
			var isDyn = isDynProp(vnode.tag, key);
			var oval = isDyn ? vnode.el[key] : oattrs[key];

			if (nval === oval) {}
			else if (isStyleProp(key))
				{ patchStyle(vnode, donor); }
			else if (isSplProp(key)) {}
			else if (isEvProp(key))
				{ patchEvent(vnode, key, nval, oval); }
			else
				{ setAttr(vnode, key, nval, isDyn, initial); }
		}

		// TODO: bench style.cssText = "" vs removeAttribute("style")
		for (var key in oattrs) {
			!(key in nattrs) &&
			!isSplProp(key) &&
			remAttr(vnode, key, isDynProp(vnode.tag, key) || isEvProp(key));
		}
	}
}

function createView(view, data, key, opts) {
	if (view.type === VVIEW) {
		data	= view.data;
		key		= view.key;
		opts	= view.opts;
		view	= view.view;
	}

	return new ViewModel(view, data, key, opts);
}

//import { XML_NS, XLINK_NS } from './defineSvgElement';
function hydrateBody(vnode) {
	for (var i = 0; i < vnode.body.length; i++) {
		var vnode2 = vnode.body[i];
		var type2 = vnode2.type;

		// ELEMENT,TEXT,COMMENT
		if (type2 <= COMMENT)
			{ insertBefore(vnode.el, hydrate(vnode2)); }		// vnode.el.appendChild(hydrate(vnode2))
		else if (type2 === VVIEW) {
			var vm = createView(vnode2.view, vnode2.data, vnode2.key, vnode2.opts)._redraw(vnode, i, false);		// todo: handle new data updates
			type2 = vm.node.type;
			insertBefore(vnode.el, hydrate(vm.node));
		}
		else if (type2 === VMODEL) {
			var vm = vnode2.vm;
			vm._redraw(vnode, i);					// , false
			type2 = vm.node.type;
			insertBefore(vnode.el, vm.node.el);		// , hydrate(vm.node)
		}
	}
}

//  TODO: DRY this out. reusing normal patch here negatively affects V8's JIT
function hydrate(vnode, withEl) {
	if (vnode.el == null) {
		if (vnode.type === ELEMENT) {
			vnode.el = withEl || createElement(vnode.tag, vnode.ns);

		//	if (vnode.tag === "svg")
		//		vnode.el.setAttributeNS(XML_NS, 'xmlns:xlink', XLINK_NS);

			if (vnode.attrs != null)
				{ patchAttrs(vnode, emptyObj, true); }

			if ((vnode.flags & LAZY_LIST) === LAZY_LIST)	// vnode.body instanceof LazyList
				{ vnode.body.body(vnode); }

			if (isArr(vnode.body))
				{ hydrateBody(vnode); }
			else if (vnode.body != null && vnode.body !== "")
				{ vnode.el.textContent = vnode.body; }
		}
		else if (vnode.type === TEXT)
			{ vnode.el = withEl || createTextNode(vnode.body); }
		else if (vnode.type === COMMENT)
			{ vnode.el = withEl || createComment(vnode.body); }
	}

	vnode.el._node = vnode;

	return vnode.el;
}

// prevent GCC from inlining some large funcs (which negatively affects Chrome's JIT)
//window.syncChildren = syncChildren;
window.lisMove = lisMove;

function nextNode(node, body) {
	return body[node.idx + 1];
}

function prevNode(node, body) {
	return body[node.idx - 1];
}

function parentNode(node) {
	return node.parent;
}

var BREAK = 1;
var BREAK_ALL = 2;

function syncDir(advSib, advNode, insert, sibName, nodeName, invSibName, invNodeName, invInsert) {
	return function(node, parEl, body, state, convTest, lis) {
		var sibNode, tmpSib;

		if (state[sibName] != null) {
			// skip dom elements not created by domvm
			if ((sibNode = state[sibName]._node) == null) {
				state[sibName] = advSib(state[sibName]);
				return;
			}

			if (parentNode(sibNode) !== node) {
				tmpSib = advSib(state[sibName]);
				sibNode.vm != null ? sibNode.vm.unmount(true) : removeChild(parEl, state[sibName]);
				state[sibName] = tmpSib;
				return;
			}
		}

		if (state[nodeName] == convTest)
			{ return BREAK_ALL; }
		else if (state[nodeName].el == null) {
			insert(parEl, hydrate(state[nodeName]), state[sibName]);	// should lis be updated here?
			state[nodeName] = advNode(state[nodeName], body);		// also need to advance sib?
		}
		else if (state[nodeName].el === state[sibName]) {
			state[nodeName] = advNode(state[nodeName], body);
			state[sibName] = advSib(state[sibName]);
		}
		// head->tail or tail->head
		else if (!lis && sibNode === state[invNodeName]) {
			tmpSib = state[sibName];
			state[sibName] = advSib(tmpSib);
			invInsert(parEl, tmpSib, state[invSibName]);
			state[invSibName] = tmpSib;
		}
		else {
			if (lis && state[sibName] != null)
				{ return lisMove(advSib, advNode, insert, sibName, nodeName, parEl, body, sibNode, state); }

			return BREAK;
		}
	};
}

function lisMove(advSib, advNode, insert, sibName, nodeName, parEl, body, sibNode, state) {
	if (sibNode._lis) {
		insert(parEl, state[nodeName].el, state[sibName]);
		state[nodeName] = advNode(state[nodeName], body);
	}
	else {
		// find closest tomb
		var t = binaryFindLarger(sibNode.idx, state.tombs);
		sibNode._lis = true;
		var tmpSib = advSib(state[sibName]);
		insert(parEl, state[sibName], t != null ? body[state.tombs[t]].el : t);

		if (t == null)
			{ state.tombs.push(sibNode.idx); }
		else
			{ state.tombs.splice(t, 0, sibNode.idx); }

		state[sibName] = tmpSib;
	}
}

var syncLft = syncDir(nextSib, nextNode, insertBefore, "lftSib", "lftNode", "rgtSib", "rgtNode", insertAfter);
var syncRgt = syncDir(prevSib, prevNode, insertAfter, "rgtSib", "rgtNode", "lftSib", "lftNode", insertBefore);

function syncChildren(node, donor) {
	var obody	= donor.body,
		parEl	= node.el,
		body	= node.body,
		state = {
			lftNode:	body[0],
			rgtNode:	body[body.length - 1],
			lftSib:		((obody)[0] || emptyObj).el,
			rgtSib:		(obody[obody.length - 1] || emptyObj).el,
		};

	converge:
	while (1) {
//		from_left:
		while (1) {
			var l = syncLft(node, parEl, body, state, null, false);
			if (l === BREAK) { break; }
			if (l === BREAK_ALL) { break converge; }
		}

//		from_right:
		while (1) {
			var r = syncRgt(node, parEl, body, state, state.lftNode, false);
			if (r === BREAK) { break; }
			if (r === BREAK_ALL) { break converge; }
		}

		sortDOM(node, parEl, body, state);
		break;
	}
}

// TODO: also use the state.rgtSib and state.rgtNode bounds, plus reduce LIS range
function sortDOM(node, parEl, body, state) {
	var kids = Array.prototype.slice.call(parEl.childNodes);
	var domIdxs = [];

	for (var k = 0; k < kids.length; k++) {
		var n = kids[k]._node;

		if (n.parent === node)
			{ domIdxs.push(n.idx); }
	}

	// list of non-movable vnode indices (already in correct order in old dom)
	var tombs = longestIncreasingSubsequence(domIdxs).map(function (i) { return domIdxs[i]; });

	for (var i = 0; i < tombs.length; i++)
		{ body[tombs[i]]._lis = true; }

	state.tombs = tombs;

	while (1) {
		var r = syncLft(node, parEl, body, state, null, true);
		if (r === BREAK_ALL) { break; }
	}
}

function alreadyAdopted(vnode) {
	return vnode.el._node.parent !== vnode.parent;
}

function takeSeqIndex(n, obody, fromIdx) {
	return obody[fromIdx];
}

function findSeqThorough(n, obody, fromIdx) {		// pre-tested isView?
	for (; fromIdx < obody.length; fromIdx++) {
		var o = obody[fromIdx];

		if (o.vm != null) {
			// match by key & viewFn || vm
			if (n.type === VVIEW && o.vm.view === n.view && o.vm.key === n.key || n.type === VMODEL && o.vm === n.vm)
				{ return o; }
		}
		else if (!alreadyAdopted(o) && n.tag === o.tag && n.type === o.type && n.key === o.key && (n.flags & ~DEEP_REMOVE) === (o.flags & ~DEEP_REMOVE))
			{ return o; }
	}

	return null;
}

function findHashKeyed(n, obody, fromIdx) {
	return obody[obody._keys[n.key]];
}

/*
// list must be a sorted list of vnodes by key
function findBinKeyed(n, list) {
	var idx = binaryKeySearch(list, n.key);
	return idx > -1 ? list[idx] : null;
}
*/

// have it handle initial hydrate? !donor?
// types (and tags if ELEM) are assumed the same, and donor exists
function patch(vnode, donor) {
	fireHook(donor.hooks, "willRecycle", donor, vnode);

	var el = vnode.el = donor.el;

	var obody = donor.body;
	var nbody = vnode.body;

	el._node = vnode;

	// "" => ""
	if (vnode.type === TEXT && nbody !== obody) {
		el.nodeValue = nbody;
		return;
	}

	if (vnode.attrs != null || donor.attrs != null)
		{ patchAttrs(vnode, donor, false); }

	// patch events

	var oldIsArr = isArr(obody);
	var newIsArr = isArr(nbody);
	var lazyList = (vnode.flags & LAZY_LIST) === LAZY_LIST;

//	var nonEqNewBody = nbody != null && nbody !== obody;

	if (oldIsArr) {
		// [] => []
		if (newIsArr || lazyList)
			{ patchChildren(vnode, donor); }
		// [] => "" | null
		else if (nbody !== obody) {
			if (nbody != null)
				{ el.textContent = nbody; }
			else
				{ clearChildren(donor); }
		}
	}
	else {
		// "" | null => []
		if (newIsArr) {
			clearChildren(donor);
			hydrateBody(vnode);
		}
		// "" | null => "" | null
		else if (nbody !== obody) {
			if (el.firstChild)
				{ el.firstChild.nodeValue = nbody; }
			else
				{ el.textContent = nbody; }
		}
	}

	fireHook(donor.hooks, "didRecycle", donor, vnode);
}

// larger qtys of KEYED_LIST children will use binary search
//const SEQ_FAILS_MAX = 100;

// TODO: modify vtree matcher to work similar to dom reconciler for keyed from left -> from right -> head/tail -> binary
// fall back to binary if after failing nri - nli > SEQ_FAILS_MAX
// while-advance non-keyed fromIdx
// [] => []
function patchChildren(vnode, donor) {
	var nbody		= vnode.body,
		nlen		= nbody.length,
		obody		= donor.body,
		olen		= obody.length,
		isLazy		= (vnode.flags & LAZY_LIST) === LAZY_LIST,
		isFixed		= (vnode.flags & FIXED_BODY) === FIXED_BODY,
		isKeyed		= (vnode.flags & KEYED_LIST) === KEYED_LIST,
		domSync		= !isFixed && vnode.type === ELEMENT,
		doFind		= true,
		find		= (
			isKeyed ? findHashKeyed :				// keyed lists/lazyLists
			isFixed || isLazy ? takeSeqIndex :		// unkeyed lazyLists and FIXED_BODY
			findSeqThorough							// more complex stuff
		);

	if (isKeyed) {
		var keys = {};
		for (var i = 0; i < obody.length; i++)
			{ keys[obody[i].key] = i; }
		obody._keys = keys;
	}

	if (domSync && nlen === 0) {
		clearChildren(donor);
		if (isLazy)
			{ vnode.body = []; }	// nbody.tpl(all);
		return;
	}

	var donor2,
		node2,
		foundIdx,
		patched = 0,
		everNonseq = false,
		fromIdx = 0;		// first unrecycled node (search head)

	if (isLazy) {
		var fnode2 = {key: null};
		var nbodyNew = Array(nlen);
	}

	for (var i = 0; i < nlen; i++) {
		if (isLazy) {
			var remake = false;
			var diffRes = null;

			if (doFind) {
				if (isKeyed)
					{ fnode2.key = nbody.key(i); }

				donor2 = find(fnode2, obody, fromIdx);
			}

			if (donor2 != null) {
                foundIdx = donor2.idx;
				diffRes = nbody.diff(i, donor2);

				// diff returns same, so cheaply adopt vnode without patching
				if (diffRes === true) {
					node2 = donor2;
					node2.parent = vnode;
					node2.idx = i;
					node2._lis = false;
				}
				// diff returns new diffVals, so generate new vnode & patch
				else
					{ remake = true; }
			}
			else
				{ remake = true; }

			if (remake) {
				node2 = nbody.tpl(i);			// what if this is a VVIEW, VMODEL, injected element?
				preProc(node2, vnode, i);

				node2._diff = diffRes != null ? diffRes : nbody.diff(i);

				if (donor2 != null)
					{ patch(node2, donor2); }
			}
			else {
				// TODO: flag tmp FIXED_BODY on unchanged nodes?

				// domSync = true;		if any idx changes or new nodes added/removed
			}

			nbodyNew[i] = node2;
		}
		else {
			var node2 = nbody[i];
			var type2 = node2.type;

			// ELEMENT,TEXT,COMMENT
			if (type2 <= COMMENT) {
				if (donor2 = doFind && find(node2, obody, fromIdx)) {
					patch(node2, donor2);
					foundIdx = donor2.idx;
				}
			}
			else if (type2 === VVIEW) {
				if (donor2 = doFind && find(node2, obody, fromIdx)) {		// update/moveTo
					foundIdx = donor2.idx;
					var vm = donor2.vm._update(node2.data, vnode, i);		// withDOM
				}
				else
					{ var vm = createView(node2.view, node2.data, node2.key, node2.opts)._redraw(vnode, i, false); }	// createView, no dom (will be handled by sync below)

				type2 = vm.node.type;
			}
			else if (type2 === VMODEL) {
				// if the injected vm has never been rendered, this vm._update() serves as the
				// initial vtree creator, but must avoid hydrating (creating .el) because syncChildren()
				// which is responsible for mounting below (and optionally hydrating), tests .el presence
				// to determine if hydration & mounting are needed
				var withDOM = isHydrated(node2.vm);

				var vm = node2.vm._update(node2.data, vnode, i, withDOM);
				type2 = vm.node.type;
			}
		}

		// found donor & during a sequential search ...at search head
		if (!isKeyed && donor2 != null) {
			if (foundIdx === fromIdx) {
				// advance head
				fromIdx++;
				// if all old vnodes adopted and more exist, stop searching
				if (fromIdx === olen && nlen > olen) {
					// short-circuit find, allow loop just create/init rest
					donor2 = null;
					doFind = false;
				}
			}
			else
				{ everNonseq = true; }

			if (olen > 100 && everNonseq && ++patched % 10 === 0)
				{ while (fromIdx < olen && alreadyAdopted(obody[fromIdx]))
					{ fromIdx++; } }
		}
	}

	// replace List w/ new body
	if (isLazy)
		{ vnode.body = nbodyNew; }

	domSync && syncChildren(vnode, donor);
}

// view + key serve as the vm's unique identity
function ViewModel(view, data, key, opts) {
	var vm = this;

	vm.view = view;
	vm.data = data;
	vm.key = key;

	if (opts) {
		vm.opts = opts;
		vm.config(opts);
	}

	var out = isPlainObj(view) ? view : view.call(vm, vm, data, key, opts);

	if (isFunc(out))
		{ vm.render = out; }
	else {
		vm.render = out.render;
		vm.config(out);
	}

	// these must be wrapped here since they're debounced per view
	vm._redrawAsync = raft(function (_) { return vm.redraw(true); });
	vm._updateAsync = raft(function (newData) { return vm.update(newData, true); });

	vm.init && vm.init.call(vm, vm, vm.data, vm.key, opts);
}

var ViewModelProto = ViewModel.prototype = {
	constructor: ViewModel,

	_diff:	null,	// diff cache

	init:	null,
	view:	null,
	key:	null,
	data:	null,
	state:	null,
	api:	null,
	opts:	null,
	node:	null,
	hooks:	null,
	onevent: noop,
	refs:	null,
	render:	null,

	mount: mount,
	unmount: unmount,
	config: function(opts) {
		var t = this;

		if (opts.init)
			{ t.init = opts.init; }
		if (opts.diff)
			{ t.diff = opts.diff; }
		if (opts.onevent)
			{ t.onevent = opts.onevent; }

		// maybe invert assignment order?
		if (opts.hooks)
			{ t.hooks = assignObj(t.hooks || {}, opts.hooks); }

		{
			if (opts.onemit)
				{ t.onemit = assignObj(t.onemit || {}, opts.onemit); }
		}
	},
	parent: function() {
		return getVm(this.node.parent);
	},
	root: function() {
		var p = this.node;

		while (p.parent)
			{ p = p.parent; }

		return p.vm;
	},
	redraw: function(sync) {
		var vm = this;
		sync ? vm._redraw(null, null, isHydrated(vm)) : vm._redrawAsync();
		return vm;
	},
	update: function(newData, sync) {
		var vm = this;
		sync ? vm._update(newData, null, null, isHydrated(vm)) : vm._updateAsync(newData);
		return vm;
	},

	_update: updateSync,
	_redraw: redrawSync,
	_redrawAsync: null,
	_updateAsync: null,
};

function mount(el, isRoot) {
	var vm = this;

	if (isRoot) {
		clearChildren({el: el, flags: 0});

		vm._redraw(null, null, false);

		// if placeholder node doesnt match root tag
		if (el.nodeName.toLowerCase() !== vm.node.tag) {
			hydrate(vm.node);
			insertBefore(el.parentNode, vm.node.el, el);
			el.parentNode.removeChild(el);
		}
		else
			{ insertBefore(el.parentNode, hydrate(vm.node, el), el); }
	}
	else {
		vm._redraw(null, null);

		if (el)
			{ insertBefore(el, vm.node.el); }
	}

	if (el)
		{ drainDidHooks(vm); }

	return vm;
}

// asSub means this was called from a sub-routine, so don't drain did* hook queue
function unmount(asSub) {
	var vm = this;

	var node = vm.node;
	var parEl = node.el.parentNode;

	// edge bug: this could also be willRemove promise-delayed; should .then() or something to make sure hooks fire in order
	removeChild(parEl, node.el);

	if (!asSub)
		{ drainDidHooks(vm); }
}

function reParent(vm, vold, newParent, newIdx) {
	if (newParent != null) {
		newParent.body[newIdx] = vold;
		vold.idx = newIdx;
		vold.parent = newParent;
		vold._lis = false;
	}
	return vm;
}

function redrawSync(newParent, newIdx, withDOM) {
	var isRedrawRoot = newParent == null;
	var vm = this;
	var isMounted = vm.node && vm.node.el && vm.node.el.parentNode;

	var vold = vm.node, oldDiff, newDiff;

	if (vm.diff != null) {
		oldDiff = vm._diff;
		vm._diff = newDiff = vm.diff(vm, vm.data);

		if (vold != null) {
			var cmpFn = isArr(oldDiff) ? cmpArr : cmpObj;
			var isSame = oldDiff === newDiff || cmpFn(oldDiff, newDiff);

			if (isSame)
				{ return reParent(vm, vold, newParent, newIdx); }
		}
	}

	isMounted && fireHook(vm.hooks, "willRedraw", vm, vm.data);

	var vnew = vm.render.call(vm, vm, vm.data, oldDiff, newDiff);

	if (vnew === vold)
		{ return reParent(vm, vold, newParent, newIdx); }

	// todo: test result of willRedraw hooks before clearing refs
	vm.refs = null;

	// always assign vm key to root vnode (this is a de-opt)
	if (vm.key != null && vnew.key !== vm.key)
		{ vnew.key = vm.key; }

	vm.node = vnew;

	if (newParent) {
		preProc(vnew, newParent, newIdx, vm);
		newParent.body[newIdx] = vnew;
	}
	else if (vold && vold.parent) {
		preProc(vnew, vold.parent, vold.idx, vm);
		vold.parent.body[vold.idx] = vnew;
	}
	else
		{ preProc(vnew, null, null, vm); }

	if (withDOM !== false) {
		if (vold) {
			// root node replacement
			if (vold.tag !== vnew.tag || vold.key !== vnew.key) {
				// hack to prevent the replacement from triggering mount/unmount
				vold.vm = vnew.vm = null;

				var parEl = vold.el.parentNode;
				var refEl = nextSib(vold.el);
				removeChild(parEl, vold.el);
				insertBefore(parEl, hydrate(vnew), refEl);

				// another hack that allows any higher-level syncChildren to set
				// reconciliation bounds using a live node
				vold.el = vnew.el;

				// restore
				vnew.vm = vm;
			}
			else
				{ patch(vnew, vold); }
		}
		else
			{ hydrate(vnew); }
	}

	isMounted && fireHook(vm.hooks, "didRedraw", vm, vm.data);

	if (isRedrawRoot && isMounted)
		{ drainDidHooks(vm); }

	return vm;
}

// this also doubles as moveTo
// TODO? @withRedraw (prevent redraw from firing)
function updateSync(newData, newParent, newIdx, withDOM) {
	var vm = this;

	if (newData != null) {
		if (vm.data !== newData) {
			fireHook(vm.hooks, "willUpdate", vm, newData);
			vm.data = newData;


		}
	}

	return vm._redraw(newParent, newIdx, withDOM);
}

function defineElement(tag, arg1, arg2, flags) {
	var attrs, body;

	if (arg2 == null) {
		if (isPlainObj(arg1))
			{ attrs = arg1; }
		else
			{ body = arg1; }
	}
	else {
		attrs = arg1;
		body = arg2;
	}

	return initElementNode(tag, attrs, body, flags);
}

//export const XML_NS = "http://www.w3.org/2000/xmlns/";
var SVG_NS = "http://www.w3.org/2000/svg";

function defineSvgElement(tag, arg1, arg2, flags) {
	var n = defineElement(tag, arg1, arg2, flags);
	n.ns = SVG_NS;
	return n;
}

function defineComment(body) {
	var node = new VNode;
	node.type = COMMENT;
	node.body = body;
	return node;
}

// placeholder for declared views
function VView(view, data, key, opts) {
	this.view = view;
	this.data = data;
	this.key = key;
	this.opts = opts;
}

VView.prototype = {
	constructor: VView,

	type: VVIEW,
	view: null,
	data: null,
	key: null,
	opts: null,
};

function defineView(view, data, key, opts) {
	return new VView(view, data, key, opts);
}

// placeholder for injected ViewModels
function VModel(vm) {
	this.vm = vm;
}

VModel.prototype = {
	constructor: VModel,

	type: VMODEL,
	vm: null,
};

function injectView(vm) {
//	if (vm.node == null)
//		vm._redraw(null, null, false);

//	return vm.node;

	return new VModel(vm);
}

function injectElement(el) {
	var node = new VNode;
	node.type = ELEMENT;
	node.el = node.key = el;
	return node;
}

function lazyList(items, cfg) {
	var len = items.length;

	var self = {
		items: items,
		length: len,
		// defaults to returning item identity (or position?)
		key: function(i) {
			return cfg.key(items[i], i);
		},
		// default returns 0?
		diff: function(i, donor) {
			var newVals = cfg.diff(items[i], i);
			if (donor == null)
				{ return newVals; }
			var oldVals = donor._diff;
			var same = newVals === oldVals || isArr(oldVals) ? cmpArr(newVals, oldVals) : cmpObj(newVals, oldVals);
			return same || newVals;
		},
		tpl: function(i) {
			return cfg.tpl(items[i], i);
		},
		map: function(tpl) {
			cfg.tpl = tpl;
			return self;
		},
		body: function(vnode) {
			var nbody = Array(len);

			for (var i = 0; i < len; i++) {
				var vnode2 = self.tpl(i);

			//	if ((vnode.flags & KEYED_LIST) === KEYED_LIST && self. != null)
			//		vnode2.key = getKey(item);

				vnode2._diff = self.diff(i);			// holds oldVals for cmp

				nbody[i] = vnode2;

				// run preproc pass (should this be just preProc in above loop?) bench
				preProc(vnode2, vnode, i);
			}

			// replace List with generated body
			vnode.body = nbody;
		}
	};

	return self;
}

var nano = {
	config: config,

	ViewModel: ViewModel,
	VNode: VNode,

	createView: createView,

	defineElement: defineElement,
	defineSvgElement: defineSvgElement,
	defineText: defineText,
	defineComment: defineComment,
	defineView: defineView,

	injectView: injectView,
	injectElement: injectElement,

	lazyList: lazyList,

	FIXED_BODY: FIXED_BODY,
	DEEP_REMOVE: DEEP_REMOVE,
	KEYED_LIST: KEYED_LIST,
	LAZY_LIST: LAZY_LIST,
};

function protoPatch(n, doRepaint) {
	patch$1(this, n, doRepaint);
}

// newNode can be either {class: style: } or full new VNode
// will/didPatch hooks?
function patch$1(o, n, doRepaint) {
	if (n.type != null) {
		// no full patching of view roots, just use redraw!
		if (o.vm != null)
			{ return; }

		preProc(n, o.parent, o.idx, null);
		o.parent.body[o.idx] = n;
		patch(n, o);
		doRepaint && repaint(n);
		drainDidHooks(getVm(n));
	}
	else {
		// TODO: re-establish refs

		// shallow-clone target
		var donor = Object.create(o);
		// fixate orig attrs
		donor.attrs = assignObj({}, o.attrs);
		// assign new attrs into live targ node
		var oattrs = assignObj(o.attrs, n);
		// prepend any fixed shorthand class
		if (o._class != null) {
			var aclass = oattrs.class;
			oattrs.class = aclass != null && aclass !== "" ? o._class + " " + aclass : o._class;
		}

		patchAttrs(o, donor);

		doRepaint && repaint(o);
	}
}

VNodeProto.patch = protoPatch;

function nextSubVms(n, accum) {
	var body = n.body;

	if (isArr(body)) {
		for (var i = 0; i < body.length; i++) {
			var n2 = body[i];

			if (n2.vm != null)
				{ accum.push(n2.vm); }
			else
				{ nextSubVms(n2, accum); }
		}
	}

	return accum;
}

function defineElementSpread(tag) {
	var args = arguments;
	var len = args.length;
	var body, attrs;

	if (len > 1) {
		var bodyIdx = 1;

		if (isPlainObj(args[1])) {
			attrs = args[1];
			bodyIdx = 2;
		}

		if (len === bodyIdx + 1 && (isVal(args[bodyIdx]) || isArr(args[bodyIdx]) || attrs && (attrs._flags & LAZY_LIST) === LAZY_LIST))
			{ body = args[bodyIdx]; }
		else
			{ body = sliceArgs(args, bodyIdx); }
	}

	return initElementNode(tag, attrs, body);
}

function defineSvgElementSpread() {
	var n = defineElementSpread.apply(null, arguments);
	n.ns = SVG_NS;
	return n;
}

ViewModelProto.emit = emit;
ViewModelProto.onemit = null;

ViewModelProto.body = function() {
	return nextSubVms(this.node, []);
};

nano.defineElementSpread = defineElementSpread;
nano.defineSvgElementSpread = defineSvgElementSpread;

return nano;

})));
//# sourceMappingURL=domvm.micro.js.map


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var dom_1 = __webpack_require__(0);
var html_1 = __webpack_require__(1);
var ScrollView = /** @class */ (function () {
    function ScrollView(getRootView, config) {
        var _a;
        if (config === void 0) { config = {}; }
        var _this = this;
        this.config = core_1.extend({
            speed: 20
        }, config);
        this._wheelName = html_1.isIE() ? "onmousewheel" : "onwheel";
        this._getRootView = getRootView;
        this._scrollTop = 0;
        this._runnerTop = 0;
        this._runnerHeight = 0;
        this._visibleArea = 1;
        this._scrollWidth = html_1.getScrollbarWidth();
        this._handlers = (_a = {
                onscroll: function () {
                    _this._update();
                }
            },
            _a[this._wheelName] = function (e) {
                e.preventDefault();
                var sign = (e.deltaY || -e.wheelDelta) > 0 ? 1 : -1;
                var delta = sign * _this.config.speed;
                var area = _this._getRefs().area;
                var maxBottom = area.scrollHeight - _this._runnerHeight;
                var newScrollTop = _this._scrollTop + delta;
                if (newScrollTop < 0) {
                    area.scrollTop = 0;
                }
                else if (newScrollTop > maxBottom) {
                    area.scrollTop = maxBottom;
                }
                else {
                    area.scrollTop = newScrollTop;
                }
                _this._update();
            },
            _a.onmousedownRunner = function (mouseDownEv) {
                mouseDownEv.preventDefault();
                var _a = _this._getRefs(), area = _a.area, runner = _a.runner;
                var rect = area.getBoundingClientRect();
                var top = rect.top + window.pageYOffset;
                var bottom = rect.bottom + window.pageYOffset;
                var maxBottom = area.scrollHeight - _this._runnerHeight;
                var delta = mouseDownEv.pageY - runner.getBoundingClientRect().top - window.pageYOffset;
                var mouseMove = function (e) {
                    var y = e.pageY - delta;
                    if (y <= top) {
                        area.scrollTop = 0;
                    }
                    else if (y > bottom) {
                        area.scrollTop = maxBottom;
                    }
                    else {
                        area.scrollTop = (y - top) / _this._visibleArea;
                    }
                    _this._update();
                };
                var mouseUp = function () {
                    document.removeEventListener("mousemove", mouseMove);
                    document.removeEventListener("mouseup", mouseUp);
                    document.body.classList.remove("dhx-no-select");
                };
                document.body.classList.add("dhx-no-select");
                document.addEventListener("mousemove", mouseMove);
                document.addEventListener("mouseup", mouseUp);
            },
            _a.onmousedownTrack = function (e) {
                if (e.target.classList.contains("scroll-runner")) {
                    return;
                }
                e.preventDefault();
                var mouseUp = function () {
                    document.removeEventListener("mouseup", mouseUp);
                    window.clearInterval(mousePressed); // typescript bug
                };
                var area = _this._getRefs().area;
                var top = e.target.getBoundingClientRect().top + window.pageYOffset;
                var maxBottom = area.scrollHeight - _this._runnerHeight;
                var y = e.pageY;
                var updateScroll = function () {
                    var scrollTop;
                    if (y < top + _this._runnerTop) {
                        scrollTop = _this._scrollTop - area.clientHeight;
                        if (scrollTop < 0) {
                            scrollTop = 0;
                        }
                    }
                    else if (y > top + _this._runnerTop + _this._runnerHeight) {
                        scrollTop = _this._scrollTop + area.clientHeight;
                        if (scrollTop > maxBottom) {
                            scrollTop = maxBottom;
                        }
                    }
                    else {
                        return;
                    }
                    area.scrollTop = scrollTop;
                    _this._update();
                };
                updateScroll();
                var mousePressed = setInterval(updateScroll, 100);
                document.addEventListener("mouseup", mouseUp);
            },
            _a);
    }
    ScrollView.prototype.render = function (element) {
        var _this = this;
        var _a;
        if (this._scrollWidth === 0) {
            return element;
        }
        return dom_1.el(".scroll-view-wrapper", {
            style: {
                width: "100%",
                height: "100%",
                overflow: "hidden",
                position: "relative"
            }
        }, [
            dom_1.el(".scroll-view", {
                onscroll: this._handlers.onscroll,
                _ref: "scroll-view",
                _hooks: {
                    didInsert: function () {
                        _this._update();
                    },
                    didRecycle: function () {
                        _this._update();
                    }
                },
                style: {
                    "height": "100%",
                    "width": "calc(100% + " + this._scrollWidth + "px)",
                    "overflowY": "scroll",
                    "-ms-overflow-style": "scrollbar"
                },
            }, [element]),
            dom_1.el(".y-scroll", (_a = {
                    onmousedown: this._handlers.onmousedownTrack
                },
                _a[this._wheelName] = this._handlers[this._wheelName],
                _a.style = {
                    width: "10px",
                    height: "100%",
                    right: 0,
                    top: 0,
                    position: "absolute"
                },
                _a), [
                dom_1.el(".scroll-runner", {
                    _ref: "scroll-runner",
                    onmousedown: this._handlers.onmousedownRunner,
                    style: {
                        height: this._runnerHeight + "px",
                        right: "2px",
                        top: this._runnerTop,
                        width: "6px",
                        position: "absolute"
                    }
                })
            ])
        ]);
    };
    ScrollView.prototype._update = function () {
        var refs = this._getRefs();
        if (!refs) {
            return;
        }
        var area = refs.area, runner = refs.runner;
        this._visibleArea = area.clientHeight / area.scrollHeight;
        this._scrollTop = area.scrollTop;
        this._runnerTop = this._scrollTop * this._visibleArea;
        if (this._visibleArea < 1) {
            this._runnerHeight = area.clientHeight * this._visibleArea;
        }
        else {
            this._runnerHeight = 0;
        }
        // update dom
        runner.style.top = this._runnerTop + "px";
        runner.style.height = this._runnerHeight + "px";
    };
    ScrollView.prototype._getRefs = function () {
        var rootView = this._getRootView();
        if (rootView.refs && rootView.refs["scroll-view"] && rootView.refs["scroll-runner"]) {
            return {
                area: rootView.refs["scroll-view"].el,
                runner: rootView.refs["scroll-runner"].el
            };
        }
    };
    return ScrollView;
}());
exports.ScrollView = ScrollView;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(46));


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var Cell_1 = __webpack_require__(47);
var dom_1 = __webpack_require__(0);
var Layout = /** @class */ (function (_super) {
    __extends(Layout, _super);
    function Layout(parent, config) {
        var _this = _super.call(this, parent, config) || this;
        if (_this.config.views) {
            _this.config.activeView = _this.config.activeView || 0;
            _this._isViewLayout = true;
        }
        _this._all = {};
        _this._parseConfig();
        _this._css += _this._xLayout ? "layout_x" : "layout_y";
        if (!(parent instanceof Layout)) {
            var view = dom_1.create({ render: function () { return _this.toVDOM(); } }, _this);
            _this.mount(parent, view);
        }
        return _this;
    }
    Layout.prototype.cell = function (id) {
        return this._all[id];
    };
    Layout.prototype.updateActiveView = function (id) {
        for (var i = 0; i < this._cells.length; i++) {
            if (this._cells[i].id === id) {
                if (this.config.activeView !== i) {
                    this.config.activeView = i;
                    this.paint();
                }
                return;
            }
        }
    };
    Layout.prototype.getActiveView = function () {
        return this._cells[this.config.activeView];
    };
    Layout.prototype.toVDOM = function () {
        if (this._isViewLayout) {
            return _super.prototype.toVDOM.call(this, [this.getActiveView().toVDOM()]);
        }
        var nodes = [];
        this._cells.forEach(function (cell) {
            var node = cell.toVDOM();
            if (Array.isArray(node)) {
                nodes.push.apply(nodes, node);
            }
            else {
                nodes.push(node);
            }
        });
        return _super.prototype.toVDOM.call(this, nodes, this._isTopParent);
    };
    Layout.prototype.removeCell = function (id) {
        var topParent = this.getTopParent();
        if (topParent._all[id]) {
            var parent_1 = topParent._all[id].getParent();
            delete topParent._all[id];
            var cells = parent_1._cells;
            var deleteIndex = -1;
            for (var i = 0; i < cells.length; i++) {
                if (cells[i].id === id) {
                    deleteIndex = i;
                    break;
                }
            }
            if (deleteIndex !== -1) {
                cells.splice(deleteIndex, 1);
            }
            this.paint();
        }
    };
    Layout.prototype.addCell = function (config, index) {
        if (index === void 0) { index = -1; }
        var topParent = this.getTopParent();
        var view = this._parseView(config, topParent);
        if (index < 0) {
            index = this._cells.length + index + 1;
        }
        this._cells.splice(index, 0, view);
        this.paint();
    };
    Layout.prototype.getId = function (index) {
        if (index < 0) {
            index = this._cells.length + index;
        }
        return this._cells[index] ? this._cells[index].id : undefined;
    };
    Layout.prototype._parseConfig = function () {
        var _this = this;
        var config = this.config;
        var topParent = this.getTopParent();
        var cells = config.rows || config.cols || config.views;
        this._xLayout = !config.rows;
        this._cells = cells.map(function (a) { return _this._parseView(a, topParent); });
    };
    Layout.prototype._createUi = function (cell) {
        if (cell.rows || cell.cols || cell.views) {
            return new Layout(this, cell);
        }
        else {
            return new Cell_1.Cell(this, cell);
        }
    };
    Layout.prototype._parseView = function (raw, topParent) {
        var view = this._createUi(raw);
        if (raw.id) {
            topParent._all[raw.id] = view;
        }
        return view;
    };
    return Layout;
}(Cell_1.Cell));
exports.Layout = Layout;


/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var view_1 = __webpack_require__(12);
var resizeMode;
(function (resizeMode) {
    resizeMode[resizeMode["unknown"] = 0] = "unknown";
    resizeMode[resizeMode["percents"] = 1] = "percents";
    resizeMode[resizeMode["pixels"] = 2] = "pixels";
    resizeMode[resizeMode["mixedpx1"] = 3] = "mixedpx1";
    resizeMode[resizeMode["mixedpx2"] = 4] = "mixedpx2";
    resizeMode[resizeMode["mixedperc1"] = 5] = "mixedperc1";
    resizeMode[resizeMode["mixedperc2"] = 6] = "mixedperc2";
})(resizeMode || (resizeMode = {}));
function getResizeMode(dir, conf1, conf2) {
    var field = dir ? "width" : "height";
    var is1perc = conf1[field] && conf1[field].indexOf("%") !== -1;
    var is2perc = conf2[field] && conf2[field].indexOf("%") !== -1;
    var is1px = conf1[field] && conf1[field].indexOf("px") !== -1;
    var is2px = conf2[field] && conf2[field].indexOf("px") !== -1;
    if (is1perc && is2perc) {
        return resizeMode.percents;
    }
    if (is1px && is2px) {
        return resizeMode.pixels;
    }
    if (is1px && !is2px) {
        return resizeMode.mixedpx1;
    }
    if (is2px && !is1px) {
        return resizeMode.mixedpx2;
    }
    if (is1perc) {
        return resizeMode.mixedperc1;
    }
    if (is2perc) {
        return resizeMode.mixedperc2;
    }
    return resizeMode.unknown;
}
function getBlockRange(block1, block2, isXLayout) {
    if (isXLayout === void 0) { isXLayout = true; }
    if (isXLayout) {
        return {
            min: block1.left + window.pageXOffset,
            max: block2.right + window.pageXOffset
        };
    }
    return {
        min: block1.top + window.pageYOffset,
        max: block2.bottom + window.pageYOffset
    };
}
var Cell = /** @class */ (function (_super) {
    __extends(Cell, _super);
    function Cell(parent, config) {
        var _this = _super.call(this, parent, config) || this;
        _this._parent = parent;
        _this._isTopParent = !(parent instanceof Cell);
        _this._initHandlers();
        _this.mount(parent, { redraw: function () {
                parent.paint();
            } });
        _this.id = _this.config.id;
        _this._css = "";
        return _this;
    }
    Cell.prototype.isVisible = function () {
        return !this.config.hidden;
    };
    Cell.prototype.isView = function () {
        return !!this._parent.config.views;
    };
    Cell.prototype.hide = function () {
        this.config.hidden = true;
        this.paint();
    };
    Cell.prototype.show = function (_forced) {
        if (this.isView()) {
            this._parent.updateActiveView(this.id);
            return;
        }
        if (this._parent && !this._parent.isVisible()) {
            this._parent.show();
        }
        this.config.hidden = false;
        this.paint();
    };
    Cell.prototype.getParent = function () {
        return this._parent;
    };
    Cell.prototype.getTopParent = function () {
        if (this._isTopParent) {
            return this;
        }
        var parent = this.getParent();
        while (parent) {
            if (parent._isTopParent) {
                return parent;
            }
            parent = parent.getParent();
        }
    };
    Cell.prototype.destructor = function () {
        this.config = null;
    };
    Cell.prototype.getWidget = function () {
        return this._ui;
    };
    Cell.prototype.attach = function (name, config) {
        if (typeof name === "object") {
            this._ui = name;
        }
        else if (typeof name === "string") {
            this._ui = new window.dhx[name](null, config);
        }
        else if (typeof name === "function") {
            if (name.prototype instanceof view_1.View) {
                this._ui = new name(null, config);
            }
            else {
                this._ui = {
                    getRootView: function () {
                        return name(config);
                    }
                };
            }
        }
        this.paint();
        return this._ui;
    };
    Cell.prototype.toVDOM = function (nodes, isTopParent) {
        if (isTopParent === void 0) { isTopParent = false; }
        var conf = this.config;
        if (conf.hidden) {
            return;
        }
        var css = this._css + " " + (this.config.css || "") + (isTopParent ? " dhx_widget" : "");
        var style = this._calculateStyle();
        var kids;
        if (this.config.html) {
            kids = [dom_1.el("div", { ".innerHTML": this.config.html })];
        }
        else if (this._ui) {
            var view = this._ui.getRootView();
            if (view.render) {
                view = dom_1.inject(view);
            }
            kids = [view];
        }
        else {
            kids = nodes || null;
        }
        var resizer = this.config.canResize && !this._isLastCell() ?
            dom_1.el(".resizer." + (this._isXDirection() ? "x" : "y"), __assign({}, this._resizerHandlers, { _ref: "resizer_" + this._uid }), [dom_1.el("div", {
                    class: "dxi " + (this._isXDirection() ? "dxi-dots-vertical" : "dxi-dots-horizontal")
                })]) : null;
        var handlers = {};
        if (this.config.on) {
            for (var key in this.config.on) {
                handlers["on" + key] = this.config.on[key];
            }
        }
        var cell = dom_1.el("div", __assign({ _key: this._uid, style: style, _ref: this._uid }, handlers, { class: "dhx_cell " + css + (this.config.collapsed ? " collapsed" : "") }), [
            this.config.header ? dom_1.el("div", {
                class: "dhx_cell_header",
                onclick: this._handlers.collapse
            }, [
                dom_1.el(".header-text", this.config.header),
                dom_1.el(".header-action-icon", [
                    dom_1.el("div", {
                        class: "dxi " + this.config.headerIcon
                    })
                ])
            ]) : null,
            !this.config.collapsed ? dom_1.el("div", {
                class: "dhx_cell_content"
            }, kids) : null,
            this.config.footer ? dom_1.el("div", {
                class: "dhx_cell_footer",
            }, this.config.footer) : null
        ]);
        return resizer ? [
            cell,
            resizer
        ] : cell;
    };
    Cell.prototype._initHandlers = function () {
        var _this = this;
        var blockOpts = {
            left: null,
            top: null,
            isActive: false,
            range: null,
            xLayout: null,
            nextCell: null,
            size: null,
            resizerLength: null,
            mode: null,
            percentsum: null
        };
        var mouseUp = function () {
            blockOpts.isActive = false;
            document.body.classList.remove("dhx-no-select");
            document.removeEventListener("mouseup", mouseUp);
            document.removeEventListener("mousemove", mouseMove);
        };
        var mouseMove = function (e) {
            if (!blockOpts.isActive || blockOpts.mode === resizeMode.unknown) {
                return;
            }
            var newValue = blockOpts.xLayout ? e.x - blockOpts.range.min - window.pageXOffset :
                e.y - blockOpts.range.min - window.pageYOffset;
            var prop = blockOpts.xLayout ? "width" : "height";
            if (newValue < 0) {
                newValue = blockOpts.resizerLength / 2;
            }
            else if (newValue > blockOpts.size) {
                newValue = blockOpts.size - blockOpts.resizerLength;
            }
            switch (blockOpts.mode) {
                case resizeMode.pixels:
                    _this.config[prop] = newValue - blockOpts.resizerLength / 2 + "px";
                    blockOpts.nextCell.config[prop] = blockOpts.size - newValue - blockOpts.resizerLength / 2 + "px";
                    break;
                case resizeMode.mixedpx1:
                    _this.config[prop] = newValue - blockOpts.resizerLength / 2 + "px";
                    break;
                case resizeMode.mixedpx2:
                    blockOpts.nextCell.config[prop] = blockOpts.size - newValue - blockOpts.resizerLength / 2 + "px";
                    break;
                case resizeMode.percents:
                    _this.config[prop] = newValue / blockOpts.size * blockOpts.percentsum + "%";
                    blockOpts.nextCell.config[prop] = (blockOpts.size - newValue) / blockOpts.size * blockOpts.percentsum + "%";
                    break;
                case resizeMode.mixedperc1:
                    _this.config[prop] = newValue / blockOpts.size * blockOpts.percentsum + "%";
                    break;
                case resizeMode.mixedperc2:
                    blockOpts.nextCell.config[prop] = (blockOpts.size - newValue) / blockOpts.size * blockOpts.percentsum + "%";
                    break;
            }
            _this.paint();
        };
        this._handlers = {
            collapse: function () {
                if (!_this.config.canCollapse) {
                    return;
                }
                _this.config.collapsed = !_this.config.collapsed;
                _this.paint();
            }
        };
        this._resizerHandlers = {
            onmousedown: function (e) {
                if (e.which === 3) {
                    return;
                }
                if (blockOpts.isActive) {
                    mouseUp();
                }
                document.body.classList.add("dhx-no-select");
                var block = _this._getCellView();
                var nextCell = _this._getNextCell();
                var nextBlock = nextCell._getCellView();
                var resizerBlock = _this._getResizerView();
                var blockOffsets = block.el.getBoundingClientRect();
                var resizerOffsets = resizerBlock.el.getBoundingClientRect();
                var nextBlockOffsets = nextBlock.el.getBoundingClientRect();
                blockOpts.xLayout = _this._isXDirection();
                blockOpts.left = blockOffsets.left + window.pageXOffset;
                blockOpts.top = blockOffsets.top + window.pageYOffset;
                blockOpts.range = getBlockRange(blockOffsets, nextBlockOffsets, blockOpts.xLayout);
                blockOpts.size = blockOpts.range.max - blockOpts.range.min;
                blockOpts.isActive = true;
                blockOpts.nextCell = nextCell;
                blockOpts.resizerLength = blockOpts.xLayout ? resizerOffsets.width : resizerOffsets.height;
                blockOpts.mode = getResizeMode(blockOpts.xLayout, _this.config, nextCell.config);
                if (blockOpts.mode === resizeMode.percents) {
                    var field = blockOpts.xLayout ? "width" : "height";
                    blockOpts.percentsum = parseFloat(_this.config[field]) + parseFloat(nextCell.config[field]);
                }
                if (blockOpts.mode === resizeMode.mixedperc1) {
                    var field = blockOpts.xLayout ? "width" : "height";
                    blockOpts.percentsum = 1 / (blockOffsets[field] / (blockOpts.size - blockOpts.resizerLength)) * parseFloat(_this.config[field]);
                }
                if (blockOpts.mode === resizeMode.mixedperc2) {
                    var field = blockOpts.xLayout ? "width" : "height";
                    blockOpts.percentsum = 1 / (nextBlockOffsets[field] / (blockOpts.size - blockOpts.resizerLength)) * parseFloat(nextCell.config[field]);
                }
                document.addEventListener("mouseup", mouseUp);
                document.addEventListener("mousemove", mouseMove);
            },
            ondragstart: function (e) { return e.preventDefault(); }
        };
    };
    Cell.prototype._isLastCell = function () {
        var parent = this._parent;
        return parent && parent._cells.indexOf(this) === parent._cells.length - 1;
    };
    Cell.prototype._getNextCell = function () {
        var parent = this._parent;
        var index = parent._cells.indexOf(this);
        return parent._cells[index + 1];
    };
    Cell.prototype._getCellView = function () {
        return this.getTopParent().getRootView().refs[this._uid];
    };
    Cell.prototype._getResizerView = function () {
        return this.getTopParent().getRootView().refs["resizer_" + this._uid];
    };
    Cell.prototype._isXDirection = function () {
        return this._parent && this._parent._xLayout;
    };
    Cell.prototype._calculateStyle = function () {
        var conf = this.config;
        var style = {};
        if (this._isXDirection()) {
            if (this.config.width !== undefined) {
                style.flex = "0 0 " + conf.width;
            }
            if (conf.height !== undefined) {
                style.height = conf.height;
            }
        }
        else {
            if (this.config.height !== undefined) {
                style.flex = "0 0 " + conf.height;
            }
            if (conf.width !== undefined) {
                style.width = conf.width;
            }
        }
        return style;
    };
    return Cell;
}(view_1.View));
exports.Cell = Cell;


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(__webpack_require__(26));
__export(__webpack_require__(61));
__export(__webpack_require__(62));
__export(__webpack_require__(63));
__export(__webpack_require__(17));
var types_1 = __webpack_require__(4);
exports.ToolbarEvents = types_1.ToolbarEvents;
exports.ItemType = types_1.ItemType;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function button(item) {
    return dom_1.el("div", {
        class: "button-container main-btn element" + helpers_1.getCss(item) + (item.value ? "" : " no-text"),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        item.icon ? helpers_1.icon(item.icon) : null,
        item.value ? dom_1.el(".button-text", item.value) : null
    ]);
}
exports.button = button;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function customHTMLButton(item) {
    return dom_1.el("div", {
        class: "button-container custom-html-btn element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        dom_1.el(".html-content", {
            ".innerHTML": item.html
        }),
        item.value ? dom_1.el(".button-text", item.value) : null
    ]);
}
exports.customHTMLButton = customHTMLButton;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function dhx_button(item) {
    return dom_1.el("button", {
        class: "dhx_btn" + helpers_1.getCss(item) + helpers_1.getButtonCss(item),
        dhx_id: item.id
    }, [
        item.icon ? helpers_1.icon(item.icon) : null,
        item.value ? dom_1.el(".item-value", item.value) : null
    ]);
}
exports.dhx_button = dhx_button;


/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function iconButton(item) {
    return dom_1.el("div", {
        class: "icon-btn element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        helpers_1.icon(item.icon),
        item.css && item.css.indexOf("ripple") !== -1 ? dom_1.el(".ripple-container-outside") : null
    ]);
}
exports.iconButton = iconButton;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function imageButton(item) {
    return dom_1.el("div", {
        class: "button-container img-btn element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        dom_1.el(".img-button-wrapper", [
            dom_1.el("img.img-button", {
                src: item.src
            })
        ])
    ]);
}
exports.imageButton = imageButton;


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function imageButtonText(item) {
    return dom_1.el("div", {
        class: "button-container img-text-btn element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        helpers_1.counter(item),
        dom_1.el("img.img-button", {
            src: item.src
        }),
        dom_1.el(".button-text", item.value)
    ]);
}
exports.imageButtonText = imageButtonText;


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var types_1 = __webpack_require__(4);
var helpers_1 = __webpack_require__(2);
function input(item, events) {
    return dom_1.el("div", {
        dhx_id: item.id,
        class: "input-container element" + helpers_1.getCss(item)
    }, [
        dom_1.el(".input-wrapper", [
            dom_1.el("input.text-input", {
                placeholder: item.placeholder,
                value: item.value,
                style: {
                    width: item.width ? item.width : null
                },
                _hooks: {
                    didInsert: function (node) {
                        if (events) {
                            events.fire(types_1.ToolbarEvents.inputCreated, [item.id, node.el]);
                        }
                    }
                },
                _key: item.id
            }),
            dom_1.el(".input-animation")
        ]),
        item.icon ? helpers_1.icon(item.icon) : null
    ]);
}
exports.input = input;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function menuItem(item) {
    return dom_1.el("div", {
        class: "menu-item element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, [
        item.icon ? helpers_1.icon(item.icon) : null,
        item.value ? dom_1.el("span.menu-item-content", item.value) : null,
        item.$openIcon ? dom_1.el(".dhx-icon.sub-menu-opener", [
            dom_1.el(".dxi." + (item.$openIcon === "right" ? ".dxi-menu-right" : ".dxi-menu-down"))
        ]) : null,
        item.hotkey ? dom_1.el(".hotkey", item.hotkey) : null
    ]);
}
exports.menuItem = menuItem;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
function separator(_item) {
    return dom_1.el(".separator");
}
exports.separator = separator;


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
function spacer(_item) {
    return dom_1.el(".spacer");
}
exports.spacer = spacer;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helpers_1 = __webpack_require__(2);
function text(item) {
    return dom_1.el("div", {
        class: "text element" + helpers_1.getCss(item),
        dhx_id: item.id
    }, item.value);
}
exports.text = text;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
function getHotKeyCode(code) {
    var matches = code.toLowerCase().match(/\w+/g);
    var comp = 0;
    var key = "";
    for (var i = 0; i < matches.length; i++) {
        var check = matches[i];
        if (check === "ctrl") {
            comp += 4;
        }
        else if (check === "shift") {
            comp += 2;
        }
        else if (check === "alt") {
            comp += 1;
        }
        else {
            key = check;
        }
    }
    return comp + key;
}
var KeyManager = /** @class */ (function () {
    function KeyManager() {
        var _this = this;
        this._keysStorage = {};
        document.addEventListener("keydown", function (e) {
            var comp = (e.ctrlKey ? 4 : 0) + (e.shiftKey ? 2 : 0) + (e.altKey ? 1 : 0);
            if(e.key != null && e.key != undefined && e.key !="") {
              var code = comp + e.key.toLowerCase();
              var action = _this._keysStorage[code];
              if (action) {
                  action.handler(e);
              }
            }
        });
    }
    KeyManager.prototype.addHotKey = function (key, handler, scope) {
        var code = getHotKeyCode(key);
        this._keysStorage[code] = {
            handler: handler,
            scope: scope
        };
    };
    KeyManager.prototype.removeHotKey = function (key, scope) {
        var keyStorage = this._keysStorage;
        if (key) {
            var code = getHotKeyCode(key);
            delete keyStorage[code];
        }
        if (scope) {
            for (var code in keyStorage) {
                if (keyStorage[code].scope === scope) {
                    delete keyStorage[code];
                }
            }
        }
    };
    KeyManager.prototype.exist = function (key) {
        var code = getHotKeyCode(key);
        return !!this._keysStorage[code];
    };
    return KeyManager;
}());
exports.keyManager = new KeyManager();


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var html_1 = __webpack_require__(1);
var helper_1 = __webpack_require__(13);
var MenuBase_1 = __webpack_require__(18);
var ContextMenu = /** @class */ (function (_super) {
    __extends(ContextMenu, _super);
    function ContextMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isContextMenu = true;
        return _this;
    }
    ContextMenu.prototype.showAt = function (elem, showAt) {
        if (showAt === void 0) { showAt = "bottom"; }
        if (elem instanceof MouseEvent) {
            this._changeActivePosition({
                left: window.pageXOffset + elem.x + 1,
                right: window.pageXOffset + elem.x + 1,
                top: window.pageYOffset + elem.y,
                bottom: window.pageYOffset + elem.y
            }, showAt);
        }
        else {
            var node = html_1.toNode(elem);
            this._changeActivePosition(helper_1.getRealPosition(node), showAt);
        }
    };
    ContextMenu.prototype._close = function () {
        this._activeMenu = null;
        this._changeActivePosition(null, null);
    };
    ContextMenu.prototype._normalizeData = function () {
        var _this = this;
        var root = this.data.getRoot();
        this.data.eachChild(root, function (item) {
            if (_this.data.haveChilds(item.id)) {
                item.$openIcon = "right";
            }
        }, true);
    };
    ContextMenu.prototype._getMode = function (_item, _root, active) {
        return active ? this._mode : "right";
    };
    ContextMenu.prototype._changeActivePosition = function (position, mode) {
        this._activePosition = position;
        this._mode = mode;
        this._listenOuterClick();
        this.paint();
    };
    return ContextMenu;
}(MenuBase_1.MenuBase));
exports.ContextMenu = ContextMenu;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var MenuBase_1 = __webpack_require__(18);
var Menu = /** @class */ (function (_super) {
    __extends(Menu, _super);
    function Menu(element, config) {
        var _this = _super.call(this, element, config) || this;
        var render = function () { return _this._draw(); };
        _this.mount(element, dom_1.create({ render: render }));
        return _this;
    }
    Menu.prototype._draw = function () {
        return dom_1.el("div", __assign({ dhx_widget_id: this._uid, class: "main-menu" }, this._handlers), this._drawMenuItems(this.data.getRoot()));
    };
    return Menu;
}(MenuBase_1.MenuBase));
exports.Menu = Menu;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var helper_1 = __webpack_require__(13);
var Toolbar_1 = __webpack_require__(26);
var types_1 = __webpack_require__(4);
var Ribbon = /** @class */ (function (_super) {
    __extends(Ribbon, _super);
    function Ribbon() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Ribbon.prototype._draw = function () {
        var _this = this;
        return dom_1.el(".ribbon.dhx_widget", {
            dhx_widget_id: this._uid,
            onclick: this._handlers.onclick
        }, this.data.map(function (block) { return _this._drawBlock(block.id); }, this.data.getRoot(), false));
    };
    Ribbon.prototype._setRoot = function (id) {
        var parentId = this.data.getParent(id);
        if (this.data.getItem(parentId).type === types_1.ItemType.block) {
            this._currentRoot = id;
        }
    };
    Ribbon.prototype._normalizeData = function () {
        var _this = this;
        var root = this.data.getRoot();
        var groups = {};
        this.data.eachChild(root, function (item) {
            if (item.type === types_1.ItemType.menuItem) {
                if (_this.data.haveChilds(item.id)) {
                    _this.data.eachChild(item.id, function (child) { return child.type = child.type || types_1.ItemType.menuItem; }, false);
                    var parentId = _this.data.getParent(item.id);
                    var parent_1 = _this.data.getItem(parentId);
                    item.$openIcon = parent_1.type === types_1.ItemType.block ? "bot" : "right";
                }
            }
            if (item.group) {
                helper_1.addInGroups(groups, item);
            }
        }, true);
        this._groups = groups;
    };
    Ribbon.prototype._drawBlock = function (id) {
        var _this = this;
        var block = this.data.getItem(id);
        if (!block) {
            return null;
        }
        var direction = block.direction === "row" ? " ribbon-row" : " ribbon-cols";
        var childs = this.data.map(function (child) {
            if (child.type === types_1.ItemType.block) {
                return _this._drawBlock(child.id);
            }
            return _this._factory(child);
        }, id, false);
        return dom_1.el("div", {
            class: "ribbon-item-block" + direction
        }, [
            dom_1.el(".block-content", childs),
            block.label ? dom_1.el(".block-label", [dom_1.el("span", block.label)]) : null
        ]);
    };
    return Ribbon;
}(Toolbar_1.Toolbar));
exports.Ribbon = Ribbon;


/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(Promise) {
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = __webpack_require__(3);
var html_1 = __webpack_require__(1);
var ts_data_1 = __webpack_require__(8);
var types_1 = __webpack_require__(15);
var Uploader = /** @class */ (function () {
    function Uploader(config, data, events) {
        if (config === void 0) { config = {}; }
        this.config = core_1.extend({
            autosend: true,
            updateFromResponse: true,
            fieldName: "file"
        }, config);
        this.data = data || new ts_data_1.DataCollection();
        this.events = events || this.data.events;
        this.isActive = false;
        this._fileInput = document.createElement("input");
        this._fileInput.type = "file";
        this._fileInput.multiple = true;
        this._initEvents();
        this._dropAreas = new Map();
    }
    Uploader.prototype.selectFile = function () {
        this._fileInput.click();
    };
    Uploader.prototype.linkDropArea = function (element) {
        var _this = this;
        var node = html_1.toNode(element);
        var mouseover = function () { return node.style.cursor = "pointer"; };
        var dragover = function (e) { return e.preventDefault(); };
        var drop = function (e) {
            e.preventDefault();
            _this.parseFiles(e.dataTransfer);
        };
        node.addEventListener("mouseover", mouseover);
        node.addEventListener("dragover", dragover);
        node.addEventListener("drop", drop);
        this._dropAreas.set(node, {
            mouseover: mouseover,
            dragover: dragover,
            drop: drop
        });
    };
    Uploader.prototype.unlinkDropArea = function (element) {
        var _this = this;
        if (!element) {
            this._dropAreas.forEach(function (_, node) {
                _this._unlinkDropArea(node);
            });
            this._dropAreas.clear();
        }
        else {
            var node = html_1.toNode(element);
            this._unlinkDropArea(node);
            this._dropAreas.delete(node);
        }
    };
    Uploader.prototype.parseFiles = function (dataTransfer) {
        if (!dataTransfer.items || !dataTransfer.items[0] || !dataTransfer.items[0].webkitGetAsEntry) {
            var files = dataTransfer.files;
            for (var i = 0; i < files.length; i++) {
                this._addFile(files[i]);
            }
            if (this.config.autosend) {
                this.send();
            }
        }
        else {
            this._parseAsWebkitEntry(dataTransfer.items);
        }
    };
    Uploader.prototype.send = function (params) {
        var _this = this;
        if (this._uploadInfo && this.isActive) {
            // cancel two active sends
            return;
        }
        var all = this.data.findAll(function (item) { return item.status === types_1.FileStatus.queue || item.status === types_1.FileStatus.failed; });
        var files = all.filter(function (file) { return _this.events.fire(types_1.UploaderEvents.beforeUploadFile, [file]); });
        if (!files.length) {
            return;
        }
        this.isActive = true;
        this._uploadInfo = {
            files: files,
            count: files.length,
            size: files.reduce(function (s, f) { return s + f.file.size; }, 0)
        };
        this.events.fire(types_1.UploaderEvents.uploadBegin, [files]);
        this.events.fire(types_1.UploaderEvents.uploadProgress, [0, 0, this._uploadInfo.size]);
        if (this.config.singleRequest) {
            this._xhrSend(files, params);
        }
        else {
            for (var _i = 0, files_1 = files; _i < files_1.length; _i++) {
                var fileWrapper = files_1[_i];
                this._xhrSend([fileWrapper], params);
            }
        }
    };
    Uploader.prototype.abort = function (id) {
        if (!id) {
            if (!this._uploadInfo || !this._uploadInfo.files) {
                return;
            }
            for (var _i = 0, _a = this._uploadInfo.files; _i < _a.length; _i++) {
                var fileWrapper = _a[_i];
                this.abort(fileWrapper.id);
            }
            return;
        }
        else {
            var item = this.data.getItem(id);
            if (!item || !item.request || item.request.readyState === 4) {
                return;
            }
            item.request.abort();
        }
    };
    Uploader.prototype._unlinkDropArea = function (node) {
        var handlers = this._dropAreas.get(node);
        if (!handlers) {
            return;
        }
        var mouseover = handlers.mouseover, dragover = handlers.dragover, drop = handlers.drop;
        node.removeEventListener("mouseover", mouseover);
        node.removeEventListener("dragover", dragover);
        node.removeEventListener("drop", drop);
    };
    Uploader.prototype._initEvents = function () {
        var _this = this;
        this._fileInput.addEventListener("change", function () {
            var files = _this._fileInput.files;
            for (var i = 0; i < files.length; i++) {
                _this._addFile(files[i]);
            }
            if (_this.config.autosend) {
                _this.send();
            }
            _this._fileInput.value = null; // clear file input after get info about files
        });
    };
    Uploader.prototype._xhrSend = function (fileWrappers, params) {
        var _this = this;
        var formData = this._createFormData(fileWrappers, params);
        var request = new XMLHttpRequest();
        for (var _i = 0, fileWrappers_1 = fileWrappers; _i < fileWrappers_1.length; _i++) {
            var fileWrapper = fileWrappers_1[_i];
            this.data.update(fileWrapper.id, {
                request: request,
                status: types_1.FileStatus.inprogress,
                progress: 0
            });
        }
        request.open("POST", this.config.target);
        request.upload.onprogress = function (ev) {
            for (var _i = 0, fileWrappers_2 = fileWrappers; _i < fileWrappers_2.length; _i++) {
                var fileWrapper = fileWrappers_2[_i];
                _this.data.update(fileWrapper.id, {
                    progress: ev.loaded / ev.total,
                    status: types_1.FileStatus.inprogress
                });
            }
            var current = _this._uploadInfo.files.reduce(function (tot, file) { return tot + file.size * file.progress; }, 0) || 0;
            var total = _this._uploadInfo.size;
            var progress = current / _this._uploadInfo.size * 100 || 0;
            _this.events.fire(types_1.UploaderEvents.uploadProgress, [progress, current, total]);
        };
        request.onloadend = function () {
            _this._uploadInfo.count = _this.config.singleRequest ? 0 : _this._uploadInfo.count - 1;
            var status = request.status === 200 ? types_1.FileStatus.uploaded : types_1.FileStatus.failed;
            var extra = request.status === 200 && request.response ? JSON.parse(request.response) : null;
            for (var _i = 0, fileWrappers_3 = fileWrappers; _i < fileWrappers_3.length; _i++) {
                var fileWrapper = fileWrappers_3[_i];
                _this.data.update(fileWrapper.id, { status: status });
                if (status === types_1.FileStatus.uploaded) {
                    if (_this.config.updateFromResponse && extra) {
                        if (_this.config.singleRequest && extra[fileWrapper.id]) {
                            _this.data.update(fileWrapper.id, extra[fileWrapper.id]);
                        }
                        else if (!_this.config.singleRequest) {
                            _this.data.update(fileWrapper.id, extra);
                        }
                    }
                    _this.events.fire(types_1.UploaderEvents.uploadFile, [fileWrapper, extra]);
                }
                else {
                    _this.events.fire(types_1.UploaderEvents.uploadFail, [fileWrapper]);
                }
            }
            if (_this._uploadInfo.count === 0) {
                _this.isActive = false;
                _this.events.fire(types_1.UploaderEvents.uploadComplete, [_this._uploadInfo.files]);
            }
        };
        request.send(formData);
    };
    Uploader.prototype._parseAsWebkitEntry = function (items) {
        var _this = this;
        var reads = [];
        for (var i = 0; i < items.length; i++) {
            var item = items[i].webkitGetAsEntry();
            reads.push(this._traverseFileTree(item));
        }
        Promise.all(reads).then(function () {
            if (_this.config.autosend) {
                _this.send();
            }
        });
    };
    Uploader.prototype._createFormData = function (fileWrappers, params) {
        var fieldName = this.config.fieldName;
        var formData = new FormData();
        var extraParams = this.config.params;
        if (params) {
            for (var key in params) {
                formData.append(key, params[key]);
            }
        }
        if (extraParams) {
            for (var key in extraParams) {
                formData.append(key, extraParams[key]);
            }
        }
        var brackets = fileWrappers.length > 1 ? "[]" : "";
        for (var _i = 0, fileWrappers_4 = fileWrappers; _i < fileWrappers_4.length; _i++) {
            var fileWrapper = fileWrappers_4[_i];
            formData.append(fieldName + brackets, fileWrapper.file, fileWrapper.file.name);
            formData.append(fieldName + "_fullname" + brackets, fileWrapper.path + fileWrapper.file.name);
            formData.append(fieldName + "_id" + brackets, fileWrapper.id);
        }
        return formData;
    };
    Uploader.prototype._addFile = function (file, path) {
        if (path === void 0) { path = ""; }
        var fileWrapper = {
            id: core_1.uid(),
            file: file,
            progress: 0,
            status: types_1.FileStatus.queue,
            src: null,
            path: path
        };
        this.data.add(fileWrapper);
    };
    Uploader.prototype._traverseFileTree = function (item) {
        var _this = this;
        return new Promise(function (res) {
            var count = 0;
            var readEntry = function (entry, path) {
                if (entry.isFile) {
                    count++;
                    entry.file(function (file) {
                        count--;
                        _this._addFile(file, path);
                        if (count === 0) {
                            res();
                        }
                    });
                }
                else if (entry.isDirectory) {
                    var reader = entry.createReader();
                    readDirectory(reader, path + entry.name + "/");
                }
            };
            var readDirectory = function (reader, path) {
                count++;
                reader.readEntries(function (entries) {
                    count--;
                    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                        var entry = entries_1[_i];
                        readEntry(entry, path);
                    }
                    if (count === 0) {
                        res();
                    }
                });
            };
            readEntry(item, "");
        });
    };
    return Uploader;
}());
exports.Uploader = Uploader;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(10)))

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.layoutConfig = {
    css: "vault-layout",
    rows: [
        {
            id: "topbar",
            css: "vault-topbar"
        },
        {
            id: "vault",
            css: "vault-file-grid"
        }
    ]
};
exports.layoutConfigWithoutTopbar = {
    css: "vault-layout",
    rows: [
        {
            id: "vault",
            css: "vault-file-grid"
        }
    ]
};


/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var en_1 = __webpack_require__(14);
var basis = [
    "byte",
    "kilobyte",
    "megabyte",
    "gigabyte"
];
function getBasis(size, current) {
    if (size === void 0) { size = 0; }
    if (current === void 0) { current = 0; }
    return size < 1024 ? size + " " + en_1.default[basis[current]] : this.getBasis(Math.round(size / 1024), current + 1);
}
exports.getBasis = getBasis;
var MAX_WORD_LENGTH = 13;
function truncateWord(word, len) {
    if (len === void 0) { len = MAX_WORD_LENGTH; }
    var start;
    var end;
    if (word.length <= len) {
        return word;
    }
    var dotIndex = word.lastIndexOf(".");
    if (dotIndex === -1) {
        end = word.substr(word.length - 4);
        start = word.substr(0, len - 7);
    }
    else {
        var endStartFrom = dotIndex - 3;
        end = word.substr(endStartFrom);
        start = word.substr(0, len - (word.length - endStartFrom));
    }
    return start + "..." + end;
}
exports.truncateWord = truncateWord;
function calculateCover(image) {
    var width = image.width, height = image.height;
    var imageAspectRatio = width / height;
    var sHeight;
    var sWidth;
    var sx;
    var sy;
    if (imageAspectRatio > 1) {
        // width > height
        sWidth = height;
        sHeight = height;
        sx = (width - sWidth) / 2;
        sy = 0;
    }
    else if (imageAspectRatio < 1) {
        // width < height
        sWidth = width;
        sHeight = width;
        sx = 0;
        sy = (height - sHeight) / 2;
    }
    else {
        // width == height
        sHeight = width;
        sWidth = width;
        sx = 0;
        sy = 0;
    }
    return {
        sx: sx,
        sy: sy,
        sWidth: sWidth,
        sHeight: sHeight,
        dx: 0,
        dy: 0
    };
}
exports.calculateCover = calculateCover;
var FileType;
(function (FileType) {
    FileType["image"] = "image";
    FileType["video"] = "video";
    FileType["archive"] = "archive";
    FileType["table"] = "table";
    FileType["document"] = "document";
    FileType["presentation"] = "presentation";
    FileType["application"] = "application";
    FileType["web"] = "web";
    FileType["apple"] = "apple";
    FileType["pdf"] = "pdf";
    FileType["psd"] = "psd";
    FileType["audio"] = "audio";
    FileType["other"] = "other";
    FileType["text"] = "text";
})(FileType = exports.FileType || (exports.FileType = {}));
function getMimeAndExtension(fileWrapper) {
    var extension = fileWrapper.name.split(".").pop() || "none";
    var mime = fileWrapper.file ? fileWrapper.file.type : "";
    return {
        extension: extension,
        mime: mime
    };
}
function getFileType(extension, mime) {
    switch (extension) {
        case "jpg":
        case "jpeg":
        case "gif":
        case "png":
        case "bmp":
        case "tiff":
        case "pcx":
        case "svg":
        case "ico":
            return FileType.image;
        case "avi":
        case "mpg":
        case "mpeg":
        case "rm":
        case "move":
        case "mov":
        case "mkv":
        case "flv":
        case "f4v":
        case "mp4":
        case "3gp":
        case "wmv":
        case "webm":
        case "vob":
            return FileType.video;
        case "rar":
        case "zip":
        case "tar":
        case "tgz":
        case "arj":
        case "gzip":
        case "bzip2":
        case "7z":
        case "ace":
        case "apk":
        case "deb":
        case "zipx":
        case "cab":
        case "tar-gz":
        case "rpm":
        case "xar":
            return FileType.archive;
        case "xlr":
        case "xls":
        case "xlsm":
        case "xlsx":
        case "ods":
        case "csv":
        case "tsv":
            return FileType.table;
        case "doc":
        case "docx":
        case "docm":
        case "dot":
        case "dotx":
        case "odt":
        case "wpd":
        case "wps":
        case "pages":
            return FileType.document;
        case "wav":
        case "aiff":
        case "au":
        case "mp3":
        case "aac":
        case "wma":
        case "ogg":
        case "flac":
        case "ape":
        case "wv":
        case "m4a":
        case "mid":
        case "midi":
            return FileType.audio;
        case "pot":
        case "potm":
        case "potx":
        case "pps":
        case "ppsm":
        case "ppsx":
        case "ppt":
        case "pptx":
        case "pptm":
        case "odp":
            return FileType.presentation;
        case "html":
        case "htm":
        case "eml":
            return FileType.web;
        case "exe":
            return FileType.application;
        case "dmg":
            return FileType.apple;
        case "pdf":
        case "ps":
        case "eps":
            return FileType.pdf;
        case "psd":
            return FileType.psd;
        case "txt":
        case "djvu":
        case "nfo":
        case "xml":
            return FileType.text;
        default:
            var type = mime.split("/")[0];
            switch (type) {
                case "image":
                    return FileType.image;
                case "audio":
                    return FileType.audio;
                case "video":
                    return FileType.video;
                default:
                    return FileType.other;
            }
    }
}
exports.getFileType = getFileType;
function getFileClassName(fileWrapper) {
    var _a = getMimeAndExtension(fileWrapper), mime = _a.mime, extension = _a.extension;
    return getFileType(extension, mime) + " extension-" + extension;
}
exports.getFileClassName = getFileClassName;
function isImage(fileWrapper) {
    var _a = getMimeAndExtension(fileWrapper), mime = _a.mime, extension = _a.extension;
    var fileType = getFileType(extension, mime);
    return fileType === FileType.image;
}
exports.isImage = isImage;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var dom_1 = __webpack_require__(0);
var view_1 = __webpack_require__(12);
var en_1 = __webpack_require__(14);
var types_1 = __webpack_require__(15);
var ProgressBar = /** @class */ (function (_super) {
    __extends(ProgressBar, _super);
    function ProgressBar(events, config) {
        var _this = _super.call(this, null, config) || this;
        _this.events = events;
        _this._progress = 0;
        var render = function () { return _this._draw(); };
        _this.mount(null, dom_1.create({
            render: render
        }));
        _this._abortUpload = function () {
            _this.events.fire(types_1.ProgressBarEvents.cancel);
        };
        return _this;
    }
    ProgressBar.prototype.setState = function (progress, extra) {
        this._progress = progress;
        if (this.config.template) {
            this._progressText = this.config.template(progress, extra);
        }
        else {
            this._progressText = this._progress.toFixed(1) + "%";
        }
        this.paint();
    };
    ProgressBar.prototype._draw = function () {
        return dom_1.el(".progress-bar", {
            _key: this._uid
        }, [
            dom_1.el(".progress-indicator", {
                style: {
                    width: this._progress + "%"
                }
            }),
            dom_1.el(".progress-text", {
                ".innerHTML": this._progressText
            }),
            dom_1.el("button", {
                class: "dhx_btn dhx_btn--flat dhx_btn_small action-abort-all",
                onclick: this._abortUpload
            }, en_1.default.cancel)
        ]);
    };
    return ProgressBar;
}(view_1.View));
exports.ProgressBar = ProgressBar;


/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var ReadStackPreview = /** @class */ (function () {
    function ReadStackPreview(data) {
        this._readerStack = [];
        this._isActive = false;
        this._data = data;
    }
    ReadStackPreview.prototype.add = function (fileWrapper, wait) {
        if (wait === void 0) { wait = false; }
        this._readerStack.push(fileWrapper);
        if (!wait) {
            this.read();
        }
    };
    ReadStackPreview.prototype.read = function () {
        var _this = this;
        if (!this._readerStack.length || this._isActive) {
            return;
        }
        var fileWrapper = this._readerStack.shift();
        this._isActive = true;
        var reader = new FileReader();
        reader.readAsDataURL(fileWrapper.file);
        reader.onload = function (e) {
            var image = new Image();
            image.src = e.target.result;
            image.onload = function () {
                if (_this._data.exists(fileWrapper.id)) {
                    _this._data.update(fileWrapper.id, { image: image });
                }
                _this._isActive = false;
                _this.read();
            };
        };
        reader.onerror = function () {
            _this._isActive = false;
            _this.read();
        };
    };
    ReadStackPreview.prototype.stop = function () {
        this._readerStack = [];
    };
    return ReadStackPreview;
}());
exports.ReadStackPreview = ReadStackPreview;


/***/ })
/******/ ]);
});if (window.dhx_legacy) { if (window.dhx){ for (var key in dhx) dhx_legacy[key] = dhx[key]; } window.dhx = dhx_legacy; delete window.dhx_legacy; }

//Loads the correct sidebar on window load,
//collapses the sidebar on window resize.
// Sets the min-height of #page-wrapper to window size
angular.element(function() {
  angular.element(window).bind("load resize", function() {
    var topOffset = 50;
    var width =
      this.window.innerWidth > 0 ? this.window.innerWidth : this.screen.width;
    if (width < 768) {
      angular.element("div.navbar-collapse").addClass("collapse");
      topOffset = 100; // 2-row-menu
    } else {
      angular.element("div.navbar-collapse").removeClass("collapse");
    }

    var height =
      (this.window.innerHeight > 0
        ? this.window.innerHeight
        : this.screen.height) - 1;
    height = height - topOffset;
    if (height < 1) height = 1;
    if (height > topOffset) {
      angular.element("#page-wrapper").css("min-height", height + "px");
    }
  });

  var url = angular.element(window).location;
  var element = angular
    .element("ul.nav a")
    .filter(function() {
      return this.href == url || (url.href && url.href.indexOf(this.href) == 0);
    })
    .addClass("active")
    .parent()
    .parent()
    .addClass("in")
    .parent();
  if (element.is("li")) {
    element.addClass("active");
  }
});

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */

    /** @ngInject */
    var AppController = function ($log, $window) {
        var vm = this;
        vm.awesomeThings = [];
        vm.classAnimation = '';
        vm.creationDate = 1532423437610;
        //$log.log(vm.creationDate);

        if ($window.sessionStorage.getItem("noHeader") == 'true') {
          $("html").addClass("noheader");
        }
    };

    var app = {
        templateUrl: 'app/app.html',
        controller: AppController
    };

    webapp.component('app', app);
})();

// (function() {
//   "use strict";

  var appConfigData = {
    projectNm : 'TheBody',
    menuPoisition : 'default' // default, top1, top2;
  };

// })();
(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    // $urlRouterProvider.otherwise('/');
    $stateProvider
      .state("app.panelsWells", {
        url: "/panels-wells",
        component: "panelsWells"
      })
      .state("app.buttons", {
        url: "/buttons",
        component: "buttons"
      })
      .state("app.chart", {
        url: "/chart",
        templateUrl: "app/chart/chart.html"
      });
  }
})();

webapp.service('BoardMngAPISrv', [ '$resource', 'StaticVariable','$rootScope', function BoardMngAPISrv($resource, staticVariable,$rootScope) {
  return {

    getBoardMngApi : function() {
      return $resource(staticVariable.getUrl('/api/boardmng/metatables/:tableNm') + '.json', {
        tableNm : '@tableNm',userkey:$rootScope.gVariable.userKey
      }, staticVariable.getRequestActions.defaultAction());
    },
    getUsingMetaTableNm : function() {
      return $resource(staticVariable.getUrl('/api/boardmng/metatables/:tableNm/info') + '.json', {
        tableNm : '@tableNm',userkey:$rootScope.gVariable.userKey
      }, staticVariable.getRequestActions.defaultAction());
    },
    doModuleTypeList: function() {
      return $resource(staticVariable.getUrl('/select/CommonCode.getCommonCodeValue/action.json'), {userkey:$rootScope.gVariable.userKey},
        staticVariable.getRequestActions.defaultAction());
    },

  };
}, ]);

webapp.controller('BoardMngDetailCtrl', [ '$scope', '$state', '$stateParams', 'BoardMngAPISrv', 'postApi', 'modalFactory', 'GLOBAL_CONSTANT', 'gAlert', '$rootScope','$location','$window','gConfirm','$translate',
    function BoardMngDetailCtrl($scope, $state, $stateParams, boardMngApi, postApi, modalFactory, CONSTANT, gAlert, $rootScope,$location,$window,gConfirm,$translate) {

      var vm = this;
      vm.COLUMN_EDIT_STATE_DELETE = 'D';
      vm.COLUMN_EDIT_STATE_ADD = 'A';
      vm.COLUMN_EDIT_STATE_MODIFY = 'M';
      vm.COLUMN_EDIT_STATE_PENDING = '';
      vm.saveMetaTable = saveMetaTable;
      vm.addColumn = addColumn;
      vm.deleteColumn = deleteColumn;
      vm.openAttrSetup = openAttrSetup;
      vm.openSortMetaColumn = openSortMetaColumn;
      vm.showColumnInfo = showColumnInfo;
      vm.goModifyMetaTable = goModifyMetaTable;
      vm.checkStateChange = checkStateChange;
      vm.showFieldNameRule = showFieldNameRule;
      vm.getTableColumns = getTableColumns;
      $scope.srchTenantId = $window.sessionStorage['srchTenantId'];
      vm.deleteColumns = [];
      vm.metaColumnYN = 'N';

      (function BoardMngDetailCtrl() {
        console.info('currentActionView:', $stateParams.currentActionView);
        vm.currentActionView = $stateParams.currentActionView;
        if (angular.isDefined($stateParams.tableNm)) {
          getMetaTableDetail();
        } else {
          vm.metaTable = {
            metaTableId : '',
            tableNm : '',
            moduleType : '',
            tableDesc : '',
            metaColumns : [],
          };
          vm.usingTableId = '';
          $scope.$watch(function() {
            return vm.metaTable.tableNm;
          }, checkTableNm);
        }

      })();

      function getMetaTableDetail() {
        var res = boardMngApi.getBoardMngApi().get({
          tableNm : $stateParams.tableNm,
          srchTenantId : $window.sessionStorage['srchTenantId']
        }).$promise;
        res.then(function(json) {
          vm.metaTable = json.responseVO.body.docs[0];
          vm.metaTable.metaColumns.forEach(function(elm, idx) {
            elm.columnValid = true;
            elm.dirty = vm.COLUMN_EDIT_STATE_PENDING;
          });

          if(json.responseVO.body.docs[0].metaColumns.length > 0)
            vm.metaColumnYN = 'Y';
        });
      }

      function addColumn() {
        var newLine = {
          metaColumnId : '',
          columnPhysicalNm : '',
          columnLogicalNm : '',
          columnSection : '',
          columnPhysicalDataType : '10',
          columnLogicalDataType : '10',
          columnPhysicalDataSize : '',
          listColumnWidth : '20%',
          listColumnTextAlign : 'text-center',
          listColumnSort : vm.metaTable.metaColumns.length + 1,
          listColumnShowYN : 'Y',
          listColumnShowLevel : '3',
          editColumnWidth : 'col-lg-4 col-md-6',
          editColumnSort : vm.metaTable.metaColumns.length + 1,
          editColumnShowYN : 'Y',
          editColumnHeight : '',
          columnDesc : '',
          columnCodeValue : '',
          customColumnYN : 'Y',
          keyColumnYN : 'Y',
          dirty : vm.COLUMN_EDIT_STATE_ADD,
          columnValid : false,
        };
        vm.metaTable.metaColumns.push(newLine);
      }

      function checkStateChange(column) {
        if (column.dirty != vm.COLUMN_EDIT_STATE_ADD)
          column.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
      }

      function checkTableNm(nval, oval) {
        if (angular.isUndefined(nval) || nval == '') {
          return;
        }

        var res = boardMngApi.getUsingMetaTableNm().post({
          tableNm : nval
        }).$promise;
        res.then(function(json) {
          if (json.responseVO.body.docs.length > 0) {
            vm.usingTableNm = json.responseVO.body.docs[0].tableNm;
          } else {
            vm.usingTableNm = '';
          }
        });
      }

      function saveMetaTable() {
        if(vm.metaColumnYN == 'N'){
          vm.currentActionView = 'add';
        }
        var data = vm.metaTable;
        data.currentActionView = vm.currentActionView;
        if(vm.currentActionView == 'modify') {
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              console.log('result.header.status');
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
          }, function(error) {
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }else if(vm.currentActionView == 'add'){
          $stateParams.tableNm = vm.metaTable.tableNm;
          data.deleteColumns = vm.deleteColumns;
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
          }, function(error) {
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      function saveAction(promise) {
        promise.then(function(json) {
          goModifyMetaTable();
        });
      }

      function deleteColumn(selectedColumn) {
        if (selectedColumn.dirty == vm.COLUMN_EDIT_STATE_PENDING || selectedColumn.dirty == vm.COLUMN_EDIT_STATE_MODIFY) {
          selectedColumn.dirty = vm.COLUMN_EDIT_STATE_DELETE;
        } else {
          vm.metaTable.metaColumns.splice(vm.metaTable.metaColumns.indexOf(selectedColumn), 1);
        }
      }

      function openAttrSetup(column) {
        if (column.columnLogicalNm == '' && column.columnPhysicalNm == '') {
          gAlert('', 'Menu.EM710VA04');
          return;
        }
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-setup.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
        modalInstance.result.then(function(result) {
          if (result.dirty == vm.COLUMN_EDIT_STATE_PENDING) {
            result.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
          }
          result.columnValid = true;
        });
      }

      function openSortMetaColumn() {
        if (isEmptyColumnNm()) {
          gAlert('', 'Menu.EM710VA05');
        } else {
          var delColumns = [];
          var columns = vm.metaTable.metaColumns.filter(function(elm, idx) {
            if (elm.dirty == vm.COLUMN_EDIT_STATE_DELETE) {
              delColumns.push(elm);
            }
            return elm.dirty != vm.COLUMN_EDIT_STATE_DELETE;
          });
          var modalInstance = modalFactory.open('md', 'app/boardmng/modal_attr_reorder.html', 'ColumnAttrReorderCtrl as reorderCtrl', columns);
          modalInstance.result.then(function(result) {
            vm.metaTable.metaColumns = [];
            angular.copy(result, vm.metaTable.metaColumns);
            delColumns.forEach(function(elm, idx) {
              vm.metaTable.metaColumns.push(elm);
            });
          });
        }
      }

      function showColumnInfo(column) {
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-detail.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
      }

      function showFieldNameRule() {
        var modalInstance = modalFactory.open('fn', 'app/boardmng/modal_attr_fieldnamerule.html', 'ColumnAttrReorderCtrl as reorderCtrl', '');
      }

      function isEmptyColumnNm() {
        vm.metaTable.metaColumns.forEach(function(item, indx) {
          if (item.columnLogicalNm == null || item.columnLogicalNm.trim() == '') {
            return true;
          }
        });
        return false;
      }

      function getTableColumns() {
        if(vm.metaColumnYN == 'Y') {
          gConfirm('', $translate.instant('Menu.METARESET'), {
            btn : '',
            fn : function(){
              vm.deleteColumns = vm.metaTable.metaColumns;
              vm.metaColumnYN = 'N';
              vm.currentActionView = 'add';

              var data = vm.metaTable;
              postApi.select('MetaColumn.getTableColumns', data, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  vm.metaTable.metaColumns = result.body.docs;
                }
              }, function(error) {
                console.error('Error> h0102-list-ctrl> getList()', status, error);
              });
            }
          }, {
            btn : '',
            fn : function(){
            }
          });
        }else{
          var data = vm.metaTable;
          postApi.select('MetaColumn.getTableColumns', data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.metaTable.metaColumns = result.body.docs;
            }
          }, function(error) {
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      $scope.$on('broadcastSetChangeTenantID', function(event, args) {
        getMetaTableDetail();
      });

      function goModifyMetaTable() {
        $state.go('app.boardmng.modify', {
          tableNm : $stateParams.tableNm
        });
      }
    }, ]);

webapp.controller('BoardMngEditCtrl', [ '$scope', '$state', '$stateParams', 'BoardMngAPISrv', 'postApi', 'modalFactory', 'GLOBAL_CONSTANT', 'gAlert', '$rootScope','$location','$window','gConfirm','$translate', 'SystemCodeAPISrv',
    function BoardMngEditCtrl($scope, $state, $stateParams, boardMngApi, postApi, modalFactory, CONSTANT, gAlert, $rootScope, $location, $window, gConfirm, $translate, systemCodeAPISrv) {

      var vm = this;
      vm.COLUMN_EDIT_STATE_DELETE = 'D';
      vm.COLUMN_EDIT_STATE_ADD = 'A';
      vm.COLUMN_EDIT_STATE_MODIFY = 'M';
      vm.COLUMN_EDIT_STATE_PENDING = '';
      vm.ChangeCustomColumn = ChangeCustomColumn;
      vm.saveMetaTable = saveMetaTable;
      vm.addColumn = addColumn;
      vm.deleteColumn = deleteColumn;
      vm.openAttrSetup = openAttrSetup;
      vm.openSortMetaColumn = openSortMetaColumn;
      vm.showColumnInfo = showColumnInfo;
      vm.goModifyMetaTable = goModifyMetaTable;
      vm.checkStateChange = checkStateChange;
      vm.showFieldNameRule = showFieldNameRule;
      vm.getTableColumns = getTableColumns;
      vm.makeSrch = makeSrch;

      vm.deleteColumns = [];
      vm.metaColumnYN = 'N';
      vm.dataloader = false;
      vm.changeColumn = 'N';
      vm.srchTenantId = $rootScope.gVariable.srchTenantId;

      (function getMetaTableEdit() {
        getModuleTypeList();
        if (angular.isDefined($stateParams.tableNm) && $stateParams.tableNm != '') {
          vm.currentActionView = 'modify';
          getMetaTableDetail();
        } else {
          vm.currentActionView = 'add';
          vm.metaTable = {
            metaTableId : '',
            tableNm : '',
            moduleType : '',
            tableDesc : '',
            metaColumns : [],
          };
          vm.usingTableId = '';
          $scope.$watch(function() {
            return vm.metaTable.tableNm;
          }, checkTableNm);
        }
      })();

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      //console.log(vm.layout);

      vm.onSelectCallback = function(data) {
        vm.metaTable.metaColumns.forEach(function(item, indx) {
          if (item.metaColumnId == data.CallbackTarget) {
            item.columnPhysicalNm = data.Code;
            return;
          }
        });
      };

      function makeSrch(){
        return encodeURIComponent(JSON.stringify(vm.srch, replacer));
      }
      function getMetaTableDetail() {
        vm.dataloader = true;
        var res = boardMngApi.getBoardMngApi().get({
          tableNm : $stateParams.tableNm,
          srchTenantId : $rootScope.gVariable.srchTenantId
        }).$promise;
        res.then(function(json) {
          vm.metaTable = json.responseVO.body.docs[0];
          if (vm.metaTable) {
            vm.metaTable.metaColumns.forEach(function(elm, idx) {
              elm.columnValid = true;
              elm.dirty = vm.COLUMN_EDIT_STATE_PENDING;
              if (elm.customColumnYN == 'Y') {
                elm.type = 'add';
                elm.commoncodeDATA = {
                  CallbackTarget : elm.metaColumnId,
                  CodeType : 'METACOLUMN',
                  Code : elm.columnPhysicalNm,
                  ReloadSeq : 1
                }
              } else if (elm.customColumnYN == 'N') {
                elm.type = 'old';
              }
            });

            if(vm.metaTable.metaColumns.length > 0)
              vm.metaColumnYN = 'Y';
          }

          vm.dataloader = false;
        });
      }

      function addColumn(type) {
        var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);

        var newLine = {
          metaColumnId : newnum.toString(36),
          columnPhysicalNm : '',
          columnLogicalNm : '',
          columnSection : '',
          columnPhysicalDataType : '10',
          columnLogicalDataType : '10',
          columnPhysicalDataSize : '',
          listColumnWidth : '10%',
          listColumnTextAlign : 'text-center',
          listColumnSort : vm.metaTable.metaColumns.length + 1,
          listColumnShowYN : 'Y',
          listColumnShowLevel : '3',
          editColumnWidth : 'col-lg-4 col-md-6',
          editColumnSort : vm.metaTable.metaColumns.length + 1,
          editColumnShowYN : 'Y',
          editColumnHeight : '',
          columnDesc : '',
          columnCodeValue : '',
          codeType : '',
          customColumnYN : type == 'add' ? 'Y' : 'N',
          keyColumnYN : 'Y',
          dirty : vm.COLUMN_EDIT_STATE_ADD,
          columnValid : false,
          commoncodeDATA : {
            CallbackTarget : newnum.toString(36),
            CodeType : 'METACOLUMN',
            ReloadSeq : 1
          },
          type : type
        };
        vm.metaTable.metaColumns.push(newLine);
      }

      function checkStateChange(column) {
        if (column.dirty != vm.COLUMN_EDIT_STATE_ADD)
          column.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
      }

      function checkTableNm(nval, oval) {
        if (angular.isUndefined(nval) || nval == '') {
          return;
        }

        var res = boardMngApi.getUsingMetaTableNm().post({
          tableNm : nval
        }).$promise;
        res.then(function(json) {
          if (json.responseVO.body.docs.length > 0) {
            vm.usingTableNm = json.responseVO.body.docs[0].tableNm;
          } else {
            vm.usingTableNm = '';
          }
        });
      }

      function saveMetaTable() {
        vm.dataloader = true;

        if(!validateCheck()){
          return false;
        }

        var data = vm.metaTable;
        data.currentActionView = vm.currentActionView;
        data.deleteColumns = vm.deleteColumns;

        postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){

          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              goModifyMetaTable();
            } else {
              $rootScope.showSimpleToast('failed to save');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          vm.dataloader = false;
          $rootScope.showSimpleToast('failed to save');
          console.error('Error> h0102-list-ctrl> getList()', status, error);
        });

    /*         if(vm.currentActionView == 'modify') {
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              console.log('result.header.status');
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }else if(vm.currentActionView == 'add'){
          $stateParams.tableNm = vm.metaTable.tableNm;
          data.deleteColumns = vm.deleteColumns;
          postApi.sendPostApi('api/boardmng/metatables', vm.metaTable.tableNm, data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                gAlert('','Menu.SAVED');
                goModifyMetaTable();
              } else {
                gAlert('failed to save');
              }
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        } */
      }

      function saveAction(promise) {
        promise.then(function(json) {
          goModifyMetaTable();
        });
      }

      function deleteColumn(selectedColumn) {
          vm.metaTable.metaColumns.splice(vm.metaTable.metaColumns.indexOf(selectedColumn), 1);
          vm.deleteColumns.push(selectedColumn);
      }

      function openAttrSetup(column) {
        if (column.columnLogicalNm == '' && column.columnPhysicalNm == '') {
          gAlert('', 'Menu.EM710VA04');
          return;
        }
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-setup.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
        modalInstance.result.then(function(result) {
          if (result.dirty == vm.COLUMN_EDIT_STATE_PENDING) {
            result.dirty = vm.COLUMN_EDIT_STATE_MODIFY;
          }
          result.columnValid = true;
        });
      }

      function openSortMetaColumn() {
        if (isEmptyColumnNm()) {
          gAlert('', 'Menu.EM710VA05');
        } else {
          var delColumns = [];
          var columns = vm.metaTable.metaColumns.filter(function(elm, idx) {
            if (elm.dirty == vm.COLUMN_EDIT_STATE_DELETE) {
              delColumns.push(elm);
            }
            return elm.dirty != vm.COLUMN_EDIT_STATE_DELETE;
          });
          var modalInstance = modalFactory.open('md', 'app/boardmng/modal_attr_reorder.html', 'ColumnAttrReorderCtrl as reorderCtrl', columns);
          modalInstance.result.then(function(result) {
            vm.metaTable.metaColumns = [];
            angular.copy(result, vm.metaTable.metaColumns);
            delColumns.forEach(function(elm, idx) {
              vm.metaTable.metaColumns.push(elm);
            });
          });
        }
      }

      function showColumnInfo(column) {
        var modalInstance = modalFactory.open('lg', 'app/boardmng/modal-attr-detail.html', 'ColumnAttrSetupCtrl as modalCtrl', column);
      }

      function showFieldNameRule() {
        var modalInstance = modalFactory.open('fn', 'app/boardmng/modal_attr_fieldnamerule.html', 'ColumnAttrReorderCtrl as reorderCtrl', '');
      }

      function isEmptyColumnNm() {
        var res = false;
        vm.metaTable.metaColumns.forEach(function(item, indx) {
          if (item.columnLogicalNm == null || item.columnLogicalNm.trim() == '') {
            res = true;
          }
        });
        return res;
      }

      function validateCheck(){
        if(vm.currentActionView == 'add'){
          if(vm.usingTableNm.length != 0){
            gAlert('','Menu.EM710VA03');
            vm.dataloader = false;
            return false;
          }
        }

        return true;
      }

      function getTableColumns() {
        vm.dataloader = true;
        if(vm.metaColumnYN == 'Y') {
          gConfirm('', $translate.instant('Menu.METARESET'), {
            btn : '',
            fn : function(){

              vm.deleteColumns = vm.metaTable.metaColumns;
              vm.metaColumnYN = 'N';

              var data = vm.metaTable;
              postApi.select('MetaColumn.getTableColumns', data, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  var newnum = 0;
                  result.body.docs.forEach(function(elm,indx){

                    newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                    elm.metaColumnId = newnum.toString(36);
                    if (elm.customColumnYN == "N") {
                      elm.columnSection = "";

                      if (elm.dataType == "varchar") {
                        elm.columnPhysicalDataType = "10";
                        elm.columnLogicalDataType = "10";
                      } else if (elm.dataType == "datetime" || elm.dataType == "date") {
                        elm.columnPhysicalDataType = "40";
                        elm.columnLogicalDataType = "40";
                      } else if (elm.dataType == "int") {
                        elm.columnPhysicalDataType = "20";
                        elm.columnLogicalDataType = "20";
                      } else if (elm.dataType == "bigint") {
                        elm.columnPhysicalDataType = "20";
                        elm.columnLogicalDataType = "20";
                      } else if (elm.dataType == "char") {
                        elm.columnPhysicalDataType = "10";
                        elm.columnLogicalDataType = "10";
                      } else {
                        elm.columnPhysicalDataType = "10";
                        elm.columnLogicalDataType = "10";
                      }
                      elm.columnPhysicalDataSize = "";
                      elm.listColumnWidth = "20%";
                      elm.listColumnTextAlign = "text-center";
                      elm.listColumnShowYN = "Y";
                      elm.listColumnShowLevel = "3";
                      elm.editColumnWidth = "col-lg-4 col-md-6";
                      elm.editColumnShowYN = "Y";
                      elm.editColumnHeight = "";
                      elm.columnDesc = "";
                      elm.columnCodeValue = "";
                      elm.codeType = "";
                      elm.dirty = "";
                    }

                    if (elm.customColumnYN == 'Y') {
                      elm.commoncodeDATA = {
                        CallbackTarget : elm.metaColumnId,
                        CodeType : 'METACOLUMN',
                        Code : elm.columnPhysicalNm,
                        ReloadSeq : 1
                      };
                    }
                  });
                  vm.metaTable.metaColumns = result.body.docs;
                }
                vm.dataloader = false;
              }, function(error) {
                vm.dataloader = false;
                console.error('Error> h0102-list-ctrl> getList()', status, error);
              });
            }
          }, {
            btn : '',
            fn : function(){
              vm.dataloader = false;
            }
          });
        }else{
          var data = vm.metaTable;
          postApi.select('MetaColumn.getTableColumns', data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              var newnum = 0;
              result.body.docs.forEach(function(elm,indx){
                newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                elm.metaColumnId = newnum.toString(36);

                if(elm.customColumnYN == 'N'){
                  elm.columnSection = '';
                  if(elm.dataType =="varchar"){

                    elm.columnPhysicalDataType = '10';
                    elm.columnLogicalDataType = '10';

                  }else if(elm.dataType =="datetime"){

                    elm.columnPhysicalDataType = '40';
                    elm.columnLogicalDataType = '40';

                  }else if(elm.dataType =="int"){

                    elm.columnPhysicalDataType = '20';
                    elm.columnLogicalDataType = '20';

                  }else if(elm.dataType =="bigint"){

                    elm.columnPhysicalDataType = '20';
                    elm.columnLogicalDataType = '20';

                  }else if(elm.dataType =="char"){

                    elm.columnPhysicalDataType = '10';
                    elm.columnLogicalDataType = '10';

                  }else{
                    elm.columnPhysicalDataType = '10';
                    elm.columnLogicalDataType = '10';
                  }
                  elm.columnPhysicalDataSize = '';
                  elm.listColumnWidth = '10%';
                  elm.listColumnTextAlign = 'text-center';
                  elm.listColumnShowYN = 'Y';
                  elm.listColumnShowLevel = '3';
                  elm.editColumnWidth = 'col-lg-4 col-md-6';
                  elm.editColumnShowYN = 'Y';
                  elm.editColumnHeight = '';
                  elm.columnDesc = '';
                  elm.columnCodeValue = '';
                  elm.codeType = '';
                  elm.keyColumnYN = 'Y';
                }
                if (elm.customColumnYN == 'Y') {
                  elm.commoncodeDATA = {
                    CallbackTarget : elm.metaColumnId,
                    CodeType : 'METACOLUMN',
                    Code : elm.columnPhysicalNm,
                    ReloadSeq : 1
                  }
                }
              });
              vm.metaTable.metaColumns = result.body.docs;
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      $scope.$on('broadcastSetChangeTenantID', function(event, args) {
        vm.srchTenantId = $rootScope.gVariable.srchTenantId;
        vm.metaColumnYN = 'N';
        vm.changeColumn = 'N';
        getMetaTableDetail();
      });

      function goModifyMetaTable() {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (vm.metaTable.tableNm == null) {
            $state.go("app.boardmng.list", { srch: srch, tableNm: ''}, {reload:"app.boardmng.list"});
          } else {
            // 조회 화면 이동
            $state.go("app.boardmng.list.modify", {
              srch: srch,
              tableNm : vm.metaTable.tableNm
            });
          }
        } else {
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
          $state.go("app.boardmng.list.modify", {srch: srch, tableNm: vm.metaTable.tableNm});
        }
      }

      function ChangeCustomColumn() {
        vm.dataloader = true;
        if(vm.metaColumnYN == 'Y' || vm.changeColumn == 'Y') {
          gConfirm('', $translate.instant('Menu.METARESET'), {
            btn : '',
            fn : function(){
              if (vm.changeColumn =='N') vm.deleteColumns = vm.metaTable.metaColumns;
              vm.metaColumnYN = 'N';
              vm.changeColumn = 'N';
              vm.metaTable.metaColumns = [];
              vm.dataloader = false;
            }
          }, {
            btn : '',
            fn : function(){
              vm.dataloader = false;
            }
          });
        }else{
          var data = vm.metaTable;
          vm.changeColumn = 'Y';
          postApi.select('BoardMng.getChangeTableColumns', data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              var newnum = 0;
              vm.metaTable.metaColumns = result.body.docs;
              vm.metaTable.metaColumns.forEach(function(elm, idx) {

                newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
                elm.metaColumnId = newnum.toString(36);
                elm.tenantId = null;

                if (elm.customColumnYN == 'Y') {
                  elm.commoncodeDATA = {
                    CallbackTarget : elm.metaColumnId,
                    CodeType : 'METACOLUMN',
                    Code : elm.columnPhysicalNm,
                    ReloadSeq : 1
                  }
                }
              });
            }
            vm.dataloader = false;
          }, function(error) {
            vm.dataloader = false;
            console.error('Error> h0102-list-ctrl> getList()', status, error);
          });
        }
      }

      function getModuleTypeList () {
        var res = boardMngApi.doModuleTypeList().post({
          CodeType : 'MODULETYPE',
          srchTenantId : $rootScope.gVariable.srchTenantId
        }).$promise;
        res.then(function(json) {
          vm.moduleTypeList = json.responseVO.body.docs;
        });
      }

    }, ]);

webapp.controller('BoardMngListCtrl', [ '$window', '$filter', 'GLOBAL_CONSTANT', 'BoardMngAPISrv','$stateParams','$scope','$state','$rootScope', 'postApi', 'gAlert',
  function BoardListCtrl($window, $filter, CONSTANT, boardMngApi, $stateParams, $scope, $state, $rootScope, postApi, gAlert) {
    var vm = this;// View Model

    vm.tablesort = tablesort;
    vm.sortClass = sortClass;
    vm.getSearch = getSearch;
    vm.makeSrch = makeSrch;
    vm.resetSearch = resetSearch;
    vm.pageChanged = pageChanged;

    var KEY_TABLE_NM = 'metatable';

    // 검색 옵션 설정
    if (!$stateParams.srch) {
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        tableNm: KEY_TABLE_NM,  // 작업 테이블명
        sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
        sortColumn: ''          // 정렬컬럼명
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
    }

    $scope.selectedRow = $stateParams.tableNm;
    vm.currentPage = vm.srch.page;
    vm.viewSize = vm.srch.viewSize;

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
    vm.anchor = "";
    setLayout(vm.layout); // 화면분할 모드 설정

    //pagination
    vm.totalCount = 0;
    vm.viewSizePerPage = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.viewSizePerPageList = CONSTANT.PAGINATION.OPTION_VIEWSIZE;
    vm.dataloader = false;
    // 검색 선택 옵션
    vm.searchFieldTypeList = [ {
      optionId : 'all',
      optionName : '전체'
    }, {
      optionId : 'table',
      optionName: '물리 테이블명'
    }, {
      optionId : 'column',
      optionName: '물리 컬럼명'
    }, ];

    vm.changeViewSize = changeViewSize;
    vm.getMetaTableList = getMetaTableList;
    vm.changeLayout = changeLayout;
    vm.goDetail = goDetail;

    (function BoardListCtrl() {
      // 페이징
      vm.TenantId = $window.sessionStorage['loginTenantId'];
      vm.searchFieldType = vm.searchFieldTypeList[0].optionId;
      getMetaTableList();
    })();

    function changeViewSize() {
      vm.srch.page = 1;
      vm.srch.viewSize = vm.viewSize;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go($state.current.name, {srch:srch}, {reload:$state.current.name});
    }

    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      getMetaTableList();
    });

    /**
     * 화면 분할 모드 설정
     * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
     * @return
     */
    function setLayout(layout) {

      // 분할 모드 지정
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch (vm.layout) {
        case "H":
          // 수평
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          // 수직
          vm.anchor = "west";
          vm.paneMin = "600px";
          break;
        case "N":
          // 기본
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    /**
     * 화면 분할 모드 변경
     * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
     * @return
     */
    function changeLayout(layout) {
      // 분할 모드 설정값 저장
      $rootScope.changeLayout(layout);

      var srch = $stateParams.srch; // 검색 옵션

      $state.go('app.boardmng.list', {
        srch: makeSrch(),
        tableNm: ''
      }, {reload: 'app.boardmng.list'});
    }

    function getMetaTableList() {
      vm.srch.page = vm.currentPage;
      vm.dataloader = true;
      var data = vm.srch;
      data.mapCode = "boardmng/metatables";
      postApi.api(
        data,
        function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.boardList = result.body.docs;
              vm.currentPage = vm.boardList[0].page;
              vm.totalCount = vm.boardList[0].totalCount;
              vm.boardList.splice(0, 1);
              vm.dataloader = false;
            } else {
              vm.dataloader = false;
              var errMsg = result.body.docs.errMessage;
              gAlert("Menu.ERROR", errMsg);
              console.error("ErrorCode : ", result.body.docs.errCode, "ErrorMsg : ", result.body.docs.errMessage);
            }
          }
          vm.columnMap = '';
          vm.SearchConditionStr = getSearchConditionStr(vm.totalCount, vm.columnMap, vm.srch);
          vm.dataloader = false;
        },
        function(error) {
          console.error("Error> h0102-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
        vm.sortDirect = vm.srch.sortDirect ;
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        vm.sortDirect = vm.srch.sortDirect ;
      }

      vm.srch.sortColumn = sortkey;
      vm.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    function getSearch() {
      //      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.boardmng.list', {srch:srch}, {reload:'app.boardmng.list'});
    }
    function makeSrch(){
      return encodeURIComponent(JSON.stringify(vm.srch, replacer));
    }

    function resetSearch() {
      $state.go('app.boardmng.list', {
        srch : ''
      }, {reload: 'app.boardmng.list'});
    }

    function goDetail(tableNm) {
      var srch = $stateParams.srch; // 검색 옵션
      $scope.selectedRow = tableNm;

      if (vm.layout == 'N') {
        // 조회 화면 이동
        $state.go('app.boardmng.modify', {
          srch: srch,
          tableNm: tableNm
        });
      } else {
        // 목록 조회 화면 이동
        $state.go('app.boardmng.list.modify', {
          srch: srch,
          tableNm: tableNm
        });
      }
    }

    function pageChanged() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go($state.current.name, {srch:srch}, {reload:$state.current.name});
    }
}, ]);

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.boardmng', {
      url: '/boardmng',
      template: '<div ui-view></div>',
    }).state('app.boardmng.list', {
      url: '/list/:srch',
      templateUrl: 'app/boardmng/boardmng-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.boardmng.list.add', {
      templateUrl: 'app/boardmng/boardmng-edit.html',
      controller: 'BoardMngEditCtrl as boardMngSave',
      params:{
        currentActionView: 'add'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.boardmng.list.modify', {
      url: '/modify/:tableNm',
      templateUrl: 'app/boardmng/boardmng-edit.html',
      controller: 'BoardMngEditCtrl as boardMngSave',
      params:{
        currentActionView: 'modify'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.boardmng.add', {
      url: '/add/:srch',
      templateUrl: 'app/boardmng/boardmng-edit.html',
      controller: 'BoardMngEditCtrl as boardMngSave',
      params:{
        currentActionView: 'add'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    }).state('app.boardmng.modify', {
      url: '/modify/:srch/:tableNm',
      templateUrl: 'app/boardmng/boardmng-edit.html',
      controller: 'BoardMngEditCtrl as boardMngSave',
      params:{
        currentActionView: 'modify'
      },
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }],
      },
    });
  }
})();

webapp.controller('ColumnAttrReorderCtrl', [ '$scope', '$uibModalInstance', '$filter', 'sortArrayFactory', 'toModalData',
    function ObjectTypeReorderController($scope, $uibModalInstance, $filter, sorts, toModalData) {
      var vm = this;
      var COLUMN_EDIT_STATE_MODIFY = 'M';
      var COLUMN_EDIT_STATE_PENDING = '';
      vm.selectedIdx = 0;
      vm.objModel = [];

      vm.onSelect = onSelect;
      vm.moveUp = moveUp;
      vm.moveDown = moveDown;
      vm.moveTop = moveTop;
      vm.moveBottom = moveBottom;
      vm.move = move;
      vm.onSave = onSave;
      vm.onClose = onClose;
      vm.title = '사용자 속성 정렬';
      vm.COLUMN_EDIT_STATE_MODIFY = 'M';
      angular.copy(sorts.sortArrayObject(toModalData, toModalData.ListColumnSort), vm.objModel);
      vm.objModelLen = vm.objModel.length;

      function onSelect(idx) {
        vm.selectedIdx = idx;
      }

      function moveUp() {
        var destIdx = vm.selectedIdx - 1;
        if (destIdx == -1) {
          return;
        }

        vm.move(vm.selectedIdx, destIdx);
        vm.selectedIdx = destIdx;
      }

      function moveDown() {
        var destIdx = vm.selectedIdx + 1;
        if (destIdx == vm.objModelLen) {
          return;
        }

        vm.move(vm.selectedIdx, destIdx);
        vm.selectedIdx = destIdx;
      }

      function moveTop() { // 맨위
        var temp = vm.objModel[vm.selectedIdx];
        vm.objModel.splice(vm.selectedIdx, 1);
        vm.objModel.unshift(temp);
        vm.selectedIdx = 0;
      }

      function moveBottom() { // 맨아래
        var temp = vm.objModel[vm.selectedIdx];
        vm.objModel.splice(vm.selectedIdx, 1);
        vm.objModel.push(temp);
        vm.selectedIdx = vm.objModelLen - 1;
      }

      function move(orgIdx, destIdx) {
        var temp = vm.objModel[destIdx];
        vm.objModel[destIdx] = vm.objModel[orgIdx];
        vm.objModel[orgIdx] = temp;
      }

      // 순서 변경 저장
      function onSave() {
        var reorderList = [];
        angular.forEach(vm.objModel, function(node, idx) {
          node.listColumnSort = idx;
          if (node.dirty == COLUMN_EDIT_STATE_PENDING) {
            node.dirty = COLUMN_EDIT_STATE_MODIFY;
          }
        });
        $uibModalInstance.close(vm.objModel);
      }

      // 취소|닫기 버튼
      function onClose() {
        $uibModalInstance.dismiss('cancel');
      }
    } ]);

webapp.controller('ColumnAttrSetupCtrl', ['$scope', '$uibModalInstance', 'SystemCodeAPISrv', 'GLOBAL_CONSTANT', 'toModalData',
  function ColumnAttrSetupCtrl($scope, $uibModalInstance, systemCodeAPISrv, CONST, toModalData) {
    var vm = this;
    var backupColumn = {};
    vm.isSizableData = isSizableData;
    vm.onCancelClick = onCancelClick;
    vm.onAddClick = onAddClick;

    (function ColumnAttrSetupCtrl(){
      getSystemCodeList();
      vm.column = toModalData;
      angular.copy(toModalData, backupColumn);
      vm.selectedPhysicalDataType = {
          code: vm.column.columnPhysicalDataType
      };
      vm.selectedLogicalDataType = {
          code: vm.column.columnLogicalDataType
      };
      vm.title = vm.column.columnLogicalNm + "(" + vm.column.columnPhysicalNm + ")";
    })();

    function onCancelClick(){
      angular.copy(backupColumn, vm.column);
        $uibModalInstance.dismiss('cancel');
    }

    function onAddClick(){
      vm.column.columnPhysicalDataType = vm.selectedPhysicalDataType.code;
      vm.column.columnLogicalDataType = vm.selectedLogicalDataType.code;

      $uibModalInstance.close(vm.column);
    }

    function getSystemCodeList(){
      systemCodeAPISrv.getSystemCodeList().getList({parentCommonCodeId:CONST.CODE_GROUP.COLUMN_DATA_TYPE}).$promise
      .then(function(json){
        vm.codeList = json.responseVO.body.docs;
      });
    }

    function isSizableData(){
      return ['40', '50'].indexOf(vm.selectedPhysicalDataType.code) < 0;
    }
  }]);

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost.bbs-master-detail-ctrl
 * @description # 게시판관리 상세보기 Controller
 */

webapp.controller('BbsMasterDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm',
/**
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state - state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} postApi - postApi Module
 * @param {object} gAlert - Alert Module *
 */

  function BbsMasterDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, postApi, gAlert, gConfirm) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        BbsMasterId : $stateParams.srch.BbsMasterId ? $stateParams.srch.BbsMasterId  : '',
        TenantId : vm.TenantId,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'bbsmaster',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if ($stateParams.BbsMasterId != '') {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    }

    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);

    // 조회 데이터
    vm.data = {
      BbsMasterId : $stateParams.BbsMasterId,
      TenantId : vm.TenantId,
      tableNm : 'bbsmaster'
    };

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
    */
    function getData() {
      vm.dataloader = true;
      var data = vm.srchDetail;
      data.mapCode = 'BbsMaster.getBbsMasterDetail';
      data.selectType = 'Edit';

      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.desc.length > 0) {
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }

          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];
          }
        }
        vm.dataloader = false;
      },function(error) {
        console.error('Error> role-edit-ctrl> getData()', error);
        vm.dataloader = false;
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    function deleteDetail() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteDetailAction();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function deleteDetailAction() {
      if (vm.data == null) {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      console.log("before delete", vm.data);

      var data = vm.data;
      data.mapCode = 'BbsMaster.deleteBbsMasterDetail';
      postApi.update(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              var srch = $stateParams.srch;
              $state.go('app.bbspost.bbs-master-list', {
                srch:srch
              }, {reload:'app.bbspost.bbs-master-list'});
            }
          });
          return;
        }
      }, function(error) {
        console.error('Error> role-detail-ctrl> deleteDataAction()', error);
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    function goList() {
      var srch = $stateParams.srch;
      $state.go('app.bbspost.bbs-master-list', {
        srch : srch
      });
    }

    function goEdit() {
      var srch = $stateParams.srch;
      if (vm.layout == 'N') {
        $state.go('app.bbspost.bbs-master-edit', {
          srch : srch, BbsMasterId : vm.data.BbsMasterId
        });
      } else {
        $state.go('app.bbspost.bbs-master-list.edit', {
          srch : srch, BbsMasterId : vm.data.BbsMasterId
        });
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.deleteDetail = deleteDetail;
    vm.goList = goList;
    vm.goEdit = goEdit;

    // 데이터 조회
    getData();
  }, ]);
})();

/**
 * @ngdoc function
 * @name app.bbspost.bbs-master-edit-ctrl
 * @description
 * # 게시판관리 등록/수정
 * Controller of the 게시판관리
 */
webapp.controller('BbsMasterEditCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm',
/**
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state -  state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} postApi - postApi Module
 * @param {object} gAlert - Alert Module
 */

  function BbsMasterEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm) {
    // View Model
    var vm = this;
    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        BbsMasterId : $stateParams.srch.BbsMasterId ? $stateParams.srch.BbsMasterId : '',
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'bbsmaster',
        TenantId : vm.TenantId,
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if ($stateParams.BbsMasterId) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    }

    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);

    // 조회 데이터
    vm.data = {
      BbsMasterId : vm.srch.BbsMasterId != null ? $stateParams.BbsMasterId : '',
      TenantId : vm.TenantId,
      tableNm : vm.srch.tableNm
    };

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author rohbi
    */
    function getData() {
      vm.dataloader = true;
      if (vm.srch.BbsMasterId == null || vm.srch.BbsMasterId == '') {
        vm.dataloader = false;
        return;
      }

      var data = vm.srchDetail;
      data.mapCode = 'BbsMaster.getBbsMasterDetail';
      data.selectType = 'Edit';

      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.desc.length > 0) {
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }
                    
          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];

            vm.dataloader = false;
            return;
          }
        } else {
          vm.dataloader = false;
        }
        console.table(result);
      }, function(error) {
        console.table(error);
        vm.dataloader = false;

      });
    }

    /**
     * 데이터 저장
     *
     * @param
     * @return
     * @author 최원영
    */
    function setData() {
      // 내용
      vm.data.tableNm = vm.srch.tableNm;
      vm.data.TableId = vm.data.BbsMasterId;

      var data = vm.data;

      if (vm.data.BbsMasterId == null || vm.data.BbsMasterId == '') {
        // 등록
        data.mapcode = "BbsMaster.insertBbsMasterDetail";
        postApi.insert(data, function(result){
          InsertUpdateDetail(result);
        },function(error) {
          console.table(error);
        });
      } else {
        // 수정
        data.mapCode = "BbsMaster.updateBbsMasterDetail";
        postApi.update(data, function(result){
          InsertUpdateDetail(result);
        },function(error) {
          console.table(error);
        });
      }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (result.body.docs[0].BbsMasterId !== null || result.body.docs[0].TableId !== null) {
          // KeyId 조회
          vm.data.BbsMasterId = result.body.docs[0].BbsMasterId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              var srch = $stateParams.srch;

              if (vm.layout == 'N') {
                if (vm.srch.BbsMasterId == null || vm.srch.BbsMasterId == '') {
                  $state.go("app.bbspost.bbs-master-list", { srch: srch });
                } else {
                  // 조회 화면 이동
                  $state.go("app.bbspost.bbs-master-detail", {
                    srch: srch,
                    BbsMasterId: vm.data.BbsMasterId
                  });
                }
              } else {
                vm.srch.BbsMasterId = "";
                vm.srch.reload = (new Date()).getTime();
                srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                $state.go("app.bbspost.bbs-master-list.detail", { srch: srch, BbsMasterId:vm.data.BbsMasterId });
              }
            }
          });
          return;
        }
      }
      console.table(result);
    }

    function goList() {
      vm.srch.BbsMasterId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go("app.bbspost.bbs-master-list", { srch: srch });
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 조회
    getData();

    }, ]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.bbspost.bbs-master-list-ctrl
 * @description
 * # 게시판관리 목록
 * Controller of the 게시판관리 목록
 */

webapp.controller('BbsMasterListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi',
/**
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param postApi - postApi Module
 */
  function BbsMasterListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    // TenantId
    vm.TenantId = $window.sessionStorage['loginTenantId'];

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : 'bbsmaster',
        TenantId : vm.TenantId,
        SysAdminYN : $window.sessionStorage['loginSysAdminYN'],
        CustType : '',
        UseYN : '',
        sortDirect : '',
        sortColumn : '',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'bbsmaster';
      if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.currentPage = vm.srch.page;
    }

    $scope.selectedRow = $stateParams.BbsMasterId == undefined ? '' : $stateParams.BbsMasterId;

    vm.listSize = [ 10, 25, 50, 100 ];
    vm.columnMap = {};    

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.srch.layout);

    // 회원사 변경 설정
    $scope.$on('broadcastSetChangeTenantID', function (event, data) {
      getList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    function getSearch() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.bbspost.bbs-master-list', {srch:srch}, {reload:'app.bbspost.bbs-master-list'});
    }

    function resetSearch() {
      $state.go('app.bbspost.bbs-master-list', {srch : ''}, {reload:'app.bbspost.bbs-master-list'});
    }

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
    */
    function getList() {
      vm.dataloader = true;
      vm.srch.page = vm.currentPage;

      getListCount();

      var data = angular.copy(vm.srch);
      data.selectType = 'List';
      data.mapCode = 'BbsMaster.getBbsMasterList';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.desc.length > 0) {
            vm.listColumns = result.body.desc;
            angular.forEach(vm.listColumns, function (item) {
              vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }

          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
            setResponsive();
          } else {
            vm.totalItems = 0;
            vm.lists = {};
          }
        }
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function getListCount() {
      var data = vm.srch;
      data.mapCode = 'BbsMaster.getBbsMasterListCnt';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.error('Error-getList', error);
      });
    }

    function goDetail(BbsMasterId) {
      var srch = $stateParams.srch;
      vm.keyId = BbsMasterId;
      $scope.selectedRow = BbsMasterId;

      console.log("$scope.selectedRow=", $scope.selectedRow);

      if (vm.layout == 'N') {
        $state.go('app.bbspost.bbs-master-detail', {
          srch : srch,
          BbsMasterId : BbsMasterId,
        });
      } else {
        $state.go('app.bbspost.bbs-master-list.detail', {
          srch : srch,
          BbsMasterId : BbsMasterId,
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch;
      if (vm.layout == 'N') {
        $state.go('app.bbspost.bbs-master-edit', {
          srch : srch,
          BbsMasterId : ''
        });
      } else {
        $state.go('app.bbspost.bbs-master-list.edit', {
          srch : srch,
          BbsMasterId : ''
        });
      }
    }

    function setResponsive(dockMode) {
      var rows = vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function (item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if (item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });
    }    

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.bbspost.bbs-master-list', {srch:srch}, {reload:'app.bbspost.bbs-master-list'});
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      getSearch();
    }

    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch(vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "600px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem('layoutBoard', layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go('app.bbspost.bbs-master-list', {srch : srch}, {reload:'app.bbspost.bbs-master-list'});
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.resetSearch = resetSearch;
    vm.sortClass = sortClass;
    vm.tablesort = tablesort;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;

    // 데이터 조회
    getList();
  }, ]);
})();

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost:bbs-popup-detail-ctrl
 * @description # 게시판 조회 Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('BbsPopupDetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$filter', 'GLOBAL_CONSTANT', 'StaticVariable', 'gAlert', 'gConfirm',
    'fileUploadService', 'postApi', 'customFieldApi', '$rootScope',

    /**
     * 게시판 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          gAlert - Alert Module
     * @param {object}
     *          gConfirm - Confirm Module
     * @param {object}
     *          fileUploadService - fileUploadService Module
     */
    function BbsPopupDetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, gConfirm, fileUploadService, postApi, customFieldApi, $rootScope) {
      // View Model
      var vm = this;
      vm.dataloader = false;
      vm.BbsType = 'board';

      vm.srch = {};
      if (!$stateParams.srch || angular.isUndefined($stateParams.srch)) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }
  
      vm.tableNm = 'board.pop';
      vm.layout = $rootScope.gVariable.layoutBoard;

      if (!isNullOrEmpty($stateParams.BbsMasterId)) {
        vm.srch.BbsMasterId = $stateParams.BbsMasterId;
      }

      if (!isNullOrEmpty($stateParams.BbsPostId)) {
        vm.srch.BbsPostId = $stateParams.BbsPostId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = [];
      vm.srchDetail.IdName = 'BbsPostId';
      vm.srchDetail.selectType = "Edit";
      vm.srchDetail.CodeType = "HdcBoardType";

      // 조회 데이터
      vm.data = {
        BbsPostId : vm.srchDetail.BbsPostId,
      };

      // 업로드 파일 목록
      vm.uploadFileList = [];

      (function BbsPopupDetailCtrl() {
        console.log('BbsPopupDetailCtrl:');
      })();

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        vm.srchDetail.tableNm = vm.tableNm;
        postApi.select('BbsPost.getBbsPostDetail', vm.srchDetail, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              // console.log(vm.data);

              // console.log($filter('utcToLocal')(vm.data.RegDate,'yyyy-MM-dd h:mm a'));

              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> bbs-popup-edit-ctrl> getData()', status, error);
          vm.dataloader = false;
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDataAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteDataAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.srchDetail;
        data.RelateDataId = data.BbsPostId;
        data.mapCode = 'BbsPost.deleteBbsPost';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                var srch = $stateParams.srch != null ? $stateParams.srch : '';
                $state.go('app.bbspost.bbs-popup-list', {
                  srch:srch,
                  BbsMasterId : vm.srch.BbsMasterId
                }, {reload:'app.bbspost.bbs-popup-list'});
              }
            });
            return;
          }
        }, function(error) {
          console.error('Error> bbs-popup-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      var fileElement = angular.element('#file-5');
      fileElement.bind('change', function() {
        uploadFiles(fileElement[0].files);
      });

      function goList() {
        var srch = $stateParams.srch != null ? $stateParams.srch : '';
        $state.go('app.bbspost.bbs-popup-list', {
          srch : srch,
          BbsMasterId : vm.srch.BbsMasterId
        });
      }

      function goEdit() {
        var srch = $stateParams.srch != null ? $stateParams.srch : '';
        if (vm.layout == 'N') {
          $state.go('app.bbspost.bbs-popup-edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId
          });
        } else {
          $state.go('app.bbspost.bbs-popup-list.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId
          });
        }
      }

      function openAttachment(li) {
        window.location = StaticVariable.getUrl('/attach/file/' + li.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + li.PhysicalFolderNm + "&fileName=" + li.LogicalFileNm);
      }

      // 함수 선언
      vm.getData = getData;
      vm.deleteData = deleteData;
      vm.goList = goList;
      vm.goEdit = goEdit;
      vm.openAttachment = openAttachment;

      // 데이터 조회
      getData();
    } ]);
  })();

/**
 * @ngdoc function
 * @name app.bbspost:bbs-popup-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("BbsPopupEditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "H0102APISrv", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout',
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} H0102APISrv - H0102APISrv Module
   * @param {object} gAlert - Alert Module
   */
  function BbsPopupEditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, H0102APISrv, gAlert, postApi, customFieldApi, $rootScope, $timeout) {
    // View Model
    var LIST_PAGE_URL = 'app.bbspost.bbs-popup-list';             // 목록 화면
    var LIST_VIEW_PAGE_URL = 'app.bbspost.bbs-popup-list.detail'; // 목록 상세 화면
    var VIEW_PAGE_URL = 'app.bbspost.bbs-popup-detail';           // 상세 화면

    var vm = this;
    vm.vault = null;
    vm.BbsType = 'Board';

    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch || angular.isUndefined($stateParams.srch)) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    //vm.srch.tableNm = $stateParams.srch && !angular.isUndefined($stateParams.srch) ? $stateParams.srch.tableNm : 'board.notice';

    vm.layout = $rootScope.gVariable.layoutBoard;

    if (!isNullOrEmpty($stateParams.BbsMasterId)) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    } 
    
    if (!isNullOrEmpty($stateParams.BbsPostId)) {
      vm.srch.BbsPostId = $stateParams.BbsPostId;
    }

    vm.tableNm = 'board.pop';
    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = [];
    vm.srchDetail.IdName = 'BbsPostId';
    vm.srchDetail.selectType = "Edit";

    vm.timeList = ["","00","01","02","03","04","05","06","07","08","09","10","11","12","13","14","15","16","17","18","19","21","22","23"];

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 조회 데이터
    vm.data = {
      BbsMasterId: vm.srch.BbsMasterId != null ? vm.srch.BbsMasterId : 1,
      tableNm: vm.srch.tableNm,
      BbsPostId: vm.srch.BbsPostId
    };

    (function BbsPopupEditCtrl() {
    })();

    // 첨부파일 Callback
    vm.onFileCallback = {
      onFileUploaded: function (id, result) {
        // 첨부파일 업로드 완료
        $scope.$apply(function () {
          angular.forEach(result.body.docs, function (item) {
            var obj = item;
            obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
            vm.uploadFileList.push(obj);
          });
        });
      },
      onFileUploadComplete: function (id) {
        // 첨부파일 업로드 이후 저장을 호출해야 함
        if (id == 'vault') {
          $timeout(setData, 1);
        }
      },
      onFileDelete: function(item) {
        console.log("delete item::", item);
        var param = {
          fileId: item.id
        };

        var prms = H0102APISrv.attachFileDelete().post(param).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.DELETED");
          }
        });
      },
      onLoaded: function(id, vault) {
        vm[id] = vault;
      }
    };

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback, null, null, 1);

      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
      vm.srchDetail.tableNm = vm.tableNm;
      // vm.srchDetail.tableNm = 'bbspost';

      postApi.select("BbsPost.getBbsPostDetail", vm.srchDetail, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              
              if (!isNullOrEmpty(vm.data.StartDT)) {
                vm.StartDate = new Date(vm.data.StartDT);
                vm.StartTime = moment(vm.data.StartDT).format('HH')
              }              
              if (!isNullOrEmpty(vm.data.EndDT)) {
                vm.EndDate = new Date(vm.data.EndDT);
                vm.EndTime = (moment(vm.data.EndDT).format('HH:mm:ss') == "23:59:59" ? "" : moment(vm.data.EndDT).format('HH'));
              }

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }

          vm.dataloader = false;

          if (result.body.docs != null && result.body.docs.length > 0 && result.body.docs[0].errMessage) {
            console.table(result);
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    vm.uploadFile = function() {
      if (vm.vault != null && vm.vault.data.getLength() > 0) {
        uploadVaultFile(vm.vault);
      } else {
        setData();
      }
    };

    /**
     * 데이터 저장
     * @param
     * @return
     */
    function setData() {

      if (!valid()) {
        return;
      }

      // 내용
      vm.dataloader = true;

      vm.data.BbsMasterId = vm.srch.BbsMasterId;
      vm.data.RelateDataId = vm.data.BbsPostId;
      vm.data.IdName = "BbsPostId";
      vm.data.uploadFileList = vm.uploadFileList;
      vm.data.userkey = vm.srch.userkey;
      vm.data.tableNm = vm.tableNm;

      var data = vm.data;
      
      data.StartDT = moment(vm.StartDate).format('YYYY-MM-DD') +" "+ (isNullOrEmpty(vm.StartTime) ? "00:00:00" : vm.StartTime + ":00:00");
      data.EndDT = moment(vm.EndDate).format('YYYY-MM-DD') +" "+ (isNullOrEmpty(vm.EndTime) ? "23:59:59" : vm.EndTime + ":00:00");

      if (vm.data.BbsPostId == null || vm.srch.BbsPostId == "0") {
        // 등록
        data.mapCode = "BbsPost.insertBbsPost";
        postApi.insert(
          data,
          function(result) {
            InsertUpdateDetail(result);
          },
          function(error) {
            dataloader = false;
            console.table(error);
          }
        );
      } else {
        // 수정
        data.mapCode = "BbsPost.updateBbsPost";
        postApi.update(
          data,
          function(result) {
            InsertUpdateDetail(result);
          },
          function(error) {
            dataloader = false;
            console.table(error);
          }
        );
      }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].BbsPostId !== null ||
          result.body.docs[0].KeyId !== null
        ) {
          // KeyId 조회
          vm.data.BbsPostId = result.body.docs[0].RelateDataId;

          // 쿠키 제거
          document.cookie = 'szPopup_box=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              goNextPage(true);
            }
          });
        }
      }

      dataloader = false;

      if (result.body.docs != null && result.body.docs[0].errMessage != null)
        console.table(result);
    }

    function goList() {
      vm.srch.BbsPostId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, { srch: srch, BbsMasterId : vm.srch.BbsMasterId });
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch != null ? $stateParams.srch : '';

      if (vm.layout == 'N') {
        if (isNullOrEmpty(vm.srch.BbsPostId)) {
          // 신규등록 -> 목록 화면 이동
          $state.go(LIST_PAGE_URL, {srch: srch, BbsMasterId : vm.srch.BbsMasterId}, {reload:LIST_PAGE_URL});
        } else {
          // 수정 -> 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            BbsPostId: vm.data.BbsPostId,
            BbsMasterId : vm.srch.BbsMasterId
          }, {reload:VIEW_PAGE_URL});
        }
      } else {
        if (reloadList) {
          vm.srch.BbsPostId = "";
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        }
        // 조회 화면 이동
        $state.go(LIST_VIEW_PAGE_URL, {srch: srch, BbsPostId: vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId});
      }
    }

    function valid(){
      if ($scope.theForm.Title.$invalid) {
        gAlert("","제목을 입력해주세요.");
        return false;
      } else if (!isNullOrEmpty(vm.columnMap['PublicYN']) && isNullOrEmpty(vm.data.PublicYN)) {
        gAlert("","공개여부를 선택해주세요.");
        return false;
      } else {
        return true;
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 및 사용자정의 컬럼 모델 설정
    getData();
  }
]);

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name app.bbspost:bbs-popup-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("BbsPopupListCtrl", [
  "$window",
  "$scope",
  "$location",
  "$state",
  "$stateParams",
  "$rootScope",
  "GLOBAL_CONSTANT",
  "postApi",
  "$compile",
  "modalFactory",
  "$translate",
  "$filter",
  "Auth",
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} BbsPopupAPISvr - BbsPopupAPISvr Module
   */
  function BbsPopupListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    postApi,
    $compile,
    modalFactory,
    $translate,
    $filter,
    Auth
  ) {
    var vm = this;
    vm.dataloader = false;

    if (!$stateParams.srch) {
      vm.srch = {
        page: 1,
        viewSize: CONSTANT.PAGINATION.VIEWSIZE,
        sortDirect: "",
        sortColumn: "",
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
      vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
      vm.currentPage = vm.srch.page;
    }

    if (vm.srch.viewSize == null) {
      vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    }

    vm.keyId = $stateParams.BbsPostId;
    $scope.selectedRow = $stateParams.BbsPostId;
    vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    if ($stateParams.BbsMasterId) {
      vm.srch.tableNm = "";
    }
    vm.srch.CodeType = "HdcBoardType";
    vm.tenantType = $window.sessionStorage['loginTenantType']; 

    vm.listSize = [10, 25, 50, 100];

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.layout);

    (function BbsPopupListCtrl() {
      console.log("BbsPopupListCtrl:");
    })();

    // 회원사 변경 설정
    $scope.$on("broadcastSetChangeTenantID", function (event, data) {
      getList();

      $rootScope.showSimpleToast($translate.instant("MSG.LISTUPDATED"));
    });

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    $scope.showDetail = function (li) {
      $location.url("/" + li.BbsPostId);
    };

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {
      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == "N") return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC";
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      getSearch();
    }

    function sortClass(sortkey) {
      if (sortkey != vm.srch.sortColumn) return "fa fa-sort";

      var rtnval = "";

      if (vm.srch.sortDirect == "ASC") {
        rtnval = "fa fa-caret-down";
      } else {
        rtnval = "fa fa-caret-up";
      }
      return rtnval;
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      if (!$scope.selectedRow) {
        vm.dataloader = true;
      }
      vm.viewSize = vm.srch.viewSize;

      getListCnt();

      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.selectType = "List"; // For CustomColumn
      data.BbsType = vm.BbsType;
      data.mapCode = "BbsPost.getBbsPostList";
      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;
              setResponsive();
            } else {
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(
            vm.totalItems,
            vm.columnMap,
            vm.srch
          );
          vm.dataloader = false;
        },
        function (error) {
          console.error("Error> bbs-popup-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.BbsType = vm.BbsType;
      data.mapCode = "BbsPost.getBbsPostListCnt";
      postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        },
        function (error) {
          console.error("Error> bbs-popup-list-ctrl> getListCnt()", status, error);
        }
      );
    } 

    function setResponsive(dockMode) {
      var rows = vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function (item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if (item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      vm.srch.srchTenantId = $rootScope.gVariable.srchTenantId;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.bbspost.bbs-popup-list",
        { srch: srch },
        { reload: "app.bbspost.bbs-popup-list" }
      );
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      getSearch();
    }

    function getSearch() {
      // vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.bbspost.bbs-popup-list-" + vm.BbsRemark,
        { srch: srch },
        { reload: "app.bbspost.bbs-popup-list-" + vm.BbsRemark, }
      );
    }

    function resetSearch() {
      $state.go(
        "app.bbspost.bbs-popup-list-" + vm.BbsRemark,
        { srch: "" },
        { reload: "app.bbspost.bbs-popup-list-" + vm.BbsRemark }
      );
    }

    function goDetail(BbsPostId) {
      //vm.srch.BbsPostId = BbsPostId;
      var srch = $stateParams.srch != null ? $stateParams.srch : '';
      vm.keyId = BbsPostId;
      $scope.selectedRow = BbsPostId;
      if (vm.layout == "N") {
        $state.go("app.bbspost.bbs-popup-detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        angular.forEach(vm.lists, function(item) {
          if (item.BbsPostId == BbsPostId) {
            if (item.UserReadImg == 'fa-envelope') {
              item.UserReadImg = 'fa-envelope-open-o';
              vm.totalUnreadItems = vm.totalUnreadItems > 0 ? vm.totalUnreadItems - 1 : 0;
            }
            return;
          }
        });

        $state.go("app.bbspost.bbs-popup-list.detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch != null ? $stateParams.srch : '';
      vm.keyId = "";
      if (vm.layout == "N") {
        $state.go("app.bbspost.bbs-popup-edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        $state.go("app.bbspost.bbs-popup-list.edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }
    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch (vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "480px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem("layoutBoard", layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch != null ? $stateParams.srch : '';
      $state.go(
        "app.bbspost.bbs-popup-list",
        {
          srch: srch, BbsMasterId:$stateParams.BbsMasterId
        },
        { reload: "app.bbspost.bbs-popup-list" }
      );
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;
    vm.resetSearch = resetSearch;
    vm.setResponsive = setResponsive;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.setSortColumn = setSortColumn;
    vm.sortClass = sortClass;
    
    getList();
  },
]);

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.bbspost', {
      url : '/bbspost',
      template : '<div ui-view></div>',
    }).state('app.bbspost.h0101-list', {
      url : '/h0101-list/:BoardId',
      templateUrl : 'app/board/h0101-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.min.css',
          ]);
        }],
      },
    }).state('app.bbspost.h0101-detail', {
      url : '/h0101-detail/:BoardId/:FreeBoardId',
      templateUrl : 'app/board/h0101-detail.html',
    }).state('app.bbspost.h0101-edit', {
      url : '/h0101-edit/:BoardId/:FreeBoardId',
      templateUrl : 'app/board/h0101-edit.html',
    })
    
    .state('app.bbspost.h0102-list', {
      url : '/h0102-list?srch/:BbsMasterId/:ScreenId',
      templateUrl : 'app/board/h0102-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.h0102-edit', {
      url : '/h0102-edit?srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-edit.html',
    }).state('app.bbspost.h0102-detail', {
      url : '/h0102-detail?srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-detail.html',
    }).state('app.bbspost.h0102-list.detail', {
      url : '/detail/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-detail.html',
    }).state('app.bbspost.h0102-list.edit', {
      url : '/edit/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-edit.html',
    })

    .state('app.bbspost.h0102-list-noti', {
      url : '/h0102-list-noti?srch/:BbsMasterId/:ScreenId',
      templateUrl : 'app/board/h0102-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.h0102-edit-noti', {
      url : '/h0102-edit-noti?srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-edit.html',
    }).state('app.bbspost.h0102-detail-noti', {
      url : '/h0102-detail-noti?srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-detail.html',
    }).state('app.bbspost.h0102-list-noti.detail', {
      url : '/detail/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-detail.html',
    }).state('app.bbspost.h0102-list-noti.edit', {
      url : '/edit/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-edit.html',
    })

    .state('app.bbspost.h0102-list-faq', {
      url : '/h0102-list-faq?srch/:BbsMasterId/:ScreenId',
      templateUrl : 'app/board/h0102-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.h0102-edit-faq', {
      url : '/h0102-edit-faq?srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-edit.html',
    }).state('app.bbspost.h0102-detail-faq', {
      url : '/h0102-detail-faq?srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-detail.html',
    }).state('app.bbspost.h0102-list-faq.detail', {
      url : '/detail/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-detail.html',
    }).state('app.bbspost.h0102-list-faq.edit', {
      url : '/edit/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-edit.html',
    })

    .state('app.bbspost.h0102-list-qna', {
      url : '/h0102-list-qna?srch/:BbsMasterId/:ScreenId',
      templateUrl : 'app/board/h0102-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.h0102-edit-qna', {
      url : '/h0102-edit-qna?srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-edit.html',
    }).state('app.bbspost.h0102-detail-qna', {
      url : '/h0102-detail-qna?srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-detail.html',
    }).state('app.bbspost.h0102-list-qna.detail', {
      url : '/detail/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-detail.html',
    }).state('app.bbspost.h0102-list-qna.edit', {
      url : '/edit/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/h0102-edit.html',
    })
    

    .state('app.bbspost.bbs-popup-list', {
      url : '/bbs-popup-list?srch/:BbsMasterId/:ScreenId',
      templateUrl : 'app/board/bbs-popup-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.bbs-popup-edit', {
      url : '/bbs-popup-edit?srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/bbs-popup-edit.html',
    }).state('app.bbspost.bbs-popup-detail', {
      url : '/bbs-popup-detail?srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/bbs-popup-detail.html',
    }).state('app.bbspost.bbs-popup-list.detail', {
      url : '/detail/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/bbs-popup-detail.html',
    }).state('app.bbspost.bbs-popup-list.edit', {
      url : '/edit/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/bbs-popup-edit.html',
    })
    
    .state('app.bbspost.bbs-master-list', {
      url : '/bbs-master-list/:srch',
      templateUrl : 'app/board/bbs-master-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.bbs-master-edit', {
      url : '/bbs-master-edit/:srch/:BbsMasterId',
      templateUrl : 'app/board/bbs-master-edit.html',
    }).state('app.bbspost.bbs-master-detail', {
      url : '/bbs-master-detail/:srch/:BbsMasterId',
      templateUrl : 'app/board/bbs-master-detail.html',
    }).state('app.bbspost.bbs-master-list.detail', {
      url : '/detail/:BbsMasterId',
      templateUrl : 'app/board/bbs-master-detail.html',
    }).state('app.bbspost.bbs-master-list.edit', {
      url : '/edit/:BbsMasterId',
      templateUrl : 'app/board/bbs-master-edit.html',
    })

    .state('app.bbspost.splitter', {
      url : '/splitter',
      templateUrl : 'app/board/splitter.html',
    })
    /* E : 고객상담관리/고객관리>고객등록 */
    /* 모달팝업 목록 */
    .state('app.bbspost.popup-list', {
      url : '/popup-list/:srch',
      templateUrl : 'app/board/popup-list.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.notice-board', {
      url : '/notice-board/:srch/:BbsMasterId',
      templateUrl : 'app/board/notice-board.html',
        resolve : {
         plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
            ]);
        } ],
      }
    }).state('app.bbspost.notice-board.edit', {
      url : '/edit/:srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/notice-board-edit.html',
    }).state('app.bbspost.notice-board.detail', {
      url : '/detail/:srch/:BbsPostId/:BbsMasterId',
      templateUrl : 'app/board/notice-board-detail.html',
    });
  }
})();

webapp.service('H0102APISrv', ['$resource', 'StaticVariable', '$rootScope',
  function H0102APISrv($resource, StaticVariable, $rootScope) {
    var bbspostApi = {
      doSelectListColumns: function() {
        return $resource(StaticVariable.getUrl('/select/MetaColumn.getSelectListColumns/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBbsPostList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCnt: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBbsPostListCnt/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doExcel: function() {
        return $resource(StaticVariable.getUrl('/excel/BbsPost.getExcelBbsPostList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBbsPostDetail/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.deleteBbsPost/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSelectEditColumns: function() {
        return $resource(StaticVariable.getUrl('/select/MetaColumn.getSelectEditColumns/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/insert/BbsPost.insertBbsPost/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.updateBbsPost/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertUdcDetail: function() {
        return $resource(StaticVariable.getUrl('/api/udc/udcInsert.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateUdcDetail: function() {
        return $resource(StaticVariable.getUrl('/api/udc/udcUpdate.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDeleteUdcDetail: function() {
        return $resource(StaticVariable.getUrl('/api/udc/udcDelete.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doFileList: function() {
        return $resource(StaticVariable.getUrl('/select/FileAttach.getFileList/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSaveAttachFile: function() {
        return $resource(StaticVariable.getUrl('/attach/saveAttachFile.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      attachFileDelete: function() {
        return $resource(StaticVariable.getUrl('/attach/file/delete.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doReply: function() {
        return $resource(StaticVariable.getUrl('/select/BbsPost.getBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doSaveReply: function() {
        return $resource(StaticVariable.getUrl('/insert/BbsPost.insertBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDeleteReply: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.deleteBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateReply: function() {
        return $resource(StaticVariable.getUrl('/update/BbsPost.updateBoardComment/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return bbspostApi;
  },
]);

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost:h0102-detail-ctrl
 * @description # 게시판 조회 Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('H0102DetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$filter', 'GLOBAL_CONSTANT', 'StaticVariable', 'H0102APISrv', 'gAlert', 'gConfirm',
    'fileUploadService', 'postApi', 'customFieldApi', '$rootScope',

    /**
     * 게시판 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          H0102APISvr - H0102APISvr Module
     * @param {object}
     *          gAlert - Alert Module
     * @param {object}
     *          gConfirm - Confirm Module
     * @param {object}
     *          fileUploadService - fileUploadService Module
     */
    function H0102DetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, gConfirm, fileUploadService, postApi, customFieldApi, $rootScope) {
      // View Model
      var vm = this;
      vm.dataloader = false;
      vm.BbsType = 'board';

      vm.srch = {};
      if (!$stateParams.srch || angular.isUndefined($stateParams.srch)) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }
  
      //vm.srch.tableNm = $stateParams.srch && !angular.isUndefined($stateParams.srch) ? $stateParams.srch.tableNm : 'board.notice';
      vm.layout = $rootScope.gVariable.layoutBoard;

      if (!isNullOrEmpty($stateParams.BbsMasterId)) {
        vm.srch.BbsMasterId = $stateParams.BbsMasterId;
      } else {
        vm.srch.BbsMasterId = '6Y024Q3ILI';
      }

      if (!isNullOrEmpty($stateParams.BbsPostId)) {
        vm.srch.BbsPostId = $stateParams.BbsPostId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = [];
      vm.srchDetail.IdName = 'BbsPostId';
      vm.srchDetail.selectType = "Edit";
      vm.srchDetail.CodeType = "HdcBoardType";

      // 조회 데이터
      vm.data = {
        TableNm : vm.srchDetail.TableNm,
        BbsPostId : vm.srchDetail.BbsPostId,
      };

      // 댓글
      vm.comment = {};

      // 댓글 조회 조건
      vm.srchReply = {
        BbsMasterId : vm.srch.BbsMasterId != '' ? vm.srch.BbsMasterId : 1,
        tableNm : 'bbspostcomm', // For CustomColumn and FileAttachment
        BbsPostId : vm.srch.BbsPostId,
        TableId : vm.srch.BbsPostId,
        IdName : 'BbsPostCommId', // For CustomColumn and FileAttachment
        viewSize : 100,
        LastId : 0,
      };
      // 옵션
      vm.items = [ {
        name : '공유',
        icon : 'zmdi zmdi-share'
      }, {
        name : '업로드',
        icon : 'zmdi zmdi-upload'
      }, {
        name : '복사',
        icon : 'zmdi zmdi-copy'
      }, {
        name : '현재 페이지 인쇄',
        icon : 'zmdi zmdi-print'
      }, ];

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];
      vm.uploadFileListReply = [];

      (function H0102DetailCtrl() {
        console.log('H0102DetailCtrl:');
      })();

      /**
       * 조회수 증가
       *
       * @param
       * @return
       */
      function updateReadCnt() {
        //doUpdateReadCnt없ㅇ므
        var prms = h0102Api.doUpdateReadCnt().post(vm.srch).$promise;
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getFileList() {

        var data = vm.srchDetail;
        data.viewColumns = {};
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              var uploadFileList = [];

              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
              return;
            }
          }
        },function(error) {
          console.error('Error> h0102-detail-ctrl> getFileList()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }
      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        vm.srchDetail.tableNm = vm.tableNm;
        postApi.select('BbsPost.getBbsPostDetail', vm.srchDetail, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              // console.log(vm.data);

              // console.log($filter('utcToLocal')(vm.data.RegDate,'yyyy-MM-dd h:mm a'));

              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> h0102-edit-ctrl> getData()', status, error);
          vm.dataloader = false;
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      // 원본 이벤트
      var originatorEv;

      /**
       * 평점 표시
       *
       * @param {object}
       *          $mdOpenMenu - Open Menu Object
       * @param {object}
       *          ev - ev Object
       * @return
       */
      function openMenu($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDataAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteDataAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.srchDetail;
        data.RelateDataId = data.BbsPostId;
        data.mapCode = 'BbsPost.deleteBbsPost';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                var srch = $stateParams.srch != null ? $stateParams.srch : '';
                $state.go('app.bbspost.h0102-list', {
                  srch:srch,
                  BbsMasterId : vm.srch.BbsMasterId
                }, {reload:'app.bbspost.h0102-list'});
              }
            });
            return;
          }
        }, function(error) {
          console.error('Error> h0102-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * Object Append 함수
       *
       * @param
       * @return
       */
      Array.prototype.append = function(array) {
        this.push.apply(this, array);
      }

      /**
       * 댓글 조회
       *
       * @param
       * @return
       */
      function getComment() {


        var data = vm.srchReply;
        data.mapCode = 'BbsPost.getBoardComment';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (vm.comment.lists == null) {
                vm.comment.lists = result.body.docs;
              } else {
                vm.comment.lists.append(result.body.docs);
              }
              vm.srchReply.LastId = result.body.docs[result.body.docs.length - 1].BbsPostCommId;
              return;
            }
          }
        }, function(error) {
          console.error('Error> h0102-detail-ctrl> getReply()', status, error);
          gAlert('', result.body.docs[0].errMessage, {
            btn : '',
            fn : function() {
              var srch = $stateParams.srch != null ? $stateParams.srch : '';
              $state.go('app.bbspost.h0102-list', {
                srch : srch
              });
            }
          });
        });
      }

      function saveReply() {
        if (angular.isUndefined(vm.data.ReplyContents) || vm.data.ReplyContents == null || vm.data.ReplyContents == '') {
          gAlert('', 'Menu.NOCONTENTS');
          return;
        }

        var data = {};
        data.BbsPostId = $stateParams.BbsPostId;
        data.Contents = vm.data.ReplyContents;
        data.mapCode = 'BbsPost.insertBoardReply';
        postApi.insert(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', '답변이 저장되었습니다.');
            return;
          }
          console.error('Error> h0102-detail-ctrl> saveReply()', status, data);
          gAlert('', result.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error> h0102-detail-ctrl> saveReply()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }

      function deleteReply() {
        var data = {};
        data.BbsPostId = $stateParams.BbsPostId;
        data.mapCode = 'BbsPost.deleteBoardReply';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', '답변이 삭제되었습니다.');
            return;
          }
          console.error('Error> h0102-detail-ctrl> deleteReply()', status, data);
          gAlert('', result.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error> h0102-detail-ctrl> deleteReply()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 저장
       *
       * @param
       * @return
       */
      function saveComment() {
        if ((angular.isUndefined(vm.srchReply.Contents) || vm.srchReply.Contents == null || vm.srchReply.Contents == '') && vm.uploadFileListReply.length == 0) {
          gAlert('', 'Menu.NOCONTENTS');
          return;
        }

        // 업로드 파일 목록
        vm.srchReply['uploadFileList'] = vm.uploadFileListReply;

        var data = vm.srchReply;
        data.mapCode = 'BbsPost.insertBoardComment';
        postApi.insert(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (result.body.docs[0].BbsPostCommId != 0) {
                vm.srchReply.Contents = '';
                vm.srchReply.uploadFileList = [];
                vm.uploadFileListReply = [];
                // 댓글 조회
                getComment();
                return;
              }
            }
          }
          console.error('Error> h0102-detail-ctrl> saveComment()', status, data);
          gAlert('', result.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error> h0102-detail-ctrl> saveComment()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }

      // 파일 삭제
      vm.setDeleteFileToggle = setDeleteFileToggle;

      /**
       * 파일 삭제
       *
       * @param
       * @return
       */
      function setDeleteFileToggle(replyObj) {
        var idx = -1;

        angular.forEach(vm.comment.lists, function(val, key) {
          if (val == replyObj) {
            idx = key;
            return;
          }
        });

        if (vm.comment.lists[idx].delState === '') {
          vm.comment.lists[idx].delState = 'delete';
        } else {
          vm.comment.lists[idx].delState = '';
        }
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteComment(replyObj) {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteCommentAction(replyObj);
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteCommentAction(replyObj) {
        var srch = {
          BbsPostCommId : replyObj.BbsPostCommId,
          tableNm : "BbsPostComm",
          TableId : replyObj.BbsPostCommId
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : replyObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName : replyObj.LogicalFileNm,
            size : replyObj.FileSize,
            fileKey : replyObj.PhysicalFileNm,
            path : replyObj.PhysicalFolderNm,
            downloadCnt : replyObj.DownloadCnt,
            delState : 'delete',
            typeId : 'file',
          };
          uploadFileList.push(obj);
          srch['uploadFileList'] = uploadFileList;
        }
        var data = srch;
        data.mapCode = 'BbsPost.deleteBoardComment';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // console.log('result',result);
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function(item, index, object) {
                if (item.BbsPostCommId == replyObj.BbsPostCommId) {
                  object.splice(index, 1);
                }
              });
              return;
            }
          }
          gAlert('', result.body.docs[0].errMessage);
        },  function(error) {
          console.error('Error> h0102-detail-ctrl> deleteCommentAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editComment(BbsPostCommId) {
        vm.comment.editid = BbsPostCommId;

        vm.comment.lists.forEach(function(item, index, object) {
          if (item.BbsPostCommId === BbsPostCommId) {
            vm.comment.editContents = item.Contents;
          }
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editCommentAction(replyObj) {
        var srch = {
          BbsPostCommId : replyObj.BbsPostCommId,
          Contents : vm.comment.editContents,
          TableNm : "BbsPostComm",
          TableId : replyObj.BbsPostCommId,
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : replyObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName : replyObj.LogicalFileNm,
            size : replyObj.FileSize,
            fileKey : replyObj.PhysicalFileNm,
            path : replyObj.PhysicalFolderNm,
            downloadCnt : replyObj.DownloadCnt,
            delState : replyObj.delState,
            typeId : "file",
          }
          uploadFileList.push(obj);

          srch['uploadFileList'] = uploadFileList;
        }

        var data = srch;
        data.mapCode = 'BbsPost.updateBoardComment';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function(item, index, object) {
                if (item.BbsPostCommId === replyObj.BbsPostCommId) {
                  item.Contents = result.body.docs[0].Contents;
                  vm.comment.editid = null;

                  if (item.delState === 'delete') {
                    item.AttachmentId = '';
                    item.PhysicalFileNm = '';
                    item.PhysicalFolderNm = '';
                    item.LogicalFileNm = '';
                    item.FileSize = '';
                    item.DownloadCnt = '';
                    item.delState = '';
                  }
                }
              });
              return;
            }
          }
          gAlert('', result.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error> h0102-detail-ctrl> editCommentAction()', status, error)
          gAlert('', error.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 수정 취소
       *
       * @param
       * @return
       */
      function editCommentCancel() {
        vm.comment.editid = null;
        vm.comment.editContents = null;
      }

      vm.openDilalog = openDilalog;

      /**
       * 첨부파일 오픈 다이얼로그
       *
       * @param
       * @return
       */
      function openDilalog() {
        angular.element('#file-5').trigger("click");
      }

      var fileElement = angular.element('#file-5');
      fileElement.bind('change', function() {
        uploadFiles(fileElement[0].files);
      });

      vm.uploadFiles = uploadFiles;

      /**
       * 첨부파일 업로드
       *
       * @param {object}
       *          files - 첨부 파일
       * @return
       */
      function uploadFiles(files) {
        var tempIds = [];

        // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
        $scope.$root.safeApply(function() {
          var hasZeroByteFile = false;

          angular.forEach(files, function(value) {
            if (value.size == 0) {
              hasZeroByteFile = true;
            } else {
              var obj = {
                isLoaded : false,
                fileName : value.name,
                size : value.size,
                id : fileUploadId,
                delState : ''
              };

              tempIds.push(obj);

              if (vm.uploadFileListReply == null)
                vm.uploadFileListReply = new Array();
              vm.uploadFileListReply.push(angular.copy(obj));
              fileUploadId++;
            }
          });

          if (hasZeroByteFile) {
            gAlert('', 'Menu.NOCONTENTS');
            return;
          }

          var request = fileUploadService.post(files, null, function(percent) {
            // -- 진행율 표시
            angular.forEach(tempIds, function(obj) {
              $('#filectl' + ' .progress .progress-bar').css('width', percent + '%');
            });

            if (percent == 100) {
              vm.showLoading = true;
            }
          });

          try {
            request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey='+$rootScope.gVariable.userKey)).then(function(value) {
              angular.forEach(value.data.responseVO.body.docs, function(item) {
                angular.forEach(vm.uploadFileListReply, function(obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.tmpFileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl("/attach/temp/" + item.tmpFileKey + "/download.do?userkey=" + $rootScope.gVariable.userKey + "&fileName=" + item.encFileName);
                    obj.delState = '';
                  }
                });
              });

              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element('#file-5').val(null);

              vm.showLoading = false;
            }, function(error) {
              console.error('Error> h0102-detail-ctrl> uploadFiles()', status, error);
            });
          } catch (error) {
            console.error('Error> h0102-detail-ctrl> uploadFiles()', status, error);
          }
        });
      }
      ;

      vm.onDelete = onDelete;

      /**
       * 첨부파일 삭제 이벤트
       *
       * @param
       * @return
       */
      function onDelete(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          if (vm.uploadFileListReply[idx].typeId == "temp") {
            var prms = fileUploadService.attachFileDelete().get({
              attachId : vm.uploadFileListReply[idx].tmpFileKey
            }).$promise;

            prms.then(function(data) {
              console.log('Success> h0102-detail-ctrl> onDelete()', data);
            }, function(error) {
              console.error('Error> h0102-detail-ctrl> onDelete()', status, error);
            })
            vm.uploadFileListReply.splice(idx, 1);
          } else if (vm.callback) {
            vm.uploadFileListReply[idx].delState = 'delete';
          }
        }
      }
      ;

      vm.onDeleteCancel = onDeleteCancel;

      /**
       * 첨부파일 삭제 취소 이벤트
       *
       * @param
       * @return
       */
      function onDeleteCancel(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          vm.uploadFileListReply[idx].delState = '';
        }
      }

      function goList() {
        var srch = $stateParams.srch != null ? $stateParams.srch : '';
        $state.go('app.bbspost.h0102-list', {
          srch : srch,
          BbsMasterId : vm.srch.BbsMasterId
        });
      }

      function goEdit() {
        var srch = $stateParams.srch != null ? $stateParams.srch : '';
        if (vm.layout == 'N') {
          $state.go('app.bbspost.h0102-edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId
          });
        } else {
          $state.go('app.bbspost.h0102-list.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId
          });
        }
      }

      function openAttachment(li) {
        window.location = StaticVariable.getUrl('/attach/file/' + li.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + li.PhysicalFolderNm + "&fileName=" + li.LogicalFileNm);
      }

      function getBbsNm() {
        if (vm.layout != 'N') {
          return;
        }
        var data = { BbsMasterId: vm.srch.BbsMasterId };
        data.mapCode = "BbsMaster.getBbsMasterDetail";
        postApi.select(
          data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.BbsNm = result.body.docs[0].BbsNm;
                vm.BbsType = result.body.docs[0].BbsType;
                vm.tableNm = result.body.docs[0].tableNm;
                getData();
              }
            }
          },
          function (error) {
            console.error("Error> h0102-list-ctrl> getList()", status, error);
          }
        );
      }
      // 함수 선언
      vm.getData = getData;
      vm.getComment = getComment;
      vm.deleteData = deleteData;
      vm.saveReply = saveReply;
      vm.deleteReply = deleteReply;
      vm.saveComment = saveComment;
      vm.deleteComment = deleteComment;
      vm.editComment = editComment;
      vm.editCommentAction = editCommentAction;
      vm.editCommentCancel = editCommentCancel;
      vm.openMenu = openMenu;
      vm.goList = goList;
      vm.goEdit = goEdit;
      vm.openAttachment = openAttachment;

      // 데이터 조회
      getBbsNm();

      getComment();
    } ]);
  })();

/**
 * @ngdoc function
 * @name app.bbspost:h0102-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("H0102EditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "H0102APISrv", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout',
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} H0102APISvr - H0102APISvr Module
   * @param {object} gAlert - Alert Module
   */
  function H0102EditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, postApi, customFieldApi, $rootScope, $timeout) {
    // View Model
    var LIST_PAGE_URL = 'app.bbspost.h0102-list';             // 목록 화면
    var LIST_VIEW_PAGE_URL = 'app.bbspost.h0102-list.detail'; // 목록 상세 화면
    var VIEW_PAGE_URL = 'app.bbspost.h0102-detail';           // 상세 화면

    var vm = this;
    vm.vault = null;
    vm.BbsType = 'Board';

    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch || angular.isUndefined($stateParams.srch)) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    //vm.srch.tableNm = $stateParams.srch && !angular.isUndefined($stateParams.srch) ? $stateParams.srch.tableNm : 'board.notice';

    vm.layout = $rootScope.gVariable.layoutBoard;

    if (!isNullOrEmpty($stateParams.BbsMasterId)) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    } else {
      vm.srch.BbsMasterId = '6Y024Q3ILI';
    }

    if (!isNullOrEmpty($stateParams.BbsPostId)) {
      vm.srch.BbsPostId = $stateParams.BbsPostId;
    }

    //vm.srch.tableNm = 'bbspost';
    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = [];
    vm.srchDetail.IdName = 'BbsPostId';
    vm.srchDetail.selectType = "Edit";

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 조회 데이터
    vm.data = {
      BbsMasterId: vm.srch.BbsMasterId != null ? vm.srch.BbsMasterId : 1,
      tableNm: vm.srch.tableNm,
      BbsPostId: vm.srch.BbsPostId
    };

    (function H0102EditCtrl() {
    })();

    // 첨부파일 Callback
    vm.onFileCallback = {
      onFileUploaded: function (id, result) {
        // 첨부파일 업로드 완료
        $scope.$apply(function () {
          angular.forEach(result.body.docs, function (item) {
            var obj = item;
            obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
            vm.uploadFileList.push(obj);
          });
        });
      },
      onFileUploadComplete: function (id) {
        // 첨부파일 업로드 이후 저장을 호출해야 함
        if (id == 'vault') {
          $timeout(setData, 1);
        }
      },
      onFileDelete: function(item) {
        console.log("delete item::", item);
        var param = {
          fileId: item.id
        };

        var prms = h0102Api.attachFileDelete().post(param).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.DELETED");
          }
        });
      },
      onLoaded: function(id, vault) {
        vm[id] = vault;
      }
    };

    /**
     * 사용자정의 컬럼 모델 설정
     *
     */
    function setUdcModel() {
      angular.forEach(Object.keys(vm.data), function(item) {
        // 사용자정의 컬럼 모델
        if (vm.udcDataType[item] == "40") {
          vm.udcModel[item] = $filter("date")(vm.data[item], "yyyy-MM-dd");
        } else {
          vm.udcModel[item] = vm.data[item];
        }
      });
    }

    /**
     * 첨부파일 목록 조회
     * @param
     * @return
     */
    function getFileList() {
      if (vm.srch.BbsPostId == null || vm.srch.BbsPostId == '0') {
        vm.dataloader = false;
        return;
      }

      var data = vm.srch;
      data.mapCode = "FileAttach.getFileList";
      postApi.select(data,
        function(result) {
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {
              // AngularJS Version
              var uploadFileList = [];
              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl(
                    "/attach/file/" +
                      item.PhysicalFileNm +
                      "/download.do?path=" +
                      item.PhysicalPath +
                      "&fileName=" +
                      item.LogicalFileNm
                  ),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: "file",
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ""
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback);

      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
      vm.srchDetail.tableNm = vm.tableNm;
      // vm.srchDetail.tableNm = 'bbspost';

      postApi.select("BbsPost.getBbsPostDetail", vm.srchDetail, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
              try {
                oEditors.getById["strHtml"].exec("PASTE_HTML", [vm.data.Contents]);
              } catch (e) {
                console.log(e);
              }
            }
          }

          vm.dataloader = false;

          if (result.body.docs != null && result.body.docs.length > 0 && result.body.docs[0].errMessage) {
            console.table(result);
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    vm.uploadFile = function() {
      if (vm.vault != null && vm.vault.data.getLength() > 0) {
        uploadVaultFile(vm.vault);
      } else {
        setData();
      }
    };

    /**
     * 데이터 저장
     * @param
     * @return
     */
    function setData() {

      if (!valid()) {
        return;
      }

      // 내용
      vm.dataloader = true;
      if (vm.BbsType == 'Board' || vm.BbsType == 'QNA') {
        oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
        vm.data.Contents = $("#strHtml").val();
      }

      vm.data.BbsMasterId = vm.srch.BbsMasterId;
      vm.data.RelateDataId = vm.data.BbsPostId;
      vm.data.IdName = "BbsPostId";
      vm.data.uploadFileList = vm.uploadFileList;
      vm.data.userkey = vm.srch.userkey;
      vm.data.tableNm = vm.tableNm;

      var data = vm.data;
      if (vm.data.BbsPostId == null || vm.srch.BbsPostId == "0") {
        // 등록
        data.mapCode = "BbsPost.insertBbsPost";
        postApi.insert(
          data,
          function(result) {
            InsertUpdateDetail(result);
          },
          function(error) {
            dataloader = false;
            console.table(error);
          }
        );
      } else {
        // 수정
        data.mapCode = "BbsPost.updateBbsPost";
        postApi.update(
          data,
          function(result) {
            InsertUpdateDetail(result);
          },
          function(error) {
            dataloader = false;
            console.table(error);
          }
        );
      }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].BbsPostId !== null ||
          result.body.docs[0].KeyId !== null
        ) {
          // KeyId 조회
          vm.data.BbsPostId = result.body.docs[0].RelateDataId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              goNextPage(true);
            }
          });
        }
      }

      dataloader = false;

      if (result.body.docs != null && result.body.docs[0].errMessage != null)
        console.table(result);
    }

    function goList() {
      vm.srch.BbsPostId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, { srch: srch, BbsMasterId : vm.srch.BbsMasterId });
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch != null ? $stateParams.srch : '';

      if (vm.layout == 'N') {
        if (isNullOrEmpty(vm.srch.BbsPostId)) {
          // 신규등록 -> 목록 화면 이동
          $state.go(LIST_PAGE_URL, {srch: srch, BbsMasterId : vm.srch.BbsMasterId}, {reload:LIST_PAGE_URL});
        } else {
          // 수정 -> 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            BbsPostId: vm.data.BbsPostId,
            BbsMasterId : vm.srch.BbsMasterId
          }, {reload:VIEW_PAGE_URL});
        }
      } else {
        if (reloadList) {
          vm.srch.BbsPostId = "";
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        }
        // 조회 화면 이동
        $state.go(LIST_VIEW_PAGE_URL, {srch: srch, BbsPostId: vm.data.BbsPostId, BbsMasterId : vm.srch.BbsMasterId});
      }
    }

    function valid(){
      if ($scope.theForm.Title.$invalid) {
        gAlert("","제목을 입력해주세요.");
        return false;
      } else if (!isNullOrEmpty(vm.columnMap['BoardType']) && isNullOrEmpty(vm.data.BoardType)) {
        gAlert("","분류를 선택해주세요.");
        return false;
      } else if (!isNullOrEmpty(vm.columnMap['PublicYN']) && isNullOrEmpty(vm.data.PublicYN)) {
        gAlert("","공개여부를 선택해주세요.");
        return false;
      } else if (!isNullOrEmpty(vm.columnMap['NoticeYN']) && isNullOrEmpty(vm.data.NoticeYN)) {
        gAlert("","중요공지여부를 선택해주세요.");
        return false;
      } else {
        return true;
      }
    }

    function getBbsNm() {
      if (vm.layout != 'N') {
        return;
      }      
      var data = { BbsMasterId: vm.srch.BbsMasterId };
      data.mapCode = "BbsMaster.getBbsMasterDetail";
      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.BbsNm = result.body.docs[0].BbsNm;
              vm.BbsType = result.body.docs[0].BbsType;
              vm.tableNm = result.body.docs[0].tableNm;
              getData();
            }
          }
        },
        function (error) {
          console.error("Error> h0102-list-ctrl> getList()", status, error);
        }
      );
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 및 사용자정의 컬럼 모델 설정
    getBbsNm();
  }
]);

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name app.bbspost:h0102-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("H0102ListCtrl", [
  "$window",
  "$scope",
  "$location",
  "$state",
  "$stateParams",
  "$rootScope",
  "GLOBAL_CONSTANT",
  "postApi",
  "$compile",
  "modalFactory",
  "$translate",
  "$filter",
  "Auth",
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} H0102APISvr - H0102APISvr Module
   */
  function H0102ListCtrl(
    $window,
    $scope,
    $location,
    $state,
    $stateParams,
    $rootScope,
    CONSTANT,
    postApi,
    $compile,
    modalFactory,
    $translate,
    $filter,
    Auth
  ) {
    var vm = this;
    vm.dataloader = false;

    vm.openModalUser = openModalUser;
    vm.clearUser = clearUser;

    if (!$stateParams.srch) {
      vm.srch = {
        page: 1,
        viewSize: CONSTANT.PAGINATION.VIEWSIZE,
        sortDirect: "",
        sortColumn: "",
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
      vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
      vm.currentPage = vm.srch.page;
    }

    if (vm.srch.viewSize == null) {
      vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    }

    vm.keyId = $stateParams.BbsPostId;
    $scope.selectedRow = $stateParams.BbsPostId;
    vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    if ($stateParams.BbsMasterId) {
      vm.srch.tableNm = "";
    }
    vm.srch.CodeType = "HdcBoardType";
    vm.BbsNm = "";
    vm.tenantType = $window.sessionStorage['loginTenantType']; 
    //    $compile($('#pane'))($scope);

    vm.listSize = [10, 25, 50, 100];

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.layout);

    (function H0102ListCtrl() {
      console.log("H0102ListCtrl:");
    })();

    // 회원사 변경 설정
    $scope.$on("broadcastSetChangeTenantID", function (event, data) {
      getList();

      $rootScope.showSimpleToast($translate.instant("MSG.LISTUPDATED"));
    });

    // 엑셀
    vm.excel = {
      downFileName: "BbsPost",
      subject: "자유게시판 리스트",
      header: [
        {
          field: "BbsPostId",
          title: "번호",
          width: "5",
          format: "number",
        },
        {
          field: "Title",
          title: "제목",
          width: "20",
          format: "string",
        },
        {
          field: "RegUserNm",
          title: "등록자",
          width: "10",
          format: "string",
        },
        {
          field: "RegDate",
          title: "등록일자",
          width: "10",
          format: "date",
        },
        {
          field: "ReadCnt",
          title: "조회수",
          width: "5",
          format: "string",
        },
        {
          field: "Reviewer",
          title: "평가자",
          width: "5",
          format: "string",
        },
      ],
    };

    /*
    if ($window.sessionStorage.getItem('h0102-list-ctrl') !== null) {
      if ($rootScope.previousPage !== null &&
        ($rootScope.previousPage.indexOf('/app/bbspost/detail') !== -1 ||
        $rootScope.previousPage.indexOf('/app/bbspost/edit') !== -1)) {
        vm.srch = JSON.parse($window.sessionStorage.getItem('h0102-list-ctrl'));
        vm.currentPage = vm.srch.page;
      }
    }
     */

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.getAddressInfo = getAddressInfo;
    $scope.showDetail = function (li) {
      $location.url("/" + li.BbsPostId);
    };
    vm.srch.ZipCode = "";
    vm.srch.Addr1 = "";
    /* 다음 주소검색 */
    function getAddressInfo() {
      new daum.Postcode({
        oncomplete: function (data) {
          vm.zipCode = data.zonecode;
          vm.addr1 =
            data.buildingName != ""
              ? data.address + " " + data.buildingName
              : data.address;
          $("#zipCode").val(vm.zipCode);
          $("#addr1").val(vm.addr1);
        },
      }).open();
    }

    /* 사용자검색 */
    function openModalUser() {
      var ctrl = "UserModalCtrl as modalCtrl";
      var paramData = { srchTenantId: $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open(
        "md",
        "components/modal/users/user-modal.html",
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (res) {
          vm.srch.UserNm = res.UserNm;
          vm.srch.UserId = res.UserId;
        },
        function (cancelData) {}
      );
    }
    /* 사용자검색- 지우기 */
    function clearUser() {
      vm.srch.UserNm = "";
      vm.srch.UserId = "";
    }

    /**
     * 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {
      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == "N") return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC";
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      getSearch();
    }

    function sortClass(sortkey) {
      if (sortkey != vm.srch.sortColumn) return "fa fa-sort";

      var rtnval = "";

      if (vm.srch.sortDirect == "ASC") {
        rtnval = "fa fa-caret-down";
      } else {
        rtnval = "fa fa-caret-up";
      }
      return rtnval;
    }

    /* 단품(제품)조회 */
    function openModalPrd() {
      var ctrl = "ProductModalCtrl as modalCtrl";
      var paramData = { srchTenantId: $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open(
        "md",
        "components/modal/product/product-modal.html",
        ctrl,
        paramData
      );
      modalInstance.result.then(
        function (res) {
          vm.srch.ProductNm = res.ProductNm;
          vm.srch.ProductId = res.ProductId;
        },
        function (cancelData) {}
      );
    }
    /* 단품(제품)조회- 지우기 */
    function clearPrd() {
      vm.srch.ProductId = "";
      vm.srch.ProductNm = "";
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      if (!$scope.selectedRow) {
        vm.dataloader = true;
      }
      vm.viewSize = vm.srch.viewSize;

      getListCnt();
      getUnreadCnt();

      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.selectType = "List"; // For CustomColumn
      data.BbsType = vm.BbsType;
      data.mapCode = "BbsPost.getBbsPostList";
      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.lists = result.body.docs;
              setResponsive();
            } else {
              vm.lists = {};
            }
          }

          vm.SearchConditionStr = getSearchConditionStr(
            vm.totalItems,
            vm.columnMap,
            vm.srch
          );
          vm.dataloader = false;
        },
        function (error) {
          console.error("Error> h0102-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
      data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
      data.BbsType = vm.BbsType;
      data.mapCode = "BbsPost.getBbsPostListCnt";
      postApi.select(data, function (result) {
          /* console.log("type C", result.header);
        console.log("type c", result.body); */
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalItems = result.body.docs;
            } else {
              vm.totalItems = 0;
            }
          }
        },
        function (error) {
          console.error("Error> h0102-list-ctrl> getListCnt()", status, error);
        }
      );
    }

    function getUnreadCnt() {
      var data = angular.copy(vm.srch);
      data.mapCode = "BbsPost.getBbsPostUnreadCnt";
      postApi.select(data, function (result) {
          /* console.log("type C", result.header);
        console.log("type c", result.body); */
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalUnreadItems = result.body.docs[0];
            } else {
              vm.totalUnreadItems = 0;
            }
          }
        },
        function (error) {
          console.error("Error> h0102-list-ctrl> getListCnt()", status, error);
        }
      );
    }    

    function setResponsive(dockMode) {
      var rows = vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function (item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if (item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });

      // if(!checkMobile()) {
      //   var mode = {};
      //   var localStorage = window.localStorage;
      //   (dockMode == undefined) ?
      //     mode.type = localStorage.getItem("dockMode") : mode.type = dockMode;
      //   setDockView($compile, $scope, mode, function(){
      //     $('#searchTextResults').footable({
      //       "columns": columns,
      //       "rows": rows,
      //       "ctrState" : $state,
      //       "key" : "BbsPostId",
      //       "link" : "app.bbspost.h0102-slist.detail",
      //       "srch" : vm.srch,
      //       "FreeBoardId" : 'W'
      //     }, function(ft) {
      //       initFootableEvent(vm,ft, function(e){

      //         var url = "http://localhost:3000/#/app/bbspost/h0102-detail/%257B%2522page%2522%253A1%252C%2522viewSize%2522%253A25%252C%2522BbsMasterId%2522%253A1%252C%2522tableNm%2522%253A%2522bbspost%2522%252C%2522searchColumns%2522%253A%257B%2522Title%2522%253Atrue%252C%2522ExtVarchar01%2522%253Atrue%252C%2522ExtInt01%2522%253Atrue%252C%2522ExtInt02%2522%253Atrue%252C%2522ExtDate01%2522%253Atrue%252C%2522ExtVarchar02%2522%253Atrue%252C%2522ExtDate02%2522%253Atrue%252C%2522RegDate%2522%253Atrue%252C%2522ExtVarchar03%2522%253Atrue%257D%252C%2522userkey%2522%253A%25225GU7YVI51O%2522%252C%2522totalItems%2522%253A%255B32%255D%252C%2522BbsPostId%2522%253A%2522W%2522%257D";
      //         console.log(url);
      //         vm.detailContent = jQuery.get(url);
      //           console.log(vm.detailContent)

      //       });
      //     });
      //   });
      // }
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      vm.srch.srchTenantId = $rootScope.gVariable.srchTenantId;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.bbspost.h0102-list",
        { srch: srch, BbsMasterId : vm.srch.BbsMasterId },
        { reload: "app.bbspost.h0102-list" }
      );
    }

    /**
     * 엑셀파일 다운로드
     * @param
     * @return
     * @author 최원영
     */
    function getExcel() {
      vm.excel.param = vm.srch;
      var data = vm.excel;

      data.mapCode = "BbsPost.getExcelBbsPostList";
      postApi.excel(
        data,
        function (result) {
          console.log("type C", result.header);
          console.log("type c", result.body);
        },
        function (error) {
          console.error("Error> h0102-list-ctrl> getExcel()", status, error);
        }
      );
      /*
      vm.excel.param = vm.srch;

      var prms = h0102Api.doExcel().post(vm.excel).$promise;

      prms.then(function(data) {
      }, function(error) {
        console.error('Error> h0102-list-ctrl> getExcel()', status, error);
      }); */
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      getSearch();
    }

    function getSearch() {
      // vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        "app.bbspost.h0102-list-" + vm.BbsRemark,
        { srch: srch },
        { reload: "app.bbspost.h0102-list-" + vm.BbsRemark, }
      );
    }

    function resetSearch() {
      $state.go(
        "app.bbspost.h0102-list-" + vm.BbsRemark,
        { srch: "" },
        { reload: "app.bbspost.h0102-list-" + vm.BbsRemark }
      );
    }

    function goDetail(BbsPostId) {
      //vm.srch.BbsPostId = BbsPostId;
      var srch = $stateParams.srch != null ? $stateParams.srch : '';
      vm.keyId = BbsPostId;
      $scope.selectedRow = BbsPostId;
      if (vm.layout == "N") {
        $state.go("app.bbspost.h0102-detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        angular.forEach(vm.lists, function(item) {
          if (item.BbsPostId == BbsPostId) {
            if (item.UserReadImg == 'fa-envelope') {
              item.UserReadImg = 'fa-envelope-open-o';
              vm.totalUnreadItems = vm.totalUnreadItems > 0 ? vm.totalUnreadItems - 1 : 0;
            }
            return;
          }
        });

        $state.go("app.bbspost.h0102-list.detail", {
          srch: srch,
          BbsPostId: BbsPostId,
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch != null ? $stateParams.srch : '';
      vm.keyId = "";
      if (vm.layout == "N") {
        $state.go("app.bbspost.h0102-edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      } else {
        $state.go("app.bbspost.h0102-list.edit", {
          srch: srch,
          BbsPostId: "",
          BbsMasterId: vm.srch.BbsMasterId,
        });
      }
    }
    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch (vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "480px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem("layoutBoard", layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch != null ? $stateParams.srch : '';
      $state.go(
        "app.bbspost.h0102-list",
        {
          srch: srch, BbsMasterId:$stateParams.BbsMasterId
        },
        { reload: "app.bbspost.h0102-list" }
      );
    }

    function getBbsNm() {
      var data = { BbsMasterId: vm.srch.BbsMasterId };
      data.mapCode = "BbsMaster.getBbsMasterDetail";
      postApi.select(
        data,
        function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.BbsNm = result.body.docs[0].BbsNm;
              vm.BbsType = result.body.docs[0].BbsType;
              vm.BbsRemark = result.body.docs[0].Remark;
              getList();
            }
          }
          vm.dataloader = false;
        },
        function (error) {
          console.error("Error> h0102-list-ctrl> getList()", status, error);
          vm.dataloader = false;
        }
      );
    }

    function goUnreadList() {
      var srch = { Unread:'Y' };
      $state.go(
        "app.bbspost.h0102-list",
        {
          srch: encodeURIComponent(JSON.stringify(srch, replacer))
        },
        { reload: "app.bbspost.h0102-list" }
      );
    }
    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.getExcel = getExcel;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;
    vm.resetSearch = resetSearch;
    vm.setResponsive = setResponsive;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.setSortColumn = setSortColumn;
    vm.sortClass = sortClass;
    vm.clearPrd = clearPrd;
    vm.openModalPrd = openModalPrd;
    vm.goUnreadList = goUnreadList;

    // 데이터 조회
    getBbsNm();
  },
]);

/* import { chmod } from "fs"; */
/**
 * @ngdoc function
 * @name app.bbspost:h0102-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('NoticeBoardCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'postApi', '$compile', 'modalFactory', '$translate', '$filter',
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} H0102APISvr - H0102APISvr Module
   */
  function NoticeBoardCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, postApi, $compile, modalFactory, $translate, $filter) {

          // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Tenant.getTenantCount'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Tenant.getTenantList';    // 목록 조회 SQL
      var EXCEL_SQL = 'BbsPost.getExcelBbsPostList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.bbspost.notice-board';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.company-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.company-list.edit.tab1';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.company-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.company-edit.tab1';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'tenant'; // 작업 테이블명
      var KEY_COLUMN_NM = 'TenantId'; // Primary Key Column
      var EXCEL_TITLE = '공지사항 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의





    var vm = this;
    vm.dataloader = false;

    vm.openModalUser = openModalUser;
    vm.clearUser = clearUser;

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : 'bbspost', // For CustomColumn and FileAttachment
        sortDirect : '',
        sortColumn : '',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'bbspost'; // For CustomColumn and FileAttachment
      vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
      vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
      vm.currentPage = vm.srch.page;
    }

    vm.keyId = $stateParams.BbsPostId;

    if (!isNullOrEmpty($stateParams.BbsMasterId)) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    } else {
      vm.srch.BbsMasterId = 1;
    }

    vm.BbsNm = '위너스 홈페이지 공지사항';

//    $compile($('#pane'))($scope);

    vm.listSize = [ 10, 25, 50, 100 ];

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.layout);

    // 회원사 변경 설정
    $scope.$on('broadcastSetChangeTenantID', function (event, data) {
      getList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    // // 엑셀
    // vm.excel = {
    //   downFileName : 'BbsPost',
    //   subject : '공지사항 리스트',
    //   header : [ {
    //     field : 'BbsPostId',
    //     title : '번호',
    //     width : '5',
    //     format : 'number'
    //   }, {
    //     field : 'Title',
    //     title : '제목',
    //     width : '20',
    //     format : 'string'
    //   }, {
    //     field : 'RegUserNm',
    //     title : '등록자',
    //     width : '10',
    //     format : 'string'
    //   }, {
    //     field : 'RegDate',
    //     title : '등록일자',
    //     width : '10',
    //     format : 'date'
    //   }, {
    //     field : 'ReadCnt',
    //     title : '조회수',
    //     width : '5',
    //     format : 'string'
    //   }, {
    //     field : 'Reviewer',
    //     title : '평가자',
    //     width : '5',
    //     format : 'string'
    //   } ],
    // };

    /*
    if ($window.sessionStorage.getItem('h0102-list-ctrl') !== null) {
      if ($rootScope.previousPage !== null &&
        ($rootScope.previousPage.indexOf('/app/bbspost/detail') !== -1 ||
        $rootScope.previousPage.indexOf('/app/bbspost/edit') !== -1)) {
        vm.srch = JSON.parse($window.sessionStorage.getItem('h0102-list-ctrl'));
        vm.currentPage = vm.srch.page;
      }
    }
     */

    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.getAddressInfo = getAddressInfo;
    $scope.showDetail = function(li) {
      $location.url('/' + li.BbsPostId);
    };
    vm.srch.ZipCode = "";
    vm.srch.Addr1 = "";
    /* 다음 주소검색 */
    function getAddressInfo(){
      new daum.Postcode({
        oncomplete: function(data) {
          vm.zipCode = data.zonecode;
          vm.addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
          $('#zipCode').val(vm.zipCode);
          $('#addr1').val(vm.addr1);
        },
      }).open();
   }

    /* 사용자검색 */
    function openModalUser() {
      var ctrl = 'UserModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('md', 'components/modal/users/user-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.UserNm = res.UserNm;
        vm.srch.UserId = res.UserId;
      }, function(cancelData) {
      });
    }
    /* 사용자검색- 지우기 */
    function clearUser() {
      vm.srch.UserNm = '';
      vm.srch.UserId = '';
    }

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }


    /* 단품(제품)조회 */
    function openModalPrd() {
      var ctrl = 'ProductModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.ProductNm = res.ProductNm;
        vm.srch.ProductId = res.ProductId;
      }, function(cancelData) {
      });
    }
    /* 단품(제품)조회- 지우기 */
    function clearPrd() {
      vm.srch.ProductId = '';
      vm.srch.ProductNm = '';
    }

    /**
     * 데이터 조회
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      getListCnt();
      vm.dataloader = true;
      vm.viewSize = vm.srch.viewSize;

      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
      data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
      data.selectType = 'List'; // For CustomColumn
      data.mapCode = 'BbsPost.getBbsPostList';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.desc.length > 0) {
            vm.listColumns = result.body.desc;
            angular.forEach(vm.listColumns, function(item) {
              vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }

          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
            setResponsive();
          } else {
            vm.lists = {};
          }
        }
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
      }, function(error) {
        console.error('Error> h0102-list-ctrl> getList()', status, error);
        vm.dataloader = false;
      });

    }

    function getListCnt() {
      var data = angular.copy(vm.srch);
      data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
      data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
      data.mapCode = 'BbsPost.getBbsPostListCnt';
      postApi.select(data, function(result){
        /* console.log("type C", result.header);
        console.log("type c", result.body); */
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.error('Error> h0102-list-ctrl> getListCnt()', status, error);
      });
    }

    function setResponsive(dockMode) {
      var rows =  vm.lists;
      var columns = [];
      var o = {};
      o.breakpoints = ["", "md","lg", "md","xs", "lg", "xs", "md", "lg"];
      //o.formatString = [""];
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function(item) {
        var column = {};
        column.name = item.ColumnPhysicalNm;
        column.title = item.ColumnLogicalNm;
        if(o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }
        if(item.ColumnPhysicalDataType == "40") {
          column.type = "date";
          column.formatString="YYYY-MM-DD";
        }
        index++;
        columns.push(column);
      });

      // if(!checkMobile()) {
      //   var mode = {};
      //   var localStorage = window.localStorage;
      //   (dockMode == undefined) ?
      //     mode.type = localStorage.getItem("dockMode") : mode.type = dockMode;
      //   setDockView($compile, $scope, mode, function(){
      //     $('#searchTextResults').footable({
      //       "columns": columns,
      //       "rows": rows,
      //       "ctrState" : $state,
      //       "key" : "BbsPostId",
      //       "link" : "app.bbspost.h0102-slist.detail",
      //       "srch" : vm.srch,
      //       "FreeBoardId" : 'W'
      //     }, function(ft) {
      //       initFootableEvent(vm,ft, function(e){

      //         var url = "http://localhost:3000/#/app/bbspost/h0102-detail/%257B%2522page%2522%253A1%252C%2522viewSize%2522%253A25%252C%2522BbsMasterId%2522%253A1%252C%2522tableNm%2522%253A%2522bbspost%2522%252C%2522searchColumns%2522%253A%257B%2522Title%2522%253Atrue%252C%2522ExtVarchar01%2522%253Atrue%252C%2522ExtInt01%2522%253Atrue%252C%2522ExtInt02%2522%253Atrue%252C%2522ExtDate01%2522%253Atrue%252C%2522ExtVarchar02%2522%253Atrue%252C%2522ExtDate02%2522%253Atrue%252C%2522RegDate%2522%253Atrue%252C%2522ExtVarchar03%2522%253Atrue%257D%252C%2522userkey%2522%253A%25225GU7YVI51O%2522%252C%2522totalItems%2522%253A%255B32%255D%252C%2522BbsPostId%2522%253A%2522W%2522%257D";
      //         console.log(url);
      //         vm.detailContent = jQuery.get(url);
      //           console.log(vm.detailContent)

      //       });
      //     });
      //   });
      // }
    }


    /**
     * 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function setPageChanged() {
      vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

      // 검색 옵션
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      // 해당 페이지 데이터 조회
      $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
    }

    function setChangeViewSize() {
      vm.currentPage = 1; // 1페이지 부터 조회
      vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

      // 데이터 조회
      getSearch();
    }

    function getSearch() {
//      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.bbspost.notice-board', {srch:srch}, {reload:'app.bbspost.notice-board'});
    }

    function resetSearch() {
      $state.go('app.bbspost.notice-board', {srch : ''}, {reload:'app.bbspost.notice-board'});
    }

    vm.test = test;
    function test(id) {
      return "/app/bbspost/h0102-list/bbspost//"+id;
    }

    function goDetail(BbsPostId) {
      //vm.srch.BbsPostId = BbsPostId;
      var srch = $stateParams.srch;
      vm.keyId = BbsPostId;
      if (vm.layout == 'N') {
        $state.go('app.bbspost.notice-board.detail', {
          srch : srch,
          BbsPostId : BbsPostId,
          BbsMasterId : vm.srch.BbsMasterId
        });
      } else {
        $state.go('app.bbspost.notice-board.detail', {
          srch : srch,
          BbsPostId : BbsPostId,
          BbsMasterId : vm.srch.BbsMasterId
        });
      }
    }

    function goEdit() {
      var srch = $stateParams.srch;
      vm.keyId = '';
      if (vm.layout == 'N') {
        $state.go('app.bbspost.notice-board.edit', {
          srch : srch, BbsPostId : '', BbsMasterId : 1
        });
      } else {
        $state.go('app.bbspost.notice-board.edit', {
          srch : srch, BbsPostId : '', BbsMasterId : 1
        });
      }
    }

    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch(vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "480px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem('layoutBoard', layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go('app.bbspost.notice-board', {
        srch : srch
      }, {reload: 'app.bbspost.notice-board'});
    }

    function getBbsNm() {
      var data = {BbsMasterId:vm.srch.BbsMasterId};
      data.mapCode = 'BbsMaster.getBbsMasterDetail';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.BbsNm = result.body.docs[0].BbsNm;
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error> notice-board-ctrl> getList()', status, error);
        vm.dataloader = false;
      });
    }

/**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if (vm.lists.length == undefined) {
          gAlert("", "조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if (vm.lists.length == 0) {
          gAlert("", "Menu.데이터가 없습니다.");
          return;
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;
        console.log(data);

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            /*
            angular.forEach(vm.columnMap, function (item) {
              obj.push(item.ColumnLogicalNm);
            });
            */
            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              obj = [];
              angular.forEach(vm.columnMap, function (item) {
                if (item.ColumnPhysicalNm == 'BirthDay' || item.ColumnPhysicalNm == 'CustRegDt' || item.ColumnPhysicalNm == 'LastVisitDt') {
                  if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                    obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
                else {
                  obj.push(value[item.ColumnPhysicalNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }

    // 함수 선언
    vm.getList = getList;
    vm.getExcelFile = getExcelFile;
    vm.setChangeViewSize = setChangeViewSize;
    vm.setPageChanged = setPageChanged;
    vm.getSearch = getSearch;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;
    vm.resetSearch = resetSearch;
    vm.setResponsive = setResponsive;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.tablesort = tablesort;
    vm.sortClass = sortClass;
    vm.clearPrd = clearPrd;
    vm.openModalPrd = openModalPrd;

    // 데이터 조회
    getBbsNm();
    getList();

  }
]);


(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.bbspost:h0102-detail-ctrl
 * @description # 게시판 조회 Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('NoticeBoardDetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$filter', 'GLOBAL_CONSTANT', 'StaticVariable', 'H0102APISrv', 'gAlert', 'gConfirm',
    'fileUploadService', 'postApi', 'customFieldApi', '$rootScope',

    /**
     * 게시판 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          H0102APISvr - H0102APISvr Module
     * @param {object}
     *          gAlert - Alert Module
     * @param {object}
     *          gConfirm - Confirm Module
     * @param {object}
     *          fileUploadService - fileUploadService Module
     */
    function NoticeBoardDetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, gConfirm, fileUploadService, postApi, customFieldApi, $rootScope) {
      // View Model
      var vm = this;
      vm.dataloader = false;

      vm.srch = {};
      if (!$stateParams.srch) {
        vm.srch = {
          page : 1,
          viewSize : CONSTANT.PAGINATION.VIEWSIZE,
          tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'bbspost', // For CustomColumn and FileAttachment
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.layout = $rootScope.gVariable.layoutBoard;

      if (!isNullOrEmpty($stateParams.BbsMasterId)) {
        vm.srch.BbsMasterId = $stateParams.BbsMasterId;
      } else {
        vm.srch.BbsMasterId = 1;
      }

      if (!isNullOrEmpty($stateParams.BbsPostId)) {
        vm.srch.BbsPostId = $stateParams.BbsPostId;
      }

      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
      vm.srchDetail.selectType = "Detail"; // For CustomColumn and FileAttachment

      // 조회 데이터
      vm.data = {
        TableNm : vm.srchDetail.TableNm,
        BbsPostId : vm.srchDetail.BbsPostId,
      };

      // 댓글
      vm.comment = {};

      // 댓글 조회 조건
      vm.srchReply = {
        BbsMasterId : vm.srch.BbsMasterId != '' ? vm.srch.BbsMasterId : 1,
        tableNm : 'bbspostcomm', // For CustomColumn and FileAttachment
        BbsPostId : vm.srch.BbsPostId,
        TableId : vm.srch.BbsPostId,
        IdName : 'BbsPostCommId', // For CustomColumn and FileAttachment
        viewSize : 100,
        LastId : 0,
      };
      // 옵션
      vm.items = [ {
        name : '공유',
        icon : 'zmdi zmdi-share'
      }, {
        name : '업로드',
        icon : 'zmdi zmdi-upload'
      }, {
        name : '복사',
        icon : 'zmdi zmdi-copy'
      }, {
        name : '현재 페이지 인쇄',
        icon : 'zmdi zmdi-print'
      }, ];

      // 업로드 파일 목록
      var fileUploadId = 0;
      vm.uploadFileList = [];
      vm.uploadFileListReply = [];

      (function NoticeBoardDetailCtrl() {
        console.log('NoticeBoardDetailCtrl:');
      })();

      /**
       * 조회수 증가
       *
       * @param
       * @return
       */
      function updateReadCnt() {
        //doUpdateReadCnt없ㅇ므
        var prms = h0102Api.doUpdateReadCnt().post(vm.srch).$promise;
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getFileList() {

        var data = vm.srchDetail;
        data.viewColumns = {};
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              var uploadFileList = [];

              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
              return;
            }
          }
        },function(error) {
          console.error('Error> Notice-Board-detail-ctrl> getFileList()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }
      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment
        postApi.select('BbsPost.getBbsPostDetail', vm.srchDetail, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              console.log($filter('utcToLocal')(vm.data.RegDate,'yyyy-MM-dd h:mm a'));

              var uploadFileList = [];
              console.log("File", vm.data);
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> Notice-Board-edit-ctrl> getData()', status, error);
          vm.dataloader = false;
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      // 원본 이벤트
      var originatorEv;

      /**
       * 평점 표시
       *
       * @param {object}
       *          $mdOpenMenu - Open Menu Object
       * @param {object}
       *          ev - ev Object
       * @return
       */
      function openMenu($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteData() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDataAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 데이터 삭제
       *
       * @param
       * @return
       */
      function deleteDataAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        // 업로드 파일 목록
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        var data = vm.srchDetail;
        data.RelateDataId = data.BbsPostId;
        data.mapCode = 'BbsPost.deleteBbsPost';
        console.log(data);
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                var srch = $stateParams.srch;
                $state.go('app.bbspost.notice-board', {
                  srch:srch
                }, {reload:'app.bbspost.notice-board'});
              }
            });
            return;
          }
        }, function(error) {
          console.error('Error> notice-board-detail-ctrl> deleteDataAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * Object Append 함수
       *
       * @param
       * @return
       */
      Array.prototype.append = function(array) {
        this.push.apply(this, array);
      }

      /**
       * 댓글 조회
       *
       * @param
       * @return
       */
      function getComment() {


        var data = vm.srchReply;
        data.mapCode = 'BbsPost.getBoardComment';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (vm.comment.lists == null) {
                vm.comment.lists = result.body.docs;
              } else {
                vm.comment.lists.append(result.body.docs);
              }
              vm.srchReply.LastId = result.body.docs[result.body.docs.length - 1].BbsPostCommId;
              return;
            }
          }
        }, function(error) {
          console.error('Error> notice-board-detail-ctrl> getReply()', status, error);
          gAlert('', result.body.docs[0].errMessage, {
            btn : '',
            fn : function() {
              var srch = $stateParams.srch;
              $state.go('app.bbspost.notice-board', {
                srch : srch
              });
            }
          });
        });
      }

      /**
       * 댓글 저장
       *
       * @param
       * @return
       */
      function saveComment() {
        if (angular.isUndefined(vm.srchReply.Contents) || vm.srchReply.Contents == null || vm.srchReply.Contents == '') {
          gAlert('', 'Menu.NOCONTENTS');
          return;
        }

        // 업로드 파일 목록
        vm.srchReply['uploadFileList'] = vm.uploadFileListReply;

        var data = vm.srchReply;
        data.mapCode = 'BbsPost.insertBoardComment';
        postApi.insert(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (result.body.docs[0].BbsPostCommId != 0) {
                vm.srchReply.Contents = '';
                vm.srchReply.uploadFileList = [];
                vm.uploadFileListReply = [];
                // 댓글 조회
                getComment();
                return;
              }
            }
          }
          console.error('Error> notice-board-detail-ctrl> saveComment()', status, data);
          gAlert('', result.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error> notice-board-detail-ctrl> saveComment()', status, error);
          gAlert('', result.body.docs[0].errMessage);
        });
      }

      // 파일 삭제
      vm.setDeleteFileToggle = setDeleteFileToggle;

      /**
       * 파일 삭제
       *
       * @param
       * @return
       */
      function setDeleteFileToggle(replyObj) {
        var idx = -1;

        angular.forEach(vm.comment.lists, function(val, key) {
          if (val == replyObj) {
            idx = key;
            return;
          }
        });

        if (vm.comment.lists[idx].delState === '') {
          vm.comment.lists[idx].delState = 'delete';
        } else {
          vm.comment.lists[idx].delState = '';
        }
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteComment(replyObj) {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteCommentAction(replyObj);
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 댓글 삭제
       *
       * @param
       * @return
       */
      function deleteCommentAction(replyObj) {
        var srch = {
          BbsPostCommId : replyObj.BbsPostCommId,
          tableNm : "BbsPostComm",
          TableId : replyObj.BbsPostCommId
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : replyObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName : replyObj.LogicalFileNm,
            size : replyObj.FileSize,
            fileKey : replyObj.PhysicalFileNm,
            path : replyObj.PhysicalFolderNm,
            downloadCnt : replyObj.DownloadCnt,
            delState : 'delete',
            typeId : 'file',
          };
          uploadFileList.push(obj);
          srch['uploadFileList'] = uploadFileList;
        }
        var data = srch;
        data.mapCode = 'BbsPost.deleteBoardComment';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            console.log('result',result);
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function(item, index, object) {
                if (item.BbsPostCommId == replyObj.BbsPostCommId) {
                  object.splice(index, 1);
                }
              });
              return;
            }
          }
          gAlert('', result.body.docs[0].errMessage);
        },  function(error) {
          console.error('Error> notice-board-detail-ctrl> deleteCommentAction()', status, error);
          gAlert('', error.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editComment(BbsPostCommId) {
        vm.comment.editid = BbsPostCommId;

        vm.comment.lists.forEach(function(item, index, object) {
          if (item.BbsPostCommId === BbsPostCommId) {
            vm.comment.editContents = item.Contents;
          }
        });
      }

      /**
       * 댓글 수정
       *
       * @param
       * @return
       */
      function editCommentAction(replyObj) {
        var srch = {
          BbsPostCommId : replyObj.BbsPostCommId,
          Contents : vm.comment.editContents,
          TableNm : "BbsPostComm",
          TableId : replyObj.BbsPostCommId,
        };

        if (replyObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : replyObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable.getUrl('/attach/file/' + replyObj.PhysicalFileNm + '/download.do?path=' + replyObj.PhysicalFolderNm + '&fileName=' + replyObj.LogicalFileNm),
            fileName : replyObj.LogicalFileNm,
            size : replyObj.FileSize,
            fileKey : replyObj.PhysicalFileNm,
            path : replyObj.PhysicalFolderNm,
            downloadCnt : replyObj.DownloadCnt,
            delState : replyObj.delState,
            typeId : "file",
          }
          uploadFileList.push(obj);

          srch['uploadFileList'] = uploadFileList;
        }

        var data = srch;
        data.mapCode = 'BbsPost.updateBoardComment';
        postApi.update(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0].BbsPostCommId != 0) {
              vm.comment.lists.forEach(function(item, index, object) {
                if (item.BbsPostCommId === replyObj.BbsPostCommId) {
                  item.Contents = result.body.docs[0].Contents;
                  vm.comment.editid = null;

                  if (item.delState === 'delete') {
                    item.AttachmentId = '';
                    item.PhysicalFileNm = '';
                    item.PhysicalFolderNm = '';
                    item.LogicalFileNm = '';
                    item.FileSize = '';
                    item.DownloadCnt = '';
                    item.delState = '';
                  }
                }
              });
              return;
            }
          }
          gAlert('', result.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error> notice-board-detail-ctrl> editCommentAction()', status, error)
          gAlert('', error.body.docs[0].errMessage);
        });
      }

      /**
       * 댓글 수정 취소
       *
       * @param
       * @return
       */
      function editCommentCancel() {
        vm.comment.editid = null;
        vm.comment.editContents = null;
      }

      vm.openDilalog = openDilalog;

      /**
       * 첨부파일 오픈 다이얼로그
       *
       * @param
       * @return
       */
      function openDilalog() {
        angular.element('#file-5').trigger("click");
      }

      var fileElement = angular.element('#file-5');
      fileElement.bind('change', function() {
        uploadFiles(fileElement[0].files);
      });

      vm.uploadFiles = uploadFiles;

      /**
       * 첨부파일 업로드
       *
       * @param {object}
       *          files - 첨부 파일
       * @return
       */
      function uploadFiles(files) {
        var tempIds = [];

        // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
        $scope.$root.safeApply(function() {
          var hasZeroByteFile = false;

          angular.forEach(files, function(value) {
            if (value.size == 0) {
              hasZeroByteFile = true;
            } else {
              var obj = {
                isLoaded : false,
                fileName : value.name,
                size : value.size,
                id : fileUploadId,
                delState : ''
              };

              tempIds.push(obj);

              if (vm.uploadFileListReply == null)
                vm.uploadFileListReply = new Array();
              vm.uploadFileListReply.push(angular.copy(obj));
              fileUploadId++;
            }
          });

          if (hasZeroByteFile) {
            gAlert('', 'Menu.NOCONTENTS');
            return;
          }

          var request = fileUploadService.post(files, null, function(percent) {
            // -- 진행율 표시
            angular.forEach(tempIds, function(obj) {
              $('#filectl' + ' .progress .progress-bar').css('width', percent + '%');
            });

            if (percent == 100) {
              vm.showLoading = true;
            }
          });

          try {
            request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey='+$rootScope.gVariable.userKey)).then(function(value) {
              angular.forEach(value.data.responseVO.body.docs, function(item) {
                angular.forEach(vm.uploadFileListReply, function(obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.tmpFileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl("/attach/temp/" + item.tmpFileKey + "/download.do?userkey=" + $rootScope.gVariable.userKey + "&fileName=" + item.encFileName);
                    obj.delState = '';
                  }
                });
              });

              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element('#file-5').val(null);

              vm.showLoading = false;
            }, function(error) {
              console.error('Error> notice-board-detail-ctrl> uploadFiles()', status, error);
            });
          } catch (error) {
            console.error('Error> notice-board-detail-ctrl> uploadFiles()', status, error);
          }
        });
      }
      ;

      vm.onDelete = onDelete;

      /**
       * 첨부파일 삭제 이벤트
       *
       * @param
       * @return
       */
      function onDelete(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          if (vm.uploadFileListReply[idx].typeId == "temp") {
            var prms = fileUploadService.attachFileDelete().get({
              attachId : vm.uploadFileListReply[idx].tmpFileKey
            }).$promise;

            prms.then(function(data) {
              console.log('Success> notice-board-detail-ctrl> onDelete()', data);
            }, function(error) {
              console.error('Error> notice-board-detail-ctrl> onDelete()', status, error);
            })
            vm.uploadFileListReply.splice(idx, 1);
          } else if (vm.callback) {
            vm.uploadFileListReply[idx].delState = 'delete';
          }
        }
      }
      ;

      vm.onDeleteCancel = onDeleteCancel;

      /**
       * 첨부파일 삭제 취소 이벤트
       *
       * @param
       * @return
       */
      function onDeleteCancel(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListReply, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          vm.uploadFileListReply[idx].delState = '';
        }
      }

      function goList() {
        var srch = $stateParams.srch;
        $state.go('app.bbspost.notice-board', {
          srch : srch
        });
      }

      function goEdit() {
        var srch = $stateParams.srch;
        if (vm.layout == 'N') {
          $state.go('app.bbspost.notice-board.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : 1
          });
        } else {
          $state.go('app.bbspost.notice-board.edit', {
            srch : srch, BbsPostId : vm.data.BbsPostId, BbsMasterId : 1
          });
        }
      }

      function openAttachment(li) {
        window.location = StaticVariable.getUrl('/attach/file/' + li.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + li.PhysicalFolderNm + "&fileName=" + li.LogicalFileNm);
      }

      // 함수 선언
      vm.getData = getData;
      vm.getComment = getComment;
      vm.deleteData = deleteData;
      vm.saveComment = saveComment;
      vm.deleteComment = deleteComment;
      vm.editComment = editComment;
      vm.editCommentAction = editCommentAction;
      vm.editCommentCancel = editCommentCancel;
      vm.openMenu = openMenu;
      vm.goList = goList;
      vm.goEdit = goEdit;
      vm.openAttachment = openAttachment;

      // 데이터 조회
      getData();

      getComment();
    } ]);
  })();

/**
 * @ngdoc function
 * @name app.bbspost:h0102-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("NoticeBoardEditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "H0102APISrv", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout',
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} H0102APISvr - H0102APISvr Module
   * @param {object} gAlert - Alert Module
   */
  function NoticeBoardEditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, h0102Api, gAlert, postApi, customFieldApi, $rootScope, $timeout) {
    // View Model
    var LIST_PAGE_URL = 'app.bbspost.notice-board';             // 목록 화면
    var LIST_VIEW_PAGE_URL = 'app.bbspost.notice-board.detail'; // 목록 상세 화면
    var VIEW_PAGE_URL = 'app.bbspost.notice-board.detail';           // 상세 화면

    var vm = this;
    vm.vault = null;

    vm.dataloader = false;
    vm.boardTypes = ["공지사항", "NewsLetter", "위너스 소식"];


    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'bbspost', // For CustomColumn and FileAttachment
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if (!isNullOrEmpty($stateParams.BbsMasterId)) {
      vm.srch.BbsMasterId = $stateParams.BbsMasterId;
    } else {
      vm.srch.BbsMasterId = 1;
    }

    if (!isNullOrEmpty($stateParams.BbsPostId)) {
      vm.srch.BbsPostId = $stateParams.BbsPostId;
    }

    vm.srchDetail = {};
    vm.columnMap = {};
    angular.copy(vm.srch, vm.srchDetail);
    vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
    vm.srchDetail.IdName = 'BbsPostId'; // For CustomColumn and FileAttachment
    vm.srchDetail.selectType = "Edit"; // For CustomColumn and FileAttachment

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 조회 데이터
    vm.data = {
      BbsMasterId: vm.srch.BbsMasterId != null ? vm.srch.BbsMasterId : 1,
      tableNm: vm.srch.tableNm,
      BbsPostId: vm.srch.BbsPostId
    };

    (function H0102EditCtrl() {
      console.log('notice-board.Ctrl:');
    })();

    // 첨부파일 Callback
    vm.onFileCallback = {
      onFileUploaded: function (id, result) {
        // 첨부파일 업로드 완료
        $scope.$apply(function () {
          angular.forEach(result.body.docs, function (item) {
            var obj = item;
            obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
            vm.uploadFileList.push(obj);
          });
        });
      },
      onFileUploadComplete: function (id) {
        // 첨부파일 업로드 이후 저장을 호출해야 함
        if (id == 'vault') {
          $timeout(setData, 1);
        }
      },
      onFileDelete: function(item) {
        console.log("delete item::", item);
        var param = {
          fileId: item.id
        };

        var prms = h0102Api.attachFileDelete().post(param).$promise;
        prms.then(function(data) {
          console.log(data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            gAlert("", "Menu.DELETED");
          }
        });
      },
      onLoaded: function(id, vault) {
        vm[id] = vault;
      }
    };

    /**
     * 사용자정의 컬럼 모델 설정
     *
     */
    function setUdcModel() {
      angular.forEach(Object.keys(vm.data), function(item) {
        // 사용자정의 컬럼 모델
        if (vm.udcDataType[item] == "40") {
          vm.udcModel[item] = $filter("date")(vm.data[item], "yyyy-MM-dd");
        } else {
          vm.udcModel[item] = vm.data[item];
        }
      });
    }

    /**
     * 첨부파일 목록 조회
     * @param
     * @return
     */
    function getFileList() {
      if (vm.srch.BbsPostId == null || vm.srch.BbsPostId == '0') {
        vm.dataloader = false;
        return;
      }

      var data = vm.srch;
      data.mapCode = "FileAttach.getFileList";
      postApi.select(data,
        function(result) {
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (!vm.showUploader) {
              // AngularJS Version
              var uploadFileList = [];
              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id: item.fileId,
                  isLoaded: true,
                  link: StaticVariable.getUrl(
                    "/attach/file/" +
                      item.PhysicalFileNm +
                      "/download.do?path=" +
                      item.PhysicalPath +
                      "&fileName=" +
                      item.LogicalFileNm
                  ),
                  fileName: item.LogicalFileNm,
                  size: item.FileSize,
                  fileKey: item.PhysicalFileNm,
                  typeId: "file",
                  path: item.PhysicalPath,
                  downloadCnt: item.DownloadCnt,
                  delState: ""
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);

            }
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;
      vm.showUploader = enableUploadComponent();
      initVaultComponent('vault', vm.onFileCallback);

      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.viewColumns = {}; // For CustomColumn and FileAttachment

      postApi.select("BbsPost.getBbsPostDetail", vm.srchDetail,
        function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              var uploadFileList = [];

              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                };
                uploadFileList.push(obj);
              });

              angular.copy(uploadFileList, vm.uploadFileList);
            }
            console.log("map",vm.columnMap);
          }

          vm.dataloader = false;

          if (result.body.docs != null && result.body.docs[0].errMessage) {
            console.table(result);
          }
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    vm.uploadFile = function() {
      if (vm.vault != null && vm.vault.data.getLength() > 0) {
        uploadVaultFile(vm.vault);
      } else {
        setData();
      }
    };

    /**
     * 데이터 저장
     * @param
     * @return
     */
    function setData() {
      // 내용
      vm.dataloader = true;
      oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);

      vm.data.BbsMasterId = vm.srch.BbsMasterId;
      vm.data.Contents = $("#strHtml").val();
      vm.data.tableNm = 'bbspost';
      vm.data.RelateDataId = vm.data.BbsPostId;
      vm.data.IdName = "BbsPostId";
      vm.data.uploadFileList = vm.uploadFileList;
      vm.data.userkey = vm.srch.userkey;

      var data = vm.data;
      if (vm.data.BbsPostId == null || vm.srch.BbsPostId == "0") {
        // 등록
        data.mapCode = "BbsPost.insertBbsPost";
        postApi.insert(
          data,
          function(result) {
            InsertUpdateDetail(result);
          },
          function(error) {
            dataloader = false;
            console.table(error);
          }
        );
      } else {
        // 수정
        data.mapCode = "BbsPost.updateBbsPost";
        postApi.update(
          data,
          function(result) {
            InsertUpdateDetail(result);
          },
          function(error) {
            dataloader = false;
            console.table(error);
          }
        );
      }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (
          result.body.docs[0].BbsPostId !== null ||
          result.body.docs[0].KeyId !== null
        ) {
          // KeyId 조회
          vm.data.BbsPostId = result.body.docs[0].RelateDataId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              goNextPage(true);
            }
          });
        }
      }

      dataloader = false;

      if (result.body.docs != null && result.body.docs[0].errMessage != null)
        console.table(result);
    }

    function goList() {
      vm.srch.BbsPostId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(LIST_PAGE_URL, { srch: srch });
    }

    function goNextPage(reloadList) {
      var srch = $stateParams.srch; // 검색 옵션

      if (vm.layout == 'N') {
        if (isNullOrEmpty(vm.srch.BbsPostId)) {
          // 신규등록 -> 목록 화면 이동
          $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
        } else {
          // 수정 -> 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            BbsPostId: vm.data.BbsPostId,
            BbsMasterId : 1
          }, {reload:VIEW_PAGE_URL});
        }
      } else {
        if (reloadList) {
          vm.srch.BbsPostId = "";
          vm.srch.reload = (new Date()).getTime();
          srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        }
        // 조회 화면 이동
        $state.go(LIST_VIEW_PAGE_URL, {srch: srch, BbsPostId: vm.data.BbsPostId, BbsMasterId : 1});
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;

    // 데이터 및 사용자정의 컬럼 모델 설정
    getData();
  }
]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.bbspost:popup-list-ctrl
 * @description
 * # 게시판 목록
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller('PopupListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'postApi', 'DTOptionsBuilder', 'DTColumnBuilder', '$compile', 'modalFactory',
  /**
   * 게시판 - 목록화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} $rootScope - rootscope object
   * @param {object} H0102APISvr - H0102APISvr Module
   */
  function PopupListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, postApi,DTOptionsBuilder, DTColumnBuilder, $compile, modalFactory) {

    var vm = this;
    /* 사용자검색 */
    function openModalUser() {
      var ctrl = 'UserModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.UserNm = res.UserNm;
        vm.srch.UserId = res.UserId;
      }, function(cancelData) {
      });
    }
    /* 사용자검색- 지우기 */
    function clearUser() {
      vm.srch.UserNm = '';
      vm.srch.UserId = '';
    }

    vm.srch = {
      ZipCode : "",
      Addr1 : ""
    }

    /* 다음 주소검색 */
    function getAddressInfo(){
      new daum.Postcode({
        oncomplete: function(data) {
          vm.zipCode = data.zonecode;
          vm.addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
          $('#zipCode').val(vm.zipCode);
          $('#addr1').val(vm.addr1);
        },
      }).open();

    }

    /* 단품(제품)조회 */
    function openModalPrd() {
      var ctrl = 'ProductModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('md', 'components/modal/product/product-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.ProductNm = res.ProductNm;
        vm.srch.ProductId = res.ProductId;
      }, function(cancelData) {
      });
    }
    /* 단품(제품)조회- 지우기 */
    function clearPrd() {
      vm.srch.ProductId = '';
      vm.srch.ProductNm = '';
    }

    /* 관리권 검색 */
    vm.srch = {
      CareTktNm : '',
      CareTktId : ''
    }
    function openModalCareTkt() {
      var ctrl = 'CareTktModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('md', 'components/modal/careTkt/care-tkt-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {

        vm.srch.CareTktNm = res.CareTktNm;
        vm.srch.CareTktId = res.KeyId;

      }, function(cancelData) {
      });
    }
    /* 관리권검색- 지우기 */
    function clearCareTkt() {
      vm.srch.CareTktNm = '';
      vm.srch.CareTktId = '';
    }


    /* 고객검색 */
    function openModalCustomer() {
      var ctrl = 'CustomerModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('lg', 'components/modal/customer/customer-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.CustNm = res.CustNm;
        vm.srch.CustId = res.CustId;
      }, function(cancelData) {
      });
    }
    /* 고객검색- 지우기 */
    function clearCustomer() {
      vm.srch.CustNm = '';
      vm.srch.CustId = '';
    }

    // 함수 선언

    vm.clearPrd = clearPrd;
    vm.openModalPrd = openModalPrd;
    vm.openModalUser = openModalUser;
    vm.clearUser = clearUser;
    vm.getAddressInfo = getAddressInfo;
    vm.openModalCareTkt = openModalCareTkt;
    vm.clearCareTkt = clearCareTkt;
    vm.clearCustomer = clearCustomer;
    vm.openModalCustomer = openModalCustomer;
  },
]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.chatting', {
      url : '/chatting',
      template : '<div ui-view></div>',
    }).state('app.chatting.h0201-roomlist', {
			url : '/h0201-roomlist?srch/:ChatUserId/:WorkerId',
			templateUrl : 'app/chatting/h0201-roomlist.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }]
      },
      cache: false,
		}).state('app.chatting.h0201-roomdetail', {
			url : '/h0201-roomdetail?srch/:FreeChatId',
			templateUrl : 'app/chatting/h0201-roomdetail.html',
			cache: false,
		}).state('app.chatting.h0201-roomedit', {
			url : '/h0201-roomedit?srch/:FreeChatId',
			templateUrl : 'app/chatting/h0201-roomedit.html',
		}).state('app.chatting.h0201-chat', {
			url : '/h0201-chat/:UserId',
			templateUrl : 'app/chatting/h0201-roomdetail.html',
		}).state('app.chatting.h0201-chatlist', {
			url : '/h0201-chatlist',
			templateUrl : 'app/chatting/h0201-chatlist.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.bootstrap.min.css',
          ]);
        }]
      }
		}).state('app.chatting.h0201-roomlist.edit', {
      url : '/edit/:FreeChatId',
      templateUrl : 'app/chatting/h0201-roomedit.html',
    }).state('app.chatting.h0201-roomlist.detail', {
      url : '/detail/:FreeChatId',
      templateUrl : 'app/chatting/h0201-roomdetail.html',
    });
  }
})();

(function() {
  'use strict';
webapp.service('H0201APISrv', [ '$resource', 'StaticVariable', '$rootScope', function H0201APISrv($resource, StaticVariable, $rootScope) {
    console.log('H0201APISrv');
    var h0201Api = {
      doListCnt : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/selectChatCount.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doExcel : function() {
        return $resource(StaticVariable.getUrl('/excel/FreeChat.getExcelChatList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateReadCnt : function() {
        return $resource(StaticVariable.getUrl('/update/FreeChat.updateChatReadCnt/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doFileList : function() {
        return $resource(StaticVariable.getUrl('/select/FileAttach.getFileList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doComment : function() {
        return $resource(StaticVariable.getUrl('/select/FreeChat.getChatComment/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail : function() {
        return $resource(StaticVariable.getUrl('/insert/FreeChat.insertChatDetail/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doSaveAttachFile : function() {
        return $resource(StaticVariable.getUrl('/attach/saveAttachFile.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doSaveComment : function() {
        return $resource(StaticVariable.getUrl('/insert/FreeChat.insertChatComment/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doDeleteComment : function() {
        return $resource(StaticVariable.getUrl('/update/FreeChat.deleteChatComment/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateComment : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/updateChatComment.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      attachFileDelete : function() {
        return $resource(StaticVariable.getUrl('/attach/file/delete.do'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doCreateDetail : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/createChat.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doViewDetail : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/viewChat.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doList : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/selectChat.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      updateReadFreeChatCommId : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/updateReadFreeChatCommId.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/updateChat.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doDelete : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/leaveChat.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doChatListCnt : function() {
        return $resource(StaticVariable.getUrl('/select/FreeChat.getAllChatCommCount/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doChatList : function() {
        return $resource(StaticVariable.getUrl('/select/FreeChat.getAllChatCommList/action.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
      doChatTaskCount : function() {
        return $resource(StaticVariable.getUrl('/api/freechat/selectChatTaskCount.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
      },
    };
    return h0201Api;
  } ]);
})();

(function() {
  'use strict';

webapp.controller('H0201ChatListCtrl', [
    '$window',
    '$scope',
    '$location',
    '$state',
    '$stateParams',
    '$rootScope',
    '$translate',
    'GLOBAL_CONSTANT',
    'H0201APISrv',
    function H0201ChatListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, CONSTANT, h0201Api) {
      var vm = this;
      vm.dataloader = false;

      console.log("$stateParams", $stateParams);
      if ($stateParams.page == undefined || $stateParams.page == "") {
        vm.currentPage = 1;
      } else {
        vm.currentPage = $stateParams.page;
      }

      vm.srch = {
        remark : '',
      };

      vm.listSize = [ 10, 25, 50, 100 ];

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
      vm.srch.ChatId = '1';
      vm.srch.viewSize = vm.viewSize;
      vm.srch.AllMsg = 'Y';

      /** 보기페이지로 갔다가 목록으로 올때, 이전 페이지 검색값 유지하기 위함 */
      if ($window.sessionStorage.getItem('h0201-chatlist-ctrl') != null) {
        console.log('H0201ListCtrl previousPage:', $rootScope.previousPage, '===', '/app/chatting/h0201-chatlist');
        if ($rootScope.previousPage != null
            && ($rootScope.previousPage.indexOf('/app/chatting/h0201-roomedit') !== -1 || $rootScope.previousPage.indexOf('/app/chatting/h0201-roomdetail') !== -1 || $rootScope.previousPage
                .indexOf('/app/chatting/h0201-chatlist') !== -1)) {
          vm.srch = JSON.parse($window.sessionStorage.getItem('h0201-chatlist-ctrl'));
          vm.currentPage = vm.srch.page;
        }
      }

      $scope.showDetail = function(li) {
        $location.url('/' + li.ntcIdx);
      };

      vm.pageChanged = pageChanged;
      vm.getList = getList;
      vm.getListCnt = getListCnt;
      vm.changeViewSize = changeViewSize;
      vm.getExcel = getExcel;

      function pageChanged() {
        console.log('vm.currentPage=', vm.currentPage, ',vm.srch.page=', vm.srch.page);
        // $state.go("app.h0201.roomlist");
        vm.srch.page = vm.currentPage;
        getList();
        // $location.path('/app/chatting/h0201-roomlist/' +
        // vm.srch.ChatId + "/" + vm.currentPage, false);
      }

      function getListCnt() {

        var prms = h0201Api.doChatListCnt().post(vm.srch).$promise;

        prms.then(

        function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalItems = data.responseVO.body.docs[0];
          }
        },

        function(error) {
          console.error('fail', status, data);
        });
      }

      function getList() {
        vm.viewSize = vm.srch.viewSize;

        getListCnt();

        $window.sessionStorage.setItem("h0201-chatlist-ctrl", angular.toJson(vm.srch));

        vm.dataloader = true;
        var prms = h0201Api.doChatList().post(vm.srch).$promise;

        prms.then(

        function(data) {
          vm.dataloader = false;
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            vm.lists = getContentsData(data.responseVO.body.docs);
          }
        },

        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }

      function changeViewSize() {
        vm.currentPage = 1;
        getList();
      }

      function getContentsData(obj) {
        return obj.map(function(veg) {
          if (veg.FreeChatType == 'S') {
            var json = JSON.parse(veg.Contents);
            veg.Contents = json.UserNm + ' ' + $translate.instant(json.Message);
          }

          return veg;
        });
      }

      function getExcel() {

        vm.excel.param = vm.srch;

        var prms = h0201Api.doExcel().post(vm.excel).$promise;

        prms.then(

        function(data) {
        },

        function(error) {
          console.error('fail', status, data);
        });

      }

      getList();
    } ]);
})();

(function() {
  'use strict';

webapp.directive('enterSubmit', function () {
  return {
    restrict: 'A',
    link: function (scope, elem, attrs) {

      elem.bind('keydown', function(event) {
        var code = event.keyCode || event.which;

        if (code === 13) {
          if (!event.shiftKey) {
            event.preventDefault();
            scope.$apply(attrs.enterSubmit);
          }
        }
      });
    }
  };
});

webapp.controller('H0201RoomDetailCtrl', ['$window', '$scope', '$rootScope', '$location', '$state', '$stateParams', '$translate', '$timeout', '$anchorScroll', 'GLOBAL_CONSTANT', 'StaticVariable',
    'postApi', 'gAlert', 'gConfirm', 'fileUploadService',
    function H0201DetailCtrl($window, $scope, $rootScope, $location, $state, $stateParams, $translate, $timeout, $anchorScroll, CONSTANT, StaticVariable, postApi, gAlert, gConfirm, fileUploadService) {
      var vm = this;
      vm.dataloader = false;

      vm.page = $stateParams.page;
      vm.layout = $rootScope.gVariable.layoutBoard;

      vm.srch = {
        UserId : $stateParams.UserId,
        FreeChatId : $stateParams.FreeChatId,
        IdName : 'FreeChatId',
        tableNm : 'freechat',
        ChatId : '1',
        uploadFileList : [],
      };
      //console.log("detail load vm.srch", vm.srch);
      vm.comment = {};

      vm.srchComment = {
        FreeChatId : $stateParams.FreeChatId,
        tableNm : "freechatcomm",
        viewSize : 10,
        ChatId : '1',
      };

      vm.items = [ {
        name : 'Share',
        icon : 'zmdi zmdi-share'
      }, {
        name : 'Upload',
        icon : 'zmdi zmdi-upload'
      }, {
        name : 'Copy',
        icon : 'zmdi zmdi-copy'
      }, {
        name : 'Print this page',
        icon : 'zmdi zmdi-print'
      } ];

      var id = 0;

      vm.data = {};
      vm.uploadFileList = [];
      vm.uploadFileListComment = [];

      vm.saveDetail = saveDetail;
      vm.getDetail = getDetail;
      vm.updateReadCnt = updateReadCnt;
      vm.getFileList = getFileList;
      vm.getPrevComment = getPrevComment;
      vm.getNextComment = getNextComment;
      vm.getComment = getComment;
      vm.editDetail = editDetail;
      vm.deleteDetail = deleteDetail;
      vm.deleteDetailAction = deleteDetailAction;
      vm.saveComment = saveComment;
      vm.deleteComment = deleteComment;
      vm.deleteCommentAction = deleteCommentAction;
      vm.editComment = editComment;
      vm.editCommentAction = editCommentAction;
      vm.editCommentCancel = editCommentCancel;
      vm.ngRepeatFinished = ngRepeatFinished;
      vm.goList = goList;

      if (vm.srch.FreeChatId != null) {
        console.log('vm.srch.FreeChatId=', vm.srch.FreeChatId);
        getDetail();
        getComment(true);
        getCommentCnt(true);
      } else if (vm.srch.UserId != null) {
        console.log('vm.srch.UserId=', vm.srch.UserId);
        saveDetail();
        return;
      }

      function saveDetail() {
        vm.data = {};
        vm.data.ChatId = 1;
        vm.data.Title = '대화';
        vm.data.Participants = ':' + $window.sessionStorage['loginUserIdx'] + '::' + vm.srch.UserId + ':';
        vm.data.tableNm = 'freechat';
        vm.data.IdName = 'FreeChatId';
        if ($window.sessionStorage['loginUserIdx'] != vm.srch.UserId) {
          vm.data.FreeChatUser = [ {
            UserId : $window.sessionStorage['loginUserIdx']
          }, {
            UserId : vm.srch.UserId
          } ];
        } else {
          vm.data.FreeChatUser = [ {
            UserId : $window.sessionStorage['loginUserIdx']
          } ];
        }

        //console.log("vm.uploadFileList", vm.uploadFileList);
        vm.dataloader = true;

        postApi.sendPostApi('api/freechat', 'createChat', vm.data,
          function(result) {
            vm.dataloader = false;
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (result.body.docCnt > 0) {
                if (data.responseVO.body.docCnt == 1) {
                  vm.srch.FreeChatId = result.body.docs[0].FreeChatId;
                  vm.srchComment.FreeChatId = vm.srch.FreeChatId;

                  getDetail();
                  getComment(true);
                  return;
                } else {
                  $state.go('app.chatting.h0201-roomlist', {
                    ChatUserId : vm.srch.UserId
                  });
                }
              }
            }

            gAlert('', data.responseVO.body.docs[0].errMessage);
          },
          function(error) {
            vm.dataloader = false;
            console.error('fail', error);
            gAlert('', data.responseVO.body.docs[0].errMessage);
          }
        );
      }

      function getDetail() {
        if (vm.srch.FreeChatId == null || vm.srch.FreeChatId == 0) {
          vm.data.FreeChatUser = [ {
            UserId : $window.sessionStorage['loginUserIdx'],
            LoginId : $window.sessionStorage['loginUserId'],
            UserNm : $window.sessionStorage['loginUserName']
          } ];
          return;
        }

        vm.dataloader = true;

        var data = angular.copy(vm.srch);
        postApi.sendPostApi('api/freechat', 'viewChat', data,
          function(result) {
            vm.dataloader = false;
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs[0].FreeChatId != null) {
                vm.data = result.body.docs[0];

                var uploadFileList = [];
                angular.forEach(vm.data.uploadFileList, function(item) {
                  var obj = {
                    id : item.fileId,
                    isLoaded : true,
                    link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                    fileName : item.LogicalFileNm,
                    size : item.FileSize,
                    fileKey : item.PhysicalFileNm,
                    typeId : 'file',
                    path : item.PhysicalPath,
                    downloadCnt : item.DownloadCnt,
                    delState : '',
                  };
                  uploadFileList.push(obj);
                });
                angular.copy(uploadFileList, vm.data.uploadFileList);

                //console.log('uploadFileList', vm.data.uploadFileList);

                return;
              }
            }

            gAlert('', result.body.docs[0].errMessage);
          },

          function(error) {
            console.error('fail', error);
            gAlert('', error.body.docs[0].errMessage);
          }
        );
      }

      function updateReadCnt() {
        var data = angular.copy(vm.srch);
        data.mapCode = 'FreeChat.updateChatReadCnt';
        postApi.update(data, function(result) {}, function(error) {});
      }

      // 사용하지 않음
      function getFileList() {

        vm.srch.tableNm = 'freechat';
        if (vm.srch.FreeChatId == null || vm.srch.FreeChatId == 0) {
          return;
        }

        var data = angular.copy(vm.srch);
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data,
          function(result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {

              var uploadFileList = [];
              angular.forEach(result.body.docs, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  typeId : 'file',
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                  delState : '',
                }
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);
              return;
            }
          },
          function(result) {
            console.error('fail', status, result);
            gAlert('알림', result.body.docs[0].errMessage);
          }
        );
      }

      vm.openMenu = openMenu;
      var originatorEv;
      function openMenu($mdOpenMenu, ev) {
        originatorEv = ev;
        $mdOpenMenu(ev);
      }

      function editDetail() {
        var srch = $stateParams.srch;
        if (vm.layout == 'N') {
          $state.go('app.chatting.h0201-roomedit', {
            srch : srch, FreeChatId : vm.srch.FreeChatId
          });
        } else {
          $state.go('app.chatting.h0201-roomlist.edit', {
            srch : srch, FreeChatId : vm.srch.FreeChatId
          });
        }
      }

      function deleteDetail() {
        gConfirm('', 'Menu.WANTTOLEAVETHEROOM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTLEAVETHEROOM');
          return;
        }
        var uploadFileList = [];
        angular.forEach(vm.data.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          }
          uploadFileList.push(obj);

        });
        vm.data.uploadFileList = uploadFileList;

        postApi.sendPostApi('api/freechat', 'leaveChat', vm.data,
          function(result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.LEFTTHEROOM', {
                btn : '',
                fn : function() {
                  $state.go('app.chatting.h0201-roomlist', {
                    ChatUserId : 0
                  });
                }
              });
              return;
            }
          },
          function(error) {
            console.error('fail', error);
            gAlert('', error.body.docs[0].errMessage);
          }
        );
      }

      Array.prototype.append = function(array) {
        this.push.apply(this, array);
      };

      function getPrevComment() {
        vm.srchComment.FirstId = vm.FirstId;
        vm.srchComment.LastId = null;
        vm.srchComment.viewSize = 10;
        //console.log('getPrevComment() ===');
        getComment(true);
      }

      function getNextComment(showLoading) {
        console.log('showLoading 000', showLoading);
        vm.srchComment.FirstId = null;
        vm.srchComment.LastId = vm.LastId;
        vm.srchComment.viewSize = 100;
        //console.log('getNextComment() ===');
        getComment(showLoading);
      }

      function getComment(showLoading) {
        //console.log("getComment(ShowLoading) ===");

        vm.dataloader = showLoading & true;

        var data = angular.copy(vm.srchComment);
        data.mapCode = 'FreeChat.getChatComment';

        postApi.select(data,
          function(result) {
            vm.dataloader = false;
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                if (vm.comment.lists == null)
                  vm.comment.lists = getContentsData(result.body.docs);
                else {
                  if (vm.srchComment.FirstId) {
                    angular.forEach(getContentsData(result.body.docs), function(item) {
                      vm.comment.lists.unshift(item);
                    });
                  } else {
                    vm.comment.lists.append(getContentsData(result.body.docs));
                  }
                }

                if (vm.srchComment.FirstId == null) {
                  $timeout(function() {
                    console.log('scroll');
                    var old = $location.hash();
                    $location.hash('bottom');
                    $anchorScroll();
                    $location.hash(old);
                  }, 0);
                }

                if (vm.srchComment.FirstId == null) {
                  if (vm.FirstId == null) {
                    vm.FirstId = result.body.docs[0].FreeChatCommId;
                  }
                  vm.LastId = result.body.docs[result.body.docs.length - 1].FreeChatCommId;
                } else {
                  vm.FirstId = result.body.docs[result.body.docs.length - 1].FreeChatCommId;
                }

                vm.srchComment.FirstId = vm.FirstId;
                vm.srchComment.LastId = vm.LastId;

                postApi.sendPostApi('api/freechat', 'updateReadFreeChatCommId', vm.srchComment,
                  function(result) {
                    if (result.header.status == CONSTANT.HttpStatus.OK) {
                      $rootScope.gVariable.totalItemChatComm = result.body.docs[0].ChatCount;
                      $rootScope.gVariable.totalItemTaskComm = result.body.docs[0].TaskCount;
                      $rootScope.gVariable.totalItemNotiComm = result.body.docs[0].NotiCount;
                      $rootScope.gVariable.totalItemComm = parseInt($rootScope.gVariable.totalItemChatComm) + parseInt($rootScope.gVariable.totalItemTaskComm);
                    }
                  },
                  function(error) {
                    vm.dataloader = false;
                    console.error('fail', error);
                  }
                );
              }
            }
          },
          function(error) {
            console.error('fail', error);
            gAlert('', error.body.docs[0].errMessage, {
              btn : '',
              fn : function() {
                $state.go('app.chatting.h0201-roomlist', {
                  ChatUserId : 0
                });
              }
            });
          }
        );
      }

      function getCommentCnt(showLoading) {
        var data = angular.copy(vm.srchComment);
        data.mapCode = 'FreeChat.getChatCommentCnt';

        postApi.select(data,
          function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                // 총 목록 건수 설정
                vm.totalItems = result.body.docs[0];
              } else {
                // 조회 실패
                vm.totalItems = 0;
              }
            }
            //console.log('vm.totalItems', vm.totalItems);
          },
          function(error) {
            console.error('fail', error);
            gAlert('', error.body.docs[0].errMessage, {
              btn : '',
              fn : function() {
                $state.go('app.chatting.h0201-roomlist', {
                  ChatUserId : 0
                });
              }
            });
          }
        );
      }

      function getContentsData(obj) {
        return obj.map(function(veg) {
          if (veg.FreeChatType == 'S') {
            var json = JSON.parse(veg.Contents);
            if (json.UserNm != '')
              veg.Contents = json.UserNm + ' ' + getMessageData(json.Message);
            else
              veg.Contents = getMessageData(json.Message);
          }

          return veg;
        });
      }

      function getMessageData(message) {
        var arg = message.split('|');
        var result = '';

        angular.forEach(arg, function(item) {
          result = result + $translate.instant(item) + " ";
        });

        return result;
      }

      function getWorkerNm(WorkerId) {
        return obj.map(function(veg) {
          if (veg.FreeChatType == 'S') {
            var json = JSON.parse(veg.Contents);
            veg.Contents = json.UserNm + ' ' + $translate.instant(json.Message);
          }

          return veg;
        });
      }

      function saveComment() {
        //var msg = $("#emoji").data("emojioneArea").getText();
        var data = angular.copy(vm.srchComment);
        data.Contents = $("#emoji").data("emojioneArea").getText().trim();
        if ((data.Contents == null || data.Contents == '') && vm.uploadFileListComment.length == 0) {
          gAlert('', 'Menu.NOCONTENTS');
          return;
        }

        data.FreeChatType = 'M';
        data.IdName = "FreeChatCommId";
        data.uploadFileList = vm.uploadFileListComment;
        data.mapCode = 'FreeChat.insertChatCommentBatch';

        postApi.insert(data,
          function(result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (result.body.docs[0].FreeChatCommId != 0) {
                vm.srchComment.WorkerId = '';
                vm.srchComment.Contents = '';
                vm.srchComment.uploadFileList = [];
                vm.uploadFileListComment = [];

                vm.send();

                getNextComment(false);

                // data.FreeChatCommId = result.body.docs[0].FreeChatCommId;
                // postApi.sendPostApi('api/freechat', 'updateReadFreeChatCommId', data,
                //   function(result) {
                //     if (result.header.status == CONSTANT.HttpStatus.OK) {
                //       $rootScope.gVariable.totalItemChatComm = result.body.docs[0].ChatCount;
                //       $rootScope.gVariable.totalItemTaskComm = result.body.docs[0].TaskCount;
                //       $rootScope.gVariable.totalItemNotiComm = result.body.docs[0].NotiCount;
                //       $rootScope.gVariable.totalItemComm = parseInt($rootScope.gVariable.totalItemChatComm) + parseInt($rootScope.gVariable.totalItemTaskComm);
                //     }
                //   },
                //   function(error) {
                //     vm.dataloader = false;
                //     console.error('fail', error);
                //   }
                // );
                return;
              }
            }

            gAlert('', result.body.docs[0].errMessage);
          },

          function(error) {
            console.error('fail', error);
            gAlert('', error.body.docs[0].errMessage);
          }
        );
        $("#emoji").data("emojioneArea").setText('');
      }

      vm.setDeleteFileToggle = setDeleteFileToggle;
      function setDeleteFileToggle(commentObj) {
        //console.log("deleteComment File");

        var idx = -1;
        angular.forEach(vm.comment.lists, function(val, key) {
          if (val == commentObj) {
            idx = key;
            return;
          }
        });
        if (vm.comment.lists[idx].delState == '') {
          vm.comment.lists[idx].delState = 'delete';
        } else {
          vm.comment.lists[idx].delState = '';
        }
      }

      function deleteComment(commentObj) {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteCommentAction(commentObj);
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteCommentAction(commentObj) {
        console.log("deleteCommentAction");

        var srch = {
          FreeChatCommId : commentObj.FreeChatCommId,
          TableNm : "FreeChatComm",
          IdName : "FreeChatCommId",
        };

        if (commentObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : commentObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable
                .getUrl('/attach/file/' + commentObj.PhysicalFileNm + '/download.do?path=' + commentObj.PhysicalFolderNm + '&fileName=' + commentObj.LogicalFileNm),
            fileName : commentObj.LogicalFileNm,
            size : commentObj.FileSize,
            fileKey : commentObj.PhysicalFileNm,
            path : commentObj.PhysicalFolderNm,
            downloadCnt : commentObj.DownloadCnt,
            delState : "delete",
            typeId : "file",
          };
          uploadFileList.push(obj);

          console.log("deleteComment File", uploadFileList);
          srch['uploadFileList'] = uploadFileList;
        }

        srch.mapCode = 'FreeChat.deleteChatComment';
        postApi.update(srch,
          function(result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (result.body.docs[0].FreeChatCommId != 0) {
                vm.comment.lists.forEach(function(item, index, object) {
                  if (item.FreeChatCommId == commentObj.FreeChatCommId) {
                    item.Contents = "MSG.DELETEDCONTENT";
                    item.LogicalFileNm = "";
                    item.PhysicalFileNm = "";
                    item.DelYN = "Y";
                  }
                });
                return;
              }
            }

            gAlert('', result.body.docs[0].errMessage);
          },

          function(error) {
            console.error('fail', error);
            gAlert('', error.body.docs[0].errMessage);
          }
        );
      }

      function editComment(FreeChatCommId) {
        console.log("editComment");

        vm.comment.editid = FreeChatCommId;

        vm.comment.lists.forEach(function(item, index, object) {
          if (item.FreeChatCommId == FreeChatCommId) {
            vm.comment.WorkerId = item.WorkerId;
            vm.comment.editContents = item.Contents;
          }
        });
      }

      function editCommentAction(commentObj) {

        var srch = {
          FreeChatCommId : commentObj.FreeChatCommId,
          FreeChatId : vm.srchComment.FreeChatId,
          WorkerId : vm.comment.WorkerId,
          Contents : vm.comment.editContents,
          TableNm : "FreeChatComm",
          IdName : "FreeChatCommId",
        };

        if (commentObj.AttachmentId != null) {
          var uploadFileList = [];

          var obj = {
            id : commentObj.AttachmentId,
            isLoaded : true,
            link : StaticVariable
                .getUrl('/attach/file/' + commentObj.PhysicalFileNm + '/download.do?path=' + commentObj.PhysicalFolderNm + '&fileName=' + commentObj.LogicalFileNm),
            fileName : commentObj.LogicalFileNm,
            size : commentObj.FileSize,
            fileKey : commentObj.PhysicalFileNm,
            path : commentObj.PhysicalFolderNm,
            downloadCnt : commentObj.DownloadCnt,
            delState : commentObj.delState,
            typeId : "file",
          };
          uploadFileList.push(obj);

          console.log("editComment File", uploadFileList);
          srch['uploadFileList'] = uploadFileList;
        }

        console.log("edit comment", srch);
        postApi.sendPostApi('api/freechat', 'updateChatComment', srch,
          function(result) {
            if (result.header.status == CONSTANT.HttpStatus.OK) {
              if (result.body.docs[0].FreeChatCommId != 0) {
                vm.comment.lists.forEach(function(item, index, object) {
                  if (item.FreeChatCommId == commentObj.FreeChatCommId) {
                    item.WorkerId = result.body.docs[0].WorkerId;
                    item.WorkerNm = result.body.docs[0].WorkerNm;
                    item.Contents = result.body.docs[0].Contents;
                    vm.comment.editid = null;

                    if (item.delState == "delete") {
                      item.AttachmentId = '';
                      item.PhysicalFileNm = '';
                      item.PhysicalFolderNm = '';
                      item.LogicalFileNm = '';
                      item.FileSize = '';
                      item.DownloadCnt = '';
                      item.delState = '';
                      item.WorkerId = '';
                      item.WorkerNm = '';
                    }
                  }
                });

                return;
              }
            }

            gAlert('', data.responseVO.body.docs[0].errMessage);
          },

          function(data) {
            console.error('fail', status, data);
            gAlert('', data.responseVO.body.docs[0].errMessage);
          }
        );
      }

      function editCommentCancel() {
        vm.comment.editid = null;
        vm.comment.editContents = null;
      }

      function goList() {
        $state.go('app.chatting.h0201-roomlist', {srch: $stateParams.srch, ChatUserId: '', WorkerId: ''}, {reload:'app.chatting.h0201-roomlist'});
      }

      vm.openDilalog = openDilalog;
      function openDilalog() {
        angular.element('#file-5').trigger("click");
      }

      var fileElement = angular.element('#file-5');
      fileElement.bind('change', function() {
        uploadFiles(fileElement[0].files);
      });

      vm.uploadFiles = uploadFiles;

      function uploadFiles(files) {
        console.log('uploadFiles', vm.uploadFileListComment);
        var tempIds = [];
        // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
        $scope.$root.safeApply(function() {
          var hasZeroByteFile = false;
          angular.forEach(files, function(value) {
            if (value.size == 0) {
              hasZeroByteFile = true;
            } else {
              var obj = {
                isLoaded : false,
                fileName : value.name,
                size : value.size,
                id : id,
                delState : ''
              };
              tempIds.push(obj);
              vm.uploadFileListComment.push(angular.copy(obj));
              id++;
            }
          });
          console.log("fu", vm.uploadFileListComment);
          if (hasZeroByteFile) {
            alert('빈 파일이 있습니다.');
            return;
          }

          var request = fileUploadService.post(files, null, function(percent) {
            // -- 진행율 표시
            angular.forEach(tempIds, function(obj) {
              console.log('progress percent::', percent);
              $('#filectl' + ' .progress .progress-bar').css('width', percent + '%');
            });
            if (percent == 100) {
              vm.showLoading = true;
            }
          });

          try {
            request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey='+$rootScope.gVariable.userKey)).then(function(value) {
              angular.forEach(value.data.responseVO.body.docs, function(item) {
                angular.forEach(vm.uploadFileListComment, function(obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.fileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl("/attach/temp/" + item.tmpFileKey + "/download.do?userkey=" + $rootScope.gVariable.userKey + "&fileName=" + item.encFileName);
                    obj.delState = '';
                    console.log("obj.link", obj.link);
                  }
                });
              });
              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element('#file-5').val(null);

              console.log('file items::', vm.uploadFileListComment);

              vm.showLoading = false;
            }, function(reason) {
              console.log(reason);
            });
          } catch (err) {
            console.log(err);
          }
        });
      }

      function ngRepeatFinished() {
        console.log('ngRepeatFinished');
      }

      vm.onDelete = onDelete;
      function onDelete(obj) {
        console.log("obj", obj);
        var idx = -1;
        angular.forEach(vm.uploadFileListComment, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          if (vm.uploadFileListComment[idx].typeId == "temp") {
            var prms = fileUploadService.attachFileDelete({
              attachId : vm.uploadFileListComment[idx].fileKey
            }, function(data) {
              vm.uploadFileListComment.splice(idx, 1);
              console.log('success', data);
            }, function(error) {
              console.error('fail', error);
            });
          } else if (vm.callback) {
            vm.uploadFileListComment[idx].delState = 'delete';
          }
        }
      }

      vm.onDeleteCancel = onDeleteCancel;
      function onDeleteCancel(obj) {
        var idx = -1;
        angular.forEach(vm.uploadFileListComment, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          vm.uploadFileListComment[idx].delState = '';
        }
      }

      vm.openAttachment = function (li) {
        if (!li.PhysicalFileNm) return;

        window.location = StaticVariable.getUrl('/attach/file/' + li.PhysicalFileNm + '/download.do?userkey=' + $rootScope.gVariable.userKey + '&path=' + li.PhysicalFolderNm + "&fileName=" + li.LogicalFileNm);
      };

      vm.serveraddr = CONSTANT.URL.API_SERVER_DOMAIN;

      var socket = null;
      var isopened = false;

//      document.addEventListener("DOMContentLoaded", function() {

      function start(serveraddr){
        if (window.WebSocket) {
            socket = new WebSocket("ws://" + serveraddr + ":19998/chat");
            socket.onmessage = function (event) {
              getNextComment(false);
              // $('#Content').after('<p>' + event.data + '</p>');
              // var json = JSON.parse(event.data);
              // console.log('json=', json);
            };
            socket.onopen = function (event) {
              isopened = true;
              var message = "{\"command\":\"freechat\",\"freechatid\":\"" + $stateParams.FreeChatId + "\"}";
              socket.send(message);
              $('#Content').after('<p>Web Socket opened!!!!!!</p>');
            };
            socket.onclose = function (event) {
              if (isopened == true) {
                $('#Content').after('<p>Web Socket closed!!!!!!</p>');
                setInterval(check, 3000);
              }

              isopened = false;
            };
        } else {
          $('#Content').after('Your browser does not support Websockets. (Use Chrome)');
        }
      }

      function check(){
        if(!socket || socket.readyState == 3) start(vm.serveraddr);
      }

      setTimeout(check, 1000);

//      });

      vm.reconnect = function () {
        console.log('reconnect()');
        socket.close();
      };

      vm.send = function () {
        if (!window.WebSocket) {
            return;
        }
        if (socket.readyState == WebSocket.OPEN) {
            socket.send(vm.message);
        } else {
          $('#Content').after('The socket is not open.');
        }
      };

      $scope.$on("$destroy", function() {
        socket.close();
      });

      /* $(document).ready(function() {
        $("#emoji").emojioneArea({
          shortcuts: false,
          events:
          {
            keypress: function(editor, event) {
              console.log(event.which);
              if (event.which === 13) {
                console.log('Enter');
                saveComment();
                event.preventDefault();
              }
            }
          }
        });
      }); */

      /* $(document).ready(function() {
        $("#emoji").emojioneArea({
            pickerPosition: "top",
            events: {
              keyup: function (editor, event) {
                if(event.which == 13){
                  if(event.shiftKey) {
                    // With shift
                  } else {
                    event.preventDefault();
                    saveComment();
                  }
                }
              }
            }
        });
      }); */
      $scope.$watch('$viewContentLoaded',
        function() {
          $timeout(function() {
            $("#emoji").emojioneArea({
              pickerPosition: "top",
              events: {
                keyup: function (editor, event) {
                  if(event.which == 13){
                    if(event.shiftKey) {
                      // With shift
                    } else {
                      event.preventDefault();
                      saveComment();
                    }
                  }
                }
              }
          });
        } ,0);
      });

    } ]);
})();

(function() {
  'use strict';
webapp.controller('H0201RoomEditCtrl', [ '$window', '$scope', '$rootScope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'postApi', 'gAlert',
    function H0201RoomEditCtrl($window, $scope, $rootScope, $location, $state, $stateParams, CONSTANT, StaticVariable, postApi, gAlert) {
      var vm = this;

      vm.page = $stateParams.page;

      vm.srch = {
        FreeChatId : $stateParams.FreeChatId,
        IdName : 'FreeChatId',
        tableNm : 'freechat',
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        ChatId : '1',
        uploadFileList : [],
      };

      vm.data = {
        ChatId : vm.srch.ChatId,
      };

      vm.dataloader = false;
      vm.layout = $rootScope.gVariable.layoutBoard;

      vm.newFreeChatUser = [];

      vm.getDetail = getDetail;
      vm.getFileList = getFileList;
      vm.saveDetail = saveDetail;
      vm.addUser = addUser;
      vm.goList = goList;

      vm.onFileCallback = {
        onFileUploadComplete : function() {
          console.log('file items::', vm.data.uploadFileList);
        },
        onFileDelete : function(item) {
          console.log('delete item::', item);
          var param = {
            'fileId' : item.id
          };
          var prms = h0201Api.attachFileDelete().post(param).$promise;
          prms.then(function(data) {
            console.log(data);
            if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED');
            }
          });
        }
      }

      vm.querySearch = querySearch;
      vm.loadContacts = loadContacts;
      // vm.allContacts = loadContacts();
      // vm.contacts = [ vm.allContacts[0] ];
      vm.filterSelected = true;
      vm.IsContact = IsContact;
      vm.onRemoveChip = onRemoveChip;
      vm.goBack = goBack;

      function IsContact(contact) {
        if (vm.newFreeChatUser != null) {
          for (var i = 0; i < vm.newFreeChatUser.length; i++) {
            if (contact.UserId == vm.newFreeChatUser[i].UserId)
              return true;
          }
        }

        if (vm.data.freeChatUser != null) {
          for (var j = 0; j < vm.data.freeChatUser.length; j++) {
            if (contact.UserId == vm.data.freeChatUser[j].UserId)
              return true;
          }
        }

        return false;
      }

      /**
       * Search for contacts.
       */
      function querySearch(query) {
        var results = query ? vm.listUsers.filter(createFilterFor(query)) : [];
        return results;
      }
      /**
       * Create filter function for a query string
       */
      function createFilterFor(query) {
        return function filterFn(contact) {
          return (contact.UserNm.indexOf(query) != -1);
        };
      }

      function onRemoveChip(item) {
        console.log('item=', item);
      }

      function loadContacts() {
        var data = angular.copy(vm.srch);
        data.mapCode = 'FreeChat.getContacts';
        postApi.select(
          data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.listUsers = result.body.docs;
              }
              var page = 1;
              var viewSize = 20;
              var totalSize = vm.listUsers.length;
              vm.contactSize = function() {
                return page * viewSize;
              };
              vm.totalContact = function() {
                return page < (totalSize / viewSize);
              };
              vm.getMoreContact = function() {
                page = page + 1;
              };
            }
            vm.dataloader = false;
          },
          function (error) {
            console.error("Error> h0102-list-ctrl> getList()", status, error);
            vm.dataloader = false;
          }
        );
      }

      function getDetail() {
        if (vm.srch.FreeChatId == null || vm.srch.FreeChatId == 0) {
          vm.newFreeChatUser = [ {
            UserId : $rootScope.gVariable.UserId,
            UserNm : $rootScope.gVariable.UserName,
            ContactNm : $rootScope.gVariable.TenantName.substring(0, 4) + '-' + $rootScope.gVariable.UserName
          } ];
          return;
        }

        vm.dataloader = true;

        var data = angular.copy(vm.srch);
        postApi.sendPostApi('api/freechat', 'viewChat', data, function(result) {
          vm.dataloader = false;
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs[0].FreeChatId != null) {
              vm.data = result.body.docs[0];

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  typeId : 'file',
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                  delState : '',
                };
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);

              console.log('$rootScope.gVariable.UserId', $rootScope.gVariable.UserId);
              console.log(vm.data.RegUser );

              if (vm.data.RegUser == $rootScope.gVariable.UserId) {
                vm.newFreeChatUser = angular.copy(vm.data.FreeChatUser);
              }

              return;
            }
          }

          gAlert('', result.body.docs[0].errMessage);
        },

        function(error) {
          console.error('fail', error);
          gAlert('', error.body.docs[0].errMessage);
        });
      }

      function getFileList() {
        vm.srch.tableNm = 'FreeChat';
        if (vm.srch.FreeChatId == null || vm.srch.FreeChatId == 0) {
          return;
        }

        var data = angular.copy(vm.srch);
        data.mapCode = 'FileAttach.getFileList';
        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            var uploadFileList = [];
            angular.forEach(result.body.docs, function(item) {
              var obj = {
                id : item.fileId,
                isLoaded : true,
                link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                fileName : item.LogicalFileNm,
                size : item.FileSize,
                fileKey : item.PhysicalFileNm,
                typeId : 'file',
                path : item.PhysicalPath,
                downloadCnt : item.DownloadCnt,
                delState : '',
              }
              uploadFileList.push(obj);
            });
            angular.copy(uploadFileList, vm.data.uploadFileList);
            return;
          }
        },

        function(result) {
          console.error('fail', status, result);
          gAlert('알림', result.body.docs[0].errMessage);
        });
      }

      function saveDetail() {
        var data = angular.copy(vm.data);
        data.Participants = ':' + $window.sessionStorage['loginUserIdx'] + ':';
        data.tableNm = "freechat";
        data.IdName = "FreeChatId";
        data.TableId = vm.data.FreeChatId;
        if (vm.data.RegUser == $rootScope.gVariable.UserId || data.FreeChatUser == null) {
          data.FreeChatUser = [];
        }
        angular.forEach(vm.newFreeChatUser, function(item) {
          data.FreeChatUser.push(item);
        });

        if (vm.data.FreeChatId == null) {
          postApi.sendPostApi('api/freechat', 'createChat', data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              vm.dataloader = false;
              console.table(error);
            }
          );

          vm.data.forceCreate = true;
        } else {
          postApi.sendPostApi('api/freechat', 'updateChat', data,
            function(result) {
              InsertUpdateDetail(result);
            },
            function(error) {
              vm.dataloader = false;
              console.table(error);
            }
          );
        }
      }

      function InsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.data = result.body.docs[0];
          var srch = $stateParams.srch; // 검색 옵션

          if (vm.layout == 'N') {
            $state.go('app.chatting.h0201-roomdetail', {srch : srch, FreeChatId : vm.data.FreeChatId}, {reload:'app.chatting.h0201-roomdetail'});
          } else {
            vm.srch.FreeChatId = "";
            vm.srch.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
            // 조회 화면 이동
            $state.go('app.chatting.h0201-roomlist.detail', {srch: srch, FreeChatId : vm.data.FreeChatId});
          }
        }

        vm.dataloader = false;

        if (result.body.docs != null && result.body.docs[0].errMessage != null)
          console.table(result);
      }

      function goBack() {
        $window.history.back();
      }

      function addUser(UserId) {
        for (var i = 0; i < vm.listUsers.length; i++) {
          if (vm.listUsers[i].UserId == UserId) {
            vm.newFreeChatUser.push(vm.listUsers[i]);
            break;
          }
        }
      }

      function goList() {
        $state.go('app.chatting.h0201-roomlist', {srch: $stateParams.srch, ChatUserId: '', WorkerId: ''}, {reload:'app.chatting.h0201-roomlist'});
      }

      getDetail();
      loadContacts();
    } ]);
})();

(function() {
  'use strict';
webapp.controller('H0201RoomListCtrl', ['$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', 'GLOBAL_CONSTANT', 'postApi', 'modalFactory',
    function H0201RoomListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, CONSTANT, postApi, modalFactory) {
      var vm = this;

      vm.dataloader = false;

      vm.layout = $rootScope.gVariable.layoutBoard;
      vm.anchor = "";
      setLayout(vm.layout);

      if (!$stateParams.srch) {
        vm.srch = {
          page: 1,
          viewSize: CONSTANT.PAGINATION.VIEWSIZE,
          tableNm: "freechat", // For CustomColumn and FileAttachment
          sortDirect: "",
          sortColumn: "",
          ChatId: "1"
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = "freechat"; // For CustomColumn and FileAttachment
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        if (vm.srch.page == null) {
          vm.srch.page = 1;
        }
        vm.srch.ChatId = "1";
      }

      $scope.selectedRow = $stateParams.FreeChatId;

      vm.listSize = [ 10, 25, 50, 100 ];
      vm.columnMap = {};
      vm.currentPage = vm.srch.page;
      vm.WorkerId = "";
      vm.WorkerNm = "";
      vm.ChatUserId = "";
      vm.ChatUserNm = "";

      console.log('$stateParams=', $stateParams);
      if ($stateParams.WorkerId != null && $stateParams.WorkerId != "" && $stateParams.WorkerId != "0") {
        vm.WorkerId = $stateParams.WorkerId;
        var data1 = {UserId:vm.WorkerId};
        data1.mapCode = 'FreeChat.getUserInfo';

        postApi.select(data1, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.WorkerNm = result.body.docs[0].UserNm;
              return;
            }
          }
        }, function(error) {
          console.table(error);
        });
      } else if ($stateParams.ChatUserId != null && $stateParams.ChatUserId != "" && $stateParams.ChatUserId != "0") {
        vm.ChatUserId = $stateParams.ChatUserId;
        var data2 = {UserId:vm.ChatUserId};
        data2.mapCode = 'FreeChat.getUserInfo';

        postApi.select(data2, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.ChatUserNm = result.body.docs[0].UserNm;
              return;
            }
          }
        }, function(error) {
          console.table(error);
        });
      }

      $scope.showDetail = function(li) {
        $location.url('/' + li.ntcIdx);
      };

      vm.setLayout = setLayout;
      vm.pageChanged = pageChanged;
      vm.getList = getList;
      vm.getListCnt = getListCnt;
      vm.changeViewSize = changeViewSize;
      vm.getExcel = getExcel;
      vm.setResponsive = setResponsive;
      vm.changeLayout = changeLayout;
      vm.goEdit = goEdit;
      vm.goDetail = goDetail;

      function setLayout(layout) {
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            vm.anchor = "west";
            vm.paneMin = "480px";
            break;
          case "N":
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      function pageChanged() {
        console.log('vm.currentPage=', vm.currentPage, ',vm.srch.page=', vm.srch.page);
        // $state.go("app.h0201.roomlist");
        vm.srch.page = vm.currentPage;
        getList();
        // $location.path('/app/request/h0201-list/' + vm.srch.ChatId + "/" +
        // vm.currentPage, false);
      }

      function getListCnt() {

        var data = angular.copy(vm.srch);
        data.WorkerId = vm.WorkerId;
        data.ChatUserId = vm.ChatUserId;
        data.selectType = "List"; // For CustomColumn
        postApi.sendPostApi('api/freechat', 'selectChatCount', data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.totalItems = result.body.docCnt;
              } else {
                vm.totalItems = 0;
              }
            }

            vm.SearchConditionStr = '<b>검색결과 <font color=red>' + Number(vm.totalItems).toLocaleString('en') + '</font>건</b> ';
            vm.dataloader = false;
          },
          function (error) {
            console.error("Error> request-list-ctrl> getList()", status, error);
            vm.dataloader = false;
          }
        );
      }

      function getList() {
        vm.viewSize = vm.srch.viewSize;

        getListCnt();
        getChatTaskCount();

        console.log('vm.srch', vm.srch);

        $window.sessionStorage.setItem('h0201-roomlist-ctrl', angular.toJson(vm.srch));

        vm.dataloader = true;

        var data = angular.copy(vm.srch);
        data.WorkerId = vm.WorkerId;
        data.ChatUserId = vm.ChatUserId;
        data.selectType = "List"; // For CustomColumn
        postApi.sendPostApi('api/freechat', 'selectChat', data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.desc.length > 0) {
                vm.listColumns = result.body.desc;
                angular.forEach(vm.listColumns, function (item) {
                  vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
                  vm.columnMap[item.ColumnPhysicalNm] = item;
                });
              }

              if (result.body.docs.length > 0) {
                vm.lists = getContentsData(result.body.docs);
                setResponsive();
              } else {
                vm.lists = {};
              }
            }

            vm.dataloader = false;
          },
          function (error) {
            console.error("Error> request-list-ctrl> getList()", status, error);
            vm.dataloader = false;
          }
        );
      }

      function changeViewSize() {
        vm.currentPage = 1;
        getList();
      }

      function getContentsData(obj) {
        return obj.map(function(veg) {
          if (veg.FreeChatType == 'S') {
            var json = JSON.parse(veg.Contents);
            if (json.UserNm != '')
              veg.Contents = json.UserNm + ' ' + getMessageData(json.Message);
            else
              veg.Contents = getMessageData(json.Message);
          }

          return veg;
        });
      }

      function getMessageData(message) {
        var arg = message.split('|');
        var result = '';

        angular.forEach(arg, function(item) {
          result = result + $translate.instant(item) + " ";
        });

        return result;
      }

      function getExcel() {

        vm.excel.param = vm.srch;

        var prms = h0201Api.doExcel().post(vm.excel).$promise;

        prms.then(

        function(data) {
        },

        function(error) {
          console.error('fail', status, data);
        });

      }

      function getChatTaskCount() {
        //commonFn.getChatTaskCount();
      }

      function setResponsive(dockMode) {
        var rows = vm.lists;
        var columns = [];
        var o = {};
        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
        //o.formatString = [""];
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};
          column.name = item.ColumnPhysicalNm;
          column.title = item.ColumnLogicalNm;
          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }
          if (item.ColumnPhysicalDataType == "40") {
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }
          index++;
          columns.push(column);
        });
      }

      function goDetail(FreeChatId) {
        //vm.srch.BbsPostId = BbsPostId;
        angular.forEach(vm.lists, function(item) {
          if (item.FreeChatId == FreeChatId) {
            item.UnReadCnt = 0;
            return;
          }
        });

        var srch = $stateParams.srch;
        $scope.selectedRow = FreeChatId;
        if (vm.layout == "N") {
          $state.go("app.chatting.h0201-roomdetail", {
            srch: srch,
            FreeChatId: FreeChatId
          });
        } else {
          $state.go("app.chatting.h0201-roomlist.detail", {
            srch: srch,
            FreeChatId: FreeChatId
          });
        }
      }

      function goEdit() {
        var srch = $stateParams.srch;
        vm.keyId = "";
        if (vm.layout == "N") {
          $state.go("app.chatting.h0201-roomedit", {
            srch: srch,
            FreeChatId: ""
          });
        } else {
          $state.go("app.chatting.h0201-roomlist.edit", {
            srch: srch,
            FreeChatId: ""
          });
        }
      }

      function changeLayout(layout) {
        $window.sessionStorage.setItem("layoutBoard", layout);
        $rootScope.gVariable.layoutBoard = layout;
        var srch = $stateParams.srch;
        $state.go(
          "app.chatting.h0201-roomlist",
          {
            ChatUserId:'', WorkerId:''
          },
          { reload: "app.chatting.h0201-roomlist" }
        );
      }

      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchWorkerModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId, ContactsYN: true};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 사용자 선택
          vm.WorkerNm = okData.UserNm;
          vm.WorkerId = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseWorker = function () {
        vm.WorkerNm = "";
        vm.WorkerId = "";
      };

      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId, ContactsYN: true};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 사용자 선택
          vm.ChatUserNm = okData.UserNm;
          vm.ChatUserId = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.ChatUserNm = "";
        vm.ChatUserId = "";
      };

      vm.getSearch = function () {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(
          "app.chatting.h0201-roomlist",
          {
            srch:srch, ChatUserId:vm.ChatUserId, WorkerId:vm.WorkerId
          },
          { reload: "app.chatting.h0201-roomlist" }
        );
      };

      vm.resetSearch = function () {
        vm.WorkerNm = "";
        vm.WorkerId = "";
        vm.ChatUserNm = "";
        vm.ChatUserId = "";
        vm.srch.RegDateFrom = "";
        vm.srch.RegDateTo = "";
        vm.RegDateFrom = "";
        vm.RegDateTo = "";
        getList();
      };

      getList();
    } ]);
})();

(function () {
  "use strict";
  /**
  * @ngdoc function
  * @name app.bbspost:company-detail-ctrl
  * @description # 회원사 조회 Controller of the 회원사관리
  */
  webapp.controller('CompanyDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'customFieldApi', 'gAlert', 'gConfirm', 'fileUploadService',


    /**
     * 회원사관리 - 조회화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          api - CompanyApiSvr Module
     * @param {object}
     *          gAlert - Alert Module *
     * @param {object}
     *          gConfirm - Confirm Module
     */

    function CompanyDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, customFieldApi, gAlert, gConfirm, fileUploadService) {
      // View Model
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
      vm.isManage = false;
      vm.changeable = false;
      vm.TenantStatus = 'R';
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1,
          viewSize: CONSTANT.PAGINATION.VIEWSIZE,
          TenantId: $stateParams.srch.TenantId ? $stateParams.srch.TenantId : 1,
          tableNm: $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'tenant',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }
      
      vm.loginUserAdminType = !isNullOrEmpty($window.sessionStorage['loginUserAdminType']) ? $window.sessionStorage['loginUserAdminType'] : "";  
      vm.isAdminS = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S"); // 시스템관리자, 사무국 

      if ($stateParams.Type == 'Introduce') {
        vm.isManage = false;
      } else if ($stateParams.Type == 'Manage') {
        vm.isManage = true;
      }

      vm.tenantId = $window.sessionStorage["loginTenantId"];
      vm.reloadSeq = 1;

      // SQL Mapper Id 정의
      var VIEW_SQL = 'Tenant.getTenantDetail';                    // 조회 SQL
      var UPDATE_STATUS_SQL = 'Tenant.updateTenantStatus';        // 기관가입승인상태 변경 SQL
      var DELETE_SQL = 'Tenant.deleteTenant';                     // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.company.company-list';             // 목록 화면
      var EDIT_PAGE_URL = 'app.company.company-edit';             // 등록/수정 화면
      var LIST_EDIT_PAGE_URL = 'app.company.company-list.edit';

      vm.layout = $rootScope.gVariable.layoutBoard;

      if ($stateParams.keyId != null && $stateParams.keyId != '') {
        vm.srch.keyId = $stateParams.keyId;
      } else {
        vm.srch.keyId = vm.tenantId;
      }

      vm.columnMap = {};
      vm.srchDetail = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.tableNm = 'tenant';
      vm.srchDetail.selectType = "Edit";
      vm.srchDetail.IdName = 'KeyId';
      vm.srchDetail.TenantId = vm.srch.keyId;

      // 업로드 파일 목록
      vm.uploadFileList = [];

      //#region getData 데이터 조회
      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        vm.dataloader = true;
        
        var data = angular.copy(vm.srchDetail);
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {          
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              
              vm.lists = result.body.docs;
              vm.data = result.body.docs[0];
              vm.TenantStatus = vm.data.TenantStatus;

              // 시스템관리자, 사무국, 현장간사, 봉사단만 수정 가능
              if(vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "H") {                
                vm.changeable = true;
              } 
            }
          }
          vm.dataloader = false;
          vm.reloadSeq++;
        }, function (data) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }
      //#endregion 
  
      //#region goList 목록이동
      function goList() {
        var srch = $stateParams.srch;
        var type = $stateParams.Type;
        $state.go(LIST_PAGE_URL, {
          srch: srch,
          Type: type
        });
      }
      //#endregion
      
      //#region goEdit, goDelete 수정 페이지 이동 및 회원사 삭제
      function goEdit() {
        var srch = $stateParams.srch;
        var type = $stateParams.Type;
        if (vm.layout == 'N') {
          $state.go(EDIT_PAGE_URL, {
            srch: srch, keyId: vm.srch.keyId, Type : type
          });
        } else {
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch, keyId: vm.srch.keyId, Type : type
          });
        }
      }

      function goDelete() {
        gConfirm('', '삭제 하시겠습니까?', {
          btn : '',
          fn : function() {
            var data ={};
            data.TenantId = vm.srch.keyId;
            data.mapCode = DELETE_SQL;
            postApi.update(data, function(result){
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("삭제되었습니다.");
                var srch = $stateParams.srch;
                var type = $stateParams.Type;
                $state.go(LIST_PAGE_URL, {
                  srch: srch,
                  Type: type
                });
              }
            });    
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }
      //#endregion

      //#region updateTenantStatus Tenant 상태 변경
      /**
       *  데이터 저장
       *
       * @param 
       * @return
       */
       vm.updateTenantStatus = function(str) {
        var TenantStatusNm = "";
        if( str == "Y" ) TenantStatusNm = "승인";
        else TenantStatusNm = "반려";
        gConfirm('', TenantStatusNm + '하시겠습니까?', {
          btn : '',
          fn : function() {
            var data ={};
            data.TenantStatus = str;
            data.TenantId = vm.srch.keyId;
            data.mapCode = UPDATE_STATUS_SQL;
            postApi.update(data, function(result){
              if ( result.header.status === CONSTANT.HttpStatus.OK ) {
                gAlert(TenantStatusNm+"되었습니다.");
                vm.TenantStatus = str;
                vm.data.TenantStatusNm = TenantStatusNm;
              }
            });    
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      };
      //#endregion

      

      // 직원 수정
      vm.goUserEdit = function(UserId) {  
        var srch = encodeURIComponent(JSON.stringify({comUserYN : "Y"}, replacer));
        $state.go("app.personal.user-edit", {
          srch: srch,
          keyId: UserId
        });
      };

      // 직원 비밀번호 초기화
      vm.resetPwd = function(UserId) { 
        gConfirm('', '비밀번호를 초기화하시겠습니까?', {
          btn : '',
          fn : function() {
            var data = {};
            data.UserId = UserId;
            data.mapCode = "Tenant.resetUserPassword";
            postApi.update(data, function(result){
              if ( result.header.status === CONSTANT.HttpStatus.OK ) {
                gAlert("초기화 되었습니다.");
              }
            });    
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      };

      // 함수 선언
      vm.getData = getData;
      vm.goList = goList;
      vm.goEdit = goEdit;
      vm.goDelete = goDelete;

      // 데이터 조회
      getData();
  }]);
})();

(function() {
  "use strict";
 /**
 * @ngdoc function
 * @name app.bbspost:company-detail-ctrl
 * @description # 회원사 조회 Controller of the 회원사관리
 */
webapp.controller('CompanyEditCtrl', [ '$window', '$rootScope', '$scope', '$timeout', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'customFieldApi', 'gAlert', 'gConfirm', 'fileUploadService', '$filter',


    /**
     * 회원사관리 - 등록/수정 화면 Control
     *
     * @param {object}
     *          $window - window object
     * @param {object}
     *          $scope - scope object
     * @param {object}
     *          $location - location object
     * @param {object}
     *          $state - state object
     * @param {object}
     *          $stateParams - state Parameter object
     * @param {object}
     *          CONSTANT - 전역 상수
     * @param {object}
     *          StaticVariable - StaticVariable object
     * @param {object}
     *          api - CompanyApiSvr Module
     * @param {object}
     *          gAlert - Alert Module *
     * @param {object}
     *          gConfirm - Confirm Module
     */

    function CompanyEditCtrl($window, $rootScope, $scope, $timeout, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, customFieldApi, gAlert, gConfirm, fileUploadService, $filter) {
      // View Model
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
      vm.isManage = false;
      vm.changeable = false;
      vm.TenantStatus = 'R';
      if ( !$stateParams.srch ) {
        vm.srch = {
          page: 1,
          viewSize: CONSTANT.PAGINATION.VIEWSIZE,
          TenantId: $stateParams.srch.TenantId ? $stateParams.srch.TenantId : 1,
          tableNm: $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'tenant',
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }
      
      vm.loginUserAdminType = !isNullOrEmpty($window.sessionStorage['loginUserAdminType']) ? $window.sessionStorage['loginUserAdminType'] : "";  

      /* 
       *  Introduce : 기관관리메뉴 
       *  Manage    : 협력기관소개메뉴 
       */
      if ( $stateParams.Type == 'Introduce' ) {
        vm.isManage = false;
      } else if ( $stateParams.Type == 'Manage' ) {
        vm.isManage = true;
      }

      vm.tenantId = $window.sessionStorage["loginTenantId"];
      vm.reloadSeq = 1;

      // SQL Mapper Id 정의
      var VIEW_SQL = 'Tenant.getTenantDetail';                    // 기광상세정보 조회 SQL
      
      var GET_ORG_SQL = 'getOrganizationList';                    // 기관구분 목록 조회 SQL
      var GET_ORG_SUB_SQL = 'getOrganizationSubList';             // 기관구분 서브 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.company.company-list';               // 목록 화면
      var DETAIL_PAGE_URL = 'app.company.company-detail';           // 상세보기 화면
      var LIST_EDIT_PAGE_URL = 'app.company.company-list.detail';   

      vm.layout = $rootScope.gVariable.layoutBoard;

      if ( $stateParams.keyId != null && $stateParams.keyId != '' ) {
        vm.srch.keyId = $stateParams.keyId;
      } else {
        vm.srch.keyId = vm.tenantId;
      }

      vm.columnMap = {};
      vm.srchDetail = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.tableNm = 'tenant';
      vm.srchDetail.selectType = "Edit";
      vm.srchDetail.IdName = 'KeyId';
      vm.srchDetail.TenantId = vm.srch.keyId;

      //#region getData 데이터 조회
      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
       function getData() {
        vm.dataloader = true;
        
        var data = angular.copy(vm.srchDetail);
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {          
          if ( result.header.status === CONSTANT.HttpStatus.OK ) {
            if ( result.body.desc.length > 0 ) {
              vm.allColumns = result.body.desc;

              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if ( result.body.docs.length > 0 ) {
              vm.lists = result.body.docs; 
              vm.data = result.body.docs[0];
              vm.TenantStatus = vm.data.TenantStatus;

              // 시스템관리자, 사무국만 수정 가능
              if(vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S") {                
                vm.changeable = true;
              } 
            }
          }
          vm.dataloader = false;
          vm.reloadSeq++;
        }, function (data) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }
      //#endregion

      //#region saveData 데이터 저장
      /**
       *  데이터 저장
       *
       * @param 
       * @return
       */
      function saveData() {
        var data = angular.copy(vm.data);
        data.TenantId = vm.srch.keyId;
        data.mapCode = 'Tenant.updateTenantDetail';
        data.Organization = data.organization_code;
        data.OrganizationSub = data.organizationSub_code;
        postApi.update(data, function(result){
          if( result.header.status === CONSTANT.HttpStatus.OK ) {
            gAlert('','수정되었습니다.', {
              btn : '',
              fn : function() {
                var type = $stateParams.Type;
                var srch = $stateParams.srch;
                $state.go('app.company.company-detail', { srch : srch, keyId : vm.srch.keyId, Type : type });
              }
            });

          }
        });
      }
      //#endregion

      //#region goList 목록 이동
      /**
       *  목록 이동
       *
       * @param 
       * @return
       */
      function goList() {
        var srch = $stateParams.srch;
        $state.go(LIST_PAGE_URL, {
          srch : srch
        });
      }
      //#endregion

      //#region goDetail 상세보기 이동
      /**
       *  상세보기 이동
       *
       * @param 
       * @return
       */
      function goDetail() {
        var srch = $stateParams.srch;
        var type = $stateParams.Type;
        if ( vm.layout == 'N' ) {
          $state.go(DETAIL_PAGE_URL, {
            srch : srch, keyId : $stateParams.keyId, Type: type
          });
        } else {
          $state.go(LIST_EDIT_PAGE_URL, {
            srch : srch, keyId : $stateParams.keyId, Type: type
          });
        }
      }
      //#endregion

      //#region getOrganizationList 기관구분 목록 조회
      /**
       * 기관구분 목록 조회
       *
       * @param 
       * @return
       */
      function getOrganizationList() {
        vm.organizationList = [];
        var data = {};
        data.mapCode = GET_ORG_SQL;
        postApi.openApi(data, function(result){
          if( result.body.docs.length > 0 ) {
            angular.forEach(result.body.docs, function(item){
              vm.organizationList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
            });
          } else {
            vm.yearsList = {};
          }
        });
      }
      //#endregion

      //#region getOrganizationSubList 기관구분서브 목록 조회
      /**
       * 기관구분서브 목록 조회
       *
       * @param 
       * @return
       */
      function getOrganizationSubList() {
        vm.organizationSubList = [];
        var data = {};
        data.mapCode = GET_ORG_SUB_SQL;
        postApi.openApi(data, function(result){
          if( result.body.docs.length > 0 ) {
            angular.forEach(result.body.docs, function(item){
              vm.organizationSubList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
            });
          }
        });
      }
      //#endregion

      //#region srchZipCodeModal 우편번호 검색
      /* 다음 주소검색 */
      function getAddressInfo() {
        new daum.Postcode({
          oncomplete: function (data) {
            $timeout(function () {     
                   
              // 시군구 코드
              vm.data.CityCode = data.sigunguCode;

              vm.data.ZipCode = data.zonecode;
              var addr1 = data.buildingName != "" ? data.address + " " + data.buildingName : data.address;
              vm.data.Addr1 = addr1;
            }, 0);
          },
        }).open();
      }      

      // 담당자 팝업
      vm.srchUserModal = function () {
        var ctrl = 'ContactUserModalCtrl as modalCtrl';
        var paramData = {TenantId: vm.srch.keyId};
        var modalInstance = modalFactory.open('lg', 'app/company/modal/contact-user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.data.ContactUserNm = okData.UserNm;
          vm.data.ContactUserId = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };
  
      //#endregion

      // 함수 선언
      vm.getData = getData;
      vm.goList = goList;
      vm.goDetail = goDetail;
      vm.saveData = saveData;
      vm.getAddressInfo = getAddressInfo;

      // 데이터 조회
      getData();
      getOrganizationList();
      getOrganizationSubList();

    }]);
    
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:company-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 사용자관리 목록
   */
  webapp.controller('CompanyListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CompanyListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Tenant.getTenantCount';                     // 목록 건수 조회 SQL
      var LIST_SQL = 'Tenant.getTenantList';                                              

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.company.company-list';                 // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.company.company-list.detail';   // 목록 조회  화면
      var VIEW_PAGE_URL = 'app.company.company-detail';               // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = '';                                          // 작업 테이블명

      // #endregion 상수 정의
      
      var vm = this;          // View Model
      vm.title = "";
      vm.dataloader = false;  // Progressbar 숨김
      vm.type = $stateParams.Type;  // 메뉴 구분
      vm.tenantType = $window.sessionStorage['loginTenantType'];       // 회원사 타입
      
      if ($stateParams.Type == 'Manage') {
        KEY_TABLE_NM = 'tenant';
        vm.title = "기관관리";
        vm.isManage = true;
      } else if ($stateParams.Type == 'Introduce') {
        KEY_TABLE_NM = 'tenantIntroduce';
        vm.title = "협력기관소개";
        vm.isManage = false;
      }

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1,                // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',     // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'RegDate'   // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE;   // 목록당 표시건수
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;   // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;     // 최대 조회건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      
      vm.TenantType = "";       // 목록 검색 시, 상태값 Array
      
      if (!isNullOrEmpty(vm.srch.TenantTypeVal)) {
        vm.TenantType = vm.srch.TenantTypeVal;
      } 

      vm.srch.TenantType = vm.TenantType;

      setLayout(vm.layout);                         // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      //#region 상세검색 관련 호출함수 
      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }
      //#endregion

      //#region getListCnt, getList, 데이터 조회
      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.isManage = vm.isManage;
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

       
        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.JoinDtFrom = $filter('localToUtc')(data.JoinDtFrom, 'from');
        data.JoinDtTo = $filter('localToUtc')(data.JoinDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        data.isManage = vm.isManage;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
              
              chgParCityCode();
              
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              if (!isNullOrEmpty(vm.lists.RegDate)) vm.lists.RegDate = moment(vm.lists.RegDate).toDate();
              var resList = [];
              var res = '';
              if (vm.lists != null) {
                angular.forEach(vm.lists, function (item) {
                  resList = [];
                  if ($stateParams.Type == 'Manage') {
                    if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {
                      res = item.Addr1;
                      resList = res.split(" ");
                      item.Addr = resList[0] + " " + resList[1];
                    }
  
                    if (item.TenantStatus == 'Y') {
                      item.TenantStatusNm = '승인';
                    } else if (item.TenantStatus == 'R') {
                      item.TenantStatusNm = '승인요청';
                    } else if (item.TenantStatus == 'E') {
                      item.TenantStatusNm = '계약종료';
                    } else {
                      item.TenantStatusNm = '반려';
                    }
                  }                 
                  
                  
                });
              }

              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }
      //#endregion

      //#region setResponsive 목록 화면 구성
      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }
      //#endregion

      //#region setPageChanged 페이지 변경시 데이터 조회
      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }
      //#endregion

      //#region setChangeViewSize 목록 당 조회 건수 변경
      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }
      //#endregion

      //#region setSortColumn 정렬 컬럼 설정
      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "DESC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }
      
      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }
      //#endregion

      //#region goDetail, goAdd, goEdit 페이지 이동
      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        var type = $stateParams.Type;
        vm.keyId = paramKeyId;
        
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            Type: type,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            Type: type,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        var type = $stateParams.Type;
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            Type: type,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            Type: type,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        var type = $stateParams.Type;
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            Type: type,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            Type: type,
            keyId: paramKeyId
          });
        }
      }
      //#endregion

      //#region setLayout, setChangeLayout 화면 분할 모드 설정 및 변경
      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }
      //#endregion

      //#region setLayout, setChangeLayout 초기 데이터 설정
      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }
      //#endregion

      //#region setDelList, setDelListAction 목록 삭제
      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }
      //#endregion      

      // 지역 시도 변경 시 시군구 목록 조회
      function chgParCityCode() {
        if( ! isNullOrEmpty(vm.srch.ParCityCode)){
          vm.CityCodeList = vm.columnMap['CityCode'].CodeList.filter(function(e){
            return e.Code.substring(0,2) == vm.srch.ParCityCode;
          });
        }
      };

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.getList = getList;                       // 목록 조회

      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시
      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동
      
      vm.chgParCityCode = chgParCityCode;    

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();


(function () {
    "use strict";
    webapp.controller('CompanyTakeListCtrl', ['$window', '$rootScope', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'postApi', '$filter',
      function CompanyTakeListCtrl($window, $rootScope, $state, $stateParams, CONSTANT, postApi, $filter) {  

        var LIST_CNT_SQL = 'Take.getCompanlyTakeListCnt';
        var LIST_SQL = 'Take.getCompanlyTakeList';  
        var LIST_VIEW_SQL = 'Take.getCompanlyTakeDetail';  
        var LIST_PAGE_URL = 'app.company.company-take-list';   

        var vm = this;      
        vm.dataloader = false;  

        vm.loginUserAdminType = !isNullOrEmpty($window.sessionStorage['loginUserAdminType']) ? $window.sessionStorage['loginUserAdminType'] : "";  
        vm.listSize = CONSTANT.PAGINATION.LISTSIZE; 
        vm.columnMap = {};

        if (!$stateParams.srch) {
            vm.srch = {
            page: 1, 
            viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, 
            tableNm: 'company_take',
            sortDirect: 'DESC',         
            sortColumn: 'T.ApplyCmpDate',      
            loginUserAdminType : vm.loginUserAdminType,   
            };
        } else {
            vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
            if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; 
            vm.currentPage = vm.srch.page;      
            vm.ApplyCmpDateFrom = $rootScope.getDateFormat(vm.srch.ApplyCmpDateFrom); 
            vm.ApplyCmpDateTo = $rootScope.getDateFormat(vm.srch.ApplyCmpDateTo);  
        }

        vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

        vm.setChangeViewSize = function() {
            vm.currentPage = 1; 
            vm.viewSize = vm.srch.viewSize; 
            vm.getSearch();
        }
        vm.getSearch = function() {
            var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
            $state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
        }
        vm.setResetSearch = function() {
          $state.go(LIST_PAGE_URL, {
            srch: ''
          }, {reload: LIST_PAGE_URL});
        }
        vm.setPageChanged = function() {
            vm.srch.page = vm.currentPage; 
            var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
        }

        // 조회
        vm.goDetail = function(paramKeyId) {
          vm.TenantId = paramKeyId;
          vm.dataloader = true;   
          var data = angular.copy(vm.srch); 
          data.TenantId = paramKeyId;
          data.mapCode = LIST_VIEW_SQL;    
          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {   
              if (result.body.docs.length > 0) {
                vm.data = result.body.docs[0];              
                vm.data.MoniDate = moment(vm.data.MoniDate).format('YYYY-MM-DD');
              } 
            }    
            vm.dataloader = false; 
          }, function (error) {
            vm.dataloader = false;   
            console.error("Error> goDetail()");
            console.table(error);    
          });
        }

        // 목록
        vm.getList = function(){
          vm.dataloader = true; 
          vm.viewSize = vm.srch.viewSize;    
          var data = angular.copy(vm.srch); 
          data.ApplyCmpDateFrom = $filter('localToUtc')(data.ApplyCmpDateFrom, 'from');
          data.ApplyCmpDateTo = $filter('localToUtc')(data.ApplyCmpDateTo, 'to'); 
          vm.getListCnt(data);     
          data.mapCode = LIST_SQL;  
          data.selectType = 'List'; 
          postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {   
              if ( result.body.desc.length > 0 ) {
                vm.allColumns = result.body.desc;  
                angular.forEach(vm.allColumns, function (item) {
                  vm.columnMap[item.ColumnPhysicalNm] = item;
                });
              }

              if (result.body.docs.length > 0) {
                vm.lists = result.body.docs;
              } else {
                vm.lists = {};
              }
            }    
            vm.dataloader = false; 

            vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          }, function (error) {
            vm.dataloader = false;   
            console.error("Error> getList()");
            console.table(error);    
          });            
        }
        vm.getListCnt = function(data) { 
            data.mapCode = LIST_CNT_SQL;    
            postApi.select(data, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {    
                if (result.body.docs.length > 0) {
                  vm.totalItems = result.body.docs;
                } else {
                  vm.totalItems = 0;
                }
              }
            }, function (error) {
              console.error("Error> getListCnt()");
              console.table(error);
            });
        }
        

        vm.getList();
      }]);
  })();
  
(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.company', {
      url : '/company',
      template : '<div ui-view></div>',
    }).state('app.company.company-list', {
      url: '/company-list/:srch/:Type',
      templateUrl: 'app/company/company-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
          ]);
        }],
      },
    })
    .state('app.company.company-detail', {
      url: '/company-detail/:srch/:keyId/:Type',
      templateUrl: 'app/company/company-detail.html',
      requiresAuthentication: true,
    }).state('app.company.company-edit', {
      url: '/company-edit/:srch/:keyId/:Type',
      templateUrl: 'app/company/company-edit.html',
      requiresAuthentication: true,
    }).state('app.company.company-list.detail', {
      url: '/detail/:keyId/:Type',
      templateUrl: 'app/company/company-detail.html',
      requiresAuthentication: true,
    }).state('app.company.company-list.edit', {
      url: '/edit/:keyId/:Type',
      templateUrl: 'app/company/company-edit.html',
    })
    .state('app.company.company-take-list', {
      url: '/company-take-list/:srch',
      templateUrl: 'app/company/company-take-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
          ]);
        }],
      },
    })
    .state('app.company.company-take-list.detail', {
      url : '/company-take-detail/:srch/:keyId',
      templateUrl : 'app/company/company-take-detail.html',
      requiresAuthentication: true
    })
    ;
  }
})();
(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.dashboard:dashboard-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @description Controller of the Dashboard
   */
  webapp.controller('DashboardCtrl',
    ['$window', '$rootScope', '$scope', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'postApi', 'gAlert', 'gConfirm', '$timeout', '$filter',
    function DashboardCtrl($window, $rootScope, $scope, $state, $stateParams, CONSTANT, StaticVariable, postApi, gAlert, gConfirm, $timeout, $filter) {
      
      var vm = this;
      vm.dataloader = false;

      if (!$stateParams.srch) {
        vm.srch = {
          page: 1,
          viewSize: CONSTANT.PAGINATION.VIEWSIZE,
          sortDirect: "",
          sortColumn: "",
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.CntDateFrom = $rootScope.getDateFormat(vm.srch.CntDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.CntDateTo = $rootScope.getDateFormat(vm.srch.CntDateTo);
        vm.currentPage = vm.srch.page;
      }

      if (vm.srch.viewSize == null) {
        vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
      }

      vm.tenantType = $window.sessionStorage['loginTenantType'];
      vm.keyId = $stateParams.BbsPostId;
      $scope.selectedRow = $stateParams.BbsPostId;
      vm.srch.BbsMasterId = "7X3HP8Q9F4";
      if ($stateParams.BbsMasterId) {
        vm.srch.tableNm = "";
      }
      vm.srch.CodeType = "HdcBoardType";
      vm.BbsNm = "";
      vm.listSize = [10, 25, 50, 100];

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};

      vm.data = {
          RG_Cnt : 0, 
          AT_Cnt : 0,
          AG_Cnt : 0,
          SP_Cnt : 0,
          RW_Cnt : 0,
          RC_Cnt : 0
      };

      angular.copy(vm.srch, vm.srchList);
      vm.srchList.searchColumns = {};
      vm.layout = $rootScope.gVariable.layoutBoard;
      vm.anchor = "";
      
      (function H0102ListCtrl() {
        console.log("DashboardCtrl:");
      })();

      // 회원사 변경 설정
      $scope.$on("broadcastSetChangeTenantID", function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant("MSG.LISTUPDATED"));
      });

      // 전역상수 선언
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
      $scope.showDetail = function (li) {
        $location.url("/" + li.BbsPostId);
      };

      //#region setSortColumn sortClass 정렬 컬럼 설정
      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == "N") return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) 
          vm.srch.sortDirect = "ASC";
        else  
          vm.srch.sortDirect = vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC";
        
        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      function sortClass(sortkey) {
        if (sortkey != vm.srch.sortColumn) return "fa fa-sort";

        var rtnval = "";

        if (vm.srch.sortDirect == "ASC") {
          rtnval = "fa fa-caret-down";
        } else {
          rtnval = "fa fa-caret-up";
        }
        return rtnval;
      }
      //#endregion

      //#region getList getListCnt getUnreadCnt getData getBbsNm 데이터 조회
      /**
       * 데이터 조회
       * @param
       * @return
       * @author 최원영
       */
      function getList() {
        if (!$scope.selectedRow) {
          vm.dataloader = true;
        }
        vm.viewSize = vm.srch.viewSize;

        getListCnt();
        getUnreadCnt();

        var data = angular.copy(vm.srch);
        data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
        data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
        data.selectType = "List"; // For CustomColumn
        data.mapCode = "BbsPost.getBbsPostList";
        postApi.select(
          data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.desc.length > 0) {
                vm.listColumns = result.body.desc;
                console.warn(vm.listColumns);
                angular.forEach(vm.listColumns, function (item) {
                  vm.srchList.searchColumns[item.ColumnPhysicalNm] = true;
                  vm.columnMap[item.ColumnPhysicalNm] = item;
                });
              }

              if (result.body.docs.length > 0) {
                vm.lists = result.body.docs;
                setResponsive();
              } else {
                vm.lists = {};
              }
            }

            vm.SearchConditionStr = getSearchConditionStr(
              vm.totalItems,
              vm.columnMap,
              vm.srch
            );
            vm.dataloader = false;
          },
          function (error) {
            console.error("Error> DashboardCtrl> getList()", status, error);
            vm.dataloader = false;
          }
        );
      }

      function getListCnt() {
        var data = angular.copy(vm.srch);
        data.RegDateFrom = $filter("localToUtc")(data.RegDateFrom, "from");
        data.RegDateTo = $filter("localToUtc")(data.RegDateTo, "to");
        data.mapCode = "BbsPost.getBbsPostListCnt";
        postApi.select(data, function (result) {
            /* console.log("type C", result.header);
          console.log("type c", result.body); */
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.totalItems = result.body.docs;
              } else {
                vm.totalItems = 0;
              }
            }
          },
          function (error) {
            console.error("Error> DashboardCtrl> getListCnt()", status, error);
          }
        );
      }

      function getUnreadCnt() {
        var data = angular.copy(vm.srch);
        data.mapCode = "BbsPost.getBbsPostUnreadCnt";
        postApi.select(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.totalUnreadItems = result.body.docs[0];
              } else {
                vm.totalUnreadItems = 0;
              }
            }
          },
          function (error) {
            console.error("Error> DashboardCtrl> getListCnt()", status, error);
          }
        );
      }    

      function getData() {
        var data = angular.copy(vm.srch);
        data.CntDateFrom = $filter("localToUtc")(data.CntDateFrom, "from");
        data.CntDateTo = $filter("localToUtc")(data.CntDateTo, "to");
        data.mapCode = "Take.getEachCaseStatusCnt";
        data.tenantType = vm.tenantType;
        postApi.select( data, function (result) {
            if ( result.header.status === CONSTANT.HttpStatus.OK ) {
              if ( result.body.docs.length > 0 ) {
                vm.statusCntList = result.body.docs;
                angular.forEach(vm.statusCntList, function (item) {
                  if ( item.Status == "RG" ) vm.data.RG_Cnt = item.Cnt;
                  else if ( item.Status == "AT" ) vm.data.AT_Cnt = item.Cnt;
                  else if ( item.Status == "AG" ) vm.data.AG_Cnt = item.Cnt;
                  else if ( item.Status == "SP" ) vm.data.SP_Cnt = item.Cnt;
                  else if ( item.Status == "RW" ) vm.data.RW_Cnt = item.Cnt;
                  else if ( item.Status == "RC" ) vm.data.RC_Cnt = item.Cnt;
                  else {}


                });
              } 
            }
          },
          function (error) {
            console.error("Error> DashboardCtrl> getEachCaseStatusCnt()", status, error);
            vm.dataloader = false;
          }
        );
      }

      function getBbsNm() {
        var data = { BbsMasterId: vm.srch.BbsMasterId };
        data.mapCode = "BbsMaster.getBbsMasterDetail";
        postApi.select(
          data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.BbsNm = result.body.docs[0].BbsNm;
              }
            }
            vm.dataloader = false;
          },
          function (error) {
            console.error("Error> DashboardCtrl> getBbsNm()", status, error);
            vm.dataloader = false;
          }
        );
      }
      //#endregion

      //#region setResponsive
      function setResponsive(dockMode) {
        var rows = vm.lists;
        var columns = [];
        var o = {};
        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"];
        //o.formatString = [""];
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};
          column.name = item.ColumnPhysicalNm;
          column.title = item.ColumnLogicalNm;
          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }
          if (item.ColumnPhysicalDataType == "40") {
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }
          index++;
          columns.push(column);
        });
      }
      //#endregion

      //#region pageChanged 페이지 번호 변경시 데이터 조회 함수 호출
      /**
       * 페이지 번호 변경시 데이터 조회 함수 호출
       * @param
       * @return
       * @author 최원영
       */
      function pageChanged() {
        vm.srch.page = vm.currentPage;
        vm.srch.srchTenantId = $rootScope.gVariable.srchTenantId;
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(
          "app.bbspost.h0102-list",
          { srch: srch },
          { reload: "app.bbspost.h0102-list" }
        );
      }
      //#endregion

      //#region goDetail 상세보기 페이지이동
      function goDetail(BbsPostId) {
        var srch = $stateParams.srch != null ? $stateParams.srch : '';
        vm.keyId = BbsPostId;
        $scope.selectedRow = BbsPostId;
        if (vm.layout == "N") {
          $state.go("app.bbspost.h0102-detail", {
            srch: srch,
            BbsPostId: BbsPostId,
            BbsMasterId: vm.srch.BbsMasterId,
          });
        } else {
          angular.forEach(vm.lists, function(item) {
            if (item.BbsPostId == BbsPostId) {
              if (item.UserReadImg == 'fa-envelope') {
                item.UserReadImg = 'fa-envelope-open-o';
                vm.totalUnreadItems = vm.totalUnreadItems > 0 ? vm.totalUnreadItems - 1 : 0;
              }
              return;
            }
          });

          $state.go("app.bbspost.h0102-list.detail", {
            srch: srch,
            BbsPostId: BbsPostId,
            BbsMasterId: vm.srch.BbsMasterId,
          });
        }
      }
      //#endregion

      //#region getSearch resetSearch 상세검색 관련 함수
      function getSearch() {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(
          "app.dashboard",
          { srch: srch },
          { reload: "app.dashboard" }
        );
      }

      function resetSearch() {
        $state.go(
          "app.dashboard",
          { srch: "" },
          { reload: "app.dashboard" }
        );
      }
      //#endregion
      
      //#region changeViewSize 목록 최대 행 수 변경
      function changeViewSize() {
        vm.currentPage = 1;
        vm.viewSize = vm.srch.viewSize;
        getSearch();
      }
      //#endregion

      
      // 팝업조회
      vm.popLink = {};
      function getPopup(){
        var data = { loginYN : 'Y' };
        data.mapCode = "Login.getPopup";
        postApi.select(
          data,
          function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.popLink = result.body.docs[0];
                vm.popLink.ImgSrc = StaticVariable.getUrl("/openapi/attach/" + vm.popLink.PhysicalPath + "/" + vm.popLink.PhysicalFileNm + "/download.do");
                if(isNullOrEmpty(vm.popLink) || isNullOrEmpty(vm.popLink.ImgSrc)){
                  chkCookie(true);
                } else {
                  chkCookie(false, vm.popLink.ImgW, vm.popLink.ImgH);
                }
              }
              else{            
                chkCookie(true);
              }
            }
            else {
              chkCookie(true);
            }
          },
          function (error) {
            console.error("Error> DashboardCtrl> getPopup()", status, error);
          }
        );
      }      

      function chkCookie(isNone, w, h) {
        try {  
          if(isNone){
            $(".szPopup_box").css("display", "none");
          } else if(document.cookie.indexOf("szPopup_box" + "=close") < 0 ) {      // 쿠키 저장여부 체크
            $(".szPopup_box").css("display", "block");
            $(".szPopup_box").css("width", w);
            $(".szPopup_box").css("height", h);
            $(".szPopup_box").css("top", 10);
            $(".szPopup_box").css("left", 0);

          } else {
            $(".szPopup_box").css("display", "none");
          }  
        } catch (e) {
          console.log("Error Popup > " + e);    
        }    
      }

      // 팝업 쿠키 생성
      function fnSetCookie( name, value, expiredays ) {  // 쿠키저장
        var todayDate = new Date();  //date객체 생성 후 변수에 저장
        todayDate.setDate( todayDate.getDate() + expiredays ); 
          
        // 시간지정(현재시간 + 지정시간)
        document.cookie = name + "=" + value + "; path=/; expires=" + todayDate.toUTCString() + ";";
      } 
                
      // 팝업 오늘하루만보기 
      vm.closePopupToday = function() { 
        fnSetCookie("szPopup_box", "close" , 1);
        $(".szPopup_box").css("display", "none");
      };
  
      // 팝업 닫기
      vm.closePopup = function() {
        $(".szPopup_box").css("display", "none");
      };
      
      // 함수 선언
      vm.pageChanged = pageChanged;
      vm.getList = getList;
      vm.changeViewSize = changeViewSize;
      vm.getSearch = getSearch;
      vm.goDetail = goDetail;
      vm.resetSearch = resetSearch;
      vm.setResponsive = setResponsive;
      vm.setSortColumn = setSortColumn;
      vm.sortClass = sortClass;
      vm.getData = getData();
      vm.getPopup = getPopup;

      // 데이터 조회
      getPopup();
      getBbsNm();
      getList();
      getData();

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        //getSearch('all');
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });
    }]);
})();

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.dashboard', {
      url : '/dashboard?srch',
      templateUrl: 'app/dashboard/dashboard.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    })
    ;
  }
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:campaign-customer-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('CampaignEmailCustomerDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CampaignEmailCustomerDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Campaign2.insertCampaignBatch';     // 등록 SQL
      var UPDATE_SQL = 'Campaign2.updateCampaign';     // 수정 SQL
      var VIEW_SQL = 'Campaign2.getCampaignDetail3';   // 조회 SQL
      var DEL_SQL = 'Campaign2.deleteCampaign';  // 삭제 SQL
      var GET_GRUOP_CUST_CNT_SQL = 'Campaign2.getGroupCustomerList2';                  // 수신그룹 대상고객 조회
      var GET_GROUP_CUST_SQL = 'Campaign2.getCampaignCustomers';
      var GET_CUST_CNT_SQL = 'Campaign2.getCampaignCustCnt';

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.campaign-email-customer-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.message.campaign-email-customer-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.message.campaign-email-customer-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign.info2'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // View Model
      var vm = this;          // View Model
      vm.layout = $rootScope.gVariable.layoutBoard;
      vm.goList = goList;

      (function CampaignCustomerDetailCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;

        vm.CmpgnImplCustId = $stateParams.keyId;
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect';
        
        vm.sendNumberVerifyList = [];
        
        getCustInfo();
      })();

      function goList() {
        var srch = $stateParams.srch != null ? $stateParams.srch : '';
        $state.go(LIST_PAGE_URL, {
          srch : srch
        });
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = {};
        data.selectType = 'Detail';
        data.CmpgnImplCustId = vm.CmpgnImplCustId;
        data.mapCode = 'Campaign2.getCampaignDetail3';

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data = result.body.docs[0];
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        console.log('data', data);
        
        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          item.SendTitle = data.SendTitle;
          item.SendMessage = data.SendMessage;
          item.SendMessage2 = data.SendMessage2;
        });
        
        postApi.insert(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.error("Error> getSendNumberList()");
          console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }
        
        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
        
      }
      
      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.messageLength = 0;
      vm.messageMaxLength = 90;
      function chkSendMessage() {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS';
        vm.messageMaxLength = vm.data.CmpgnChannel == 'SMS' ? '90' : '2000';
        vm.messageLength = bytes;
      }
      
      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까?', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }

    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:campaign-customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the campaign 목록
   */
  webapp.controller('CampaignEmailCustomerListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CampaignEmailCustomerListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Campaign2.getCampaignImplCustomerListCnt3'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign2.getCampaignImplCustomerList3';    // 목록 조회 SQL
      var STATS_SQL = 'Campaign2.getEmailStatsList';
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Campaign2.deleteCampaignList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.campaign-email-customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.message.campaign-email-customer-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.message.campaign-email-customer-list.edit';    // 목록 등록/수정 화면

      var VIEW_PAGE_URL = 'app.message.campaign-email-customer-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.message.campaign-email-customer-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaignImplCustomer2'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      var toDate = new Date();

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          // CmpgnChannel : 'EMAIL',
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          RegDateFrom : moment(new Date(toDate.getFullYear(), toDate.getMonth(), 1)).format('YYYY-MM-DD'),
          RegDateTo : moment(new Date(toDate.getFullYear(), toDate.getMonth()+1, 0)).format('YYYY-MM-DD')
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId == null ? '':$stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      $rootScope.$on('$viewContentLoaded', function(event, viewName, viewContent){
        console.log('rootScope $viewContentLoaded th count=', $(".table-custom thead th").length);
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      
      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.ManagerId = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.ManagerId = "";
      };
      

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        
        getListCnt(); // 목록 건수 조회
        getStatsList();
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        if(vm.RegDateFrom == undefined && vm.RegDateTo == undefined) {
          vm.RegDateFrom = vm.srch.RegDateFrom;
          vm.RegDateTo = vm.srch.RegDateTo; 
        }
        vm.srch.RegDateFrom = moment(data.RegDateFrom).format('YYYY-MM-DD');
        vm.srch.RegDateTo = moment(data.RegDateTo).format('YYYY-MM-DD');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      function getStatsList() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.mapCode = STATS_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.FailSms = result.body.docs[0].FailSms;
              vm.SuccessSms = result.body.docs[0].SuccessSms;
              vm.WaitSms = result.body.docs[0].WaitSms;
            } else {
              // 조회 실패
              vm.FailSms = 0;
              vm.SuccessSms = 0;
              vm.WaitSms = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;
        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd(cmpgnType) {
        vm.keyId = '';
        var srch = $stateParams.srch; // 검색 옵션
        var pageUrl = '';

        if (vm.layout == 'N') {
          pageUrl = EDIT_PAGE_URL;
        } else {
          pageUrl = LIST_EDIT_PAGE_URL;
        }
        
        $state.go(pageUrl, {
          srch: srch,
          formType: '',
          cmpgnType : cmpgnType,
          keyId: ''
        });
      }
      
      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId, cmpgnType) {
        var bAuto = false;
        var srch = $stateParams.srch; // 검색 옵션
        var pageUrl = '';
        
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          pageUrl = EDIT_PAGE_URL;
        } else {
          pageUrl = LIST_EDIT_PAGE_URL;
        }
        
        $state.go(pageUrl, {
          srch: srch,
          cmpgnType: cmpgnType,
          keyId: paramKeyId
        });
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.getStatsList = getStatsList;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:campaign-customer-detail-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('CampaignSmsCustomerDetailCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout', '$filter',

    function CampaignSmsCustomerDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'Campaign2.insertCampaignBatch';     // 등록 SQL
      var UPDATE_SQL = 'Campaign2.updateCampaign';     // 수정 SQL
      var VIEW_SQL = 'Campaign2.getCampaignDetail3';   // 조회 SQL
      var DEL_SQL = 'Campaign2.deleteCampaign';  // 삭제 SQL
      var GET_GRUOP_CUST_CNT_SQL = 'Campaign2.getGroupCustomerList2';                  // 수신그룹 대상고객 조회
      var GET_GROUP_CUST_SQL = 'Campaign2.getCampaignCustomers';
      var GET_CUST_CNT_SQL = 'Campaign2.getCampaignCustCnt';

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.campaign-sms-customer-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.message.campaign-sms-customer-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.message.campaign-sms-customer-edit';           // 수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign.info2'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // View Model
      var vm = this;          // View Model
      vm.layout = $rootScope.gVariable.layoutBoard;
      vm.goList = goList;

      (function CampaignCustomerDetailCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;

        vm.CmpgnImplCustId = $stateParams.keyId;
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect';
        
        vm.sendNumberVerifyList = [];
        
        getCustInfo();
      })();

      function goList() {
        var srch = $stateParams.srch != null ? $stateParams.srch : '';
        $state.go(LIST_PAGE_URL, {
          srch : srch
        });
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = {};
        data.selectType = 'Detail';
        data.CmpgnImplCustId = vm.CmpgnImplCustId;
        data.mapCode = 'Campaign2.getCampaignDetail3';

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data = result.body.docs[0];
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        console.log('data', data);
        
        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          item.SendTitle = data.SendTitle;
          item.SendMessage = data.SendMessage;
          item.SendMessage2 = data.SendMessage2;
        });
        
        postApi.insert(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.error("Error> getSendNumberList()");
          console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }
        
        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
        
      }
      
      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.messageLength = 0;
      vm.messageMaxLength = 90;
      function chkSendMessage() {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS';
        vm.messageMaxLength = vm.data.CmpgnChannel == 'SMS' ? '90' : '2000';
        vm.messageLength = bytes;
      }
      
      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까?', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }

    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:campaign-customer-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the campaign 목록
   */
  webapp.controller('CampaignSmsCustomerListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function CampaignSmsCustomerListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Campaign2.getCampaignImplCustomerListCnt2'; // 목록 건수 조회 SQL
      var LIST_SQL = 'Campaign2.getCampaignImplCustomerList2';    // 목록 조회 SQL
      var STATS_SQL = 'Campaign2.getSmsStatsList';
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'Campaign2.deleteCampaignList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.campaign-sms-customer-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.message.campaign-sms-customer-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.message.campaign-sms-customer-list.edit';    // 목록 등록/수정 화면

      var VIEW_PAGE_URL = 'app.message.campaign-sms-customer-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.message.campaign-sms-customer-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaignImplCustomer2'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      var toDate = new Date();

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          // CmpgnChannel : 'SMS',
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
          RegDateFrom : moment(new Date(toDate.getFullYear(), toDate.getMonth(), 1)).format('YYYY-MM-DD'),
          RegDateTo : moment(new Date(toDate.getFullYear(), toDate.getMonth()+1, 0)).format('YYYY-MM-DD')
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId == null ? '':$stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      $rootScope.$on('$viewContentLoaded', function(event, viewName, viewContent){
        console.log('rootScope $viewContentLoaded th count=', $(".table-custom thead th").length);
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      
      /**
       * 담당자 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserModal = function () {
        var ctrl = 'UserModalCtrl as modalCtrl';
        var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
        var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          vm.srch.ManagerNm = okData.UserNm;
          vm.srch.ManagerId = okData.UserId;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 담당자 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUser = function () {
        vm.srch.ManagerNm = "";
        vm.srch.ManagerId = "";
      };
      

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
        
        getListCnt(); // 목록 건수 조회
        getStatsList();
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        if(vm.RegDateFrom == undefined && vm.RegDateTo == undefined) {
          vm.RegDateFrom = vm.srch.RegDateFrom;
          vm.RegDateTo = vm.srch.RegDateTo; 
        }
        vm.srch.RegDateFrom = moment(data.RegDateFrom).format('YYYY-MM-DD');
        vm.srch.RegDateTo = moment(data.RegDateTo).format('YYYY-MM-DD');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          // vm.SearchConditionStrPlain = vm.SearchConditionStr.replace(/<[^>]+>/g, '');
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김
          
          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
          
        });
      }

      function getStatsList() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.mapCode = STATS_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.FailSms = result.body.docs[0].FailSms;
              vm.SuccessSms = result.body.docs[0].SuccessSms;
              vm.WaitSms = result.body.docs[0].WaitSms;
            } else {
              // 조회 실패
              vm.FailSms = 0;
              vm.SuccessSms = 0;
              vm.WaitSms = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;
        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd(cmpgnType) {
        vm.keyId = '';
        var srch = $stateParams.srch; // 검색 옵션
        var pageUrl = '';

        if (vm.layout == 'N') {
          pageUrl = EDIT_PAGE_URL;
        } else {
          pageUrl = LIST_EDIT_PAGE_URL;
        }
        
        $state.go(pageUrl, {
          srch: srch,
          formType: '',
          cmpgnType : cmpgnType,
          keyId: ''
        });
      }
      
      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId, cmpgnType) {
        var bAuto = false;
        var srch = $stateParams.srch; // 검색 옵션
        var pageUrl = '';
        
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          pageUrl = EDIT_PAGE_URL;
        } else {
          pageUrl = LIST_EDIT_PAGE_URL;
        }
        
        $state.go(pageUrl, {
          srch: srch,
          cmpgnType: cmpgnType,
          keyId: paramKeyId
        });
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.getStatsList = getStatsList;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function () {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.message', {
      url: '/message',
      template: '<div ui-view></div>'
    })
    .state('app.message.sms-send-number-save', {
      url: '/sms-send-number-save/:srch',
      templateUrl: 'app/message/sms-send-number-save.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    })
    .state('app.message.sms-send-number-list', {
      url: '/sms-send-number-list/:srch',
      templateUrl: 'app/message/sms-send-number-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.message.sms-send-number-edit', {
      url: '/sms-send-number-edit/:srch/:keyId',
      templateUrl: 'app/message/sms-send-number-edit.html',
    }).state('app.message.sms-send-number-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/message/sms-send-number-edit.html',
    })
    .state('app.message.campaign-sms-customer-list', {
      url: '/campaign-sms-customer-list/:srch',
      templateUrl: 'app/message/campaign-sms-customer-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.message.campaign-sms-customer-detail', {
      url: '/campaign-sms-customer-detail/:srch/:keyId',
      templateUrl: 'app/message/campaign-sms-customer-detail.html',
    }).state('app.message.campaign-sms-customer-list.detail', {
      url: '/detail/:keyId',
      templateUrl: 'app/message/campaign-sms-customer-detail.html',
    })    
    .state('app.message.campaign-email-customer-list', {
      url: '/campaign-email-customer-list/:srch',
      templateUrl: 'app/message/campaign-email-customer-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.message.campaign-email-customer-detail', {
      url: '/campaign-email-customer-detail/:srch/:keyId',
      templateUrl: 'app/message/campaign-email-customer-detail.html',
    }).state('app.message.campaign-email-customer-list.detail', {
      url: '/detail/:keyId',
      templateUrl: 'app/message/campaign-email-customer-detail.html',
    })    
    .state('app.message.form-email-list', {
      url: '/form-email-list/:srch',
      templateUrl: 'app/message/form-email-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.message.form-email-edit', {
      url: '/form-email-edit/:srch/:keyId',
      templateUrl: 'app/message/form-email-edit.html',
    }).state('app.message.form-email-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/message/form-email-edit.html',
    });
  }
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message.sms-send-number-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 서식 목록
   */
  webapp.controller('SmsSendNumberListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SmsSendNumberListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'SendNumberVerify.insertSendNumberVerify';     // 등록 SQL
      var LIST_CNT_SQL = 'SendNumberVerify.getSendNumberVerifyListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'SendNumberVerify.getSendNumberVerifyList';    // 목록 조회 SQL
      var DELETE_LIST_SQL = 'SendNumberVerify.deleteSendNumberVerify'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.sms-send-number-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.message.sms-send-number-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.message.sms-send-number-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.message.sms-send-number-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.message.sms-send-number-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'SendNumberVerify'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
          //RegDateFrom : '',
          //RegDateTo : '',
          //SendNumber : '',
          //CertType : '',
          //CertYN : ''
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId,formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }
      


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시
      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message.sms-send-number-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the 서식 목록
   */
  webapp.controller('SmsSendNumberSaveCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SmsSendNumberListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'SendNumberVerify.insertSendNumberVerify';     // 등록 SQL
      var LIST_CNT_SQL = 'SendNumberVerify.getSendNumberVerifyListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'SendNumberVerify.getSendNumberVerifyList';    // 목록 조회 SQL
      var DELETE_LIST_SQL = 'SendNumberVerify.deleteSendNumberVerify'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.message.sms-send-number-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.message.sms-send-number-list.detail';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.message.sms-send-number-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.message.sms-send-number-detail';       // 조회 화면
      var EDIT_PAGE_URL = 'app.message.sms-send-number-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'SendNumberVerify'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.RegDateFrom = $rootScope.getDateFormat(vm.srch.RegDateFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.RegDateTo = $rootScope.getDateFormat(vm.srch.RegDateTo);
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수
      
      vm.data = {
         tableNm : KEY_TABLE_NM
       , SendNumber : ''
       , CertType : 'MOBILE'
       , SiteId : 'MMG'
      };
      
      vm.uploadFileList = [];  // 첨부파일 목록
      vm.showUploader = false; // 파입 업로드 컴포넌트 숨김

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      
      
      // #region 첨부파일 Callback
      vm.onFileCallback = {
        onFileUploaded: function (id, result) {
          // 첨부파일 업로드
          $scope.$apply(function () {
            angular.forEach(result.body.docs, function (item) {
              var obj = item;
              obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
              vm.uploadFileList.push(obj);
            });
          });
        },
        onFileUploadComplete: function (id) {
          // 첨부파일 업로드 완료
          // 첨부파일 업로드 이후 저장을 호출해야 함
          if (id == 'vault') {
            $timeout(uploadFile2, 1);
          } else if (id == 'vault2') {
            $timeout(setData, 1);
          }
        },
        onFileDelete: function (item) {
          // 첨부파일 삭제
          var param = {
            fileId: item.id
          };

          // TODO: 첨부파일 삭제 기능 구현 필요
          postApi.attach(param,
            function (result) {
              // 삭제 성공
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                gAlert("", "Menu.DELETED");
              }
            },
            function (error) {
              // 삭제 실패
              console.error("Error> onFileDelete()");
              console.table(error);
            }
          );


        },
        onLoaded: function (id, vault) {
          // 첨부파일 control 설정
          vm[id] = vault;
        }
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.RegDateFrom = $filter('localToUtc')(data.RegDateFrom, 'from');
        data.RegDateTo = $filter('localToUtc')(data.RegDateTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId,formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션

        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }


      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /*
       * 2두리로 만들기
       */
      function setZero(val){
        return val > 10 ?  '' + val : '0' + val ;
      };
      
      /*
       * 요청ID생성
       */
      function setMerchantUID() {
        var d = new Date();
        var rndNum = Math.floor(10 + Math.random() * d.getTime());
        return "CID_" + (d.getFullYear() + "").substring(2, 4) + "" + setZero(d.getMonth() + 1) + "" + setZero(d.getDate()) + "" + setZero(d.getHours()) + "" + setZero(d.getMinutes()) + "_" + rndNum;;
      }
      
      function setVerifyData() {
        
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendNumber)) {
          errMsg = errMsg + '-전화번호를 입력해 주세요.';
        }
        
        if(vm.data.CertType != 'MOBILE' ){
          if (isNullOrEmpty(vm.uploadFileList)) {
            errMsg = errMsg + '<br/>-첨부파일을 업로드 해주세요.';
          }
        }
        
        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        if(vm.data.CertType =='MOBILE' )
        {
          /*
           * 본인인증은 SSCRM용을 사용한다.
           */
          IMP.init("imp86263784"); 
          IMP.certification({ 
            merchant_uid: setMerchantUID()
            ,phone: vm.data.SendNumber           
          }, function (certifyResult) {
            console.table(certifyResult);
            
            if (certifyResult.success) {
              postApi.openApi('personalCertify', certifyResult, function (result) {
                setPaymentCertify(result);
              }, function (error) {
                console.error("Error : personalCertify");
                console.table(error);
              });
            } else {
              alert("본인인증에 실패하였습니다.(" + certifyResult.error_msg + ")");
            }
          });
          
        }else{
          var data = angular.copy(vm.data); // 검색 옵션 설정
          data.mapCode = INSERT_SQL;
          
          data.uploadFileList = [];
          angular.forEach(vm.uploadFileList, function(item) {
            data.uploadFileList.push(item);
          });
          
          postApi.insert(data, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if ( result.body.docs[0].RelateDataId !== null ) {
                gAlert("", "Menu.SAVED", {
                  btn: "",
                  fn: function () {
                    getList();
                  }
                });
                return;
              }
            }else{
              gAlert('', result.body.docs[0].errMessage);
            }
          }, function (error) {
            console.error("Error : personalCertify");
            console.table(error);
          });
        }
      }
      
      /**
       * 결제 처리후 process
       */
      /* function setPaymentCertify(result) {
        var data = angular.copy(vm.data);
        data.mapcode = INSERT_SQL;
        console.log('result', result);
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs[0].RelateDataId !== null && result.body.docs[0].errCd != 'DUP') {
            postApi.insert(data,function (result) {
              alert("발신번호가 인증되었습니다.\n승인 대기.");
              getList();
            }, function (error) {
              console.error("Error : personalCertify");
              console.table(error);
            });
          } else {
            if(result.body.docs[0].errCd && result.body.docs[0].errCd == 'DUP'){
              alert("발신번호가 중복되었습니다."); 
            }else{
              alert("본인인증에 오류가 발생하였습니다.\n고객센터에 문의해주세요.");
            }
            gAlert('', result.body.docs[0].errMessage);
            return false;
          }
        } 
      } */

      /**
       * 결제 처리후 process
       */
      function setPaymentCertify(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if ( result.body.docs[0].status ) {
            gAlert("발신번호가 인증되었습니다.");
            getList();
          }else{
            if(result.body.docs[0].errCd && result.body.docs[0].errCd == 'DUP'){
              gAlert("발신번호가 중복되었습니다.");
            }else{
              gAlert("본인인증에 오류가 발생하였습니다.\n고객센터에 문의해주세요.");
            }
            return false;
          }
        }
      }
      
      
      function setChangeRadioBtn(_data) {
        vm.data.CertType = _data;
        if(_data == "MOBILE") {
          vm.showUploader = false;
        } else {
          vm.showUploader = true;
        }
      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시
      vm.setVerifyData = setVerifyData;
      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.setChangeRadioBtn = setChangeRadioBtn;

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function() {
    "use strict";
  
    webapp.config(routerConfig);
  
    /** @ngInject */
    function routerConfig($stateProvider, $urlRouterProvider) {
      $stateProvider.state('app.eland-request', {
        url : '/eland-request',
        template : '<div ui-view></div>',
      })
      /********************
       * 사례관리기관 페이지 
       ********************/
      // 지원신청 사례 목록
      .state('app.eland-request.take-list-take', {
        url : '/take-list-take/:srch/:type/:status',
        templateUrl : 'app/eland-request/take-list.html',
        requiresAuthentication: true,
        resolve: {
            plugins: ['$ocLazyLoad', function($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css'
              ]);
            }],
        }
      })
      // 지원신청 결과보고 목록
      .state('app.eland-request.take-list-take-RW', {
        url : '/take-list-take-RW/:srch/:type/:status',
        templateUrl : 'app/eland-request/take-list.html',
        requiresAuthentication: true,
        resolve: {
            plugins: ['$ocLazyLoad', function($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css'
              ]);
            }],
        }
      })
      // 지원신청 사례평가 목록
      .state('app.eland-request.take-list-take-RC', {
        url : '/take-list-take-RC/:srch/:type/:status',
        templateUrl : 'app/eland-request/take-list.html',
        requiresAuthentication: true,
        resolve: {
            plugins: ['$ocLazyLoad', function($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css'
              ]);
            }],
        }
      })
      // 위기가정 요청목록
      .state('app.eland-request.take-list-give-RG', {
        url : '/take-list-give-RG/:srch/:type/:status',
        templateUrl : 'app/eland-request/take-list.html',
        requiresAuthentication: true,
        resolve: {
            plugins: ['$ocLazyLoad', function($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css'
              ]);
            }],
        }
      })
      // 위기가정 관심사례 목록
      .state('app.eland-request.take-list-give-AT', {
        url : '/take-list-give-AT/:srch/:type/:status',
        templateUrl : 'app/eland-request/take-list.html',
        requiresAuthentication: true,
        resolve: {
            plugins: ['$ocLazyLoad', function($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css'
              ]);
            }],
        }
      })
      // 위기가정 지원목록
      .state('app.eland-request.take-list-give-AG', {
        url : '/take-list-give-AG/:srch/:type/:status',
        templateUrl : 'app/eland-request/take-list.html',
        requiresAuthentication: true,
        resolve: {
            plugins: ['$ocLazyLoad', function($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css'
              ]);
            }],
        }
      })
      // 위기가정 결과보고
      .state('app.eland-request.take-list-give-RW', {
        url : '/take-list-give-RW/:srch/:type/:status',
        templateUrl : 'app/eland-request/take-list.html',
        requiresAuthentication: true,
        resolve: {
            plugins: ['$ocLazyLoad', function($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css'
              ]);
            }],
        }
      })
      // 사례기관 평가
      .state('app.eland-request.take-list-give-RC', {
        url : '/take-list-give-RC/:srch/:type/:status',
        templateUrl : 'app/eland-request/take-list.html',
        requiresAuthentication: true,
        resolve: {
            plugins: ['$ocLazyLoad', function($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css'
              ]);
            }],
        }
      })
      // 사례 목록
      .state('app.eland-request.take-list', {
        url : '/take-list/:srch/:type/:status',
        templateUrl : 'app/eland-request/take-list.html',
        requiresAuthentication: true,
        resolve: {
            plugins: ['$ocLazyLoad', function($ocLazyLoad) {
              return $ocLazyLoad.load([
                '/assets/app/vendor/footable/js/footable.js',
                '/assets/app/vendor/footable/css/footable.core.min.css'
              ]);
            }],
        }
      })
      // 지원사례 등록
      .state('app.eland-request.take-edit', {
        url : '/take-edit/:srch/:type/:status/:keyId',
        templateUrl : 'app/eland-request/take-edit.html',
        requiresAuthentication: true
      })
      // 지원사례 등록(분할)
      .state('app.eland-request.take-list-take.edit', {
        url : '/edit/:srch/:status/:keyId',
        templateUrl : 'app/eland-request/take-edit.html',
        requiresAuthentication: true
      })
      // 사례 상세
      .state('app.eland-request.take-detail', {
        url : '/take-detail/:srch/:type/:status/:keyId',
        templateUrl : 'app/eland-request/take-detail.html',
        requiresAuthentication: true
      })
      // 사례 상세 (사례 목록) (분할)
      .state('app.eland-request.take-list.detail', {
        url : '/detail/:srch/:status/:keyId',
        templateUrl : 'app/eland-request/take-detail.html',
        requiresAuthentication: true
      })
      // 사례 상세 (지원신청 사례목록) (분할)
      .state('app.eland-request.take-list-take.detail', {
        url : '/detail/:srch/:status/:keyId',
        templateUrl : 'app/eland-request/take-detail.html',
        requiresAuthentication: true
      })
      // 사례 상세 (지원신청 결과보고) (분할)
      .state('app.eland-request.take-list-take-RW.detail', {
        url : '/detail/:srch/:status/:keyId',
        templateUrl : 'app/eland-request/take-detail.html',
        requiresAuthentication: true
      })
      // 사례 상세 (지원신청 사례평가) (분할)
      .state('app.eland-request.take-list-take-RC.detail', {
        url : '/detail/:srch/:status/:keyId',
        templateUrl : 'app/eland-request/take-detail.html',
        requiresAuthentication: true
      })
      // 사례 상세 (위기가정 요청목록) (분할)
      .state('app.eland-request.take-list-give-RG.detail', {
        url : '/detail/:srch/:status/:keyId',
        templateUrl : 'app/eland-request/take-detail.html',
        requiresAuthentication: true
      })
      // 사례 상세 (위기가정 관심사례) (분할)
      .state('app.eland-request.take-list-give-AT.detail', {
        url : '/detail/:srch/:status/:keyId',
        templateUrl : 'app/eland-request/take-detail.html',
        requiresAuthentication: true
      })
      // 사례 상세 (위기가정 지원목록) (분할)
      .state('app.eland-request.take-list-give-AG.detail', {
        url : '/detail/:srch/:status/:keyId',
        templateUrl : 'app/eland-request/take-detail.html',
        requiresAuthentication: true
      })
      // 사례 상세 (위기가정 결과보고) (분할)
      .state('app.eland-request.take-list-give-RW.detail', {
        url : '/detail/:srch/:status/:keyId',
        templateUrl : 'app/eland-request/take-detail.html',
        requiresAuthentication: true
      })
      // 사례 상세 (사례기관 평가) (분할)
      .state('app.eland-request.take-list-give-RC.detail', {
        url : '/detail/:srch/:status/:keyId',
        templateUrl : 'app/eland-request/take-detail.html',
        requiresAuthentication: true
      })
      // 지원사례 결과 보고 등록
      .state('app.eland-request.take-result-edit', {
        url : '/take-result-edit/:srch/:type/:status/:keyId',
        templateUrl : 'app/eland-request/take-result-edit.html',
        requiresAuthentication: true
      })
      // 지원사례 결과 보고 등록 (지원신청 사례목록)(분할)
      .state('app.eland-request.take-list-take.result-edit', {
        url : '/result-edit/:srch/:keyId',
        templateUrl : 'app/eland-request/take-result-edit.html',
        requiresAuthentication: true
      })
      // 지원사례 결과 보고 등록 (지원신청 결과보고)(분할)
      .state('app.eland-request.take-list-take-RW.result-edit', {
        url : '/result-edit/:srch/:keyId',
        templateUrl : 'app/eland-request/take-result-edit.html',
        requiresAuthentication: true
      })
      // 지원사례 결과 보고 상세
      .state('app.eland-request.take-result-detail', {
        url : '/take-result-detail/:srch/:type/:status/:keyId',
        templateUrl : 'app/eland-request/take-result-detail.html',
        requiresAuthentication: true
      })
      // 지원사례 결과 보고 상세(분할)
      .state('app.eland-request.take-list.result-detail', {
        url : '/result-detail/:srch/:keyId',
        templateUrl : 'app/eland-request/take-result-detail.html',
        requiresAuthentication: true
      })
      // 지원사례 결과 보고 상세 (지원신청 사례목록) (분할)
      .state('app.eland-request.take-list-take.result-detail', {
        url : '/result-detail/:srch/:keyId',
        templateUrl : 'app/eland-request/take-result-detail.html',
        requiresAuthentication: true
      })
      // 지원사례 결과 보고 상세 (지원신청 결과보고) (분할)
      .state('app.eland-request.take-list-take-RW.result-detail', {
        url : '/result-detail/:srch/:keyId',
        templateUrl : 'app/eland-request/take-result-detail.html',
        requiresAuthentication: true
      })
      // 지원사례 결과 보고 상세 (위기가정 결과보고) (분할)
      .state('app.eland-request.take-list-give-RW.result-detail', {
        url : '/result-detail/:srch/:keyId',
        templateUrl : 'app/eland-request/take-result-detail.html',
        requiresAuthentication: true
      })
      // 지원신청 사례 평가 등록
      .state('app.eland-request.take-eval-edit', {
        url : '/take-eval-edit/:srch/:type/:status/:keyId',
        templateUrl : 'app/eland-request/take-eval-edit.html',
        requiresAuthentication: true
      })
      // 지원신청 사례 평가 등록 (분할)
      .state('app.eland-request.take-list.eval-edit', {
        url : '/eval-edit/:srch/:keyId',
        templateUrl : 'app/eland-request/take-eval-edit.html',
        requiresAuthentication: true
      })
      // 지원신청 사례 평가 등록 (지원신청 사례목록) (분할)
      .state('app.eland-request.take-list-take.eval-edit', {
        url : '/eval-edit/:srch/:keyId',
        templateUrl : 'app/eland-request/take-eval-edit.html',
        requiresAuthentication: true
      })
      // 지원신청 사례 평가 등록 (지원신청 사례평가) (분할)
      .state('app.eland-request.take-list-take-RC.eval-edit', {
        url : '/eval-edit/:srch/:keyId',
        templateUrl : 'app/eland-request/take-eval-edit.html',
        requiresAuthentication: true
      })
      // 지원신청 사례 평가 등록 (사례기관 평가) (분할)
      .state('app.eland-request.take-list-give-RC.eval-edit', {
        url : '/eval-edit/:srch/:keyId',
        templateUrl : 'app/eland-request/take-eval-edit.html',
        requiresAuthentication: true
      })
      // 지원신청 사례 평가 상세
      .state('app.eland-request.take-eval-detail', {
        url : '/take-eval-detail/:srch/:type/:status/:keyId',
        templateUrl : 'app/eland-request/take-eval-detail.html',
        requiresAuthentication: true
      })
      // 지원신청 사례 평가 상세(분할)
      .state('app.eland-request.take-list.eval-detail', {
        url : '/eval-detail/:srch/:keyId',
        templateUrl : 'app/eland-request/take-eval-detail.html',
        requiresAuthentication: true
      })
      // 우수사례 등록
      .state('app.eland-request.take-best-edit', {
        url : '/take-best-edit/:srch/:type/:status/:keyId',
        templateUrl : 'app/eland-request/take-best-edit.html',
        requiresAuthentication: true
      })
      // 우수사례 상세
      .state('app.eland-request.take-best-detail', {
        url : '/take-best-detail/:srch/:type/:status/:keyId',
        templateUrl : 'app/eland-request/take-best-detail.html',
        requiresAuthentication: true
      })
      ;
    }
})();
webapp.controller("BestCaseDetailCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout', '$sce', '$http',
  /**
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} gAlert - Alert Module
   */
  function BestCaseDetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, postApi, customFieldApi, $rootScope, $timeout, $sce, $http) {

    var LIST_PAGE_URL = 'app.eland-request.take-list';   
    var VIEW_SQL = 'Take.getBestCaseDetail';           

    var vm = this;

    vm.dataloader = false;
    vm.ailoader1 = false;
    vm.ailoader2 = false;
    vm.aiView = {
      AiStory: '',
    }    

    vm.srch = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.tenantType = $window.sessionStorage['loginTenantType']; 
    vm.srchDetail = {};
    vm.columnMap = {};

    if ( !$stateParams.srch ) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }
    if ( !isNullOrEmpty($stateParams.keyId) ) {
      vm.srch.CaseManageId = $stateParams.keyId;
    }
    if ( !isNullOrEmpty($stateParams.BestCaseId) ) {
      vm.srch.BestCaseId = $stateParams.BestCaseId;
    }
    vm.srch.tableNm = 'bestcase';    
    angular.copy(vm.srch, vm.srchDetail);

    // 조회 데이터
    vm.data = {
      tableNm :  vm.srch.tableNm,
      BestCaseId : vm.srch.BestCaseId,
      CaseManageId : vm.srch.CaseManageId
    };

    /**
     * 데이터 조회
     */
     function getData() {
      vm.dataloader = true;
      vm.srchDetail.keyId = $stateParams.keyId;
      vm.srchDetail.mapCode = VIEW_SQL;
      postApi.select(vm.srchDetail, function(result) {
          if ( result.header.status === CONSTANT.HttpStatus.OK ) {
            if ( result.body.docs.length > 0 ) {
              vm.data = result.body.docs[0];              
              vm.data.ReqDate = moment(vm.data.ReqDate).format('YYYY-MM-DD');

              vm.aiView.AiStory = vm.getAiHtml(vm.data.AiStory);
              if(vm.data.AiNewYN == "Y"){
                getAiData()
                .then(function() {
                })
                .catch(function(error) {                                
                  gAlert('', 'AI 분석 중 오류가 발생했습니다.');
                  console.error("에러 발생:", error);
                });
              }
            }
          }

          vm.dataloader = false;
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    /**
     * 목록 이동
     */
    vm.goList = function() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      var type = $stateParams.type;
      var status = $stateParams.status;

      if (!isNullOrEmpty(type)) {
        if (!isNullOrEmpty(status)) {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type + '-' + status;
        } else {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type;
        }
      }
      $state.go(LIST_PAGE_URL, { srch: srch, type : type, status : status});
    };

    vm.aiStoryEdit = false,
    vm.toggleAiEdit = function(tgt){
      vm.aiStoryEdit = ! vm.aiStoryEdit;
    }

    /**
     * ai 저장
     */
    vm.saveAiData = function(isAi){      
      var data = {
        BestCaseId : vm.data.BestCaseId,
        AiStory : vm.data.AiStory,
      }
      
      if (isNullOrEmpty(data.AiStory)) {
        gAlert('', '저장할 내용이 없습니다');
        return false;
      }

      var mapCode = 'Take.updateAiStoryData';

      postApi.sendPostApi('update', mapCode, data, function (result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          var msg = "";
          if(isAi){
            vm.aiView.AiStory = vm.getAiHtml(vm.data.AiStory);
            vm.aiStoryEdit = false;
          } else {
            gAlert('', '저장되었습니다.', {
              btn : '',
              fn : function() {
                vm.aiView.AiStory = vm.getAiHtml(vm.data.AiStory);
                vm.aiStoryEdit = false;
              }
            });
          }
        }
      },function (error) {
        console.table(error);
      });
    };

    /**
     * ai 조회
     */
    function getAiData() {
      return new Promise(function(resolve, reject) {
        var data = {     
          query: "",
          req_num: vm.data.keyId,
        };
        vm.ailoader1 = true;

        postApi.getAiData(data, "story")
        .then(function(response) {
          if (response.header.status === CONSTANT.HttpStatus.OK) {
            var responseText = response.body.docs[0].answer || '오류';
            
            vm.data.AiStory = responseText; 
            vm.aiView.AiStory = vm.getAiHtml(responseText);
            vm.saveAiData(true);

            resolve("ok"); 
          } else {
            reject(response.body.docs[0].errMessage); 
          }
        })
        .catch(function(error) {
          var errorMessage = (error.data && error.data.detail) ? error.data.detail : '오류';
          console.error(errorMessage);
          reject(error); 
        })
        .finally(function() {
          vm.ailoader1 = false; 
        });
      });
    }

    vm.getAiHtml = function (htmlTxt){
      return $sce.trustAsHtml(htmlTxt);
    }

    /**
     * 다운로드
     */
    vm.downloadFile = function(){
      var data = {    
        query: "전달하는 html 태그 텍스트를 DOCX 파일로 생성해줘",
        req_num: vm.data.keyId,
      };
      vm.ailoader2 = true;

      postApi.getAiDownload(data)
        .then(function(response) {
          var blob = new Blob([response.data], { 
              type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' 
          });
          var link = document.createElement('a');
          link.href = window.URL.createObjectURL(blob);
          link.download = "story.docx";
          link.click();
          window.URL.revokeObjectURL(link.href);
      })
      .catch(function(error) {
          console.error("다운로드 오류:", error);
      })
      .finally(function() {
          vm.ailoader2 = false;
      });
    };

    getData();
  }
]);

webapp.controller("BestCaseEditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout', 'fileUploadService', 'TakeService', 
  /**
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} gAlert - Alert Module
   */
  function BestCaseEditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, postApi, customFieldApi, $rootScope, $timeout, fileUploadService, TakeService) {

    var LIST_PAGE_URL = 'app.eland-request.take-list'; 

    var VIEW_SQL = 'Take.getBestCaseDetail';    
    var INSERT_SQL = 'Take.insertBestCaseDetail';   
    var UPDATE_SQL = 'Take.updateBestCaseDetail';   

    var vm = this;

    vm.dataloader = false;
    vm.srch = {};
    vm.layout = $rootScope.gVariable.layoutBoard; 
    vm.srchDetail = {};
    vm.columnMap = {};

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    if ( !isNullOrEmpty($stateParams.keyId) ) {
      vm.srch.CaseManageId = $stateParams.keyId;
    }

    vm.srch.tableNm = 'bestcase';    
    angular.copy(vm.srch, vm.srchDetail);

    vm.srchDetail.uploadFileList = []; 
    vm.srchDetail.IdName = 'BestCaseId'; 
    vm.srchDetail.selectType = "Edit"; 

    vm.uploadFileList = [];
    vm.showUploader = false;

    vm.data = {
      tableNm :  vm.srch.tableNm,
      CaseManageId : vm.srch.CaseManageId
    }; 
    
    
   // 업로드 파일 목록
   vm.attach = {
    Photo1: { label: '지원 후 사진', grpId: 1, id: 'Photo1', size: 0, delState: '', ngIf: true},
    Photo2: { label: '', grpId: 2, id: 'Photo2', size: 0, delState: '', ngIf: false},
    Photo3: { label: '', grpId: 3, id: 'Photo3', size: 0, delState: '', ngIf: false},
    Photo4: { label: '', grpId: 4, id: 'Photo4', size: 0, delState: '', ngIf: false},
    Photo5: { label: '', grpId: 5, id: 'Photo5', size: 0, delState: '', ngIf: false},
    Letter1: { label: '감사 편지', grpId: 11, id: 'Letter1', size: 0, delState: '', ngIf: true},
    Letter2: { label: '', grpId: 12, id: 'Letter2', size: 0, delState: '', ngIf: false},
    Letter3: { label: '', grpId: 13, id: 'Letter3', size: 0, delState: '', ngIf: false},
    Letter4: { label: '', grpId: 14, id: 'Letter4', size: 0, delState: '', ngIf: false},
    Letter5: { label: '', grpId: 15, id: 'Letter5', size: 0, delState: '', ngIf: false},
  };

  vm.attachRpt = angular.copy(TakeService.rptAttach2);

  vm.addFile = function(type) {
    isMax = true;
    for (var i = 1; i <= 5; i++) {
      var key = type + i;
      if (vm.attach[key].ngIf === false) {
        vm.attach[key].ngIf = true; 
        isMax = false;
        break; 
      }
    }
    if(isMax){        
      alert("더 이상 파일을 추가할 수 없습니다.");
    }
  } 

    /**
     * 데이터 조회
     */
    vm.getData = function() {
        vm.dataloader = true;
        vm.srchDetail.keyId = $stateParams.keyId;
        vm.srchDetail.mapCode = VIEW_SQL;
        vm.srchDetail.tableNm = vm.srch.tableNm;
        vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
        postApi.select(vm.srchDetail, function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
                if (result.body.docs.length > 0) {
                    vm.data = result.body.docs[0];
                    vm.data.ReqDate = moment(vm.data.ReqDate).format('YYYY-MM-DD');     

                    if (vm.data.uploadFileList) {
                      angular.forEach(vm.data.uploadFileList, function (item) {
                        angular.forEach(vm.attach, function (att) {
                          if(att.grpId == item.GrpId){    
                            var target = att.id;    
                            vm.attach[target].isLoaded = true;
                            vm.attach[target].fileName = item.LogicalFileNm;
                            vm.attach[target].size = item.FileSize;
                            vm.attach[target].path = item.PhysicalPath;
                            vm.attach[target].fileKey = item.PhysicalFileNm;
                            vm.attach[target].link = StaticVariable.getUrl("/openapi/attach/" + item.PhysicalPath + "/" + item.PhysicalFileNm + "/download.do");
                            vm.attach[target].delState = '';
                            vm.attach[target].ngIf = true;
                          } else {
                            return;
                          }
                        });
                      });
                    } else {
                      vm.data.uploadFileList = [];
                    }
                }
            }
            vm.dataloader = false;
        },
        function(error) {
            vm.dataloader = false;
            console.table(error);
        });
    }

    // 결과보고서의 대상자 사진
    vm.getPhotoData = function() {
      vm.dataloader = true;
      var data = {
        tableNm : 'resultreport', 
        IdName : 'ResultReportId',
        uploadFileList : [],
        keyId : $stateParams.keyId,
      }
      postApi.select("Take.getTakeResultDetail", data, function (result) {
          if ( result.header.status === CONSTANT.HttpStatus.OK ) {
            if ( result.body.docs.length > 0 ) {
              if (result.body.docs[0].uploadFileList) {
                angular.forEach(result.body.docs[0].uploadFileList, function (item) {
                  angular.forEach(vm.attachRpt, function (att) {
                    if(att.grpId == item.GrpId){                        
                      var target = att.id;    
                      vm.attachRpt[target].isLoaded = true;
                      vm.attachRpt[target].fileName = item.LogicalFileNm;
                      vm.attachRpt[target].link = StaticVariable.getUrl("/openapi/attach/" + item.PhysicalPath + "/" + item.PhysicalFileNm + "/download.do");
                      vm.attachRpt[target].downAuth = true;
                      vm.attachRpt[target].ngIf = true;
                    } else {
                      return;
                    }
                  });
                });
              } 
            }
          }
          vm.dataloader = false;
        },
        function (error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    /**
     * 데이터 저장
     */
    vm.setData = function() {      
        if (getIsValidData()) {
            var data = angular.copy(vm.data);
            data.AiNewYN = "Y";
            data.tableNm = vm.srch.tableNm;
            data.tableId = vm.data.BestCaseId;
            data.IdName = vm.srchDetail.IdName; 
            data.keyId = $stateParams.keyId; // CaseManageId
            if (isNullOrEmpty(data.BestCaseId)) {
                data.mapCode = INSERT_SQL;
            } else {
                data.mapCode = UPDATE_SQL;
            }

            postApi.insert(data, function(result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                    if (result.body.docs.length > 0) {
                        gAlert('', '저장 되었습니다.', {
                        btn : '',
                        fn : function() {
                            vm.goList();
                        }
                        });
                    }
                }
            });
        }
    }

    /**
     * 목록 이동
     */
    vm.goList = function() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      var type = $stateParams.type;
      var status = $stateParams.status; 
      if (!isNullOrEmpty(type)) {
        if (!isNullOrEmpty(status)) {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type + '-' + status;
        } else {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type;
        }
      }
      $state.go(LIST_PAGE_URL, { srch: srch, type : type, status : status});
    }

    /**
     * 유효성 검사
     */
    function getIsValidData() {
      var data = angular.copy(vm.data);
      var errMsg = '';  
      
      fileKeys = ['Photo1', 'Photo2', 'Photo3', 'Photo4', 'Photo5'];
      if (fileKeys.every(function(key) { return isNullOrEmpty(vm.attachRpt[key].fileName);})
        && fileKeys.every(function(key) { return isNullOrEmpty(vm.attach[key].fileName);})) {
        errMsg = errMsg + '- 지원후 사진을 1장 이상 업로드 해주세요. </br>';
      }

      fileKeys = ['Review1', 'Review2', 'Review3', 'Review4', 'Review5'];
      fileKeys2 = ['Letter1', 'Letter2', 'Letter3', 'Letter4', 'Letter5'];
      if (fileKeys.every(function(key) { return isNullOrEmpty(vm.attachRpt[key].fileName);})
        && fileKeys2.every(function(key) { return isNullOrEmpty(vm.attach[key].fileName);})) {
        errMsg = errMsg + '- 감사편지를 1장 이상 업로드 해주세요. </br>';
      }

      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }
 
      return true;
    }   

    /** 
     * 파일 업로드 
     */
    vm.openAttachDialog = function (target) {  
        var elementNm = "#" + target;
        var fileElement = angular.element(elementNm);
   
        fileElement.trigger("click");    
        fileElement.off('change').on('change', function () {
          var file = fileElement[0].files[0];
          if (!file) return;    
          
         var fileName = file.name.toLowerCase();
         var isImage = file.type.startsWith("image/") || /\.(jpg|jpeg|png|gif|webp|pdf)$/.test(fileName);
   
         if (!isImage) {
           alert("이미지 또는 PDF 파일만 업로드할 수 있습니다.");
                 $(this).val(""); 
                 return; 
             }
   
          var reader = new FileReader();
          reader.onload = function (e) {         
            vm.data[target] =  $(fileElement).val(); 
            vm.onChangeHandler([file], target); 
          };    
          reader.readAsDataURL(file);  
        });
      };

      vm.onChangeHandler = function (files, target) {
        $scope.$root.safeApply(function () {
          resetAttachment(target);
          vm.attach[target].fileName = files[0].name;
          vm.attach[target].size = files[0].size;
          var request = fileUploadService.post(files, null, function (percent) {
          });
   
          try {
            request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey=' + $rootScope.gVariable.userKey)).then(function (value) {   
              angular.forEach(value.data.responseVO.body.docs, function (item) {
                if (item.fileName == vm.attach[target].fileName && item.size == vm.attach[target].size) {
                  vm.attach[target].isLoaded = true;
                  vm.attach[target].tmpFileKey = item.tmpFileKey;
                  vm.attach[target].fileKey = item.tmpFileKey; 
                  vm.attach[target].typeId = item.typeId;
                  vm.attach[target].path = item.path;
                  vm.attach[target].link = StaticVariable.getUrl("/openapi/attach/temp/" + item.tmpFileKey + "/download.do?&fileName=" + item.encFileName);
                  vm.attach[target].delState = '';
                  vm.data.uploadFileList.push(vm.attach[target]);   
                }
              });
            }, function (error) {
              console.error('Error> company-edit-ctrl> uploadFiles()', status, error);
            });
          } catch (error) {
            console.error('Error> company-edit-ctrl> uploadFiles()', status, error);
          }
        });
      };

      function resetAttachment(target) {
        vm.attach[target].isLoaded = false;
        vm.attach[target].fileName = '';
        vm.attach[target].size = 0;
        vm.attach[target].path = '';
        vm.attach[target].link = '';
        vm.attach[target].delState = '';
      }

      /**
       * 파일 삭제
       */
      vm.onDelete = function (target) {
        angular.forEach(vm.data.uploadFileList, function (item, idx) {
          if(vm.attach[target].fileKey != undefined){
            if (item.PhysicalFileNm == vm.attach[target].fileKey) {
              item.delState = 'delete';
              item.fileKey = vm.attach[target].fileKey;
              item.id = item.fileId;
              item.path = vm.attach[target].path;
            }
          } else {
            if (item.id == target) {
              vm.data.uploadFileList.splice(idx, 1) 
            }
          }
        });

        resetAttachment(target);
        return;
      };

      // 첨부파일 다운로드
    vm.downloadFile = function (target) {
      if (!isNullOrEmpty(vm.attachRpt[target].link)) {
        window.open(vm.attachRpt[target].link);
      }
    };

    vm.getData();
    vm.getPhotoData();
  }
]);

/**
 * @ngdoc function
 * @name app.request:request-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("TakeDetailCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "gAlert", 'modalFactory', "postApi", "customFieldApi", "$rootScope", '$timeout', 'gConfirm', '$sce', '$http', 'TakeService',
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} gAlert - Alert Module
   */
  function TakeDetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, 
    modalFactory, postApi, customFieldApi, $rootScope, $timeout, gConfirm, $sce, $http, TakeService) {
    var vm = this;
    
    vm.dataloader = false;
    vm.ailoader1 = false;
    vm.aiView = {
      request: '',
      site: '',
      external: '',
      summary: '',
      final: '',
    }    
    vm.aiRequestEdit = false,
    vm.aiFinalEdit = false,

    vm.srchDetail = {};
    vm.columnMap = {};
    vm.layout = $rootScope.gVariable.layoutBoard;

    // 관련 화면 정의
    var LIST_PAGE_URL = 'app.eland-request.take-list';                                  // 목록 화면      
    var EDIT_PAGE_URL = 'app.eland-request.take-edit';                                  // 등록/수정 화면
    var LIST_EDIT_PAGE_URL = 'app.eland-request.take-list-take.edit';                   // 등록/수정 분할 화면

    // SQL Mapper Id 정의
    var VIEW_SQL = 'Take.getTakeDetail';                                                // 상세 조회 SQL
    var TENANT_VIEW_SQL = 'Tenant.getTenantDetail';                                     // 기관 정보 조회 SQL
    var FRM_LIST_SQL = 'Take.getTakeFrmList';                                           // 가족관계 목록 조회 SQL
    var TENANT_SPT_LIST_SQL = 'Take.getTakeTenantSptList';                              // 타기관 지원 목록 조회 SQL
    var FINAN_LIST_SQL = 'Take.getTakeFinanList';                                       // 금융자산 목록 조회 SQL
    var STATUS_LIST_SQL = 'Take.getStatusRecordDetail';                                 // 상태이력 목록 조회 SQL
    var INSERT_STATUS_SQL = 'Take.insertStatusRecord';                                  // 상태 처리 SQL (결과보고대기 제외)
    var INSERT_STATUS_RW_SQL = 'Take.insertStatusRecordRW';                             // 상태 처리 SQL (결과보고대기만 포함)
    var DELETE_DETAIL_SQL = 'Take.deleteTakeDetail';                                    // 삭제 처리 SQL
    var INSERT_COMMENT_SQL = 'Take.insertTakeComment';                                  // 댓글 저장 SQL
    var UPDATE_COMMENT_SQL = 'Take.updateTakeComment';                                  // 댓글 수정 SQL
    var COMMNET_LIST_SQL = 'Take.getTakeCommentList';                                   // 댓글 목록 조회 SQL
    var DELETE_COMMENT_SQL = 'Take.deleteTakeComment';                                  // 댓글 삭제 SQL
    var INSERT_TENANTRECOMM_SQL = 'Take.insertTenantRecomm';                            // 기관추천 저장 SQL
    var DELETE_TENANTRECOMM_SQL = 'Take.deleteTenantRecomm';                            // 기관추천 삭제 SQL
    var LIST_TENANTRECOMM_SQL = 'Take.getTenantRecommList';                             // 기관추천 목록 조회 SQL
    var RESET_DETAIL_SQL = 'Take.resetTakeDetail';                                      // 사례 상태 초기화 SQL
    var CANCEL_STATUSCNT_SQL = 'Take.canCelStatusCnt';                                  // 상태 처리 조회 SQL (관심, 논의중 취소)
    var CANCEL_ONE_STATUS_SQL = 'Take.canCelOneStatusRecord';                           // 상태 처리 SQL (1건일때 관심, 논의중 취소)
    var CANCEL_STATUS_SQL = 'Take.canCelStatusRecord';                                   // 상태 처리 SQL (여러건일때 관심, 논의중 취소)
    var ETCCOST_LIST_SQL = 'Take.getTakeEtcCostList'                  // 기타지출 목록 조회 SQL
    var INSERT_VOLUNTEER_SQL = 'Take.insertVolunteer';                            // 봉사단 저장 SQL
    var DELETE_VOLUNTEER_SQL = 'Take.deleteVolunteer';                            // 봉사단 삭제 SQL
    var LIST_VOLUNTEER_SQL = 'Take.getVolunteerList';                             // 봉사단 목록 조회 SQL
    var UPDATE_EXE_SQL = 'Take.updateTakeByAdmin';                            // 실행정보 저장 SQL
    var COMMNET_ADMIN_LIST_SQL = 'Take.getTakeCommentAdminList';                                   // 댓글관리자 목록 조회 SQL
    var SV_ADMIN_LIST_SQL = 'Take.getTakeSiteVeriftAdminList';
    var EXTN_LIST_SQL = 'Take.getTakeExtnList';                      // 외부자원연계 목록 조회 SQL

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.keyId = $stateParams.keyId;
    
    vm.btnShow = '1';       

    // 업로드 파일 목록
    vm.attach = angular.copy(TakeService.caseAttach);

    vm.selfData = angular.copy(TakeService.selfDataQst);
    vm.selfDataResult = {};
    vm.selfDataQna = angular.copy(TakeService.selfDataQna);

    vm.fileView = function(key){
     chk = true;
     switch(key){
       case 'AttachFile5': chk = !vm.isPesEtcOnly; break;
       case 'AttachFile2': chk = !vm.isPesEtcOnly; break;
       case 'AttachFile4': chk = !vm.isPesEtcOnly; break;
       case 'AttachFile6': chk = vm.isPesOnly; break;
     }
     return vm.attach[key].ngIf && chk;
    }

    vm.timeList = angular.copy(TakeService.timeList);

    vm.tenantType = $window.sessionStorage['loginTenantType'];                          // 회원사 타입
    vm.tenantId = $window.sessionStorage['loginTenantId'];                              // 회원사 ID
    
    vm.loginUserAdminType = !isNullOrEmpty($window.sessionStorage['loginUserAdminType']) ? $window.sessionStorage['loginUserAdminType'] : "";  
    vm.isAdminA = vm.loginUserAdminType == "A";
    vm.isAdminS = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S"); // 시스템관리자, 사무국
    vm.isAdminSH = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "H"); // 시스템관리자, 사무국, 현장간사
    vm.isAdminB = (vm.loginUserAdminType == "B"); // 봉사단
    vm.isCaseB = false;
    vm.isAdminAI = (vm.isAdminSH || (!isNullOrEmpty($window.sessionStorage['loginUserAiAdminYN']) && $window.sessionStorage['loginUserAiAdminYN'] == "Y")); 
    vm.regUserType = '';

    vm.comment = {};                                                                    // 댓글
    vm.ext1Data = {}; // 추천기관                                                     
    vm.ext2Data = {}; // 봉사단
    vm.oldStatus = "";
    vm.commAdminData = {list:[]}; // 비밀댓글관리자
    vm.svAdminData = {list:[]}; // 현장실사심사자

    vm.isPesOnly = false;
    vm.isPesEtcOnly = false;

    // 실행정보 비활성화
    vm.disExe1 = true;
    vm.disExe2 = true;
    vm.disExe3 = true;
    vm.disExe4 = true;
    
    vm.isMobile = false;

    // 외부자원연계 데이터
    vm.extnData = {};
    vm.extnList = [];
    vm.TotalExtnSum = 0;

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;

      var data = angular.copy(vm.srch);
      data.mapCode = VIEW_SQL;
      data.keyId = vm.keyId;

      // For CustomColumn and FileAttachment
      data.tableNm = 'casemanage';
      data.IdName = 'keyId';
      data.selectType = 'Edit';
      data.uploadFileList = []; 

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.desc.length > 0) {
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }
          
          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];
            vm.data.BirthDay = moment(vm.data.BirthDay).format('YYYY-MM-DD');
            
            // 물품지원(Req06)만 선택했을 경우
            vm.isPesOnly = ((isNullOrEmpty(vm.data.SupportReq01) || vm.data.SupportReq01 == "0")
                              && (isNullOrEmpty(vm.data.SupportReq02) || vm.data.SupportReq02 == "0") 
                              && (isNullOrEmpty(vm.data.SupportReq03) || vm.data.SupportReq03 == "0") 
                              && (isNullOrEmpty(vm.data.SupportReq04) || vm.data.SupportReq04 == "0") 
                              && (isNullOrEmpty(vm.data.SupportReq05) || vm.data.SupportReq05 == "0") 
                              && ( ! isNullOrEmpty(vm.data.SupportReq06) && vm.data.SupportReq06 == "1"));    

            // 물품지원(Req06), 기타(Req05)만 선택했을 경우
            vm.isPesEtcOnly = ((isNullOrEmpty(vm.data.SupportReq01) || vm.data.SupportReq01 == "0")
              && (isNullOrEmpty(vm.data.SupportReq02) || vm.data.SupportReq02 == "0") 
              && (isNullOrEmpty(vm.data.SupportReq03) || vm.data.SupportReq03 == "0") 
              && (isNullOrEmpty(vm.data.SupportReq04) || vm.data.SupportReq04 == "0") 
              && (( ! isNullOrEmpty(vm.data.SupportReq05) && vm.data.SupportReq05 == "1") 
                    || ( ! isNullOrEmpty(vm.data.SupportReq06) && vm.data.SupportReq06 == "1")));    
            
            if (!isNullOrEmpty(vm.data.WorkStartDate)) {
              vm.data.WorkStartDate = moment(vm.data.WorkStartDate).format('YYYY-MM-DD');
            }
            if (!isNullOrEmpty(vm.data.WorkEndDate)) {
              vm.data.WorkEndDate = moment(vm.data.WorkEndDate).format('YYYY-MM-DD');
            }
            
            // 현장실사일   
            if (!isNullOrEmpty(vm.data.SiteVeriftDate1) && !isNullOrEmpty(vm.data.SiteVeriftTime11)) {    
              vm.SiteVeriftDate1 = vm.data.SiteVeriftDate1 +" "+ vm.data.SiteVeriftTime11;    
            }
            if (!isNullOrEmpty(vm.data.SiteVeriftDate2) && !isNullOrEmpty(vm.data.SiteVeriftTime21)) {    
              vm.SiteVeriftDate2 = vm.data.SiteVeriftDate2 +" "+ vm.data.SiteVeriftTime21;          
            }
            
            if (!isNullOrEmpty(vm.data.SiteVeriftDate)) vm.SiteVeriftDate = new Date(vm.data.SiteVeriftDate);
            if (!isNullOrEmpty(vm.data.ApplyCmpDate)) vm.ApplyCmpDate = new Date(vm.data.ApplyCmpDate);
            
            if (vm.data.Status == 'RG') {
              vm.approATShow = true;
            }

            // 사전설문지
            angular.forEach(vm.selfDataQna, function (qst, key) {
              if ( ! isNullOrEmpty(vm.data[key + '_q']))  qst.question = vm.data[key + '_q'];
              if ( ! isNullOrEmpty(vm.data[key + '_a']))  qst.answer = vm.data[key + '_a'];
            });

            if (vm.data.uploadFileList) {
              angular.forEach(vm.data.uploadFileList, function(item) {                
                angular.forEach(vm.attach, function (att) {
                  if(att.grpId == item.GrpId){    
                    var target = att.id;            
                    vm.attach[target].isLoaded = true;
                    vm.attach[target].fileName = item.LogicalFileNm;
                    vm.attach[target].size = item.FileSize;
                    vm.attach[target].path = item.PhysicalPath;
                    vm.attach[target].fileKey = item.PhysicalFileNm;
                    vm.attach[target].link = StaticVariable.getUrl("/openapi/attach/" + item.PhysicalPath + "/" + item.PhysicalFileNm + "/download.do");                    
                    vm.attach[target].delState = '';
                    vm.attach[target].fileLock = item.FileLock;
                    vm.attach[target].downAuth = (item.FileLock == "N" || (item.FileLock == "Y" && (vm.data.RegUserYN == "Y" || vm.tenantId == "0")));
                    vm.attach[target].ngIf = true;

                    // 미리보기
                    var fname = item.LogicalFileNm.toLowerCase();
                    var fUrl = StaticVariable.getUrl("/openapi/attach/" + item.PhysicalPath + "/" + item.PhysicalFileNm + "/view.do");
                    if(fname.indexOf(".pdf") !== -1) {
                      vm.attach[target].viewType = "pdf";
                      fUrl = $sce.trustAsResourceUrl("assets/pdf/web/viewer.html?file=" + encodeURIComponent(fUrl));   
                    } else if(fname.indexOf(".jpg") !== -1 || fname.indexOf(".jpeg") !== -1) {
                      vm.attach[target].viewType = "jpg";
                    }
                    if( ! isNullOrEmpty(vm.attach[target].viewType)){
                      vm.attach[target].view = fUrl;
                      vm.attach[target].preview = true;
                    }

                    vm.aiView.request = vm.getAiHtml(vm.data.AiRequest);
                    vm.aiView.site = vm.getAiHtml(vm.data.AiSite);
                    vm.aiView.external = vm.getAiHtml(vm.data.AiExternal);
                    vm.aiView.summary = vm.getAiHtml(vm.data.AiSummary);
                    vm.aiView.final = vm.getAiHtml(vm.data.AiFinal);

                    // AI 분석용
                    if(target == "AttachFile5" && fname.indexOf(".pdf") !== -1 && vm.data.AiNewYN == "Y" && ! vm.isPesEtcOnly && vm.isAdminAI){
                    var data = {
                        attachType : "real",
                        attachId : item.PhysicalFileNm ,
                        tenantId : vm.tenantId,
                        mapCode : "getBase64ByFile", 
                      };
                      postApi.openApi(data, function (result) {
                        if (result.header.status == CONSTANT.HttpStatus.OK) {   
                          if (result.body.docs.length > 0) {
                            var data = result.body.docs[0];
                            vm.attach[target].base64 = data.base64;   
                            getAiData("adminchk", data.base64)
                            .catch(function(error) {
                              gAlert('', error);
                            }); 
                          }
                        }
                      }, function(error) {}); 
                    }                    
                    
                  } else {
                    return;
                  }
                });
              });
            } else {
              vm.data.uploadFileList = [];
            }            

            // 자가진단
            angular.forEach(vm.selfData, function (qst, key) {
              if ( ! isNullOrEmpty(vm.data[key]) && vm.data[key] == 0) {
                qst.chk = vm.data[key];
              } else {
                qst.chk = 1;
              }
            });
            vm.selfDataResult = TakeService.getSelfDataResult(vm.selfData);

            // 사전설문지
            angular.forEach(vm.selfDataQna, function (qst, key) {
              if ( ! isNullOrEmpty(vm.data[key + '_q']))  qst.question = vm.data[key + '_q'];
              if ( ! isNullOrEmpty(vm.data[key + '_a']))  qst.answer = vm.data[key + '_a'];
            });
            
            // 상태변경 체크용
            vm.oldStatus = vm.data.Status;
            
            // 지정 봉사단 여부
            if( ! isNullOrEmpty(vm.data.IsCaseB)){
              vm.isCaseB = (vm.data.IsCaseB > 0);
            }
            
            // 등록자의 권한에 따라 등록 및 수정 항목 변경을 위한 값 (사례기관 T, 그외 A)
            vm.regUserType = (isNullOrEmpty(vm.data.RegAuth) ? "" : vm.data.RegAuth);

          } else {
            vm.data = {};
          }

          // 사례기관만 조회 비밀번호 체크
          vm.chkPass = false; 
          if(vm.tenantType != 'TAKETENANT' || vm.data.RegUserYN == "Y"){
            vm.chkPass = true;
          }

          // 기관정보 조회
          getTenantInfo();
          // 가족관계 목록 조회
          getFrmList();
          // 타기관 지원 목록 조회
          getTenantSptList();
          // 금융자산 목록 조회
          getFinanList();
          // 상태이력 목록 조회
          getStatusRecordList();
          // 댓글 목록 조회
          getCommentList();
          // 기관추천 목록 조회
          getTenantRecommList();
          // 기타지출 목록 조회
          getEtcCostList();
          // 봉사단 목록 조회
          getVolunteerList();
          // 현장실사 심사자 목록 조회
          getSiteVeriftAdminList();
          // 외부자원연계 목록 조회
          getExtnList();

          // 실행정보 비활성화
          vm.disExe1 = (isNullOrEmpty(vm.data.Status) || (vm.data.Status != 'RG' && vm.data.Status != 'AT' && vm.data.Status != 'AG'));
          vm.disExe2 = (vm.tenantId != "0");
          vm.disExe3 = (vm.tenantId != "0");
          vm.disExe4 = (vm.tenantId != "0");
        }

        vm.dataloader = false;
      }, function(error) {
        vm.dataloader = false;
        console.error("Error> getData()");
        console.table(error);
      });
    }

    vm.getAiHtml = function (markdownTxt){
      var rawHtml = marked.parse(markdownTxt || '');
      //var cleanHtml = DOMPurify.sanitize(rawHtml);
      return $sce.trustAsHtml(rawHtml);
    }

    /**
     * 기관정보 조회
     * @param
     * @return
     */
     function getTenantInfo() {
      var data = {};
      if (isNullOrEmpty(vm.data.TenantId)) {
        data.keyId = vm.tenantId;
      } else {
        data.keyId = vm.data.TenantId;
      }
      
      data.mapCode = TENANT_VIEW_SQL;

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.tenantData = result.body.docs[0];
          } else {
            vm.tenantData = {};
          }          
        } 
      }, function(error) {
          console.error("Error> getTenantInfo()");
          console.table(error);
      });
    }

    /**
     * 가족관계 목록 조회
     * @param
     * @return
     */
    function getFrmList() {
      var data = {keyId : vm.keyId, mapCode : FRM_LIST_SQL};

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data.frmList = result.body.docs;
          } else {
            vm.data.frmList = [];
          }
        } 
      }, function(error) {
          console.error("Error> getFrmList()");
          console.table(error);
      });
    }

    /**
     * 타기관 지원 목록 조회
     * @param
     * @return
     */
     function getTenantSptList() {
      var data = {keyId : vm.keyId, mapCode : TENANT_SPT_LIST_SQL};

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data.tenantSptList = result.body.docs;
            angular.forEach(vm.data.tenantSptList, function(item) {
              item.SptStartDate = moment(item.SptStartDate).format('YYYY-MM-DD');
              item.SptEndDate = moment(item.SptEndDate).format('YYYY-MM-DD');
            });
          } else {
            vm.data.tenantSptList = [];
          }    
        } 
      }, function(error) {
          console.error("Error> getTenantSptList()");
          console.table(error);
      });
    }

    /**
     * 금융자산 목록 조회
     * @param
     * @return
     */
     function getFinanList() {
      var data = {keyId : vm.keyId, mapCode : FINAN_LIST_SQL};

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data.finanList = result.body.docs;
          }  else {
            vm.data.finanList = [];
          }        
        } 
      }, function(error) {
          console.error("Error> getFinanList()");
          console.table(error);
      });
    }

    function getStatusRecordList() {

      var data = {keyId : vm.keyId, mapCode : STATUS_LIST_SQL};

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.recordStatus = result.body.docs[0].Status;

            if (vm.recordStatus != 'SP' && vm.recordStatus != 'RW' && vm.recordStatus != 'RC' && (vm.data.Status == 'SP' || vm.data.Status == 'RW' || vm.data.Status == 'RC')) {
              gConfirm('', '<div class="text-center">지원이 확정된 사례입니다. 취소하기를 하셔야 목록에서 보이지 않습니다.<br>취소하시겠습니까?</div>', {
                btn : '',
                fn : function() {
                  if (vm.recordStatus == 'AT') {
                    canCelData('AT', 'R');
                  } else if ( vm.recordStatus == 'AG') {
                    canCelData('AG', 'R');
                  }
                }
              }, {
                btn : '',
                fn : function() {
                  if (vm.recordStatus == 'AT') {
                    vm.cancelATShow = true;
                    vm.cancelAGShow = false;
                  }
                  if ( vm.recordStatus == 'AG') {
                    vm.cancelATShow = false;
                    vm.cancelAGShow = true;
                  }
                }
              });
            } else {
              if (vm.recordStatus == 'AT') {
                vm.approATShow = false;
                vm.approAGShow = true;
                vm.cancelATShow = true;
                vm.cancelAGShow = false;
              }
              if ( vm.recordStatus == 'AG') {
                vm.approAGShow = false;
                vm.approSPShow = true;
                vm.cancelATShow = false;
                vm.cancelAGShow = true;
              }
            }
          } else {
            if (vm.data.Status == 'SP' && vm.tenantType == 'GIVETENANT') {
              gAlert('', '지원이 확정된 사례입니다.', {
                btn : '',
                fn : function() {
                  goList();
                }
              });
            } else {
              vm.approATShow = true;
              vm.approAGShow = false;
            }
          }
        }
      });
    }

    // 퀵메뉴 버튼 이동
    function scrollMove(id) {
      document.getElementById(id).scrollIntoView({block:'start', behavior:'smooth'});
    }

    /**
     * 목록화면 이동
     * @param
     * @return
     */
    function goList() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      var type = $stateParams.type;
      var status = $stateParams.status; // 상태값
      if (!isNullOrEmpty(type)) {
        if (!isNullOrEmpty(status)) {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type + '-' + status;
        } else {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type;
        }
      }
      $state.go(LIST_PAGE_URL, { srch: srch, type : type, status : status});
    }

    /**
     * 수정화면 이동
     * @param
     * @return
     */
    function goEdit() {      
      console.log('layout === ', vm.layout);
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      var type = $stateParams.type;
      var status = $stateParams.status; // 상태값

      if (vm.layout == 'N') {
        $state.go(EDIT_PAGE_URL, { srch: srch, type : type, status : status, keyId : vm.keyId });
      } else {
        $state.go(LIST_EDIT_PAGE_URL, { srch: srch, status : status, keyId : vm.keyId });
      }      
    }

    // 첨부파일 다운로드
    vm.downloadFile = function (target, viewType) {
      if(vm.attach[target].downAuth && vm.tenantType != 'GIVETENANT'){
        switch(viewType){
          case "L" : 
            if (!isNullOrEmpty(vm.attach[target].link)) {
              window.open(vm.attach[target].link);
            }
            break;

          case "V" : 
            if (!isNullOrEmpty(vm.attach[target].view)) {
              vm.attach[target].preview = ! vm.attach[target].preview;
              console.error(target);
            }
            break;
        }
      } else {
        alert("다운로드 권한이 없습니다.");
      }
    };
    
    function printTake() {
      var URL = location.origin + '/#/print-take?keyId=' + vm.keyId;
      window.open(URL, 'print-take', 'width=1030px,height=800px,scrollbars=yes');
    }

    function approval(status) {
      var data = '';
      var statusUpdYN = 'N';
      if (status != 'RW') {
        if (vm.data.Status != 'RG') {
          if (vm.data.Status == 'AT') {
            if (status == 'AG') {
              statusUpdYN = 'Y';
            } else {
              statusUpdYN = 'N';
            }
          } 
          if (vm.data.Status == 'AG') {
            if (status == 'SP') {
              statusUpdYN = 'Y';
            } else {
              statusUpdYN = 'N';
            }
          } 
        } else {
          statusUpdYN = 'Y';
        }

        data = {
          mapCode : INSERT_STATUS_SQL,
          keyId : vm.keyId,
          Status : status,
          StatusUpdYN : statusUpdYN,          
          TargetNm : vm.data.TargetNm // 매체발송 치환용
        };        
  
        postApi.insert(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              gAlert('', '처리되었습니다.', {
                btn : '',
                fn : function() {
                  goList();
                }
              });
            }
          }
        });
      } else {
        if (getIsValidData()) {
          data = angular.copy(vm.data);
          data.mapCode = INSERT_STATUS_RW_SQL;
          data.keyId = vm.keyId;
          data.Status = status;
          postApi.insert(data, function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                gAlert('', '처리되었습니다.', {
                  btn : '',
                  fn : function() {
                    goList();
                  }
                });
              }
            }
          });  
        }
      }
    }

    function getIsValidData() {
      var data = angular.copy(vm.data);
      var errMsg = '';

      if (isNullOrEmpty(data.SiteDueDilYN)) {
        errMsg = errMsg + ' - 현장실사 배정을 선택해주세요. <br/>';
      }
      if (isNullOrEmpty(data.SiteVeriftYN)) {
        errMsg = errMsg + ' - 현장검증 인증을 선택해주세요. <br/>';
      }

      if (!isNullOrEmpty(errMsg)) {
        gAlert('',errMsg);
        return false;
      }
      return true;
    }

    function setDelData() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          setDelDataAction();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function setDelDataAction() {
      var data = angular.copy(vm.data);
      data.mapCode = DELETE_DETAIL_SQL;

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              goList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> setDelDataAction()");
        console.table(error);
      });
    }

    function saveComment() {

      // 추가 버튼 클릭 안한 비밀댓글 지정자가 있을 경우 자동 등록
      if(! isNullOrEmpty(vm.commAdminData.UserId)){
        vm.addCommAdmin();
      }

      if (isNullOrEmpty(vm.commentData.Content)) {
        gAlert('', '댓글 내용을 입력해주세요.');
        return false;
      }

      var data = angular.copy(vm.commentData);
      data.commAdminList = vm.commAdminData.list;
      data.keyId = vm.keyId;
      data.mapCode = INSERT_COMMENT_SQL;

      // 매체발송 치환용
      data.TargetNm = vm.data.TargetNm;
      data.RegTenantNm = $window.sessionStorage['loginTenantName'];   

      if(data.SecretCommYN == "1" && data.commAdminList.length > 0){
        data.sendMsgType = "Y1"; // 지정 비밀댓글
      } else if(data.SecretCommYN == "1"){
        data.sendMsgType = "Y2"; // 비지정 비밀댓글
      } else {
        data.sendMsgType = "N"; // 일반댓글
      }

      postApi.insert(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '댓글이 저장되었습니다.', {
            btn : '',
            fn : function() {
              vm.commentData = {};
              vm.commAdminData = {list:[]};
              getCommentList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> saveComment()");
        console.table(error);
      });
    }

    function getCommentList() {
      var data = {
        keyId : vm.keyId,
        mapCode : COMMNET_LIST_SQL
      };

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.comment.list = result.body.docs;
            angular.forEach(vm.comment.list, function(item) {
              item.RegDate = moment(item.RegDate).format('YYYY-MM-DD HH:mm');
              item.chkView = true;
              // 비밀댓글 권한 > 본인이거나, 댓글조회 가능한 관리자
              if( ! isNullOrEmpty(item.SecretCommYN) && item.SecretCommYN == "1"){
                item.chkView = (item.RegUser == $rootScope.gVariable.UserId || $window.sessionStorage['isCommentAdmin'] == "1");
              }
            });
          } else {
            vm.comment.list = [];
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getCommentList()");
        console.table(error);
      });
    }

    function editComment(li) {
      vm.comment.editid = li.CommentId;
      vm.comment.editContent = li.Content;
      vm.comment.SecretCommYN = li.SecretCommYN;  
      vm.comment.AdminData = {list:[]};

      var data = {
        keyId : vm.keyId,
        commentId : li.CommentId,
        mapCode : COMMNET_ADMIN_LIST_SQL
      };

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.comment.AdminData.list = result.body.docs;
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> editComment()");
        console.table(error);
      });
    }

    function editCommentAction(li) {
      if (isNullOrEmpty(vm.comment.editContent)) {
        gAlert('', '수정할 댓글 내용을 입력해주세요.');
        return false;
      }

      var data = angular.copy(li);
      data.Content = angular.copy(vm.comment.editContent);
      data.SecretCommYN = angular.copy(vm.comment.SecretCommYN);
      data.mapCode = UPDATE_COMMENT_SQL;
      data.commAdminList = vm.comment.AdminData.list;

      postApi.update(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '수정되었습니다.', {
            btn : '',
            fn : function() {
              vm.comment.editid = '';
              vm.comment.editContent = '';      
              vm.comment.AdminData = {list:[]};
              getCommentList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> editCommentAction()");
        console.table(error);
      });
    }

    /**
      * 댓글 수정 취소
      *
      * @param
      * @return
    */
    function editCommentCancel() {
      vm.comment.editid = null;
      vm.comment.editContent = null;   
      vm.comment.AdminData = {list:[]};
    }

    /**
      * 댓글 삭제
      *
      * @param
      * @return
    */
    function deleteComment(li) {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteCommentAction(li);
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function deleteCommentAction(li) {
      var data = angular.copy(li);
      data.mapCode = DELETE_COMMENT_SQL;

      postApi.update(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '삭제되었습니다.', {
            btn : '',
            fn : function() {
              getCommentList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> deleteCommentAction()");
        console.table(error);
      });
    }   

    // 댓글관리자 팝업
    vm.srchCommAdminModal = function (type) {
      var ctrl = 'CommAdminModalCtrl as modalCtrl';
      var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
      var modalInstance = modalFactory.open('lg', 'app/eland-request/modal/comm-admin-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        if(type == "E"){
          vm.comment.AdminData.UserNm = okData.UserNm;
          vm.comment.AdminData.UserId = okData.UserId;
        } else {
          vm.commAdminData.UserNm = okData.UserNm;
          vm.commAdminData.UserId = okData.UserId;
        }
      }, function (cancelData) {
        // 취소
      });
    };

    // 댓글관리자 추가
    vm.addCommAdmin = function (type) {      
      if(type == "E"){
        if( ! isNullOrEmpty(vm.comment.AdminData.UserId)){
          vm.comment.AdminData.list.push({UserId : vm.comment.AdminData.UserId, UserNm : vm.comment.AdminData.UserNm});      
          vm.comment.AdminData.UserNm = "";
          vm.comment.AdminData.UserId = "";
        }
      } else {
        if( ! isNullOrEmpty(vm.commAdminData.UserId)){
          vm.commAdminData.list.push({UserId : vm.commAdminData.UserId, UserNm : vm.commAdminData.UserNm});      
          vm.commAdminData.UserNm = "";
          vm.commAdminData.UserId = "";
        }
      }
    }

    // 댓글관리자 삭제
    vm.delCommAdmin = function (idx, type) {
      if(type == "E"){
        vm.comment.AdminData.list.splice(idx, 1); 
      } else {
        vm.commAdminData.list.splice(idx, 1); 
      }
    }

    function reSetData() {
      gConfirm('', '초기화 하시겠습니까?', {
        btn : '',
        fn : function() {
          var data = {keyId : vm.keyId, mapCode : RESET_DETAIL_SQL};

          postApi.update(data, function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              gAlert('', '초기화 되었습니다.', {
                btn : '',
                fn : function() {
                  goList();
                }
              });
            }
          }, function (error) {
            // 조회 중 오류 발생
            console.error("Error> reSetData()");
            console.table(error);
          });
        }
      }, {
        btn : '',
        fn : function() {
        }
      });      
    }

    function canCelData(status, type) {
      var data = {keyId : vm.keyId, Status : status, mapCode : CANCEL_STATUSCNT_SQL};
      if (type == 'R') {
        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              if (result.body.docs.length == 1) {
                canCelStatusOneData(status);
              }
              if (result.body.docs.length > 1) {
                canCelStatusData(status);
              }
            }       
          } 
        }, function(error) {
            console.error("Error> canCelData()");
            console.table(error);
        });
      } else {
        gConfirm('', '취소 하시겠습니까?', {
          btn : '',
          fn : function() {
            postApi.select(data, function(result) {
              if (result.header.status == CONSTANT.HttpStatus.OK) {
                if (result.body.docs.length > 0) {
                  if (result.body.docs.length == 1) {
                    canCelStatusOneData(status);
                  }
                  if (result.body.docs.length > 1) {
                    canCelStatusData(status);
                  }
                }       
              } 
            }, function(error) {
                console.error("Error> canCelData()");
                console.table(error);
            });
          }
        }, {
          btn : '',
          fn : function() {
          }
        });  
      } 
    }

    function canCelStatusOneData(status) {
      var data = {keyId : vm.keyId, Status : status, mapCode : CANCEL_ONE_STATUS_SQL};

      postApi.update(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (status == 'AT') {
            vm.approATShow = true;
            vm.approAGShow = false;
          }
          if (status == 'AG') {
            vm.approAGShow = true;
            vm.approSPShow = false;
          }
          gAlert('', '취소 되었습니다.', {
            btn : '',
            fn : function() {
              goList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> canCelStatusOneData()");
        console.table(error);
      });
    }

    function canCelStatusData(status) {
      var data = {keyId : vm.keyId, Status : status, mapCode : CANCEL_STATUS_SQL};

      postApi.update(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '취소 되었습니다.', {
            btn : '',
            fn : function() {
              goList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> canCelStatusData()");
        console.table(error);
      });
    }

    /**
     * 기타지출 목록 조회
     * @param
     * @return
     */
     function getEtcCostList() {
      var data = { keyId: vm.keyId, mapCode: ETCCOST_LIST_SQL };

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data.etcCostList = result.body.docs;
          } else {
            vm.data.etcCostList = [];
          }
        }
      }, function (error) {
        console.error("Error> getEtcCostList()");
        console.table(error);
      });
    }

    // 기관검색
    vm.srchTenantModal = function (type) {
      var ctrl = 'RecomTenantModalCtrl as vc';
      var paramData = {};
      var modalInstance = modalFactory.open('modal', 'app/eland-request/modal/recom-tenant-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        // 회원사 선택
        if (okData != null) {
            
          switch(type){
            case "R" :  // 추천기관
              vm.ext1Data.RecommTenantNm = okData.TenantNm;
              vm.ext1Data.RecommTenantId = okData.TenantId;
              break;

            case "F" : // 최종심사 후원기관
              vm.finalData.FinalTenantNm = okData.TenantNm;
              vm.finalData.FinalTenantId = okData.TenantId;
              break;
          }          
        }
      }, function (cancelData) {
        // 취소
      });
    };

    // 추천기관 저장
    function saveTenantRecomm() {
      var data = angular.copy(vm.ext1Data);
      data.keyId = vm.keyId;
      data.mapCode = INSERT_TENANTRECOMM_SQL;

      // 매체발송 치환용
      data.TakeTenantNm = vm.data.TakeTenantNm;
      data.TargetNm = vm.data.TargetNm_;

      postApi.insert(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '등록되었습니다.', {
            btn : '',
            fn : function() {
              vm.ext1Data.RecommTenantId = '';
              getTenantRecommList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> saveTenantRecomm()");
        console.table(error);
      });
    }

    // 추천기관 목록
    function getTenantRecommList() {
      var data = {keyId : vm.keyId, mapCode : LIST_TENANTRECOMM_SQL};

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.ext1Data.list = result.body.docs;
          } else {
            vm.ext1Data.list = [];
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getTenantRecommList()");
        console.table(error);
      });
    }

    // 추천기관 삭제
    function deleteTenantRecomm(li) {
      var data = angular.copy(li);
      data.mapCode = DELETE_TENANTRECOMM_SQL;

      postApi.update(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '삭제되었습니다.', {
            btn : '',
            fn : function() {
              getTenantRecommList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> deleteTenantRecomm()");
        console.table(error);
      });
    }

    // 봉사단 팝업
    vm.srchVolunteerModal = function () {
      var ctrl = 'VolunteerModalCtrl as modalCtrl';
      var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
      var modalInstance = modalFactory.open('lg', 'app/eland-request/modal/volunteer-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        vm.ext2Data.UserNm = okData.UserNm;
        vm.ext2Data.UserId = okData.UserId;
      }, function (cancelData) {
        // 취소
      });
    };

    // 봉사단 저장
    function saveVolunteer() {
      var data = angular.copy(vm.ext2Data);
      data.keyId = vm.keyId;
      data.mapCode = INSERT_VOLUNTEER_SQL;

      // 매체발송 치환용
      data.TargetNm = vm.data.TargetNm;

      postApi.insert(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '등록되었습니다.', {
            btn : '',
            fn : function() {
              vm.ext2Data.UserId = '';
              getVolunteerList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> saveVolunteer()");
        console.table(error);
      });
    }

    // 봉사단 목록
    function getVolunteerList() {
      var data = {keyId : vm.keyId, mapCode : LIST_VOLUNTEER_SQL};

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.ext2Data.list = result.body.docs;
          } else {
            vm.ext2Data.list = [];
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getVolunteerList()");
        console.table(error);
      });
    }

    // 봉사단 삭제
    function deleteVolunteer(li) {
      var data = angular.copy(li);
      data.mapCode = DELETE_VOLUNTEER_SQL;

      postApi.update(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '삭제되었습니다.', {
            btn : '',
            fn : function() {
              getVolunteerList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> deleteVolunteer()");
        console.table(error);
      });
    }

    
    // 현장실사 심사단 목록
    function getSiteVeriftAdminList() {
      var data = {keyId : vm.keyId, mapCode : SV_ADMIN_LIST_SQL};

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.svAdminData.list = result.body.docs;
          } else {
            vm.svAdminData.list = [];
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getSiteVeriftAdminList()");
        console.table(error);
      });
    }

    // 실행정보 저장
    vm.saveExe = function() {

      // 등록(RG) > 관심기관수, 지원확정일자 초기화
      // 관심(AT) & 논의중(AG) > 지원확정일자 초기화
      // 지원확정(SP) & 결과보고대기(RW) > 결과보고작성 초기화

      var data = {
        mapCode : UPDATE_EXE_SQL,
        keyId : vm.keyId,
        Status : (vm.oldStatus != vm.data.Status ? vm.data.Status : ""),
        SiteVeriftYN : vm.data.SiteVeriftYN,
        GiveTenantId : vm.data.GiveTenantId,        
        TargetNm : vm.data.TargetNm, // 매체발송 치환용
        ApplyCmpDate : moment(vm.data.ApplyCmpDate).format('YYYY-MM-DD')
      };  

      postApi.insert(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            gAlert('', '처리되었습니다.', {
              btn : '',
              fn : function() {
                //
                if(vm.oldStatus != vm.data.Status && (vm.data.Status == "NO" || vm.data.Status == "SP")){
                    vm.oldStatus = vm.data.Status;
                    if( ! vm.isPesEtcOnly){
                      vm.autoComment();
                    }
                } else {
                    goList();
                }
              }
            });
          }
        }
      });
    }  

    // 미선정, 지원확정 시 자동댓글
    vm.autoComment = function(){

        var commTxt = "";
        switch(vm.data.Status){
            case "NO" : // 미선정
                commTxt = "안녕하세요 sos위고입니다.\n"
                        + "신청해주신 사례는 미선정되었음을 안내드립니다. 도음을 드리지 못해 죄송합니다.\n"
                        + "sos위고사업의 선정 기준에 따라 미선정된 점 양해를 부탁드립니다.\n"
                        + "적합한 타 자원을 활용하시어 지원받으시기를 권장드립니다.\n"
                        + "선정 기준은 다음과 같으니 참고부탁드립니다.\n\n"
                        + "1. 지원의 사각지대 : 정부 지원 등 사회적 안정망의 사각지대\n"
                        + "2. 위기상황 : 갑작스러운 위기상황(사망, 실직, 사고, 질병, 화재, 주거 퇴거 등)으로 생활의 어려움을 겪는 가정\n"
                        + "3. 경제상황 : 비수급 빈곤층, 차상위 계층, 소득이 있으나 부채 및 여러 사유로 경제적 위기에 놓인 가정\n"
                        + "4.일상생활 회복 및 문제 해결 가능성 : 단기간 지원을 통해 당면한 개인, 가정의 위기 상황과 문제가 해결되는 경우\n\n"
                        + "*자립비 영역은 자립에 대한 심사 기준이 추가되며, 지원 이후, 자립과 자활이 가능한 주부양자에 대한 지원입니다.\n"                
                        + "감사합니다.";
                break;

            case "SP" : // 지원확정
              
                commTxt =  "안녕하세요 sos위고입니다.\n"+ vm.data.TargetNm +"님 ";

                var chk = false;
                if(Number(vm.data.FinalHousSptAmt) > 0){
                    commTxt = commTxt + "주거비 " + vm.data.FinalHousSptAmt + "원"; 
                    chk = true;
                }
                if(Number(vm.data.FinalLivingAmt) > 0){
                    if(chk) commTxt = commTxt + ", ";
                    commTxt = commTxt + "생계비 " + vm.data.FinalLivingAmt + "원"; 
                    chk = true;
                }
                if(Number(vm.data.FinalCureSptAmt) > 0){
                    if(chk) commTxt = commTxt + ", ";
                    commTxt = commTxt + "치료비 " + vm.data.FinalCureSptAmt + "원"; 
                    chk = true;
                }
                if(Number(vm.data.FinalEduSptAmt) > 0){
                    if(chk) commTxt = commTxt + ", ";
                    commTxt = commTxt + "자립비 " + vm.data.FinalEduSptAmt + "원"; 
                    chk = true;
                }
                if(Number(vm.data.FinalEtcSptAmt) > 0){
                    if(chk) commTxt = commTxt + ", ";
                    commTxt = commTxt + "기타 " + vm.data.FinalEtcSptAmt + "원"; 
                    chk = true;
                }
                if(Number(vm.data.FinalVouSptAmt) > 0){
                    if(chk) commTxt = commTxt + ", ";
                    commTxt = commTxt + "SOS위고카드(물품·의료선지원) " + vm.data.FinalVouSptAmt + "원"; 
                }

                commTxt = commTxt + " 지원확정되었습니다.\n\n" 
                        + "선정공문은 soswego홈페이지 - 게시판 - 공지사항 참고부탁드립니다.\n\n"
                        + "- 지원금 사용 완료(최대 6개월이내 사용) 1개월 이내 결과보고서 제출\n" 
                        + "- 상세 내역은 sos위고사이트 게시판 내 종료 [결과보고서 및 모니터링 안내문] 참조\n\n"   
                        + "결과보고서 제출후, 현장 모니터링을 시행하오니 반드시 협조 부탁드립니다.\n" 
                        + "기한 내 결과보고서 미제출시 신규 사례 신청에 제한이 있을 수 있습니다.\n\n" 
                        + "기타 궁금하신 사항은 SOSWEGO@daum.net으로 문의부탁드립니다.\n" 
                        + "감사합니다.";
                break;
        }

        vm.commentData = {
            Content: commTxt,
            //SecretCommYN: "1"
        }    
        vm.commAdminData.list.push({UserId : 'B'});
        saveComment();
    }

    // 조회 비밀번호 체크
    vm.doChkPass = function () {
      if(isNullOrEmpty(vm.data.chkPasswd)) {
        gAlert('', "비밀번호를 입력하세요.");
      }
      else {
        var pw = (isNullOrEmpty(vm.data.Passwd) ? "" : vm.data.Passwd);
        if(pw != vm.data.chkPasswd){
          gAlert('', "비밀번호가 일치하지 않습니다.");
        } else {
          vm.chkPass = true;
        }
      }
    };

    // 현장실사 저장
    vm.saveSiteVeriftData = function(){   

      // 추가 버튼 클릭 안한 심사자가 있을 경우 자동 등록
      if(! isNullOrEmpty(vm.svAdminData.UserId)){
        vm.addSiteVeriftAdmin();
      }

      var data = {
        keyId : vm.data.keyId,
        SiteVeriftUserTxt : vm.data.SiteVeriftUserTxt,
        SiteVeriftDate : moment(vm.data.SiteVeriftDate).format('YYYY-MM-DD'),
        SiteVeriftTime : vm.data.SiteVeriftTime,
        SiteVeriftStat : vm.data.SiteVeriftStat,
        AiSummary : vm.data.AiSummary,
        SiteVeriftAdminList : vm.svAdminData.list,
        SiteVeriftAdminYN : (vm.svAdminData.list.length > 0 ? "Y" : "N"),
        TargetNm : vm.data.TargetNm
      }
      var errMsg = '';

      if ( isNullOrEmpty(data.SiteVeriftUserTxt) ) {
        errMsg = errMsg + '- 담당자를 입력하세요.<br/>';
      }
      if ( isNullOrEmpty(data.SiteVeriftDate) || isNullOrEmpty(data.SiteVeriftTime) ) {
        errMsg = errMsg + '- 일시를 선택하세요.<br/>';
      }
      if ( isNullOrEmpty(data.SiteVeriftStat) ) {
        errMsg = errMsg + '- 진행여부를 선택하세요.<br/>';
      }
      if ( isNullOrEmpty(data.AiSummary) ) {
        errMsg = errMsg + '- 내용을 입력하세요.<br/>';
      }
      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }

      var mapCode = 'Take.updateSiteVeriftData';

      postApi.sendPostApi('update', mapCode, data, function (result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '저장되었습니다.', {
            btn : '',
            fn : function() {
            }
          });
        }
      },function (error) {
        console.table(error);
      });
    };

    // 최종심사 저장
    vm.saveAiFinalSptData = function(isAi){      
      var data = {
        keyId : vm.data.keyId,
        FinalHousSptAmt : vm.data.FinalHousSptAmt,
        FinalLivingAmt : vm.data.FinalLivingAmt,
        FinalCureSptAmt : vm.data.FinalCureSptAmt,
        FinalEduSptAmt : vm.data.FinalEduSptAmt,
        FinalEtcSptAmt : vm.data.FinalEtcSptAmt,
        FinalVouSptAmt : vm.data.FinalVouSptAmt,
        FinalSptSum : vm.data.FinalSptSum,
        FinalTenantNm : vm.data.FinalTenantNm,
        AiFinal : vm.data.AiFinal,
      }
      
      if( ! isAi) {   
        var errMsg = '';
        if ( isNullOrEmpty(data.FinalSptSum) || data.FinalSptSum == "0") {
          errMsg = errMsg + '- 지원영역의 금액을 입력하세요.<br/>';
        }
        if ( isNullOrEmpty(data.FinalTenantNm) ) {
          errMsg = errMsg + '- 후원기관을 입력하세요.<br/>';
        }
        if (!isNullOrEmpty(errMsg)) { 
          gAlert('', errMsg);
          return false;
        }      
      }

      var mapCode = 'Take.updateFinalSptData';

      postApi.sendPostApi('update', mapCode, data, function (result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if(isAi){
            vm.aiView.final = vm.getAiHtml(vm.data.AiFinal);
            vm.aiFinalEdit = false;
          } else {
            gAlert('', '저장되었습니다.', {
              btn : '',
              fn : function() {
                vm.aiView.final = vm.getAiHtml(vm.data.AiFinal);
                vm.aiFinalEdit = false;
              }
            });
          }
        }
      },function (error) {
        console.table(error);
      });
    };    

    // 총 지원 합계 계산
    vm.getTotalSptSum = function() {
      if (isNullOrEmpty(vm.data.FinalHousSptAmt)) {
        vm.data.FinalHousSptAmt = 0;
      } else if (!isNullOrEmpty(vm.data.FinalHousSptAmt) && vm.data.FinalHousSptAmt != '0' && String(vm.data.FinalHousSptAmt).charAt(0) == '0') {
        vm.data.FinalHousSptAmt = vm.data.FinalHousSptAmt.replace(/(^0+)/, "");
      }
      if (isNullOrEmpty(vm.data.FinalLivingAmt)) {
        vm.data.FinalLivingAmt = 0;
      } else if (!isNullOrEmpty(vm.data.FinalLivingAmt) && vm.data.FinalLivingAmt != '0' && String(vm.data.FinalLivingAmt).charAt(0) == '0') {
        vm.data.FinalLivingAmt = vm.data.FinalLivingAmt.replace(/(^0+)/, "");
      }
      if (isNullOrEmpty(vm.data.FinalEduSptAmt)) {
        vm.data.FinalEduSptAmt = 0;
      } else if (!isNullOrEmpty(vm.data.FinalEduSptAmt) && vm.data.FinalEduSptAmt != '0' && String(vm.data.FinalEduSptAmt).charAt(0) == '0') {
        vm.data.FinalEduSptAmt = vm.data.FinalEduSptAmt.replace(/(^0+)/, "");
      }
      if (isNullOrEmpty(vm.data.FinalCureSptAmt)) {
        vm.data.FinalCureSptAmt = 0;
      } else if (!isNullOrEmpty(vm.data.FinalCureSptAmt) && vm.data.FinalCureSptAmt != '0' && String(vm.data.FinalCureSptAmt).charAt(0) == '0') {
        vm.data.FinalCureSptAmt = vm.data.FinalCureSptAmt.replace(/(^0+)/, "");
      }
      if (isNullOrEmpty(vm.data.FinalVouSptAmt)) {
        vm.data.FinalVouSptAmt = 0;
      } else if (!isNullOrEmpty(vm.data.FinalVouSptAmt) && vm.data.FinalVouSptAmt != '0' && String(vm.data.FinalVouSptAmt).charAt(0) == '0') {
        vm.data.FinalVouSptAmt = vm.data.FinalVouSptAmt.replace(/(^0+)/, "");
      }
      if (isNullOrEmpty(vm.data.FinalEtcSptAmt)) {
        vm.data.FinalEtcSptAmt = 0;
      } else if (!isNullOrEmpty(vm.data.FinalEtcSptAmt) && vm.data.FinalEtcSptAmt != '0' && String(vm.data.FinalEtcSptAmt).charAt(0) == '0') {
        vm.data.FinalEtcSptAmt = vm.data.FinalEtcSptAmt.replace(/(^0+)/, "");
      }

      vm.data.FinalSptSum = Number(vm.data.FinalHousSptAmt) + Number(vm.data.FinalLivingAmt) + Number(vm.data.FinalEduSptAmt) + Number(vm.data.FinalCureSptAmt) + Number(vm.data.FinalVouSptAmt) + Number(vm.data.FinalEtcSptAmt);
    }    

    // 현장실사심사자 팝업
    vm.srchSiteVeriftAdminModal = function (type) {
      var ctrl = 'SiteVeriftAdminModalCtrl as modalCtrl';
      var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
      var modalInstance = modalFactory.open('lg', 'app/eland-request/modal/sv-admin-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        vm.svAdminData.UserNm = okData.UserNm;
        vm.svAdminData.UserId = okData.UserId;
      }, function (cancelData) {
        // 취소
      });
    };

    // 현장실사심사자 추가
    vm.addSiteVeriftAdmin = function (type) {      
      if( ! isNullOrEmpty(vm.svAdminData.UserId)){
        vm.svAdminData.list.push({UserId : vm.svAdminData.UserId, UserNm : vm.svAdminData.UserNm});      
        vm.svAdminData.UserNm = "";
        vm.svAdminData.UserId = "";
      }
    }

    // 현장실사심사자 삭제
    vm.delSiteVeriftAdmin = function (idx, type) {
      vm.svAdminData.list.splice(idx, 1); 
    }  
    

    /**
     * 외부자원연계 목록 조회
     * @param
     * @return
     */
     function getExtnList() {
      var data = { keyId: vm.keyId, mapCode: EXTN_LIST_SQL };

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.extnList = result.body.docs;
            getTotalExtnSum();
          } else {
            vm.extnList = [];
          }
        }
      }, function (error) {
        console.error("Error> getExtnList()");
        console.table(error);
      });
    } 

    // 외부자원연계 추가 시, Validation 체크
    function IsValidExtnData(isReq) {
      var errMsg = '';
      if (isNullOrEmpty(vm.extnData.ExtnNm)) {
        errMsg = errMsg + '- 지원기관명을 입력해주세요.<br/>';
      }
      if (isNullOrEmpty(vm.extnData.ExtnAmt)) {
        errMsg = errMsg + '- 지원금액 입력해주세요.<br/>';
      }
      if (!isNullOrEmpty(errMsg)) {
        if(isReq){
          return false;
        } else {
          gAlert('', errMsg);
          return false;
        }
      }
      return true;
    }


    // 외부자원연계 추가
    function addExtn(isReq) {
      if (IsValidExtnData(isReq)) {
        vm.extnList.push(vm.extnData);
        vm.extnData = {};
        getTotalExtnSum();
      } 
    }

    // 외부자원연계 삭제
    function delExtn(index) {
      vm.extnList.splice(index, 1);
      getTotalExtnSum();
    }

    // 외부자원연계 총 지원금 합계
    function getTotalExtnSum() {
      var sum = 0;
      angular.forEach(vm.extnList, function(item) {
        sum = sum + Number(item.ExtnAmt);
      });
      vm.TotalExtnSum = sum;
    }

    // 외부자원연계 저장
    vm.saveExtnData = function(){    
      if (vm.extnList.length == 0 && ! isNullOrEmpty(vm.extnData)) { 
        vm.addExtn(true);
      }

      var data = {
        keyId : vm.data.keyId,
        extnList : vm.extnList
      }

      var mapCode = 'Take.insertExtnData';
      postApi.sendPostApi('insert', mapCode, data, function (result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '저장되었습니다.', {
            btn : '',
            fn : function() {
            }
          });
        }
      },function (error) {
        console.table(error);
      });
    };

    // ai 분석
    vm.setAiData = function() {
      if ( isNullOrEmpty(vm.data.AiSummary)) {
        gAlert('', '분석할 현장실사 내용이 없습니다');
        return false;
      } else {
        getAiData("final")
        .catch(function(error) {
          gAlert('', error);
        }); 
      }
    }

    function getAiData(type, file_base64) {
      return new Promise(function(resolve, reject) {
        var data = {}

        if(type == "final"){
          data = {
            query: "",
            req_num: vm.keyId,
          };
        } else {
          data = {
            file_base64: file_base64,
            file_type: "application/pdf",
            query: "\n\n2. [사전설문지]는 다음과 같아.\n<사전설문지>\n"+ JSON.stringify(vm.selfDataQna) +"\n</사전설문지>",
            req_num: vm.keyId,
          };
        }
        vm.ailoader1 = true;

        postApi.getAiData(data, type)
        .then(function(response) {
          vm.ailoader1 = false;
          if (response.header.status === CONSTANT.HttpStatus.OK) {

            if(type == "final"){
              // 최종심사 내용
              responseText = response.body.docs[0].answer || '오류';
              vm.data.AiFinal = responseText; 
              vm.aiView.final = vm.getAiHtml(responseText);
              vm.saveAiFinalSptData(true);
            } 
            else {
              // 판단근거
              responseText1 = response.body.docs[0].answer1 || '오류';
              vm.data.AiSiteVeriftYN = (/##\s*적합\s*##/.test(responseText1) !== -1 ? "Y" : "N");   
              vm.data.AiRequest = responseText1.replace(/##\s*적합\s*##/g, ''); ;   
              vm.aiView.request = vm.getAiHtml(vm.data.AiRequest);

              responseText2 = response.body.docs[0].answer2 || '오류';
              var siteTxt = responseText2.split("## ✅ 2. **외부자원 연계 추천**");

              // 체크리스트
              vm.data.AiSite = siteTxt[0]; 
              vm.aiView.site = vm.getAiHtml(vm.data.AiSite);

              // 외부자원목록
              vm.data.AiExternal = siteTxt.length > 1 ? "## ✅ 2. **외부자원 연계 추천**" + siteTxt[1] : "";
              vm.aiView.external = vm.getAiHtml(vm.data.AiExternal);

              vm.saveAiRequestData(true);

              // 현장실사 요약
              responseText3 = response.body.docs[0].answer3 || '오류';
              vm.data.AiSummary = responseText3;
              vm.aiView.summary = vm.getAiHtml(responseText3);
              vm.saveAiSumData(true);
            }            
                
            resolve("ok"); // 성공 시 resolve
          } else {
            reject(response.body.docs[0].errMessage); // 실패 시 reject
          }
        })
        .catch(function(error) {
          vm.ailoader1 = false;
          var errorMessage = (error.data && error.data.detail) ? error.data.detail : '오류';
          reject(errorMessage); // 실패 시 reject
        });
      });
    }

    // ai 자동 심사 결과
    vm.saveAiRequestData = function(isAi){      
      var data = {
        keyId : vm.data.keyId,
        AiSiteVeriftYN : vm.data.AiSiteVeriftYN,
        AiRequest : vm.data.AiRequest,
        AiSite : vm.data.AiSite,
        AiExternal : vm.data.AiExternal,
      }
      
      if ( isNullOrEmpty(data.AiRequest) && isNullOrEmpty(data.AiSite)) {
        gAlert('', '저장할 심사결과 내용이 없습니다');
        return false;
      }

      var mapCode = 'Take.updateAiRequestData';

      postApi.sendPostApi('update', mapCode, data, function (result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          var msg = "";
          if(isAi){
            vm.aiView.request = vm.getAiHtml(vm.data.AiRequest);
            vm.aiView.site = vm.getAiHtml(vm.data.AiSite);
            vm.aiView.external = vm.getAiHtml(vm.data.AiExternal);
            vm.aiRequestEdit = false;
            vm.scrollMove('pn10');
          } else {
            gAlert('', '저장되었습니다.', {
              btn : '',
              fn : function() {
                vm.aiView.request = vm.getAiHtml(vm.data.AiRequest);
                vm.aiView.site = vm.getAiHtml(vm.data.AiSite);
                vm.aiView.external = vm.getAiHtml(vm.data.AiExternal);
                vm.aiRequestEdit = false;
              }
            });
          }
        }
      },function (error) {
        console.table(error);
      });
    };
    
    // 현장실사 ai 요약 저장
    vm.saveAiSumData = function(isAi){      
      var data = {
        keyId : vm.data.keyId,
        AiSummary : vm.data.AiSummary,
      }

      if ( isNullOrEmpty(data.AiSummary)) {
        gAlert('', '저장할 현장실사 요약 내용이 없습니다');
        return false;
      }

      var mapCode = 'Take.updateAiSummaryData';

      postApi.sendPostApi('update', mapCode, data, function (result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if(isAi){
            vm.aiView.summary = vm.getAiHtml(vm.data.AiSummary);
          } else {
            gAlert('', '저장되었습니다.', {
              btn : '',
              fn : function() {
                vm.aiView.summary = vm.getAiHtml(vm.data.AiSummary);
              }
            });
          }
        }
      },function (error) {
        console.table(error);
      });
    };

    vm.toggleAiEdit = function(tgt){
      switch(tgt){
        case "R": vm.aiRequestEdit = ! vm.aiRequestEdit; break;
        case "F": vm.aiFinalEdit = ! vm.aiFinalEdit; break;
      }
    }


    vm.goList = goList;                                   // 목록 화면 이동
    vm.goEdit = goEdit;                                   // 수정 화면 이동
    vm.scrollMove = scrollMove;                           // 퀵메뉴 버튼 이동
    vm.printTake = printTake;                             // 출력 버튼
    vm.approval = approval;                               // 단계 진행 버튼
    vm.setDelData = setDelData;                           // 상세 데이터 삭제
    vm.saveComment = saveComment;                         // 댓글 저장
    vm.editComment = editComment;                         // 댓글 수정모드로 변경
    vm.editCommentAction = editCommentAction;             // 댓글 수정 저장
    vm.editCommentCancel = editCommentCancel;             // 댓글 수정 취소
    vm.deleteComment = deleteComment;                     // 댓글 삭제 엑션 호출
    vm.saveTenantRecomm = saveTenantRecomm;               // 기관추천 저장
    vm.deleteTenantRecomm = deleteTenantRecomm;           // 기관추천 삭제
    vm.getTenantRecommList = getTenantRecommList;         // 기관추천 목록
    vm.reSetData = reSetData; 
    vm.canCelData = canCelData;                           // 상태 취소 조회
    vm.canCelStatusOneData = canCelStatusOneData;         // 상태 취소 (1건일때)
    vm.canCelStatusData = canCelStatusData;               // 상태 취소 (여러건일때)
    vm.saveVolunteer = saveVolunteer;                // 봉사단 저장
    vm.deleteVolunteer = deleteVolunteer;            // 봉사단 삭제
    vm.getVolunteerList = getVolunteerList;             // 봉사단 목록
    vm.getAiData = getAiData;                           // ai 분석

    // 외부자원연계
    vm.getExtnList = getExtnList;                     
    vm.IsValidExtnData = IsValidExtnData;
    vm.addExtn = addExtn;
    vm.delExtn = delExtn;
    vm.getTotalExtnSum = getTotalExtnSum;
    

    $timeout(function() {
      vm.isMobile = checkMobile();
      
      // 데이터 조회
      getData();
    }, 0);
  }
]);

/**
 * @ngdoc function
 * @name app.request:request-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
 webapp.controller("TakeEditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT", 
 "StaticVariable", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout', 'fileUploadService',  
 'gConfirm', '$http', 'modalFactory', 'TakeService', 
 /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} gAlert - Alert Module
 */
 function TakeEditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT,   StaticVariable, gAlert, postApi, 
  customFieldApi, $rootScope, $timeout, fileUploadService, gConfirm, $http, modalFactory, TakeService) {
   // View Model
   var LIST_PAGE_URL = 'app.eland-request.take-list';             // 목록 화면
   var EDIT_PAGE_URL = 'app.eland-request.take-edit';

   // SQL Mapper Id 정의
   var VIEW_SQL = 'Take.getTakeDetail';                           // 상세 조회 SQL
   var TENANT_VIEW_SQL = 'Tenant.getTenantDetail';                // 기관 정보 조회 SQL
   var FRM_LIST_SQL = 'Take.getTakeFrmList';                      // 가족관계 목록 조회 SQL
   var TENANT_SPT_LIST_SQL = 'Take.getTakeTenantSptList';         // 타기관 지원 목록 조회 SQL
   var FINAN_LIST_SQL = 'Take.getTakeFinanList';                  // 금융자산 목록 조회 SQL
   var INSERT_SQL = 'Take.insertTake';                            // 저장 SQL
   var UPDATE_SQL = 'Take.updateTake';                            // 전체 업데이트 SQL
   var ETCCOST_LIST_SQL = 'Take.getTakeEtcCostList'                  // 기타지출 목록 조회 SQL

   var vm = this;

   vm.dataloader = false;
   vm.ailoader1 = false;
   vm.srch = {};
   vm.layout = $rootScope.gVariable.layoutBoard;
   vm.columnMap = {};
   vm.btnShow = '1';                                               // 퀵메뉴 Show/Hide 여부


   vm.selfChk = false;
   vm.selfChkResult = false;
   vm.selfData = angular.copy(TakeService.selfDataQst);
   vm.selfDataResult = {};
   vm.selfDataQna = angular.copy(TakeService.selfDataQna);

   // diabled 값 초기화
   vm.disabledDisease = true;
   vm.disabledImpair = true;
   vm.disabledIrdr = true;
   vm.disabledHous = true;
   vm.disabledLiving = true;
   vm.disabledEdu = true;
   vm.disabledCure = true;
   vm.disabledVou = true;
   vm.disabledHEtc = true;
   vm.disabledJaga = true;
   vm.disabledJeonse = true;
   vm.disabledMonthDep = true;
   vm.disabledAptDep = true;
   vm.disabledFreeLease = true;
   vm.disabledHousEtc = true;
   vm.disabledWorkDate = false;

   vm.isPesOnly = false;
   vm.isPesEtcOnly = false;

   vm.HealthIndemList1 = [];
   vm.HealthIndemList2 = [];

   vm.tenantType = $window.sessionStorage['loginTenantType'];                          // 회원사 타입
   vm.loginUserAdminType = !isNullOrEmpty($window.sessionStorage['loginUserAdminType']) ? $window.sessionStorage['loginUserAdminType'] : "";  
   vm.isAdminS = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S"); // 시스템관리자, 사무국
   vm.isAdminSH = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "H"); // 시스템관리자, 사무국, 현장간사
    
   vm.regUserType = '';

   if (!$stateParams.srch) {
     vm.srch = {
       page: 1,
       viewSize: CONSTANT.PAGINATION.VIEWSIZE
     };
   } else {
     vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
   }

   if (!isNullOrEmpty($stateParams.keyId)) {
     vm.keyId = $stateParams.keyId;
   }

   vm.data = {
     SecretYN : "0",
     RegUserYN : "Y"
   }

   // 업로드 파일 목록
   vm.attach = angular.copy(TakeService.caseAttach);

    vm.addFile = function() {
      isMax = true;
      for (var i = 1; i <= 10; i++) {
        var key = 'AddFile' + i;
        if (vm.attach[key].ngIf === false) {
          vm.attach[key].ngIf = true; 
          isMax = false;
          break; 
        }
      }
      if(isMax){        
        alert("더 이상 파일을 추가할 수 없습니다.");
      }
    } 

   vm.fileView = function(key){
    chk = true;
    switch(key){
      case 'AttachFile5': chk = !vm.isPesEtcOnly; break;
      case 'AttachFile2': chk = !vm.isPesEtcOnly; break;
      case 'AttachFile4': chk = !vm.isPesEtcOnly; break;
      case 'AttachFile6': chk = vm.isPesOnly; break;
    }
    return vm.attach[key].ngIf && chk;
   }

   // 기관ID
   vm.tenantId = $window.sessionStorage['loginTenantId'];

   // 가족사항 데이터
   vm.frmData = {};

   // 타기관지원연계여부(긴급지원) 데이터
   vm.emerTenantSptData = {};

   // 타기관지원연계여부(민간지원) 데이터
   vm.privateTenantSptData = {};

   // 금융자산 데이터
   vm.finanData = {};

   // 파일 공통
   vm.fileAttach = null;

   // 기타지출 데이터
   vm.etcCostData = {};

   // 현장실사용 시간
   vm.timeList = angular.copy(TakeService.timeList);

   /**
    * 데이터 조회
    * @param
    * @return
    */
   function getData() {
     vm.dataloader = true;

     var data = angular.copy(vm.srch);
     data.mapCode = VIEW_SQL;
     data.keyId = vm.keyId;

     // For CustomColumn and FileAttachment
     data.tableNm = 'casemanage';
     data.IdName = 'keyId';
     data.selectType = 'Edit';
     data.uploadFileList = [];

     postApi.select(data, function (result) {
       if (result.header.status === CONSTANT.HttpStatus.OK) {
         if (result.body.desc.length > 0) {
           vm.allColumns = result.body.desc;
           angular.forEach(vm.allColumns, function (item) {
             vm.columnMap[item.ColumnPhysicalNm] = item;
           });

           // 보호구분>의료보장
           vm.HealthIndemList1 = vm.columnMap['HealthIndem'].CodeList.filter(function(e){
               return e.Code != "03" && e.Code != "04";
           });
           vm.HealthIndemList2 = vm.columnMap['HealthIndem'].CodeList.filter(function(e){
             return e.Code == "03" || e.Code == "04";
           });
         }

         if (result.body.docs.length > 0) {
           vm.data = result.body.docs[0];
           if (!isNullOrEmpty(vm.data.BirthDay)) {
             vm.BirthDay = new Date(vm.data.BirthDay);
           }
           if (!isNullOrEmpty(vm.data.WorkStartDate)) {
             vm.WorkStartDate = new Date(vm.data.WorkStartDate);
           }
           if (!isNullOrEmpty(vm.data.WorkEndDate)) {
             vm.WorkEndDate = new Date(vm.data.WorkEndDate);
           }
           if (!isNullOrEmpty(vm.data.SiteVeriftDate1)) {
             vm.SiteVeriftDate1 = new Date(vm.data.SiteVeriftDate1);
           }
           if (!isNullOrEmpty(vm.data.SiteVeriftDate2)) {
             vm.SiteVeriftDate2 = new Date(vm.data.SiteVeriftDate2);
           }

           if (vm.data.SupportReq01 == '1') {
             chgSupport('H');
           }
           if (vm.data.SupportReq02 == '1') {
             chgSupport('L');
           }
           if (vm.data.SupportReq03 == '1') {
             chgSupport('E');
           }
           if (vm.data.SupportReq04 == '1') {
             chgSupport('C');
           }
           if (vm.data.SupportReq06 == '1') {
             chgSupport('V');
           }
           if (vm.data.SupportReq05 == '1') {
             chgSupport('ETC');
           }            

           if (vm.data.uploadFileList) {
             angular.forEach(vm.data.uploadFileList, function (item) {
               angular.forEach(vm.attach, function (att) {
                 if(att.grpId == item.GrpId){    
                   var target = att.id;                
                   vm.attach[target].isLoaded = true;
                   vm.attach[target].fileName = item.LogicalFileNm;
                   vm.attach[target].size = item.FileSize;
                   vm.attach[target].path = item.PhysicalPath;
                   vm.attach[target].fileKey = item.PhysicalFileNm;
                   vm.attach[target].link = StaticVariable.getUrl("/openapi/attach/" + item.PhysicalPath + "/" + item.PhysicalFileNm + "/download.do");
                   vm.attach[target].delState = '';
                   vm.attach[target].fileLock = item.FileLock;
                   vm.attach[target].downAuth = (item.FileLock == "N" || (item.FileLock == "Y" && (vm.data.RegUserYN == "Y" || vm.tenantId == "0")));
                   vm.attach[target].ngIf = true;
                 } else {
                   return;
                 }
               });
             });
           } else {
             vm.data.uploadFileList = [];
           }

          // 자가진단
          angular.forEach(vm.selfData, function (qst, key) {
            if ( ! isNullOrEmpty(vm.data[key]) && vm.data[key] == 0) {
              qst.chk = vm.data[key];
            } else {
              qst.chk = 1;
            }
          });
          vm.selfChk = true;
          vm.selfDataResult = TakeService.getSelfDataResult(vm.selfData);
          vm.selfChkResult = (vm.selfDataResult.totalSc >= 14);

          // 사전설문지
          angular.forEach(vm.selfDataQna, function (qst, key) {
            if ( ! isNullOrEmpty(vm.data[key + '_q']))  qst.question = vm.data[key + '_q'];
            if ( ! isNullOrEmpty(vm.data[key + '_a']))  qst.answer = vm.data[key + '_a'];
          });

         } else {
           vm.data = {
             DiseaseYN: '0',
             ImpairYN: '0',
             IrdrYN: '0',
             EmergWelfareYN: '1',
             PrivateSptYN: '1',
             CarPos: '1',
             uploadFileList: [],
           };
         }

         // 등록자의 권한에 따라 등록 및 수정 항목 변경을 위한 값 (사례기관 T, 그외 A)
         if(isNullOrEmpty(vm.data.RegAuth)){
           vm.regUserType = ($window.sessionStorage['loginTenantType'] == 'TAKETENANT' ? "T" : "A");
         } else {
           vm.regUserType = vm.data.RegAuth;
         }
         
         // 기관정보 조회
         getTenantInfo();
         // 가족관계 목록 조회
         getFrmList();
         // 타기관 지원 목록 조회
         getTenantSptList();
         // 금융자산 목록 조회
         getFinanList();
         // 기타지출 목록 조회
         getEtcCostList();
       }

       vm.dataloader = false;
     }, function (error) {
       vm.dataloader = false;
       console.error("Error> getData()");
       console.table(error);
     }
     );
   }

   /**
    * 기관정보 조회
    * @param
    * @return
    */
   function getTenantInfo() {
     var data = {};
     if (isNullOrEmpty(vm.data.TenantId)) {
       data.keyId = vm.tenantId;
     } else {
       data.keyId = vm.data.TenantId;
     }

     data.mapCode = TENANT_VIEW_SQL;

     postApi.select(data, function (result) {
       if (result.header.status == CONSTANT.HttpStatus.OK) {
         if (result.body.docs.length > 0) {
           vm.tenantData = result.body.docs[0];
         } else {
           vm.tenantData = {};
         }
       }
     }, function (error) {
       console.error("Error> getTenantInfo()");
       console.table(error);
     });
   }

   /**
    * 가족관계 목록 조회
    * @param
    * @return
    */
   function getFrmList() {
     var data = { keyId: vm.keyId, mapCode: FRM_LIST_SQL };

     postApi.select(data, function (result) {
       if (result.header.status == CONSTANT.HttpStatus.OK) {
         if (result.body.docs.length > 0) {
           vm.data.frmList = result.body.docs;
         } else {
           vm.data.frmList = [];
         }
       }
     }, function (error) {
       console.error("Error> getFrmList()");
       console.table(error);
     });
   }

   /**
    * 타기관 지원 목록 조회
    * @param
    * @return
    */
   function getTenantSptList() {
     var data = { keyId: vm.keyId, mapCode: TENANT_SPT_LIST_SQL };

     postApi.select(data, function (result) {
       if (result.header.status == CONSTANT.HttpStatus.OK) {
         if (result.body.docs.length > 0) {
           vm.data.tenantSptList = result.body.docs;
           angular.forEach(vm.data.tenantSptList, function (item) {
             item.SptStartDate = moment(item.SptStartDate).format('YYYY-MM-DD');
             item.SptEndDate = moment(item.SptEndDate).format('YYYY-MM-DD');
           });
         } else {
           vm.data.tenantSptList = [];
         }
       }
     }, function (error) {
       console.error("Error> getTenantSptList()");
       console.table(error);
     });
   }

   /**
    * 금융자산 목록 조회
    * @param
    * @return
    */
   function getFinanList() {
     var data = { keyId: vm.keyId, mapCode: FINAN_LIST_SQL };

     postApi.select(data, function (result) {
       if (result.header.status == CONSTANT.HttpStatus.OK) {
         if (result.body.docs.length > 0) {
           vm.data.finanList = result.body.docs;
         } else {
           vm.data.finanList = [];
         }
       }
     }, function (error) {
       console.error("Error> getFinanList()");
       console.table(error);
     });
   }

   // 추가 버튼 대상일 경우 1행 입력 상태면 자동 추가 처리
   function autoSetListData(data) {      
     if (data.frmList.length == 0 && ! isNullOrEmpty(vm.frmData)) { // 가족관계
       vm.addFrm(true);
       data.frmList = angular.copy(vm.data.frmList);
     }
     if (data.etcCostList.length == 0 && ! isNullOrEmpty(vm.etcCostData)) { // 기타지출
       vm.addEtcCost(true);
       data.etcCostList = angular.copy(vm.data.etcCostList);
     }      
     if (data.finanList.length == 0 && ! isNullOrEmpty(vm.finanData)) { // 자산
       vm.addFinan(true);
       data.finanList = angular.copy(vm.data.finanList);
     }
     if (data.EmergWelfareYN == '1' && data.tenantSptList.filter(function(e){ return e.Type == "E"; }).length == 0 && ! isNullOrEmpty(vm.emerTenantSptData))  { // 긴급생계비
       vm.addTenantSptList("E", true);
       data.tenantSptList = angular.copy(vm.data.tenantSptList);
     }      
     if (data.PrivateSptYN == '1' && data.tenantSptList.filter(function(e){ return e.Type == "P"; }).length == 0 && ! isNullOrEmpty(vm.privateTenantSptData))  { // 외부지원
       vm.addTenantSptList("P", true);
       data.tenantSptList = angular.copy(vm.data.tenantSptList);
     }   
   }

   /**
    * 데이터 유효성 체크
    * @param
    * @return
    */
   function getIsValidData() {
     var data = angular.copy(vm.data);
     var errMsg = '';
     var errMsgCnt = 0;
     var errTargetNm = '';

     // 추가 버튼 대상일 경우 1행 입력 상태면 자동 추가 처리
     vm.autoSetListData(data);   

     // 0번 유효성 체크 ------------------------------------------------------------------------------------------
     if ( ! vm.selfChk) {
       if (errMsgCnt == 0) {
         errMsgCnt++;
       }
       errMsg = errMsg + '- 신청 적합성 자가진단을 진행해주세요. </br>';
     }

     if (isNullOrEmpty(data.Passwd)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'Passwd';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 조회 비밀번호를 입력해주세요. </br>';
     }
     if (isNullOrEmpty(data.SecretYN)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'rdoScretN';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 타기관 연계 신청 동의 여부를 선택해주세요. </br>';
     }
     if (isNullOrEmpty(data.Title)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'Title';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 제목을 입력해주세요. </br>';
     }

     // 1번 유효성 체크 ------------------------------------------------------------------------------------------
     if (isNullOrEmpty(data.TargetNm)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'TargetNm';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 대상자 이름을 입력해주세요. </br>';
     }
     if (isNullOrEmpty(data.Gender)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'Gender';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 대상자 성별을 선택해주세요. </br>';
     }
     if (isNullOrEmpty(data.Jumin1) || isNullOrEmpty(data.Jumin2)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'JuminNo';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 대상자 주민등록번호를 입력해주세요. </br>';
     }
     if (isNullOrEmpty(data.Age)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'Age';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 대상자 나이를 입력해주세요. </br>';
     }
     if (isNullOrEmpty(data.Mobile)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'Mobile';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 대상자 연락처를 입력해주세요. </br>';
     }
     if (isNullOrEmpty(data.ZipCode) || isNullOrEmpty(data.Addr1) || isNullOrEmpty(data.Addr2)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'ZipCode';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 대상자 주소를 입력해주세요. </br>';
     }
     if (isNullOrEmpty(data.GenType)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'GenType';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 대상자 세대유형을 선택해주세요. </br>';
     }      
     if (data.GenType == '09' && isNullOrEmpty(data.GenTypeEtc)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'GenTypeEtc';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 대상자 세대유형 기타 유형을 입력해주세요. </br>';
     }
     if (isNullOrEmpty(data.DiseaseYN)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'DiseaseYN';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 대상자 질병 및 질환 여부를 선택해주세요. </br>';
     } else {
       if (data.DiseaseYN == '1' && isNullOrEmpty(data.DiseaseNm)) {
         if (errMsgCnt == 0) {
           errTargetNm = 'DiseaseYN';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 대상자 질병 및 질환 내용을 입력해주세요. </br>';
       }
     }
     if (isNullOrEmpty(data.ProtType)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'ProtType';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 대상자 보호구분을 선택해주세요. </br>';
     }
     if ((data.ProtType == '07' || data.ProtType == '05') && isNullOrEmpty(data.HealthIndem)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'ProtType';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 대상자 보호구분 하위 항목을 선택해주세요. </br>';
     }
     if (isNullOrEmpty(data.ImpairYN)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'ImpairYN';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 대상자 장애 여부를 선택해주세요. </br>';
     } else {
       if (data.ImpairYN == '1' && isNullOrEmpty(data.ImpairNm)) {
         if (errMsgCnt == 0) {
           errTargetNm = 'ImpairYN';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 대상자 장애 내용을 입력해주세요. </br>';
       }
     }

     // 2번 유효성 체크 ------------------------------------------------------------------------------------------
     if ((isNullOrEmpty(data.SupportReq01) || data.SupportReq01 == '0')
         && (isNullOrEmpty(data.SupportReq02) || data.SupportReq02 == '0') 
         && (isNullOrEmpty(data.SupportReq03) || data.SupportReq03 == '0') 
         && (isNullOrEmpty(data.SupportReq04) || data.SupportReq04 == '0') 
         && (isNullOrEmpty(data.SupportReq05) || data.SupportReq05 == '0') 
         && (isNullOrEmpty(data.SupportReq06) || data.SupportReq06 == '0')) {
       if (errMsgCnt == 0) {
         errTargetNm = 'SupportReq01';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 신청영역을 1가지 이상 선택해주세요. </br>';
     }
     if (data.SupportReq01 == '1') {
       if (isNullOrEmpty(data.HousSptAmt) || data.HousSptAmt == 0) {
         if (errMsgCnt == 0) {
           errTargetNm = 'SupportReq01';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 신청영역 주거비 금액을 입력해주세요. </br>';
       }
     }
     if (data.SupportReq02 == '1') {
       if (isNullOrEmpty(data.livingAmt) || data.livingAmt == 0) {
         if (errMsgCnt == 0) {
           errTargetNm = 'SupportReq01';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 신청영역 생계비 금액을 입력해주세요. </br>';
       }
     }
     if (data.SupportReq04 == '1') {
       if (isNullOrEmpty(data.CureSptAmt) || data.CureSptAmt == 0) {
         if (errMsgCnt == 0) {
           errTargetNm = 'SupportReq01';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 신청영역 치료비 금액을 입력해주세요. </br>';
       }
     }
     if (data.SupportReq03 == '1') {
       if (isNullOrEmpty(data.EduSptAmt) || data.EduSptAmt == 0) {
         if (errMsgCnt == 0) {
           errTargetNm = 'SupportReq01';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 신청영역 자립비 금액을 입력해주세요. </br>';
       }
     }
     if (data.SupportReq05 == '1') {
       if (isNullOrEmpty(data.EtcSptAmt) || data.EtcSptAmt == 0) {
         if (errMsgCnt == 0) {
           errTargetNm = 'SupportReq01';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 신청영역 기타 금액을 입력해주세요. </br>';
       }
     }
     if (data.SupportReq06 == '1') {
       if (isNullOrEmpty(data.VouSptAmt) || data.VouSptAmt == 0) {
         if (errMsgCnt == 0) {
           errTargetNm = 'SupportReq01';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 신청영역 물품지원 금액을 입력해주세요. </br>';
       }
     }
     if (isNullOrEmpty(data.EtcSptCn)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'EtcSptCn';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 신청영역 산출근거를 입력해주세요. </br>';
     }     
     
     // 3번 유효성 체크 ------------------------------------------------------------------------------------------
     if(vm.isPesEtcOnly){
       if (isNullOrEmpty(data.CohabitCnt)) {
         if (errMsgCnt == 0) {
           errTargetNm = 'CohabitCnt';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 동거 가구원 수를 입력해주세요. </br>';
       }
       if (data.frmList.length == 0) {
         if (errMsgCnt == 0) {
           errTargetNm = 'FrmList';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 가족관계 정보를 입력해주세요. </br>';
       }
     }

     // 4번 유효성 체크 ------------------------------------------------------------------------------------------
     if(vm.isPesEtcOnly){
       if (isNullOrEmpty(data.HousType)) {
         if (errMsgCnt == 0) {
           errTargetNm = 'HousType';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 주거형태를 선택해주세요. </br>';
       }
       if (data.HousType == '1' && isNullOrEmpty(data.JagaAmt)) {
         if (errMsgCnt == 0) {
           errTargetNm = 'HousType';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 주거형태 -> 자가 시가를 입력해주세요. </br>';
       }
       if (data.HousType == '2' && isNullOrEmpty(data.JeonseAmt)) {
         if (errMsgCnt == 0) {
           errTargetNm = 'HousType';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 주거형태 -> 전세 보증금을 입력해주세요. </br>';
       }
       if (data.HousType == '3' && isNullOrEmpty(data.MonthDep)) {
         if (errMsgCnt == 0) {
           errTargetNm = 'HousType';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 주거형태 -> 월세 보증금을 입력해주세요. </br>';
       }
       if (data.HousType == '3' && isNullOrEmpty(data.MonthAmt)) {
         if (errMsgCnt == 0) {
           errTargetNm = 'HousType';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 주거형태 -> 월세를 입력해주세요. </br>';
       }
       if (data.HousType == '4' && isNullOrEmpty(data.AptDep)) {
         if (errMsgCnt == 0) {
           errTargetNm = 'HousType';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 주거형태 -> 공공임대 보증금을 입력해주세요. </br>';
       }
       if (data.HousType == '4' && isNullOrEmpty(data.AptAmt)) {
         if (errMsgCnt == 0) {
           errTargetNm = 'HousType';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 주거형태 -> 공공임대 월세를 입력해주세요. </br>';
       }
       if (data.HousType == '5' && isNullOrEmpty(data.FreeLease)) {
         if (errMsgCnt == 0) {
           errTargetNm = 'HousType';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 주거형태 -> 무상임대 소유자와 관계를 입력해주세요. </br>';
       }
       if (data.HousType == '6' && isNullOrEmpty(data.HousEtcCn)) {
         if (errMsgCnt == 0) {
           errTargetNm = 'HousType';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 주거형태 -> 기타 사항을 입력해주세요. </br>';
       }
       if (data.finanList.length == 0) {
         if (errMsgCnt == 0) {
           errTargetNm = 'finanList';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 자산 정보를 입력해주세요. </br>';
       }
       if (data.LiabYN == '1') {
         if ((isNullOrEmpty(data.LiabType1) && isNullOrEmpty(data.LiabType2) && isNullOrEmpty(data.LiabType3) && isNullOrEmpty(data.LiabType4))) {
           if (errMsgCnt == 0) {
             errTargetNm = 'LiabYN';
             errMsgCnt++;
           }
           errMsg = errMsg + '- 부채유형을 1가지 이상 선택해주세요. </br>';
         }
         if ((isNullOrEmpty(data.LiabAmt1) && isNullOrEmpty(data.LiabAmt2) && isNullOrEmpty(data.LiabAmt3) && isNullOrEmpty(data.LiabAmt4))) {
           if (errMsgCnt == 0) {
             errTargetNm = 'LiabYN';
             errMsgCnt++;
           }
           errMsg = errMsg + '- 부채 금액을 입력해주세요. </br>';
         }
       }
      if (isNullOrEmpty(data.EmergWelfareYN)) {
        if (errMsgCnt == 0) {
          errTargetNm = 'EmergWelfareYN';
          errMsgCnt++;
        }
        errMsg = errMsg + '- 긴급생계비 신청여부를 선택해주세요. </br>';
      }
      if (data.EmergWelfareYN == '1' && data.tenantSptList.filter(function(e){ return e.Type == "E"; }).length == 0) {
        if (errMsgCnt == 0) {
          errTargetNm = 'EmergWelfareYN';
          errMsgCnt++;
        }
        errMsg = errMsg + '- 긴급생계비 신청 정보를 입력해주세요. </br>';
      }
      if (data.EmergWelfareYN == '0' && isNullOrEmpty(data.FailCn)) {
        if (errMsgCnt == 0) {
          errTargetNm = 'EmergWelfareYN';
          errMsgCnt++;
        }
        errMsg = errMsg + '- 긴급생계비 불가사유를 입력해주세요. </br>';
      }
      if (isNullOrEmpty(data.PrivateSptYN)) {
        if (errMsgCnt == 0) {
          errTargetNm = 'PrivateSptYN';
          errMsgCnt++;
        }
        errMsg = errMsg + '- 외부지원 신청여부를 선택해주세요. </br>';
      }
      if (data.PrivateSptYN == '1' && data.tenantSptList.filter(function(e){ return e.Type == "P"; }).length == 0) {
        if (errMsgCnt == 0) {
          errTargetNm = 'PrivateSptYN';
          errMsgCnt++;
        }
        errMsg = errMsg + '- 외부지원 신청 정보를 입력해주세요. </br>';
      }
     }

     // 6번 유효성 체크 ------------------------------------------------------------------------------------------
     if (isNullOrEmpty(data.ContactNm)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'ContactNm';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 추천기관 담당자명을 입력해주세요. </br>';
     }
     if (isNullOrEmpty(data.ContactEmail)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'ContactMobile';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 추천기관 담당자 직통번호를 입력해주세요. </br>';
     }
     if (isNullOrEmpty(data.ContactEmail)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'ContactEmail';
         errMsgCnt++;
         }
       errMsg = errMsg + '- 추천기관 담당자 E-mail을 입력해주세요. </br>';
     }

     if(vm.isPesEtcOnly){        
       if (isNullOrEmpty(data.SupportNec) || data.SupportNec.length < 200) {
         if (errMsgCnt == 0) {
           errTargetNm = 'SupportNec';
           errMsgCnt++;
         }
         errMsg = errMsg + '- 대상자 위기상황 요약 및 추천사유를 200자 이상 입력해주세요. </br>';
       }
     }

     // 8번 유효성 체크 ------------------------------------------------------------------------------------------
     if( ! vm.isPesEtcOnly && isNullOrEmpty(vm.attach['AttachFile5'].fileName)){
       if (errMsgCnt == 0) {
         errTargetNm = 'attachFile';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 지원신청서를 업로드 해주세요. </br>';
     }
     if (isNullOrEmpty(vm.attach['AttachFile1'].fileName)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'attachFile';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 공통 필수서류를 업로드 해주세요. </br>';
     }

    var list = Object.values(vm.selfDataQna || {});
    var hasEmpty = list.some(function(qst) {
      return !qst.answer || qst.answer.trim() === '';
    });
    if (hasEmpty && vm.tenantType == 'TAKETENANT' && ! vm.isPesEtcOnly) {
      errTargetNm = 'SelfDataQna';
      errMsg = errMsg + '- 서류심사 체크리스트 답변을 입력해주세요. </br>';
    }
     
     // 9번 유효성 체크 ------------------------------------------------------------------------------------------
     if (isNullOrEmpty(data.SiteVeriftDate1) || isNullOrEmpty(data.SiteVeriftTime11)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'SiteVeriftDate';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 현장실사 1순위 일시를 선택해주세요. </br>';
     }      
     if (isNullOrEmpty(data.SiteVeriftDate2) || isNullOrEmpty(data.SiteVeriftTime21)) {
       if (errMsgCnt == 0) {
         errTargetNm = 'SiteVeriftDate';
         errMsgCnt++;
       }
       errMsg = errMsg + '- 현장실사 2순위 일시를 선택해주세요. </br>';
     }

     if (!isNullOrEmpty(errMsg)) {
       gAlert('', errMsg);
       $("#"+errTargetNm).attr("tabindex", -1).focus();
       return false;
     }

     return true;
   }

   /**
    * 데이터 저장
    * @param
    * @return
    */
   function saveData() {

     if (getIsValidData()) {
       var data = angular.copy(vm.data);
       var type = '';
       var mapCode = '';
       data.tableNm = 'casemanage';
       data.IdName = 'keyId';

       // 임시저장>등록, 최종제출>최종제출 외에는 상태값 변경되지 않도록 값 비움
       if(isNullOrEmpty(vm.data.Status) || vm.data.Status == "RG"){
         data.Status = 'RG';
       } else {
         data.Status = "";
       }

       if (!isNullOrEmpty(vm.keyId)) {
         data.keyId = vm.keyId;
         type = 'update';
         mapCode = UPDATE_SQL;
       } else {
         type = 'insert';
         mapCode = INSERT_SQL;
         data.RegAuth = vm.regUserType;
       }

       if (!isNullOrEmpty(data.BirthDay)) {
         data.BirthDay = moment(data.BirthDay).format('YYYY-MM-DD');
       }
       if (!isNullOrEmpty(data.WorkStartDate)) {
         data.WorkStartDate = moment(data.WorkStartDate).format('YYYY-MM-DD');
       }
       if (!isNullOrEmpty(data.WorkEndDate)) {
         data.WorkEndDate = moment(data.WorkEndDate).format('YYYY-MM-DD');
       }

      // 자가진단, 추가질문응답 저장
      if(vm.tenantType == 'TAKETENANT') {
        data.selfData = [];
        angular.forEach(vm.selfData, function(item, key) {    
          data.selfData.push({key: key, chk: item.chk});
        });
        data.selfDataQna = [];
        angular.forEach(vm.selfDataQna, function(item, key) {    
          data.selfDataQna.push({key: key, question: item.question, answer: item.answer});
        });
      }

       postApi.sendPostApi(type, mapCode, data, function (result) {
         if (result.header.status === CONSTANT.HttpStatus.OK) {
           if (result.body.docs.length > 0) {
             if (isNullOrEmpty(vm.keyId)) {
               vm.keyId = result.body.docs[0].RelateDataId;
             }
             gAlert('', '저장 되었습니다.', {
               btn: '',
               fn: function () {
                 goList();
               }
             });
           }
         }
       });
     }
   }

   /**
    * 데이터 임시저장
    * @param
    * @return
    */
   function saveTempData() {
     var data = vm.data;
     var type = '';
     var mapCode = '';      

     // 추가 버튼 대상일 경우 1행 입력 상태면 자동 추가 처리
     vm.autoSetListData(data); 

     data.tableNm = 'casemanage';
     data.IdName = 'keyId';

     if (!isNullOrEmpty(vm.keyId)) {
       data.keyId = vm.keyId;
       type = 'update';
       mapCode = UPDATE_SQL;
     } else {
       type = 'insert';
       mapCode = INSERT_SQL;
       data.RegAuth = vm.regUserType;
     }

     if (!isNullOrEmpty(data.BirthDay)) {
       data.BirthDay = moment(data.BirthDay).format('YYYY-MM-DD');
     }
     if (!isNullOrEmpty(data.WorkStartDate)) {
       data.WorkStartDate = moment(data.WorkStartDate).format('YYYY-MM-DD');
     }
     if (!isNullOrEmpty(data.WorkEndDate)) {
       data.WorkEndDate = moment(data.WorkEndDate).format('YYYY-MM-DD');
     }

     // 자가진단, 추가질문응답 저장
     if(vm.tenantType == 'TAKETENANT') {
       data.selfData = [];
       angular.forEach(vm.selfData, function(item, key) {    
         data.selfData.push({key: key, chk: item.chk});
       });
       data.selfDataQna = [];
       angular.forEach(vm.selfDataQna, function(item, key) {    
         data.selfDataQna.push({key: key, question: item.question, answer: item.answer});
       });
     }

     postApi.sendPostApi(type, mapCode, data, function (result) {
       if (result.header.status === CONSTANT.HttpStatus.OK) {
         if (result.body.docs.length > 0) {
           if (isNullOrEmpty(vm.keyId)) {
             vm.keyId = result.body.docs[0].RelateDataId;
             $stateParams.keyId = vm.keyId;
           }
           gAlert('', '임시저장 되었습니다.', {
             btn: '',
             fn: function () {
               var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
               var type = $stateParams.type;
               var status = $stateParams.status; // 상태값

               $state.go(EDIT_PAGE_URL, { srch: srch, type: type, status: status, keyId: vm.keyId });               
               getData();
             }
           });
         }
       }
     });
   }

   /* 다음 주소검색 */
   function srchZipCodeModal() {
     new daum.Postcode({
       oncomplete: function (data) {
         $timeout(function () {                        

           // 현장간사를 위한 시군구 코드
           vm.data.CityCode = data.sigunguCode;

           vm.data.ZipCode = data.zonecode;
           var addr1 = data.buildingName != "" ? data.address + " " + data.buildingName : data.address;
           vm.data.Addr1 = addr1;
         }, 0);
       },
     }).open();
   }

   // 가족 관계 추가 시, Validation 체크
   function getIsValidFrmData(isReq) {
     var errMsg = '';

     if (isNullOrEmpty(vm.frmData.FrNm)) {
       errMsg = errMsg + '- 성명을 입력해주세요.<br/>';
     }
     if (isNullOrEmpty(vm.frmData.Relp)) {
       errMsg = errMsg + '- 관계를 입력해주세요.<br/>';
     }
     if (isNullOrEmpty(vm.frmData.Age)) {
       errMsg = errMsg + '- 출생연도 입력해주세요.<br/>';
     }
     if (isNullOrEmpty(vm.frmData.Job)) {
       errMsg = errMsg + '- 직업을 입력해주세요.<br/>';
     }
     if (isNullOrEmpty(vm.frmData.CohabitYN)) {
       errMsg = errMsg + '- 동거여부를 입력해주세요.<br/>';
     }

     if (!isNullOrEmpty(errMsg)) {
       if(isReq){
         return false;
       } else {
         gAlert('', errMsg);
         return false;
       }
     }
     return true;
   }

   // 가족 관계 추가
   function addFrm(isReq) {
     if (getIsValidFrmData(isReq)) {
       vm.data.frmList.push(vm.frmData);
       vm.frmData = {};
     } 
   }

   // 가족 관계 삭제
   function delFrm(index) {
     vm.data.frmList.splice(index, 1);
   }

   // 타기관지원연계 추가 시, Validation 체크
   function getIsValidTenantSptData(type, isReq) {
     var errMsg = '';
     // 긴급지원
     if (type == 'E') {
       if (isNullOrEmpty(vm.emerTenantSptData.TenantSptNm)) {
         errMsg = errMsg + '- 지원기관을 입력하세요. <br/>';
       }
       if (isNullOrEmpty(vm.emerTenantSptData.SptAmt)) {
         errMsg = errMsg + '- 지원금액을 입력하세요. <br/>';
       }
       if (isNullOrEmpty(vm.emerTenantSptData.SptStartDate) || isNullOrEmpty(vm.emerTenantSptData.SptEndDate)) {
         errMsg = errMsg + '- 지원기간을 입력하세요. <br/>';
       }
       if (isNullOrEmpty(vm.emerTenantSptData.SptCn)) {
         errMsg = errMsg + '- 지원내용을 입력하세요. <br/>';
       }
     }

     // 민간지원
     if (type == 'P') {
       if (isNullOrEmpty(vm.privateTenantSptData.TenantSptNm)) {
         errMsg = errMsg + '- 지원기관을 입력하세요. <br/>';
       }
       if (isNullOrEmpty(vm.privateTenantSptData.SptAmt)) {
         errMsg = errMsg + '- 지원금액을 입력하세요. <br/>';
       }
       if (isNullOrEmpty(vm.privateTenantSptData.SptStartDate) || isNullOrEmpty(vm.privateTenantSptData.SptEndDate)) {
         errMsg = errMsg + '- 지원기간을 입력하세요. <br/>';
       }
       if (isNullOrEmpty(vm.privateTenantSptData.SptCn)) {
         errMsg = errMsg + '- 지원내용을 입력하세요. <br/>';
       }
     }

     if (!isNullOrEmpty(errMsg)) {          
       if(isReq){
         return false;
       } else {
         gAlert('', errMsg);
         return false;
       }
     }
     return true;
   }

   // 타기관지원연계 추가
   function addTenantSptList(type, isReq) {
     if (getIsValidTenantSptData(type, isReq)) {
       if (type == 'E') {              // 긴급복지
         vm.emerTenantSptData.Type = type;
         vm.emerTenantSptData.emerSptStartDate = moment(vm.emerTenantSptData.emerSptStartDate).format('YYYY-MM-DD');
         vm.emerTenantSptData.emerSptEndDate = moment(vm.emerTenantSptData.emerSptEndDate).format('YYYY-MM-DD');
         vm.data.tenantSptList.push(vm.emerTenantSptData);
         vm.emerTenantSptData = {};
         vm.emerSptStartDate = null;
         vm.emerSptEndDate = null;
       } else if (type == 'P') {       // 민간지원
         vm.privateTenantSptData.Type = type;
         vm.privateTenantSptData.privateSptStartDate = moment(vm.privateTenantSptData.privateSptStartDate).format('YYYY-MM-DD');
         vm.privateTenantSptData.privateSptEndDate = moment(vm.privateTenantSptData.privateSptEndDate).format('YYYY-MM-DD');
         vm.data.tenantSptList.push(vm.privateTenantSptData);
         vm.privateTenantSptData = {};
         vm.privateSptStartDate = null;
         vm.privateSptEndDate = null;
       }
     }
   }

   // 타기관지원연계 삭제
   function delTenantSptList(index) {
     vm.data.tenantSptList.splice(index, 1);
   }

   // 지원요청영역 선택 시, 사업신청분야 Disabled 변경
   function chgSupport(type, chk) {

     // 주거지원
     if (type == 'H') {
       if (vm.data.SupportReq01 == '1') {
         vm.disabledHous = false;
       } else {
         vm.disabledHous = true;
         vm.data.HousSptAmt = 0;
         getTotalSptSum();
       }
     }
     // 생계지원
     if (type == 'L') {
       if (vm.data.SupportReq02 == '1') {
         vm.disabledLiving = false;
       } else {
         vm.disabledLiving = true;
         vm.data.livingAmt = 0;
         getTotalSptSum();
       }
     }
     // 교육지원
     if (type == 'E') {
       if (vm.data.SupportReq03 == '1') {
         vm.disabledEdu = false;
       } else {
         vm.disabledEdu = true;
         vm.data.EduSptAmt = 0;
         getTotalSptSum();
       }
     }
     // 치료비지원
     if (type == 'C') {
       if (vm.data.SupportReq04 == '1') {
         vm.disabledCure = false;
       } else {
         vm.disabledCure = true;
         vm.data.CureSptAmt = 0;
         getTotalSptSum();
       }
     }
     // 물품바우처지원
     if (type == 'V') {
       if (vm.data.SupportReq06 == '1') {
         vm.disabledVou = false;
       } else {
         vm.disabledVou = true;
         vm.data.VouSptAmt = 0;
         getTotalSptSum();
       }        
     }
     // 기타지원
     if (type == 'ETC') {
       if (vm.data.SupportReq05 == '1') {
         vm.disabledHEtc = false;
       } else {
         vm.disabledHEtc = true;
         vm.data.EtcSptAmt = 0;
         getTotalSptSum();
       }
     }  

     // 물품지원(Req06)만 선택했을 경우
     vm.isPesOnly = ((isNullOrEmpty(vm.data.SupportReq01) || vm.data.SupportReq01 == "0")
                       && (isNullOrEmpty(vm.data.SupportReq02) || vm.data.SupportReq02 == "0") 
                       && (isNullOrEmpty(vm.data.SupportReq03) || vm.data.SupportReq03 == "0") 
                       && (isNullOrEmpty(vm.data.SupportReq04) || vm.data.SupportReq04 == "0") 
                       && (isNullOrEmpty(vm.data.SupportReq05) || vm.data.SupportReq05 == "0") 
                       && ( ! isNullOrEmpty(vm.data.SupportReq06) && vm.data.SupportReq06 == "1"));    

    // 물품지원(Req06), 기타(Req05)만 선택했을 경우
    vm.isPesEtcOnly = ((isNullOrEmpty(vm.data.SupportReq01) || vm.data.SupportReq01 == "0")
                      && (isNullOrEmpty(vm.data.SupportReq02) || vm.data.SupportReq02 == "0") 
                      && (isNullOrEmpty(vm.data.SupportReq03) || vm.data.SupportReq03 == "0") 
                      && (isNullOrEmpty(vm.data.SupportReq04) || vm.data.SupportReq04 == "0") 
                      && (( ! isNullOrEmpty(vm.data.SupportReq05) && vm.data.SupportReq05 == "1") 
                            || ( ! isNullOrEmpty(vm.data.SupportReq06) && vm.data.SupportReq06 == "1")));   
   }

   // 총 지원 합계 계산
   function getTotalSptSum() {
     if (isNullOrEmpty(vm.data.HousSptAmt)) {
       vm.data.HousSptAmt = 0;
     } else if (!isNullOrEmpty(vm.data.HousSptAmt) && vm.data.HousSptAmt != '0' && String(vm.data.HousSptAmt).charAt(0) == '0') {
       vm.data.HousSptAmt = vm.data.HousSptAmt.replace(/(^0+)/, "");
     }
     if (isNullOrEmpty(vm.data.livingAmt)) {
       vm.data.livingAmt = 0;
     } else if (!isNullOrEmpty(vm.data.livingAmt) && vm.data.livingAmt != '0' && String(vm.data.livingAmt).charAt(0) == '0') {
       vm.data.livingAmt = vm.data.livingAmt.replace(/(^0+)/, "");
     }
     if (isNullOrEmpty(vm.data.EduSptAmt)) {
       vm.data.EduSptAmt = 0;
     } else if (!isNullOrEmpty(vm.data.EduSptAmt) && vm.data.EduSptAmt != '0' && String(vm.data.EduSptAmt).charAt(0) == '0') {
       vm.data.EduSptAmt = vm.data.EduSptAmt.replace(/(^0+)/, "");
     }
     if (isNullOrEmpty(vm.data.CureSptAmt)) {
       vm.data.CureSptAmt = 0;
     } else if (!isNullOrEmpty(vm.data.CureSptAmt) && vm.data.CureSptAmt != '0' && String(vm.data.CureSptAmt).charAt(0) == '0') {
       vm.data.CureSptAmt = vm.data.CureSptAmt.replace(/(^0+)/, "");
     }
     if (isNullOrEmpty(vm.data.VouSptAmt)) {
       vm.data.VouSptAmt = 0;
     } else if (!isNullOrEmpty(vm.data.VouSptAmt) && vm.data.VouSptAmt != '0' && String(vm.data.VouSptAmt).charAt(0) == '0') {
       vm.data.CureVouSptAmtSptAmt = vm.data.VouSptAmt.replace(/(^0+)/, "");
     }
     if (isNullOrEmpty(vm.data.EtcSptAmt)) {
       vm.data.EtcSptAmt = 0;
     } else if (!isNullOrEmpty(vm.data.EtcSptAmt) && vm.data.EtcSptAmt != '0' && String(vm.data.EtcSptAmt).charAt(0) == '0') {
       vm.data.EtcSptAmt = vm.data.EtcSptAmt.replace(/(^0+)/, "");
     }

     vm.data.TotalSptSum = Number(vm.data.HousSptAmt) + Number(vm.data.livingAmt) + Number(vm.data.EduSptAmt) + Number(vm.data.CureSptAmt) + Number(vm.data.VouSptAmt) + Number(vm.data.EtcSptAmt);
   }

   // 수입 합계 계산
   function getTotalInc() {
     if (isNullOrEmpty(vm.data.WorkInc)) {
       vm.data.WorkInc = 0;
     } else if (!isNullOrEmpty(vm.data.WorkInc) && vm.data.WorkInc != '0' && String(vm.data.WorkInc).charAt(0) == '0') {
       vm.data.WorkInc = vm.data.WorkInc.replace(/(^0+)/, "");
     }
     if (isNullOrEmpty(vm.data.GovtGrant)) {
       vm.data.GovtGrant = 0;
     } else if (!isNullOrEmpty(vm.data.GovtGrant) && vm.data.GovtGrant != '0' && String(vm.data.GovtGrant).charAt(0) == '0') {
       vm.data.GovtGrant = vm.data.GovtGrant.replace(/(^0+)/, "");
     }
     if (isNullOrEmpty(vm.data.Donation)) {
       vm.data.Donation = 0;
     } else if (!isNullOrEmpty(vm.data.Donation) && vm.data.Donation != '0' && String(vm.data.Donation).charAt(0) == '0') {
       vm.data.Donation = vm.data.Donation.replace(/(^0+)/, "");
     }
     if (isNullOrEmpty(vm.data.Etc)) {
       vm.data.Etc = 0;
     } else if (!isNullOrEmpty(vm.data.Etc) && vm.data.Etc != '0' && String(vm.data.Etc.charAt(0)) == '0') {
       vm.data.Etc = vm.data.Etc.replace(/(^0+)/, "");
     }

     vm.data.TotalInc = Number(vm.data.WorkInc) + Number(vm.data.GovtGrant) + Number(vm.data.Donation) + Number(vm.data.Etc);
   }

   // 지출 합계 계산
   function getTotalCost() {
     if (isNullOrEmpty(vm.data.HousCost)) {
       vm.data.HousCost = 0;
     } else if (!isNullOrEmpty(vm.data.HousCost) && vm.data.HousCost != '0' && String(vm.data.HousCost).charAt(0) == '0') {
       vm.data.HousCost = vm.data.HousCost.replace(/(^0+)/, "");
     }
     if (isNullOrEmpty(vm.data.MaintCost)) {
       vm.data.MaintCost = 0;
     } else if (!isNullOrEmpty(vm.data.MaintCost) && vm.data.MaintCost != '0' && String(vm.data.MaintCost).charAt(0) == '0') {
       vm.data.MaintCost = vm.data.MaintCost.replace(/(^0+)/, "");
     }
     if (isNullOrEmpty(vm.data.FoodCost)) {
       vm.data.FoodCost = 0;
     } else if (!isNullOrEmpty(vm.data.FoodCost) && vm.data.FoodCost != '0' && String(vm.data.FoodCost).charAt(0) == '0') {
       vm.data.FoodCost = vm.data.FoodCost.replace(/(^0+)/, "");
     }
     if (isNullOrEmpty(vm.data.HealthCost)) {
       vm.data.HealthCost = 0;
     } else if (!isNullOrEmpty(vm.data.HealthCost) && vm.data.HealthCost != '0' && String(vm.data.HealthCost).charAt(0) == '0') {
       vm.data.HealthCost = vm.data.HealthCost.replace(/(^0+)/, "");
     }
     if (isNullOrEmpty(vm.data.EduCost)) {
       vm.data.EduCost = 0;
     } else if (!isNullOrEmpty(vm.data.EduCost) && vm.data.EduCost != '0' && String(vm.data.EduCost).charAt(0) == '0') {
       vm.data.EduCost = vm.data.EduCost.replace(/(^0+)/, "");
     }

     vm.data.TotalCost = Number(vm.data.HousCost) + Number(vm.data.MaintCost) + Number(vm.data.FoodCost) + Number(vm.data.HealthCost) + Number(vm.data.EduCost);

     // 기타지출
     var eCost = 0;
     if(!isNullOrEmpty(vm.data.etcCostList)){
       angular.forEach(vm.data.etcCostList, function (item) {
         if (isNullOrEmpty(item.EtcCost)) {
           item.EtcCost = 0;
         } else if (!isNullOrEmpty(item.EtcCost) && item.EtcCost != '0' && String(item.EtcCost).charAt(0) == '0') {
           item.EtcCost = item.EtcCost.replace(/(^0+)/, "");
         }
         eCost = eCost + Number(item.EtcCost)
       });
     }
     vm.data.TotalCost = vm.data.TotalCost + eCost;
   }

   // 재산현황 - 주거 변경 시, disabled 변경
   function chgHouseType(num) {
     if (num == '1') {
       vm.data.JeonseAmt = null;
       vm.data.JeonseLoan = null;
       vm.data.MonthDep = null;
       vm.data.MonthAmt = null;
       vm.data.AptDep = null;
       vm.data.AptAmt = null;
       vm.data.FreeLease = null;
       vm.data.HousEtcCn = null;
     }
     if (num == '2') {
       vm.data.JagaAmt = null;
       vm.data.JagaLoan = null;
       vm.data.MonthDep = null;
       vm.data.MonthAmt = null;
       vm.data.AptDep = null;
       vm.data.AptAmt = null;
       vm.data.FreeLease = null;
       vm.data.HousEtcCn = null;
     }
     if (num == '3') {
       vm.data.JagaAmt = null;
       vm.data.JagaLoan = null;
       vm.data.JeonseAmt = null;
       vm.data.JeonseLoan = null;
       vm.data.AptDep = null;
       vm.data.AptAmt = null;
       vm.data.FreeLease = null;
       vm.data.HousEtcCn = null;
     }
     if (num == '4') {
       vm.data.JagaAmt = null;
       vm.data.JagaLoan = null;
       vm.data.JeonseAmt = null;
       vm.data.JeonseLoan = null;
       vm.data.MonthDep = null;
       vm.data.MonthAmt = null;
       vm.data.FreeLease = null;
       vm.data.HousEtcCn = null;
     }
     if (num == '5') {
       vm.data.JagaAmt = null;
       vm.data.JagaLoan = null;
       vm.data.JeonseAmt = null;
       vm.data.JeonseLoan = null;
       vm.data.MonthDep = null;
       vm.data.MonthAmt = null;
       vm.data.AptDep = null;
       vm.data.AptAmt = null;
       vm.data.HousEtcCn = null;
     }
     if (num == '6') {
       vm.data.JagaAmt = null;
       vm.data.JagaLoan = null;
       vm.data.JeonseAmt = null;
       vm.data.JeonseLoan = null;
       vm.data.MonthDep = null;
       vm.data.MonthAmt = null;
       vm.data.AptDep = null;
       vm.data.AptAmt = null;
       vm.data.FreeLease = null;
     }
   }

   // 금융자산 추가 시, Validation 체크
   function getIsValidFinanData(isReq) {
     var errMsg = '';

     if (isNullOrEmpty(vm.finanData.Type)) {
       errMsg = errMsg + '- 종류를 선택해주세요.<br/>';
     }
     if(vm.finanData.Type != '5') {
       if (isNullOrEmpty(vm.finanData.Amount)) {
         errMsg = errMsg + '- 금액을 입력해주세요.<br/>';
       }
       if (isNullOrEmpty(vm.finanData.UseYN)) {
         errMsg = errMsg + '- 사용여부를 선택해주세요.<br/>';
       }  
     }
     
     if (!isNullOrEmpty(errMsg)) {              
       if(isReq){
         return false;
       } else {
         gAlert('', errMsg);
         return false;
       }
     }
     return true;
   }

   // 금융자산 추가
   function addFinan(isReq) {
     if (getIsValidFinanData(isReq)) {
       angular.forEach(vm.columnMap['FinanType'].CodeList, function (item) {
         if (item.Code == vm.finanData.Type) {
           vm.finanData.TypeNm = item.CodeValue;
         }
       });
       if (vm.finanData.UseYN == '1') {
         vm.finanData.UseYNNm = '가능';
       } else {
         vm.finanData.UseYNNm = '불가능';
       }

       vm.data.finanList.push(vm.finanData);
       vm.finanData = {};
     }
   }

   // 금융자산 삭제
   function delFinan(index) {
     vm.data.finanList.splice(index, 1);
   }

   // 데이터 초기화
   vm.chgInit = function(type) {
     switch(type){
       case 1 : // 세대유형
         if (vm.data.GenType != '09') {
           vm.data.GenTypeEtc = null;
         } 
         break;

       case 2 : // 질병여부
         if (vm.data.DiseaseYN == '0') {
           vm.data.DiseaseNm = null;
         }
         break;
       
       case 3 : // 보호구분
         if (vm.data.ProtType != '05' && vm.data.ProtType != '07' ) {
           vm.data.HealthIndem = null;
         } 
         break;
         
       case 4 : // 장애 여부
         if (vm.data.ImpairYN == '0') {
           vm.data.ImpairNm = null;
         }
         break;
     }      
   };

   // 근로 상태 - 근로기간 Disabled 설정
   function chgWorkStat() {
     // 무직상황 1년 이상 경우 Disabled
     if (vm.data.WorkStat == '4') {
       vm.disabledWorkDate = true;
     } else {
       vm.disabledWorkDate = false;
     }
   }

   // 긴급복지/민간지원 이용여부 클릭 시, 데이터 초기화
   function chgTenantSpt(type) {
     // 긴급복지 이용여부
     if (type == 'emer') {
       if (vm.data.EmergWelfareYN == '1') {
         vm.data.NotApplyCN = null;
         vm.data.FailCn = null;
       } else if (vm.data.EmergWelfareYN == '0') {
         angular.forEach(vm.data.tenantSptList, function (item, index) {
           if (item.Type == 'E') {
             vm.data.tenantSptList.splice(index, 1);
           }
         });
         vm.data.emerTenantSptData = {};
         vm.emerSptStartDate = null;
         vm.emerSptEndDate = null;
         vm.data.NotApplyCN = null;
       } else {
         angular.forEach(vm.data.tenantSptList, function (item, index) {
           if (item.Type == 'E') {
             vm.data.tenantSptList.splice(index, 1);
           }
         });
         vm.data.emerTenantSptData = {};
         vm.emerSptStartDate = null;
         vm.emerSptEndDate = null;
         vm.data.FailCn = null;
       }
     }
     // 민간지원 이용여부
     if (type == 'priv') {
       if (vm.data.PrivateSptYN == '0') {
         angular.forEach(vm.data.tenantSptList, function (item, index) {
           if (item.Type == 'P') {
             vm.data.tenantSptList.splice(index, 1);
           }
         });
         vm.data.privateTenantSptData = {};
         vm.privateSptStartDate = null;
         vm.privateSptEndDate = null;
       }
     }
   }

   // 차량 소유 여부 클릭 시, 데이터 초기화
   function chgCarYN() {
     vm.data.CarType = null;
     vm.data.CarPurYear = null;
   }

   // 모금연계/사진사용 가능 여부 클릭 시, 데이터 초기화
   function chgFundYN(type) {
     if (type == 1 && vm.data.LinkYN == '0') {
       vm.data.BroadCastFund = '0';
       vm.data.OnLineFund =  '0';
       vm.data.FundEtc = '0' ;
       vm.data.PhotoUseYN =  '0';
       vm.data.PhotoUse01 =  '0';
       vm.data.PhotoUse02 =  '0';
       vm.data.PhotoUse03 =  '0';
       vm.data.PhotoUse04 =  '0';
     }
     if (type == 2 && vm.data.PhotoUseYN == '0') {
       vm.data.PhotoUse01 =  '0';
       vm.data.PhotoUse02 =  '0';
       vm.data.PhotoUse03 =  '0';
       vm.data.PhotoUse04 =  '0';
     }
   }

   // 파일 업로드창 
   vm.openAttachDialog = function (target) {  
     var elementNm = "#" + target;
     var fileElement = angular.element(elementNm);

     fileElement.trigger("click");    
     fileElement.off('change').on('change', function () {
       var file = fileElement[0].files[0];
       if (!file) return;    
       
      var fileName = file.name.toLowerCase();
      var isPdf = file.type === "application/pdf" || fileName.endsWith(".pdf");
      var isImage = file.type.startsWith("image/") || /\.(jpg|jpeg|png|gif|webp)$/.test(fileName);

      if (!isPdf && !isImage) {
        alert("PDF와 이미지 파일만 업로드할 수 있습니다.");
              $(this).val(""); 
              return; 
          }

       var reader = new FileReader();
       reader.onload = function (e) {         
         vm.data[target] =  $(fileElement).val(); 
         if(target == "AttachFile5"){
          vm.data.AiNewYN = "Y";
         }
         vm.onChangeHandler([file], target); 
       };    
       reader.readAsDataURL(file);  
     });
   };

   /**
    * 첨부파일 업로드
    *
    * @param {object}
    *          files - 첨부 파일
    * @return
   */
   vm.onChangeHandler = function (files, target) {
     // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
     $scope.$root.safeApply(function () {
       resetAttachment(target);
       vm.attach[target].fileName = files[0].name;
       vm.attach[target].size = files[0].size;
       var request = fileUploadService.post(files, null, function (percent) {
       });

       try {
         request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey=' + $rootScope.gVariable.userKey)).then(function (value) {  
           angular.forEach(value.data.responseVO.body.docs, function (item) {

            // AI 분석용
            if(target == "AttachFile5" && vm.tenantType == 'TAKETENANT' && ! vm.isPesEtcOnly){
              var data = {
                attachType : "temp",
                attachId : item.tmpFileKey ,
                tenantId : vm.tenantId,
                mapCode : "getBase64ByFile", 
              };
              postApi.openApi(data, function (result) {
                if (result.header.status == CONSTANT.HttpStatus.OK) {   
                  if (result.body.docs.length > 0) {
                    var data = result.body.docs[0];
                    vm.getAiData(data.base64)
                    .catch(function(error) {
                      gAlert('', 'AI 분석 중 오류가 발생했습니다.');
                    }); 
                  }
                }
              }, function(error) {}); 
            } 


             if (item.fileName == vm.attach[target].fileName && item.size == vm.attach[target].size) {
               vm.attach[target].isLoaded = true;
               vm.attach[target].tmpFileKey = item.tmpFileKey;
               vm.attach[target].fileKey = item.tmpFileKey; // 삭제 후 새로 등록하는 경우에 필요
               vm.attach[target].typeId = item.typeId;
               vm.attach[target].path = item.path;
               vm.attach[target].link = StaticVariable.getUrl("/openapi/attach/temp/" + item.tmpFileKey + "/download.do?&fileName=" + item.encFileName);
               vm.attach[target].delState = '';
               vm.data.uploadFileList.push(vm.attach[target]);   
             }
           });
         }, function (error) {
           console.error('Error> company-edit-ctrl> uploadFiles()', status, error);
         });
       } catch (error) {
         console.error('Error> company-edit-ctrl> uploadFiles()', status, error);
       }
     });
   };

   // 파일 삭제
   vm.onDelete = function (target) {
     angular.forEach(vm.data.uploadFileList, function (item, idx) {
       if(vm.attach[target].fileKey != undefined){
         if (item.PhysicalFileNm == vm.attach[target].fileKey) {
           item.delState = 'delete';
           item.fileKey = vm.attach[target].fileKey;
           item.id = item.fileId;
           item.path = vm.attach[target].path;
         }
       } else {
         if (item.id == target) {
           vm.data.uploadFileList.splice(idx, 1) 
         }
       }
     });

     resetAttachment(target);
     return;
   };

   // 파일 삭제 후 데이터 초기화
   function resetAttachment(target) {
     vm.attach[target].isLoaded = false;
     vm.attach[target].fileName = '';
     vm.attach[target].size = 0;
     vm.attach[target].path = '';
     vm.attach[target].link = '';
     vm.attach[target].delState = '';
     vm.attach[target].fileLock = 'Y';
     vm.attach[target].downAuth = true;
   }

   // 파일 다운로드
   vm.downloadTemp = function (target, arrObj) {
     if(vm.attach[target].downAuth){
       if( ! arrObj){
         if (!isNullOrEmpty(vm.attach[target].link)) {
           window.open(vm.attach[target].link);
         }
       } else {
         if (!isNullOrEmpty(arrObj.link)) {
           window.open(arrObj.link);
         }
       }
     } else {
       alert("다운로드 권한이 없습니다.");
     }
   };


   /**
     * 양식파일 다운로드
     * @param
     * @return
     */
   vm.downloadFile = function (type) {
     var fName = "";
     switch(type){
       case "AttachFile1" : 
         if(vm.isPesEtcOnly)
         {
           fName = "이랜드복지재단_SOS위고_개인정보동의서.hwpx"; 
         } 
         else {
           if(vm.tenantType == 'TAKETENANT') {
             fName = "이랜드복지재단_SOS위고_공통필수서류(기관용).hwpx"; 
           }
           else {
             fName = "이랜드복지재단_SOS위고_신청서(봉사단용).hwpx"; 
           }
         }
         break;
         
       case "AttachFile5" : 
         fName = "이랜드복지재단_SOS위고_신청서(기관용).hwp"; 
         break;
         
      case "AttachFile6" : 
        fName = "물품지원양식.hwp"; 
        break;
     }
     window.location.href = "/assets/download/" + fName;
   };

   // 목록 이동
   function goList() {
     var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
     var type = $stateParams.type;
     var status = $stateParams.status; // 상태값
     if (!isNullOrEmpty(type)) {
       if (!isNullOrEmpty(status)) {
         LIST_PAGE_URL = LIST_PAGE_URL + '-' + type + '-' + status;
       } else {
         LIST_PAGE_URL = LIST_PAGE_URL + '-' + type;
       }
     }
     $state.go(LIST_PAGE_URL, { srch: srch, type : type, status : status});
   }

   // 퀵메뉴 버튼 이동
   function scrollMove(id) {
     document.getElementById(id).scrollIntoView({ block: 'start', behavior: 'smooth' });
   }

   // Tip 클릭
   vm.tips = ['0', '0', '0'];
    function clickTip(index) {
      vm.tips[index] = (vm.tips[index] === '0') ? '1' : '0';
    }

   function chgAge() {
     if (vm.data.Jumin1.length === 6 && vm.data.Jumin2.length === 7) {
       var y = parseInt(vm.data.Jumin1.substring(0, 2));
       var m = vm.data.Jumin1.substring(2, 4);
       var d = vm.data.Jumin1.substring(4, 6);
       var x = parseInt(vm.data.Jumin2.substring(0, 1)); 
       var yyyy = x < 3 ? 1900 + y : 2000 + y;

       var BirthDay = moment(yyyy+'-'+m+'-'+d).format('YYYY-MM-DD');
       var toDay = new Date();
       var age = toDay.getFullYear() - Number(BirthDay.slice(0, 4));
       var mon = toDay.getMonth() - Number(BirthDay.slice(5, 7));
       if (mon < 0 || (mon == 0 && toDay.getDate() < Number(BirthDay.slice(8, 10)))) {
         age = age - 1;
       }
       vm.data.Age = age;
     }
   }    

   // 부채
   vm.chgLiabType = function(type){
     switch(type) {
       case 0 :
         vm.data.LiabType1 = null;
         vm.data.LiabAmt1 = null;
         vm.data.LiabType2 = null;
         vm.data.LiabAmt2 = null;
         vm.data.LiabType3 = null;
         vm.data.LiabAmt3 = null;
         vm.data.LiabType4 = null;
         vm.data.LiabType4Cn = null;
         vm.data.LiabAmt4 = null;
         vm.data.LiabCn = null;
         break;

       case 1 : if(vm.data.LiabType1 == '0') vm.data.LiabAmt1 = null; break;
       case 2 : if(vm.data.LiabType2 == '0') vm.data.LiabAmt2 = null; break;
       case 3 : if(vm.data.LiabType3 == '0') vm.data.LiabAmt3 = null; break;
       case 4 : if(vm.data.LiabType4 == '0') vm.data.LiabAmt4 = null; break;
     }
   };  

   /**
    * 기타지출 목록 조회
    * @param
    * @return
    */
    function getEtcCostList() {
     var data = { keyId: vm.keyId, mapCode: ETCCOST_LIST_SQL };

     postApi.select(data, function (result) {
       if (result.header.status == CONSTANT.HttpStatus.OK) {
         if (result.body.docs.length > 0) {
           vm.data.etcCostList = result.body.docs;
         } else {
           vm.data.etcCostList = [];
         }
       }
     }, function (error) {
       console.error("Error> getEtcCostList()");
       console.table(error);
     });
   }

   // 기타지출 추가
   vm.addEtcCost = function () {
     var errMsg = '';
     if (isNullOrEmpty(vm.etcCostData.EtcCost)) {
       errMsg = errMsg + '- 금액을 입력해주세요.<br/>';
     }
     if (isNullOrEmpty(vm.etcCostData.EtcCn)) {
       errMsg = errMsg + '- 세부내용을 입력해주세요.<br/>';
     }
     
     if (!isNullOrEmpty(errMsg)) {
       gAlert('', errMsg);
       return false;
     }
     else {
       vm.data.etcCostList.push(vm.etcCostData);
       vm.etcCostData = {};

       vm.getTotalCost();
     }
   };

   // 기타지출 삭제
   vm.delEtcCost = function (index) {
     vm.data.etcCostList.splice(index, 1);

     vm.getTotalCost();
   };

   // 현장실사 날짜 체크
   vm.chkSiteVeriftDate = function (num, pickDt){
     var today = moment(new Date()).format('YYYY-MM-DD');
     var limitDt = moment(new Date()).add(3, 'day').format('YYYY-MM-DD');
     var denyDt = moment(new Date()).add(10, 'day').format('YYYY-MM-DD');
     var pickDt = moment(new Date(pickDt)).format('YYYY-MM-DD');
     var week = moment(new Date(pickDt)).day();
     var msg = "";

     if(pickDt < today || pickDt > denyDt || week == 0 || week == 6) {
       msg = "신청일은 오늘로부터 10일 이내, 평일만 선택할 수 있습니다.";
     }

     if(msg != ""){
       alert(msg);
       setSiteVeriftDate(num, "");
     } 
     else {
       if(pickDt >= limitDt){
         gConfirm('', '이후 날짜를 선택할 경우 결과 발표가 예정보다 늦어질 수 있습니다. 선택하시겠습니까?', {
           btn : '',
           fn : function() {
             setSiteVeriftDate(num, pickDt);
           }
         }, {
           btn : '',
           fn : function() {
             setSiteVeriftDate(num, "");
           }
         });
       } else {
         setSiteVeriftDate(num, pickDt);
       }
     }
   };

   // 현장실사 날짜 설정
   function setSiteVeriftDate(num, pickDt){
     switch(num){
       case 1 : 
         vm.data.SiteVeriftDate1 = pickDt; 
         break;
       case 2 : 
         vm.data.SiteVeriftDate2 = pickDt; 
         break;
     }
   }

   // 첨부파일 잠금/해제
   vm.setFileLock = function(target, lockYN){    
     if(isNullOrEmpty(vm.keyId) || vm.data.RegUserYN == "Y" || vm.isAdminS)
     {
       if( ! isNullOrEmpty(vm.keyId)){
         angular.forEach(vm.data.uploadFileList, function (item) {
           if (vm.attach[target].fileKey != undefined && item.PhysicalFileNm == vm.attach[target].fileKey) {
             item.delState = 'update';
             item.fileKey = vm.attach[target].fileKey;
             item.id = item.fileId;
             item.fileLock = lockYN;
           }
         });
       }
       vm.attach[target].fileLock = lockYN;
     }
     else {
       alert("잠금/해제 권한이 없습니다.");
     }
   };

   // 자가진단 메시지
   vm.doSelfChk = function(doChk){
    if( ! doChk){
      if(vm.selfChkResult){
        alert("신청 기준을 충족 하였습니다.\n신청을 진행해 주세요.");
      } else {
        alert("SOS위고 지원 기준에 미충족 하였습니다.\n항목을 보완하여 재진단하시거나, 지역 내 복지기관 및 공적 지원 제도를 통해 도움 받으시길 권해드립니다.");
      }   
    } else {
      popSelfChk();
    }
   }

   // 자가진단표 팝업
   function popSelfChk() {
    var ctrl = 'SelfChkModalCtrl as modalCtrl';
    var paramData = {selfData: vm.selfData, key: vm.data.keyId, selfChkId: vm.data.SelfChkId};
    var modalInstance = modalFactory.open('lg', 'app/eland-request/modal/self-chk-modal.html', ctrl, paramData);
    modalInstance.result.then(function (okData) {
      vm.selfChk = true;
      vm.selfChkResult = okData.selfChkResult;
      vm.selfData = okData.selfData;
      vm.selfDataResult = okData.selfDataResult;
      vm.doSelfChk(false);
    }, function (cancelData) {
    });
   }

   
vm.getAiData = function(file_base64) {
  return new Promise(function(resolve, reject) {
    var data = {
      file_base64: file_base64,
      file_type: "application/pdf",
      query: "",
      req_num: vm.keyId,
    };
    vm.ailoader1 = true;        

    postApi.getAiData(data, "selfchk")
    .then(function(response) {
      vm.ailoader1 = false;
      if (response.header.status === CONSTANT.HttpStatus.OK) {

        var responseText = response.body.docs[0].answer || '오류';
        var data = JSON.parse(responseText.replace(/```json|```/g, '').trim());

        angular.forEach(vm.selfDataQna, function (qst, key) {
          qst.question = data[key].question;
          qst.answer = "";
        });
        
        $("#pn5").attr("tabindex", -1).focus();
        
        resolve("ok"); // 성공 시 resolve
      } else {
        reject(response.body.docs[0].errMessage); // 실패 시 reject
      }
    })
    .catch(function(error) {
      vm.ailoader1 = false;
      var errorMessage = (error.data && error.data.detail) ? error.data.detail : '오류';
      reject(errorMessage); // 실패 시 reject
    });
  });
}

   

   // 함수 선언
   vm.getData = getData;                    // 데이터 조회
   vm.saveData = saveData;                  // 데이터 저장
   vm.goList = goList;                      // 목록 이동
   vm.addFrm = addFrm;                      // 가족사항 추가
   vm.delFrm = delFrm;                      // 가족사항 삭제
   vm.srchZipCodeModal = srchZipCodeModal;  // 주소 팝업
   vm.addTenantSptList = addTenantSptList;  // 타기관지원연계 추가
   vm.delTenantSptList = delTenantSptList;  // 타기관지원연계 삭제
   vm.chgSupport = chgSupport;              // 지원요청영역 선택 시, disabled 변경
   vm.saveTempData = saveTempData;          // 임시저장
   vm.getTotalSptSum = getTotalSptSum;      // 총 합계금액 계산
   vm.getTotalInc = getTotalInc;            // 수입 합계 계산
   vm.getTotalCost = getTotalCost;          // 지출 합계 계산
   vm.chgHouseType = chgHouseType;          // 재산현황 - 주거 변경 시, disabled 변경
   vm.addFinan = addFinan;                  // 금융자산 추가
   vm.delFinan = delFinan;                  // 금융자산 삭제
   vm.chgWorkStat = chgWorkStat;            // 근로 상태 - 근로기간 Disabled 설정
   vm.chgTenantSpt = chgTenantSpt;          // 긴급복지/민간지원 이용여부 클릭 시, 데이터 초기화
   vm.chgCarYN = chgCarYN;                  // 차량 소유 여부 클릭 시, 데이터 초기화
   vm.chgFundYN = chgFundYN;                // 모금연계/사진사용 가능 여부 클릭 시, 데이터 초기화
   vm.scrollMove = scrollMove;              // 퀵메뉴 버튼 이동
   vm.clickTip = clickTip;                  // Tip 클릭 이벤트
   vm.chgAge = chgAge;                      // 만 나이 계산
   vm.autoSetListData = autoSetListData;  // 추가 버튼 대상일 경우 1행 입력 상태면 자동 추가 처리

   // 데이터 조회
   getData();

   if(isNullOrEmpty(vm.keyId)) {
    vm.doSelfChk(true);
   }

 }
]);

/**
 * @ngdoc function
 * @name app.request:request-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("TakeEvalDetailCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout', '$sce',
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} gAlert - Alert Module
   */
  function TakeEvalDetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, postApi, customFieldApi, $rootScope, $timeout, $sce) {
    // View Model
    var LIST_PAGE_URL = 'app.eland-request.take-list';      // 목록 화면

    // SQL Mapper Id 정의
    var VIEW_SQL = 'Take.getTakeEvalDetail';                    // 기본정보 조회 SQL

    var vm = this;

    vm.dataloader = false;
    vm.ailoader1 = false;
    vm.aiView = {
      AiOverall: '',
    }    

    vm.srch = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.tenantType = $window.sessionStorage['loginTenantType']; 
    vm.srchDetail = {};
    vm.columnMap = {};

    // diabled 값 초기화
    vm.disabledHous = true;
    vm.disabledLiving = true;
    vm.disabledEdu = true;
    vm.disabledCure = true;
    vm.disabledHEtc = true;

    if ( !$stateParams.srch ) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }
    if ( !isNullOrEmpty($stateParams.keyId) ) {
      vm.srch.CaseManageId = $stateParams.keyId;
    }
    if ( !isNullOrEmpty($stateParams.EvaluateId) ) {
      vm.srch.EvaluateId = $stateParams.EvaluateId;
    }
    vm.srch.tableNm = 'casemanage_rc';    
    angular.copy(vm.srch, vm.srchDetail);

    vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
    vm.srchDetail.IdName = 'EvaluateId'; // For CustomColumn and FileAttachment
    vm.srchDetail.selectType = "Edit"; // For CustomColumn and FileAttachment

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 조회 데이터
    vm.data = {
      tableNm :  vm.srch.tableNm,
      EvaluateId : vm.srch.EvaluateId,
      CaseManageId : vm.srch.CaseManageId
    };
    
    // 평가하기 가능 사용자
    //vm.isAdminEval = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || (!isNullOrEmpty($window.sessionStorage['loginUserEvalAdminYN']) && $window.sessionStorage['loginUserEvalAdminYN'] == "Y")); 
    vm.isAdminEval = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "H"); 
        
    //#region getData() 데이터 조회
    /**
     * 데이터 조회
     * @param
     * @return
     */
     function getData() {
      vm.dataloader = true;
      vm.srchDetail.keyId = $stateParams.keyId;
      vm.srchDetail.mapCode = VIEW_SQL;
      postApi.select(vm.srchDetail, function(result) {
          if ( result.header.status === CONSTANT.HttpStatus.OK ) {
            if ( result.body.desc.length > 0 ) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if ( result.body.docs.length > 0 ) {
              vm.data = result.body.docs[0];              
              vm.data.ReqDate = moment(vm.data.ReqDate).format('YYYY-MM-DD');

              vm.aiView.AiOverall = vm.getAiHtml(vm.data.AiOverall);
              if(vm.data.AiNewYN == "Y"){
                getAiData()
                .then(function() {
                })
                .catch(function(error) {                                
                  gAlert('', 'AI 분석 중 오류가 발생했습니다.');
                  console.error("에러 발생:", error);
                });
              }
            }
          }

          vm.dataloader = false;
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    //#region goList() 목록 이동
    // 목록 이동
    function goList() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      var type = $stateParams.type;
      var status = $stateParams.status;

      if (!isNullOrEmpty(type)) {
        if (!isNullOrEmpty(status)) {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type + '-' + status;
        } else {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type;
        }
      }
      $state.go(LIST_PAGE_URL, { srch: srch, type : type, status : status});
    }
    //#endregion

    // Tip 클릭                                     
    vm.tips = ['0','0'];
    vm.clickTip = function(index) {
      vm.tips[index] = (vm.tips[index] === '0') ? '1' : '0';
    };

    vm.aiOverallEdit = false,
    vm.toggleAiEdit = function(tgt){
      vm.aiOverallEdit = ! vm.aiOverallEdit;
    }

    // ai 자동 심사 결과
    vm.saveAiData = function(isAi){      
      var data = {
        EvaluateId : vm.data.EvaluateId,
        AiOverall : vm.data.AiOverall,
        AiOverallSc : vm.data.AiOverallSc,
      }
      
      if (isNullOrEmpty(data.AiOverall)) {
        gAlert('', '저장할 내용이 없습니다');
        return false;
      }

      var mapCode = 'Take.updateAiOverallData';

      postApi.sendPostApi('update', mapCode, data, function (result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          var msg = "";
          if(isAi){
            vm.aiView.AiOverall = vm.getAiHtml(vm.data.AiOverall);
            vm.aiOverallEdit = false;
          } else {
            gAlert('', '저장되었습니다.', {
              btn : '',
              fn : function() {
                vm.aiView.AiOverall = vm.getAiHtml(vm.data.AiOverall);
                vm.aiOverallEdit = false;
              }
            });
          }
        }
      },function (error) {
        console.table(error);
      });
    };

    function getAiData() {
      return new Promise(function(resolve, reject) {
        var data = {      
          query: "",
          req_num: vm.data.keyId,
        };
        vm.ailoader1 = true;

        postApi.getAiData(data, "overall")
        .then(function(response) {
          vm.ailoader1 = false;
          if (response.header.status === CONSTANT.HttpStatus.OK) {
            var responseText = response.body.docs[0].answer || '오류';

            responseText = responseText.replace(/✅/g, "<br>✅");
            responseText = responseText.replace(/📌/g, "<br>📌");

            scTxt = responseText.match(/AI 권고 종합 평가 점수:\s*(\d+)점/);
            vm.data.AiOverallSc = scTxt? scTxt[1] : "";
            
            vm.data.AiOverall = responseText; 
            vm.aiView.AiOverall = vm.getAiHtml(responseText);
            vm.saveAiData(true);

            resolve("ok"); // 성공 시 resolve
          } else {
            reject(response.body.docs[0].errMessage); // 실패 시 reject
          }
        })
        .catch(function(error) {
          vm.ailoader1 = false;
          var errorMessage = (error.data && error.data.detail) ? error.data.detail : '오류';
          console.error(errorMessage);
          reject(error); // 실패 시 reject
        });
      });
    }

    vm.getAiHtml = function (markdownTxt){
      var rawHtml = marked.parse(markdownTxt || '');
      return $sce.trustAsHtml(rawHtml);
    }
    
    // 함수 선언
    vm.getData = getData;                    // 데이터 조회
    vm.goList = goList;                      // 목록 이동

    // 데이터 조회
    getData();
  }
]);

/**
 * @ngdoc function
 * @name app.request:request-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("TakeEvalditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout',
  /**
   * 사레 결과보고 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} gAlert - Alert Module
   */
  function TakeEvalditCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, postApi, customFieldApi, $rootScope, $timeout) {
    // View Model
    var LIST_PAGE_URL = 'app.eland-request.take-list';             // 목록 화면

    // SQL Mapper Id 정의
    var VIEW_SQL = 'Take.getTakeEvalDetail';         // 기본정보 조회 SQL
    var INSERT_SQL = 'Take.insertTakeEvalDetail';    // 전체 등록 SQL
    var UPDATE_SQL = 'Take.updateTakeEvalDetail';    // 전체 업데이트 SQL

    var vm = this;

    vm.dataloader = false;
    vm.srch = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.tenantType = $window.sessionStorage['loginTenantType']; 
    vm.srchDetail = {};
    vm.columnMap = {};

    // diabled 값 초기화
    vm.disabledHous = true;
    vm.disabledLiving = true;
    vm.disabledEdu = true;
    vm.disabledCure = true;
    vm.disabledHEtc = true;
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    if ( !isNullOrEmpty($stateParams.keyId) ) {
      vm.srch.CaseManageId = $stateParams.keyId;
    }
    if (!isNullOrEmpty($stateParams.EvaluateId)) {
      vm.srch.EvaluateId = $stateParams.EvaluateId;
    }

    vm.srch.tableNm = 'casemanage_rc';    
    angular.copy(vm.srch, vm.srchDetail);

    vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
    vm.srchDetail.IdName = 'EvaluateId'; // For CustomColumn and FileAttachment
    vm.srchDetail.selectType = "Edit"; // For CustomColumn and FileAttachment

    // 업로드 파일 목록
    vm.uploadFileList = [];
    vm.showUploader = false;

    // 조회 데이터
    vm.data = {
      tableNm :  vm.srch.tableNm,
      EvaluateId : vm.srch.EvaluateId,
      CaseManageId : vm.srch.CaseManageId
    };

    // 평가하기 가능 사용자
    //vm.isAdminEval = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || (!isNullOrEmpty($window.sessionStorage['loginUserEvalAdminYN']) && $window.sessionStorage['loginUserEvalAdminYN'] == "Y")); 
    vm.isAdminEval = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "H"); 
    
    //#region getData, getdata 데이터 조회
    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;
      vm.srchDetail.keyId = $stateParams.keyId;
      vm.srchDetail.mapCode = VIEW_SQL;
      postApi.select(vm.srchDetail, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
              vm.data.ReqDate = moment(vm.data.ReqDate).format('YYYY-MM-DD');    
            }
          }

          vm.dataloader = false;
        },
        function(error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }

    //#region setDate 데이터 저장
    /**
     * 데이터 저장
     * @param
     * @return
     */
    function setData() {      
     if (getIsValidData()) {
      var data = angular.copy(vm.data);
      data.AiNewYN = "Y";
      data.tenantType = vm.tenantType;
      data.keyId = $stateParams.keyId; // CaseManageId
      if (isNullOrEmpty(data.EvaluateId)) {
        data.mapCode = INSERT_SQL;
      } else {
        data.mapCode = UPDATE_SQL;
      }

      postApi.insert(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            gAlert('', '저장 되었습니다.', {
              btn : '',
              fn : function() {
                goList();
              }
            });
          }
        }
      });

    }
    }
    //#endregion

    //#region goList 목록이동
    // 목록 이동
    function goList() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      var type = $stateParams.type;
      var status = $stateParams.status; // 상태값
      if (!isNullOrEmpty(type)) {
        if (!isNullOrEmpty(status)) {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type + '-' + status;
        } else {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type;
        }
      }

      $state.go(LIST_PAGE_URL, { srch: srch, type : type, status : status});
    }
    //#endregion

    //#region getIsValidData 유효성 검사
    function getIsValidData() {
      var data = angular.copy(vm.data);
      var errMsg = ''; 

      if (isNullOrEmpty(data.MoniSc1) || isNullOrEmpty(data.MoniSc2) || isNullOrEmpty(data.MoniSc3) || isNullOrEmpty(data.MoniSc4) || isNullOrEmpty(data.MoniSc5)) {
        errMsg = errMsg + '- 지원적합률 평가를 입력하세요. </br>';
      }

      if (isNullOrEmpty(data.TakeTenantSc1) || isNullOrEmpty(data.TakeTenantSc2) || isNullOrEmpty(data.TakeTenantSc3) || isNullOrEmpty(data.TakeTenantSc4)) {
        errMsg = errMsg + '- 사례관리 기관 평가를 입력하세요. </br>';
      }

      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }
 
      return true;
    }
    //#endregion

    // Tip 클릭                                     
    vm.tips = ['0', '0', '0', '0', '0', '0', '0', '0', '0'];
    vm.clickTip = function(index) {
      vm.tips[index] = (vm.tips[index] === '0') ? '1' : '0';
    };

    vm.calc = function(type) {
      if(type == 0 || type == 1){
        var scores_m = [
          vm.data.MoniSc1,
          vm.data.MoniSc2,
          vm.data.MoniSc3,
          vm.data.MoniSc4,
          vm.data.MoniSc5
        ];
        var sum_m = scores_m.reduce(function(a, b) { 
            return a + (Number(b) || 0); 
        }, 0);
        vm.data.MoniSc = (sum_m / scores_m.length).toFixed(1);
        vm.data.MoniResult = (vm.data.MoniSc >= 3.4) ? 'Y' : 'N';
      }

      if(type == 0 || type == 2){
        var scores_t = [
          vm.data.TakeTenantSc1,
          vm.data.TakeTenantSc2,
          vm.data.TakeTenantSc3,
          vm.data.TakeTenantSc4
        ];
        var weights_t = [0.35, 0.20, 0.20, 0.25]; // 가중치

        var sum_t = scores_t.reduce(function(a, b, index) {
            return Number(a) + ((Number(b) || 0) * weights_t[index]);
        }, 0);
        vm.data.TakeTenantSc = (sum_t * 20).toFixed(1); // 100점 환산
        if (vm.data.TakeTenantSc >= 90) {
          vm.data.TakeTenantGrade = 'A';
          vm.data.TakeTenantGradeNm = '우수기관';
        } else if (vm.data.TakeTenantSc >= 80) {
          vm.data.TakeTenantGrade = 'B';
          vm.data.TakeTenantGradeNm = '협력우수기관';
        } else if (vm.data.TakeTenantSc >= 70) {
          vm.data.TakeTenantGrade = 'C';
          vm.data.TakeTenantGradeNm = '일반기관';
        } else {
          vm.data.TakeTenantGrade = 'D';
          vm.data.TakeTenantGradeNm = '관리필요기관';
        }
      }
    };

    // 함수 선언
    vm.getData = getData;                    // 데이터 조회
    vm.setData = setData;                  // 데이터 저장
    vm.goList = goList;                      // 목록 이동
    vm.getIsValidData = getIsValidData;      // 유효성 체크

    // 데이터 조회
    getData();
  }
]);

(function () {
  "use strict";
  webapp.controller('TakeListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function TakeListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'Take.getTakeListCnt';                                           // 목록 건수 조회 SQL
      var LIST_SQL = 'Take.getTakeList';                                                  // 목록 조회 SQL
      var DELETE_LIST_SQL = 'Take.deleteTakeList';                                        // 목록에서 삭제
      var LIST_GIVE_CNT_SQL = 'Take.getGiveTenantTakeListCnt';                            // 후원기관 (관심/지원) 목록 건수 조회 SQL
      var LIST_GIVE_SQL = 'Take.getGiveTenantTakeList';                                   // 후원기관 (관심/지원) 목록 조회 SQL

      
      var EXCEL_SQL = 'Take.getTakeExcelList'; // 엑셀다운로드 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.eland-request.take-list';                                  // 목록 화면      
      var EDIT_PAGE_URL = 'app.eland-request.take-edit';                                  // 등록/수정 화면
      var VIEW_PAGE_URL = 'app.eland-request.take-detail';                                // 상세 화면
      var RESULT_EDIT_PAGE_URL = 'app.eland-request.take-result-edit';                    // 결과보고 등록/수정 화면      
      var RESULT_VIEW_PAGE_URL = 'app.eland-request.take-result-detail';                  // 결과보고 상세 화면
      var EVAL_EDIT_PAGE_URL = 'app.eland-request.take-eval-edit';                        // 평가하기 등록 화면      
      var EVAL_VIEW_PAGE_URL = 'app.eland-request.take-eval-detail';                      // 평가하기 상세 화면
      var BEST_EDIT_PAGE_URL = 'app.eland-request.take-best-edit';                        // 우수사례 등록
      var BEST_VIEW_PAGE_URL = 'app.eland-request.take-best-detail';                      // 우수사례 조회
      
      
      // 관련 테이블 정의
      var KEY_TABLE_NM = 'casemanage';                                                    // 작업 테이블명
      var KEY_COLUMN_NM = 'casemanageId';                                                 // Primary Key Column
      // #endregion 상수 정의

      var vm = this;                                                                      // View Model
      vm.dataloader = false;         
      //console.warn($stateParams.status);                                                    // Progressbar 숨김
      vm.status = $stateParams.status;                                                    // 사례목록 상태값
      vm.tenantType = $window.sessionStorage['loginTenantType'];                          // 회원사 타입
      vm.tenantId = $window.sessionStorage['loginTenantId'];                              // 회원사 ID     
      
      // 상태 및 회원사 타입에 따른 Title 및 작업테이블 변경
      // TAKETENANT : 사례기관 / GIVETENANT : 후원기관
      if (isNullOrEmpty(vm.status)) {
        if (vm.tenantType == 'GIVETENANT') {
          vm.title = '신청목록';
        } else {
          vm.title = '사례목록';
        }
      }
      if (vm.status == 'RG') {
        if (vm.tenantType == 'GIVETENANT') {
          vm.title = '신청목록';
        } else {
          vm.title = '사례목록';
        }
      }
      if (vm.status == 'AT') {
        if (vm.tenantType == 'GIVETENANT') {
          vm.title = '관심사례';
        } else {
          vm.title = '사례목록';
        }
      }
      if (vm.status == 'AG') {
        if (vm.tenantType == 'GIVETENANT') {
          vm.title = '지원목록';
        }
      }
      if(vm.status == 'RW') {
        vm.title = '결과보고';
      }
      if(vm.status == 'RC') {
        if (vm.tenantType != 'TAKETENANT' && vm.tenantType != 'GIVETENANT') {
          vm.title = '평가목록';
        } else {
          vm.title = '사례기관 평가';
        }
      }      
         
      vm.loginUserAdminType = !isNullOrEmpty($window.sessionStorage['loginUserAdminType']) ? $window.sessionStorage['loginUserAdminType'] : ""; // 관리자구분 (봉사자 B)
      vm.isAdminSH = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "H"); // 시스템관리자, 사무국, 현장간사
      //vm.isAdminEval = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || (!isNullOrEmpty($window.sessionStorage['loginUserEvalAdminYN']) && $window.sessionStorage['loginUserEvalAdminYN'] == "Y")); 
      vm.isAdminEval = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "H"); 
    
    
      var arrCityCode = !isNullOrEmpty($window.sessionStorage['loginUserCityCodeList']) && vm.loginUserAdminType == "H" ? $window.sessionStorage['loginUserCityCodeList'].split(',') : []; // 현장간사 지역구분 
      vm.loginUserCityCode = [];   
      vm.loginUserParCityCode = [];   
      angular.forEach(arrCityCode, function (cCode) {
        var tmp = cCode.substring(2,5);
        if(tmp == "000"){
          vm.loginUserParCityCode.push(cCode.substring(0,2)); // 시군구 전체
        } else {          
          vm.loginUserCityCode.push(cCode); // 특정 시군구
        }
      });

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명          
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',         // 정렬컬럼명
          GenType : [],           // 세대구분
          ProtType : [],          // 보호구분
          HealthIndem : [],        // 의료보장 
          ChkStatus : [],   // 진행상태
          pCodeList : [],   // 지역1
          cCodeList : [],   // 지역2
          selCityCodeList : [],
          loginUserAdminType : vm.loginUserAdminType,
          loginUserCityCode : vm.loginUserCityCode,    
          loginUserParCityCode : vm.loginUserParCityCode,
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        !isNullOrEmpty(vm.srch.viewSize) ? CONSTANT.PAGINATION.VIEWSIZE : 10; // 페이지당 조회건수
        vm.ReqDateFrom = $rootScope.getDateFormat(vm.srch.ReqDateFrom); // 신청시작일 초기화
        vm.ReqDateTo = $rootScope.getDateFormat(vm.srch.ReqDateTo);     // 신청종료일 초기화
        vm.currentPage = vm.srch.page;
      }

      vm.srchStatus = [];       // 목록 검색 시, 상태값 Array
      
      if (!isNullOrEmpty(vm.status)) {
        vm.srchStatus.push(vm.status);
      }
      if (vm.status == 'RG') {
        vm.srchStatus.push('AT');
        vm.srchStatus.push('AG');
        vm.srchStatus.push('SP');
      }
      // 후원기관 - 위기가정 지원목록 (논의중,지원확정)
      if (vm.status == 'AG') {
        vm.srchStatus.push('SP');     
      }
      // 후원기관 - 위기가정 결과보고 (결과보고대기,결과보고완료)
      if (vm.status == 'RW') {
        vm.srchStatus.push('RC');
        vm.srchStatus.push('SP');
        vm.srchStatus.push('MC');
      }
      // 평가목록
      if (vm.status == 'RC') {
        vm.srchStatus.push('RC');
        vm.srchStatus.push('MC');
      }

      vm.srch.Status = vm.status;
      vm.srch.srchStatus = vm.srchStatus;
      
      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = 'N'//$rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수


      // 각 페이지별 항목 보이기/숨기기
      vm.v01 = true; //최종제출일
      vm.v02 = ([null,'','RG','RC'].includes(vm.status)); //지역
      vm.v03 = (vm.tenantType != 'TAKETENANT'); //사례기관
      vm.v04 = (!['RC'].includes(vm.status) && vm.tenantId == 0); //현장확인
      vm.v05 = true; //대상자명
      vm.v06 = true; //제목
      vm.v07 = (vm.tenantType == 'TAKETENANT'); //생년월일
      vm.v08 = (vm.tenantType != 'TAKETENANT'); //지원요청영역
      vm.v09 = (!['RC'].includes(vm.status) && vm.tenantType != 'TAKETENANT'); //관심기관수
      vm.v10 = (vm.tenantId == 0); //지원확정일자
      vm.v11 = (vm.tenantType != 'GIVETENANT'); //후원기관
      vm.v12 = (!['AT', 'AG'].includes(vm.status)); //진행상태
      vm.v13 = (['AT','AG'].includes(vm.status) && vm.tenantType == 'GIVETENANT'); //나의진행상태
      vm.v14 = (['RC','RW'].includes(vm.status) && vm.tenantId == 0); //결과보고완료일
      vm.v15 = (['RW','SP'].includes(vm.status));  //결과보고 && (vc.tenantId != 0 || (li.RegUserYN == 'Y' && vc.loginUserAdminType == 'B'))
      vm.v16 = (['RC'].includes(vm.status) && vm.tenantId == 0); //모니터링
      vm.v17 = (['RW','RC'].includes(vm.status) && vm.isAdminSH) //모니터링 평가
      vm.v18 = (['RC'].includes(vm.status) && vm.isAdminSH); //우수사례
      
      /**
       * 데이터 조회
       * @param
       * @return
       * @author 이기훈
       */
      function getSearch() {
        if (!isNullOrEmpty(vm.srch.StatusVal)) {
          vm.srch.srchStatus = [vm.srch.StatusVal];
        }        

        // 검색 지역 등록
        if(vm.srch.selCityCodeList.length > 0){
          var pCodeList = [];
          var cCodeList = [];
          angular.forEach(vm.srch.selCityCodeList, function(c) {
            if(c.cCode.substring(2,5) == "000") {
              pCodeList.push(c.pCode);
            } else {
              cCodeList.push(c.cCode);
            }
          });
          vm.srch.pCodeList = pCodeList;
          vm.srch.cCodeList = cCodeList;
        }

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
      }      

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        var srch = '';
        var type = $stateParams.type;
        var status = $stateParams.status;

        if (!isNullOrEmpty(type)) {
          if (!isNullOrEmpty(status)) {
            LIST_PAGE_URL = LIST_PAGE_URL + '-' + type + '-' + status;
          } else {
            LIST_PAGE_URL = LIST_PAGE_URL + '-' + type;
          }
        }
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch, type:type, status: status}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {
        var data = angular.copy(vm.srch);
        data.mapCode = LIST_CNT_SQL;

        postApi.select(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch);
        data.tType = vm.tenantType;
        data.mapCode = LIST_SQL;
        data.selectType = 'List';   // 작업 테이블 타입
        //console.log(data);

        postApi.select(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });

              chgParCityCode(vm.srch.ParCityCode);
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.lists = result.body.docs;
              angular.forEach(vm.lists, function(item) {
                var ApplyDateList = [];
                item.ApplyDateList = [];
                item.GiveTenantList = [];

                if (!isNullOrEmpty(item.GiveTenantNm)) {
                  if (item.GiveTenantNm.indexOf(',') > 0) {
                    item.GiveTenantList = item.GiveTenantNm.split(',');
                  } else {
                    item.GiveTenantList.push(item.GiveTenantNm);
                  }
                }
                if (!isNullOrEmpty(item.ApplyDate)) {
                  if (item.ApplyDate.indexOf(',') > 0) {
                    ApplyDateList = item.ApplyDate.split(',');
                  } else {
                    ApplyDateList.push(item.ApplyDate);
                  }
                  angular.forEach(ApplyDateList, function(sub, index) {
                    var ApplyDate = {ApplyDate : moment(sub).format('YYYY-MM-DD')};
                    item.ApplyDateList.push(ApplyDate);
                  });
                }
              });
            } else {
              // 조회 실패
              vm.lists = [];
            }
            
          }
          vm.dataloader = false; // Progressbar 숨김
          
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
          vm.SearchConditionStrPlain = vm.SearchConditionStr.replace(/<[^>]+>/g, '');
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
        
        setResponsive();
        
        vm.dataloader = false;
      }

       /**
       * 후원기관 (관심/지원)목록 건수 조회
       *
       * @param
       * @return
       */
        function getGiveTenantListCnt() {
          var data = angular.copy(vm.srch);
          data.mapCode = LIST_GIVE_CNT_SQL;
  
          postApi.select(data, function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                // 총 목록 건수 설정
                vm.totalItems = result.body.docs;
              } else {
                // 조회 실패
                vm.totalItems = 0;
              }
            }
          }, function (error) {
            // 조회 중 오류 발생
            console.error("Error> getGiveTenantListCnt()");
            console.table(error);
          });
        }
  
        /**
         * 후원기관 (관심/지원)목록 조회
         *
         * @param
         * @return
         */
        function getGiveTenantList() {
          vm.dataloader = true; // Progressbar 표시
          vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정
          getGiveTenantListCnt(); // 후원기관 (관심/지원)목록 건수 조회
  
          var data = angular.copy(vm.srch);
          data.mapCode = LIST_GIVE_SQL;
          data.selectType = 'List';   // 작업 테이블 타입
          //console.log(data);
  
          postApi.select(data, function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              // MetaColumn 사용
              if (result.body.desc.length > 0) {
                // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
                vm.listColumns = result.body.desc;
                angular.forEach(vm.listColumns, function (item) {
                  vm.columnMap[item.ColumnPhysicalNm] = item;
                });
              } else {
                console.error('Error> getGiveTenantList()> MetaColumn 정보 조회 오류');
                console.table(data);
              }
  
              if (result.body.docs.length > 0) {
                // 총 목록 건수 설정
                vm.lists = result.body.docs;
                angular.forEach(vm.lists, function(item) {
                  var ApplyDateList = [];
                  item.ApplyDateList = [];
                  item.GiveTenantList = [];
  
                  if (!isNullOrEmpty(item.GiveTenantNm)) {
                    if (item.GiveTenantNm.indexOf(',') > 0) {
                      item.GiveTenantList = item.GiveTenantNm.split(',');
                    } else {
                      item.GiveTenantList.push(item.GiveTenantNm);
                    }
                  }
                  if (!isNullOrEmpty(item.ApplyDate)) {
                    if (item.ApplyDate.indexOf(',') > 0) {
                      ApplyDateList = item.ApplyDate.split(',');
                    } else {
                      ApplyDateList.push(item.ApplyDate);
                    }
                    angular.forEach(ApplyDateList, function(sub, index) {
                      var ApplyDate = {ApplyDate : moment(sub).format('YYYY-MM-DD')};
                      item.ApplyDateList.push(ApplyDate);
                    });
                  }
                  if (item.SupportReq.length > 0) {
                    item.SupportReq = item.SupportReq.substring(0, item.SupportReq.length - 1);
                  } 
                });
              } else {
                // 조회 실패
                vm.lists = [];
              }
              
            }
            vm.dataloader = false; // Progressbar 숨김
            
            vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
            vm.SearchConditionStrPlain = vm.SearchConditionStr.replace(/<[^>]+>/g, '');
          }, function (error) {
            // 조회 중 오류 발생
            console.error("Error> getList()");
            console.table(error);
          });
          
          setResponsive();
          
          vm.dataloader = false;
        }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        var type = $stateParams.type;
        var status = $stateParams.status;

        if (!isNullOrEmpty(type)) {
          if (!isNullOrEmpty(status)) {
            LIST_PAGE_URL = LIST_PAGE_URL + '-' + type + '-' + status;
          } else {
            LIST_PAGE_URL = LIST_PAGE_URL + '-' + type;
          }
        }
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch, type:type, status: status}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      function goDetail(keyId, page) {
        var srch = (isNullOrEmpty($stateParams.srch) ? encodeURIComponent(JSON.stringify(vm.srch, replacer)) : $stateParams.srch);                               // 검색 옵션
        var type = $stateParams.type;                               // 테넌트 타입
        var status = $stateParams.status;                           // 상태값
        vm.keyId = keyId;
        $state.go(page, {
          srch: srch,
          type: type,
          status : status,
          keyId: vm.keyId
        });
      }
      vm.goTakeDetail = function(keyId) {
        goDetail(keyId, VIEW_PAGE_URL);
      }
      vm.goResultDetail = function(keyId) {
        goDetail(keyId, RESULT_VIEW_PAGE_URL);
      }
      vm.goEvalDetail = function(keyId) {
        goDetail(keyId, EVAL_VIEW_PAGE_URL);
      }
      vm.goBestDetail = function(keyId) {
        goDetail(keyId, BEST_VIEW_PAGE_URL);
      };
      

      function goAdd(keyId, page) {
        var srch = (isNullOrEmpty($stateParams.srch) ? encodeURIComponent(JSON.stringify(vm.srch, replacer)) : $stateParams.srch);   
        var type = $stateParams.type; // 검색 옵션
        var status = $stateParams.status; // 상태값
        vm.keyId = keyId;
        $state.go(page, {
          srch: srch,
          type: type,
          status: status,
          keyId: vm.keyId
        });
      }
      vm.goTakeAdd = function() {
        if(vm.rptChk && vm.tenantType == 'TAKETENANT'){
          gAlert('', '결과보고 미작성 1개월 경과 사례가 있습니다.');
          goAdd('', EDIT_PAGE_URL);
        } else {
          goAdd('', EDIT_PAGE_URL);
        }        
      }
      vm.goResultAdd = function(keyId) {
        goAdd(keyId, RESULT_EDIT_PAGE_URL);
      }
      vm.goEvalAdd = function(keyId) {
        goAdd(keyId, EVAL_EDIT_PAGE_URL);
      }
      vm.goBestAdd = function(keyId) {
        goAdd(keyId, BEST_EDIT_PAGE_URL);
      }; 

      

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].keyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0) {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        for (var i = 0; i < vm.lists.length; i++) {
          //console.log(vm.lists[i].Status);
          if (vm.lists[i].chkRow) {
            if (!isNullOrEmpty(vm.lists[i].Status) && vm.lists[i].Status != 'RG') {
              gAlert('', '진행상태가 작성중 또는 등록인 목록만 삭제 가능합니다.');
              return false;
            }
          }
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 검색 지역 시도 변경 시 시군구 목록 조회
      function chgParCityCode(p) {
        if( ! isNullOrEmpty(p)){
          vm.CityCodeList = vm.columnMap['CityCode'].CodeList.filter(function(e){
            return e.Code.substring(0,2) == p;
          });
        }
      };

      // 검색 지역 추가
      vm.selCityCode = function(c){  
        var p = ""; 
        if(isNullOrEmpty(c)){
          p = vm.srch.ParCityCode;
          c = p + "000";
          vm.srch.CityCode = c;
        } else {
          p = c.substring(0,2); 
        }         
        vm.chgParCityCode(p); 
        var pData = vm.columnMap['ParCityCode'].CodeList.filter(function(e){ return e.Code == p; })[0];
        var cData = vm.CityCodeList.filter(function(e){ return e.Code == c; })[0];
        vm.srch.selCityCodeList.push({pCode : pData.Code, pName : pData.CodeValue, cCode : cData.Code, cName : cData.CodeValue});
        vm.srch.ParCityCode = "";
        vm.srch.CityCode = "";
      }

      // 검색 지역 삭제
      vm.delCityCode = function(index) {
        vm.srch.selCityCodeList.splice(index, 1);
      } 
    
      // 출력
      vm.printTake = function() {        
        var kId = "";
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            kId = vm.lists[i].keyId;            
            var URL = location.origin + '/#/print-take?keyId=' + kId;
            window.open(URL, 'print-take'+i , 'width=1030px,height=800px,scrollbars=yes');
          }
        }
        if (kId == "") {
          gAlert('', '출력할 항목을 선택해주세요.');
          return false;
        }
      }
      /**
     * 엑셀파일 다운로드
     * @param
     * @return
     */
      function getExcel() {

        if (vm.lists.length == undefined || vm.lists.length == 0) {
          gAlert("", "데이터가 없습니다.");
          return;
        }

        // 체크한 대상만 엑셀로 다운로드
        vm.srch.KeyIdList = [];
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].keyId);
          }
        }

        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        var excelColMap = [
          {colNm:"ReqDate", xlsNm:"접수일"},
          {colNm:"ApplyCmpDate", xlsNm:"선정일"},
          {colNm:"CityName", xlsNm:"지역"},
          {colNm:"TargetNm", xlsNm:"대상자명"},
          {colNm:"TakeTenantNm", xlsNm:"기관명"},
          {colNm:"GenTypeNm", xlsNm:"세대유형"},
          {colNm:"ProtTypeNm", xlsNm:"보호구분"},
          {colNm:"FinalLivingAmt", xlsNm:"생계비", mg:1},
          {colNm:"FinalHousSptAmt", xlsNm:"주거비", mg:2},
          {colNm:"FinalCureSptAmt", xlsNm:"치료비", mg:2},
          {colNm:"FinalEduSptAmt", xlsNm:"자립비", mg:2},
          {colNm:"FinalVouSptAmt", xlsNm:"물품지원", mg:2},
          {colNm:"FinalEtcSptAmt", xlsNm:"기타", mg:2},
          {colNm:"FinalSptSum", xlsNm:"지원금액"},
          {colNm:"FinalTenantNm", xlsNm:"후원기관"},
          {colNm:"FinalTenantNm", xlsNm:"지원기관명"},
          {colNm:"ExtnalSupport", xlsNm:"외부자원연계"},
          {colNm:"ExtnalTotalAmt", xlsNm:"외부자원총지원금"},
          {colNm:"Mobile", xlsNm:"연락처"},
          {colNm:"Addr", xlsNm:"주소"},
          {colNm:"ContactNm", xlsNm:"담당자명"},
          {colNm:"ContactMobile", xlsNm:"담당연락처"},
          {colNm:"ContactEmail", xlsNm:"담당이메일"},
          {colNm:"StatusNm", xlsNm:"진행상태"},
          {colNm:"JuminNo", xlsNm:"주민등록번호"},
          {colNm:"SiteVeriftUserTxt", xlsNm:"현장실사담당자"},
          {colNm:"SiteVeriftDT", xlsNm:"현장실사일시"},
        ];

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = "사례목록";
            $scope.exportData = [];

            var headerRow1 = [];
            var headerRow2 = [];

            angular.forEach(excelColMap, function (item) {
              if (item.mg == 1) {
                headerRow1.push("지원영역");
                headerRow2.push(item.xlsNm);
              }else if (item.mg == 2){
                headerRow1.push("cspan_lf");
                headerRow2.push(item.xlsNm);
              }else {
                headerRow1.push(item.xlsNm);
                headerRow2.push("rspan_up");
              }
            });
            $scope.exportData.push(headerRow1);
            $scope.exportData.push(headerRow2);

            // Data:
            angular.forEach($scope.jsonToExport, function (value) {
              var obj = [];
              angular.forEach(excelColMap, function (item) {
                if (item.colNm == 'ReqDate' || item.colNm == 'ApplyCmpDate') {
                  obj.push(moment(value[item.colNm]).toDate());
                } else {
                  obj.push(value[item.colNm]);
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData, $scope.fileName, null, 2);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcel()");
          console.table(error);
        });
      }


      // 1개월 경과 결과보고 미작성 건수 조회
      function chkReportCnt() {
        var data = angular.copy(vm.srch);
        data.mapCode = "Take.getReportChkCnt";
        postApi.select(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.rptChk = result.body.docs > 0;
            } else {
              vm.rptChk = false;
            }
          }
        }, function (error) {
          console.error("Error> chkReportCnt()");
          console.table(error);
        });
      }


      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.setDelList = setDelList;                 // 목록 삭제

      vm.chgParCityCode = chgParCityCode;      
      vm.getExcel = getExcel;

      if (vm.tenantType == 'GIVETENANT' && (vm.status == 'AT' || vm.status == 'AG')) {
        getGiveTenantList();
      } else {
        // 목록 조회
        getList();
      }

      // 1개월 경과 결과보고 미작성 건수 조회
      chkReportCnt();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

/**
 * @ngdoc function
 * @name app.request:request-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("TakeResultDetailCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout', 'gConfirm', 'modalFactory', 'TakeService', 
  /**
   * 게시판 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} gAlert - Alert Module
   */
  function TakeResultDetailCtrl($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, 
    postApi, customFieldApi, $rootScope, $timeout, gConfirm, modalFactory, TakeService) {
    // View Model
    var LIST_PAGE_URL = 'app.eland-request.take-list';                      // 목록 화면
    var EDIT_PAGE_URL = 'app.eland-request.take-result-edit';                                  // 등록/수정 화면
    var LIST_EDIT_PAGE_URL = 'app.eland-request.take-list-take.result-edit';                   // 등록/수정 분할 화면

    // SQL Mapper Id 정의
    var VIEW_SQL = 'Take.getTakeResultDetail';                              // 상세 조회 SQL
    var INSERT_COMMENT_SQL = 'Take.insertResultReportComment';              // 댓글 저장 SQL
    var COMMNET_LIST_SQL = 'Take.getResultReportCommentList';               // 댓글 목록 조회 SQL
    var UPDATE_COMMENT_SQL = 'Take.updateResultReportComment';              // 댓글 수정 SQL
    var DELETE_COMMENT_SQL = 'Take.deleteResultReportComment';              // 댓글 삭제 SQL
    var COMMNET_ADMIN_LIST_SQL = 'Take.getResultReportCommAdminList';                                   // 댓글관리자 목록 조회 SQL
    var UPDATE_STATUS_RETURN_SQL = 'Take.updateResultReportStatus';    //  반려 SQL
    var vm = this;

    vm.dataloader = false;
    vm.srch = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.tenantId = $window.sessionStorage['loginTenantId'];                  // 회원사 ID
    vm.srchDetail = {};
    vm.columnMap = {};
    vm.vaultTarget = null;                                                  // 대상자 첨부파일 컴포넌트
    vm.vaultAccounting = null;                                              // 회계 첨부파일 컴포넌트

    // diabled 값 초기화
    vm.disabledHous = true;
    vm.disabledLiving = true;
    vm.disabledEdu = true;
    vm.disabledCure = true;
    vm.disabledHEtc = true;

    vm.comment = {};
    vm.commAdminData = {list:[]}; // 비밀댓글관리자
    
    vm.photoList = [];
    for(var i = 1; i <= 5; i++){
      vm.photoList.push({no:i, id:"Photo"+i, f:""});
    }
    vm.reviewList = [];
    for(var i = 1; i <= 5; i++){
      vm.reviewList.push({no:i, id:"Review"+i, f:""});
    }
    vm.accountList = [];
    for(var i = 1; i <= 5; i++){
      vm.accountList.push({no:i, id:"Account"+i, f:""});
    }
    vm.etcFileList = [];
    for(var i = 1; i <= 5; i++){
      vm.etcFileList.push({no:i, id:"EtcFile"+i, f:""});
    }

    vm.timeList = angular.copy(TakeService.timeList);

    // 업로드 파일 목록
    vm.attach = angular.copy(TakeService.rptAttach);

    if ( !$stateParams.srch ) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    if ( !isNullOrEmpty($stateParams.keyId) ) {
      vm.srch.CaseManageId = $stateParams.keyId;
    }

    if ( !isNullOrEmpty($stateParams.ResultReportId) ) {
      vm.srch.ResultReportId = $stateParams.ResultReportId;
    }


    vm.srch.tableNm = 'resultreport';    
    angular.copy(vm.srch, vm.srchDetail);

    vm.srchDetail.IdName = 'ResultReportId'; // For CustomColumn and FileAttachment
    vm.srchDetail.selectType = "Edit"; // For CustomColumn and FileAttachment

    vm.loginUserAdminType = !isNullOrEmpty($window.sessionStorage['loginUserAdminType']) ? $window.sessionStorage['loginUserAdminType'] : "";  

    vm.isAdminSHT = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "H" || vm.loginUserAdminType == "T"); 
    vm.isAdminSHB = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "H" || vm.loginUserAdminType == "B"); 
    vm.isAdminSH = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "H"); 
    vm.isAdminS = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S"); 

    // 조회 데이터
    vm.data = {
      budgetExecList : [],
      SptAmtSum : 0,
      ExecAmtSum : 0,
      BlanceSum : 0,
      RateSvg : 0,
      tableNm :  vm.srch.tableNm,
      ResultReportId : vm.srch.ResultReportId,
      CaseManageId : vm.srch.CaseManageId
    };
    
    // 예산 집행 내역 데이터
    vm.budgetExecData = {};
    
    vm.chk1 = false;
    vm.chk2 = false;
    vm.chk3 = false;
    vm.chk4 = false;   
    vm.chkCnt = 0;
    
    //#region getData 데이터 조회
    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;

      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.keyId = $stateParams.keyId;
      vm.srchDetail.srchTenantId = '0';
      
      vm.srchDetail.tableNm = 'resultreport';
      vm.srchDetail.selectType = 'Edit'; // 모니터링 정보 가져오기 위해

      postApi.select(VIEW_SQL, vm.srchDetail, function (result) {
          if ( result.header.status === CONSTANT.HttpStatus.OK ) {

            if (result.body.desc.length > 0) {
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if ( result.body.docs.length > 0 ) {
              vm.data = result.body.docs[0];
              vm.ReqDate = moment(vm.data.ReqDate).format('YYYY-MM-DD');
              vm.SptStartDate = moment(vm.data.SptStartDate).format('YYYY-MM-DD');
              vm.SptEndDate = moment(vm.data.SptEndDate).format('YYYY-MM-DD');              
              if (!isNullOrEmpty(vm.data.MoniDate1) && !isNullOrEmpty(vm.data.MoniTime1)) {    
                vm.MoniDate1 = vm.data.MoniDate1 +" "+ vm.data.MoniTime1;    
              }
              if (!isNullOrEmpty(vm.data.MoniDate2) && !isNullOrEmpty(vm.data.MoniTime2)) {    
                vm.MoniDate2 = vm.data.MoniDate2 +" "+ vm.data.MoniTime2;          
              }
              if (!isNullOrEmpty(vm.data.MoniDate)) vm.MoniDate = new Date(vm.data.MoniDate);
              vm.data.SptAmtSum = 0;
              vm.data.ExecAmtSum = 0;
              vm.data.BlanceSum = 0;
              vm.data.RateAvg = 0;
              vm.data.budgetExecList = [];
              vm.GiveTenantId = vm.data.GiveTenantId;

              if (vm.data.uploadFileList) {
                angular.forEach(vm.data.uploadFileList, function (item) {
                  angular.forEach(vm.attach, function (att) {
                    if(att.grpId == item.GrpId){    
                      var target = att.id;    
                      vm.attach[target].isLoaded = true;
                      vm.attach[target].fileName = item.LogicalFileNm;
                      vm.attach[target].size = item.FileSize;
                      vm.attach[target].path = item.PhysicalPath;
                      vm.attach[target].fileKey = item.PhysicalFileNm;
                      vm.attach[target].link = StaticVariable.getUrl("/openapi/attach/" + item.PhysicalPath + "/" + item.PhysicalFileNm + "/download.do");
                      vm.attach[target].delState = '';
                      vm.attach[target].fileLock = item.FileLock;
                      vm.attach[target].downAuth = (item.FileLock == "N" || (item.FileLock == "Y" && (vm.data.RegUserYN == "Y" || vm.tenantId == "0")));
                      vm.attach[target].ngIf = true;
                    } else {
                      return;
                    }
                  });
                });
              } else {
                vm.data.uploadFileList = [];
              }

              getBudgetExecList(vm.data.ResultReportId);
              getCommentList();
            }
          }

          vm.dataloader = false;
        },
        function (error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }
    
    
    /**
     * 예산 이행 실적 목록 조회
     * @param
     * @return
     */
     function getBudgetExecList(keyId) { 
      var data = {};
      data.mapCode = 'Take.getSptReqDetailList';
      data.keyId = keyId;
      postApi.select(data, function (result) {
        if ( result.header.status === CONSTANT.HttpStatus.OK ) {
         
          vm.data.SptAmtSum = 0;
          vm.data.ExecAmtSum = 0;
          vm.data.BlanceSum = 0;
          vm.data.RateAvg = 0;

          if ( result.body.docs.length > 0 ) {
            vm.data.budgetExecList = result.body.docs;            
            angular.forEach(vm.data.budgetExecList, function(item) {              
              vm.data.BlanceSum += Number(item.Blance);
              vm.data.ExecAmtSum += Number(item.ExecAmt);
              vm.data.SptAmtSum += Number(item.SptAmt);
              item.Rate = Math.round(item.ExecAmt / item.SptAmt * 100);
            });
            vm.data.RateAvg = Math.round(vm.data.ExecAmtSum / vm.data.SptAmtSum * 100);
            
          } else {
            vm.data.budgetExecList = [];
          }
        }
        
        angular.forEach(vm.data.budgetExecList, function(req) {
          switch(req.SptRecord){
            case "1": vm.chk1 = true; vm.chkCnt++; break; //주거비

            case "2": vm.chk2 = true; 
            case "5": vm.chk2 = true; 
            case "6": vm.chk2 = true; 
            vm.chkCnt++;  break; //생계비

            case "3": vm.chk3 = true; vm.chkCnt++; break; //자립비
            case "4": vm.chk4 = true; vm.chkCnt++; break; //치료비
          }
        });
        if(vm.chkCnt > 4) vm.chkCnt = 4;

        vm.dataloader = false;
      },
      function (error) {
        vm.dataloader = false;
        console.table(error);
      });
    }
    //#endregion
    
    //#region getCommentList 댓글목록 조회
    function getCommentList() {
      var data = {
        keyId : vm.data.ResultReportId,
        mapCode : COMMNET_LIST_SQL
      };
      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.comment.list = result.body.docs;
            angular.forEach(vm.comment.list, function(item) {
              item.RegDate = moment(item.RegDate).format('YYYY-MM-DD HH:mm');
              item.chkView = true;
              // 비밀댓글 권한 > 본인이거나, 댓글조회 가능한 관리자
              if( ! isNullOrEmpty(item.SecretCommYN) && item.SecretCommYN == "1"){
                item.chkView = (item.RegUser == $rootScope.gVariable.UserId || $window.sessionStorage['isCommentAdmin'] == "1");
              }
            });
          } else {
            vm.comment.list = [];
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getCommentList()");
        console.table(error);
      });
    }
    //#endregion

    //#region saveComment, editComment 댓글/수정 저장
    function saveComment() {      

      // 추가 버튼 클릭 안한 비밀댓글 지정자가 있을 경우 자동 등록
      if(! isNullOrEmpty(vm.commAdminData.UserId)){
        vm.addCommAdmin();
      }

      if (isNullOrEmpty(vm.commentData.Content)) {
        gAlert('', '댓글 내용을 입력해주세요.');
        return false;
      }

      var data = angular.copy(vm.commentData);
      data.commAdminList = vm.commAdminData.list;
      data.keyId = vm.data.ResultReportId;
      data.mapCode = INSERT_COMMENT_SQL;

      // 매체발송 치환용
      data.TargetNm = vm.data.TargetNm;
      data.RegTenantNm = $window.sessionStorage['loginTenantName'];   

      if(data.SecretCommYN == "1" && data.commAdminList.length > 0){
        data.sendMsgType = "Y1"; // 지정 비밀댓글
      } else if(data.SecretCommYN == "1"){
        data.sendMsgType = "Y2"; // 비지정 비밀댓글
      } else {
        data.sendMsgType = "N"; // 일반댓글
      }

      postApi.insert(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '저장되었습니다.', {
            btn : '',
            fn : function() {
              vm.commentData = {};
              vm.commAdminData = {list:[]};
              getCommentList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> saveComment()");
        console.table(error);
      });
    }

    function editComment(li) {
      vm.comment.editid = li.ResultReportCommId;
      vm.comment.editContent = li.Content;
      vm.comment.SecretCommYN = li.SecretCommYN;   
      vm.comment.AdminData = {list:[]};

      var data = {
        keyId : vm.keyId,
        rCommentId : li.ResultReportCommId,
        mapCode : COMMNET_ADMIN_LIST_SQL
      };

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.comment.AdminData.list = result.body.docs;
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> editComment()");
        console.table(error);
      });
    }
    
    function editCommentAction(li) {
      if (isNullOrEmpty(vm.comment.editContent)) {
        gAlert('', '수정할 댓글 내용을 입력해주세요.');
        return false;
      }

      var data = angular.copy(li);
      data.Content = angular.copy(vm.comment.editContent);
      data.SecretCommYN = angular.copy(vm.comment.SecretCommYN);
      data.mapCode = UPDATE_COMMENT_SQL;
      data.commAdminList = vm.comment.AdminData.list;

      postApi.update(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '수정되었습니다.', {
            btn : '',
            fn : function() {
              vm.comment.editid = '';
              vm.comment.editContent = '';   
              vm.comment.AdminData = {list:[]};
              getCommentList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> editCommentAction()");
        console.table(error);
      });
    }
    //#endregion

    //#region editCommentCancel 댓글 수정 취소
    /**
      * 댓글 수정 취소
      *
      * @param
      * @return
    */
     function editCommentCancel() {
      vm.comment.editid = null;
      vm.comment.editContent = null;   
      vm.comment.AdminData = {list:[]};
    }
    //#endregion

    //#region deleteComment 댓글 삭제
    /**
      * 댓글 삭제
      *
      * @param
      * @return
    */
     function deleteComment(li) {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteCommentAction(li);
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }
    
    function deleteCommentAction(li) {
      var data = angular.copy(li);
      data.mapCode = DELETE_COMMENT_SQL;

      postApi.update(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '삭제되었습니다.', {
            btn : '',
            fn : function() {
              getCommentList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> deleteCommentAction()");
        console.table(error);
      });
    }
    //#endregion

    // 댓글관리자 팝업
    vm.srchCommAdminModal = function (type) {
      var ctrl = 'CommAdminModalCtrl as modalCtrl';
      var paramData = {srchTenantId: $rootScope.gVariable.srchTenantId};
      var modalInstance = modalFactory.open('lg', 'app/eland-request/modal/comm-admin-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        if(type == "E"){
          vm.comment.AdminData.UserNm = okData.UserNm;
          vm.comment.AdminData.UserId = okData.UserId;
        } else {
          vm.commAdminData.UserNm = okData.UserNm;
          vm.commAdminData.UserId = okData.UserId;
        }
      }, function (cancelData) {
        // 취소
      });
    };

    // 댓글관리자 추가
    vm.addCommAdmin = function (type) { 
      if(type == "E"){
        if( ! isNullOrEmpty(vm.comment.AdminData.UserId)){
          vm.comment.AdminData.list.push({UserId : vm.comment.AdminData.UserId, UserNm : vm.comment.AdminData.UserNm});      
          vm.comment.AdminData.UserNm = "";
          vm.comment.AdminData.UserId = "";
        }
      } else {
        if( ! isNullOrEmpty(vm.commAdminData.UserId)){
          vm.commAdminData.list.push({UserId : vm.commAdminData.UserId, UserNm : vm.commAdminData.UserNm});      
          vm.commAdminData.UserNm = "";
          vm.commAdminData.UserId = "";
        }
      }
    }

    // 댓글관리자 삭제
    vm.delCommAdmin = function (idx, type) {
      if(type == "E"){
        vm.comment.AdminData.list.splice(idx, 1); 
      } else {
        vm.commAdminData.list.splice(idx, 1); 
      }
    }

    //#region goList 목록 이동
    function goList() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      var type = $stateParams.type;
      var status = $stateParams.status;

      if (!isNullOrEmpty(type)) {
        if (!isNullOrEmpty(status)) {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type + '-' + status;
        } else {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type;
        }
      }
      $state.go(LIST_PAGE_URL, { srch: srch, type : type, status : status});
    }
    //#endregion

    // 첨부파일 다운로드
    vm.downloadFile = function (target) {
      if(vm.attach[target].downAuth && vm.tenantType != 'GIVETENANT'){
          if (!isNullOrEmpty(vm.attach[target].link)) {
            window.open(vm.attach[target].link);
          }
      } else {
        alert("다운로드 권한이 없습니다.");
      }
    };

    /**
     * 수정화면 이동
     * @param
     * @return
     */
    function goEdit() {      
      console.log('layout === ', vm.layout);
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      var type = $stateParams.type;
      var status = $stateParams.status; // 상태값
      var keyId = vm.srch.CaseManageId;

      if (vm.layout == 'N') {
        $state.go(EDIT_PAGE_URL, { srch: srch, type : type, status : status, keyId : keyId });
      } else {
        $state.go(LIST_EDIT_PAGE_URL, { srch: srch, status : status, keyId : keyId });
      }      
    }

    function setReturn() {
      gConfirm('', '반려하시겠습니까?', {
        btn : '',
        fn : function() {
          setReturnAction();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function setReturnAction() {
      var data = {
        keyId : vm.srch.CaseManageId,
        ResultReportId : vm.data.ResultReportId,
        Type : "RETN",
      };
      data.mapCode = UPDATE_STATUS_RETURN_SQL;

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '반려되었습니다.', {
            btn : '',
            fn : function() {
              goList();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> setReturnAction()");
        console.table(error);
      });
    }

    // 모니터링 저장
    vm.saveMoniData = function(){
      var data = {
        keyId : vm.data.ResultReportId,
        MoniUserTxt : vm.data.MoniUserTxt,
        MoniDate : moment(vm.data.MoniDate).format('YYYY-MM-DD'),
        MoniTime : vm.data.MoniTime,
        MoniStat : vm.data.MoniStat,
      }
      var errMsg = '';

      if ( isNullOrEmpty(data.MoniUserTxt) ) {
        errMsg = errMsg + '- 담당자를 입력하세요.<br/>';
      }
      if ( isNullOrEmpty(data.MoniDate) || isNullOrEmpty(data.MoniTime) ) {
        errMsg = errMsg + '- 일시를 선택하세요.<br/>';
      }
      if ( isNullOrEmpty(data.MoniStat) ) {
        errMsg = errMsg + '- 진행여부를 선택하세요.<br/>';
      }
      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }

      var mapCode = 'Take.updateMoniData';

      postApi.sendPostApi('update', mapCode, data, function (result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', '저장되었습니다.', {
            btn : '',
            fn : function() {
            }
          });
        }
      },function (error) {
        console.table(error);
      });
    };

    // Tip 클릭      ;                                  
    vm.tips = ['0'];
    vm.clickTip = function(index) {
      vm.tips[index] = (vm.tips[index] === '0') ? '1' : '0';
    };

    vm.goList = goList;                      // 목록 이동
    vm.goEdit = goEdit;                                   // 수정 화면 이동
    vm.setReturn = setReturn;                           // 반려
    vm.saveComment = saveComment;                         // 댓글 저장
    vm.editComment = editComment;                         // 댓글 수정모드로 변경
    vm.editCommentAction = editCommentAction;             // 댓글 수정 저장
    vm.editCommentCancel = editCommentCancel;             // 댓글 수정 취소
    vm.deleteComment = deleteComment;                     // 댓글 삭제 엑션 호출
    getData();
  }
]);

/**
 * @ngdoc function
 * @name app.request:request-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the 사용자정의 컬럼 게시판
 */
webapp.controller("TakeResultEditCtrl", ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT",
                                   "StaticVariable", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout', 'fileUploadService', 'TakeService',
  /**
   * 사레 결과보고 - 등록/수정화면 Control
   * @param {object} $window - window object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state -  state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} CONSTANT - 전역 상수
   * @param {object} StaticVariable - StaticVariable object
   * @param {object} gAlert - Alert Module
   */
  function TakeResultEditCtrl( $window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, 
    postApi, customFieldApi, $rootScope, $timeout, fileUploadService, TakeService) {
    // View Model
    var LIST_PAGE_URL = 'app.eland-request.take-list';    // 목록 화면

    // SQL Mapper Id 정의
    var VIEW_SQL = 'Take.getTakeResultDetail';            // 상세 조회 SQL
    var INSERT_SQL = 'Take.insertResultReport';           // 전체 등록 SQL
    var INSERT_TEMP_SQL = 'Take.insertTempResultReport';  // 전체 등록 SQL
    var UPDATE_SQL = 'Take.updateResultReport';           // 전체 업데이트 SQL
    var INSERT_BUDGET_SQL = 'Take.insertBudgetExecList';  // 예산 실적 등록 및 수정 SQL

    var vm = this;

    vm.dataloader = false;
    vm.srch = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.srchDetail = {};
    vm.columnMap = {};

    // diabled 값 초기화
    vm.disabledHous = true;
    vm.disabledLiving = true;
    vm.disabledEdu = true;
    vm.disabledCure = true;
    vm.disabledHEtc = true;

    vm.loginUserAdminType = !isNullOrEmpty($window.sessionStorage['loginUserAdminType']) ? $window.sessionStorage['loginUserAdminType'] : "";  
    vm.isAdminS = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S"); // 시스템관리자, 사무국

    if ( !$stateParams.srch ) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    if ( !isNullOrEmpty($stateParams.keyId) ) {
      vm.srch.CaseManageId = $stateParams.keyId;
    }

    if ( !isNullOrEmpty($stateParams.ResultReportId) ) {
      vm.srch.ResultReportId = $stateParams.ResultReportId;
    }

    vm.srch.tableNm = 'resultreport';    
    angular.copy(vm.srch, vm.srchDetail);

    vm.srchDetail.IdName = 'ResultReportId'; // For CustomColumn and FileAttachment
    vm.srchDetail.selectType = "Edit";       // For CustomColumn and FileAttachment

    vm.rateList = ["0","10","20","30","40","50","60","70","80","90","100"];
    vm.timeList = angular.copy(TakeService.timeList);

    vm.chk1 = false;
    vm.chk2 = false;
    vm.chk3 = false;
    vm.chk4 = false;   
    vm.chkCnt = 0;

    // 업로드 파일 목록
    vm.attach = angular.copy(TakeService.rptAttach);

    vm.addFile = function(type) {
      isMax = true;
      for (var i = 1; i <= 5; i++) {
        var key = type + i;
        if (vm.attach[key].ngIf === false) {
          vm.attach[key].ngIf = true; 
          isMax = false;
          break; 
        }
      }
      if(isMax){        
        alert("더 이상 파일을 추가할 수 없습니다.");
      }
    } 

    // 조회 데이터
    vm.data = {
      budgetExecList : [],
      SptAmtSum : 0,
      ExecAmtSum : 0,
      BlanceSum : 0,
      tableNm :  vm.srch.tableNm,
      ResultReportId : vm.srch.ResultReportId,
      CaseManageId : vm.srch.CaseManageId
    };
    
    // 예산 집행 내역 데이터
    vm.budgetExecData = {};
    

    /**
     * 예산 이행 실적 목록 조회
     * @param
     * @return
     */
    function getBudgetExecList(keyId) { 
      var data = {};
      data.mapCode = 'Take.getSptReqDetailList';
      data.keyId = keyId;
      data.tableNm = 'casemanage_rs';
      data.selectType = 'List';   // 작업 테이블 타입
      postApi.select(data, function (result) {
        if ( result.header.status === CONSTANT.HttpStatus.OK ) {
          if ( result.body.desc.length > 0 ) {
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
            
          }
          if ( result.body.docs.length > 0 ) {
            vm.data.budgetExecList = result.body.docs;    
            angular.forEach(vm.data.budgetExecList, function(item) {              
              vm.data.BlanceSum += Number(item.Blance);
              vm.data.ExecAmtSum += Number(item.ExecAmt);
              vm.data.SptAmtSum += Number(item.SptAmt);
              item.Rate = Math.round(item.ExecAmt / item.SptAmt * 100);
            });
            vm.data.RateAvg = Math.round(vm.data.ExecAmtSum / vm.data.SptAmtSum * 100);         
          }
        }
        
        vm.setSupportSc();

        vm.dataloader = false;
      },
      function (error) {
        vm.dataloader = false;
        console.table(error);
      });
    }

    vm.setSupportSc = function(){
      angular.forEach(vm.data.budgetExecList, function(req) {
        switch(req.SptRecord){
          case "1": //주거비
            if(! vm.chk1) {
              vm.chk1 = true; 
              vm.chkCnt++; 
            }
            break; 
          case "2": //생계비
            if(! vm.chk2) {
              vm.chk2 = true; 
              vm.chkCnt++; 
            }
            break; 
          case "3": //자립비
            if(! vm.chk3) {
              vm.chk3 = true; 
              vm.chkCnt++; 
            }
            break; 
          case "4": //치료비
            if(! vm.chk4) {
              vm.chk4 = true; 
              vm.chkCnt++; 
            }
            break; 
          case "5": //기타 > 생계비
            if(! vm.chk2) {
              vm.chk2 = true; 
              vm.chkCnt++;
            }
            break; 
        }
      });

      if(vm.chkCnt == 0) {
        vm.chk1 = true;
        vm.chk2 = true;
        vm.chk3 = true;
        vm.chk4 = true;
        vm.chkCnt = 4;
      }
    }

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;

      vm.srchDetail.uploadFileList = []; // For CustomColumn and FileAttachment
      vm.srchDetail.keyId = $stateParams.keyId;

      postApi.select(VIEW_SQL, vm.srchDetail, function (result) {
          if ( result.header.status === CONSTANT.HttpStatus.OK ) {
            if ( result.body.docs.length > 0 ) {
              vm.data = result.body.docs[0];
              vm.ReqDate = moment(vm.data.ReqDate).format('YYYY-MM-DD');
              if( !isNullOrEmpty(vm.data.SptStartDate) ) vm.SptStartDate = new Date(vm.data.SptStartDate);
              if( !isNullOrEmpty(vm.data.SptEndDate) ) vm.SptEndDate = new Date(vm.data.SptEndDate);              
              if (!isNullOrEmpty(vm.data.MoniDate1)) vm.MoniDate1 = new Date(vm.data.MoniDate1);
              if (!isNullOrEmpty(vm.data.MoniDate2)) vm.MoniDate2 = new Date(vm.data.MoniDate2);
              vm.data.SptAmtSum = 0;
              vm.data.ExecAmtSum = 0;
              vm.data.BlanceSum = 0;
              vm.data.budgetExecList = [];
              vm.GiveTenantId = vm.data.GiveTenantId;

              if (vm.data.uploadFileList) {
                angular.forEach(vm.data.uploadFileList, function (item) {
                  angular.forEach(vm.attach, function (att) {
                    if(att.grpId == item.GrpId){    
                      var target = att.id;    
                      vm.attach[target].isLoaded = true;
                      vm.attach[target].fileName = item.LogicalFileNm;
                      vm.attach[target].size = item.FileSize;
                      vm.attach[target].path = item.PhysicalPath;
                      vm.attach[target].fileKey = item.PhysicalFileNm;
                      vm.attach[target].link = StaticVariable.getUrl("/openapi/attach/" + item.PhysicalPath + "/" + item.PhysicalFileNm + "/download.do");
                      vm.attach[target].delState = '';
                      vm.attach[target].fileLock = item.FileLock;
                      vm.attach[target].downAuth = (item.FileLock == "N" || (item.FileLock == "Y" && (vm.data.RegUserYN == "Y" || vm.tenantId == "0")));
                      vm.attach[target].ngIf = true;
                    } else {
                      return;
                    }
                  });
                });
              } else {
                vm.data.uploadFileList = [];
              }

              getBudgetExecList(vm.data.ResultReportId);
            }
          }

          vm.dataloader = false;
        },
        function (error) {
          vm.dataloader = false;
          console.table(error);
        }
      );
    }
    //#endregion

    //#region saveData 데이터 저장
    /**
     * 데이터 저장
     * @param
     * @return
     */
    function saveData(type) {
      if (getIsValidData(type)) {
        var data = angular.copy(vm.data);
        var mapCode = '';

        data.tableNm = vm.srch.tableNm;
        data.tableId = vm.data.ResultReportId;
        data.IdName = "TableId";
        data.userkey = vm.srch.userkey;
        data.SptStartDate = moment(data.SptStartDate).format('YYYY-MM-DD');
        data.SptEndDate =  moment(data.SptEndDate).format('YYYY-MM-DD');
        data.Type = type;

        var sum = 0;
        var cnt = 0;

        if(vm.chk1) {
          cnt++;
          sum = sum + (Number(data.SupportSc1));
        }
        if(vm.chk2) {
          cnt++;
          sum = sum + (Number(data.SupportSc2));
        }
        if(vm.chk3) {
          cnt++;
          sum = sum + (Number(data.SupportSc3));
        }
        if(vm.chk4) {
          cnt++;
          sum = sum + (Number(data.SupportSc4));
        }

        data.SupportSc = (sum / cnt).toFixed(1);
        data.SupportResult = (data.SupportSc >= 3.4) ? 'Y' : 'N';

        if (isNullOrEmpty(data.ResultReportId)) {
          if(type == 'SAVE') {
            mapCode = INSERT_SQL;
          } else {
            mapCode = INSERT_TEMP_SQL;
          }
          
          data.keyId = $stateParams.keyId;
          postApi.sendPostApi('insert', mapCode, data, function (result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.data.ResultReportId = result.body.docs[0].TableId;
              InsertUpdateDetail();
            }
          },function (error) {
            console.table(error);
          });
        } else {
          mapCode = UPDATE_SQL;
          data.keyId = $stateParams.keyId;
          postApi.sendPostApi('update', mapCode, data, function (result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              vm.data.ResultReportId = result.body.docs[0].TableId;
              InsertUpdateDetail();
            }
          },function (error) {
            console.table(error);
          });
        }
      }
    }
    
    function InsertUpdateDetail() {
        vm.dataloader = true;
        var data = {lists : []};
        data.mapCode = INSERT_BUDGET_SQL;
        data.lists = vm.data.budgetExecList; 
        data.keyId = vm.data.ResultReportId;
        data.CaseManageId = $stateParams.keyId;
        postApi.insert(data, function (result){
          if ( result.header.status === CONSTANT.HttpStatus.OK || result.header.status === 406 ) {
            gAlert('', '저장되었습니다.', {
              btn : '',
              fn : function() {
                goList();
              }
            });
          }
          vm.dataloader = false;
        },function (error) {
          console.table(error);
        });
    }
    
    /**
     *  Validation Check && 대상자 첨부파일 업로드 호출
     *
     * @param 
     * @return
     */
    function getIsValidData(type) {
      var data = angular.copy(vm.data);
      var errMsg = '';

      // 추가 버튼 대상일 경우 1행 입력 상태면 자동 추가 처리
      if (data.budgetExecList.length == 0 && ! isNullOrEmpty(vm.budgetExecData)) {
        vm.addBudgetExec(true);
        data.budgetExecList = angular.copy(vm.data.budgetExecList);
        data.BlanceSum = angular.copy(vm.data.BlanceSum);
      }
      
      if(type == 'SAVE') {
        if ( isNullOrEmpty(data.SptStartDate) ) {
          errMsg = errMsg + '- 지원기간(시작일)을 입력하세요.<br/>';
        }
  
        if ( isNullOrEmpty(data.SptEndDate) ) {
          errMsg = errMsg + '- 지원기간(종료일)을 입력하세요.<br/>';
        }
  
        if ( !isNullOrEmpty(data.SptStartDate) && !isNullOrEmpty(data.SptEndDate) ) {
          if ( data.SptStartDate > data.SptEndDate ) {
            errMsg = errMsg + '- 지원시작일은 종료일 이후일 수 없습니다.<br/>';
          }
        }
  
        if ( isNullOrEmpty(data.ApplyRiskLv) ) {
          errMsg = errMsg + '- 신청 시 위기 정도를 선택하세요.<br/>';
        }
  
        if ( isNullOrEmpty(data.SptRiskLv)) {
          errMsg = errMsg + '- 지원  후 위기 정도를 선택하세요.<br/>';
        }

        
        if (vm.chk1 && isNullOrEmpty(vm.data.SupportSc1)) {
          errMsg = errMsg + '- 주거비 영역 위기해결률을 선택하세요. </br>';
        }
        if (vm.chk2 && isNullOrEmpty(vm.data.SupportSc2)) {
          errMsg = errMsg + '- 생계비 영역 위기해결률을 선택하세요. </br>';
        }
        if (vm.chk3 && isNullOrEmpty(vm.data.SupportSc3)) {
          errMsg = errMsg + '- 자립비 영역 위기해결률을 선택하세요. </br>';
        }
        if (vm.chk4 && isNullOrEmpty(vm.data.SupportSc4)) {
          errMsg = errMsg + '- 치료비 영역 위기해결률을 선택하세요. </br>';
        }
  
        if ( isNullOrEmpty(data.PerSocSpt) || data.PerSocSpt.length < 300) {
          errMsg = errMsg + '- 위기해결 종합평가를 300자 이상 입력하세요.<br/>';
        }

        fileKeys = ['Photo1', 'Photo2', 'Photo3', 'Photo4', 'Photo5'];
        if (fileKeys.every(function(key) { return isNullOrEmpty(vm.attach[key].fileName);})) {
          errMsg = errMsg + '- 대상자 사진을 1장 이상 업로드 해주세요. </br>';
        }

        fileKeys = ['Review1', 'Review2', 'Review3', 'Review4', 'Review5'];
        if (fileKeys.every(function(key) { return isNullOrEmpty(vm.attach[key].fileName);})) {
          errMsg = errMsg + '- 대상자 후기를 1장 이상 업로드 해주세요. </br>';
        }
  
        if ( isNullOrEmpty(data.ManagePlan)) {
          errMsg = errMsg + '- 사례관리 목표를 입력하세요.<br/>';
        }
  
        if ( isNullOrEmpty(data.SptResultRate)) {
          errMsg = errMsg + '- 목표 대비 달성 정도를 선택하세요.<br/>';
        }
  
        if ( isNullOrEmpty(data.SptResult)) {
          errMsg = errMsg + '- 사례관리 결과를 입력하세요.<br/>';
        }
  
        if ( isNullOrEmpty(data.AfterPlan)) {
          errMsg = errMsg + '- 향후 계획을 입력하세요.<br/>';
        }
        
        if ( data.budgetExecList.length == 0 ) {
          errMsg = errMsg + '- 예산 집행 내역을 입력하세요.<br/>';
        }
  
        if ( data.BlanceSum > 0 && isNullOrEmpty(data.BlanceCn) ) {
          errMsg = errMsg + '- 잔액 사유를 입력하세요.<br/>';
        }
  
        if ( data.BlanceSum > 0 && isNullOrEmpty(data.BlanceRtnYN) ) {
          errMsg = errMsg + '- 지원금 반환처리를 선택하세요.<br/>';
        }

        fileKeys = ['Account1', 'Account2', 'Account3', 'Account4', 'Account5'];
        if (fileKeys.every(function(key) { return isNullOrEmpty(vm.attach[key].fileName);})) {
          errMsg = errMsg + '- 회계서류를 1장 이상 업로드 해주세요. </br>';
        }

        if (isNullOrEmpty(data.MoniDate1) || isNullOrEmpty(data.MoniTime1)) {
          errMsg = errMsg + '- 모니터링 1순위 일시를 선택해주세요.<br/>';
        }      
        if (isNullOrEmpty(data.MoniDate2) || isNullOrEmpty(data.MoniTime2)) {
          errMsg = errMsg + '- 모니터링 2순위 일시를 선택해주세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }
      }
      return true;
    }
    
    function goList() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      var type = $stateParams.type;
      var status = $stateParams.status;

      if (!isNullOrEmpty(type)) {
        if (!isNullOrEmpty(status)) {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type + '-' + status;
        } else {
          LIST_PAGE_URL = LIST_PAGE_URL + '-' + type;
        }
      }
      $state.go(LIST_PAGE_URL, { srch: srch, type : type, status : status});
      
    }    
    
    function getIsValidBudgetExecData(isSave) {
      var errMsg = '';
      if ( isNullOrEmpty(vm.budgetExecData.SptRecord) ) {
        errMsg = errMsg + '- 지원내역을 선택해주세요.<br/>';
      }

      if ( isNullOrEmpty(vm.budgetExecData.SptAmt) ) {
        errMsg = errMsg + '- 지원금을 입력해주세요.<br/>';
      }

      if ( isNullOrEmpty(vm.budgetExecData.ExecAmt) ) {
        errMsg = errMsg + '- 집행금을 입력해주세요.<br/>';
      }
      
      if ( isNullOrEmpty(vm.budgetExecData.Blance) ) {
        errMsg = errMsg + '- 잔액를 입력해주세요.<br/>';
      }

      if ( !isNullOrEmpty(vm.budgetExecData.SptAmt) && !isNullOrEmpty(vm.budgetExecData.ExecAmt) && !isNullOrEmpty(vm.budgetExecData.Blance) ) {
        if ( Number(vm.budgetExecData.SptAmt) < Number(vm.budgetExecData.ExecAmt) + Number(vm.budgetExecData.Blance) ) {
          errMsg = errMsg + '- 집행액과 잔액의 합은 지원금액을 초과할 수 없습니다.<br/>';
        } else if ( Number(vm.budgetExecData.SptAmt) > Number(vm.budgetExecData.ExecAmt) + Number(vm.budgetExecData.Blance) ) {
          errMsg = errMsg + '- 집행액과 잔액의 합은 지원금액과 동일해야 합니다.<br/>';
        } 
      }
      
      if ( isNullOrEmpty(vm.budgetExecData.TransType) ) {
        errMsg = errMsg + '- 이체방식을 선택해주세요.<br/>';
      }

      if ( !isNullOrEmpty(errMsg) ) {        
        if(isSave){
          return false;
        } else {
          gAlert('', errMsg);
          return false;
        }
      }
      return true;      
    }
    
    // 예산 집행 내역 추가
    function addBudgetExec(isSave) {
      if(isNullOrEmpty(vm.data.budgetExecList)){
        vm.chk1 = false;
        vm.chk2 = false;
        vm.chk3 = false;
        vm.chk4 = false;
        vm.chkCnt = 0;
      }
      if ( getIsValidBudgetExecData(isSave) ) {
        if ( vm.budgetExecData.SptRecord == 1 ) vm.budgetExecData.SptRecordNm = '주거비';
        else if ( vm.budgetExecData.SptRecord == 2 ) vm.budgetExecData.SptRecordNm = '생계비';
        else if ( vm.budgetExecData.SptRecord == 4 ) vm.budgetExecData.SptRecordNm = '치료비';
        else if ( vm.budgetExecData.SptRecord == 3 ) vm.budgetExecData.SptRecordNm = '자립비';
        else vm.budgetExecData.SptRecordNm = '기타';
        if ( vm.budgetExecData.TransType == '1' ) vm.budgetExecData.TransTypeNm = '이랜드복지재단에서 직접이체';
        else if ( vm.budgetExecData.TransType == '2' ) vm.budgetExecData.TransTypeNm = '사례관리기관으로 이체';
        else if ( vm.budgetExecData.TransType == '3' ) vm.budgetExecData.TransTypeNm = '체리카드 충전';
        vm.data.budgetExecList.push(vm.budgetExecData);
        vm.data.SptAmtSum += Number(vm.budgetExecData.SptAmt);
        vm.data.ExecAmtSum += Number(vm.budgetExecData.ExecAmt);
        vm.data.BlanceSum += Number(vm.budgetExecData.Blance); 
        vm.data.RateAvg = Math.round(vm.data.ExecAmtSum / vm.data.SptAmtSum * 100);
        vm.budgetExecData = {};

        vm.setSupportSc();
      }
    }

    // 예산 집행 내역 삭제
    function delBudgetExecList(index) {
      vm.data.SptAmtSum -= Number(vm.data.budgetExecList[index].SptAmt);
      vm.data.ExecAmtSum -= Number(vm.data.budgetExecList[index].ExecAmt);
      vm.data.BlanceSum -= Number(vm.data.budgetExecList[index].Blance);  
      vm.data.budgetExecList.splice(index, 1);     
    }
    //#endregion

    

    // Tip 클릭      
    vm.supportSc = [0, 1, 2, 3, 4, 5]  ;                                  
    vm.tips = ['0', '0', '0', '0', '0'];
    function clickTip(index) {
      vm.tips[index] = (vm.tips[index] === '0') ? '1' : '0';
    }

    // 자동계산
    vm.cal = function (){
      if( ! isNullOrEmpty(vm.budgetExecData.SptAmt) && ! isNullOrEmpty(vm.budgetExecData.ExecAmt)) {
        var a = vm.budgetExecData.SptAmt;
        var b = vm.budgetExecData.ExecAmt;        
        vm.budgetExecData.Blance = a - b;
        vm.budgetExecData.Rate = Math.round(b / a * 100);
      }
    };

    // 현장실사 날짜 체크
    vm.chkMoniDate = function (num, pickDt){
      var today = moment(new Date()).format('YYYY-MM-DD');
      //var limitDt = moment(new Date()).add(3, 'day').format('YYYY-MM-DD');
      //var denyDt = moment(new Date()).add(10, 'day').format('YYYY-MM-DD');
      var pickDt = moment(new Date(pickDt)).format('YYYY-MM-DD');
      //var week = moment(new Date(pickDt)).day();
      var msg = "";

      //if(pickDt < today || pickDt > denyDt || week == 0 || week == 6) {
      //  msg = "신청일은 오늘로부터 10일 이내, 평일만 선택할 수 있습니다.";
      //}

      if(msg != ""){
        alert(msg);
        setMoniDate(num, "");
      } 
      else {
        /*if(pickDt >= limitDt){
          gConfirm('', '이후 날짜를 선택할 경우 결과 발표가 예정보다 늦어질 수 있습니다. 선택하시겠습니까?', {
            btn : '',
            fn : function() {
              setMoniDate(num, pickDt);
            }
          }, {
            btn : '',
            fn : function() {
              setMoniDate(num, "");
            }
          });
        } else {*/
          setMoniDate(num, pickDt);
        //}
      }
    };

    // 모니터링 날짜 설정
    function setMoniDate(num, pickDt){
      switch(num){
        case 1 : 
          vm.data.MoniDate1 = pickDt; 
          break;
        case 2 : 
          vm.data.MoniDate2 = pickDt; 
          break;
      }
    }
    // 첨부파일 잠금/해제
   vm.setFileLock = function(target, lockYN){  
    if(isNullOrEmpty(vm.data.ResultReportId) || vm.data.RegUserYN == "Y" || vm.isAdminS)
    {  
      if( ! isNullOrEmpty(vm.data.ResultReportId)){  
        angular.forEach(vm.data.uploadFileList, function (item) {
          if (vm.attach[target].fileKey != undefined && item.PhysicalFileNm == vm.attach[target].fileKey) {  
            console.error(4);
            item.delState = 'update';
            item.fileKey = vm.attach[target].fileKey;
            item.id = item.fileId;
            item.fileLock = lockYN;
          }
        });
      }
      vm.attach[target].fileLock = lockYN;
    }
    else {
      alert("잠금/해제 권한이 없습니다.");
    }
  };

    // 파일 업로드창 
   vm.openAttachDialog = function (target) {  
    var elementNm = "#" + target;
    var fileElement = angular.element(elementNm);

    fileElement.trigger("click");    
    fileElement.off('change').on('change', function () {
      var file = fileElement[0].files[0];
      if (!file) return;    
      
     var fileName = file.name.toLowerCase();
     var isPdf = file.type === "application/pdf" || fileName.endsWith(".pdf");
     var isImage = file.type.startsWith("image/") || /\.(jpg|jpeg|png|gif|webp)$/.test(fileName);

     if (!isPdf && !isImage) {
       alert("PDF와 이미지 파일만 업로드할 수 있습니다.");
             $(this).val(""); 
             return; 
         }

      var reader = new FileReader();
      reader.onload = function (e) {         
        vm.data[target] =  $(fileElement).val(); 
        vm.onChangeHandler([file], target); 
      };    
      reader.readAsDataURL(file);  
    });
  };

  /**
   * 첨부파일 업로드
   *
   * @param {object}
   *          files - 첨부 파일
   * @return
  */
  vm.onChangeHandler = function (files, target) {
    // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
    $scope.$root.safeApply(function () {
      resetAttachment(target);
      vm.attach[target].fileName = files[0].name;
      vm.attach[target].size = files[0].size;
      var request = fileUploadService.post(files, null, function (percent) {
      });

      try {
        request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey=' + $rootScope.gVariable.userKey)).then(function (value) {   
          angular.forEach(value.data.responseVO.body.docs, function (item) {
            if (item.fileName == vm.attach[target].fileName && item.size == vm.attach[target].size) {
              vm.attach[target].isLoaded = true;
              vm.attach[target].tmpFileKey = item.tmpFileKey;
              vm.attach[target].fileKey = item.tmpFileKey; // 삭제 후 새로 등록하는 경우에 필요
              vm.attach[target].typeId = item.typeId;
              vm.attach[target].path = item.path;
              vm.attach[target].link = StaticVariable.getUrl("/openapi/attach/temp/" + item.tmpFileKey + "/download.do?&fileName=" + item.encFileName);
              vm.attach[target].delState = '';
              vm.data.uploadFileList.push(vm.attach[target]);   
            }
          });
        }, function (error) {
          console.error('Error> company-edit-ctrl> uploadFiles()', status, error);
        });
      } catch (error) {
        console.error('Error> company-edit-ctrl> uploadFiles()', status, error);
      }
    });
  };

  // 파일 삭제
  vm.onDelete = function (target) {
    angular.forEach(vm.data.uploadFileList, function (item, idx) {
      if(vm.attach[target].fileKey != undefined){
        if (item.PhysicalFileNm == vm.attach[target].fileKey) {
          item.delState = 'delete';
          item.fileKey = vm.attach[target].fileKey;
          item.id = item.fileId;
          item.path = vm.attach[target].path;
        }
      } else {
        if (item.id == target) {
          vm.data.uploadFileList.splice(idx, 1) 
        }
      }
    });

    resetAttachment(target);
    return;
  };

  // 파일 삭제 후 데이터 초기화
  function resetAttachment(target) {
    vm.attach[target].isLoaded = false;
    vm.attach[target].fileName = '';
    vm.attach[target].size = 0;
    vm.attach[target].path = '';
    vm.attach[target].link = '';
    vm.attach[target].delState = '';
    vm.attach[target].fileLock = 'Y';
    vm.attach[target].downAuth = true;
  }

  // 파일 다운로드
  vm.downloadTemp = function (target, arrObj) {
    if(vm.attach[target].downAuth){
      if( ! arrObj){
        if (!isNullOrEmpty(vm.attach[target].link)) {
          window.open(vm.attach[target].link);
        }
      } else {
        if (!isNullOrEmpty(arrObj.link)) {
          window.open(arrObj.link);
        }
      }
    } else {
      alert("다운로드 권한이 없습니다.");
    }
  };

    /**
      * 양식파일 다운로드
      * @param
      * @return
      */
     vm.downloadFile = function (type) {
      var fName = "";
      switch(type){
        case "Account" : fName = "이랜드복지재단_SOS위고_결과보고_안내.hwpx"; break;
      }
      window.location.href = "/assets/download/" + fName;
    };

    // 함수 선언
    vm.getData = getData;                    // 데이터 조회
    vm.saveData = saveData;                  // 데이터 저장
    vm.goList = goList;                      // 목록 이동
    vm.addBudgetExec = addBudgetExec;                      // 가족사항 추가
    vm.delBudgetExecList = delBudgetExecList;
    vm.getIsValidData = getIsValidData;
    vm.clickTip = clickTip;                  // Tip 클릭 이벤트

    // 데이터 조회
    getData();
  }
]);

webapp.service('TakeService', function() {
    var vm = this;  

    vm.timeList = ["09:00","09:30","10:00","10:30","11:00","11:30","12:00","12:30","13:00","13:30","14:00","14:30","15:00","15:30","16:00"];

    // 신청서 첨부파일
    vm.caseAttach = {
        AttachFile5: { label: '지원신청서', txt: '지원신청서'
                       , grpId: 50, id: 'AttachFile5', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: true, preview: false, viewType: ""},
        AttachFile1: { label: '공통 필수서류', txt: '공문, 개인정보동의서, 경제상황증명서류'
                       , grpId: 41, id: 'AttachFile1', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: true, preview: false, viewType: ""},
        AttachFile2: { label: '항목별 필수서류', txt: '견적서(주거환경개선비), 치료비(진단서, 치료비 추정 내역서, 파노라마 사진) 등'
                       , grpId: 42, id: 'AttachFile2', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: true, preview: false, viewType: ""},                    
        AttachFile4: { label: '기관 사업자등록증, 통장사본', txt: '지원금 이체 받을 기관 서류를 제출해 주시기 바랍니다.'
                       , grpId: 49, id: 'AttachFile4', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: true, preview: false, viewType: ""},    
        AttachFile6: { label: '물품리스트', txt: ''
                       , grpId: 56, id: 'AttachFile6', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: true, preview: false, viewType: ""},   
        AttachFile3: { label: '기타 제출서류', txt: '대상자 원본 사진 등 (물품지원 제외)'
                       , grpId: 43, id: 'AttachFile3', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: true, preview: false, viewType: ""},   
        AddFile1: { label: '추가서류', grpId: 44, id: 'AddFile1', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
        AddFile2: { label: '', grpId: 45, id: 'AddFile2', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
        AddFile3: { label: '', grpId: 46, id: 'AddFile3', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
        AddFile4: { label: '', grpId: 47, id: 'AddFile4', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
        AddFile5: { label: '', grpId: 48, id: 'AddFile5', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
        AddFile6: { label: '', grpId: 51, id: 'AddFile6', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
        AddFile7: { label: '', grpId: 52, id: 'AddFile7', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
        AddFile8: { label: '', grpId: 53, id: 'AddFile8', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
        AddFile9: { label: '', grpId: 54, id: 'AddFile9', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
        AddFile10: { label: '', grpId: 55, id: 'AddFile10', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
      };

    // 결과보고 첨부파일
    vm.rptAttach = {
        Photo1: { label: '대상자 사진', txt: '지원 후 변화 사진 첨부', grpId: 1, id: 'Photo1', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: true },
        Photo2: { label: '', grpId: 2, id: 'Photo2', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        Photo3: { label: '', grpId: 3, id: 'Photo3', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        Photo4: { label: '', grpId: 4, id: 'Photo4', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        Photo5: { label: '', grpId: 5, id: 'Photo5', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },  
        Review1: { label: '대상자 후기', txt: '대상자 감사 편지(손 편지), 변화스토리 등', grpId: 6, id: 'Review1', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: true },
        Review2: { label: '', grpId: 7, id: 'Review2', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        Review3: { label: '', grpId: 8, id: 'Review3', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        Review4: { label: '', grpId: 9, id: 'Review4', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        Review5: { label: '', grpId: 10, id: 'Review5', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        Account1: { label: '회계서류 첨부', txt: '영수증, 이체확인증, 기타 증빙서류', grpId: 11, id: 'Account1', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: true },
        Account2: { label: '', grpId: 12, id: 'Account2', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        Account3: { label: '', grpId: 13, id: 'Account3', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        Account4: { label: '', grpId: 14, id: 'Account4', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        Account5: { label: '', grpId: 15, id: 'Account5', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        EtcFile1: { label: '기타', grpId: 16, id: 'EtcFile1', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: true },
        EtcFile2: { label: '', grpId: 17, id: 'EtcFile2', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        EtcFile3: { label: '', grpId: 18, id: 'EtcFile3', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        EtcFile4: { label: '', grpId: 19, id: 'EtcFile4', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
        EtcFile5: { label: '', grpId: 20, id: 'EtcFile5', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false }      
      };

    

    // 결과보고 첨부파일 > 우수사례용
    vm.rptAttach2 = {
      Photo1: { label: '결과보고> 대상자 사진', txt: '지원 후 변화 사진 첨부', grpId: 1, id: 'Photo1', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: true },
      Photo2: { label: '', grpId: 2, id: 'Photo2', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
      Photo3: { label: '', grpId: 3, id: 'Photo3', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
      Photo4: { label: '', grpId: 4, id: 'Photo4', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
      Photo5: { label: '', grpId: 5, id: 'Photo5', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },  
      Review1: { label: '결과보고> 대상자 후기', txt: '대상자 감사 편지(손 편지), 변화스토리 등', grpId: 6, id: 'Review1', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: true },
      Review2: { label: '', grpId: 7, id: 'Review2', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
      Review3: { label: '', grpId: 8, id: 'Review3', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
      Review4: { label: '', grpId: 9, id: 'Review4', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },
      Review5: { label: '', grpId: 10, id: 'Review5', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false },     
    };  
    
    // 자가진단 데이터
    vm.selfDataQst = {
        Qst01 : {sec0:'긴급위기', sec1:'긴급위기', sec2:'퇴거 또는 노숙 위험', chk:0, sc:1, css1:'#C00000', css2:'#F7E6EF', txt:'강제퇴거 통보(명도소송·집행) 받았거나 임시거주·노숙 위기 상태 / 갑작스러운 퇴거 위기인지, 주거지 불안정 상태 여부 확인'},
        Qst02 : {sec0:'긴급위기', sec1:'', sec2:'단전·단수·가스 중단', chk:0, sc:1, css1:'#F7E6EF', css2:'#F7E6EF', txt:'공과금 체납으로 전기·수도·가스 단절 예고 또는 이미 단절된 상태'},
        Qst03 : {sec0:'긴급위기', sec1:'', sec2:'응급 치료 필요', chk:0, sc:1, css1:'#F7E6EF', css2:'#F7E6EF', txt:'갑작스러운 건강 악화·사고로 즉각적 치료 개입 필요 / 응급치료 필요, 사고 등 긴급 상황'},
        Qst04 : {sec0:'긴급위기', sec1:'', sec2:'식사 해결 어려움', chk:0, sc:1, css1:'#F7E6EF', css2:'#F7E6EF', txt:'식품구입비 없어 결식 또는 실질적 식량 부족 상태 (기준 모호 — 단순 식품지원과 구분하여 판단)'},
        Qst05 : {sec0:'공적사각', sec1:'공적사각', sec2:'기초생활수급자 아님', chk:0, sc:1, css1:'#090963', css2:'#DAEFF7', txt:'일반·차상위·미등록외국인 등 해당 / 기초생활수급 신청자 제외 / 수급 신청 후 긴급생계비 미지원 대상으로 소득 공백 있는 경우 예외'},
        Qst06 : {sec0:'공적사각', sec1:'', sec2:'긴급복지 미지원', chk:0, sc:1, css1:'#DAEFF7', css2:'#DAEFF7', txt:'미등록외국인·한부모/미혼모/이혼 등 법적자격 소송 진행으로 공적자원 연계 불가한 경우'},
        Qst07 : {sec0:'공적사각', sec1:'', sec2:'공적지원 탈락', chk:0, sc:1, css1:'#DAEFF7', css2:'#DAEFF7', txt:'자산기준 초과(처분불가 자산 포함)로 긴급복지·기초수급 탈락 / "공적지원 탈락"과 중복 여부 확인 필요'},
        Qst08 : {sec0:'공적사각', sec1:'', sec2:'제도 기준 미충족', chk:0, sc:1, css1:'#DAEFF7', css2:'#DAEFF7', txt:'처분불가 차량 소유, 부채만 있는 자가 등으로 공적자원 연계 불가 / 자산으로 잡히지만 실질 활용 불가한 경우'},
        Qst09 : {sec0:'생활취약', sec1:'생활취약', sec2:'최근 실직', chk:0, sc:1, css1:'#090963', css2:'#DAEFF7', txt:'최근 3개월 내 실직·폐업·소득 단절 / 주부양자와의 분리, 자녀돌봄 등 포함 / 소득 감소 이유 구체 확인'},
        Qst10 : {sec0:'생활취약', sec1:'', sec2:'월세 체납', chk:0, sc:1, css1:'#DAEFF7', css2:'#DAEFF7', txt:'월세 2개월↑ 체납 또는 관리비 체납으로 퇴거 위험 / CT의 소득대비 부채 상환금액이 높은지 확인'},
        Qst11 : {sec0:'생활취약', sec1:'', sec2:'의료비 부담', chk:0, sc:1, css1:'#DAEFF7', css2:'#DAEFF7', txt:'소득 대비 치료비 과중, 수술, 치료비로 가계 압박 심화 / 개인회생·파산·채무조정 불가한 경우도 해당'},
        Qst12 : {sec0:'생활취약', sec1:'', sec2:'생계비 부족', chk:0, sc:1, css1:'#DAEFF7', css2:'#DAEFF7', txt:'가구별 최저생계비 대비 월소득 낮거나 고정지출(월세·관리비·식비) 후 생계비 부족 / 자녀학원·저축보험 등은 지출 확인(제외 대상) 수입 대비 지출이 높은 경우 사유 확인(부채 등-재정관리 문제 여부 파악)'},
        Qst13 : {sec0:'사회고립', sec1:'사회고립', sec2:'가족 보호 없음', chk:0, sc:1, css1:'#090963', css2:'#DAEFF7', txt:'1인가구 또는 가족 있어도 실질적 지원·보호 불가 / 가족·지인 등의 도움을 요청할 대상이 없는지 확인'},
        Qst14 : {sec0:'사회고립', sec1:'', sec2:'도움 요청 대상 없음', chk:0, sc:1, css1:'#DAEFF7', css2:'#DAEFF7', txt:'긴급 시 도움 청할 가족·지인·이웃 없음 ("도움 요청 대상 없음 / 사회적 관계 단절" 중복 항목 여부 확인)'},
        Qst15 : {sec0:'사회고립', sec1:'', sec2:'사회적 관계 단절', chk:0, sc:1, css1:'#DAEFF7', css2:'#DAEFF7', txt:'지역사회·이웃 연결망 부재, 장기 고립 상태'},
        Qst16 : {sec0:'사회고립', sec1:'', sec2:'돌봄 지원 없음', chk:0, sc:1, css1:'#DAEFF7', css2:'#DAEFF7', txt:'아동·노인·장애인 돌봄 필요자 있으나 지원 전무 / "도움 요청 대상 없음·사회적 관계 단절" 중복 항목 확인 필요'},
        Qst17 : {sec0:'기능취약', sec1:'기능취약', sec2:'일상생활 유지 어려움', chk:0, sc:1, css1:'#090963', css2:'#DAEFF7', txt:'식사·청결·이동 등 기본 자기관리 어려운 상태'},
        Qst18 : {sec0:'기능취약', sec1:'', sec2:'건강관리 어려움', chk:0, sc:1, css1:'#DAEFF7', css2:'#DAEFF7', txt:'재정적 사유로 치료 미진행 또는 중단·정신건강 위기·치료 필요 (만성질환은 제외 대상/정신건강 이상의 경우, 회복가능 여부 파악)'},
        Qst19 : {sec0:'기능취약', sec1:'', sec2:'행정 접근 어려움', chk:0, sc:1, css1:'#DAEFF7', css2:'#DAEFF7', txt:'언어장벽·장애·고령으로 공적서비스 신청 스스로 불가'},
        Qst20 : {sec0:'기능취약', sec1:'', sec2:'위기 대응 능력 부족', chk:0, sc:1, css1:'#DAEFF7', css2:'#DAEFF7', txt:'자원 탐색·활용 능력 없어 스스로 위기 해결 불가'},
        Qst21 : {sec0:'복합위기', sec1:'복합위기', sec2:'경제+건강 위기', chk:0, sc:1, css1:'#C00000', css2:'#F7E6EF', txt:'소득 단절과 건강 문제 동시 발생 (중복위기 가중 — 플랫폼 매칭지원 검토)'},
        Qst22 : {sec0:'복합위기', sec1:'', sec2:'경제+주거 위기', chk:0, sc:1, css1:'#F7E6EF', css2:'#F7E6EF', txt:'소득 단절과 주거 불안정 중복 (플랫폼 매칭 지원 검토)'},
        Qst23 : {sec0:'복합위기', sec1:'', sec2:'고립+경제 위기', chk:0, sc:1, css1:'#F7E6EF', css2:'#F7E6EF', txt:'사회적 고립과 경제 위기 중복 (사회적 고립 해결이 가능한지 검토)'},
        Qst24 : {sec0:'수용태도', sec1:'수용태도', sec2:'지원 거부 없음', chk:0, sc:1, css1:'#04380D', css2:'#DCF5F7', txt:'지원 수용 의사 확인, 서비스 거부 이력 없음 (만성적, 민원성에 의한 신청 제외)'},
        Qst25 : {sec0:'문제인식', sec1:'문제인식', sec2:'위기 인식', chk:0, sc:1, css1:'#04380D', css2:'#DCF5F7', txt:'본인 상황을 위기로 인식하고 변화 필요성 인지'},
        Qst26 : {sec0:'변화의지', sec1:'변화의지', sec2:'개선 의지', chk:0, sc:1, css1:'#04380D', css2:'#DCF5F7', txt:'일자리 탐색·고정지출 감소 시도·소득으로 체납금 상환 등 자발적 노력 확인 / 가지고 있는 자산 없는 경우'},
        Qst27 : {sec0:'사례협력', sec1:'사례협력', sec2:'사례관리 협력', chk:0, sc:1, css1:'#04380D', css2:'#DCF5F7', txt:'기관과 협력 의지 확인, 이후 사례관리 계획이 분명한지 / 지속적 어려움 있었으나 발굴 초기라 긴급개입 시급한 경우 사례관리 기간 검토(라포가 형성이 되어 대상가정을 잘 파악하고 있는지)'},
        Qst28 : {sec0:'개입효과', sec1:'개입효과', sec2:'단기개입 효과 가능', chk:0, sc:1, css1:'#04380D', css2:'#DCF5F7', txt:'발굴 초기 또는 긴급상황 악화 전 개입으로 효과 기대 / 이전에 긴급생계비 지원 받아 이번 위기에 불가한 경우 확인 필수'},
        Qst29 : {sec0:'근로가능', sec1:'근로가능', sec2:'근로 가능성', chk:0, sc:1, css1:'#04380D', css2:'#DCF5F7', txt:'가구 구성원 내 근로가능한 사람이 없는 경우 해당 / ★자립비 한정: 치아 문제로 근로 어려운 경우 + 자부담 치과치료 의지 확인 치아상태가 근로중단과 관계가 있는지 검토'},
      }; 

      // 추가 질문/응답
      vm.selfDataQna = {
        Qst01 : {no: 1, question: "", answer: ""},
        Qst02 : {no: 2, question: "", answer: ""},
        Qst03 : {no: 3, question: "", answer: ""},
        Qst04 : {no: 4, question: "", answer: ""},
        Qst05 : {no: 5, question: "", answer: ""},
      }; 

      vm.getSelfDataResult = function(selfData){
        var data = {
          totalSc: 0,
          stepTxt: "",
          amtTxt: ""
        }
        data.totalSc = Object.values(selfData).reduce(function(sum, item) { return sum + Number(item.chk); }, 0);
        if (data.totalSc >= 26) {
          data.stepTxt = "즉시지원 - 생존 위기";
          data.amtTxt = "500~700만원 (생계+주거+치료 통합지원)";
        } else if (data.totalSc >= 21) {
          data.stepTxt = "우선지원 - 고위험 위기";
          data.amtTxt = "300~500만원 (2개 영역 지원)";
        } else if (data.totalSc >= 14) {
          data.stepTxt = "일반지원(1차 선정) - 생활 위기";
          data.amtTxt = "100~300만원 (1개 영역 지원)";
        } else if (data.totalSc >= 7) {
          data.stepTxt = "자원연계 - 경계군";
          data.amtTxt = "0~100만원 (외부자원 중심)";
        } else {
          data.stepTxt = "지원제외 (정보 제공)";
          data.amtTxt = "0원";
        }
        return data;
      }
  });
(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.personal', {
      url : '/personal',
      template : '<div ui-view></div>',
    })
    // 임직원관리
    .state('app.personal.user-list', {
      url : '/user-list/:srch',
      templateUrl : 'app/personal/user/user-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
            ]);
        }],
      }
    }).state('app.personal.user-edit', {
      url: '/user-edit/:srch/:keyId',
      templateUrl: 'app/personal/user/user-edit.html'
    })
    .state('app.personal.user-list.edit', {
      url: '/user-edit/:keyId',
      templateUrl: 'app/personal/user/user-edit.html'
    })
    .state('app.personal.user-edit.tab1', {
      url: '/tab1',
      templateUrl: 'app/personal/user/user-edit-tab1.html'
    })
    .state('app.personal.user-list.edit.tab1', {
      url: '/tab1',
      templateUrl: 'app/personal/user/user-edit-tab1.html'
    })
    .state('app.personal.user-edit.tab2', {
      url: '/tab2',
      templateUrl: 'app/personal/user/user-edit-tab2.html'
    })
    .state('app.personal.user-list.edit.tab2', {
      url: '/tab2',
      templateUrl: 'app/personal/user/user-edit-tab2.html'
    })
    .state('app.personal.user-edit.tab3', {
      url: '/tab3',
      templateUrl: 'app/personal/user/user-edit-tab3.html'
    })
    .state('app.personal.user-list.edit.tab3', {
      url: '/tab3', 
      templateUrl: 'app/personal/user/user-edit-tab3.html'
    })
    .state('app.personal.user-view', {
      url: '/user-edit/:srch/:keyId',
      templateUrl: 'app/personal/user/user-edit-tab1.html'
    });
  }
})();
webapp.service('SystemCodeAPISrv', ['$resource', 'StaticVariable', '$rootScope',
	  function SystemCodeAPISrv($resource, staticVariable, $rootScope) {
	    return {
	    	getSystemCodeList: function(){
	    		return $resource(staticVariable.getUrl('/api/system/codegroup/:parentCommonCodeId/codelist.json'), {
	    			parentCommonCodeId : '@parentCommonCodeId', userkey:$rootScope.gVariable.userKey
	    		}, staticVariable.getRequestActions.getStandardAction());
	    	},
	    	getCommonCodeList: function(){
	    		return $resource(staticVariable.getUrl('/api/common/codegroup/:parentCommonCodeId/codelist.json'), {
	    			parentCommonCodeId : '@parentCommonCodeId', userkey:$rootScope.gVariable.userKey
	    		}, staticVariable.getRequestActions.getStandardAction());
	    	},
	    };
  },
]);

(function() {
  "use strict";

  webapp.config(routerConfig);

  /** @ngInject */
  function routerConfig($stateProvider, $urlRouterProvider) {
    $stateProvider.state('app.system', {
      url : '/system',
      template : '<div ui-view></div>',
    })
    // 공통코드관리
    .state('app.system.commoncode-list', {
      url : '/commoncode-list',
      templateUrl : 'app/system/common-code/commoncode-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
            ]);
        } ],
      }
    })
    
    // 부서관리
    .state('app.system.department-list', {
      url: '/department-list',
      templateUrl: 'app/system/department/department-list.html',
      requiresAuthentication: true,
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
          ]);
        }],
      },
    }).state('app.system.department-detail', {
        url: '/department-detail/:DeptId',
        templateUrl: 'app/system/department/department-detail.html',
    }).state('app.system.department-edit', {
      url: '/department-edit/:DeptId',
      templateUrl: 'app/system/department/department-edit.html',
    })

    // 쿼리생성기
    .state('app.system.makequery-list', {
      url: '/makequery-list',
      templateUrl: 'app/system/make-query/makequery-list.html',
      requiresAuthentication: true,
    })

    // 메뉴관리
    .state('app.system.menumanage-list', {
      url : '/menumanage-list',
      templateUrl : 'app/system/menu/menu-manage-list.html',
      requiresAuthentication: true,
    }).state('app.system.menumanage-mobilelist', {
      url : '/menumanage-mobilelist',
      templateUrl : 'app/system/menu/menu-manage-list.html',
      requiresAuthentication: true,
    })
    
    // 역할관리
    .state('app.system.role-list', {
      url: '/role-list/:srch',
      templateUrl: 'app/system/role/role-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
          ]);
        }],
      },
    }).state('app.system.role-detail', {
        url: '/role-detail/:srch/:RoleId',
        templateUrl: 'app/system/role/role-detail.html',
    }).state('app.system.role-edit', {
      url: '/role-edit/:srch/:RoleId',
      templateUrl: 'app/system/role/role-edit.html',
    }).state('app.system.role-list.detail', {
      url: '/detail/:RoleId',
      templateUrl: 'app/system/role/role-detail.html',
    }).state('app.system.role-list.edit', {
      url: '/edit/:RoleId',
      templateUrl: 'app/system/role/role-edit.html',
    })

    // 역활별 화면 권한
    .state('app.system.screen-list.detail', {
      url: '/detail/:ScreenId',
      templateUrl: 'app/system/role-screen/screen-detail.html',
    }).state('app.system.screen-list.edit', {
      url: '/edit/:ScreenId',
      templateUrl: 'app/system/role-screen/screen-edit.html',
    }).state('app.system.rolescreen-list', {
      url: '/rolescreen-list/:mobile/:srch',
      templateUrl: 'app/system/role-screen/rolescreen-list.html',
      resolve: {
        plugins: ['$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css'
          ]);
        }],
      },
    }).state('app.system.rolescreen-detail', {
        url: '/rolescreen-detail/:RolescreenId',
        templateUrl: 'app/system/role-screen/rolescreen-detail.html',
    }).state('app.system.rolescreen-edit', {
      url: '/rolescreen-edit/:RolescreenId',
      templateUrl: 'app/system/role-screen/rolescreen-edit.html',
    })

    // 화면관리
    .state('app.system.screen-list', {
      url: '/screen-list/:srch',
      templateUrl: 'app/system/screen/screen-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.system.screen-detail', {
        url: '/screen-detail/:ScreenId',
        templateUrl: 'app/system/screen/screen-detail.html',
    }).state('app.system.screen-edit', {
      url: '/screen-edit/:ScreenId',
      templateUrl: 'app/system/screen/screen-edit.html',
    })

    // 프로젝트 관리
    .state('app.system.project-manage-list', {
      url: '/project-manage-list/:srch',
      templateUrl: 'app/system/project-manage/project-manage-list.html',
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        } ],
      }
    }).state('app.system.project-manage-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/system/project-manage/project-edit.html',
    }).state('app.system.project-manage-edit', {
      url: '/project-edit/:srch/:keyId',
      templateUrl: 'app/system/project-manage/project-edit.html',
    })

    // 공지사항 등록
    .state('app.system.notice-list', {
      url: '/notice-list/:srch',
      templateUrl: 'app/system/notice/sys-notice-list-view.html',
      requiresAuthentication: true,
    }).state('app.system.notice-edit', {
      url: '/notice-edit/:keyId',
      templateUrl: 'app/system/notice/sys-notice-edit-view.html',
    }).state('app.system.notice-list.edit', {
      url: '/notice-edit/:keyId',
        templateUrl: 'app/system/notice/sys-notice-edit-view.html',
    })

    // 바로가기 관리
    .state('app.system.bookmark-manage', {
      url: '/bookmark-manage/',
      templateUrl: 'app/system/bookmark/bookmark-manage.html',
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    })

    // 마이그레이션
    .state('app.system.migration-list', {
      url: '/migration-list',
      templateUrl: 'app/system/migration/migration-list-view.html',
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
           ]);
        }],
      }
    })
    //SMS 자동발송문구 관리
    .state('app.system.sms-auto-list', {
      url: '/sms-auto-list/:srch',
      templateUrl: 'app/system/sms/sms-auto-list.html',
      requiresAuthentication: true,
      resolve : {
        plugins : [ '$ocLazyLoad', function($ocLazyLoad) {
          return $ocLazyLoad.load([
            '/assets/app/vendor/footable/js/footable.js',
            '/assets/app/vendor/footable/css/footable.core.min.css',
          ]);
        } ],
      }
    }).state('app.system.sms-auto-edit', {
      url: '/sms-auto-edit/:srch/:keyId',
      templateUrl: 'app/system/sms/sms-auto-edit.html',
    }).state('app.system.sms-auto-list.edit', {
      url: '/edit/:keyId',
      templateUrl: 'app/system/sms/sms-auto-edit.html',
    })
        
    ;
  }
})();
/*
 ng-sortable v1.3.8
 The MIT License (MIT)

 Copyright (c) 2014 Muhammed Ashik

 Permission is hereby granted, free of charge, to any person obtaining a copy
 of this software and associated documentation files (the "Software"), to deal
 in the Software without restriction, including without limitation the rights
 to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 copies of the Software, and to permit persons to whom the Software is
 furnished to do so, subject to the following conditions:

 The above copyright notice and this permission notice shall be included in all
 copies or substantial portions of the Software.

 THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 SOFTWARE.
 */

/*jshint indent: 2 */
/*global angular: false */

(function () {
  'use strict';
  angular.module('as.sortable', [])
    .constant('sortableConfig', {
      itemClass: 'as-sortable-item',
      handleClass: 'as-sortable-item-handle',
      placeHolderClass: 'as-sortable-placeholder',
      dragClass: 'as-sortable-drag',
      hiddenClass: 'as-sortable-hidden',
      dragging: 'as-sortable-dragging'
    });
}());

/*jshint indent: 2 */
/*global angular: false */

(function () {
  'use strict';

  var mainModule = angular.module('as.sortable');

  /**
   * Helper factory for sortable.
   */
  mainModule.factory('$helper', ['$document', '$window',
    function ($document, $window) {
      return {

        /**
         * Get the height of an element.
         *
         * @param {Object} element Angular element.
         * @returns {String} Height
         */
        height: function (element) {
          return element[0].getBoundingClientRect().height;
        },

        /**
         * Get the width of an element.
         *
         * @param {Object} element Angular element.
         * @returns {String} Width
         */
        width: function (element) {
          return element[0].getBoundingClientRect().width;
        },

        /**
         * Get the offset values of an element.
         *
         * @param {Object} element Angular element.
         * @param {Object} [scrollableContainer] Scrollable container object for calculating relative top & left (optional, defaults to Document)
         * @returns {Object} Object with properties width, height, top and left
         */
        offset: function (element, scrollableContainer) {
          var boundingClientRect = element[0].getBoundingClientRect();
          if (!scrollableContainer) {
            scrollableContainer = $document[0].documentElement;
          }

          return {
            width: boundingClientRect.width || element.prop('offsetWidth'),
            height: boundingClientRect.height || element.prop('offsetHeight'),
            top: boundingClientRect.top + ($window.pageYOffset || scrollableContainer.scrollTop - scrollableContainer.offsetTop),
            left: boundingClientRect.left + ($window.pageXOffset || scrollableContainer.scrollLeft - scrollableContainer.offsetLeft)
          };
        },

        /**
         * get the event object for touch.
         *
         * @param  {Object} event the touch event
         * @return {Object} the touch event object.
         */
        eventObj: function (event) {
          var obj = event;
          if (event.targetTouches !== undefined) {
            obj = event.targetTouches.item(0);
          } else if (event.originalEvent !== undefined && event.originalEvent.targetTouches !== undefined) {
            obj = event.originalEvent.targetTouches.item(0);
          }
          return obj;
        },

        /**
         * Checks whether the touch is valid and multiple.
         *
         * @param event the event object.
         * @returns {boolean} true if touch is multiple.
         */
        isTouchInvalid: function (event) {

          var touchInvalid = false;
          if (event.touches !== undefined && event.touches.length > 1) {
            touchInvalid = true;
          } else if (event.originalEvent !== undefined &&
            event.originalEvent.touches !== undefined && event.originalEvent.touches.length > 1) {
            touchInvalid = true;
          }
          return touchInvalid;
        },

        /**
         * Get the start position of the target element according to the provided event properties.
         *
         * @param {Object} event Event
         * @param {Object} target Target element
         * @param {Object} [scrollableContainer] (optional) Scrollable container object
         * @returns {Object} Object with properties offsetX, offsetY.
         */
        positionStarted: function (event, target, scrollableContainer) {
          var pos = {};
          pos.offsetX = event.pageX - this.offset(target, scrollableContainer).left;
          pos.offsetY = event.pageY - this.offset(target, scrollableContainer).top;
          pos.startX = pos.lastX = event.pageX;
          pos.startY = pos.lastY = event.pageY;
          pos.nowX = pos.nowY = pos.distX = pos.distY = pos.dirAx = 0;
          pos.dirX = pos.dirY = pos.lastDirX = pos.lastDirY = pos.distAxX = pos.distAxY = 0;
          return pos;
        },

        /**
         * Calculates the event position and sets the direction
         * properties.
         *
         * @param pos the current position of the element.
         * @param event the move event.
         */
        calculatePosition: function (pos, event) {
          // mouse position last events
          pos.lastX = pos.nowX;
          pos.lastY = pos.nowY;

          // mouse position this events
          pos.nowX = event.pageX;
          pos.nowY = event.pageY;

          // distance mouse moved between events
          pos.distX = pos.nowX - pos.lastX;
          pos.distY = pos.nowY - pos.lastY;

          // direction mouse was moving
          pos.lastDirX = pos.dirX;
          pos.lastDirY = pos.dirY;

          // direction mouse is now moving (on both axis)
          pos.dirX = pos.distX === 0 ? 0 : pos.distX > 0 ? 1 : -1;
          pos.dirY = pos.distY === 0 ? 0 : pos.distY > 0 ? 1 : -1;

          // axis mouse is now moving on
          var newAx = Math.abs(pos.distX) > Math.abs(pos.distY) ? 1 : 0;

          // calc distance moved on this axis (and direction)
          if (pos.dirAx !== newAx) {
            pos.distAxX = 0;
            pos.distAxY = 0;
          } else {
            pos.distAxX += Math.abs(pos.distX);
            if (pos.dirX !== 0 && pos.dirX !== pos.lastDirX) {
              pos.distAxX = 0;
            }

            pos.distAxY += Math.abs(pos.distY);
            if (pos.dirY !== 0 && pos.dirY !== pos.lastDirY) {
              pos.distAxY = 0;
            }
          }
          pos.dirAx = newAx;
        },

        /**
         * Move the position by applying style.
         *
         * @param event the event object
         * @param element - the dom element
         * @param pos - current position
         * @param container - the bounding container.
         * @param containerPositioning - absolute or relative positioning.
         * @param {Object} [scrollableContainer] (optional) Scrollable container object
         */
        movePosition: function (event, element, pos, container, containerPositioning, scrollableContainer) {
          var bounds;
          var useRelative = (containerPositioning === 'relative');

          element.x = event.pageX - pos.offsetX;
          element.y = event.pageY - pos.offsetY;

          if (container) {
            bounds = this.offset(container, scrollableContainer);

            if (useRelative) {
              // reduce positioning by bounds
              element.x -= bounds.left;
              element.y -= bounds.top;

              // reset bounds
              bounds.left = 0;
              bounds.top = 0;
            }

            if (element.x < bounds.left) {
              element.x = bounds.left;
            } else if (element.x >= bounds.width + bounds.left - this.offset(element).width) {
              element.x = bounds.width + bounds.left - this.offset(element).width;
            }
            if (element.y < bounds.top) {
              element.y = bounds.top;
            } else if (element.y >= bounds.height + bounds.top - this.offset(element).height) {
              element.y = bounds.height + bounds.top - this.offset(element).height;
            }
          }

          element.css({
            'left': element.x + 'px',
            'top': element.y + 'px'
          });

          this.calculatePosition(pos, event);
        },

        /**
         * The drag item info and functions.
         * retains the item info before and after move.
         * holds source item and target scope.
         *
         * @param item - the drag item
         * @returns {{index: *, parent: *, source: *,
                 *          sourceInfo: {index: *, itemScope: (*|.dragItem.sourceInfo.itemScope|$scope.itemScope|itemScope), sortableScope: *},
                 *         moveTo: moveTo, isSameParent: isSameParent, isOrderChanged: isOrderChanged, eventArgs: eventArgs, apply: apply}}
         */
        dragItem: function (item) {

          return {
            index: item.index(),
            parent: item.sortableScope,
            source: item,
            targetElement: null,
            targetElementOffset: null,
            sourceInfo: {
              index: item.index(),
              itemScope: item.itemScope,
              sortableScope: item.sortableScope
            },
            canMove: function(itemPosition, targetElement, targetElementOffset) {
              // return true if targetElement has been changed since last call
              if (this.targetElement !== targetElement) {
                this.targetElement = targetElement;
                this.targetElementOffset = targetElementOffset;
                return true;
              }
              // return true if mouse is moving in the last moving direction of targetElement
              if (itemPosition.dirX * (targetElementOffset.left - this.targetElementOffset.left) > 0 ||
                  itemPosition.dirY * (targetElementOffset.top - this.targetElementOffset.top) > 0) {
                this.targetElementOffset = targetElementOffset;
                return true;
              }
              // return false otherwise
              return false;
            },
            moveTo: function (parent, index) {
              // move the item to a new position
              this.parent = parent;
              // if the source item is in the same parent, the target index is after the source index and we're not cloning
              if (this.isSameParent() && this.source.index() < index && !this.sourceInfo.sortableScope.cloning) {
                index = index - 1;
              }
              this.index = index;
            },
            isSameParent: function () {
              return this.parent.element === this.sourceInfo.sortableScope.element;
            },
            isOrderChanged: function () {
              return this.index !== this.sourceInfo.index;
            },
            eventArgs: function () {
              return {
                source: this.sourceInfo,
                dest: {
                  index: this.index,
                  sortableScope: this.parent
                }
              };
            },
            apply: function () {
              if (!this.sourceInfo.sortableScope.cloning) {
                // if not cloning, remove the item from the source model.
                this.sourceInfo.sortableScope.removeItem(this.sourceInfo.index);

                // if the dragged item is not already there, insert the item. This avoids ng-repeat dupes error
                if (this.parent.options.allowDuplicates || this.parent.modelValue.indexOf(this.source.modelValue) < 0) {
                  this.parent.insertItem(this.index, this.source.modelValue);
                }
              } else if (!this.parent.options.clone) { // prevent drop inside sortables that specify options.clone = true
                // clone the model value as well
                this.parent.insertItem(this.index, angular.copy(this.source.modelValue));
              }
            }
          };
        },

        /**
         * Check the drag is not allowed for the element.
         *
         * @param element - the element to check
         * @returns {boolean} - true if drag is not allowed.
         */
        noDrag: function (element) {
          return element.attr('no-drag') !== undefined || element.attr('data-no-drag') !== undefined;
        },

        /**
         * Helper function to find the first ancestor with a given selector
         * @param el - angular element to start looking at
         * @param selector - selector to find the parent
         * @returns {Object} - Angular element of the ancestor or body if not found
         * @private
         */
        findAncestor: function (el, selector) {
          el = el[0];
          var matches = Element.matches || Element.prototype.mozMatchesSelector || Element.prototype.msMatchesSelector || Element.prototype.oMatchesSelector || Element.prototype.webkitMatchesSelector;
          while ((el = el.parentElement) && !matches.call(el, selector)) {
          }
          return el ? angular.element(el) : angular.element(document.body);
        }
      };
    }
  ]);

}());

/*jshint undef: false, unused: false, indent: 2*/
/*global angular: false */

(function () {

  'use strict';
  var mainModule = angular.module('as.sortable');

  /**
   * Controller for Sortable.
   * @param $scope - the sortable scope.
   */
  mainModule.controller('as.sortable.sortableController', ['$scope', function ($scope) {

    this.scope = $scope;

    $scope.modelValue = null; // sortable list.
    $scope.callbacks = null;
    $scope.type = 'sortable';
    $scope.options = {
      longTouch: false
    };
    $scope.isDisabled = false;

    /**
     * Inserts the item in to the sortable list.
     *
     * @param index - the item index.
     * @param itemData - the item model data.
     */
    $scope.insertItem = function (index, itemData) {
      if ($scope.options.allowDuplicates) {
        $scope.modelValue.splice(index, 0, angular.copy(itemData));
      } else {
        $scope.modelValue.splice(index, 0, itemData);
      }
    };

    /**
     * Removes the item from the sortable list.
     *
     * @param index - index to be removed.
     * @returns {*} - removed item.
     */
    $scope.removeItem = function (index) {
      var removedItem = null;
      if (index > -1) {
        removedItem = $scope.modelValue.splice(index, 1)[0];
      }
      return removedItem;
    };

    /**
     * Checks whether the sortable list is empty.
     *
     * @returns {null|*|$scope.modelValue|boolean}
     */
    $scope.isEmpty = function () {
      return ($scope.modelValue && $scope.modelValue.length === 0);
    };

    /**
     * Wrapper for the accept callback delegates to callback.
     *
     * @param sourceItemHandleScope - drag item handle scope.
     * @param destScope - sortable target scope.
     * @param destItemScope - sortable destination item scope.
     * @returns {*|boolean} - true if drop is allowed for the drag item in drop target.
     */
    $scope.accept = function (sourceItemHandleScope, destScope, destItemScope) {
      return $scope.callbacks.accept(sourceItemHandleScope, destScope, destItemScope);
    };

  }]);

  /**
   * Sortable directive - defines callbacks.
   * Parent directive for draggable and sortable items.
   * Sets modelValue, callbacks, element in scope.
   * sortOptions also includes a longTouch option which activates longTouch when set to true (default is false).
   */
  mainModule.directive('asSortable',
    function () {
      return {
        require: 'ngModel', // get a hold of NgModelController
        restrict: 'A',
        scope: true,
        controller: 'as.sortable.sortableController',
        link: function (scope, element, attrs, ngModelController) {

          var ngModel, callbacks;

          ngModel = ngModelController;

          if (!ngModel) {
            return; // do nothing if no ng-model
          }

          // Set the model value in to scope.
          ngModel.$render = function () {
            scope.modelValue = ngModel.$modelValue;
          };
          //set the element in scope to be accessed by its sub scope.
          scope.element = element;
          element.data('_scope',scope); // #144, work with angular debugInfoEnabled(false)

          callbacks = {accept: null, orderChanged: null, itemMoved: null, dragStart: null, dragMove:null, dragCancel: null, dragEnd: null};

          /**
           * Invoked to decide whether to allow drop.
           *
           * @param sourceItemHandleScope - the drag item handle scope.
           * @param destSortableScope - the drop target sortable scope.
           * @param destItemScope - the drop target item scope.
           * @returns {boolean} - true if allowed for drop.
           */
          callbacks.accept = function (sourceItemHandleScope, destSortableScope, destItemScope) {
            return true;
          };

          /**
           * Invoked when order of a drag item is changed.
           *
           * @param event - the event object.
           */
          callbacks.orderChanged = function (event) {
          };

          /**
           * Invoked when the item is moved to other sortable.
           *
           * @param event - the event object.
           */
          callbacks.itemMoved = function (event) {
          };

          /**
           * Invoked when the drag started successfully.
           *
           * @param event - the event object.
           */
          callbacks.dragStart = function (event) {
          };

          /**
           * Invoked when the drag move.
           *
           * @param itemPosition - the item position.
           * @param containment - the containment element.
           * @param eventObj - the event object.
          */
          callbacks.dragMove = angular.noop;

          /**
           * Invoked when the drag cancelled.
           *
           * @param event - the event object.
           */
          callbacks.dragCancel = function (event) {
          };

          /**
           * Invoked when the drag stopped.
           *
           * @param event - the event object.
           */
          callbacks.dragEnd = function (event) {
          };

          //Set the sortOptions callbacks else set it to default.
          scope.$watch(attrs.asSortable, function (newVal, oldVal) {
            angular.forEach(newVal, function (value, key) {
              if (callbacks[key]) {
                if (typeof value === 'function') {
                  callbacks[key] = value;
                }
              } else {
                scope.options[key] = value;
              }
            });
            scope.callbacks = callbacks;
          }, true);

          // Set isDisabled if attr is set, if undefined isDisabled = false
          if (angular.isDefined(attrs.isDisabled)) {
            scope.$watch(attrs.isDisabled, function (newVal, oldVal) {
              if (!angular.isUndefined(newVal)) {
                scope.isDisabled = newVal;
              }
            }, true);
          }
        }
      };
    });

}());

/*jshint indent: 2 */
/*global angular: false */

(function () {

  'use strict';
  var mainModule = angular.module('as.sortable');

  /**
   * Controller for sortableItemHandle
   *
   * @param $scope - item handle scope.
   */
  mainModule.controller('as.sortable.sortableItemHandleController', ['$scope', function ($scope) {

    this.scope = $scope;

    $scope.itemScope = null;
    $scope.type = 'handle';
  }]);

  //Check if a node is parent to another node
  function isParent(possibleParent, elem) {
    if(!elem || elem.nodeName === 'HTML') {
      return false;
    }

    if(elem.parentNode === possibleParent) {
      return true;
    }

    return isParent(possibleParent, elem.parentNode);
  }

  /**
   * Directive for sortable item handle.
   */
  mainModule.directive('asSortableItemHandle', ['sortableConfig', '$helper', '$window', '$document', '$timeout',
    function (sortableConfig, $helper, $window, $document, $timeout) {
      return {
        require: '^asSortableItem',
        scope: true,
        restrict: 'A',
        controller: 'as.sortable.sortableItemHandleController',
        link: function (scope, element, attrs, itemController) {

          var dragElement, //drag item element.
            placeHolder, //place holder class element.
            placeElement,//hidden place element.
            itemPosition, //drag item element position.
            dragItemInfo, //drag item data.
            containment,//the drag container.
            containerPositioning, // absolute or relative positioning.
            dragListen,// drag listen event.
            scrollableContainer, //the scrollable container
            dragStart,// drag start event.
            dragMove,//drag move event.
            dragEnd,//drag end event.
            dragCancel,//drag cancel event.
            isDraggable,//is element draggable.
            placeHolderIndex,//placeholder index in items elements.
            bindDrag,//bind drag events.
            unbindDrag,//unbind drag events.
            bindEvents,//bind the drag events.
            unBindEvents,//unbind the drag events.
            hasTouch,// has touch support.
            isIOS,// is iOS device.
            longTouchStart, // long touch start event
            longTouchCancel, // cancel long touch
            longTouchTimer, // timer promise for the long touch on iOS devices
            dragHandled, //drag handled.
            createPlaceholder,//create place holder.
            isPlaceHolderPresent,//is placeholder present.
            isDisabled = false, // drag enabled
            escapeListen, // escape listen event
            isLongTouch = false; //long touch disabled.

          hasTouch = 'ontouchstart' in $window;
          isIOS = /iPad|iPhone|iPod/.test($window.navigator.userAgent) && !$window.MSStream;

          if (sortableConfig.handleClass) {
            element.addClass(sortableConfig.handleClass);
          }

          scope.itemScope = itemController.scope;
          element.data('_scope', scope); // #144, work with angular debugInfoEnabled(false)

          scope.$watchGroup(['sortableScope.isDisabled', 'sortableScope.options.longTouch'],
              function (newValues) {
            if (isDisabled !== newValues[0]) {
              isDisabled = newValues[0];
              if (isDisabled) {
                unbindDrag();
              } else {
                bindDrag();
              }
            } else if (isLongTouch !== newValues[1]) {
              isLongTouch = newValues[1];
              unbindDrag();
              bindDrag();
            } else {
              bindDrag();
            }
          });

          scope.$on('$destroy', function () {
            angular.element($document[0].body).unbind('keydown', escapeListen);
          });

          createPlaceholder = function (itemScope) {
            if (typeof scope.sortableScope.options.placeholder === 'function') {
              return angular.element(scope.sortableScope.options.placeholder(itemScope));
            } else if (typeof scope.sortableScope.options.placeholder === 'string') {
              return angular.element(scope.sortableScope.options.placeholder);
            } else {
              return angular.element($document[0].createElement(itemScope.element.prop('tagName')));
            }
          };

          /**
           * Listens for a 10px movement before
           * dragStart is called to allow for
           * a click event on the element.
           *
           * @param event - the event object.
           */
          dragListen = function (event) {

            var unbindMoveListen = function () {
              angular.element($document).unbind('mousemove', moveListen);
              angular.element($document).unbind('touchmove', moveListen);
              element.unbind('mouseup', unbindMoveListen);
              element.unbind('touchend', unbindMoveListen);
              element.unbind('touchcancel', unbindMoveListen);
            };

            var startPosition;
            var moveListen = function (e) {
              e.preventDefault();
              var eventObj = $helper.eventObj(e);
              if (!startPosition) {
                startPosition = { clientX: eventObj.clientX, clientY: eventObj.clientY };
              }
              if (Math.abs(eventObj.clientX - startPosition.clientX) + Math.abs(eventObj.clientY - startPosition.clientY) > 10) {
                unbindMoveListen();
                dragStart(event);
              }
            };

            angular.element($document).bind('mousemove', moveListen);
            angular.element($document).bind('touchmove', moveListen);
            element.bind('mouseup', unbindMoveListen);
            element.bind('touchend', unbindMoveListen);
            element.bind('touchcancel', unbindMoveListen);
            event.stopPropagation();
          };

          /**
           * Triggered when drag event starts.
           *
           * @param event the event object.
           */
          dragStart = function (event) {

            var eventObj, tagName;

            if (!hasTouch && (event.button === 2 || event.which === 3)) {
              // disable right click
              return;
            }
            if (hasTouch && $helper.isTouchInvalid(event)) {
              return;
            }
            if (dragHandled || !isDraggable(event)) {
              // event has already fired in other scope.
              return;
            }
            // Set the flag to prevent other items from inheriting the drag event
            dragHandled = true;
            event.preventDefault();
            eventObj = $helper.eventObj(event);
            scope.sortableScope = scope.sortableScope || scope.itemScope.sortableScope; //isolate directive scope issue.
            scope.callbacks = scope.callbacks || scope.itemScope.callbacks; //isolate directive scope issue.

            if (scope.itemScope.sortableScope.options.clone || (scope.itemScope.sortableScope.options.ctrlClone && event.ctrlKey)) {
                // Clone option is true
                // or Ctrl clone option is true & the ctrl key was pressed when the user innitiated drag
              scope.itemScope.sortableScope.cloning = true;
            } else {
              scope.itemScope.sortableScope.cloning = false;
            }

            // (optional) Scrollable container as reference for top & left offset calculations, defaults to Document
            scrollableContainer = angular.element($document[0].querySelector(scope.sortableScope.options.scrollableContainer)).length > 0 ?
              $document[0].querySelector(scope.sortableScope.options.scrollableContainer) : $document[0].documentElement;

            containment = (scope.sortableScope.options.containment)? $helper.findAncestor(element, scope.sortableScope.options.containment):angular.element($document[0].body);
            //capture mouse move on containment.
            containment.css('cursor', 'move');
            containment.css('cursor', '-webkit-grabbing');
            containment.css('cursor', '-moz-grabbing');
            containment.addClass('as-sortable-un-selectable');

            // container positioning
            containerPositioning = scope.sortableScope.options.containerPositioning || 'absolute';

            dragItemInfo = $helper.dragItem(scope);
            tagName = scope.itemScope.element.prop('tagName');

            dragElement = angular.element($document[0].createElement(scope.sortableScope.element.prop('tagName')))
              .addClass(scope.sortableScope.element.attr('class')).addClass(sortableConfig.dragClass);
            dragElement.css('width', $helper.width(scope.itemScope.element) + 'px');
            dragElement.css('height', $helper.height(scope.itemScope.element) + 'px');

            placeHolder = createPlaceholder(scope.itemScope)
              .addClass(sortableConfig.placeHolderClass).addClass(scope.sortableScope.options.additionalPlaceholderClass);
            placeHolder.css('width', $helper.width(scope.itemScope.element) + 'px');
            placeHolder.css('height', $helper.height(scope.itemScope.element) + 'px');

            placeElement = angular.element($document[0].createElement(tagName));
            if (sortableConfig.hiddenClass) {
              placeElement.addClass(sortableConfig.hiddenClass);
            }

            itemPosition = $helper.positionStarted(eventObj, scope.itemScope.element, scrollableContainer);

            // fill the immediate vacuum.
            if (!scope.itemScope.sortableScope.options.clone) {
              scope.itemScope.element.after(placeHolder);
            }

            if (scope.itemScope.sortableScope.cloning) {
              // clone option is enabled or triggered, so clone the element.
              dragElement.append(scope.itemScope.element.clone());
            }
            else {
              // add hidden placeholder element in original position.
              scope.itemScope.element.after(placeElement);
              // not cloning, so use the original element.
              dragElement.append(scope.itemScope.element);
            }

            containment.append(dragElement);
            $helper.movePosition(eventObj, dragElement, itemPosition, containment, containerPositioning, scrollableContainer);

            scope.sortableScope.$apply(function () {
              scope.callbacks.dragStart(dragItemInfo.eventArgs());
            });
            bindEvents();
          };

          /**
           * Allow Drag if it is a proper item-handle element.
           *
           * @param event - the event object.
           * @return boolean - true if element is draggable.
           */
          isDraggable = function (event) {

            var elementClicked, sourceScope, isDraggable;

            elementClicked = angular.element(event.target);

            // look for the handle on the current scope or parent scopes
            sourceScope = fetchScope(elementClicked);

            isDraggable = (sourceScope && sourceScope.type === 'handle');

            //If a 'no-drag' element inside item-handle if any.
            while (isDraggable && elementClicked[0] !== element[0]) {
              if ($helper.noDrag(elementClicked)) {
                isDraggable = false;
              }
              elementClicked = elementClicked.parent();
            }
            return isDraggable;
          };

          /**
           * Inserts the placeHolder in to the targetScope.
           *
           * @param targetElement the target element
           * @param targetScope the target scope
           */
          function insertBefore(targetElement, targetScope) {
            // Ensure the placeholder is visible in the target (unless it's a table row)
            if (placeHolder.css('display') !== 'table-row') {
              placeHolder.css('display', 'block');
            }
            if (!targetScope.sortableScope.options.clone) {
              targetElement[0].parentNode.insertBefore(placeHolder[0], targetElement[0]);
              dragItemInfo.moveTo(targetScope.sortableScope, targetScope.index());
            }
          }

          /**
           * Inserts the placeHolder next to the targetScope.
           *
           * @param targetElement the target element
           * @param targetScope the target scope
           */
          function insertAfter(targetElement, targetScope) {
            // Ensure the placeholder is visible in the target (unless it's a table row)
            if (placeHolder.css('display') !== 'table-row') {
              placeHolder.css('display', 'block');
            }
            if (!targetScope.sortableScope.options.clone) {
              targetElement.after(placeHolder);
              dragItemInfo.moveTo(targetScope.sortableScope, targetScope.index() + 1);
            }
          }

          /**
           * Triggered when drag is moving.
           *
           * @param event - the event object.
           */
          dragMove = function (event) {

            var eventObj, targetX, targetY, targetScope, targetElement;

            if (hasTouch && $helper.isTouchInvalid(event)) {
              return;
            }
            // Ignore event if not handled
            if (!dragHandled) {
              return;
            }
            if (dragElement) {

              event.preventDefault();

              eventObj = $helper.eventObj(event);

              // checking if dragMove callback exists, to prevent application
              // rerenderings on each mouse move event
              if (scope.callbacks.dragMove !== angular.noop) {
                scope.sortableScope.$apply(function () {
                  scope.callbacks.dragMove(itemPosition, containment, eventObj);
                });
              }

              targetX = eventObj.pageX - $document[0].documentElement.scrollLeft;
              targetY = eventObj.pageY - ($window.pageYOffset || $document[0].documentElement.scrollTop);

              //IE fixes: hide show element, call element from point twice to return pick correct element.
              dragElement.addClass(sortableConfig.hiddenClass);
              targetElement = angular.element($document[0].elementFromPoint(targetX, targetY));
              dragElement.removeClass(sortableConfig.hiddenClass);

              $helper.movePosition(eventObj, dragElement, itemPosition, containment, containerPositioning, scrollableContainer);

              //Set Class as dragging starts
              dragElement.addClass(sortableConfig.dragging);

              targetScope = fetchScope(targetElement);

              if (!targetScope || !targetScope.type) {
                return;
              }
              if (targetScope.type === 'handle') {
                targetScope = targetScope.itemScope;
              }
              if (targetScope.type !== 'item' && targetScope.type !== 'sortable') {
                return;
              }

              if (targetScope.type === 'item' && targetScope.accept(scope, targetScope.sortableScope, targetScope)) {
                // decide where to insert placeholder based on target element and current placeholder if is present
                targetElement = targetScope.element;

                // Fix #241 Drag and drop have trembling with blocks of different size
                var targetElementOffset = $helper.offset(targetElement, scrollableContainer);
                if (!dragItemInfo.canMove(itemPosition, targetElement, targetElementOffset)) {
                  return;
                }

                var placeholderIndex = placeHolderIndex(targetScope.sortableScope.element);
                if (placeholderIndex < 0) {
                  insertBefore(targetElement, targetScope);
                } else {
                  if (placeholderIndex <= targetScope.index()) {
                    insertAfter(targetElement, targetScope);
                  } else {
                    insertBefore(targetElement, targetScope);
                  }
                }
              }

              if (targetScope.type === 'sortable') {//sortable scope.
                if (targetScope.accept(scope, targetScope) &&
                  !isParent(targetScope.element[0], targetElement[0])) {
                  //moving over sortable bucket. not over item.
                  if (!isPlaceHolderPresent(targetElement) && !targetScope.options.clone) {
                    targetElement[0].appendChild(placeHolder[0]);
                    dragItemInfo.moveTo(targetScope, targetScope.modelValue.length);
                  }
                }
              }
            }
          };


          /**
           * Fetch scope from element or parents
           * @param  {object} element Source element
           * @return {object}         Scope, or null if not found
           */
          function fetchScope(element) {
            var scope;
            while (!scope && element.length) {
              scope = element.data('_scope');
              if (!scope) {
                element = element.parent();
              }
            }
            return scope;
          }


          /**
           * Get position of place holder among item elements in itemScope.
           * @param targetElement the target element to check with.
           * @returns {*} -1 if placeholder is not present, index if yes.
           */
          placeHolderIndex = function (targetElement) {
            var itemElements, i;
            // targetElement is placeHolder itself, return index 0
            if (targetElement.hasClass(sortableConfig.placeHolderClass)){
              return 0;
            }
            // find index in target children
            itemElements = targetElement.children();
            for (i = 0; i < itemElements.length; i += 1) {
              //TODO may not be accurate when elements contain other siblings than item elements
              //solve by adding 1 to model index of previous item element
              if (angular.element(itemElements[i]).hasClass(sortableConfig.placeHolderClass)) {
                return i;
              }
            }
            return -1;
          };


          /**
           * Check there is no place holder placed by itemScope.
           * @param targetElement the target element to check with.
           * @returns {*} true if place holder present.
           */
          isPlaceHolderPresent = function (targetElement) {
            return placeHolderIndex(targetElement) >= 0;
          };

          /**
           * Rollback the drag data changes.
           */

          function rollbackDragChanges() {
            if (!scope.itemScope.sortableScope.cloning) {
              placeElement.replaceWith(scope.itemScope.element);
            }
            placeHolder.remove();
            dragElement.remove();
            dragElement = null;
            dragHandled = false;
            containment.css('cursor', '');
            containment.removeClass('as-sortable-un-selectable');
          }

          /**
           * triggered while drag ends.
           *
           * @param event - the event object.
           */
          dragEnd = function (event) {
            // Ignore event if not handled
            if (!dragHandled) {
              return;
            }
            event.preventDefault();
            if (dragElement) {
              //rollback all the changes.
              rollbackDragChanges();
              // update model data
              dragItemInfo.apply();
              scope.sortableScope.$apply(function () {
                if (dragItemInfo.isSameParent()) {
                  if (dragItemInfo.isOrderChanged()) {
                    scope.callbacks.orderChanged(dragItemInfo.eventArgs());
                  }
                } else {
                  scope.callbacks.itemMoved(dragItemInfo.eventArgs());
                }
              });
              scope.sortableScope.$apply(function () {
                scope.callbacks.dragEnd(dragItemInfo.eventArgs());
              });
              dragItemInfo = null;
            }
            unBindEvents();
          };

          /**
           * triggered while drag is cancelled.
           *
           * @param event - the event object.
           */
          dragCancel = function (event) {
            // Ignore event if not handled
            if (!dragHandled) {
              return;
            }
            event.preventDefault();

            if (dragElement) {
              //rollback all the changes.
              rollbackDragChanges();
              scope.sortableScope.$apply(function () {
                scope.callbacks.dragCancel(dragItemInfo.eventArgs());
              });
              dragItemInfo = null;
            }
            unBindEvents();
          };

          /**
           * Binds the drag start events.
           */
          bindDrag = function () {
            if (hasTouch) {
              if (isLongTouch) {
                if (isIOS) {
                  element.bind('touchstart', longTouchStart);
                  element.bind('touchend', longTouchCancel);
                  element.bind('touchmove', longTouchCancel);
                } else {
                  element.bind('contextmenu', dragListen);
                }
              } else {
                element.bind('touchstart', dragListen);
              }
            }
            element.bind('mousedown', dragListen);
          };

          /**
           * Unbinds the drag start events.
           */
          unbindDrag = function () {
            element.unbind('touchstart', longTouchStart);
            element.unbind('touchend', longTouchCancel);
            element.unbind('touchmove', longTouchCancel);
            element.unbind('contextmenu', dragListen);
            element.unbind('touchstart', dragListen);
            element.unbind('mousedown', dragListen);
          };

          /**
           * starts a timer to detect long touch on iOS devices. If touch held for more than 500ms,
           * it would be considered as long touch.
           *
           * @param event - the event object.
           */
          longTouchStart = function(event) {
            longTouchTimer = $timeout(function() {
              dragListen(event);
            }, 500);
          };

          /**
           * cancel the long touch and its timer.
           */
          longTouchCancel = function() {
            $timeout.cancel(longTouchTimer);
          };

          //bind drag start events.
          //put in a watcher since this method is now depending on the longtouch option from sortable.sortOptions
          //bindDrag();

          //Cancel drag on escape press.
          escapeListen = function (event) {
            if (event.keyCode === 27) {
              dragCancel(event);
            }
          };
          angular.element($document[0].body).bind('keydown', escapeListen);

          /**
           * Binds the events based on the actions.
           */
          bindEvents = function () {
            angular.element($document).bind('touchmove', dragMove);
            angular.element($document).bind('touchend', dragEnd);
            angular.element($document).bind('touchcancel', dragCancel);
            angular.element($document).bind('mousemove', dragMove);
            angular.element($document).bind('mouseup', dragEnd);
          };

          /**
           * Un binds the events for drag support.
           */
          unBindEvents = function () {
            angular.element($document).unbind('touchend', dragEnd);
            angular.element($document).unbind('touchcancel', dragCancel);
            angular.element($document).unbind('touchmove', dragMove);
            angular.element($document).unbind('mouseup', dragEnd);
            angular.element($document).unbind('mousemove', dragMove);
          };
        }
      };
    }]);
}());

/*jshint indent: 2 */
/*global angular: false */

(function () {

  'use strict';
  var mainModule = angular.module('as.sortable');

  /**
   * Controller for sortable item.
   *
   * @param $scope - drag item scope
   */
  mainModule.controller('as.sortable.sortableItemController', ['$scope', function ($scope) {

    this.scope = $scope;

    $scope.sortableScope = null;
    $scope.modelValue = null; // sortable item.
    $scope.type = 'item';

    /**
     * returns the index of the drag item from the sortable list.
     *
     * @returns {*} - index value.
     */
    $scope.index = function () {
      return $scope.$index;
    };

    /**
     * Returns the item model data.
     *
     * @returns {*} - item model value.
     */
    $scope.itemData = function () {
      return $scope.sortableScope.modelValue[$scope.$index];
    };

  }]);

  /**
   * sortableItem directive.
   */
  mainModule.directive('asSortableItem', ['sortableConfig',
    function (sortableConfig) {
      return {
        require: ['^asSortable', '?ngModel'],
        restrict: 'A',
        controller: 'as.sortable.sortableItemController',
        link: function (scope, element, attrs, ctrl) {
          var sortableController = ctrl[0];
          var ngModelController = ctrl[1];
          if (sortableConfig.itemClass) {
            element.addClass(sortableConfig.itemClass);
          }
          scope.sortableScope = sortableController.scope;
          if (ngModelController) {
            ngModelController.$render = function () {
              scope.modelValue = ngModelController.$modelValue;
            };
          } else {
            scope.modelValue = sortableController.scope.modelValue[scope.$index];
          }
          scope.element = element;
          element.data('_scope',scope); // #144, work with angular debugInfoEnabled(false)
        }
      };
    }]);

}());

(function () {
  "use strict";
  webapp.directive('clickAndDisable', function() {
    return {
      scope: {
        clickAndDisable: '&'
      },
      link: function(scope, iElement, iAttrs) {
        iElement.bind('click', function() {
          iElement.prop('disabled',true);
          scope.clickAndDisable().finally(function() {
            iElement.prop('disabled',false);
          })
        });
      }
    };
  });
}());

(function () {
  "use strict";
  webapp.directive('fileDropzone', function() {
  return {
    restrict: 'A',
    scope: {
      file: '=',
      fileName: '='
    },
    link: function(scope, element, attrs) {
      var checkSize,
          isTypeValid,
          processDragOverOrEnter,
          validMimeTypes;

      processDragOverOrEnter = function (event) {
        if (event != null) {
          event.preventDefault();
        }
        if(enableUploadComponent()) {
          var $obj = $(".dhx-dropable-area.drop-files-here");
          if($obj.length == 0) $obj = $(".dhx-files-block.dhx-webkit-scroll");
          if( $obj.length > 0) {
            $obj.closest(".layout_y").addClass('dhx-dragin');
          }
        }
        return false;
      };

      validMimeTypes = attrs.fileDropzone;
      element.bind('dragover', processDragOverOrEnter);
      element.bind('dragenter', processDragOverOrEnter);
      element.hover(function(){

      }, function(){
        var $obj = $(".dhx-dropable-area.drop-files-here");
        $obj.closest(".layout_y").removeClass('dhx-dragin');
      });
      

      return element.bind('drop', function(event) {
        console.log("drop")

        return false;
      });
    }
  };
})
}());

(function () {
  "use strict";
  webapp.directive('inputEnter', function () {
    return function (scope, element, attrs) {
      element.bind("keydown keypress", function (event) {
        if (event.which === 13) {
          scope.$apply(function () {
            scope.$eval(attrs.inputEnter);
          });
          event.preventDefault();
        }
      });
    }
  });
}());

(function () {
  "use strict";
  webapp.directive('krInput', ['$parse', function($parse) {
    return {
        priority : 2,
        restrict : 'A',
        compile : function(element) {
            element.on('compositionstart', function(e) {
                e.stopImmediatePropagation();
            });
        },
    };
  }]);
}());

'use strict';

/**
 * @ngdoc directive
 * @name minovateApp.directive:activateButton
 * @description
 * # activateButton
 */
webapp.directive('permission', [ 'Auth', function(Auth) {
  return {
    restrict : 'A',
    scope : {
      permission : '=',
    },

    link : function(scope, elem, attrs) {
      scope.$watch(attrs.ngShow, function() {
        /* console.log('scope.permission=', scope.permission); */
        if (Auth.userHasPermission(scope.permission)) {
          elem.show();
        } else {
          elem.hide();
        }
      });
    }
  }
} ]);

/**
 * tenantList
 * 
 **/
webapp.directive('tenantList', function(){
    return {
      restrict: 'A',
      scope:{
        ngModel : '=',
        tenant : '='
      },
      template : '<option value="" selected>---- 선택 ----</option><option value="{{li.TenantId}}" ng-repeat="li in vc.lists">{{li.TenantNm}}</option>',
      controller : 'TenantListCtrl as vc',
      link : function(scope, ele, attr, ctrl){
        scope.$watchCollection('ngModel', function(){
            if(ctrl.lists){
                ctrl.lists.forEach(function(item){
                    if(item.TenantId == scope.ngModel){
                        scope.tenant = item.TenantNm;
                    }
                });
            }
        });
      }
    };
});

webapp.controller('TenantListCtrl', ['postApi', 'GLOBAL_CONSTANT', '$scope',
    function TenantListCtrl(postApi, CONSTANT, $scope){
        var vm = this;
        
        var LIST_SQL = 'Tenant.getSrchTenantList';

        var data = {};
        data.mapCode = LIST_SQL;
        postApi.select(data, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {
                if(result.body.docCnt > 0){
                    vm.lists = result.body.docs;
                }
            }
        });
    }
]);
/* 'use strict'; */

/**
 * @ngdoc directive
 * @name minovateApp.directive:tileControlToggle
 * @description
 * # tileControlToggle
 */
webapp.directive('tileControlToggle', function () {
    return {
      restrict: 'A',
      link: function postLink(scope, element) {
        var tile = element.parents('.tile');

        element.on('click', function(){
          tile.toggleClass('collapsed');
          tile.children().not('.tile-header').slideToggle(150);
        });
      }
    };
  });

/**
 * TimePicker
 * 
 **/
webapp.directive('timePicker', function(){
    return {
      restrict: 'A',
      scope:{
        ngModel : '=',
        callback : '='
      },
      link : function(scope, ele, attr){
        $(ele).timeDropper({}, function(result){
          scope.callback(result);
        });
      }
    };
});
webapp.filter('byteCheck', function () {
	return function(text,b,i,c){
		if(angular.isUndefined(text)) return 0;
		for(b=i=0;c=text.charCodeAt(i++);b+=c>>11?3:c>>7?2:1);
		return b;
	}
});

/**
 * Usage
 * {{text|byteCheck}} / 2000byte
 * Output
 * "12 / 2000byte"
 *
 */

// add the filter to your application module
webapp.filter('filesize', function ($sce) {
		return function (bytes) {
	        if(bytes < 1024) return bytes + " Bytes";
	        else if(bytes < 1048576) return(bytes / 1024).toFixed(2) + " KB";
	        else if(bytes < 1073741824) return(bytes / 1048576).toFixed(2) + " MB";
	        else return(bytes / 1073741824).toFixed(2) + " GB";
		};
	});
/**
 * Usage
 * var myFile = 5678;
 *
 * {{myText|filesize}}
 *
 * Output
 * "5.54 Kb"
 *
 */


webapp.filter('htmlString', function($sce){
	return function(val){
		if(val) {
			return $sce.trustAsHtml(val);
		}else{
		    return val;
		}
	};
});


(function() {
  "use strict";

  webapp.filter("localToUtc", Filter);

  function Filter($filter) {
    return function(localeDateString, type, timezoneOffset) {
      var localeDate;
      var utcDate;
      var toUtcDate = "";

      if (!localeDateString) {
        return;
      }

      if (typeof localeDateString === "string" && localeDateString != "") {
        var dateArr = localeDateString.split("-");
        if (dateArr.length == 3) {
          localeDate = new Date(dateArr[0], parseInt(dateArr[1]) - 1, dateArr[2], 0, 0, 0);
        }
      } else if (typeof localeDateString === "object" && localeDateString instanceof Date) {
        localeDate = localeDateString;
      } else {
        return "";
      }

      if (!timezoneOffset || timezoneOffset == 0) {
        if (!type) {
          utcDate = new Date(localeDate.getTime() + (localeDate.getTimezoneOffset() * 60000));
        } else if (type == 'from') {
          utcDate = new Date(localeDate.getTime() + (localeDate.getTimezoneOffset() * 60000));
        } else if (type == 'to') {
          utcDate = new Date(localeDate.getTime() + (localeDate.getTimezoneOffset() * 60000) + 86399000);
        }
      } else {
        if (!type) {
          utcDate = new Date(localeDate.getTime() + (-1 * timezoneOffset * 60 * 60000));
        } else if (type == 'from') {
          utcDate = new Date(localeDate.getTime() + (-1 * timezoneOffset * 60 * 60000));
        } else if (type == 'to') {
          utcDate = new Date(localeDate.getTime() + (-1 * timezoneOffset * 60 * 60000) + 86399000);
        }
      }

      toUtcDate = $filter("date")(utcDate, 'yyyy-MM-dd HH:mm:ss');

      return toUtcDate;
    };
  }
})();

/*!
 * nl2br필터는 carriage return 값을 html의 <br/>로 바꿔준다.
 * */
webapp.filter('nl2brString', function($sce){
    return function(val){
        if(angular.isString(val)) {
            return $sce.trustAsHtml(val.replace(/\n/g, '<br/>'));
        }else{
            return val;
        }
    };
});


webapp.filter('tel', function ($sce) {
	return function (tel) {

		if(!tel) return tel;

		tel = tel.replace(/[^0-9]/g, '');

    	var tmp = '';
		
		if (tel.length < 4){
			return tel;
    	} else if(tel.length < 7) {
			tmp += tel.substr(0, 3);
			tmp += '-';
			tmp += tel.substr(3);
			return tmp;
    	} else if(tel.length == 8) {
			tmp += tel.substr(0, 4);
			tmp += '-';
			tmp += tel.substr(4);
			return tmp;
    	} else if(tel.length < 10) {
        	if( tel.substr(0, 2) =='02') { //02-123-5678            
            	tmp += tel.substr(0, 2);
            	tmp += '-';
            	tmp += tel.substr(2, 3);
            	tmp += '-';
            	tmp += tel.substr(5);
            	return tmp;
        	} else if (tel.substring(0, 1) == '1') {
				tmp += tel.substr(0, 4);
            	tmp += '-';
            	tmp += tel.substr(4, 4);
            	return tmp;
			}
    	} else if(tel.length < 11) {
        	if(tel.substr(0, 2) =='02') { 	//02-1234-5678            
            	tmp += tel.substr(0, 2);
            	tmp += '-';
				tmp += tel.substr(2, 4);
				tmp += '-';
				tmp += tel.substr(6);
				return tmp;
			} else {                        //010-123-4567            
				tmp += tel.substr(0, 3);
				tmp += '-';
				tmp += tel.substr(3, 3);
				tmp += '-';
				tmp += tel.substr(6);
				return tmp;
			}
		} else if(tel.length < 12) {		//010-1234-5678
			if(tel.substr(0, 4) =='0505') {
				tmp += tel.substr(0, 4);
				tmp += '-';
				tmp += tel.substr(4, 4);
				tmp += '-';
				tmp += tel.substr(8);
				return tmp;
			} else {
				tmp += tel.substr(0, 3);
				tmp += '-';
				tmp += tel.substr(3, 4);
				tmp += '-';
				tmp += tel.substr(7);
				return tmp;
			}
		} else { 
			return tel;
		}
	};
});
/*!
 * url-encode필터는 url에서 사용하면 안되는 특수 문자를 인코딩해 주는 필터이다..
 * */
webapp.filter('toLocaleDate', ['$filter', '$window', 'StaticVariable', function($filter, $window, variables) {
    return function(dateNumber) {
        var localeDate;
        var toLocalDate = '';
//        $window.localStorage.loginUserLang 변경 필요.
        var format = variables.getDateFormat('ko', false);

        if(typeof dateNumber == 'string' && dateNumber != ''){
            localeDate = new Date(parseInt(dateNumber));
        }else if(typeof dateNumber == 'number'){
            localeDate = new Date(dateNumber);
        }else{
            return '';
        }

        if(format != ''){
            toLocalDate = $filter('date')(localeDate, format);
        }else{
            toLocalDate = localeDate.toLocaleDateString();
        }
        return toLocalDate;
    };
}]);

/*!
 * url-encode필터는 url에서 사용하면 안되는 특수 문자를 인코딩해 주는 필터이다..
 * */
webapp.filter('toLocaleDatetime', ['$filter', '$window', 'StaticVariable', function($filter, $window, variables) {
    return function(dateNumber) {

        var localeDate;
        var toLocalDate = '';
        var format = variables.getDateFormat($window.localStorage.loginUserLang, true);

        if(typeof dateNumber == 'string' && dateNumber != ''){
            localeDate = new Date(parseInt(dateNumber));
        }else if(typeof dateNumber == 'number'){
            localeDate = new Date(dateNumber);
        }else{
            return '';
        }

        if(format != ''){
            toLocalDate = $filter('date')(localeDate, format);
        }else{
            toLocalDate = localeDate.toLocaleDateString();
        }

        return toLocalDate;
    };
}]);

(function() {
  "use strict";

  webapp.filter("utcToLocal", Filter);

  function Filter($filter) {
    return function(utcDateString, format) {
      var localeDate;
      var toLocalDate = "";

      if (!utcDateString) {
        return;
      }

      if (typeof utcDateString == "string" && utcDateString != "") {
        localeDate = new Date(parseInt(utcDateString));
      } else if (typeof utcDateString == "number") {
        localeDate = new Date(utcDateString);
      } else {
        return "";
      }

      //localeDate += 'Z';

      if (format != "") {
        toLocalDate = $filter("date")(localeDate, format);
      } else {
        toLocalDate = localeDate.toLocaleDateString();
      }

      return toLocalDate;
    };
  }
})();


function setTmpFileKey(fileKeys) {
	angular.element($(".fileAttachArea")).scope().modalCtrl.fileKeys = fileKeys;
};



webapp.controller('mtSidenavCtrl', function($scope, $timeout, $mdSidenav, $mdUtil, $log) {

    $scope.page = {
      title: 'Sidenav',
      subtitle: 'Place subtitle here...'
    };

    $scope.toggleLeft = buildToggler('left');
    $scope.toggleRight = buildToggler('right');
    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildToggler(navID) {
      var debounceFn =  $mdUtil.debounce(function(){
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      },200);
      return debounceFn;
    }

  })

  .controller('mtSidenavLeftCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      $mdSidenav('left').close()
        .then(function () {
          $log.debug("close LEFT is done");
        });
    };
  })
  .controller('mtSidenavRightCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      $mdSidenav('right').close()
        .then(function () {
          $log.debug("close RIGHT is done");
        });
    };
  });





(function() {
  var module,
    __slice = [].slice;

  module = angular.module("fa.directive.borderLayout", []);

  module.factory("paneManager", function() {
    return {
      panes: {},
      get: function(paneId) {
        return this.panes[paneId];
      },
      set: function(paneId, pane) {
        return this.panes[paneId] = pane;
      },
      remove: function(paneId) {
        return delete this.panes[paneId];
      }
    };
  });

  module.directive("faPane", [
    "$window", "$rootScope", "paneManager", function($window, $rootScope, paneManager) {
      var Region, generateSerialId, getHandleStyle, getOrientation, getScrollerStyle;
      Region = (function() {
        function Region(_at_width, _at_height, _at_top, _at_right, _at_bottom, _at_left) {
          this.width = _at_width != null ? _at_width : 0;
          this.height = _at_height != null ? _at_height : 0;
          this.top = _at_top != null ? _at_top : 0;
          this.right = _at_right != null ? _at_right : 0;
          this.bottom = _at_bottom != null ? _at_bottom : 0;
          this.left = _at_left != null ? _at_left : 0;
        }

        Region.prototype.clone = function() {
          return new Region(this.width, this.height, this.top, this.right, this.bottom, this.left);
        };

        Region.prototype.calculateSize = function(orientation, target) {
          var available, matches, terms, total;
          if (target == null) {
            target = 0;
          }
          total = this.getSize(orientation);
          available = this.getAvailableSize(orientation);
          if (angular.isNumber(target)) {
            if (target >= 1) {
              return Math.round(target);
            }
            if (target >= 0) {
              return Math.round(target * total);
            }
            return 0;
          }
          target = target.replace(/\s+/mg, "");
          if ((terms = target.split("-")).length > 1) {
            return this.calculateSize(orientation, terms.shift()) - this.calculateSize(orientation, terms.join("+"));
          }
          if ((terms = target.split("+")).length > 1) {
            return this.calculateSize(orientation, terms.shift()) + this.calculateSize(orientation, terms.join("+"));
          }
          if (matches = target.match(/^(\d+)px$/)) {
            return parseInt(matches[1], 10);
          }
          if (matches = target.match(/^(\d+)$/)) {
            return parseInt(matches[1], 10);
          }
          if (matches = target.match(/^(\d+(?:\.\d+)?)&$/)) {
            return Math.round(available * parseFloat(matches[1]) / 100);
          }
          if (matches = target.match(/^(\d+(?:\.\d+)?)%$/)) {
            return Math.round(total * parseFloat(matches[1]) / 100);
          }
          throw new Error("Unsupported size: " + target);
        };

        Region.prototype.consume = function(anchor, size) {
          var style;
          if (size == null) {
            size = 0;
          }

          switch (anchor) {
            case "north":
              style = {
                top: this.top + "px",
                right: this.right + "px",
                bottom: "auto",
                left: this.left + "px",
                height: size + "px",
                width: "auto"
              };
              this.top += size;
              break;
            case "east":
              style = {
                top: this.top + "px",
                right: this.right + "px",
                bottom: this.bottom + "px",
                left: "auto",
                width: size + "px",
                height: "auto"
              };
              this.right += size;
              break;
            case "south":
              style = {
                top: "auto",
                right: this.right + "px",
                bottom: this.bottom + "px",
                left: this.left + "px",
                height: size + "px",
                width: "auto"
              };
              this.bottom += size;
              break;
            case "west":
              style = {
                top: this.top + "px",
                right: "auto",
                bottom: this.bottom + "px",
                left: this.left + "px",
                width: size + "px",
                height: "auto"
              };
              this.left += size;
          }
          if (size === 0) {
            style.display = "none";
          }
          return style;
        };

        Region.prototype.getInnerRegion = function() {
          return new Region(this.width - this.right - this.left, this.height - this.top - this.bottom);
        };

        Region.prototype.getSize = function(orientation) {
          switch (orientation) {
            case "vertical":
              return this.height;
            case "horizontal":
              return this.width;
          }
        };

        Region.prototype.getAvailableSize = function(orientation) {
          switch (orientation) {
            case "vertical":
              return this.height - this.top - this.bottom;
            case "horizontal":
              return this.width - this.right - this.left;
          }
        };

        Region.prototype.toString = function() {
          return "{" + this.top + ", " + this.right + ", " + this.bottom + ", " + this.left + "}, {" + this.width + ", " + this.height + "}";
        };

        return Region;

      })();
      getOrientation = function(anchor) {
        switch (anchor) {
          case "north":
          case "south":
            return "vertical";
          case "east":
          case "west":
            return "horizontal";
        }
      };
      getScrollerStyle = function(anchor, size) {
        var style;
        style = {
          top: 0,
          right: 0,
          bottom: 0,
          left: 0
        };
        if (size) {
          switch (anchor) {
            case "north":
              style.bottom = "auto";
              style.height = size + "px";
              break;
            case "east":
              style.left = "auto";
              style.width = size + "px";
              break;
            case "south":
              style.top = "auto";
              style.height = size + "px";
              break;
            case "west":
              style.right = "auto";
              style.width = size + "px";
          }
        }
        return style;
      };
      getHandleStyle = function(anchor, region, handleSize) {
        switch (anchor) {
          case "north":
            return {
              height: (region.calculateSize('vertical', handleSize)) + "px",
              right: 0,
              left: 0,
              bottom: 0
            };
          case "south":
            return {
              height: (region.calculateSize('vertical', handleSize)) + "px",
              right: 0,
              left: 0,
              top: 0
            };
          case "east":
            return {
              width: (region.calculateSize('horizontal', handleSize)) + "px",
              top: 0,
              bottom: 0,
              left: 0
            };
          case "west":
            return {
              width: (region.calculateSize('horizontal', handleSize)) + "px",
              top: 0,
              bottom: 0,
              right: 0
            };
        }
      };
      generateSerialId = (function() {
        var counter, fun;
        counter = 0;
        fun = function() {
          return counter++;
        };
        fun.peek = function() {
          return counter;
        };
        return fun;
      })();
      return {
        restrict: "A",
        replace: true,
        require: "faPane",
        priority: 1,
        transclude: "element",
        scope: {
          anchor: "@paneAnchor",
          paneId: "@faPane",
          size: "@paneSize",
          min: "@paneMin",
          max: "@paneMax",
          handle: "@paneHandle",
          closed: "=paneClosed",
          closable: "@paneNoToggle"
        },
        template: "<div class=\"fa-pane pane-{{$pane.id}}\">\n  <div class=\"fa-pane-overlay\"></div>\n  <div class=\"fa-pane-handle\" fa-pane-resizer>\n    <div ng-if=\"!paneNotoggle\" class=\"fa-pane-toggle\" ng-click=\"$pane.toggle()\"></div>\n  </div>\n</div>",
        controllerAs: "$pane",
        controller: function() {
          var $pane, Pane;
          return $pane = new (Pane = (function() {
            function Pane() {
              this.children = [];
              this.closed = false;
              this.max = Number.MAX_VALUE;
              this.min = 0;
            }

            Pane.prototype.$scheduleReflow = function() {
              if ($pane.parent) {
                return $pane.parent.$scheduleReflow();
              } else if (!$pane.$reflowScheduled) {
                $pane.$reflowScheduled = true;
                return $rootScope.$evalAsync(function() {
                  if ($pane.$reflowScheduled) {
                    $pane.reflow();
                  }
                  return $pane.$reflowScheduled = false;
                });
              }
            };

            Pane.prototype.getOptions = function() {
              return {
                anchor: this.anchor,
                targetSize: this.targetSize,
                size: this.size,
                min: this.min,
                max: this.max,
                handle: {
                  open: this.handleSizeOpen || 0,
                  closed: this.handleSizeClosed || 0
                },
                closed: this.closed
              };
            };

            Pane.prototype.setOptions = function(options) {
              if (options == null) {
                options = {};
              }
              if (options.anchor != null) {
                this.setAnchor(options.anchor);
              }
              if (options.size != null) {
                this.setTargetSize(options.size);
              }
              if (options.min != null) {
                this.setMinSize(options.min);
              }
              if (options.max != null) {
                this.setMaxSize(options.max);
              }
              if (options.handle != null) {
                this.setHandleSize(options.handle);
              }
              if (options.closed != null) {
                return this.toggle(!options.closed);
              }
            };

            Pane.prototype.setAnchor = function(_at_anchor) {
              this.anchor = _at_anchor;
              return this.$scheduleReflow();
            };

            Pane.prototype.setTargetSize = function(_at_targetSize) {
              this.targetSize = _at_targetSize;
              return this.$scheduleReflow();
            };

            Pane.prototype.setMinSize = function(_at_min) {
              this.min = _at_min;
              return this.$scheduleReflow();
            };

            Pane.prototype.setMaxSize = function(_at_max) {
              this.max = _at_max;
              return this.$scheduleReflow();
            };

            Pane.prototype.setHandleSize = function(handleSize) {
              if ((handleSize != null ? handleSize.open : void 0) || (handleSize != null ? handleSize.closed : void 0)) {
                this.handleSizeOpen = handleSize.open || 0;
                this.handleSizeClosed = handleSize.closed || 0;
              } else {
                this.handleSizeOpen = this.handleSizeClosed = parseInt(handleSize, 10);
              }
              return this.$scheduleReflow();
            };

            Pane.prototype.addChild = function(child) {
              child.parent = $pane;
              this.children.push(child);
              if (this.children.length) {
                $pane.$containerEl.addClass("fa-pane-parent");
              }
              return $pane.$scheduleReflow();
            };

            Pane.prototype.getOrientation = function() {
              return getOrientation($pane.anchor);
            };

            Pane.prototype.onHandleDown = function() {
              return $pane.$containerEl.addClass("active");
            };

            Pane.prototype.onHandleUp = function() {
              $pane.$containerEl.removeClass("active");
              return $pane.$scheduleReflow();
            };

            Pane.prototype.removeChild = function(child) {
              var idx;
              if (!(0 > (idx = this.children.indexOf(child)))) {
                this.children.splice(idx, 1);
              }
              if (!this.children.length) {
                $pane.$containerEl.removeClass("fa-pane-parent");
              }
              return $pane.$scheduleReflow();
            };

            Pane.prototype.reflow = function(region) {
              var handleSize, height, orientation, size, styleContainer, styleHandle, styleScroller, width, _ref;
              width = $pane.$containerEl[0].offsetWidth;
              height = $pane.$containerEl[0].offsetHeight;
              region || (region = new Region(width, height));
              if ((_ref = $pane.anchor) === "north" || _ref === "east" || _ref === "south" || _ref === "west") {
                $pane.$containerEl.removeClass("fa-pane-orientation-vertical");
                $pane.$containerEl.removeClass("fa-pane-orientation-horizontal");
                orientation = getOrientation($pane.anchor);
                $pane.$containerEl.addClass("fa-pane-orientation-" + orientation);
                handleSize = region.calculateSize(orientation, !$pane.closed && $pane.handleSizeOpen || $pane.handleSizeClosed);
                if ($pane.closed) {
                  size = handleSize;
                } else {
                  size = region.calculateSize(orientation, !$pane.closed && $pane.targetSize || handleSize);
                  size = Math.min(size, region.calculateSize(orientation, $pane.max));
                  size = Math.max(size, region.calculateSize(orientation, $pane.min));
                  size = Math.min(size, region.getAvailableSize(orientation));
                  size = Math.max(size, handleSize);
                }
                this.size = size;
                styleContainer = region.consume($pane.anchor, size);
                styleScroller = getScrollerStyle($pane.anchor, size - handleSize);
                styleHandle = getHandleStyle($pane.anchor, region, handleSize);
                $pane.$containerEl.attr("style", "").css(styleContainer);
                $pane.$overlayEl.attr("style", "").css(styleScroller);
                $pane.$handleEl.attr("style", "").css(styleHandle);
                $pane.$scrollerEl.attr("style", "").css(styleScroller);
                if ($rootScope.gVariable && $rootScope.gVariable.layoutBoardSize) {
                  $rootScope.gVariable.layoutBoardSize = size + "px";
                  $window.sessionStorage.setItem("layoutBoardSize", size + "px");
                }
              } else {

                // SZ Custom HJH GJ
                // 방향에 따라 사이즈 조절
                var offset = $pane.$containerEl.offset();
                var tempHeight = ($(window).height() - offset.top) + "px";
                var $parentObj = $pane.$containerEl.closest("[pane-wrap-anchor]")
                var anchor = $parentObj.attr("pane-wrap-anchor");
                var sheight = "auto";
                var swidth = "auto";
                if(!$pane.$containerEl.hasClass("pane-root")) sheight = "auto";
                else {
                  if(anchor != "west" && anchor != "north") {
                    swidth = "100%";
                    sheight = tempHeight;
                    $parentObj.find("[fa-pane]").css("height","auto");
                    $parentObj.find("[fa-pane]").css("width","auto");
                  } else {
                    sheight = tempHeight;
                  }
                }

                $pane.$containerEl.css({
                  top: region.top + "px",
                  right: region.right + "px",
                  bottom: region.bottom + "px",
                  left: region.left + "px",
                  width: swidth,
                  height: sheight
                });
              }

              $pane.$region = region.clone();


              // HJH HJ 19.07.02
              // anchor == west 일경우
              // 자식 엘리먼트의 사이즈 조절을 하기 위해 fapane-size Attribute 속성을 추가
              // 나머지는 CSS에서 작업
              if($pane.anchor == "west") {
                var $rootPane = $pane.parent;
                var $first = $rootPane.children[0];
                var $second = $rootPane.children[1];
                var fw = $rootPane.children[0].size, sw = $rootPane.$region.width - fw;
                if (fw > 992) $first.$containerEl.attr('fapane-size', "lg");
                else if (fw > 768) $first.$containerEl.attr('fapane-size', "md");
                else if (fw > 650) $first.$containerEl.attr('fapane-size', "sm");
                else $first.$containerEl.attr('fapane-size', "xs");
                if (sw > 992) $second.$containerEl.attr('fapane-size', "lg");
                else if (sw > 768) $second.$containerEl.attr('fapane-size', "md");
                else if (sw > 650) $second.$containerEl.attr('fapane-size', "sm");
                else $second.$containerEl.attr('fapane-size', "xs");
              } else {
                if($pane.anchor != undefined) $('[fapane-size]').removeAttr('fapane-size');
              }

              return $pane.reflowChildren(region.getInnerRegion());
            };

            Pane.prototype.reflowChildren = function(region) {
              var child, _i, _len, _ref, _results;
              region || (region = $pane.$region);
              $pane.children.sort(function(a, b) {
                return a.order - b.order;
              });
              _ref = $pane.children;
              _results = [];
              for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                child = _ref[_i];
                _results.push(child.reflow(region));
              }
              return _results;
            };

            Pane.prototype.resize = function(size) {
              if (size == null) {
                size = $pane.targetSize;
              }
              $pane.targetSize = size;
              $pane.parent.reflowChildren($pane.parent.$region.getInnerRegion());
              if (size !== $pane.size) {
                return $pane.$containerEl.addClass("fa-pane-constrained");
              } else {
                return $pane.$containerEl.removeClass("fa-pane-constrained");
              }
            };

            Pane.prototype.toggle = function(open) {
              var reflow;
              if (open == null) {
                open = !!$pane.closed;
              }
              $pane.closed = !open;
              reflow = function() {
                if ($pane.parent) {
                  return $pane.parent.$scheduleReflow();
                } else {
                  return $pane.$scheduleReflow();
                }
              };
              if ($pane.closed) {
                $pane.$containerEl.addClass("fa-pane-closed");
              } else {
                $pane.$containerEl.removeClass("fa-pane-closed");
              }
              return reflow();
            };

            return Pane;

          })());
        },
        compile: function($el, $attrs, $transclude) {
          var link, serialId;
          serialId = generateSerialId();
          return link = function($scope, $el, $attrs, $pane) {
            var $directiveScope, $transcludeScope;
            $directiveScope = $scope.$parent.$new();
            $directiveScope.$pane = $scope.$pane = $pane;
            $transcludeScope = $directiveScope.$new();
            if ($pane.order == null) {
              $pane.order = serialId;
            }
            $pane.$isolateScope = $scope;
            $pane.$directiveScope = $directiveScope;
            $pane.$transcludeScope = $transcludeScope;
            return $transclude($transcludeScope, function(clone) {
              clone.addClass("fa-pane-scroller");
              $el.append(clone);
              $pane.$containerEl = $el;
              $pane.$overlayEl = $el.children().eq(0);
              $pane.$handleEl = $el.children().eq(1);
              $pane.$scrollerEl = $el.children().eq(2);
              $scope.$watch("anchor", function(anchor) {
                return $pane.setAnchor(anchor);
              });
              $scope.$watch("size", function(targetSize) {
                return $pane.setTargetSize(targetSize);
              });
              $scope.$watch("closed", function(closed) {
                return $pane.toggle(!closed);
              });
              $scope.$watch("min", function(min) {
                return $pane.setMinSize(min != null ? min : 0);
              });
              $scope.$watch("max", function(max) {
                return $pane.setMaxSize(max != null ? max : Number.MAX_VALUE);
              });
              $scope.$watch("paneId", function(paneId, prevPaneId) {
                if (prevPaneId) {
                  paneManager.remove(prevPaneId);
                }
                paneManager.set(paneId, $pane);
                return $pane.id = paneId;
              });
              $scope.$watch("handle", function(handle) {
                return $pane.setHandleSize(handle);
              });
              $pane.$directiveScope.$on("fa-pane-attach", function(e, child) {
                if (child !== $pane) {
                  e.stopPropagation();
                  return $pane.addChild(child);
                }
              });
              $pane.$directiveScope.$on("fa-pane-detach", function(e, child) {
                if (child !== $pane) {
                  e.stopPropagation();
                  return $pane.removeChild(child);
                }
              });
              $window.addEventListener("resize", function(e) {
                e.stopPropagation();
                return $pane.$scheduleReflow();
              });
              $pane.$directiveScope.$on("$stateChangeSuccess", function() {

                return $pane.$scheduleReflow();
              });
              $pane.$directiveScope.$emit("fa-pane-attach", $pane);
              return $pane.$directiveScope.$on("$destroy", function() {
                return $pane.$directiveScope.$emit("fa-pane-detach", $pane);
              });
            });
          };
        }
      };
    }
  ]);

  module.directive("faPaneToggle", [
    "paneManager", function(paneManager) {
      return {
        link: function($scope, $el, $attrs) {
          return $attrs.$observe("faPaneToggle", function(paneId) {});
        }
      };
    }
  ]);

  module.directive("faPaneResizer", [
    "$window", function($window) {
      var throttle;
      throttle = function(delay, fn) {
        var throttled;
        throttled = false;
        return function() {
          if (throttled) {
            return;
          }
          throttled = true;
          setTimeout(function() {
            return throttled = false;
          }, delay);
          return fn.call.apply(fn, [this].concat(__slice.call(arguments)));
        };
      };
      return {
        restrict: "A",
        link: function($scope, $element, $attrs, $pane) {
          var clickRadius, clickTime, el;
          $pane || ($pane = $scope.$pane);
          el = $element[0];
          clickRadius = 5;
          clickTime = 300;
          $scope.$watch((function() {
            return $pane.getOrientation();
          }), function(orientation) {
            $element.removeClass("vertical");
            $element.removeClass("horizontal");
            switch (orientation) {
              case "vertical":
                return $element.addClass("vertical");
              case "horizontal":
                return $element.addClass("horizontal");
            }
          });
          return el.addEventListener("mousedown", function(e) {
            var anchor, coord, handleMouseMove, handleMouseMoveThrottled, handleMouseUp, scale, startCoord, startPos, startSize, startTime;
            if (e.button !== 0) {
              return;
            }
            anchor = $pane.anchor;
            if (anchor === "north" || anchor === "south") {
              coord = "screenY";
            } else if (anchor === "west" || anchor === "east") {
              coord = "screenX";
            }
            if (anchor === "north" || anchor === "west") {
              scale = 1;
            } else if (anchor === "south" || anchor === "east") {
              scale = -1;
            }
            startPos = {
              x: e.screenX,
              y: e.screenY
            };
            startCoord = e[coord];
            startSize = $pane.size;
            startTime = Date.now();
            el.unselectable = "on";
            el.onselectstart = function() {
              return false;
            };
            el.style.userSelect = el.style.MozUserSelect = "none";
            e.preventDefault();
            e.defaultPrevented = true;
            e = null;
            handleMouseMove = function(e) {
              $pane.$containerEl.addClass("fa-pane-resizing");

              $scope.$apply(function() {
                var targetSize;
                // by rohbi on 2019.06.17
                targetSize = startSize + scale * (e[coord] - startCoord);
                //targetSize = startSize + scale * (startCoord - e[coord]);
                return $pane.resize(targetSize);
              });
              e.preventDefault();
              e.defaultPrevented = true;
              return e = null;
            };
            handleMouseUp = function(e) {
              var cleanup, displacementSq, timeElapsed;
              displacementSq = Math.pow(e.screenX - startPos.x, 2) + Math.pow(e.screenY - startPos.y, 2);
              timeElapsed = Date.now() - startTime;
              $window.removeEventListener("mousemove", handleMouseMoveThrottled, true);
              $window.removeEventListener("mouseup", handleMouseUp, true);
              cleanup = function() {
                $pane.$containerEl.removeClass("fa-pane-resizing");
                e.preventDefault();
                e.defaultPrevented = true;
                return e = null;
              };
              if (displacementSq <= Math.pow(clickRadius, 2) && timeElapsed <= clickTime) {
                cleanup();
                return;
              }
              handleMouseMove(e);
              return cleanup();
            };
            handleMouseMoveThrottled = throttle(10, handleMouseMove);
            $window.addEventListener("mouseup", handleMouseUp, true);
            return $window.addEventListener("mousemove", handleMouseMoveThrottled, true);
          });
        }
      };
    }
  ]);

}).call(this);


angular.module('ngDock', []).factory('dock', function () {
  var valids = ['left', 'right', 'top', 'bottom', 'fill'];
  return {
    dockRefs: {},
    valids: valids,
    handlesByDock: {
      "top": "s",
      "left": "e",
      "right": "w",
      "bottom": "n"
    },
    Area: (function () {
      function setPosition(r, s, pos) {
        r.position = 'absolute';
        if (pos != "bottom") r.top = s.top; else { r.top = 'auto'; }
        if (pos != "left") r.right = s.right; else { r.right = 'auto'; }
        if (pos != "right") r.left = s.left; else { r.left = 'auto'; }
        if (pos != "top") r.bottom = s.bottom; else { r.bottom = 'auto'; }
      }
      function decreaseSize($element, pos, s) {
        if ("top|bottom".indexOf(pos) != -1) size = $element.outerHeight(true);
        if ("left|right".indexOf(pos) != -1) size = $element.outerWidth(true);
        if (pos == "bottom") s.bottom += size;
        if (pos == "left") s.left += size;
        if (pos == "right") s.right += size;
        if (pos == "top") s.top += size;
      }
      function removeClasses($element) {
        var x = valids.length;
        while (x--)
          $element.removeClass("dock-" + valids[x]);
      }
      function update($element, pos, s) {
        var r = {};
        removeClasses($element);
        setPosition(r, s, pos);
        $element.addClass("dock-" + pos);
        $element.css(r);
        decreaseSize($element, pos, s);
      }
      var Area = function ($div, $scope) {
        var s = {
          top: 0,
          bottom: 0,
          left: 0,
          right: 0
        };
        var childList = [];
        this.addChild = function ($element, $pos) {
          var pos = $scope.$eval($pos);

          if (valids.indexOf(pos) == -1)
            throw {
              message: " : dock position must be one of this: " + valids.join(', ')
            };
          childList.push({
            element: $element,
            pos: $pos,
            order: childList.length
          });

          console.log($(".ui-resizable-handle"))
          if($(".ui-resizable-handle").length > 0) {
            if($(".ui-resizable-handle > div").length == 0)
              $(".ui-resizable-handle").append("<div></div>");
          }
          update($element, pos, s);
        };
        this.refresh = function () {
          s.top = 0;
          s.bottom = 0;
          s.left = 0;
          s.right = 0;
          for (var x = 0; x < childList.length; x++) {
            var pos = $scope.$eval(childList[x].pos);
            update(childList[x].element, pos, s);
          }
        };


        var _this = this;
        $(window).resize(function () {
          $(".ui-resizable-handle").addClass("ui-resizable-bar-area");
          _this.refresh();
          clearTimeout($.data(this, 'resizeTimer'));
          $.data(this, 'resizeTimer', setTimeout(function() {
              $(".ui-resizable-handle").removeClass("ui-resizable-bar-area");
          }, 250));
        });
        $scope.$watch(function () {
          _this.refresh();
        });
      };
      return Area;
    })()
  };
})
.directive('dockRef', function (dock) {
  return {
    restrict: "A",
    controller: function ($scope, $element) {
      $scope.__dock_ref_id = String(Math.random()).replace(/\./g, "");
      dock.dockRefs[$scope.__dock_ref_id] = new dock.Area($element, $scope);
    },
    scope: true
  };
})
.directive('dock', function (dock) {
  return {
    restrict: "A",
    controller: function ($scope, $element) {
      var dp = $element.attr('dock');
      $scope.__dock_id = String(Math.random()).replace(/\./g, "");
      var area = dock.dockRefs[$scope.$parent.__dock_ref_id];
      area.addChild($element, dp);
    },
    scope: true
  };
})
.directive("dockResizable", function (dock) {
  function enableResize($element, dp) {
    $element.resizable({
      handles: dock.handlesByDock[dp]
    });
  }
  return {
    require: 'dock',
    restrict: "A",
    controller: function ($scope, $element) {

      var dp = $scope.$eval($element.attr('dock'));
      if (dock.valids.indexOf(dp) >= 0 && dp != "fill") enableResize($element, dp);
      $scope.$watch(function () {
        var newdp = $scope.$eval($element.attr('dock'));
        if (newdp != dp) {
          if (dock.valids.indexOf(newdp) == -1)
            throw {
              message: "> dock position must be one of this: " + valids.join(', ')
            };
          dp = newdp;
          $element.resizable('destroy');
          if (newdp != 'fill') enableResize($element, dp);
        }
      });
    }
  };
});


angular.module('AuthServices', [ 'ngResource' ]).factory('Auth', function($resource, $rootScope, $window) {

  var auth = {};
  //auth.permissions = {'app.system.user-list':true,'app.system.department-list':false};
  auth.permissions = null;

  auth.init = function(perm) {
    auth.permissions = {};

    angular.forEach(perm, function(item) {
      auth.permissions[item.PageUrl] = item;
    });

    $window.sessionStorage.setItem("authPer", angular.toJson(auth.permissions))
  };

  auth.checkPermissionForView = function(view) {
    if (auth.permissions == null) {
      auth.permissions = angular.fromJson($window.sessionStorage.getItem("authPer"));
    }

    if (!view.requiresAuthentication) {
      return true;
    }

    return userHasPermissionForView(view);
  };

  var userHasPermissionForView = function(view) {
    if (!auth.isLoggedIn()) {
      return false;
    }

    return auth.userHasPermission(view.name);
  };

  auth.userHasPermission = function(viewName) {
    if (!auth.isLoggedIn()) {
      return false;
    }

    //console.log('2 permissions=', auth.permissions);
    //console.log('auth.permissions[viewName]=', auth.permissions[viewName]);

    if (auth.permissions == null) {
      auth.permissions = angular.fromJson($window.sessionStorage.getItem("authPer"));
    }

    if (auth.permissions == null) {
      return false;
    }

    /* console.log(viewName); */

    if (viewName.indexOf(':') == -1) {
      if (auth.permissions[viewName] == null) {
        //console.log('auth.permissions viewName null');
        //return false;
        return true;
      }

      if (auth.permissions[viewName]['read'] == 'Y') {
        return true;
      }
    } else {
      var view = viewName.split(':')[0];
      var button = viewName.split(':')[1];

      if (auth.permissions[view] == null || auth.permissions[view][button] == null) {
        return false;
      }

      if (auth.permissions[view][button] == 'Y') {
        return true;
      }
    }

    return false;
  };

  auth.currentUser = function() {
    return $window.sessionStorage.user;
  };

  auth.isLoggedIn = function() {
    return $window.sessionStorage.loginUserIdx != null;
  };

  return auth;
});

//"use strict";
/**
 * @ngdoc Service, Directive
 * @since 2020-01-08
 * @description 
 *   데이터를 입력하여 자동으로 화면을 그려주는 서비스
 *   !!!!중요!!!
 *    - fa-pane 을 통해서 화면을 나누었을 시 동일한 이름으로 변수를 지정하면
 *      리스트화면에 autoPage의 데이터를 변경함
 *      그러한 이유로 변수 선언시 리스트는 apL, 상세는 apD로 변수 선언(서로 다르게)
 *      테스트를 해본 건 아니지만 TAB 역시 비슷할 것으로 보임
 * @version 1.0
 * @namespace autoPage
 */

/******************************************************************************** */
// 확장 기능 개발 구간 시작
/******************************************************************************** */
/******************************************************************************** */
// Override 정의 함수
// 지정 함수가 없을 경우  autoPage에서 자동 바인딩
// 함수는 vm에 무조건 연동 
// ex1) vm.getList = function(){};
// ex2) function getList(){}; vm.getList = getList;

// setLayout = fa-pane 기본 구조 설정
// setChangeLayout = fa-pane 레이아웃 변경 버튼 클릭
// getData (getInitData 함수로 통합) = 상세화면 초기 값 호출
// getList (getInitData 함수로 통합) = 리스트화면 데이터 호출
// getListCnt (getInitData 함수로 통합) = 리스트화면 카운트 : MapperId->init->LIST_CNT_SQL 가 있으면 자동제외
// getInitData = 초기 데이터 호출 (MapperId -> init 에서 호출되는 MapperId)
// setSortColumn = 테이블 정렬
// setSortDirect = 정렬 설정에 따른 Grid header Icon 표시 
// setResetSearch = 검색항목 초기화
// setChangeViewSize = 목록 당 조회 건수 변경

// setPageChanged = 페이지 클릭시 호출 함수
// getSearch = 검색 버튼 클릭 시

// goDetail = 상세페이지 이동 (삭제 - 무조건 edit 파일로 가서 disabled, ng-if를 통해 처리하기를 권함) 
// goAdd = 추가페이지 이동

// getExcelFile = 엑셀 다운로드
// setDelList = 리스트 항목 삭제(미구현)


/******************************************************************************** */

/* "use strict"; */
webapp.service('autoPage', 
  ['GLOBAL_CONSTANT', 'StaticVariable', '$rootScope', '$window', '$state', '$stateParams', 'postApi', '$compile', '$interval', '$filter', 'modalFactory', '$timeout', 'gAlert', 'gConfirm', '$translate',
  function autoPage(CONSTANT, StaticVariable, $rootScope, $window, $state, $stateParams, postApi, $compile, $interval, $filter, modalFactory, $timeout, gAlert, gConfirm, $translate) {
    return function(){
      var fns = {
        timeSec : 100,
        datas : {},
        copyVm : {},
        dateInfo : [],
        vaultObj : [],
        tempUploadFile : [],
        uploadFileList : [],
        checkValutUpload : false,
        pageType : { LIST : "LIST", DETAIL : "DETAIL", EDIT : "EDIT", CONTENT : "CONTENT", VIEW : "VIEW",},
        setData : function(DATA) { 
          this.copyVm = angular.copy(DATA.vm);
          this.datas = DATA;
        },
        getData : function() { return this.datas; },
        checkEmptyType : function(type) { return (typeof type == 'undefined') ? true : false; },
        init : function() {
          var D = this.datas;
          var thisObj = this;

          if(D.vm.keyId != undefined) $rootScope.gVariable.listKeyId = D.vm.keyId;

          D.scope.$watch('$viewContentLoaded', function(){
            if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
              D.vm.getInitDataExt();
            }
          });
        },
        initSrchData : function() {
          var D = this.datas;
          if (D.vm.srchMem) {
            angular.copy(D.vm.srchMem, D.vm.srch);
          }
        },
        initView : function() {
          var D = this.datas;
          var thisObj = this;
          if(D.pageType.toUpperCase() == thisObj.pageType.LIST) {
            if(D.listStack == undefined || D.listStack == true)
              $rootScope.gVariable.listKeyId = '';
          }
          D.scope.$watch('$viewContentLoaded', function(){
            if (D.FormGroup != undefined && D.FormGroup.length > 0) {
              thisObj.drawFormBox(D);  
            } else {
              D.FormGroup = [];
              thisObj.setModalFn(D);
            }
            
            if(D.pageType.toUpperCase() == thisObj.pageType.LIST && thisObj.checkEmptyType(D.vm.setLayout)) thisObj.setLayout(D);
           
            if(D.pageType.toUpperCase() == thisObj.pageType.LIST) {
              
              if(thisObj.datas.enableListCheck != undefined) {
                thisObj.datas.vm.listCheckboxEnable = thisObj.datas.enableListCheck;
              } else {
                thisObj.datas.vm.listCheckboxEnable = false;
              }
              thisObj.initListTableSortField(D);
              thisObj.initListDefaultVmFnc(D);
              D.vm.listSize = CONSTANT.PAGINATION.NEW_LISTSIZE;
              D.vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
              if (D.vm.headerTitle == '전체 회원 리스트') {
                D.vm.viewSize = 25;
              }
              D.vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
              D.vm.srchList = {};
              D.vm.columnMap = {};
              angular.copy(D.vm.srch, D.vm.srchList);
            } else {
              D.vm.layout = $rootScope.gVariable.layoutBoard;
              $rootScope.gVariable.listKeyId = D.vm.keyId;
              thisObj.initViewDefaultVmFnc(D);
            }

            if(thisObj.checkEmptyType(D.vm.getInitData)) {
              thisObj.initBindingVm(D);
              if(D.pageType.toUpperCase() == thisObj.pageType.VIEW) {
                D.vm.data = {};
              }
              thisObj.getBindInitData(D);
            }
          });
        },
        initViewDefaultVmFnc : function(D) {
          var thisObj = this;
          if(this.checkEmptyType(D.vm.goList)) {
            D.vm.goList = function() {
              var url = "", param = {};
              if (D.vm.layout == 'N') {
                url = D.PageUrl.LIST_PAGE_URL.url;
              } else {
                url = D.PageUrl.LIST_EDIT_PAGE_URL.url;
              }

              var srch = D.stateParams.srch; // 검색 옵션
              if(url == undefined) {
                if (D.vm.layout == 'N') {
                  url = D.PageUrl.LIST_PAGE_URL;
                } else {
                  url = D.PageUrl.LIST_EDIT_PAGE_URL;
                }
                param = {};
              } else {
                if (D.vm.layout == 'N') {
                  param = D.PageUrl.LIST_PAGE_URL.param;
                } else {
                  param = D.PageUrl.LIST_EDIT_PAGE_URL.param;
                }
              }
              if(srch != undefined) param.srch = srch             
              else param.srch = "";
              param = JSON.stringify(param);
              if (D.vm.layout == 'N') {
                if (isNullOrEmpty(D.vm.keyId)) {
                  // 신규등록 -> 목록 화면 이동
                  $state.go(url, JSON.parse(param) , {reload: url});
                } else {
                  $state.go(url, JSON.parse(param) , {reload: url});
                }
              } else {
              }
            };
          }

          if(this.checkEmptyType(D.vm.setDelData)) {
            D.vm.setDelData = function() {
              gConfirm('', 'Menu.DELETECONFIRM', {
                btn: '',
                fn: function () {
                  // 데이터 삭제
                  if (D.vm.data == null) {
                    // 삭제할 데이터 미 존재
                    gAlert('', 'Menu.CANNOTDELETE');
                    return;
                  }

                  var url = "", param = {};
                  url = D.PageUrl.LIST_PAGE_URL.url;
                  var srch = D.stateParams.srch; // 검색 옵션
                  if(url == undefined) {
                    url = D.PageUrl.LIST_PAGE_URL;
                    param = {};
                  } else {
                    param = D.PageUrl.LIST_PAGE_URL.param;
                  }
                  if(srch != undefined) param.srch = srch
                  else param.srch = "";
                  param = JSON.stringify(param);
                  $state.go(url, JSON.parse(param) , {reload: url});
                }
              }, {
                btn: '',
                fn: function () {
                  // 취소
                }
              });
            };
          }
        }, 
        initListDefaultVmFnc : function(D) {
          var thisObj = this;
          if(this.checkEmptyType(D.vm.setResetSearch)) {
            D.vm.setResetSearch = function() {
              D.vm.srch = {};
              D.vm.srch.page = 1;
              D.vm.srch.viewSize = !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10; // 페이지당 조회건수
              if (D.vm.headerTitle == '전체 회원 리스트') {
                D.vm.srch.viewSize = 25;
              }
              thisObj.getListSearch();
            };
          }
          if(this.checkEmptyType(D.vm.setChangeViewSize)) {
            D.vm.setChangeViewSize = function() {
              if(D.vm.srch) {
                D.vm.srch.page = 1;
              }
              D.vm.currentPage = 1; // 1페이지 부터 조회
              D.vm.viewSize = D.vm.srch.viewSize; // 목록 당 조회 건수
              thisObj.getListSearch();
            };
          }

          if(thisObj.datas.enableListCheck != undefined) {
            if(this.checkEmptyType(D.vm.chkRowChg)) {
              D.vm.chkRowChg = function(data) {
               
              };
            }
            if(this.checkEmptyType(D.vm.chkRowAll)) {
              D.vm.chkRowAll = function() {
                for(var i = 0 ; i < D.vm.lists.length; i++) {
                  D.vm.lists[i].chkRow = D.vm.checkListCheckbox;
                }
              };
            } 
          }

          
          if(this.checkEmptyType(D.vm.getListKeyId)) {
            D.vm.getListKeyId = function() {
              if(D.rootScope != undefined) {
                return D.rootScope.gVariable.listKeyId;
              } else return '';
            };
          }
          

          if(this.checkEmptyType(D.vm.setPageChanged)) {
            D.vm.setPageChanged = function() {
              // D.vm.currentPage = 1; // 1페이지 부터 조회
              // D.vm.viewSize = D.vm.srch.viewSize; // 목록 당 조회 건수
              // thisObj.getListSearch();

              D.vm.srch.page = D.vm.currentPage; // 조회 할 페이지 번호
              D.vm.currentPage = D.vm.currentPage;
              thisObj.getListSearch();
            };
          }

          if(this.checkEmptyType(D.vm.getSearch)) {
            D.vm.getSearch = function() {
              /* var limitedBeforeYear = moment().add(-2, 'years').format("YYYY-MM-DD"); 
              var limitedAfterYear = moment().add(+2, 'years').format("YYYY-MM-DD"); 
              if (D.vm.headerTitle == '전체 회원 리스트') {
                if (D.vm.srch.memberType != 'A') {
                  if (isNullOrEmpty(D.vm.srch.CustNm) && isNullOrEmpty(D.vm.srch.CustCode) && isNullOrEmpty(D.vm.srch.Manager) && isNullOrEmpty(D.vm.srch.RegManage)) {
                    if ((isNullOrEmpty(D.vm.srch.ExpirdDate_Str) || isNullOrEmpty(D.vm.srch.ExpirdDate_End)) && (isNullOrEmpty(D.vm.srch.LockerDate_Str) || isNullOrEmpty(D.vm.srch.LockerDate_End)) && (isNullOrEmpty(D.vm.srch.PayDate_Str) || isNullOrEmpty(D.vm.srch.PayDate_End))) {
                      gAlert('', '입력된 날짜가 없습니다. 기간 검색은 2년까지 가능합니다.');
                      return false;
                    } else if ((D.vm.srch.LockerDate_Str < limitedBeforeYear || D.vm.srch.LockerDate_End > limitedAfterYear)) {
                      gAlert('', '검색 기간이 2년을 초과하였습니다. 기간 검색은 2년까지 가능합니다.');
                      return false;
                    } else if (D.vm.srch.ExpirdDate_Str < limitedBeforeYear || D.vm.srch.ExpirdDate_End > limitedAfterYear) {
                      gAlert('', '검색 기간이 2년을 초과하였습니다. 기간 검색은 2년까지 가능합니다.');
                      return false;
                    } else if (D.vm.srch.PayDate_Str < limitedBeforeYear || D.vm.srch.PayDate_End > limitedAfterYear) {
                      gAlert('', '검색 기간이 2년을 초과하였습니다. 기간 검색은 2년까지 가능합니다.');
                      return false;
                    }
                  }
                }
              } */
              thisObj.getListSearch();
            };
          }

          if(this.checkEmptyType(D.vm.setDelData)) {
            D.vm.setDelData = function() {
              gConfirm('', 'Menu.DELETECONFIRM', {
                btn : '',
                fn : function() {
                  var delList = [];
                  angular.forEach(D.vm.lists, function (item) {
                    if(item.chkRow) {
                      delList.push(item.KeyId)
                    }
                  });

                  if (delList.length == 0)
                  {
                    gAlert('', 'Menu.DELETENODATA');
                    return false;
                  }

                  var param = {};
                  param.mapCode = thisObj.datas.MapperId.del;
                  param.KeyIdList = angular.copy(delList);

                  postApi.update(param, function (result) {
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      gAlert('', 'Menu.DELETED', {
                        btn : '',
                        fn : function() {
                          $state.reload();
                        }
                      });
                    }
                  }, function (error) {
                    console.error("Error> setDelListAction()");
                    console.table(error);
                  });
                }
              }, {
                btn : '',
                fn : function() {
                }
              });
            };
          }
         
          if(D.pageType.toUpperCase() == thisObj.pageType.LIST) {
            
            if(D.MapperId.excel != undefined) {
              if(this.checkEmptyType(D.vm.getExcelFile)) {
                D.vm.getExcelFile = function() {
                  if(D.vm.lists.length == undefined) {
                    gAlert("","조회 후 엑셀을 다운로드 하십시오.");
                    return;
                  }
                  if(D.vm.lists.length == 0) {
                    gAlert("","Menu.데이터가 없습니다.");
                    return;
                  }
                  var header = [];
                  var a = document.createElement("a");
                  document.body.appendChild(a);
                  var data = angular.copy(D.vm.srch);
                  data.viewSize = 0;
                  data.mapCode = D.MapperId.excel.EXCEL_SQL;

                  if(D.enableListCheck == true) {
                    var ExcelAddList = [];
                    for(var i = 0; i < D.vm.lists.length; i++) {
                      if(D.vm.lists[i].chkRow) {
                        var t = {
                          KeyId : D.vm.lists[i].KeyId
                        }
                        ExcelAddList.push(t);
                      }                      
                    }
                    if(ExcelAddList.length > 0) {
                      data.atList = angular.copy(ExcelAddList);
                    }
                  }

                  postApi.select(data, function (result) {
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      D.scope.jsonToExport = result.body.docs;
                      D.scope.fileName = D.MapperId.excel.EXCEL_TITLE;
                      D.scope.exportData = [];
                      var obj = [];
                      angular.forEach(result.body.desc, function (item) {
                        if(item.ListColumnShowYN == "Y") {
                          obj.push(item.ColumnLogicalNm);
                        }
                      });
                      D.scope.exportData.push(obj);
                      angular.forEach(D.scope.jsonToExport, function(value) {
                        obj = [];
                        angular.forEach(result.body.desc, function(item) {
                          if(item.ColumnLogicalDataType == '40') {
                            if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                              obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                            } else {
                              obj.push(value[item.ColumnPhysicalNm]);
                            }
                          } else {
                            obj.push(value[item.ColumnPhysicalNm]);
                          }
                        });
                        D.scope.exportData.push(obj);
                      });     
                      $rootScope.excelDown(D.scope.exportData,D.MapperId.excel.EXCEL_TITLE);
                    }
                  }, function (error) {
                    // 조회 중 오류 발생
                    console.error("Error> getExcelFile()");
                    console.table(error);
                  });
                }
              }
            }
  
            if(this.checkEmptyType(D.vm.goEdit)) {
              D.vm.goEdit = function(p) {
                var srch = D.stateParams.srch; // 검색 옵션
                //D.vm.KeyId = p.KeyId;
  
                try {
                  var url = "", param = {};
                  if (D.vm.layout == 'N') {
                    // 등록/수정 화면 이동
                    url = D.PageUrl.EDIT_PAGE_URL.url; 
                    if(url == undefined) {
                      url = D.PageUrl.EDIT_PAGE_URL;
                      param = {};
                    } else {
                      param = D.PageUrl.EDIT_PAGE_URL.param;
                    }
                  } else {
                    url = D.PageUrl.LIST_EDIT_PAGE_URL.url;
                    if(url == undefined) {
                      url = D.PageUrl.LIST_EDIT_PAGE_URL;
                      param = {};
                    } else {
                      param = D.PageUrl.LIST_EDIT_PAGE_URL.param;
                    }
                  }
                  
                  if(param == undefined) param = {};
                  if(srch != undefined) param.srch = srch
                  else param.srch = "";
                  if(!isNullOrEmpty(p.KeyId)) {
                    param.KeyId = p.KeyId;
                    param.keyId = p.KeyId;
                  } else {
                    param.KeyId = p.keyId;
                    param.keyId = p.keyId;
                  }
                                    
                  param = JSON.stringify(param);              
                  $state.go(url, JSON.parse(param) , {reload: url});
                } catch (e) {
                  console.error("PageUrl.EDIT_PAGE_URL 을 추가 하시거나 goEdit 함수를 오버라이드 하세요.");
                }
                
              };
            }
  
            if(this.checkEmptyType(D.vm.goAdd)) {
              D.vm.goAdd = function(keyId) {
                keyId = '';
                var srch = D.stateParams.srch; // 검색 옵션
                D.vm.keyId = keyId;
         
                var url = "", param = {};
                if (D.vm.layout == 'N') {
                  // 등록/수정 화면 이동
                  url = D.PageUrl.EDIT_PAGE_URL.url;
                  if(url == undefined) {
                    url = D.PageUrl.EDIT_PAGE_URL;
                    param = {};
                  } else {
                    param = D.PageUrl.EDIT_PAGE_URL.param;
                  }
                } else {
                  url = D.PageUrl.LIST_EDIT_PAGE_URL.url; 
                  if(url == undefined) {
                    url = D.PageUrl.LIST_EDIT_PAGE_URL;
                    param = {};
                  } else {
                    param = D.PageUrl.LIST_EDIT_PAGE_URL.param;
                  }
                }
                
                if(param == undefined) param = {};
                if(srch != undefined) param.srch = srch
                else param.srch = "";
                param.keyId = keyId;
                param = JSON.stringify(param);              
                $state.go(url, JSON.parse(param) , {reload: url});
              }
            }
  
            D.vm.listToPage = function(data) {

              D.vm.keyId = data.KeyId;
              try {
                if(D.PageUrl.LIST_DETAIL_PAGE_URL != undefined) {
                  //D.vm.goDetail(keyId);
                  D.vm.goEdit(data);
                } else {
                  D.vm.goEdit(data);
                }
              } catch(e) {
                D.vm.goEdit(data);
              }
              
            }
          }
        },
  
        initListTableSortField : function(D) {
          var thisObj = this;
  
          if(this.checkEmptyType(D.vm.setSortColumn)) {
            D.vm.setSortColumn = function(sortColumn, isSortable, liCol) {
              if (isSortable == 'N') return;
              // 정렬순서(오름차순, 내림차순) 설정
              if (D.vm.srch.sortColumn != sortColumn) {
                D.vm.srch.sortDirect = "ASC";
              } else if (D.vm.srch.sortColumn == sortColumn){ 
                if(D.vm.srch.sortDirect == "ASC") {
                  D.vm.srch.sortDirect = "DESC"
                } else {
                  D.vm.srch.sortDirect = "ASC"
                }
              } else {
                D.vm.srch.sortDirect = (D.vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
              }
              D.vm.srch.sortColumn = sortColumn;
              thisObj.getListSearch();
            }
          }
  
          if(this.checkEmptyType(D.vm.setSortColumn)) {
            D.vm.setSortDirect = function(sortColumn) {
              if (sortColumn != D.vm.srch.sortColumn) {
                return 'fa fa-sort';
              }
              var rtnval = '';
              // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
              (D.vm.srch.sortDirect == 'ASC') ? rtnval = 'fa fa-caret-down' : rtnval = 'fa fa-caret-up';
              
              return rtnval;
            }
          }
        },
        getListSearch : function() {
          var thisObj = this;
          var D = thisObj.datas;
          var srch = D.vm.srch; // 검색 옵션
          var url = null;
          var param = {};
          var listStack = true;
          if(D.listStack != undefined) listStack = D.listStack;

          if(listStack) {
            url = D.PageUrl.LIST_PAGE_URL.url; 
            if(url == undefined) {
              url = D.PageUrl.LIST_PAGE_URL;
              param = {};
            } else {
              param = D.PageUrl.LIST_PAGE_URL.param;
            }    
            if(param == undefined) param = {};
            if(srch != undefined) {
              for(var i = 0; i < this.dateInfo.length; i++) {
                var at = this.dateInfo[i].key.replace("vm.","");
                if(at.indexOf("_Str") != -1) {
                  srch[at] = $filter('localToUtc')(srch[at],'from');
                } 
                if(at.indexOf("_End") != -1) {
                  srch[at] = $filter('localToUtc')(srch[at],'to');
                }
              }
              param.srch =  encodeURIComponent(JSON.stringify(srch));
            } else { 
              param.srch = "";
            }
            param = JSON.stringify(param);          
            $state.go(url, JSON.parse(param) , {reload: url});
          } else {
            this.getBindListDataExt(D, "List");
          }
        },
        select : function(data, callback) {
          postApi.select(data, function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) 
              callback(result.body.docs);
          }, function(error) {
            console.table(error);
          });
        },
        commit : function(data, callback) {
          
          var thisObj = this;
          var D = thisObj.datas;

          if(D.pageType == undefined) {
            var thisObj = this;
            var D = thisObj.datas;
            var count = 0;
            try {
              var interval = $interval(function(){
                if(!thisObj.checkValutUpload) {
                  thisObj.checkValutUpload = true;
                  if(thisObj.vaultObj.length > 0) {
                    if( (count) == thisObj.vaultObj.length) {
                      thisObj.checkValutUpload = false;
                      $interval.cancel(interval);
                      thisObj.saveContentData(data, callback);
                    } else {
                      uploadVaultFile(thisObj.vaultObj[count]);
                    }
                    count++;
                  } else {
                    thisObj.checkValutUpload = false;
                    $interval.cancel(interval);
                    thisObj.saveContentData(data, callback);
                  }
                } else {
                  thisObj.checkValutUpload = false;
                  $interval.cancel(interval);
                  thisObj.saveContentData(data, callback);
                }          
              },500);
            } catch (e) {
              $interval.cancel(interval);
              console.table(e);
            }
          } else {
            if(D.pageType.toUpperCase() != this.pageType.LIST) {
              var thisObj = this;
              var D = thisObj.datas;
              var count = 0;
              try {
                var interval = $interval(function(){
                  if(!thisObj.checkValutUpload) {
                    thisObj.checkValutUpload = true;
                    if(thisObj.vaultObj.length > 0) {
                      if( (count) == thisObj.vaultObj.length) {
                        thisObj.checkValutUpload = false;
                        $interval.cancel(interval);
                        thisObj.saveContentData(data, callback);
                      } else {
                        uploadVaultFile(thisObj.vaultObj[count]);
                      }
                      count++;
                    } else {
                      thisObj.checkValutUpload = false;
                      $interval.cancel(interval);
                      thisObj.saveContentData(data, callback);
                    }
                  } else {
                    thisObj.checkValutUpload = false;
                    $interval.cancel(interval);
                    thisObj.saveContentData(data, callback);
                  }          
                },500);
              } catch (e) {
                $interval.cancel(interval);
                console.table(e);
              }
            } else {
              var thisObj = this;
              var D = thisObj.datas;
              var count = 0;
              try {
                var interval = $interval(function(){
                  if(!thisObj.checkValutUpload) {
                    thisObj.checkValutUpload = true;
                    if(thisObj.vaultObj.length > 0) {
                      if( (count) == thisObj.vaultObj.length) {
                        thisObj.checkValutUpload = false;
                        $interval.cancel(interval);
                        thisObj.saveContentData(data, callback);
                      } else {
                        uploadVaultFile(thisObj.vaultObj[count]);
                      }
                      count++;
                    } else {
                      thisObj.checkValutUpload = false;
                      $interval.cancel(interval);
                      thisObj.saveContentData(data, callback);
                    }
                  } else {
                    thisObj.checkValutUpload = false;
                    $interval.cancel(interval);
                    thisObj.saveContentData(data, callback);
                  }          
                },500);
              } catch (e) {
                $interval.cancel(interval);
                console.table(e);
              }
              }
          }
        },
        saveContentData : function(data, callback) {
          var thisObj = this;
          var D = thisObj.datas;
          data = angular.copy(data);

          // data에 keyId가 넘어왔을 경우에는 vm 이 아닌
          // 넘겨온 데이터를 기준으로 key값을 조회한다.
          var checkUpdate = false;
          if(data != undefined) {
            if(!isNullOrEmpty(data.keyId)) {
              checkUpdate = true;
              data.KeyId = data.KeyId;
            } else if(!isNullOrEmpty(data.KeyId)) {
              checkUpdate = false;
              data.keyId = data.KeyId;
            }

            var uploadFileData = [];          
            for(var i = 0; i < thisObj.uploadFileList.length; i++) {
              var at = thisObj.uploadFileList[i];
              for(var j = 0; j < at.length; j++) {
                if(at[j].tmpLink) {
                  at[j].grpId = i+1;
                  uploadFileData.push(at[j]);
                } else if (at[j].delState == "delete") {
                  uploadFileData.push(at[j]);
                }
              }
            }
            data.uploadFileList = [];
            angular.forEach(uploadFileData, function(item) {
              D.vm.data.uploadFileList.push(item);
            });

            for(var i = 0; i < thisObj.dateInfo.length; i++) {            
              var at = thisObj.dateInfo[i];
              if(at.type == "date") {
                var keyObj =  thisObj.getStrObjectValue(D, at.bindKey);
                data[at.key.replace("vc.","").replace("vm.","")] = keyObj;
              } else {
                var keyObj =  thisObj.getStrObjectValue(D, at.key);
                var utcDate = null;
                if (!at.datetype) {
                  utcDate = $filter('localToUtc')(keyObj);
                  data[at.key.replace("vc.","").replace("vm.","")] = utcDate;
                } else {
                  if(Array.isArray(at.datetype)) {
                    for(var k = 0; k < at.datetype.length; k++) {
                      utcDate = $filter('localToUtc')(keyObj, at.datetype[k]);
                      data[at.key.replace("vc.","").replace("vm.","")] = utcDate;
                    }
                  } else {
                    utcDate = $filter('localToUtc')(keyObj, at.datetype);
                    data[at.key.replace("vc.","").replace("vm.","")] = utcDate;
                  }
                }
              }
            }
            
            if (isNullOrEmpty(data.keyId) && isNullOrEmpty(data.KeyId)) {
              checkUpdate = false;
            } else {
              checkUpdate = true;
              if(isNullOrEmpty(data.KeyId)) {
                data.KeyId = data.keyId;
              }
            }

          } else {

            var uploadFileData = [];          
            for(var i = 0; i < thisObj.uploadFileList.length; i++) {
              var at = thisObj.uploadFileList[i];
              for(var j = 0; j < at.length; j++) {
                if(at[j].tmpLink) {
                  at[j].grpId = i+1;
                  uploadFileData.push(at[j]);
                } else if (at[j].delState == "delete") {
                  uploadFileData.push(at[j]);
                }
              }
            }
            D.vm.data.uploadFileList = [];
            angular.forEach(uploadFileData, function(item) {
              D.vm.data.uploadFileList.push(item);
            });

            for(var i = 0; i < thisObj.dateInfo.length; i++) {            
              var at = thisObj.dateInfo[i];
              if(at.type == "date") {
                var keyObj =  thisObj.getStrObjectValue(D, at.bindKey);
                data[at.key.replace("vc.","").replace("vm.","")] = keyObj;
              } else {
                var keyObj =  thisObj.getStrObjectValue(D, at.key);
                var utcDate = null;
                if (!at.datetype) {
                  utcDate = $filter('localToUtc')(keyObj);
                  data[at.key.replace("vc.","").replace("vm.","")] = utcDate;
                } else {
                  if(Array.isArray(at.datetype)) {
                    for(var k = 0; k < at.datetype.length; k++) {
                      utcDate = $filter('localToUtc')(keyObj, at.datetype[k]);
                      data[at.key.replace("vc.","").replace("vm.","")] = utcDate;
                    }
                  } else {
                    utcDate = $filter('localToUtc')(keyObj, at.datetype);
                    data[at.key.replace("vc.","").replace("vm.","")] = utcDate;
                  }
                }
              }
            }
            
            if (isNullOrEmpty(D.vm.keyId) && isNullOrEmpty(D.vm.KeyId)) {
              checkUpdate = false;
            } else {
              checkUpdate = true;
              if(isNullOrEmpty(D.vm.KeyId)) {
                D.vm.KeyId = D.vm.KeyId;
              }
            }
          }

          var toastMsg = '';
          if(data.toastMsg != undefined) {
            toastMsg = data.toastMsg;
          }

          if (!checkUpdate) {
            // 신규 등록
            var param = {};
            if(data == undefined) {
              param = angular.copy(D.vm.data);
            } else {
              param = angular.copy(data);
            }

            if(data != undefined) {
              // if(!isNullOrEmpty(data.mapCode)) {
              // } else if(!isNullOrEmpty(data.KeyId)) {
              //   param.mapCode = D.MapperId.insert;
              // }
              if(typeof(data.mapCode) != 'string' ) {
                if(data.mapCode.insert == undefined) {
                  var result = {};
                  result.header = {status:405, msg: "This service requires a 'mapCode.insert' key for data."};
                  result.body = {};
                  console.error(result.header);
                } else {
                  param.mapCode = data.mapCode.insert;    
                }
              } else {
                param.mapCode = data.mapCode;
              }

            } else {
              param.mapCode = D.MapperId.insert;
            }

           
            postApi.insert(param, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                //D.vm.goList();
                //keyId
                //if(data == undefined) {
                  D.vm.keyId = result.body.docs[0].RelateDataId;
                //}
 
                if(toastMsg != "") {
                  $rootScope.showSimpleToast(toastMsg);
                }

                if(callback != undefined) {
                  callback(result);
                  return;
                } else {
                  var url = "", param = {};
                  url = D.PageUrl.LIST_PAGE_URL.url;
                  if (D.vm.layout == 'N') {
                    url = D.PageUrl.EDIT_PAGE_URL.url;
                  } else {
                    url = D.PageUrl.LIST_EDIT_PAGE_URL.url;
                  }
                  var srch = D.stateParams.srch; // 검색 옵션
                  
                  if(url == undefined) {
                    if (D.vm.layout == 'N') {
                      url = D.PageUrl.EDIT_PAGE_URL;
                      param = {};
                    } else {
                      url = D.PageUrl.LIST_EDIT_PAGE_URL;
                      param = {};
                    }
                  } else {
                    if (D.vm.layout == 'N') {
                      param = D.PageUrl.EDIT_PAGE_URL.param;
                    } else {
                      param = D.PageUrl.LIST_EDIT_PAGE_URL.param;
                    }
                  }
                  
                  param.keyId = D.vm.keyId;
                  param.srch = "";
                  param = JSON.stringify(param);

                  $state.go(url, JSON.parse(param) , {reload: url});
                }

                // 테스트해봐야함
              } else {
                console.error("Error> commit.InsertData()");  
              }
            }, function (error) {
              console.error("Error> setData()");
              console.table(error);
            });
          } else {
          // 수정
           
            var param = {};
            if(data == undefined) {
              param = angular.copy(D.vm.data);
            } else {
              param = angular.copy(data);
            }

            if(data != undefined) {
              if(typeof(data.mapCode) != 'string' ) {
                if(data.mapCode.update == undefined) {
                  var result = {};
                  result.header = {status:405, msg: "This service requires a 'mapCode.update' key for data."};
                  result.body = {};
                  console.error(result.header);
                } else {
                  param.mapCode = data.mapCode.update;    
                }
              }
            } else {
              param.mapCode = D.MapperId.update;
            }


            postApi.update(param, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {

                if(toastMsg != "") {
                  $rootScope.showSimpleToast(toastMsg);
                } else {
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                }
                // gAlert("", "Menu.SAVED", {
                //   btn: "",
                //   fn: function () {
                    // 화면 분할 모드에 따른 이동
                    if(callback != undefined) {
                      callback(result);
                      return;
                    } else {
                      $state.reload();
                    }
                //   }
                // });
              }
            }, function (error) {
              console.error("Error> setData()");
              gAlert('', 'Menu.EXCEPTIONOCCURED');
            });
          }
          
        },
        getBindInitData : function(D) {
          if(D.pageType.toUpperCase() == this.pageType.LIST) {
            this.getBindListDataExt(D, "List");
          } else if(D.pageType.toUpperCase() == this.pageType.DETAIL) {
  
          } else if(D.pageType.toUpperCase() == this.pageType.EDIT) {
  
          } else if(D.pageType.toUpperCase() == this.pageType.VIEW) {
            this.getBindListDataExt(D, "Edit");
          } 
        },
        setChangeDateUTC : function(D) {
          var srch = angular.copy(D.vm.srch);
          var srchKeys = Object.keys(srch);

          if(D.FormGroup != undefined) {
            for(var i = 0 ; i < srchKeys.length; i++) {
              for(var j = 0 ; j < D.FormGroup.length; j++) {
                var field = D.FormGroup[j].field;
                if(!field) field = [];
                for(var k = 0 ; k < field.length; k++) {
                  var at = field[k], bindKey = at.bindKey, type = at.type;
                  var utcYn = (at.utcYn != undefined) ? utcYn = at.utcYn : utcYn = false;
                  if(type == "date" && utcYn) {                  
                    if(Array.isArray(bindKey)) {
                      for(var l = 0; l < bindKey.length; l++) {
                        var bindKey2 = bindKey[l].split(".");
                        bindKey2 = bindKey2[bindKey2.length-1];
                        if(srchKeys[i] == bindKey2) {                 
                          if(bindKey2.indexOf("From") != -1) {
                            srch[srchKeys[i]] = $filter('localToUtc')( srch[srchKeys[i]], 'from');
                          } else if(bindKey2.indexOf("to") != -1) {
                            srch[srchKeys[i]] = $filter('localToUtc')( srch[srchKeys[i]], 'to');
                          } else{
                            srch[srchKeys[i]] = $filter('localToUtc')( srch[srchKeys[i]]);
                          }
                        }
                      }
                    } else {
                      bindKey = bindKey.split(".");
                      bindKey = bindKey[bindKey.length-1];
                      if(srchKeys[i] == bindKey) {                       
                        if(bindKey.indexOf("From") != -1) {
                          srch[srchKeys[i]] = $filter('localToUtc')( srch[srchKeys[i]], 'from');
                        } else if(bindKey.indexOf("to") != -1) {
                          if(srch[srchKeys[i]].indexOf(" ")== -1)
                          srch[srchKeys[i]] = $filter('localToUtc')( srch[srchKeys[i]], 'to');
                        } else {
                          srch[srchKeys[i]] = $filter('localToUtc')( srch[srchKeys[i]]);
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          return angular.copy(srch);
        },
        getBindListDataExt : function(D, selectType) {
          var thisObj = this, multyParm = [];
          
          D.vm.dataloader = true;
          var dataExtendMqpper = [];
          if(D.pageType.toUpperCase() == this.pageType.LIST) {
            D.vm.srch.selectType = selectType;
            var params = this.setChangeDateUTC(D);
            if(D.listParam) {
              var listParamKeys = Object.keys(D.listParam);
              for(var i = 0; i < listParamKeys.length; i++) {
                params[listParamKeys[i]] = D.listParam[listParamKeys[i]];
              }
            }
            multyParm = [
              {mapCode : D.MapperId.init.LIST_CNT_SQL, param : params},
              {mapCode : D.MapperId.init.LIST_SQL, param : params},
            ];
          } else {
            // 상세페이지 전용, 현재 else로 처리 했지만 추가적인 부분일 경우에는 else if로 변경 필요
            D.vm.data = {};
            D.vm.srchDetail = {};
            D.vm.srchDetail.IdName = D.keyColumnNm;
            D.vm.srchDetail.tableNm = D.keyTableNm;
            if(D.MapperId != undefined)
              D.vm.srchDetail.mapCode = D.MapperId.init.VIEW_SQL.mapCode;
            D.vm.srchDetail.keyId = D.keyId;
            D.vm.srchDetail.selectType = selectType;
            D.vm.srchDetail.uploadFileList = [];
            
            if(D.MapperId == undefined) {
              if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
                D.vm.getInitDataExt();
              }
              return;
            }
            
            var baseParam = {
              mapCode : D.vm.srchDetail.mapCode,
              param : D.vm.srchDetail
            }
            multyParm.push(baseParam);

            var keys = Object.keys(D.MapperId.init);
            for(var i = 0; i < keys.length; i++) {
              if(keys[i] != 'VIEW_SQL') {
                var data = D.MapperId.init[keys[i]];
                if(data.param == undefined) data.param = {};
                data.MapperId = keys[i];
                dataExtendMqpper.push(data);
              }
            }

            D.vm.showUploader = enableUploadComponent();
            if(this.checkEmptyType(D.vm.onFileCallback)) {

              D.vm.onFileCallback = {
                onFileUploaded: function (id, result) {
                  var bindFile = thisObj.datas.MapperId.init.VIEW_SQL.bindFile;                  
                  angular.forEach(result.body.docs, function (item) {
                    var obj = item;
                    obj.link = StaticVariable.getUrl(item.tmpLink) + "?fileName=" + item.fileName + "&userkey=" + $rootScope.gVariable.userKey;
                    
                    for(var i = 0; i < bindFile.length; i++) {
                      if(bindFile[i].vault == id) {
                        thisObj.uploadFileList[i].push(obj);
                      }
                    }
                  });
                },
                onFileUploadComplete: function (id) {
                  thisObj.checkValutUpload = false;

                },
                onFileDelete: function (item) {
                },
                onLoaded: function (id, vault) {
                  D.vm[id] = vault;
                  thisObj.vaultObj.push(D.vm[id]);
                }
              };
            }

            for(var i = 0; i < keys.length; i++) {
              if(typeof(D.MapperId.init[keys[i]]) == "object") {
                var at = D.MapperId.init[keys[i]];
                if(at.bindFile != undefined) {
                  var atKeys = Object.keys(at.bindFile);
                  for(var j = 0; j < atKeys.length; j++){
                    if(at.bindFile[atKeys[j]].vault != undefined) {
                      initVaultComponent(at.bindFile[atKeys[j]].vault.replace("#", "").replace(".", ""), D.vm.onFileCallback);
                    }
                  }
                }
              }
            }
            
          }
          D.vm.columnMap = [];
          
          this.postApi(D, multyParm, function(){
            D.vm.srchMem = angular.copy(D.vm.srch);

            if(D.pageType.toUpperCase() == thisObj.pageType.LIST) {

            } else {

              if(dataExtendMqpper.length > 0) {
                thisObj.postApi(D, dataExtendMqpper);
              }
            }

          });
        },
        getData : function(param, callback) {
          var thisObj = this, D = this.datas;

          postApi.select(param, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              var columnMap = {};
              if (result.body.desc.length > 0) {
                // MetaColumn 정보를 이용하여 표시할 목록 정보 설정                
                angular.forEach(result.body.desc, function (item) {
                  columnMap[item.ColumnPhysicalNm] = item;
                });
                result.columnMap = columnMap;
              } 
              callback(result);
            }
          });
          

        },
        postApi : function(D, multyParm, callback) {
          var thisObj = this;

          postApi.select(multyParm, function (result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
  
              if(D.pageType.toUpperCase() == thisObj.pageType.LIST) {
                if(D.MapperId.init.LIST_CNT_SQL == result.mapCode) {
                  //(result.body.docs.length > 0) ? D.vm.totalItems = result.body.docs[0] : D.vm.totalItems = 0;
                  if (result.body.docs.length > 0) {
                    D.vm.totalItems = result.body.docs[0];
                  }
                } else if(D.MapperId.init.LIST_SQL == result.mapCode) {

                  if (D.vm.headerTitle == '전체 회원 리스트') {
                    if(isNullOrEmpty(D.vm.srch.memberType)) {
                      D.vm.srch.memberType = 'A';
                    }
                    if(isNullOrEmpty(D.vm.srch.AttendanceType)) {
                      D.vm.srch.AttendanceType  = '';
                    }
                    if(isNullOrEmpty(D.vm.srch.Gender)) {
                      D.vm.srch.Gender  = '';
                    }
                    if(isNullOrEmpty(D.vm.srch.Age)) {
                      D.vm.srch.Age  = '';
                    }
                  }
                  if (result.body.desc.length > 0) {
                    // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
                    D.vm.listColumns = result.body.desc;
                    angular.forEach(D.vm.listColumns, function (item) {
                      D.vm.columnMap[item.ColumnPhysicalNm] = item;
                    });
                  } else {
                    var srch = angular.copy(D.vm.srch);
                    srch.mapCode = result.mapCode;
                    var check = [];
                    if(result.body.desc.length == 0) check.push("desc.length = 0");
                    srch.checkMsg = check;
                  }
                  if (result.body.docs.length > 0 && !isNullOrEmpty(D.vm.listColumns)) {
                    D.vm.lists = result.body.docs;
                   
                    var resList = [];
                    var res = '';
                    if (D.vm.lists != null) {
                      angular.forEach(D.vm.lists, function (item) {
                        resList = [];
                        if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {
                          res = item.Addr1;
                          resList = res.split(" ");
                          item.Addr = resList[0] + " " + resList[1];
                        }
                      });
                    }
                  } else if (result.body.docs.length > 0 && isNullOrEmpty(D.vm.listColumns)) {
                    D.vm.lists = result.body.docs;
                  } else {
                    D.vm.lists = [];
                  }
                  if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
                    D.vm.getInitDataExt(result.body);
                  }
                  $timeout(function(){
                    D.vm.dataloader = false;
                  }, thisObj.timeSec); 
                  //D.vm.dataloader = false;
                }
                D.vm.SearchConditionStr = getSearchConditionStr(D.vm.totalItems);
              } else { // VIEW PAGE
  
                if(D.MapperId.init.VIEW_SQL.mapCode == result.mapCode) {
                  if (result.body.desc.length > 0) {
                    // 사용자정의 컬럼 설정
                    D.vm.allColumns = result.body.desc;
                    
                    angular.forEach(D.vm.allColumns, function (item) {
                      D.vm.columnMap[item.ColumnPhysicalNm] = item;
                    });
                  }
  
                  if(result.body.docs.length == 0) {
                    D.vm.data = {};
                    if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
                      D.vm.getInitDataExt(result.body);
                    }
                  } else {
                    D.vm.data = result.body.docs[0];  
                  
                    if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
                      D.vm.getInitDataExt(result.body);
                    }
                    if(result.body.docs[0].uploadFileList != undefined && result.body.docs[0].uploadFileList.length > 0) {
                      
                      thisObj.changeUtcToLocal(D, D.vm.data, result.mapCode);

                      var bindKey = D.MapperId.init.VIEW_SQL.bindFile[0].bindKey;
                      if(bindKey != undefined && bindKey != "") {
                        bindKey = bindKey.split(".")[1];
                        D.vm[bindKey] = [];
                      }

                      angular.forEach(D.vm.data.uploadFileList, function (item) {
                        var obj = {
                          id: item.fileId,
                          isLoaded: true,
                          link: StaticVariable.getFileDownloadUrl(item.PhysicalFileNm),
                          fileName: item.LogicalFileNm,
                          size: item.FileSize,
                          fileKey: item.PhysicalFileNm,
                          grpId : item.GrpId,
                          path: item.PhysicalPath,
                          downloadCnt: item.DownloadCnt,
                        };
                        
                        D.vm[bindKey].push(obj);
                      });

                      thisObj.uploadFileList.push(D.vm[bindKey]);
    
                    }
                  }
                } else {
                  // 기본 mapperID 가 아닌 경우
                  for(var i = 0; i < multyParm.length; i++) {
                    if(multyParm[i].mapCode == result.mapCode) {
                      var fnc =  eval("D."+ multyParm[i].callback);
                      fnc(result.body)
                    }
                  }
                }

                $timeout(function(){
                  D.vm.dataloader = false;
                }, thisObj.timeSec); 
                //D.vm.dataloader = false;
              }
            } else {

              if(D.pageType.toUpperCase() == thisObj.pageType.LIST && D.MapperId.init.LIST_SQL == result.mapCode) {
                if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
                  D.vm.getInitDataExt(result);
                }
              };
              if(D.pageType.toUpperCase() == thisObj.pageType.VIEW && D.MapperId.init.VIEW_SQL.mapCode == result.mapCode) {
                if(!thisObj.checkEmptyType(D.vm.getInitDataExt)) {
                  D.vm.getInitDataExt(result);
                }
              }
            }
            if(callback != undefined) callback();

            if (D.MapperId.init.LIST_CNT_SQL != result.mapCode) {
              $timeout(function(){
                D.vm.dataloader = false;
              }, thisObj.timeSec);
            }
            //D.vm.dataloader = false; // Progressbar 숨김

    
          }, function (error) {
            $timeout(function(){
              D.vm.dataloader = false;
            }, thisObj.timeSec); 
            //D.vm.dataloader = false; // Progressbar 숨김
            console.table(error);
          });

        },
        changeUtcToLocal : function(D, data, mapCode) {
          var thisObj = this;
          for(var i = 0; i < thisObj.dateInfo.length; i++) {
            if(mapCode == thisObj.dateInfo[i].mapCode) {
              var at = thisObj.dateInfo[i];
              if(data[at.key] != undefined) {
                thisObj.setStrObjValue(D, "vm." + at.key , moment(data[at.key]).toDate());
              }
            }
          }
        },
        changeLocalToUtc : function(D, data, mapCode) {
          
        },
        convCamelCase : function(str) {
          var id = str;
          var convId = '';
          if( id == null) id = $(input).eq(i).attr("ng-model");
          if(id == null) {}
          id = id.split(".");
          for(var j = 0; j < id.length; j++)
            convId += id[j].charAt(0).toUpperCase() + id[j].substring(1, id[j].length);
          convId = convId+ "_" + i;
          if( $(input).eq(i).attr("id")  != "" && $(input).eq(i).attr("id")  != undefined) {
            convId = $(input).eq(i).attr("id") ;
          }
          return convId;
        },
        initBindingVm : function(D) {
          D.vm.headerTitle = D.headerTitle;

          var srchData = { keyTableNm : D.keyTableNm, keyColumnNm: D.keyColumnNm, srch : D.stateParams.srch };
          D.vm.srch = this.makeSrchData(srchData, D);
          if(D.srch != undefined) {
            var srchKey = Object.keys(D.srch);
            var vmSrchKey = Object.keys(D.vm.srch);
            for(var i= 0; i < srchKey.length; i++) {
              var check = true;
              for(var j = 0; j < vmSrchKey.length; j++) {
                if(srchKey[i] == vmSrchKey[j]) {
                  check = false;
                  break;
                }
              }
              if(check) {
                D.vm.srch[srchKey[i]] = D.srch[srchKey[i]];
              }
            }
          }

          // 2020.03.14 edit에서 검색된 값이 검색에 영향을 미치는 부분이 있음
          // 리스트 서치 박스에서 keyId가 있다면 자동 바인딩이 될 것임으로
          // 구지 등록 할 필요가 없을 것으로 보임
          // if( !isNullOrEmpty(D.vm.keyId)) {
          //   D.vm.srch.KeyId = D.vm.keyId;
          // } else if( !isNullOrEmpty(D.vm.KeyId)) {
          //   D.vm.srch.KeyId = D.vm.KeyId;
          // }

          if(D.pageType.toUpperCase() == this.pageType.LIST) {
            // List 일 경우 기본적으로 srch를 기준으로 작업이 됩
            
          } else if(D.pageType.toUpperCase() == this.pageType.DETAIL) {
  
          } else if(D.pageType.toUpperCase() == this.pageType.EDIT) {
  
          } 
          //$timeout(function(){
          //  D.vm.dataloader = false;
          //}, this.timeSec); 
          //D.vm.dataloader = false;
        },
        makeSrchData : function(srchData, D) {
          var srch = {}
          if (!D.stateParams.srch) {
            var temp = {};
            (!isNullOrEmpty(srchData.keyTableNm)) ? temp.keyTableNm = srchData.keyTableNm : temp.keyTableNm = D.keyTableNm; // 작업테이블명
            (!isNullOrEmpty(srchData.sortDirect)) ? temp.sortDirect = srchData.sortDirect : temp.sortDirect = ""; // 정렬순서 (ASC:오름차순, DESC:내림차순)
            (!isNullOrEmpty(srchData.sortColumn)) ? temp.sortColumn = srchData.sortColumn : temp.sortColumn = ""; // 정렬컬럼명
            (!isNullOrEmpty(srchData.keyColumnNm)) ? temp.keyColumnNm = srchData.keyColumnNm : temp.keyColumnNm = ""; // 정렬컬럼명

            srch.page = 1;
            srch.viewSize = !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10; // 페이지당 조회건수
            if (D.vm.headerTitle == '전체 회원 리스트') {
              srch.viewSize = 25;
            }
            srch.tableNm = temp.keyTableNm;
            srch.sortDirect = temp.sortDirect;
            srch.sortColumn = temp.sortColumn;
          } else {
            srch = JSON.parse(decodeURIComponent(D.stateParams.srch));
            srch.tableNm = D.keyTableNm;
            var srchKeys = Object.keys(srch);
            
            if(srch.page != undefined) {
              D.vm.currentPage = srch.page;
            }
            
            if(srch.viewSize != undefined) {
              D.vm.viewSize = srch.viewSize;
            }

            if(D.FormGroup != undefined) {
              for(var i = 0 ; i < srchKeys.length; i++) {
                for(var j = 0 ; j < D.FormGroup.length; j++) {
                  var field = D.FormGroup[j].field;
                  if(!field) field = [];
                  for(var k = 0 ; k < field.length; k++) {
                    var at = field[k], bindKey = at.bindKey, type = at.type, key = at.key;
                    var utcYn = (at.utcYn != undefined) ? utcYn = at.utcYn : utcYn = false;
                    if(type == "date" && utcYn) {                    
                      if(Array.isArray(bindKey)) {
                        for(var l = 0; l < bindKey.length; l++) {
                          var bindKey2 = bindKey[l].split(".");
                          bindKey2 = bindKey2[bindKey2.length-1];
                          if(srchKeys[i] == bindKey2) {     
                          D.vm[bindKey2] = moment(srch[srchKeys[i]]).toDate();
                          }
                        }
                      } else {
                        bindKey = bindKey.split(".");
                        bindKey = bindKey[bindKey.length-1];
                        if(srchKeys[i] == bindKey) {         
                          D.vm[bindKey] = moment(srch[srchKeys[i]]).toDate();
                        }
                      }
                    }
                  }
                }
              }
            }
          }
          var result = angular.copy(srch);
          return result;
        },
  
        setLayout : function(D) {
          if(!D.vm.layout) {
            D.vm.layout = $rootScope.gVariable.layoutBoard;
          }
          this.initChangeLayout(D);
        },
        initChangeLayout : function(D) {
          var thisObj = this;
          var vm = D.vm;
          switch (vm.layout) {
            case "H":
              // 수평
              vm.anchor = "north";
              vm.paneMin = "300px";
              break;
            case "V":
              // 수직
              vm.anchor = "west";
              vm.paneMin = "600px";
              break;
            case "N":
              // 기본
              vm.anchor = "";
              vm.paneMin = "600px";
              break;
          }
  
          vm.setChangeLayout = function(layout, vc) {
            var vm = D.vm;
            $window.sessionStorage.setItem('layoutBoard', layout);
            $rootScope.gVariable.layoutBoard = layout;
            var srch = vc.srch; // 검색 옵션
            var url = null;
            var param = {};
            url = D.PageUrl.LIST_PAGE_URL.url; 
            if(url == undefined) {
              url = D.PageUrl.LIST_PAGE_URL;
              param = {};
            } else {
              param = D.PageUrl.LIST_PAGE_URL.param;
            }    
            if(param == undefined) param = {};
            if(srch != undefined) param.srch =  encodeURIComponent(JSON.stringify(srch));
            else param.srch = "";
            param = JSON.stringify(param);
            $state.go(url, JSON.parse(param) , {reload: url});
          };
        },
        getObjFieldType : function (type, colClass, layout) {
  
          var thisObj = this;
          var formType = "inner";
          var $elemForm = $("<div />", {class : "form-group form-inner-label"});

          if(layout == undefined) {
            if(thisObj.datas.pageType.toUpperCase() != thisObj.pageType.LIST) {
              $elemForm = $("<div />", {class : "form-group form-inline"});
              formType = "inline";
            }
          } else {
            if(layout == mElemTx.layout.inline) {
              $elemForm = $("<div />", {class : "form-group form-inline"});
            } 
            formType = layout;
          }

          if(type == "date" || type.toLowerCase() == "datetime") {
  
            var $elemDateGroup = $("<div />", {class : "input-group", "ng-controller":"DatepickerDemoCtrl"});
            var $elemDateInput = $("<input />", {
              class: "form-control", "clear-text" : "취소", "close-text" : "닫기", "current-text" : "오늘", "datepicker-options" : "dateOptions", "is-open" : "opened", "ng-change" : "", "ng-model":"", "ng-required": "false",
              "placeholder":"", "type":"text", "uib-datepicker-popup" : "{{ :: format}}"
            });
            var $elemDateSpan = $("<span />", { class : "input-group-btn" })
            var $elemDateButton = $("<button />", { class : "btn btn-default", "ng-click" : "open($event)", type : "button" });
            var $elemDateIco =  $("<i />", { class : "glyphicon glyphicon-calendar" });

            $elemDateButton.html($elemDateIco.clone());
            $elemDateSpan.html($elemDateButton.clone());
            if(formType == "inner")  {
              $elemDateGroup.html($elemDateInput.clone());
              $elemDateGroup.append($elemDateSpan.clone());
              $elemForm.html($elemDateGroup.clone());
            } else {
              var $label = $("<label />");
              $elemDateGroup.html($elemDateInput.clone());
              $elemDateGroup.append($elemDateSpan.clone());
              $elemForm.append($label.clone())
              $elemForm.append($elemDateGroup.clone())
            }
          } else if (type == "input") {
            var $input = $("<input />", {class : "form-control form-right", type : "text"});
            if(formType == "inline") {
              var $label = $("<label/>", {});
              $elemForm.html($label.clone());
              $elemForm.append($input.clone());
            } else {
              $elemForm.html($input.clone());
            }
          } else if (type == "text") {
            var $input = $("<input />", {class : "form-control form-right", type : "text"});
            if(formType == "inline") {
              var $label = $("<label/>", {});
              $elemForm.html($label.clone());
              $elemForm.append($input.clone());
            } else {
              $elemForm.html($input.clone());
            }
          } else if (type == "textarea") {
            var $input = $("<textarea />", {class : "form-control", row : 5});
            if(formType == "inline") {
              var $label = $("<label/>", {});
              $elemForm.html($label.clone());
              $elemForm.append($input.clone());
            } else {
              $elemForm.removeClass("form-inner-label");
              $elemForm.html($input.clone());
            }
          } else if (type == "select") {
            var $ccc = $("<common-code-custom />", {});
            var $label = $("<label/>", {});
            $elemForm.html($ccc.clone());
            $elemForm.append($label.clone());
          } else if (type == "radio") {
            $elemForm.attr("class", "form-group form-inline radio-wrap");
            var $label = $("<label />", {});
            var $inputGroup = $("<div />", {class:"input-group input-radio-custom-group"});
            var $repeatDiv = $("<div />", {class:"radio-inline"});
            var $customLabel = $("<label />", {class:"custom-radio-btn"});
            var $span1 = $("<span />", {class:"helping-el"});
            var $span2 = $("<span />", {class:"label-text", text: '{{li.CodeValue}}'});
            var $input = $("<input />", {class : "clr form-right", type : "radio", value: "{{li.Code}}"});

            $customLabel.html($input.clone());
            $customLabel.append($span1.clone());
            $customLabel.append($span2.clone());

            $repeatDiv.html($customLabel.clone());
            $inputGroup.html($repeatDiv.clone());
            $elemForm.html($label.clone());
            $elemForm.append($inputGroup.clone());
          } else if (type == "modal") {
            var $inputGroup = $("<div />", {class:"input-group"});
            var $FormGoup = $("<div />", {class : "form-group form-inner-label"});
            var $input = $("<input />", {class : "form-control form-right", type : "text", readonly:""});
            var $label = $("<label/>", {});
            var $btnGroupSpan = $("<span />", { class : "input-group-btn" });
            var $btnGroupSpanButton = $("<button />", { class : "btn btn-default", type : "button" });
            var $btnGroupSpanIco =  $("<i />", { class : "fa fa-search" });
            $FormGoup.html($input.clone());
            $FormGoup.append($label.clone());
            $btnGroupSpanButton.html($btnGroupSpanIco.clone());
            $btnGroupSpan.html($btnGroupSpanButton.clone());
            $btnGroupSpanIco =  $("<i />", { class : "fa fa-eraser" });
            $btnGroupSpanButton.html($btnGroupSpanIco.clone());
            $btnGroupSpan.append($btnGroupSpanButton.clone());
            $inputGroup.html($FormGoup.clone());
            $inputGroup.append($btnGroupSpan.clone());
            return $inputGroup;
          } else if (type == "address") {
            var $returnRow = $("<div />", {class:"row"});
            var $row = $("<div />", {class:"row"});
            var $wrap = $("<div />", {class: colClass});
            var $formGroup = $("<div />", {class: "form-group form-inline"});
            var $label = $("<label />", {});
            var $inputGroup = $("<div />", {class: "input-group"});
            var $input = $("<input />", {class : "form-control", type : "text", readonly:""});
            var $span = $("<span />", {class: "input-group-btn"});
            var $button = $("<button />", {class: "btn btn-default", type:"button"});
            var $i = $("<i />", {class: "fa fa-search"});

            $button.html( $i.clone());
            $span.html( $button.clone());
            $inputGroup.html($input.clone());
            $inputGroup.append($span.clone());
            $formGroup.html($label.clone());
            $formGroup.append($inputGroup.clone());
            $wrap.html($formGroup.clone());
            $row.html($wrap.clone());
            var $zipcodeWrap = $("<div />", {class:"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"});
            $zipcodeWrap.html($row);
            $returnRow.html($zipcodeWrap.clone());

            var $addr1 = $("<div />", {class:"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"});
            $formGroup.html($label.clone());
            $formGroup.append($input.clone());
            $addr1.html($formGroup.clone());
            $returnRow.append($addr1);

            var $addr2 = $("<div />", {class:"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6"});
            $formGroup.html($label.clone());
            $formGroup.append($input.clone());
            $addr2.html($formGroup.clone());
            $returnRow.append($addr2);

            return $returnRow;
          } else if (type == "checkbox") {

          }

          return $elemForm;
        },
        setForms : function(forms) {

          var thisObj = this;
          var D = this.datas;
          var elemWidth;
          var checkUseModal = false;
          var checkZipCode = false, checkUseZipCode = false;
          var target = forms.target;
          var $elem = $("html");
          var field = forms.field;
          var arrayObj = [];
          var layout = forms.layout;
          var bindData = forms.bindData;

          if(layout == undefined) layout = mElemTx.layout.inner;
          
          if(typeof(target) == "string") {
            target = target.split(" ");            
            for(var j = 0; j < target.length; j++) {
              if(target[j].indexOf("[") > -1) {
                var splite = target[j].replaceAll(" ","").split("[");
                splite[1] = Number(splite[1].replace("]", ""));
                ($elem != null) ? $elem = $elem.find(splite[0]).eq(splite[1]) : $elem = $(splite[0]).eq(splite[1]);
              } else {
                ($elem != null) ? $elem = $elem.find(target[j]) : $elem = $(target[j]);
              }
            }
          } else {
            $elem = target;
          }

          if(forms.resetForm) {
            $elem.empty().html('');
          }

          for(var j = 0; j < field.length; j++) {
            var af = field[j];
            var disabled = af.disabled;
            af.bindKey = forms.bindKey + "." +af.key;
            var col=4, colClass = "";
            if (!isNullOrEmpty(af.col)) col = Number(af.col);
            if(col==4) colClass = "col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3";
            else if(col==3) colClass = "col-xs-6 col-sm-6 col-md-4 col-lg-4 col-xl-4";
            else if(col==2) colClass = "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6";
            else if(col==1) colClass = "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12";

            if(af.layout != undefined) layout = af.layout;
            var $fObj = thisObj.getObjFieldType(af.type, colClass, layout);
            var $copyObj = $fObj.clone();

            var $mainWrap = $("<div />", {
              class : colClass
            });

            var checkDoubleDate = false;

            if(af.type == "date" || af.type.toLowerCase() == "datetime") {
              
              if(Array.isArray(af.key)) {
                var $rowWrap = $("<div />", {
                  class :  "row"
                });
                var $subWrap = $("<div />", {
                  class :  "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                });

                checkDoubleDate = true;
                if(elemWidth > 500 && col < 3) {
                  $mainWrap.attr("class", "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6");
                }
                var $input = $copyObj.find("input");
                // from
                var dateKey = af.key[0];
                //dateKey = dateKey[dateKey.length-1];
               // D.vm[dateKey] = '';


                if(af.ngChange != undefined) {
                  if(typeof(af.ngChange) == "string") {
                    $input.attr("ng-change", af.ngChange+'()');
                  } else {
                    $input.attr("ng-change", af.ngChange[0]+'()');
                  }
                } else if(af.callback != undefined) {
                  $input.attr("ng-change", af.callback+'()');
                  if(typeof(af.callback) == "string") {
                    $input.attr("ng-change", af.callback+'()');
                  } else {
                    $input.attr("ng-change", af.callback[0]+'()');
                  }
                } else {
                  var value = forms.bindKey + "." + dateKey + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                  $input.attr("ng-change", value);
                }

                $input.attr("ng-model", "vc." + dateKey);
                
                if(af.appendBody == undefined || af.appendBody == true) {
                  $input.attr("datepicker-append-to-body", "true");
                } else {
                  $input.attr("datepicker-append-to-body", "false");
                }

                if(disabled != undefined) $input.attr("ng-disabled", disabled);

                if(thisObj.datas.pageType == undefined) {

                  if(layout == mElemTx.layout.inner) {
                    $input.attr("placeholder", af.label[0]);
                  } else {
                    var $label = $copyObj.find("label");
                    if(Array.isArray(af.label)) {
                      $input.attr("placeholder", af.label[0]);
                    } else {
                      $label.text(af.label);
                      $label.attr("title", af.label);
                    }
                  }

                } else {
                  if(thisObj.datas.pageType.toUpperCase() == thisObj.pageType.LIST) {
                    $input.attr("placeholder", af.label[0]);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.text(af.label[0]);
                  }
                }

                if(af.where != undefined) {
                  if(typeof(af.where) == "string") {
                    $copyObj.attr("ng-if", af.where);
                  } else {
                    $copyObj.attr("ng-if", af.where[0]);
                  }
                }

                $subWrap.html($copyObj.clone());
                $subWrap.attr("data-key", dateKey)
                $rowWrap.html($subWrap.clone());
                //$mainWrap.html($subWrap.clone());
                
                $mainWrap.addClass("doubleDate");
                //arrayObj.push($mainWrap.clone());
                
                thisObj.dateInfo.push({key : "vm." + dateKey, type : af.type, datetype : af.datetype, bindKey : forms.bindKey + "." + dateKey})
                // to
                
                var dateKey = af.key[1];
                if(af.ngChange != undefined) {
                  if(typeof(af.ngChange) == "string") {
                   
                  } else {
                    $input.attr("ng-change", af.ngChange[1]+'()');
                  }
                } else if(af.callback != undefined) {
                  $input.attr("ng-change", af.callback+'()');
                  if(typeof(af.callback) == "string") {
                  } else {
                    if(af.callback[1]) {
                      $input.attr("ng-change", af.callback[1]+'()');
                    } else {
                      $input.removeAttr("ng-change");
                    }
                  }
                } else {
                  var value = forms.bindKey + "." + dateKey + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                  $input.attr("ng-change", value);
                }

                $input.attr("ng-model", "vc." + dateKey);
                if(af.appendBody == undefined || af.appendBody == true) {
                  $input.attr("datepicker-append-to-body", "true");
                } else {
                  $input.attr("datepicker-append-to-body", "false");
                }
                if(disabled != undefined) $input.attr("ng-disabled", disabled);
                
                if(thisObj.datas.pageType == undefined) {
                  if(layout == mElemTx.layout.inner) {
                    $input.attr("placeholder", af.label[0]);
                  } else {
                    var $label = $copyObj.find("label");
                    if(Array.isArray(af.label)) {
                      $input.attr("placeholder", af.label[0]);
                    } else {
                      $label.detach();
                    }
                  }
                } else {
                  if(thisObj.datas.pageType.toUpperCase() == thisObj.pageType.LIST) {
                    $input.attr("placeholder", af.label[1]);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.text(af.label[0]);
                    $label.attr("title", af.label[0]);
                  }
                }
                
                $subWrap = $("<div />", {
                  class :  "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6"
                });

                if(af.where != undefined) {
                  if(typeof(af.where) == "string") {
                    $copyObj.attr("ng-if", af.where);
                  } else {
                    $copyObj.attr("ng-if", af.where[0]);
                  }
                }

                $copyObj.removeClass("form-inline");
                $copyObj.css("padding-left", "1%");
                $subWrap.html($copyObj.clone());
                $subWrap.attr("data-key", af.key[1])
                $rowWrap.append($subWrap.clone());
                $mainWrap.html($rowWrap.clone());
                //$mainWrap.attr("data-key", af.key)
                arrayObj.push($mainWrap.clone());

                thisObj.dateInfo.push({key : "vm." + dateKey, type : af.type, datetype : af.datetype, bindKey : forms.bindKey + "." + dateKey})

              } else {
                var dateKey = af.key;
                var $input = $copyObj.find("input");
                // from
                if(af.ngChange != undefined) {
                  $input.attr("ng-change", af.ngChange+'()');
                } else if(af.callback != undefined) {
                  $input.attr("ng-change", af.callback+'()');
                } else {
                  var value = forms.bindKey + "." + dateKey + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                  $input.attr("ng-change", value);
                }
                $input.attr("ng-model", "vc." + dateKey);
                if(af.appendBody == undefined || af.appendBody == true) {
                  $input.attr("datepicker-append-to-body", "true");
                } else {
                  $input.attr("datepicker-append-to-body", "false");
                }

                //var dateKey = af.bindKey.split(".");
                // dateKey = dateKey[dateKey.length-1];
                // D.vm[dateKey] = '';
                //var value = af.bindKey + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                //$input.attr("ng-change", value);
                //$input.attr("ng-model", "vc." + dateKey);
                if(disabled != undefined) $input.attr("ng-disabled", disabled);

                if(thisObj.datas.pageType == undefined) {

                  if(layout == mElemTx.layout.inner) {
                    $input.attr("placeholder", af.label);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.html(af.label);
                    $label.attr("title", af.label);
                  }
                } else {
                  if(thisObj.datas.pageType.toUpperCase() == thisObj.pageType.LIST) {
                    $input.attr("placeholder", af.label[0]);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.text(af.label);
                    $label.attr("title", af.label);
                  }                  
                }

                var dateInfo = {key : "vm." +  dateKey, type : af.type, datetype : af.datetype, bindKey : forms.bindKey + "." + dateKey};
                  thisObj.dateInfo.push(dateInfo)
              }
            } else if(af.type == "input"){
              var $input = $copyObj.find("input");
              if(af.inputType != undefined) {
                if(af.inputType == "number") {
                  $input.attr('comma','');
                }
              }

              if(af.ngChange != undefined) {
                $input.attr('ng-change',af.ngChange + "("+ af.bindKey+", this)");
              } else if(af.callback != undefined) {
                $input.attr('ng-change',af.callback + "("+ af.bindKey+", this)");
              }


              $input.attr("ng-model", af.bindKey);

              if(thisObj.datas.pageType == undefined) {

                if(layout == mElemTx.layout.inner) {
                  $input.attr("placeholder", af.label);
                } else {
                  var $label = $copyObj.find("label");
                  $label.html(af.label);
                  $label.attr("title", af.label);
                }

                if(disabled != undefined) $input.attr("ng-disabled", disabled);
              } else {
                if(thisObj.datas.pageType.toUpperCase() != thisObj.pageType.LIST) {
                  var $label = $copyObj.find("label");
                  $label.html(af.label);
                  $label.attr("title", af.label);
                } else {
                  $input.attr("placeholder", af.label);
                }
                if(disabled != undefined) $input.attr("ng-disabled", disabled);
              }
            } else if(af.type == "text"){
              var $input = $copyObj.find("input");
              if(af.inputType != undefined) {
                if(af.inputType == "number") {
                  $input.attr('comma','');
                }
                if(af.inputType == "date") {
                  $input.attr('md-date-utc-to-local', af.bindKey);
                }
              }

              if(af.ngChange != undefined) {
                $input.attr('ng-change',af.ngChange + "("+ af.bindKey+", this)");
              } else if(af.callback != undefined) {
                $input.attr('ng-change',af.callback + "("+ af.bindKey+", this)");
              }

              $input.attr("ng-model", af.bindKey);
              if(thisObj.datas.pageType == undefined) {
                if(layout == mElemTx.layout.inner) {
                  $input.attr("placeholder", af.label);
                } else {
                  var $label = $copyObj.find("label");
                  $label.html(af.label);
                  $label.attr("title", af.label);
                }
                if(disabled != undefined) $input.attr("ng-disabled", disabled);
              } else {
                if(thisObj.datas.pageType.toUpperCase() != thisObj.pageType.LIST) {
                  var $label = $copyObj.find("label");
                  $label.html(af.label);
                  $label.attr("title", af.label);
                } else {
                  $input.attr("placeholder", af.label);
                }
                if(disabled != undefined) $input.attr("ng-disabled", disabled);
              }
            } else if(af.type == "textarea"){
              var $input = $copyObj.find("textarea");
              if(af.row != undefined) $input.attr("rows", af.row);
              $input.attr("ng-model", af.bindKey);
              if(thisObj.datas.pageType == undefined) {
                var $label = $copyObj.find("label");
                $label.html(af.label);
                $label.attr("title", af.label);
              } else {
                if(thisObj.datas.pageType.toUpperCase() != thisObj.pageType.LIST) {
                  var $label = $copyObj.find("label");
                  $label.html(af.label);
                  $label.attr("title", af.label);
                } else {
                  $input.attr("placeholder", af.label);
                }
              }
              
              if(af.readOnly != undefined && af.readOnly == true) $input.attr("readonly", '');
              if(disabled != undefined) $input.attr("ng-disabled", disabled);
            } else if(af.type == "select"){
              var $ccc = $copyObj.find("common-code-custom");
              var $label = $copyObj.find("label");
              if(af.bindData != undefined) {
                $ccc.attr("code-list", af.bindData.replace("vm.","vc."));
              } else {
                $ccc.attr("code-list", "vc.columnMap['" + af.key + "'].CodeList");
              }
              
              if(af.codeExclude != undefined) {
                $ccc.attr("code-exclude", af.codeExclude.replace("vm.","vc."));
              } 

              if(disabled != undefined) $ccc.attr("is-disabled", disabled);
              $ccc.attr("code-model", af.bindKey);
              $label.text(af.label);
              $label.attr("title", af.label);
              if(af.callback != undefined) {
                $ccc.attr("callback", af.callback);
              }
            } else if(af.type == "radio"){
              var $label = $copyObj.find("label");
              var $input = $copyObj.find("input");
              var $radioInline = $copyObj.find(".radio-inline");
              $label.eq(0).text(af.label);
              $label.eq(0).attr("title", af.label);
              if(af.bindData != undefined) {
                $radioInline.attr("ng-repeat", "li in " + af.bindData.replace("vm.","vc."));
                $radioInline.attr("title", "{{li.CodeValue}}");
              } else {
                $radioInline.attr("ng-repeat", "li in vc.columnMap['" + af.key + "'].CodeList");
              }
              $input.attr("ng-model", af.bindKey);
              $input.attr("ng-checked", af.bindKey + " == li.Code");
              if(disabled != undefined) $input.attr("ng-disabled", disabled);
              if(af.callback != undefined) $input.attr("ng-change", af.callback + "(li);");
              //$radioInline.append("{{li.CodeValue}}");
            } else if(af.type == "modal"){
              checkUseModal = true;
              var $label = $copyObj.find("label");
              $label.html(af.label);
              $label.attr("title", af.label);
              var $input = $copyObj.find("input");
              $input.attr("ng-model", af.bindLabel);
              var $searchBtn = $copyObj.find("button").eq(0);
              var $eraserBtn = $copyObj.find("button").eq(1);

              $searchBtn.attr("ng-click", af.clickFn + "();")
              $eraserBtn.attr("ng-click", "vc.eraserModalData('" + af.bindLabel+ "','" + af.bindKey +"');")
            }  else if(af.type == "address"){
              checkZipCode = true, checkUseZipCode = true;
              var $zipWrap = $copyObj.find("> div").eq(0);
              var $add1Wrap = $copyObj.find("> div").eq(1);
              var $add2Wrap = $copyObj.find("> div").eq(2);
              $zipWrap.find("label").text(af.label);
              $zipWrap.find("label").attr("title", af.label);
              
              var bindKey = forms.bindKey;
              var postCode = bindKey + "." + af.key[0];
              var add1 = bindKey + "." + af.key[1];
              var add2 = bindKey + "." + af.key[2];

              $zipWrap.find("input").attr("ng-model", postCode);
              $zipWrap.find("button").attr("ng-click", "vc.setAddressField('"+postCode+"','"+add1+"','"+add2+"')");
              $add1Wrap.find("label").text('주소');
              $add1Wrap.find("label").attr("title", "주소");
              $add1Wrap.find("input").attr("ng-model", add1);
              $add2Wrap.find("label").text('상세주소');
              $add2Wrap.find("label").attr("title", "상세주소");
              $add2Wrap.find("input").attr("ng-model", add2);
              $add2Wrap.find("input").removeAttr("readonly");                
              $zipWrap.attr("data-key", af.key)
              //$zipWrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
              $add1Wrap.attr("data-key", af.key)
              //$add1Wrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
              $add2Wrap.attr("data-key", af.key)
              //$add2Wrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
              arrayObj.push($zipWrap.clone());
              arrayObj.push($add1Wrap.clone());
              arrayObj.push($add2Wrap.clone());
            } else if(af.type == "checkbox") {
              // var $mdCheckbox = $("<md-checkbox />", {
              //   "ng-true-value" : 'Y',
              //   "ng-false-value" : 'N',
              //   "role" : 'checkbox',
              //   class : 'md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty',
              // });
              var $mdCheckbox = $("<md-checkbox />", {
              });

              if(af.disabled != undefined) $mdCheckbox.attr("ng-disabled", af.disabled);
              $mdCheckbox.attr("ng-true-value", "'Y'");
              $mdCheckbox.attr("ng-false-value", "'N'");
              $mdCheckbox.attr("role", 'checkbox');
              var $inputGroup = $("<div />", {class:"input-group"});

              if(af.bindData != undefined) {    
                $mdCheckbox.attr("ng-repeat", "li in " + af.bindData.replace("vm.","vc."));
                $mdCheckbox.attr("role", 'checkbox');
                af.bindKey = forms.bindKey + "[li.Code]";
                $mdCheckbox.attr('ng-model', af.bindKey)
                $mdCheckbox.attr('title', '{{li.CodeValue}}')
                $mdCheckbox.text("{{li.CodeValue}}");

                if(af.label != undefined) {
                  var $label = $("<label />", {
                    text : af.label
                  })
                  
                  $inputGroup.html($mdCheckbox.clone());
                  $copyObj.html($label.clone());
                  $copyObj.append($inputGroup);
                  
                } else {
                  $inputGroup.html($mdCheckbox.clone());
                  $copyObj.append($mdCheckbox.clone());
                }
              } else if(Array.isArray(af.key)) {
                //$copyObj.empty().html('');
                for(var k = 0; k < af.label.length; k++) {
                  af.bindKey = forms.bindKey + "." + af.key[k];
                  $mdCheckbox.attr('ng-model', af.bindKey)
                  $mdCheckbox.text(af.label[k])
                  $copyObj.append($mdCheckbox.clone());
                }
              } else {
                af.bindKey = forms.bindKey + "." + af.key;
                $mdCheckbox.attr('ng-model', af.bindKey)
                $mdCheckbox.text(af.label)
                $copyObj.append($mdCheckbox.clone());
              }              
            }

            if(af.where != undefined) {
              $mainWrap.attr('ng-if', af.where);
            }
            

            if(!checkDoubleDate && !checkZipCode) {
              $mainWrap.html($copyObj.clone());
              $mainWrap.attr("data-key", af.key)
              arrayObj.push($mainWrap.clone());
            }

            
            checkDoubleDate = false;
            checkZipCode = false;
          }

       

          if(forms.fixOrder == undefined) forms.fixOrder = true
          if(forms.fixOrder == true) {
            for(var k = 0; k < arrayObj.length; k++) 
              $elem.append(arrayObj[k].clone());

              $compile($elem)(D.scope);
              initViewLoadedInputBoxStyle();
              //if(checkUseModal) {
                thisObj.setModalFn(D);
              //}
              if(checkUseZipCode) {
                thisObj.setAddressFn(D);
              }
          } else {
            var intervalCount = 0;
            var interval = $interval(function(){
              try {
                if(!D.vm.columnMap) {
                  intervalCount++;
                  if(intervalCount==5){
                    $interval.cancel(interval);
                  }
                } else {
                  $interval.cancel(interval);
                  var keys = Object.keys(D.vm.columnMap);
                  for(var k = 0; k < keys.length; k++) {
                    for(var l = 0; l < arrayObj.length; l++) {
                      var dataKey = $(arrayObj[l]).attr("data-key");
                      if(dataKey == keys[k]) {
                        $elem.append(arrayObj[l].clone())
                      }
                    }
                  }
                  $compile($elem)(D.scope);
                  initViewLoadedInputBoxStyle();
                  //if(checkUseModal) {
                    thisObj.setModalFn(D);
                  //}
                }
              } catch(e) {
                $interval.cancel(interval);
                console.table(e);
              }
            },500);
          }
        },
        setSrchDateForm : function(){
          var D = this.datas;
          var dateInfo = this.dateInfo;
          for(var i = 0; i < dateInfo.length; i++) {
            var obj = this.getStrObjectValue(D, dateInfo[i].bindKey);
            if(obj == undefined) continue;
            obj = moment(obj).toDate();//format('YYYY-MM-DD');
            var key = dateInfo[i].key;
            key = key.replace("vm.","");
            if(key.indexOf("_Str") > 0) {
              obj = $filter('localToUtc')(obj,'to');
            } else {
              obj = $filter('localToUtc')(obj,'from');
            }
            this.datePicker().setDate(key, obj)
          }
        },
        setStrObjValue : function(D, p, v){
          p = p.replace("vc.", "vm.").split(".");
          var object = D;
          for(var i = 0; i < p.length-1; i++) {
            object = Object.assign(object[p[i]]);
          }
          $timeout(function(){
            object[ p[p.length -1]] = v;
          },0);
          
        },
        getStrObjectValue : function(D, p){

          try {
            var ps = p.replace("vc.", "vm.").split(".");
            var object = D;
            for(var i = 0; i < ps.length-1; i++) {              
              object = Object.assign(object[ps[i]]);
            }
            return object[ ps[ps.length-1]];
          } catch(e) {
            return null;
          }
        },
        getStrObject : function(D, p){

          try {
            var ps = p.replace("vc.", "vm.").split(".");
            var object = D;
            for(var i = 0; i < ps.length; i++) {              
              object = Object.assign(object[ps[i]]);
            }
            return object;
          } catch(e) {
            return null;
          }
        },
        setAddressFn : function(D) {
          var thisObj = this;
          if(this.checkEmptyType(D.vm.setAddressField)) {
            D.vm.setAddressField = function(p1, p2, p3) {
              new daum.Postcode({
                oncomplete: function(data) {
                  thisObj.setStrObjValue(D, p1, data.zonecode);
                  var addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
                  thisObj.setStrObjValue(D, p2, addr1);
                },
              }).open();
            };
          }
        },
        setModalFn : function(D) {

          if(this.checkEmptyType(D.vm.eraserModalData)) {
            D.vm.eraserModalData = function(p1, p2) {
              p1 = p1.replace("vc.", "vm.").split(".");
              p2 = p2.replace("vc.", "vm.").split(".");

              if(p1.length == 1) {
                D[p1[0]] = '';
              } else if(p1.length == 2) {
                D[p1[0]][p1[1]] = '';
              } else if(p1.length == 3) {
                D[p1[0]][p1[1]][p1[2]] = '';
              }

              if(p2.length == 1) {
                D[p2[0]] = '';
              } else if(p2.length == 2) {
                D[p2[0]][p2[1]] = '';
              } else if(p2.length == 3) {
                D[p2[0]][p2[1]][p2[2]] = '';
              }
             
            };
          }

          if(this.checkEmptyType(D.vm.openModal)) {
            D.vm.openModal = function(p, callback, cancelCallback) {
              var modalInstance = modalFactory.open(p.size, p.template, p.ctrl, p.param);
              modalInstance.result.then(function(res) {
                if(callback != undefined) {
                  callback(res);
                }
              }, function(cancelData) {
                if(cancelCallback != undefined) {
                  cancelCallback(cancelData);
                }
              });
            };
          }

        },
        drawFormBox : function(D) {
  
          var thisObj = this;
          if(D.FormGroup.drawSuccess == true) return;
          D.FormGroup.drawSuccess = true;

          for(var i = 0; i < D.FormGroup.length; i++) {
            var afg = D.FormGroup[i];
            var target = afg.target.split(" ");
            var $elem = null;
            var elemWidth;
            var checkUseModal = false;
            var checkZipCode = false, checkUseZipCode = false;
            for(var j = 0; j < target.length; j++) {
              if(target[j].indexOf("[") > -1) {
                var splite = target[j].replaceAll(" ","").split("[");
                splite[1] = Number(splite[1].replace("]", ""));
                ($elem != null) ? $elem = $elem.find(splite[0]).eq(splite[1]) : $elem = $(splite[0]).eq(splite[1]);
              } else {
                ($elem != null) ? $elem = $elem.find(target[j]) : $elem = $(target[j]);
              }
            }

            //var $elem = angular.element(afg.target);
            var arrayObj = [];
            if(D.pageType.toUpperCase() == thisObj.pageType.LIST) {
              if (!isNullOrEmpty(afg.searchboxSize)) {
                $elem.closest(".search-detail-wrap").css("width", afg.searchboxSize);
                elemWidth = Number(afg.searchboxSize.replace("px","").replace("%",""));
              } else {
                elemWidth = $elem.closest(".search-detail-wrap").width();
              }
            }
            //$elem.empty().html('');
            var field = afg.field;
            if(!field) field = [];
            for(var j = 0; j < field.length; j++) {
              var af = field[j];
              var col=4, colClass = "";
              if (!isNullOrEmpty(af.col)) col = Number(af.col);
              if(col==4) colClass = "col-xs-12 col-sm-6 col-md-3 col-lg-3 col-xl-3";
              else if(col==3) colClass = "col-xs-12 col-sm-6 col-md-4 col-lg-4 col-xl-4";
              else if(col==2) colClass = "col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6";
              else if(col==1) colClass = "col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12";
              var $fObj = thisObj.getObjFieldType(af.type, colClass);
              var $copyObj = $fObj.clone();

              var $mainWrap = $("<div />", {
                class : colClass
              });

              var checkDoubleDate = false;
              if(af.type == "date") {

                if(Array.isArray(af.bindKey)) {
                  checkDoubleDate = true;
                  if(elemWidth > 500 && col < 3) {
                    $mainWrap.attr("class", "col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6");
                  }
                  var $input = $copyObj.find("input");
                  // from
                  var dateKey = af.bindKey[0].split(".");
                  dateKey = dateKey[dateKey.length-1];
                  D.vm[dateKey] = '';
                  var value = af.bindKey[0] + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                  $input.attr("ng-change", value);
                  $input.attr("ng-model", "vc." + dateKey);
                  if(thisObj.datas.pageType.toUpperCase() == thisObj.pageType.LIST) {
                    $input.attr("placeholder", af.label[0]);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.text(af.label[0]);
                  }

                  $mainWrap.html($copyObj.clone());
                  $mainWrap.attr("data-key", af.key)
                  $mainWrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
                  arrayObj.push($mainWrap.clone());
                  
                  if(af.utcYn) {
                    var dateInfo = {key : af.key, bindKey : af.bindKey[0], datetype : af.datetype, mapCode : afg.MapperId};
                    thisObj.dateInfo.push(dateInfo)
                  }

                  // to
                  var dateKey = af.bindKey[1].split(".");
                  dateKey = dateKey[dateKey.length-1];
                  D.vm[dateKey] = '';
                  var value = af.bindKey[1] + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                  $input.attr("ng-change", value);
                  $input.attr("ng-model", "vc." + dateKey);
                  if(thisObj.datas.pageType.toUpperCase() == thisObj.pageType.LIST) {
                    $input.attr("placeholder", af.label[1]);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.text(af.label[1]);
                  }
                  
                  $mainWrap.html($copyObj.clone());
                  $mainWrap.attr("data-key", af.key)
                  $mainWrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
                  arrayObj.push($mainWrap.clone());

                  if(af.utcYn) {
                    var dateInfo = {key : af.key, bindKey : af.bindKey[1], datetype : af.datetype, mapCode : afg.MapperId};
                    thisObj.dateInfo.push(dateInfo)
                  }

                } else {
                  var $input = $copyObj.find("input");
                  // from
                  var dateKey = af.bindKey.split(".");
                  dateKey = dateKey[dateKey.length-1];
                  D.vm[dateKey] = '';
                  var value = af.bindKey + " = (vc." + dateKey + "| date: 'yyyy-MM-dd')";
                  $input.attr("ng-change", value);
                  $input.attr("ng-model", "vc." + dateKey);
                  
                  if(thisObj.datas.pageType.toUpperCase() == thisObj.pageType.LIST) {
                    $input.attr("placeholder", af.label[0]);
                  } else {
                    var $label = $copyObj.find("label");
                    $label.text(af.label);
                  }

                  if(af.utcYn) {
                    var dateInfo = {key : af.key, bindKey : af.bindKey, datetype : af.datetype, mapCode : afg.MapperId};
                    thisObj.dateInfo.push(dateInfo);
                  }
                }
              } else if(af.type == "input"){
                var $input = $copyObj.find("input");
                $input.attr("ng-model", af.bindKey);
                if(thisObj.datas.pageType.toUpperCase() != thisObj.pageType.LIST) {
                  var $label = $copyObj.find("label");
                  $label.html(af.label);
                } else {
                  $input.attr("placeholder", af.label);
                }
              } else if(af.type == "select"){
                var $ccc = $copyObj.find("common-code-custom");
                var $label = $copyObj.find("label");
                $ccc.attr("code-list", "vc.columnMap['" + af.key + "'].CodeList");
                $ccc.attr("code-model", af.bindKey);
                $label.text(af.label);
                if(af.callback != undefined) {
                  $ccc.attr("callback", af.callback);
                }
              } else if(af.type == "radio"){
                var $label = $copyObj.find("label");
                var $input = $copyObj.find("input");
                var $radioInline = $copyObj.find(".radio-inline");
                $label.text(af.label);
                $radioInline.attr("ng-repeat", "li in vc.columnMap['" + af.key +"'].CodeList");
                $input.attr("ng-model", af.bindKey);
                $input.attr("ng-checked", af.bindKey + " == li.Code");
                if(af.callback != undefined) $input.attr("ng-change", af.callback + "();");
                $radioInline.append("{{li.CodeValue}}");
              } else if(af.type == "modal"){
                checkUseModal = true;
                var $label = $copyObj.find("label");
                $label.html(af.label);
                var $input = $copyObj.find("input");
                $input.attr("ng-model", af.bindLabel);
                var $searchBtn = $copyObj.find("button").eq(0);
                var $eraserBtn = $copyObj.find("button").eq(1);

                $searchBtn.attr("ng-click", af.clickFn + "();")
                $eraserBtn.attr("ng-click", "vc.eraserModalData('" + af.bindLabel+ "','" + af.bindKey +"');")
              }  else if(af.type == "address"){
                checkZipCode = true, checkUseZipCode = true;
                var $zipWrap = $copyObj.find("> div").eq(0);
                var $add1Wrap = $copyObj.find("> div").eq(1);
                var $add2Wrap = $copyObj.find("> div").eq(2);
                $zipWrap.find("label").text(af.label);
                $zipWrap.find("input").attr("ng-model", af.bindKey[0]);
                $zipWrap.find("button").attr("ng-click", "vc.setAddressField('"+af.bindKey[0]+"','"+af.bindKey[1]+"','"+af.bindKey[2]+"')");
                $add1Wrap.find("label").text('주소');
                $add1Wrap.find("input").attr("ng-model", af.bindKey[1]);
                $add2Wrap.find("label").text('상세주소');
                $add2Wrap.find("input").attr("ng-model", af.bindKey[2]);
                $add2Wrap.find("input").removeAttr("readonly");                
                $zipWrap.attr("data-key", af.key)
                $zipWrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
                $add1Wrap.attr("data-key", af.key)
                $add1Wrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
                $add2Wrap.attr("data-key", af.key)
                $add2Wrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
                arrayObj.push($zipWrap.clone());
                arrayObj.push($add1Wrap.clone());
                arrayObj.push($add2Wrap.clone());
              }

              if(!checkDoubleDate && !checkZipCode) {
                $mainWrap.html($copyObj.clone());
                $mainWrap.attr("data-key", af.key)
                $mainWrap.attr("ng-if", "vc.columnMap['" + af.key + "']")
                arrayObj.push($mainWrap.clone());
              }

              checkDoubleDate = false;
              checkZipCode = false;
            }

            if(afg.fixOrder == true) {
              for(var k = 0; k < arrayObj.length; k++) 
                $elem.append(arrayObj[k].clone());
                $compile($elem)(D.scope);
                //if(checkUseModal) {
                  thisObj.setModalFn(D);
                //}
                if(checkUseZipCode) {
                  thisObj.setAddressFn(D);
                }
            } else {
              var intervalCount = 0;
              var interval = $interval(function(){
                try {
                  if(!D.vm.columnMap) {
                    intervalCount++;
                    if(intervalCount==5){
                      $interval.cancel(interval);
                    }
                  } else {
                    $interval.cancel(interval);
                    var keys = Object.keys(D.vm.columnMap);
                    for(var k = 0; k < keys.length; k++) {
                      for(var l = 0; l < arrayObj.length; l++) {
                        var dataKey = $(arrayObj[l]).attr("data-key");
                        if(dataKey == keys[k]) {
                          $elem.append(arrayObj[l].clone())
                        }
                      }
                    }
                    $compile($elem)(D.scope);
                    //if(checkUseModal) {
                      thisObj.setModalFn(D);
                    //}
                  }
                } catch(e) {
                  $interval.cancel(interval);
                  console.table(e);
                }
              },500);
            }
          }
        },

        openModal : function(p, callback, cancelCallback) {
          var modalInstance = modalFactory.open(p.size, p.template, p.ctrl, p.param);
          modalInstance.result.then(function(res) {
            if(callback != undefined) {
              callback(res);
            }
          }, function(cancelData) {
            if(cancelCallback != undefined) {
              cancelCallback(cancelData);
            }
          });
        },
        alert : function(MSG, callback){
          if(callback == undefined)
            gAlert('', MSG);
          else 
            gAlert('',MSG, {
              btn : '',
              fn : function() {
                callback();
              }
            });
        },
        confirm : function(MSG, okCallback, cancelCallback) {
          gConfirm('', MSG, {
            btn : '',
            fn : function() {
              if(okCallback != undefined)
              okCallback();
            }
          }, {
            btn : '',
            fn : function() {
              if(cancelCallback != undefined)
                cancelCallback();
            }
          });

        },
        toast : function(msg) {
          $rootScope.showSimpleToast(msg);
        },

        go : function(p1, p2, p3) {
          if(p3 == undefined)
            $state.go(p1, p2 , {reload: p1});
          else 
            $state.go(p1, p2 , {reload: p3});
        },
        datePicker : function() {
          var vm = this.datas.vm;
          var dates = this.dateInfo;
          var thisObj = this;
          return {
            setDate : function(key, date) {           
              if(key.indexOf("vc.") > -1) {
                key = key.replace("vc.", "vm.")
              } 
              if(key.indexOf("vm.") == - 1) {
                key = "vm." + key;
              }

              for(var i  = 0; i < dates.length; i++) {
                if(key == dates[i].key) {
                  var caldate =  moment(date).format('YYYY-MM-DD');
                  var bindKeyArray = dates[i].bindKey.split(".");
                  if(bindKeyArray.length == 2) {
                    vm[bindKeyArray[1]] = caldate;
                  } else if(bindKeyArray.length == 3) {
                    vm[bindKeyArray[1]][bindKeyArray[2]] = caldate;
                  } else if(bindKeyArray.length == 4) {
                    vm[bindKeyArray[1]][bindKeyArray[2]][bindKeyArray[3]] = caldate;
                  } else if(bindKeyArray.length == 5) {
                    vm[bindKeyArray[1]][bindKeyArray[2]][bindKeyArray[3]][bindKeyArray[4]] = caldate;
                  } else if(bindKeyArray.length == 6) {
                    vm[bindKeyArray[1]][bindKeyArray[2]][bindKeyArray[3]][bindKeyArray[4]][bindKeyArray[5]] = caldate;
                  }

                  var keyArray = dates[i].key.split(".");
                  vm[keyArray[1]] = moment(date).toDate();
                  
                }                
              }
            },

            moment : function(p) {
              if(p == undefined) {
                return moment().toDate();
              } else {
                return moment(p).toDate();
              }
              
            },

            getToday : function() {
              return moment().toDate();
            },

            getTodayStartOf : function() {
              return moment().startOf('day');
            },            

            setCalDays  : function(p, month, option) {
              // option :
              // d = day
              // w = week
              // M = Month
              // y = year
              if(option.toUpperCase == "M") option = "M";
              vm[p] = moment(moment().add(month, option)).toDate();
            },

            setCalMonth  : function(p1, p2, p3, p4, p5) {
              var checkDateP1 = false;
              if(new Date(p1) == "Invalid Date" || new Date(p1).toISOString().split('T')[0] == "1970-01-01") {
                checkDateP1 = false;
              } else {
                checkDateP1 = true;
              }
              var checkNaN_p1 = isNaN(p1);
              var checkNaN_p2 = isNaN(p2);
              var result;
              if(typeof(p1) == 'string' && !checkNaN_p2 && !checkDateP1) {
                p1 = p1.replace('vm.', '').replace('vc.', '');
                if(p2 == 0) {
                  result = moment(moment(moment(vm[p1]).toDate()).add(p2, 'M')).toDate();
                } else {
                  result = moment(moment(moment(vm[p1]).toDate()).add(p2, 'M').subtract(1, 'd')).toDate();
                }                
              } else if(typeof(p1) == 'object' && checkDateP1)  {
                if(p2 == 0) {
                  result = moment(moment(moment(p1).toDate()).add(p2, 'M')).toDate();
                } else {
                  result = moment(moment(moment(p1).toDate()).add(p2, 'M').subtract(1, 'd')).toDate();
                }
              } else if(!checkNaN_p1) {
                if(p1 == 0) {
                  result = moment(moment().add(p1-0, 'd')).toDate();
                } else {
                  result = moment(moment().add(p1-1, 'd')).toDate();
                }
              }

              return result;
            },

            setCalDay  : function(p1, p2, p3, p4, p5) {
              var result;
              if(p3 != undefined) {
                // p1 참고
                // p2 기간
                // p3 타입
                p3 = p3.toLowerCase();
                if(p3 == "m") p3 = "M";
                
                if(p2 == 0) {
                  result = moment(moment(moment(p1).toDate()).add(Number(p2), p3)).toDate();
                } else{
                  result = moment(moment(moment(p1).toDate()).add(Number(p2), p3).subtract(1, 'd')).toDate();
                }
              } else {
                var checkDateP1 = false;
                if(new Date(p1) == "Invalid Date" || new Date(p1).toISOString().split('T')[0] == "1970-01-01") {
                  checkDateP1 = false;
                } else {
                  checkDateP1 = true;
                }
                var checkNaN_p1 = isNaN(p1);
                var checkNaN_p2 = isNaN(p2);
                var result;
                if(typeof(p1) == 'string' && !checkNaN_p2 && !checkDateP1) {
                  p1 = p1.replace('vm.', '').replace('vc.', '');
                  result = moment(moment(moment(vm[p1]).toDate()).add(p2, 'd')).toDate();
                } else if(typeof(p1) == 'object' && checkDateP1)  {
                  result = moment(moment(moment(p1).toDate()).add(p2, 'd')).toDate();
                } else if(!checkNaN_p1) {
                  result = moment(moment().add(p1, 'd')).toDate();
                }
              }

              return result;
            },
          }
        },
        
      }; // End Fns;
      return fns;
    }

    return ins;
  },
])
.directive('pageHeader', 
  [ '$compile', '$parse', function($compile, $parse) {

    var $row = $("<div />", { class: "row" });
    var $wrap = $("<div />", { class: "col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12" });
    var $pageHeader = $("<div />", { class: "page-header", text: "{{vc.headerTitle}}" });
    var $dockBtnWrap = $("<div />", { class: "pull-right dock-header-tx list-split" });

    var btns = ["vc.setChangeLayout('N', vc)", "vc.setChangeLayout('V', vc)","vc.setChangeLayout('H', vc)"];
    var imgs = ["assets/images/icon-sp-list.png", "assets/images/icon-sp-rl.png", "assets/images/icon-sp-tb.png"];

    for(var i = 0; i < btns.length; i++) {
      var $btn = $("<span />", { "ng-click": btns[i] });
      var $img = $("<img />", { alt: "", src: imgs[i] });
      $btn.html($img.clone());
      $dockBtnWrap.append($btn.clone());
    }

    $pageHeader.append($dockBtnWrap.clone());
    $wrap.html($pageHeader.clone());
    $row.html($wrap.clone());
    return {
      transclude : true,
      replace: true,
      restrict : 'E',
      require: false,
      scope : false,
      template : $wrap.html(),
      compile: function compile(tElement, tAttrs) {
        return function postLink(scope, iElement, iAttrs) { }
      },
      link : function(scope, element, attrs, ctrl) {}
    };
}])
.directive('listTable', 
  [ '$compile', '$parse', 
  function($compile, $parse) {

    var $row = $("<div />", { class: "row" });
    var $wrap = $("<div />", { class: "col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12" });
    var $panel = $("<div />", { class: "panel panel-default tile" });
    var $panelBody = $("<div />", { class: "panel-body collapse in" });
    var $table = $("<table />", {
      class : "table table-striped table-bordered table-hover data_table table-custom",
      "data-filter" : "#filter", ///있긴한데 불필요한 것 같아서 주석처리
      style: "table-layout:fixed"
    });
    var $thead = $("<thead />", {});
    var $tr = $("<tr />", {});
    var $checkHeader = $("<th />", {class: 'text-center', style : 'vertical-align:middle; width: 40px;', 'ng-if':'vc.listCheckboxEnable'});
    var $headerCheckbox = $("<input />", {type:'checkbox', 'ng-click': 'vc.chkRowAll()', 'ng-model' : 'vc.checkListCheckbox'});
    $checkHeader.html($headerCheckbox.clone());
    var $theadTh = $("<th />", {
      class: "text-center none {{liCol.ListColumnShowLevel}}",
      "data-toggle" : "{{liCol.KeyColumnYN == 'Y'? 'true' : 'false'}}",
      "ng-click" : "vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN, liCol)",
      "ng-repeat" : "liCol in vc.listColumns",
      style : "width: {{liCol.ListColumnWidth}}",
      text : "{{ ::liCol.ColumnLogicalNm | translate }}"
    });
    var $theadThSpen = $("<span />", {
      class : "fa fa-sort",
      "ng-show" : "liCol.KeyColumnYN == 'Y'"
    });
    var $tbody = $("<tbody />", {});
    var $checkBodyTd = $("<td />", {class: 'text-center', style : 'vertical-align:middle; width: 40px;', 'ng-if':'vc.listCheckboxEnable'});
    var $checkBodyTdInput = $("<input />", {type:'checkbox', 'ng-model' : 'li.chkRow', 'ng-change': 'vc.chkRowChg(li)'});
    $checkBodyTd.html($checkBodyTdInput.clone())

    var $listTr = $("<tr />", { "ng-repeat": "li in vc.lists", style: "cursor:pointer", "ng-class": "{'bg-lightyellow':vc.getListKeyId() == li.KeyId}"});
    var $listTd = $("<td />", { 
      class: "{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}",
      "ng-click": "vc.listToPage(li)", 
      "ng-repeat" : "liCol in vc.listColumns",
      text : "{{liCol.ColumnLogicalDataType != '40' ? (liCol.ColumnLogicalDataType == '20' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:'yyyy-MM-dd')}}",     });
    
    var $emptyDiv = $("<div />", { 
      class: "tbnodata", 
      "ng-if" : "vc.totalItems == 0",  
      text : "{{ 'MSG.NO_DATA' | translate }}",
      style : "text-align:center; padding:15px; border:solid 1px #CCC; border-top:none;"
    });

    $tr.html($checkHeader.clone());
    $theadTh.append($theadThSpen.clone());
    $tr.append($theadTh.clone());
    $thead.html($tr.clone());
    $table.html($thead.clone());
    // $emptyTr.html($emptyTd.clone());
    // $tbody.append($emptyTr.clone());

    $listTr.html($checkBodyTd.clone());
    $listTr.append($listTd.clone());
    $tbody.append($listTr.clone());
    $table.append($tbody.clone());
    $panelBody.append($table.clone());
    $panelBody.append($emptyDiv.clone());

    // 페이징까지 처리진행
    var $wrap2 = $("<div />", { class: "col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12" });
    var $panel = $("<div />", { class: "panel panel-default tile" });
    var $panelBody2 = $("<div />", { class: "panel-body collapse in" });
    var $row2 = $("<div />", { class: "row" });
    var $viewSizeWrap = $("<div />", { class: "col-xl-4 col-lg-4 col-md-4 col-sm-2 col-xs-2 col-sm-hidden col-xs-hidden  paging_pad", style:"width:50%" });
    var $formGroup = $("<div />", { class: "form-group form-inline select-size-list"});
    var $label = $("<label />", {text : "{{ :: 'Menu.LIST' | translate }}"});
    var $select = $("<select />", { 
      "aria-controls" : "DataTables_Table_0", class: "input-sm", name: "DataTables_Table_0_length",
      "ng-change" :"vc.setChangeViewSize()", "ng-model" : "vc.srch.viewSize",
      "ng-options" : "c for c in vc.listSize" });
    var $pagingBarWrap = $("<div />", { class: "col-xl-8 col-lg-8 col-md-8 col-sm-6 col-xs-6 paging_pad", style:"width:50%"});
    var $pullRight =  $("<div />", { class: "paging dataTables_paginate pull-right" });
    var $ul =  $("<ul />", { 
      "uib-pagination" : "",
      "data-ng-if" :"vc.totalItems", "direction-links" :"true", "first-text":"{{'BTN.PAGINATION.FIRST'|translate}}", "last-text": "{{'BTN.PAGINATION.LAST'|translate}}",
      "name" : "pagination", "next-text" : "{{'BTN.PAGINATION.NEXT'|translate}}", "ng-change" : "vc.setPageChanged()", "ng-model":"vc.currentPage",
      "previous-text":"{{'BTN.PAGINATION.PREV'|translate}}", "total-items":"vc.totalItems", "boundary-links":"true",
      "items-per-page":"vc.viewSize", "max-size" : "vc.maxSize", "num-pages":"vc.numPages", "rotate":"false", "template-url" : "components/template/pagination.html"
    });
    var $row3 = $("<div />", { class: "row" });
    $formGroup.append($label.clone());
    $formGroup.append($select.clone());
    $viewSizeWrap.append($formGroup.clone());
    $row2.append($viewSizeWrap.clone());    
    $pullRight.append($ul.clone());
    $pagingBarWrap.append($pullRight.clone());
    $row2.append($pagingBarWrap.clone());
    $panelBody.append($row2.clone());
    $panel.append($panelBody.clone());
    $wrap.append($panel.clone());
    $row.append($wrap.clone());
    var $last = $("<div />");
    $last.html($row.clone());

    return {
      transclude : true,
      replace: false,
      restrict : 'E',
      require: false,
      scope :false,
      template : $last.html(),
      compile: function compile(tElement, tAttrs) {
        return function postLink(scope, iElement, iAttrs) { }
      },
      link : function(scope, element, attrs, ctrl) {}
    };
}])
.directive('listCustom', 
  [ '$compile', '$parse', 
  function($compile, $parse) {
    return {
      restrict : 'E',
      compile: function compile(element, tAttrs) {
       
        var viewTypeObj = element.find("[view-type]");
        for(var i = 0; i < viewTypeObj.length; i++) {

          var bindObj = viewTypeObj.eq(i).find("[bind-key]");
          for(var j = 0; j < bindObj.length; j++) {
            bindObj.eq(j).attr("ng-bind", bindObj.eq(j).attr("bind-key"))
          }

          var ifObj = viewTypeObj.eq(i).find("[bind-if]");
          for(var j = 0; j < ifObj.length; j++) {
            ifObj.eq(j).attr("ng-if", ifObj.eq(j).attr("bind-if"))
          }

          if(viewTypeObj.eq(i).attr("bind-repeat") != undefined) {
            viewTypeObj.eq(i).attr("ng-repeat", viewTypeObj.eq(i).attr("bind-repeat"));
          }
          var repeatObj = viewTypeObj.eq(i).find("[bind-repeat]");
          for(var j = 0; j < repeatObj.length; j++) {
            repeatObj.eq(j).attr("ng-repeat", repeatObj.eq(j).attr("bind-repeat"))
          }
        }
      }
    };
}])
.directive('listPaging', 
  [ '$compile', '$parse', 
  function($compile, $parse) {

    // 페이징까지 처리진행
    var $wrap2 = $("<div />", { class: "col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12" });
    var $panel = $("<div />", { class: "panel panel-default tile" });
    var $panelBody2 = $("<div />", { class: "panel-body collapse in" });
    var $row2 = $("<div />", { class: "row" });
    var $viewSizeWrap = $("<div />", { class: "col-xl-4 col-lg-4 col-md-4 col-sm-2 col-xs-2 col-sm-hidden col-xs-hidden  paging_pad", style:"width:50%" });
    var $formGroup = $("<div />", { class: "form-group form-inline select-size-list"});
    var $label = $("<label />", {text : "{{ :: 'Menu.LIST' | translate }}"});
    var $select = $("<select />", { 
      "aria-controls" : "DataTables_Table_0", class: "input-sm", name: "DataTables_Table_0_length",
      "ng-change" :"vc.setChangeViewSize()", "ng-model" : "vc.srch.viewSize",
      "ng-options" : "c for c in vc.listSize" });
    var $pagingBarWrap = $("<div />", { class: "col-xl-8 col-lg-8 col-md-8 col-sm-6 col-xs-6 paging_pad", style:"width:50%"});
    var $pullRight =  $("<div />", { class: "paging dataTables_paginate pull-right" });
    var $ul =  $("<ul />", { 
      "uib-pagination" : "",
      "data-ng-if" :"vc.totalItems", "direction-links" :"true", "first-text":"{{'BTN.PAGINATION.FIRST'|translate}}", "last-text": "{{'BTN.PAGINATION.LAST'|translate}}",
      "name" : "pagination", "next-text" : "{{'BTN.PAGINATION.NEXT'|translate}}", "ng-change" : "vc.setPageChanged()", "ng-model":"vc.currentPage",
      "previous-text":"{{'BTN.PAGINATION.PREV'|translate}}", "total-items":"vc.totalItems", "boundary-links":"true",
      "items-per-page":"vc.viewSize", "max-size" : "vc.maxSize", "num-pages":"vc.numPages", "rotate":"false", "template-url" : "components/template/pagination.html"
    });

    $formGroup.append($select.clone());
    $viewSizeWrap.append($formGroup.clone());
    $row2.append($viewSizeWrap.clone());    
    $pullRight.append($ul.clone());
    $pagingBarWrap.append($pullRight.clone());
    $row2.append($pagingBarWrap.clone());
    // $panelBody.append($row2.clone());
    // $panel.append($panelBody.clone());
    // $wrap.append($row2.clone());
    // $row.append($wrap.clone());
    var $last = $("<div />", {
      class : 'row'
    });
    $last.html($row2.clone());

    return {
      transclude : true,
      replace: false,
      restrict : 'E',
      require: false,
      scope :false,
      template : $last.html(),
      compile: function compile(tElement, tAttrs) {
        return function postLink(scope, iElement, iAttrs) { }
      },
      link : function(scope, element, attrs, ctrl) {}
    };
}]);
/* "use strict"; */
webapp.service('commonFns', 
  ['GLOBAL_CONSTANT', 'StaticVariable', '$rootScope', '$window', '$state', '$stateParams',
  function commonFns(CONSTANT, StaticVariable, $rootScope, $window, $state, $stateParams) {

    var fns = {
      vm : {},
      makeSrchData : function(srchData) {

        var temp = {};
        (!isNullOrEmpty(srchData.keyTableNm)) ? temp.keyTableNm = srchData.keyTableNm : temp.keyTableNm = ""; // 작업테이블명
        (!isNullOrEmpty(srchData.sortDirect)) ? temp.sortDirect = srchData.sortDirect : temp.sortDirect = ""; // 정렬순서 (ASC:오름차순, DESC:내림차순)
        (!isNullOrEmpty(srchData.sortColumn)) ? temp.sortColumn = srchData.sortColumn : temp.sortColumn = ""; // 정렬컬럼명
       
        if (!srchData.srch) {
          this.vm.srch = {};
          this.vm.srch.page = 1;
          this.vm.srch.viewSize = !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          this.vm.srch.tableNm = temp.keyTableNm;
          this.vm.srch.sortDirect = temp.sortDirect;
          this.vm.srch.sortColumn = temp.sortColumn;
        } else {
          this.vm.srch = JSON.parse(decodeURIComponent(srchData.srch));
          this.vm.srch.tableNm = !isNullOrEmpty(srchData.srch.tableNm) ? srchData.srch.tableNm : temp.keyTableNm;
        }

        var result = angular.copy(this.vm.srch);
        this.vm = {};
        return result;
      },

      setLayout : function(vm) {
        vm.layout = $rootScope.gVariable.layoutBoard;
        this.initChangeLayout(vm);
      },
      initChangeLayout : function(vm) {
        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }

        vm.setChangeLayout = function(layout, vc) {
          $window.sessionStorage.setItem('layoutBoard', layout);
          $rootScope.gVariable.layoutBoard = layout;
          var srch = vc.srch; // 검색 옵션
          var url = vc.PageUrl.LIST_PAGE_URL;
          url = url.substring(0, url.indexOf("/"));
          var urlOption = vc.PageUrl.LIST_PAGE_URL;
          var param = {};
          param.srch = srch;
          if(urlOption.indexOf("({") != -1) {
            urlOption = urlOption.substring( urlOption.indexOf("({"), urlOption.length)
              .replaceAll(" ","").replaceAll("({","").replaceAll("})","").replaceAll('"',"").replaceAll("'","").split(",");
            for(var i = 0; i < urlOption.length; i++) {
              var keyValue = urlOption[i].split(":");
              param[keyValue[0]] = keyValue[1];
            }
          }
          //$state.go(url,{ param }, {reload: url});
        }
      },

    };
    return fns;
  }
]);

/* "use strict"; */
webapp.service('customFieldApi', ['$resource', 'StaticVariable', '$rootScope', '$filter',
  function customFieldApi($resource, StaticVariable, $rootScope, $filter) {
    /**
     * * Noti
     *   - 호출 타입
     *     * customFieldApi 내 type 참고
    **/
    var translate = $filter('translate');

    var customFieldApi = {
      setReadOnlyUdcColumns : function(allColumns) {
        var udcColumns = [];
        // var udcCols = vm.allColumns.filter(x => x.CustomColumnYN == 'Y');
        var udcCols = allColumns.filter(function(x) {
          return x.CustomColumnYN == 'Y';
        });
        // for (var i = 0; i < udcCols.length; i += 4){
        var row = {};
        row.className = 'row';
        row.fieldGroup = [];

        for (var j = 0; j < udcCols.length; j++) {
          var item = {};

          if (udcCols[j] !== undefined) {
            item.key = udcCols[j].ColumnPhysicalNm;
            item.className = udcCols[j].EditColumnWidth;

            item.type = 'readOnly';

            item.templateOptions = {};
            item.templateOptions.label = udcCols[j].ColumnLogicalNm;

            row.fieldGroup.push(item);
          }
        }

        // 등록/수정 대상 사용자정의 컬럼 정보
        udcColumns.push(row);

        return udcColumns;
      },
      setEditableUdcColumns : function(allColumns) {
        var udcColumns = [];
        //      var udcCols = vm.allColumns.filter(x => x.CustomColumnYN === 'Y');
        var udcCols = allColumns.filter(function(x) {
          return x.CustomColumnYN === 'Y';
        });

        // row당 4개의 컬럼 표시
        var row = {};
        row.className = 'row';
        row.fieldGroup = [];

        for (var j = 0; j < udcCols.length; j++) {

          var item = {};
          if (udcCols[j] !== undefined) {
            item.key = udcCols[j].ColumnPhysicalNm;
            item.className = udcCols[j].EditColumnWidth+' form-right';
            console.log('udcCols : ',udcCols[j].EditColumnWidth);
            item.type = 'input';

            item.templateOptions = {};
            item.templateOptions.label = udcCols[j].ColumnLogicalNm;

            //TODO: 데이터 유형에 따라서 type을 다르게 처리 필요
            // 10-text, 20-number, 30-number(float), 40-date, 50-select
            console.log(udcCols[j]);
            switch (udcCols[j].ColumnPhysicalDataType) {
            case '20':
              item.templateOptions.type = 'number';
              item.templateOptions.placeholder = '{숫자만 입력하세요.}';
              break;
            case '30':
              item.templateOptions.type = 'number';
              item.templateOptions.placeholder = '{숫자만 입력하세요.}';
              break;
            case '40':
              item.templateOptions.type = 'text';
              item.templateOptions.placeholder = '{년-월-일}';
              break;
            case '50':
              item.type = 'select';
              item.templateOptions.valueProp = 'abbr';
              item.templateOptions.labelProp = 'name';
              item.templateOptions.options = [];

              var items = [{name:'--'+translate('Menu.CHOOSE')+'--',abbr:''}];

              if (udcCols[j].CodeKey != null && udcCols[j].CodeValue != null) {
                var codeValues = udcCols[j].CodeValue.split(',');
                var codeKeys = udcCols[j].CodeKey.split(',');

                codeValues.forEach(function(codeRow, key) {
                  var code = {};
                  code.name = codeRow;
                  code.abbr = codeKeys[key];
                  items.push(code);
                });
              } else  if (udcCols[j].ColumnCodeValue.length > 0) {
                var codeValues = udcCols[j].ColumnCodeValue.split(',');

                codeValues.forEach(function(codeRow) {
                  var code = {};
                  code.name = codeRow;
                  code.abbr = codeRow;
                  items.push(code);
                });
              }

              item.templateOptions.options = items;

              break;
            default:
              item.templateOptions.type = 'text';
              break;
            }

            row.fieldGroup.push(item);
          }
        }
        // 등록/수정 대상 사용자정의 컬럼 정보
        udcColumns.push(row);

        return udcColumns;
      },
    };
    return customFieldApi;
  },
]);

/* "use strict"; */
webapp.service("Helper", ["$state","$location",
  function($state, $location) {
    var services = {};

    function objectKeys(object) {
      var result = [];

      angular.forEach(object, function(val, key) {
        result.push(val);
      });
      return result;
    }

    services.stateIs = function(state_name) {
      var names = state_name.split('.');
      var state = '';
      var url = '';

      angular.forEach(names, function(name) {
        state = state == '' ? name : state + '.' + name;
        if ($state.get(state)) {
          url = url + $state.get(state).url;
        }
      });

      return url;
    };

    return services;
  }
]);

/* "use strict"; */
webapp.service('ifProxy',
  ['GLOBAL_CONSTANT', '$compile', 'postApi', '$window', 'gAlert', '$rootScope', '$state', 'StaticVariable', 'LoginAPISrv', '$timeout',
  function ifProxy(CONSTANT, $compile, postApi, $window, gAlert, $rootScope, $state, StaticVariable, loginApi, $timeout) {

    var vm = this;
    vm.userType = $window.sessionStorage['USE_APPTYPE'];

     /**
     * @description 멤버스 로그인
     * @param Object data : Iframe으로 받은 정보값
     * @return void
     */
    vm.membersLogin = function (data) {
      var field = data;
      field.loginId = field.memId;
      field.loginPw = field.memPwd;
      postApi.login('custLogin',field, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          //$window.localStorage['M_USER_PWD'] = field.memPwd;
          $window.localStorage['M_USER_ID'] = field.memId;
          $window.localStorage['M_USER_PW'] = field.loginPw;
          $window.localStorage['M_USER_SAVEID'] = field.saveId;
          $window.localStorage['M_USER_TYPE'] = "MEMBER";
          $window.localStorage['M_USER_SAVEAUTOLOGIN'] = field.saveAutoLogin;
          $rootScope.setUserSession(result.body.docs[0]);
          $rootScope.$broadcast('broadcastMobileChangeUserState', {});
          ifProxy.send('startLogin', { passYn: true} );
        } else {
          gAlert('', '로그인에 실패하였습니다. 다시 시도하여주세요.', {
            btn: '확인', fn: function () { }
          });
        }
      });
    };
    /**
     * @description 리더스 로그인
     * @param Object data : Iframe으로 받은 정보값
     * @return void
     */
    vm.Login = function (data) {
      var field = data;
      field.loginId = field.memId;
      field.loginPw = field.memPwd;

      postApi.login('login',field, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          //$window.localStorage['M_USER_PWD'] = field.memPwd;
          $window.localStorage['M_USER_ID'] = field.memId;
          $window.localStorage['M_USER_PW'] = field.loginPw;
          $window.localStorage['M_USER_SAVEID'] = field.saveId;
          $window.localStorage['M_USER_TYPE'] = "MASTER";
          $window.localStorage['M_USER_SAVEAUTOLOGIN'] = field.saveAutoLogin;
          $rootScope.setUserSession(result.body.docs[0]);
          $rootScope.$broadcast('broadcastMobileChangeUserState', {});
          ifProxy.send('startLogin', { passYn: true} );
        } else {

          if(result.body.docs.length > 0 && result.body.docs[0].checkApproval == "N") {
            gAlert('', result.body.docs[0].MSG, {
              btn: '확인', fn: function () { }
            });
          } else {
            gAlert('', '로그인에 실패하였습니다. 다시 시도하여주세요.', {
              btn: '확인', fn: function () { }
            });
          }
        }
      });
    };


    var ifProxy = null;
    var regEvent = true;
    ifProxy = {
      instance : this,
      responselistner : null,
      porthole : null,
      $frame : null,
      $fromRequestKey : null,
      orgTargetRequestKey : null,
      getIfProxyReqKey : null,
      reset : function () {

      },
      init : function(option){
        //$window.sessionStorage["M_LAST_PAGE"] = $state.current.name;
        this.porthole = new Porthole.WindowProxy(SHOP_DOMAIN_ADDRESSS, option.targetId);

        $frame = $("#" + option.targetId);
        $frame.attr("ng-src", option.url);
        var offset = $("#page-wrapper [ui-view]").offset();
        $frame.css("height", $(window).height() - offset.top );
        $frame.css("display", "block");
        $compile($frame)(option.scope);

        var callback = option.callback;

        if(regEvent) {
          this.porthole.addEventListener(this.reqeuest);
          regEvent = false;
        }

        if(callback.completInit != null)
          callback.completInit(this.porthole);

        if(callback.contentChangeSuccess != null)
          ifProxy.porthole.Callback_contentChangeSuccess = callback.contentChangeSuccess;

        if(callback.onMessage != null)
          ifProxy.porthole.Callback_onMessage = callback.onMessage;
      },

      reqeuest :  function(msg) {
        if (SHOP_DOMAIN_ADDRESSS.replace("https","").replace("http","") == msg.origin.replace("https","").replace("http","")) {
          ifProxy.orgTargetRequestKey = msg.data.data.requestKey;
          var action = msg.data.action;
          var sData = msg.data.data;
          if(action == "redirctLoginPage") {
            StaticVariable.sessionExpire();
            var prms = loginApi.doLogout().post().$promise;
            prms.then(function(json) {
              var temp = {};
              temp.layoutBoard = "N";
              temp.USE_APPTYPE = $window.sessionStorage["USE_APPTYPE"];
              $window.sessionStorage.clear();
              $window.localStorage.clear();
              gAlert('', '접속 정보가 변경되어 재로그인이 필요합니다.', {
                btn : '',
                fn : function() {
                  $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
                  $window.sessionStorage["USE_APPTYPE"] = temp.USE_APPTYPE;
                  vm.showTopBtn = true;
                  $rootScope.$broadcast('broadcastMobileChangeUserState', {});

                  $state.go("m.member.login");
                }
              });
            }, function(error) {
              console.error('fail', status);
            });
          }

          if(action == "setNavi" && sData.title == "회원로그인" && $window.loginUserIdx != undefined) {
            StaticVariable.sessionExpire();
            var prms = loginApi.doLogout().post().$promise;
            prms.then(function(json) {
              var temp = {};
              temp.layoutBoard = "N";
              temp.USE_APPTYPE = $window.sessionStorage["USE_APPTYPE"];
              $window.sessionStorage.clear();
              $window.localStorage.clear();
              gAlert('', '접속 정보가 변경되어 재로그인이 필요합니다.', {
                btn : '',
                fn : function() {
                  $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
                  $window.sessionStorage["USE_APPTYPE"] = temp.USE_APPTYPE;
                  vm.showTopBtn = true;
                  $rootScope.$broadcast('broadcastMobileChangeUserState', {});
                }
              });
            }, function(error) {
              console.error('fail', status);
            });
          }

          if(action == "startLogin") {
            M.fcm.getFcmToken({
              onSucess:function(token){
                msg.data.data.osType = getOs();
                msg.data.data.fcmToken = token;
                if(vm.userType == "members") {
                  vm.membersLogin(msg.data.data);
                } else {
                  vm.Login(msg.data.data);
                }
              }
            });
            return;
          }

          if(action == "findUserId" || action == "findUserPw") {
            var request = sData;
            request.mapCode = 'checkFindUserInfo';
            request.action = action;
            request.userType = vm.userType;
            postApi.openApi(request, function (result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                console.log(result);
                var req = {};
                if(result.body.docs.length == 0) {
                  req.passYn = false;
                  gAlert('', '해당 정보를 찾을 수 없습니다.', {
                    btn: '확인', fn: function () { }
                  });
                } else {
                  req.passYn = true;
                }
                ifProxy.send(action, req);
              }
            });
            return;
          }

          if(action == "goDashboard") {
            $state.go("m.dashboard");
          }

          if(ifProxy.porthole.Callback_contentChangeSuccess != null && action == 'frameContentChangeSuccess') {
            if($window.sessionStorage["M_LAST_PAGE"] != $state.current.name) {
              ifProxy.porthole.Callback_contentChangeSuccess(sData);
              $window.sessionStorage["M_LAST_PAGE"] = $state.current.name;
            } else {

            }
            return;
          }

          var data = msg.data;
          if(data.useAuth) {

          } else {
            var response = {
              action : action,
              requestKey : data.requestKey,
              data : data.data
            };
            delete response.data.action;
            delete response.data.useAuth;
            ifProxy.porthole.Callback_onMessage(response);
          }
        } else {

        }
      },

      send : function (action, data) {
        if(data == null) data = {};
        if(data != null) {
          data.requestKey = '';
			    data.useAuth = false;
          this.porthole.post({action: action, data : data, useAuth : false});
        } else {
          var data = {};
          data.requestKey = '';
			    data.useAuth = false;
          this.porthole.post({action: action});
        }
      },

      page : function(data) {
        var thisTemp = this;
        var param = {};
        param.requestKey = ifProxy.orgTargetRequestKey;
        var porthole = this.porthole;
        postApi.openApi('getRequestKey',param, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            var action = "goPages";
            data.useAuth = true;
            data.fromKey = param.requestKey;
            data.requestKey = result.body.docs[0].requestKey;
            data.userKey = result.body.docs[0].userKey;
            //porthole.post({action: action, data : data, useAuth : true});
            //alert(JSON.stringify(data))
            thisTemp.overrideSender(action, data);
          } else {
            console.error(result);
          }
        });
      },

      overrideSender : function(action, data) {
        //$timeout(
          try {

          this.porthole.post({action: action, data : data, useAuth : true})
        } catch (e) {
          console.log(e)
          $window.sessionStorage["M_LAST_PAGE"] = "";
          $state.reload($state.current.name);
        }
          //, 500);
          //this.porthole.post({action: action, data : data, useAuth : true});
        //}, 1000)

      },

      authApi : function(actionKey, data) {
        var param = {};
        param.requestKey = ifProxy.orgTargetRequestKey;
        var porthole = this.porthole;
        postApi.openApi('getRequestKey',param, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            var action = "authApi";
            data.useAuth = true;
            data.actionKey = actionKey;
            data.fromKey = ifProxy.orgTargetRequestKey;
            data.requestKey = result.body.docs[0].requestKey;
            data.userKey = result.body.docs[0].userKey;

            porthole.post({action: action, data : data, useAuth : true});

          } else {
            console.error(result);
          }
        });
      }
    };
    return ifProxy;
  },
]);

/* "use strict"; */
webapp.service('postApi', ['$resource', 'StaticVariable', '$rootScope', '$window', '$timeout', '$http',
  function postApi($resource, StaticVariable, $rootScope, $window, $timeout, $http) {
    /**
     * * Noti
     *   - 사용방법 예시
     *     * postApi.get('namespace.method', data, function(){});
     *     * postApi.get(data, function(){});
     *     * postApi.get(data, callbackFnc);
     *       > function callbackFnc() {}
     *
     *      var data = {mapCode : 'Role.getRoleList'};
     *      postApi.get(data, function(result){
     *        console.log("type B", result);
     *      });
     *      var data = {};
     *      postApi.get('Role.getRoleList', data, function(result){
     *        console.log("type C", result);
     *      });
     *      var data = {};
     *      postApi.get('Role.getRoleList', data, callback);
     *      function callback(result) {
     *        console.log("type D", result);
     *      }
     *
     *   - 호출 타입
     *     * postApi 내 type 참고
    **/

    var postApi = {
      runningCode : {},
      type : {
        select : "select", insert : "insert", update : "update", delete : "delete",
        action : "action", attach : "attach", excel : "excel", api : "api",
        openApi : "openapi", login : "login",
      },
      makeData : function(D) {
        if($window.sessionStorage["loginTenantId"] != "" && $window.sessionStorage["loginTenantId"] != null && $window.sessionStorage["loginTenantId"] != undefined){
          D.userkey = $rootScope.gVariable.userKey;
        }
        if ($window.sessionStorage['loginSysAdminYN'] == "Y" && !D.srchTenantId) {
          D.srchTenantId = $rootScope.gVariable.srchTenantId;
        }
        return D;
      },
      makeErrorMsg : function(errorType) {
        var result = {};
        if(errorType == "undefinedSqlMap") result.header = {status:405, msg: "This service requires a 'mapCode' key for data."};
        result.body = {};
        console.error(result.header);
        return result;
      },
      makeResultData : function(D){
        var result = {};
        if (D == null || D.responseVO == null) return result;
        result.header = D.responseVO.header;
        result.body = D.responseVO.body;
        return result;
      },
      getMapCode : function(D) {
        var obj = {result : false, mapcode : ""};
        for( var key in D )
          if(key.toLowerCase() == "mapcode") {
            obj.result = true;
            obj.mapcode =  D[key];
            obj.data = D;
            delete obj.data.mapCode;
          }
        return obj;
      },
      sendPost : function(p1, p2, p3, callback, callback2) {

        var thisObj = this;

        /**
         * @Date  : 2020. 02. 20
         * @ISSUE : Insert, Update, Delete 중복 클릭시 여러번 호출되는 문제
         * @processing :
         *  SQLID, MapCode를 체크하여 중복클릭인지를 확인
         *  값이 존재하지 않을 경우 정상 프로세스를 태운 후 값을 받고 1초 후에 Map에서 삭제
         *  값이 존재할 경우 1분동안 콜백을 기다리고 1분이 지났을 경우에는 Map에서 삭제
         */
        if( this.runningCode[p2] != undefined) {
          var startTime  =  new Date(this.runningCode[p2].time);
          var now =  (new Date()).getTime();
          var elapsed = (now - startTime) / 1000;
          if(elapsed > 60) {
            delete thisObj.runningCode[p2];
          } else {
            return;
          }
        } else {
          if(p1.toLowerCase() == this.type.insert || p1.toLowerCase() == this.type.update 
            || p1.toLowerCase() == this.type.delete) {
            this.runningCode[p2] = {
              type : p1, 
              time :  (new Date()).getTime()
            }
          }
        }

        try {
          var param = {}, vm;
          if(p3.ctrl != undefined) {
            vm = p3.ctrl;            
            param = angular.copy(p3);
            delete param.ctrl;
          } else {
            param = angular.copy(p3);
          }
          var timeSec = 1000;
          if(vm) vm.dataloader = true;
          $resource(StaticVariable.getUrl('/'+ p1 +'/' + p2  + '/action.json'), {userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction()).post(this.makeData(param)).$promise.then(function (data) {
            callback(postApi.makeResultData(data), p2);
            if(p1.toLowerCase() == thisObj.type.insert || p1.toLowerCase() == thisObj.type.update || p1.toLowerCase() == thisObj.type.delete) {
              $timeout(function(){
                delete thisObj.runningCode[p2];
              }, 1000);
            }
            $timeout(function(){
              if(vm) vm.dataloader = false;
            }, timeSec); 
          }, function(error) {
            callback2(error, p2);
            if(p1.toLowerCase() == thisObj.type.insert || p1.toLowerCase() == thisObj.type.update || p1.toLowerCase() == thisObj.type.delete) {
              $timeout(function(){
                delete thisObj.runningCode[p2];
              }, 1000);
            }
            $timeout(function(){
              if(vm) vm.dataloader = false;
            }, timeSec); 
          });
        } catch(e) {
          console.error(e)
        }
      },
      sendPostOpen : function(p1, p2, p3, callback, callback2) {
        $resource(StaticVariable.getUrl('/'+ p1 +'/' + p2  + '.json'), {},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(p3)).$promise.then(function (data) {
          callback(postApi.makeResultData(data));
        }, function(error) {
          callback2(error);
        });
      },
      sendPostCustom : function(p1, p2, p3, callback, callback2) {
        $resource(StaticVariable.getUrl('/'+ p1 +'/' + p2  + '/actionCustom.json'), {userkey:$rootScope.gVariable.userKey},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(p3)).$promise.then(function (data) {
          callback(postApi.makeResultData(data));
        }, function(error) {
          callback2(error);
        });
      },
      sendPostApi : function(p1, p2, p3, callback, callback2) {
        $resource(StaticVariable.getUrl('/'+ p1 +'/' + p2  + '.json'), {userkey:$rootScope.gVariable.userKey},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(p3)).$promise.then(function (data) {
          callback(postApi.makeResultData(data));
        }, function(error) {
          callback2(error);
        });
      },
      login : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPostOpen(this.type.login, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPostOpen(this.type.login, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      select : function(p1, p2, callback, callback2) {
        if(Array.isArray(p1)) {
          // HJH GJ - 20200103 멀티 Select를 할 수 있는 환경 추가
          // postApi.select(data, function(result) {});
          // data 가 배열일 경우 해당 루트를 타게됨
          // data 구조 = [{mapCode: "map1", param: data},{mapCode: "map1", param: data}];
          // 기존과 다르게 mapCode 명시 - 같은 파라메터를 넘길 수 있음으로 mapCode가 key 값을 가지게 됨
          for(var i = 0; i < p1.length; i++) {
            this.sendPost(this.type.select, p1[i].mapCode, p1[i].param, function(data, mapCode){ data.mapCode = mapCode; p2(data); });
          }

        } else {
          if(typeof p1 == "string") {
              this.sendPost(this.type.select, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
          } else {
            var code = this.getMapCode(p1);
            if(code.result) {
              this.sendPost(this.type.select, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
            } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
          }
        }
      },
      callbackSelect : function(p1, p2, tempData, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.select, p1, p2, function(data){ callback(data, tempData); }, function(data){ callback2(data, tempData); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.select, code.mapcode, code.data, function(data){ p2(data, tempData); },function(data){ callback(data, tempData); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      selectCustom : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPostCustom(this.type.select, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPostCustom(this.type.select, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      insert : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.insert, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.insert, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else callback2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      update : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.update, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.update, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      delete : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.delete, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.delete, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      action : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.action, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.action, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      attach : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.attach, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.attach, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      excel : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPost(this.type.excel, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPost(this.type.excel, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      excelFile : function(p1, p2, p3, callback, callback2) {

        var url = null;
        var data = {};
        var finleNm;
        var cal1, cal2;
        if(typeof p1 == "string") {
          url = StaticVariable.getUrl('/'+ this.type.excel +'/' + p1  + '.json');

          if(typeof p2 == "string") {
            if(p2.indexOf("xls") != -1 || p2.indexOf("xlsx") != -1) {
              fileNm = p2;
            } else {
              fileNm = p2 + ".xlsx"
            }
            data = p3;
            cal1 = callback;
            cal2 = callback2;
          } else {
            fileNm = "";
            data = p2;
            cal1 = p3;
            cal2 = callback;
          }
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            url = StaticVariable.getUrl('/'+ this.type.excel +'/' + code.mapcode  + '.json');
            data = p1;
          } else {
            p2(postApi.makeErrorMsg("undefinedSqlMap"));
            return;
          }
          
          if(p1.fileNm != undefined) {
            if(p1.fileNm.indexOf("xls") != -1 || p1.fileNm.indexOf("xlsx") != -1) {
              fileNm = p1.fileNm;
            } else {
              fileNm = p1.fileNm + ".xlsx"
            }
          } else {
            fileNm = "";
          }

          cal1 = p2;
          cal2 = p3;
        }
        var temp = {};
        temp = this.makeData(temp)
        url+= "?userkey=" + temp.userkey;
        $http({
          method: 'POST',
          url: url,
          data: data,
          responseType: 'arraybuffer',
        })
        .success(function(data, status, headers, config) {
          var linkElement = document.createElement('a');
          try {
              var blob = new Blob([data], { type: "application/octet-stream" });
              var url = window.URL.createObjectURL(blob);
              
              if(fileNm == "") {
                var urls = url.split("/");
                fileNm = urls[urls.length-1] + ".xlsx";
              }
              linkElement.setAttribute('href', url);
              linkElement.setAttribute("download", fileNm);
              var clickEvent = new MouseEvent("click", {
                  "view": window,
                  "bubbles": true,
                  "cancelable": false
              });
              linkElement.dispatchEvent(clickEvent);
              if(cal1 != undefined) {
                 cal1(data)
              }
          } catch (ex) {
              if(cal2 != undefined) {
                cal2(ex)
              }
          }
        }).error(function (data) {
            if(cal2 != undefined) {
              cal2(data)
            }
        });
      },
      api : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
            this.sendPostApi(this.type.api, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPostApi(this.type.api, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      openApi : function(p1, p2, callback, callback2) {
        if(typeof p1 == "string") {
          this.sendPostOpen(this.type.openApi, p1, p2, function(data){ callback(data); }, function(data){ callback2(data); });
        } else {
          var code = this.getMapCode(p1);
          if(code.result) {
            this.sendPostOpen(this.type.openApi, code.mapcode, code.data, function(data){ p2(data); },function(data){ callback(data); });
          } else p2(postApi.makeErrorMsg("undefinedSqlMap"));
        }
      },
      ajax : {
        get : function(p1, p2, callback) {
          if(typeof p1 == "string") postApi.ajax.sendAjax(postApi.type.select, p1, p2, function(data){ callback(data); });
          else {
            var code = postApi.getMapCode(p1);
            (code.result) ? postApi.ajax.sendAjax(postApi.type.select, code.mapcode, code.data, function(data){ p2(data); })
            : p2(postApi.makeErrorMsg("undefinedSqlMap"));
          }
        },
        set : function(p1, p2, callback) {
          if(typeof p1 == "string") postApi.ajax.sendAjax(postApi.type.insert, p1, p2, function(data){ callback(data); });
          else {
            var code = postApi.getMapCode(p1);
            (code.result) ? postApi.ajax.sendAjax(postApi.type.insert, code.mapcode, code.data, function(data){ p2(data); })
            : p2(postApi.makeErrorMsg("undefinedSqlMap"));
          }
        },
        upt : function(p1, p2, callback) {
          if(typeof p1 == "string") postApi.ajax.sendAjax(postApi.type.update, p1, p2, function(data){ callback(data); });
          else {
            var code = postApi.getMapCode(p1);
            (code.result) ? postApi.ajax.sendAjax(postApi.type.update, code.mapcode, code.data, function(data){ p2(data); })
            : p2(postApi.makeErrorMsg("undefinedSqlMap"));
          }
        },
        del : function(p1, p2, callback) {
          if(typeof p1 == "string") postApi.ajax.sendAjax(postApi.type.delete, p1, p2, function(data){ callback(data); });
          else {
            var code = postApi.getMapCode(p1);
            (code.result) ? postApi.ajax.sendAjax(postApi.type.delete, code.mapcode, code.data, function(data){ p2(data); })
            : p2(postApi.makeErrorMsg("undefinedSqlMap"));
          }
        },
        sendAjax : function(type, sqlmap, data, callback) {
          if(data == undefined) data = {};
          var url = "/"  + type + "/" + sqlmap + "/action.json"
          if(sqlmap.indexOf(".json") > -1) url = "/"  + type + "/" + sqlmap;
          data.userkey = $rootScope.gVariable.userKey;
          if ($window.sessionStorage['loginSysAdminYN'] == "Y" && !data.srchTenantId) {
            data.srchTenantId = $window.sessionStorage['srchTenantId'];
          }
          url = StaticVariable.getUrl(url);
          url = url + "?" +$rootScope.gVariable.userKey;
          var reciveJsonData = null;
          $.ajax({
            type: "POST",
            url: url,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            data: JSON.stringify(data),
            async: false,
            crossDomain: true,
            beforeSend : function(xhr){},
            success: function(result){callback(reciveJsonData)},
            error: function(jqXHR, textStatus, errorThrown) {}
          });
        }
      },
      insertComplex : function(data, callback, callback2){
        $resource(StaticVariable.getUrl('/rainbow/insertComplex.json'), {userkey:$rootScope.gVariable.userKey},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(data)).$promise.then(function (data) {
          callback(postApi.makeResultData(data));
        }, function(error) {
          callback2(error);
        });
      },
      fileInsert : function(data, callback, callback2){
        $resource(StaticVariable.getUrl('/independent/insertFile.json'), {userkey:$rootScope.gVariable.userKey},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(data)).$promise.then(function (data) {
          callback(postApi.makeResultData(data));
        }, function(error) {
          callback2(error);
        });
      },
      fileSelect : function(data, callback, callback2){
        $resource(StaticVariable.getUrl('/independent/selectFile.json'), {userkey:$rootScope.gVariable.userKey},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(data)).$promise.then(function (data) {
          callback(postApi.makeResultData(data));
        }, function(error) {
          callback2(error);
        });
      },
      fileDelete : function(data, callback, callback2){
        $resource(StaticVariable.getUrl('/independent/deleteFile.json'), {userkey:$rootScope.gVariable.userKey},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(data)).$promise.then(function (data) {
          callback(postApi.makeResultData(data));
        }, function(error) {
          callback2(error);
        });
      },
      duplicateMobileCheck : function(data, callback, callback2) {
        if (data.UserNm && data.Mobile) {
          $resource(StaticVariable.getUrl('/login/duplicateMobileCheck.json'),{userkey:$rootScope.gVariable.userKey},
          StaticVariable.getRequestActions.defaultAction()).post(this.makeData(data)).$promise.then(function (data) {
            callback(postApi.makeResultData(data));
          }, function(error) {
            callback2(error);
          });
        }
      },
      getAiData : function(data, jobType) {
        return $resource(
          StaticVariable.getUrl('/select/' + jobType + '/getAiData.json'),
          { userkey: $rootScope.gVariable.userKey },
          StaticVariable.getRequestActions.defaultAction()
        )
        .post(this.makeData(data)).$promise
        .then(function(response) {
          return postApi.makeResultData(response);
        });
      },
      getAiDownload: function(data) {
        return $resource(
            StaticVariable.getUrl('/select/getFile/getAiData.json'),
            { userkey: $rootScope.gVariable.userKey },
            {
                download: {
                    method: 'POST',
                    responseType: 'arraybuffer', 
                    transformResponse: function(data, headersGetter) {
                        return { data: data, headers: headersGetter() };
                    }
                }
            }
        )
        .download(this.makeData(data)).$promise;
      }
    };
    return postApi;
  },
]);
/*
== malihu jquery custom scrollbar plugin ==
Version: 3.1.5
Plugin URI: http://manos.malihu.gr/jquery-custom-content-scroller
Author: malihu
Author URI: http://manos.malihu.gr
License: MIT License (MIT)
*/

/*
Copyright Manos Malihutsakis (email: manos@malihu.gr)

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.
*/

/*
The code below is fairly long, fully commented and should be normally used in development.
For production, use either the minified jquery.mCustomScrollbar.min.js script or
the production-ready jquery.mCustomScrollbar.concat.min.js which contains the plugin
and dependencies (minified).
*/

(function(factory){
	if(typeof define==="function" && define.amd){
		define(["jquery"],factory);
	}else if(typeof module!=="undefined" && module.exports){
		module.exports=factory;
	}else{
		factory(jQuery,window,document);
	}
}(function($){
(function(init){
	var _rjs=typeof define==="function" && define.amd, /* RequireJS */
		_njs=typeof module !== "undefined" && module.exports, /* NodeJS */
		_dlp=("https:"==document.location.protocol) ? "https:" : "http:", /* location protocol */
		_url="cdnjs.cloudflare.com/ajax/libs/jquery-mousewheel/3.1.13/jquery.mousewheel.min.js";
	if(!_rjs){
		if(_njs){
			require("jquery-mousewheel")($);
		}else{
			/* load jquery-mousewheel plugin (via CDN) if it's not present or not loaded via RequireJS
			(works when mCustomScrollbar fn is called on window load) */
			$.event.special.mousewheel || $("head").append(decodeURI("%3Cscript src="+_dlp+"//"+_url+"%3E%3C/script%3E"));
		}
	}
	init();
}(function(){

	/*
	----------------------------------------
	PLUGIN NAMESPACE, PREFIX, DEFAULT SELECTOR(S)
	----------------------------------------
	*/

	var pluginNS="mCustomScrollbar",
		pluginPfx="mCS",
		defaultSelector=".mCustomScrollbar",





	/*
	----------------------------------------
	DEFAULT OPTIONS
	----------------------------------------
	*/

		defaults={
			/*
			set element/content width/height programmatically
			values: boolean, pixels, percentage
				option						default
				-------------------------------------
				setWidth					false
				setHeight					false
			*/
			/*
			set the initial css top property of content
			values: string (e.g. "-100px", "10%" etc.)
			*/
			setTop:0,
			/*
			set the initial css left property of content
			values: string (e.g. "-100px", "10%" etc.)
			*/
			setLeft:0,
			/*
			scrollbar axis (vertical and/or horizontal scrollbars)
			values (string): "y", "x", "yx"
			*/
			axis:"y",
			/*
			position of scrollbar relative to content
			values (string): "inside", "outside" ("outside" requires elements with position:relative)
			*/
			scrollbarPosition:"inside",
			/*
			scrolling inertia
			values: integer (milliseconds)
			*/
			scrollInertia:950,
			/*
			auto-adjust scrollbar dragger length
			values: boolean
			*/
			autoDraggerLength:true,
			/*
			auto-hide scrollbar when idle
			values: boolean
				option						default
				-------------------------------------
				autoHideScrollbar			false
			*/
			/*
			auto-expands scrollbar on mouse-over and dragging
			values: boolean
				option						default
				-------------------------------------
				autoExpandScrollbar			false
			*/
			/*
			always show scrollbar, even when there's nothing to scroll
			values: integer (0=disable, 1=always show dragger rail and buttons, 2=always show dragger rail, dragger and buttons), boolean
			*/
			alwaysShowScrollbar:0,
			/*
			scrolling always snaps to a multiple of this number in pixels
			values: integer, array ([y,x])
				option						default
				-------------------------------------
				snapAmount					null
			*/
			/*
			when snapping, snap with this number in pixels as an offset
			values: integer
			*/
			snapOffset:0,
			/*
			mouse-wheel scrolling
			*/
			mouseWheel:{
				/*
				enable mouse-wheel scrolling
				values: boolean
				*/
				enable:true,
				/*
				scrolling amount in pixels
				values: "auto", integer
				*/
				scrollAmount:"auto",
				/*
				mouse-wheel scrolling axis
				the default scrolling direction when both vertical and horizontal scrollbars are present
				values (string): "y", "x"
				*/
				axis:"y",
				/*
				prevent the default behaviour which automatically scrolls the parent element(s) when end of scrolling is reached
				values: boolean
					option						default
					-------------------------------------
					preventDefault				null
				*/
				/*
				the reported mouse-wheel delta value. The number of lines (translated to pixels) one wheel notch scrolls.
				values: "auto", integer
				"auto" uses the default OS/browser value
				*/
				deltaFactor:"auto",
				/*
				normalize mouse-wheel delta to -1 or 1 (disables mouse-wheel acceleration)
				values: boolean
					option						default
					-------------------------------------
					normalizeDelta				null
				*/
				/*
				invert mouse-wheel scrolling direction
				values: boolean
					option						default
					-------------------------------------
					invert						null
				*/
				/*
				the tags that disable mouse-wheel when cursor is over them
				*/
				disableOver:["select","option","keygen","datalist","textarea"]
			},
			/*
			scrollbar buttons
			*/
			scrollButtons:{
				/*
				enable scrollbar buttons
				values: boolean
					option						default
					-------------------------------------
					enable						null
				*/
				/*
				scrollbar buttons scrolling type
				values (string): "stepless", "stepped"
				*/
				scrollType:"stepless",
				/*
				scrolling amount in pixels
				values: "auto", integer
				*/
				scrollAmount:"auto"
				/*
				tabindex of the scrollbar buttons
				values: false, integer
					option						default
					-------------------------------------
					tabindex					null
				*/
			},
			/*
			keyboard scrolling
			*/
			keyboard:{
				/*
				enable scrolling via keyboard
				values: boolean
				*/
				enable:true,
				/*
				keyboard scrolling type
				values (string): "stepless", "stepped"
				*/
				scrollType:"stepless",
				/*
				scrolling amount in pixels
				values: "auto", integer
				*/
				scrollAmount:"auto"
			},
			/*
			enable content touch-swipe scrolling
			values: boolean, integer, string (number)
			integer values define the axis-specific minimum amount required for scrolling momentum
			*/
			contentTouchScroll:25,
			/*
			enable/disable document (default) touch-swipe scrolling
			*/
			documentTouchScroll:true,
			/*
			advanced option parameters
			*/
			advanced:{
				/*
				auto-expand content horizontally (for "x" or "yx" axis)
				values: boolean, integer (the value 2 forces the non scrollHeight/scrollWidth method, the value 3 forces the scrollHeight/scrollWidth method)
					option						default
					-------------------------------------
					autoExpandHorizontalScroll	null
				*/
				/*
				auto-scroll to elements with focus
				*/
				autoScrollOnFocus:"input,textarea,select,button,datalist,keygen,a[tabindex],area,object,[contenteditable='true']",
				/*
				auto-update scrollbars on content, element or viewport resize
				should be true for fluid layouts/elements, adding/removing content dynamically, hiding/showing elements, content with images etc.
				values: boolean
				*/
				updateOnContentResize:true,
				/*
				auto-update scrollbars each time each image inside the element is fully loaded
				values: "auto", boolean
				*/
				updateOnImageLoad:"auto",
				/*
				auto-update scrollbars based on the amount and size changes of specific selectors
				useful when you need to update the scrollbar(s) automatically, each time a type of element is added, removed or changes its size
				values: boolean, string (e.g. "ul li" will auto-update scrollbars each time list-items inside the element are changed)
				a value of true (boolean) will auto-update scrollbars each time any element is changed
					option						default
					-------------------------------------
					updateOnSelectorChange		null
				*/
				/*
				extra selectors that'll allow scrollbar dragging upon mousemove/up, pointermove/up, touchend etc. (e.g. "selector-1, selector-2")
					option						default
					-------------------------------------
					extraDraggableSelectors		null
				*/
				/*
				extra selectors that'll release scrollbar dragging upon mouseup, pointerup, touchend etc. (e.g. "selector-1, selector-2")
					option						default
					-------------------------------------
					releaseDraggableSelectors	null
				*/
				/*
				auto-update timeout
				values: integer (milliseconds)
				*/
				autoUpdateTimeout:60
			},
			/*
			scrollbar theme
			values: string (see CSS/plugin URI for a list of ready-to-use themes)
			*/
			theme:"light",
			/*
			user defined callback functions
			*/
			callbacks:{
				/*
				Available callbacks:
					callback					default
					-------------------------------------
					onCreate					null
					onInit						null
					onScrollStart				null
					onScroll					null
					onTotalScroll				null
					onTotalScrollBack			null
					whileScrolling				null
					onOverflowY					null
					onOverflowX					null
					onOverflowYNone				null
					onOverflowXNone				null
					onImageLoad					null
					onSelectorChange			null
					onBeforeUpdate				null
					onUpdate					null
				*/
				onTotalScrollOffset:0,
				onTotalScrollBackOffset:0,
				alwaysTriggerOffsets:true
			}
			/*
			add scrollbar(s) on all elements matching the current selector, now and in the future
			values: boolean, string
			string values: "on" (enable), "once" (disable after first invocation), "off" (disable)
			liveSelector values: string (selector)
				option						default
				-------------------------------------
				live						false
				liveSelector				null
			*/
		},





	/*
	----------------------------------------
	VARS, CONSTANTS
	----------------------------------------
	*/

		totalInstances=0, /* plugin instances amount */
		liveTimers={}, /* live option timers */
		oldIE=(window.attachEvent && !window.addEventListener) ? 1 : 0, /* detect IE < 9 */
		touchActive=false,touchable, /* global touch vars (for touch and pointer events) */
		/* general plugin classes */
		classes=[
			"mCSB_dragger_onDrag","mCSB_scrollTools_onDrag","mCS_img_loaded","mCS_disabled","mCS_destroyed","mCS_no_scrollbar",
			"mCS-autoHide","mCS-dir-rtl","mCS_no_scrollbar_y","mCS_no_scrollbar_x","mCS_y_hidden","mCS_x_hidden","mCSB_draggerContainer",
			"mCSB_buttonUp","mCSB_buttonDown","mCSB_buttonLeft","mCSB_buttonRight"
		],





	/*
	----------------------------------------
	METHODS
	----------------------------------------
	*/

		methods={

			/*
			plugin initialization method
			creates the scrollbar(s), plugin data object and options
			----------------------------------------
			*/

			init:function(options){

				var options=$.extend(true,{},defaults,options),
					selector=_selector.call(this); /* validate selector */

				/*
				if live option is enabled, monitor for elements matching the current selector and
				apply scrollbar(s) when found (now and in the future)
				*/
				if(options.live){
					var liveSelector=options.liveSelector || this.selector || defaultSelector, /* live selector(s) */
						$liveSelector=$(liveSelector); /* live selector(s) as jquery object */
					if(options.live==="off"){
						/*
						disable live if requested
						usage: $(selector).mCustomScrollbar({live:"off"});
						*/
						removeLiveTimers(liveSelector);
						return;
					}
					liveTimers[liveSelector]=setTimeout(function(){
						/* call mCustomScrollbar fn on live selector(s) every half-second */
						$liveSelector.mCustomScrollbar(options);
						if(options.live==="once" && $liveSelector.length){
							/* disable live after first invocation */
							removeLiveTimers(liveSelector);
						}
					},500);
				}else{
					removeLiveTimers(liveSelector);
				}

				/* options backward compatibility (for versions < 3.0.0) and normalization */
				options.setWidth=(options.set_width) ? options.set_width : options.setWidth;
				options.setHeight=(options.set_height) ? options.set_height : options.setHeight;
				options.axis=(options.horizontalScroll) ? "x" : _findAxis(options.axis);
				options.scrollInertia=options.scrollInertia>0 && options.scrollInertia<17 ? 17 : options.scrollInertia;
				if(typeof options.mouseWheel!=="object" &&  options.mouseWheel==true){ /* old school mouseWheel option (non-object) */
					options.mouseWheel={enable:true,scrollAmount:"auto",axis:"y",preventDefault:false,deltaFactor:"auto",normalizeDelta:false,invert:false}
				}
				options.mouseWheel.scrollAmount=!options.mouseWheelPixels ? options.mouseWheel.scrollAmount : options.mouseWheelPixels;
				options.mouseWheel.normalizeDelta=!options.advanced.normalizeMouseWheelDelta ? options.mouseWheel.normalizeDelta : options.advanced.normalizeMouseWheelDelta;
				options.scrollButtons.scrollType=_findScrollButtonsType(options.scrollButtons.scrollType);

				_theme(options); /* theme-specific options */

				/* plugin constructor */
				return $(selector).each(function(){

					var $this=$(this);

					if(!$this.data(pluginPfx)){ /* prevent multiple instantiations */

						/* store options and create objects in jquery data */
						$this.data(pluginPfx,{
							idx:++totalInstances, /* instance index */
							opt:options, /* options */
							scrollRatio:{y:null,x:null}, /* scrollbar to content ratio */
							overflowed:null, /* overflowed axis */
							contentReset:{y:null,x:null}, /* object to check when content resets */
							bindEvents:false, /* object to check if events are bound */
							tweenRunning:false, /* object to check if tween is running */
							sequential:{}, /* sequential scrolling object */
							langDir:$this.css("direction"), /* detect/store direction (ltr or rtl) */
							cbOffsets:null, /* object to check whether callback offsets always trigger */
							/*
							object to check how scrolling events where last triggered
							"internal" (default - triggered by this script), "external" (triggered by other scripts, e.g. via scrollTo method)
							usage: object.data("mCS").trigger
							*/
							trigger:null,
							/*
							object to check for changes in elements in order to call the update method automatically
							*/
							poll:{size:{o:0,n:0},img:{o:0,n:0},change:{o:0,n:0}}
						});

						var d=$this.data(pluginPfx),o=d.opt,
							/* HTML data attributes */
							htmlDataAxis=$this.data("mcs-axis"),htmlDataSbPos=$this.data("mcs-scrollbar-position"),htmlDataTheme=$this.data("mcs-theme");

						if(htmlDataAxis){o.axis=htmlDataAxis;} /* usage example: data-mcs-axis="y" */
						if(htmlDataSbPos){o.scrollbarPosition=htmlDataSbPos;} /* usage example: data-mcs-scrollbar-position="outside" */
						if(htmlDataTheme){ /* usage example: data-mcs-theme="minimal" */
							o.theme=htmlDataTheme;
							_theme(o); /* theme-specific options */
						}

						_pluginMarkup.call(this); /* add plugin markup */

						if(d && o.callbacks.onCreate && typeof o.callbacks.onCreate==="function"){o.callbacks.onCreate.call(this);} /* callbacks: onCreate */

						$("#mCSB_"+d.idx+"_container img:not(."+classes[2]+")").addClass(classes[2]); /* flag loaded images */

						methods.update.call(null,$this); /* call the update method */

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin update method
			updates content and scrollbar(s) values, events and status
			----------------------------------------
			usage: $(selector).mCustomScrollbar("update");
			*/

			update:function(el,cb){

				var selector=el || _selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt,
							mCSB_container=$("#mCSB_"+d.idx+"_container"),
							mCustomScrollBox=$("#mCSB_"+d.idx),
							mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];

						if(!mCSB_container.length){return;}

						if(d.tweenRunning){_stop($this);} /* stop any running tweens while updating */

						if(cb && d && o.callbacks.onBeforeUpdate && typeof o.callbacks.onBeforeUpdate==="function"){o.callbacks.onBeforeUpdate.call(this);} /* callbacks: onBeforeUpdate */

						/* if element was disabled or destroyed, remove class(es) */
						if($this.hasClass(classes[3])){$this.removeClass(classes[3]);}
						if($this.hasClass(classes[4])){$this.removeClass(classes[4]);}

						/* css flexbox fix, detect/set max-height */
						mCustomScrollBox.css("max-height","none");
						if(mCustomScrollBox.height()!==$this.height()){mCustomScrollBox.css("max-height",$this.height());}

						_expandContentHorizontally.call(this); /* expand content horizontally */

						if(o.axis!=="y" && !o.advanced.autoExpandHorizontalScroll){
							mCSB_container.css("width",_contentWidth(mCSB_container));
						}

						d.overflowed=_overflowed.call(this); /* determine if scrolling is required */

						_scrollbarVisibility.call(this); /* show/hide scrollbar(s) */

						/* auto-adjust scrollbar dragger length analogous to content */
						if(o.autoDraggerLength){_setDraggerLength.call(this);}

						_scrollRatio.call(this); /* calculate and store scrollbar to content ratio */

						_bindEvents.call(this); /* bind scrollbar events */

						/* reset scrolling position and/or events */
						var to=[Math.abs(mCSB_container[0].offsetTop),Math.abs(mCSB_container[0].offsetLeft)];
						if(o.axis!=="x"){ /* y/yx axis */
							if(!d.overflowed[0]){ /* y scrolling is not required */
								_resetContentPosition.call(this); /* reset content position */
								if(o.axis==="y"){
									_unbindEvents.call(this);
								}else if(o.axis==="yx" && d.overflowed[1]){
									_scrollTo($this,to[1].toString(),{dir:"x",dur:0,overwrite:"none"});
								}
							}else if(mCSB_dragger[0].height()>mCSB_dragger[0].parent().height()){
								_resetContentPosition.call(this); /* reset content position */
							}else{ /* y scrolling is required */
								_scrollTo($this,to[0].toString(),{dir:"y",dur:0,overwrite:"none"});
								d.contentReset.y=null;
							}
						}
						if(o.axis!=="y"){ /* x/yx axis */
							if(!d.overflowed[1]){ /* x scrolling is not required */
								_resetContentPosition.call(this); /* reset content position */
								if(o.axis==="x"){
									_unbindEvents.call(this);
								}else if(o.axis==="yx" && d.overflowed[0]){
									_scrollTo($this,to[0].toString(),{dir:"y",dur:0,overwrite:"none"});
								}
							}else if(mCSB_dragger[1].width()>mCSB_dragger[1].parent().width()){
								_resetContentPosition.call(this); /* reset content position */
							}else{ /* x scrolling is required */
								_scrollTo($this,to[1].toString(),{dir:"x",dur:0,overwrite:"none"});
								d.contentReset.x=null;
							}
						}

						/* callbacks: onImageLoad, onSelectorChange, onUpdate */
						if(cb && d){
							if(cb===2 && o.callbacks.onImageLoad && typeof o.callbacks.onImageLoad==="function"){
								o.callbacks.onImageLoad.call(this);
							}else if(cb===3 && o.callbacks.onSelectorChange && typeof o.callbacks.onSelectorChange==="function"){
								o.callbacks.onSelectorChange.call(this);
							}else if(o.callbacks.onUpdate && typeof o.callbacks.onUpdate==="function"){
								o.callbacks.onUpdate.call(this);
							}
						}

						_autoUpdate.call(this); /* initialize automatic updating (for dynamic content, fluid layouts etc.) */

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin scrollTo method
			triggers a scrolling event to a specific value
			----------------------------------------
			usage: $(selector).mCustomScrollbar("scrollTo",value,options);
			*/

			scrollTo:function(val,options){

				/* prevent silly things like $(selector).mCustomScrollbar("scrollTo",undefined); */
				if(typeof val=="undefined" || val==null){return;}

				var selector=_selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt,
							/* method default options */
							methodDefaults={
								trigger:"external", /* method is by default triggered externally (e.g. from other scripts) */
								scrollInertia:o.scrollInertia, /* scrolling inertia (animation duration) */
								scrollEasing:"mcsEaseInOut", /* animation easing */
								moveDragger:false, /* move dragger instead of content */
								timeout:60, /* scroll-to delay */
								callbacks:true, /* enable/disable callbacks */
								onStart:true,
								onUpdate:true,
								onComplete:true
							},
							methodOptions=$.extend(true,{},methodDefaults,options),
							to=_arr.call(this,val),dur=methodOptions.scrollInertia>0 && methodOptions.scrollInertia<17 ? 17 : methodOptions.scrollInertia;

						/* translate yx values to actual scroll-to positions */
						to[0]=_to.call(this,to[0],"y");
						to[1]=_to.call(this,to[1],"x");

						/*
						check if scroll-to value moves the dragger instead of content.
						Only pixel values apply on dragger (e.g. 100, "100px", "-=100" etc.)
						*/
						if(methodOptions.moveDragger){
							to[0]*=d.scrollRatio.y;
							to[1]*=d.scrollRatio.x;
						}

						methodOptions.dur=_isTabHidden() ? 0 : dur; //skip animations if browser tab is hidden

						setTimeout(function(){
							/* do the scrolling */
							if(to[0]!==null && typeof to[0]!=="undefined" && o.axis!=="x" && d.overflowed[0]){ /* scroll y */
								methodOptions.dir="y";
								methodOptions.overwrite="all";
								_scrollTo($this,to[0].toString(),methodOptions);
							}
							if(to[1]!==null && typeof to[1]!=="undefined" && o.axis!=="y" && d.overflowed[1]){ /* scroll x */
								methodOptions.dir="x";
								methodOptions.overwrite="none";
								_scrollTo($this,to[1].toString(),methodOptions);
							}
						},methodOptions.timeout);

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin stop method
			stops scrolling animation
			----------------------------------------
			usage: $(selector).mCustomScrollbar("stop");
			*/
			stop:function(){

				var selector=_selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						_stop($this);

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin disable method
			temporarily disables the scrollbar(s)
			----------------------------------------
			usage: $(selector).mCustomScrollbar("disable",reset);
			reset (boolean): resets content position to 0
			*/
			disable:function(r){

				var selector=_selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx);

						_autoUpdate.call(this,"remove"); /* remove automatic updating */

						_unbindEvents.call(this); /* unbind events */

						if(r){_resetContentPosition.call(this);} /* reset content position */

						_scrollbarVisibility.call(this,true); /* show/hide scrollbar(s) */

						$this.addClass(classes[3]); /* add disable class */

					}

				});

			},
			/* ---------------------------------------- */



			/*
			plugin destroy method
			completely removes the scrollbar(s) and returns the element to its original state
			----------------------------------------
			usage: $(selector).mCustomScrollbar("destroy");
			*/
			destroy:function(){

				var selector=_selector.call(this); /* validate selector */

				return $(selector).each(function(){

					var $this=$(this);

					if($this.data(pluginPfx)){ /* check if plugin has initialized */

						var d=$this.data(pluginPfx),o=d.opt,
							mCustomScrollBox=$("#mCSB_"+d.idx),
							mCSB_container=$("#mCSB_"+d.idx+"_container"),
							scrollbar=$(".mCSB_"+d.idx+"_scrollbar");

						if(o.live){removeLiveTimers(o.liveSelector || $(selector).selector);} /* remove live timers */

						_autoUpdate.call(this,"remove"); /* remove automatic updating */

						_unbindEvents.call(this); /* unbind events */

						_resetContentPosition.call(this); /* reset content position */

						$this.removeData(pluginPfx); /* remove plugin data object */

						_delete(this,"mcs"); /* delete callbacks object */

						/* remove plugin markup */
						scrollbar.remove(); /* remove scrollbar(s) first (those can be either inside or outside plugin's inner wrapper) */
						mCSB_container.find("img."+classes[2]).removeClass(classes[2]); /* remove loaded images flag */
						mCustomScrollBox.replaceWith(mCSB_container.contents()); /* replace plugin's inner wrapper with the original content */
						/* remove plugin classes from the element and add destroy class */
						$this.removeClass(pluginNS+" _"+pluginPfx+"_"+d.idx+" "+classes[6]+" "+classes[7]+" "+classes[5]+" "+classes[3]).addClass(classes[4]);

					}

				});

			}
			/* ---------------------------------------- */

		},





	/*
	----------------------------------------
	FUNCTIONS
	----------------------------------------
	*/

		/* validates selector (if selector is invalid or undefined uses the default one) */
		_selector=function(){
			return (typeof $(this)!=="object" || $(this).length<1) ? defaultSelector : this;
		},
		/* -------------------- */


		/* changes options according to theme */
		_theme=function(obj){
			var fixedSizeScrollbarThemes=["rounded","rounded-dark","rounded-dots","rounded-dots-dark"],
				nonExpandedScrollbarThemes=["rounded-dots","rounded-dots-dark","3d","3d-dark","3d-thick","3d-thick-dark","inset","inset-dark","inset-2","inset-2-dark","inset-3","inset-3-dark"],
				disabledScrollButtonsThemes=["minimal","minimal-dark"],
				enabledAutoHideScrollbarThemes=["minimal","minimal-dark"],
				scrollbarPositionOutsideThemes=["minimal","minimal-dark"];
			obj.autoDraggerLength=$.inArray(obj.theme,fixedSizeScrollbarThemes) > -1 ? false : obj.autoDraggerLength;
			obj.autoExpandScrollbar=$.inArray(obj.theme,nonExpandedScrollbarThemes) > -1 ? false : obj.autoExpandScrollbar;
			obj.scrollButtons.enable=$.inArray(obj.theme,disabledScrollButtonsThemes) > -1 ? false : obj.scrollButtons.enable;
			obj.autoHideScrollbar=$.inArray(obj.theme,enabledAutoHideScrollbarThemes) > -1 ? true : obj.autoHideScrollbar;
			obj.scrollbarPosition=$.inArray(obj.theme,scrollbarPositionOutsideThemes) > -1 ? "outside" : obj.scrollbarPosition;
		},
		/* -------------------- */


		/* live option timers removal */
		removeLiveTimers=function(selector){
			if(liveTimers[selector]){
				clearTimeout(liveTimers[selector]);
				_delete(liveTimers,selector);
			}
		},
		/* -------------------- */


		/* normalizes axis option to valid values: "y", "x", "yx" */
		_findAxis=function(val){
			return (val==="yx" || val==="xy" || val==="auto") ? "yx" : (val==="x" || val==="horizontal") ? "x" : "y";
		},
		/* -------------------- */


		/* normalizes scrollButtons.scrollType option to valid values: "stepless", "stepped" */
		_findScrollButtonsType=function(val){
			return (val==="stepped" || val==="pixels" || val==="step" || val==="click") ? "stepped" : "stepless";
		},
		/* -------------------- */


		/* generates plugin markup */
		_pluginMarkup=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				expandClass=o.autoExpandScrollbar ? " "+classes[1]+"_expand" : "",
				scrollbar=["<div id='mCSB_"+d.idx+"_scrollbar_vertical' class='mCSB_scrollTools mCSB_"+d.idx+"_scrollbar mCS-"+o.theme+" mCSB_scrollTools_vertical"+expandClass+"'><div class='"+classes[12]+"'><div id='mCSB_"+d.idx+"_dragger_vertical' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>","<div id='mCSB_"+d.idx+"_scrollbar_horizontal' class='mCSB_scrollTools mCSB_"+d.idx+"_scrollbar mCS-"+o.theme+" mCSB_scrollTools_horizontal"+expandClass+"'><div class='"+classes[12]+"'><div id='mCSB_"+d.idx+"_dragger_horizontal' class='mCSB_dragger' style='position:absolute;'><div class='mCSB_dragger_bar' /></div><div class='mCSB_draggerRail' /></div></div>"],
				wrapperClass=o.axis==="yx" ? "mCSB_vertical_horizontal" : o.axis==="x" ? "mCSB_horizontal" : "mCSB_vertical",
				scrollbars=o.axis==="yx" ? scrollbar[0]+scrollbar[1] : o.axis==="x" ? scrollbar[1] : scrollbar[0],
				contentWrapper=o.axis==="yx" ? "<div id='mCSB_"+d.idx+"_container_wrapper' class='mCSB_container_wrapper' />" : "",
				autoHideClass=o.autoHideScrollbar ? " "+classes[6] : "",
				scrollbarDirClass=(o.axis!=="x" && d.langDir==="rtl") ? " "+classes[7] : "";
			if(o.setWidth){$this.css("width",o.setWidth);} /* set element width */
			if(o.setHeight){$this.css("height",o.setHeight);} /* set element height */
			o.setLeft=(o.axis!=="y" && d.langDir==="rtl") ? "989999px" : o.setLeft; /* adjust left position for rtl direction */
			$this.addClass(pluginNS+" _"+pluginPfx+"_"+d.idx+autoHideClass+scrollbarDirClass).wrapInner("<div id='mCSB_"+d.idx+"' class='mCustomScrollBox mCS-"+o.theme+" "+wrapperClass+"'><div id='mCSB_"+d.idx+"_container' class='mCSB_container' style='position:relative; top:"+o.setTop+"; left:"+o.setLeft+";' dir='"+d.langDir+"' /></div>");
			var mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container");
			if(o.axis!=="y" && !o.advanced.autoExpandHorizontalScroll){
				mCSB_container.css("width",_contentWidth(mCSB_container));
			}
			if(o.scrollbarPosition==="outside"){
				if($this.css("position")==="static"){ /* requires elements with non-static position */
					$this.css("position","relative");
				}
				$this.css("overflow","visible");
				mCustomScrollBox.addClass("mCSB_outside").after(scrollbars);
			}else{
				mCustomScrollBox.addClass("mCSB_inside").append(scrollbars);
				mCSB_container.wrap(contentWrapper);
			}
			_scrollButtons.call(this); /* add scrollbar buttons */
			/* minimum dragger length */
			var mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];
			mCSB_dragger[0].css("min-height",mCSB_dragger[0].height());
			mCSB_dragger[1].css("min-width",mCSB_dragger[1].width());
		},
		/* -------------------- */


		/* calculates content width */
		_contentWidth=function(el){
			var val=[el[0].scrollWidth,Math.max.apply(Math,el.children().map(function(){return $(this).outerWidth(true);}).get())],w=el.parent().width();
			return val[0]>w ? val[0] : val[1]>w ? val[1] : "100%";
		},
		/* -------------------- */


		/* expands content horizontally */
		_expandContentHorizontally=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCSB_container=$("#mCSB_"+d.idx+"_container");
			if(o.advanced.autoExpandHorizontalScroll && o.axis!=="y"){
				/* calculate scrollWidth */
				mCSB_container.css({"width":"auto","min-width":0,"overflow-x":"scroll"});
				var w=Math.ceil(mCSB_container[0].scrollWidth);
				if(o.advanced.autoExpandHorizontalScroll===3 || (o.advanced.autoExpandHorizontalScroll!==2 && w>mCSB_container.parent().width())){
					mCSB_container.css({"width":w,"min-width":"100%","overflow-x":"inherit"});
				}else{
					/*
					wrap content with an infinite width div and set its position to absolute and width to auto.
					Setting width to auto before calculating the actual width is important!
					We must let the browser set the width as browser zoom values are impossible to calculate.
					*/
					mCSB_container.css({"overflow-x":"inherit","position":"absolute"})
						.wrap("<div class='mCSB_h_wrapper' style='position:relative; left:0; width:999999px;' />")
						.css({ /* set actual width, original position and un-wrap */
							/*
							get the exact width (with decimals) and then round-up.
							Using jquery outerWidth() will round the width value which will mess up with inner elements that have non-integer width
							*/
							"width":(Math.ceil(mCSB_container[0].getBoundingClientRect().right+0.4)-Math.floor(mCSB_container[0].getBoundingClientRect().left)),
							"min-width":"100%",
							"position":"relative"
						}).unwrap();
				}
			}
		},
		/* -------------------- */


		/* adds scrollbar buttons */
		_scrollButtons=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCSB_scrollTools=$(".mCSB_"+d.idx+"_scrollbar:first"),
				tabindex=!_isNumeric(o.scrollButtons.tabindex) ? "" : "tabindex='"+o.scrollButtons.tabindex+"'",
				btnHTML=[
					"<a href='#' class='"+classes[13]+"' "+tabindex+" />",
					"<a href='#' class='"+classes[14]+"' "+tabindex+" />",
					"<a href='#' class='"+classes[15]+"' "+tabindex+" />",
					"<a href='#' class='"+classes[16]+"' "+tabindex+" />"
				],
				btn=[(o.axis==="x" ? btnHTML[2] : btnHTML[0]),(o.axis==="x" ? btnHTML[3] : btnHTML[1]),btnHTML[2],btnHTML[3]];
			if(o.scrollButtons.enable){
				mCSB_scrollTools.prepend(btn[0]).append(btn[1]).next(".mCSB_scrollTools").prepend(btn[2]).append(btn[3]);
			}
		},
		/* -------------------- */


		/* auto-adjusts scrollbar dragger length */
		_setDraggerLength=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
				ratio=[mCustomScrollBox.height()/mCSB_container.outerHeight(false),mCustomScrollBox.width()/mCSB_container.outerWidth(false)],
				l=[
					parseInt(mCSB_dragger[0].css("min-height")),Math.round(ratio[0]*mCSB_dragger[0].parent().height()),
					parseInt(mCSB_dragger[1].css("min-width")),Math.round(ratio[1]*mCSB_dragger[1].parent().width())
				],
				h=oldIE && (l[1]<l[0]) ? l[0] : l[1],w=oldIE && (l[3]<l[2]) ? l[2] : l[3];
			mCSB_dragger[0].css({
				"height":h,"max-height":(mCSB_dragger[0].parent().height()-10)
			}).find(".mCSB_dragger_bar").css({"line-height":l[0]+"px"});
			mCSB_dragger[1].css({
				"width":w,"max-width":(mCSB_dragger[1].parent().width()-10)
			});
		},
		/* -------------------- */


		/* calculates scrollbar to content ratio */
		_scrollRatio=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
				scrollAmount=[mCSB_container.outerHeight(false)-mCustomScrollBox.height(),mCSB_container.outerWidth(false)-mCustomScrollBox.width()],
				ratio=[
					scrollAmount[0]/(mCSB_dragger[0].parent().height()-mCSB_dragger[0].height()),
					scrollAmount[1]/(mCSB_dragger[1].parent().width()-mCSB_dragger[1].width())
				];
			d.scrollRatio={y:ratio[0],x:ratio[1]};
		},
		/* -------------------- */


		/* toggles scrolling classes */
		_onDragClasses=function(el,action,xpnd){
			var expandClass=xpnd ? classes[0]+"_expanded" : "",
				scrollbar=el.closest(".mCSB_scrollTools");
			if(action==="active"){
				el.toggleClass(classes[0]+" "+expandClass); scrollbar.toggleClass(classes[1]);
				el[0]._draggable=el[0]._draggable ? 0 : 1;
			}else{
				if(!el[0]._draggable){
					if(action==="hide"){
						el.removeClass(classes[0]); scrollbar.removeClass(classes[1]);
					}else{
						el.addClass(classes[0]); scrollbar.addClass(classes[1]);
					}
				}
			}
		},
		/* -------------------- */


		/* checks if content overflows its container to determine if scrolling is required */
		_overflowed=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				contentHeight=d.overflowed==null ? mCSB_container.height() : mCSB_container.outerHeight(false),
				contentWidth=d.overflowed==null ? mCSB_container.width() : mCSB_container.outerWidth(false),
				h=mCSB_container[0].scrollHeight,w=mCSB_container[0].scrollWidth;
			if(h>contentHeight){contentHeight=h;}
			if(w>contentWidth){contentWidth=w;}
			return [contentHeight>mCustomScrollBox.height(),contentWidth>mCustomScrollBox.width()];
		},
		/* -------------------- */


		/* resets content position to 0 */
		_resetContentPosition=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")];
			_stop($this); /* stop any current scrolling before resetting */
			if((o.axis!=="x" && !d.overflowed[0]) || (o.axis==="y" && d.overflowed[0])){ /* reset y */
				mCSB_dragger[0].add(mCSB_container).css("top",0);
				_scrollTo($this,"_resetY");
			}
			if((o.axis!=="y" && !d.overflowed[1]) || (o.axis==="x" && d.overflowed[1])){ /* reset x */
				var cx=dx=0;
				if(d.langDir==="rtl"){ /* adjust left position for rtl direction */
					cx=mCustomScrollBox.width()-mCSB_container.outerWidth(false);
					dx=Math.abs(cx/d.scrollRatio.x);
				}
				mCSB_container.css("left",cx);
				mCSB_dragger[1].css("left",dx);
				_scrollTo($this,"_resetX");
			}
		},
		/* -------------------- */


		/* binds scrollbar events */
		_bindEvents=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt;
			if(!d.bindEvents){ /* check if events are already bound */
				_draggable.call(this);
				if(o.contentTouchScroll){_contentDraggable.call(this);}
				_selectable.call(this);
				if(o.mouseWheel.enable){ /* bind mousewheel fn when plugin is available */
					function _mwt(){
						mousewheelTimeout=setTimeout(function(){
							if(!$.event.special.mousewheel){
								_mwt();
							}else{
								clearTimeout(mousewheelTimeout);
								_mousewheel.call($this[0]);
							}
						},100);
					}
					var mousewheelTimeout;
					_mwt();
				}
				_draggerRail.call(this);
				_wrapperScroll.call(this);
				if(o.advanced.autoScrollOnFocus){_focus.call(this);}
				if(o.scrollButtons.enable){_buttons.call(this);}
				if(o.keyboard.enable){_keyboard.call(this);}
				d.bindEvents=true;
			}
		},
		/* -------------------- */


		/* unbinds scrollbar events */
		_unbindEvents=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				sb=".mCSB_"+d.idx+"_scrollbar",
				sel=$("#mCSB_"+d.idx+",#mCSB_"+d.idx+"_container,#mCSB_"+d.idx+"_container_wrapper,"+sb+" ."+classes[12]+",#mCSB_"+d.idx+"_dragger_vertical,#mCSB_"+d.idx+"_dragger_horizontal,"+sb+">a"),
				mCSB_container=$("#mCSB_"+d.idx+"_container");
			if(o.advanced.releaseDraggableSelectors){sel.add($(o.advanced.releaseDraggableSelectors));}
			if(o.advanced.extraDraggableSelectors){sel.add($(o.advanced.extraDraggableSelectors));}
			if(d.bindEvents){ /* check if events are bound */
				/* unbind namespaced events from document/selectors */
				$(document).add($(!_canAccessIFrame() || top.document)).unbind("."+namespace);
				sel.each(function(){
					$(this).unbind("."+namespace);
				});
				/* clear and delete timeouts/objects */
				clearTimeout($this[0]._focusTimeout); _delete($this[0],"_focusTimeout");
				clearTimeout(d.sequential.step); _delete(d.sequential,"step");
				clearTimeout(mCSB_container[0].onCompleteTimeout); _delete(mCSB_container[0],"onCompleteTimeout");
				d.bindEvents=false;
			}
		},
		/* -------------------- */


		/* toggles scrollbar visibility */
		_scrollbarVisibility=function(disabled){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				contentWrapper=$("#mCSB_"+d.idx+"_container_wrapper"),
				content=contentWrapper.length ? contentWrapper : $("#mCSB_"+d.idx+"_container"),
				scrollbar=[$("#mCSB_"+d.idx+"_scrollbar_vertical"),$("#mCSB_"+d.idx+"_scrollbar_horizontal")],
				mCSB_dragger=[scrollbar[0].find(".mCSB_dragger"),scrollbar[1].find(".mCSB_dragger")];
			if(o.axis!=="x"){
				if(d.overflowed[0] && !disabled){
					scrollbar[0].add(mCSB_dragger[0]).add(scrollbar[0].children("a")).css("display","block");
					content.removeClass(classes[8]+" "+classes[10]);
				}else{
					if(o.alwaysShowScrollbar){
						if(o.alwaysShowScrollbar!==2){mCSB_dragger[0].css("display","none");}
						content.removeClass(classes[10]);
					}else{
						scrollbar[0].css("display","none");
						content.addClass(classes[10]);
					}
					content.addClass(classes[8]);
				}
			}
			if(o.axis!=="y"){
				if(d.overflowed[1] && !disabled){
					scrollbar[1].add(mCSB_dragger[1]).add(scrollbar[1].children("a")).css("display","block");
					content.removeClass(classes[9]+" "+classes[11]);
				}else{
					if(o.alwaysShowScrollbar){
						if(o.alwaysShowScrollbar!==2){mCSB_dragger[1].css("display","none");}
						content.removeClass(classes[11]);
					}else{
						scrollbar[1].css("display","none");
						content.addClass(classes[11]);
					}
					content.addClass(classes[9]);
				}
			}
			if(!d.overflowed[0] && !d.overflowed[1]){
				$this.addClass(classes[5]);
			}else{
				$this.removeClass(classes[5]);
			}
		},
		/* -------------------- */


		/* returns input coordinates of pointer, touch and mouse events (relative to document) */
		_coordinates=function(e){
			var t=e.type,o=e.target.ownerDocument!==document && frameElement!==null ? [$(frameElement).offset().top,$(frameElement).offset().left] : null,
				io=_canAccessIFrame() && e.target.ownerDocument!==top.document && frameElement!==null ? [$(e.view.frameElement).offset().top,$(e.view.frameElement).offset().left] : [0,0];
			switch(t){
				case "pointerdown": case "MSPointerDown": case "pointermove": case "MSPointerMove": case "pointerup": case "MSPointerUp":
					return o ? [e.originalEvent.pageY-o[0]+io[0],e.originalEvent.pageX-o[1]+io[1],false] : [e.originalEvent.pageY,e.originalEvent.pageX,false];
					break;
				case "touchstart": case "touchmove": case "touchend":
					var touch=e.originalEvent.touches[0] || e.originalEvent.changedTouches[0],
						touches=e.originalEvent.touches.length || e.originalEvent.changedTouches.length;
					return e.target.ownerDocument!==document ? [touch.screenY,touch.screenX,touches>1] : [touch.pageY,touch.pageX,touches>1];
					break;
				default:
					return o ? [e.pageY-o[0]+io[0],e.pageX-o[1]+io[1],false] : [e.pageY,e.pageX,false];
			}
		},
		/* -------------------- */


		/*
		SCROLLBAR DRAG EVENTS
		scrolls content via scrollbar dragging
		*/
		_draggable=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				draggerId=["mCSB_"+d.idx+"_dragger_vertical","mCSB_"+d.idx+"_dragger_horizontal"],
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=$("#"+draggerId[0]+",#"+draggerId[1]),
				draggable,dragY,dragX,
				rds=o.advanced.releaseDraggableSelectors ? mCSB_dragger.add($(o.advanced.releaseDraggableSelectors)) : mCSB_dragger,
				eds=o.advanced.extraDraggableSelectors ? $(!_canAccessIFrame() || top.document).add($(o.advanced.extraDraggableSelectors)) : $(!_canAccessIFrame() || top.document);
			mCSB_dragger.bind("contextmenu."+namespace,function(e){
				e.preventDefault(); //prevent right click
			}).bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace,function(e){
				e.stopImmediatePropagation();
				e.preventDefault();
				if(!_mouseBtnLeft(e)){return;} /* left mouse button only */
				touchActive=true;
				if(oldIE){document.onselectstart=function(){return false;}} /* disable text selection for IE < 9 */
				_iframe.call(mCSB_container,false); /* enable scrollbar dragging over iframes by disabling their events */
				_stop($this);
				draggable=$(this);
				var offset=draggable.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left,
					h=draggable.height()+offset.top,w=draggable.width()+offset.left;
				if(y<h && y>0 && x<w && x>0){
					dragY=y;
					dragX=x;
				}
				_onDragClasses(draggable,"active",o.autoExpandScrollbar);
			}).bind("touchmove."+namespace,function(e){
				e.stopImmediatePropagation();
				e.preventDefault();
				var offset=draggable.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left;
				_drag(dragY,dragX,y,x);
			});
			$(document).add(eds).bind("mousemove."+namespace+" pointermove."+namespace+" MSPointerMove."+namespace,function(e){
				if(draggable){
					var offset=draggable.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left;
					if(dragY===y && dragX===x){return;} /* has it really moved? */
					_drag(dragY,dragX,y,x);
				}
			}).add(rds).bind("mouseup."+namespace+" touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace,function(e){
				if(draggable){
					_onDragClasses(draggable,"active",o.autoExpandScrollbar);
					draggable=null;
				}
				touchActive=false;
				if(oldIE){document.onselectstart=null;} /* enable text selection for IE < 9 */
				_iframe.call(mCSB_container,true); /* enable iframes events */
			});
			function _drag(dragY,dragX,y,x){
				mCSB_container[0].idleTimer=o.scrollInertia<233 ? 250 : 0;
				if(draggable.attr("id")===draggerId[1]){
					var dir="x",to=((draggable[0].offsetLeft-dragX)+x)*d.scrollRatio.x;
				}else{
					var dir="y",to=((draggable[0].offsetTop-dragY)+y)*d.scrollRatio.y;
				}
				_scrollTo($this,to.toString(),{dir:dir,drag:true});
			}
		},
		/* -------------------- */


		/*
		TOUCH SWIPE EVENTS
		scrolls content via touch swipe
		Emulates the native touch-swipe scrolling with momentum found in iOS, Android and WP devices
		*/
		_contentDraggable=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
				draggable,dragY,dragX,touchStartY,touchStartX,touchMoveY=[],touchMoveX=[],startTime,runningTime,endTime,distance,speed,amount,
				durA=0,durB,overwrite=o.axis==="yx" ? "none" : "all",touchIntent=[],touchDrag,docDrag,
				iframe=mCSB_container.find("iframe"),
				events=[
					"touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace, //start
					"touchmove."+namespace+" pointermove."+namespace+" MSPointerMove."+namespace, //move
					"touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace //end
				],
				touchAction=document.body.style.touchAction!==undefined && document.body.style.touchAction!=="";
			mCSB_container.bind(events[0],function(e){
				_onTouchstart(e);
			}).bind(events[1],function(e){
				_onTouchmove(e);
			});
			mCustomScrollBox.bind(events[0],function(e){
				_onTouchstart2(e);
			}).bind(events[2],function(e){
				_onTouchend(e);
			});
			if(iframe.length){
				iframe.each(function(){
					$(this).bind("load",function(){
						/* bind events on accessible iframes */
						if(_canAccessIFrame(this)){
							$(this.contentDocument || this.contentWindow.document).bind(events[0],function(e){
								_onTouchstart(e);
								_onTouchstart2(e);
							}).bind(events[1],function(e){
								_onTouchmove(e);
							}).bind(events[2],function(e){
								_onTouchend(e);
							});
						}
					});
				});
			}
			function _onTouchstart(e){
				if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){touchable=0; return;}
				touchable=1; touchDrag=0; docDrag=0; draggable=1;
				$this.removeClass("mCS_touch_action");
				var offset=mCSB_container.offset();
				dragY=_coordinates(e)[0]-offset.top;
				dragX=_coordinates(e)[1]-offset.left;
				touchIntent=[_coordinates(e)[0],_coordinates(e)[1]];
			}
			function _onTouchmove(e){
				if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){return;}
				if(!o.documentTouchScroll){e.preventDefault();}
				e.stopImmediatePropagation();
				if(docDrag && !touchDrag){return;}
				if(draggable){
					runningTime=_getTime();
					var offset=mCustomScrollBox.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left,
						easing="mcsLinearOut";
					touchMoveY.push(y);
					touchMoveX.push(x);
					touchIntent[2]=Math.abs(_coordinates(e)[0]-touchIntent[0]); touchIntent[3]=Math.abs(_coordinates(e)[1]-touchIntent[1]);
					if(d.overflowed[0]){
						var limit=mCSB_dragger[0].parent().height()-mCSB_dragger[0].height(),
							prevent=((dragY-y)>0 && (y-dragY)>-(limit*d.scrollRatio.y) && (touchIntent[3]*2<touchIntent[2] || o.axis==="yx"));
					}
					if(d.overflowed[1]){
						var limitX=mCSB_dragger[1].parent().width()-mCSB_dragger[1].width(),
							preventX=((dragX-x)>0 && (x-dragX)>-(limitX*d.scrollRatio.x) && (touchIntent[2]*2<touchIntent[3] || o.axis==="yx"));
					}
					if(prevent || preventX){ /* prevent native document scrolling */
						if(!touchAction){e.preventDefault();}
						touchDrag=1;
					}else{
						docDrag=1;
						$this.addClass("mCS_touch_action");
					}
					if(touchAction){e.preventDefault();}
					amount=o.axis==="yx" ? [(dragY-y),(dragX-x)] : o.axis==="x" ? [null,(dragX-x)] : [(dragY-y),null];
					mCSB_container[0].idleTimer=250;
					if(d.overflowed[0]){_drag(amount[0],durA,easing,"y","all",true);}
					if(d.overflowed[1]){_drag(amount[1],durA,easing,"x",overwrite,true);}
				}
			}
			function _onTouchstart2(e){
				if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){touchable=0; return;}
				touchable=1;
				e.stopImmediatePropagation();
				_stop($this);
				startTime=_getTime();
				var offset=mCustomScrollBox.offset();
				touchStartY=_coordinates(e)[0]-offset.top;
				touchStartX=_coordinates(e)[1]-offset.left;
				touchMoveY=[]; touchMoveX=[];
			}
			function _onTouchend(e){
				if(!_pointerTouch(e) || touchActive || _coordinates(e)[2]){return;}
				draggable=0;
				e.stopImmediatePropagation();
				touchDrag=0; docDrag=0;
				endTime=_getTime();
				var offset=mCustomScrollBox.offset(),y=_coordinates(e)[0]-offset.top,x=_coordinates(e)[1]-offset.left;
				if((endTime-runningTime)>30){return;}
				speed=1000/(endTime-startTime);
				var easing="mcsEaseOut",slow=speed<2.5,
					diff=slow ? [touchMoveY[touchMoveY.length-2],touchMoveX[touchMoveX.length-2]] : [0,0];
				distance=slow ? [(y-diff[0]),(x-diff[1])] : [y-touchStartY,x-touchStartX];
				var absDistance=[Math.abs(distance[0]),Math.abs(distance[1])];
				speed=slow ? [Math.abs(distance[0]/4),Math.abs(distance[1]/4)] : [speed,speed];
				var a=[
					Math.abs(mCSB_container[0].offsetTop)-(distance[0]*_m((absDistance[0]/speed[0]),speed[0])),
					Math.abs(mCSB_container[0].offsetLeft)-(distance[1]*_m((absDistance[1]/speed[1]),speed[1]))
				];
				amount=o.axis==="yx" ? [a[0],a[1]] : o.axis==="x" ? [null,a[1]] : [a[0],null];
				durB=[(absDistance[0]*4)+o.scrollInertia,(absDistance[1]*4)+o.scrollInertia];
				var md=parseInt(o.contentTouchScroll) || 0; /* absolute minimum distance required */
				amount[0]=absDistance[0]>md ? amount[0] : 0;
				amount[1]=absDistance[1]>md ? amount[1] : 0;
				if(d.overflowed[0]){_drag(amount[0],durB[0],easing,"y",overwrite,false);}
				if(d.overflowed[1]){_drag(amount[1],durB[1],easing,"x",overwrite,false);}
			}
			function _m(ds,s){
				var r=[s*1.5,s*2,s/1.5,s/2];
				if(ds>90){
					return s>4 ? r[0] : r[3];
				}else if(ds>60){
					return s>3 ? r[3] : r[2];
				}else if(ds>30){
					return s>8 ? r[1] : s>6 ? r[0] : s>4 ? s : r[2];
				}else{
					return s>8 ? s : r[3];
				}
			}
			function _drag(amount,dur,easing,dir,overwrite,drag){
				if(!amount){return;}
				_scrollTo($this,amount.toString(),{dur:dur,scrollEasing:easing,dir:dir,overwrite:overwrite,drag:drag});
			}
		},
		/* -------------------- */


		/*
		SELECT TEXT EVENTS
		scrolls content when text is selected
		*/
		_selectable=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
				namespace=pluginPfx+"_"+d.idx,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				action;
			mCSB_container.bind("mousedown."+namespace,function(e){
				if(touchable){return;}
				if(!action){action=1; touchActive=true;}
			}).add(document).bind("mousemove."+namespace,function(e){
				if(!touchable && action && _sel()){
					var offset=mCSB_container.offset(),
						y=_coordinates(e)[0]-offset.top+mCSB_container[0].offsetTop,x=_coordinates(e)[1]-offset.left+mCSB_container[0].offsetLeft;
					if(y>0 && y<wrapper.height() && x>0 && x<wrapper.width()){
						if(seq.step){_seq("off",null,"stepped");}
					}else{
						if(o.axis!=="x" && d.overflowed[0]){
							if(y<0){
								_seq("on",38);
							}else if(y>wrapper.height()){
								_seq("on",40);
							}
						}
						if(o.axis!=="y" && d.overflowed[1]){
							if(x<0){
								_seq("on",37);
							}else if(x>wrapper.width()){
								_seq("on",39);
							}
						}
					}
				}
			}).bind("mouseup."+namespace+" dragend."+namespace,function(e){
				if(touchable){return;}
				if(action){action=0; _seq("off",null);}
				touchActive=false;
			});
			function _sel(){
				return 	window.getSelection ? window.getSelection().toString() :
						document.selection && document.selection.type!="Control" ? document.selection.createRange().text : 0;
			}
			function _seq(a,c,s){
				seq.type=s && action ? "stepped" : "stepless";
				seq.scrollAmount=10;
				_sequentialScroll($this,a,c,"mcsLinearOut",s ? 60 : null);
			}
		},
		/* -------------------- */


		/*
		MOUSE WHEEL EVENT
		scrolls content via mouse-wheel
		via mouse-wheel plugin (https://github.com/brandonaaron/jquery-mousewheel)
		*/
		_mousewheel=function(){
			if(!$(this).data(pluginPfx)){return;} /* Check if the scrollbar is ready to use mousewheel events (issue: #185) */
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_dragger=[$("#mCSB_"+d.idx+"_dragger_vertical"),$("#mCSB_"+d.idx+"_dragger_horizontal")],
				iframe=$("#mCSB_"+d.idx+"_container").find("iframe");
			if(iframe.length){
				iframe.each(function(){
					$(this).bind("load",function(){
						/* bind events on accessible iframes */
						if(_canAccessIFrame(this)){
							$(this.contentDocument || this.contentWindow.document).bind("mousewheel."+namespace,function(e,delta){
								_onMousewheel(e,delta);
							});
						}
					});
				});
			}
			mCustomScrollBox.bind("mousewheel."+namespace,function(e,delta){
				_onMousewheel(e,delta);
			});
			function _onMousewheel(e,delta){
				_stop($this);
				if(_disableMousewheel($this,e.target)){return;} /* disables mouse-wheel when hovering specific elements */
				var deltaFactor=o.mouseWheel.deltaFactor!=="auto" ? parseInt(o.mouseWheel.deltaFactor) : (oldIE && e.deltaFactor<100) ? 100 : e.deltaFactor || 100,
					dur=o.scrollInertia;
				if(o.axis==="x" || o.mouseWheel.axis==="x"){
					var dir="x",
						px=[Math.round(deltaFactor*d.scrollRatio.x),parseInt(o.mouseWheel.scrollAmount)],
						amount=o.mouseWheel.scrollAmount!=="auto" ? px[1] : px[0]>=mCustomScrollBox.width() ? mCustomScrollBox.width()*0.9 : px[0],
						contentPos=Math.abs($("#mCSB_"+d.idx+"_container")[0].offsetLeft),
						draggerPos=mCSB_dragger[1][0].offsetLeft,
						limit=mCSB_dragger[1].parent().width()-mCSB_dragger[1].width(),
						dlt=o.mouseWheel.axis==="y" ? (e.deltaY || delta) : e.deltaX;
				}else{
					var dir="y",
						px=[Math.round(deltaFactor*d.scrollRatio.y),parseInt(o.mouseWheel.scrollAmount)],
						amount=o.mouseWheel.scrollAmount!=="auto" ? px[1] : px[0]>=mCustomScrollBox.height() ? mCustomScrollBox.height()*0.9 : px[0],
						contentPos=Math.abs($("#mCSB_"+d.idx+"_container")[0].offsetTop),
						draggerPos=mCSB_dragger[0][0].offsetTop,
						limit=mCSB_dragger[0].parent().height()-mCSB_dragger[0].height(),
						dlt=e.deltaY || delta;
				}
				if((dir==="y" && !d.overflowed[0]) || (dir==="x" && !d.overflowed[1])){return;}
				if(o.mouseWheel.invert || e.webkitDirectionInvertedFromDevice){dlt=-dlt;}
				if(o.mouseWheel.normalizeDelta){dlt=dlt<0 ? -1 : 1;}
				if((dlt>0 && draggerPos!==0) || (dlt<0 && draggerPos!==limit) || o.mouseWheel.preventDefault){
					e.stopImmediatePropagation();
					e.preventDefault();
				}
				if(e.deltaFactor<5 && !o.mouseWheel.normalizeDelta){
					//very low deltaFactor values mean some kind of delta acceleration (e.g. osx trackpad), so adjusting scrolling accordingly
					amount=e.deltaFactor; dur=17;
				}
				_scrollTo($this,(contentPos-(dlt*amount)).toString(),{dir:dir,dur:dur});
			}
		},
		/* -------------------- */


		/* checks if iframe can be accessed */
		_canAccessIFrameCache=new Object(),
		_canAccessIFrame=function(iframe){
		    var result=false,cacheKey=false,html=null;
		    if(iframe===undefined){
				cacheKey="#empty";
		    }else if($(iframe).attr("id")!==undefined){
				cacheKey=$(iframe).attr("id");
		    }
			if(cacheKey!==false && _canAccessIFrameCache[cacheKey]!==undefined){
				return _canAccessIFrameCache[cacheKey];
			}
			if(!iframe){
				try{
					var doc=top.document;
					html=doc.body.innerHTML;
				}catch(err){/* do nothing */}
				result=(html!==null);
			}else{
				try{
					var doc=iframe.contentDocument || iframe.contentWindow.document;
					html=doc.body.innerHTML;
				}catch(err){/* do nothing */}
				result=(html!==null);
			}
			if(cacheKey!==false){_canAccessIFrameCache[cacheKey]=result;}
			return result;
		},
		/* -------------------- */


		/* switches iframe's pointer-events property (drag, mousewheel etc. over cross-domain iframes) */
		_iframe=function(evt){
			var el=this.find("iframe");
			if(!el.length){return;} /* check if content contains iframes */
			var val=!evt ? "none" : "auto";
			el.css("pointer-events",val); /* for IE11, iframe's display property should not be "block" */
		},
		/* -------------------- */


		/* disables mouse-wheel when hovering specific elements like select, datalist etc. */
		_disableMousewheel=function(el,target){
			var tag=target.nodeName.toLowerCase(),
				tags=el.data(pluginPfx).opt.mouseWheel.disableOver,
				/* elements that require focus */
				focusTags=["select","textarea"];
			return $.inArray(tag,tags) > -1 && !($.inArray(tag,focusTags) > -1 && !$(target).is(":focus"));
		},
		/* -------------------- */


		/*
		DRAGGER RAIL CLICK EVENT
		scrolls content via dragger rail
		*/
		_draggerRail=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				namespace=pluginPfx+"_"+d.idx,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				mCSB_draggerContainer=$(".mCSB_"+d.idx+"_scrollbar ."+classes[12]),
				clickable;
			mCSB_draggerContainer.bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace,function(e){
				touchActive=true;
				if(!$(e.target).hasClass("mCSB_dragger")){clickable=1;}
			}).bind("touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace,function(e){
				touchActive=false;
			}).bind("click."+namespace,function(e){
				if(!clickable){return;}
				clickable=0;
				if($(e.target).hasClass(classes[12]) || $(e.target).hasClass("mCSB_draggerRail")){
					_stop($this);
					var el=$(this),mCSB_dragger=el.find(".mCSB_dragger");
					if(el.parent(".mCSB_scrollTools_horizontal").length>0){
						if(!d.overflowed[1]){return;}
						var dir="x",
							clickDir=e.pageX>mCSB_dragger.offset().left ? -1 : 1,
							to=Math.abs(mCSB_container[0].offsetLeft)-(clickDir*(wrapper.width()*0.9));
					}else{
						if(!d.overflowed[0]){return;}
						var dir="y",
							clickDir=e.pageY>mCSB_dragger.offset().top ? -1 : 1,
							to=Math.abs(mCSB_container[0].offsetTop)-(clickDir*(wrapper.height()*0.9));
					}
					_scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mcsEaseInOut"});
				}
			});
		},
		/* -------------------- */


		/*
		FOCUS EVENT
		scrolls content via element focus (e.g. clicking an input, pressing TAB key etc.)
		*/
		_focus=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				namespace=pluginPfx+"_"+d.idx,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent();
			mCSB_container.bind("focusin."+namespace,function(e){
				var el=$(document.activeElement),
					nested=mCSB_container.find(".mCustomScrollBox").length,
					dur=0;
				if(!el.is(o.advanced.autoScrollOnFocus)){return;}
				_stop($this);
				clearTimeout($this[0]._focusTimeout);
				$this[0]._focusTimer=nested ? (dur+17)*nested : 0;
				$this[0]._focusTimeout=setTimeout(function(){
					var	to=[_childPos(el)[0],_childPos(el)[1]],
						contentPos=[mCSB_container[0].offsetTop,mCSB_container[0].offsetLeft],
						isVisible=[
							(contentPos[0]+to[0]>=0 && contentPos[0]+to[0]<wrapper.height()-el.outerHeight(false)),
							(contentPos[1]+to[1]>=0 && contentPos[0]+to[1]<wrapper.width()-el.outerWidth(false))
						],
						overwrite=(o.axis==="yx" && !isVisible[0] && !isVisible[1]) ? "none" : "all";
					if(o.axis!=="x" && !isVisible[0]){
						_scrollTo($this,to[0].toString(),{dir:"y",scrollEasing:"mcsEaseInOut",overwrite:overwrite,dur:dur});
					}
					if(o.axis!=="y" && !isVisible[1]){
						_scrollTo($this,to[1].toString(),{dir:"x",scrollEasing:"mcsEaseInOut",overwrite:overwrite,dur:dur});
					}
				},$this[0]._focusTimer);
			});
		},
		/* -------------------- */


		/* sets content wrapper scrollTop/scrollLeft always to 0 */
		_wrapperScroll=function(){
			var $this=$(this),d=$this.data(pluginPfx),
				namespace=pluginPfx+"_"+d.idx,
				wrapper=$("#mCSB_"+d.idx+"_container").parent();
			wrapper.bind("scroll."+namespace,function(e){
				if(wrapper.scrollTop()!==0 || wrapper.scrollLeft()!==0){
					$(".mCSB_"+d.idx+"_scrollbar").css("visibility","hidden"); /* hide scrollbar(s) */
				}
			});
		},
		/* -------------------- */


		/*
		BUTTONS EVENTS
		scrolls content via up, down, left and right buttons
		*/
		_buttons=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
				namespace=pluginPfx+"_"+d.idx,
				sel=".mCSB_"+d.idx+"_scrollbar",
				btn=$(sel+">a");
			btn.bind("contextmenu."+namespace,function(e){
				e.preventDefault(); //prevent right click
			}).bind("mousedown."+namespace+" touchstart."+namespace+" pointerdown."+namespace+" MSPointerDown."+namespace+" mouseup."+namespace+" touchend."+namespace+" pointerup."+namespace+" MSPointerUp."+namespace+" mouseout."+namespace+" pointerout."+namespace+" MSPointerOut."+namespace+" click."+namespace,function(e){
				e.preventDefault();
				if(!_mouseBtnLeft(e)){return;} /* left mouse button only */
				var btnClass=$(this).attr("class");
				seq.type=o.scrollButtons.scrollType;
				switch(e.type){
					case "mousedown": case "touchstart": case "pointerdown": case "MSPointerDown":
						if(seq.type==="stepped"){return;}
						touchActive=true;
						d.tweenRunning=false;
						_seq("on",btnClass);
						break;
					case "mouseup": case "touchend": case "pointerup": case "MSPointerUp":
					case "mouseout": case "pointerout": case "MSPointerOut":
						if(seq.type==="stepped"){return;}
						touchActive=false;
						if(seq.dir){_seq("off",btnClass);}
						break;
					case "click":
						if(seq.type!=="stepped" || d.tweenRunning){return;}
						_seq("on",btnClass);
						break;
				}
				function _seq(a,c){
					seq.scrollAmount=o.scrollButtons.scrollAmount;
					_sequentialScroll($this,a,c);
				}
			});
		},
		/* -------------------- */


		/*
		KEYBOARD EVENTS
		scrolls content via keyboard
		Keys: up arrow, down arrow, left arrow, right arrow, PgUp, PgDn, Home, End
		*/
		_keyboard=function(){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,seq=d.sequential,
				namespace=pluginPfx+"_"+d.idx,
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				editables="input,textarea,select,datalist,keygen,[contenteditable='true']",
				iframe=mCSB_container.find("iframe"),
				events=["blur."+namespace+" keydown."+namespace+" keyup."+namespace];
			if(iframe.length){
				iframe.each(function(){
					$(this).bind("load",function(){
						/* bind events on accessible iframes */
						if(_canAccessIFrame(this)){
							$(this.contentDocument || this.contentWindow.document).bind(events[0],function(e){
								_onKeyboard(e);
							});
						}
					});
				});
			}
			mCustomScrollBox.attr("tabindex","0").bind(events[0],function(e){
				_onKeyboard(e);
			});
			function _onKeyboard(e){
				switch(e.type){
					case "blur":
						if(d.tweenRunning && seq.dir){_seq("off",null);}
						break;
					case "keydown": case "keyup":
						var code=e.keyCode ? e.keyCode : e.which,action="on";
						if((o.axis!=="x" && (code===38 || code===40)) || (o.axis!=="y" && (code===37 || code===39))){
							/* up (38), down (40), left (37), right (39) arrows */
							if(((code===38 || code===40) && !d.overflowed[0]) || ((code===37 || code===39) && !d.overflowed[1])){return;}
							if(e.type==="keyup"){action="off";}
							if(!$(document.activeElement).is(editables)){
								e.preventDefault();
								e.stopImmediatePropagation();
								_seq(action,code);
							}
						}else if(code===33 || code===34){
							/* PgUp (33), PgDn (34) */
							if(d.overflowed[0] || d.overflowed[1]){
								e.preventDefault();
								e.stopImmediatePropagation();
							}
							if(e.type==="keyup"){
								_stop($this);
								var keyboardDir=code===34 ? -1 : 1;
								if(o.axis==="x" || (o.axis==="yx" && d.overflowed[1] && !d.overflowed[0])){
									var dir="x",to=Math.abs(mCSB_container[0].offsetLeft)-(keyboardDir*(wrapper.width()*0.9));
								}else{
									var dir="y",to=Math.abs(mCSB_container[0].offsetTop)-(keyboardDir*(wrapper.height()*0.9));
								}
								_scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mcsEaseInOut"});
							}
						}else if(code===35 || code===36){
							/* End (35), Home (36) */
							if(!$(document.activeElement).is(editables)){
								if(d.overflowed[0] || d.overflowed[1]){
									e.preventDefault();
									e.stopImmediatePropagation();
								}
								if(e.type==="keyup"){
									if(o.axis==="x" || (o.axis==="yx" && d.overflowed[1] && !d.overflowed[0])){
										var dir="x",to=code===35 ? Math.abs(wrapper.width()-mCSB_container.outerWidth(false)) : 0;
									}else{
										var dir="y",to=code===35 ? Math.abs(wrapper.height()-mCSB_container.outerHeight(false)) : 0;
									}
									_scrollTo($this,to.toString(),{dir:dir,scrollEasing:"mcsEaseInOut"});
								}
							}
						}
						break;
				}
				function _seq(a,c){
					seq.type=o.keyboard.scrollType;
					seq.scrollAmount=o.keyboard.scrollAmount;
					if(seq.type==="stepped" && d.tweenRunning){return;}
					_sequentialScroll($this,a,c);
				}
			}
		},
		/* -------------------- */


		/* scrolls content sequentially (used when scrolling via buttons, keyboard arrows etc.) */
		_sequentialScroll=function(el,action,trigger,e,s){
			var d=el.data(pluginPfx),o=d.opt,seq=d.sequential,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				once=seq.type==="stepped" ? true : false,
				steplessSpeed=o.scrollInertia < 26 ? 26 : o.scrollInertia, /* 26/1.5=17 */
				steppedSpeed=o.scrollInertia < 1 ? 17 : o.scrollInertia;
			switch(action){
				case "on":
					seq.dir=[
						(trigger===classes[16] || trigger===classes[15] || trigger===39 || trigger===37 ? "x" : "y"),
						(trigger===classes[13] || trigger===classes[15] || trigger===38 || trigger===37 ? -1 : 1)
					];
					_stop(el);
					if(_isNumeric(trigger) && seq.type==="stepped"){return;}
					_on(once);
					break;
				case "off":
					_off();
					if(once || (d.tweenRunning && seq.dir)){
						_on(true);
					}
					break;
			}

			/* starts sequence */
			function _on(once){
				if(o.snapAmount){seq.scrollAmount=!(o.snapAmount instanceof Array) ? o.snapAmount : seq.dir[0]==="x" ? o.snapAmount[1] : o.snapAmount[0];} /* scrolling snapping */
				var c=seq.type!=="stepped", /* continuous scrolling */
					t=s ? s : !once ? 1000/60 : c ? steplessSpeed/1.5 : steppedSpeed, /* timer */
					m=!once ? 2.5 : c ? 7.5 : 40, /* multiplier */
					contentPos=[Math.abs(mCSB_container[0].offsetTop),Math.abs(mCSB_container[0].offsetLeft)],
					ratio=[d.scrollRatio.y>10 ? 10 : d.scrollRatio.y,d.scrollRatio.x>10 ? 10 : d.scrollRatio.x],
					amount=seq.dir[0]==="x" ? contentPos[1]+(seq.dir[1]*(ratio[1]*m)) : contentPos[0]+(seq.dir[1]*(ratio[0]*m)),
					px=seq.dir[0]==="x" ? contentPos[1]+(seq.dir[1]*parseInt(seq.scrollAmount)) : contentPos[0]+(seq.dir[1]*parseInt(seq.scrollAmount)),
					to=seq.scrollAmount!=="auto" ? px : amount,
					easing=e ? e : !once ? "mcsLinear" : c ? "mcsLinearOut" : "mcsEaseInOut",
					onComplete=!once ? false : true;
				if(once && t<17){
					to=seq.dir[0]==="x" ? contentPos[1] : contentPos[0];
				}
				_scrollTo(el,to.toString(),{dir:seq.dir[0],scrollEasing:easing,dur:t,onComplete:onComplete});
				if(once){
					seq.dir=false;
					return;
				}
				clearTimeout(seq.step);
				seq.step=setTimeout(function(){
					_on();
				},t);
			}
			/* stops sequence */
			function _off(){
				clearTimeout(seq.step);
				_delete(seq,"step");
				_stop(el);
			}
		},
		/* -------------------- */


		/* returns a yx array from value */
		_arr=function(val){
			var o=$(this).data(pluginPfx).opt,vals=[];
			if(typeof val==="function"){val=val();} /* check if the value is a single anonymous function */
			/* check if value is object or array, its length and create an array with yx values */
			if(!(val instanceof Array)){ /* object value (e.g. {y:"100",x:"100"}, 100 etc.) */
				vals[0]=val.y ? val.y : val.x || o.axis==="x" ? null : val;
				vals[1]=val.x ? val.x : val.y || o.axis==="y" ? null : val;
			}else{ /* array value (e.g. [100,100]) */
				vals=val.length>1 ? [val[0],val[1]] : o.axis==="x" ? [null,val[0]] : [val[0],null];
			}
			/* check if array values are anonymous functions */
			if(typeof vals[0]==="function"){vals[0]=vals[0]();}
			if(typeof vals[1]==="function"){vals[1]=vals[1]();}
			return vals;
		},
		/* -------------------- */


		/* translates values (e.g. "top", 100, "100px", "#id") to actual scroll-to positions */
		_to=function(val,dir){
			if(val==null || typeof val=="undefined"){return;}
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				t=typeof val;
			if(!dir){dir=o.axis==="x" ? "x" : "y";}
			var contentLength=dir==="x" ? mCSB_container.outerWidth(false)-wrapper.width() : mCSB_container.outerHeight(false)-wrapper.height(),
				contentPos=dir==="x" ? mCSB_container[0].offsetLeft : mCSB_container[0].offsetTop,
				cssProp=dir==="x" ? "left" : "top";
			switch(t){
				case "function": /* this currently is not used. Consider removing it */
					return val();
					break;
				case "object": /* js/jquery object */
					var obj=val.jquery ? val : $(val);
					if(!obj.length){return;}
					return dir==="x" ? _childPos(obj)[1] : _childPos(obj)[0];
					break;
				case "string": case "number":
					if(_isNumeric(val)){ /* numeric value */
						return Math.abs(val);
					}else if(val.indexOf("%")!==-1){ /* percentage value */
						return Math.abs(contentLength*parseInt(val)/100);
					}else if(val.indexOf("-=")!==-1){ /* decrease value */
						return Math.abs(contentPos-parseInt(val.split("-=")[1]));
					}else if(val.indexOf("+=")!==-1){ /* inrease value */
						var p=(contentPos+parseInt(val.split("+=")[1]));
						return p>=0 ? 0 : Math.abs(p);
					}else if(val.indexOf("px")!==-1 && _isNumeric(val.split("px")[0])){ /* pixels string value (e.g. "100px") */
						return Math.abs(val.split("px")[0]);
					}else{
						if(val==="top" || val==="left"){ /* special strings */
							return 0;
						}else if(val==="bottom"){
							return Math.abs(wrapper.height()-mCSB_container.outerHeight(false));
						}else if(val==="right"){
							return Math.abs(wrapper.width()-mCSB_container.outerWidth(false));
						}else if(val==="first" || val==="last"){
							var obj=mCSB_container.find(":"+val);
							return dir==="x" ? _childPos(obj)[1] : _childPos(obj)[0];
						}else{
							if($(val).length){ /* jquery selector */
								return dir==="x" ? _childPos($(val))[1] : _childPos($(val))[0];
							}else{ /* other values (e.g. "100em") */
								mCSB_container.css(cssProp,val);
								methods.update.call(null,$this[0]);
								return;
							}
						}
					}
					break;
			}
		},
		/* -------------------- */


		/* calls the update method automatically */
		_autoUpdate=function(rem){
			var $this=$(this),d=$this.data(pluginPfx),o=d.opt,
				mCSB_container=$("#mCSB_"+d.idx+"_container");
			if(rem){
				/*
				removes autoUpdate timer
				usage: _autoUpdate.call(this,"remove");
				*/
				clearTimeout(mCSB_container[0].autoUpdate);
				_delete(mCSB_container[0],"autoUpdate");
				return;
			}
			upd();
			function upd(){
				clearTimeout(mCSB_container[0].autoUpdate);
				if($this.parents("html").length===0){
					/* check element in dom tree */
					$this=null;
					return;
				}
				mCSB_container[0].autoUpdate=setTimeout(function(){
					/* update on specific selector(s) length and size change */
					if(o.advanced.updateOnSelectorChange){
						d.poll.change.n=sizesSum();
						if(d.poll.change.n!==d.poll.change.o){
							d.poll.change.o=d.poll.change.n;
							doUpd(3);
							return;
						}
					}
					/* update on main element and scrollbar size changes */
					if(o.advanced.updateOnContentResize){
						d.poll.size.n=$this[0].scrollHeight+$this[0].scrollWidth+mCSB_container[0].offsetHeight+$this[0].offsetHeight+$this[0].offsetWidth;
						if(d.poll.size.n!==d.poll.size.o){
							d.poll.size.o=d.poll.size.n;
							doUpd(1);
							return;
						}
					}
					/* update on image load */
					if(o.advanced.updateOnImageLoad){
						if(!(o.advanced.updateOnImageLoad==="auto" && o.axis==="y")){ //by default, it doesn't run on vertical content
							d.poll.img.n=mCSB_container.find("img").length;
							if(d.poll.img.n!==d.poll.img.o){
								d.poll.img.o=d.poll.img.n;
								mCSB_container.find("img").each(function(){
									imgLoader(this);
								});
								return;
							}
						}
					}
					if(o.advanced.updateOnSelectorChange || o.advanced.updateOnContentResize || o.advanced.updateOnImageLoad){upd();}
				},o.advanced.autoUpdateTimeout);
			}
			/* a tiny image loader */
			function imgLoader(el){
				if($(el).hasClass(classes[2])){doUpd(); return;}
				var img=new Image();
				function createDelegate(contextObject,delegateMethod){
					return function(){return delegateMethod.apply(contextObject,arguments);}
				}
				function imgOnLoad(){
					this.onload=null;
					$(el).addClass(classes[2]);
					doUpd(2);
				}
				img.onload=createDelegate(img,imgOnLoad);
				img.src=el.src;
			}
			/* returns the total height and width sum of all elements matching the selector */
			function sizesSum(){
				if(o.advanced.updateOnSelectorChange===true){o.advanced.updateOnSelectorChange="*";}
				var total=0,sel=mCSB_container.find(o.advanced.updateOnSelectorChange);
				if(o.advanced.updateOnSelectorChange && sel.length>0){sel.each(function(){total+=this.offsetHeight+this.offsetWidth;});}
				return total;
			}
			/* calls the update method */
			function doUpd(cb){
				clearTimeout(mCSB_container[0].autoUpdate);
				methods.update.call(null,$this[0],cb);
			}
		},
		/* -------------------- */


		/* snaps scrolling to a multiple of a pixels number */
		_snapAmount=function(to,amount,offset){
			return (Math.round(to/amount)*amount-offset);
		},
		/* -------------------- */


		/* stops content and scrollbar animations */
		_stop=function(el){
			var d=el.data(pluginPfx),
				sel=$("#mCSB_"+d.idx+"_container,#mCSB_"+d.idx+"_container_wrapper,#mCSB_"+d.idx+"_dragger_vertical,#mCSB_"+d.idx+"_dragger_horizontal");
			sel.each(function(){
				_stopTween.call(this);
			});
		},
		/* -------------------- */


		/*
		ANIMATES CONTENT
		This is where the actual scrolling happens
		*/
		_scrollTo=function(el,to,options){
			var d=el.data(pluginPfx),o=d.opt,
				defaults={
					trigger:"internal",
					dir:"y",
					scrollEasing:"mcsEaseOut",
					drag:false,
					dur:o.scrollInertia,
					overwrite:"all",
					callbacks:true,
					onStart:true,
					onUpdate:true,
					onComplete:true
				},
				options=$.extend(defaults,options),
				dur=[options.dur,(options.drag ? 0 : options.dur)],
				mCustomScrollBox=$("#mCSB_"+d.idx),
				mCSB_container=$("#mCSB_"+d.idx+"_container"),
				wrapper=mCSB_container.parent(),
				totalScrollOffsets=o.callbacks.onTotalScrollOffset ? _arr.call(el,o.callbacks.onTotalScrollOffset) : [0,0],
				totalScrollBackOffsets=o.callbacks.onTotalScrollBackOffset ? _arr.call(el,o.callbacks.onTotalScrollBackOffset) : [0,0];
			d.trigger=options.trigger;
			if(wrapper.scrollTop()!==0 || wrapper.scrollLeft()!==0){ /* always reset scrollTop/Left */
				$(".mCSB_"+d.idx+"_scrollbar").css("visibility","visible");
				wrapper.scrollTop(0).scrollLeft(0);
			}
			if(to==="_resetY" && !d.contentReset.y){
				/* callbacks: onOverflowYNone */
				if(_cb("onOverflowYNone")){o.callbacks.onOverflowYNone.call(el[0]);}
				d.contentReset.y=1;
			}
			if(to==="_resetX" && !d.contentReset.x){
				/* callbacks: onOverflowXNone */
				if(_cb("onOverflowXNone")){o.callbacks.onOverflowXNone.call(el[0]);}
				d.contentReset.x=1;
			}
			if(to==="_resetY" || to==="_resetX"){return;}
			if((d.contentReset.y || !el[0].mcs) && d.overflowed[0]){
				/* callbacks: onOverflowY */
				if(_cb("onOverflowY")){o.callbacks.onOverflowY.call(el[0]);}
				d.contentReset.x=null;
			}
			if((d.contentReset.x || !el[0].mcs) && d.overflowed[1]){
				/* callbacks: onOverflowX */
				if(_cb("onOverflowX")){o.callbacks.onOverflowX.call(el[0]);}
				d.contentReset.x=null;
			}
			if(o.snapAmount){ /* scrolling snapping */
				var snapAmount=!(o.snapAmount instanceof Array) ? o.snapAmount : options.dir==="x" ? o.snapAmount[1] : o.snapAmount[0];
				to=_snapAmount(to,snapAmount,o.snapOffset);
			}
			switch(options.dir){
				case "x":
					var mCSB_dragger=$("#mCSB_"+d.idx+"_dragger_horizontal"),
						property="left",
						contentPos=mCSB_container[0].offsetLeft,
						limit=[
							mCustomScrollBox.width()-mCSB_container.outerWidth(false),
							mCSB_dragger.parent().width()-mCSB_dragger.width()
						],
						scrollTo=[to,to===0 ? 0 : (to/d.scrollRatio.x)],
						tso=totalScrollOffsets[1],
						tsbo=totalScrollBackOffsets[1],
						totalScrollOffset=tso>0 ? tso/d.scrollRatio.x : 0,
						totalScrollBackOffset=tsbo>0 ? tsbo/d.scrollRatio.x : 0;
					break;
				case "y":
					var mCSB_dragger=$("#mCSB_"+d.idx+"_dragger_vertical"),
						property="top",
						contentPos=mCSB_container[0].offsetTop,
						limit=[
							mCustomScrollBox.height()-mCSB_container.outerHeight(false),
							mCSB_dragger.parent().height()-mCSB_dragger.height()
						],
						scrollTo=[to,to===0 ? 0 : (to/d.scrollRatio.y)],
						tso=totalScrollOffsets[0],
						tsbo=totalScrollBackOffsets[0],
						totalScrollOffset=tso>0 ? tso/d.scrollRatio.y : 0,
						totalScrollBackOffset=tsbo>0 ? tsbo/d.scrollRatio.y : 0;
					break;
			}
			if(scrollTo[1]<0 || (scrollTo[0]===0 && scrollTo[1]===0)){
				scrollTo=[0,0];
			}else if(scrollTo[1]>=limit[1]){
				scrollTo=[limit[0],limit[1]];
			}else{
				scrollTo[0]=-scrollTo[0];
			}
			if(!el[0].mcs){
				_mcs();  /* init mcs object (once) to make it available before callbacks */
				if(_cb("onInit")){o.callbacks.onInit.call(el[0]);} /* callbacks: onInit */
			}
			clearTimeout(mCSB_container[0].onCompleteTimeout);
			_tweenTo(mCSB_dragger[0],property,Math.round(scrollTo[1]),dur[1],options.scrollEasing);
			if(!d.tweenRunning && ((contentPos===0 && scrollTo[0]>=0) || (contentPos===limit[0] && scrollTo[0]<=limit[0]))){return;}
			_tweenTo(mCSB_container[0],property,Math.round(scrollTo[0]),dur[0],options.scrollEasing,options.overwrite,{
				onStart:function(){
					if(options.callbacks && options.onStart && !d.tweenRunning){
						/* callbacks: onScrollStart */
						if(_cb("onScrollStart")){_mcs(); o.callbacks.onScrollStart.call(el[0]);}
						d.tweenRunning=true;
						_onDragClasses(mCSB_dragger);
						d.cbOffsets=_cbOffsets();
					}
				},onUpdate:function(){
					if(options.callbacks && options.onUpdate){
						/* callbacks: whileScrolling */
						if(_cb("whileScrolling")){_mcs(); o.callbacks.whileScrolling.call(el[0]);}
					}
				},onComplete:function(){
					if(options.callbacks && options.onComplete){
						if(o.axis==="yx"){clearTimeout(mCSB_container[0].onCompleteTimeout);}
						var t=mCSB_container[0].idleTimer || 0;
						mCSB_container[0].onCompleteTimeout=setTimeout(function(){
							/* callbacks: onScroll, onTotalScroll, onTotalScrollBack */
							if(_cb("onScroll")){_mcs(); o.callbacks.onScroll.call(el[0]);}
							if(_cb("onTotalScroll") && scrollTo[1]>=limit[1]-totalScrollOffset && d.cbOffsets[0]){_mcs(); o.callbacks.onTotalScroll.call(el[0]);}
							if(_cb("onTotalScrollBack") && scrollTo[1]<=totalScrollBackOffset && d.cbOffsets[1]){_mcs(); o.callbacks.onTotalScrollBack.call(el[0]);}
							d.tweenRunning=false;
							mCSB_container[0].idleTimer=0;
							_onDragClasses(mCSB_dragger,"hide");
						},t);
					}
				}
			});
			/* checks if callback function exists */
			function _cb(cb){
				return d && o.callbacks[cb] && typeof o.callbacks[cb]==="function";
			}
			/* checks whether callback offsets always trigger */
			function _cbOffsets(){
				return [o.callbacks.alwaysTriggerOffsets || contentPos>=limit[0]+tso,o.callbacks.alwaysTriggerOffsets || contentPos<=-tsbo];
			}
			/*
			populates object with useful values for the user
			values:
				content: this.mcs.content
				content top position: this.mcs.top
				content left position: this.mcs.left
				dragger top position: this.mcs.draggerTop
				dragger left position: this.mcs.draggerLeft
				scrolling y percentage: this.mcs.topPct
				scrolling x percentage: this.mcs.leftPct
				scrolling direction: this.mcs.direction
			*/
			function _mcs(){
				var cp=[mCSB_container[0].offsetTop,mCSB_container[0].offsetLeft], /* content position */
					dp=[mCSB_dragger[0].offsetTop,mCSB_dragger[0].offsetLeft], /* dragger position */
					cl=[mCSB_container.outerHeight(false),mCSB_container.outerWidth(false)], /* content length */
					pl=[mCustomScrollBox.height(),mCustomScrollBox.width()]; /* content parent length */
				el[0].mcs={
					content:mCSB_container, /* original content wrapper as jquery object */
					top:cp[0],left:cp[1],draggerTop:dp[0],draggerLeft:dp[1],
					topPct:Math.round((100*Math.abs(cp[0]))/(Math.abs(cl[0])-pl[0])),leftPct:Math.round((100*Math.abs(cp[1]))/(Math.abs(cl[1])-pl[1])),
					direction:options.dir
				};
				/*
				this refers to the original element containing the scrollbar(s)
				usage: this.mcs.top, this.mcs.leftPct etc.
				*/
			}
		},
		/* -------------------- */


		/*
		CUSTOM JAVASCRIPT ANIMATION TWEEN
		Lighter and faster than jquery animate() and css transitions
		Animates top/left properties and includes easings
		*/
		_tweenTo=function(el,prop,to,duration,easing,overwrite,callbacks){
			if(!el._mTween){el._mTween={top:{},left:{}};}
			var callbacks=callbacks || {},
				onStart=callbacks.onStart || function(){},onUpdate=callbacks.onUpdate || function(){},onComplete=callbacks.onComplete || function(){},
				startTime=_getTime(),_delay,progress=0,from=el.offsetTop,elStyle=el.style,_request,tobj=el._mTween[prop];
			if(prop==="left"){from=el.offsetLeft;}
			var diff=to-from;
			tobj.stop=0;
			if(overwrite!=="none"){_cancelTween();}
			_startTween();
			function _step(){
				if(tobj.stop){return;}
				if(!progress){onStart.call();}
				progress=_getTime()-startTime;
				_tween();
				if(progress>=tobj.time){
					tobj.time=(progress>tobj.time) ? progress+_delay-(progress-tobj.time) : progress+_delay-1;
					if(tobj.time<progress+1){tobj.time=progress+1;}
				}
				if(tobj.time<duration){tobj.id=_request(_step);}else{onComplete.call();}
			}
			function _tween(){
				if(duration>0){
					tobj.currVal=_ease(tobj.time,from,diff,duration,easing);
					elStyle[prop]=Math.round(tobj.currVal)+"px";
				}else{
					elStyle[prop]=to+"px";
				}
				onUpdate.call();
			}
			function _startTween(){
				_delay=1000/60;
				tobj.time=progress+_delay;
				_request=(!window.requestAnimationFrame) ? function(f){_tween(); return setTimeout(f,0.01);} : window.requestAnimationFrame;
				tobj.id=_request(_step);
			}
			function _cancelTween(){
				if(tobj.id==null){return;}
				if(!window.requestAnimationFrame){clearTimeout(tobj.id);
				}else{window.cancelAnimationFrame(tobj.id);}
				tobj.id=null;
			}
			function _ease(t,b,c,d,type){
				switch(type){
					case "linear": case "mcsLinear":
						return c*t/d + b;
						break;
					case "mcsLinearOut":
						t/=d; t--; return c * Math.sqrt(1 - t*t) + b;
						break;
					case "easeInOutSmooth":
						t/=d/2;
						if(t<1) return c/2*t*t + b;
						t--;
						return -c/2 * (t*(t-2) - 1) + b;
						break;
					case "easeInOutStrong":
						t/=d/2;
						if(t<1) return c/2 * Math.pow( 2, 10 * (t - 1) ) + b;
						t--;
						return c/2 * ( -Math.pow( 2, -10 * t) + 2 ) + b;
						break;
					case "easeInOut": case "mcsEaseInOut":
						t/=d/2;
						if(t<1) return c/2*t*t*t + b;
						t-=2;
						return c/2*(t*t*t + 2) + b;
						break;
					case "easeOutSmooth":
						t/=d; t--;
						return -c * (t*t*t*t - 1) + b;
						break;
					case "easeOutStrong":
						return c * ( -Math.pow( 2, -10 * t/d ) + 1 ) + b;
						break;
					case "easeOut": case "mcsEaseOut": default:
						var ts=(t/=d)*t,tc=ts*t;
						return b+c*(0.499999999999997*tc*ts + -2.5*ts*ts + 5.5*tc + -6.5*ts + 4*t);
				}
			}
		},
		/* -------------------- */


		/* returns current time */
		_getTime=function(){
			if(window.performance && window.performance.now){
				return window.performance.now();
			}else{
				if(window.performance && window.performance.webkitNow){
					return window.performance.webkitNow();
				}else{
					if(Date.now){return Date.now();}else{return new Date().getTime();}
				}
			}
		},
		/* -------------------- */


		/* stops a tween */
		_stopTween=function(){
			var el=this;
			if(!el._mTween){el._mTween={top:{},left:{}};}
			var props=["top","left"];
			for(var i=0; i<props.length; i++){
				var prop=props[i];
				if(el._mTween[prop].id){
					if(!window.requestAnimationFrame){clearTimeout(el._mTween[prop].id);
					}else{window.cancelAnimationFrame(el._mTween[prop].id);}
					el._mTween[prop].id=null;
					el._mTween[prop].stop=1;
				}
			}
		},
		/* -------------------- */


		/* deletes a property (avoiding the exception thrown by IE) */
		_delete=function(c,m){
			try{delete c[m];}catch(e){c[m]=null;}
		},
		/* -------------------- */


		/* detects left mouse button */
		_mouseBtnLeft=function(e){
			return !(e.which && e.which!==1);
		},
		/* -------------------- */


		/* detects if pointer type event is touch */
		_pointerTouch=function(e){
			var t=e.originalEvent.pointerType;
			return !(t && t!=="touch" && t!==2);
		},
		/* -------------------- */


		/* checks if value is numeric */
		_isNumeric=function(val){
			return !isNaN(parseFloat(val)) && isFinite(val);
		},
		/* -------------------- */


		/* returns element position according to content */
		_childPos=function(el){
			var p=el.parents(".mCSB_container");
			return [el.offset().top-p.offset().top,el.offset().left-p.offset().left];
		},
		/* -------------------- */


		/* checks if browser tab is hidden/inactive via Page Visibility API */
		_isTabHidden=function(){
			var prop=_getHiddenProp();
			if(!prop) return false;
			return document[prop];
			function _getHiddenProp(){
				var pfx=["webkit","moz","ms","o"];
				if("hidden" in document) return "hidden"; //natively supported
				for(var i=0; i<pfx.length; i++){ //prefixed
				    if((pfx[i]+"Hidden") in document)
				        return pfx[i]+"Hidden";
				}
				return null; //not supported
			}
		};
		/* -------------------- */





	/*
	----------------------------------------
	PLUGIN SETUP
	----------------------------------------
	*/

	/* plugin constructor functions */
	$.fn[pluginNS]=function(method){ /* usage: $(selector).mCustomScrollbar(); */
		if(methods[method]){
			return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
		}else if(typeof method==="object" || !method){
			return methods.init.apply(this,arguments);
		}else{
			$.error("Method "+method+" does not exist");
		}
	};
	$[pluginNS]=function(method){ /* usage: $.mCustomScrollbar(); */
		if(methods[method]){
			return methods[method].apply(this,Array.prototype.slice.call(arguments,1));
		}else if(typeof method==="object" || !method){
			return methods.init.apply(this,arguments);
		}else{
			$.error("Method "+method+" does not exist");
		}
	};

	/*
	allow setting plugin default options.
	usage: $.mCustomScrollbar.defaults.scrollInertia=500;
	to apply any changed default options on default selectors (below), use inside document ready fn
	e.g.: $(document).ready(function(){ $.mCustomScrollbar.defaults.scrollInertia=500; });
	*/
	$[pluginNS].defaults=defaults;

	/*
	add window object (window.mCustomScrollbar)
	usage: if(window.mCustomScrollbar){console.log("custom scrollbar plugin loaded");}
	*/
	window[pluginNS]=true;

	$(window).bind("load",function(){

		$(defaultSelector)[pluginNS](); /* add scrollbars automatically on default selector */

		/* extend jQuery expressions */
		$.extend($.expr[":"],{
			/* checks if element is within scrollable viewport */
			mcsInView:$.expr[":"].mcsInView || function(el){
				var $el=$(el),content=$el.parents(".mCSB_container"),wrapper,cPos;
				if(!content.length){return;}
				wrapper=content.parent();
				cPos=[content[0].offsetTop,content[0].offsetLeft];
				return 	cPos[0]+_childPos($el)[0]>=0 && cPos[0]+_childPos($el)[0]<wrapper.height()-$el.outerHeight(false) &&
						cPos[1]+_childPos($el)[1]>=0 && cPos[1]+_childPos($el)[1]<wrapper.width()-$el.outerWidth(false);
			},
			/* checks if element or part of element is in view of scrollable viewport */
			mcsInSight:$.expr[":"].mcsInSight || function(el,i,m){
				var $el=$(el),elD,content=$el.parents(".mCSB_container"),wrapperView,pos,wrapperViewPct,
					pctVals=m[3]==="exact" ? [[1,0],[1,0]] : [[0.9,0.1],[0.6,0.4]];
				if(!content.length){return;}
				elD=[$el.outerHeight(false),$el.outerWidth(false)];
				pos=[content[0].offsetTop+_childPos($el)[0],content[0].offsetLeft+_childPos($el)[1]];
				wrapperView=[content.parent()[0].offsetHeight,content.parent()[0].offsetWidth];
				wrapperViewPct=[elD[0]<wrapperView[0] ? pctVals[0] : pctVals[1],elD[1]<wrapperView[1] ? pctVals[0] : pctVals[1]];
				return 	pos[0]-(wrapperView[0]*wrapperViewPct[0][0])<0 && pos[0]+elD[0]-(wrapperView[0]*wrapperViewPct[0][1])>=0 &&
						pos[1]-(wrapperView[1]*wrapperViewPct[1][0])<0 && pos[1]+elD[1]-(wrapperView[1]*wrapperViewPct[1][1])>=0;
			},
			/* checks if element is overflowed having visible scrollbar(s) */
			mcsOverflow:$.expr[":"].mcsOverflow || function(el){
				var d=$(el).data(pluginPfx);
				if(!d){return;}
				return d.overflowed[0] || d.overflowed[1];
			}
		});

	});

}))}));

(function() {
    "use strict";
    EmailCollectionController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', '$timeout', 'MAIN', 'LoginAPISrv', 'postApi', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', 'Auth'];
  
    /** @ngInject */
    function EmailCollectionController($scope, $log, $state, $filter, $cookies, $rootScope, $timeout, MAIN, loginApi, postApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth) {
      var vm = this;
      vm.user = {};
      vm.loginInfo = {};
  
     
    }
  
    webapp.component("emailCollection", {
      transclude: true,
      bindings: {},
      controller: EmailCollectionController,
      controllerAs: "emailCollection",
      templateUrl: "components/emailCollection/emailCollection.html"
    });
  })();
  
webapp.service('LoginAPISrv', [ '$resource', '$rootScope', 'StaticVariable', function LoginAPISrv($resource, $rootScope, StaticVariable) {
  var loginApi = {
    doLogin : function(obj) {
      return $resource(StaticVariable.getUrl('/login/login.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doLogout : function(obj) {
      return $resource(StaticVariable.getUrl('/login/logout.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
    doCustomerLogin : function(obj) {
      return $resource(StaticVariable.getUrl('/login/loginCustomer.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doCheckSession : function(obj) {
      return $resource(StaticVariable.getUrl('/login/checkSession.json'), {userkey:$rootScope.gVariable.userKey}, StaticVariable.getRequestActions.defaultAction());
    },
    doPersonal_IdSrch : function(obj) {
      return $resource(StaticVariable.getUrl('/login/personal_IdSrch.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doCompany_IdSrch : function(obj) {
      return $resource(StaticVariable.getUrl('/login/company_IdSrch.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doPersonal_PwSrch : function(obj) {
      return $resource(StaticVariable.getUrl('/login/personal_PwSrch.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doCompany_PwSrch : function(obj) {
      return $resource(StaticVariable.getUrl('/login/company_PwSrch.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doResetPassword : function() {
      return $resource(StaticVariable.getUrl('/login/resetPassword.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doSaveResetPwAutoMail : function() {
      return $resource(StaticVariable.getUrl('/login/insertAutoMail.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doCreateUser : function(obj) {
      return $resource(StaticVariable.getUrl('/login/signupUser.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doCheckLoginId : function(obj) {
      return $resource(StaticVariable.getUrl('/login/checkLoginId.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doMetaColumns : function(obj) {
      return $resource(StaticVariable.getUrl('/login/getMetaColumns.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doGetTenant : function(obj) {
      return $resource(StaticVariable.getUrl('/login/getTenant.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doGetPopup : function(obj) {
      return $resource(StaticVariable.getUrl('/login/getPopup.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
  };
  return loginApi;
} ]);

(function () {
    'use strict';
    LoginFooterController.$inject = ['$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'gAlert', '$window', 'StaticVariable', 'Auth', 'modalFactory', '$scope'];
  
    /** @ngInject */
    function LoginFooterController($log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, gAlert, $window, StaticVariable, Auth, modalFactory, $scope) {
      var vm = this;
    }

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */
    var loginFooter = {
      transclude: true,
      controller: LoginFooterController,
      bindings: {},
      controllerAs: "loginFooter",
      templateUrl: 'components/login/login-footer.html'
    };
  
    webapp.component("loginFooter", loginFooter);
  })();
  
  
(function () {
    'use strict';
    LoginHeaderController.$inject = ['$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'gAlert', '$window', 'StaticVariable', 'Auth', 'modalFactory', '$scope' ,'postApi'];
  
    /** @ngInject */
    function LoginHeaderController($log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, gAlert, $window, StaticVariable, Auth, modalFactory, $scope, postApi) {
      var vm = this;
      vm.title = $window.sessionStorage['loginTitle'];
      vm.url = $window.sessionStorage['loginUrl'];

      vm.stateName = $state.current.name;

      $rootScope.$on("$stateChangeSuccess", function(event, toState) {
        vm.stateName = toState.name;
      });
      
      

      vm.showNoticeDetail = function(BbsPostId) {
        var data = {tableNm:'board.notice', BbsPostId:BbsPostId, selectType:'Detail', TenantId:0};

        var prms = postApi.sendPostApi('openapi/board', 'getDetail', data, function (result) {
          if (result && result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docCnt > 0) {
              var item = result.body.docs[0];

              var ctrl = 'ContentsModalCtrl as modalCtrl';
              var paramData = { Contents:item.Contents, Title:item.Title, VideoLink:item.ExtVarchar01};
              var modalInstance = modalFactory.open('lg', 'components/modal/contents/contents-modal.html', ctrl, paramData);
            }
          } else {

          }
        }, function(error) {
          gAlert('', error);
          console.error('fail', status);
        });
      };

      vm.downloadFile = function (type) {
        window.location.href = "/assets/download/이랜드복지재단_SOS위고_신청및결과보고.hwpx";
      };
    }

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */
    var loginHeader = {
      transclude: true,
      controller: LoginHeaderController,
      bindings: {},
      controllerAs: "loginHeader",
      templateUrl: 'components/login/login-header.html'
    };
  
    webapp.component("loginHeader", loginHeader);
  })();
  
  
(function() {
  "use strict";
  LoginController.$inject = 
  ['$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'gAlert', 'modalFactory', 'Auth', 'autoPage', '$stateParams', '$scope', 'postApi', '$window', 'StaticVariable'];

  /** @ngInject */
  function LoginController($log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, gAlert, modalFactory, Auth, autoPage,  $stateParams, $scope, postApi, $window, StaticVariable) {
    var vm = this;
    vm.user = {};
    vm.loginInfo = {};

    vm.registeredpost = {};

    var pageData = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope
    };
    
    // 로그인 헤더 버튼 설정
    $window.sessionStorage['loginTitle'] = '회원가입';
    $window.sessionStorage['loginUrl'] = 'signupTenant';

    vm.stateName = $state.current.name;
    $(".szPopup_box").css("display", "block");

    $rootScope.$on("$stateChangeSuccess", function(event, toState) {
      vm.stateName = toState.name;
    });

    if($cookies.get('mySavedId') != undefined) {
      vm.loginInfo.loginId = $cookies.get('mySavedId');
      vm.loginInfo.saveId = '1';
    }

    var translate = $filter("translate");
    vm.language = $rootScope.currentLanguage;
    vm.placeholder = {
      id: translate("LOGIN.LABEL.ID"),
      pw: translate("LOGIN.LABEL.PW")
    };

    vm.findIdPwd = findIdPwd;
    vm.doLogin = doLogin;
    vm.onChangeHandler = onChangeHandler;
    vm.doGetPopup = doGetPopup;

    // 팝업조회
    vm.popLink = {};
    function doGetPopup(){
      var param = { loginYN : 'N' };
      var prms = loginApi.doGetPopup().post(param).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          if (data.responseVO.body.docCnt > 0) {
            vm.popLink = data.responseVO.body.docs[0];
            vm.popLink.ImgSrc = StaticVariable.getUrl("/openapi/attach/" + vm.popLink.PhysicalPath + "/" + vm.popLink.PhysicalFileNm + "/download.do");
            if(isNullOrEmpty(vm.popLink) || isNullOrEmpty(vm.popLink.ImgSrc)){
              chkCookie(true);
            } else {
              chkCookie(false, vm.popLink.ImgW, vm.popLink.ImgH);
            }
          }
          else{            
            chkCookie(true);
          }
        } 
        else {
          chkCookie(true);
        }
      }, function (error) {
        console.error("Error> doGetPopup()");
        console.table(error);
      });
    }
    
    doGetPopup();

    function doLogin() {
      vm.appName = MAIN.APP_NAME;

      var prms = loginApi.doLogin().post(vm.loginInfo).$promise;
      prms.then(function(data) {
        if (data && data.responseVO && data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
          if (data.responseVO.body.docCnt > 0) {
            $(".n-login-box").css("display","none");
            $(".blockBg").css("display","none");
            $("body").css("overflow","auto");            
            setUserSession(vm, data);
            $state.go(data.responseVO.body.docs[0].mainpage, { srch: '' });
          } else {
            gAlert('', 'Menu.INVALIEDIDPASSWORD');
          }
        } else {
          if(data.responseVO && data.responseVO.body.docs.length > 0 && data.responseVO.body.docs[0].checkApproval == "N") {
            gAlert('', data.responseVO.body.docs[0].MSG, {
              btn: '확인', fn: function () { }
            });
          } else {
            gAlert('', '로그인에 실패하였습니다. 다시 시도하여주세요.', {
              btn: '확인', fn: function () { }
            });
          }
        }
      }, function(error) {
        gAlert('', error);
        console.error('fail', status);
      });

      //$log.info("account::", vm.loginInfo.account);
      //$log.info("secureCode::", vm.loginInfo.secureCode);
      // $state.go("app.dashboard");
    }    

    function onChangeHandler() {
      console.log('language=', vm.language);
      $rootScope.changeLanguage(vm.language);
    }

    function setUserSession(vm, json) {
      if (vm.loginInfo.saveId == '1') {
        var now = new Date();
        var cookieExp = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());

        $cookies.put('mySavedId', vm.loginInfo.loginId);

      } else {
        $cookies.remove('mySavedId');
      }

      $rootScope.setUserSession(json.responseVO.body.docs[0]);

      Auth.init(json.responseVO.body.docs[0].permissions);
    }

    function findIdPwd(type){
      var ctrl = 'FindIdPwdModalCtrl as modalCtrl';
      var paramData = { type : type };
      var modalInstance = modalFactory.open('modal', 'components/modal/findIdPwd/findIdPwd-modal.html', ctrl, paramData);
    }

    vm.openPopLogin = function() {
      $(".n-login-box").css("display","block");
      $(".blockBg").css("display","block");
      $("body").css("overflow","hidden");
    };

    vm.cancelPopLogin = function() {
      $(".n-login-box").css("display","none");
      $(".blockBg").css("display","none");
      $("body").css("overflow","auto");
    };


    vm.setRegisteredpost = function() {

      console.log(vm.registeredpost)
      if(isNullOrEmpty(vm.registeredpost.RegName)) {
        ap.alert("이름을 입력하세요.");
        return;
      }

      if(isNullOrEmpty(vm.registeredpost.Mobile)) {
        ap.alert("연락처를 입력하세요.");
        return;
      }

      if(isNullOrEmpty(vm.registeredpost.Email)) {
        ap.alert("이메일을 입력하세요.");
        return;
      }

      vm.registeredpost.mapCode = "setRegisteredpost";

      ap.confirm("문의를 등록하시겠습니까?", function(){

        postApi.login(vm.registeredpost, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.registeredpost.RegName = '';
            vm.registeredpost.Company = '';
            vm.registeredpost.Mobile = '';
            vm.registeredpost.Email = '';
            vm.registeredpost.Content = '';
            ap.alert("등록되었습니다.");
          }
        });
      });
    };
    
    vm.autoLogin = function(loginId) {
      vm.loginInfo.loginId = loginId;
      vm.loginInfo.loginPw = '1234'; 
      
      doLogin();
    };

    function chkCookie(isNone, w, h) {
      try {  
        if(isNone){
          $(".szPopup_box").css("display", "none");
          $(".szPopup_overlay").css("display", "none");
          $("body").removeClass("popup-open");
        } else if(document.cookie.indexOf("szPopup_box" + "=close") < 0 ) {      // 쿠키 저장여부 체크
          $(".szPopup_box").css("display", "flex");
          // $(".szPopup_box").css("width", w);
          // $(".szPopup_box").css("height", h);
          $("body").addClass("popup-open");
          $(".szPopup_overlay").css("display", "block");
        } else {
          $(".szPopup_box").css("display", "none");
          $(".szPopup_overlay").css("display", "none");
          $("body").removeClass("popup-open");
        }  
      } catch (e) {
        console.log("Error Popup > " + e);    
      }    
    }

    // 팝업 쿠키 생성
    function fnSetCookie( name, value, expiredays ) {  // 쿠키저장
      var todayDate = new Date();  //date객체 생성 후 변수에 저장
      todayDate.setDate( todayDate.getDate() + expiredays ); 
        
      // 시간지정(현재시간 + 지정시간)
      document.cookie = name + "=" + value + "; path=/; expires=" + todayDate.toUTCString() + ";";
    } 
                
    // 팝업 오늘하루만보기 
    vm.closePopupToday = function() { 
      fnSetCookie("szPopup_box", "close" , 1);
      vm.closePopup();
    };

    // 팝업 닫기
    vm.closePopup = function() {
      $(".szPopup_box").css("display", "none");
      $(".szPopup_overlay").css("display", "none");
      $("body").removeClass("popup-open");
    };

    vm.getInitDataExt = function() {};

    vm.goNotice = function() {
      $state.go('login.notice', {srch : '',});
    };

    function getBoardList(type) {

      var data = {
        page: 1,
        viewSize: 5,
        tableNm: "board." + type
      };

      var prms = postApi.sendPostApi('openapi/board', 'getList', data, function (result) {
        //console.log(result);
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            switch(type){
              case "notice" : vm.noticeList = result.body.docs; break;
              case "faq" : vm.faqList = result.body.docs; break;
            }
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.error('fail', status);
      });
    }  

    vm.showDetail = function(BbsPostId, type) {
      var data = {
        tableNm: "board." + type, 
        BbsPostId: BbsPostId, 
        selectType: 'Detail', 
        uploadFileList:[],        
        IdName: 'BbsPostId'
      };

      var prms = postApi.sendPostApi('openapi/board', 'getDetail', data, function (result) {
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            var item = result.body.docs[0];

            var uploadFileList = [];
            angular.forEach(item.uploadFileList, function(f) {
              var obj = {
                id : f.fileId,
                link : StaticVariable.getUrl("/openapi/attach/" + f.PhysicalPath + "/" + f.PhysicalFileNm + "/download.do"),
                fileName : f.LogicalFileNm,
                size : f.FileSize,
              };
              uploadFileList.push(obj);
            });

            var ctrl = 'ContentsModalCtrl as modalCtrl';
            var paramData = { Contents:item.Contents, Title:item.Title, VideoLink:item.ExtVarchar01, FileList:uploadFileList};
            var modalInstance = modalFactory.open('lg', 'components/modal/contents/contents-modal.html', ctrl, paramData);
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.error('fail', status);
      });
    };
    
    var ap = new autoPage();
    ap.setData(pageData);
    ap.init();    

    getBoardList("notice");
    getBoardList("faq");
  }

  webapp.component("login", {
    transclude: true,
    bindings: {},
    controller: LoginController,
    controllerAs: "login",
    templateUrl: "components/login/login.html"
  });

  /* swiper */
  window.onload = function () {
    new Swiper('.swiper-container', {
      loop: true,
      autoplay: {
        delay: 3000,
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  };  
})();

(function() {
  "use strict";
  LogoutController.$inject = ['$window', '$state', 'StaticVariable', 'LoginAPISrv', 'gAlert'];

  /** @ngInject */
  function LogoutController($window, $state, StaticVariable, loginApi, gAlert) {
    var vm = this;
    vm.user = {};
    vm.loginInfo = {};

    vm.doLogout = doLogout;

    function doLogout() {
      StaticVariable.sessionExpire();
      var prms = loginApi.doLogout().post().$promise;
      prms.then(function(json) {
        var temp = {};
        temp.layoutBoard = "N";
        $window.sessionStorage.clear();
        $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
        gAlert('', 'Menu.SIGNEDOUT', {
          btn : '',
          fn : function() {
            //$window.location.replace('/' + CONSTANT.URL.CONTEXT);
            //$state.reload('main.login');
            $state.go('login');
          }
        });
      }, function(error) {
        console.error('fail', status);
      });
    }

    doLogout();

  }

  webapp.component("logout", {
    transclude: true,
    bindings: {},
    controller: LogoutController,
  });
})();

(function() {
    "use strict";
    SignupFirstController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'StaticVariable', 'gAlert', 'gConfirm', '$window', '$translate', '$stateParams', 'customFieldApi','postApi', 'fileUploadService', '$timeout'];
  
    /** @ngInject */
    function SignupFirstController($scope, $log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, StaticVariable, gAlert, gConfirm, $window, $translate, $stateParams, customFieldApi, postApi, fileUploadService, $timeout) {
      var vm = this;
      vm.data = {};
      vm.srch = decodeURIComponent($stateParams.srch);

      vm.signUpTenant = function (data) { 
          if (data =='N') {
            if(vm.data.agreeYN_1 == 'Y' && vm.data.agreeYN_2 == 'Y' && vm.data.agreeYN_3 == 'Y') {
              $state.go("signupSecond", {srch:vm.srch});
            } else {
              alert("회원가입을 위해 약관에 동의해주세요.");
            }
          } else if (data =='C'){
            $state.go("login");
          }
      };

      vm.agreeAll = function () {
        if(vm.data.agreeYN == 'N') {
          vm.data.agreeYN_1 = 'N';
          vm.data.agreeYN_2 = 'N';
          vm.data.agreeYN_3 = 'N';
        } else {
          vm.data.agreeYN_1 = 'Y';
          vm.data.agreeYN_2 = 'Y';
          vm.data.agreeYN_3 = 'Y';
        }
      };
    }
    

    webapp.component("signupFirst", {
      transclude: true,
      bindings: {},
      controller: SignupFirstController,
      controllerAs: "vc",
      templateUrl: "components/login/signup-first-step.html"
    });
  })();
  
(function() {
  "use strict";
  SignupSecondController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'StaticVariable', 'gAlert', 'gConfirm', '$window', '$translate', '$stateParams', 'customFieldApi','postApi', 'fileUploadService', '$timeout'];

  /** @ngInject */
  function SignupSecondController($scope, $log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, StaticVariable, gAlert, gConfirm, $window, $translate, $stateParams, customFieldApi, postApi, fileUploadService, $timeout) {
    var vm = this;
    vm.data = {};
    vm.srch = decodeURIComponent($stateParams.srch);
    vm.TenantType = vm.srch;
    vm.loginIdDisYN = 'N';
    vm.authYN = false;
    vm.etcList = [];
    vm.interestList = [];
    // SQL Mapper Id 정의
    var GET_LOGID_DUP_SQL =        'getLoginIdDup';                     // 로그인 아이디 중복 체크
    var GET_ORG_SQL =              'getOrganizationList';               // 기관구분 목록 조회 SQL
    var GET_ORG_SUB_SQL =          'getOrganizationSubList';            // 기관구분 서브 목록 조회 SQL
    var GET_INT_FAM_SQL =          'getTenantInterestFamillyList';      // 관심대상가정 목록 조회 SQL
    var GET_APP_SQL =              'getAppPathList';                    // 사업신청경로 목록 조회
    var GET_TENANT_INT_SQL =       'getTenantInterestList';             // 관심설정 목록 조회
    var CHK_BIZNO_MOB_EMAIL_SQL =  'checkDupBizNoMobileEmailCnt';       // 담당자 휴대폰 번호 및 이메일 중복체크 SQL
    var INSERT_TENANT_SQL =        'insertTenant';                      // 기관 등록
    
    var type = '';

    // 가입구분
    if (vm.srch == 'G') {
      vm.data.MenuTypeList = [{codeValue : '후원기관', code: 'GIVETENANT'}];
      type = 'GIVETENANT';
    } else if (vm.srch == 'T') {
      vm.data.MenuTypeList = [{codeValue : '사례관리기관', code: 'TAKETENANT'}];
      type = 'TAKETENANT';
    }
     
    //#region Select List Setting (EmailList, monthList, dayList, yearList)
    // 월 목록
    vm.monthList = [
      {month: '1', value: '01'},
      {month: '2', value: '02'},
      {month: '3', value: '03'},
      {month: '4', value: '04'},
      {month: '5', value: '05'},
      {month: '6', value: '06'},
      {month: '7', value: '07'},
      {month: '8', value: '08'},
      {month: '9', value: '09'},
      {month: '10', value: '10'},
      {month: '11', value: '11'},
      {month: '12', value: '12'}
    ];
    // 일 목록
    vm.dayList = [
      {day: '1', value: '01'},
      {day: '2', value: '02'},
      {day: '3', value: '03'},
      {day: '4', value: '04'},
      {day: '5', value: '05'},
      {day: '6', value: '06'},
      {day: '7', value: '07'},
      {day: '8', value: '08'},
      {day: '9', value: '09'},
      {day: '10', value: '10'},
      {day: '11', value: '11'},
      {day: '12', value: '12'},
      {day: '13', value: '13'},
      {day: '14', value: '14'},
      {day: '15', value: '15'},
      {day: '16', value: '16'},
      {day: '17', value: '17'},
      {day: '18', value: '18'},
      {day: '19', value: '19'},
      {day: '20', value: '20'},
      {day: '21', value: '21'},
      {day: '22', value: '22'},
      {day: '23', value: '23'},
      {day: '24', value: '24'},
      {day: '25', value: '25'},
      {day: '26', value: '26'},
      {day: '27', value: '27'},
      {day: '28', value: '28'},
      {day: '29', value: '29'},
      {day: '30', value: '30'},
      {day: '31', value: '31'}        
    ];
    // 년 목록
    vm.yearList = [];
    var d = new Date();
    var week      = d.getDay();
    var date  = new Date(d.getTime() - (week * 24 * 60 * 60 * 1000));

    var date_year  = date.getFullYear();
    for (var i = 0; i<100; i++ ) {
      vm.yearList.push({year : (date_year-i).toString(), value : (date_year-i).toString() });
    }
    //#endregion
    
    //#region srchZipCodeModal 우편번호 검색 팝업 호출
    /**
    * 우편번호 검색 팝업 호출
    *
    * @param {string}
    * @return {boolean}
    */
    vm.srchZipCodeModal = function() {
      new daum.Postcode({
        oncomplete: function(data) {
          $timeout(function(){
                   
            // 시군구 코드
            vm.data.CityCode = data.sigunguCode;
            
            vm.data.ZipCode = data.zonecode;
            var addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
            vm.data.Addr1 = addr1;
          }, 0);
        },
      }).open();
    };
    //#endregion

    //#region signUpTenant 가입신청 및 취소 버튼 클릭
    /**
     *  가입신청 및 취소 버튼 클릭
     *
     * @param 
     * @return
     */
    vm.signUpTenant = function (data) {
      if(data == 'C') {
        $state.go("login");
      } else {
        chkBizNoMobileEmailDup();
      }
    };
    //#endregion

    //#region selectPriority 관심대상 가정 우선순위 지정
    /**
     * 관심대상 가정 우선순위 지정
     *
     * @param 0 ~ 4 (1순위 ~ 5순위)
     * @return
     */
     $scope.selectPriority = function(data) {
      var str = '';
      var code = '';
      str =  $("button[name='interest"+data+"']").text();
      code = $("button[name='interest"+data+"']").attr("data-code");
      if (vm.data.priority0 != str && 
          vm.data.priority1 != str && 
          vm.data.priority2 != str && 
          vm.data.priority3 != str && 
          vm.data.priority4 != str ) {

          if (vm.data.priority0 == '' || vm.data.priority0 == undefined) {
            vm.data.priority0 = str;
            $("#priority0").attr("data-code", code);
          } else if(vm.data.priority1 == '' || vm.data.priority1 == undefined) {
            vm.data.priority1 = str;
            $("#priority1").attr("data-code", code);
          } else if(vm.data.priority2 == '' || vm.data.priority2 == undefined) {
            vm.data.priority2 = str;
            $("#priority2").attr("data-code", code);
          } else if(vm.data.priority3 == '' || vm.data.priority3 == undefined) {
            vm.data.priority3 = str;
            $("#priority3").attr("data-code", code);
          } else if(vm.data.priority4 == '' || vm.data.priority4 == undefined) {
            vm.data.priority4 = str;
            $("#priority4").attr("data-code", code);
          }
      }
    };
    //#endregion

    //#region refreshPriority 관심대상 가정 우선순위 Input 초기화
    /**
     * 관심대상 가정 우선순위 Input 초기화
     *
     * @param 
     * @return
     */
    $scope.refreshPriority = function() {
      vm.data.priority0 = undefined;
      vm.data.priority1 = undefined;
      vm.data.priority2 = undefined;
      vm.data.priority3 = undefined;
      vm.data.priority4 = undefined;
      $("#priority0").attr("data-code", "");
      $("#priority1").attr("data-code", "");
      $("#priority2").attr("data-code", "");
      $("#priority3").attr("data-code", "");
      $("#priority4").attr("data-code", "");
    };
    //#endregion

    //#region chkLoginIdDup 아이디중복 체크
    /**
     * 아이디 중복체크
     *
     * @param
     * @return
     */
    function chkLoginIdDup() {
      var data = angular.copy(vm.data);
      data.mapCode = GET_LOGID_DUP_SQL;

      $("#loginid").css("display", "block");
      if(isNullOrEmpty(vm.data.LoginId)) {
        $("#loginid").css("display", "none");
        return false;
      } else if (!chkPassId('ID')) {
        $("#loginid").removeClass("pass");
        $("#loginid").addClass("not_pass");
        $("#loginid i").removeClass("glyphicon-ok");
        $("#loginid i").addClass("glyphicon-remove");
        $("#loginidTx").text("아이디 형식을 확인해주세요.(영문, 숫자 포함 4~20자 조합해 입력)");
        return false;
      } else {
        postApi.login(data, function(result){
          if(result.body.docs[0].DupCnt > 0) {
            $("#loginid").removeClass("pass");
            $("#loginid").addClass("not_pass");
            $("#loginid i").removeClass("glyphicon-ok");
            $("#loginid i").addClass("glyphicon-remove");    
            $("#loginidTx").text("이미 사용중인 아이디입니다.");
            return false;
          } else {
            $("#loginidTx").text("사용 가능한 아이디입니다.");
            $("#loginid").removeClass("not_pass");
            $("#loginid").addClass("pass");
            $("#loginid i").removeClass("glyphicon-remove");
            $("#loginid i").addClass("glyphicon-ok");
            vm.loginIdDisYN = 'Y';
          }
        });
      }
    }
    //#endregion
    
    //#region chkPassId 아이디/비밀번호 체크
    /**
     * 아이디/비밀번호 체크
     *
     * @param str 'ID' or 'PWD'
     * @return
     */
     function chkPassId(str) {
      if(str == 'PWD') {
        var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_;:<>,.[\]{\}])[A-Za-z\d!@#$%^&*()\-_;:<>,.[\]{\}]+$/g;
        var birthDay = moment(vm.data.BirthDay).format('MMDD');
        var birthDay2 = moment(vm.data.BirthDay).format('YYMMDD');

        if(!reg.test(vm.data.Password)) return false;
        if(vm.data.Password.indexOf(birthDay) > -1) return false;
        if(vm.data.Password.indexOf(birthDay2) > -1) return false;
        if(vm.data.Password.length < 8) return false;

        return true;
      
      } else if (str == 'ID') {      
        var reg1 = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]+$/g;
        
        if( !reg1.test(vm.data.LoginId)) return false;
        if(vm.data.LoginId.length < 4) return false;
        
        return true;
      }
    }
    //#endregion chkPassId 아이디/비밀번호 체크

    //#region getOrganizationList 기관구분 목록 조회
    /**
     * 기관구분 목록 조회
     *
     * @param 
     * @return
     */
    function getOrganizationList() {
      vm.organizationList = [];
      var data = {};
      data.mapCode = GET_ORG_SQL;
      postApi.openApi(data, function(result){
        if(result.body.docs.length > 0) {
          angular.forEach(result.body.docs, function(item){
            vm.organizationList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
          });
        } else {
          vm.yearsList = {};
        }
      });
    }
    //#endregion
    
    //#region getOrganizationSubList 기관구분서브 목록 조회
    /**
     * 기관구분서브 목록 조회
     *
     * @param 
     * @return
     */
    function getOrganizationSubList() {
      vm.organizationSubList = [];
      var data = {};
      data.mapCode = GET_ORG_SUB_SQL;
      postApi.openApi(data, function(result){
        if(result.body.docs.length > 0) {
          angular.forEach(result.body.docs, function(item){
            vm.organizationSubList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
          });
        }
      });
    }
    //#endregion

    //#region getAppPathList 사업신청경로 목록 조회
    /**
     * 사업신청경로 목록 조회
     *
     * @param 
     * @return
     */
    function getAppPathList() {
      vm.appPathList = [];
      var data = {};
      data.mapCode = GET_APP_SQL;
      postApi.openApi(data, function(result){
        if(result.body.docs.length > 0) {
          angular.forEach(result.body.docs, function(item){
            vm.appPathList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
          });
        } else {
          vm.yearsList = {};
        }
      });
    }
    //#endregion

    //#region getInterstFamillyData 관심대상 가정 조회
    /**
     * 관심대상 가정 조회
     *
     * @param 
     * @return
     */
    function getInterestFamillyData() {
      var data = {};
      data.mapCode = GET_INT_FAM_SQL;
      postApi.openApi(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공

          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            console.warn(result.body.docs);
            for (var i=0; i< result.body.docs.length; i++){
              $("button[name='interest"+i+"']").text(result.body.docs[i].CodeValue);
              $("button[name='interest"+i+"']").attr("data-code",result.body.docs[i].Code );
              if(i>4) vm.etcList.push(result.body.docs[i]);
            }
          }
        } else {
          console.error("Error> getInterstFamillyData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }

      }, function (error) {
        console.error("Error> getInterstFamillyData()");
        console.table(error);
      });
    }
    //#endregion

    //#region getInterestData 관심설정 조회
    /**
     * 관심설정 조회
     *
     * @param 
     * @return
     */
    function getInterestData() {
      var data = {};
      data.mapCode = GET_TENANT_INT_SQL;
      postApi.openApi(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            for (var i=0; i< result.body.docs.length; i++){
                vm.interestList.push(result.body.docs[i]);
            }
          }
        } else {
          console.error("Error> getInterstData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }

      }, function (error) {
        console.error("Error> getInterstData()");
        console.table(error);
      });
    }
    //#endregion
    
    //#region saveData 데이터 저장
    /**
     *  데이터 저장
     *
     * @param 
     * @return
     */
    function saveData() {
      var data = angular.copy(vm.data);
      
      // 마케팅 동의 여부 미선택시 'N'으로 저장
      if(data.SmsAgreeYN == undefined) data.SmsAgreeYN = 'N';
      if(data.EmailAgreeYN == undefined) data.EmailAgreeYN = 'N';
      if(data.BaseYN == undefined) data.BaseYN = 'N';
      
      data.ReqURL = 'app.company.company-detail';
      data.tableNm = 'tenant';
      data.TenantStatus = 'R';
      data.RelateDataId = data.KeyId;
      data.MainPage = 'app.dashboard';
      data.priority0 = $("#priority0").attr("data-code");
      data.priority1 = $("#priority1").attr("data-code");
      data.priority2 = $("#priority2").attr("data-code");
      data.priority3 = $("#priority3").attr("data-code");
      data.priority4 = $("#priority4").attr("data-code");
      data.tenantType = vm.TenantType;
      data.mapCode = INSERT_TENANT_SQL;
      
      // 관심대상가정 기타 체크박스 저장
      var etcCount = $(".etcList").children().length-1;
      data.priorityEtc = "";
      for (i=0; i<etcCount; i++) {
        if($(".etcList li input[data-idx="+i+"]").is(":checked") == true) 
          data.priorityEtc += $(".etcList li input[data-idx="+i+"]").attr("data-code")+",";
      }

       // 관심설정 기타 체크박스 저장
       var interestCount = $(".interestList").children().length-1;
       data.interest = "";
       for (i=0; i<interestCount; i++) {
         if($(".interestList li input[data-idx="+i+"]").is(":checked") == true) 
           data.interest += $(".interestList li input[data-idx="+i+"]").attr("data-code")+",";
       }
       
      data.interest = data.interest.substring(0,data.interest.length-1);
      postApi.login(data, function(result){
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          gAlert('','승인요청되었습니다. <br>회원가입 -> 정보 입력 -> 조회 버튼으로 내용 확인 가능합니다.', {
            btn : '',
            fn : function() {
              $state.go('login');
            }
          });
        }
      }, function(error) {
        console.error('fail', status, data);
      });
    }
    //#endregion

    //#region getIsValidData Validation Check
    /**
     *  Validation Check
     *
     * @param 
     * @return
     */
    function getIsValidData() {
      var data = angular.copy(vm.data);
      var errMsg = '';
      
      // 로그인 정보 Validation Check
      if(isNullOrEmpty(data.LoginId)) {
        errMsg = errMsg + '- 아이디를 입력하세요.<br/>';
      }
      if(vm.loginIdDisYN == 'N') {
        errMsg = errMsg + '- 아이디 중복확인을 해주세요.<br/>';
      }
      if(isNullOrEmpty(data.Password)) {
        errMsg = errMsg + '- 비밀번호를 입력하세요.<br/>';
      }
      if(data.Password != data.Password2) {
        errMsg = errMsg + '- 비밀번호가 일치하지 않습니다.<br/>';
      }
      if (!isNullOrEmpty(data.Password)){
        if (!chkPassId('PWD'))
        errMsg = errMsg + '- 비밀번호 형식을 확인해주세요.<br/>';
      }

      // 기관 정보 Validation Check
      if(isNullOrEmpty(data.TenantNm)) {
        errMsg = errMsg + '- 기관명을 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.Ceo)) {
        errMsg = errMsg + '- 대표자명을 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.BizRegNo)) {
        errMsg = errMsg + '- 사업자등록번호를 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.Email1)) {
        errMsg = errMsg + '- 대표 이메일을 입력하세요.<br/>';
      } else {
        vm.data.TenantEmail = data.Email1;
      }
      if(isNullOrEmpty(data.TelNo)) {
        errMsg = errMsg + '- 대표 전화번호를 입력하세요.<br/>';
      }

      if (isNullOrEmpty(data.organization_code)) {
        errMsg = errMsg + '- 기관구분을 입력하십시오.<br/>';     
      } else if (data.organization_code != 57) {
        vm.data.Organization = vm.data.organization_code;
        vm.data.OrganizationSub = "";
      } else {
        if(isNullOrEmpty(data.organizationSub_code)) {
          errMsg = errMsg + '- 기관구분을 입력하십시오.<br/>';     
        } else {
          vm.data.Organization = vm.data.organization_code;
          vm.data.OrganizationSub = vm.data.organizationSub_code;
        } 
      }  

      if(isNullOrEmpty(data.ZipCode) || isNullOrEmpty(data.Addr1) || isNullOrEmpty(data.Addr2)) {
        errMsg = errMsg + '- 주소를 입력하세요.<br/>';
      }
      
      // 담당자 정보 Validation Check
      if(isNullOrEmpty(data.Mobile)) {
        errMsg = errMsg + '- 담당자 휴대폰 번호를 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.UserNm)) {
        errMsg = errMsg + '- 담당자 이름을 입력하세요.<br/>';
      }
      if(isNullOrEmpty(data.Email3)) {
        errMsg = errMsg + '- 담당자 이메일을 입력하세요.<br/>';
      } else {
        vm.data.UserEmail = data.Email3 ;
      } 

      // 본인인증
      if(vm.authYN == false) {
        errMsg = errMsg + '- 담당자 본인인증을 완료해주세요.<br/>';
      }
      
      if(vm.TenantType == 'T') {
        if (isNullOrEmpty(data.AppPath)) {
          errMsg = errMsg + '- 사업신청경로를 입력하십시오.<br/>';     
        }
      }

      // 2021.04.21 필수항목 제외
      /* if(isNullOrEmpty(data.Fax)) {
        errMsg = errMsg + '- FaX번호를 입력하세요.<br/>';
      } 
      
      if(isNullOrEmpty(data.Year) || isNullOrEmpty(data.Month) || isNullOrEmpty(data.Day)) {
        errMsg = errMsg + '- 설립년월일을 입력하세요.<br/>';
      } else {
        vm.data.BusinessYear = data.Year +"-"+ data.Month +"-"+ data.Day;
      } */

      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }

      saveData();
      
    }
    //#endregion
    
    //#region 본인인증
    /**
     *  본인인증 시작
     *
     * @param 
     * @return
     */
    vm.authMob = function(){
      
      // 이미 인증완료했을 시 return
      if (vm.authYN) {
        return;
      }
      
      //#region 입력 값 Validation Check
      if(isNullOrEmpty(vm.data.UserNm)) {
        gAlert('', '담당자 이름을 입력하세요.'); 
        return true;
      }    
      if(isNullOrEmpty(vm.data.Mobile)) {
        gAlert('', '휴대폰 번호를 입력하세요.');
        return true;
      }
      //#endregion 입력 값 Validation Check
      
      var mob = vm.data.Mobile;
      var result = mob.replaceAll('-', '').replaceAll(' ', '');
      var regExp = /^[0-9-]{10,11}$/;

      // 휴대폰번호 중복체크 로직
      var mobileData = {};
      mobileData.UserNm = vm.data.UserNm;
      mobileData.Mobile = result;
      mobileData.Type = type;
      
      if (!regExp.test(result)) {
        gAlert('', '휴대폰번호 형식에 맞지 않는 번호입니다.');
        return;
      }

      postApi.duplicateMobileCheck(mobileData, function(res){
        if (res.header.status === CONSTANT.HttpStatus.OK) {
          // 휴대폰번호 중복 처리
          if (res.body.docs[0].result > 0) {

            gAlert('', '이미 등록된 휴대폰번호 입니다.');
            return;
          } 
          // 휴대폰번호가 중복이 아니고 정규식이 맞다면 인증 처리
          else {
            IMP.init("imp86263784"); 
            IMP.certification({ 
              merchant_uid: setMerchantUID(),name: vm.data.UserNm, phone: vm.data.Mobile
            }, function(certifyResult) {
              console.table(certifyResult);
              
              if (certifyResult.success) {
                verifyPersonalInfo(true);
              } else {
                verifyPersonalInfo(false);
                gAlert('', "본인인증에 실패하였습니다.(" + certifyResult.error_msg + ")");
              }
            });
          }
        }
      },
      function(error) {
        console.error(error);
        gAlert('', '휴대폰 번호 중복체크에 오류가 발생하였습니다.'); 
      });
    };

    function verifyPersonalInfo (param) {
      if (param) {

        gAlert('', '인증 되었습니다.');
      } else {
        gAlert('', '인증되지 않았습니다.');
      }
      vm.authYN = param;
    }

    function setMerchantUID() {
      var d = new Date();
      var rndNum = Math.floor(10 + Math.random() * d.getTime());
      return "CID_" + (d.getFullYear() + "").substring(2, 4) + "" + setZero(d.getMonth() + 1) + "" + setZero(d.getDate()) + "" + setZero(d.getHours()) + "" + setZero(d.getMinutes()) + "_" + rndNum;
    }

    function setZero(val) {
      return val > 10 ?  '' + val : '0' + val ;
    }
    //#endregion

    //#region chkBizNoMobileEmailDup 사업자 등록번호, 담당자 휴대폰번호 및 이메일 중복체크
    function chkBizNoMobileEmailDup() {
      if (!isNullOrEmpty(vm.data.Mobile) && !isNullOrEmpty(vm.data.Email3)) {
        var data = {};
        data.Type = type;
        data.Mobile = vm.data.Mobile;
        data.Email = vm.data.Email3;
        data.BizNo = vm.data.BizRegNo;
        data.mapCode = CHK_BIZNO_MOB_EMAIL_SQL;
        postApi.openApi(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            var res = ""; 
            if (result.body.docs.length > 0) {
              
              if (result.body.docs[0].DupCnt >0 && vm.prevMobile != vm.data.Mobile) {
                res += "- 이미 등록된 담당자 휴대폰번호입니다.<br/>";
              } 
              if (result.body.docs[1].DupCnt >0 && vm.prevEmail != vm.data.Email3) {
                res += "- 이미 등록된 담당자 이메일입니다.<br/>";
              }
              if (result.body.docs.length == 3 && result.body.docs[2].DupCnt > 0) {
                res += "- 이미 등록된 사업자번호입니다.<br/>";
              }
            }
            
            if (!isNullOrEmpty(res)) gAlert('', res);
            else getIsValidData();
          }
        }, function (error) {
          console.error("Error> chkBizNoMobileEmailDup()");
          console.table(error);
        });
      } else {
        gAlert('', "- 담당자 휴대폰번호 및 이메일은 필수입력 항목입니다.<br/>");
      }
    }
    //#endregion
    
    //#region keyPressHandler - Enter 입력 시 Submit되는 현상 방지 
    $scope.keyPressHandler = function(e) {
      if (e.keyCode === 13) {
          e.preventDefault();
          e.stopPropagation();
  
          // Perform your custom logic here if any
      }
    };
    //#endregion

    getOrganizationList();
    getOrganizationSubList();
    getAppPathList();
    getInterestFamillyData();
    getInterestData();
    vm.chkPassId = chkPassId;
    vm.chkLoginIdDup = chkLoginIdDup;
    vm.chkBizNoMobileEmailDup = chkBizNoMobileEmailDup;
  }
  
  webapp.component("signupSecond", {
    transclude: true,
    bindings: {},
    controller: SignupSecondController,
    controllerAs: "vc",
    templateUrl: "components/login/signup-second-step.html"
  });
  
})();



(function() {
    "use strict";
    SignupController.$inject = ['$state', '$rootScope', '$window'];
  
    /** @ngInject */
    function SignupController($state, $rootScope, $window) {
      var vm = this;
      vm.data = {};
      
      vm.signUpTenant = function (data) {
        $state.go("signupFirst", {srch:encodeURIComponent(data)});
      };

      // 로그인 헤더 버튼 설정
      $window.sessionStorage['loginTitle'] = '로그인';
      $window.sessionStorage['loginUrl'] = 'login';
    }

    webapp.component("signupTenant", {
      transclude: true,
      bindings: {},
      controller: SignupController,
      controllerAs: "vc",
      templateUrl: "components/login/signup.html"
    });
  })();
  
webapp.service('ModalAPISrv', ['$rootScope', '$resource', 'StaticVariable',
  function ModalAPISrv($rootScope, $resource, staticVariable) {
    var modalApi = {
      getClientApi: function(){
        return $resource(staticVariable.getUrl('/api/org/clients.json?userkey=' + $rootScope.gVariable.userKey), {},
            staticVariable.getRequestActions.getStandardAction());
      },
      getOrgDeptUserApi: function(){
        return $resource(staticVariable.getUrl('/api/org/department/:deptId/users.json?userkey=' + $rootScope.gVariable.userKey), {
          deptId: '@deptId'
        }, staticVariable.getRequestActions.getStandardAction());
      },
      getOrgDepartmentApi: function(){
        return $resource(staticVariable.getUrl('/api/org/departement/tree.json?userkey=' + $rootScope.gVariable.userKey), {},
            staticVariable.getRequestActions.getStandardAction());
      },
      doDeptList: function() {
        return $resource(staticVariable.getUrl('/select/Department.getDepartmentTree/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      doTenantList: function() {
        alert('doTenantList');
        return $resource(staticVariable.getUrl('/select/Tenant.getTenantSrch/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      doLocationList: function() {
        return $resource(staticVariable.getUrl('/select/Location.getLocationTreeList/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      getUserApi: function(){
        return $resource(staticVariable.getUrl('/select/User.getUserMgrList/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      getUserCntApi: function(){
        return $resource(staticVariable.getUrl('/select/User.getUserMgrListCnt/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      getShopApi: function(){
        return $resource(staticVariable.getUrl('/select/DataAnalysis.getShopList/action.json?userkey=' + $rootScope.gVariable.userKey), {},
            staticVariable.getRequestActions.defaultAction());
      },
      getShopCntApi: function(){
        return $resource(staticVariable.getUrl('/select/DataAnalysis.getShopCount/action.json?userkey=' + $rootScope.gVariable.userKey), {},
            staticVariable.getRequestActions.defaultAction());
      },
      getUserRoleApi: function(){
        return $resource(staticVariable.getUrl('/select/Role.getRoleList/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      getUserRoleCntApi: function(){
        return $resource(staticVariable.getUrl('/select/Role.getRoleListCnt/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
      doUpdateDefaultActionDetail : function() {
        return $resource(staticVariable.getUrl('/update/DataAnalysis.updateDefaultActionDetail/action.json?userkey=' + $rootScope.gVariable.userKey), {},
          staticVariable.getRequestActions.defaultAction());
      },
    };
    return modalApi;
  },
]);

(function() {
  "use strict";
  PrintTakeController.$inject =  ["$window", "$scope", "$location", "$state", "$stateParams", "$filter", "GLOBAL_CONSTANT", "StaticVariable", "gAlert", "postApi", "customFieldApi", "$rootScope", '$timeout', 'gConfirm'];

  /** @ngInject */
  function PrintTakeController($window, $scope, $location, $state, $stateParams, $filter, CONSTANT, StaticVariable, gAlert, postApi, customFieldApi, $rootScope, $timeout, gConfirm) {
    var vm = this;

    vm.tenantId = $window.sessionStorage['loginTenantId'];
    vm.keyId = $stateParams.keyId;
    vm.columnMap = {};

    // SQL Mapper Id 정의
    var VIEW_SQL = 'Take.getTakeDetail';                                                // 상세 조회 SQL
    var TENANT_VIEW_SQL = 'Tenant.getTenantDetail';                                     // 기관 정보 조회 SQL
    var FRM_LIST_SQL = 'Take.getTakeFrmList';                                           // 가족관계 목록 조회 SQL
    var TENANT_SPT_LIST_SQL = 'Take.getTakeTenantSptList';                              // 타기관 지원 목록 조회 SQL
    var FINAN_LIST_SQL = 'Take.getTakeFinanList';                                       // 금융자산 목록 조회 SQL
    var ETCCOST_LIST_SQL = 'Take.getTakeEtcCostList'                  // 기타지출 목록 조회 SQL

    // 업로드 파일 목록
    vm.attach = {
      AttachFile5: { label: '지원신청서', grpId: 50, id: 'AttachFile5', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false, preview: false, viewType: ""},
      AttachFile1: { label: '공통 필수서류', grpId: 41, id: 'AttachFile1', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false, preview: false, viewType: ""},
      AttachFile2: { label: '항목별 필수서류', grpId: 42, id: 'AttachFile2', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false, preview: false, viewType: ""},                    
      AttachFile4: { label: '기관 사업자등록증, 통장사본', grpId: 49, id: 'AttachFile4', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false, preview: false, viewType: ""},    
      AttachFile6: { label: '물품리스트', grpId: 56, id: 'AttachFile6', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false, preview: false, viewType: ""},   
      AttachFile3: { label: '기타 제출서류', grpId: 43, id: 'AttachFile3', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false, preview: false, viewType: ""},   
      AddFile1: { label: '추가서류1', grpId: 44, id: 'AddFile1', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
      AddFile2: { label: '추가서류2', grpId: 45, id: 'AddFile2', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
      AddFile3: { label: '추가서류3', grpId: 46, id: 'AddFile3', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
      AddFile4: { label: '추가서류4', grpId: 47, id: 'AddFile4', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
      AddFile5: { label: '추가서류5', grpId: 48, id: 'AddFile5', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
      AddFile6: { label: '추가서류6', grpId: 51, id: 'AddFile6', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
      AddFile7: { label: '추가서류7', grpId: 52, id: 'AddFile7', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
      AddFile8: { label: '추가서류8', grpId: 53, id: 'AddFile8', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
      AddFile9: { label: '추가서류9', grpId: 54, id: 'AddFile9', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
      AddFile10: { label: '추가서류10', grpId: 55, id: 'AddFile10', size: 0, delState: '', fileLock:'Y', downAuth: true, ngIf: false},
    };

    vm.fileView = function(key){
     var chk = true;
     switch(key){
       case 'AttachFile5': chk = !vm.isPesEtcOnly; break;
       case 'AttachFile2': chk = !vm.isPesEtcOnly; break;
       case 'AttachFile4': chk = !vm.isPesEtcOnly; break;
       case 'AttachFile6': chk = vm.isPesOnly; break;
     }
     return vm.attach[key].ngIf && chk;
    }
    
    // 사진
    vm.photoList = [];
    for(var i = 1; i <= 5; i++){
      vm.photoList.push({no:i, id:"Photo"+i, f:""});
    }
    // 증명서류
    vm.econCertiList = [];
    for(var i = 1; i <= 10; i++){
      vm.econCertiList.push({no:i, id:"EconCerti"+i, f:""});
    }
    // 기타서류
    vm.etcFileList = [];
    for(var i = 1; i <= 10; i++){
      vm.etcFileList.push({no:i, id:"EtcFile"+i, f:""});
    } 

    vm.tenantType = $window.sessionStorage['loginTenantType'];                          // 회원사 타입
    vm.tenantId = $window.sessionStorage['loginTenantId']; 
    
    vm.regUserType = '';
    
    vm.isPesOnly = false;
    vm.isPesEtcOnly = false;

    /**
     * 데이터 조회
     * @param
     * @return
     */
    function getData() {
      vm.dataloader = true;

      var data = {keyId : vm.keyId};
      data.mapCode = VIEW_SQL;
      data.keyId = vm.keyId;

      // For CustomColumn and FileAttachment
      data.tableNm = 'casemanage';
      data.IdName = 'keyId';
      data.selectType = 'Edit';
      data.uploadFileList = []; 

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.desc.length > 0) {
            vm.allColumns = result.body.desc;
            angular.forEach(vm.allColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
            });
          }
          
          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];
            vm.data.BirthDay = moment(vm.data.BirthDay).format('YYYY-MM-DD');
            
            // 물품지원(Req06)만 선택했을 경우
            vm.isPesOnly = ((isNullOrEmpty(vm.data.SupportReq01) || vm.data.SupportReq01 == "0")
                              && (isNullOrEmpty(vm.data.SupportReq02) || vm.data.SupportReq02 == "0") 
                              && (isNullOrEmpty(vm.data.SupportReq03) || vm.data.SupportReq03 == "0") 
                              && (isNullOrEmpty(vm.data.SupportReq04) || vm.data.SupportReq04 == "0") 
                              && (isNullOrEmpty(vm.data.SupportReq05) || vm.data.SupportReq05 == "0") 
                              && ( ! isNullOrEmpty(vm.data.SupportReq06) && vm.data.SupportReq06 == "1"));    

            // 물품지원(Req06), 기타(Req05)만 선택했을 경우
            vm.isPesEtcOnly = ((isNullOrEmpty(vm.data.SupportReq01) || vm.data.SupportReq01 == "0")
              && (isNullOrEmpty(vm.data.SupportReq02) || vm.data.SupportReq02 == "0") 
              && (isNullOrEmpty(vm.data.SupportReq03) || vm.data.SupportReq03 == "0") 
              && (isNullOrEmpty(vm.data.SupportReq04) || vm.data.SupportReq04 == "0") 
              && (( ! isNullOrEmpty(vm.data.SupportReq05) && vm.data.SupportReq05 == "1") 
                    || ( ! isNullOrEmpty(vm.data.SupportReq06) && vm.data.SupportReq06 == "1")));   
            
            if (!isNullOrEmpty(vm.data.WorkStartDate)) {
              vm.data.WorkStartDate = moment(vm.data.WorkStartDate).format('YYYY-MM-DD');
            }
            if (!isNullOrEmpty(vm.data.WorkEndDate)) {
              vm.data.WorkEndDate = moment(vm.data.WorkEndDate).format('YYYY-MM-DD');
            }
            
            // 현장실사일   
            if (!isNullOrEmpty(vm.data.SiteVeriftDate1) && !isNullOrEmpty(vm.data.SiteVeriftTime11)) {    
              vm.SiteVeriftDate1 = vm.data.SiteVeriftDate1 +" "+ vm.data.SiteVeriftTime11;    
            }
            if (!isNullOrEmpty(vm.data.SiteVeriftDate2) && !isNullOrEmpty(vm.data.SiteVeriftTime21)) {    
              vm.SiteVeriftDate2 = vm.data.SiteVeriftDate2 +" "+ vm.data.SiteVeriftTime21;          
            }
            if (!isNullOrEmpty(vm.data.SiteVeriftDate)) vm.SiteVeriftDate = new Date(vm.data.SiteVeriftDate);

            if (vm.data.uploadFileList) {
              angular.forEach(vm.data.uploadFileList, function(item) {
                angular.forEach(vm.attach, function (att) {
                  if(att.grpId == item.GrpId){    
                    var target = att.id;            
                    vm.attach[target].isLoaded = true;
                    vm.attach[target].fileName = item.LogicalFileNm;
                    vm.attach[target].size = item.FileSize;
                    vm.attach[target].path = item.PhysicalPath;
                    vm.attach[target].fileKey = item.PhysicalFileNm;
                    vm.attach[target].link = StaticVariable.getUrl("/openapi/attach/" + item.PhysicalPath + "/" + item.PhysicalFileNm + "/download.do");                    
                    vm.attach[target].delState = '';
                    vm.attach[target].fileLock = item.FileLock;
                    vm.attach[target].downAuth = (item.FileLock == "N" || (item.FileLock == "Y" && (vm.data.RegUserYN == "Y" || vm.tenantId == "0")));
                    vm.attach[target].ngIf = true;
                  }
                });
              });
            } else {
              vm.data.uploadFileList = [];
            }

            // 등록자의 권한에 따라 등록 및 조회 항목 변경을 위한 값 (사례기관 T, 그외 A)
            vm.regUserType = (isNullOrEmpty(vm.data.RegAuth) ? "" : vm.data.RegAuth);

          } else {
            vm.data = {};
          }

          // 기관정보 조회
          getTenantInfo();
          // 가족관계 목록 조회
          getFrmList();
          // 타기관 지원 목록 조회
          getTenantSptList();
          // 금융자산 목록 조회
          getFinanList();
          // 기타지출 목록 조회
          getEtcCostList();

          setTimeout(function() {
            printDetail()
          }, 1500);
          //setTimeout(printDetail(), 10000);
        }

        vm.dataloader = false;
      }, function(error) {
        vm.dataloader = false;
        console.error("Error> getData()");
        console.table(error);
      });
    }

    /**
     * 기관정보 조회
     * @param
     * @return
     */
     function getTenantInfo() {
      var data = {};
      if (isNullOrEmpty(vm.data.TenantId)) {
        data.keyId = vm.tenantId;
      } else {
        data.keyId = vm.data.TenantId;
      }
      
      data.mapCode = TENANT_VIEW_SQL;

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.tenantData = result.body.docs[0];
          } else {
            vm.tenantData = {};
          }          
        } 
      }, function(error) {
          console.error("Error> getTenantInfo()");
          console.table(error);
      });
    }

    /**
     * 가족관계 목록 조회
     * @param
     * @return
     */
    function getFrmList() {
      var data = {keyId : vm.keyId, mapCode : FRM_LIST_SQL};

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data.frmList = result.body.docs;
          } else {
            vm.data.frmList = [];
          }
        } 
      }, function(error) {
          console.error("Error> getFrmList()");
          console.table(error);
      });
    }

    /**
     * 타기관 지원 목록 조회
     * @param
     * @return
     */
     function getTenantSptList() {
      var data = {keyId : vm.keyId, mapCode : TENANT_SPT_LIST_SQL};

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data.tenantSptList = result.body.docs;
            angular.forEach(vm.data.tenantSptList, function(item) {
              item.SptStartDate = moment(item.SptStartDate).format('YYYY-MM-DD');
              item.SptEndDate = moment(item.SptEndDate).format('YYYY-MM-DD');
            });
          } else {
            vm.data.tenantSptList = [];
          }    
        } 
      }, function(error) {
          console.error("Error> getTenantSptList()");
          console.table(error);
      });
    }

    /**
     * 금융자산 목록 조회
     * @param
     * @return
     */
     function getFinanList() {
      var data = {keyId : vm.keyId, mapCode : FINAN_LIST_SQL};

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data.finanList = result.body.docs;
          }  else {
            vm.data.finanList = [];
          }        
        } 
      }, function(error) {
          console.error("Error> getFinanList()");
          console.table(error);
      });
    }

    /**
     * 기타지출 목록 조회
     * @param
     * @return
     */
     function getEtcCostList() {
      var data = { keyId: vm.keyId, mapCode: ETCCOST_LIST_SQL };

      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data.etcCostList = result.body.docs;
          } else {
            vm.data.etcCostList = [];
          }
        }
      }, function (error) {
        console.error("Error> getEtcCostList()");
        console.table(error);
      });
    } 

    function printDetail() {
      $("#btn_print").css('display', 'none');
      window.print();
      $("#btn_print").css('display', '');
    }

    vm.printDetail = printDetail;

    getData();
    

    $("#btn_print").css('display', 'none');

  }

  

  webapp.component("printTake", {
    transclude: true,
    bindings: {},
    controller: PrintTakeController,
    controllerAs: "vc",
    templateUrl: "components/print/print-take.html"
  });
})();

(function() {
    "use strict";
    PrivacyPolicyController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', '$timeout', 'MAIN', 'LoginAPISrv', 'postApi', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', 'Auth'];
  
    /** @ngInject */
    function PrivacyPolicyController($scope, $log, $state, $filter, $cookies, $rootScope, $timeout, MAIN, loginApi, postApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth) {
      var vm = this;
      vm.user = {};
      vm.loginInfo = {};
  
     
    }
  
    webapp.component("privacyPolicy", {
      transclude: true,
      bindings: {},
      controller: PrivacyPolicyController,
      controllerAs: "privacyPolicy",
      templateUrl: "components/privacyPolicy/privacyPolicy.html"
    });
  })();
  
(function() {
  "use strict";
  NoticeController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', '$timeout', 'MAIN', 'LoginAPISrv', 'postApi', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', 'Auth', '$stateParams','StaticVariable'];

  /** @ngInject */
  function NoticeController($scope, $log, $state, $filter, $cookies, $rootScope, $timeout, MAIN, loginApi, postApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth, $stateParams, StaticVariable) {
    var vm = this;
    vm.user = {};
    vm.loginInfo = {};

    if($cookies.get('mySavedId') != undefined) {
      vm.loginInfo.loginId = $cookies.get('mySavedId');
      vm.loginInfo.saveId = '1';
    }

    vm.stateName = $state.current.name;

    if (!$stateParams.srch) {
      vm.srch = {
        page: 1,
        viewSize: CONSTANT.PAGINATION.VIEWSIZE,
        tableNm: vm.stateName.replace(/login/gi, 'board')
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.currentPage = vm.srch.page;
    }   

    var translate = $filter("translate");
    vm.language = $rootScope.currentLanguage;
    //console.log('$rootScope.currentLanguage=', $rootScope.currentLanguage);
    vm.placeholder = {
      id: translate("LOGIN.LABEL.ID"),
      pw: translate("LOGIN.LABEL.PW")
    };
    $log.info("console log info translate::", translate("LOGIN.BTN.LOGIN"));

    vm.onChangeHandler = onChangeHandler;

    function onChangeHandler() {
      //console.log('language=', vm.language);
      $rootScope.changeLanguage(vm.language);
    }

    vm.getSearch = getSearch;

    function getSearch() {
      //      vm.srch.time = (new Date()).getTime();
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        vm.stateName,
        { srch: srch },
        { reload: vm.stateName }
      );
    }

    vm.pageChanged = function() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go(
        vm.stateName,
        { srch: srch },
        { reload: vm.stateName }
      );
    }

    function getBoardList() {
 
      getBoardListCnt();

      var data = angular.copy(vm.srch);

      var prms = postApi.sendPostApi('openapi/board', 'getList', data, function (result) {
        //console.log(result);
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.boardlist = result.body.docs;
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.error('fail', status);
      });
    }

    function getBoardListCnt() {
      var data = angular.copy(vm.srch);

      var prms = postApi.sendPostApi('openapi/board', 'getListCnt', data, function (result) {
        //console.log(result);
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.error('fail', status);
      });
    }    

    vm.showDetail = function(BbsPostId) {
      var data = {
        tableNm:vm.stateName.replace(/login/gi, 'board'), 
        BbsPostId:BbsPostId, 
        selectType:'Detail', 
        uploadFileList:[],        
        IdName:'BbsPostId'
      };

      var prms = postApi.sendPostApi('openapi/board', 'getDetail', data, function (result) {
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            var item = result.body.docs[0];

            var uploadFileList = [];
            angular.forEach(item.uploadFileList, function(f) {
              var obj = {
                id : f.fileId,
                link : StaticVariable.getUrl("/openapi/attach/" + f.PhysicalPath + "/" + f.PhysicalFileNm + "/download.do"),
                fileName : f.LogicalFileNm,
                size : f.FileSize,
              };
              uploadFileList.push(obj);
            });

            var ctrl = 'ContentsModalCtrl as modalCtrl';
            var paramData = { Contents:item.Contents, Title:item.Title, VideoLink:item.ExtVarchar01, FileList:uploadFileList};
            var modalInstance = modalFactory.open('lg', 'components/modal/contents/contents-modal.html', ctrl, paramData);
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.error('fail', status);
      });
    };

    vm.searchValueKeyPress = function(event) {
      if(event.keyCode == 13) {
        getSearch();
      }
    };

    getBoardList();
  }

  webapp.component("notice", {
    transclude: true,
    bindings: {},
    controller: NoticeController,
    controllerAs: "notice",
    templateUrl: "components/notice/notice.html"
  });

  webapp.component("faq", {
    transclude: true,
    bindings: {},
    controller: NoticeController,
    controllerAs: "faq",
    templateUrl: "components/notice/faq.html"
  });  
})();

(function() {
  "use strict";
  QnaController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', '$timeout', 'MAIN', 'LoginAPISrv', 'postApi', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', 'Auth'];

  /** @ngInject */
  function QnaController($scope, $log, $state, $filter, $cookies, $rootScope, $timeout, MAIN, loginApi, postApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth) {
    var vm = this;
    vm.user = {};
    vm.loginInfo = {};

    if($cookies.get('mySavedId') != undefined) {
      vm.loginInfo.loginId = $cookies.get('mySavedId');
      vm.loginInfo.saveId = '1';
    }

    var translate = $filter("translate");
    vm.language = $rootScope.currentLanguage;
    //console.log('$rootScope.currentLanguage=', $rootScope.currentLanguage);
    vm.placeholder = {
      id: translate("LOGIN.LABEL.ID"),
      pw: translate("LOGIN.LABEL.PW")
    };
    $log.info("console log info translate::", translate("LOGIN.BTN.LOGIN"));

    vm.onChangeHandler = onChangeHandler;

    function onChangeHandler() {
      //console.log('language=', vm.language);
      $rootScope.changeLanguage(vm.language);
    }

    function setUserSession(vm, json) {
      if (vm.loginInfo.saveId == '1') {
        var now = new Date();
        var cookieExp = new Date(now.getFullYear()+1, now.getMonth(), now.getDate());

        $cookies.put('mySavedId', vm.loginInfo.loginId);

      } else {
        $cookies.remove('mySavedId');
      }

      $rootScope.setUserSession(json.responseVO.body.docs[0]);

      Auth.init(json.responseVO.body.docs[0].permissions);

//      Auth.init(json.responseVO.body.docs[0].permissions);

      // 이메일, 전화번호 추가
      // $window.sessionStorage['loginUserEmail'] =
      // json.responseVO.body.docs[0].email;

      // $window.location.replace('/app/dashboard');
      // $state.reload("home");

      // $state.go("app.dashboard");
    }

    function getBoardList() {
      var data = {BbsMasterId:'3WUUDKU3SO', TenantId:'7TLIMMJEL9'};

      var prms = postApi.sendPostApi('openapi/board', 'getList', data, function (result) {
        //console.log(result);
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.boardlist = result.body.docs;
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.error('fail', status);
      });
    }

    vm.showDetail = function(BbsPostId) {
      var data = {BbsMasterId:'3WUUDKU3SO', TenantId:'7TLIMMJEL9', BbsPostId:BbsPostId, selectType:'Detail'};

      var prms = postApi.sendPostApi('openapi/board', 'getDetail', data, function (result) {
        if (result && result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            var item = result.body.docs[0];

            var ctrl = 'ContentsModalCtrl as modalCtrl';
            var paramData = { Contents:item.Contents, Title:item.Title, VideoLink:item.ExtVarchar01};
            var modalInstance = modalFactory.open('lg', 'components/modal/contents/contents-modal.html', ctrl, paramData);
          } else {
            gAlert('', 'Menu.INVALIEDIDPASSWORD');
          }
        } else {

        }
      }, function(error) {
        gAlert('', error);
        console.error('fail', status);
      });
    };

    getBoardList();
  }

  webapp.component("qna", {
    transclude: true,
    bindings: {},
    controller: QnaController,
    controllerAs: "qna",
    templateUrl: "components/qna/qna.html"
  });
})();

(function() {
    "use strict";
    TermsOfServiceController.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', '$timeout', 'MAIN', 'LoginAPISrv', 'postApi', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', 'Auth'];
  
    /** @ngInject */
    function TermsOfServiceController($scope, $log, $state, $filter, $cookies, $rootScope, $timeout, MAIN, loginApi, postApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth) {
      var vm = this;
      vm.user = {};
      vm.loginInfo = {};
  
     
    }
  
    webapp.component("termsOfService", {
      transclude: true,
      bindings: {},
      controller: TermsOfServiceController,
      controllerAs: "termsOfService",
      templateUrl: "components/termsOfService/termsOfService.html"
    });
  })();
  
(function() {
    "use strict";
    TermsOfService2021Controller.$inject = ['$scope', '$log', '$state', '$filter', '$cookies', '$rootScope', '$timeout', 'MAIN', 'LoginAPISrv', 'postApi', 'GLOBAL_CONSTANT', 'gAlert', '$window', '$translate','modalFactory', 'Auth'];
  
    /** @ngInject */
    function TermsOfService2021Controller($scope, $log, $state, $filter, $cookies, $rootScope, $timeout, MAIN, loginApi, postApi, CONSTANT, gAlert, $window, $translate, modalFactory, Auth) {
      var vm = this;
      vm.user = {};
      vm.loginInfo = {};
  
     
    }
  
    webapp.component("termsOfService2021", {
      transclude: true,
      bindings: {},
      controller: TermsOfService2021Controller,
      controllerAs: "termsOfService2021",
      templateUrl: "components/termsOfService/termsOfService2021.html"
    });
  })();
  
webapp.controller('ChangeStatusModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', '$filter', 'gAlert', 'modalFactory',
    function ChangeStatusModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, $filter, gAlert, modalFactory ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.data = {};

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        $uibModalInstance.close(vm.data);
      }

    } ]);

webapp.controller('ContactUserModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function ContactUserModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getUserList = getUserList;
      vm.columnMap = {};
      vm.SrchEntryDtTo = '';
      vm.SrchEntryDtFrom = '';

      (function ContactUserModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;
        vm.UserList = [];
      })();

      function changeViewSize() {
        getUserList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          LoginId : vm.LoginId != undefined ? vm.LoginId : '',
          UserNm : vm.UserNm != undefined ? vm.UserNm : '',
          WorkStyle : vm.WorkStyle != undefined ? vm.WorkStyle : '',
          WorkStatus : vm.WorkStatus != undefined ? vm.WorkStatus : '',
          UserGrade : vm.UserGrade != undefined ? vm.UserGrade : '',
          TenantId : toModalData.TenantId,
        }
        vm.filter = req;
        return req;
      }

      function getUserList() {
        getUserListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'users';
        data.mapCode = 'User.getUserModalList';

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.UserList = result.body.docs;
            } else {
              vm.UserList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function getUserListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'User.getUserModalListCnt';
        
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            } else {
              vm.totalCount = 0;
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(User) {
        $uibModalInstance.close(User);
      }

    } ]);

(function() {
  "use strict";

  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPosHeader
   * @description
   * # adminPosHeader
   */
  StatesController.$inject = [];
  /** @ngInject */
  function StatesController() {}

  webapp.component("stats", {
    templateUrl: "app/dashboard/stats/stats.html",
    controller: StatesController,
    controllerAs: "states",
    bindings: {
      model: "=",
      comments: "@",
      number: "@",
      name: "@",
      colour: "@",
      details: "@",
      type: "@",
      goto: "@"
    }
  });
})();

webapp.controller('CommAdminModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function CommAdminModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getUserList = getUserList;
      vm.columnMap = {};
      vm.SrchEntryDtTo = '';
      vm.SrchEntryDtFrom = '';

      (function CommAdminModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.UserList = [];
      })();

      function changeViewSize() {
        getUserList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          LoginId : vm.LoginId != undefined ? vm.LoginId : '',
          UserNm : vm.UserNm != undefined ? vm.UserNm : '',
          WorkStyle : vm.WorkStyle != undefined ? vm.WorkStyle : '',
          WorkStatus : vm.WorkStatus != undefined ? vm.WorkStatus : '',
          UserGrade : vm.UserGrade != undefined ? vm.UserGrade : '',
          AdminTypeList : "'S','H','B'", // 재단관리자(사무국, 현장간사, 봉사단)
          CommentAdminYN : '1'
        }
        vm.filter = req;
        return req;
      }

      function getUserList() {
        getUserListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'users';
        data.mapCode = 'User.getUserModalList';

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.UserList = result.body.docs;
            } else {
              vm.UserList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function getUserListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'User.getUserModalListCnt';
        
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            } else {
              vm.totalCount = 0;
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(User) {
        $uibModalInstance.close(User);
      }

    } ]);

webapp.controller('FileViewModalCtrl', [ '$uibModalInstance', 'toModalData',
    function VolunteerModalCtrl($uibModalInstance, toModalData) {
      var vm = this;
      vm.cancel = cancel;

      (function FileViewModalCtrl() {
        vm.filePath = toModalData.filePath;    
        vm.viewType = toModalData.viewType;    
      })();

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

    } ]);

webapp.controller('RecomTenantModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$state',
    function RecomTenantModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, $state) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;

      vm.srch = {
		    TenantNm : '',
        TenantId : '',
        viewSize : 10,
        Ceo :'',
      };

      vm.selectedTenantId = toModalData.TenantId;
      if (toModalData.showBaseTenant == undefined || toModalData.showBaseTenant == null) {
        vm.showBaseTenant = 'Y';
      } else if(toModalData.showBaseTenant != undefined && toModalData.showBaseTenant != '') {
        if(!toModalData.showBaseTenant) vm.showBaseTenant = 'N';
        else vm.showBaseTenant = 'Y';
      } else if (!toModalData.showBaseTenant) {
        vm.showBaseTenant = 'N';
      } else {
        vm.showBaseTenant = 'Y';
      }

      (function RecomTenantModalCtrl() {
        getList();
      })();
      function getList() {

        var data = {
          TenantNm : vm.srch.TenantNm,
          TenantType : 'GIVETENANT', 
          TenantStatus : 'Y',
          page : vm.srch.page,
        };

        getCnt();

        data.mapCode= 'Tenant.getTenantSrch';
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.tenantlists = result.body.docs;

            var resList = [];
            var res = '';

            if (vm.tenantlists != null) {
              angular.forEach(vm.tenantlists, function (item) {
                  resList = [];
                  if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {
                  res = item.Addr1;
                  resList = res.split(" ");
                  item.Addr1 = resList[0] + " " + resList[1];
                  }
              });
            }
          }
        });
      }

      function getCnt() {
        var data = {
          TenantNm : vm.srch.TenantNm,
          TenantType : 'GIVETENANT', 
          TenantStatus : 'Y'
        };

        data.mapCode= 'Tenant.getTenantSrchCnt';
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalItems = result.body.docs[0].totalItems;
          }
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
        /*var p = '';
        $state.go('app.dashboard', p, {reload: 'app.dashboard'});*/
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function pageChanged() {
        vm.srch.page = vm.currentPage;
        getList();

      }

      vm.pageChanged = pageChanged;
    } ]);

webapp.controller('SelfChkModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'TakeService', 
    function SelfChkModalCtrl($window, $scope, $uibModalInstance, toModalData, TakeService ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.calc = calc;

      vm.selfChkResult = false;
      vm.keyId = null;
      vm.selfChkId = null;     
      vm.selfData = {};
      vm.selfDataResult = {};

      (function SelfChkModalCtrl() {  
        vm.keyId = toModalData.keyId;
        vm.selfChkId = toModalData.selfChkId;
        vm.selfData = toModalData.selfData;
        vm.selfDataResult = TakeService.getSelfDataResult(vm.selfData);
      })();

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        var data = {
            selfChkResult : vm.selfChkResult,
            selfData : vm.selfData,
            selfDataResult : vm.selfDataResult
        }
        $uibModalInstance.close(data);
      }

      function calc() {
        vm.selfDataResult = TakeService.getSelfDataResult(vm.selfData);
        vm.selfChkResult = (vm.selfDataResult.totalSc >= 14);
      }

    } ]);

webapp.controller('SiteVeriftAdminModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function SiteVeriftAdminModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getUserList = getUserList;
      vm.columnMap = {};
      vm.SrchEntryDtTo = '';
      vm.SrchEntryDtFrom = '';

      (function SiteVeriftAdminModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.UserList = [];
      })();

      function changeViewSize() {
        getUserList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          LoginId : vm.LoginId != undefined ? vm.LoginId : '',
          UserNm : vm.UserNm != undefined ? vm.UserNm : '',
          WorkStyle : vm.WorkStyle != undefined ? vm.WorkStyle : '',
          WorkStatus : vm.WorkStatus != undefined ? vm.WorkStatus : '',
          UserGrade : vm.UserGrade != undefined ? vm.UserGrade : '',
          AdminTypeList : "'S','H','B'", // 재단관리자(사무국, 현장간사, 봉사단)
        }
        vm.filter = req;
        return req;
      }

      function getUserList() {
        getUserListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'users';
        data.mapCode = 'User.getUserModalList';

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.UserList = result.body.docs;
            } else {
              vm.UserList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function getUserListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'User.getUserModalListCnt';
        
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            } else {
              vm.totalCount = 0;
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(User) {
        $uibModalInstance.close(User);
      }

    } ]);

webapp.controller('VolunteerModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function VolunteerModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getUserList = getUserList;
      vm.columnMap = {};
      vm.SrchEntryDtTo = '';
      vm.SrchEntryDtFrom = '';

      (function VolunteerModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.UserList = [];
        getUserList();
      })();

      function changeViewSize() {
        getUserList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          LoginId : vm.LoginId != undefined ? vm.LoginId : '',
          UserNm : vm.UserNm != undefined ? vm.UserNm : '',
          WorkStyle : vm.WorkStyle != undefined ? vm.WorkStyle : '',
          WorkStatus : vm.WorkStatus != undefined ? vm.WorkStatus : '',
          UserGrade : vm.UserGrade != undefined ? vm.UserGrade : '',
          //AdminType : "B" // 봉사단
          AdminTypeList : "'B','H'" // 봉사단, 현장간사
        }
        vm.filter = req;
        return req;
      }

      function getUserList() {
        getUserListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'users';
        data.mapCode = 'User.getUserModalList';

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.UserList = result.body.docs;
            } else {
              vm.UserList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function getUserListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'User.getUserModalListCnt';
        
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            } else {
              vm.totalCount = 0;
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(User) {
        $uibModalInstance.close(User);
      }

    } ]);

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:user-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 임직원관리 등록/수정
   */

  webapp.controller('PersonalUserEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function PersonalUserEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'User.insertUser';   // 등록 SQL
      var GETID_SQL = 'checkLoginId';  // 아이디중복 SQL
      var UPDATE_SQL = 'User.updateUser';           // 수정 SQL
      var VIEW_SQL = 'User.getUserDetail';       // 조회 SQL
      var DEL_SQL = 'User.deleteUserDetail';        // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.personal.user-list';                 // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.personal.user-list.edit';                 // 목록 화면
      var VIEW_PAGE_URL = 'app.personal.user-edit';           // 조회 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Users'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      
      // #endregion 상수 정의
      
      // View Model
      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.changeable = false;  
      vm.ifAddView = false;
      vm.ifTabView = false;

      // 현장간사 지역
      vm.cityDataH = {
        pCode: "",
        cCode: "",
        cCodeList: [],
        selCityCodeList: [],
        selCityNameList: "",
      };

      // AI담당 지역
      vm.cityDataAi = {
        pCode: "",
        cCode: "",
        cCodeList: [],
        selCityCodeList: [],
        selCityNameList: "",
      };

      // 대상 사용자 관리자 여부
      vm.chkAdmin = false;
      vm.chkAdminSH = false; // 사무국, 현장간사
      vm.chkAdminH = false; // 현장간사
      vm.chkAdminG = false; // 후원기관관리자    

      vm.newYN = true;
      if(!isNullOrEmpty($stateParams.keyId)) {
        vm.keyId = $stateParams.keyId;
        vm.ifAddView = false;
        vm.ifTabView = true;
        vm.newYN = false;
      } else {
        vm.ifAddView = true;
        vm.ifTabView = false;
        vm.newYN = true;
        vm.titleNm = "임직원등록";
      }

      var pageData = { 
        vm : vm, 
        stateParams : $stateParams, 
        scope : $scope,
        rootScope : $rootScope,
        pageType : "VIEW",
        keyTableNm : "tenant",
        keyColumnNm : "KeyId",
        keyId : vm.keyId,
      };

      // 검색 옵션 설정
      if (!$stateParams.srch) {

        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          keyId: !isNullOrEmpty($stateParams.srch.keyId) ? $stateParams.srch.keyId : '', // Primary Key Data
          tableNm: !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM, // 작업 테이블명
          srchTenantId: !isNullOrEmpty($stateParams.srch.srchTenantId) ? $stateParams.srch.srchTenantId : $rootScope.gVariable.srchTenantId // 작업 회원사
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
        if (!vm.srch.tableNm) vm.srch.tableNm = KEY_TABLE_NM;                                    // 관리자 구분
      }      

      vm.comUserYN = !isNullOrEmpty(vm.srch.comUserYN) ? vm.srch.comUserYN : "N";

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.loginUserAdminType = !isNullOrEmpty($window.sessionStorage['loginUserAdminType']) ? $window.sessionStorage['loginUserAdminType'] : "";  
      
      
      // 로그인 사용자 관리자 여부
      vm.isAdminS = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S"); // 시스템관리자, 사무국
      vm.isAdminSHB = (vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "H" || vm.loginUserAdminType == "B"); // 시스템관리자, 사무국, 현장간사, 봉사단

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: !isNullOrEmpty(vm.srch.keyId) ? vm.srch.keyId : '', // Primary Key Data
        tableNm: KEY_TABLE_NM                                      // 작업 테이블명
      };

      if(isNullOrEmpty(vm.keyId)) {
        vm.data.LoginId = '';
        vm.data.Password = '';
        vm.data.photoUrl = "/assets/images/empty_user.png";
        angular.element("#userPhoto").css("background-image", "url(" + vm.data.photoUrl + ")");
        vm.data.Gender = "M";
        vm.data.LnrSlrType = 'S';
      }

      // #region 회원사 검색 팝업 호출

      /**
       * 회원사 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchTenantModal = function () {
        var ctrl = 'TenantModalCtrl as vc';
        var paramData = {TenantId: vm.data.TenantId};
        var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 회원사 선택
          if (okData != null) {
            vm.data.TenantNm = okData.TenantNm;
            vm.data.TenantId = okData.TenantId;
          }
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 회원사 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseTenant = function () {
        if (vm.TenantId && vm.TenantId != '0') {
          return;
        }
        vm.data.TenantNm = "";
        vm.data.TenantId = "";
      };
      // #endregion 회원사 검색 팝업 호출

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        vm.setChangeTab('tab1');
        vm.url = '/tab1';

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;
        data.keyId = $stateParams.keyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              vm.tmpEmail = vm.data.Email;
              vm.tmpPassword = vm.data.Password;

              // 시스템관리자, 사무국, 후원기관, 사례관리기관 관리자만 수정 가능
              if(vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "G" || vm.loginUserAdminType == "T") {                
                vm.changeable = true;
              } 
              // 시스템관리자, 사무국
              if(vm.data.AdminType == 'A' || vm.data.AdminType == 'S') {                
                vm.chkAdminAS = true;  
              }  
              // 사무국,현장간사
              if(vm.data.AdminType == 'S' || vm.data.AdminType == 'H') {                
                vm.chkAdminSH = true;  
              }  
              // 현장간사 지역
              if(vm.data.AdminType == 'H') {                
                vm.chkAdminH = true;  
                var arrCityCode = vm.data.CityCodeList.split(",");    
                angular.forEach(arrCityCode, function(c){  
                  vm.selCityCode('H',c);           
                });
              }   
              // AI 지역      
              if( ! isNullOrEmpty(vm.data.CityCodeListAi)){  
                var arrCityCode = vm.data.CityCodeListAi.split(",");    
                angular.forEach(arrCityCode, function(c){  
                  vm.selCityCode('A',c);           
                });
              }
              // 관리자   
              if( !isNullOrEmpty(vm.data.AdminType) && vm.data.AdminType != 'U') {                
                vm.chkAdmin = true;
              } 

              vm.titleNm = " 임직원 상세 정보";
              //Date형식 처리
              if (vm.data.BirthDay != null && vm.data.BirthDay != "") vm.BirthDay = moment(vm.data.BirthDay).toDate();
              if (vm.data.EntryDt != null && vm.data.EntryDt != "") vm.EntryDt = moment(vm.data.EntryDt).toDate();
              if (vm.data.RetireDt != null && vm.data.RetireDt != "") vm.RetireDt = moment(vm.data.RetireDt).toDate();

              if (isNullOrEmpty(vm.srch.keyId)) {
                vm.data.PhotoUrl = "/assets/images/empty_user.png";
                angular.element("#userPhoto").css("background-image", "url(" + vm.data.PhotoUrl + ")");
                vm.data.Gender = "M";
              } else {
                // photoUrl
                if(vm.data.PhotoUrl == undefined) vm.data.PhotoUrl = "/assets/images/empty_user.png";
                angular.element("#userPhoto").css("background-image", "url(" + vm.data.PhotoUrl + ")");
              }

              getRoleUserList();
            } else {
              console.log('nodata');
              vm.changeable = true;
              vm.data.TenantId = $rootScope.gVariable.srchTenantId;
              vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }

      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.LoginId)) {
          errMsg = errMsg + '- 아이디를 입력하세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.keyId)) {
          if (isNullOrEmpty(vm.data.checkedLoginId)) {
            errMsg = errMsg + '- 아이디 중복체크하세요.<br/>';
          }
        }

        if (isNullOrEmpty(vm.data.UserNm)) {
          errMsg = errMsg + '- 이름을 입력하세요.<br/>';
        }

        if (!isNullOrEmpty(vm.data.KeyId) && vm.tmpPassword != vm.data.Password) {
          if( isNullOrEmpty(vm.data.Password)) {
            errMsg = errMsg + '- 비밀번호를 입력하세요.<br/>';
          }
        }
        if (vm.data.Password != vm.data.Password2) {
          errMsg = errMsg + '- 비밀번호가 일치하지 않습니다.<br/>';
        }
        
        if(isNullOrEmpty(vm.data.Email)) {
          errMsg = errMsg + '- 이메일을 입력하세요.<br/>';
        } 

        if (isNullOrEmpty(vm.data.Mobile)) {
          errMsg = errMsg + '- 핸드폰번호를 입력하세요.<br/>';
        }

        if(isNullOrEmpty(vm.data.WorkStatus)) {
          errMsg = errMsg + '- 재직여부를 입력하세요.<br/>';
        }


        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true;
        // #endregion 필수항목 체크
      }

      /**
       * 역할 목록 조회
       *
       * @param
       * @return
       */
      function getRoleList() {
        var data = {
          TenantId: vm.TenantId,
          mapCode: 'Role.getRoleList'
        };

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 역할 목록 표시
            vm.roleOption = result.body.docs;
          }
        }, function (error) {
          // 오류 발생
          console.error("Error> getRoleList()");
          console.table(error);
        });
      }

      /**
       * 비밀번호 체크
       *
       * @param
       * @return
       */
      function getIsValidPassword() {
        var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_;:<>,.[\]{\}])[A-Za-z\d!@#$%^&*()\-_;:<>,.[\]{\}]+$/g;
        var birthDay = moment(vm.data.BirthDay).format('MMDD');
        var birthDay2 = moment(vm.data.BirthDay).format('YYMMDD');

        if(!reg.test(vm.data.Password)) return false;
        if(vm.data.Password.indexOf(birthDay) > -1) return false;
        if(vm.data.Password.indexOf(birthDay2) > -1) return false;
        if(vm.data.Password.length < 8) return false;

        return true;

      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (getIsValidData() == false) {
          return;
        }
        if(getIsValidData()) {
          gConfirm('', '임직원을 등록하시겠습니까?', {
            btn : '',
            fn : function() {
              // 내용
              vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
              vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
              vm.data.userkey = vm.srch.userkey;          // 사용자 식별 키

              if(vm.data.BirthDay != null && vm.data.BirthDay != "") {
                vm.data.BirthDay = moment(vm.data.BirthDay).format('YYYY-MM-DD');
              } else {
                //vm.data.BirthDay = '';
              }

              if(vm.data.EntryDt != null && vm.data.EntryDt != "") {
                vm.data.EntryDt = moment(vm.data.EntryDt).format('YYYY-MM-DD');
              } else {
                vm.data.EntryDt = '';
              }

              if(vm.data.RetireDt != null && vm.data.RetireDt != "") {
                vm.data.RetireDt = moment(vm.data.RetireDt).format('YYYY-MM-DD');
              } else {
                //vm.data.RetireDt = '';
              }
              
              // 현장간사 지역 등록
              if(vm.cityDataH.selCityCodeList.length > 0){
                var codeList = "";
                angular.forEach(vm.cityDataH.selCityCodeList, function(c) {
                  var comma = (codeList != "" ? "," : "");
                  codeList = codeList + comma + c.cCode;
                });
                if(codeList != "") vm.data.CityCodeList = codeList;
              }
              
              // ai담당 지역 등록
              if(vm.cityDataAi.selCityCodeList.length > 0){
                var codeList = "";
                angular.forEach(vm.cityDataAi.selCityCodeList, function(c) {
                  var comma = (codeList != "" ? "," : "");
                  codeList = codeList + comma + c.cCode;
                });
                if(codeList != "") vm.data.CityCodeListAi = codeList;
              }
              
              var data = vm.data; // 사용자 입력 데이터

              if (isNullOrEmpty(vm.data.keyId)) {
                // 신규 등록
                data.mapCode = INSERT_SQL;

                postApi.insert(data, function (result) {
                  setInsertUpdateDetail(result);
                }, function (error) {
                  console.error("Error> setData()");
                  console.table(error);
                });
              } 
            }
          });
        }
      }

      function editData() {
        console.log('mobile', vm.data);
        if (getIsValidData() == false) {
          return;
        }

        if (getIsValidData()) {
          gConfirm('', '임직원 정보를 수정하시겠습니까?', {
            btn : '',
            fn : function() {
              vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
              vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column

              if(vm.data.BirthDay != null && vm.data.BirthDay != "") {
                vm.data.BirthDay = moment(vm.data.BirthDay).format('YYYY-MM-DD');
              } else {
                //vm.data.BirthDay = '';
              }

              if(vm.data.EntryDt != null && vm.data.EntryDt != "") {
                vm.data.EntryDt = moment(vm.data.EntryDt).format('YYYY-MM-DD');
              } else {
                vm.data.EntryDt = '';
              }

              if(vm.data.RetireDt != null && vm.data.RetireDt != "") {
                vm.data.RetireDt = moment(vm.data.RetireDt).format('YYYY-MM-DD');
              } else {
                //vm.data.RetireDt = '';
              }
              
              // 현장간사 지역 등록
              if(vm.cityDataH.selCityCodeList.length > 0){
                var codeList = "";
                angular.forEach(vm.cityDataH.selCityCodeList, function(c) {
                  var comma = (codeList != "" ? "," : "");
                  codeList = codeList + comma + c.cCode;
                });
                if(codeList != "") vm.data.CityCodeList = codeList;
              }
              
              // ai담당 지역 등록
              if(vm.cityDataAi.selCityCodeList.length > 0){
                var codeList = "";
                angular.forEach(vm.cityDataAi.selCityCodeList, function(c) {
                  var comma = (codeList != "" ? "," : "");
                  codeList = codeList + comma + c.cCode;
                });
                if(codeList != "") vm.data.CityCodeListAi = codeList;
              }
              
              var data = vm.data;
              data.KeyId = data.keyId;
              data.mapCode = UPDATE_SQL;

              postApi.update(data, function (result) {
                setInsertUpdateDetail(result);
              }, function (error) {
                console.error("Error> editData()");
                console.table(error);
              });
            }
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                // 화면 분할 모드에 따른 이동
                goNextPage(true);
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

      function goNextPage(reloadList) {
        var srch = $stateParams.srch;

        if (vm.layout == 'N') {
          if (isNullOrEmpty(vm.srch.keyId)) {
            // 신규등록 -> 목록 화면 이동
            $state.go(LIST_PAGE_URL, {srch: srch}, {reload:LIST_PAGE_URL});
          } else {
            // 수정 -> 조회 화면 이동
            $state.go(VIEW_PAGE_URL, {
              srch: srch,
              keyId: vm.data.KeyId
            }, {reload:VIEW_PAGE_URL});
          }
        } else {
          if (reloadList) {
            var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
            srch2.keyId = '';
            srch2.reload = (new Date()).getTime();
            srch = encodeURIComponent(JSON.stringify(srch2, replacer));
          }

          // 조회 화면 이동
          $state.go(LIST_PAGE_URL, {srch:srch, keyId: vm.data.KeyId});
        }
      }

      /**
       * 사용자 중복 체크
       *
       * @param
       * @return
       */
      function getIsDupLoginId() {
        var data = vm.data;

        if (isNullOrEmpty(vm.data.LoginId)) {
          return;
        }

        vm.data.checkedLoginId = "";

        if (!getIsValidId()) {
          gAlert('', '사용할 수 없는 아이디 입니다.');
          return;
        }

        data.mapCode = GETID_SQL;

        postApi.login(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.data.checkedLoginId = vm.data.LoginId;
            gAlert('', '사용가능한 아이디 입니다.');
          } else {
            gAlert('', result.body.docs[0].errMessage);
            vm.data.checkedLoginId = "";
          }
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });
      }

      /**
       * 아이디 유효성 검사
       * (영문 소문자, 숫자, 특수문자 -_)
       *
       * @param
       * @return
       */
      function getIsValidId() {
        var regExp = /^[a-z0-9\-_]{5,25}$/;
        if (!regExp.test(vm.data.LoginId)) return false;
        //if (vm.data.LoginId.search(/\s/) != -1) return false;

        return true;
      }


      /**
       * 데이터 삭제 확인
       *
       * @param
       * @return
       */
      function delData() {
        gConfirm('', '임직원 정보를 삭제하시겠습니까?', {
          btn : '',
          fn : function() {
            var data = angular.copy(vm.data);
            data.KeyId = data.keyId;
            data.mapCode = DEL_SQL;

            postApi.update(data, function(result) {

              if (data == null) {
                // 삭제할 데이터 미 존재
                gAlert('', 'Menu.CANNOTDELETE');
                return;
              }

              if (result.header.status == CONSTANT.HttpStatus.OK) {
                gAlert('', 'Menu.DELETED', {
                  btn: '',
                  fn: function () {
                    // 삭제 성공
                    var srch = $stateParams.srch;
    
                    // 목록 화면 이동
                    $state.go(LIST_PAGE_URL, {
                        srch: srch
                      },
                      {reload: LIST_PAGE_URL});
                  }
                });
              }
            }, function (error) {
              console.error("Error> delData()");
              console.table(error);
            });
          }
        });
      }

      /**
       * Tab변경
       *
       * @param {string} tabId - 조회할 TabId
       * @return {boolean}
       */
      function setChangeTab(tabId) {
        var viewPageUrl = '';

        if (vm.layout == 'N') {
          viewPageUrl = VIEW_PAGE_URL + '.' + tabId;
          // 수정
          $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId}, {reload:viewPageUrl});
        } else {
          viewPageUrl = LIST_VIEW_PAGE_URL + '.' + tabId;
          // 목록.수정 화면 이동
          $state.go(viewPageUrl, {srch: $stateParams.srch, keyId: $stateParams.keyId}, {reload:viewPageUrl});
        }
      }

      function setDelOwnerDataAction(param) {

        param.mapCode = "remoteJfc";
        param.remoteAction = "getUserType";

        postApi.openApi(param, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
          } else {
            }
        });
        var data = vm.data;
        data.mapCode = DEL_SHOP_SQL;
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if(result.body.docs[0].O_Result == 0) {
              gAlert('', 'Menu.DELETED', {
                btn: '',
                fn: function () {
                  // 삭제 성공
                  var srch = $stateParams.srch;

                  // 목록 화면 이동
                  $state.go(LIST_PAGE_URL, {
                      srch: srch
                    },
                    {reload: LIST_PAGE_URL});
                }
              });
            } else {
              gAlert('', '삭제되지 않았습니다.', {
                btn: '',
                fn: function () {
                  var srch = $stateParams.srch;

                  // 목록 화면 이동
                  $state.go(LIST_PAGE_URL, {
                      srch: srch
                    },
                    {reload: LIST_PAGE_URL});
                }
              });
            }
          }
        }, function (error) {
          // 삭제 중 오류 발생
          console.error("Error> delDataAction()");
          console.table(error);
        });
      }

      /** 
       * @description 우편번호 검색
      **/
      vm.srchZipCodeModal = function() {
        new daum.Postcode({
          oncomplete: function(data) {
            $timeout(function(){              

              // 현장간사 지역
              if(vm.chkAdminH){
                vm.cityDataH.pCode = data.sigunguCode.substring(0,2);
                vm.cityDataH.cCode = data.sigunguCode;
                vm.chgParCityCode('H',vm.cityDataH.pCode);
              }

              vm.data.ZipCode = data.zonecode;
              var addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
              vm.data.Addr1 = addr1;
            },0);
          },
        }).open();
      };

            /**
       * 역할 검색 팝업 호출
       *
       * @param {string}
       * @return {boolean}
       */
      vm.srchUserroleModal = function () {
        var ctrl = 'UserroleModalCtrl as vc';
        var paramData = {
          TenantId: vm.data.TenantId,
          UserRoles: vm.data.UserRoles
        };

        var modalInstance = modalFactory.open('modal', 'components/modal/userRole/userrole-modal.html', ctrl, paramData);
        modalInstance.result.then(function (okData) {
          // 역할 선택
          vm.data.UserRoles = okData;
          var UserRoleNms = [];
          var UserRoleIds = [];
          angular.forEach(vm.data.UserRoles, function (role) {
            UserRoleNms.push(role.RoleNm);
            UserRoleIds.push(role.RoleId);
            setAdminType(role.RoleNm);
          }); 
          
          // 현장간사 해제 시 관련 데이터 제거
          if( !vm.chkAdminH ) {
            vm.cityDataH.selCityCodeList = [];
            vm.cityDataH.selCityNameList = "";
          }

          vm.data.UserRoleNms = UserRoleNms.join(',');
          vm.data.UserRoleIds = UserRoleIds.join(',');

        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 역할 초기화
       *
       * @param {string}
       * @return {boolean}
       */
      vm.eraseUserRole = function () {
        vm.data.UserRoleIds = "";
        vm.data.UserRoleNms = "";
      };
      
      // 관리자구분 설정
      function setAdminType(rName){
        vm.data.AdminType = "U";
        vm.chkAdmin = false;
        vm.chkAdminSH = false;
        vm.chkAdminH = false;

        if(rName.indexOf('시스템관리자') != -1) {
          vm.data.AdminType = "A";
          vm.chkAdmin = true;
        }
        if(rName.indexOf('사무국') != -1) {
          vm.data.AdminType = "S";
          vm.chkAdminSH = true;
          vm.chkAdmin = true;
        }
        if(rName.indexOf('현장간사') != -1) {
          vm.data.AdminType = "H";
          vm.chkAdmin = true;
          vm.chkAdminSH = true;
          vm.chkAdminH = true;
        }
        if(rName.indexOf('봉사단') != -1) {
          vm.data.AdminType = "B";
          vm.chkAdmin = true;
        }
        if(rName.indexOf('후원기관관리자') != -1) {
          vm.data.AdminType = "G";
          vm.chkAdmin = true;
          vm.chkAdminG = true;
        }
        if(rName.indexOf('사례기관관리자') != -1) {
          vm.data.AdminType = "T";
          vm.chkAdmin = true;
        }
      }

      function getRoleUserList(){
        var data = {};
        data.mapCode = 'Role.getRoleUsers';
        data.UserId = vm.keyId;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              
              vm.data.UserRoles = result.body.docs;

              var UserRoleNms = [];
              var UserRoleIds = [];
              
              vm.data.UserRoles.forEach(function(item){
                UserRoleNms.push(item.RoleNm);
                UserRoleIds.push(item.RoleId);
              });

              vm.data.UserRoleNms = UserRoleNms.join(',');
              vm.data.UserRoleIds = UserRoleIds.join(',');
            }
          }
        });
      }

      // 현장간사 지역 시도 변경 시 시군구 목록 조회
      vm.chgParCityCode = function(type,p) {
        if( ! isNullOrEmpty(p)){
          switch(type){
            case "H":
              vm.cityDataH.cCodeList = vm.columnMap['CityCode'].CodeList.filter(function(e){
                return e.Code.substring(0,2) == p;
              });
              break;
            case "A":
              vm.cityDataAi.cCodeList = vm.columnMap['CityCode'].CodeList.filter(function(e){
                return e.Code.substring(0,2) == p;
              });
              break;
          }
        }
      };

      // 현장간사 지역 추가
      vm.selCityCode = function(type, c){   
        var p = c.substring(0,2);  
        vm.chgParCityCode(type,p); 
        var pData = vm.columnMap['ParCityCode'].CodeList.filter(function(e){ return e.Code == p; })[0];

        switch(type){
          case "H":           
            var cData = vm.cityDataH.cCodeList.filter(function(e){ return e.Code == c; })[0];
            vm.cityDataH.selCityCodeList.push({pName : pData.CodeValue, cName : cData.CodeValue, cCode : cData.Code});
            var comma = (isNullOrEmpty(vm.cityDataH.selCityNameList) ? "" : ", ");
            vm.cityDataH.selCityNameList = vm.cityDataH.selCityNameList + comma + pData.CodeValue +" "+ cData.CodeValue;
            break;
          
          case "A":           
            var cData = vm.cityDataAi.cCodeList.filter(function(e){ return e.Code == c; })[0];
            vm.cityDataAi.selCityCodeList.push({pName : pData.CodeValue, cName : cData.CodeValue, cCode : cData.Code});
            var comma = (isNullOrEmpty(vm.cityDataAi.selCityNameList) ? "" : ", ");
            vm.cityDataAi.selCityNameList = vm.cityDataAi.selCityNameList + comma + pData.CodeValue +" "+ cData.CodeValue;
            break;
        }
      }

      //  현장간사 지역 삭제
      vm.delCityCode = function(type, index) {
        switch(type){
          case "H": 
            vm.cityDataH.selCityCodeList.splice(index, 1);
            break;

          case "A": 
            vm.cityDataAi.selCityCodeList.splice(index, 1);
            break;
        }
      }      

      vm.goBack = function() {
        $window.history.back();
      }

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.getIsShowColumn = getIsShowColumn;     // 등록/수정 화면에 표시할 컬럼인지 여부 확인
      vm.getRoleList = getRoleList;             // 역할 목록 조회

      vm.setData = setData;                     // 데이터 저장
      vm.editData = editData;

      vm.goList = goList;                       // 목록 화면 이동
      vm.getIsDupLoginId = getIsDupLoginId;     // 사용자 중복 체크
      vm.delData = delData;               // 데이터 삭제

      vm.setChangeTab = setChangeTab;
      vm.setDelOwnerDataAction = setDelOwnerDataAction;

      // 데이터 조회
      getData();
    }]);

})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name PersonalUserEditTab1Ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @param {object} $filter - filter object
   */
  webapp.controller('PersonalUserEditTab1Ctrl', 
    ['$scope','$stateParams', 'fileUploadService', 'StaticVariable', '$rootScope', 'postApi', 'modalFactory', 'GLOBAL_CONSTANT', 'gAlert',
    function PersonalUserEditTab1Ctrl($scope, $stateParams, fileUploadService, StaticVariable, $rootScope, postApi, modalFactory, CONSTANT, gAlert) {

      var vm = this;  // View Model
      vm.pageType = $stateParams.type;
      vm.KeyId = $stateParams.keyId;

      var LIST_SQL = 'User.getUserseduhistoryList';
      var LIST_CNT_SQL = 'User.getUserseduhistoryListCnt';
      var DEL_SQL = 'User.delUserseduhistoryList';

      var KEY_TABLE_NM = 'userseduhistory';
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      vm.getList = getList;
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;
      vm.delData = delData;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',         // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.KeyId = vm.KeyId;
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.KeyId = vm.KeyId;
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정

        data.mapCode = LIST_SQL;

        getListCnt(); // 목록 건수 조회

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              /* angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
              }); */
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

       /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        getList();
        // 해당 페이지 데이터 조회
        //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getList();
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      function delData() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].keyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> delData()");
          console.table(error);
        });
      }

      getList();

      setInitData();

      /******************************************************************************** */
      // 확장 기능 개발 구간 시작

      /** 
      * @description 학력사항 추가 팝업
      **/
      vm.setData = function() {
        var ctrl = 'UserseduhistoryModalCtrl as vc';
        var paramData = { KeyId : $stateParams.keyId, AddYn : true };
        var modalInstance = modalFactory.open('lg', 'app/personal/user/modal/userseduhistory-modal-view.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          getList();
        }, function(cancelData) {
          // 취소
        });
      };

      vm.editData = function(p) {
        var ctrl = 'UserseduhistoryModalCtrl as vc';
        var paramData = { KeyId : p, AddYn : false };
        var modalInstance = modalFactory.open('lg', 'app/personal/user/modal/userseduhistory-modal-view.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          getList();
        }, function(cancelData) {
          // 취소
        });
      };

      
      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        vm.setResetSearch();  
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });
      
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name PersonalUserEditTab2Ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @param {object} $filter - filter object
   */
  webapp.controller('PersonalUserEditTab2Ctrl', 
    ['$scope','$stateParams', 'fileUploadService', 'StaticVariable', '$rootScope', 'postApi', 'modalFactory', 'GLOBAL_CONSTANT', 'gAlert',
    function PersonalUserEditTab2Ctrl($scope, $stateParams, fileUploadService, StaticVariable, $rootScope, postApi, modalFactory, CONSTANT, gAlert) {

      var vm = this;  // View Model
      vm.pageType = $stateParams.type;
      vm.KeyId = $stateParams.keyId;

      var LIST_SQL = 'User.getUsersqualiList';
      var LIST_CNT_SQL = 'User.getUsersqualiListCnt';
      var DEL_SQL = 'User.delUsersqualiList';

      var KEY_TABLE_NM = 'usersquali';
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      vm.getList = getList;
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;
      vm.delData = delData;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',         // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.KeyId = vm.KeyId;
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.KeyId = vm.KeyId;
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정

        data.mapCode = LIST_SQL;

        getListCnt(); // 목록 건수 조회

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              /* angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
              }); */
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              console.log('lists', vm.lists);
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

       /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        getList();
        // 해당 페이지 데이터 조회
        //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getList();
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      function delData() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].keyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> delData()");
          console.table(error);
        });
      }

      getList();

      setInitData();

      /******************************************************************************** */
      // 확장 기능 개발 구간 시작

      /** 
      * @description 학력사항 추가 팝업
      **/
      vm.setData = function() {
        var ctrl = 'UsersqualiModalCtrl as vc';
        var paramData = { KeyId : $stateParams.keyId, AddYn : true };
        var modalInstance = modalFactory.open('lg', 'app/personal/user/modal/usersquali-modal-view.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          getList();
        }, function(cancelData) {
          // 취소
        });
      };

      vm.editData = function(p) {
        var ctrl = 'UsersqualiModalCtrl as vc';
        var paramData = { KeyId : p, AddYn : false };
        var modalInstance = modalFactory.open('lg', 'app/personal/user/modal/usersquali-modal-view.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          getList();
        }, function(cancelData) {
          // 취소
        });
      };

      
      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        vm.setResetSearch();  
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });
      
    }]);
})();

(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name PersonalUserEditTab2Ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @param {object} $filter - filter object
   */
  webapp.controller('PersonalUserEditTab3Ctrl', 
    ['$scope','$stateParams', 'fileUploadService', 'StaticVariable', '$rootScope', 'postApi', 'modalFactory', 'GLOBAL_CONSTANT', 'gAlert',
    function PersonalUserEditTab3Ctrl($scope, $stateParams, fileUploadService, StaticVariable, $rootScope, postApi, modalFactory, CONSTANT, gAlert) {

      var vm = this;  // View Model
      vm.pageType = $stateParams.type;
      vm.KeyId = $stateParams.keyId;

      var LIST_SQL = 'User.getUserscareerList';
      var LIST_CNT_SQL = 'User.getUserscareerListCnt';
      var DEL_SQL = 'User.delUserscareerList';

      var KEY_TABLE_NM = 'userscareer';
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      vm.getList = getList;
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;
      vm.delData = delData;

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',         // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.KeyId = vm.KeyId;
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.KeyId = vm.KeyId;
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정

        data.mapCode = LIST_SQL;

        getListCnt(); // 목록 건수 조회

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              /* angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
              }); */
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              console.log('lists', vm.lists);
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);
        });
      }

       /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        getList();
        // 해당 페이지 데이터 조회
        //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getList();
      }

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      function delData() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            vm.srch.KeyIdList.push(vm.lists[i].keyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DEL_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> delData()");
          console.table(error);
        });
      }

      getList();

      setInitData();

      /******************************************************************************** */
      // 확장 기능 개발 구간 시작

      /** 
      * @description 학력사항 추가 팝업
      **/
      vm.setData = function() {
        var ctrl = 'UserscareerModalCtrl as vc';
        var paramData = { KeyId : $stateParams.keyId, AddYn : true };
        var modalInstance = modalFactory.open('lg', 'app/personal/user/modal/userscareer-modal-view.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          getList();
        }, function(cancelData) {
          // 취소
        });
      };

      vm.editData = function(p) {
        var ctrl = 'UserscareerModalCtrl as vc';
        var paramData = { KeyId : p, AddYn : false };
        var modalInstance = modalFactory.open('lg', 'app/personal/user/modal/userscareer-modal-view.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          getList();
        }, function(cancelData) {
          // 취소
        });
      };

      
      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        vm.setResetSearch();  
        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });
      
    }]);
})();


(function () {
  "use strict";
  webapp.controller('PersonalUserListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function PersonalUserListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'User.getUserListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'User.getUserList';    // 목록 조회 SQL
      var EXCEL_SQL = 'User.getExcelList'; // 엑셀다운로드 SQL
      var DELETE_LIST_SQL = 'User.deleteUserList'; // 목록에서 삭제

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.personal.user-list';         // 목록 화면
      var LIST_EDIT_PAGE_URL = 'app.personal.user-list.edit';         // 목록 화면
      var EDIT_PAGE_URL = 'app.personal.user-edit';    // 등록/수정 화면
      //var VIEW_PAGE_URL = 'app.personal.user-detail';       // 상세 화면
      var VIEW_PAGE_URL = 'app.personal.user-edit';       // 상세 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'users'; // 작업 테이블명
      var KEY_COLUMN_NM = 'UserId'; // Primary Key Column
      var EXCEL_TITLE = '임직원관리 목록'; //User 엑셀파일 이름
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김
      vm.changeable = false;
      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: ''          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.EntryDtFrom = $rootScope.getDateFormat(vm.srch.EntryDtFrom); // YYYY-MM-DD 를 date type 으로 변환
        vm.EntryDtTo = $rootScope.getDateFormat(vm.srch.EntryDtTo);
        if (!vm.srch.viewSize ) vm.srch.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
        vm.currentPage = vm.srch.page;        
      }

      vm.loginUserAdminType = !isNullOrEmpty($window.sessionStorage['loginUserAdminType']) ? $window.sessionStorage['loginUserAdminType'] : "";                              // 관리자 구분

      vm.keyId = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));

        // 데이터 조회
        $state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {
          srch: ''
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.EntryDtFrom = $filter('localToUtc')(data.EntryDtFrom, 'from');
        data.EntryDtTo = $filter('localToUtc')(data.EntryDtTo, 'to');

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.EntryDtFrom = $filter('localToUtc')(data.EntryDtFrom, 'from');
        data.EntryDtTo = $filter('localToUtc')(data.EntryDtTo, 'to');
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            console.error(vm.columnMap);

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              vm.data = result.body.docs[0];
              // 시스템관리자, 사무국, 후원기관, 사례관리기관 관리자만 수정 가능
              if(vm.loginUserAdminType == "A" || vm.loginUserAdminType == "S" || vm.loginUserAdminType == "G" || vm.loginUserAdminType == "T") {                
                vm.changeable = true;
              }
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 신규 추가 - 등록/수정 화면 이동
       * @param
       * @return
       */
      function goAdd() {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = '';

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: ''
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      /**
       * Excel 파일 다운로드
       * @param
       * @return
       */
      function getExcelFile() {

        if(vm.lists.length == undefined) {
          gAlert("","조회 후 엑셀을 다운로드 하십시오.");
          return;
        }

        if(vm.lists.length == 0) {
          gAlert("","Menu.데이터가 없습니다.");
          return;
        }

        var header = [];
        var a = document.createElement("a");
        document.body.appendChild(a);

        var data = vm.srch;
        data.mapCode = EXCEL_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $scope.jsonToExport = result.body.docs;
            $scope.fileName = EXCEL_TITLE;
            $scope.exportData = [];

            var obj = [];

            angular.forEach(vm.columnMap, function (item) {
              if(item.ListColumnShowLevel != "showlevel0") {
                obj.push(item.ColumnLogicalNm);
              }
            });
            $scope.exportData.push(obj);

            // Data:
            angular.forEach($scope.jsonToExport, function(value) {
              obj = [];
              angular.forEach(vm.columnMap, function(item) {
                if(item.ListColumnShowLevel != "showlevel0") {
                  if(item.ColumnPhysicalNm == 'EntryDt') {
                    if (!isNullOrEmpty(value[item.ColumnPhysicalNm])) {
                      obj.push(moment(value[item.ColumnPhysicalNm]).toDate());
                    } else {
                      obj.push(value[item.ColumnPhysicalNm]);
                    }
                  } else {
                    obj.push(value[item.ColumnPhysicalNm]);
                  }
                }
              });
              $scope.exportData.push(obj);
            });

            $rootScope.excelDown($scope.exportData,$scope.fileName);
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getExcelFile()");
          console.table(error);
        });
      }


      /**
       * 부서 검색 팝업 호출
       *
       * @param
       * @return
       */
      vm.srchDeptModal = function () {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        // 부서 검색 팝업 호출
        var modalInstance = modalFactory.open('modal', 'components/modal/department/dept-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          // 부서 선택
          vm.srch.DeptNm = okData.label;
          vm.srch.DeptId = okData.data;
        }, function (cancelData) {
          // 취소
        });
      };

      /**
       * 부서 초기화
       *
       * @param
       * @return
       */
      vm.eraseDept = function () {
        vm.srch.DeptNm = "";
        vm.srch.DeptId = "";
      };

      /**
       * 초기 데이터 설정
       * @param
       * @return
       */
      function setInitData() {
        // 목록 체크박스 로직 설정
        vm.chkHead = false;
        $scope.chkRowChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            if (!vm.lists[i].isChecked) {
              vm.chkHead = false;
              return;
            }
          }
          vm.chkHead = true;
        };

        $scope.chkHeadChg = function () {
          for (var i = 0; i < vm.lists.length; i++) {
            vm.lists[i].chkRow = vm.chkHead;
          }
        };

      }

      /**
       * 목록 삭제 확인
       * @param
       * @return
       */
      function setDelList() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            setDelListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      /**
       * 목록 삭제
       * @param
       * @return
       */
      function setDelListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow)
          {
            vm.srch.KeyIdList.push(vm.lists[i].KeyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = DELETE_LIST_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getList();
              }
            });
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> setDelListAction()");
          console.table(error);
        });
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goAdd = goAdd;                           // 신규추가 - 등록/수정 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정
      vm.setDelList = setDelList;                 // 목록 삭제
      vm.getExcelFile = getExcelFile;             // Excel 파일 다운로드

      // 목록 조회
      getList();

      // 초기 데이터 설정
      setInitData();
    }]);
})();

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.system:common-properties-ctrl
 * @description
 * # 공통설정
 * Controller of the 공통설정
 */

webapp.controller('CommonPropertiesCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gAlert', 'gConfirm', '$translate',
/**
 * 시스템관리 - 공통설정 Control
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param postApi - postApi Module
 */
  function CommonPropertiesCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi, gAlert, gConfirm, $translate) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    // TenantId
    vm.TenantId = $window.sessionStorage['loginTenantId'];

    // 회원사 변경 체크
    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      getList();

      $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
    });

    vm.srch = {};

    vm.lists = [];

    /**
     * 데이터 조회
     *
     * @param
     * @return
    */
    function getList() {
      //getListCount();
      vm.dataloader = true;

      var data = vm.srch;
      postApi.sendPostApi('api/CommonProperties', 'getCommonPropertiesList', data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;

            angular.forEach(vm.lists, function(item) {
              item.makeCustomYN = 'Y';
            });
          } else {
            vm.totalItems = 0;
            vm.lists = [];
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', status, data);
        vm.dataloader = false;
      });
    }

    function getListCount() {
      var data = vm.srch;
      data.mapCode = 'CommonProperties.getCommonPropertiesList';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.error('Error-getList', status, data);
      });
    }

    function saveListComment() {
      if ($rootScope.gVariable.srchTenantId == 0 || $rootScope.gVariable.SysAdminYN != 'Y') {
        saveList();
        return;
      }

      gConfirm('', 'Menu.SAVECONFIRM', {
        btn : '',
        fn : function() {
          saveList();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function saveList() {
      //getListCount();
      if(!$scope.form1.$valid) {
        return false;
      }

      vm.dataloader = true;

      var data = {lists : []};
      angular.forEach(vm.lists, function(item) {
        if (item.makeCustomYN && item.makeCustomYN == 'Y') {
          data.lists.push(item);
        }
      });

      if (data.lists.length == 0) {
        return;
      }

      data.mapCode = 'CommonProperties.insertCommoncodeDetailBatch';

      postApi.insert(data, function(result) {
        vm.dataloader = false;
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          getList();
        }
      }, function(error) {
        console.error('Error-getList', status, data);
        vm.dataloader = false;
      });
    }

    function addNew() {
      var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
      var commonPropertiesId = newnum.toString(36);

      var item = {
        CommonPropertiesId:commonPropertiesId,
        isNew:'Y',
        TenantId:$rootScope.gVariable.srchTenantId,
        makeCustomYN:'Y'
      };
      vm.lists.push(item);
    }

    function checkChanged(li) {
      if (li.DelYN == 'Y') {
        if (li.isNew == 'Y') {
          angular.forEach(vm.lists, function(item, key) {
            if (item.CommonPropertiesId == li.CommonPropertiesId) {
              console.log(item, key);
              vm.lists.splice(key, 1);
            }
          });
        }
      }
    }

    // 함수 선언
    vm.getList = getList;
    vm.saveList = saveList;
    vm.saveListComment = saveListComment;
    vm.addNew = addNew;
    vm.checkChanged = checkChanged;

    // 데이터 조회
    getList();
  }, ]);
})();

webapp.service('CommoncodeAPISrv', [ '$resource', 'StaticVariable', function CommoncodeAPISrv($resource, StaticVariable) {
  console.log('CommoncodeAPISrv');
  var api = {
    doList : function() {
      return $resource(StaticVariable.getUrl('/select/CommonCode.getCommonCodeList/action.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doSaveList : function() {
      return $resource(StaticVariable.getUrl('/api/system/updateCommoncodeListBatch.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doUpdateDeviceInfoStatusCd : function() {
      return $resource(StaticVariable.getUrl('/api/device/updateDeviceInfoStatusCd.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
    doTreeList : function() {
      return $resource(StaticVariable.getUrl('/select/CommonCode.getCommonCodeTreeList/action.json'), {}, StaticVariable.getRequestActions.defaultAction());
    },
  };
  return api;
} ]);

webapp.controller('CommoncodeListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'CommoncodeAPISrv', 'modalFactory', '$interval', '$timeout',
    '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', 'postApi', '$translate', function CommoncodeListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, api, modalWindow, $interval, $timeout, $mdUtil, $mdSidenav, gAlert, gConfirm, postApi, $translate) {
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
      vm.maxcommoncodeid = 0;
      vm.lists = [];
      vm.saveYn = true;
      vm.data = {CustomCode: 0};

      $scope.toggleLeft = buildToggler('left');
      $scope.toggleRight = buildToggler('right');
      /**
       * Build handler to open/close a SideNav; when animation finishes
       * report completion in console
       */
      function buildToggler(navID) {
        var debounceFn = $mdUtil.debounce(function() {
          $mdSidenav(navID).toggle().then(function() {
            console.debug("toggle " + navID + " is done");
          });
        }, 200);
        return debounceFn;
      }

      $scope.init = function() {
        // check if there is query in url
        // and fire search in case its value is not empty
      };

      // stops the interval
      $scope.$on("$destroy", function() {
      });

      $scope.$on('broadcastSetChangeTenantID', function(event, data) {
        resetList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      function resetSearch() {
        vm.srch.CodeValue = '';
        vm.data = {CustomCode: 0};
        tree.select_branch(null);
      }

      function resetList() {
        resetSearch();

        getTreeList();
      }

      vm.nextSearch = function() {
        tree.next_search_text();
      };

      // 함수 선언
      vm.resetSearch = resetSearch;
      vm.resetList = resetList;
      vm.getTreeList = getTreeList;
      vm.delNode = delNode;
      vm.delNodeCancel = delNodeCancel;
      vm.saveData = saveData;
      vm.onChangeCodeValue = onChangeCodeValue;
      vm.onChangeCode = onChangeCode;
      vm.onChanged = onChanged;
      vm.ChangeCustomCode = ChangeCustomCode;
      vm.parentCodeValue01 = '';

      // my_tree 반드시 선언하기
      var tree;
      $scope.my_tree = tree = {};

      vm.topItem = null;

      vm.UseYNData = {
        CallbackTarget : '0000',
        CodeType : 'USEYN',
        Code : vm.data.UseYN,
        ReloadSeq : 1
      };

      vm.onSelectCallback = function(data) {
        if (data.CallbackTarget == '0000') {
          vm.data.UseYN = data.Code;
        }
      };

      getTreeList();

      function getTreeList() {
        // 사전에 트리 선언함.(중요포인트)
        vm.dataloader = true;
        $scope.my_data = [];

        // 로케이션관리 select 검색실행함
        var data = vm.srch;
        data.mapCode = 'CommonCode.getCommonCodeTreeList';
        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length == 0) {
              return;
            }

            // select한 datatable 바인딩
            vm.lists = result.body.docs;

            vm.topItem = result.body.docs[0];

            refreshTree();

            // 트리 펼치기
            $timeout(function() {
              return tree.expand_init();

            }, 1);
          }
        }, function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

      // 계층형 json 부모/자식 구분하여 구조 변환
      function insert(obj, item) {
        var parent = item.parent; // 부모값
        var map = obj.map;
        map[item.guid] = item; // 아이템 구성함

        if (parent === null)
          obj.res.push(item); // 부모값 생성
        else {
          var parentItem = map[parent];
          // 자식값 생성
          if (parentItem != null) {
            if (parentItem.hasOwnProperty("children"))
              parentItem.children.push(item);
            else
              parentItem.children = [ item ];
          }
        }

        return obj;
      }

      // guid, parent 제외한 계층형 json 구조 변환하기
      function traverse(jsonObj) {

        for (var i = 0; i < jsonObj.length; i++) {
          if (jsonObj[i].children == null) {
          } else {
            traverse(jsonObj[i].children);
          }

          // label, children 만 추가함
          var newItem = {
            "label" : jsonObj[i].label,
            "data" : jsonObj[i].guid,
            "children" : jsonObj[i].children,
            "classes" : jsonObj[i].classes,
          }
          jsonObj[i] = newItem;
        }
      }

      // 트리 목록에서 조회값
      $scope.my_tree_handler = function(branch) {
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.CommonCodeId.toString()) {
            vm.data = item;
            vm.UseYNData = {
              CallbackTarget : '0000',
              CodeType : 'USEYN',
              Code : vm.data.UseYN,
              ReloadSeq : (new Date()).getTime()
            };

            var pBranch = tree.get_parent_branch(branch);

            vm.parentCodeValue01 = '';

            if (pBranch) {
              angular.forEach(vm.lists, function(pItem) {
                if (pBranch.data == pItem.CommonCodeId.toString()) {
                  vm.parentCodeValue01 = pItem.CodeValue01;
                }
              });
            }

            return;
          }
        });
      };

      $scope.try_adding_a_branch = function() {

        var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
        var commonCodeId = newnum.toString(36);

        var branch = tree.get_selected_branch();
        if (branch == null) {
          var commoncode = {
            'CodeValue' : '새로운 코드',
            'CommonCodeId' : commonCodeId,
            'ParentCommonCodeId' : 0,
            'CodeLevel' : 1,
            'UseYN' : 'Y',
            'New' : 'Y',
            'CodeType' : '',
            'TenantId' : $rootScope.gVariable.srchTenantId,
            'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1
          };
          vm.lists.push(commoncode);
        } else {
          angular.forEach(vm.lists, function(item) {
            if (branch.data == item.CommonCodeId.toString()) {
              var commoncode = {
                'CodeValue' : '새로운 코드',
                'CommonCodeId' : commonCodeId,
                'ParentCommonCodeId' : branch.data,
                'CodeLevel' : item.CodeLevel + 1,
                'UseYN' : 'Y',
                'New' : 'Y',
                'CodeType' : item.CodeType == '000' ? item.Code : item.CodeType,
                'TenantId' : $rootScope.gVariable.srchTenantId,
                'CustomCode' : $rootScope.gVariable.srchTenantId == 0 ? 0 : 1,
                'CodeValue01' : item.CodeValue01,
                'SysCodeYN' : item.SysCodeYN
              };
              vm.lists.push(commoncode);
              vm.parentCodeValue01 = item.CodeValue01;
              return;
            }
          });
        }

        var code = {};
        if ($rootScope.gVariable.srchTenantId == 0) {
          code = {label: '[*]새로운 코드', data: commonCodeId};
        } else {
          code = {label: '[*]새로운 코드', data: commonCodeId, classes: ['color-red']};
        }
        var new_branch = tree.add_branch(branch, code);
        tree.select_branch(new_branch);
      };

      function delNode() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        if (tree.get_children(branch) != null && tree.get_children(branch).length > 0) {
          $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'));
          return;
        }

        gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
          btn : '',
          fn : function(){
            if (vm.data.New == 'Y'){
              deleteNodeTree();
            }else {
              vm.data.DelYN = 'Y';
              saveData();
            }
          }
        }, {
          btn : '',
          fn : function(){
          }
        });
      }

      function deleteNodeTree() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.CommonCodeId.toString()) {
            var index = vm.lists.indexOf(item);
            vm.lists.splice(index, 1);

            var parent = tree.select_parent_branch();
            if(parent){
              parent.children.splice(parent.children.indexOf(branch),1);
            } else {
              refreshTree();
            }

            return;
          }
        });

        tree.select_branch(null);
        vm.data = {CustomCode: 0};
      }

      function refreshTree() {

        // 리스트 생성
        var arrlist = [];

        // for문으로 다시 json 구조로 변환함.
        angular.forEach(vm.lists, function(item) {
          // 객체 생성
          var data = {};

          data.label = $translate.instant(item.CodeValue);
          data.guid = item.CommonCodeId;
          data.parent = item.ParentCommonCodeId == undefined || item.ParentCommonCodeId == 0 ? null : item.ParentCommonCodeId;
          data.classes = [];
          data.classes.push(item.TenantId == '0' ? '' : 'color-red');

          // 리스트에 생성된 객체 삽입
          arrlist.push(data);

          if (item.CommonCodeId > vm.maxcommoncodeid)
            vm.maxcommoncodeid = item.CommonCodeId;
        });

        // 계층형 json 구조로 변환함
        var recursiveArray = unflatten(arrlist);

        // guid, parent 제외 변환함
        traverse(recursiveArray);

        // 트리구조에 바인딩
        $scope.my_data = recursiveArray;

        // 트리 펼치기
//        $timeout(function() {
//          return tree.expand_all();
//        }, 1);

      }

      function onChangeCodeValue() {
        onChanged();
        var branch = tree.get_selected_branch();
        if (branch == null) return;
          branch.label = '[*]' + vm.data.CodeValue;
      }

      function onChangeCode() {
        onChanged();
        if (vm.data.New == 'Y') {
        }

        if (vm.parentCodeValue01) {
          vm.data.CodeValue01 = vm.parentCodeValue01 + "." + vm.data.Code;
        } else {
          vm.data.CodeValue01 = vm.data.Code;
        }
      }

      function onChanged() {
        if (vm.data.New == null || vm.data.New != 'Y') {
          vm.data.Edit = 'Y';
        }
      }

      function removeNode(jsonObj, commonCodeId) {
        for (var i = 0; i < jsonObj.length; i++) {
          console.log('jsonObj[i]=', jsonObj[i]);
          console.log('CommonCodeId=', commonCodeId);

          if (jsonObj[i].data == commonCodeId) {
            jsonObj[i].children = [];
            return true;
          }

          if (jsonObj[i].children == null) {
          } else {
            if (removeNode(jsonObj[i].children, commonCodeId) == true)
              break;
          }
        }
      }

      function delNodeCancel() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.CommonCodeId.toString()) {
            item.DelYN = 'N';
            branch.label = branch.label.replace(/^\[X\]/,"");;
            return;
          }
        });
      }

      function saveData() {
        vm.dataloader = true;
        var data = {lists : []};
        data.mapCode = 'CommonCode.insertCommoncodeDetailBatch';
        data.lists.push(vm.data);
        postApi.insert(data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            var branch = tree.get_selected_branch();
            branch.label = branch.label.replace(/^\[\*\]/,"");

            if (vm.data.New == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.data.New = '';
            } else if (vm.data.DelYN == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.DELETED'));
              deleteNodeTree();
            } else {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
              vm.data.Edit = '';
            }
//            getTreeList();
          }
        },

        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });

      }

      function ChangeCustomCode() {
        console.log($rootScope.gVariable);
        if (vm.data.CustomCode == 0) {
          gConfirm('', $translate.instant('MSG.CUSTOMCODESTART'), {
            btn : '',
            fn : function(){
              var data = vm.data;
              var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
              data.NewCommonCodeId = newnum.toString(36).toUpperCase();
              data.mapCode = 'CommonCode.makeCustomCommonCode';
              postApi.insert(data, function(result) {
                if (result.header.status == CONSTANT.HttpStatus.OK) {
                  getTreeList();
                  vm.data.CustomCode = 1;
                }
              }, function(error) {
                console.error('fail', status, data);
              });
            }
          }, {
            btn : '',
            fn : function(){
            }
          });
        } else {
          gConfirm('', $translate.instant('MSG.CUSTOMCODESTOP'), {
            btn : '',
            fn : function(){
              var data = vm.data;
              data.mapCode = 'CommonCode.removeCustomCommonCode';
              postApi.update(data, function(result) {
                if (result.header.status == CONSTANT.HttpStatus.OK) {
                  getTreeList();
                  vm.data.CustomCode = 0;
                }
              }, function(error) {
                console.error('fail', status, data);
              });
            }
          }, {
            btn : '',
            fn : function(){
            }
          });
        }
      }

    } ]);


webapp.controller('MakeQueryListCtrl', 
['$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', 'GLOBAL_CONSTANT', 'postApi', 'modalFactory', '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', '$timeout',
function MakeQueryList($window, $scope, $location, $state, $stateParams, $rootScope, $translate, CONSTANT, postApi, modalFactory, $mdUtil, $mdSidenav, gAlert, gConfirm, $timeout) {
    

  var vm = this;
  vm.tableSchema = "mmg";
  vm.tables = []; // 테이블리스트
  vm.cols = []; // 컬럼리스트

  vm.namespace; // Mapper ID

  vm.checkMainTb = false;
  vm.tbMain = {}; // 메인 정보
  vm.tbJoins = []; // 조인테이블 정보
  // vm.innerjoinTb = []; // InnerJoin Table
  // vm.leftjoinTb = []; // LeftJoin Table

  vm.tempColsData = {}; // 호출된 테이블 컬럼을 임시로 저장한다.
  vm.checkDrawView = false;

  vm.copyFn = function() {
    console.log("copy")

    if(document.body.createTextRange) {
      var textRange = document.body.createTextRange();
      textRange.moveToElementText(document.getElementById("queryView"))
      textRange.execCommand("Copy");
      gAlert("","복사하였습니다.")
    } else {
      window.getSelection().selectAllChildren(document.getElementById("queryView"));
      document.execCommand("Copy");
      gAlert("","복사하였습니다.")
    }

  }

  vm.blurAlis = function(p) {
    var param = {};
    param = JSON.parse(JSON.stringify(p))
    param.mapCode = "makeQuery.setTbAlias";
    postApi.select(param, function(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        param.mapCode = "makeQuery.getAliasTable";
        postApi.select(param, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            p.rkey = result.body.docs[0].rkey;
          }
        });
      }
    });
  }

  vm.changeAlis = function(p) {
    
    p.aliasNm = p.aliasNm.toUpperCase();
    if(vm.checkMainTb) {
      if(p.tbNm.toLowerCase() == vm.tbMain.tableNm.toLowerCase()) {
        vm.tbMain.aliasNm = p.aliasNm.toUpperCase();
      }
    }

    var keys = Object.keys(vm.tempColsData);
    if(keys.length > 0) {
      if(vm.tempColsData[p.tbNm] != undefined) {
        vm.tempColsData[p.tbNm].aliasNm = p.aliasNm.toUpperCase();
      }
    }

    if(vm.cols.length > 0) {
      for(var i = 0; i < vm.cols.length; i++) {
        if(p.tbNm.toLowerCase() == vm.cols[i].tbNm.toLowerCase()) {
          vm.cols[i].aliasNm = p.aliasNm.toUpperCase();
        }
      }
    }
  };

  vm.setMainTable = function(p) {
    var checkCount = 0;
    angular.forEach(vm.tables, function(item) {
      if(p.tbNm != item.tbNm) {
        item.mChecked = false;
      } else checkCount++;
    });

    if(checkCount > 0) vm.checkMainTb = true;

    vm.tbMain.tableNm = p.tbNm.substring(0,1).toUpperCase() + p.tbNm.substring(1,p.tbNm.length).toLowerCase();
    vm.tbMain.aliasNm = p.aliasNm.toUpperCase();
    vm.setColData(p, "m");
  };

  vm.setJoinTable = function(p) {
    vm.tbJoins = [];
    vm.setColData(p, "ij");
  };

  vm.setColData = function(p, type){

    if( vm.tempColsData[p.tbNm] == undefined) {
      var param = {};
      param.mapCode = "makeQuery.getTableColumnList";
      param.tableSchema = vm.tableSchema;
      param.tbNm = p.tbNm;

      postApi.select(param, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.tempColsData[p.tbNm] = {};
          vm.tempColsData[p.tbNm]["aliasNm"] = p.aliasNm;
          vm.tempColsData[p.tbNm]["cols"] = result.body.docs;

          var pk = "";
          for(var i = 0; i < result.body.docs.length; i++) {
            var at = result.body.docs[i];
            if(at.column_key == "PRI") {
              pk = at.column_name;
              break;
            }
          }
          p.pk = pk;
          vm.initColData(p, type);
        }
      });
    } else {
      vm.initColData(p, type);
    }
    vm.writeQueryField();
  };

  vm.writeQueryField = function() {

  };

  vm.initColData = function(p, type){
    vm.cols = [];
    var mainCols = [], joinCols =[];
    angular.forEach(vm.tables, function(item) {
      if(p.tbNm != item.tbNm) {
        if(type == "m") {
          item.mChecked = false;
        }
      }
    })
    angular.forEach(vm.tables, function(item) {
      if(item.mChecked) {
        for(var i = 0; i < vm.tempColsData[item.tbNm].cols.length; i++) {
          vm.cols.push( 
            {tbNm: item.tbNm, aliasNm : vm.tempColsData[item.tbNm].aliasNm, colNm : vm.tempColsData[item.tbNm].cols[i].column_name, 
            dataType : vm.tempColsData[item.tbNm].cols[i].data_type, 
            priYn : (vm.tempColsData[item.tbNm].cols[i].column_key == 'PRI') ? 'Y':'N', 
            checkedYn: true, selectType: "m" } 
          ) 
        }
      }

      if(item.ijChecked) {
        vm.tbJoins.push(item);
        for(var i = 0; i < vm.tempColsData[item.tbNm].cols.length; i++) {
          joinCols.push( 
            {tbNm: item.tbNm, aliasNm : vm.tempColsData[item.tbNm].aliasNm, colNm : vm.tempColsData[item.tbNm].cols[i].column_name, 
            dataType : vm.tempColsData[item.tbNm].cols[i].data_type, 
            priYn : (vm.tempColsData[item.tbNm].cols[i].column_key == 'PRI') ? 'Y':'N', 
            checkedYn: true, selectType: "i" } 
          ) 
        }
      }

      if(item.ljChecked) {
        vm.tbJoins.push(item);
        for(var i = 0; i < vm.tempColsData[item.tbNm].cols.length; i++) {
          joinCols.push( 
            {tbNm: item.tbNm, aliasNm : vm.tempColsData[item.tbNm].aliasNm, colNm : vm.tempColsData[item.tbNm].cols[i].column_name,
            dataType : vm.tempColsData[item.tbNm].cols[i].data_type, 
            priYn : (vm.tempColsData[item.tbNm].cols[i].column_key == 'PRI') ? 'Y':'N', 
            checkedYn: true, selectType: "l" } 
          ) 
        }
      }
    });
    angular.forEach(joinCols, function(item) {
      vm.cols.push(item);
    })
    if(vm.cols.length > 0) vm.checkDrawView = true;
    else  vm.checkDrawView = false;
  };

  vm.changeMapperId = function() {
    vm.namespace = htpt('<mapper namespace="'+ vm.mapperId +'">');
  }


  function htpt(str) {
    var str = String(str).replaceAll("<", "&lt;").replaceAll(">", "&gt;");
    return  str.replaceAll("undefined", "");
  }
  vm.getTableList = function() {

    var param = {};
    param.mapCode = "makeQuery.getTableList";
    param.tableSchema = vm.tableSchema;
    postApi.select(param, function(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        vm.tables = result.body.docs;

        for(var i = 0; i < vm.tables.length; i++) {
          var at = vm.tables[i];
          if(at.aliasNm == undefined) at.aliasNm = at.tbNm.toLowerCase();
        }
      }
    })
  }
  vm.init = function() {

    vm.getTableList();
    vm.namespace = htpt('<mapper namespace="'+ vm.mapperId +'">');
    vm.mapperend = htpt('</mapper>');

  }

  vm.init();
}]);



webapp.service('DepartmentAPISrv', ['$resource', 'StaticVariable',
    function DepartmentAPISrv($resource, StaticVariable) {
		console.log('DepartmentAPISrv');
    	var hDepartmentApi = {
    		doList : function() {
    			return $resource(StaticVariable.getUrl('/select/Department.getDepartmentList/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
        doTreeList : function() {
          return $resource(StaticVariable.getUrl('/select/Department.getDepartmentTreeList/action.json'), {},
              StaticVariable.getRequestActions.defaultAction());
        },
        doSaveList : function() {
          return $resource(StaticVariable.getUrl('/update/Department.updateDepartmentTreeListBatch/action.json'), {},
              StaticVariable.getRequestActions.defaultAction());
        },
    		doListCnt : function() {
    			return $resource(StaticVariable.getUrl('/select/Department.getDepartmentCount/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
    		doDetail : function() {
    			return $resource(StaticVariable.getUrl('/select/Department.getDepartmentDetail/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
    		doUpdateDetail : function() {
    			return $resource(StaticVariable.getUrl('/update/Department.updateDepartmentDetail/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
    		doInsertDetail : function() {
    			return $resource(StaticVariable.getUrl('/insert/Department.insertDepartmentDetail/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			},
    		doDelete : function() {
    			return $resource(StaticVariable.getUrl('/update/Department.deleteDepartmentDetail/action.json'), {},
    					StaticVariable.getRequestActions.defaultAction());
   			}
    	};
    	return hDepartmentApi;
	}
]);

webapp.controller('DepartmentDetailCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'DepartmentAPISrv', 'gAlert', 'gConfirm',
    'fileUploadService', function DepartmentDetailCtrl($window, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, departmentApi, gAlert, gConfirm, fileUploadService) {
      var vm = this;

      vm.page = $stateParams.page;
      vm.srch = {
        FreeBoardId : $stateParams.DeptId,
        TableId : $stateParams.DeptId,
        tableNm : 'department',
        DeptId : $stateParams.DeptId,
      };
      console.log("detail load vm.srch", vm.srch);
      vm.comment = {};

      var id = 0;

      vm.getDetail = getDetail;
      vm.deleteDetail = deleteDetail;
      vm.deleteDetailAction = deleteDetailAction;

      vm.userId = $window.sessionStorage['loginUserIdx'];

      function getDetail() {

        var prms = departmentApi.doDetail().post(vm.srch).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            vm.data = data.responseVO.body.docs[0];
            return;
          }

          gAlert('', data.responseVO.body.docs[0].errMessage, {
            btn : '',
            fn : function() {
              $state.go("app.system.department-list", {
                page : vm.page
              })
            }
          });
        },

        function(data) {
          gAlert('', data.responseVO.body.docs[0].errMessage, {
            btn : '',
            fn : function() {
              $state.go("app.system.department-list", {
                page : vm.page
              })
            }
          });
        });
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }
        console.log("vm.uploadFileList", vm.uploadFileList);
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          };
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        console.log("before delete", vm.data);

        var prms = departmentApi.doDelete().post(vm.data).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                $state.go("app.system.department-list")
              }
            });

          }
        },

          function (error) {
            console.table(error);
        });
      }

      Array.prototype.append = function(array) {
        this.push.apply(this, array)
      };

      getDetail();
    } ]);

webapp.controller('DepartmentEditCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'DepartmentAPISrv', 'gAlert', '$rootScope',
    function DepartmentEditCtrl($window, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, departmentApi, gAlert, $rootScope) {
      var vm = this;

      vm.page = $stateParams.page;

      vm.uploadFileList = [];
      vm.srch = {
        FreeBoardId : $stateParams.DeptId,
        TableId : $stateParams.DeptId,
        tableNm : 'department',
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        DeptId : $stateParams.DeptId,
      };

      vm.data = {
        DeptId : vm.srch.DeptId,
      };

      vm.getDetail = getDetail;
      vm.saveDetail = saveDetail;
      vm.listLink = listLink;

      $rootScope.$on('$locationChangeStart', function(event, current, previous) {
        // console.log("현재페이지",'current=', current, ",previous=", previous);
        vm.previous = previous;
      });

      // 부서 조회 start
      vm.srchDeptModal = function() {
        var ctrl = 'DeptModalCtrl as vc';
        var paramData = {};

        var modalInstance = modalWindow.open('modal', 'views/modal/dept-modal.html', ctrl, paramData);
        modalInstance.result.then(function(okData) {
          vm.data.ParentDeptNm = okData.label;
          vm.data.ParentDeptId = okData.data;
        }, function(cancelData) {
        });
      };

      vm.eraseDept = function() {
        vm.data.ParentDeptNm = "";
        vm.data.ParentDeptId = "";
      };
      // 부서 조회 end

      function listLink() {

        if (vm.previous.substring(vm.previous.length - 31) == 'app/system/department-list') {
          $state.go("app.system.department-list");
        } else {
          $state.go("app.system.department-list");
        }
      }

      function getDetail() {
        if (vm.srch.DeptId == null || vm.srch.DeptId == 0) {
          return;
        }

        var prms = departmentApi.doDetail().post(vm.srch).$promise;

        prms.then(function(data) {
          console.log("load", data);
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].DeptId != null) {
              vm.data = data.responseVO.body.docs[0];
              console.log("before getFileList", vm.data);

              return;
            }
          }
            console.table(data);
        },

        function(data) {
          console.table(data);
        });
      }

      function saveDetail() {

        vm.data.tableNm = "department";
        vm.data.TableId = vm.data.DeptId;

        var prms = null;

        if (vm.data.DeptId == null || vm.data.DeptId == 0)
          prms = departmentApi.doInsertDetail().post(vm.data).$promise;
        else
          prms = departmentApi.doUpdateDetail().post(vm.data).$promise;

        prms.then(

        function(data) {
          console.log(data);
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].DeptId != null || data.responseVO.body.docs[0].TableId != null) { // insert 시 TableId 만 넘어옴
              vm.data.keyId = data.responseVO.body.docs[0].DeptId;

              gAlert('', 'Menu.SAVED', {
                btn : '확인',
                fn : function() {
                  if ($stateParams.DeptId == 0) {
                    $state.go("app.system.department-list");
                  } else {
                    vm.data.DeptId = data.responseVO.body.docs[0].DeptId != null ? data.responseVO.body.docs[0].DeptId : data.responseVO.body.docs[0].TableId;
                    $state.go("app.system.department-detail", {
                      DeptId : vm.data.DeptId
                    });
                  }
                }
              });

              return;
            }
          }

          gAlert('', data.responseVO.body.docs[0].errMessage);
        },

        function(error) {
          console.table(data);
        });
      }

      getDetail();
    } ]);

webapp.controller('DepartmentListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', '$translate', 'GLOBAL_CONSTANT', 'postApi', 'modalFactory', '$mdUtil', '$mdSidenav', 'gAlert', 'gConfirm', '$timeout',
    function CommoncodeListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, $translate, CONSTANT, postApi, modalFactory, $mdUtil, $mdSidenav, gAlert, gConfirm, $timeout) {
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
      vm.maxdeptid = 0;
      vm.lists = [];
      vm.saveYn = true;
      $scope.toggleLeft = buildToggler('left');
      $scope.toggleRight = buildToggler('right');
      /**
       * Build handler to open/close a SideNav; when animation finishes
       * report completion in console
       */
      function buildToggler(navID) {
        var debounceFn = $mdUtil.debounce(function() {
          $mdSidenav(navID).toggle().then(function() {
            console.debug("toggle " + navID + " is done");
          });
        }, 200);
        return debounceFn;
      }

      $scope.init = function() {
        // check if there is query in url
        // and fire search in case its value is not empty
      };

      // stops the interval
      $scope.$on("$destroy", function() {
      });

      $scope.$on('broadcastSetChangeTenantID', function(event, data) {
        resetList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'), '#toastContainer');
      });

      function resetSearch() {
        vm.srch.DeptNm = '';
        vm.data = {DeptNm: ''};
        tree.select_branch(null);
      }

      function resetList() {
        resetSearch();

        getTreeList();
      }

      vm.nextSearch = function() {
        tree.next_search_text();
      };

      // 함수 선언
      vm.resetSearch = resetSearch;
      vm.resetList = resetList;
      vm.getTreeList = getTreeList;
      vm.delNode = delNode;
      vm.delNodeCancel = delNodeCancel;
      vm.saveData = saveData;
      vm.onChanged = onChanged;
      vm.onChangeDeptNm = onChangeDeptNm;
      vm.getClear = getClear;

      var tree;
      $scope.my_tree = tree = {};

      vm.topItem = null;

      vm.onSelectCallback = function(data) {
        if (data.CallbackTarget == '0000') {
          vm.data.UseYN = data.Code;
        }
      };

      getTreeList();

      function onChangeDeptNm() {
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        if (vm.data.New == 'Y') {
          branch.label = '[*]' + vm.data.DeptNm;
        } else {
          branch.label = vm.data.DeptNm;
          vm.data.Edit = 'Y';
        }
      }

      vm.topItem = null;

      function getTreeList() {
        // 사전에 트리 선언함.(중요포인트)
        vm.dataloader = true;
        $scope.my_data = [];

        var data = vm.srch;
        data.mapCode = "Department.getDepartmentTreeList";
        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length == 0) return;

            vm.lists = result.body.docs;

            vm.topItem = result.body.docs[0];

            refreshTree();
          }
        },
        function(error) {
          vm.dataloader = false;
          console.error("fail", status, data);
        });
      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

      // 계층형 json 부모/자식 구분하여 구조 변환
      function insert(obj, item) {
        var parent = item.parent; // 부모값
        var map = obj.map;
        map[item.guid] = item; // 아이템 구성함

        if (parent === null)
          obj.res.push(item); // 부모값 생성
        else {
          var parentItem = map[parent];
          // 자식값 생성
          if (parentItem != null) {
            if (parentItem.hasOwnProperty("children"))
              parentItem.children.push(item);
            else
              parentItem.children = [ item ];
          }
        }

        return obj;
      }

      // guid, parent 제외한 계층형 json 구조 변환하기
      function traverse(jsonObj) {

        for (var i = 0; i < jsonObj.length; i++) {
          if (jsonObj[i].children == null) {
          } else {
            traverse(jsonObj[i].children);
          }

          // label, children 만 추가함
          var newItem = {
            "label" : jsonObj[i].label,
            "data" : jsonObj[i].guid,
            "children" : jsonObj[i].children,
          }
          jsonObj[i] = newItem;
        }
      }

      // 트리 목록에서 조회값
      $scope.my_tree_handler = function(branch) {
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.DeptId.toString()) {
            vm.data = item;
            return;
          }
        });
      };

      $scope.try_adding_a_branch = function() {

        var newnum = Math.floor(Math.random() * 899999999999999 + 100000000000000);
        var DeptId = newnum.toString(36);

        var branch = tree.get_selected_branch();
        if (branch == null) {
          var dept = {
            'DeptNm' : '새로운부서',
            'DeptId' : DeptId,
            'ParentDeptId' : 0,
            'Depth' : 1,
            'New' : 'Y'
          };
          vm.lists.push(dept);
        } else {
          angular.forEach(vm.lists, function(item) {
            if (branch.data == item.DeptId.toString()) {
              var dept = {
                'DeptNm' : '새로운부서',
                'DeptId' : DeptId,
                'ParentDeptId' : branch.data,
                'Depth' : item.Depth + 1,
                'New' : 'Y'
              };
              vm.lists.push(dept);
              return;
            }
          });
        }

        var new_branch = tree.add_branch(branch, {
          label: '[*]새로운부서',
          data: DeptId
        });
        tree.select_branch(new_branch);
      };

      function delNode() {
        var DeptId = '';
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        if (tree.get_children(branch) != null && tree.get_children(branch).length > 0) {
          $rootScope.showSimpleToast($translate.instant('Menu.CANNOT_DELECT_CHILD_NODE'), '#toastContainer');
          return;
        }

        gConfirm('', $translate.instant('Menu.DELETECONFIRM'), {
          btn : '',
          fn : function(){
            if (vm.data.New == 'Y'){
              deleteNodeTree();
            }else {
              vm.data.DelYN = 'Y';
              saveData();
            }
          }
        }, {
          btn : '',
          fn : function(){
          }
        });
      }

      function deleteNodeTree() {
        var commonCodeId = '';
        var branch = tree.get_selected_branch();
        if (branch == null) return;

        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.DeptId.toString()) {
            var index = vm.lists.indexOf(item);
            vm.lists.splice(index, 1);

            var parent = tree.select_parent_branch();
            if(parent){
              parent.children.splice(parent.children.indexOf(branch),1);
            } else {
              refreshTree();
            }

            return;
          }
        });

        tree.select_branch(null);
        vm.data = {CustomCode: 0};
      }

      function refreshTree() {

        // 리스트 생성
        var arrlist = new Array();

        // for문으로 다시 json 구조로 변환함.
        for (var i = 0; i < vm.lists.length; i++) {
          // 객체 생성
          var data = new Object();

          data.label = vm.lists[i]['DeptNm'];
          data.guid = vm.lists[i]['DeptId'].toString();
          data.parent = vm.lists[i]['ParentDeptId'] == undefined || vm.lists[i]['ParentDeptId'] == 0 ? null : vm.lists[i]['ParentDeptId'].toString();

          // 리스트에 생성된 객체 삽입
          arrlist.push(data);

          if (vm.lists[i]['Deptid'] > vm.maxdeptid)
            vm.maxdeptid = vm.lists[i]['Deptid'];
        }

        // 계층형 json 구조로 변환함
        var recursiveArray = unflatten(arrlist);

        // guid, parent 제외 변환함
        traverse(recursiveArray);

        // 트리구조에 바인딩
        $scope.my_data = recursiveArray;

        // 트리 펼치기
        $timeout(function() {
          return tree.expand_init();
        }, 1);

      }

      function removeNode(jsonObj, DeptId) {
        for (var i = 0; i < jsonObj.length; i++) {
          console.log('DeptId=', DeptId);

          if (jsonObj[i].data == DeptId) {
            jsonObj[i].children = [];
            return true;
          }

          if (jsonObj[i].children == null) {
          } else {
            if (removeNode(jsonObj[i].children, DeptId) == true)
              break;
          }
        }
      }

      function delNodeCancel() {
        var DeptId = '';
        var branch = tree.get_selected_branch();
        angular.forEach(vm.lists, function(item) {
          if (branch.data == item.DeptId.toString()) {
            item.DelYN = 'N';
            branch.label = branch.label.replace(/^\[X\]/,"");;
            return;
          }
        });
      }

      function saveData() {
        vm.dataloader = true;
        var data = {lists : []};
        data.mapCode = 'Department.updateDepartmentTreeListBatch';
        data.lists.push(vm.data);
        postApi.insert(data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (vm.data.New == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'), '#toastContainer');
              vm.data.New = '';
              var branch = tree.get_selected_branch();
              branch.label = branch.label.replace(/^\[\*\]/,"");
            } else if (vm.data.DelYN == 'Y') {
              $rootScope.showSimpleToast($translate.instant('Menu.DELETED'), '#toastContainer');
              deleteNodeTree();
            } else {
              $rootScope.showSimpleToast($translate.instant('Menu.SAVED'), '#toastContainer');
              vm.data.Edit = '';
            }
//            getTreeList();
          }
        },
        function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });

      }

      function onChanged() {
        if (vm.data.New == null || vm.data.New != 'Y') {
          vm.data.Edit = 'Y';
        }
      }

      function getClear() {
        vm.srch.DeptNm = '';
      }
    } ]);

(function () {
  "use strict";
  webapp.controller('SysNoticEditCtrl', 
    ['$scope','$stateParams', 'autoPage', '$state', '$rootScope', 'gAlert',
    function SysNoticEditCtrl($scope, $stateParams, autoPage, $state,  $rootScope, gAlert) {
      var vm = this;
      var ap = new autoPage();
      
      vm.keyId = $stateParams.keyId;
      vm.layout = $rootScope.gVariable.layoutBoard;

      // TYPE DATA
      var ctrlData = SysNoticEditCtrlData(vm);
      var mapCode = ctrlData.get('mapCode');
      var pageUrl = ctrlData.get('pageUrl');
      var form = ctrlData.get('form');
     
      var pageData = { 
        vm : vm, 
        stateParams : $stateParams, 
        scope : $scope,
        PageUrl : pageUrl,
      };

      // VIEW DATA
      vm.notice = {};         // 저장 데이터

      //1.All, 2.User, 3.Customer, 4.0-Tenant ALL, 4.0-Tenant All, 5.0-Tenant User, 6.Tenant Customer, 9.Private
      vm.publicTarget = [
        {Code : '1', CodeValue: '전체'},
        {Code : '2', CodeValue: '직원'},
        {Code : '3', CodeValue: '회원'},
      ]


      // DECLARE
      /******************************************************************************** */
   
      function getIsValidData() {
        var errMsg = '';
        if (isNullOrEmpty(vm.notice.Title)) errMsg = errMsg + '- 제목을 입력하세요.<br/>';
        if (isNullOrEmpty(vm.notice.PublicTarget)) errMsg = errMsg + '- 공개대상을 선택하세요.<br/>';
        if (isNullOrEmpty(vm.notice.Contents)) errMsg = errMsg + '- 내용을 입력하세요.<br/>';
        
        if (!isNullOrEmpty(errMsg)) {
          ap.alert(errMsg);
          return false;
        }

        return true;
      }

      function setData() {
        console.log("start setData")
        //Editor
        ap.confirm('공지사항을 저장하시겠습니까?',
          function(){
          oEditors.getById["strHtml"].exec("UPDATE_CONTENTS_FIELD", []);
          vm.notice.Contents = $("#strHtml").val();
          if(getIsValidData()) {
            var p = angular.copy(vm.notice);
            p.mapCode = mapCode.update;
            ap.commit(p, function () {
              gAlert('', 'Menu.SAVED', {
                btn: '',
                fn: function () {
                  goList();
                }
              });
            });
          }
        });
      }

      function setDelData() {
        ap.confirm('공지사항을 삭제하시겠습니까?',
          function(){

            var p = angular.copy(vm.notice);
            p.mapCode = mapCode.delete;
            ap.commit(p, function(){
              gAlert('', 'Menu.DELETED', {
                btn: '',
                fn: function () {
                  if(vm.layout == "N") {
                    $state.go(pageUrl.LIST_PAGE_URL.url, {
                      srch: ''
                    } , {reload: pageUrl.LIST_PAGE_URL.url});
                  } else {
                    $state.go(pageUrl.LIST_EDIT_PAGE_URL.url, {
                      srch: '', keyId : ''
                    } , {reload: pageUrl.LIST_EDIT_PAGE_URL.url});
                  }
                }
              });
            });
        });
      }

      function goList() {
        $state.go(pageUrl.LIST_PAGE_URL.url, {srch: ''});
      }

      // 확장 기능 개발 구간 종료
      /******************************************************************************** */

      /******************************************************************************** */
      // Fn Callback 시작
      function getInitDataExt(){

        if(isNullOrEmpty(vm.keyId)) {
          vm.titleNm = "공지사항 등록";
          ap.setForms(form.section01);
        } else {
          vm.titleNm = "공지사항 수정";

          var p = {
            KeyId : $stateParams.keyId,
            SysNotice : 'Y',
            mapCode : mapCode.selectDetail
          };

          ap.select(p, function(result) {
            vm.notice = result[0];
            vm.notice.PublicTarget = vm.notice.PublicTarget.toString();
            ap.setForms(form.section01);
          })
        }

      };
      // Fn Callback 종료
      /******************************************************************************** */
      
      /******************************************************************************** */
      // 함수 정의 시작

      /** @description 저장 전 데이터 유효성 검사 **/
      vm.getIsValidData = getIsValidData;
      /** @description 데이터 저장 버튼 클릭 시 **/
      vm.setData = setData;
      vm.setDelData = setDelData;
      vm.getInitDataExt = getInitDataExt;
      vm.goList = goList;

      // 함수 정의 종료
      /******************************************************************************** */
      ap.setData(pageData);
      ap.init();

    }]);
})();

/**
 * @Notic
 *  - autoPage를 개발 하다보니 폼을 그리는 Object가 너무길어 파일을 따로 분리함
 *  - 기본적인 정보는 define 하는게 목적
 *  - 함수명 : 컨트롤러명 + Data 로 통일 필요
 * 
 * 
 * @SetFormsGuide v0.1.20.1.6
 * 
 * @type {NotNull} 폼의 형태 (text, select, textarea, radio, checkbox, date, dateTime)
 * @label 필드명 
 * @key {NotNull} 바인드되는 Object 명 상위 bindKey와 연관성을 가짐
 * @col {NotNull} 한 Row에 그릴 수 있는 갯수} 1, 2, 3, 4 
 * @disabled 활성/비활성 담당으로 true/false, 혹은 vc. 로 시작되는 문자형
 * @bindData {NotNull} View 기준으로 작성된 부분으로 vc.로시작되어야함
 * @callback ng-change를 기본으로 사용한 콜백 함수
 * @layout 폼의 Layouy을 설정한다 inner, inline
 * @inputType input:text에 한정된 키값으로 number 를 지원하고 있다.
 * @where ng-if문에 해당
 * 
 * @필수공통 type, key, col
 * @생략가능 lable, disabled, bindData, callback, layout
 * 
 * @타입별 부가설명
 * @date bindData가 2개의 값을 갖는 배열일 경우 From, To로 자동변경
 * @text inputType key를 추가할 수 있으며 현재 number를 지원하고 있음
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * 
 * @issue columnMap 처리가 미흡
 */

"use strict";
function SysNoticEditCtrlData(vm) {
  return {
    datas : {},
    define : {
      // postApi 기본 전달 값
      mapCode : {
        selectDetail : "Notice.getNoticeDetail",        
        update : {
          insert : 'Notice.insertNotice',
          update : 'Notice.updateNotice'
        },
        delete : 'Notice.delNotice'
      },
      pageUrl : {            
        LIST_PAGE_URL : {
          url : 'app.system.notice-list',         // 목록 화면
          param : {
            srch : vm.srch,
          }
        },
        LIST_EDIT_PAGE_URL : {
           url : 'app.system.notice-list.edit',    // 목록 등록/수정 화면
           param : {
            srch : vm.srch,
            keyId : vm.keyId
           }
        },
        EDIT_PAGE_URL : {
          url : 'app.system.notice-edit',    // 목록 등록/수정 화면
          param : {
            srch : vm.srch,
            keyId : vm.keyId
          }
       },            
      },
      // 폼에 대한 정보를 정의
      form : {
        section01 : {
          target : "#inputWrap",
          bindKey : viewTx.vc + '.notice',
          layout : mElemTx.layout.inline,
          resetForm :true,
          field : [
            {
              label : "제목",
              key : "Title",   
              type : mElemTx.text, 
              col : 2,
            },
            {
              label : "공개",
              key : "PublicTarget",   
              type : mElemTx.select, 
              col : 3,
              bindData : viewTx.vc + '.publicTarget',
            },
          ]
        },
      }
    },

    /**
     * @description 기본 정의 함수
     */
    set : function(key, value){ this.define[key] = value},
    get : function(key) { 
      var define = this.define[key];
      return JSON.parse(JSON.stringify(define));
    },
    setData : function(key, value){ this.Datas[key] = value},
    getData : function(key) { 
      var datas = this.datas[key];
      return JSON.parse(JSON.stringify(datas));
    }
  }
}
(function () {
  "use strict";
  webapp.controller('SysNoticListCtrl', 
    ['$scope','$stateParams', 'autoPage', 'fileUploadService', 'StaticVariable', '$rootScope', 'postApi',
    function SysNoticListCtrl($scope, $stateParams, ap, fileUploadService, StaticVariable, $rootScope, postApi) {

      var vm = this;          // View Model
      vm.pageType = $stateParams.type;
      vm.keyId = $stateParams.keyId;

      var ctrlData = SysNoticListCtrlData(vm);
      var apiOption = ctrlData.get('apiOption');
      var pageUrl = ctrlData.get('pageUrl');
      var form = ctrlData.get('form');

      var pageData = {
        vm : vm,
        stateParams : $stateParams,
        scope : $scope,
        headerTitle : vm.headerTitle,
        pageType : "LIST",
        //listStack : false,
        listParam : {
          TcId : vm.keyId,
          SysNotice : 'Y'
        },
        keyTableNm : "Notice",
        keyColumnNm : "KeyId",
        //enableListCheck : true,
        MapperId : apiOption,
        PageUrl : pageUrl,
        rootScope : $rootScope
      };

      vm.goodsState = [];
      vm.YnList = [
        {Code : 'Y', CodeValue : 'Y'},
        {Code : 'N', CodeValue : 'N'},
      ];

      vm.publicTarget = [
        {Code : '1', CodeValue: '전체'},
        {Code : '2', CodeValue: '직원'},
        {Code : '3', CodeValue: '회원'},
      ]
      /******************************************************************************** */
      // 확장 기능 개발 구간 시작

      function getInitDataExt() {
        vm.headerTitle = "공지리스트";
        
        // var p = {mapCode: 'CommonCode.getCommonCodeValue', ParentCommonCodeId: '2MREQT6FV6'};
        // ap.select(p, function(result){vm.goodsState = result;});

        ap.setForms(form.SEARCH);
      };

      // 확장 기능 개발 구간 종료
      /******************************************************************************** */

      /******************************************************************************** */
      // 함수 정의 시작


      /** @description AP init Callback**/
      vm.getInitDataExt = getInitDataExt;

      // 함수 정의 종료
      /******************************************************************************** */
      var ap = new ap();
      ap.setData(pageData);
      ap.initView();
      // autoPage 종료
    }]);

})();

/**
 * @Notic
 *  - autoPage를 개발 하다보니 폼을 그리는 Object가 너무길어 파일을 따로 분리함
 *  - 기본적인 정보는 define 하는게 목적
 *  - 함수명 : 컨트롤러명 + Data 로 통일 필요
 * 
 * 
 * @SetFormsGuide v0.1.20.1.6
 * 
 * @type {NotNull} 폼의 형태 (text, select, textarea, radio, checkbox, date, dateTime)
 * @label 필드명 
 * @key {NotNull} 바인드되는 Object 명 상위 bindKey와 연관성을 가짐
 * @col {NotNull} 한 Row에 그릴 수 있는 갯수} 1, 2, 3, 4 
 * @disabled 활성/비활성 담당으로 true/false, 혹은 vc. 로 시작되는 문자형
 * @bindData {NotNull} View 기준으로 작성된 부분으로 vc.로시작되어야함
 * @callback ng-change를 기본으로 사용한 콜백 함수
 * @layout 폼의 Layouy을 설정한다 inner, inline
 * @inputType input:text에 한정된 키값으로 number 를 지원하고 있다.
 * @where ng-if문에 해당
 * 
 * @필수공통 type, key, col
 * @생략가능 lable, disabled, bindData, callback, layout
 * 
 * @타입별 부가설명
 * @date bindData가 2개의 값을 갖는 배열일 경우 From, To로 자동변경
 * @text inputType key를 추가할 수 있으며 현재 number를 지원하고 있음
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * @select 코드파람은 Code, CodeValue 배열값으로 넘겨주어야함
 * 
 * @issue columnMap 처리가 미흡
 */

"use strict";
function SysNoticListCtrlData(vm) {
  return {
    datas : {},
    define : {
      // postApi 기본 전달 값
      apiOption : {
        init : {
          LIST_CNT_SQL : 'Notice.getNoticeListCnt', // 목록 건수 조회 SQL
          LIST_SQL : 'Notice.getNoticeList',    // 목록 조회 SQL
        },
        del : {

        },
      },
      pageUrl : {
        LIST_PAGE_URL : {
          url : 'app.system.notice-list',         // 목록 화면
          param : {
            srch : vm.srch,
          }
        },
        LIST_EDIT_PAGE_URL : {
           url : 'app.system.notice-list.edit',    // 목록 등록/수정 화면
           param : {
            srch : vm.srch,
            KeyId : ''
           }
        },
        EDIT_PAGE_URL : {
          url : 'app.system.notice-edit',    // 목록 등록/수정 화면
          param : {
            srch : vm.srch,
            KeyId : ''
          }
       },
      },
      form : {
        SEARCH : {
          target : "#searchWrap",
          bindKey : viewTx.vc + '.srch',
          layout : mElemTx.layout.inner,
          resetForm :true,
          field : [
            {   
              label : "타이틀",
              type : mElemTx.text,
              col : 1,
              key : "Title",
            },
            {   
              label : "공개타입",
              type : mElemTx.select,
              col : 1,
              key : "PublicTarget",
              bindData : "vc.publicTarget"
            },
          ]
        },
      }   
    },

    /**
     * @description 기본 정의 함수
     */
    set : function(key, value){ this.define[key] = value},
    get : function(key) { 
      var define = this.define[key];
      return JSON.parse(JSON.stringify(define));
    },
    setData : function(key, value){ this.Datas[key] = value},
    getData : function(key) { 
      var datas = this.datas[key];
      return JSON.parse(JSON.stringify(datas));
    }
  }
}
(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:menumanage-list-ctrl
   * @description
   * # 메뉴 관리
   * 사용자 메뉴를 편집 및 관리 할 수 있는 페이지
   */

  webapp.controller('MenuManageCtrl', [
    '$window', '$scope', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'postApi', 'gAlert', 'gConfirm', '$translate', '$compile', 'modalFactory',
    function MenuManageCtrl($window, $scope, $state, $stateParams, $rootScope, CONSTANT, postApi, gAlert, gConfirm, $translate, $compile, modalFactory) {
      var vm = this;
      vm.targetField = null; // Focus 엘리먼트를 구하기 위한 변수
      vm.selectMenu = null; // 선택된 메뉴가 있는지 체크하는 변수
      vm.checkShowDetailView = false; // 메뉴의 디테일 화면을 보여줄지에 여부
      vm.menuList = [];
      vm.menuInfo = [];
      vm.delMenuList = [];
      vm.fontList = [];

      vm.addInputFa = "fa-";

      vm.sendData = { menuList: vm.menuList, delMenuList: vm.delMenuList };

      vm.roleLevelList = [];
      for(var i = 0; i < 16; i++) {
        var o = {};
        o.commonCodeId = i.toString();
        o.codeNm = "Level " + i;
        vm.roleLevelList.push(o);
      }

      vm.SysAdmin = false;
      vm.viewMode = "A"; // A : 전체보기, T : 회원사보기, TV : 회원사일때
      if ($window.sessionStorage['loginSysAdminYN'] == "Y") {
        vm.SysAdmin = true;
        vm.viewMode = "A";
      } else {
        vm.viewMode = "TV";
      }

      vm.showTabView = [];
      for (var i = 0; i < 3; i++) vm.showTabView.push('');
      vm.showTabView[0] = "in active";

      vm.menuTitle = 'All Category';
      vm.selectTenantInfo = {};
      vm.tenantList = [];

      vm.sysAdminDisable = false;

      vm.selectedGroupOptions = "";
      vm.mobileOnlyYN = "N";
      if($state.$current.name.indexOf("menumanage-mobilelist") != -1) vm.mobileOnlyYN = "Y";

      vm.selectNewWindowYn = [
        {value : "Y", codeNm : "Y"},
        {value : "N", codeNm : "N"},
      ];

      vm.roles = [];
      vm.rolesInfo = [];
      vm.rolesInfo.sqlMapper = [];
      vm.checkEdtLabel = false;
      vm.checkEdtLabelText = "라벨편집";

      vm.choiceRolePage = "";

      vm.mSrchTenentID = '0';

      vm.toggleMenuType = function(menuType) {
        console.log(menuType);
      };

      vm.setDetailView = function (code) {
        if(code == undefined) {
          vm.menuInfo = [];
          vm.rolesInfo = {};
          vm.setChangeTab(0);
          return;
        }

        var data = { mapCode: 'Menu.getBaseMenuInfo', menuId: code.menuId, type: vm.viewMode, srchTenantId: '0' };
        if (vm.SysAdmin && vm.viewMode == "TV") data.tenant = vm.selectTenantInfo.id;
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.rolesInfo = [];
            vm.choiceRolePage ="";
            vm.setChangeTab(0);
            if(result.body.docs.length > 0) {
              vm.menuInfo = result.body.docs[0];
              vm.menuInfo.depth = code.depth;
              vm.menuInfo.useYn = code.useYn;
              vm.menuInfo.roleLevel = vm.menuInfo.roleLevel.toString();

              vm.menuInfo.menuTenantId = code.menuTenantId;
              ( vm.menuInfo.useYn == "Y" || ( vm.menuInfo.menuTenantId != null &&  vm.menuInfo.menuTenantId != ""))
              ?  vm.menuInfo.levelYn = true :  vm.menuInfo.levelYn = false;

              getFa();
              vm.getPages();
              vm.getMenuType();
            } else {
              var o = {};
              o.menuTenantId = code.menuTenantId;
              o.menuId = code.menuId;
              o.menuNm = code.menuNm;
              o.icon = code.icon;
              o.mobileOnlyYN = vm.mobileOnlyYN;
              o.useYn = code.useYn;
              o.menuTenantId = code.menuTenantId;
              o.roleLevel = "1";

              (o.useYn == "Y" || (o.menuTenantId != null && o.menuTenantId != "")) ? o.levelYn = true : o.levelYn = false;
              vm.menuInfo = o;

            }

            if (vm.mobileOnlyYN == "Y") getMenuSvyList(); //모바일 메뉴관리인 경우 연관페이지 정보도 같이 가져오도록 추가
          } else {
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.getMenuType = function() {
        angular.forEach(vm.radioMenuType, function(item) {
          item.checked = false;
        });

        vm.menuInfo.pages = [];
        var data = { mapCode: 'MenuType.getBaseMenuType', menuId: vm.menuInfo.menuId, srchTenantId: '0' };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.menuInfo.menuTypes = result.body.docs;

            angular.forEach(vm.radioMenuType, function(item) {
              angular.forEach(vm.menuInfo.menuTypes, function(menu) {
                if (item.code == menu.MenuType) {
                  item.checked = true;
                  return;
                }
              });
            });
          } else {
            console.error('Error> getMenuType', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> getMenuType', status, error);
        });
      };

      vm.getPages = function () {
        vm.menuInfo.pages = {};
        var data = { mapCode: 'Screen.getBaseMenuScreen', menuId: vm.menuInfo.menuId };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.menuInfo.pages = result.body.docs;
          } else {
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.addChild = function (depth, code) {
        var $elem;
        (depth == 0) ? $elem = $("#editorDepth01") : $elem = $("#editor" + code);
        $elem.css("display", "block");
        $elem.find("input").focus();

        $(".subTextmenu").addClass("importantHidden");
      };

      vm.delChild = function (depth, obj) {
        if (obj.child.length > 0) {
          gAlert('', '하위 메뉴가 있으면 삭제할 수 없습니다.', {
            btn: '확인', fn: function () { }
          });
          return;
        }
        var data = { mapCode: 'Menu.getUseTenantMenu', menuId: obj.menuId, srchTenantId: '0' };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            var msg = "";
            if(result.body.docs.length == 0) {
              msg = "[" + obj.menuNm + "] 삭제하시겠습니까?";
            } else {
              var company = "";
              for(var j = 0; j < result.body.docs.length; j++) {
                if(j != 0) company += ", ";
                company += result.body.docs[j].TenantNm;
              }
              msg = "[" + company + "] 회원사가 사용중입니다.<br>그래도 [" + obj.menuNm + "] 삭제하시겠습니까?";
            }

            gConfirm('', msg , {
              btn: '확인', fn: function () {
                var data = { mapCode: 'Menu.delMenuList', menuId: obj.menuId, srchTenantId: '0' };
                postApi.select(data, function (result) {
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    $rootScope.$broadcast('broadcastSetChangeMenuList', {});
                    $rootScope.showSimpleToast($translate.instant('삭제하였습니다.'));
                    initBaseMenuList();
                  }
                });
              }
            }, {btn: '취소', fn: function () {}
            });

        } else {
          console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
        }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.editChild = function (depth, obj) {
        //console.log("Edt :", depth, obj)
      };

      /**
      * 같은 Depth, 직속 관계가 아닐 경우 자리 이동을 하지 않기 위함
      */
      vm.sortableOptions = {
        allowDuplicates: true,
        accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
          var result = false;
          if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id) result = true;
          var target = sourceItemHandleScope.itemScope.item;
          if(target.menuTenantId == "") result = false;
          if(target.useYn == "N") result = false;
          if(destItemScope.modelValue.menuTenantId == "") result = false;
          if(destItemScope.modelValue.useYn == "N") result = false;
          return result;
        },
        dragEnd: function (eventObj) {
          var source = eventObj.source.sortableScope.modelValue;
          vm.setChangeSort(source);
        },
      };

      vm.setChangeSort = function (obj, ps) {
        for (var i = 0; i < obj.length; i++) {
          var minusLength = $("#atMenu_" + obj[i].menuId).closest("[ng-model]").
            parent().find("div").eq(0).find( ".fa-minus").length;
          if(minusLength != 0) $("#atMenu_" + obj[i].menuId).css("display","block");
          var tempSort = makeSortPath(obj[i].sort);
          if(ps == undefined) {
            if(tempSort.length == 1) {
              obj[i].sort = (100+i);
              obj[i].tempSortPath[0] = (100+i);
            } else if(tempSort.length == 2) {
              obj[i].sort = Number(tempSort[0] + "" + (100+i));
              obj[i].tempSortPath[0] = tempSort[0];
              obj[i].tempSortPath[1] = (100+i);
            } else {
              obj[i].sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
              obj[i].tempSortPath[0] = tempSort[0];
              obj[i].tempSortPath[1] = tempSort[1];
              obj[i].tempSortPath[2] = (100+i);
            }
          } else {
            var tempSort = makeSortPath(ps);
            if(tempSort.length == 1) {
              obj[i].sort = Number(tempSort[0] + "" + (100+i));
              obj[i].tempSortPath[0] = tempSort[0];
              obj[i].tempSortPath[1] = (100+i);
            } else {
              obj[i].sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
              obj[i].tempSortPath[0] = tempSort[0];
              obj[i].tempSortPath[1] = tempSort[1];
              obj[i].tempSortPath[2] = (100+i);
            }
          }
          if (obj[i].child.length > 0) vm.setChangeSort(obj[i].child, obj[i].sort);
        }
      };

      /**
       * 메뉴 확장
       * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
      */
      vm.extendMenu = function (elementId) {
        var $o = $("#" + elementId);
        var code = elementId.split("_")[1];
        var menupath = $o.attr("menu-sort");
        var depth;
        if ($o.hasClass("depth-one")) depth = 1;
        else if ($o.hasClass("depth-two")) depth = 2;

        if (depth == 1) {
          $(".extend-btn").removeClass("fa-minus");
          $(".extend-btn").addClass("fa-plus");
          $(".depth-two").slideUp();
          $(".depth-three").slideUp();
          if ($("[menu-sort^='" + menupath + "'].depth-two").eq(0).css("display") == "block") {
            $("[menu-sort^='" + menupath + "'].depth-two").slideUp();
          } else {
            $o.find(".extend-btn").addClass("fa-minus");
            $("[menu-sort^='" + menupath + "'].depth-two").slideDown();
          }
        } else {
          if ($("[menu-sort^='" + menupath + "'] .depth-three").eq(0).css("display") == "block") {
            $o.find(".extend-btn").removeClass("fa-minus");
            $o.find(".extend-btn").addClass("fa-plus");
            $("[menu-sort^='" + menupath + "'] .depth-three").slideUp();
          } else {
            $(".depth-three").slideUp();
            $o.closest(".as-sortable-item").parent().find(".extend-btn").removeClass("fa-minus");
            $o.closest(".as-sortable-item").parent().find(".extend-btn").addClass("fa-plus");
            $o.find(".extend-btn").addClass("fa-minus");
            $("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
          }
        }
      }

      /**
       * 동일 선상의 서브 메뉴를 보여주기 위함
       * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
      */
      vm.showSubMenu = function (elementId) { $("#" + elementId).css("display", "block"); }

      /**
       * 동일 선상의 서브 메뉴를 숨기기 위함
       * @param {String} elementId 메뉴 ng-mouseleave 시 해당 서브 메뉴 아이디
      */
      vm.hiddenSubMenu = function (elementId) { $("#" + elementId).css("display", "none"); }

      /**
       * 메뉴 타이틀 변경 시 버튼 비활성 / 활성 을 표시하기 위함
      */
      vm.menuTitleChange = function () {
        var val = $(vm.targetField).val();
        var $obj = $(vm.targetField);
        var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
        (val.length == 0) ? $okBtn.addClass("disable") : $okBtn.removeClass("disable");
      };

      /**
       * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
       * @param {int} depth 메뉴 Depth
      */
      vm.cancelMenuItem = function (depth) {
        var $obj = $(vm.targetField);
        var $editLayout = $obj.closest(".edit-layout");
        var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
        $okBtn.addClass("disable");
        $editLayout.css("display", "none");
        $obj.val("");
        $(".subTextmenu").removeClass("importantHidden");
      };

      /**
       * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
       * @param {int} depth 메뉴 Depth
      */
      vm.addMenuItem = function (depth) {
        // 190503 만약 로그인 권한이 Sysadmin 이 아닐 경우
        // 해당 로직을 진행하면 안됨 (기능 추가 필요);
        var $obj = $(vm.targetField);
        if ($obj.val() == undefined || $obj.val().length == 0) return;
        var data = {};
        data.menuNm = $obj.val();
        data.menuId = makeDateUUID();
        data.depth = depth;
        data.child = [];
        data.delYn = "N"; // 생성모드
        data.mobileOnlyYN = vm.mobileOnlyYN;
        data.disableClass = "disable-master";
        data.tenantId = "";
        data.useYn = "N";
        data.roleLevel = 1;

        var checkDepth;
        if (depth == 1) {

          var checkUseY = 0, checkUseN = 0;
          for(var i = 0; i < vm.menuList.length; i++) {
            if(vm.menuList[i].useYn =="Y") checkUseY = vm.menuList[i].sort;
            if(vm.menuList[i].useYn =="N") checkUseN = vm.menuList[i].sort;
          }

          if(checkUseN == 0) {
            data.sort = checkUseY + 100;
          } else {
            data.sort = checkUseN + 1;
          }

          data.tempSortPath = [];
          data.tempSortPath[0] = data.sort;

          checkDepth = 1;
          vm.depth01title = "";
        } else {
          var sort = $obj.closest(".edit-layout").attr("menu-sort");
          var obj = findObject(vm.menuList, 'sort', sort);
          data.sort = sort + "" + (obj.child.length + 100);
          var sortArray = makeSortPath(data.sort);
          data.tempSortPath = sortArray;
          if (sortArray.length == 2) {
            checkDepth = 2;
            vm.depth02title = "";
          } else {
            checkDepth = 3;
            vm.depth03title = "";
          }
        }

        data.srchTenantId = '0';

        postApi.insert('Menu.setBaseMenuList', data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            var obj = findObject(vm.menuList, 'sort', sort);

            if (checkDepth == 1) vm.menuList.push(data);
            else obj.child.push(data);

            if (depth != 1) {
              $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
              $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
              setTimeout(function () {
                $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
              }, 500);
            }

            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
            vm.setDetailView(data);
          }
        }, function (error) {
          console.error('Error> setBaseMenuList', status, error);
        });

        var $editLayout = $obj.closest(".edit-layout");
        var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
        $okBtn.addClass("disable");
        $editLayout.css("display", "none");
        $obj.val("");

        $(".subTextmenu").removeClass("importantHidden");
      };

      /**
       * 포커스가 된 엘리먼트를 구하기 위함
       * @param {object} $event AngularJS Object
      */
      $scope.focusCallback = function ($event) {
        if ($event.target === null) return;
        vm.targetField = $event.target;
      };

      vm.addPage = function () {
        if (vm.menuInfo.length == 0) {
          vm.alertSelectMenu();
          return;
        }

        if(vm.menuInfo.pages == null ) vm.menuInfo.pages = [];
        var o = {screenId:'', mainYn: 'N', screenNm: '', pageUrl: '', pageUrlParam: '', newWindowYn:'N', delYn: 'N' };
        vm.menuInfo.pages.push(o);
      };

      vm.delPage = function(item, idx) {
        if(item.screenId != null && item.screenId != "") {
          if(item.delYn == "Y") {
            item.delYn = "N";
          } else if(item.delYn == "N") {
            item.delYn = "Y";
          }
        } else if(item.screenId == null || item.screenId == "") {
          if(item.delYn == "N") {
            vm.menuInfo.pages.splice(idx, 1);
          }
        } else if(item.delYn == "Y") {
          item.delYn = "N";
        } else if(item.delYn == "N") {
          item.delYn = "Y";
        } else {
          vm.menuInfo.pages.splice(idx, 1);
        }
      };

      /**
       * Font 를 저장한다. DELETE 예정
      */
      vm.setFa = function () {
        if ($("#viewFontIcon").width() == 0) return;
        var data = { mapCode: "fontAwesome.setFontList", name: vm.addInputFa, srchTenantId: '0' };
        postApi.insert(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.addInputFa = "fa-";
            getFa();
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.setChangeIcon = function (name) {
        if(vm.menuInfo.length == 0) {
          return;
        }
        for (var i = 0; i < vm.fontList.length; i++) {
          if (vm.fontList[i].name == name) {
            vm.fontList[i].active = "active";
          } else {
            vm.fontList[i].active = "";
          }
        }

        var menu = findObject(vm.menuList, 'menuId', vm.menuInfo.menuId);
        if (name == "_초기화") {
          menu.icon = '';
          vm.menuInfo.icon = '';
        } else {
          menu.icon = name;
          vm.menuInfo.icon = name;
        }

      };

      vm.invalidBaseInfo = function () {
        if (vm.menuInfo.length == 0) {
          vm.alertSelectMenu();
          return;
        }

        if (vm.menuInfo.name == '') {
          gAlert('', '메뉴명을 입력하세요.', {
            btn: '확인', fn: function () { }
          });
          return;
        }

        if(vm.viewMode != "T") {
          if (vm.menuInfo.pages != null && vm.menuInfo.pages.length == 0) {
            if (!vm.checkPages(function (boolean) {
              if (boolean) vm.checkMainPages();
            }));
          } else {
            vm.checkMainPages();
          }
        } else {
          vm.uptMenuBaseInfo();
        }

        // srchTenantId가 0일때만 insertBaseMenuTypeBatch 호출
        if ($rootScope.gVariable.srchTenantId == 0) {
          vm.updateMenuType();
        }
      };

      vm.updateMenuType = function() {
        var map = "MenuType.insertBaseMenuTypeBatch";
        var menuType = {MenuId: vm.menuInfo.menuId, lists:[], srchTenantId: '0'};
        angular.forEach(vm.radioMenuType, function(item) {
          if (item.checked) {
            menuType.lists.push(item);
          }
        });

        postApi.insert(map, menuType, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

          } else {
            console.error('Error> updateMenuType', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> updateMenuType', status, error);
        });
      };

      vm.uptMenuBaseInfo = function () {


        var map = "Menu.setBaseMenuInfoBatch";

        if( vm.menuInfo.roleLevel == null || vm.menuInfo.roleLevel == "") {
          vm.menuInfo.roleLevel = '1';
        }

        var setType = [];
        if(vm.menuInfo.depth == 1) {
          if(vm.menuInfo.menuType != null && vm.menuInfo.menuType != "") {

            var rootMenu = findObject(vm.menuList, 'menuId', vm.menuInfo.menuId);
            var menuType = vm.menuInfo.menuType;

            for(var i = 0; i < rootMenu.child.length; i++) {
              rootMenu.child[i].menuType = menuType;
              setType.push(rootMenu.child[i]);
              for(var j = 0; j < rootMenu.child[i].child.length; j++) {
                rootMenu.child[i].child[j].menuType = menuType;
                setType.push(rootMenu.child[i].child[j]);
              }
            }
          }
        }

        vm.menuInfo.setType = setType;
        if($rootScope.gVariable.srchTenantId != 0) {
          vm.menuInfo.pages = [];
        }
        vm.menuInfo.srchTenantId = '0';
        postApi.update(map, vm.menuInfo, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            var temp = findObject(vm.menuList, 'menuId', vm.menuInfo.menuId);
            temp.menuNm = vm.menuInfo.menuNm;
            vm.getPages();

            $rootScope.$broadcast('broadcastSetChangeMenuList', {});
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          } else {
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.checkMainPages = function () {
        if (vm.menuInfo.pages != null && vm.menuInfo.pages.length != 0) {
          var st = $(":input:radio[name=pageMain]:checked").val();
          if (vm.SysAdmin) {
            if (st == undefined) {
              gAlert('', '연관페이지의 [메인]을 선택하여주세요.', {
                btn: '확인', fn: function () { }
              });
              return;
            }

            var check = 0;
            for (var i = 0; i < vm.menuInfo.pages.length; i++) {
              if (vm.menuInfo.pages[i].pageNm == "") {
                gAlert('', '연관페이지의 [페이지명]을 확인하여주세요.', { btn: '확인', fn: function () { }});
                return;
              }
              if (vm.menuInfo.pages[i].pageUrl == "") {
                gAlert('', '연관페이지의 [페이지URL]을 확인하여주세요.', {btn: '확인', fn: function () { }});
                return;
              }
            }

            for (var i = 0; i < vm.menuInfo.pages.length; i++) {
              vm.menuInfo.pages[i].mainYn = "N";
            }

            vm.menuInfo.pages[st].mainYn = "Y";
          }

          var st = $(":input:radio[name=optionMenuType]:checked").val();
          vm.menuInfo.menuType = st;
          vm.uptMenuBaseInfo();
        } else {
          vm.uptMenuBaseInfo();
        }
      }

      vm.checkPages = function (callback) {
        gConfirm("연관 페이지가 없습니다. 계속 진행하시겠습니까?",
          { btn: '확인', fn: function () { callback(true); } },
          { btn: '취소', fn: function () { callback(false); } }
        );
      };

      vm.alertSelectMenu = function () {
        gAlert('w', '메뉴를 선택하여주세요.', {
          btn: '확인', fn: function () { }
        });
      };

      vm.onChangeGroupView = function (code) {
        if (code == null || code == undefined || code == "") {
          angular.forEach(vm.menuList, function (key, value) {
            key.extendGroupClass = "";
          });
        } else {
          angular.forEach(vm.menuList, function (key, value) {
            if (key.menuType == undefined) key.menuType = "";
            if (key.menuType.toString() == code.toString()) {
              if (key.mShowYn != "Y")
                key.extendGroupClass = "visible-group";
              else
                key.extendGroupClass = "visible-use-group";

            } else {
              key.extendGroupClass = "invisible-group";
            }
            //}
          });
        }
      };

      vm.onChangeNewWindowYn = function (code) {

      };

      /************************************************************* */
      vm.setChangeTenant = function (id, name) {
        vm.viewMode = "TV";
        vm.menuTitle = 'All Category';
        vm.sysAdminDisable = true
        vm.selectTenantInfo.id = id;
        vm.selectTenantInfo.name = name;

        for (var i = 0; i < vm.showTabView.length; i++) vm.showTabView[i] = "";
        vm.showTabView[0] = "in active";

        setTimeout(function () {
          $("ul.nav-tabs li").removeClass("active");
          $("ul.nav-tabs li").eq(1).addClass("active");
        }, 25);

        vm.menuList = [];
        vm.menuInfo = [];

        var data = { mapCode: 'Menu.getTenantMenuList', tenant: id, srchTenantId: '0' };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            makeMenuList(result.body.docs, true);
          } else {
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      // arrow  true : top, false : down, default up;
      var resultObj = {};
      vm.findUptTenantNode = function (obj, arrow) {
        resultObj.str = [];
        resultObj.codes = [];
        if (arrow) { // UP
          var path = makeSortPath(obj.sort);
          for (var i = 0; i < path.length-1; i++) {
            var temp = "";
            for(var j = 0; j < i+1; j++) {
              temp += path[j];
            }
            temp = findObject(vm.menuList, 'sort', temp);
            if (temp.useYn == "N") {
              resultObj.codes.push(temp);
              resultObj.str.push(temp.menuNm);
            }
          }
        } else {
          var temp = obj.child;
          var k = [];
          var count = 0;
          for (var c = 0; c < 1000; c++) {
            for (var i = 0; i < temp.length; i++) {
              var check = true;
              for (var j = 0; j < k.length; j++) {
                if (k[j].menuId == temp[i].menuId) {
                  check = false;
                  break;
                }
              }
              if (check) k.push(temp[i]);
              else count = -1;
            }

            if (count == -1) break;
            if (k.length == count) break;
            else {
              count = k.length;
              temp = [];
              for (var i = 0; i < k.length; i++) {
                if (k[i] == undefined) {
                  count = -1;
                  break;
                }
                for (var j = 0; j < k[i].child.length; j++) temp.push(k[i].child[j]);
              }
            }
          }

          for (var i = 0; i < k.length; i++) {
            resultObj.str.push(k[i].menuNm);
          }
          resultObj.codes = k;
        }
        resultObj.str = resultObj.str.toString();
        return resultObj;
      };

      vm.setTenantEnable = function (depth, obj) {
        if (depth == 1) {
          if (obj.tenantId == "" || obj.useYn == "N") {
            gConfirm('', "해당 메뉴를 [활성] 하시겠습니까?", {
              btn: '확인', fn: function () {
                if (obj.child.length > 0) {
                  vm.checkDepth1OtherData(obj);
                } else {
                  var toData = [];
                  toData.push(obj);
                  vm.setChangeMenuState(toData, true);
                }
              }
            }, {btn: '취소', fn: function () {}});
          } else {
            var msg = "";
            if (obj.child.length > 0) msg = "해당 메뉴의 하위 메뉴포함하여 [비활성] 하시겠습니까?";
            else msg = "해당 메뉴를 [비활성] 하시겠습니까?";
            gConfirm('', msg, {
              btn: '확인', fn: function () {
                var toData = [];
                toData.push(obj);
                var result = vm.findUptTenantNode(obj, false);
                for (var i = 0; i < result.codes.length; i++) {
                  result.codes[i].useYn = "N";
                  result.codes[i].disableClass = "disable-master";
                  toData.push(result.codes[i]);
                }
                vm.setChangeMenuState(toData, false);
              }
            }, {
              btn: '취소', fn: function () {}
            });
          }
          // End Depth 1;
        } else {
          // 2Depth 이상
          var str, state = false, result = [], msg = '';
          (obj.tenantId == "" || obj.useYn == "N") ?  state = true : state = false;
          if(state) {
            result = vm.findUptTenantNode(obj, true);
            if(result.codes.length == 0) {
              msg = "해당 메뉴를 [활성] 하시겠습니까?";
            } else {
              msg = "해당 메뉴 포함하여 [" + result.str + "] 메뉴를 [활성] 하시겠습니까?";
            }
          } else {
            if(obj.child.length > 0) {
              result = vm.findUptTenantNode(obj, false);
              msg = "해당 메뉴의 하위 메뉴포함하여 [비활성] 하시겠습니까?";
            } else {
              msg = "해당 메뉴를 [비활성] 하시겠습니까?";
            }
          }

          gConfirm('', msg, {
            btn: '확인', fn: function () {
              var toData = [];
              setMenuState(state, obj);
              toData = setChangeDepthCode(state, obj);
              if(state) {
                if(obj.child.length > 0) {
                  gConfirm('', "해당 메뉴의 하위 메뉴를 모두 [활성] 하시겠습니까.", {
                    btn: '확인', fn: function () {
                      var $thisObj = findObject(toData, 'sort', obj.sort);
                      for(var i = 0; i < $thisObj.child.length; i++) {
                        $thisObj.child[i] = setMenuState(state, $thisObj.child[i]);
                        var temp = findObject(vm.menuList, 'sort', $thisObj.child[i].sort);
                        temp = setMenuState(state, temp);
                      }

                      (state) ? vm.setChangeMenuState(toData, true, true) : vm.setChangeMenuState(toData, false, true);
                    }
                  }, {
                    btn: '취소', fn: function () {
                      (state) ? vm.setChangeMenuState(toData, true, true) : vm.setChangeMenuState(toData, false, true);
                    }
                  });
                } else {
                  (state) ? vm.setChangeMenuState(toData, true) : vm.setChangeMenuState(toData, false);
                }
              } else {
                (state) ? vm.setChangeMenuState(toData, true) : vm.setChangeMenuState(toData, false);
              }
            }
          }, {
            btn: '취소', fn: function () {}
          });
        }
      };

      function setMenuState(state, data) {

        // 배열로 작업 예정
        if(state) {
          data.useYn = "Y";
          data.disableClass = "";
        } else {
          data.useYn = "N";
          data.disableClass = "disable-master";
        }

        return data;
      }

      // 2Depth 이상 수행 함수
      function setChangeDepthCode(state, obj) {

        var result = [];
        var sort = makeSortPath(obj.sort);
        var size = sort.length, oneDepth, twoDepth, sortKey = -1;
        oneDepth = findObject(vm.menuList, 'sort', sort[0]);
        if(size == 3){
           twoDepth = findObject(vm.menuList, 'sort', Number(sort[0]+''+sort[1]));
           if(state) setMenuState(state, twoDepth);
        }


        if(state) { // 활성
          var index = -1, checkSort = -1, sortidx = -1;
          if(oneDepth.useYn == "Y") {
            sortKey = oneDepth.sort;
          } else {
            for(var i = 0; i < vm.menuList.length; i++) {
              if(vm.menuList[i].menuId == oneDepth.menuId) {
                index = i;
              }
              if(vm.menuList[i].useYn == "Y") {
                checkSort = Number(vm.menuList[i].sort);
                sortidx = i;
              }
            }

            if(checkSort == -1) { sortKey = 100 } else { sortKey = checkSort+1; }
            oneDepth.useYn = "Y";
            oneDepth.disableClass = "";
            oneDepth.sort = sortKey;
            oneDepth.tempSortPath[0] = sortKey;

            result.push(oneDepth);
          }

          for(var i = 0; i < oneDepth.child.length; i++) {
            var o = oneDepth.child[i];
            var childSort = makeSortPath(o.sort);
            childSort[0] = sortKey;
            o.sort =  + "" + Number(childSort.toString().replaceAll(",",""));
            o.tempSortPath = childSort;
            var d3ParentCode = [];
            angular.copy(o.tempSortPath, d3ParentCode);
            d3ParentCode.push(0);

            result.push(o);
            for(var j = 0; j < o.child.length; j++) {
              var _o = o.child[j];
              d3ParentCode[2] = _o.tempSortPath[2];
              _o.sort =  Number(d3ParentCode.toString().replaceAll(",",""));
              _o.tempSortPath = d3ParentCode;
              result.push(_o);
            }
          }

          if(index != -1) {
            var temp = {};
            angular.copy(vm.menuList[index], temp);
            vm.menuList.splice(index, 1);
            if(state) {
              (sortidx != -1) ? vm.menuList.splice(sortidx+1, 0, temp) : vm.menuList.push(temp);
            } else {
              vm.menuList.push(temp);
            }
          }
        } else { // 비활성
          result.push(obj);
          if(obj.child.length > 0) {
            for(var i = 0; i < obj.child.length; i++) {
              obj.child[i] = setMenuState(state, obj.child[i]);
              result.push(obj.child[i]);
            }
          }
        }
        return result;
      }

      vm.checkDepth1OtherData = function (obj) {
        var result = vm.findUptTenantNode(obj, false);
        if (result.codes.length > 0) {
          gConfirm('', "해당 메뉴의 하위 메뉴를 모두 [활성] 하시겠습니까.", {
            btn: '확인', fn: function () {
              var toData = [];
              toData.push(obj);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].useYn = "Y";
                result.codes[i].disableClass = "";
                toData.push(result.codes[i]);
              }

              vm.setChangeMenuState(toData, true);
            }
          }, {
              btn: '취소', fn: function () {
                var toData = [];
                toData.push(obj);
                for (var i = 0; i < result.codes.length; i++) {
                  toData.push(result.codes[i]);
                }
                vm.setChangeMenuState(toData, true);
              }
            });
        } else {
          var toData = [];
          toData.push(obj);
          vm.setChangeMenuState(toData, true);
        }
      };

      vm.setChangeMenuState = function (data, state, checkSortEnable) {
        var sendData = {};
        sendData.menus = data;
        // 190717 배열 인덱스 조절
        var index = -1;
        var sortidx = -1;
        if(data[0].depth == 1) {
          var sortKey = -1;
          for(var i = 0; i < vm.menuList.length; i++) {
            if(vm.menuList[i].menuId == data[0].menuId) {
              index = i;
              break;
            }
          }

          if(!state) {
            var checkUseY = 0, checkUseN = 0;
            for(var i = 0; i < vm.menuList.length; i++) {
              if(vm.menuList[i].useYn =="Y") checkUseY = vm.menuList[i].sort;
              if(vm.menuList[i].useYn =="N") checkUseN = vm.menuList[i].sort;
            }
            (checkUseN == 0) ? sortKey = checkUseY + 100 : sortKey = checkUseN + 1;
            data[0].useYn = "N";
            data[0].disableClass = "disable-master";
          } else {
            var checkSort = -1;
            for(var i = 0; i < vm.menuList.length; i++) {
              if(vm.menuList[i].useYn == "Y") {
                checkSort = Number(vm.menuList[i].sort);
                sortidx = i;
              }
            }
            if(checkSort == -1) { sortKey = 100 } else { sortKey = checkSort+1; }
            data[0].useYn = "Y";
            data[0].disableClass = "";
          }

          for(var i = 0; i < data.length; i++) {
            var orgSort = makeSortPath(data[i].sort);
            orgSort[0] = sortKey;
            data[i].sort = Number(orgSort.toString().replaceAll(",",""));
            data[i].tempSortPath = orgSort;
          }
        } // END IF (data[0].depth == 1)

        for (var i = 0; i < data.length; i++) {
          if(data[i].tenantId == "") {
            (vm.SysAdmin) ? data[i].tenantId
              = $window.sessionStorage['srchTenantId'] : data[i].tenantId = $window.sessionStorage['loginTenantId'];
          }
        }


        if(index != -1) {

          // index 검증
          for(var i = 0; i < sortidx; i++) {
            if(vm.menuList[i].useYn == "N") {
              sortidx = i - 2 ;
            }
          }

          var temp = {};
          angular.copy(vm.menuList[index], temp);
          vm.menuList.splice(index, 1);
          if(state) {

            if(sortidx != -1) {
              if(checkSortEnable == undefined)  sortidx = sortidx+1;
              vm.menuList.splice(sortidx, 0, temp);
            } else {
              vm.menuList.push(temp);
            }
          } else {
            vm.menuList.push(temp);
          }
        }

        sendData.menus = data;
        sendData.srchTenantId = '0';
        postApi.update('Menu.setTenantMenuList', sendData, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $rootScope.$broadcast('broadcastSetChangeMenuList', {});
            var msg;
            (state) ? msg = "해당 메뉴를 [활성]하였습니다." : msg = "해당 메뉴를 [비활성]하였습니다.";
            $rootScope.showSimpleToast(msg);
            vm.setChangeMenuList(false);
            for(var k = 0; k < data.length; k++) {
              if(data[k].menuTenantId == null || data[k].menuTenantId == "") {
                var request = {};
                request.menuId = data[k].menuId;
                request.srchTenantId = '0';
                postApi.callbackSelect('Menu.getTenantMenuId', request, data[k], function(result, data){
                  var sData = findObject(vm.menuList, 'menuId', data.menuId);
                  sData.menuTenantId =result.body.docs[0].menuTenantId;
                });
              }
            }
          } else {
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      /* START 연관설문 ********************************************* */
      vm.srch = {};
      vm.deleteMenuSvyList = deleteMenuSvyList;

      // 문제 목록 체크박스 설정
      vm.menuSvyChkHead = false;
      $scope.menuSvyChkRowChg = function () {
        for (var i = 0; i < vm.menuSvyLists.length; i++) {
          if (!vm.menuSvyLists[i].isChecked) {
            vm.menuSvyChkHead = false;
            return;
          }
        }
        vm.menuSvyChkHead = true;
      };

      $scope.menuSvyChkHeadChg = function () {
        for (var i = 0; i < vm.menuSvyLists.length; i++) {
          vm.menuSvyLists[i].menuSvyChkRow = vm.menuSvyChkHead;
        }
      };

      getMenuSvyList();

      /**
       * 설문 추가 팝업 호출
       */
      vm.addMenuSvyModal = function () {
        if (isNullOrEmpty(vm.menuInfo.menuId)) {
          vm.alertSelectMenu();
          return;
        }

        var ctrl = 'MenusurveyModalCtrl as vc';
        var paramData = {keyId: vm.menuInfo.menuId};
        var modalInstance = modalFactory.open('modal', 'components/modal/survey/menusvy-modal.html', ctrl, paramData);

        modalInstance.result.then(function (okData) {
          getMenuSvyList();
        }, function (cancelData) {
          getMenuSvyList();
        });
      };

      /**
       * 설문 목록 조회
       */
      function getMenuSvyList() {
        vm.dataloader = true; // Progressbar 표시

        var data = {};
        data.mapCode = "Survey.getMenusurveyList";
        data.MenuId = vm.menuInfo.menuId;
        data.srchTenantId = '0';

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            //console.log("re", result);
            if (result.body.docs.length > 0) {
              // 목록 데이터 표시
              vm.menuSvyLists = result.body.docs;
              vm.menuSvyTotalItems = vm.menuSvyLists.length;
            } else {
              // 데이터 조회 실패
              vm.menuSvyLists = {};
              vm.menuSvyTotalItems = 0;
            }
          }

          vm.dataloader = false; // Progressbar 숨김
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getMenuSvyList()");
          console.table(error);
        });
      }

      /**
       * 설문 목록 삭제
       */
      function deleteMenuSvyList() {
        if (isNullOrEmpty(vm.menuInfo.menuId)) {
          vm.alertSelectMenu();
          return;
        }

        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteMenuSvyListAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteMenuSvyListAction() {
        vm.srch.KeyIdList = [];

        for (var i = 0; i < vm.menuSvyLists.length; i++) {
          if (vm.menuSvyLists[i].menuSvyChkRow)
          {
            vm.srch.KeyIdList.push(vm.menuSvyLists[i].MenuSvyId);
          }
        }

        if (vm.srch.KeyIdList == null || vm.srch.KeyIdList.length == 0)
        {
          gAlert('', 'Menu.DELETENODATA');
          return false;
        }

        var data = vm.srch;
        data.mapCode = "Survey.deleteMenusurveyList";
        data.srchTenantId = '0';
        //data.MenuId = vm.menuInfo.menuId;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                getMenuSvyList();
              }
            });
          }
        }, function (error) {
          console.error("Error> deleteMenuSvyListAction()");
          console.table(error);
        });
      }
      /* END 연관설문 ********************************************* */


      /* START 권한정보 ********************************************* */

      /**
       * 페이지를 선택하였을 시 기본 정보를 가져온다.
       * @param {int} depth 메뉴 Depth
      */
      vm.loadPageData = function(data) {
        vm.rolesInfo = data;
        vm.rolesInfo.loadPageData = [];
        vm.rolesInfo.sqlMapper = [];
        vm.rolesInfo.conditions = [];
        vm.rolesInfo.Btn01Text = '';
        vm.rolesInfo.Btn02Text = '';
        vm.rolesInfo.Btn03Text = '';
        vm.rolesInfo.Btn04Text = '';
        vm.rolesInfo.Btn05Text = '';
        vm.rolesInfo.Btn06Text = '';
        vm.choiceRolePage = data.screenId;

        var srch = { mapCode: 'Menu.getBaseRoleInfo', screenId : data.screenId, srchTenantId: '0'};
        postApi.select(srch, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            initRoleData(result);
          } else {
            console.error('Error> getBaseRoleInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> getBaseRoleInfo', error);
        });
      };

      function initRoleData(result) {
        vm.rolesInfo.screen = result.body.docs;

        if (vm.rolesInfo.screen.length > 0) {
          vm.rolesInfo.Btn01Text = vm.rolesInfo.screen[0].Btn01Text;
          vm.rolesInfo.Btn02Text = vm.rolesInfo.screen[0].Btn02Text;
          vm.rolesInfo.Btn03Text = vm.rolesInfo.screen[0].Btn03Text;
          vm.rolesInfo.Btn04Text = vm.rolesInfo.screen[0].Btn04Text;
          vm.rolesInfo.Btn05Text = vm.rolesInfo.screen[0].Btn05Text;
          vm.rolesInfo.Btn06Text = vm.rolesInfo.screen[0].Btn06Text;
        }

        if(vm.rolesInfo.sqlId != null) {
          var sqlMap = vm.rolesInfo.sqlId.split(",");
          for(var i = 0; i < sqlMap.length; i++) {
            var o = {};
            o.sqlCode = sqlMap[i];
            o.useYn = true;
            o.delYn = "N";
            vm.rolesInfo.sqlMapper.push(o);
          }
        }

        if(vm.rolesInfo.paramPass != null) {
          var pass = vm.rolesInfo.paramPass.split(",");
          for(var i = 0; i < pass.length; i++) {
            var spliter = pass[i].split("=");
            var o = {};
            o.condition = spliter[0];
            o.value = spliter[1];
            o.useYn = true;
            o.delYn = "N";
            if(o.condition != null && o.condition != "")
            vm.rolesInfo.conditions.push(o);
          }
        }

        if(vm.rolesInfo.paramRefuse != null) {
          var paramRefuse = vm.rolesInfo.paramRefuse.split(",");
          for(var i = 0; i < paramRefuse.length; i++) {
            var spliter = paramRefuse[i].split("=");
            var o = {};
            o.condition = spliter[0];
            o.value = spliter[1];
            o.useYn = true;
            o.delYn = "N";
            if(o.condition != null && o.condition != "")
              vm.rolesInfo.conditions.push(o);
          }
        }

        vm.loadRolesData();
      }

      vm.loadRolesData = function() {
        if(vm.menuInfo.pages != null) {

        }
        //console.log(vm.menuInfo.pages);
      };

      vm.getLoadSqlMapper = function(){

        if (vm.choiceRolePage == null || vm.choiceRolePage == "") {
          gAlert('w', '연관페이지를 선택하여주세요.', {
            btn: '확인', fn: function () { }
          });
          return;
        }
        openTextFile();
      };

      function openTextFile() {
        var input = document.createElement("input");
        input.type = "file";
        input.accept = "js";

        input.onchange = function (event) {
            processFile(event.target.files[0]);
        };

        input.click();
      }

      function processFile(file) {
        var tx = "";
        var reader = new FileReader();
        reader.onload = function () {
          tx = reader.result.replaceAll(" ", "").replaceAll("\r\n","").replaceAll("\n","");
          if(tx.trim().length < 1) {
            gAlert('', '다시 시도하여주세요.', {
              btn: '확인', fn: function () { }
            });
            return;
          }
          for(var i = 0; i < 100; i++) {
            var check = false, index = -1, compareStr;
            if(tx.toLowerCase().indexOf('mapcode') != -1) {
              check = true;
              index = tx.toLowerCase().indexOf('mapcode');
              compareStr = 'mapcode';
            } else if(tx.toLowerCase().indexOf('postapi.') != -1) {
              check = true;
              index = tx.toLowerCase().indexOf('postapi.');
              compareStr = 'postapi';
            }
            if(!check) break;
            else {
              var index1 = -1, index2 = -1;
              tx = tx.substring(index, tx.length);
              if(compareStr == "mapcode") {
                index1 = tx.indexOf("\"");
                index2 = tx.indexOf("'");
                if(index1 == -1) index1 = 9999;
                if(index2 == -1) index2 = 9999;
                var temp;
                if(index1 < index2) {
                  tx = tx.substring(tx.indexOf('\"') + 1,tx.length);
                  temp = tx.substring(0, tx.indexOf('\"'));
                } else {
                  tx = tx.substring(tx.indexOf("'") + 1,tx.length);
                  temp = tx.substring(0, tx.indexOf("'"));
                }
                if(temp.indexOf("(") == -1 && temp.indexOf(")") == -1) {
                  var o = {};
                  o.sqlCode = temp.trim();
                  o.useYn = true;
                  o.delYn = "N";
                  var subCheck = true;
                  for(var z = 0; z < vm.rolesInfo.sqlMapper.length; z++) {
                    if(vm.rolesInfo.sqlMapper[z].sqlCode == o.sqlCode) {
                      subCheck = false;
                      break;
                    }
                  }
                  if(subCheck) {
                    if(temp.length > 1) vm.rolesInfo.sqlMapper.push(o);
                  }
                }

              } else {
                tx = tx.substring( tx.indexOf('(')+1, tx.length);
                var subTx = tx.substring(0, tx.indexOf(",")).trim();
                index1 = subTx.indexOf("\"");
                index2 = subTx.indexOf("'");
                if(index1 == -1) index1 = 9999;
                if(index2 == -1) index2 = 9999;
                if(index1 < index2) {
                  subTx = subTx.substring(subTx.indexOf('\"') + 1,subTx.length);
                  subTx = subTx.substring(0, subTx.indexOf('\"'));
                } else if(index1 > index2){
                  subTx = subTx.substring(subTx.indexOf("'") + 1,subTx.length);
                  subTx = subTx.substring(0, subTx.indexOf("'"));
                }
                if(subTx.indexOf(".") > -1) {
                  var o = {};
                  o.sqlCode = subTx.trim();
                  o.useYn = true;
                  o.delYn = "N";
                  var subCheck = true;
                  for(var z = 0; z < vm.rolesInfo.sqlMapper.length; z++) {
                    if(vm.rolesInfo.sqlMapper[z].sqlCode == o.sqlCode) {
                      subCheck = false;
                      break;
                    }
                  }
                  if(subCheck) {
                    if(subTx.length > 1) vm.rolesInfo.sqlMapper.push(o);
                  }
                }
              }
            }
          }

          setTimeout(function(){
            vm.rolesInfo.sqlMapper.push({sqlCode : ""});
            vm.rolesInfo.sqlMapper.splice(vm.rolesInfo.sqlMapper.length-1, 1);
            $rootScope.showSimpleToast('파일을 로드하였습니다.');
          }, 1000);

        };

        var errorEvent = function(event) {

          gAlert('', '다시 시도하여주세요.', {
            btn: '확인', fn: function () { }
          });
          if (event.type === 'loadstart') {
            reader.abort();
          }
        };
        reader.onerror = errorEvent;

        reader.readAsText(file, /* optional */ "utf-8");
      }

      vm.addSqlMapper = function() {
        if (vm.menuInfo.length == 0) {
          vm.alertSelectMenu();
          return;
        }
        var o = {};
        o.sqlCode = "";
        o.useYn = true;
        o.delYn = "N";
        vm.rolesInfo.sqlMapper.push(o);
      };

      vm.addCondition = function() {
        if (vm.menuInfo.length == 0) {
          vm.alertSelectMenu();
          return;
        }

        if(vm.rolesInfo.conditions == null) vm.rolesInfo.conditions = [];

        var o = {};
        o.condition = "";
        o.value = "";
        o.useYn = true;
        o.delYn = "N";
        vm.rolesInfo.conditions.push(o);
      };

      vm.setChangeEdtLabel = function() {
        if(vm.checkEdtLabel) {
          vm.checkEdtLabel = false;
          vm.checkEdtLabelText = "라벨편집";
        } else {
          vm.checkEdtLabel = true;
          vm.checkEdtLabelText = "수정완료";
        }
      };

      vm.setRoleData = function() {
        var request = angular.copy(vm.rolesInfo);

        var sql = request.sqlMapper;
        var cd = request.conditions;

        request.sqlId = "";
        for(var i = 0; i < sql.length; i++) {
          if(sql[i].useYn && sql[i].delYn == "N") {
            if(i != 0) request.sqlId += ",";
            request.sqlId += sql[i].sqlCode;
          }
        }
        request.paramPass = "";
        request.paramRefuse = "";
        for(var i = 0; i < cd.length; i++) {
          if(cd[i].delYn == "N") {
            if(cd[i].useYn) {
              request.paramPass += (cd[i].condition + "=" + cd[i].value + ",");
            } else {
              request.paramRefuse += (cd[i].condition + "=" + cd[i].value + ",");
            }
          }
        }
        if(request.paramPass != "") request.paramPass = request.paramPass.substring(0, request.paramPass.length-1);
        if(request.paramRefuse != "") request.paramRefuse =request.paramRefuse.substring(0, request.paramRefuse.length-1);

        // RoleScreen
        var screen = request.screen;
        request.roleScreen = [];
        for(var i = 0; i < screen.length; i++) {
          var o = {};
          o.roleScrId = screen[i].RoleScrId;
          o.screenId = screen[i].ScreenId;
          o.viewYn = screen[i].ViewYN;
          o.roleId = screen[i].RoleId;
          o.btn01Yn = screen[i].Btn01YN;
          o.btn02Yn = screen[i].Btn02YN;
          o.btn03Yn = screen[i].Btn03YN;
          o.btn04Yn = screen[i].Btn04YN;
          o.btn05Yn = screen[i].Btn05YN;
          o.btn06Yn = screen[i].Btn06YN;
          request.roleScreen.push(o);
        }
        request.srchTenantId = '0';

        postApi.update('Screen.updateScreenDetail2', request, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          } else {
            console.error('Error> setRoleData', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setRoleData', status, error);
        });

      };

      /************************************************************* */
      vm.viewChange = function (mode) {
        vm.viewMode = mode;
      };

      vm.setChangeMenuList = function (checkToast) {
        // 메뉴 리스트 1렬로 변경
        // A 모드와 TV 모드 변경
        var data = {}
        data.type = vm.viewMode;
        data.menus = [];
        var temp = vm.menuList;
        for (var i = 0; i < temp.length; i++) {
          data.menus.push(temp[i]);
          if (temp[i].child.length > 0) {
            for (var j = 0; j < temp[i].child.length; j++) {
              data.menus.push(temp[i].child[j]);
              if (temp[i].child[j].child.length > 0) {
                for (var k = 0; k < temp[i].child[j].child.length; k++) {
                  data.menus.push(temp[i].child[j].child[k]);
                }
              }
            }
          }
        }
        data.srchTenantId = '0';
        postApi.update('Menu.setAlignMenuList', data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if(checkToast != false) $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          } else {
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      };

      vm.setChangeTab = function (index) {
        if(index == 1) {
          if (vm.menuInfo.length == 0) {
            setTimeout(function(){
              $(".nav-tabs li").eq(0).addClass("active");
              $(".nav-tabs li").eq(1).removeClass("active");
            }, 500);

            vm.alertSelectMenu();
            return;
          }

          vm.loadRolesData();
        } else {
          $(".nav-tabs li").eq(0).addClass("active");
          $(".nav-tabs li").eq(1).removeClass("active");
        }

        for (var i = 0; i < vm.showTabView.length; i++) vm.showTabView[i] = "";
        vm.showTabView[index] = "in active";


      };

      //>> ICON
      /**
       * Font 를 저장한다.
      */
      function getFa() {
        var data = { mapCode: "fontAwesome.getFontList", srchTenantId: '0'};
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            vm.fontList = [];
            if (vm.menuInfo.icon != undefined) {
              for (var i = 0; i < result.body.docs.length; i++) {
                var o = {};
                o.name = result.body.docs[i].name;
                if (vm.menuInfo.icon == result.body.docs[i].name) {
                  o.active = "active";
                }
                vm.fontList.push(o);
              }
            } else {
              vm.fontList = result.body.docs;
            }
          }
        }, function (error) {
          console.error('Error> setBaseMenuInfo', status, error);
        });
      }

      //>> SELECT
      function initBaseMenuList() {
        vm.mSrchTenentID = '0';
        vm.menuList = [];
        vm.setChangeTab(0);
        var srchTenentID = $window.sessionStorage['srchTenantId'];
        if (vm.SysAdmin && srchTenentID == "0") vm.viewMode = "A";
        else vm.viewMode = "T";
        var request = { mapCode: 'Menu.getBaseMenuList', mobileOnlyYN: vm.mobileOnlyYN, srchTenantId: '0'};
        postApi.select(request, function (response) {
          if (checkResponse('initBaseMenuList', response)) {
            (vm.viewMode == "T") ? makeMenuList(response.body.docs, true) : makeMenuList(response.body.docs);
          }
        }, function (e) { console.error('Error> setBaseMenuInfo', status, e); });
      }

      function initRadioMenuType() {
        var data = { mapCode: 'Menu.getMenuType', code: '', mobileOnlyYN: vm.mobileOnlyYN, srchTenantId: '0' }
        postApi.select(data, function (response) {
          if (checkResponse('initRadioMenuType', response)) {
            vm.radioMenuType = response.body.docs;
          }
        }, function (e) { console.error('Error> initRadioMenuType', status, e); });
      }

      //>> #Broadcast
      // $scope.$on('broadcastSetChangeTenantID', function (event, args) {
      //   vm.setDetailView();
      //   initBaseMenuList();
      // });

      //>> #Init
      vm.initialize = function () {
        initBaseMenuList();
        initRadioMenuType();
        getFa();
      };
      vm.initialize();

      //>> #Other

      function makeSortPath(sort) {
        var sort = sort.toString();
        var result = Array();
        if(sort.length >= 3) {
          result.push(Number(sort.substring(0, 3)));
        }
        if(sort.length >= 6) {
          result.push(Number(sort.substring(3, 6)));
        }
        if(sort.length == 9) {
          result.push(Number(sort.substring(6, 9)));
        }
        return result;
      }

      function makeMenuList(data, check) {
        console.log(data, check)
        console.log(check, JSON.parse(JSON.stringify(data)))
        // SORT를 다시 만들어주는 작업이 필요함
        // 현재 베이스 코드와 일반 코드가 정렬하면서 문제가 발생
        var checkDepth1Code = 0;
        var checkUpdateMenuList = false;
        var lastUseYSort = 99;
        for (var i = 0; i < data.length; i++) {
          var o = {};
          o.menuId = data[i].menuId;
          o.depth = data[i].depth;
          o.menuNm = data[i].menuNm;
          o.path = data[i].path;
          o.icon = data[i].icon;
          o.menuType = data[i].menuType;
          o.sort = data[i].sort;
          o.baseSortKey = data[i].baseSortKey;

          if(o.depth == 1 && (data[i].menuTenantId == "" || data[i].useYn == "N")) {

            var tempSort = o.sort;
            var checkN = false, checkPassSort = 0, checkUseNSort = 0;
            for(var j = 0; j < vm.menuList.length; j++) {
              if(vm.menuList[j].useYn == "Y") checkPassSort = vm.menuList[j].sort;
              if(vm.menuList[j].useYn == "N") checkUseNSort = vm.menuList[j].sort;
            }

            (checkUseNSort == 0) ? o.sort = checkPassSort + 100 : o.sort = checkUseNSort + 1;
            checkDepth1Code = o.sort;
            for(var j = i+1; j < data.length; j++) {
              var code1Depth = makeSortPath(data[j].sort);
              if(tempSort == code1Depth[0]) {
                data[j].sort = checkDepth1Code + "" + code1Depth[1];
                if(code1Depth.length == 3) data[j].sort += ""+code1Depth[2];
                data[j].sort = Number(data[j].sort);
              }
            }
          } else {
            if(o.depth == 1) {
              if(lastUseYSort + 1 == data[i].sort) {
                lastUseYSort = data[i].sort;
              } else {
                checkUpdateMenuList = true;
                lastUseYSort = lastUseYSort + 1;
                o.sort = lastUseYSort;
                for(var j = i+1; j < data.length; j++) {
                  var code1Depth = makeSortPath(data[j].sort);
                  if(data[i].sort == code1Depth[0]) {
                    code1Depth[0] = lastUseYSort;
                    data[j].sort = Number(code1Depth.toString().replaceAll(",",""));
                  }
                }
              }
            }
          }

          o.tempSortPath = makeSortPath(o.sort);
          o.tempBaseSortPath = makeSortPath(o.baseSortKey);
          o.tenantId = data[i].tenantId;
          o.menuTenantId = data[i].menuTenantId;
          o.useYn = data[i].useYn;

          if (data[i].tenantId == "" ) o.disableClass = "disable-master";
          else if(data[i].useYn == "N")  o.disableClass = "disable-master";
          else o.disableClass = "";
          o.extendGroupClass = "";
          o.child = [];

          if (Number(data[i].depth) == 1) {
            vm.menuList.push(o);
          } else {

            // 2019.11.06 기존 Sort가 겹치는 문제가 발생하여
            // 2Depth부터는 BaseSortKey를 기준으로 변경하도록 수정

            /* var temp;
            if(o.tempSortPath.length == 2) temp = o.tempSortPath[0];
            else temp = o.tempSortPath[0] + '' + o.tempSortPath[1];
            var sData;
            sData = findObject(vm.menuList, 'sort', temp); */

            var temp;
            if(o.tempBaseSortPath.length == 2) temp = o.tempBaseSortPath[0];
            else temp = o.tempBaseSortPath[0] + '' + o.tempBaseSortPath[1];
            var sData;
            //sData = findObject(vm.menuList, 'sort', temp);

            /* if(temp == '209' || temp == "209102" ) {
              console.log(sData, o)
            } */


          //  if(!sData) {

              var parent = findObject(vm.menuList, 'baseSortKey', temp);
              var parentCode = parent.sort;
              var subpath = makeSortPath(parentCode);
              if(subpath.length == 1) {
                o.tempSortPath[0] = subpath[0];
                o.tempSortPath[1] = 100 + parent.child.length;
                temp = subpath[0]
              } else {
                o.tempSortPath[0] = subpath[0];
                o.tempSortPath[1] = subpath[1];
                o.tempSortPath[2] = 100 + parent.child.length;
                temp = o.tempSortPath[0] + '' + o.tempSortPath[1];
              }

              o.sort = o.tempSortPath.toString().replaceAll(",","");

              sData = findObject(vm.menuList, 'sort', temp);
              checkUpdateMenuList = true;
              //console.log(parentCode, o, temp, sData);
           //}
            sData['child'].push(o);
          }
        }

        if(checkUpdateMenuList) {
          vm.setChangeMenuList(false);
        }
        if (vm.selectedGroupOptions != "") vm.onChangeGroupView(vm.selectedGroupOptions);
      };

      function findObject(obj, key, value) {
        for (var i = 0; i < obj.length; i++) {
          for (var objKey in obj[i]) {
            if (objKey == key) {
              if (obj[i][objKey] == value) {
                return obj[i];
              }
            }
          }
          if (obj[i]["child"].length > 0) {
            var result = findObject(obj[i]["child"], key, value);
            if (result != false) return result;
          }
        }
        return false;
      }

      function checkResponse(fNm, reponse) {
        if (reponse.header.status === CONSTANT.HttpStatus.OK) return true;
        else {
          console.error('Error>' + fNm, reponse.header.status, reponse.body.docs[0]);
        }
      }
    },
  ])
})();

webapp.service('RoleAPISrv', ['$resource', 'StaticVariable',
  function RoleAPISrv($resource, StaticVariable) {
    var api = {
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/Role.getRoleList/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCount: function() {
        return $resource(StaticVariable.getUrl('/select/Role.getRoleListCnt/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/Role.getRoleDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail: function() {
        return $resource(StaticVariable.getUrl('/update/Role.updateRoleDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/insert/Role.insertRoleDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/Role.deleteRoleDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return api;
  },
]);

(function() {
  "use strict";
  /**
 * @ngdoc function
 * @name app.system:role-detail-ctrl
 * @description # 사용자 역할 상세보기 Controller
 */

webapp.controller('RoleDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'RoleAPISrv',
    'gAlert', 'gConfirm', 'postApi',
/**
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state - state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} RoleAPISrv - RoleAPISrv Module
 * @param {object} gAlert - Alert Module *
 */

  function RoleDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, gAlert, gConfirm, postApi) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        RoleId : $stateParams.srch.RoleId ? $stateParams.srch.RoleId  : '',
        TenantId : vm.TenantId,
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'role',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if ($stateParams.RoleId) {
      vm.srch.RoleId = $stateParams.RoleId;
    }

    vm.srchDetail = {};
    angular.copy(vm.srch, vm.srchDetail);

    // 조회 데이터
    vm.data = {
      RoleId : $stateParams.RoleId,
      TenantId : vm.TenantId,
      tableNm : 'role',
    };

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
    */
    function getData() {
      vm.dataloader = true;
      var data = vm.srchDetail;

      data.mapCode = 'Role.getRoleDetail';

      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];
          }
        }
        vm.dataloader = false;
      },function(error) {
        console.error('Error> role-edit-ctrl> getData()', status, error);
        vm.dataloader = false;
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    function deleteDetail() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteDetailAction();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function deleteDetailAction() {
      if (vm.data == null) {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      console.log("before delete", vm.data);

      var data = vm.data;
      data.mapCode = 'Role.deleteRoleDetail';
      postApi.update(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              var srch = $stateParams.srch;
              $state.go('app.system.role-list', {
                srch:srch
              }, {reload:'app.system.role-list'});
            }
          });
          return;
        }
      }, function(error) {
        console.error('Error> role-detail-ctrl> deleteDataAction()', status, error);
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    function goList() {
      var srch = $stateParams.srch;
      $state.go('app.system.role-list', {
        srch : srch
      });
    }

    function goEdit() {
      var srch = $stateParams.srch;
      if (vm.layout == 'N') {
        $state.go('app.system.role-edit', {
          srch : srch, RoleId : vm.data.RoleId
        });
      } else {
        $state.go('app.system.role-list.edit', {
          srch : srch, RoleId : vm.data.RoleId
        });
      }
    }

    // 함수 선언
    vm.getData = getData;
    vm.deleteDetail = deleteDetail;
    vm.goList = goList;
    vm.goEdit = goEdit;

    // 데이터 조회
    getData();
  }, ]);
})();

/**
 * @ngdoc function
 * @name app.system.role-edit-ctrl
 * @description
 * # 역활 등록/수정
 * Controller of the 역활관리
 */
webapp.controller('RoleEditCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'RoleAPISrv',
    'gAlert', 'gConfirm', 'postApi',
/**
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state -  state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} RoleAPISrv - RoleAPISrv Module
 * @param {object} gAlert - Alert Module
 */

  function RoleEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, api, gAlert, gConfirm, postApi) {
    // View Model
    var vm = this;
    vm.dataloader = false;

    vm.srch = {};
    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        BbsMasterId : $stateParams.srch.BbsMasterId ? $stateParams.srch.RoleId : '',
        tableNm : $stateParams.srch.tableNm ? $stateParams.srch.tableNm : 'Users',
        TenantId : vm.TenantId,
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
    }

    vm.layout = $rootScope.gVariable.layoutBoard;

    if ($stateParams.RoleId) {
      vm.srch.RoleId = $stateParams.RoleId;
    }

    vm.srchDetail = {};
    angular.copy(vm.srch, vm.srchDetail);

    // 조회 데이터
    vm.data = {
      RoleId : vm.srch.RoleId != null ? $stateParams.RoleId : '',
      TenantId : vm.TenantId,
      tableNm : vm.srch.tableNm,
      RoleType : 'ROOT'
    };

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author rohbi
    */
    function getData() {
      vm.dataloader = true;
      if (vm.srch.RoleId == null || vm.srch.RoleId == '') {
        vm.dataloader = false;
        return;
      }

      var data = vm.srchDetail;
      data.mapCode = 'Role.getRoleDetail';

      postApi.select(data, function(result){
        vm.dataloader = false;
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.data = result.body.docs[0];

          }
        }
      }, function(error) {
        console.table(error);
        vm.dataloader = false;
      });
    }

  /**
   * 필수 입력 & Validation Check
   *
   * @param
   * @return
   */
  function getIsValidData() {

    // #region 필수항목 체크
    var errMsg = '';


    if (isNullOrEmpty(vm.data.RoleNm))
      errMsg = errMsg + '- 역할명을 입력하세요.<br/>';

    if (!isNullOrEmpty(errMsg)) {
      gAlert('', errMsg);
      return false;
    }

    // #endregion 필수항목 체크

    //#region Validation Check

    return true;
    //#endregion Validation Check
  }


    /**
     * 데이터 저장
     *
     * @param
     * @return
     * @author 최원영
    */
    function setData() {

      // #region 필수항목 & Validation Check 체크
      if (!getIsValidData()) {
        return;
      }
      // #endregion 필수항목 & Validation Check 체크


      // 내용
      vm.data.tableNm = vm.srch.tableNm;
      vm.data.TableId = vm.data.RoleId;

      var data = vm.data;

      if (vm.data.RoleId == null || vm.data.RoleId == '') {
        // 등록
        data.mapcode = "Role.insertRoleDetail";
        postApi.insert(data, function(result){
          InsertUpdateDetail(result);
        },function(error) {
          console.table(error);
        });
      } else {
        // 수정
        data.mapCode = "Role.updateRoleDetail";
        postApi.update(data, function(result){
          InsertUpdateDetail(result);
        },function(error) {
          console.table(error);
        });
      }
    }

    function InsertUpdateDetail(result) {
      if (result.header.status === CONSTANT.HttpStatus.OK) {
        if (result.body.docs[0].RoleId !== null || result.body.docs[0].TableId !== null) {
          // KeyId 조회
          vm.data.RoleId = result.body.docs[0].RoleId;

          gAlert("", "Menu.SAVED", {
            btn: "",
            fn: function() {
              var srch = $stateParams.srch;

              if (vm.layout == 'N') {
                if (vm.srch.RoleId == null || vm.srch.RoleId == '') {
                  $state.go("app.system.role-list", { srch: srch });
                } else {
                  // 조회 화면 이동
                  $state.go("app.system.role-detail", {
                    srch: srch,
                    RoleId: vm.data.RoleId
                  });
                }
              } else {
                vm.srch.RoleId = "";
                vm.srch.reload = (new Date()).getTime();
                srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                $state.go("app.system.role-list.detail", { srch: srch, RoleId:vm.data.RoleId });
              }
            }
          });
          return;
        }
      }
      console.table(result);
    }

    function goList() {
      vm.srch.RoleId = "";
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go("app.system.role-list", { srch: srch });
    }

    function deleteDetail() {
      gConfirm('', 'Menu.DELETECONFIRM', {
        btn : '',
        fn : function() {
          deleteDetailAction();
        }
      }, {
        btn : '',
        fn : function() {
        }
      });
    }

    function deleteDetailAction() {
      if (vm.data == null) {
        gAlert('', 'Menu.CANNOTDELETE');
        return;
      }

      var data = vm.data;
      data.mapCode = 'Role.deleteRoleDetail';
      postApi.update(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.DELETED', {
            btn : '',
            fn : function() {
              if (vm.layout == 'N') {
                vm.srch.RoleId = "";
                srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                $state.go("app.system.role-list", { srch: srch });
              } else {
                vm.srch.ScreenId = "";
                vm.srch.reload = (new Date()).getTime();
                srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                $state.go("app.system.role-list.edit", { srch: srch, RoleId:''});
              }
            }
          });

        }
      }, function(error) {
        console.error('Error> role-detail-ctrl> deleteDataAction()', status, error);
        gAlert('', error.responseVO.body.docs[0].errMessage);
      });
    }

    // 함수 선언
    vm.getData = getData;
    vm.setData = setData;
    vm.goList = goList;
    vm.deleteDetail = deleteDetail;

    // 데이터 조회
    getData();

    }, ]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.system:role-list-ctrl
 * @description
 * # 고객그룹 목록
 * Controller of the 고객그룹 목록
 */

webapp.controller('RoleListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi',
/**
 * 고객그룹 - 목록화면 Control
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param RoleAPISrv - RoleAPISrv Module
 */
  function RoleListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi) {

    // View Model
    var vm = this;
    vm.dataloader = false;

    // TenantId
    vm.TenantId = $window.sessionStorage['loginTenantId'];

    if (!$stateParams.srch) {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : 'Role',
        TenantId : vm.TenantId,
        SysAdminYN : $window.sessionStorage['loginSysAdminYN'],
        CustType : '',
        UseYN : '',
        sortDirect : '',
        sortColumn : '',
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'Role';
      vm.currentPage = vm.srch.page;
    }

    $scope.selectedRow = $stateParams.RoleId;

    // view 사이즈 목록
    vm.listSize = [ 10, 25, 50, 100 ];


    // 전역상수 선언
    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.srch.layout);

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    function getSearch() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go($state.current.name, {srch:srch}, {reload:$state.current.name});
    }

    function resetSearch() {
      $state.go('app.system.role-list', {
        srch : ''
      }, {reload: 'app.system.role-list'});
    }

    // 회원사 변경 체크
    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      getList();
    });

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
    */
    function getList() {
      vm.dataloader = true;
      vm.srch.page = vm.currentPage;
      $window.sessionStorage.setItem("role-list-ctrl", angular.toJson(vm.srch));

      getListCount();

      var data = vm.srch;
      data.mapCode = 'Role.getRoleList';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.totalItems = 0;
            vm.lists = {};
          }
        }
        vm.columnMap = '';
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', status, data);
        vm.dataloader = false;
      });
    }

    function getListCount() {
      var data = vm.srch;
      data.mapCode = 'Role.getRoleListCnt';

      postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docCnt > 0) {
            vm.totalItems = result.body.docs;
          } else {
            vm.totalItems = 0;
          }
        }
      }, function(error) {
        console.error('Error-getList', status, data);
      });
    }

    function goEdit(RoleId) {
      var srch = $stateParams.srch;
      $scope.selectedRow = RoleId;

      if (vm.layout == 'N') {
        $state.go('app.system.role-edit', {
          srch : srch,
          RoleId : RoleId,
        });
      } else {
        $state.go('app.system.role-list.edit', {
          srch : srch,
          RoleId : RoleId,
        });
      }
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go('app.system.role-list', {srch:srch}, {reload:'app.system.role-list'});
    }

    function changeViewSize() {
      vm.currentPage = 1;
      vm.viewSize = vm.srch.viewSize;
      console.log('srch :: ch ::',vm.viewSize);
      getSearch();
    }

    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch(vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "600px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem('layoutBoard', layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go('app.system.role-list', {
        srch : srch
      }, {reload: 'app.system.role-list'});
    }

      // 함수 선언
      vm.pageChanged = pageChanged;
      vm.getList = getList;
      vm.changeViewSize = changeViewSize;
      vm.getSearch = getSearch;
      vm.resetSearch = resetSearch;
      vm.sortClass = sortClass;
      vm.tablesort = tablesort;
      vm.setLayout = setLayout;
      vm.changeLayout = changeLayout;
      vm.goEdit = goEdit;

      // 데이터 조회
      getList();
    }, ]);
})();

webapp.service('ScreenAPISrv', ['$resource', 'StaticVariable',
  function ScreenAPISrv($resource, StaticVariable) {
    var api = {
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/Screen.getScreenList/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCnt: function() {
        return $resource(StaticVariable.getUrl('/select/Screen.getScreenCount/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/Screen.getScreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doComboRole: function() {
          return $resource(StaticVariable.getUrl('/select/Role.getRoleList/action.json'), {},
            StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateDetail: function() {
        return $resource(StaticVariable.getUrl('/update/Screen.updateScreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/insert/Screen.insertScreen/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/Screen.deleteScreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doCallProcRolescreen: function() {
    	  return $resource(StaticVariable.getUrl('/select/Rolescreen.callProcRolescreen/action.json'), {},
    			  StaticVariable.getRequestActions.defaultAction());
      },
    };
    return api;
  },
]);

/**
 * @ngdoc function
 * @name
 * @description # 등록/수정 Controller
 * @param {object}
 *          $window - window object
 * @param {object}
 *          $scope - scope object
 * @param {object}
 *          $location - location object
 * @param {object}
 *          $state - state object
 * @param {object}
 *          $stateParams - state Parameter object
 * @param {object}
 *          CONSTANT - 전역 상수
 * @param {object}
 *          StaticVariable - StaticVariable object
 * @param {object}
 *          api - ScreenApiSvr Module
 * @param {object}
 *          gAlert - Alert Module *
 */
webapp.controller('ScreenDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'ScreenAPISrv',
    'gAlert', 'gConfirm', function ScreenDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, gAlert, gConfirm) {

      // View Model
      var vm = this;

      // 페이징
      vm.page = $stateParams.page;

      // 검색 조건
      vm.srch = {
        ScreenId : $stateParams.ScreenId,
        IdName : 'ScreenId',
        TableId : $stateParams.ScreenId,
        tableNm : 'Screen',
      };

      // 조회 데이터
      vm.data = {
        ScreenId : $stateParams.ScreenId,
        IdName : 'ScreenId',
        TableId : $stateParams.ScreenId,
        tableNm : 'Screen',
      };

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        var prms = api.doDetail().post(vm.srch).$promise;
        prms.then(function(data) {
          console.log("load", data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].ScreenId !== null) {
              vm.data = data.responseVO.body.docs[0];
              return;
            }
          }
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        }, function(data) {
          console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       * @author 최원영
       */
      function setData() {
        // 내용
        vm.data.tableNm = "Screen";
        vm.data.TableId = vm.data.ScreenId;

        var prms = null;

        console.log(vm.data);
        if (vm.data.ScreenId == 0) {
          // 등록
          prms = api.doInsertDetail().post(vm.data).$promise;
        } else {
          // 수정
          prms = api.doUpdateDetail().post(vm.data).$promise;
        }

        prms.then(function(data) {
          console.log(data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].TenantId !== null || data.responseVO.body.docs[0].TableId !== null) { // insert
              // 시
              // TableId
              // 만
              // 넘어옴
              // KeyId 조회
              vm.data.ScreenId = data.responseVO.body.docs[0].ScreenId;

              gAlert('', 'Menu.SAVED', {
                btn : '확인',
                fn : function() {
                  if ($stateParams.ScreenId === "0") {
                    $state.go("app.system.screen-list");
                  } else {
                    vm.data.ScreenId = data.responseVO.body.docs[0].ScreenId !== null ? data.responseVO.body.docs[0].ScreenId : "0";
                    vm.srch.ScreenId = vm.data.ScreenId;
                  }
                }
              });
              return;
            }
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error-setData', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }
        console.log("before delete", vm.data);

        var prms = api.doDelete().post(vm.data).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                $state.go("app.system.screen-list")
              }
            });
            return;
          }
        },

        function(data) {
          console.error('fail', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      // 함수 선언
      vm.getData = getData;
      vm.setData = setData;
      vm.deleteDetail = deleteDetail;

      // 데이터 조회
      getData();
    }, ]);

/**
 * @ngdoc function
 * @name app.system:screen-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state -  state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} postApi - postApi Module
 * @param {object} gAlert - Alert Module
 */
webapp.controller('ScreenEditCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', function ScreenEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, postApi, gAlert, gConfirm) {
      // View Model
      var vm = this;

      // 페이징
      vm.page = $stateParams.page;

      // 검색 조건
      vm.srch = {
        ScreenId : $stateParams.ScreenId,
        IdName : 'ScreenId',
        TableId : $stateParams.ScreenId,
        tableNm : 'screen',
        uploadFileList : [],
      };

      // 조회 데이터
      vm.data = {
        ScreenId : $stateParams.ScreenId,
        tableNm : 'screen',
        IdName : 'ScreenId',
      };

      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        var data = vm.srch;
        data.mapCode = 'Screen.getScreenDetail';
        vm.dataloader = true;
        // 내용
        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];
            }
          } else {
            console.log(result.body);
            gAlert('', result.body.docs[0].errMessage);
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error-getList', error);
          vm.dataloader = false;
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       * @author 최원영
       */
      function setData() {
        var data = vm.data;
        data.tableNm = vm.srch.tableNm;
        data.TableId = vm.data.ScreenId;
        vm.dataloader = true;
        if (data.ScreenId == null || data.ScreenId == '') {
          // 등록
          data.mapcode = "Screen.insertScreen";
          postApi.insert(data, function(result) {
            vm.dataloader = false;
            InsertUpdateDetail(result);
          },function(error) {
            vm.dataloader = false;
            console.table(error);
          });
        } else {
          // 수정
          data.mapCode = "Screen.updateScreenDetail";
          postApi.update(data, function(result){
            vm.dataloader = false;
            InsertUpdateDetail(result);
          },function(error) {
            vm.dataloader = false;
            console.table(error);
          });
        }
      }

      function InsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (result.body.docs[0].ScreenId !== null || result.body.docs[0].TableId !== null) {
            // KeyId 조회
            vm.data.ScreenId = result.body.docs[0].ScreenId;

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function() {
                var srch = $stateParams.srch;

                if (vm.layout == 'N') {
                  if (vm.srch.ScreenId == null || vm.srch.ScreenId == '') {
                    $state.go("app.system.screen-list", { srch: srch });
                  } else {
                    // 조회 화면 이동
                    $state.go("app.system.screen-edit", {
                      srch: srch,
                      ScreenId: vm.data.ScreenId
                    });
                  }
                } else {
                  var srch2 = srch? JSON.parse(decodeURIComponent(srch)):{};
                  srch2.ScreenId = "";
                  srch2.reload = (new Date()).getTime();
                  srch = encodeURIComponent(JSON.stringify(srch2, replacer));

                  $state.go("app.system.screen-list.edit", { srch: srch, ScreenId:vm.data.ScreenId });
                }
              }
            });
            return;
          }
        }
        console.table(result);
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }

        vm.dataloader = true;
        vm.data.mapcode = "Screen.deleteScreenDetail";
        postApi.update(vm.data, function(result) {
          vm.dataloader = false;
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                if (vm.layout == 'N') {
                  vm.srch.ScreenId = "";
                  srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                  $state.go("app.system.screen-list", { srch: srch });
                } else {
                  vm.srch.ScreenId = "";
                  vm.srch.reload = (new Date()).getTime();
                  srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
                  $state.go("app.system.screen-list.edit", { srch: srch, ScreenId:''});
                }
              }
            });
          }
        },function(error) {
          vm.dataloader = false;
          console.table(error);
        });
      }

      function goList() {
        vm.srch.ScreenId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go("app.system.screen-list", { srch: srch });
      }

      // 함수 선언
      vm.getData = getData;
      vm.setData = setData;
      vm.goList = goList;
      vm.deleteDetail = deleteDetail;

      // 데이터 조회
      getData();
    }, ]);

(function() {
  "use strict";
/**
 * @ngdoc function
 * @name app.bbspost:bbspost-list-ctrl
 * @description # 목록 Controller of the 사용자정의 필드 게시판
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param api -  ScreenAPISrv Module
 */
webapp.controller('ScreenListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi', 'gAlert', 'gConfirm',
  function ScreenListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi, gAlert, gConfirm) {
    // View Model
    var vm = this;
    vm.dataloader = false;

    // TenantId
    vm.TenantId = $window.sessionStorage['loginTenantId'];

    if ($stateParams.srch == '') {
      vm.srch = {
        page : 1,
        viewSize : CONSTANT.PAGINATION.VIEWSIZE,
        tableNm : 'screen',
        TenantId : vm.TenantId,
        SysAdminYN : $window.sessionStorage['loginSysAdminYN'],
        sortDirect : '',
        sortColumn : ''
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'screen';
      vm.currentPage = vm.srch.page;
    }

    $scope.selectedRow = $stateParams.ScreenId;

    vm.listSize = [ 10, 25, 50, 100 ];

    vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE;
    vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;
    vm.srch.viewSize = vm.viewSize;

    // 검색 조건 표시용 컬럼 목록
    vm.srchList = {};
    angular.copy(vm.srch, vm.srchList);
    vm.srchList.searchColumns = {};
    vm.layout = $rootScope.gVariable.layoutBoard;
    vm.anchor = "";
    setLayout(vm.srch.layout);

    /* Sorting Methods */
    function tablesort(sortkey){
      if (vm.srch.sortColumn != sortkey) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortkey;
      getSearch();
    }

    function sortClass(sortkey){
      if (sortkey != vm.srch.sortColumn)
        return 'fa fa-sort';

      var rtnval = '';

      if (vm.srch.sortDirect == 'ASC'){
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    function getSearch() {
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go($state.current.name, {srch:srch}, {reload:$state.current.name});
    }

    function resetSearch() {
      $state.go('app.system.screen-list', {
        srch : ''
      }, {reload: 'app.system.screen-list'});
    }

    // 회원사 변경 체크
    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      getList();
    });

    /**
     * 데이터 조회
     *
     * @param
     * @return
     * @author 최원영
     */
    function getList() {
      vm.viewSize = vm.srch.viewSize;

      vm.dataloader = true;
      getListCnt();

      var data = vm.srch;
      data.mapCode = 'Screen.getScreenList';

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.lists = result.body.docs;
          } else {
            vm.totalItems = 0;
            vm.lists = {};
          }
        }
        vm.columnMap = '';
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function getListCnt() {
      var data = vm.srch;
      data.mapCode = 'Screen.getScreenListCnt';

      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs[0].totalItems;
          } else {
            vm.totalItems = 0;
            vm.lists = {};
          }
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function goDetail(ScreenId) {
      var srch = $stateParams.srch;

      if (vm.layout == 'N') {
        $state.go('app.system.screen-detail', {
          srch : srch,
          ScreenId : ScreenId,
        });
      } else {
        $state.go('app.system.screen-list.detail', {
          srch : srch,
          ScreenId : ScreenId,
        });
      }
    }

    function goEdit(ScreenId) {
      var srch = $stateParams.srch;
      $scope.selectedRow = ScreenId;

      if (vm.layout == 'N') {
        $state.go('app.system.screen-edit', {
          srch : srch,
          ScreenId : ScreenId
        });
      } else {
        $state.go('app.system.screen-list.edit', {
          srch : srch,
          ScreenId : ScreenId
        });
      }
    }

    /**
     * 페이지 번호 변경시 데이터 조회 함수 호출
     * @param
     * @return
     * @author 최원영
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      getSearch();
    }

    function changeViewSize() {
      vm.currentPage = 1;
      getList();
    }

    function setLayout(layout) {
      if (angular.isUndefined(layout)) {
        vm.layout = $rootScope.gVariable.layoutBoard;
      } else {
        vm.layout = layout;
      }

      switch(vm.layout) {
        case "H":
          vm.anchor = "north";
          vm.paneMin = "300px";
          break;
        case "V":
          vm.anchor = "west";
          vm.paneMin = "600px";
          break;
        case "N":
          vm.anchor = "";
          vm.paneMin = "600px";
          break;
      }
    }

    function changeLayout(layout) {
      $window.sessionStorage.setItem('layoutBoard', layout);
      $rootScope.gVariable.layoutBoard = layout;
      var srch = $stateParams.srch;
      $state.go('app.system.screen-list', {
        srch : srch
      }, {reload: 'app.system.screen-list'});
    }

    // 함수 선언
    vm.pageChanged = pageChanged;
    vm.getList = getList;
    vm.changeViewSize = changeViewSize;
    vm.getSearch = getSearch;
    vm.resetSearch = resetSearch;
    vm.sortClass = sortClass;
    vm.tablesort = tablesort;
    vm.setLayout = setLayout;
    vm.changeLayout = changeLayout;
    vm.goDetail = goDetail;
    vm.goEdit = goEdit;

    // 데이터 조회
    getList();
  }, ]);
})();

webapp.service('RolescreenAPISrv', ['$resource', 'StaticVariable',
  function RolescreenAPISrv($resource, StaticVariable) {
    var api = {
      doList: function() {
        return $resource(StaticVariable.getUrl('/select/Rolescreen.getRolescreenList/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doListCnt: function() {
        return $resource(StaticVariable.getUrl('/select/Rolescreen.getRolescreenCount/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDetail: function() {
        return $resource(StaticVariable.getUrl('/select/Rolescreen.getRolescreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doComboRole: function() {
          return $resource(StaticVariable.getUrl('/select/Role.getRoleList/action.json'), {},
            StaticVariable.getRequestActions.defaultAction());
      },
      doUpdateList: function() {
        return $resource(StaticVariable.getUrl('/update/Rolescreen.updateRolescreen/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doInsertDetail: function() {
        return $resource(StaticVariable.getUrl('/tenant/insertRolescreen.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
      doDelete: function() {
        return $resource(StaticVariable.getUrl('/update/Rolescreen.deleteRolescreenDetail/action.json'), {},
          StaticVariable.getRequestActions.defaultAction());
      },
    };
    return api;
  },
]);

/**
 * @ngdoc function
 * @name
 * @description # 등록/수정 Controller
 * @param {object}
 *          $window - window object
 * @param {object}
 *          $scope - scope object
 * @param {object}
 *          $location - location object
 * @param {object}
 *          $state - state object
 * @param {object}
 *          $stateParams - state Parameter object
 * @param {object}
 *          CONSTANT - 전역 상수
 * @param {object}
 *          StaticVariable - StaticVariable object
 * @param {object}
 *          api - RolescreenApiSvr Module
 * @param {object}
 *          gAlert - Alert Module *
 */
webapp.controller('RolescreenDetailCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'RolescreenAPISrv',
    'gAlert', 'gConfirm', function RolescreenDetailCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, gAlert, gConfirm) {

      // View Model
      var vm = this;

      // 페이징
      vm.page = $stateParams.page;

      vm.onSelectCallback = {
        onSelectComplete : function(data) {
          if (data.CodeType == '130') {
            vm.data.CompanyType = data.Value;
          }
        }
      }

      // 업로드 파일 목록
      vm.uploadFileList = [];

      vm.onFileCallback = {
        onFileUploadComplete : function() {
          console.log('file items::', vm.uploadFileList);
        },
        onFileDelete : function(item) {
          console.log('delete item::', item);
          var param = {
            'fileId' : item.id
          };
          var prms = h0101Api.attachFileDelete().post(param).$promise;
          prms.then(

          function(data) {
            console.log(data);
            if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED');
            }
          });
        }
      }

      vm.stateParams = {
        TenantId : $stateParams.TenantId,
      };

      // 검색 조건
      vm.srch = {
        TenantId : $stateParams.TenantId,
        IdName : 'TenantId',
        TableId : $stateParams.TenantId,
        tableNm : 'Tenant',
        uploadFileList : [],
      };

      // 조회 데이터
      vm.data = {
        TenantId : vm.TenantId,
        IdName : 'TenantId',
        TableId : $stateParams.TenantId,
        tableNm : 'Tenant',
      };

      /**
       * 데이터 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getData() {
        if (vm.srch.TenantId === null || vm.srch.TenantId === '') {
          console.log('$rootScope.gVariable', $rootScope.gVariable);
          vm.data.TenantId = $rootScope.gVariable.TenantId;
          vm.data.TenantNm = $rootScope.gVariable.TenantName;
          return;
        }

        var prms = api.doDetail().post(vm.srch).$promise;
        prms.then(function(data) {
          console.log("load", data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].CompanyId !== null) {
              vm.data = data.responseVO.body.docs[0];

              var uploadFileList = [];
              angular.forEach(vm.data.uploadFileList, function(item) {
                var obj = {
                  id : item.fileId,
                  isLoaded : true,
                  link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                  fileName : item.LogicalFileNm,
                  size : item.FileSize,
                  fileKey : item.PhysicalFileNm,
                  path : item.PhysicalPath,
                  downloadCnt : item.DownloadCnt,
                }
                uploadFileList.push(obj);
              });
              angular.copy(uploadFileList, vm.data.uploadFileList);

              return;
            }
          }
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        }, function(data) {
          console.error('fail', status, data);
          gAlert('알림', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       * @author 최원영
       */
      function getFileList() {
        vm.srch.tableNm = 'Companys';

        if (vm.srch.CompanyId === null || vm.srch.CompanyId === "0") {
          return;
        }

        var prms = api.doFileList().post(vm.srch).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            var uploadFileList = [];

            angular.forEach(data.responseVO.body.docs, function(item) {
              var obj = {
                id : item.fileId,
                isLoaded : true,
                link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                fileName : item.LogicalFileNm,
                size : item.FileSize,
                fileKey : item.PhysicalFileNm,
                typeId : 'file',
                path : item.PhysicalPath,
                downloadCnt : item.DownloadCnt,
                delState : '',
              }

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);
            return;
          }
        }, function(data) {
          console.error('Error-getFileList', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       * @author 최원영
       */
      function setData() {
        // 내용
        vm.data.tableNm = "Tenant";
        vm.data.TableId = vm.data.TenantId;

        var prms = null;

        vm.data['uploadFileList'] = vm.uploadFileList;

        console.log(vm.data);
        if (vm.data.TenantId == 0) {
          // 등록
          prms = api.doInsertDetail().post(vm.data).$promise;
        } else {
          // 수정
          prms = api.doUpdateDetail().post(vm.data).$promise;
        }

        prms.then(function(data) {
          console.log(data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].TenantId !== null || data.responseVO.body.docs[0].TableId !== null) { // insert
              // 시
              // TableId
              // 만
              // 넘어옴
              // KeyId 조회
              vm.data.TenantId = data.responseVO.body.docs[0].TenantId;

              gAlert('', 'Menu.SAVED', {
                btn : '확인',
                fn : function() {
                  if ($stateParams.TenantId === "0") {
                    $state.go("app.system.rolescreen-list");
                  } else {
                    vm.data.TenantId = data.responseVO.body.docs[0].TenantId !== null ? data.responseVO.body.docs[0].TenantId : "0";
                    vm.srch.TenantId = vm.data.TenantId;
                    getFileList();
                  }
                }
              });
              return;
            }
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error-setData', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      function deleteDetail() {
        gConfirm('', 'Menu.DELETECONFIRM', {
          btn : '',
          fn : function() {
            deleteDetailAction();
          }
        }, {
          btn : '',
          fn : function() {
          }
        });
      }

      function deleteDetailAction() {
        if (vm.data == null) {
          gAlert('', 'Menu.CANNOTDELETE');
          return;
        }
        console.log("vm.uploadFileList", vm.uploadFileList);
        var uploadFileList = [];
        angular.forEach(vm.uploadFileList, function(item) {
          var obj = {
            id : item.id,
            fileName : item.fileName,
            size : item.size,
            fileKey : item.fileKey,
            typeId : 'file',
            path : item.path,
            delState : 'delete',
          }
          uploadFileList.push(obj);

        });
        vm.data['uploadFileList'] = uploadFileList;

        console.log("before delete", vm.data);

        var prms = api.doDelete().post(vm.data).$promise;

        prms.then(function(data) {
          if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
            gAlert('', 'Menu.DELETED', {
              btn : '',
              fn : function() {
                $state.go("app.system.rolescreen-list")
              }
            });
            return;
          }
        },

        function(data) {
          console.error('fail', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      // 함수 선언
      vm.getData = getData;
      vm.getFileList = getFileList;
      vm.setData = setData;
      vm.deleteDetail = deleteDetail;

      // 데이터 조회
      getData();
    }, ]);

/**
 * @ngdoc function
 * @name app.bbspost:bbspost-edit-ctrl
 * @description
 * # 게시판 등록/수정
 * Controller of the
 * @param {object} $window - window object
 * @param {object} $scope - scope object
 * @param {object} $location - location object
 * @param {object} $state -  state object
 * @param {object} $stateParams - state Parameter object
 * @param {object} CONSTANT - 전역 상수
 * @param {object} StaticVariable - StaticVariable object
 * @param {object} api - RolescreenApiSrv Module
 * @param {object} gAlert - Alert Module
 */
webapp.controller('RolescreenEditCtrl', [ '$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'RolescreenAPISrv',
    'gAlert', 'gConfirm', function RolescreenEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalWindow, api, gAlert, gConfirm) {

      // View Model
      var vm = this;

      // 페이징
      vm.page = $stateParams.page;

      vm.CompanyTypeData = {
        CodeType : '130',
        TenantId : vm.TenantId,
        Value : ''
      }

      vm.onSelectCallback = {
        onSelectComplete : function(data) {
          console.log('onSelectComplete', data);
          if (data.CodeType == '130') {
            vm.data.CompanyType = data.Value;
          }
        }
      }

      // 업로드 파일 목록
      vm.uploadFileList = [];

      vm.onFileCallback = {
        onFileUploadComplete : function() {
          console.log('file items::', vm.uploadFileList);
        },
        onFileDelete : function(item) {
          console.log('delete item::', item);
          var param = {
            'fileId' : item.id
          };
          var prms = h0101Api.attachFileDelete().post(param).$promise;
          prms.then(

          function(data) {
            console.log(data);
            if (data.responseVO.header.status == CONSTANT.HttpStatus.OK) {
              gAlert('', 'Menu.DELETED');
            }
          });
        }
      }

      vm.stateParams = {
        TenantId : $stateParams.TenantId,
      };

      // 검색 조건
      vm.srch = {
        TenantId : $stateParams.TenantId,
        IdName : 'TenantId',
        TableId : $stateParams.TenantId,
        tableNm : 'Tenant',
        uploadFileList : [],
      };

      // 조회 데이터
      vm.data = {
        TenantId : $stateParams.TenantId,
        tableNm : 'Tenant',
        IdName : 'TenantId',
      };

      /**
       * 데이터 조회
       *
       * @param
       * @return
       */
      function getData() {
        if (vm.srch.TenantId === null || vm.srch.TenantId === '') {
          console.log('$rootScope.gVariable', $rootScope.gVariable);
          vm.data.TenantId = $rootScope.gVariable.TenantId;
          vm.data.TenantNm = $rootScope.gVariable.TenantId == '0' ? '' : $rootScope.gVariable.TenantName;
          return;
        }

        var prms = api.doDetail().post(vm.srch).$promise;
        prms.then(function(data) {
          console.log("load", data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docCnt !== 0 && data.responseVO.body.docs[0].TenantId !== null) {
              vm.data = data.responseVO.body.docs[0];

              // 첨부파일 목록 조회
              getFileList();

              return;
            }
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }, function(data) {
          console.error('fail', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 첨부파일 목록 조회
       *
       * @param
       * @return
       */
      function getFileList() {
        vm.srch.tableNm = 'Tenant';

        if (vm.srch.TenantId === null || vm.srch.TenantId === "0") {
          return;
        }

        var prms = api.doFileList().post(vm.srch).$promise;
        prms.then(function(data) {
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            var uploadFileList = [];

            angular.forEach(data.responseVO.body.docs, function(item) {
              var obj = {
                id : item.fileId,
                isLoaded : true,
                link : StaticVariable.getUrl('/attach/file/' + item.PhysicalFileNm + '/download.do?path=' + item.PhysicalPath + '&fileName=' + item.LogicalFileNm),
                fileName : item.LogicalFileNm,
                size : item.FileSize,
                fileKey : item.PhysicalFileNm,
                typeId : 'file',
                path : item.PhysicalPath,
                downloadCnt : item.DownloadCnt,
                delState : '',
              }

              uploadFileList.push(obj);
            });

            angular.copy(uploadFileList, vm.uploadFileList);
            return;
          }
        }, function(data) {
          console.error('Error-getFileList', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // 내용
        vm.data.TableId = vm.data.TenantId;
        vm.data.tableNm = 'Tenant';
        vm.data.IdName = 'TenantId';

        var prms = null;

        vm.data['uploadFileList'] = vm.uploadFileList;

        console.log(vm.data);
        if (vm.data.TenantId == 0) {
          // 등록
          prms = api.doInsertDetail().post(vm.data).$promise;
        } else {
          // 수정
          prms = api.doUpdateDetail().post(vm.data).$promise;
        }

        prms.then(function(data) {
          console.log(data);
          if (data.responseVO.header.status === CONSTANT.HttpStatus.OK) {
            if (data.responseVO.body.docs[0].CompanyId !== null || data.responseVO.body.docs[0].TableId !== null) { // insert시 TableId 만 넘어옴
              // KeyId 조회
              gAlert('', 'Menu.SAVED', {
                btn : '확인',
                fn : function() {
                  vm.data.TenantId = data.responseVO.body.docs[0].TenantId != null ? data.responseVO.body.docs[0].TenantId : data.responseVO.body.docs[0].TableId;
                  $state.go("app.system.rolescreen-detail", {
                    TenantId : vm.data.TenantId
                  });
                }
              });
              return;
            }
          }
          gAlert('', data.responseVO.body.docs[0].errMessage);
        }, function(error) {
          console.error('Error-setData', status, data);
          gAlert('', data.responseVO.body.docs[0].errMessage);
        });
      }

      // 함수 선언
      vm.getData = getData;
      vm.getFileList = getFileList;
      vm.setData = setData;

      // 데이터 조회
      getData();
    }, ]);

/**
 * @ngdoc function
 * @name app.bbspost:bbspost-list-ctrl
 * @description # 목록 Controller of the 사용자정의 필드 게시판
 * @param $window - window object
 * @param $scope - scope object
 * @param $location - location object
 * @param $state - state object
 * @param $stateParams - state Parameter object
 * @param CONSTANT - 전역 상수
 * @param $rootScope - rootscope object
 * @param api -  RolescreenAPISrv Module
 */
webapp.controller('RolescreenListCtrl', [ '$window', '$scope', '$location', '$state', '$stateParams', '$rootScope', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi','gAlert','LoginAPISrv','Auth',
  function RolescreenListCtrl($window, $scope, $location, $state, $stateParams, $rootScope, CONSTANT, modalWindow, postApi, gAlert, loginApi, Auth) {
    // View Model
    var vm = this;

    vm.TenantId = $window.sessionStorage['loginTenantId'];

    // 검색 조건
    if ($stateParams.srch == '' || $stateParams.srch == undefined) {
      vm.srch = {
        TenantId : vm.TenantId,
        SysAdminYN : $window.sessionStorage['loginSysAdminYN'],
        mobile : 'N'
      };
    } else {
      vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      vm.srch.tableNm = vm.srch.tableNm ? vm.srch.tableNm : 'rolescrean';
      vm.currentPage = vm.srch.page;
    }

    if ($stateParams.mobile) {
      vm.srch.mobile = $stateParams.mobile;
    }

    vm.data = {
      ActionId: vm.srch.ActionId,
    };

    vm.checkAllBtn = {ViewYN:'N', Btn01YN:'N', Btn02YN:'N', Btn03YN:'N', Btn04YN:'N', Btn05YN:'N', Btn06YN:'N'};

    // 회원사 변경 체크
    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      vm.srch.ScreenNm = '';
      vm.srch.PageUrl = '';
      vm.srch.role = '';
      getList();
      getRoleList();
    });

    /**
     * 데이터 조회
     *
     * @param
     * @return
     */
    function getList() {
      vm.srch.page = vm.currentPage;

      getListCnt();

      var data = vm.srch;
      console.log(vm.srch);
      data.mapCode = 'Rolescreen.getRolescreenList';
      // 내용
      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          vm.lists = result.body.docs;
        } else {
          console.log(result.body);
          gAlert('', result.body.docs[0].errMessage);
        }
        vm.columnMap = '';
        vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        vm.dataloader = false;
        fnCloseLayer();
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function getListCnt() {
      var data = vm.srch;
      data.mapCode = 'Rolescreen.getRolescreenCount';
      // 내용
      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          if (result.body.docs.length > 0) {
            vm.totalItems = result.body.docs[0];
          }
        } else {
          console.log(result.body);
          gAlert('', result.body.docs[0].errMessage);
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function getRoleList() {
      var data = vm.srch;
      data.mapCode = 'Role.getRoleList';
      // 내용
      postApi.select(data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          vm.roleList = result.body.docs;
        } else {
          console.log(result.body);
          gAlert('', result.body.docs[0].errMessage);
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function saveList() {
      vm.dataloader = true;
      vm.data.upList = vm.lists;
      vm.data.mapCode = 'Rolescreen.updateRolescreen';
      // 내용
      postApi.update(vm.data, function(result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.SAVED', {
            btn: '확인',
            fn: function () {
              $state.go("app.system.rolescreen-list");
            }
          });
        } else {
          console.log(result.body);
          gAlert('', result.body.docs[0].errMessage);
        }
        vm.dataloader = false;
      }, function(error) {
        console.error('Error-getList', error);
        vm.dataloader = false;
      });
    }

    function checkBtn(BtnYN) {
      angular.forEach(vm.lists, function(item) {
        item[BtnYN] = vm.checkAllBtn[BtnYN];
      });
    }

    function doCheckSession() {
      var prms = loginApi.doCheckSession().post().$promise;

      prms.then(function (json) {
        if (json.responseVO.header.status == CONSTANT.HttpStatus.OK && json.responseVO.body.docs != null && json.responseVO.body.docs != '') {

          $rootScope.setUserSession(json.responseVO.body.docs[0]);

          Auth.init(json.responseVO.body.docs[0].permissions);

          vm.userNm = $window.sessionStorage['loginUserName'];
          vm.userGbn = $window.sessionStorage['loginUserGbn'];
          vm.userTerm = $window.sessionStorage['loginUserTerm'];

        } else {
          StaticVariable.sessionExpire();
        }
      }, function (error) {
        console.table(error);
      });
    }

    /**
      * 데이터 조회
      * @param
      * @return
    */
    function getSearch() {
      vm.srch.mobile = null;
      var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      $state.go($state.current.name, {mobile:$stateParams.mobile, srch:srch}, {reload:$state.current.name});
    }

    function resetSearch() {
      $state.go('app.system.rolescreen-list', {
        srch : ''
      }, {reload: 'app.system.rolescreen-list'});
    }

    // 함수 선언
    vm.getList = getList;
    vm.getRoleList = getRoleList;
    vm.saveList = saveList;
    vm.checkBtn = checkBtn;
    vm.getSearch = getSearch;
    vm.resetSearch = resetSearch;

    // 데이터 조회
    getList();
    getRoleList();
  }, ]);


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.system:form-edit-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @param {object} $timeout - timeout object
   * @description Controller of the 사용자관리 등록/수정
   */

  webapp.controller('SmsAutoEditCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$timeout',

    function SmsAutoEditCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $timeout) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var INSERT_SQL = 'SmsSituationAuto.insertSmsSituationAuto';     // 등록 SQL
      var UPDATE_SQL = "SmsSituationAuto.updateSmsSituationAuto";   // 인증 승인
      var VIEW_SQL = 'SmsSituationAuto.getSmsSituationAutoDetail'; // 조회 SQL
      var DEL_SQL = 'SmsSituationAuto.deleteSmsSituationAuto';  // 삭제 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.sms-auto-list';             // 목록 화면
      var LIST_VIEW_PAGE_URL = 'app.system.sms-auto-list.edit'; // 목록 수정 화면
      var VIEW_PAGE_URL = 'app.system.sms-auto-edit';           // 수정 화면

      var KEY_TABLE_NM = 'Sms-Situation-Auto'; // 작업 테이블명


      // View Model
      var vm = this;          // View Model

      vm.formType = $stateParams.formType;
      vm.dataloader = false;  // Progressbar 숨김
      vm.vault = null;        // 첨부파일 컴포넌트
      vm.vault2 = null;        // 첨부파일 컴포넌트

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 25, // 페이지당 조회건수
          keyId: !isNullOrEmpty($stateParams.keyId) ? $stateParams.keyId : '', // Primary Key Data
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          formType: $stateParams.formType
        };

      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.keyId = $stateParams.keyId;
      }
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)

      // Key Data 설정
      if (!isNullOrEmpty($stateParams.keyId)) {
        vm.srch.keyId = $stateParams.keyId;
      }

      // 조회 데이터 설정
      vm.srchDetail = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchDetail);
      vm.srchDetail.srchTenantId = vm.srchDetail.srchTenantId != null ? vm.srchDetail.srchTenantId : $rootScope.gVariable.srchTenantId;
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        CmpgnChannel : 'KAKAO', //SMS : 90byte, LMS : 2000byte
      };

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {
        vm.dataloader = true; // Progressbar 표시

        if (isNullOrEmpty(vm.srch.keyId)) {
          vm.dataloader = false;  // Progressbar 숨김
        }
        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (!isNullOrEmpty(vm.srch.keyId)) {
              if (result.body.docs.length > 0) {
                // 조회 데이터 설정
                vm.data = result.body.docs[0];
                vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
              } else {
                vm.data.TenantId = $rootScope.gVariable.srchTenantId;
                vm.data.TenantNm = $rootScope.gVariable.srchTenantName;
              }
            }

            vm.chkSendMessage();
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }
      /**
       * 등록/수정 화면에 표시할 컬럼인지 여부 확인
       *
       * @param {string} columnNm - 물리 컬럼명
       * @return {boolean} true - 존재시, false - 미 존재시
       */
      function getIsShowColumn(columnNm) {
        var result = false;
        var itemIndex = vm.srch.editColumns.indexOf(columnNm);

        result = (itemIndex > -1);
        return result;
      }

     /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;

        // #region 필수항목 체크
        var errMsg = '';
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 발송 내용을 확인하세요.<br/>';
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          bRtn =  false;
        }

        return bRtn;
      }

     /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        if (getIsValidData()) {
          // 내용
          var data = vm.data; // 사용자 입력 데이터

          if(isNullOrEmpty(data.keyId)){
            data.mapCode = INSERT_SQL;
          }else{
            data.RelateDataId = data.keyId;
            data.mapCode = UPDATE_SQL;
          }

          postApi.update(data, function (result) {
            setInsertUpdateDetail(result);
          }, function (error) {
            console.error("Error> setData()");
            gAlert('', 'Menu.EXCEPTIONOCCURED');
          });
        }
      }

      /**
       * 데이터 저장 후 처리
       *
       * @param result - 저장 결과
       * @return
       */
      function setInsertUpdateDetail(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if (
            result.body.docs[0].KeyId !== null ||
            result.body.docs[0].NewKeyId !== null ||
            result.body.docs[0].RelateDataId !== null
          ) {
            // KeyId 조회
            if (!isNullOrEmpty(result.body.docs[0].NewKeyId)) {
              vm.data.KeyId = result.body.docs[0].NewKeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].KeyId)) {
              vm.data.KeyId = result.body.docs[0].KeyId;
            } else if (!isNullOrEmpty(result.body.docs[0].RelateDataId)) {
              vm.data.KeyId = result.body.docs[0].RelateDataId;
            }

            gAlert("", "Menu.SAVED", {
              btn: "",
              fn: function () {
                if (vm.layout == 'N') {
                  goList();
                }
              }
            });
            return;
          }
        }

        console.error("Error> setInsertUpdateDetail()");
        gAlert('', result.body.docs[0].errMessage);
      }

      /**
       * 목록 화면 이동
       *
       * @param
       * @return
       */
      function goList() {
        vm.srch.keyId = "";
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        $state.go(LIST_PAGE_URL, {srch: srch});
      }

       /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
          //vm.data.SendMessage = fnCutMsg(msg, 90);
        }

        vm.messageLength = bytes;
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }

      vm.tabId = 'tab1';
      vm.setChangeTab = function(_id){
        vm.tabId = _id;
        $('.tab-pane.active').addClass('fade').removeClass('active');
        $('#noti-' + vm.tabId).removeClass('fade').addClass('active');
      };

      // 함수 정의
      vm.getData = getData;                     // 데이터 조회
      vm.setData = setData;                     // 데이터 저장

      vm.goList = goList;                       // 목록 화면 이동

      // 데이터 조회
      getData();

    }]);

})();


(function () {
  "use strict";
  /**
   * @ngdoc function
   * @name app.message:form-list-ctrl
   * @param {object} $window - window object
   * @param {object} $rootScope - rootScope object
   * @param {object} $scope - scope object
   * @param {object} $location - location object
   * @param {object} $state - state object
   * @param {object} $stateParams - state Parameter object
   * @param {object} GLOBAL_CONSTANT - Global Constant
   * @param {object} StaticVariable - StaticVariable Constant
   * @param {object} modalFactory - Modal Popup object
   * @param {object} postApi - postApi Module
   * @param {object} gAlert - gAlert Module
   * @param {object} gConfirm - gConfirm Module
   * @param {object} customFieldApi - customFieldApi Module
   * @param {object} $translate - translate object
   * @description Controller of the sms자동발송
   */
  webapp.controller('SmsAutoListCtrl', ['$window', '$rootScope', '$scope', '$location', '$state', '$stateParams', 'GLOBAL_CONSTANT', 'StaticVariable', 'modalFactory', 'postApi',
    'gAlert', 'gConfirm', 'customFieldApi', '$translate', '$filter',

    function SmsAutoListCtrl($window, $rootScope, $scope, $location, $state, $stateParams, CONSTANT, StaticVariable, modalFactory, postApi, gAlert, gConfirm, udcApi, $translate, $filter) {

      // #region 상수 정의

      // SQL Mapper Id 정의
      var LIST_CNT_SQL = 'SmsSituationAuto.getSmsSituationAutoListCnt'; // 목록 건수 조회 SQL
      var LIST_SQL = 'SmsSituationAuto.getSmsSituationAutoList';    // 목록 조회 SQL

      // 관련 화면 정의
      var LIST_PAGE_URL = 'app.system.sms-auto-list';         // 목록 화면
      var LIST_DETAIL_PAGE_URL = 'app.system.sms-auto-list.edit';  // 목록 조회  화면
      var LIST_EDIT_PAGE_URL = 'app.system.sms-auto-list.edit';    // 목록 등록/수정 화면
      var VIEW_PAGE_URL = 'app.system.sms-auto-edit';       // 조회 화면
      var EDIT_PAGE_URL = 'app.system.sms-auto-edit';         // 등록/수정 화면

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Sms-Situation-Auto'; // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column
      // #endregion 상수 정의

      var vm = this;          // View Model
      vm.dataloader = false;  // Progressbar 숨김

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: '',         // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: '',          // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
        vm.srch.tableNm = !isNullOrEmpty($stateParams.srch.tableNm) ? $stateParams.srch.tableNm : KEY_TABLE_NM;
        vm.currentPage = vm.srch.page;
      }

      vm.keyId = $stateParams.keyId;
      $scope.selectedRow = $stateParams.keyId;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      angular.copy(vm.srch, vm.srchList);
      vm.layout = $rootScope.gVariable.layoutBoard; // 화면 분할모드 :  H(수평), V(수직), N(기본)
      vm.anchor = "";
      setLayout(vm.layout); // 화면분할 모드 설정

      // 회원사 변경 설정
      $scope.$on('broadcastSetChangeTenantID', function (event, data) {
        getList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getSearch() {
        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 검색값 초기화
       * @param
       * @return
       */
      function setResetSearch() {
        $state.go(LIST_PAGE_URL, {srch: ''}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정

        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
              vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김
          vm.SearchConditionStr = getSearchConditionStr(vm.totalItems, vm.columnMap, vm.srch);
        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        $state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getSearch();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {
        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == "N") return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = vm.srchList.sortDirect == "ASC" ? "DESC" : "ASC";
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getSearch();
      }

      function sortClass(sortkey) {
        if (sortkey != vm.srch.sortColumn) return "fa fa-sort";

        var rtnval = "";

        if (vm.srch.sortDirect == "ASC") {
          rtnval = "fa fa-caret-down";
        } else {
          rtnval = "fa fa-caret-up";
        }
        return rtnval;
      }

      /**
       * 조회 화면 이동
       * @param
       * @return
       */
      function goDetail(paramKeyId,formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        $scope.selectedRow = paramKeyId;

        if (vm.layout == 'N') {
          // 조회 화면 이동
          $state.go(VIEW_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        } else {
          // 목록 조회 화면 이동
          $state.go(LIST_DETAIL_PAGE_URL, {
            srch: srch,
            formType: formType,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 등록/수정 화면 이동
       * @param
       * @return
       */
      function goEdit(paramKeyId, formType) {
        var srch = $stateParams.srch; // 검색 옵션
        vm.keyId = paramKeyId;
        $scope.selectedRow = paramKeyId;

        if (vm.layout == 'N') {
          // 등록/수정 화면 이동
          $state.go(EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        } else {
          // 목록 등록/수정 화면 이동
          $state.go(LIST_EDIT_PAGE_URL, {
            srch: srch,
            keyId: paramKeyId
          });
        }
      }

      /**
       * 화면 분할 모드 설정
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setLayout(layout) {

        // 분할 모드 지정
        if (angular.isUndefined(layout)) {
          vm.layout = $rootScope.gVariable.layoutBoard;
        } else {
          vm.layout = layout;
        }

        switch (vm.layout) {
          case "H":
            // 수평
            vm.anchor = "north";
            vm.paneMin = "300px";
            break;
          case "V":
            // 수직
            vm.anchor = "west";
            vm.paneMin = "600px";
            break;
          case "N":
            // 기본
            vm.anchor = "";
            vm.paneMin = "600px";
            break;
        }
      }

      /**
       * 화면 분할 모드 변경
       * @param layout - 분할 모드 : H(수평), V(수직), N(기본)
       * @return
       */
      function setChangeLayout(layout) {

        // 분할 모드 설정값 저장
        $window.sessionStorage.setItem('layoutBoard', layout);
        $rootScope.gVariable.layoutBoard = layout;

        var srch = $stateParams.srch; // 검색 옵션

        $state.go(LIST_PAGE_URL, {
          srch: srch
        }, {reload: LIST_PAGE_URL});
      }

      // 함수 정의
      vm.getSearch = getSearch;                   // 데이터 조회
      vm.setResetSearch = setResetSearch;         // 검색값 초기화
      vm.getList = getList;                       // 목록 조회

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경

      vm.setSortColumn = setSortColumn;           // 정렬 설정
      vm.sortClass = sortClass;      

      vm.goDetail = goDetail;                     // 조회 화면 이동
      vm.goEdit = goEdit;                         // 등록/수정 화면 이동

      vm.setChangeLayout = setChangeLayout;       // 화면모드 설정

      // 목록 조회
      getList();
    }]);
})();

webapp.service('CommonAPISrv', ['$resource', 'StaticVariable',
    function CommonAPISrv($resource, StaticVariable) {
    	var commonApi = {
       		doComboCode : function() {
       			return $resource(StaticVariable.getUrl('/api/system/getCommonCodeList.json'), {},
       					StaticVariable.getRequestActions.defaultAction());
   			},
    	};
    	return commonApi;
	}
]);


webapp.controller('CommonCodeCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', 'CommonAPISrv', 'postApi',
  function CommonCodeCtrl($scope, $element, $compile, CONSTANT, commonApi, postApi) {
    var vm = this;
    vm.isDisabled = false;
    vm.isRequired = false;

    vm.paramData = {
      CodeType : '',
      ParentCommonCodeId : '',
      CommonCodeId : '',
      Code : '',
      CodeValue : '',
      CallbackTarget : '',
      ReloadSeq : 0
    };

    vm.data = {};
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onChangeHandler = function() {
      if (vm.callback) {
        if (vm.data != null) {
          vm.data.CallbackTarget = vm.paramData.CallbackTarget;
          vm.callback(vm.data);
        } else {
          var data = vm.paramData;
          data.Code = '';
          vm.callback(data);
        }
      }
    };

    vm.getSelectList = getSelectList;
    function getSelectList() {
      if (vm.paramData == null || vm.paramData.CodeType == null || vm.paramData.CodeType == '') {
        vm.list = {};
        return;
      }

      angular.copy(vm.paramData, vm.data);

      vm.data.mapCode = "CommonCode.getCommonCodeList";

      var prms = postApi.select(vm.data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.list = result.body.docs;
        }
      }, function(error) {
        console.table(error);
      });
    }

  }
]);

webapp.directive('commonCode', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      paramData : "=",
      callback : "=",
      isDisabled : "=",
      chooseMessage : "=",
      isRequired : "="
    },
    templateUrl : 'scripts/directives/common-code/common-code.html',
    controller : 'CommonCodeCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      ctrl.callback = scope.callback;

      scope.$watchCollection('paramData', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.paramData = scope.paramData;
        ctrl.getSelectList();
      });

      scope.$watchCollection('isDisabled', function(value) {
        //console.log('isDisabled=', scope.isDisabled);
        if (ctrl.isDisabled != undefined)
          ctrl.isDisabled = scope.isDisabled;
      });

      scope.$watchCollection('isRequired', function(value) {
        //console.log('isDisabled=', scope.isDisabled);
        if (ctrl.isRequired != undefined)
          ctrl.isRequired = scope.isRequired;
      });      

      scope.$watchCollection('chooseMessage', function(value) {
        if (scope.chooseMessage != undefined)
          ctrl.chooseMessage = scope.chooseMessage;
      });
    }
  };
} ]);

webapp.controller('CommonCodeCustomCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate',
  function CommonCodeCustomCtrl($scope, $element, $compile, CONSTANT, $translate) {
    var vm = this;
    vm.isDisabled = false;
    vm.isRequired = false;

    vm.codeList = {
      Code : '',
      CodeValue : ''
    };

    vm.codeModel = {};
    vm.SelectedCode = 'Y';

    vm.list = [];
    vm.data = {};
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onChangeHandler = function() {
      if (!vm.codeModel) {
        vm.codeModel = '';
      }

      try {
        vm.initChangeData(vm.codeModel);
      } catch (err) {
        vm.initChangeData("");
      }
    };

    vm.getSelectList = getSelectList;
    function getSelectList(codeList, codeExclude) {
      angular.forEach(codeList, function (item) {
        var bEx = true;
        if(codeExclude && codeExclude.length > 0 ){
          for(var i = 0; i < codeExclude.length; i++){
            if(codeExclude[i] == item.Code){
              bEx = false;
              break;
            }
          }
        }
        
        if(bEx){
          vm.list.push(item);
        }
        
      });
    }
  }
]);

webapp.directive('commonCodeCustom', 
  [ '$compile', '$parse', '$translate',
  function($compile, $parse, $translate) {
    return {
      transclude : true,
      replace: true,
      restrict : 'E',
      scope : true,
      template : function(scope, iAttrs){
        var choose = $translate.instant('Menu.CHOOSE')
        var $wrap = $("<div />");
        var $select = $("<select />", { class: "form-control",  style:"min-width:100px;" });
        var $option = $("<option />", { value: "",  text:'-- ' + choose + ' --' });
        var $optionCode = $("<option />", { "ng-repeat": "opt in " + iAttrs.codeList,  text:'{{opt.CodeValue}}', value: '{{opt.Code}}', "ng-if": "opt.hidden !='Y'" });
        $select.html( $option.clone());
        $select.append( $optionCode.clone());
        if(iAttrs.codeModel != undefined) $select.attr("ng-model", iAttrs.codeModel);
        //if(iAttrs.codeList != undefined) $select.attr("ng-options", "opt.Code as opt.CodeValue for opt in " + iAttrs.codeList);
        // ngchange 를 넣었을시 초기에 두번 호출되는 이슈로 주석처리
        //if(iAttrs.callback != undefined) $select.attr("ng-change", iAttrs.callback + "(" +  iAttrs.codeModel+ ");");
        if(iAttrs.isDisabled != undefined) $select.attr("ng-disabled", iAttrs.isDisabled);
        if(iAttrs.isRequired != undefined) $select.attr("ng-required", iAttrs.isRequired);   
        $wrap.html($select.clone());
        return $wrap.html();
      },
      compile: function compile(tElement, tAttrs) {
        return {
          post: function($scope, element, attr) {},
          pre: function($scope, element, attr) {
            $scope.element = element;
            $scope.codeList = $scope.$eval(attr.codeList);
            $scope.checkInit = false;
            function commonCodeCustomSetInit(val, callback) {
              var value = $scope.$eval(val);
              if(!isNullOrEmpty(value)) {
                $scope.element.value = $scope.$eval(val);
              }
            }
            $scope.$watch(attr.codeModel, function(item){
              var itemTypeOf = typeof(item);
              if(itemTypeOf == 'undefined') {
                // Type이 undefined 일 경우 초기 셋팅일 확률이 높아서 패스 처리
              } else if(item == null) {
                if(attr.callback) { $scope.$eval(attr.callback+"('')"); }  
              } else {
                if(attr.callback) { $scope.$eval(attr.callback+"('" + item + "')"); }
              }
            }, true);

            $scope.$watch(attr.codeList, function(item){
              var itemTypeOf = typeof(item);
              if(itemTypeOf != 'undefined') {
                if(attr.codeExclude) {
                  var codeExclude = $scope.$eval(attr.codeExclude);
                  angular.forEach(item, function(at){
                    var check = true;
                    for(var i = 0; i < codeExclude.length; i++) {
                      if(codeExclude[i] == at.Code) {
                        check = false;
                        break;
                      }
                    }
                    if(!check) at.hidden = "Y";
                    else at.hidden = "N";
                  })
                }
              }
            }, true);
            
            commonCodeCustomSetInit(attr.codeModel, attr.ngChange);
          }
        }
      },
    };
}]);
webapp.controller('CommonCodeSearchCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate',
  function CommonCodeSearchCtrl($scope, $element, $compile, CONSTANT, $translate) {
    var vm = this;
    vm.isDisabled = false;
    vm.isRequired = false;

    vm.codeList = {
      Code : '',
      CodeValue : ''
    };

    vm.codeModel = {};
    vm.SelectedCode = 'Y';

    vm.list = [];
    vm.data = {};
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onChangeHandler = function() {
      if (!vm.codeModel) {
        vm.codeModel = '';
      }

      try {
        vm.initChangeData(vm.codeModel);
      } catch (err) {
        vm.initChangeData("");
      }
    };

    vm.getSelectList = getSelectList;
    function getSelectList(codeList, codeExclude) {
      angular.forEach(codeList, function (item) {
        var bEx = true;
        if(codeExclude && codeExclude.length > 0 ){
          for(var i = 0; i < codeExclude.length; i++){
            if(codeExclude[i] == item.Code){
              bEx = false;
              break;
            }
          }
        }
        
        if(bEx){
          vm.list.push(item);
        }
        
      });
    }
  }
]);

webapp.directive('commonCodeSearch', 
  [ '$compile', '$parse', '$translate',
  function($compile, $parse, $translate) {
    return {
      transclude : true,
      replace: true,
      restrict : 'E',
      scope : true,
      template : function(scope, iAttrs){
        var choose = $translate.instant('Menu.CHOOSE');
        var $wrap = $("<div />");
        /* var $select = $("<select />", { class: "form-control",  style:"min-width:100px;" }); */
        var $select = $("<select />", { class: ""});
        var $option = $("<option />", { value: "",  text:'-- ' + choose + ' --' });
        var $optionCode = $("<option />", { "ng-repeat": "opt in " + iAttrs.codeList,  text:'{{opt.CodeValue}}', value: '{{opt.Code}}', "ng-if": "opt.hidden !='Y'" });
        $select.html( $option.clone());
        $select.append( $optionCode.clone());
        if(iAttrs.codeModel != undefined) $select.attr("ng-model",iAttrs.codeModel);
        //if(iAttrs.codeList != undefined) $select.attr("ng-options", "opt.Code as opt.CodeValue for opt in " + iAttrs.codeList);
        // ngchange 를 넣었을시 초기에 두번 호출되는 이슈로 주석처리
        //if(iAttrs.callback != undefined) $select.attr("ng-change", iAttrs.callback + "(" +  iAttrs.codeModel+ ");");
        if(iAttrs.isDisabled != undefined) $select.attr("ng-disabled", iAttrs.isDisabled);
        if(iAttrs.isRequired != undefined) $select.attr("ng-required", iAttrs.isRequired);
        $wrap.html($select.clone());
        return $wrap.html();
      },
      compile: function compile(tElement, tAttrs) {
        return {
          post: function($scope, element, attr) {},
          pre: function($scope, element, attr) {
            $scope.element = element;
            $scope.codeList = $scope.$eval(attr.codeList);
            $scope.checkInit = false;
            function commonCodeSearchSetInit(val, callback) {
              var value = $scope.$eval(val);
              if(!isNullOrEmpty(value)) {
                $scope.element.value = $scope.$eval(val);
              }
            }
            $scope.$watch(attr.codeModel, function(item){
              var itemTypeOf = typeof(item);
              if(itemTypeOf == 'undefined') {
                // Type이 undefined 일 경우 초기 셋팅일 확률이 높아서 패스 처리
              } else if(item == null) {
                if(attr.callback) { $scope.$eval(attr.callback+"('')"); }  
              } else {
                if(attr.callback) { $scope.$eval(attr.callback+"('" + item + "')"); }
              }
            }, true);

            $scope.$watch(attr.codeList, function(item){
              var itemTypeOf = typeof(item);
              if(itemTypeOf != 'undefined') {
                if(attr.codeExclude) {
                  var codeExclude = $scope.$eval(attr.codeExclude);
                  angular.forEach(item, function(at){
                    var check = true;
                    for(var i = 0; i < codeExclude.length; i++) {
                      if(codeExclude[i] == at.Code) {
                        check = false;
                        break;
                      }
                    }
                    if(!check) at.hidden = "Y";
                    else at.hidden = "N";
                  });
                }
              }
            }, true);
            
            commonCodeSearchSetInit(attr.codeModel, attr.ngChange);
          }
        };
      },
    };
}]);
webapp.controller('CommonCodeSignupCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', 'CommonAPISrv', 'postApi',
  function CommonCodeSignupCtrl($scope, $element, $compile, CONSTANT, commonApi, postApi) {
    var vm = this;
    vm.isDisabled = false;

    vm.paramData = {
      CodeType : '',
      ParentCommonCodeId : '',
      CommonCodeId : '',
      Code : '',
      CodeValue : '',
      CallbackTarget : '',
      ReloadSeq : 0
    };

    vm.data = {};
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onChangeHandler = function() {
      if (vm.callback) {
        if (vm.data != null) {
          vm.data.CallbackTarget = vm.paramData.CallbackTarget;
          vm.callback(vm.data);
        } else {
          var data = vm.paramData;
          data.Code = '';
          vm.callback(data);
        }
      }
    };

    vm.getSelectList = getSelectList;
    function getSelectList() {
      if (vm.paramData == null || vm.paramData.CodeType == null || vm.paramData.CodeType == '') {
        vm.list = {};
        return;
      }

      angular.copy(vm.paramData, vm.data);

      vm.data.mapCode = "getCommonCodeList";

      var prms = postApi.login(vm.data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.list = result.body.docs;
        }
      }, function(error) {
        console.table(error);
      });
    }

  }
]);

webapp.directive('commonCodeSignup', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      paramData : "=",
      callback : "=",
      isDisabled : "=",
      chooseMessage : "=",
      selectWidth : "="
    },
    templateUrl : 'scripts/directives/common-code-signup/common-code-signup.html',
    controller : 'CommonCodeSignupCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      ctrl.callback = scope.callback;

      scope.$watchCollection('paramData', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.paramData = scope.paramData;
        ctrl.getSelectList();
      });

      scope.$watchCollection('isDisabled', function(value) {
        //console.log('isDisabled=', scope.isDisabled);
        if (ctrl.isDisabled != undefined)
          ctrl.isDisabled = scope.isDisabled;
      });

      scope.$watchCollection('chooseMessage', function(value) {
        if (scope.chooseMessage != undefined)
          ctrl.chooseMessage = scope.chooseMessage;
      });

      scope.$watchCollection('selectWidth', function(value) {
        if (scope.selectWidth != undefined)
          ctrl.selectWidth = scope.selectWidth;
      });

    }
  };
} ]);

webapp.controller('CommonCodeFoodCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', 'postApi',
  function CommonCodeFoodCtrl($scope, $element, $compile, CONSTANT, postApi) {
    var vm = this;
    vm.isDisabled = false;

    vm.codeModel = {};
    vm.codeChanged = null;
    vm.chooseMessage = 'Menu.CHOOSE';
    vm.list = [[], []];
    vm.CommonCode = [];
    vm.CommonCode1 = {};

    vm.onChangeHandler = function(index) {
      if (index == 0) {
        getSelectList(2, vm.CommonCode[0].Code);
      } else if (index == 1) {
        try {
          if (vm.CommonCode[0] != null && vm.CommonCode[1] != null) {
            vm.initChangeData(vm.CommonCode[0].Code + '.' + vm.CommonCode[1].Code, vm.CommonCode[0].CodeValue + '.' + vm.CommonCode[1].CodeValue, true);
          }
        } catch (err) {
          vm.initChangeData("", "", true);
        }        
      }
    };

    vm.setSelectList = setSelectList;
    function setSelectList(codeList) {
      vm.list = [[], []];
    }

    vm.selectChange = selectChange;
    function selectChange() {
      if (vm.codeModel) {
        var Code = vm.codeModel.split('.');
        console.log('Code=', Code);
        vm.list[1] = [];
        vm.CommonCode[0] = {Code:Code[0]};
        vm.CommonCode1 = {Code:Code[1]};

        getSelectList(2, vm.CommonCode[0].Code);
      } else {
      }
    }    

    vm.getSelectList = getSelectList;
    function getSelectList(CodeLevel, ParentCommonCodeId) {
      vm.list[CodeLevel - 1] = [];

      var data = {};
      data.CodeLevel = CodeLevel;
      data.mapCode = "FoodList.getFoodlistValue";
      if (ParentCommonCodeId) {
        data.ParentCommonCodeId = ParentCommonCodeId;
      }

      var prms = postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.list[CodeLevel - 1] = result.body.docs;
          if (CodeLevel == 2) {
            vm.CommonCode[1] = vm.CommonCode1;
          }
        }
      }, function(error) {
        console.error('Error> getSelectList', error);
      });
    }

    vm.getSelectList(1, null);

  }
]);

webapp.directive('commonCodeFood', [ '$compile', '$parse', '$timeout', function($compile, $parse, $timeout) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      codeList : "=",
      codeModel : "=",
      reloadSeq : "=",
      codeChanged : "=",
      chooseMessage : "=",
      preventChanging : "=",
      codeIndex : "="
    },
    templateUrl : 'scripts/directives/common-code-tree/common-code-food.html',
    controller : 'CommonCodeFoodCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      // scope.$watchCollection('codeType', function(value) {
      //   ctrl.codeModel = scope.codeModel;
      //   ctrl.getSelectList(scope.codeType);
      // });
      ctrl.codeModel = scope.codeModel;
      ctrl.codeChanged = scope.codeChanged;

      scope.$watchCollection('codeList', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.codeModel = scope.codeModel;
        ctrl.setSelectList(scope.codeList);
      });

      scope.$watchCollection('reloadSeq', function(value) {
        if (attrs.reloadSeq != undefined) {
          ctrl.CommonCode[0] = null;
          ctrl.CommonCode[1] = null;
        }
      });

      scope.$watchCollection('codeModel', function(value) {
        ctrl.codeModel = value;
        ctrl.selectChange();
      });      

      /** CommonCode Controller **/
      ctrl.initChangeData = function(code, codevalue, bLast) {
        try {
          if (attrs.codeModel != undefined) {
            scope.codeModel = code;
          }

          if (attrs.codeChanged != undefined) {
            if (!scope.preventChanging || bLast) {
              $timeout(function() {
                return ctrl.codeChanged(code, codevalue, scope.codeIndex);
              }, 1);
            }
          }
        } catch (e) {}
      };
    }
  };
} ]);

webapp.controller('CommonCodeProjectCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', 'postApi',
  function CommonCodeProjectCtrl($scope, $element, $compile, CONSTANT, postApi) {
    var vm = this;
    vm.isDisabled = false;

    vm.prmYear = null;
    vm.prmType = null;
    vm.prmId = null;
    vm.preventChanging = null;
    vm.codeChanged = null;
    vm.chooseMessage = 'Menu.CHOOSE';
    vm.listYear = [];
    vm.listPrm = [];
    vm.data = {};

    vm.onChangeHandlerId = function() {
      console.log('onChangeHandlerId=', vm.prmId);
      vm.initChangeDataId(vm.prmId);
    };

    vm.onChangeHandlerYear = function() {
      vm.initChangeDataYear(vm.prmYear);
      getSelectList();
    };    

    vm.setSelectList = setSelectList;
    function setSelectList(prmList) {
      vm.listPrm = prmList;
    }

    vm.getSelectList = getSelectList;
    function getSelectList() {
      vm.listPrm = [];

      if (!vm.prmYear || !vm.prmType) {
        return;
      }

      var data = {};
      data.PrmYear = vm.prmYear;
      data.PrmType = vm.prmType;
      data.mapCode = "ProjectManage.getProjectManageCodeList";

      var prms = postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.listPrm = result.body.docs;
        }
      }, function(error) {
        console.error('Error> getSelectList', error);
      });
    }

    vm.getYearList = getYearList;
    function getYearList() {
      vm.listYear = [];

      var data = {};
      data.CodeType = "SEARCH_YEAR";
      data.mapCode = "CommonCode.getCommonCodeList";

      var prms = postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.listYear = result.body.docs;
        }
      }, function(error) {
        console.error('Error> getSelectList', error);
      });
    }

    vm.getProjectInfo = getProjectInfo;
    function getProjectInfo() {
      if (!vm.prmYear || !vm.prmId) {
        return;
      }

      var data = {};
      data.PrmYear = vm.prmYear;
      data.PrmId = vm.prmId;
      data.mapCode = "ProjectManage.getProjectInfo";

      var prms = postApi.select(data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.data = result.body.docs[0];
        }
      }, function(error) {
        console.error('Error> getSelectList', error);
      });
    }

    vm.setPreventChanging = setPreventChanging;
    function setPreventChanging(preventChanging) {
      vm.preventChanging = preventChanging;
      if (vm.preventChanging === false) {
        vm.getYearList();
        vm.getSelectList();
      }

      if (vm.preventChanging === true) {
        vm.getProjectInfo();
      }      
    }
  }
]);

webapp.directive('commonCodeProject', [ '$compile', '$parse', '$timeout', function($compile, $parse, $timeout) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      prmYear : "=",
      prmType : "=",
      prmId : "=",
      reloadSeq : "=",
      chooseMessage : "=",
      preventChanging : "=",
      codeChanged : "="
    },
    templateUrl : 'scripts/directives/common-code-tree/common-code-project.html',
    controller : 'CommonCodeProjectCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      ctrl.prmYear = scope.prmYear;
      ctrl.prmType = scope.prmType;
      ctrl.prmId = scope.prmId;
      ctrl.setPreventChanging(scope.preventChanging);

      scope.$watchCollection('reloadSeq', function(value) {
        if (attrs.reloadSeq != undefined && value !== undefined) {
          ctrl.prmYear = scope.prmYear;
          ctrl.prmType = scope.prmType;
          ctrl.prmId = scope.prmId;
          ctrl.setPreventChanging(scope.preventChanging);
        }
      });

      /** CommonCode Controller **/
      ctrl.initChangeDataYear = function(prmYear) {
        try {
          if (!scope.preventChanging) {
            scope.prmYear = prmYear;

            $timeout(function() {
              //console.log('initChangeData prmId=', prmId);
              return scope.codeChanged();
            }, 1);
          }
        } catch (e) {}
      };

      ctrl.initChangeDataId = function(prmId) {
        try {
          if (!scope.preventChanging) {
            scope.prmId = prmId;

            $timeout(function() {
              //console.log('initChangeData prmId=', prmId);
              return scope.codeChanged();
            }, 1);
          }
        } catch (e) {}
      };
    }
  };
} ]);

webapp.service('CommonCodeTreeAPISrv', ['$resource', 'StaticVariable',
    function CommonCodeTreeAPISrv($resource, StaticVariable) {
    	var commonApi = {
       		doComboCode : function() {
       			return $resource(StaticVariable.getUrl('/api/system/getCommonCodeList.json'), {},
       					StaticVariable.getRequestActions.defaultAction());
   			},
    	};
    	return commonApi;
	}
]);


webapp.controller('CommonCodeTreeCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', 'CommonAPISrv', 'postApi',
  function CommonCodeTreeCtrl($scope, $element, $compile, CONSTANT, commonApi, postApi) {
    var vm = this;
    vm.isDisabled = false;
    vm.isRequired = false;

    vm.codeModel = {};
    vm.codeChanged = null;
    vm.data = {};
    vm.chooseMessage = 'Menu.CHOOSE';
    vm.allList = {};
    vm.list = [[], [], [], []];
    vm.CommonCode = [];
    vm.Code = [];
    vm.CodeValue = [];

    vm.onChangeHandler = function(index) {
      angular.forEach(vm.Code, function(item, key) {
        if (key > index) {
          vm.Code[key] = '';
          vm.CodeValue[key] = '';
        }
      });

      vm.list[index + 1] = [];

      if (vm.CommonCode[index]) {
        vm.Code[index] = vm.CommonCode[index].Code;
        vm.CodeValue[index] = vm.CommonCode[index].CodeValue;

        angular.forEach(vm.allList, function(item) {
          if (vm.CommonCode[index] && vm.CommonCode[index].CommonCodeId == item.ParentCommonCodeId) {
            vm.list[index + 1].push(item);
          }
        });
      } else {
        vm.Code[index] = '';
        vm.CodeValue[index] = '';
      }

      try {
        var bLast = vm.list[index + 1].length == 0 && vm.Code[index] ? true : false;
        vm.initChangeData(vm.Code.filter(function(el){return el != '';}).join('.'), vm.CodeValue.filter(function(el){return el != '';}).join('.'), bLast);
      } catch (err) {
        vm.initChangeData("", "", true);
      }
    };

    vm.setSelectList = setSelectList;
    function setSelectList(codeList) {
      if (codeList == null || codeList == '') {
        vm.list = {};
        return;
      }

      vm.list = [[], [], [], []];

      if (vm.codeModel) {
        vm.Code = vm.codeModel.split('.');

        angular.forEach(vm.Code, function(code, key) {
          vm.CommonCode[key] = {Code:code};
        });
      }

      vm.allList = codeList;

      vm.CodeLevel = vm.allList.reduce(function(a, b) {
        if (a.indexOf(b.CodeLevel) < 0) a.push(b.CodeLevel);
        return a;
      }, []);

      var index = 0;

      angular.forEach(vm.allList, function(item) {
        if (vm.CodeLevel[0]) {
          if (vm.CodeLevel[0] == item.CodeLevel) {
            vm.list[0].push(item);

            if (vm.CommonCode[0] && vm.CommonCode[0].Code == item.Code) {
              vm.CommonCode[0].CommonCodeId = item.CommonCodeId;
            }
          }
        }
      });

      angular.forEach(vm.CodeLevel, function(codeLevel, key) {
        if (key == 0) return;

        angular.forEach(vm.allList, function(item) {
          if (codeLevel == item.CodeLevel) {
            if (vm.CommonCode[key - 1] && vm.CommonCode[key - 1].CommonCodeId == item.ParentCommonCodeId) {
              vm.list[key].push(item);

              if (vm.CommonCode[key] && vm.CommonCode[key].Code == item.Code) {
                vm.CommonCode[key].CommonCodeId = item.CommonCodeId;
              }
            }
          }
        });
      });
    }

    vm.getSelectList = getSelectList;
    function getSelectList(codeType) {
      if (codeType == null || codeType == '') {
        vm.list = {};
        return;
      }

      vm.list = [[], [], [], []];

      if (vm.codeModel) {
        vm.Code = vm.codeModel.split('.');

        angular.forEach(vm.Code, function(code, key) {
          vm.CommonCode[key] = {Code:code};
        });
      }

      if (codeType == 'PROJECT') {
        vm.data.mapCode = "Routine.getRoutineCodeTreeValue";
      } else if (codeType == 'FOODLIST') {
        vm.data.mapCode = "FoodList.getFoodlistTreeValue";        
      } else {
        vm.data.CodeType = codeType;
        vm.data.mapCode = "CommonCode.getCommonCodeTreeValue";
      }      

      var prms = postApi.select(vm.data, function(result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          vm.allList = result.body.docs;

          vm.CodeLevel = vm.allList.reduce(function(a, b) {
            if (a.indexOf(b.CodeLevel) < 0) a.push(b.CodeLevel);
            return a;
          }, []);

          var index = 0;

          angular.forEach(vm.allList, function(item) {
            if (vm.CodeLevel[0]) {
              if (vm.CodeLevel[0] == item.CodeLevel) {
                vm.list[0].push(item);

                if (vm.CommonCode[0] && vm.CommonCode[0].Code == item.Code) {
                  vm.CommonCode[0].CommonCodeId = item.CommonCodeId;
                }
              }
            }
          });

          angular.forEach(vm.CodeLevel, function(codeLevel, key) {
            if (key == 0) return;

            angular.forEach(vm.allList, function(item) {
              if (codeLevel == item.CodeLevel) {
                if (vm.CommonCode[key - 1] && vm.CommonCode[key - 1].CommonCodeId == item.ParentCommonCodeId) {
                  vm.list[key].push(item);

                  if (vm.CommonCode[key] && vm.CommonCode[key].Code == item.Code) {
                    vm.CommonCode[key].CommonCodeId = item.CommonCodeId;
                  }
                }
              }
            });
          });
        }
      }, function(error) {
        console.error('Error> getSelectList', error);
      });
    }

  }
]);

webapp.directive('commonCodeTree', [ '$compile', '$parse', '$timeout', function($compile, $parse, $timeout) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      codeType : "=",
      codeList : "=",
      codeModel : "=",
      reloadSeq : "=",
      codeChanged : "=",
      chooseMessage : "=",
      preventChanging : "=",
      isRequired : "="
    },
    templateUrl : 'scripts/directives/common-code-tree/common-code-tree.html',
    controller : 'CommonCodeTreeCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      // scope.$watchCollection('codeType', function(value) {
      //   ctrl.codeModel = scope.codeModel;
      //   ctrl.getSelectList(scope.codeType);
      // });
      ctrl.codeModel = scope.codeModel;
      ctrl.codeChanged = scope.codeChanged;

      scope.$watchCollection('codeList', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.codeModel = scope.codeModel;
        ctrl.setSelectList(scope.codeList);
      });

      scope.$watchCollection('reloadSeq', function(value) {
        if (attrs.reloadSeq != undefined) {
          ctrl.getSelectList(scope.codeType);
        }
      });

      scope.$watchCollection('isRequired', function(value) {
        //console.log('isDisabled=', scope.isDisabled);
        if (ctrl.isRequired != undefined)
          ctrl.isRequired = scope.isRequired;
      });      

      /** CommonCode Controller **/
      ctrl.initChangeData = function(code, codevalue, bLast) {
        try {
          if (attrs.codeModel != undefined) {
            scope.codeModel = code;
          }

          if (attrs.codeChanged != undefined) {
            if (!scope.preventChanging || bLast) {
              $timeout(function() {
                return scope.codeChanged(code, codevalue);
              }, 1);
            }
          }
        } catch (e) {}
      };
    }
  };
} ]);

webapp.controller('SearchConditionCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT',
  function SearchConditionCtrl($scope, $element, $compile, CONSTANT) {
    var vm = this;

    vm.searchCoditionStr = "";
    vm.columnMap = null;
    vm.srch = "";
    vm.count = 0;
    vm.countStr = "0";

    vm.updateSearchCoditionStr = function() {
      console.log(vm.count);
      console.log(vm.columnMap);
      console.log(vm.srch);

      vm.countStr = vm.count? vm.count : 0;
      vm.searchConditionStr = "";

      if (vm.columnMap == null)
        return;

      for (var key2 in vm.columnMap) {
        console.log(key2);
      }

      var str = [];
      for (var key in vm.srch) {
        if (key == 'page' || key == 'viewSize' || key == 'tableNm' || key == 'sortDirect' || key == 'sortColumn' || key == 'userkey' || key == 'selectType' || key == 'srchTenantId')
          continue;

        var name = key;
        var value = vm.srch[key];

        console.log(key);

        if (vm.columnMap[key]) {
          name = vm.columnMap[key].ColumnLogicalNm;

          console.log(name, value);

          if (vm.columnMap[key].ColumnLogicalDataType == "50") {
            if (vm.columnMap[key].CodeList) {
              vm.columnMap[key].CodeList.forEach(function (v) {
                if (v.Code == value) {
                  value = v.CodeValue;
                  return;
                }
              });
            }
          }
        }

        str.push(name + ':' + value);
      }

      vm.searchConditionStr += str.join(',');
    };
  }
]);

webapp.directive('searchCondition', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      count : "=",
      columnMap : "=",
      srch : "="
    },
    templateUrl : 'scripts/directives/search-condition/search-condition.html',
    controller : 'SearchConditionCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      scope.$watchCollection('count', function(value) {
        ctrl.count = scope.count;
      });

      scope.$watchCollection('columnMap', function(value) {
        ctrl.columnMap = scope.columnMap;
      });

      scope.$watchCollection('srch', function(value) {
        //console.log('watchCollection paramData=', value);
        ctrl.srch = scope.srch;
        ctrl.updateSearchCoditionStr();
      });
    }
  };
} ]);

webapp.directive('mdDateUtcToLocal', 
  [ '$compile', '$parse',
  function($compile, $parse) {
  return {
    require:'^ngModel',
    restrict:'A',
    scope : {
      mdDateFilter : "=",
      ngModel : "=",
      mdDateUtcToLocal : "="
    },
    link:function (scope, elm, attrs, ctrl) {
      scope.$watchCollection('mdDateUtcToLocal', function(value) {        
        if(value) {
          var format = moment(moment(value).toDate()).format('YYYY-MM-DD');
          scope.ngModel = format;
        }
      });
    }
  };
} ]);

webapp.controller('SelectDataGroupCtrl', [ '$scope', '$rootScope', '$element', '$compile', '$filter', 'GLOBAL_CONSTANT', 'modalFactory', 'postApi',
  function SelectDataGroupCtrl($scope, $rootScope, $element, $compile, $filter, CONSTANT, modalFactory, postApi) {
    var vm = this;

    vm.DatagroupNm = $rootScope.gVariable.dataGroupNm;
    vm.ActionNm = $rootScope.gVariable.dataActionNm;

    vm.changeDatagroup = changeDatagroup;

    function changeDatagroup() {
      var ctrl = 'DataGroupActionModalCtrl as vc';
      var paramData = {};

      // 부서 검색 팝업 호출
      var modalInstance = modalFactory.open('modal', 'components/modal/dataanalysis/data-group-action-modal.html', ctrl, paramData);

      modalInstance.result.then(function (okData) {
        $rootScope.setGVariable('dataGroupId', okData.DatagroupId);
        $rootScope.setGVariable('dataActionId', okData.ActionId);
        $rootScope.setGVariable('dataGroupNm', okData.DatagroupNm);
        $rootScope.setGVariable('dataActionNm', okData.ActionNm);
        vm.DatagroupNm = okData.DatagroupNm;
        vm.ActionNm = okData.ActionNm;

        if (vm.codeChanged) {
          vm.codeChanged();
        }
      }, function (cancelData) {
        // 취소
      });
    }
  }
]);

webapp.directive('selectDataGroup', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      codeChanged : "=",
    },
    templateUrl : 'scripts/directives/select-data-group/select-data-group.html',
    controller : 'SelectDataGroupCtrl as ccCtrl',
    link : function(scope, element, attrs, ctrl) {
      ctrl.codeChanged = scope.codeChanged;
    }
  };
} ]);

webapp.controller('SortableContainerCtrl',
  [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', 'postApi', '$rootScope', 'gConfirm', 'gAlert',
function SortableContainerCtrl
  ($scope, $element, $compile, CONSTANT, $translate, postApi, $rootScope, gConfirm, gAlert) {
    var vm = this;
    vm.isDisabled = false;

    vm.changeSortArray = [];

    vm.sortableOptions = {
      allowDuplicates: true,
      accept: function (sourceItemHandleScope, destSortableScope, destItemScope) {
        var result = false;
        if(sourceItemHandleScope.itemScope.sortableScope.$id === destSortableScope.$id) result = true;
        var target = sourceItemHandleScope.itemScope.item;
        // if(target.menuTenantId == "") result = false;
        // if(target.useYn == "N") result = false;
        // if(destItemScope.modelValue.menuTenantId == "") result = false;
        // if(destItemScope.modelValue.useYn == "N") result = false;

        return result;
      },
      dragEnd: function (eventObj) {
        var source = eventObj.source.sortableScope.modelValue;

        vm.changeSortArray = [];
        vm.setChangeSort(source);
        vm.setChangedSort(vm.changeSortArray);

      },
    };

    /**
       * 메뉴 확장
       * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
      */
     vm.extendMenu = function (elementId) {
      var $o = $("#" + elementId);
      var code = elementId.split("_")[1];
      var menupath = $o.attr("menu-sort");
      var depth;
      if ($o.hasClass("depth-one")) depth = 1;
      else if ($o.hasClass("depth-two")) depth = 2;

      if (depth == 1) {
        $(".extend-btn").removeClass("fa-angle-up");
        $(".extend-btn").addClass("fa-angle-down");
        $(".depth-two").slideUp();
        $(".depth-three").slideUp();
        if ($("[menu-sort^='" + menupath + "'].depth-two").eq(0).css("display") == "block") {
          $o.find(".extend-btn").addClass("fa-angle-down");
          $o.find(".extend-btn").removeClass("fa-angle-up");
          $("[menu-sort^='" + menupath + "'].depth-two").slideUp();
        } else {
          $o.find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").removeClass("fa-angle-down");
          $("[menu-sort^='" + menupath + "'].depth-two").slideDown();
        }
      } else {
        console.log($("[menu-sort^='" + menupath + "'] .depth-three").eq(0).css("display"));
        if ($("[menu-sort^='" + menupath + "'] .depth-three").eq(0).css("display") == "block") {
          $o.find(".extend-btn").addClass("fa-angle-down");
          $o.find(".extend-btn").removeClass("fa-angle-up");
          $("[menu-sort^='" + menupath + "'] .depth-three").slideUp();
          //$("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
        } else {
          $(".depth-three").slideUp();
          $o.closest(".as-sortable-item").parent().find(".extend-btn").removeClass("fa-angle-down");
          $o.closest(".as-sortable-item").parent().find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").addClass("fa-angle-up");
          $o.find(".extend-btn").removeClass("fa-angle-down");
          $("[menu-sort^='" + menupath + "'] .depth-three").slideDown();
        }
      }
    }

    /**
     * 포커스가 된 엘리먼트를 구하기 위함
     * @param {object} $event AngularJS Object
    */
    $scope.focusCallback = function ($event) {
      if ($event.target === null) return;
      vm.targetField = $event.target;
    };

    /**
     * 자식 노드 추가
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.addChild = function (depth, code) {
      var $elem;
      (depth == 0) ? $elem = $("#editorDepth01") : $elem = $("#editor" + code);
      $elem.css("display", "block");
      $elem.find("input").focus();

      $(".subTextmenu").addClass("importantHidden");
    };

    /**
     * 동일 선상의 서브 메뉴를 보여주기 위함
     * @param {String} elementId 메뉴 ng-mouseover 시 해당 서브 메뉴 아이디
    */
    vm.showSubMenu = function (elementId) { $("#" + elementId).css("display", "block"); }

    /**
     * 동일 선상의 서브 메뉴를 숨기기 위함
     * @param {String} elementId 메뉴 ng-mouseleave 시 해당 서브 메뉴 아이디
    */
    vm.hiddenSubMenu = function (elementId) { $("#" + elementId).css("display", "none"); }

    /**
     * 메뉴 타이틀 변경 시 버튼 비활성 / 활성 을 표시하기 위함
    */
    vm.menuTitleChange = function () {
      var val = $(vm.targetField).val();
      var $obj = $(vm.targetField);
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      (val.length == 0) ? $okBtn.addClass("disable") : $okBtn.removeClass("disable");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.cancelMenuItem = function (depth) {
      var $obj = $(vm.targetField);
      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");
      $(".subTextmenu").removeClass("importantHidden");
    };

    /**
     * 메뉴 등록 모드에서 취소 버튼을 클릭하였을 시
     * @param {int} depth 메뉴 Depth
    */
    vm.addMenuItem = function (depth) {
      // 190503 만약 로그인 권한이 Sysadmin 이 아닐 경우
      // 해당 로직을 진행하면 안됨 (기능 추가 필요);
      
      var $obj = $(vm.targetField);
      if ($obj.val() == undefined || $obj.val().length == 0) return;
      var data = {};
      data.ItemNm = $obj.val();
      //data.tempId = makeDateUUID();
      //data.keyId = '';
      data.depth = depth;
      data.child = [];
      data.DelYN = "N"; // 생성모드
      //data.disableClass = "disable-master";
      data.UseYN = "Y";

      var checkDepth;
      if (depth == 1) {

        var checkCount = 0;
        if(vm.bindData.length == 0) data.sort = 100;
        else {
          for(var i = 0; i < vm.bindData.length; i++) {
            if(vm.bindData[i].CodeLevel == 1) data.sort = vm.bindData[i].Sort + 1;
          } 
        }
        
        data.tempSortPath = [];
        data.tempSortPath[0] = data.sort;
        checkDepth = 1;
        vm.depth01title = "";
      } else {
        var sort = $obj.closest(".edit-layout").attr("menu-sort");
        var obj = findObject(vm.bindData, 'Sort', sort);
        data.sort = sort + "" + (obj.child.length + 100);
        var sortArray = makeSortPath(data.sort);
        data.tempSortPath = sortArray;
        data.ParentCommonCodeId = obj.KeyId;
        if (sortArray.length == 2) {
          checkDepth = 2;
          vm.depth02title = "";
        } else {
          checkDepth = 3;
          vm.depth03title = "";
        }
      }


      if (depth != 1) {
        $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
        $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
        setTimeout(function () {
          $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
        }, 500);
      }


      // console.log(vm.options)
      // if(vm.options != undefined) {
      //   mapperId = vm.options.MapperId;
      // }
      
      // if(mapperId.insert.param != undefined) {
      //   var keys = Object.keys(mapperId.insert.param);
      //   for(var i = 0; i < keys.length; i++) {
      //     data[keys[i]] = mapperId.insert.param[keys[i]];
      //   }
      // }

      data.CodeLevel = data.depth;
      data.Sort = data.sort;
      vm.addItem(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {

          var obj = findObject(vm.bindData, 'Sort', sort);
          data.KeyId = result.body.docs[0].RelateDataId;
          data.tempId = data.KeyId;
          if (checkDepth == 1) {
            vm.bindData.push(data);
          } else {
            obj.child.push(data);
          } 

          //var $obj = findObject(vm.bindData, 'Sort', sort);

          if (depth != 1) {
            $obj.closest(".sortable-row").prev().find("i").eq(0).removeClass("fa-plus");
            $obj.closest(".sortable-row").prev().find("i").eq(0).addClass("fa-minus");
            setTimeout(function () {
              $obj.closest(".sortable-row").find(".as-sortable-item-text").css("display", "block");
            }, 500);
          }

          $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
          //vm.linkData = data;
          vm.bindLinkData(data);
          vm.setDetailView(data);
        }  
      });

      var $editLayout = $obj.closest(".edit-layout");
      var $okBtn = $obj.closest(".edit-layout").find(".okBtn");
      $okBtn.addClass("disable");
      $editLayout.css("display", "none");
      $obj.val("");

      $(".subTextmenu").removeClass("importantHidden");
    };

    vm.uptAtName = function(data) {
      var obj = findObject(vm.bindData, 'KeyId', data.KeyId);
      obj.ItemNm = data.name;
    }

    vm.setRootTitle = function(title) {
      vm.rootTitle = title;
    }

    vm.setChangeSort = function (obj, ps) {
      for (var i = 0; i < obj.length; i++) {
        var minusLength = $("#atMenu_" + obj[i].tempId).closest("[ng-model]").
          parent().find("div").eq(0).find( ".fa-minus").length;
        if(minusLength != 0) $("#atMenu_" + obj[i].tempId).css("display","block");
        var tempSort = makeSortPath(obj[i].Sort);
        if(ps == undefined) {
          if(tempSort.length == 1) {
            obj[i].Sort = (100+i);
          } else if(tempSort.length == 2) {
            obj[i].Sort = Number(tempSort[0] + "" + (100+i));
          } else {
            obj[i].Sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
          }
          vm.changeSortArray.push(obj[i]);
        } else {
          var tempSort = makeSortPath(ps);
          if(tempSort.length == 1) {
            obj[i].Sort = Number(tempSort[0] + "" + (100+i));
          } else {
            obj[i].Sort = Number(tempSort[0] + "" + tempSort[1] + "" + (100+i));
          }
          vm.changeSortArray.push(obj[i]);
        }
        //if(obj[i].child != undefined)
        
        if (obj[i].child.length > 0) {
          vm.setChangeSort(obj[i].child, obj[i].Sort);
        }
      }
    };

    vm.setCtrlDetailView = function(item) {
      //vm.linkData = item;
      vm.bindLinkData(item);
      vm.setDetailView(item);
    }

    function makeSortPath(sort) {
      var sort = sort.toString();
      var result = Array();
      if(sort.length >= 3) {
        result.push(Number(sort.substring(0, 3)));
      }
      if(sort.length >= 6) {
        result.push(Number(sort.substring(3, 6)));
      }
      if(sort.length == 9) {
        result.push(Number(sort.substring(6, 9)));
      }
      return result;
    }

    vm.checkDepth1OtherData = function (obj, callback) {
      var result = vm.findUptTenantNode(obj, false);
      if (result.codes.length > 0) {
        gConfirm('', "해당 메뉴의 하위 메뉴를 모두 [활성] 하시겠습니까.", {
          btn: '확인', fn: function () {
            var toData = [];
            obj.UseYN = "Y";
            toData.push(obj);
            for (var i = 0; i < result.codes.length; i++) {
              result.codes[i].UseYN = "Y";
              toData.push(result.codes[i]);
            }

            callback(toData);
          }
        }, {
            btn: '취소', fn: function () {
              var toData = [];
              obj.UseYN = "Y";
              toData.push(obj);
              for (var i = 0; i < result.codes.length; i++) {
                toData.push(result.codes[i]);
              }
              callback(toData);
            }
          });
      } else {
        var toData = [];
        toData.push(obj);
        vm.setChangeMenuState(toData, true);
      }
    };

    vm.delChild = function (depth, obj) {
      if (obj.child.length > 0) {
        gAlert('', '하위 항목이 있으면 삭제할 수 없습니다.', {
          btn: '확인', fn: function () { }
        });
        return;
      }

      var $obj = $(vm.targetField);
      var sort = obj.Sort;
      var mSort = makeSortPath(sort);
      var msg = "";
      msg = "[" + obj.ItemNm + "] 삭제하시겠습니까?";
      gConfirm('', msg , {
        btn: '확인', fn: function () {
          vm.setDeleteItem(obj, function(result){
            if (result.header.status === CONSTANT.HttpStatus.OK) {              
              //if(result.body.docs[0].CodeLevel > 1) {
                // var $obj = null;
                // if (mSort.length == 2) {
                //   $obj = $("[menu-sort=" +mSort[0] + "].as-sortable-item-text");
                // } else if (mSort.length == 3) {
                //   $obj = $("[menu-sort=" +mSort[1] + "].as-sortable-item-text");
                // }

                // console.log($obj);
                // console.log(mSort.length);

                // if(mSort.length > 1) {
                //   $obj.find("i").eq(0).removeClass("fa-plus");
                //   $obj.find("i").eq(0).addClass("fa-minus");
                //   setTimeout(function () {
                //     $obj.find(".as-sortable-item-text").css("display", "block");
                //   }, 500);
                // }
              //}
            }            
          })
        }
      }, {btn: '취소', fn: function () {}
      });
    };

    vm.setAtListEnable = function (depth, obj) {
      if (depth == 1) {
        if (obj.UseYN == "N") {
          gConfirm('', obj.ItemNm + "를 [활성] 하시겠습니까?", {
            btn: '확인', fn: function () {
              if (obj.child.length > 0) {
                var toData = [];
                vm.checkDepth1OtherData(obj, function(subResult){
                  toData = subResult;
                  vm.setChangeMenuState(toData, function(result){
                    if (result.header.status === CONSTANT.HttpStatus.OK) {
                      angular.forEach(result.body.docs[0].list, function(item){
                        var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                        if(item.UseYN == "N") {
                          $thisObj.disableClass = "disable-master";
                        } else {
                          $thisObj.disableClass = "";
                        }
                      });
                      $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                    } else {
                      $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                    }
                  });
                });
              } else {
                var toData = [];
                obj.UseYN = "Y";
                toData.push(obj);
                vm.setChangeMenuState(toData, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs[0].list, function(item){
                      var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                      if(item.UseYN == "N") {
                        $thisObj.disableClass = "disable-master";
                      } else {
                        $thisObj.disableClass = "";
                      }
                    });
                    $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                  } else {
                    $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                  }
                });
              }
            }
          }, {btn: '취소', fn: function () {}});
        } else {
          var msg = "";
          if (obj.child.length > 0) msg = obj.ItemNm + "의 하위 항목을 포함하여 [비활성] 하시겠습니까?";
          else msg = obj.ItemNm + "를 [비활성] 하시겠습니까?";
          gConfirm('', msg, {
            btn: '확인', fn: function () {
              var toData = [];
              obj.UseYN = "N";
              toData.push(obj);
              var result = vm.findUptTenantNode(obj, false);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].UseYN = "N";
                toData.push(result.codes[i]);
              }

              vm.setChangeMenuState(toData, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs[0].list, function(item){
                    var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                    if(item.UseYN == "N") {
                      $thisObj.disableClass = "disable-master";
                    } else {
                      $thisObj.disableClass = "";
                    }
                  });
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                } else {
                  $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                }
              });
            }
          }, {
            btn: '취소', fn: function () {}
          });
        }
        // End Depth 1;
      } else {
        // 2Depth 이상
        var str, state = false, result = [], msg = '';
        (obj.UseYN == "N") ?  state = true : state = false;
        if(state) {
          result = vm.findUptTenantNode(obj, true);
          if(result.codes.length == 0) {
            msg = obj.ItemNm +"를 [활성] 하시겠습니까?";
          } else {
            msg = obj.ItemNm +"를 포함하여 [" + result.str + "] 메뉴를 [활성] 하시겠습니까?";
          }
        } else {
          if(obj.child.length > 0) {
            result = vm.findUptTenantNode(obj, false);
            msg = obj.ItemNm + "의 하위 항목을 포함하여 [비활성] 하시겠습니까?";
          } else {
            msg = obj.ItemNm + "를 [비활성] 하시겠습니까?";
          }
        }
        var tempResult = angular.copy(result);
        gConfirm('', msg, {
          btn: '확인', fn: function () {            
            var toData = [];
            toData.push(obj);
            if(state) {
              angular.forEach(tempResult.codes, function(item){
                toData.push(item);
              })
              if(obj.child.length > 0) {
                gConfirm('', obj.ItemNm + "의 하위 항목을 모두 [활성] 하시겠습니까.", {
                  btn: '확인', fn: function () {
                    var $thisObj = findObject(toData, 'Sort', obj.sort);
                    for(var i = 0; i < $thisObj.child.length; i++) {
                      $thisObj.child[i] = setMenuState(state, $thisObj.child[i]);
                      var temp = findObject(vm.menuList, 'Sort', $thisObj.child[i].sort);
                      temp = setMenuState(state, temp);
                    }

                    vm.setChangeMenuState(toData, function(result){
                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        angular.forEach(result.body.docs[0].list, function(item){
                          var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                          if(item.UseYN == "N") {
                            $thisObj.UseYN = "N";
                            $thisObj.disableClass = "disable-master";
                          } else {
                            $thisObj.UseYN = "Y";
                            $thisObj.disableClass = "";
                          }
                        });
                        $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                      } else {
                        $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                      }
                    });
                  }
                }, {
                  btn: '취소', fn: function () {
                    vm.setChangeMenuState(toData, function(result){
                      if (result.header.status === CONSTANT.HttpStatus.OK) {
                        angular.forEach(result.body.docs[0].list, function(item){
                          var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                          if(item.UseYN == "N") {
                            $thisObj.UseYN = "N";
                            $thisObj.disableClass = "disable-master";
                          } else {
                            $thisObj.UseYN = "Y";
                            $thisObj.disableClass = "";
                          }
                        });
                        $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                      } else {
                        $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                      }
                    });
                  }
                });
              } else {
                angular.forEach(toData, function(item, key) {
                  item.UseYN = "Y";
                });

                vm.setChangeMenuState(toData, function(result){
                  if (result.header.status === CONSTANT.HttpStatus.OK) {
                    angular.forEach(result.body.docs[0].list, function(item){
                      var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                      if(item.UseYN == "N") {
                        $thisObj.UseYN = "N";
                        $thisObj.disableClass = "disable-master";
                      } else {
                        $thisObj.UseYN = "Y";
                        $thisObj.disableClass = "";
                      }
                    });
                    $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                  } else {
                    $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                  }
                });
              }
            } else { // else !State

              var result = vm.findUptTenantNode(obj, false);
              for (var i = 0; i < result.codes.length; i++) {
                result.codes[i].useYn = "N";
                toData.push(result.codes[i]);
              }

              angular.forEach(toData, function(item, key) {
                item.UseYN = "N";
              });

              vm.setChangeMenuState(toData, function(result){
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  angular.forEach(result.body.docs[0].list, function(item){
                    var $thisObj = findObject(vm.bindData, 'KeyId', item.KeyId);
                    if(item.UseYN == "N") {
                      $thisObj.UseYN = "N";
                      $thisObj.disableClass = "disable-master";
                    } else {
                      $thisObj.UseYN = "Y";
                      $thisObj.disableClass = "";
                    }
                  });
                  $rootScope.showSimpleToast($translate.instant('Menu.SAVED'));
                } else {
                  $rootScope.showSimpleToast($translate.instant('저장을 실패하였습니다.'));
                }
              });
              //(state) ? vm.setChangeMenuState(toData, true) : vm.setChangeMenuState(toData, false);
            }
          }
        }, {
          btn: '취소', fn: function () {}
        });
      }
    };

    // // 2Depth 이상 수행 함수
    // function setChangeDepthCode(state, obj) {

    //   var result = [];
    //   var sort = makeSortPath(obj.Sort);
    //   var size = sort.length, oneDepth, twoDepth, sortKey = -1;
    //   oneDepth = findObject(vm.menuList, 'sort', sort[0]);
    //   if(size == 3){
    //      twoDepth = findObject(vm.menuList, 'sort', Number(sort[0]+''+sort[1]));
    //      if(state) setMenuState(state, twoDepth);
    //   }


    //   if(state) { // 활성
    //     var index = -1, checkSort = -1, sortidx = -1;
    //     if(oneDepth.useYn == "Y") {
    //       sortKey = oneDepth.sort;
    //     } else {
    //       for(var i = 0; i < vm.menuList.length; i++) {
    //         if(vm.menuList[i].menuId == oneDepth.menuId) {
    //           index = i;
    //         }
    //         if(vm.menuList[i].useYn == "Y") {
    //           checkSort = Number(vm.menuList[i].sort);
    //           sortidx = i;
    //         }
    //       }

    //       if(checkSort == -1) { sortKey = 100 } else { sortKey = checkSort+1; }
    //       oneDepth.useYn = "Y";
    //       oneDepth.disableClass = "";
    //       oneDepth.sort = sortKey;
    //       oneDepth.tempSortPath[0] = sortKey;

    //       result.push(oneDepth);
    //     }

    //     for(var i = 0; i < oneDepth.child.length; i++) {
    //       var o = oneDepth.child[i];
    //       var childSort = makeSortPath(o.Sort);
    //       childSort[0] = sortKey;
    //       o.sort =  + "" + Number(childSort.toString().replaceAll(",",""));
    //       o.tempSortPath = childSort;
    //       var d3ParentCode = [];
    //       angular.copy(o.tempSortPath, d3ParentCode);
    //       d3ParentCode.push(0);

    //       result.push(o);
    //       for(var j = 0; j < o.child.length; j++) {
    //         var _o = o.child[j];
    //         d3ParentCode[2] = _o.tempSortPath[2];
    //         _o.sort =  Number(d3ParentCode.toString().replaceAll(",",""));
    //         _o.tempSortPath = d3ParentCode;
    //         result.push(_o);
    //       }
    //     }

    //     if(index != -1) {
    //       var temp = {};
    //       angular.copy(vm.menuList[index], temp);
    //       vm.menuList.splice(index, 1);
    //       if(state) {
    //         (sortidx != -1) ? vm.menuList.splice(sortidx+1, 0, temp) : vm.menuList.push(temp);
    //       } else {
    //         vm.menuList.push(temp);
    //       }
    //     }
    //   } else { // 비활성
    //     result.push(obj);
    //     if(obj.child.length > 0) {
    //       for(var i = 0; i < obj.child.length; i++) {
    //         obj.child[i] = setMenuState(state, obj.child[i]);
    //         result.push(obj.child[i]);
    //       }
    //     }
    //   }
    //   return result;
    // }

    
    vm.findUptTenantNode = function (obj, arrow) {
      var resultObj = {};
      resultObj.str = [];
      resultObj.codes = [];
      if (arrow) { // UP
        var path = makeSortPath(obj.Sort);
        for (var i = 0; i < path.length-1; i++) {
          var temp = "";
          for(var j = 0; j < i+1; j++) {
            temp += path[j];
          }
          temp = findObject(vm.bindData, 'Sort', temp);
          if (temp.UseYN == "N") {
            resultObj.codes.push(temp);
            resultObj.str.push(temp.ItemNm);
          }
        }
      } else {
        var temp = obj.child;
        var k = [];
        var count = 0;
        for (var c = 0; c < 1000; c++) {
          for (var i = 0; i < temp.length; i++) {
            var check = true;
            for (var j = 0; j < k.length; j++) {
              if (k[j].KeyId == temp[i].KeyId) {
                check = false;
                break;
              }
            }
            if (check) k.push(temp[i]);
            else count = -1;
          }

          if (count == -1) break;
          if (k.length == count) break;
          else {
            count = k.length;
            temp = [];
            for (var i = 0; i < k.length; i++) {
              if (k[i] == undefined) {
                count = -1;
                break;
              }
              for (var j = 0; j < k[i].child.length; j++) temp.push(k[i].child[j]);
            }
          }
        }
        for (var i = 0; i < k.length; i++) {
          resultObj.str.push(k[i].ItemNm);
        }
        resultObj.codes = k;
      }
      resultObj.str = resultObj.str.toString();
      return resultObj;
    };

    function setMenuState(state, data) {
      // 배열로 작업 예정
      if(state) {
        data.useYn = "Y";
        data.disableClass = "";
      } else {
        data.useYn = "N";
        data.disableClass = "disable-master";
      }
      return data;
    }

    // // 2Depth 이상 수행 함수
    // function setChangeDepthCode(state, obj) {

    //   var result = [];
    //   var sort = makeSortPath(obj.Sort);
    //   var size = sort.length, oneDepth, twoDepth, sortKey = -1;
    //   oneDepth = findObject(vm.menuList, 'Sort', sort[0]);
    //   if(size == 3){
    //      twoDepth = findObject(vm.menuList, 'Sort', Number(sort[0]+''+sort[1]));
    //      if(state) setMenuState(state, twoDepth);
    //   }

    //   if(state) { // 활성
    //     var index = -1, checkSort = -1, sortidx = -1;
    //     if(oneDepth.useYn == "Y") {
    //       sortKey = oneDepth.sort;
    //     } else {
    //       for(var i = 0; i < vm.menuList.length; i++) {
    //         if(vm.menuList[i].menuId == oneDepth.menuId) {
    //           index = i;
    //         }
    //         if(vm.menuList[i].useYn == "Y") {
    //           checkSort = Number(vm.menuList[i].sort);
    //           sortidx = i;
    //         }
    //       }

    //       if(checkSort == -1) { sortKey = 100 } else { sortKey = checkSort+1; }
    //       oneDepth.useYn = "Y";
    //       oneDepth.disableClass = "";
    //       oneDepth.sort = sortKey;
    //       oneDepth.tempSortPath[0] = sortKey;

    //       result.push(oneDepth);
    //     }

    //     for(var i = 0; i < oneDepth.child.length; i++) {
    //       var o = oneDepth.child[i];
    //       var childSort = makeSortPath(o.sort);
    //       childSort[0] = sortKey;
    //       o.sort =  + "" + Number(childSort.toString().replaceAll(",",""));
    //       o.tempSortPath = childSort;
    //       var d3ParentCode = [];
    //       angular.copy(o.tempSortPath, d3ParentCode);
    //       d3ParentCode.push(0);

    //       result.push(o);
    //       for(var j = 0; j < o.child.length; j++) {
    //         var _o = o.child[j];
    //         d3ParentCode[2] = _o.tempSortPath[2];
    //         _o.sort =  Number(d3ParentCode.toString().replaceAll(",",""));
    //         _o.tempSortPath = d3ParentCode;
    //         result.push(_o);
    //       }
    //     }

    //     if(index != -1) {
    //       var temp = {};
    //       angular.copy(vm.menuList[index], temp);
    //       vm.menuList.splice(index, 1);
    //       if(state) {
    //         (sortidx != -1) ? vm.menuList.splice(sortidx+1, 0, temp) : vm.menuList.push(temp);
    //       } else {
    //         vm.menuList.push(temp);
    //       }
    //     }
    //   } else { // 비활성
    //     result.push(obj);
    //     if(obj.child.length > 0) {
    //       for(var i = 0; i < obj.child.length; i++) {
    //         obj.child[i] = setMenuState(state, obj.child[i]);
    //         result.push(obj.child[i]);
    //       }
    //     }
    //   }
    //   return result;
    // }

    function findObject(obj, key, value) {
      for (var i = 0; i < obj.length; i++) {
        for (var objKey in obj[i]) {
          if (objKey == key) {
            if (obj[i][objKey] == value) {
              return obj[i];
            }
          }
        }
        if(obj[i]["child"] != undefined) {
          if (obj[i]["child"].length > 0) {
            var result = findObject(obj[i]["child"], key, value);
            if (result != false) return result;
          }
        }
      }
      return false;
    }

    vm.drawList = function(data) {
      var temp = [];

      for(var i = 0; i < data.length; i++) {
        data[i].tempId = data[i].KeyId;
        if(data[i].sort != undefined) data[i].Sort = data[i].sort;

        if(data[i].CodeLevel == 1) {
          data[i].child = [];
          if(data[i].UseYN == "N") {
            data[i].disableClass = "disable-master";
          }
          temp.push(data[i]);
        } else if(data[i].CodeLevel > 1) {
          data[i].child = [];
          var obj = findObject(data, 'KeyId', data[i].ParentCommonCodeId);
          if(obj.child == undefined) obj.child = [];
          if(data[i].UseYN == "N") {
            data[i].disableClass = "disable-master";
          }
          obj.child.push(data[i]);
        }
      }

      vm.bindData = temp;
    };

    vm.makeListData = function() {

    }

    vm.init = function() {
      
      //vm.getData();
    };
    
  }]);

webapp.directive('sortableContainer', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      objectKey : "=",
      options : "=",
      bindData : "=",
      rootTitle : "@",
      linkData : "=",
      initCallback : "=",
      maxDepth : "@"
    },
    templateUrl : 'scripts/directives/sortable-container/sortable-container.html',
    controller : 'SortableContainerCtrl as scVc',
    link : function(scope, element, attrs, ctrl) {
      
      ctrl.options = scope.options;

      ctrl.bindData = scope.bindData;
      ctrl.rootTitle = scope.rootTitle;
      ctrl.linkData = scope.linkData;
      ctrl.maxDepth = scope.maxDepth;
      if(ctrl.maxDepth == undefined) ctrl.maxDepth = 3;
      ctrl.init();

      scope.initCallback(ctrl);

      ctrl.bindLinkData = function(data) {
        scope.linkData = data;
        //scope.initCallback.setDetailView(data);
      }
      
      //ctrl.objectKey = scope.objectKey;
    }
  };
}]);

webapp.controller('UdcDetailCtrl', [ '$scope', '$rootScope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', '$filter',
  function UdcDetailCtrl($scope, $rootScope, $element, $compile, CONSTANT, $translate, $filter) {
    var vm = this;
    vm.disabled = false;
    vm.metaList = [];
    vm.metaModel = [];
    vm.initalized = false;
    vm.name = 'name';

    vm.getCodeValue = function(key) {
      return $rootScope.getCodeValue(vm.metaList[key].CodeList, vm.metaModel[key]);
    };
  }
]);

webapp.directive('udcDetail', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      metaList : "=",
      metaModel : "=",
    },
    templateUrl : 'scripts/directives/udc/udc-detail.html',
    controller : 'UdcDetailCtrl as vc',
    link : function(scope, element, attrs, ctrl) {
      scope.$watchCollection('metaList', function(value) {
        ctrl.metaList = scope.metaList;
        ctrl.metaModel = scope.metaModel;
        ctrl.initalized = true;
      });

      ctrl.initChangeData = function(val) {
        try {
          if(attrs.metaModel != undefined) {
//            scope.metaModel = val;
          }
        } catch (e) {}
      };
    }
  };
} ]);

webapp.controller('UdcEditCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', '$filter',
  function UdcEditCtrl($scope, $element, $compile, CONSTANT, $translate, $filter) {
    var vm = this;
    vm.disabled = false;
    vm.metaList = [];
    vm.metaModel = [];

    vm.initalized = false;
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onModelChanged = function() {
      if (!vm.initalized) return;

      try {
        vm.initChangeData(vm.metaModel);
      } catch (err) {
        vm.initChangeData("");
      }
    };

    vm.onDateChanged = function(ColumnPhysicalNm, index) {
//    vm.metaModel[ColumnPhysicalNm] = $filter('date')(vm.RegDate[index], 'yyyy-MM-dd', 'UTC');
      vm.metaModel[ColumnPhysicalNm] = (new Date(vm.RegDate[index])).getTime();
      vm.onModelChanged();
    };
  }
]);

webapp.directive('udcEdit', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      metaList : "=",
      metaModel : "=",
    },
    templateUrl : 'scripts/directives/udc/udc-edit.html',
    controller : 'UdcEditCtrl as vc',
    link : function(scope, element, attrs, ctrl) {
      scope.$watchCollection('metaList', function(value) {
        ctrl.metaList = scope.metaList;
        ctrl.metaModel = scope.metaModel;
        ctrl.initalized = true;
      });

      ctrl.initChangeData = function(val) {
        try {
          if(attrs.metaModel != undefined) {
//            scope.metaModel = val;
          }
        } catch (e) {}
      };
    }
  };
} ]);

webapp.controller('UdcSearchCtrl', [ '$scope', '$element', '$compile', 'GLOBAL_CONSTANT', '$translate', '$filter',
  function UdcSearchCtrl($scope, $element, $compile, CONSTANT, $translate, $filter) {
    var vm = this;
    vm.disabled = false;
    vm.metaList = [];
    vm.metaModel = [];

    vm.initalized = false;
    vm.chooseMessage = 'Menu.CHOOSE';

    vm.onModelChanged = function() {
      if (!vm.initalized) return;

      try {
        vm.initChangeData(vm.metaModel);
      } catch (err) {
        vm.initChangeData("");
      }
    };

    vm.onDateChanged = function(ColumnPhysicalNm, index) {
//    vm.metaModel[ColumnPhysicalNm] = $filter('date')(vm.RegDate[index], 'yyyy-MM-dd', 'UTC');
      vm.metaModel[ColumnPhysicalNm] = (new Date(vm.RegDate[index])).getTime();
      vm.onModelChanged();
    };
  }
]);

webapp.directive('udcSearch', [ '$compile', '$parse', function($compile, $parse) {
  return {
    transclude : true,
    restrict : 'E',
    scope : {
      metaList : "=",
      metaModel : "=",
    },
    templateUrl : 'scripts/directives/udc/udc-search.html',
    controller : 'UdcSearchCtrl as vc',
    link : function(scope, element, attrs, ctrl) {
      scope.$watchCollection('metaList', function(value) {
        ctrl.metaList = scope.metaList;
        ctrl.metaModel = scope.metaModel;
        ctrl.initalized = true;
      });

      ctrl.initChangeData = function(val) {
        try {
          if(attrs.metaModel != undefined) {
//            scope.metaModel = val;
          }
        } catch (e) {}
      };
    }
  };
} ]);

webapp.controller('FileAttachController', [ '$scope', '$element', '$compile', '$timeout', 'StaticVariable', 'fileUploadService', 'uuidFactory', '$rootScope',
    function FileAttachController($scope, $element, $compile, $timeout, StaticVariable, fileUploadService, uuid, $rootScope) {
      var vm = this;
      var addLine = '';
      var request;

      vm.showLoading = false;
      vm.onDelete = onDelete;
      vm.onDeleteCancel = onDeleteCancel;
      vm.loadingPosition = "";
      vm.fileData = new Array();
      var id = 0;

      vm.onChangeHandler = function(files) {
        console.log('onChangeHandler');
        vm.uploadFiles(files);
      };

      $scope.$on('cancelFileSend', function(event, args) {
        if (request) {
          request.about();
        }
      });

      vm.uploadFiles = uploadFiles;

      function uploadFiles(files) {
        console.log('uploadFiles', vm.fileData);
        var tempIds = [];
        // $scope.$root.safeApply 이 함수를 통해 model을 set해주지 않으면 실시간 갱신이 안되는 문제가 있다.
        $scope.$root.safeApply(function() {
          var hasZeroByteFile = false;
          angular.forEach(files, function(value) {
            if (value.size == 0) {
              hasZeroByteFile = true;
            } else {
              var obj = {
                isLoaded : false,
                fileName : value.name,
                size : value.size,
                id : id,
                delState : ''
              };
              tempIds.push(obj);
              if (vm.fileData == null)
                vm.fileData = new Array();
              vm.fileData.push(angular.copy(obj));
              id++;
            }
          });
          console.log("fu", vm.fileData);
          if (hasZeroByteFile) {
            alert('빈 파일이 있습니다.');
            return;
          }

          request = fileUploadService.post(files, null, function(percent) {
            // -- 진행율 표시
            angular.forEach(tempIds, function(obj) {
              console.log('progress percent::', percent);
              $('#filectl_' + obj.id + ' .progress .progress-bar').css('width', percent + '%');
            });
            if (percent == 100) {
              vm.showLoading = true;
            }
          });

          try {
            request.to(StaticVariable.getUrl('/attach/temp/upload.do?userkey='+$rootScope.gVariable.userKey)).then(function(value) {
              angular.forEach(value.data.responseVO.body.docs, function(item) {
                angular.forEach(vm.fileData, function(obj) {
                  if (item.fileName == obj.fileName && item.size == obj.size) {
                    obj.isLoaded = true;
                    obj.tmpFileKey = item.tmpFileKey;
                    obj.typeId = item.typeId;
                    obj.path = item.path;
                    obj.link = StaticVariable.getUrl("/attach/temp/" + item.tmpFileKey + "/download.do?fileName=" + item.encFileName);
                    obj.delState = '';
                    console.log(obj.link);
                  }
                });
              });
              // 올린 파일에 대해서는 Html의 file element가 가지고 있는 파일의 내용을 지워준다.
              angular.element(vm.fileElement).val(null);
              if (vm.callback) {
                vm.callback.onFileUploadComplete();
              }
              vm.showLoading = false;
            }, function(reason) {
              console.log(reason);
            });
          } catch (err) {
            console.log(err);
          }
        });
      }
      ;

      function onDelete(obj) {
        if (obj.typeId != "temp") {
          if (obj.delState != 'delete')
            obj.delState = 'delete';
          else
            obj.delState = '';
          return;
        }

        var idx = -1;
        angular.forEach(vm.fileData, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          if (vm.fileData[idx].typeId == "temp") {
            fileUploadService.attachFileDelete(vm.fileData[idx], function(data){
              console.log('success', data);
              vm.fileData.splice(idx, 1);
            }, function(error) {
              console.error('fail', error);
            });
          } else {
            vm.fileData[idx].delState = 'delete';
            // if (vm.callback)
            // vm.callback.onFileDelete(vm.fileData[idx]);
          }
        }
      }
      ;

      function onDeleteCancel(obj) {
        var idx = -1;
        angular.forEach(vm.fileData, function(val, key) {
          if (val == obj) {
            idx = key;
            return;
          }
        });

        if (idx != -1) {
          vm.fileData[idx].delState = '';
          /*			if (vm.fileData[idx].typeId == "temp") {
          			var prms = fileUploadService.attachFileDelete().get({attachId:vm.fileData[idx].fileKey}).$promise;

          			prms.then(
          	                function (data) {
          	                	console.log('success', data);
          	                },
          	                function (error) {
          	                    console.error('fail', error);
          	                }
          	            )
          			} else if (vm.callback){
          				vm.callback.onFileDelete(vm.fileData[idx]);
          			}
          			vm.fileData.splice(idx, 1);\
           */
        }
      }
      ;

      vm.openDilalog = openDilalog;
      function openDilalog() {
        angular.element('#file-5').trigger("click");
      }

    } ]);

webapp.directive('fileAttach', ['$compile','$parse', function ($compile,$parse) {
    return {
    	transclude: true,
        restrict: 'E',
        scope:{
        	fileData:"=",
        	preFilesUpload:"=",
        	callback:"="
        },
        templateUrl: 'scripts/file-attach/directive/file-attach.html',
        controller: 'FileAttachController as faCtrl',
        link: function(scope, element, attrs, ctrl) {
        	var fileElement = angular.element(element[0].querySelector('input'));
        	fileElement.bind('change', function(){
        		ctrl.onChangeHandler(fileElement[0].files);
        	});

        	scope.$watchCollection('fileData', function(value) {
          	ctrl.fileData = scope.fileData;
          });

          if(scope.preFilesUpload && scope.preFilesUpload.length > 0){
            ctrl.uploadFiles(scope.preFilesUpload);
          }
          ctrl.callback = scope.callback;
          ctrl.fileElement = fileElement;

	        var checkSize, isTypeValid, processDragOverOrEnter, validMimeTypes;
	        processDragOverOrEnter = function(event) {
	          if (event != null) {
	            event.preventDefault();
	          }
	          event.dataTransfer.effectAllowed = 'copy';
	          return false;
	        };
	        validMimeTypes = attrs.fileDropzone;
	        checkSize = function(size) {
	          var _ref;
	          if (((_ref = attrs.maxFileSize) === (void 0) || _ref === '') || (size / 1024) / 1024 < attrs.maxFileSize) {
	            return true;
	          } else {
	            alert("File must be smaller than " + attrs.maxFileSize + " MB");
	            return false;
	          }
	        };
	        isTypeValid = function(type) {
	          if ((validMimeTypes === (void 0) || validMimeTypes === '') || validMimeTypes.indexOf(type) > -1) {
	            return true;
	          } else {
	            alert("Invalid file type.  File must be one of following types " + validMimeTypes);
	            return false;
	          }
	        };
	        element.bind('dragover', processDragOverOrEnter);
	        element.bind('dragenter', processDragOverOrEnter);
	        return element.bind('drop', function(event) {
	          var file, name, reader, size, type;
	          if (event != null) {
	            event.preventDefault();
	          }
	          reader = new FileReader();
	          reader.onload = function(evt) {
	            if (checkSize(size) && isTypeValid(type)) {
	              return scope.$apply(function() {
	                scope.file = evt.target.result;
	                if (angular.isString(scope.fileName)) {
	                  return scope.fileName = name;
	                }
	              });
	            }
	          };
	          file = event.dataTransfer.files[0];
	          name = file.name;
	          type = file.type;
	          size = file.size;
	          reader.readAsDataURL(file);
	          return false;
	        });
        }
    };
}]);

(function() {
  'use strict';
  angular.module('reusableThings', []).directive('fileDropzone', function() {
    return {
      restrict: 'A',
      scope: {
        file: '=',
        fileName: '='
      },
      link: function(scope, element, attrs) {
        var checkSize, isTypeValid, processDragOverOrEnter, validMimeTypes;
        processDragOverOrEnter = function(event) {
          if (event != null) {
            event.preventDefault();
          }
          event.dataTransfer.effectAllowed = 'copy';
          return false;
        };
        validMimeTypes = attrs.fileDropzone;
        checkSize = function(size) {
          var _ref;
          if (((_ref = attrs.maxFileSize) === (void 0) || _ref === '') || (size / 1024) / 1024 < attrs.maxFileSize) {
            return true;
          } else {
            alert("File must be smaller than " + attrs.maxFileSize + " MB");
            return false;
          }
        };
        isTypeValid = function(type) {
          if ((validMimeTypes === (void 0) || validMimeTypes === '') || validMimeTypes.indexOf(type) > -1) {
            return true;
          } else {
            alert("Invalid file type.  File must be one of following types " + validMimeTypes);
            return false;
          }
        };
        element.bind('dragover', processDragOverOrEnter);
        element.bind('dragenter', processDragOverOrEnter);
        return element.bind('drop', function(event) {
          var file, name, reader, size, type;
          if (event != null) {
            event.preventDefault();
          }
          reader = new FileReader();
          reader.onload = function(evt) {
            if (checkSize(size) && isTypeValid(type)) {
              return scope.$apply(function() {
                scope.file = evt.target.result;
                if (angular.isString(scope.fileName)) {
                  return scope.fileName = name;
                }
              });
            }
          };
          file = event.dataTransfer.files[0];
          name = file.name;
          type = file.type;
          size = file.size;
          reader.readAsDataURL(file);
          return false;
        });
      }
    };
  });

}).call(this);

(function() {
  'use strict';
    angular.module('reusableThings').controller('TestCtrl', function($scope) {
        $scope.image = null
        $scope.imageFileName = ''
    });

}).call(this);

webapp.factory('fileAttachDataUtil', function() {
	return {
		isLoading : function(arr) {
			if (arr) {
				var ret = false;
				angular.forEach(arr, function(value) {
					if (!value.isLoaded) {
						ret = true;
						return;
					}
				});
				return ret;
			} else {
				return ret;
			}
		},
		getTempFileKeys : function(arr) {
			var ret = [];
			if(arr){
				angular.forEach(arr, function(value) {
					if(value.tmpFileKey){
						ret.push(value.tmpFileKey);
					}
				});
			}
			return ret;
		},
		getAttachIds: function(arr){
			var ret = [];
			if(arr){
				angular.forEach(arr, function(value) {
					if(value.attachId){
						ret.push(value.attachId);
					}
				});
			}
			return ret;
		},
		cancel: function(scope){
			scope.$broadcast('cancelFileSend', {});
		}
	}
});

webapp.factory('fileUploadListener', fileUploadListener);
function fileUploadListener() {
	this.listener = {
			setListener: function(listener){
				this.listener = listener;
			},
			getListener: function()
			{
				return this.listener;
			}
		};
	return this.listener;
};

webapp.service('fileUploadService', [ '$rootScope', '$q', '$resource', 'StaticVariable', '$window', FileUploadService ]);

function FileUploadService($rootScope, $q, $resource, StaticVariable, $window) {
	var requests = [];
	var svc = {
    makeData : function(D) {
      if($window.sessionStorage["loginTenantId"] != "" && $window.sessionStorage["loginTenantId"] != null && $window.sessionStorage["loginTenantId"] != undefined){
        D.userkey = $rootScope.gVariable.userKey;
      }
      if ($window.sessionStorage['loginSysAdminYN'] == "Y" && !D.srchTenantId) {
        D.srchTenantId = $rootScope.gVariable.srchTenantId;
      }
      return D;
    },
		post : function(files, data, progressCb) {
			var xhr = new XMLHttpRequest();
			requests.push(xhr);
			return {
				to : function(uploadUrl) {
					var deferred = $q.defer()
					if (!files || !files.length) {
						deferred.reject("No files to upload");
						return;
          }

          // CORS 문제 발생
          // xhr.withCredentials = true;
          xhr.upload.onprogress = onProgress;
          xhr.onload = onLoad;
          xhr.upload.onerror = onError;

          var formData = new FormData();

          if (data) {
            Object.keys(data).forEach(function(key) {
              formData.append(key, data[key]);
            });
          }

          for (var idx = 0; idx < files.length; idx++) {
            formData.append(files[idx].name, files[idx]);
          }

          xhr.open("POST", uploadUrl);
          xhr.send(formData);

          function onProgress(e) {
            $rootScope.safeApply(function() {
              var percentCompleted;
              if (e.lengthComputable) {
                percentCompleted = Math.round((e.loaded / e.total) * 100);
                if (progressCb) {
                  progressCb(percentCompleted);
                } else if (deferred.notify) {
                  deferred.notify(percentCompleted);
                }
              }
            });
          }

          function onLoad(e) {
            var idx = -1;
            angular.forEach(requests, function(val, key) {
              if (val == xhr) {
                idx = key;
              }
            });
            if (idx != -1) {
              requests.splice(idx, 1);
            }
            $rootScope.safeApply(function() {

              // 2020.01.28 HJH GJ
              // 스마트에디터 주소로 전달 시 JSON 타입으로 오지않아서 예외처리
              var ret = {};
              try {
                ret = {
                  files: files,
                  data: angular.fromJson(xhr.responseText)
                };
              } catch(e) {
                ret = {
                  files: files,
                  data: xhr.responseText
                };
              }
              deferred.resolve(ret);
            });
          }

          function onError(e) {
            var msg = xhr.responseText? xhr.responseText : "An unknown error occurred posting to '" + uploadUrl + "'";
            $rootScope.safeApply(function() {
              deferred.reject(msg);
            });
          }

					return deferred.promise;
				},
				about: function(){
					if(requests){
						angular.forEach(requests, function(req){
							req.abort();
						});
					}
				}
			};
		},
		attachFileDelete : function(data, callback, callback2){
			return $resource(StaticVariable.getUrl('/attach/temp/delete.json'), {userkey:$rootScope.gVariable.userKey},
        StaticVariable.getRequestActions.defaultAction()).post(this.makeData(data)).$promise.then(function(success){
          callback(success);
        },
        function(error){
          callback2(error);
        });
		},
	};

	return svc;
};

(function() {
  ButtonsController.$inject = [];

  function ButtonsController() {}
  var buttons = {
    bindings: {},
    controller: ButtonsController,
    controllerAs: "buttons",
    templateUrl: "components/biz-component/buttons/buttons.html"
  };
  webapp.component("buttons", buttons);
})();

webapp.controller('LoginModalCtrl',
  ['$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'autoPage', '$stateParams', 'gAlert', '$window', '$filter',
  function LoginModalCtrl($scope, $uibModalInstance, toModalData, CONSTANT, postApi, ap, $stateParams, gAlert, $window, $filter) {
    
    var vm = this;
    var pageData = {
      vm : vm,
      stateParams : $stateParams,
      scope : $scope
    };
    
    // 확장 기능 개발 구간 종료
    /******************************************************************************** */

    vm.getInitDataExt = function() {
      console.log("init Ap")
    };

    vm.findIdPwd = function(find){
      var ctrl = 'FindIdPwdModalCtrl as modalCtrl';
      var paramData = { find : find };
      var modalInstance = modalFactory.open('modal', 'components/modal/findIdPwd/findIdPwd-modal.html', ctrl, paramData);
    }

    // 확장 기능 개발 구간 밑에서 정의해주세요.
    var ap = new ap();
    ap.setData(pageData);
    ap.init();

    vm.cancel = function() {
      $uibModalInstance.dismiss('cancel data');
    }

    vm.ok = function(item) {
      $uibModalInstance.close(item);
    }
  } 
]);

webapp.controller('AddPhotoCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function AddPhotoCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi) {
      var vm = this;
      vm.data = {};
      vm.uploadFileList = [];
      vm.showUploader = true;
      var vaultExt = 'jpg, gif, png';
      vm.showUploader = enableUploadComponent();
      vm.title = toModalData.title;
      vm.id = toModalData.id;
      initVaultComponent(vm.id, toModalData.imageCallback, null, vaultExt);
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        var data = {};
        data.activityNm = vm.data.activityNm;
        if(isNullOrEmpty(data.activityNm)){
          $('#activityNm').focus();
          $('#activityNm').css('border', '1px solid #f00');
          $('#activityNm').attr('placeholder', vm.title+'명을 입력해주세요.');
          return;
        }
        $uibModalInstance.close(data);
        
      }

      vm.cancel = cancel;
      vm.ok = ok;
}]);

webapp.controller('imageModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function imageModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi) {

        var vm = this;
        $scope.link = toModalData;

        function cancel() {
            $uibModalInstance.dismiss('cancel data');
        }

        vm.cancel = cancel;
    }
]);
webapp.controller('ApprovalModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', '$filter', 'gAlert', 'modalFactory',
    function ApprovalModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, $filter, gAlert, modalFactory ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.data = {};
      vm.title = toModalData.title;

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        $uibModalInstance.close(vm.data);
      }

    } ]);

webapp.controller('ContentsModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$sce',
    function ContentsModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $sce ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;

      if(!isNullOrEmpty(toModalData.VideoLink)){
        vm.VideoLink = $sce.trustAsResourceUrl(toModalData.VideoLink.replace("watch?v=","embed/") + "?rel=0");
      }
      vm.FileList = toModalData.FileList;
      vm.Contents = toModalData.Contents;
      vm.Title = toModalData.Title;

      (function ContentsModalCtrl() {

      })();

      function ok() {
        $uibModalInstance.close();
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

    } ]);

webapp.controller('UploadExcelUserModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function UploadExcelUserModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;

      vm.srch = {
		    TenantNm : '',
        TenantId : '',
        viewSize : 10
      };

      vm.selectedTenantId = toModalData.TenantId;

      (function TenantModalCtrl() {
        getList();
      })();

      function getList() {

        var data = {
          mapCode: 'Tenant.getTenantSrch',
          TenantNm : vm.srch.TenantNm,
          userkey : '',
        };

        if($window.sessionStorage['loginTenantId']!= null && $window.sessionStorage['loginTenantId'] != "" && $window.sessionStorage['loginTenantId'] != undefined){
          data.mapCode= 'Tenant.getTenantSrch';
          postApi.select(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;
              vm.totalItems = result.body.docCnt;
            }
          });
        } else if($window.sessionStorage['loginTenantId'] == null || $window.sessionStorage['loginTenantId'] == "" &&  $window.sessionStorage['loginTenantId'] == undefined) {
          data.mapCode= 'getTenantId';
          postApi.login(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;
              vm.totalItems = result.body.docCnt;
            }
          });
        }

      }


      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }
    } ]);

webapp.controller('FindIdPwdModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert',
    function FindIdPwdModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert ) {
      var vm = this;
      vm.success = false;
      vm.type = toModalData.type;
      console.warn(toModalData.type)
      vm.findType = "Phone";
      vm.disabled1 = "1";
      vm.disabled2 = "1";
      vm.LoginId = "";
      vm.dataloader = false;
      vm.data = {};

      (function FindIdPwdModalCtrl() {
      })();


      /* 인증번호 발송 버튼 */
      function auth() {
        if (!getIsValidData()) return;

        vm.dataloader = true;

        var data = {
          UserNm: vm.UserNm,                             // 이름
          LoginId: vm.type == 'IU' ? '' : vm.LoginId,    // 로그인 ID
          Type: vm.type,
          FindType: vm.findType,
          mapCode: 'findIdPwd'
        };

        if (vm.findType == "Email") {
          data.Email = vm.Email;                               // 이메일
        } else {
          data.Mobile = vm.Mobile;   
        }

        postApi.login(data, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              gAlert('', '인증번호를 발송했습니다.\n인증번호가 오지 않으면 입력하신 정보가 회원정보와 일치하는지 확인해 주세요.');

              if (vm.findType == "Email") {
                vm.disabled2 = "0";
              }
              else {
                vm.disabled1 = "0";
              }

              vm.dataloader = false;
            } else {
              gAlert('', 'Menu.SYSTEMALARM');
            }
          } else {
            gAlert('', result.body.docs[0].errMessage);

            vm.dataloader = false;
          }
        }, function(error) {
          console.error('Error> findIdPwd-modal-ctrl> auth()', status, error);

          vm.dataloader = false;
        });
      }


      /* 다음 버튼 */
      function submit() {
        if (!getIsValidData()) return;

        if (vm.findType == 'Phone') {
          if (vm.disabled1 == "1") {
            gAlert('', '휴대폰번호를 인증요청 해주세요.');
            return;
          }
        }
    
        if (vm.findType == 'Email') {
          if (vm.disabled2 == "1") {
            gAlert('', '이메일주소를 인증요청 해주세요.');
            return;
          }
        }

        if (vm.type == "IU") {
          var loginData = {
            LoginId: vm.LoginId,
            Email: vm.Email, 
            FindType: vm.findType, 
            Type: vm.type, 
            CetificationNum: vm.CetificationNum2,
            mapCode: 'selectIdPassFindCetification'
          };

          if (vm.findType == 'Email') {
            loginData.CetificationNum = vm.CetificationNum2;
            loginData.Email = vm.Email;
          } else {
            loginData.CetificationNum = vm.CetificationNum1;
            loginData.Mobile = vm.Mobile;
          }

          postApi.login(loginData, function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              if (result.body.docs.length > 0) {
                vm.success = true;
                vm.data.LoginId = result.body.docs[0].LoginId;
              } else {
                gAlert('', '잘못된 인증번호이거나 오류가 발생하였습니다.\n다시 시도해 주세요.');
                return;
              }
            } else {
              gAlert('', result.body.docs[0].errMessage);
            }
          }, function(error) {
            console.error('Error> findIdPwd-modal-ctrl> submit()', status, error);
          });
        }
        else {
          vm.success = true;
        }
      }


      /* 확인 버튼 */
      function submit2() {
        if (!getIsValidData()) return;

        loginData = { 
          LoginId: vm.LoginId, 
          Password: vm.data.Password, 
          CetificationNum: vm.data.CetificationNum,
          Type: vm.type,
          TableType: 'users',
          mapCode: 'updatePassword'
        };

        postApi.login(loginData, function(result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.data = result.body.docs[0];

              if (vm.data.result == 0) {
                gAlert('', '잘못된 인증번호이거나 오류가 발생하였습니다.\n다시 시도해 주세요.');
                return;
              }
              else {
                gAlert('', '수정 되었습니다.');
                $uibModalInstance.dismiss('cancel data');
              }
            }
            else {
              gAlert('', '잘못된 인증번호이거나 오류가 발생하였습니다.\n다시 시도해 주세요.');
              return;
            }
          } else {
            gAlert('', result.body.docs[0].errMessage);
          }
        }, function(error) {
          console.error('Error> findIdPwd-modal-ctrl> submit2()', status, error);
        });
      }


      /* 닫기 버튼 */
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }


      /* 핸드폰번호 정규식 검사 */
      function getIsValidMobile() {
        var reg = /^[0-9-]{10,11}$/g;

        if (!reg.test(vm.Mobile)) return false;

        return true;
      }


      /* 이메일 정규식 검사 */
      function getIsValidEmail() {
        var reg = /^[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*@[0-9a-zA-Z]([-_\.]?[0-9a-zA-Z])*\.[a-zA-Z]{2,3}$/i;

        if (!reg.test(vm.Email)) return false;

        return true;
      }


      /* 비밀번호 정규식 검사 */
      function getIsValidPassword() {
        var reg = /^(?=.*[a-zA-Z0-9])(?=.*[a-zA-Z!`~@#$%^&*()_=+{}|?<>,./\-])(?=.*[a-z0-9!`~@#$%^&*()_=+{}|?<>,./\-])(?=.*[A-Z0-9!`~@#$%^&*()_=+{}|?<>,./\-]).{8,}$/g; // 대문자, 소문자, 숫자, 특수문자 중 2개조합 8자리이상

        if (!reg.test(vm.data.Password)) return false;
        if (vm.data.Password.length < 8) return false;

        return true;
      }


      /* Validation Check */
      function getIsValidData() {
        var errMsg = '';

        if (isNullOrEmpty(vm.UserNm)) {
          errMsg = errMsg + '- 이름을 입력하세요.<br/>';
        }

        /* 아이디 찾기 */
        if (vm.type == "IU") {
          /* 휴대폰번호로 찾기 */
          if (vm.findType == "Phone") {
            if (isNullOrEmpty(vm.Mobile)) {
              errMsg = errMsg + '- 휴대폰번호를 입력하세요.<br/>';
            }

            if (!isNullOrEmpty(vm.Mobile)) { 
              if (!getIsValidMobile()) {
                errMsg = errMsg + '- 휴대폰번호 형식을 확인해 주세요.<br/>ex) 01012345678<br/>';
              }
            }
          }
          /* 이메일로 찾기 */
          else {
            if (isNullOrEmpty(vm.Email)) {
              errMsg = errMsg + '- 이메일주소를 입력하세요.<br/>';
            }

            if (!isNullOrEmpty(vm.Email)) { 
              if (!getIsValidEmail()) {
                errMsg = errMsg + '- 이메일 형식을 확인해 주세요.<br/>ex) sample@sample.co.kr<br/>';
              }
            }
          }
        }
        /* 비밀번호 찾기 */
        else {
          if (isNullOrEmpty(vm.LoginId)) {
            errMsg = errMsg + '- 아이디를 입력하세요.<br/>';
          }

          /* 휴대폰번호로 찾기 */
          if (vm.findType == "Phone") {
            if (isNullOrEmpty(vm.Mobile)) {
              errMsg = errMsg + '- 휴대폰번호를 입력하세요.<br/>';
            }

            if (!isNullOrEmpty(vm.Mobile)) { 
              if (!getIsValidMobile()) {
                errMsg = errMsg + '- 휴대폰번호 형식을 확인해 주세요.<br/>ex) 01012345678<br/>';
              }
            }
          }
          /* 이메일로 찾기 */
          else {
            if (isNullOrEmpty(vm.Email)) {
              errMsg = errMsg + '- 이메일주소를 입력하세요.<br/>';
            }

            if (!isNullOrEmpty(vm.Email)) { 
              if (!getIsValidEmail()) {
                errMsg = errMsg + '- 이메일 형식을 확인해 주세요.<br/>ex) sample@sample.co.kr<br/>';
              }
            }
          }

          /* 비밀번호 변경시 */
          if (vm.success) {
            if (isNullOrEmpty(vm.data.CetificationNum)) {
              errMsg = errMsg + '- 인증번호를 입력하세요.<br/>';
            }

            if (isNullOrEmpty(vm.data.Password)) {
              errMsg = errMsg + '- 비밀번호를 입력하세요.<br/>';
            }
    
            if (vm.data.Password != vm.data.RePassword) {
              errMsg = errMsg + '- 비밀번호가 일치하지 않습니다.<br/>';
            }
    
            if (!isNullOrEmpty(vm.data.Password)) { 
              if (!getIsValidPassword()) {
                errMsg = errMsg + '- 비밀번호 형식을 확인해 주세요.<br/>ex) 대문자, 소문자, 숫자, 특수문자 중 2개조합 8자리이상.<br/>';
              }
            }
          }
        }

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }

        return true; 
      }

      function chkPassId(str) {
        if(str == 'PWD') {
          var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_;:<>,.[\]{\}])[A-Za-z\d!@#$%^&*()\-_;:<>,.[\]{\}]+$/g;
  
          if(!reg.test(vm.data.Password)) return false;
          if(vm.data.Password.length < 8) return false;
  
          return true;
        
        }
      }


      /* 휴대폰번호로 찾기, 이메일로 찾기 Change */
      $scope.changeFindType = function(findType) {
        vm.findType = findType;
      };


      vm.submit = submit;
      vm.submit2 = submit2;
      vm.cancel = cancel;
      vm.auth = auth;
      vm.chkPassId = chkPassId;

    } ]);

webapp.controller('FormModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function FormModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getFormList = getFormList;
      vm.columnMap = {};

      (function FormModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.FormType = toModalData.formType;
        vm.FormList = [];
        getFormList();
      })();

      function changeViewSize() {
        getFormList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          formType: toModalData.formType,
        }
        vm.filter = req;
        return req;
      }

      function getFormList() {
        getFormListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'form';
        data.mapCode = 'Campaign2.getFormList';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.FormList = result.body.docs;
            } else {
              vm.FormList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getFormList()', status, error);
          vm.dataloader = false;
        });
      }

      function getFormListCnt() {

        var data = vm.getRequestParams();
        data.mapCode = 'Campaign2.getFormListCnt';
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getFormList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(Form) {
        $uibModalInstance.close(Form);
//        gConfirm('', '작성된 내용이 있을경우 해당 서식으로 대체됩니다. 진행하시겠습니까?', {
//          btn: '',
//          fn: function () {
//            $uibModalInstance.close(Form);
//          }
//        }, {
//          btn: '',
//          fn: function () {
//            cancel();
//          }
//        });
      }

    } ]);

/**
 * 캠페인 발송용 대상자 추가/변경.
 * - 고객 추가시에 DB에 바로 추가하지 않고. List에 가지고 있다가 저장할때 일괄 적용할것.
 */
webapp.controller('GroupEditModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', 'modalFactory', 'gConfirm', '$filter', '$translate',
  function GroupEditModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, modalFactory, gConfirm, $filter, $translate) {

    var vm = this;
    vm.data = toModalData;
    vm.originData = angular.copy(vm.data);

    // 필수항목 체크
    function getIsValidData() {
      var errMsg = '';
      if(isNullOrEmpty(vm.data.CustNm)) {
        //errMsg = errMsg + '- 이름을 입력해 주세요.<br/>';
        vm.data.CustNm = '';
      }
      
      if(vm.data.SendType == "SMS"){
        if(isNullOrEmpty(vm.data.Mobile)) {
          errMsg = errMsg + '- 핸드폰 정보를 입력해 주세요.<br/>';
        }
      }
      
      if(vm.data.SendType == "EMAIL"){
        if(isNullOrEmpty(vm.data.Email)) {
          errMsg = errMsg + '- 이메일 정보를 입력해 주세요.<br/>';
        }
      }
      
      if (!isNullOrEmpty(errMsg)) {
        gAlert('', errMsg);
        return false;
      }
      return true;
    }

    // 저장
    function setData() {
      if (getIsValidData() == false) {
        return;
      }

      // 신규 추가의 경우 발송대기 상태
      if(isNullOrEmpty(vm.data.RespStatus)){
        vm.data.RespStatus = "N";
        vm.data.RespStatusConv = "발송대기";
      }else{
        // 발송대기가 아니면서 휴대폰이나 이메일이 변경된 경우 발송대기로 변경하여 재발송 대상이 되게 한다.
        if(vm.data.RespStatus != "N" &&
            ((vm.data.SendType == "SMS" && vm.data.Mobile != vm.originData.Mobile) 
                || (vm.data.SendType == "EMAIL" && vm.data.Email != vm.originData.Email))
        ) {
            vm.data.RespStatus = "N";
            vm.data.RespStatusConv = "발송대기";
        }
      }

      setInsertUpdateDetail();
    }

    // 저장 후 처리
    function setInsertUpdateDetail() {
      $uibModalInstance.close(vm.data);
    }

    // 닫기
    function closeWin() {
      $uibModalInstance.close();
    }

    // 함수 정의
    vm.setData = setData;    // 데이터 저장
    vm.closeWin = closeWin;  // 닫기
  }, ]);

/*
 * CampaginID = 0로 저장
 * CampaignImplCustomer 에 직접입력
 */
webapp.controller('SmsCustSendModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function SmsCustSendModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.chkSendMessage = chkSendMessage;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.chkADTxt = chkADTxt;
      vm.chkDenyTxt = chkDenyTxt;
      vm.getCustInfo = getCustInfo;
      vm.columnMap = {};
      vm.data = {
          //CmpgnId : '',
          //CmpgnImplId : '',
          //CmpgnChannel : 'SMS',  //SMS : 90byte, LMS : 2000byte,
          CustIdList : [],
//          ToNm : '',
//          ToInfo : '',  
          FromInfo : '',
          SendTitle : '',
          SendMessage : ''
      };
      vm.userNm = $window.sessionStorage['loginUserName'];
      vm.Point = "";
      
      vm.addADTxtYN = 'N';
      vm.addADTxt = '(광고)';
      
      vm.addDenyTxtYN = 'N';
      vm.addDenyTxt = '무료수신거부 ';

      vm.custList = [];
      
      (function SmsCustSendModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.getRequestParams = getRequestParams;
        vm.changeViewSize = changeViewSize;

        vm.keyIdList = toModalData.keyIdList;
        vm.SENDNUM_LIST_SQL = 'SendNumberVerify.getSendNumberVerifySimpleList';  
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect';
        vm.TENANT_INFO_SQL = 'PaymentInfo.getTenantDetail';
        
        vm.sendNumberVerifyList = [];
        
        getTenantInfo();
        getCustInfo();
      })();

      function getRequestParams() {
        var req = {
            KeyIdList : vm.keyIdList,
            page : vm.currentPageNum,
            viewSize : vm.viewSizePerPage
        };
        vm.filter = req;
        return req;
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.mapCode = 'MMG_Customer.getCustomerDetailSms';
        
        getSendNumberList();
        getCustInfoCnt();

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data.CustIdList = result.body.docs;
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }

      vm.UsedPoint = function () {
        getTenantInfo();
        if (vm.data.CmpgnChannel == 'SMS') {
          vm.Point = vm.tenantInfo.CostSMS * vm.data.CustIdList.length;
        }
        if (vm.data.CmpgnChannel == 'LMS') {
          vm.Point = vm.tenantInfo.CostMMS * vm.data.CustIdList.length;
        }
      };
      function getCustInfoCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'MMG_Customer.getCustomerDetailSmsCnt';
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }
      
      
      /**
       * 발신인증번호 조회
       */
      function getSendNumberList(){
        //초기화
        vm.sendNumberVerifyList = [];
        
        var data = vm.getRequestParams();
        data.mapCode = vm.SENDNUM_LIST_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김
            
            if (result.body.docs.length > 0) {
              angular.forEach(result.body.docs, function (item) {
                vm.sendNumberVerifyList.push({'Code' : item.SendNumber, 'CodeValue' : item.SendNumber});
              });
            } else {
              gAlert("", "발신번호를 등록해야 합니다.", {
                btn: "",
                fn: function () {
                  cancel();
                  location.href = '/#/app/message/sms-send-number-save/';
                }
              });
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getSendNumberList()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getSendNumberList()");
          console.table(error);
        });
        
      }
      
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        data.Point = vm.Point;
        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          item.SendTitle = data.SendTitle;
          item.SendMessage = data.SendMessage;
          item.SendMessage2 = data.SendMessage2;
        });
        
        postApi.insert(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.error("Error> getSendNumberList()");
          console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }
        
        if (isNullOrEmpty(vm.data.CmpgnChannel)) {
          errMsg = errMsg + '- 문자 종류를 선택해 주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }
        if (vm.Point > vm.tenantInfo.ServPoint) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }

        if (vm.tenantInfo.ServPoint <= 0) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
        
      }

      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      /* vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; 
        vm.data.CmpgnChannel = vm.data.SmsType;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            vm.data.SmsType = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            flag = true;
            vm.data.SmsType = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      }; */

      vm.messageLength = 0;
      vm.messageMaxLength = 90;

      if (vm.data.CmpgnChannel == 'SMS') {
        vm.messageMaxLength = 90;
      }

      if (vm.data.CmpgnChannel == 'LMS') {
        vm.messageMaxLength = 2000;
      }

      var flag = false;

      function chkSendMessage() {
        vm.UsedPoint();
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
          
          if (vm.data.CmpgnChannel == 'SMS') {
            vm.data.SendMessage = fnCutMsg(msg, 88);
          }

          if (vm.data.CmpgnChannel == 'LMS') {
            vm.data.SendMessage = fnCutMsg(msg, 1999);
          }
        }
        
        /* vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; */
        vm.data.CmpgnChannel = vm.data.CmpgnChannel;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            vm.data.CmpgnChannel = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            flag = true;
            vm.data.CmpgnChannel = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      };

      vm.chkSendType = function (type) {
        if (type == 'SMS' || type =='') {
          vm.data.CmpgnChannel = 'SMS';
          vm.data.CmpgnChannel = 'SMS';
          vm.messageMaxLength = '90';
          if (Number(vm.messageLength) > 90) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return;
          } 

          if (!isNullOrEmpty(vm.data.SendTitle)) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('메세지 제목을 확인해 주세요.');
          }
          flag = false;
        } else if (type == 'LMS') {
          flag = true;
          vm.data.CmpgnChannel = 'LMS';
          vm.data.CmpgnChannel = 'LMS';
          vm.messageMaxLength = '2000';
        }
        vm.UsedPoint();
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까?', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }
      
      /**
       * Tenant정보 조회
       */
      function getTenantInfo(){
        var data = {
           TenantId : $window.sessionStorage["loginTenantId"]
          ,mapCode : vm.TENANT_INFO_SQL
        };
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tenantInfo = result.body.docs[0];
              vm.addDenyTxt += vm.tenantInfo.SMSDenyNum;
            } else {
              vm.tenantInfo = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getTenantInfo()");
          console.table(error);
        });
      }

    } ]);

/*
 * CampaginID = 0로 저장
 * CampaignImplCustomer 에 직접입력
 */
webapp.controller('SmsExpirationGxModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function SmsExpirationGxModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.chkSendMessage = chkSendMessage;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.chkADTxt = chkADTxt;
      vm.chkDenyTxt = chkDenyTxt;
      vm.getCustInfo = getCustInfo;
      vm.columnMap = {};
      vm.data = {
          //CmpgnId : '0',
          //CmpgnImplId : '0',
          //CmpgnChannel : 'SMS',  //SMS : 90byte, LMS : 2000byte,
          CustIdList : [],
//          ToNm : '',
//          ToInfo : '',  
          FromInfo : '',
          SendTitle : '',
          SendMessage : ''
      };
      vm.userNm = $window.sessionStorage['loginUserName'];
      vm.Point = "";
      vm.ExpirationStartDate = toModalData.ExpirationStartDate;
      vm.ExpirationEndDate = toModalData.ExpirationEndDate;
      
      vm.addADTxtYN = 'N';
      vm.addADTxt = '(광고)';
      
      vm.addDenyTxtYN = 'N';
      vm.addDenyTxt = '무료수신거부 ';

      vm.custList = [];
      var toDate = new Date();
      
      (function SmsExpirationGxModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.getRequestParams = getRequestParams;
        vm.changeViewSize = changeViewSize;

        vm.keyIdList = toModalData.keyIdList;
        vm.SENDNUM_LIST_SQL = 'SendNumberVerify.getSendNumberVerifySimpleList';  
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect2';
        vm.TENANT_INFO_SQL = 'PaymentInfo.getTenantDetail';
        
        vm.sendNumberVerifyList = [];
        
        getTenantInfo();
        getCustInfo();
      })();

      function getRequestParams() {
        var req = {
            KeyIdList : vm.keyIdList,
            page : vm.currentPageNum,
            viewSize : vm.viewSizePerPage
        };
        vm.filter = req;
        return req;
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.mapCode = 'MMG_Customer.getExpirationGXCustomerDetailSms';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;

        data.KeyIdList = toModalData.keyIdList;
        getSendNumberList();
        getCustInfoCnt();
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data.CustIdList = result.body.docs;
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }

      function getCustInfoCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'MMG_Customer.getExpirationGXCustomerDetailSmsCnt';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      vm.UsedPoint = function () {
        getTenantInfo();
        if (vm.data.CmpgnChannel == 'SMS') {
          vm.Point = vm.tenantInfo.CostSMS * vm.keyIdList.length;
        }
        if (vm.data.CmpgnChannel == 'LMS') {
          vm.Point = vm.tenantInfo.CostMMS * vm.keyIdList.length;
        }
        console.log('vm.point', vm.point);
      };
      
      /**
       * 발신인증번호 조회
       */
      function getSendNumberList(){
        //초기화
        vm.sendNumberVerifyList = [];
        
        var data = vm.getRequestParams();
        data.mapCode = vm.SENDNUM_LIST_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김
            
            if (result.body.docs.length > 0) {
              angular.forEach(result.body.docs, function (item) {
                vm.sendNumberVerifyList.push({'Code' : item.SendNumber, 'CodeValue' : item.SendNumber});
              });
            } else {
              gAlert("", "발신번호를 등록해야 합니다.", {
                btn: "",
                fn: function () {
                  cancel();
                  location.href = '/#/app/message/sms-send-number-save/';
                }
              });
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getSendNumberList()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getSendNumberList()");
          console.table(error);
        });
        
      }
      
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        data.Point = vm.Point;

        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          var sendTitle = data.SendTitle.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.MembershipFullNm)
                          .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          var sendMsg = data.SendMessage.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.MembershipFullNm)
                      .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          item.SendTitle = sendTitle;
          item.SendMessage = sendMsg;
        });

        postApi.update(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.error("Error> getSendNumberList()");
          console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }

        if (isNullOrEmpty(vm.data.CmpgnChannel)) {
          errMsg = errMsg + '- 문자 종류를 선택해 주세요.<br/>';
        }
        
        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }

        if (vm.Point > vm.tenantInfo.ServPoint) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }

        if (vm.tenantInfo.ServPoint <= 0) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
        
      }
      
      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      /* vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; 
        vm.data.CmpgnChannel = vm.data.SmsType;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            vm.data.SmsType = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            flag = true;
            vm.data.SmsType = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      }; */

      vm.messageLength = 0;
      vm.messageMaxLength = 90;

      if (vm.data.CmpgnChannel == 'SMS') {
        vm.messageMaxLength = 90;
      }

      if (vm.data.CmpgnChannel == 'LMS') {
        vm.messageMaxLength = 2000;
      }

      var flag = false;

      function chkSendMessage() {
        vm.UsedPoint();
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
          
          if (vm.data.CmpgnChannel == 'SMS') {
            vm.data.SendMessage = fnCutMsg(msg, 88);
          }

          if (vm.data.CmpgnChannel == 'LMS') {
            vm.data.SendMessage = fnCutMsg(msg, 1999);
          }
        }
        
        /* vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; */
        vm.data.CmpgnChannel = vm.data.CmpgnChannel;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            vm.data.CmpgnChannel = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            flag = true;
            vm.data.CmpgnChannel = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      };

      vm.chkSendType = function (type) {
        if (type == 'SMS' || type =='') {
          vm.data.CmpgnChannel = 'SMS';
          vm.data.CmpgnChannel = 'SMS';
          vm.messageMaxLength = '90';
          if (Number(vm.messageLength) > 90) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return;
          } 

          if (!isNullOrEmpty(vm.data.SendTitle)) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('메세지 제목을 확인해 주세요.');
          }
          flag = false;
        } else if (type == 'LMS') {
          flag = true;
          vm.data.CmpgnChannel = 'LMS';
          vm.data.CmpgnChannel = 'LMS';
          vm.messageMaxLength = '2000';
        }
        vm.UsedPoint();
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까??', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }
      
      /**
       * Tenant정보 조회
       */
      function getTenantInfo(){
        var data = {
           TenantId : $window.sessionStorage["loginTenantId"]
          ,mapCode : vm.TENANT_INFO_SQL
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tenantInfo = result.body.docs[0];
              vm.addDenyTxt += vm.tenantInfo.SMSDenyNum;
            } else {
              vm.tenantInfo = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getTenantInfo()");
          console.table(error);
        });
      }

    } ]);

/*
 * CampaginID = 0로 저장
 * CampaignImplCustomer 에 직접입력
 */
webapp.controller('SmsExpirationItemModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function SmsExpirationItemModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.chkSendMessage = chkSendMessage;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.chkADTxt = chkADTxt;
      vm.chkDenyTxt = chkDenyTxt;
      vm.getCustInfo = getCustInfo;
      vm.columnMap = {};
      vm.data = {
          //CmpgnId : '0',
          //CmpgnImplId : '0',
          //CmpgnChannel : 'SMS',  //SMS : 90byte, LMS : 2000byte,
          CustIdList : [],
//          ToNm : '',
//          ToInfo : '',  
          FromInfo : '',
          SendTitle : '',
          SendMessage : ''
      };
      vm.userNm = $window.sessionStorage['loginUserName'];
      vm.Point = "";
      vm.ExpirationStartDate = toModalData.ExpirationStartDate;
      vm.ExpirationEndDate = toModalData.ExpirationEndDate;
      
      vm.addADTxtYN = 'N';
      vm.addADTxt = '(광고)';
      
      vm.addDenyTxtYN = 'N';
      vm.addDenyTxt = '무료수신거부 ';

      vm.custList = [];
      var toDate = new Date();
      
      (function SmsExpirationItemModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.getRequestParams = getRequestParams;
        vm.changeViewSize = changeViewSize;

        vm.keyIdList = toModalData.keyIdList;
        vm.SENDNUM_LIST_SQL = 'SendNumberVerify.getSendNumberVerifySimpleList';  
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect2';
        vm.TENANT_INFO_SQL = 'PaymentInfo.getTenantDetail';
        
        vm.sendNumberVerifyList = [];
        
        getTenantInfo();
        getCustInfo();
      })();

      function getRequestParams() {
        var req = {
            KeyIdList : vm.keyIdList,
            page : vm.currentPageNum,
            viewSize : vm.viewSizePerPage
        };
        vm.filter = req;
        return req;
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.mapCode = 'MMG_Customer.getExpirationItemCustomerDetailSms';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;

        data.KeyIdList = toModalData.keyIdList;
        getSendNumberList();
        getCustInfoCnt();

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data.CustIdList = result.body.docs;
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }

      function getCustInfoCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'MMG_Customer.getExpirationItemCustomerDetailSmsCnt';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      vm.UsedPoint = function () {
        getTenantInfo();
        if (vm.data.CmpgnChannel == 'SMS') {
          vm.Point = vm.tenantInfo.CostSMS * vm.keyIdList.length;
        }
        if (vm.data.CmpgnChannel == 'LMS') {
          vm.Point = vm.tenantInfo.CostMMS * vm.keyIdList.length;
        }
        console.log('vm.point', vm.point);
      };
      
      /**
       * 발신인증번호 조회
       */
      function getSendNumberList(){
        //초기화
        vm.sendNumberVerifyList = [];
        
        var data = vm.getRequestParams();
        data.mapCode = vm.SENDNUM_LIST_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김
            
            if (result.body.docs.length > 0) {
              angular.forEach(result.body.docs, function (item) {
                vm.sendNumberVerifyList.push({'Code' : item.SendNumber, 'CodeValue' : item.SendNumber});
              });
            } else {
              gAlert("", "발신번호를 등록해야 합니다.", {
                btn: "",
                fn: function () {
                  cancel();
                  location.href = '/#/app/message/sms-send-number-save/';
                }
              });
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getSendNumberList()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getSendNumberList()");
          console.table(error);
        });
        
      }
      
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        data.Point = vm.Point;
        
        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          var sendTitle = data.SendTitle.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.ItemFullNm)
                          .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          var sendMsg = data.SendMessage.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.ItemFullNm)
                      .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          item.SendTitle = sendTitle;
          item.SendMessage = sendMsg;
        });
        
        postApi.update(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.error("Error> getSendNumberList()");
          console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }
        
        if (isNullOrEmpty(vm.data.CmpgnChannel)) {
          errMsg = errMsg + '- 문자 종류를 선택해 주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }

        if (vm.Point > vm.tenantInfo.ServPoint) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }

        if (vm.tenantInfo.ServPoint <= 0) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
        
      }
      
      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      /* vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; 
        vm.data.CmpgnChannel = vm.data.SmsType;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            vm.data.SmsType = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            flag = true;
            vm.data.SmsType = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      }; */

      vm.messageLength = 0;
      vm.messageMaxLength = 90;

      if (vm.data.CmpgnChannel == 'SMS') {
        vm.messageMaxLength = 90;
      }

      if (vm.data.CmpgnChannel == 'LMS') {
        vm.messageMaxLength = 2000;
      }

      var flag = false;

      function chkSendMessage() {
        vm.UsedPoint();
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
          
          if (vm.data.CmpgnChannel == 'SMS') {
            vm.data.SendMessage = fnCutMsg(msg, 88);
          }

          if (vm.data.CmpgnChannel == 'LMS') {
            vm.data.SendMessage = fnCutMsg(msg, 1999);
          }
        }
        
        /* vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; */
        vm.data.CmpgnChannel = vm.data.CmpgnChannel;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            vm.data.CmpgnChannel = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            flag = true;
            vm.data.CmpgnChannel = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      };

      vm.chkSendType = function (type) {
        if (type == 'SMS' || type =='') {
          vm.data.CmpgnChannel = 'SMS';
          vm.data.CmpgnChannel = 'SMS';
          vm.messageMaxLength = '90';
          if (Number(vm.messageLength) > 90) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return;
          } 

          if (!isNullOrEmpty(vm.data.SendTitle)) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('메세지 제목을 확인해 주세요.');
          }
          flag = false;
        } else if (type == 'LMS') {
          flag = true;
          vm.data.CmpgnChannel = 'LMS';
          vm.data.CmpgnChannel = 'LMS';
          vm.messageMaxLength = '2000';
        }
        vm.UsedPoint();
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까?', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }
      
      /**
       * Tenant정보 조회
       */
      function getTenantInfo(){
        var data = {
           TenantId : $window.sessionStorage["loginTenantId"]
          ,mapCode : vm.TENANT_INFO_SQL
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tenantInfo = result.body.docs[0];
              vm.addDenyTxt += vm.tenantInfo.SMSDenyNum;
            } else {
              vm.tenantInfo = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getTenantInfo()");
          console.table(error);
        });
      }

    } ]);

/*
 * CampaginID = 0로 저장
 * CampaignImplCustomer 에 직접입력
 */
webapp.controller('SmsExpirationLockerModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function SmsExpirationLockerModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.chkSendMessage = chkSendMessage;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.chkADTxt = chkADTxt;
      vm.chkDenyTxt = chkDenyTxt;
      vm.getCustInfo = getCustInfo;
      vm.columnMap = {};
      vm.data = {
          //CmpgnId : '0',
          //CmpgnImplId : '0',
          //CmpgnChannel : 'SMS',  //SMS : 90byte, LMS : 2000byte,
          CustIdList : [],
//          ToNm : '',
//          ToInfo : '',  
          FromInfo : '',
          SendTitle : '',
          SendMessage : ''
      };
      vm.userNm = $window.sessionStorage['loginUserName'];
      vm.Point = "";
      vm.ExpirationStartDate = toModalData.ExpirationStartDate;
      vm.ExpirationEndDate = toModalData.ExpirationEndDate;
      
      vm.addADTxtYN = 'N';
      vm.addADTxt = '(광고)';
      
      vm.addDenyTxtYN = 'N';
      vm.addDenyTxt = '무료수신거부 ';

      vm.custList = [];
      var toDate = new Date();
      
      (function SmsExpirationLockerModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.getRequestParams = getRequestParams;
        vm.changeViewSize = changeViewSize;

        vm.keyIdList = toModalData.keyIdList;
        vm.SENDNUM_LIST_SQL = 'SendNumberVerify.getSendNumberVerifySimpleList';  
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect2';
        vm.TENANT_INFO_SQL = 'PaymentInfo.getTenantDetail';
        
        vm.sendNumberVerifyList = [];
        
        getTenantInfo();
        getCustInfo();
      })();

      function getRequestParams() {
        var req = {
            KeyIdList : vm.keyIdList,
            page : vm.currentPageNum,
            viewSize : vm.viewSizePerPage
        };
        vm.filter = req;
        return req;
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.mapCode = 'MMG_Customer.getExpirationLockerCustomerDetailSms';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;
        
        data.KeyIdList = toModalData.keyIdList;
        getSendNumberList();
        getCustInfoCnt();

        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data.CustIdList = result.body.docs;
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }

      function getCustInfoCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'MMG_Customer.getExpirationLockerCustomerDetailSmsCnt';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      vm.UsedPoint = function () {
        getTenantInfo();
        if (vm.data.CmpgnChannel == 'SMS') {
          vm.Point = vm.tenantInfo.CostSMS * vm.keyIdList.length;
        }
        if (vm.data.CmpgnChannel == 'LMS') {
          vm.Point = vm.tenantInfo.CostMMS * vm.keyIdList.length;
        }
        console.log('vm.point', vm.point);
      };
      
      /**
       * 발신인증번호 조회
       */
      function getSendNumberList(){
        //초기화
        vm.sendNumberVerifyList = [];
        
        var data = vm.getRequestParams();
        data.mapCode = vm.SENDNUM_LIST_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김
            
            if (result.body.docs.length > 0) {
              angular.forEach(result.body.docs, function (item) {
                vm.sendNumberVerifyList.push({'Code' : item.SendNumber, 'CodeValue' : item.SendNumber});
              });
            } else {
              gAlert("", "발신번호를 등록해야 합니다.", {
                btn: "",
                fn: function () {
                  cancel();
                  location.href = '/#/app/message/sms-send-number-save/';
                }
              });
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getSendNumberList()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getSendNumberList()");
          console.table(error);
        });
        
      }
      
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        data.Point = vm.Point;
        
        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          var sendTitle = data.SendTitle.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.LockerFullNm)
                          .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          var sendMsg = data.SendMessage.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.LockerFullNm)
                      .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          item.SendTitle = sendTitle;
          item.SendMessage = sendMsg;
        });
        
        postApi.update(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.error("Error> getSendNumberList()");
          console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }
        
        if (isNullOrEmpty(vm.data.CmpgnChannel)) {
          errMsg = errMsg + '- 문자 종류를 선택해 주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }

        if (vm.Point > vm.tenantInfo.ServPoint) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }

        if (vm.tenantInfo.ServPoint <= 0) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }
        
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
        
      }
      
      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      /* vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; 
        vm.data.CmpgnChannel = vm.data.SmsType;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            vm.data.SmsType = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            flag = true;
            vm.data.SmsType = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      }; */

      vm.messageLength = 0;
      vm.messageMaxLength = 90;

      if (vm.data.CmpgnChannel == 'SMS') {
        vm.messageMaxLength = 90;
      }

      if (vm.data.CmpgnChannel == 'LMS') {
        vm.messageMaxLength = 2000;
      }

      var flag = false;

      function chkSendMessage() {
        vm.UsedPoint();
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
          
          if (vm.data.CmpgnChannel == 'SMS') {
            vm.data.SendMessage = fnCutMsg(msg, 88);
          }

          if (vm.data.CmpgnChannel == 'LMS') {
            vm.data.SendMessage = fnCutMsg(msg, 1999);
          }
        }
        
        /* vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; */
        vm.data.CmpgnChannel = vm.data.CmpgnChannel;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            vm.data.CmpgnChannel = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            flag = true;
            vm.data.CmpgnChannel = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      };

      vm.chkSendType = function (type) {
        if (type == 'SMS' || type =='') {
          vm.data.CmpgnChannel = 'SMS';
          vm.data.CmpgnChannel = 'SMS';
          vm.messageMaxLength = '90';
          if (Number(vm.messageLength) > 90) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return;
          } 

          if (!isNullOrEmpty(vm.data.SendTitle)) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('메세지 제목을 확인해 주세요.');
          }
          flag = false;
        } else if (type == 'LMS') {
          flag = true;
          vm.data.CmpgnChannel = 'LMS';
          vm.data.CmpgnChannel = 'LMS';
          vm.messageMaxLength = '2000';
        }
        vm.UsedPoint();
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까?', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }
      
      /**
       * Tenant정보 조회
       */
      function getTenantInfo(){
        var data = {
           TenantId : $window.sessionStorage["loginTenantId"]
          ,mapCode : vm.TENANT_INFO_SQL
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tenantInfo = result.body.docs[0];
              vm.addDenyTxt += vm.tenantInfo.SMSDenyNum;
            } else {
              vm.tenantInfo = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getTenantInfo()");
          console.table(error);
        });
      }

    } ]);

/*
 * CampaginID = 0로 저장
 * CampaignImplCustomer 에 직접입력
 */
webapp.controller('SmsExpirationMembershipModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm',
    function SmsExpirationMembershipModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm ) {
      var vm = this;
      vm.chkSendMessage = chkSendMessage;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.chkADTxt = chkADTxt;
      vm.chkDenyTxt = chkDenyTxt;
      vm.getCustInfo = getCustInfo;
      vm.columnMap = {};
      vm.data = {
          //CmpgnId : '0',
          //CmpgnImplId : '0',
          //CmpgnChannel : 'SMS',  //SMS : 90byte, LMS : 2000byte,
          CustIdList : [],
//          ToNm : '',
//          ToInfo : '',  
          FromInfo : '',
          SendTitle : '',
          SendMessage : ''
      };
      vm.userNm = $window.sessionStorage['loginUserName'];
      vm.Point = "";
      vm.ExpirationStartDate = toModalData.ExpirationStartDate;
      vm.ExpirationEndDate = toModalData.ExpirationEndDate;
      
      vm.addADTxtYN = 'N';
      vm.addADTxt = '(광고)';
      
      vm.addDenyTxtYN = 'N';
      vm.addDenyTxt = '무료수신거부 ';

      vm.custList = [];
      var toDate = new Date();

      (function SmsExpirationMembershipModal2Ctrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.getRequestParams = getRequestParams;
        vm.changeViewSize = changeViewSize;

        vm.keyIdList = toModalData.keyIdList;
        vm.SENDNUM_LIST_SQL = 'SendNumberVerify.getSendNumberVerifySimpleList';  
        vm.INSERT_SQL = 'CampaignImpl.insertCampaignImplCustomerDirect2';
        vm.TENANT_INFO_SQL = 'PaymentInfo.getTenantDetail';
        
        vm.sendNumberVerifyList = [];
        
        getTenantInfo();
        getCustInfo();
      })();

      function getRequestParams() {
        var req = {
            KeyIdList : vm.keyIdList,
            page : vm.currentPageNum,
            viewSize : vm.viewSizePerPage
        };
        vm.filter = req;
        return req;
      }

      function changeViewSize() {
        getCustInfo();
      }

      //고객정보 조회
      function getCustInfo() {
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.mapCode = 'MMG_Customer.getExpirationMembershipCustomerDetailSms';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;
        
        data.KeyIdList = toModalData.keyIdList;
        getSendNumberList();
        getCustInfoCnt();
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {        
              vm.data.CustIdList = result.body.docs;
            } else {
              gAlert('', '문자발송을 위한 회원을 선택해 주세요.');
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getCustInfo()', status, error);
          vm.dataloader = false;
        });
      }

      function getCustInfoCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'MMG_Customer.getExpirationMembershipCustomerDetailSmsCnt';
        data.ExpirationStartDate = vm.ExpirationStartDate;
        data.ExpirationEndDate = vm.ExpirationEndDate;
        
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs;
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      vm.UsedPoint = function () {
        getTenantInfo();
        if (vm.data.CmpgnChannel == 'SMS') {
          vm.Point = vm.tenantInfo.CostSMS * vm.keyIdList.length;
        }
        if (vm.data.CmpgnChannel == 'LMS') {
          vm.Point = vm.tenantInfo.CostMMS * vm.keyIdList.length;
        }
        console.log('vm.point', vm.point);
      };
      
      /**
       * 발신인증번호 조회
       */
      function getSendNumberList(){
        //초기화
        vm.sendNumberVerifyList = [];
        
        var data = vm.getRequestParams();
        data.mapCode = vm.SENDNUM_LIST_SQL;
        
        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공
            vm.dataloader = false; // Progressbar 숨김
            
            if (result.body.docs.length > 0) {
              angular.forEach(result.body.docs, function (item) {
                vm.sendNumberVerifyList.push({'Code' : item.SendNumber, 'CodeValue' : item.SendNumber});
              });
            } else {
              gAlert("", "발신번호를 등록해야 합니다.", {
                btn: "",
                fn: function () {
                  cancel();
                  location.href = '/#/app/message/sms-send-number-save/';
                }
              });
            }
          } else {
            vm.dataloader = false; // Progressbar 숨김

            console.error("Error> getSendNumberList()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getSendNumberList()");
          console.table(error);
        });
        
      }
      
      
      /**
       * 메세지 전송
       */
      function sendSmsMessage(){
        var data = angular.copy(vm.data);
        data.mapCode = vm.INSERT_SQL;
        data.keyIdList = vm.keyIdList;
        data.FromNm = vm.userNm;
        data.Point = vm.Point;

        angular.forEach(data.CustIdList, function (item) {
          //TODO : 문자 치환
          var sendTitle = data.SendTitle.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.MembershipFullNm)
                          .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          var sendMsg = data.SendMessage.replace(/{CustNm}/gi, item.CustNm).replace(/{ProdNm}/gi, item.MembershipFullNm)
                      .replace(/{M}/gi, toDate.getMonth()+1).replace(/{D}/gi, toDate.getDay()).replace(/{HH}/gi, toDate.getHours()).replace(/{MM}/gi, toDate.getMinutes());
          item.SendTitle = sendTitle;
          item.SendMessage = sendMsg;
        });
        
        postApi.update(data, function (result) {
          gAlert('전송되었습니다.');
          $uibModalInstance.close();
        }, function (error) {
          console.error("Error> getSendNumberList()");
          console.table(error);
          gAlert('', 'Menu.EXCEPTIONOCCURED');
        });
      }


      /**
       * 필수항목 체크
       * @param
       * @return
       */
      function getIsValidData() {
        var bRtn = true;
        var errMsg = '';
        
        if (isNullOrEmpty(vm.data.SendType)) {
          vm.data.SendType = 'DIRECT';
        }
        
        if (isNullOrEmpty(vm.data.CmpgnChannel)) {
          errMsg = errMsg + '- 문자 종류를 선택해 주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.FromInfo)) {
          errMsg = errMsg + '- 인증된 발송번호를 선택해 주세요.<br/>';
        }
        
        //LMS. MMS 일경우 필수
        if (vm.data.CmpgnChannel == 'LMS'  && isNullOrEmpty(vm.data.SendTitle)) {
          errMsg = errMsg + '- 메세지 제목을 입력해 주세요.<br/>';
        }
        
        
        if (isNullOrEmpty(vm.data.SendMessage)) {
          errMsg = errMsg + '- 메세지 내용을 입력해 주세요.<br/>';
        }

        if (vm.Point > vm.tenantInfo.ServPoint) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }

        if (vm.tenantInfo.ServPoint <= 0) {
          errMsg = errMsg + '- 포인트를 충전해 주세요.<br/>';
        }
        
        if (!isNullOrEmpty(errMsg)) {
          bRtn =  false;
          gAlert('', errMsg);
        }

        return bRtn;
      }
      
      /**
       * 발송내용 바이트 체크
       *
       * @param
       * @return
       */
      /* vm.messageLength = 0;
      vm.messageMaxLength = 90;
      var flag = false;

      vm.chkSendMessage = function () {
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;

          if (bytes > 2000) {
            vm.data.SendMessage = fnCutMsg(msg, 2000);
            bytes = 2000;
          }
        }
        
        vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; 
        vm.data.CmpgnChannel = vm.data.SmsType;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            vm.data.SmsType = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.SmsType) || vm.data.SmsType == 'SMS')) {
            flag = true;
            vm.data.SmsType = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      }; */

      vm.messageLength = 0;
      vm.messageMaxLength = 90;

      if (vm.data.CmpgnChannel == 'SMS') {
        vm.messageMaxLength = 90;
      }

      if (vm.data.CmpgnChannel == 'LMS') {
        vm.messageMaxLength = 2000;
      }

      var flag = false;

      function chkSendMessage() {
        vm.UsedPoint();
        var msg = "";
        var bytes = 0;

        if(!isNullOrEmpty(vm.data.SendMessage)) {
          msg = vm.data.SendMessage;
          bytes = msg.length + (escape(msg) + "%u").match(/%u/g).length - 1;
          
          if (vm.data.CmpgnChannel == 'SMS') {
            vm.data.SendMessage = fnCutMsg(msg, 88);
          }

          if (vm.data.CmpgnChannel == 'LMS') {
            vm.data.SendMessage = fnCutMsg(msg, 1999);
          }
        }
        
        /* vm.data.CmpgnChannel = bytes > 90 ? 'LMS' : 'SMS'; */
        vm.data.CmpgnChannel = vm.data.CmpgnChannel;
        vm.messageMaxLength = vm.data.CmpgnChannel == 'LMS' ? '2000' : '90';
        vm.messageLength = bytes; 
        if (flag == false) {
          if (vm.messageMaxLength == '90' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            vm.data.CmpgnChannel = 'SMS';
            vm.data.CmpgnChannel = 'SMS';
            vm.messageMaxLength = '90';
          } else if (vm.messageMaxLength == '2000' && (isNullOrEmpty(vm.data.CmpgnChannel) || vm.data.CmpgnChannel == 'SMS')) {
            flag = true;
            vm.data.CmpgnChannel = 'LMS';
            vm.data.CmpgnChannel = 'LMS';
            vm.messageMaxLength = '2000';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return flag;
          }
        }
      };

      vm.chkSendType = function (type) {
        if (type == 'SMS' || type =='') {
          vm.data.CmpgnChannel = 'SMS';
          vm.data.CmpgnChannel = 'SMS';
          vm.messageMaxLength = '90';
          if (Number(vm.messageLength) > 90) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('SMS(단문)의 최대 90 bytes를 초과하여 MMS(장문)으로 전환됩니다.');
            return;
          } 

          if (!isNullOrEmpty(vm.data.SendTitle)) {
            vm.data.CmpgnChannel = 'LMS';
            gAlert('메세지 제목을 확인해 주세요.');
          }
          flag = false;
        } else if (type == 'LMS') {
          flag = true;
          vm.data.CmpgnChannel = 'LMS';
          vm.data.CmpgnChannel = 'LMS';
          vm.messageMaxLength = '2000';
        }
        vm.UsedPoint();
      };

      /**
       * 메세지 글 자르기
       * @param
       * @return
       */
      function fnCutMsg(str, length) {
        var ret = '';
        var i;
        var msglen = 0;

        for (i = 0; i < str.length; i++) {
          var ch = str.charAt(i);

          if (escape(ch).length > 4) {
            msglen += 2;
          } else {
            msglen++;
          }
          if (msglen > length) break;
          ret += ch;
        }
        return ret;
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }
      
      function ok() {
        if (getIsValidData()) {
          gConfirm('', '메세지를 전송하시겠습니까?', {
            btn: '',
            fn: function () {
              sendSmsMessage();
            }
          }, {
            btn: '',
            fn: function () {
              //cancel();
            }
          });
        }else{
          return false;
        }
      }
      
      /**
       * 광고문구 추가
       */
      function chkADTxt() {
        if(vm.addADTxtYN == 'Y'){
          vm.data.SendTitle = vm.addADTxt + vm.data.SendTitle;
          vm.data.SendMessage = vm.addADTxt + vm.data.SendMessage;
        }else{
          vm.data.SendTitle = vm.data.SendTitle.replaceAll(vm.addADTxt, '');
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addADTxt, '');
        }
        
        chkSendMessage();
      }
      
      
      function chkDenyTxt() {
        if(vm.data.SendMessage == undefined){
          vm.data.SendMessage = '';
        }
        
        if(vm.addDenyTxtYN == 'Y'){
          vm.data.SendMessage = vm.data.SendMessage + vm.addDenyTxt;
        }else{
          vm.data.SendMessage = vm.data.SendMessage.replaceAll(vm.addDenyTxt, '');
        }
        
        chkSendMessage();
      }
      
      /**
       * Tenant정보 조회
       */
      function getTenantInfo(){
        var data = {
           TenantId : $window.sessionStorage["loginTenantId"]
          ,mapCode : vm.TENANT_INFO_SQL
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.tenantInfo = result.body.docs[0];
              vm.addDenyTxt += vm.tenantInfo.SMSDenyNum;
            } else {
              vm.tenantInfo = {};
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getTenantInfo()");
          console.table(error);
        });
      }

    } ]);

webapp.controller('SrchCustModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'gAlert', 'gConfirm', 'postApi', '$rootScope', 'modalFactory',
    function SrchCustModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, gAlert, gConfirm, postApi, $rootScope, modalFactory) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.columnMap = {};
     
      vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
      vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign.srchcustomer'; // 그룹고객 작업 테이블명
      var LIST_SQL = 'Campaign2.getSrchCustomerList';
      var LIST_CNT_SQL = 'Campaign2.getSrchCustomerListCnt';
      var ADD_GRPCUST_SQL = 'Campaign2.insertGroupcustomer';
      var ADD_ALL_GRPCUST_SQL = 'Campaign2.insertGroupcustomerSrchAll';

      var MEMBERSHIP_LIST_SQL = 'MembershipPayment.getMmgmembershippaymentCodeList';
      var USER_LIST_SQL = 'User.getSelectCodeUsers';
  
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        userkey : '',
        tableNm : KEY_TABLE_NM,
      };
  
      vm.currentPage = vm.srch.page;

      (function SrchCustModalCtrl() {
        vm.GrpId = toModalData.GrpId;

        vm.mcl = [];
        vm.manageList = [];

        getList();
        getMembershipList();
        getUserList();
        setInitData();
      })();


      function getList() {
        vm.dataloader = true; // Progressbar 표시
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        data.GrpId = vm.GrpId;

        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      function getListCnt() {
        var data = angular.copy(vm.srch); // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL;
        data.GrpId = vm.GrpId;

        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.totalItems = result.body.docs[0];
          }
        });
      }

    /**
     * 그룹고객 목록 화면 구성
     *
     * @param
     * @return
     */
    function setResponsive() {
      var columns = [];
      var o = {};

      o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
      o.type = [];
      o.style = [];

      var index = 0;
      angular.forEach(vm.listColumns, function (item) {
        var column = {};

        column.name = item.ColumnPhysicalNm; // 물리 컬럼명
        column.title = item.ColumnLogicalNm; // 논리 컬럼명

        if (o.breakpoints[index] != "") {
          column.breakpoints = setBreakPoint(o.breakpoints[index]);
        }

        if (item.ColumnPhysicalDataType == "40") {
          // 날짜형 데이터 처리
          column.type = "date";
          column.formatString = "YYYY-MM-DD";
        }

        index++;
        columns.push(column);
      });
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel data');
    }

    function ok(item) {
      $uibModalInstance.close(item);
    }
    
    /**
     * 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function pageChanged() {
      vm.srch.page = vm.currentPage;
      getList();
    }

    /* 사용자검색 */
    function srchUserModal() {

      var ctrl = 'UserModalCtrl as modalCtrl';
      var paramData = { srchTenantId : $rootScope.gVariable.srchTenantId };

      var modalInstance = modalFactory.open('lg', 'components/modal/users/user-modal.html', ctrl, paramData);
      modalInstance.result.then(function(res) {
        vm.srch.ManagerNm = res.UserNm;
        vm.srch.ManagerId = res.UserId;
      }, function(cancelData) {
        //
      });
    }
    
    /* 사용자검색- 지우기 */
    function eraseUser() {
      vm.srch.ManagerNm = '';
      vm.srch.ManagerId = '';
    }

    /**
     * 초기 데이터 설정
     * @param
     * @return
     */
    function setInitData() {
      // 목록 체크박스 로직 설정
      vm.chkHead = false;
      $scope.chkRowChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          if (!vm.lists[i].isChecked) {
            vm.chkHead = false;
            return;
          }
        }
        vm.chkHead = true;
      };

      $scope.chkHeadChg = function () {
        for (var i = 0; i < vm.lists.length; i++) {
          vm.lists[i].chkRow = vm.chkHead;
        }
      };

    }

      /**
     * 그룹고객 정렬 컬럼 설정
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @param {string} isSortable - 정렬가능 여부
     * @return
     */
    function setSortColumn(sortColumn, isSortable) {

      // 정렬이 불가한 컬럼은 미 반영
      if (isSortable == 'N') return;

      // 정렬순서(오름차순, 내림차순) 설정
      if (vm.srch.sortColumn != sortColumn) {
        vm.srch.sortDirect = "ASC";
      } else {
        vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
      }

      vm.srch.sortColumn = sortColumn;

      // 조회
      //getSearch();
      getList();
    }

    /**
     * 그룹고객 정렬 컬럼 설정에 따른 Grid header Icon 표시
     *
     * @param {string} sortColumn  - 정렬 컬럼명
     * @return
     */
    function setSortDirect(sortColumn) {
      // 정렬이 되지 않은 컬럼 표시
      if (sortColumn != vm.srch.sortColumn) {
        return 'fa fa-sort';
      }

      var rtnval = '';

      // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
      if (vm.srch.sortDirect == 'ASC') {
        rtnval = 'fa fa-caret-down';
      } else {
        rtnval = 'fa fa-caret-up';
      }
      return rtnval;
    }

    /**
     * 그룹고객 페이지 변경시 데이터 조회
     * @param
     * @return
     */
    function setPageChanged() {
      vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

      // 검색 옵션
      //var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
      // 해당 페이지 데이터 조회
      //$state.go(LIST_PAGE_URL, {srch: srch}, {reload: LIST_PAGE_URL});

      getList();
    }

    /**
     * 그룹고객 목록 당 조회 건수 변경
     * @param
     * @return
     */
    function setChangeViewSize() {
      vm.currentPage = 1; // 1페이지 부터 조회
      vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

      // 데이터 조회
      //getSearch();
      getList();
    }
    
    
    function addGrpcust(_type) {
      var data = angular.copy(vm.srch);

      data.GrpId = vm.GrpId;
      data.srchTenantId = $rootScope.gVariable.srchTenantId; 
      console.log('type', _type == 'ALL');
      if(_type == 'ALL'){
        data.mapCode = ADD_ALL_GRPCUST_SQL;
      }else{
        data.mapCode = ADD_GRPCUST_SQL;
        data.lists = [];
        for (var i = 0; i < vm.lists.length; i++) {
          if (vm.lists[i].chkRow) {
            data.lists.push(vm.lists[i].KeyId);
          }
        }
      }

      postApi.update(data, function (result) {
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          gAlert('', 'Menu.SAVED', {
            btn : '',
            fn : function() {
              ok();
            }
          });
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> addGrpcust()");
        console.table(error);
      });
    }
    /* var list = [];
    function getMembershipList() {
      var data = vm.srch;
      data.mapCode = MEMBERSHIP_LIST_SQL;
      
      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            list = result.body.docs;
            angular.forEach(list , function (item){
              row = {};
              row.CodeValue = item.CodeValue;

              vm.mcl.push(row);
            });
            console.log('vm.mcl', vm.mcl);
          } 
        } else {
          console.error("Error> getData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }
      }, function (error) {
        console.error("Error> getData()");
        console.table(error);
      });
    } */
    
    function getMembershipList() {
      vm.mcl = [];
      var data = vm.srch;
      data.mapCode = MEMBERSHIP_LIST_SQL;
      
      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            angular.forEach(result.body.docs , function (item){
              vm.mcl.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
            });
          } 
        } else {
          console.error("Error> getData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }
      }, function (error) {
        console.error("Error> getData()");
        console.table(error);
      });
    }

    function getUserList() {
      vm.manageList = [];
      var data = vm.srch;
      data.mapCode = USER_LIST_SQL;
      
      postApi.select(data, function (result) {
        if (result.header.status == CONSTANT.HttpStatus.OK) {
          // 데이터 조회 성공
          if (result.body.docs.length > 0) {
            // 조회 데이터 설정
            angular.forEach(result.body.docs , function (item){
              vm.manageList.push({'Code' : item.Code, 'CodeValue' : item.CodeValue});
            });
          } 
        } else {
          console.error("Error> getData()");

          if (!isNullOrEmpty(result.body.docs)) {
            gAlert('', result.body.docs[0].errMessage);
          }
        }
      }, function (error) {
        console.error("Error> getData()");
        console.table(error);
      });
    }

    function setResetSearch() {
      vm.srch = '';
      vm.srch = {
        page: 1, // 현재 조회 페이지 번호
        viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
        userkey : '',
        tableNm : KEY_TABLE_NM,
      };
      getList();
    }

    vm.pageChanged = pageChanged;
    vm.srchUserModal = srchUserModal;
    vm.eraseUser = eraseUser;
    vm.setSortColumn = setSortColumn;           // 정렬 설정
    vm.setSortDirect = setSortDirect;           // 정렬 설정에 따른 Grid header Icon 표시
    vm.setPageChanged = setPageChanged;
    vm.setChangeViewSize = setChangeViewSize;
    vm.addGrpcust = addGrpcust;

    vm.getMembershipList = getMembershipList;
    vm.getUserList = getUserList;

    vm.setResetSearch = setResetSearch;
  } ]);

webapp.controller('SrchCustModal2Ctrl', ['$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$rootScope', 'modalFactory', '$mdUtil', '$stateParams','$http', 'gAlert', 'gConfirm',
    function SrchCustModal2Ctrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, $rootScope, modalFactory, $mdUtil,$stateParams,$http, gAlert, gConfirm) {
      var vm = this;
      vm.dataloader = false;
      vm.srch = {};
      vm.maxGrpId = 0;
      vm.lists = [];
      vm.saveYn = true;
      vm.data = {
        'GrpId': (toModalData.GrpId == undefined ? '' : toModalData.GrpId)
        ,'GrpCustList' : (toModalData.GrpCustList == undefined ? [] : toModalData.GrpCustList)
      };

      vm.grpcustLists = vm.data.GrpCustList;
      vm.totalItems = vm.grpcustLists.length;

      var o = {
          breakpoints : ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]
         ,type : []
         ,style : []
       }

       var columns = [{name: "CustNm", title: "회원명"},{name: "Mobile", title: "핸드폰"},{name: "Email", title: "이메일"}];
       vm.grpcustListColumns = [{ColumnPhysicalNm: "CustNm", ColumnLogicalNm: "회원명"},{ColumnPhysicalNm: "Mobile", ColumnLogicalNm: "핸드폰"},{ColumnPhysicalNm: "Email", ColumnLogicalNm: "이메일"}];

       vm.viewSize = CONSTANT.PAGINATION.VIEWSIZE; // 페이지당 조회건수
       vm.maxSize = CONSTANT.PAGINATION.MAXSIZE;   // 최대 조회건수

      $scope.toggleLeft = buildToggler('left');
      $scope.toggleRight = buildToggler('right');

      // 함수 선언
      vm.resetList = resetList;
      vm.deleteGrpcust = deleteGrpcust;

      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.cancel = cancel;
      vm.ok = ok;

      // --------------------------------------------------------- 그룹고객 관련 소스 ---------------------------------------------------------
      // 관련 테이블 정의
      var EXCEL_TITLE = '그룹고객목록'; // 그룹고객 엑셀파일 이름
      var EXCEL_FORM_TITLE = '일괄업로드 양식';

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: 10, // 페이지당 조회건수
          sortDirect: 'DESC',     // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'CustNm' // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.currentPage = 1;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      vm.anchor = "";
      angular.copy(vm.srch, vm.srchList);

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      /**
       * TODO : 전제 목록을 넘겨줘야. 삭제된것을 처리할수 있다.
       */
      function ok() {
        var chkList = [];
        angular.forEach(vm.viewList, function(item){
          if (item.chkRow) {
            chkList.push(item);
          }
        });
        //if(chkList.length > 0) gAlert('', '체크한 대상자에게만 발송됩니다.');

        $uibModalInstance.close({
          'list' : vm.grpcustLists,
          //'chkList' : chkList
        });
      }


      /**
       * 고객 삭제
       *
       * @param
       * @return
       */
      function deleteGrpcust(type) {
        gConfirm('', '발송 대상에서 제외하시겠습니까?', {
          btn : '',
          fn : function() {
            deleteGrpcustAction(type);
          }
        }, {
          btn : '',
          fn : function() {
            //ignore
          }
        });
      }

      /**
       * 고객 삭제 처리
       */
      function deleteGrpcustAction(type) {
        //삭제데이터
        vm.delData = [];

        if (type == "") {
          angular.forEach(vm.viewList, function(item){
            if (item.chkRow) {
              vm.delData.push(item);
            }
          });

          angular.forEach(vm.delData, function(item){
            vm.grpcustLists.splice(vm.grpcustLists.indexOf(item),1);
          });

        } else if (type == "ALL") {
          vm.grpcustLists = [];
        }

        setChangeViewSize();
      }

      /**
       * 그룹고객 목록 화면 구성
       *
       * 전체 / 대상자
       * if(!(item.RespStatus == "R" || item.RespStatus == "D")){
       *
       * @param
       * @return
       */
      function getGrpcustList() {
        vm.totalItems = vm.grpcustLists.length;

        var startNum = ((vm.currentPage - 1) * vm.viewSize);
        var endNum = (vm.currentPage * vm.viewSize);

        vm.viewList = [];
        for(var i = 0; i < vm.grpcustLists.length; i++){
          if(i >= startNum && i < endNum){
            vm.viewList.push(vm.grpcustLists[i]);
          }
        }

      }

      /**
       * 그룹고객 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        getGrpcustList();
      }

      /**
       * 그룹고객 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.chkHead = false;
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize =  CONSTANT.PAGINATION.VIEWSIZE; // 목록 당 조회 건수

        // 데이터 조회
        getGrpcustList();
      }

      /**
       * Build handler to open/close a SideNav; when animation finishes
       * report completion in console
       */
      function buildToggler(navID) {
        var debounceFn = $mdUtil.debounce(function() {
          $mdSidenav(navID).toggle().then(function() {
            console.debug("toggle " + navID + " is done");
          });
        }, 200);
        return debounceFn;
      }

      $scope.init = function() {
        // check if there is query in url
        // and fire search in case its value is not empty
      };

      // stops the interval
      $scope.$on("$destroy", function() {
      });

      $scope.$on('broadcastSetChangeTenantID', function(event, data) {
        resetList();

        $rootScope.showSimpleToast($translate.instant('MSG.LISTUPDATED'));
      });

      // 목록 체크박스 로직 설정
      vm.chkHead = false;
      $scope.chkRowChg = function () {
        for (var i = 0; i < vm.viewList.length; i++) {
          if (!vm.viewList[i].isChecked) {
            vm.chkHead = false;
            return;
          }
        }
        vm.chkHead = true;
      };

      $scope.chkHeadChg = function () {
        for (var i = 0; i < vm.viewList.length; i++) {
          vm.viewList[i].chkRow = vm.chkHead;
        }
      };

      function resetList() {
        getTreeList();
      }

      /**
       * 고객추가
       *
       * @param {string}
       * @return {boolean}
       */
      vm.GroupCustEditModal = function (_idx) {
        vm.editIdx = null;
        var ctrl;
        var paramData = {};
        var modalInstance;

        if (_idx != undefined){
          vm.editIdx = _idx;
          paramData = angular.copy(vm.viewList[vm.editIdx]);
        }
        paramData.SendType = vm.data.SendType;
       
        ctrl = 'GroupEditModalCtrl as vc';
        modalInstance = modalFactory.open("md", "components/modal/message/group-edit-modal.html", ctrl, paramData);
        
        modalInstance.result.then(
          function (okData) {
            if (okData) {
              if (vm.editIdx != undefined) {
                vm.viewList[vm.editIdx] = okData;
                vm.grpcustLists[((vm.currentPage - 1) * vm.viewSize) + vm.editIdx] = okData;
              } else {
                vm.grpcustLists.unshift(okData);
                getGrpcustList();
              }
            }
          },
          function (cancelData) {
            //ignore
          }
        );
      };
      getGrpcustList();
    } ]);

webapp.controller('SrchCustModal3Ctrl', ['$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$rootScope', 'modalFactory', '$mdUtil', '$stateParams','$http', 'gAlert', 'gConfirm',
    function SrchCustModal3Ctrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, $rootScope, modalFactory, $mdUtil,$stateParams,$http, gAlert, gConfirm) {
      var vm = this;
      vm.dataloader = false;

      var LIST_SQL = 'Campaign2.getCampaignCustomers';
      var LIST_CNT_SQL = 'Campaign2.getCampaignCustomersCnt';

      //var columns = [{name: "CustNm", title: "회원명"},{name: "CustCode", title: "회원코드"}, {name: "Mobile", title: "핸드폰"},{name: "Email", title: "이메일"}];
      //vm.grpcustListColumns = [{ColumnPhysicalNm: "CustNm", ColumnLogicalNm: "회원명"},{ColumnPhysicalNm: "CustCode", ColumnLogicalNm: "회원코드"}, {ColumnPhysicalNm: "Mobile", ColumnLogicalNm: "핸드폰"},{ColumnPhysicalNm: "Email", ColumnLogicalNm: "이메일"}];


      // 함수 선언
      vm.setPageChanged = setPageChanged;         // 페이지 변경시 데이터 조회
      vm.setChangeViewSize = setChangeViewSize;   // 목록 당 조회 건수 변경
      vm.cancel = cancel;

      // --------------------------------------------------------- 그룹고객 관련 소스 ---------------------------------------------------------
      // 관련 테이블 정의
      var KEY_TABLE_NM = 'campaign.customer.modal'; // 작업 테이블명
      var KEY_COLUMN_NM = 'CmpgnCustId'; // Primary Key Column

      // 검색 옵션 설정
      if (!$stateParams.srch) {
        vm.srch = {
          page: 1, // 현재 조회 페이지 번호
          viewSize: !isNullOrEmpty(CONSTANT.PAGINATION.VIEWSIZE) ? CONSTANT.PAGINATION.VIEWSIZE : 10, // 페이지당 조회건수
          tableNm: KEY_TABLE_NM,  // 작업 테이블명
          sortDirect: 'DESC',     // 정렬순서 (ASC:오름차순, DESC:내림차순)
          sortColumn: 'CustNm' // 정렬컬럼명
        };
      } else {
        vm.srch = JSON.parse(decodeURIComponent($stateParams.srch));
      }

      vm.currentPage = 1;
      vm.listSize = CONSTANT.PAGINATION.LISTSIZE; // 목록당 표시건수

      // 검색 조건 표시용 컬럼 목록
      vm.srchList = {};
      vm.columnMap = {};
      vm.anchor = "";
      angular.copy(vm.srch, vm.srchList);

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      /**
       * 그룹고객 목록 화면 구성
       *
       * 전체 / 대상자
       * if(!(item.RespStatus == "R" || item.RespStatus == "D")){
       *
       * @param
       * @return
       */
      /* function getGrpcustList() {
        vm.totalItems = vm.grpcustLists.length;

        var startNum = ((vm.currentPage - 1) * vm.viewSize);
        var endNum = (vm.currentPage * vm.viewSize);

        vm.viewList = [];
        for(var i = 0; i < vm.grpcustLists.length; i++){
          if(i >= startNum && i < endNum){
            vm.viewList.push(vm.grpcustLists[i]);
          }
        }
      } */

      /**
       * 목록 건수 조회
       *
       * @param
       * @return
       */
      function getListCnt() {

        var data = vm.srch; // 검색 옵션 설정
        data.mapCode = LIST_CNT_SQL; // 목록 건수 조회 SQL Mapper ID        
        data.keyId = toModalData.keyId;
        if (toModalData.ResultCode == 'Etc') {
          data.ResultCodeEtc = toModalData.ResultCode;
        } else {
          data.ResultCode = toModalData.ResultCode;
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              // 총 목록 건수 설정
              vm.totalItems = result.body.docs[0];
            } else {
              // 조회 실패
              vm.totalItems = 0;
            }
          }
        }, function (error) {
          // 조회 중 오류 발생
          console.error("Error> getListCnt()");
          console.table(error);
        });
      }

      /**
       * 목록 조회
       *
       * @param
       * @return
       */
      function getList() {
        vm.viewSize = vm.srch.viewSize; // 목록당 조회건수 설정

        getListCnt(); // 목록 건수 조회

        var data = vm.srch; // 검색 옵션 설정
        data.selectType = 'List'; // 사용자정의 컬럼의 조회 유형 설정
        data.mapCode = LIST_SQL;
        data.keyId = toModalData.keyId;
        if (toModalData.ResultCode == 'Etc') {
          data.ResultCodeEtc = toModalData.ResultCode;
        } else {
          data.ResultCode = toModalData.ResultCode;
        }
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            // MetaColumn 사용
            if (result.body.desc.length > 0) {
              // MetaColumn 정보를 이용하여 표시할 목록 정보 설정
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            } else {
              console.error('Error> getList()> MetaColumn 정보 조회 오류');
              console.table(data);
            }

            if (result.body.docs.length > 0 && !isNullOrEmpty(vm.listColumns)) {
              // 목록 데이터 표시
              vm.lists = result.body.docs;
              // 목록 화면 구성
              setResponsive();
            } else {
              // 데이터 조회 실패
              vm.lists = {};
            }
          }

          vm.dataloader = false; // Progressbar 숨김

        }, function (error) {
          vm.dataloader = false; // Progressbar 숨김

          // 조회 중 오류 발생
          console.error("Error> getList()");
          console.table(error);

        });
      }

      /**
       * 목록 화면 구성
       *
       * @param
       * @return
       */
      function setResponsive() {
        var columns = [];
        var o = {};

        o.breakpoints = ["", "md", "lg", "md", "xs", "lg", "xs", "md", "lg"]; // Bootstrap 컬럼 css
        o.type = [];
        o.style = [];

        var index = 0;
        angular.forEach(vm.listColumns, function (item) {
          var column = {};

          column.name = item.ColumnPhysicalNm; // 물리 컬럼명
          column.title = item.ColumnLogicalNm; // 논리 컬럼명

          if (o.breakpoints[index] != "") {
            column.breakpoints = setBreakPoint(o.breakpoints[index]);
          }

          if (item.ColumnPhysicalDataType == "40") {
            // 날짜형 데이터 처리
            column.type = "date";
            column.formatString = "YYYY-MM-DD";
          }

          index++;
          columns.push(column);
        });
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function setPageChanged() {
        vm.srch.page = vm.currentPage; // 조회 할 페이지 번호

        // 검색 옵션
        var srch = encodeURIComponent(JSON.stringify(vm.srch, replacer));
        // 해당 페이지 데이터 조회
        //$state.go($state.current.name, {srch: srch}, {reload: $state.current.name});
        getList();
      }

      /**
       * 목록 당 조회 건수 변경
       * @param
       * @return
       */
      function setChangeViewSize() {
        vm.currentPage = 1; // 1페이지 부터 조회
        vm.viewSize = vm.srch.viewSize; // 목록 당 조회 건수

        // 데이터 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @param {string} isSortable - 정렬가능 여부
       * @return
       */
      function setSortColumn(sortColumn, isSortable) {

        // 정렬이 불가한 컬럼은 미 반영
        if (isSortable == 'N') return;

        // 정렬순서(오름차순, 내림차순) 설정
        if (vm.srch.sortColumn != sortColumn) {
          vm.srch.sortDirect = "ASC";
        } else {
          vm.srch.sortDirect = (vm.srch.sortDirect == "ASC" ? "DESC" : "ASC");
        }

        vm.srch.sortColumn = sortColumn;

        // 조회
        getList();
      }

      /**
       * 정렬 컬럼 설정에 따른 Grid header Icon 표시
       *
       * @param {string} sortColumn  - 정렬 컬럼명
       * @return
       */
      function setSortDirect(sortColumn) {
        // 정렬이 되지 않은 컬럼 표시
        if (sortColumn != vm.srch.sortColumn) {
          return 'fa fa-sort';
        }

        var rtnval = '';

        // 정렬순서(오름차순, 내림차순)에 따른 Icon 표시
        if (vm.srch.sortDirect == 'ASC') {
          rtnval = 'fa fa-caret-down';
        } else {
          rtnval = 'fa fa-caret-up';
        }
        return rtnval;
      }
      vm.getList = getList;
      vm.setSortColumn = setSortColumn;
      vm.setSortDirect = setSortDirect;

      getList();
    } ]);

webapp.controller('TreeModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', 'gConfirm', '$translate', '$timeout',
    function TreeModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, gConfirm, $translate, $timeout ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.columnMap = {};
      var tree;
      $scope.my_tree = tree = {};
      vm.srch = {};
      (function TreeModalCtrl() {
        vm.getRequestParams = getRequestParams;
        getTreeList();
      })();

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          formType: toModalData.formType,
        }
        vm.filter = req;
        return req;
      }

      function getTreeList() {
        // 사전에 트리 선언함.(중요포인트)
        vm.dataloader = true;
        $scope.my_data = [];

        // 로케이션관리 select 검색실행함
        var data = vm.srch;

        data.mapCode = 'Campaign.getGroupList';
        postApi.select(data, function(result) {
          vm.dataloader = false;

          if (result.header.status == CONSTANT.HttpStatus.OK) {

            if (result.body.docs.length == 0) {
              return;
            }

            // select한 datatable 바인딩
            vm.lists = result.body.docs;

            vm.topItem = result.body.docs[0];

            refreshTree();

            // 트리 펼치기
            $timeout(function() {
              return tree.expand_init();
            }, 1);

          }
        }, function(error) {
          vm.dataloader = false;
          console.error('fail', status, data);
        });
      }

      function refreshTree() {

        // 리스트 생성
        var arrlist = [];

        // for문으로 다시 json 구조로 변환함.
        angular.forEach(vm.lists, function(item) {
          // 객체 생성
          var data = {};

          data.label = $translate.instant(item.GrpNm);
          data.guid = item.GrpId;
          data.parent = item.ParentGrpId == undefined || item.ParentGrpId == 0 ? null : item.ParentGrpId;
          data.classes = [];
          //data.classes.push(item.TenantId == '0' ? '' : 'color-red');

          // 리스트에 생성된 객체 삽입
          arrlist.push(data);

          if (item.GrpId > vm.maxGrpId)
            vm.maxGrpId = item.GrpId;
        });

        // 계층형 json 구조로 변환함
        var recursiveArray = unflatten(arrlist);

        // guid, parent 제외 변환함
        traverse(recursiveArray);

        // 트리구조에 바인딩
        $scope.my_data = recursiveArray;

        // 트리 펼치기
  //        $timeout(function() {
  //          return tree.expand_all();
  //        }, 1);

      }

      // 계층형 json 구조로 변환
      function unflatten(items) {
        // 다시 설정(배치)하는 부분
        return items.reduce(insert, {
          res : [],
          map : {}
        }).res;
      }

    // 계층형 json 부모/자식 구분하여 구조 변환
    function insert(obj, item) {
      var parent = item.parent; // 부모값
      var map = obj.map;
      map[item.guid] = item; // 아이템 구성함

      if (parent === null)
        obj.res.push(item); // 부모값 생성
      else {
        var parentItem = map[parent];
        // 자식값 생성
        if (parentItem != null) {
          if (parentItem.hasOwnProperty("children"))
            parentItem.children.push(item);
          else
            parentItem.children = [ item ];
        }
      }

      return obj;
    }

    // guid, parent 제외한 계층형 json 구조 변환하기
    function traverse(jsonObj) {

      for (var i = 0; i < jsonObj.length; i++) {
        if (jsonObj[i].children == null) {
        } else {
          traverse(jsonObj[i].children);
        }

        // label, children 만 추가함
        var newItem = {
          "label" : jsonObj[i].label,
          "data" : jsonObj[i].guid,
          "children" : jsonObj[i].children,
          "classes" : jsonObj[i].classes,
        }
        jsonObj[i] = newItem;
      }
    }



      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        var branch = tree.get_selected_branch();

        var data = {GrpNm : branch.label, GrpId : branch.data};
        $uibModalInstance.close(data);
      }

    } ]);

webapp.controller('TenantModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', '$state',
    function TenantModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi, $state) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;

      vm.srch = {
		    TenantNm : '',
        TenantId : '',
        viewSize : 10,
        Ceo :'',
      };

      vm.selectedTenantId = toModalData.TenantId;
      if (toModalData.showBaseTenant == undefined || toModalData.showBaseTenant == null) {
        vm.showBaseTenant = 'Y';
      } else if(toModalData.showBaseTenant != undefined && toModalData.showBaseTenant != '') {
        if(!toModalData.showBaseTenant) vm.showBaseTenant = 'N';
        else vm.showBaseTenant = 'Y';
      } else if (!toModalData.showBaseTenant) {
        vm.showBaseTenant = 'N';
      } else {
        vm.showBaseTenant = 'Y';
      }

      (function TenantModalCtrl() {
        getList();
      })();
      function getList() {

        var data = {
          mapCode: 'Tenant.getTenantSrch',
          TenantNm : vm.srch.TenantNm,
          Ceo : vm.srch.Ceo,
          userkey : '',
          showBaseTenant : vm.showBaseTenant,
          page : vm.srch.page,
        };

        if($window.sessionStorage['loginTenantId']!= null && $window.sessionStorage['loginTenantId'] != "" && $window.sessionStorage['loginTenantId'] != undefined){

          getCnt(true);

          data.mapCode= 'Tenant.getTenantSrch';
          postApi.select(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;

              var resList = [];
              var res = '';

              if (vm.tenantlists != null) {
                angular.forEach(vm.tenantlists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {
                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr1 = resList[0] + " " + resList[1];
                   }
                });
              }
            }
          });
        } else if($window.sessionStorage['loginTenantId'] == null || $window.sessionStorage['loginTenantId'] == "" &&  $window.sessionStorage['loginTenantId'] == undefined) {

          getCnt(false);

          data.showBaseTenant = vm.showBaseTenant;
          data.mapCode= 'getTenantId';
          postApi.login(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.tenantlists = result.body.docs;

              console.log('d',vm.tenantlists);

              var resList = [];
              var res = '';

              if (vm.tenantlists != null) {
                angular.forEach(vm.tenantlists, function (item) {
                   resList = [];
                   if (item.Addr1 != undefined && !isNullOrEmpty(item.Addr1)) {
                    res = item.Addr1;
                    resList = res.split(" ");
                    item.Addr1 = resList[0] + " " + resList[1];
                   }
                });
              }
            }
          });
        }


      }

      function getCnt(checkSession) {
        var data = {
          mapCode: 'Tenant.getTenantSrchCnt',
          TenantNm : vm.srch.TenantNm,
          Ceo : vm.srch.Ceo,
          userkey : '',
          showBaseTenant : vm.showBaseTenant
        };

        if(checkSession) {
          data.mapCode= 'Tenant.getTenantSrchCnt';
          postApi.select(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.totalItems = result.body.docs[0].totalItems;
            }
          });
        } else {
          data.mapCode= 'getTenantSrchCnt';
          postApi.login(data, function (result) {
            if(result.header.status == CONSTANT.HttpStatus.OK) {
              vm.totalItems = result.body.docs[0].totalItems;
            }
          });
        }
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
        /*var p = '';
        $state.go('app.dashboard', p, {reload: 'app.dashboard'});*/
      }

      /**
       * 페이지 변경시 데이터 조회
       * @param
       * @return
       */
      function pageChanged() {
        vm.srch.page = vm.currentPage;
        getList();

      }

      vm.pageChanged = pageChanged;
    } ]);

webapp.controller('Tenant2ModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi',
    function Tenant2ModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, postApi) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.currentPage = 1;
      vm.maxSize = 10;


      vm.srch = {
		    TenantNm : '',
        TenantId : toModalData.TenantId,
        viewSize : 10
		  };

      (function TenantModalCtrl() {
        getList();
      })();


      function getList() {
        var data = {
          mapCode: 'Tenant.getTenantSrch', TenantNm : vm.srch.TenantNm, TenantId : toModalData.TenantId
        };
        postApi.select(data, function (result) {
          if(result.header.status == CONSTANT.HttpStatus.OK) {
            vm.tenantlists = result.body.docs;
            vm.totalItems = result.body.docCnt;

          }
        });
      }


      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(item) {
        $uibModalInstance.close(item);
      }
    } ]);

webapp.controller('MyPageModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi', 'gAlert', '$rootScope', '$timeout',
    function MyPageModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi, gAlert, $rootScope, $timeout ) {
      var vm = this;
      vm.etcList = [];
      vm.interestList = [];
      vm.srchDetail = {};
      vm.columnMap = {};
      vm.prevMobile = "";
      vm.prevEmail = "";

      // function
      vm.setData = setData;
      vm.getData = getData;
      vm.chkMobileEmailDup = chkMobileEmailDup;
      vm.cancel = cancel;
      vm.ok = ok;

      // SQL 
      var VIEW_SQL =                 'User.getUserMgrDetail';                 // 사용자 정보 조회 SQL
      var UPDATE_SQL =               'User.updateMyPage';                     // 사용자 정보 수정 SQL
      var CHK_MOB_EMAIL_SQL =        'User.checkDupBizNoMobileEmailCnt';      // 담당자 휴대폰 번호 및 이메일 중복체크 SQL
      
      // 관련 테이블 정의
      var KEY_TABLE_NM = 'Users';  // 작업 테이블명
      var KEY_COLUMN_NM = 'KeyId'; // Primary Key Column

      // 조회 데이터 설정
      vm.keyId = toModalData.UserId;
      vm.TenantId = toModalData.TenantId;
      vm.srchDetail.IdName = KEY_COLUMN_NM; // Primary Key Column
      vm.srchDetail.selectType = "Edit"; // 사용자정의 컬럼 작업 유형 : List(목록), Detail(조회), Edit(등록/수정)
      vm.srchDetail.keyId = vm.keyId;
      vm.srchDetail.tableNm = KEY_TABLE_NM;

      // 등록/수정 표시용 컬럼 목록
      vm.srchDetail.editColumns = {};

      // 조회 데이터
      vm.data = {
        KeyId: vm.keyId,        // Primary Key Data
        tableNm: KEY_TABLE_NM   // 작업 테이블명
      };
      
      //#region getData 데이터 조회
      /**
       * 데이터 조회
       * @param
       * @return
       */
      function getData() {

        vm.srchDetail.viewColumns = {}; // 조회 컬럼

        var data = vm.srchDetail;
        data.mapCode = VIEW_SQL;

        postApi.select(data, function (result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            // 데이터 조회 성공

            if (result.body.desc.length > 0) {
              // 사용자정의 컬럼 설정
              vm.allColumns = result.body.desc;
              angular.forEach(vm.allColumns, function (item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }

            if (result.body.docs.length > 0) {
              // 조회 데이터 설정
              vm.data = result.body.docs[0];
              vm.data.Email3 = vm.data.Email;
              vm.prevMobile = vm.data.Mobile;
              vm.prevEmail = vm.data.Email;
              vm.data.keyId = result.body.docs[0].KeyId != null ? result.body.docs[0].KeyId : '';
            }
          } else {
            console.error("Error> getData()");

            if (!isNullOrEmpty(result.body.docs)) {
              gAlert('', result.body.docs[0].errMessage);
            }
          }

        }, function (error) {
          console.error("Error> getData()");
          console.table(error);
        });
      }
      //#endregion

      //#region setData 데이터 저장
      /**
       * 데이터 저장
       *
       * @param
       * @return
       */
      function setData() {
        // #region 필수항목 체크
        var errMsg = '';

        if (!isNullOrEmpty(vm.data.Password)) {
          if (vm.data.Password.length < 8 || vm.data.Password.length > 14) {
            errMsg = errMsg + '- 암호는 최소 8자 이상 14자 이하로 작성해주세요.<br/>';
            gAlert('', errMsg);
            return false;
          }
        }
        
        if (vm.data.Password != vm.data.Password2)
          errMsg = errMsg + '- 비밀번호가 일치하지 않습니다.<br/>';

        if (!isNullOrEmpty(vm.data.Password)) {
          if (!chkPass())
          errMsg = errMsg + '- 비밀번호 형식을 확인해주세요.<br/>';
        }

        if (isNullOrEmpty(vm.data.Mobile))
          errMsg = errMsg + '- 휴대폰 번호를 입력하십시오.<br/>'; 
        
        if (isNullOrEmpty(vm.data.Email3))
          errMsg = errMsg + '- 이메일을 입력하십시오.<br/>';

        if (!isNullOrEmpty(errMsg)) {
          gAlert('', errMsg);
          return false;
        }
        // #endregion 필수항목 체크

        // 내용
        vm.data.tableNm = KEY_TABLE_NM;             // 작업 테이블명
        vm.data.IdName = KEY_COLUMN_NM;             // Primary Key Column
        vm.data.userkey = $rootScope.gVariable.userkey;       // 사용자 식별 키
        var data = {};
        data = vm.data; // 사용자 입력 데이터
        data.Email = data.Email3;
        
        // 수정
        data.RelateDataId = data.keyId;
        data.mapCode = UPDATE_SQL;

        postApi.update(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (
              result.body.docs[0].KeyId !== null ||
              result.body.docs[0].NewKeyId !== null
            ) {
              // KeyId 조회
              vm.data.keyId = !isNullOrEmpty(result.body.docs[0].NewKeyId) ? result.body.docs[0].NewKeyId : result.body.docs[0].KeyId;
              gAlert("", "Menu.SAVED", {
                btn: "",
                fn: function () {
                  ok();
                }
              });
              return;
            }
          }
        }, function (error) {
          console.error("Error> setData()");
          console.table(error);
        });

      }
      //#endregion

      //#region chkPass 비밀번호 체크
      /**
       * 비밀번호 체크
       *
       * @param
       * @return
       */
      function chkPass() {
        var reg = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*()\-_;:<>,.[\]{\}])[A-Za-z\d!@#$%^&*()\-_;:<>,.[\]{\}]+$/g;
        var birthDay = moment(vm.data.BirthDay).format('MMDD');
        var birthDay2 = moment(vm.data.BirthDay).format('YYMMDD');

        if (!reg.test(vm.data.Password)) return false;
        if (vm.data.Password.indexOf(birthDay) > -1) return false;
        if (vm.data.Password.indexOf(birthDay2) > -1) return false;
        if (vm.data.Password.length < 8) return false;
        if (!isNullOrEmpty(vm.data.keyId)) setMallFW();


        return true;

      }
      //#endregion

      //#region setMallFW 
      /**
       * setMallFW
       *
       * @param
       * @return
       */
      function setMallFW(param) {
        var param = {};
        param.rTenantID = $rootScope.gVariable.srchTenantId;
        param.rUserID = vm.data.KeyId;
        param.rLoginID = vm.data.LoginId;
        param.rShopTentID = vm.data.TenantId;
        param.mapCode = "remoteJfc";
        param.remoteAction = "setChangePw";
        param.rUserPw = vm.data.Password;

        postApi.openApi(param, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
          } else {
          }
        });
      }
      //#endregion
     
      //#region srchZipCodeModal 우편번호 검색 팝업 호출
      /**
      * 우편번호 검색 팝업 호출
      *
      * @param {string}
      * @return {boolean}
      */
       vm.srchZipCodeModal = function() {
        new daum.Postcode({
          oncomplete: function(data) {
            $timeout(function() {
              vm.data.ZipCode = data.zonecode;
              var addr1 = data.buildingName!= "" ? data.address+" "+data.buildingName : data.address ;
              vm.data.Addr1 = addr1;
            }, 0);
          },
        }).open();
      };
      //#endregion

      //#region chkMobileEmailDup 담당자 휴대폰 번호 및 이메일 중복체크
      function chkMobileEmailDup() {
        if (!isNullOrEmpty(vm.data.Mobile) && !isNullOrEmpty(vm.data.Email3)) {
          var data = {};
          data.Mobile = vm.data.Mobile;
          data.Email = vm.data.Email3;
          data.mapCode = CHK_MOB_EMAIL_SQL;
          postApi.select(data, function(result) {
            if (result.header.status === CONSTANT.HttpStatus.OK) {
              var res = ""; 
              if (result.body.docs.length > 0) {
                
                if (result.body.docs[0].DupCnt >0 && vm.prevMobile != vm.data.Mobile) {
                  res += "- 이미 등록된 담당자 휴대폰번호입니다.<br/>";
                } 
                if (result.body.docs[1].DupCnt >0 && vm.prevEmail != vm.data.Email3) {
                  res += "- 이미 등록된 담당자 이메일입니다.<br/>";
                }
              }
              
              if (!isNullOrEmpty(res)) gAlert('', res);
              else setData();
            }
          }, function (error) {
            console.error("Error> chkMobileEmailDup()");
            console.table(error);
          });
        } else {
          gAlert('', "- 담당자 휴대폰번호 및 이메일은 필수입력 항목입니다.<br/>");
        }
      }
      //#endregion
      
      (function MyPageModalCtrl() {
      })();
      
      function ok() {
        $uibModalInstance.close();
      }
      
      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }


      getData();
      
    } ]);

webapp.controller('UserroleModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function UserroleModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi) {
      var vm = this;

      vm.UserRoles = [];
      if (!isNullOrEmpty(toModalData.UserRoles))
        vm.UserRoles = toModalData.UserRoles;

      vm.data = {list:[]};

      vm.cancel = cancel;
      vm.ok = ok;
      vm.getList = getList;
      vm.IsRole = IsRole;
      vm.addRole = addRole;
      vm.querySearch = querySearch;
      vm.onRemoveChip = onRemoveChip;
      vm.filterSelected = true;
      vm.tenantType = $window.sessionStorage['loginTenantType'];

      (function UserroleModalCtrl() {
        // search
        vm.searchValue = '';
        vm.selectPeriod = 'all';
        vm.startDate = '';
        vm.endDate = '';
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        // 검색 선택 옵션
        vm.searchFieldTypeList = [ {
          optionId : 'UserNm',
          optionName : '이름'
        } ];
        vm.searchFieldType = vm.searchFieldTypeList[0].optionId;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.list = [];
        getList();
      })();
      function changeViewSize() {
        getList();
      }
      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          searchFieldType : vm.searchFieldType,
          RoleNm : vm.searchValue,
          selectPeriod : vm.selectPeriod,
          TenantId : toModalData.TenantId
        };
        vm.filter = req;
        return req;
      }

      function getList() {
        getListCnt();

        var data = vm.getRequestParams();
        data.mapCode = 'Role.getRoleList';
        data.RoleType = vm.tenantType;

        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docCnt > 0) {
              vm.data.list = result.body.docs;
            } else {
              vm.totalCount = 0;
            }
          }
        }, function(error) {
          console.error('Error-getList', status, data);
        });
      }

      function getListCnt() {
        var data = vm.getRequestParams();
        data.mapCode = 'Role.getRoleListCnt';
        data.RoleType = vm.tenantType;

        postApi.select(data, function(result) {
          if (result.header.status == CONSTANT.HttpStatus.OK) {
            if (result.body.docCnt > 0) {
              vm.totalCount = result.body.docs[0];
            }
          }
        }, function(error) {
          console.error('Error-getList', status, data);
        });
      }

      function IsRole(role) {

        if(vm.UserRoles != null && vm.UserRoles != undefined && vm.UserRoles != ""){

          for (i = 0; i < vm.UserRoles.length; i++) {
            if (role.RoleId == vm.UserRoles[i].RoleId)
              return true;
          }
        }
        return false;
      }

      function addRole(RoleId) {
        // 이랜드는 역할 하나만 추가 가능
        vm.UserRoles = [];
        for (var i = 0; i < vm.data.list.length; i++) {
          if (vm.data.list[i].RoleId == RoleId) {
            vm.UserRoles.push(vm.data.list[i]);
            break;
          }
        }
      }

      /**
       * Search for contacts.
       */
      function querySearch(query) {
        var results = query ? vm.data.list.filter(createFilterFor(query)) : [];
        return results;
      }
      /**
       * Create filter function for a query string
       */
      function createFilterFor(query) {
        return function filterFn(role) {
          return (role.RoleNm.indexOf(query) != -1);
        };
      }

      function onRemoveChip(item) {
        console.log('item=', item);
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok() {
        $uibModalInstance.close(vm.UserRoles);
      }

    } ]);

webapp.controller('UserModalCtrl', [ '$window', '$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'ModalAPISrv', 'postApi',
    function UserModalCtrl($window, $scope, $uibModalInstance, toModalData, CONSTANT, modalApi, postApi ) {
      var vm = this;
      vm.cancel = cancel;
      vm.ok = ok;
      vm.getUserList = getUserList;
      vm.columnMap = {};
      vm.SrchEntryDtTo = '';
      vm.SrchEntryDtFrom = '';

      vm.MobileYn = toModalData.MobileYn;
      if(toModalData.MobileYn == undefined) vm.MobileYn = false;
      vm.ContactsYN = toModalData.ContactsYN;
      if(toModalData.ContactsYN == undefined) vm.ContactsYN = false;

      (function UserModalCtrl() {
        // pagination
        vm.totalCount = 0;
        vm.currentPageNum = 1;
        vm.viewSizePerPage = CONSTANT.POPUP_PAGINATION.VIEWSIZE;
        vm.maxSize = CONSTANT.POPUP_PAGINATION.MAXSIZE;
        vm.viewSizePerPageList = CONSTANT.POPUP_PAGINATION.OPTION_VIEWSIZE;
        vm.changeViewSize = changeViewSize;
        vm.getRequestParams = getRequestParams;

        vm.UserList = [];
        getUserList();
      })();

      function changeViewSize() {
        getUserList();
      }

      function getRequestParams() {
        var req = {
          page : vm.currentPageNum,
          viewSize : vm.viewSizePerPage,
          LoginId : vm.LoginId != undefined ? vm.LoginId : '',
          UserNm : vm.UserNm != undefined ? vm.UserNm : '',
          WorkStyle : vm.WorkStyle != undefined ? vm.WorkStyle : '',
          WorkStatus : vm.WorkStatus != undefined ? vm.WorkStatus : '',
          UserGrade : vm.UserGrade != undefined ? vm.UserGrade : ''
        }
        vm.filter = req;
        return req;
      }

      function getUserList() {
        getUserListCnt();
        var data = vm.getRequestParams();
        data.selectType = 'List';
        data.tableNm = 'users';
        if (!vm.ContactsYN) {
          data.mapCode = 'User.getUserModalList';
        } else {
          data.mapCode = 'FreeChat.getUserModalList';
        }
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {

            if (result.body.desc.length > 0) {
              vm.listColumns = result.body.desc;
              angular.forEach(vm.listColumns, function(item) {
                vm.columnMap[item.ColumnPhysicalNm] = item;
              });
            }
            if (result.body.docs.length > 0) {
              vm.UserList = result.body.docs;
            } else {
              vm.UserList = {};
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function getUserListCnt() {

        var data = vm.getRequestParams();
        if (!vm.ContactsYN) {
          data.mapCode = 'User.getUserModalListCnt';
        } else {
          data.mapCode = 'FreeChat.getUserModalListCnt';
        }
        postApi.select(data, function(result){
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.totalCount = result.body.docs[0];
            } else {
              vm.totalCount = 0;
            }
          }
          vm.dataloader = false;
        }, function(error) {
          console.error('Error> user-modal-ctrl> getUserList()', status, error);
          vm.dataloader = false;
        });
      }

      function cancel() {
        $uibModalInstance.dismiss('cancel data');
      }

      function ok(User) {
        $uibModalInstance.close(User);
      }

    } ]);

/* 'use strict'; */

/**
 * @ngdoc function
 * @name minovateApp.controller:UiGeneralCtrl
 * @description
 * # UiGeneralCtrl
 * Controller of the minovateApp
 */
webapp
  .controller('GeneralCtrl', function ($scope) {
    $scope.page = {
      title: 'General Elements',
      subtitle: 'Place subtitle here...'
    };
  })

  .controller('ProgressDemoCtrl', function ($scope) {
    $scope.max = 200;

    $scope.random = function() {
      var value = Math.floor((Math.random() * 100) + 1);
      var type;

      if (value < 25) {
        type = 'success';
      } else if (value < 50) {
        type = 'info';
      } else if (value < 75) {
        type = 'warning';
      } else {
        type = 'danger';
      }

      $scope.showWarning = (type === 'danger' || type === 'warning');

      $scope.dynamic = value;
      $scope.type = type;
    };

    $scope.random();

    $scope.randomStacked = function() {
      $scope.stacked = [];
      var types = ['success', 'info', 'warning', 'danger'];

      for (var i = 0, n = Math.floor((Math.random() * 4) + 1); i < n; i++) {
          var index = Math.floor((Math.random() * 4));
          $scope.stacked.push({
            value: Math.floor((Math.random() * 30) + 1),
            type: types[index]
          });
      }
    };

    $scope.randomStacked();
  })

  .controller('RatingDemoCtrl', function ($scope) {
    $scope.rate = 7;
    $scope.max = 10;
    $scope.isReadonly = false;

    $scope.hoveringOver = function(value) {
      $scope.overStar = value;
      $scope.percent = 100 * (value / $scope.max);
    };
  })

  .controller('ButtonsCtrl', function ($scope) {
    $scope.singleModel = 1;

    $scope.radioModel = 'Middle';

    $scope.checkModel = {
      left: false,
      middle: true,
      right: false
    };
  })

  .controller('CarouselDemoCtrl', function ($scope) {
    $scope.myInterval = 5000;
    $scope.noWrapSlides = false;
    var slides = $scope.slides = [];
    $scope.addSlide = function() {
      var newWidth = 801 + slides.length + 1;
      slides.push({
        image: '//placekitten.com/' + newWidth + '/300',
        text: ['More','Extra','Lots of','Surplus'][slides.length % 4] + ' ' +
        ['Cats', 'Kittys', 'Felines', 'Cutes'][slides.length % 4]
      });
    };
    for (var i=0; i<4; i++) {
      $scope.addSlide();
    }
  })

  .controller('TooltipDemoCtrl', function ($scope, $sce) {
    $scope.dynamicTooltip = 'Hello, World!';
    $scope.dynamicTooltipText = 'dynamic';
    $scope.htmlTooltip = $sce.trustAsHtml('I\'ve been made <b>bold</b>!');
  })

  /* jshint ignore:start */
  .controller('TypeaheadCtrl', function($scope, $http) {

    $scope.selected = undefined;
    $scope.states = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Dakota', 'North Carolina', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];

    // Any function returning a promise object can be used to load values asynchronously
    $scope.getLocation = function(val) {
      return $http.get('http://maps.googleapis.com/maps/api/geocode/json', {
        params: {
          address: val,
          sensor: false
        }
      }).then(function(response){
        return response.data.results.map(function(item){
          return item.formatted_address;
        });
      });

    };

    $scope.statesWithFlags = [{'name':'Alabama','flag':'5/5c/Flag_of_Alabama.svg/45px-Flag_of_Alabama.svg.png'},{'name':'Alaska','flag':'e/e6/Flag_of_Alaska.svg/43px-Flag_of_Alaska.svg.png'},{'name':'Arizona','flag':'9/9d/Flag_of_Arizona.svg/45px-Flag_of_Arizona.svg.png'},{'name':'Arkansas','flag':'9/9d/Flag_of_Arkansas.svg/45px-Flag_of_Arkansas.svg.png'},{'name':'California','flag':'0/01/Flag_of_California.svg/45px-Flag_of_California.svg.png'},{'name':'Colorado','flag':'4/46/Flag_of_Colorado.svg/45px-Flag_of_Colorado.svg.png'},{'name':'Connecticut','flag':'9/96/Flag_of_Connecticut.svg/39px-Flag_of_Connecticut.svg.png'},{'name':'Delaware','flag':'c/c6/Flag_of_Delaware.svg/45px-Flag_of_Delaware.svg.png'},{'name':'Florida','flag':'f/f7/Flag_of_Florida.svg/45px-Flag_of_Florida.svg.png'},{'name':'Georgia','flag':'5/54/Flag_of_Georgia_%28U.S._state%29.svg/46px-Flag_of_Georgia_%28U.S._state%29.svg.png'},{'name':'Hawaii','flag':'e/ef/Flag_of_Hawaii.svg/46px-Flag_of_Hawaii.svg.png'},{'name':'Idaho','flag':'a/a4/Flag_of_Idaho.svg/38px-Flag_of_Idaho.svg.png'},{'name':'Illinois','flag':'0/01/Flag_of_Illinois.svg/46px-Flag_of_Illinois.svg.png'},{'name':'Indiana','flag':'a/ac/Flag_of_Indiana.svg/45px-Flag_of_Indiana.svg.png'},{'name':'Iowa','flag':'a/aa/Flag_of_Iowa.svg/44px-Flag_of_Iowa.svg.png'},{'name':'Kansas','flag':'d/da/Flag_of_Kansas.svg/46px-Flag_of_Kansas.svg.png'},{'name':'Kentucky','flag':'8/8d/Flag_of_Kentucky.svg/46px-Flag_of_Kentucky.svg.png'},{'name':'Louisiana','flag':'e/e0/Flag_of_Louisiana.svg/46px-Flag_of_Louisiana.svg.png'},{'name':'Maine','flag':'3/35/Flag_of_Maine.svg/45px-Flag_of_Maine.svg.png'},{'name':'Maryland','flag':'a/a0/Flag_of_Maryland.svg/45px-Flag_of_Maryland.svg.png'},{'name':'Massachusetts','flag':'f/f2/Flag_of_Massachusetts.svg/46px-Flag_of_Massachusetts.svg.png'},{'name':'Michigan','flag':'b/b5/Flag_of_Michigan.svg/45px-Flag_of_Michigan.svg.png'},{'name':'Minnesota','flag':'b/b9/Flag_of_Minnesota.svg/46px-Flag_of_Minnesota.svg.png'},{'name':'Mississippi','flag':'4/42/Flag_of_Mississippi.svg/45px-Flag_of_Mississippi.svg.png'},{'name':'Missouri','flag':'5/5a/Flag_of_Missouri.svg/46px-Flag_of_Missouri.svg.png'},{'name':'Montana','flag':'c/cb/Flag_of_Montana.svg/45px-Flag_of_Montana.svg.png'},{'name':'Nebraska','flag':'4/4d/Flag_of_Nebraska.svg/46px-Flag_of_Nebraska.svg.png'},{'name':'Nevada','flag':'f/f1/Flag_of_Nevada.svg/45px-Flag_of_Nevada.svg.png'},{'name':'New Hampshire','flag':'2/28/Flag_of_New_Hampshire.svg/45px-Flag_of_New_Hampshire.svg.png'},{'name':'New Jersey','flag':'9/92/Flag_of_New_Jersey.svg/45px-Flag_of_New_Jersey.svg.png'},{'name':'New Mexico','flag':'c/c3/Flag_of_New_Mexico.svg/45px-Flag_of_New_Mexico.svg.png'},{'name':'New York','flag':'1/1a/Flag_of_New_York.svg/46px-Flag_of_New_York.svg.png'},{'name':'North Carolina','flag':'b/bb/Flag_of_North_Carolina.svg/45px-Flag_of_North_Carolina.svg.png'},{'name':'North Dakota','flag':'e/ee/Flag_of_North_Dakota.svg/38px-Flag_of_North_Dakota.svg.png'},{'name':'Ohio','flag':'4/4c/Flag_of_Ohio.svg/46px-Flag_of_Ohio.svg.png'},{'name':'Oklahoma','flag':'6/6e/Flag_of_Oklahoma.svg/45px-Flag_of_Oklahoma.svg.png'},{'name':'Oregon','flag':'b/b9/Flag_of_Oregon.svg/46px-Flag_of_Oregon.svg.png'},{'name':'Pennsylvania','flag':'f/f7/Flag_of_Pennsylvania.svg/45px-Flag_of_Pennsylvania.svg.png'},{'name':'Rhode Island','flag':'f/f3/Flag_of_Rhode_Island.svg/32px-Flag_of_Rhode_Island.svg.png'},{'name':'South Carolina','flag':'6/69/Flag_of_South_Carolina.svg/45px-Flag_of_South_Carolina.svg.png'},{'name':'South Dakota','flag':'1/1a/Flag_of_South_Dakota.svg/46px-Flag_of_South_Dakota.svg.png'},{'name':'Tennessee','flag':'9/9e/Flag_of_Tennessee.svg/46px-Flag_of_Tennessee.svg.png'},{'name':'Texas','flag':'f/f7/Flag_of_Texas.svg/45px-Flag_of_Texas.svg.png'},{'name':'Utah','flag':'f/f6/Flag_of_Utah.svg/45px-Flag_of_Utah.svg.png'},{'name':'Vermont','flag':'4/49/Flag_of_Vermont.svg/46px-Flag_of_Vermont.svg.png'},{'name':'Virginia','flag':'4/47/Flag_of_Virginia.svg/44px-Flag_of_Virginia.svg.png'},{'name':'Washington','flag':'5/54/Flag_of_Washington.svg/46px-Flag_of_Washington.svg.png'},{'name':'West Virginia','flag':'2/22/Flag_of_West_Virginia.svg/46px-Flag_of_West_Virginia.svg.png'},{'name':'Wisconsin','flag':'2/22/Flag_of_Wisconsin.svg/45px-Flag_of_Wisconsin.svg.png'},{'name':'Wyoming','flag':'b/bc/Flag_of_Wyoming.svg/43px-Flag_of_Wyoming.svg.png'}];
  })
  /* jshint ignore:end */

  .controller('DropdownCtrl', function ($scope) {

     $scope.items = [
      'The first choice!',
      'And another choice for you.',
      'but wait! A third!'
    ];

    $scope.status = {
      isopen: false
    };

    $scope.toggled = function(open) {
      console.log('Dropdown is now: ', open);
    };

    $scope.toggleDropdown = function($event) {
      $event.preventDefault();
      $event.stopPropagation();
      $scope.status.isopen = !$scope.status.isopen;
    };
  })

  .controller('DatepickerDemoCtrl', function ($scope) {

    $scope.today = function() {
      $scope.dt = new Date();
    };

    $scope.today();

    $scope.clear = function () {
      $scope.dt = null;
    };

    // Disable weekend selection
    $scope.disabled = function(date, mode) {
      return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
    };

    $scope.toggleMin = function() {
      $scope.minDate = $scope.minDate ? null : new Date();
    };
    $scope.toggleMin();

    $scope.open = function($event) {
      $event.preventDefault();
      $event.stopPropagation();

      $scope.opened = true;
    };

    $scope.dateOptions = {
      formatYear: 'yy',
      startingDay: 0,
      showWeeks: false,
      'class': 'datepicker'
    };

    $scope.formats = ['yyyy-MM-dd', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate'];
    $scope.format = $scope.formats[0];

    $scope.processDate = function (dt) {
      return $filter('date')(dt, 'yyyy-MM-dd');
    }
  })

  .controller('TimepickerDemoCtrl', function ($scope) {
    $scope.mytime = new Date();

    $scope.hstep = 1;
    $scope.mstep = 15;

    $scope.options = {
      hstep: [1, 2, 3],
      mstep: [1, 5, 10, 15, 25, 30]
    };

    $scope.ismeridian = true;
    $scope.toggleMode = function() {
      $scope.ismeridian = ! $scope.ismeridian;
    };

    $scope.update = function() {
      var d = new Date();
      d.setHours( 14 );
      d.setMinutes( 0 );
      $scope.mytime = d;
    };

    $scope.changed = function () {
      console.log('Time changed to: ' + $scope.mytime);
    };

    $scope.clear = function() {
      $scope.mytime = null;
    };
  })

  .controller('PaginationDemoCtrl', function ($scope) {
    $scope.totalItems = 64;
    $scope.currentPage = 4;

    $scope.setPage = function (pageNo) {
      $scope.currentPage = pageNo;
    };

    $scope.pageChanged = function() {
      console.log('Page changed to: ' + $scope.currentPage);
    };

    $scope.maxSize = 5;
    $scope.bigTotalItems = 175;
    $scope.bigCurrentPage = 1;
  })

  .controller('PopoverDemoCtrl', function ($scope) {
    $scope.dynamicPopover = 'Hello, World!';
    $scope.dynamicPopoverTitle = 'Title';
  });

(function() {
  webapp
  .factory('dock', function() {
    var valids = [ 'left', 'right', 'top', 'bottom', 'fill' ];
    return {
      dockRefs: {},
      valids: valids,
      handlesByDock: {
        "top": "s",
        "left": "e",
        "right": "w",
        "bottom": "n"
      },
      Area: (function() {
        function setPosition(r, s, pos) {
            r.position = 'absolute';
            if (pos != "bottom") r.top = s.top; else { r.top = 'auto'; }
            if (pos != "left") r.right = s.right; else { r.right = 'auto'; }
            if (pos != "right") r.left = s.left; else { r.left = 'auto'; }
            if (pos != "top") r.bottom = s.bottom; else { r.bottom = 'auto'; }
        }
        function decreaseSize($element, pos, s) {
            var size = 0;
            if ("top|bottom".indexOf(pos) != -1) size = $element.outerHeight(true);
            if ("left|right".indexOf(pos) != -1) size = $element.outerWidth(true);
            if (pos == "bottom") s.bottom += size;
            if (pos == "left")   s.left   += size;
            if (pos == "right")  s.right  += size;
            if (pos == "top")    s.top    += size;
        }
        function removeClasses($element){
          var x = valids.length;
          while(x--)
            $element.removeClass("dock-" + valids[x]);
        }
        function update($element, pos, s) {
            var r = {};
            removeClasses($element);
            setPosition(r, s, pos);
            $element.addClass("dock-" + pos);
            $element.css(r);
            decreaseSize($element, pos, s);
        }
        var Area = function($div, $scope) {
          var s = {
            top: 0,
            bottom: 0,
            left: 0,
            right: 0
          };
          var childList = [];
          this.addChild = function($element, $pos) {
            var pos = $scope.$eval($pos);
            console.log('pos=', pos);

            if (valids.indexOf(pos) == -1)
              throw {
                message: "dock position must be one of this: " + valids.join(', ')
              };
            childList.push({
              element: $element,
              pos: $pos,
              order: childList.length
            });
            update($element, pos, s);
          };
          this.refresh = function() {
            s.top = 0;
            s.bottom = 0;
            s.left = 0;
            s.right= 0;
            for (var x = 0; x < childList.length; x++) {
              var pos = $scope.$eval(childList[x].pos);
              update(childList[x].element, pos, s);
            }
          };

          var _this = this;
          $(window).resize(function() {
            _this.refresh();
          });
          $scope.$watch(function() {
            _this.refresh();
          });
        };
        return Area;
      })()
    };
  })
  .directive('dockRef', function(dock) {
    return {
      restrict: "A",
      controller: function($scope, $element) {
        $scope.__dock_ref_id = String(Math.random()).replace(/\./g, "");
        dock.dockRefs[$scope.__dock_ref_id] = new dock.Area($element, $scope);
      },
      scope: true
    };
  })
  .directive('dock', function(dock) {
    return {
      restrict: "A",
      controller: function($scope, $element) {
        var dp = $element.attr('dock');
        $scope.__dock_id = String(Math.random()).replace(/\./g, "");
        var area = dock.dockRefs[$scope.$parent.__dock_ref_id];
        area.addChild($element, dp);
      },
      scope: true
    };
  })
  .directive("dockResizable", function(dock) {
    function enableResize($element, dp) {
      $element.resizable({
        handles: dock.handlesByDock[dp]
      });
    }
    return {
      require: 'dock',
      restrict: "A",
      controller: function($scope, $element) {
        var dp = $scope.$eval($element.attr('dock'));
        if (dock.valids.indexOf(dp) >= 0 && dp != "fill") enableResize($element, dp);
        $scope.$watch(function() {
          var newdp = $scope.$eval($element.attr('dock'));
          if (newdp != dp) {
            if (dock.valids.indexOf(newdp) == -1)
              throw {
                message: "dock position must be one of this: " + valids.join(', ')
              };
            dp = newdp;
            $element.resizable('destroy');
            if (newdp != 'fill') enableResize($element, dp);
          }
        });
      }
    }
  });
})();

(function() {
  "use strict";
  webapp.factory('gAlert',
    [ '$filter', '$rootScope', 'modalFactory',
    function($filter, $rootScope, modalFactory) {

      var templateUrl = 'components/ui-component/factory/galert-factory.html';

      return function(p1, p2, p3, p4) {

        /*
          if p2 ? string : p1 = "type", p2 = msg, p3 = function
          else p1 = msg, p2 = function

          Alert Type : info, error
          p1 type of String : alert type
          p1 type of Function : ok function / default Info
        */

        var ico = "", color = "", mode = true;
        if(typeof(p2) == "string") {
          if(p1.toLowerCase() == "i") {
            ico = "alert-icon-exclamation";
            color = "0066cc";
          } else if(p1.toLowerCase() == "c") {
           ico = "alert-icon-check";
           color = "0066cc";
          } else if(p1.toLowerCase() == "w") {
            ico = "alert-icon-caution";
            color = "be1a16";
          } else {
            ico = "alert-icon-exclamation";
            color = "0066cc";
          }
        } else {
          mode = false;
          ico = "alert-icon-exclamation";
          color = "0066cc";
        }

        var translate = $filter('translate');
        var defaultCloseBtn = translate('Menu.CONFIRM');
        if(mode) {
          if ($rootScope.gVariable.alertMessage == p2 || p2 == null)
            return;
        } else {
          if ($rootScope.gVariable.alertMessage == p1 || p1 == null)
            return;
        }


        var modalInstance = modalFactory.open('sm', templateUrl, function($uibModalInstance, $scope, $document) {
          //$scope.title = (title == '') ? translate('Menu.ALERT') : translate(title);

          var msg = (mode) ? p2 : p1;
          $rootScope.gVariable.alertMessage = msg;
          $scope.alertColor = color;
          $scope.alertMessage = translate(msg);
          $scope.alertIco = ico;

          var okAct;
          if(mode) {
            $scope.closeBtn = p3 && p3.btn ? translate(p3.btn) : defaultCloseBtn;
            okAct = p3;
          } else {
            $scope.closeBtn = p2 && p2.btn ? translate(p2.btn) : defaultCloseBtn;
            okAct = p2;
          }

          var okFn = okAct && okAct.fn ? okAct.fn : null;
          $scope.onClose = function() {
            if (okFn)
              okFn();
            $uibModalInstance.dismiss('cancel');
            $rootScope.gVariable.alertMessage = '';
          };

          var EVENT_TYPES = 'keydown keypress';
          function eventHandler(event) {
            var _key = event.which; // enter, space
            if ((_key === 13 || _key === 32) && event.target.className.indexOf('modal') > -1) {
              event.preventDefault();
              $scope.onClose();
            }
          }
          $document.on(EVENT_TYPES, eventHandler);
          $scope.$on('$destroy', function() {
            $document.off(EVENT_TYPES, eventHandler);
          });
        }, {}, {
          keyboard : true
        });
      };
    }]);
})();

webapp.factory('gConfirm', [ '$filter', 'modalFactory', function($filter, modalFactory) {
  var defaultIconClazz = 'noty';
  var templateUrl = 'components/ui-component/factory/gconfirm-factory.html';

  var basicConfirm = function(p1, p2, p3, p4, p5) {

    //title, msg, okAct, closeAct, options
    /*
      if p2 ? string : p1 = "type", p2 = msg, p3 = ok, p4 = cancel;
      else p1 = msg, p2 = ok, p3 = cancel

      Alert Type : info, error
      p1 type of String : alert type
      p1 type of Function : ok function / default Info
    */

   var ico = "", color = "", mode = true;
   if(typeof(p2) == "string") {
     if(p1.toLowerCase() == "i") {
       ico = "alert-icon-exclamation";
       color = "0066cc";
     } else if(p1.toLowerCase() == "c") {
      ico = "alert-icon-check";
      color = "0066cc";
     } else if(p1.toLowerCase() == "w") {
       ico = "alert-icon-caution";
       color = "be1a16";
     } else {
       ico = "alert-icon-exclamation";
       color = "0066cc";
     }
   } else {
     mode = false;
     ico = "alert-icon-exclamation";
     color = "0066cc";
   }

    var translate = $filter('translate');
    var defaultCloseBtn = translate('Menu.CANCEL');
    var defaultOkBtn = translate('Menu.OK');

    var modalInstance = modalFactory.open('sm', templateUrl, function($uibModalInstance, $scope, $document) {

      var msg = (mode) ? p2 : p1;

      $scope.alertColor = color;
      $scope.alertIco = ico;
      $scope.alertMessage = translate(msg);

      var okAct, closeAct;
      if(mode) {
        okAct = p3; closeAct = p4;
        $scope.okBtn = okAct && okAct.btn ? translate(okAct.btn) : defaultOkBtn;
        $scope.closeBtn = closeAct && closeAct.btn ? translate(closeAct.btn) : defaultCloseBtn;
        $scope.iconClazz = p5 && p5.type ? p5.type : defaultIconClazz;
      } else {
        okAct = p2; closeAct = p3;
        $scope.okBtn = okAct && okAct.btn ? translate(okAct.btn) : defaultOkBtn;
        $scope.closeBtn = closeAct && closeAct.btn ? translate(closeAct.btn) : defaultCloseBtn;
        $scope.iconClazz = p4 && p4.type ? p4.type : defaultIconClazz;
      }

      var okFn = okAct && okAct.fn ? okAct.fn : null;
      var closeFn = closeAct && closeAct.fn ? closeAct.fn : null;

      $scope.onClose = function() {
        if (closeFn)
          closeFn();
        $uibModalInstance.dismiss('cancel');
      };
      $scope.onOk = function() {
        if (okFn)
          okFn();
        $uibModalInstance.dismiss('cancel');
      };

      var EVENT_TYPES = 'keydown keypress';
      function eventHandler(event) {
        var _key = event.which; // enter, space
        if ((_key === 13 || _key === 32) && event.target.className.indexOf('modal') > -1) {
          event.preventDefault();
          $scope.onOk();
        }

      }
      $document.on(EVENT_TYPES, eventHandler);
      $scope.$on('$destroy', function() {
        $document.off(EVENT_TYPES, eventHandler);
      });
    }, {}, {
      keyboard : true
    });
  }

  return basicConfirm;
} ]);

webapp.factory('gSelect', [ '$filter', 'modalFactory', function($filter, modalFactory) {
    var defaultIconClazz = 'noty';
    var templateUrl = 'components/ui-component/factory/gselect-factory.html';

    var basicConfirm = function(p1, p2, p3, p4, p5, p6, p7) {

      //title, msg, okAct, closeAct, options
      /*
        if p2 ? string : p1 = "type", p2 = msg, p3 = ok, p4 = cancel;
        else p1 = msg, p2 = ok, p3 = cancel

        Alert Type : info, error
        p1 type of String : alert type
        p1 type of Function : ok function / default Info
      */

    var ico = "", color = "", mode = true;
    if(p1.toLowerCase() == "i") {
      ico = "alert-icon-exclamation";
      color = "0066cc";
    } else if(p1.toLowerCase() == "c") {
      ico = "alert-icon-check";
      color = "0066cc";
    } else if(p1.toLowerCase() == "w") {
      ico = "alert-icon-caution";
      color = "be1a16";
    } else {
      ico = "alert-icon-exclamation";
      color = "0066cc";
    }

    var translate = $filter('translate');
    var defaultCloseBtn = translate('Menu.CANCEL');
    var defaultOkBtn = translate('Menu.OK');

    var modalInstance = modalFactory.open('sm', templateUrl, function($uibModalInstance, $scope, $document) {

      $scope.alertColor = color;
      $scope.alertIco = ico;
      $scope.alertMessage = translate(p2);
      $scope.items = p5;
      $scope.mode = p6;

      var okAct, closeAct;
      okAct = p3; closeAct = p4;
      $scope.okBtn = okAct && okAct.btn ? translate(okAct.btn) : defaultOkBtn;
      $scope.closeBtn = closeAct && closeAct.btn ? translate(closeAct.btn) : defaultCloseBtn;
      $scope.iconClazz = p7 && p7.type ? p7.type : defaultIconClazz;

      var okFn = okAct && okAct.fn ? okAct.fn : null;
      var closeFn = closeAct && closeAct.fn ? closeAct.fn : null;

      $scope.onClose = function() {
        if (closeFn)
          closeFn();
        $uibModalInstance.dismiss('cancel');
      };
      $scope.onOk = function() {
        if (okFn)
          okFn($scope.mode);
        $uibModalInstance.dismiss('cancel');
      };

      var EVENT_TYPES = 'keydown keypress';
      function eventHandler(event) {
        var _key = event.which; // enter, space
        if ((_key === 13 || _key === 32) && event.target.className.indexOf('modal') > -1) {
          event.preventDefault();
          $scope.onOk();
        }
      }
      $document.on(EVENT_TYPES, eventHandler);
      $scope.$on('$destroy', function() {
        $document.off(EVENT_TYPES, eventHandler);
      });
    }, {}, {
      keyboard : true
    });
  };

  return basicConfirm;
} ]);

/**
 * 자세한 옵션은 https://angular-ui.github.io/bootstrap/ 의 Modal 항목 참고
 *
 * 사용 예제
 *
 * <pre>
 * 모달을 사용하는 측 모달 열기
 * var modalInstance = modalFactory.open('lg', 'html/changemng/req-change.html',
 * 		'ReqChangeController', data: modal측에 전달할 객체);
 * 모달 외부에서 내부로 값 전달 하는 방법
 * data에 데이터를 넣고, 모달의 내부에서 사용하는 controller에서
 * gmsController.controller('ReqChangeController', [ '$scope','$uibModalInstance','toModalData',
 * 	function($scope, $uibModalInstance, toModalData) {
 * console.log(JSON.stringify(toModalData));
 * 이런식으로 하면 toModalData안에 데이터가 들어있게 된다.
 *
 * 모달에서 처리된 값 받기
 * modalInstance.result.then(function(data) {
 * 	console.log(JSON.stringify(data))
 * }, function() {
 * 	$log.info('Modal dismissed at: ' + new Date());
 * });
 *
 * 모달 내부에서 외부로 값 전달 하는 방법
 * 확인 버튼
 * $uibModalInstance.close($scope.reqChangeModel);
 * - modalInstance.result.then(function(data) 모달을 사용하는 측에서 data에 값이 들어오게 된다.
 *
 * 취소 버튼
 * $uibModalInstance.dismiss('cancel');
 * - modalInstance.result.then 이부분이 호출되지 않게 된다.
 *
 *
 * </pre>
 */

webapp.factory('modalFactory', [ '$uibModal', '$rootScope', ModalFactory ]);

function ModalFactory($uibModal, $rootScope) {
  var modalInstance = {};
  // $uibModalInstance

  modalInstance.open = function(size, templateUrl, controller, data, options) {
    var modal = $uibModal.open({
      animation : false,
      templateUrl : templateUrl,
      controller : controller,
      // size - (Type: string, Example: lg)
      // Optional suffix of modal window class. The value used is appended
      // to the modal- class, i.e. a value of sm gives modal-sm.
      size : size,
      backdrop : 'static',
      // 키보드 esc로 모달을 닫을지 여부
      keyboard : options && options.keyboard ? options.keyboard : true,
      windowTemplate : 'ui/template/modal/window.html',
      // 모달 외부로 부터 내부로 전달 받을 값
      resolve : {
        toModalData : function() {
          return data;
        }
      }
    });
    return modal;
  };
  return modalInstance;
};

webapp.factory('modalPopup', ['$uibModal', '$rootScope', modalPopup]);

function modalPopup($uibModal, $rootScope) {
  var modalInstance = {};
  modalInstance.open = function(templateUrl, controller, data, options) {
    var as = controller.split(' ');
    as = as[as.length - 1];

    var $wrap = $("<div id='wrap'/>");
    var $popupHeader = $('<div />', { class: 'custom-popup-header' });
    var $popupHeader = $('<div />', { class: 'custom-popup-header' });
    //"ng-click" : '$uibModalInstance.dismiss("cancel data");'
    var $popupView = $('<div />', { 'ng-include': '', src: templateUrl });

    var modal = $uibModal.open({
      animation: true,
      templateUrl: templateUrl,
      //template: "<div ng-click='vc.cancel();'>닫기</div><div ng-include src=\"'" + templateUrl +"'\"></div>",
      controller: controller,
      backdrop: 'static',
      // 키보드 esc로 모달을 닫을지 여부
      keyboard: options && options.keyboard ? options.keyboard : true,
      windowTemplate: 'components/ui-component/factory/modal-mobile-popup.html',
      // 모달 외부로 부터 내부로 전달 받을 값
      windowClass: 'modal-mobile-popup',
      resolve: {
        toModalData: function() {
          return data;
        }
      }
    });
    return modal;
  };
  return modalInstance;
}

/**
 * sort-array-object.js는 object Type들로 이루어진 Array에 대한 정렬을 제공하는 기능이다. 숫자 타입의 속성 값만 비교 가능하다.
 * Params - input: 정렬할 데이터
 * Params - attr : 정렬 기준 항목
 */
webapp.factory('sortArrayFactory', ['$resource', 'GLOBAL_CONSTANT', function sortArrayFactory($resource, CONSTANT) {
    return {
        sortArrayObject: function(input, attr){
            if(!angular.isArray(input)){
                return input;
            }
            input.sort(function(pre, post){
                try{
                    a = parseInt(pre[attr]);
                    b = parseInt(post[attr]);
                    return a - b;
                }catch(ex){
                    throw new Error('NumberFormat Error.');
                    return input;
                }
            })
            return input;
        }
    }
}]);

/**
 * static-variable-factory.js는 ng-app 전역적인 변수값을 정의하여 사용할 수 있는 정적 메소드이다.
 */

webapp.factory('StaticVariable', [
    '$state',
    '$window',
    '$cookies',
    '$filter',
    '$rootScope',
    'gAlert',
    'GLOBAL_CONSTANT',
    function($state, $window, $cookies, $filter, $rootScope, gAlert, CONSTANT) {
      // -- ACCESS_DENIED("ACN1N00-403") 홈으로 이동
      // -- ALREADY_LOGGED_IN("ACN0N04-409") 로그인에서만 사용
      // -- ACCESS_TOKEN_IS_NULL("ACN0N01-401") 로그인으로 이동
      // -- INVALID_TOKEN("ACN1N01-401") 로그인으로 이동
      // -- TOKEN_IS_EXPIRED("ACN1N02-401") 로그인으로 이동
      // -- DOES_NOT_MATCH_TOKEN_VERSION("ACN1N03-401") 로그인으로 이동
      // -- LOGEDIN_ANOTHER_CLIENT("ACN1N04-401") 로그인으로 이동
      function getContextPath() {
        var offset=location.href.indexOf(location.host)+location.host.length;
        if (offset + 1 >= location.href.length)
          return "";

        var ctxPath=location.href.substring(offset+1,location.href.indexOf('/',offset+1));

        if (ctxPath == '#')
          ctxPath = '';

        return ctxPath;
      }

      CONSTANT.URL.CONTEXT = getContextPath();
      var translate = $filter('translate');

      var alreadyOccurError = false;
      var serverDead = false;

      var intercept = {
        response : function(JSON) {
          //console.info('intercept JSON=====', JSON);
          return JSON.data;
        },
        responseError : function(error) {
          console.log('intercept error=====', error);

          if (error.data == null) {
            gAlert(translate('Menu.SERVERERROR4'), "Unknown error.");
            return null;
          }

          if ((error.status == -1 || error.status == 400) && !serverDead) {
            serverDead = true;
            gAlert(translate('Menu.SERVERERROR1'), {
              fn : function() {
                sessionExpire();
                $state.go('login');
              }
            });

          } else if (error.data && angular.isUndefined(error.data.response)) {
            gAlert(translate('Menu.SERVERERROR2'), error.statusText, {
              fn : function() {
                console.error('server Error', '[' + error.status + ']' + error.statusText);
                if (error.status == 401 || error.status == 400) {
                  sessionExpire();
                  $state.go('login');
                }
              }
            });
            return null;
          } else if (error.data.response.body.docs.errCode == 'ACN0N01-401' || error.data.response.body.docs.errCode == 'ACN1N01-401'
              || error.data.response.body.docs.errCode == 'ACN1N02-401' || error.data.response.body.docs.errCode == 'ACN1N03-401'
              || error.data.response.body.docs.errCode == 'ACN1N04-401') {

            if ($window.sessionStorage.isLoggedIn) {
              alreadyOccurError = true;
              sessionExpire();
              $state.go('login');
              return null;
            }
          } else if (error.data.response.body.docs.errCode === 'ACN1N00-403') {
            console.log(error.data);
            gAlert(translate('Menu.SERVERERROR3'), error.data.response.body.docs.errMessage, {
              fn : function() {
                console.error(error.data.response.body.docs.errMessage);
                $state.go('login');
              }
            });
            return null;
          } else {
            return error.data;
          }

          gAlert(translate('Menu.SERVERERROR4'), error.data.response.body.docs.errMessage);
          console.error(error.data.response.body.docs.errCode, error.data.response.body.docs.errMessage);
        }
      };
      function sessionExpire() {
        $window.sessionStorage.removeItem('isLoggedIn');
        $window.sessionStorage.removeItem('loginUserId');
        $window.sessionStorage.removeItem('loginUserIdx');
        $window.sessionStorage.removeItem('loginSysAdminYN');
        $window.sessionStorage.removeItem('loginUserName');
        $window.sessionStorage.removeItem('loginUserGbn');
        $window.sessionStorage.removeItem('loginUserDept');
        $window.sessionStorage.removeItem('loginUserDeptCode');
        $window.sessionStorage.removeItem('loginComGbn');
        $window.sessionStorage.removeItem('loginUserType');
        $window.sessionStorage.removeItem('loginUserEmail');
        $window.sessionStorage.removeItem('loginTenantId');
        $window.sessionStorage.removeItem('loginTenantName');
        $window.sessionStorage.removeItem('loginTenantDir');
        $window.sessionStorage.removeItem('loginEmail');
        $window.sessionStorage.removeItem('loginTelNo');
        $window.sessionStorage.removeItem('srchTenantId');
        $window.sessionStorage.removeItem('srchTenantName');
      }
      return {
        getUrl : function(uri) {
          var domainPort = CONSTANT.URL.PORT == null || CONSTANT.URL.PORT == "" ? "" : ":" + CONSTANT.URL.PORT;
          var domainContext = CONSTANT.URL.CONTEXT == null || CONSTANT.URL.CONTEXT == "" ? "" : '/' + CONSTANT.URL.CONTEXT;
          var domainVersion = CONSTANT.URL.VERSION == null || CONSTANT.URL.VERSION == "" ? "" : '/' + CONSTANT.URL.VERSION;

          var url = CONSTANT.URL.HTTP_PROTOCOL + '//' +
          CONSTANT.URL.API_SERVER_DOMAIN + domainPort + domainContext +
          domainVersion + uri;
          //var url = domainContext + domainVersion + uri;
          return url;
        },
        getFileDownloadUrl : function(FileKey) {
          return this.getUrl('/attach/file/' + FileKey + '/download.do?userkey=' + $rootScope.gVariable.userKey);
        },
        getDateFormat : function(langCode, useDateTime) {
          var foramt;
          switch (langCode) {
          case 'ko':
            format = 'yyyy.MM.dd';
            break;
          case 'zh':
            // break;
          case 'ja':
            format = 'yyyy.MM.dd';
            break;
          case 'en':
            format = 'MM/dd/yy';
            break;
          default:
            format = 'MM/dd/yy';
            break;
          }
          return useDateTime ? format + ' HH:mm:ss' : format;
        },
        sessionExpire : function() {
          sessionExpire();
        },
        getRequestActions : {
          defaultAction : function() {
            return {
              one : {
                method : 'GET',
                interceptor : intercept,
                transformResponse : function(data, headersGetter) {
                  var contentType = headersGetter('Content-Type');
                  if (contentType && contentType.indexOf('text/html') > -1) {
                    return {
                      'body' : data
                    };
                  }
                  return angular.fromJson(data);
                }
              },
              post : {
                method : "POST",
                interceptor : intercept
              },
              get : {
                method : "GET",
                interceptor : intercept
              },
            };
          },
          getStandardAction : function() {
            return {
              getOne : {
                method : 'GET',
                headers : {
                  'Content-Type' : 'application/json'
                },
                interceptor : intercept,
              },
              getList : {
                method : "GET",
                headers : {
                  'Content-Type' : 'application/json'
                },
                interceptor : intercept,
              },
              create : {
                method : "POST",
                headers : {
                  'Content-Type' : 'application/json'
                },
                interceptor : intercept,
              },
              modify : {
                method : "PUT",
                headers : {
                  'Content-Type' : 'application/json'
                },
                interceptor : intercept,
              },
              remove : {
                method : "DELETE",
                headers : {
                  'Content-Type' : 'application/json'
                },
                interceptor : intercept,
              },
            };
          },
        }
      };
    } ]);

webapp.factory("uuidFactory", function() {
	function r(r) {
		return Math.random() * r
	}
	return {
		v4 : function() {
			var n, a = "";
			for (n = 0; 36 > n; n++)
				a += 14 === n ? "4" : 19 === n ? "89ab".charAt(r(4)) : 8 === n
						|| 13 === n || 18 === n || 23 === n ? "-"
						: "0123456789abcdef".charAt(r(16));
			return a
		}
	};
});

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */

    TimeLine.$inject = ['$log'];

    /** @ngInject */
    function TimeLine($log) {
        $log.info('TimeLine Controller');
    }

    angular.module('salevis4-web')
        .component('timeline', {
            templateUrl: 'components/ui-component/timeline/timeline.html',
            controller: TimeLine
        });

})();

(function () {
  "use strict";
    webapp.controller('UserscareerModalCtrl',
      ['$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'autoPage', '$stateParams', 'gAlert', '$window',
      function UserscareerModalCtrl($scope, $uibModalInstance, toModalData, CONSTANT, postApi, ap, $stateParams, gAlert, $window) {
        
        var INSERT_SQL = 'User.insertUserscareer';     // 등록 SQL
        var UPDATE_SQL = 'User.updateUserscareer';     // 수정 SQL
        var VIEW_SQL = 'User.getUserscareerDetail';

        var vm = this;
        vm.data = {}; // BASE DATA;
    
        vm.checkSave = false;
        vm.checkEdit = false;
        vm.enableSystemYn = false;

      /**
       * @description
       * # 모달팝업 데이터 설정
       */
        var mData = angular.copy(toModalData);
        mData.selectType = "Edit";

        if(!mData.AddYn) {
          vm.checkEdit = true;
        } else {
          vm.checkSave = true;
        }

        vm.setData = function() {
          if(getIsValidData()) {

            if(!isNullOrEmpty(mData.KeyId)) {
              var data = vm.data;

              data.UserId = mData.KeyId;
              data.mapCode = INSERT_SQL;
              postApi.insert(data, function(result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  if (result.body.docs.length > 0) {
                    $uibModalInstance.close();
                  } else {
                  }
                }
              }, function (error) {
                console.error("Error> setData()");
                console.table(error);
                gAlert('', error.body.docs[0].errMessage);
              });
            }
          }
        };

        vm.editData = function() {
          if(getIsValidData()) {
            if(!isNullOrEmpty(mData.KeyId)) {
              var data = vm.data; // 사용자 입력 데이터
              data.TermStartDate = moment(data.TermStartDate).format('YYYY-MM-DD');
              data.TermEndDate = moment(data.TermEndDate).format('YYYY-MM-DD');
              data.mapCode = UPDATE_SQL;

              postApi.update(data, function(result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  if (result.body.docs.length > 0) {
                    $uibModalInstance.close();
                  } else {
                  }
                }
              }, function (error) {
                console.error("Error> editData()");
                console.table(error);
                gAlert('', error.body.docs[0].errMessage);
              });
            }
          }
        };

        function getIsValidData() {

          var errMsg = '';
          if (isNullOrEmpty(vm.data.TermStartDate)) errMsg = errMsg + '- 입사일자를 입력하세요.<br/>';
          if (isNullOrEmpty(vm.data.TermEndDate)) errMsg = errMsg + '- 퇴사일자를 입력하세요.<br/>';
          if (isNullOrEmpty(vm.data.Company)) errMsg = errMsg + '- 근무처를 입력하세요.<br/>';
          if (isNullOrEmpty(vm.data.JobTitle)) errMsg = errMsg + '- 직급을 입력하세요.<br/>';

          if (!isNullOrEmpty(errMsg)) {
            gAlert('', errMsg);
            return false;
          }
          return true;
        }



        vm.cancel = function() {
          $uibModalInstance.dismiss('cancel data');
        };

        function getData() {
          if(!mData.AddYn) {
            var data = vm.data;
            data.KeyId = mData.KeyId;
            data.mapCode = VIEW_SQL;

            postApi.select(data, function(result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                if (result.body.docs.length > 0) {
                  vm.data = result.body.docs[0];
                  vm.data.keyId = mData.KeyId;
                  
                  vm.TermStartDate = moment(vm.data.TermStartDate).toDate();
                  vm.TermEndDate = moment(vm.data.TermEndDate).toDate();
                }
              } else {
                console.error("Error> getData()");
  
                if (!isNullOrEmpty(result.body.docs)) {
                  gAlert('', result.body.docs[0].errMessage);
                }
              }
  
            }, function (error) {
              console.error("Error> getData()");
              console.table(error);
            });
          }
        }

        vm.getData = getData();

    }]);
})();
(function () {
  "use strict";
    webapp.controller('UserseduhistoryModalCtrl',
      ['$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'autoPage', '$stateParams', 'gAlert', '$window',
      function UserseduhistoryModalCtrl($scope, $uibModalInstance, toModalData, CONSTANT, postApi, ap, $stateParams, gAlert, $window) {
        
        var INSERT_SQL = 'User.insertUserseduhistory';     // 등록 SQL
        var UPDATE_SQL = 'User.updateUserseduhistory';     // 수정 SQL
        var VIEW_SQL = 'User.getUserseduhistoryDetail';

        var vm = this;
        vm.data = {}; // BASE DATA;
    
        vm.checkSave = false;
        vm.checkEdit = false;
        vm.enableSystemYn = false;

      /**
       * @description
       * # 모달팝업 데이터 설정
       */
        var mData = angular.copy(toModalData);
        mData.selectType = "Edit";

        if(!mData.AddYn) {
          vm.checkEdit = true;
        } else {
          vm.checkSave = true;
        }

        vm.setData = function() {
          if(getIsValidData()) {

            if(!isNullOrEmpty(mData.KeyId)) {
              var data = vm.data;

              data.UserId = mData.KeyId;
              data.mapCode = INSERT_SQL;
              postApi.insert(data, function(result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  if (result.body.docs.length > 0) {
                    $uibModalInstance.close();
                  } else {
                  }
                }
              }, function (error) {
                console.error("Error> setData()");
                console.table(error);
                gAlert('', error.body.docs[0].errMessage);
              });
            }
          }
        };

        vm.editData = function() {
          if(getIsValidData()) {
            if(!isNullOrEmpty(mData.KeyId)) {
              var data = vm.data; // 사용자 입력 데이터
              data.AdmissionDate = moment(data.AdmissionDate).format('YYYY-MM-DD');
              data.GraduatedDate = moment(data.GraduatedDate).format('YYYY-MM-DD');
              data.mapCode = UPDATE_SQL;

              postApi.update(data, function(result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  if (result.body.docs.length > 0) {
                    $uibModalInstance.close();
                  } else {
                  }
                }
              }, function (error) {
                console.error("Error> editData()");
                console.table(error);
                gAlert('', error.body.docs[0].errMessage);
              });
            }
          }
        };

        function getIsValidData() {

          var errMsg = '';
          if (isNullOrEmpty(vm.data.Degree)) errMsg = errMsg + '- 학교구분을 선택하세요.<br/>';
          if (isNullOrEmpty(vm.data.SchoolNm)) errMsg = errMsg + '- 학교명을 입력하세요.<br/>';
          if (isNullOrEmpty(vm.data.Location)) errMsg = errMsg + '- 소재지를 선택하세요.<br/>';
          if (isNullOrEmpty(vm.data.MajorNm)) errMsg = errMsg + '- 전공명을 입력하세요.<br/>';
          if (isNullOrEmpty(vm.data.AdmissionDate)) errMsg = errMsg + '- 입학년월을 입력하세요.<br/>';
          if (isNullOrEmpty(vm.data.GraduatedDate)) errMsg = errMsg + '- 졸업년월을 입력하세요.<br/>';
          if (isNullOrEmpty(vm.data.Status)) errMsg = errMsg + '- 졸업상태를 선택하세요.<br/>';

          if (!isNullOrEmpty(errMsg)) {
            gAlert('', errMsg);
            return false;
          }
          return true;
        }



        vm.cancel = function() {
          $uibModalInstance.dismiss('cancel data');
        };

        function getData() {
          if(!mData.AddYn) {
            var data = vm.data;
            data.KeyId = mData.KeyId;
            data.mapCode = VIEW_SQL;

            postApi.select(data, function(result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                if (result.body.docs.length > 0) {
                  vm.data = result.body.docs[0];
                  vm.data.keyId = mData.KeyId;
                  
                  vm.AdmissionDate = moment(vm.data.AdmissionDate).toDate();
                  vm.GraduatedDate = moment(vm.data.GraduatedDate).toDate();
                }
              } else {
                console.error("Error> getData()");
  
                if (!isNullOrEmpty(result.body.docs)) {
                  gAlert('', result.body.docs[0].errMessage);
                }
              }
  
            }, function (error) {
              console.error("Error> getData()");
              console.table(error);
            });
          }
        }

        vm.getData = getData();

    }]);
})();
(function () {
  "use strict";
    webapp.controller('UsersqualiModalCtrl',
      ['$scope', '$uibModalInstance', 'toModalData', 'GLOBAL_CONSTANT', 'postApi', 'autoPage', '$stateParams', 'gAlert', '$window',
      function UsersqualiModalCtrl($scope, $uibModalInstance, toModalData, CONSTANT, postApi, ap, $stateParams, gAlert, $window) {
        
        var INSERT_SQL = 'User.insertUsersquali';     // 등록 SQL
        var UPDATE_SQL = 'User.updateUsersquali';     // 수정 SQL
        var VIEW_SQL = 'User.getUsersqualiDetail';

        var vm = this;
        vm.data = {}; // BASE DATA;
    
        vm.checkSave = false;
        vm.checkEdit = false;
        vm.enableSystemYn = false;

      /**
       * @description
       * # 모달팝업 데이터 설정
       */
        var mData = angular.copy(toModalData);
        mData.selectType = "Edit";

        if(!mData.AddYn) {
          vm.checkEdit = true;
        } else {
          vm.checkSave = true;
        }

        vm.setData = function() {
          if(getIsValidData()) {

            if(!isNullOrEmpty(mData.KeyId)) {
              var data = vm.data;

              data.UserId = mData.KeyId;
              data.mapCode = INSERT_SQL;
              postApi.insert(data, function(result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  if (result.body.docs.length > 0) {
                    $uibModalInstance.close();
                  } else {
                  }
                }
              }, function (error) {
                console.error("Error> setData()");
                console.table(error);
                gAlert('', error.body.docs[0].errMessage);
              });
            }
          }
        };

        vm.editData = function() {
          if(getIsValidData()) {
            if(!isNullOrEmpty(mData.KeyId)) {
              var data = vm.data; // 사용자 입력 데이터
              data.QualiDate = moment(data.QualiDate).format('YYYY-MM-DD');
              data.mapCode = UPDATE_SQL;

              postApi.update(data, function(result) {
                if (result.header.status === CONSTANT.HttpStatus.OK) {
                  if (result.body.docs.length > 0) {
                    $uibModalInstance.close();
                  } else {
                  }
                }
              }, function (error) {
                console.error("Error> editData()");
                console.table(error);
                gAlert('', error.body.docs[0].errMessage);
              });
            }
          }
        };

        function getIsValidData() {

          var errMsg = '';
          if (isNullOrEmpty(vm.data.LicenseNm)) errMsg = errMsg + '- 자격증명을 입력하세요.<br/>';
          if (isNullOrEmpty(vm.data.LicenseNo)) errMsg = errMsg + '- 자격번호를 입력하세요.<br/>';
          if (isNullOrEmpty(vm.data.QualiDate)) errMsg = errMsg + '- 취득일을 입력하세요.<br/>';
          if (isNullOrEmpty(vm.data.LicenseOffice)) errMsg = errMsg + '- 발행처를 입력하세요.<br/>';

          if (!isNullOrEmpty(errMsg)) {
            gAlert('', errMsg);
            return false;
          }
          return true;
        }



        vm.cancel = function() {
          $uibModalInstance.dismiss('cancel data');
        };

        function getData() {
          if(!mData.AddYn) {
            var data = vm.data;
            data.KeyId = mData.KeyId;
            data.mapCode = VIEW_SQL;

            postApi.select(data, function(result) {
              if (result.header.status === CONSTANT.HttpStatus.OK) {
                if (result.body.docs.length > 0) {
                  vm.data = result.body.docs[0];
                  vm.data.keyId = mData.KeyId;
                  
                  vm.QualiDate = moment(vm.data.QualiDate).toDate();
                }
              } else {
                console.error("Error> getData()");
  
                if (!isNullOrEmpty(result.body.docs)) {
                  gAlert('', result.body.docs[0].errMessage);
                }
              }
  
            }, function (error) {
              console.error("Error> getData()");
              console.table(error);
            });
          }
        }

        vm.getData = getData();

    }]);
})();
(function () {
  'use strict';
  HeaderController.$inject = ['$log', '$state', '$filter', '$cookies', '$rootScope', 'MAIN', 'LoginAPISrv', 'GLOBAL_CONSTANT', 'gAlert', '$window', 'StaticVariable', 'Auth', 'modalFactory', '$scope'];

  /** @ngInject */
  function HeaderController($log, $state, $filter, $cookies, $rootScope, MAIN, loginApi, CONSTANT, gAlert, $window, StaticVariable, Auth, modalFactory, $scope) {
    var vm = this;

    vm.srch = {};
    var translate = $filter("translate");

    //$log.info("console log info translate::", translate("LOGIN.BTN.LOGIN"));

    vm.loginInfo = {};
    vm.doLogin = doLogin;
    vm.isLogin = isLogin;
    vm.doLogout = doLogout;
    vm.doCheckSession = doCheckSession;
    vm.checkUse = false;
    vm.paddingTop = 40;

    vm.headerTitle = $window.sessionStorage["loginTenantName"];

    vm.TENANTID = "";
    vm.TENANTNAME = "";
    if ($window.sessionStorage['loginSysAdminYN'] == "Y") {
      if($window.sessionStorage['srchTenantId'] == undefined) {
        vm.TENANTID = $window.sessionStorage['loginTenantId'];
        vm.TENANTNAME = $window.sessionStorage['loginTenantName'];
        $window.sessionStorage.setItem('srchTenantId', $window.sessionStorage['loginTenantId']);
        $window.sessionStorage.setItem('srchTenantName', $window.sessionStorage['loginTenantName']);
        $rootScope.gVariable.srchTenantId = $window.sessionStorage['loginTenantId'];
        $rootScope.gVariable.srchTenantName = $window.sessionStorage['loginTenantName'];
      } else {
        vm.TENANTID = $window.sessionStorage['srchTenantId'];
        vm.TENANTNAME = $window.sessionStorage['srchTenantName'];
        $rootScope.gVariable.srchTenantId = $window.sessionStorage['srchTenantId'];
        $rootScope.gVariable.srchTenantName = $window.sessionStorage['srchTenantName'];
      }
      vm.checkUse = true;
    } else {
      $window.sessionStorage.setItem('srchTenantId', $window.sessionStorage['loginTenantId']);
      $window.sessionStorage.setItem('srchTenantName', $window.sessionStorage['loginTenantName']);
      $rootScope.gVariable.srchTenantId = $window.sessionStorage['srchTenantId'];
      $rootScope.gVariable.srchTenantName = $window.sessionStorage['srchTenantName'];
    }

    vm.srchTenantModal = function() {
      var ctrl = 'TenantModalCtrl as vc';
      var paramData = {TenantId:$rootScope.gVariable.srchTenantId}
      var modalInstance = modalFactory.open('modal', 'components/modal/tenant/tenant-modal.html', ctrl, paramData);
      modalInstance.result.then(function(okData) {
        vm.TENANTID = okData.TenantId;
        vm.TENANTNAME = okData.TenantNm;
        $window.sessionStorage.setItem('srchTenantId', okData.TenantId);
        $window.sessionStorage.setItem('srchTenantName', okData.TenantNm);
        $rootScope.gVariable.srchTenantId = okData.TenantId;
        $rootScope.gVariable.srchTenantName = okData.TenantNm;
        $rootScope.$broadcast('broadcastSetChangeTenantID', okData);
        vm.headerTitle = okData.TenantNm;
      }, function(cancelData) {});
    };

    vm.eraseTenant = function() {
      vm.TENANTID = $window.sessionStorage['loginTenantId'];
      vm.TENANTNAME = $window.sessionStorage['loginTenantName'];
      $window.sessionStorage.setItem('srchTenantId', $window.sessionStorage['loginTenantId']);
      $window.sessionStorage.setItem('srchTenantName', $window.sessionStorage['loginTenantName']);
      $rootScope.gVariable.srchTenantId = $window.sessionStorage['loginTenantId'];
      $rootScope.gVariable.srchTenantName = $window.sessionStorage['loginTenantName'];
      vm.headerTitle = $window.sessionStorage['loginTenantName'];
      $rootScope.$broadcast('broadcastSetChangeTenantID', {});
    };
    doCheckSession();

    function doLogin() {
      vm.appName = MAIN.APP_NAME;
      $log.info("account::", vm.loginInfo.account);
      $log.info("secureCode::", vm.loginInfo.secureCode);
      $state.go("main.dashboard");
    }

    $scope.$on('broadcastSetChangeTenantID', function(event, args) {
      vm.TENANTNAME = $window.sessionStorage['srchTenantName'];
    });

    function isLogin() {}

    function doLogout() {}

    function doCheckSession() {
      var prms = loginApi.doCheckSession().post({}).$promise;

      prms.then(function(json) {
        if (json != null && json.responseVO != null && json.responseVO.header.status == CONSTANT.HttpStatus.OK && json.responseVO.body.docs != null && json.responseVO.body.docs != '') {
          //console.log('Login user')
          $rootScope.setUserSession(json.responseVO.body.docs[0]);

          Auth.init(json.responseVO.body.docs[0].permissions);

          vm.userNm = $window.sessionStorage['loginUserName'];
          vm.userGbn = $window.sessionStorage['loginUserGbn'];
          vm.userTerm = $window.sessionStorage['loginUserTerm'];

        } else {
          StaticVariable.sessionExpire();
          $state.go('login');
        }
        // gAlert("로그아웃 되었습니다.");
      }, function(error) {
        console.error('fail', status);
      });
    }
  }
  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPosHeader
   * @description
   * # adminPosHeader
   */
  var header = {
    transclude: true,
    controller: HeaderController,
    bindings: {},
    controllerAs: "header",
    templateUrl: 'components/ui-component/layout/header/header.html'
  };

  webapp.component("header", header);
})();


(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name izzyposWebApp.directive:adminPosHeader
   * @description
   * # adminPosHeader
   */
  SidebarController.$inject = ['GLOBAL_CONSTANT', 'postApi', '$scope', '$rootScope', '$state', '$filter', 'Helper', '$window'];
  function SidebarController(CONSTANT, postApi, $scope, $rootScope, $state, $filter, Helper, $window) {

    var LIST_PAGE_URL = 'app.eland-request.take-list';
    var LIST_PAGE_URL_REG = 'app.company.company-list';
    var vm = this;
    vm.selectedMenu = 'dashboard';
    vm.collapseVar = 0;
    vm.secondCollapseVar = -1;
    vm.threeCollapseVar = -1;
    vm.menuList = [];
    vm.markList = [];
    vm.tenantType = $window.sessionStorage['loginTenantType'];                          // 회원사 타입;
    vm.regRequestCnt = 0;
    vm.giveTenantCnt = 0;
    vm.takeRequestCnt = 0;
    vm.check = function (x) {
      if (x == vm.collapseVar)
        vm.collapseVar = 0;
      else
        vm.collapseVar = x;
    };

    vm.secondCheck = function (y) {
      if (y == vm.secondCollapseVar)
        vm.secondCollapseVar = 0;
      else
        vm.secondCollapseVar = y;
    };

    vm.threeCheck = function (y) {
      if (y == vm.threeCollapseVar)
        vm.threeCollapseVar = 0;
      else
        vm.threeCollapseVar = y;
    };

    vm.navMenuMdSizeState = window.localStorage.getItem("navMenuMdSizeState");

    $scope.$on('broadcastSetChangeMenuList', function(event, args) {
      vm.loadMenuData();
    });

    vm.loadMenuData = function () {
      vm.menuList = [];
      var mobileOnlyYN = "N";
      //if(checkMobile()) mobileOnlyYN = 'Y';
      var data = { mapCode: 'getMenuList2', mobileOnlyYN : mobileOnlyYN};
      postApi.select(data, function (result) {
        if (result != null && result.header != null && result.header.status === CONSTANT.HttpStatus.OK) {
          vm.makeMenuList(result.body.docs, true);
          //var count = result.body.docs.length;
          var interval = setInterval(function() {
            if( vm.menuList.length > 0) {
              $(".sz-custom-navbar-toggle").css("display","block");
              initNavView();
              clearInterval(interval);
            }
          }, 600);
        } else {
          if (result != null && result.header != null && result.body != null)
            console.error('Error> setBaseMenuInfo', result.header.status, result.body.docs[0]);
          else
          console.error('Error> setBaseMenuInfo');
        }
      }, function (error) {
        console.error('Error> setBaseMenuInfo', error);
      });
    };
    vm.loadMenuData();

    function makeSortPath(sort) {

      var sort = sort.toString();
      var result = Array();
      if(sort.length >= 3) {
        result.push(sort.substring(0, 3));
      }
      if(sort.length >= 6) {
        result.push(sort.substring(3, 6))
      }
      if(sort.length == 9) {
        result.push(sort.substring(6, 9))
      }
      return result;
    }
    vm.makeMenuList = function (data) {

      /* temp :
        Menu에 바로 데이터를 바인딩할 경우
        바인딩한 데이터를 바로 화면에 그리기 때문에 속도에 문제가 있어
        temp 에서 선 작업 한 후 메뉴리스트에 값을 대입
      */
      var temp = [];
      var bFoundMainPage = false;
      var mainPage = '';

      var tenantId = $window.sessionStorage.getItem("loginTenantId");
      for (var i = 0; i < data.length; i++) {
        var o = {};
        o.menuId = data[i].menuId;
        o.depth = data[i].depth;
        o.name = data[i].menuNm;
        o.icon = data[i].icon;
        o.sort = data[i].sort;
        o.tempSortPath = makeSortPath(data[i].sort);
        o.idx = i;

        if(data[i].menuCode != null && data[i].menuCode != undefined) {
          o.menuCode = data[i].menuCode;
        }
        o.child = [];

        o.pageUrl = data[i].pageUrl;
        o.pageUrlParam = data[i].pageUrlParam;
        if(o.pageUrl == "app.system.company-list") {
          if (tenantId != '0') {
            o.pageUrl = "app.system.company-edit.tab1"
            o.pageUrlParam = "({srch:'', keyId:' " + tenantId + "'})"
          }
        }

        if (Number(data[i].depth) == 1) {
          temp.push(o);
        } else {
          var temp2;
          if(o.tempSortPath.length == 2) temp2 = o.tempSortPath[0];
          else temp2 = o.tempSortPath[0] + '' + o.tempSortPath[1];
          var sData = vm.findObject(temp, 'sort', temp2);
          if (sData['child'])
            sData['child'].push(o);
        }

        // var page = Helper.stateIs(data[i].pageUrl);
        // if (page == $rootScope.gVariable.mainPage) {
        //   bFoundMainPage = true;
        // }
      }

      // if (!bFoundMainPage && data.length > 0) {
      //   $rootScope.setGVariable('mainPage', Helper.stateIs(data[0].pageUrl));
      //   $state.go(data[0].pageUrl);
      // }

      vm.menuList = temp;
    };

    vm.findObject = function (obj, key, value) {
      for (var i = 0; i < obj.length; i++) {
        for (var objKey in obj[i]) {
          if (objKey == key) {
            if (obj[i][objKey] == value) {
              return obj[i];
            }
          }
        }
        if (obj[i]["child"].length > 0) {
          var result = vm.findObject(obj[i]["child"], key, value);
          if (result != false) return result;
        }
      }
      return false;
    };

    vm.goList = function(data) {
      if (data == 'REG') {
        $state.go(LIST_PAGE_URL_REG, {
          srch: '',
          Type: 'Manage'
        });
      } else if (data == 'REQ') {
        $state.go(LIST_PAGE_URL, {
          srch: '',
          type: '',
          status : 'RG'
        });
      } else {
        $state.go(LIST_PAGE_URL, {
          srch: '',
          type: '',
          status : 'AT'
        });
      }
    };
    // function getData() {
    //   var srch = {};
    //   srch.mapCode = "MaDatagroup.getDatagroupAndAction";

    //   var prms = postApi.select(srch, function(result) {
    //     if (result.header.status === CONSTANT.HttpStatus.OK) {
    //       if (result.body.docs.length == 0) {
    //         $rootScope.setGVariable('dataGroupId', '');
    //         $rootScope.setGVariable('dataActionId', '');
    //         $rootScope.setGVariable('dataGroupNm', '');
    //         $rootScope.setGVariable('dataActionNm', '');
    //       } else {
    //         var data = result.body.docs[0];
    //         $rootScope.setGVariable('dataGroupId', data.DatagroupId);
    //         $rootScope.setGVariable('dataActionId', data.ActionId);
    //         $rootScope.setGVariable('dataGroupNm', data.DatagroupNm);
    //         if (data.ActionId) {
    //           $rootScope.setGVariable('dataActionNm', data.ActionNm + ' (' + $filter('utcToLocal')(data.ABeginDate,'yyyy-MM-dd') + '~' + $filter('utcToLocal')(data.AEndDate,'yyyy-MM-dd') + ')');
    //         }
    //       }
    //     }
    //   }, function(error) {
    //     console.table(error);
    //   });
    // }

    // getData();

    function getBookmarkList(){
      var data = {};
      data.mapCode = 'Bookmark.getBookmarkList';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if(result.body.docs.length > 0){
            vm.markList = result.body.docs;
          }else{
            vm.markList = [];
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getBookmarkList()");
        console.table(error);
      });
    }

    function getSideBarCount(){
      var data = {};
      data.mapCode = 'Take.getSideBarCount';
      postApi.select(data, function(result){
        if (result.header.status === CONSTANT.HttpStatus.OK) {
          if(result.body.docs.length > 0){
            vm.regRequestCnt = result.body.docs[0].Cnt;
            vm.takeRequestCnt = result.body.docs[1].Cnt;
            vm.giveTenantCnt = result.body.docs[2].Cnt;
          }else{
            vm.regRequestCnt = 0;
            vm.takeRequestCnt = 0;
            vm.giveTenantCnt = 0;
          }
        }
      }, function (error) {
        // 조회 중 오류 발생
        console.error("Error> getSideBarCount()");
        console.table(error);
      });
    }
    //getSideBarCount();
    getBookmarkList();
  }

  // Header 쪽에 선언 하는 것이 맞으나
  // 소스 찾기가 어려울 것 같아 한 곳에 선언
  // Window Resize Event에 따른 HTML 에 사이즈 선언 함
  /**
* @description
*  메뉴 초기 설정
*/
  function initNavView() {

    setOsAgent();
    setToggleBtnEvent();
    setMenuEvent();
    setResizeEvent();
    setTimeout(function(){
      $(".side_wrapper").mCustomScrollbar();
    },1000);
  }

  function setMenuEvent() {

    $("html.sidebar-on-top2 .sidebar-nav > ul > li > a").click(function(e) {
      $("html.sidebar-on-top2 .sidebar-nav").addClass("on");
    });

    $("html.sidebar-on-top2 .sidebar-nav > ul > li > ul a").click(function(e) {
      $("html.sidebar-on-top2 .sidebar-nav").removeClass("on");
    });
    

    $(".sidebar-nav > ul > li > a").click(function(e) {
      var currentState = $("body").attr("nav-state").split("-");
      if(currentState[0] == "md") {
        if(currentState[1].indexOf('rm') > -1 || currentState[1].indexOf('lm') > -1 || currentState[1].indexOf('s') > -1) {
          e.stopImmediatePropagation();
        }
      }
    });

    $(".sidebar-nav  ul  li  a").click(function(e) {
      if( $(this).attr("ui-sref") != undefined && $(this).attr("ui-sref") != "" ) {
        e.stopImmediatePropagation();
        var aThis = $(this);
        setTimeout(function(){
          $(".sidebar-nav  ul  li").removeClass("active");
          $(aThis).closest("li").addClass("active");
          $(aThis).closest("li").parent().closest("li").addClass("active");
          $(aThis).closest("li").parent().closest("li").parent().closest("li").addClass("active");
        },0);
      } else {

      }
    });

    $(".sidebar-nav > ul > li").hover(function(e) {
      var currentState = $("body").attr("nav-state").split("-");
      if(currentState[0] == "md") {
        if(currentState[1].indexOf('rm') > -1 || currentState[1].indexOf('lm') > -1 || currentState[1].indexOf('s') > -1) {

          $(this).addClass('active');
          $(this).find("> ul").css("overflow","auto");
          $(this).find("> ul").addClass("in");
          $(this).find("> ul").css("height", "auto");
          $(this).find("> ul").attr("aria-expanded", "true");
          $(this).find("> ul").attr("aria-hidden", "false");

          var offset = $(this).offset();
          $(this).find("> ul").css("top", offset.top);
          var $ulObj = $(this).find("> ul");
          var $thisObj = $(this);
          var ulHeight = ($ulObj.find('li').height() * $ulObj.find('li').length)
          if(offset.top + ulHeight > $(window).height()) {
            $ulObj.css("top","");
            $ulObj.css("bottom", $(window).height() - offset.top - $thisObj.height());
          }
        } else {
          $(this).find("> ul").css("top", "");
          $(this).find("> ul").css("bottom", "");
        }
      } else {
        $(this).find("> ul").css("top", "");
        $(this).find("> ul").css("bottom", "");
      }
    }, function(e){
      var currentState = $("body").attr("nav-state").split("-");
      if(currentState[0] == "md") {
        if(currentState[1].indexOf('rm') > -1 || currentState[1].indexOf('lm') > -1 || currentState[1].indexOf('s') > -1) {

          $(this).removeClass('active');
          $(this).find("> ul").removeClass("in");
          $(this).find("> ul").css("overflow","");
          $(this).find("> ul").css("height", "0px");
          $(this).find("> ul").attr("aria-expanded", "false");
          $(this).find("> ul").attr("aria-hidden", "true");

        } else {
          $(this).find("> ul").css("top", "");
          $(this).find("> ul").css("bottom", "");
        }
      } else {
        $(this).find("> ul").css("top", "");
        $(this).find("> ul").css("bottom", "");
      }
    });
  }

  /**
  * @description
  *  OS Agent 설정
  */
  function setOsAgent() {
    var isMobile = false;

    // Mobile 여부 확인
    if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
      || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4)))
      isMobile = true;

    if (isMobile) {
      $("body").attr("is-device", "Y");
    } else {
      $("body").attr("is-device", "N");
    }

  }

  function changeNavState() {
    var currentState = $("body").attr("nav-state").split("-");
    var winWidth = $(window).width();

    if (winWidth < 768 ) {
      (currentState[1] == "on") ? currentState[1] = "off" : currentState[1] = "on";
      $("body").attr("nav-state", currentState[0] + "-" + currentState[1])
      if(currentState[1] == "on") setBlockLayer();
      else $("#nav-block-screen").detach();
    } else {
      var localStorage = window.localStorage;
      var navState = localStorage.getItem("navMenuMdSizeState");
      $("body").attr("nav-state", currentState[0] + "-" + navState);
    }
    setToggleImage();
  }

  /**
  * @description
  *  초기 페이지 진입시 Layer 설정
  */
  function setBlockLayer() {
    var $div = $("<div />", {
      id: "nav-block-screen",
      onclick: "changeNavState();"
    });
    $("html body").append($div.clone());
    $("#nav-block-screen").bind("click", function(){
      changeNavState();
    });
  }



  /**
  * @description
  *  토글 버튼 클릭시 nav state 값 변경
  */
  function setToggleBtnEvent() {
    $(".sz-custom-navbar-toggle").bind("click", function () {
      $(this).addClass("focus");
      var winWidth = $(window).width();

      if (winWidth < 768 ) {
        changeNavState();
      } else {
        var localStorage = window.localStorage;
        var navState;
        if( $("body").attr("nav-state") != undefined) navState = $("body").attr("nav-state").split("-")[1];
        else navState = localStorage.getItem("navMenuMdSizeState");
        if(navState == "l") {
          navState = "lm";
          hiddenSecondMenus()
        } else if(navState == "lm") {
          navState = "s";
          hiddenSecondMenus()
        } else if(navState == "s") {
          navState = "rm";
          hiddenSecondMenus()
        } else if(navState == "rm") {
          navState = "l";
          $(".side_bookmark").css("display","block");
        }
        localStorage.setItem('navMenuMdSizeState', navState);
        changeNavState();
      }

      setTimeout(function () { $(".sz-custom-navbar-toggle").removeClass("focus"); }, 150);
    });
  }

  function hiddenSecondMenus() {
    //$(".sidebar-nav > ul > li > ul").removeClass('active');
    $(".sidebar-nav > ul > li > ul").removeClass("in");
    $(".sidebar-nav > ul > li > ul").css("overflow","");
    $(".sidebar-nav > ul > li > ul").css("height", "0px");
    $(".sidebar-nav > ul > li > ul").attr("aria-expanded", "false");
    $(".sidebar-nav > ul > li > ul").attr("aria-hidden", "true");
    $(".side_bookmark").css("display","none");
    

  }

  function setToggleImage() {

    if ($(window).width() < 768 ) {
      $(".sz-custom-navbar-toggle i").removeClass('fa-outdent');
      $(".sz-custom-navbar-toggle i").removeClass('fa-indent');
      $(".sz-custom-navbar-toggle i").addClass('fa-bars');
    } else {
      var localStorage = window.localStorage;
      var navState = localStorage.getItem("navMenuMdSizeState");
      $(".sz-custom-navbar-toggle i").removeClass('fa-bars');
      if(navState == "l") {
        $(".sz-custom-navbar-toggle i").addClass('fa-outdent');
        $(".sz-custom-navbar-toggle i").removeClass('fa-indent');
      } else if(navState == "lm") {
        $(".sz-custom-navbar-toggle i").addClass('fa-outdent');
        $(".sz-custom-navbar-toggle i").removeClass('fa-indent');
      } else if(navState == "s") {
        $(".sz-custom-navbar-toggle i").removeClass('fa-outdent');
        $(".sz-custom-navbar-toggle i").addClass('fa-indent');
      } else if(navState == "rm") {
        $(".sz-custom-navbar-toggle i").removeClass('fa-outdent');
        $(".sz-custom-navbar-toggle i").addClass('fa-indent');
      }
    }
  }

  /**
  * @description
  *  화면 사이즈 변경 시 html element에 nav state 값을 변경해주는 함수
  */
  function setResizeEvent() {
    $(window).resize(function () {
      initNavState();
    });
  }

  /**
  * @description
  *  window 넓이에 따른 값 셋팅
  */
  function initNavState() {
    var winWidth = $(window).width();
    if (winWidth < 560) $("body").attr("nav-state", "xs-off");
    else if (winWidth < 768) $("body").attr("nav-state", "sm-off");
    else if (winWidth > 767 ) {

      if($("#nav-block-screen").length > 0) $("#nav-block-screen").detach();
      var localStorage = window.localStorage;
      var navState = localStorage.getItem("navMenuMdSizeState");
      if(navState == null || navState == undefined || navState == "on" || navState == "off") {
        navState = "l";
        localStorage.setItem('navMenuMdSizeState', navState);
      }
      $("body").attr("nav-state", "md-" + navState);
    }
    setToggleImage();
  }

  angular.module('salevis4-web')
    .component('sidebar', {
      templateUrl: 'components/ui-component/layout/sidebar/sidebar.html',
      controller: SidebarController,
      controllerAs: 'sidebar'
    });

})();

(function () {
    'use strict';

    HeaderNotificationController.$inject = ['$log','$window','LoginAPISrv','StaticVariable','GLOBAL_CONSTANT', 'gAlert', '$state', 'modalFactory', '$rootScope', 'postApi'];
    /** @ngInject */
    function HeaderNotificationController($log, $window, loginApi, StaticVariable, CONSTANT, gAlert, $state, modalFactory, $rootScope, postApi) {
      var vm = this;
      vm.srch = {};
      vm.user = {UserName:$rootScope.gVariable.UserName};
      vm.doLogout = doLogout;
      vm.myPage = myPage;
      vm.checkUse = false;
      vm.tenantId = $window.sessionStorage.loginTenantId;
      vm.goDetail = goDetail;
      vm.layout = $rootScope.gVariable.layoutBoard;
      vm.getUnReadContent = getUnReadContent;

      vm.sumUnReadCnt = 0;

      function doLogout() {
        StaticVariable.sessionExpire();
        var prms = loginApi.doLogout().post().$promise;
        prms.then(function(json) {
          var temp = {};
          temp.layoutBoard = "N";
          $window.sessionStorage.clear();
          $window.sessionStorage["layoutBoard"] = temp.layoutBoard;
          gAlert('', 'Menu.SIGNEDOUT', {
            btn : '',
            fn : function() {
              //$window.location.replace('/' + CONSTANT.URL.CONTEXT);
              //$state.reload('main.login');
              // $window.location.replace('/#/home/main');
              $window.location.href="/";
            }
          });
        }, function(error) {
          console.error('fail', status);
        });
      }

      /**
       * 내정보 수정 팝업 호출
       *
       */
      function myPage() {
        var ctrl = 'MyPageModalCtrl as modalCtrl';
        var paramData = {UserId : $rootScope.gVariable.UserId, TenantId: $window.sessionStorage["loginTenantId"]};
        var modalInstance = modalFactory.open("lg", "components/modal/mypage/mypage-modal.html", ctrl, paramData);
        modalInstance.result.then(
          function (okData) {
            //성공
          },
          function (cancelData) {
            // 취소
          }
        );
      }
      
      vm.goPage = function() {
        $state.go("app.company.company-take-list", { srch: ""});
      }

      function getSumUnReadCnt() {
        var data = angular.copy(vm.srch);
        data.SESSION_USERID =  $rootScope.gVariable.UserId;
        data.ChatId = "1";
        data.mapCode = 'FreeChat.getSumUnReadCnt';
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.sumUnReadCnt = result.body.docs[0];
            } else {
              vm.sumUnReadCnt = 0;
            }
          }
            vm.dataloader = false;
          }
        );
      }

      function getUnReadContent() {
        getSumUnReadCnt();
        console.log('getUnReadContent');
        var data = angular.copy(vm.srch);
        data.SESSION_USERID = $rootScope.gVariable.UserId;
        data.mapCode = 'FreeChat.getUnReadContent';
        postApi.select(data, function (result) {
          if (result.header.status === CONSTANT.HttpStatus.OK) {
            if (result.body.docs.length > 0) {
              vm.unReadContentList = result.body.docs;
            }
          }
        });
      }

      /* setInterval(function(){
        getSumUnReadCnt();
      }, 3000); */

      //$scope.selectedRow = $stateParams.FreeChatId;

      function goDetail(FreeChatId) {
        angular.forEach(vm.unReadContentList, function(item) {
          if (item.FreeChatId == FreeChatId) {
            vm.unReadContentList = [];
            return;
          }
        });
        //var srch = $stateParams.srch;
        //$scope.selectedRow = FreeChatId;
        if (vm.layout == "N") {
          $state.go("app.chatting.h0201-roomdetail", {
            FreeChatId: FreeChatId
          });
        } else {
          $state.go("app.chatting.h0201-roomlist.detail", {
            FreeChatId: FreeChatId
          });
        }
      }

      getSumUnReadCnt();

    } // End Controller

    var header = {
      transclude: true,
      controller: HeaderNotificationController,
      bindings: {},
      controllerAs: "vc",
      templateUrl: 'components/ui-component/layout/header/header-notification/header-notification.html'
    };

    webapp.component("headerNotification", header);

})();

(function () {
    'use strict';

    /**
     * @ngdoc directive
     * @name izzyposWebApp.directive:adminPosHeader
     * @description
     * # adminPosHeader
     */

    angular.module('salevis4-web')
        .component('sidebarSearch', {
            templateUrl: 'components/ui-component/layout/sidebar/sidebar-search/sidebar-search.html',
            controller: function ($scope) {
                $scope.selectedMenu = 'home';
            }
        });
})();

angular.module("salevis4-web").run(["$templateCache", function($templateCache) {$templateCache.put("index.html","<!doctype html><html ng-app=salevis4-web><!-- test --><head><title>SOS위고</title><meta charset=utf-8><meta name=description content=\"\"><meta name=viewport content=\"width=device-width,initial-scale=1,maximum-scale=1,user-scalable=no\"><meta http-equiv=Expires content=-1><meta http-equiv=Pragma content=no-cache><meta http-equiv=Cache-Control content=No-Cache><!-- Place favicon.ico and apple-touch-icon.png in the root directory --><!-- build:css({.tmp/serve,src}) styles/vendor.css --><!-- bower:css --><!-- run `gulp inject` to automatically populate bower styles dependencies --><!-- endbower --><!-- endbuild --><!-- build:css({.tmp/serve,src}) styles/app.css --><!-- inject:css --><!-- css files will be automatically insert here --><!-- endinject --><!-- endbuild --><!-- 공지팝업 CSS\r\n    <style type=\"text/css\">\r\n    .dim-layer .modal-popup-cover {\r\n      min-width: 320px;\r\n      height: 100vh;\r\n      position: relative;\r\n      letter-spacing: -0.55px;\r\n      display: flex;\r\n      align-items: center;\r\n      justify-content: center;\r\n      overflow: hidden;\r\n      box-sizing: border-box;\r\n      overflow-x: none;\r\n    }\r\n\r\n    .dim-layer .popup-inner {\r\n      min-width: 500px;\r\n      max-width: 60%;\r\n      -webkit-box-shadow: 0px 0px 35px -9px rgb(0 0 0 / 75%);\r\n      -moz-box-shadow: 0px 0px 35px -9px rgba(0,0,0,0.75);\r\n      box-shadow: 0px 0px 35px -9px rgb(0 0 0 / 75%);\r\n      border-radius: 4px;\r\n      background-color: #ffffff;\r\n    }\r\n\r\n    .dim-layer .popup-inner .inner-header, .popup-inner .inner-body {\r\n      text-align: center;\r\n      margin-top : 35px;\r\n    }\r\n\r\n    .dim-layer .inner-header strong {\r\n      font-size: 30px;\r\n      font-weight: 800;\r\n      color: #333;\r\n      z-index: 3;\r\n      position: relative;\r\n    }\r\n\r\n    .dim-layer .inner-body {\r\n      padding: 25px 20px;\r\n      background-color: #fff;\r\n    }\r\n\r\n    .dim-layer .inner-body strong {\r\n      font-size: 23px;\r\n      letter-spacing: -1px;\r\n      font-weight: 800;\r\n      color: #0072d6;\r\n    }\r\n\r\n    .dim-layer .body-info {\r\n      border-radius: 8px;\r\n      background-color: #f1f3f5;\r\n      padding: 15px 15px 15px 25px;\r\n      border: 1px solid #e6e8eb;\r\n      font-size: 14px;\r\n      line-height: 20px;\r\n      margin-top: 20px;\r\n      color: #343a40;\r\n      text-align: left;\r\n    }\r\n\r\n    .dim-layer .inner-footer {\r\n      text-align : right;\r\n      height: 50px;\r\n      border-top: 1px solid #e6e9eb;\r\n      line-height: 50px;\r\n      padding: 0 30px;\r\n      background-color: #f8f9fa;\r\n      font-size: 13px;\r\n      color: #495057;\r\n    }\r\n\r\n    .dim-layer .inner-footer #chkbox {\r\n      margin: auto 2px;\r\n    }\r\n\r\n    .dim-layer .inner-footer input {\r\n      height: 30px;\r\n      vertical-align: middle;\r\n    }\r\n\r\n    .dim-layer .inner-footer input {\r\n      height: 30px;\r\n      vertical-align: middle;\r\n    }\r\n\r\n  </style> --></head><body><!--[if lt IE 10]>\r\n    <p class=\"browsehappy\">최신 웹 브라우저로 업그레이드 하시기 바랍니다. (권장: Internet Explorer 11 이상, Google Chrome 76 이상). <a\r\n      href=\"http://browsehappy.com/\">최신 웹 브라우저 다운로드</a></p>\r\n    <![endif]--><div ui-view style=\"height: 100%\"><div class=loading-container><div class=loading></div><div id=loading-text>loading...</div></div></div><!-- build:js(src) scripts/vendor.js --><!-- bower:js --><!-- run `gulp inject` to automatically populate bower script dependencies --><!-- endbower --><!-- endbuild --><!-- build:js({.tmp/serve,.tmp/partials,src}) scripts/app.js --><!-- inject:js --><!-- js files will be automatically insert here --><!-- endinject --><!-- inject:partials --><!-- angular templates will be automatically converted in js and inserted here --><!-- endinject --><!-- endbuild --><link rel=stylesheet href=assets/css/common.css><link rel=stylesheet href=assets/css/custom-media-width-size.css><link rel=stylesheet href=assets/css/fullcalendar.min.css><link rel=stylesheet href=assets/css/scheduler.min.css><link rel=stylesheet href=assets/css/main.css><link rel=stylesheet href=assets/css/timedropper.css><link rel=stylesheet href=assets/css/emojionearea.min.css><link rel=stylesheet href=assets/css/eland-detail.css><link rel=stylesheet href=assets/css/eland-login.css><link rel=stylesheet href=assets/css/eland.css><!-- Swiper 5.4.5 CSS --><link rel=stylesheet href=https://unpkg.com/swiper@5.4.5/css/swiper.min.css><!-- Swiper 5.4.5 JS --><script src=https://unpkg.com/swiper@5.4.5/js/swiper.min.js></script><script src=assets/app/common/emojionearea.min.js></script><script src=assets/global-constant.js></script><script src=assets/app/common/common.js></script><!--<script src=\"http://dmaps.daum.net/map_js_init/postcode.v2.js\"></script>--><!-- SSL 적용시 호출 --><script src=https://t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js></script><script src=https://service.iamport.kr/js/iamport.payment-1.1.4.js></script><script src=assets/app/common/FileSaver.min.js></script><script src=assets/app/common/xlsx.full.min.js></script><script src=assets/app/common/fullcalendar.min.js></script><script src=assets/app/common/scheduler.min.js></script><script src=assets/app/common/locale-all.js></script><script src=assets/app/common/signature_pad.min.js></script><script src=assets/js/convertKoEn.js></script><script src=https://cdn.jsdelivr.net/npm/marked/marked.min.js></script><script src=https://cdn.jsdelivr.net/npm/dompurify@3.0.5/dist/purify.min.js></script><!-- 공지 팝업\r\n      <div class=\"dim-layer\" id=\"dim-layer\" style=\"position: fixed; _position: absolute; top: 0; left: 0; width: 100%; height: 100%; z-index: 100;\">\r\n      <div class=\"dimBg\" style=\"position: absolute; top: 0; left: 0; width: 100%; height: 100%; background: #000; opacity: 0.2;\"></div>\r\n      \r\n      <div id=\"Notice\" class=\"modal-popup-cover\">\r\n        <div class=\"popup-inner\">\r\n          <div class=\"inner-header\">\r\n            <strong>시스템 점검 공지안내</strong>\r\n            <p>시스템 점검으로 서비스 이용이 제한될 수 있으니 양해바랍니다.</p>\r\n          </div>\r\n          <div class=\"inner-body\">\r\n            <strong class=\"fnt-blue\">작업 일시 : 2021.06.22 (화) 09:00~18:00</strong>\r\n            <div class=\"body-info\">\r\n              ※ 상기 작업 시간은 사정에 의해 변경될 수 있습니다<div class=\"br\"></div>\r\n              ※ 예정된 시간에 작업을 완료하도록 최선을 다하겠습니다.\r\n            </div>\r\n          </div>\r\n          <div class=\"inner-footer\">\r\n            <span>\r\n              <label for=\"chkbox\">\r\n                <input type=\"checkbox\" id=\"chkbox\" onclick=\"javascript: closeToday();\" />오늘 더이상 보이지 않기\r\n              </label>\r\n            </span>\r\n            <span>\r\n              <input type=\"button\" class=\"btn btn-default\" onclick=\"javascript:closePop();\" value=\"창 닫기\" />\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div> --><script>window.addEventListener(\'DOMContentLoaded\', function () {\r\n        const chatBot = document.getElementById(\'chatBot\');\r\n        if (!chatBot) return;\r\n      \r\n        let isDragging = false;\r\n        let offsetX = 0;\r\n        let offsetY = 0;\r\n        let moved = false;\r\n      \r\n        chatBot.addEventListener(\'mousedown\', function (e) {\r\n          isDragging = true;\r\n          moved = false;\r\n          offsetX = e.clientX - chatBot.getBoundingClientRect().left;\r\n          offsetY = e.clientY - chatBot.getBoundingClientRect().top;\r\n          e.preventDefault();\r\n        });\r\n      \r\n        document.addEventListener(\'mousemove\', function (e) {\r\n          if (!isDragging) return;\r\n      \r\n          moved = true;\r\n      \r\n          let newLeft = e.clientX - offsetX;\r\n          let newTop = e.clientY - offsetY;\r\n      \r\n          // 👉 방어: chatBot 렌더 안 됐으면 중단\r\n          const width = chatBot.offsetWidth || 130;\r\n          const height = chatBot.offsetHeight || 130;\r\n      \r\n          const maxLeft = window.innerWidth - width;\r\n          const maxTop = window.innerHeight - height;\r\n      \r\n          newLeft = Math.max(0, Math.min(newLeft, maxLeft));\r\n          newTop = Math.max(0, Math.min(newTop, maxTop));\r\n      \r\n          chatBot.style.left = `${newLeft}px`;\r\n          chatBot.style.top = `${newTop}px`;\r\n          chatBot.style.right = \'auto\';\r\n          chatBot.style.bottom = \'auto\';\r\n        });\r\n      \r\n        document.addEventListener(\'mouseup\', function () {\r\n          isDragging = false;\r\n        });\r\n      \r\n        // 클릭 방지\r\n        const link = chatBot.querySelector(\'a\');\r\n        link.addEventListener(\'click\', function (e) {\r\n          if (moved) {\r\n            e.preventDefault();\r\n            e.stopPropagation();\r\n          }\r\n        });\r\n      });\r\n      \r\n      function resetChatBotPosition() {\r\n        const chatBot = document.getElementById(\'chatBot\');\r\n        if (!chatBot) return;\r\n\r\n        chatBot.style.left = \'auto\';\r\n        chatBot.style.top = \'auto\';\r\n        chatBot.style.right = \'30px\';\r\n        chatBot.style.bottom = \'30px\';\r\n      }</script><div class=chat-bot id=chatBot><a href=https://pf.kakao.com/_Fixnxgxj target=_blank class=chat-bot-button><img src=../assets/images/icon/ai-icon.png alt=\"ai 상담 챗봇\"></a></div></body><script>// Popup 띄우기 	\r\n	/* $(function(){\r\n                \r\n		if(document.cookie.indexOf(\"dim-layer=close\") < 0 ){      // 쿠키 저장여부 체크\r\n			document.getElementById(\"dim-layer\").style.display = \"block\";\r\n		} else {\r\n			document.getElementById(\"dim-layer\").style.display = \"none\"; \r\n		}\r\n	});\r\n\r\n	// 쿠키 생성\r\n	function setCookie( name, value, expiredays ) {  // 쿠키저장\r\n		var todayDate = new Date();  //date객체 생성 후 변수에 저장\r\n		todayDate.setDate( todayDate.getDate() + expiredays ); \r\n   	 \r\n		// 시간지정(현재시간 + 지정시간)\r\n		document.cookie = name + \"=\" + value + \"; path=/; expires=\" + todayDate.toUTCString() + \";\"\r\n	} \r\n             \r\n	//오늘하루만보기 닫기버튼 스크립트\r\n	function closeToday() { \r\n		setCookie( \"dim-layer\", \"close\" , 1  ); \r\n	\r\n		$(\"#dim-layer\").css(\"display\", \"none\");\r\n		document.getElementById(\"dim-layer\").style.display = \"none\";\r\n	}\r\n\r\n	//닫기버튼 스크립트\r\n	function closePop() { \r\n		document.getElementById(\"dim-layer\").style.display = \"none\";\r\n	} */</script></html>");
$templateCache.put("app/app.html","<div id=wrapper><!-- Navigation --><!-- <div ui-view=\"header\"></div> --><header ng-if=\"$root.gVariable.noHeader == \'false\'\"></header><sidebar></sidebar><!-- /.navbar-top-links --><!-- /.navbar-static-side --><div id=page-wrapper style=\"min-height: 561px\"><div ui-view></div></div><!-- /#page-wrapper --></div>");
$templateCache.put("app/board/bbs-master-detail.html","<div class=\"page page-footable\" ng-controller=\"BbsMasterDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>게시판 관리</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>마스터아이디</label><div class=\"form-control txt_view\" ng-bind=vc.data.BbsMasterId></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>게시판명</label><div class=\"form-control txt_view\" ng-bind=vc.data.BbsNm></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BbsType\'].ColumnLogicalNm | translate}}<span class=point_red ng-show=\"vc.data.BbsType == \'\'\">*</span></label><div class=\"form-control txt_view\">{{$root.getCodeValue(vc.columnMap[\'BbsType\'].CodeList, vc.data.BbsType)}}</div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>메타테이블 TableNm</label><div class=\"form-control txt_view\" ng-bind=vc.data.MetatableNm></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC04\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=\"vc.data.RegDate | utcToLocal:\'yyyy-MM-dd hh:mm\'\"></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12\"><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Remark></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/board/bbs-master-edit.html","<div class=\"page page-footable\" ng-controller=\"BbsMasterEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>게시판 관리</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>마스터아이디</label><input type=text class=form-control ng-model=vc.data.BbsMasterId readonly></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>게시판명</label><input type=text class=form-control ng-model=vc.data.BbsNm></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BbsType\'].ColumnLogicalNm | translate}}<span class=point_red ng-show=\"vc.data.BbsType == \'\'\">*</span></label><common-code-custom code-list=\"vc.columnMap[\'BbsType\'].CodeList\" code-model=vc.data.BbsType></common-code-custom></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>메타테이블 TableNm</label><input type=text class=form-control ng-model=vc.data.MetatableNm></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC03\' | translate }}</label><input type=text class=form-control ng-model=vc.data.RegUserNm readonly></div></div><div class=\"col-lg-4 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC04\' | translate }}</label><div class=form-control ng-bind=\"vc.data.RegDate | utcToLocal:\'yyyy-MM-dd hh:mm\'\"></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Remark></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/bbs-master-list.html","<div class=\"page page-footable\" ng-controller=\"BbsMasterListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>게시판 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size={{$root.gVariable.layoutBoardSize}} pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.BbsNm placeholder=\"게시판명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.BbsNm type=text><label>게시판명</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.getExcel()><i class=\"fa fa-file-excel-o\"></i> {{ :: \'Menu.EXCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.EM630\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.BbsMasterId, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.BbsMasterId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=40>{{li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd HH:mm\'}}</span> <span ng-switch-when=50>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60>{{$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm]) | html}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></tbody></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/bbs-popup-detail.html","<div class=\"page page-footable\" ng-controller=\"BbsPopupDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>팝업공지관리 조회</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit() ng-if=\"($root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\')\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-if=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.Title></span></div></div></div><div class=row><div class=col-lg-4 ng-if=\"vc.columnMap[\'StartDT\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'StartDT\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.StartDT></span></div></div><div class=col-lg-4 ng-if=\"vc.columnMap[\'EndDT\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EndDT\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.EndDT></span></div></div><div class=col-lg-4 ng-if=\"vc.columnMap[\'StartDT\']\"><div class=\"form-group form-inline\"><label>크기</label><span class=form-control>{{vc.data.ImgW}} * {{vc.data.ImgH}}</span></div></div></div><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'GoLink\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'GoLink\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.GoLink></span></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div ng-if=\"vc.uploadFileList.length > 0\" style=margin-left:95px><a href={{vc.uploadFileList[0].link}} target=attach><img src={{vc.uploadFileList[0].link}} width={{vc.data.ImgW}} height={{vc.data.ImgH}}></a></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit() ng-if=\"($root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\')\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-if=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/bbs-popup-edit.html","<div class=\"page page-footable\" ng-controller=\"BbsPopupEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>팝업공지관리 수정</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><form class=\"ng-pristine ng-valid\" role=form name=theForm ng-submit=vc.uploadFile()><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\" type=button><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" type=submit><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}<span class=point_red>*</span></label><input type=text class=\"form-control form-right\" ng-model=vc.data.Title name=Title minlength=2 ng-required=true></div></div></div><div class=row><div class=col-lg-3 ng-if=\"vc.columnMap[\'StartDT\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'StartDT\'].ColumnLogicalNm | translate }}<span class=point_red>*</span></label><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-model=vc.StartDate ng-required=true placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-2 ng-if=\"vc.columnMap[\'StartDT\']\"><div class=\"form-group form-inline\"><label>시작시간</label><select class=form-control ng-model=vc.StartTime ng-options=\"t for t in vc.timeList\"></select></div></div><div class=col-lg-3 ng-if=\"vc.columnMap[\'EndDT\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EndDT\'].ColumnLogicalNm | translate }}<span class=point_red>*</span></label><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-model=vc.EndDate ng-required=true placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=col-lg-2 ng-if=\"vc.columnMap[\'EndDT\']\"><div class=\"form-group form-inline\"><label>종료시간</label><select class=form-control ng-model=vc.EndTime ng-options=\"t for t in vc.timeList\"></select></div></div><div class=col-lg-2 ng-if=\"vc.columnMap[\'LoginYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'LoginYN\'].ColumnLogicalNm | translate }}<span class=point_red ng-show=\"vc.data.LoginYN == \'\'\">*</span></label><common-code-custom code-list=\"vc.columnMap[\'LoginYN\'].CodeList\" code-model=vc.data.LoginYN is-required=true></common-code-custom></div></div></div><div class=row><div class=col-lg-5 ng-if=\"vc.columnMap[\'ImgW\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ImgW\'].ColumnLogicalNm | translate }}<span class=point_red ng-show=\"vc.data.ImgW == \'\'\">*</span></label><input type=text class=\"form-control form-right\" ng-model=vc.data.ImgW name=ImgW ng-required=true numbersonly placeholder=\"픽셀크기를 입력해 주세요. (ex 500)\"></div></div><div class=col-lg-5 ng-if=\"vc.columnMap[\'ImgH\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ImgH\'].ColumnLogicalNm | translate }}<span class=point_red ng-show=\"vc.data.ImgH == \'\'\">*</span></label><input type=text class=\"form-control form-right\" ng-model=vc.data.ImgH name=ImgH ng-required=true numbersonly placeholder=\"픽셀크기를 입력해 주세요. (ex 500)\"></div></div><div class=col-lg-2 ng-if=\"vc.columnMap[\'PublicYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}<span class=point_red ng-show=\"vc.data.PublicYN == \'\'\">*</span></label><common-code-custom code-list=\"vc.columnMap[\'PublicYN\'].CodeList\" code-model=vc.data.PublicYN is-required=true></common-code-custom></div></div></div><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'GoLink\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'GoLink\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.GoLink name=GoLink></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><br><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div style=\"margin-left: 90px\" id=vault class=vault-block vault-company></div></form></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><div class=form-control-no-border><table class=\"table table-hover table-striped no-footer fullTable\" width=100%><colgroup><col style=width:50%><col style=width:25%><col style=width:25%></colgroup><thead><tr><th><span>이미지</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><a href={{fli.link}} target=attach><img src={{fli.link}} style=width:80%></a></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=\"row mt-5\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\" type=button><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></form></div><!-- /page content --></div>");
$templateCache.put("app/board/bbs-popup-list.html","<div class=\"page page-footable\" ng-controller=\"BbsPopupListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>팝업공지관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size={{$root.gVariable.layoutBoardSize}} pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Title type=text><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\" ng-if=\"(vc.tenantType != \'GIVETENANT\' && vc.tenantType != \'TAKETENANT\') || vc.BbsType == \'QNA\'\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.BbsPostId, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.BbsPostId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=40 class=onelinetext>{{li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd HH:mm\'}}</span> <span ng-switch-when=50 class=onelinetext>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60 class=onelinetext>{{$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm]) | html}}</span> <span ng-switch-when=70 class=onelinetext>{{li[liCol.ColumnPhysicalNm] | tel}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></tbody></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/h0102-detail.html","<div class=\"page page-footable\" ng-controller=\"H0102DetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{vc.BbsNm}}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit() ng-if=\"($root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\') && !vc.data.ReplyContents\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-if=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.Title></span></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BoardType\']\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate}}</label><span class=form-control>{{$root.getCodeValue(vc.columnMap[\'BoardType\'].CodeList, vc.data.BoardType)}}</span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=\"vc.data.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.RegUserNm></span></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EdtDate\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=\"vc.data.EdtDate | utcToLocal:\'yyyy-MM-dd h:mm a\'\"></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EdtUserNm\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.EdtUserNm></span></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'ReadCnt\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReadCnt\'].ColumnLogicalNm | translate }}</label><span class=form-control ng-bind=vc.data.ReadCnt></span></div></div></div><!-- <div class=\"row\">\r\n              <div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'PublicYN\']\">\r\n                <div class=\"form-group form-inline\">\r\n                  <label>{{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}</label>\r\n                  <span class=\"form-control\">{{$root.getCodeValue(vc.columnMap[\'PublicYN\'].CodeList, vc.data.PublicYN)}}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'NoticeYN\']\">\r\n                <div class=\"form-group form-inline\">\r\n                  <label>{{ vc.columnMap[\'NoticeYN\'].ColumnLogicalNm | translate }}</label>\r\n                  <span class=\"form-control\">{{$root.getCodeValue(vc.columnMap[\'NoticeYN\'].CodeList, vc.data.NoticeYN)}}</span>\r\n                </div>\r\n              </div>\r\n              <div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BbsPostId\']\">\r\n                <div class=\"form-group form-inline\">\r\n                  <label>{{ vc.columnMap[\'BbsPostId\'].ColumnLogicalNm | translate }}</label>\r\n                  <span class=\"form-control\" ng-bind=\"vc.data.BbsPostId\"></span>\r\n                </div>\r\n              </div>\r\n            </div> --><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div class=form-control-no-border style=height:100%><table class=\"table table-hover table-striped no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div></div><div class=row ng-if=\"vc.BbsType == \'Board\' || vc.BbsType == \'QNA\'\"><div class=col-lg-12 ng-if=\"vc.columnMap[\'Contents\']\"><div class=\"form-control-no-border no-border-custom\"><span class=txt_view ng-bind-html=vc.data.Contents|htmlString style=\"min-height: 100px\"></span></div></div></div><!-- <div class=\"row\" ng-if=\"vc.BbsType == \'QNA\'\">\r\n              <div class=\"col-lg-12\" ng-if=\"vc.columnMap[\'Contents\']\">\r\n                <div class=\"form-control-no-border no-border-custom\">\r\n                  <pre class=\"txt_view\" style=\"min-height: 100px;\">{{vc.data.Contents}}</pre>\r\n                </div>\r\n              </div>\r\n            </div> --><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-detail meta-list=vc.allColumns meta-model=vc.data></udc-detail></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit() ng-if=\"($root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\') && !vc.data.ReplyContents\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-if=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row ng-if=\"vc.BbsType == \'QNA\'\"><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>답변</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=form-group><div class=col-sm-12><textarea class=form-control rows=10 style=\"width: 100%; height: 300px\" ng-model=vc.data.ReplyContents permission=\"\'app.bbspost.h0102-list-qna:button01\'\"></textarea><pre class=txt_view style=\"min-height: 100px\" permission=\"\'app.bbspost.h0102-list-qna:button02\'\">{{vc.data.ReplyContents}}</pre><div class=\"pull-right mt-5\"><button class=\"btn btn-outline btn-default\" ng-click=vc.saveReply() permission=\"\'app.bbspost.h0102-list-qna:button01\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteReply() permission=\"\'app.bbspost.h0102-list-qna:button01\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.COMMENT\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><article class=streamline-post ng-repeat=\"li in vc.comment.lists\"><div class=post-container><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\">{{li.RegUserNm}} <span><i class=\"fa fa-clock-o mr-5\"></i> {{li.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span> <span class=\"text-muted pull-right\" ng-hide=\"li.BbsPostCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editComment(li.BbsPostCommId)><i class=\"glyphicon glyphicon-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn-min btn btn-default\" ng-click=vc.deleteComment(li)><i class=\"glyphicon glyphicon-trash\"></i> {{ \'Menu.DELETE\' | translate }}</button> </span><span class=\"text-muted pull-right\" ng-if=\"li.BbsPostCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editCommentAction(li)><i class=\"glyphicon glyphicon-ok\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button href=\"\" class=\"btn-min btn btn-default\" ng-click=vc.editCommentCancel()><i class=\"glyphicon glyphicon-remove\"></i> {{ \'Menu.CANCEL\' | translate }}</button></span></div><div class=panel-body ng-hide=\"li.BbsPostCommId == vc.comment.editid\">{{li.Contents}}<table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100% ng-if=li.LogicalFileNm><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"></colgroup><tbody><tr><td><a href=\"\" ng-click=vc.openAttachment(li)>{{li.LogicalFileNm}}</a></td><td align=right><span class=file_size ng-bind=li.FileSize|filesize></span></td></tr></tbody></table></div><div class=panel-body ng-if=\"li.BbsPostCommId == vc.comment.editid\"><textarea class=form-control id=strReply rows=10 style=\"width:100%; height:40px; resize:vertical\" ng-model=vc.comment.editContents></textarea><span ng-show=\"li.AttachmentId != null && li.AttachmentId != \'\'\"><br>{{li.LogicalFileNm}}&nbsp;&nbsp;&nbsp;&nbsp;<a href=\"\" ng-click=vc.setDeleteFileToggle(li)><span ng-show=\"li.delState == \'\' \"><i class=icon-trash>{{ \'Menu.DELETE\' | translate }}</i></span><span ng-show=\"li.delState != \'\'\"><i class=icon-refresh></i> {{ \'Menu.CANCEL\' | translate }}</span></a></span></div></div></div></article><div class=streamline-form><form class=\"ng-pristine ng-valid\"><div class=\"form-group form-inner-label form-comment\"><div class=input-group><textarea class=form-control id=strReply placeholder=\"댓글 작성...\" rows=10 style=\"width:100%; height:40px; resize:vertical\" ng-model=vc.srchReply.Contents></textarea><span class=input-group-btn style=\"vertical-align: top\"><button class=\"btn btn-default cm_btn\" type=button ng-click=vc.saveComment()>{{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default cm_btn\" type=button ng-click=vc.openDilalog()>{{ \'Menu.ATTACHMENT\' | translate }}</button> </span><input id=file-5 style=\"display: none\" class=file type=file data-preview-file-type=any></div></div><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><tbody><tr id=filectl ng-repeat=\"obj in vc.uploadFileListReply\"><td><div ng-show=!obj.isLoaded class=file_list ng-bind=obj.fileName></div><a href={{obj.link}} target=attach ng-if=obj.isLoaded>{{obj.fileName}}</a></td><td align=right><span class=file_size ng-bind=obj.size|filesize></span></td><td><div class=\"progress progress-xs\" style=\"margin-bottom: 0px;height:10px\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div></td><td></td><td align=center><a ng-if=\"obj.delState == \'\'\" href=\"\" ng-click=vc.onDelete(obj)><i class=icon-trash></i></a> <a ng-if=\"obj.delState != \'\' \" href=\"\" ng-click=vc.onDeleteCancel(obj)><i class=icon-cancel-square></i> {{ \'Menu.DELETE\' | translate }}</a></td></tr></tbody></table></form><div>&nbsp;</div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content -->");
$templateCache.put("app/board/h0102-edit.html","<!-- Html Editor --><script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"H0102EditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{vc.BbsNm}}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><form class=\"ng-pristine ng-valid\" role=form name=theForm ng-submit=vc.uploadFile()><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" type=submit><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}<span class=point_red ng-show=theForm.Title.$invalid>*</span></label><input type=text class=\"form-control form-right\" ng-model=vc.data.Title name=Title minlength=2 ng-required=true></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BoardType\']\"><div class=\"form-group form-inline\"><!-- <label>{{vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate}}<span class=\"point_red\" ng-show=\"vc.data.BoardType == \'\'\">*</span></label> --><label>{{vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><common-code-custom code-list=\"vc.columnMap[\'BoardType\'].CodeList\" code-model=vc.data.BoardType is-required=false></common-code-custom></div></div><!-- <div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegDate\']\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label>\r\n                    <span class=\"form-control\" ng-bind=\"vc.data.RegDate | date:\'yyyy-MM-dd h:mm a\'\"></span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegUserNm\']\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label>{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label>\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.RegUserNm\" readonly>\r\n                  </div>\r\n                </div> --></div><!-- <div class=\"row\">\r\n                <div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BbsPostId\']\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label>{{ vc.columnMap[\'BbsPostId\'].ColumnLogicalNm | translate }}</label>\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.BbsPostId\" readonly>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtDate\']\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label>{{ vc.columnMap[\'EdtDate\'].ColumnLogicalNm | translate }}</label>\r\n                    <span class=\"form-control\" ng-bind=\"vc.data.EdtDate | date:\'yyyy-MM-dd h:mm a\'\"></span>\r\n                  </div>\r\n                </div>\r\n                <div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtUserNm\']\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label>{{ vc.columnMap[\'EdtUserNm\'].ColumnLogicalNm | translate }}</label>\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.EdtUserNm\" readonly>\r\n                  </div>\r\n                </div>\r\n              </div> --><div class=row><!-- <div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'ReadCnt\']\">\r\n                  <div class=\"form-group form-inline\">\r\n                    <label>{{ vc.columnMap[\'ReadCnt\'].ColumnLogicalNm | translate }}</label>\r\n                    <input type=\"text\" class=\"form-control\" ng-model=\"vc.data.ReadCnt\" readonly>\r\n                  </div>\r\n                </div> --><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'PublicYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}<span class=point_red ng-show=\"vc.data.PublicYN == \'\'\">*</span></label><common-code-custom code-list=\"vc.columnMap[\'PublicYN\'].CodeList\" code-model=vc.data.PublicYN is-required=true></common-code-custom></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'NoticeYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'NoticeYN\'].ColumnLogicalNm | translate }}<span class=point_red ng-show=\"vc.data.NoticeYN == \'\'\">*</span></label><common-code-custom code-list=\"vc.columnMap[\'NoticeYN\'].CodeList\" code-model=vc.data.NoticeYN is-required=true></common-code-custom></div></div></div><div class=row><div class=\"col-lg-12 col-md-12\" ng-if=\"vc.columnMap[\'Tags\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Tags\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Tags></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><br><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div style=\"margin-left: 90px\" id=vault class=vault-block vault-company></div></form></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><!--                    <label>{{ \'Menu.ATTACHMENT\' | translate }}</label>--><div class=form-control-no-border><table class=\"table table-hover table-striped no-footer fullTable\" width=100%><colgroup><col style=\"width: auto\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><div class=row><div class=form-group><div class=col-sm-12><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=\"row mt-5\"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></form></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n      //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록\r\n      fOnBeforeUnload : function() {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/board/h0102-list.html","<div class=\"page page-footable\" ng-controller=\"H0102ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{vc.BbsNm}}<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size={{$root.gVariable.layoutBoardSize}} pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Title type=text><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Contents type=text><label>{{ vc.columnMap[\'Contents\'].ColumnLogicalNm | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'BoardType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'BoardType\'].CodeList\" code-model=vc.srch.BoardType></common-code-custom><label>{{vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\" ng-if=\"(vc.tenantType != \'GIVETENANT\' && vc.tenantType != \'TAKETENANT\') || vc.BbsType == \'QNA\'\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{vc.BbsNm}}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.BbsPostId, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.BbsPostId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=40 class=onelinetext>{{li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd HH:mm\'}}</span> <span ng-switch-when=50 class=onelinetext>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60 class=onelinetext>{{$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm]) | html}}</span> <span ng-switch-when=70 class=onelinetext>{{li[liCol.ColumnPhysicalNm] | tel}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></tbody></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/h0102-mlist.html","<div class=\"page page-footable\" ng-controller=\"H0102ListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><h1 class=page-header>{{ :: \'Menu.h0102\' | translate }}</h1><div class=\"pull-right dock-header-tx\"><span ng-click=\"vc.setResponsive(\'default\')\">기본</span> <span ng-click=\"vc.setResponsive(\'vertical\')\">좌우</span> <span ng-click=\"vc.setResponsive(\'horizon\')\">상하</span></div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div id=dockWrap><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.getExcel()><i class=\"fa fa-file-excel-o\"></i> {{ :: \'Menu.EXCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div></div><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-info tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\">{{ :: \'Menu.SEARCH\' | translate }} {{ :: \'Menu.CONDITION\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-4 col-md-4 col-sm-8 col-xs-8\"><div class=\"form-group form-inner-label\" ng-show=vc.srch.searchColumns.Title><input type=text class=\"form-control form-right\" ng-model=vc.srch.Title><label>{{ :: \'Menu.TITLE\' | translate }}</label></div></div><div class=\"col-lg-2 col-md-2 col-sm-4 col-xs-4\"><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=vc.srch.Contents class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>{{ :: \'Menu.INCLUSION_OF_CONTENT\' | translate }}</md-checkbox></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=\"form-group form-inner-label\"><div class=input-group ng-show=vc.srch.searchColumns.RegDate ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateFrom ng-change=\"vc.srch.RegDateFrom = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"{{ ::  \'Menu.REG_DATEFROM\' | translate }}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=\"form-group form-inner-label\"><div class=input-group ng-show=vc.srch.searchColumns.RegDate ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-model=vc.RegDateTo ng-change=\"vc.srch.RegDateTo = (objDate | date: \'yyyy-MM-dd\')\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기 placeholder=\"{{ ::  \'Menu.REG_DATETO\' | translate }}\"> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-lg-2 col-md-2 col-sm-2 col-xs-2\"><input type=text class=form-control ng-show=vc.srch.searchColumns.RegUser_ ng-model=vc.srch.RegUser_ placeholder=등록자></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=pull-right><button class=\"btn btn-info\" activate-button ng-click=vc.getSearch()><i class=\"fa fa-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}<!-- 입력값 초기화 후 자동 리스트 재조회 --></button></div></div></div></div></div></div></div><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.h0102\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead></thead><tbody></tbody></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /dockWrap --></div><!-- /page content --></div><ui-view></ui-view>");
$templateCache.put("app/board/notice-board-detail.html","<div class=\"page page-footable\" ng-controller=\"NoticeBoardDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.h0102\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Title></div></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BbsPostId\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BbsPostId\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.BbsPostId></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\">{{vc.data.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EdtDate\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\">{{vc.data.EdtDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'EdtUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'EdtUserNm\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.EdtUserNm></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BoardType\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.BoardType></div></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'ReadCnt\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReadCnt\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.ReadCnt></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'PublicYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.PublicYNNm></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'NoticeYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'NoticeYN\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.NoticeYNNm></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12\" ng-if=\"vc.columnMap[\'Tags\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Tags\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Tags></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div style=\"margin-left: 85px\"><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: 50%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span style=text-align:center ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td><span style=text-align:center class=file_size ng-bind=fli.size|filesize></span></td><td><span style=text-align:center class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div></div><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Contents\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Contents\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" style=\"height:100px; overflow-y: hidden\" ng-bind-html=vc.data.Contents|htmlString></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.COMMENT\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><article class=streamline-post ng-repeat=\"li in vc.comment.lists\"><div class=post-container><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\">{{li.RegUserNm}} <span><i class=\"fa fa-clock-o mr-5\"></i> {{li.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span> <span class=\"text-muted pull-right\" ng-hide=\"li.BbsPostCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editComment(li.BbsPostCommId)><i class=\"glyphicon glyphicon-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn-min btn btn-default\" ng-click=vc.deleteComment(li)><i class=\"glyphicon glyphicon-trash\"></i> {{ \'Menu.DELETE\' | translate }}</button> </span><span class=\"text-muted pull-right\" ng-show=\"li.BbsPostCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editCommentAction(li)><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button href=\"\" class=\"btn-min btn btn-default\" ng-click=vc.editCommentCancel()><i class=\"glyphicon glyphicon-remove\"></i> {{ \'Menu.CANCEL\' | translate }}</button></span></div><div class=panel-body ng-hide=\"li.BbsPostCommId == vc.comment.editid\">{{li.Contents}}<table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100% ng-if=li.LogicalFileNm><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"></colgroup><tbody><tr><td><a href=\"\" ng-click=vc.openAttachment(li)>{{li.LogicalFileNm}}</a></td><td align=right><span class=file_size ng-bind=li.FileSize|filesize></span></td></tr></tbody></table></div><div class=panel-body ng-show=\"li.BbsPostCommId == vc.comment.editid\"><textarea class=form-control id=strReply rows=10 style=\"width:100%; height:40px; resize:vertical\" ng-model=vc.comment.editContents></textarea><span ng-show=\"li.AttachmentId != null && li.AttachmentId != \'\'\"><br>{{li.LogicalFileNm}}&nbsp;&nbsp;&nbsp;&nbsp;<a href=\"\" ng-click=vc.setDeleteFileToggle(li)><span ng-show=\"li.delState == \'\' \"><i class=icon-trash>{{ \'Menu.DELETE\' | translate }}</i></span><span ng-show=\"li.delState != \'\'\"><i class=icon-refresh></i> {{ \'Menu.CANCEL\' | translate }}</span></a></span></div></div></div></article><div class=streamline-form><form class=\"ng-pristine ng-valid\"><div class=\"form-group form-inner-label form-comment\"><div class=input-group><textarea class=form-control id=strReply placeholder=\"댓글 작성...\" rows=10 style=\"width:100%; height:40px; resize: vertical\" ng-model=vc.srchReply.Contents></textarea><span class=input-group-btn style=\"vertical-align: top\"><button class=\"btn btn-default\" type=button ng-click=vc.saveComment()>{{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" type=button ng-click=vc.openDilalog()>{{ \'Menu.ATTACHMENT\' | translate }}</button> </span><input id=file-5 style=\"display: none\" class=file type=file data-preview-file-type=any></div></div><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><tbody><tr id=filectl ng-repeat=\"obj in vc.uploadFileListReply\"><td><div ng-show=!obj.isLoaded class=file_list ng-bind=obj.fileName></div><a href={{obj.link}} target=attach ng-show=obj.isLoaded>{{obj.fileName}}</a></td><td align=right><span class=file_size ng-bind=obj.size|filesize></span></td><td><div class=\"progress progress-xs\" style=\"margin-bottom: 0px;height:10px\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div></td><td></td><td align=center><a ng-show=\"obj.delState == \'\'\" href=\"\" ng-click=vc.onDelete(obj)><i class=icon-trash></i></a> <a ng-show=\"obj.delState != \'\' \" href=\"\" ng-click=vc.onDeleteCancel(obj)><i class=icon-cancel-square></i> {{ \'Menu.DELETE\' | translate }}</a></td></tr></tbody></table></form><div>&nbsp;</div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/board/notice-board-edit.html","<!-- Html Editor --><script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><div class=\"page page-footable\" ng-controller=\"NoticeBoardEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.h0102\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-12 ng-if=\"vc.columnMap[\'Title\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Title></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BbsPostId\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BbsPostId\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.BbsPostId></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegDate\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\">{{vc.data.RegDate | date:\'yyyy-MM-dd h:mm a\':\'UTC\'}}</div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'BoardType\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'BoardType\'].CodeList\" code-model=vc.data.BoardType></common-code-custom></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'RegUserNm\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegUserNm\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div></div><div class=row><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'ReadCnt\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'ReadCnt\'].ColumnLogicalNm | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.ReadCnt></div></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'PublicYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'PublicYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'PublicYN\'].CodeList\" code-model=vc.data.PublicYN></common-code-custom></div></div><div class=\"col-lg-4 col-md-6\" ng-if=\"vc.columnMap[\'NoticeYN\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'NoticeYN\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"vc.columnMap[\'NoticeYN\'].CodeList\" code-model=vc.data.NoticeYN></common-code-custom></div></div></div><div class=row><div class=\"col-lg-12 col-md-12\" ng-if=\"vc.columnMap[\'Tags\']\"><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'Tags\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Tags></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" ng-if=!vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div style=\"margin-left: 85px\" id=vault class=vault-block vault-company></div></form></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.ATTACHMENT\' | translate }}</label><div style=\"margin-left: 85px\"><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group style=margin:0px><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div></div><div class=row><div class=form-group><div class=col-sm-12><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.data.Contents></textarea></div></div></div></form><div class=row><!-- 사용자정의 컬럼 등록/수정 --><div class=\"form-group form-inline\"><form class=\"ng-pristine ng-valid\" ng-submit=\"\" name=vc.udcForm novalidate><formly-form model=vc.udcModel fields=vc.udcColumns options=vc.udcOptions form=vc.udcForm></formly-form></form></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.uploadFile()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"ko_KR\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : false, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      //bSkipXssFilter : true,		// client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n      //aAdditionalFontList : aAdditionalFontSet,		// 추가 글꼴 목록\r\n      fOnBeforeUnload : function() {\r\n        //alert(\"완료!\");\r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/board/notice-board.html","<div class=\"page page-footable\" ng-controller=\"NoticeBoardCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>PR Center 게시판<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size={{$root.gVariable.layoutBoardSize}} pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Title type=text><label>{{ :: \'Menu.TITLE\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Contents type=text><label>{{ :: \'Menu.CONTENTS\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.getExcelFile()><i class=\"fa fa-file-excel-o\"></i> {{ :: \'Menu.EXCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.h0102\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th ng-repeat=\"liCol in vc.listColumns\" ng-click=\"vc.tablesort(\'T.\'+liCol.ColumnPhysicalNm)\" data-toggle=true style=\"width: {{liCol.ListColumnWidth}}\" class=\"text-center none\">{{liCol.ColumnLogicalNm}} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.BbsPostId) style=\"cursor: pointer\" my-directive ng-class=\"{\'bg-lightyellow\':vc.keyId == li.BbsPostId}\"><!-- Result Items --><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in vc.listColumns\">{{liCol.ColumnPhysicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd h:mm a\')}}</td></tr></tbody></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.setChangeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=app/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div><!-- /page content --></div>");
$templateCache.put("app/board/popup-list.html","<div class=\"page page-footable\" ng-controller=\"PopupListCtrl as vc\"><!-- page header --><div class=\"row rel\"><div class=col-lg-12><div class=page-header>팝업 list<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size={{$root.gVariable.layoutBoardSize}} pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=row><!-- 사용자 검색 --><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>사용자명</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.srch.UserNm placeholder=사용자명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.openModalUser()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearUser()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- 사용자 검색 끝--><!-- 단품(제품)조회 --><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>단품 조회</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.srch.ProductNm placeholder=품목명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.openModalPrd()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearPrd()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!--단품(제품)조회 끝--><!-- 주소검색 (다음) --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2\"><div class=\"form-group form-inline sm-mb0\"><label>주소</label><div class=input-group><input type=text id=zipCode class=form-control ng-model=vc.srch.ZipCode readonly> {{vc.srch.ZipCode}} <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.getAddressInfo()><i class=\"fa fa-search\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-lg-4 wd85\"><div class=form-group><input type=text id=addr1 ng-model=vc.srch.Addr1 class=form-control readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6 wd85\"><div class=form-group><input type=text id=addr2 ng-model=vc.srch.Addr2 class=form-control></div></div></div><!-- 주소검색 (다음) --><!-- 관리권 검색 --><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>관리권명</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.srch.CareTktNm placeholder=관리권명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.openModalCareTkt()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearCareTkt()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- 관리권 검색 끝--><!-- 고객 검색 --><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>고객명</label><div class=\"input-group custom-search-form\"><input type=text class=form-control ng-model=vc.srch.CustNm placeholder=고객명 readonly> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.openModalCustomer()><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.clearCustomer()><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- 고객 검색 끝--></div></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/boardmng/boardmng-detail.html","<div class=\"page page-footable\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC01\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableNm></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC02\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.moduleType></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableDesc></div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EM710VT07\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><span ng-repeat=\"column in boardMngDetail.metaTable.metaColumns track by $index\"><div class=row><div class=col-lg-3><div class=form-group><label>{{ \'Menu.EM710VC02\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnLogicalNm></div></div></div><div class=col-lg-3><div class=form-group><label ng-show=\"column.customColumnYN == \'Y\'\">{{ \'Menu.EM710VC03\' | translate }} <i class=\"fa fa-question-circle\" ng-click=boardMngDetail.showFieldNameRule() style=color:red></i></label><label style=\"color: red\" ng-show=\"column.customColumnYN == \'N\'\">{{ \'Menu.EM710VC03\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnPhysicalNm></div></div></div><div class=col-lg-2><div class=form-group><label>{{ \'Menu.EM710VC04\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnWidth></div></div></div><div class=col-lg-1><div class=form-group><label>{{ \'Menu.EM710VC05\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnSort></div></div></div><div class=col-lg-1><label>{{ \'Menu.EM710VC06\' | translate }}</label><div class=form-control-static><label><input type=checkbox ng-checked=\"column.listColumnShowYN == \'Y\'\" disabled required></label><label><input type=checkbox ng-checked=\"column.editColumnShowYN == \'Y\'\" disabled required></label></div></div><div class=col-lg-2><div class=pull-right style=\"height: 100%\"><button class=\"btn btn-primary btn-xs mb-10 mr-5\" ng-click=boardMngDetail.showColumnInfo(column)><i class=\"fa fa-sticky-note-o\">{{ \'Menu.EICON_DETAILPROPERTY\' | translate }}</i></button></div></div></div></span><!-- /tile body --></div><!-- /tile --></div></div><!-- /col --></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/boardmng/boardmng-detail_bak.html","<div class=\"page page-footable\"><!-- page header --><div class=row><div class=col-lg-12><h1 class=page-header>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</h1></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC01\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableNm></div></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC02\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.moduleType></div></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><label>{{ \'Menu.EM710DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=boardMngDetail.metaTable.tableDesc></div></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EM710VT07\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><span ng-repeat=\"column in boardMngDetail.metaTable.metaColumns track by $index\"><div class=row><div class=col-lg-3><div class=form-group><label>{{ \'Menu.EM710VC02\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnLogicalNm></div></div></div><div class=col-lg-3><div class=form-group><label ng-show=\"column.customColumnYN == \'Y\'\">{{ \'Menu.EM710VC03\' | translate }} <i class=\"fa fa-question-circle\" ng-click=boardMngDetail.showFieldNameRule() style=color:red></i></label><label style=\"color: red\" ng-show=\"column.customColumnYN == \'N\'\">{{ \'Menu.EM710VC03\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.columnPhysicalNm></div></div></div><div class=col-lg-2><div class=form-group><label>{{ \'Menu.EM710VC04\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnWidth></div></div></div><div class=col-lg-1><div class=form-group><label>{{ \'Menu.EM710VC05\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=column.listColumnSort></div></div></div><div class=col-lg-1><label>{{ \'Menu.EM710VC06\' | translate }}</label><div class=form-control-static><label><input type=checkbox ng-checked=\"column.listColumnShowYN == \'Y\'\" disabled required></label><label><input type=checkbox ng-checked=\"column.editColumnShowYN == \'Y\'\" disabled required></label></div></div><div class=col-lg-2><div class=pull-right style=\"height: 100%\"><button class=\"btn btn-primary btn-xs mb-10 mr-5\" ng-click=boardMngDetail.showColumnInfo(column)><i class=\"fa fa-sticky-note-o\">{{ \'Menu.EICON_DETAILPROPERTY\' | translate }}</i></button></div></div></div></span><!-- /tile body --></div><!-- /tile --></div></div><!-- /col --></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ui-sref=app.boardmng.list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=boardMngDetail.goModifyMetaTable()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button></div></div></div><!-- /page content --></div></div>");
$templateCache.put("app/boardmng/boardmng-edit.html","<div class=\"page page-footable\" id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.EDIT\' | translate }}</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><form name=metaTable><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button type=button class=\"btn btn-default\" ui-sref=\"app.boardmng.list({srch:\'{{boardMngSave.makeSrch()}}\'})\" ng-if=\"boardMngSave.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=\" metaTable.$valid && boardMngSave.saveMetaTable()\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.META_TABLE\' | translate }} {{ \'Menu.DETAIL\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group ng-if=\"boardMngSave.currentActionView==\'modify\'\"><label>{{ \'Menu.EM710VC01\' | translate }}</label><div class=\"form-control-static txt_view\" ng-bind=boardMngSave.metaTable.tableNm></div></div><div class=form-group ng-if=\"boardMngSave.currentActionView==\'add\'\"><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC01\' | translate }}</label><input class=\"form-control pre\" name=tableNm ng-disabled=\"$root.gVariable.srchTenantId != 0\" ng-maxlength=100 ng-minlength=3 ng-model=boardMngSave.metaTable.tableNm ng-model-options=\"{ updateOn: \'blur\' }\" ng-required=true type=text><div ng-show=metaTable.tableNm.$error.minlength class=\"col-xs-12 col-md-12 alert alert-warning\" role=alert>{{ \'Menu.EM710VA01\' | translate }}</div><div ng-show=metaTable.tableNm.$error.maxlength class=\"col-xs-12 col-md-12 alert alert-warning\" role=alert>{{ \'Menu.EM710VA02\' | translate }}</div><div ng-show=\"boardMngSave.usingTableNm.length > 0\" class=\"col-xs-12 col-md-12 alert alert-warning\" role=alert>{{boardMngSave.usingTableNm}} {{ \'Menu.EM710VA03\' | translate }}</div></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label style=\"color: red\">*</label><label>모듈유형</label><common-code-custom code-list=boardMngSave.moduleTypeList code-model=boardMngSave.metaTable.moduleType ng-disabled=\"$root.gVariable.srchTenantId != 0\" ng-required=true></common-code-custom></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.EM710DC03\' | translate }}</label><textarea class=form-control row=3 cols=50 ng-model=boardMngSave.metaTable.tableDesc ng-disabled=\"$root.gVariable.srchTenantId != 0\"></textarea></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=boardMngSave.openSortMetaColumn() ng-if=\"boardMngSave.metaTable.metaColumns.length > 0\" type=button><i class=\"fa fa-edit\"></i> 컬럼 표시순서 정렬</button></div></div></div></div></div></div></div><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EM710VT07\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=dataloader ng-show=boardMngSave.dataloader></div><div class=row><div class=col-lg-12><div class=pull-right style=\"height: 100%\"><div class=form-group><md-checkbox md-no-ink=\"\" ng-if=\"$root.gVariable.srchTenantId != \'0\'\" ng-click=boardMngSave.ChangeCustomColumn() ng-checked=\"boardMngSave.metaTable.metaColumns.length == 0 ? false:true\" class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox style=\"margin-right: 30px\">{{ \'Menu.CUSTOMCOLUMN\' | translate }}</md-checkbox><button type=button class=\"btn btn-default\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\" ng-disabled=\"metaTable.tableNm.$invalid && boardMngSave.currentActionView ==\'add\'\" ng-click=boardMngSave.getTableColumns()><i class=\"fa fa-table\"></i> 기본 컬럼 조회</button> <button type=button class=\"btn btn-default\" ng-click=\"boardMngSave.addColumn(\'base\')\"><i class=\"fa fa-table\"></i> 기본 컬럼 추가</button> <button class=\"btn btn-default\" ng-click=\"boardMngSave.addColumn(\'add\')\" type=button><i class=\"fa fa-edit\"></i> 사용자정의 컬럼 추가</button> <button class=\"btn btn-primary\" ng-click=\"metaTable.$valid && boardMngSave.saveMetaTable()\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></div><table class=\"table table-striped table-bordered table-hover data_table table-custom\"><!-- Header --><thead><tr><th data-toggle=true class=text-center><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC02\' | translate }}</label></th><th data-toggle=true class=text-center><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC03\' | translate }} <i class=\"fa fa-question-circle\" ng-click=boardMngSave.showFieldNameRule() style=color:red></i></label></th><th data-toggle=true class=text-center><label style=\"color: red\">*</label><label>{{ \'Menu.EM710VC04\' | translate }}</label></th><th data-toggle=true class=text-center><label>{{ \'Menu.EM710VC05\' | translate }}</label></th><th data-toggle=true class=text-center><label>{{ \'Menu.EM710VC06\' | translate }}</label></th><th data-toggle=true class=text-center><label>{{ \'Menu.EM710VT08\' | translate }}</label></th><th data-toggle=true class=text-center><label></label></th></tr></thead><tbody><tr ng-repeat=\"column in boardMngSave.metaTable.metaColumns track by $index\"><td><input type=text class=form-control ng-model=column.columnLogicalNm ng-change=boardMngSave.checkStateChange(column) name=columnLogicalNm required></td><td><common-code ng-if=\"column.customColumnYN == \'Y\'\" param-data=column.commoncodeDATA callback=boardMngSave.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\" required></common-code><input type=text ng-if=\"column.customColumnYN == \'N\'\" class=form-control ng-model=column.columnPhysicalNm ng-change=boardMngSave.checkStateChange(column) ng-readonly=\"column.customColumnYN == \'N\' && $root.gVariable.SysAdminYN != \'Y\'\"></td><td><input type=text class=form-control ng-model=column.listColumnWidth ng-change=boardMngSave.checkStateChange(column) required></td><td><input type=text class=form-control ng-model=column.listColumnSort ng-change=boardMngSave.checkStateChange(column) required></td><td><label><input type=checkbox ng-checked=\"column.listColumnShowYN == \'Y\'\" ng-model=column.listColumnShowYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> <span ng-if=\"column.listColumnShowLevel == \'showlevel1\'\">①항상</span> <span ng-if=\"column.listColumnShowLevel == \'showlevel2\'\">②768 이상</span> <span ng-if=\"column.listColumnShowLevel == \'showlevel3\'\">③992 이상</span> <span ng-if=\"column.listColumnShowLevel == \'showlevel0\'\">검색만표시</span></label></td><td><input type=checkbox ng-checked=\"column.editColumnShowYN == \'Y\'\" ng-model=column.editColumnShowYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td><button type=button class=\"btn btn-danger btn-min\" ng-click=boardMngSave.deleteColumn(column)><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button type=button class=\"btn btn-success btn-min\" ng-click=boardMngSave.openAttrSetup(column)><i class=\"fa fa-edit\">{{ \'Menu.EICON_DETAILEDIT\' | translate }}</i></button></td></tr></tbody></table><!-- /tile body --></div><!-- /tile --></div></div><!-- /col --></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group btn-bottom\"><div class=pull-right><button type=button class=\"btn btn-default\" ui-sref=\"app.boardmng.list({srch:\'{{boardMngSave.makeSrch()}}\'})\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=\"metaTable.$valid && boardMngSave.saveMetaTable()\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div></form></div><!-- /page content --></div>");
$templateCache.put("app/boardmng/boardmng-list.html","<div class=\"page page-footable\" ng-controller=\"BoardMngListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.EM700\' | translate }}<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=\"row shop-view\"><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"물리 테이블/컬럼명 검색\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.tabelNm type=text><label>물리 테이블명</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.columnLogicalNm type=text><label>물리 컬럼명</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.goDetail(\'\')\" ng-if=\"$root.gVariable.srchTenantId == 0\"><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><div class=row><div class=col-lg-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong>{{ \'Menu.LIST\' | translate }}</strong><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=dataloader ng-show=boardMngSave.dataloader></div><!-- Search Result --><table id=searchTextResults data-filter=#filter data-page-size={{vc.viewSizePerPage}} class=\"table table-striped table-bordered table-hover data_table table-custom\"><!-- Header --><thead><tr><th class=text-center data-toggle=true ng-click=\"vc.tablesort(\'X.TableNm\')\">물리 테이블명<span class=\"{{vc.sortClass(\'X.TableNm\')}}\"></span></th><th class=text-center data-toggle=true ng-click=\"vc.tablesort(\'X.TableDesc\')\">테이블 설명<span class=\"{{vc.sortClass(\'X.TableDesc\')}}\"></span></th></tr></thead><tbody><tr ng-repeat=\"li in vc.boardList\" style=\"cursor: pointer\" ng-click=vc.goDetail(li.tableNm) ng-class=\"{\'bg-lightyellow\':selectedRow == li.tableNm}\"><!-- Result Items --><td class=text-left><span ng-bind=li.tableNm></span></td><td class=text-left><span ng-bind=li.tableDesc></span></td></tr></tbody></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.viewSizePerPageList\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalCount ng-model=vc.currentPage total-items=vc.totalCount previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div></div></div></div></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/boardmng/modal-attr-detail.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"modal-title page-header\">{{ modalCtrl.title | translate }}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><form name=metaColumn novalidate><div class=row><div class=col-lg-4><div class=form-group><label>컬럼표시섹션</label><input type=text class=\"form-control pre\" ng-model=modalCtrl.column.columnSection></div></div><div class=col-lg-4><div class=form-group><label><input type=checkbox ng-checked-=\"modalCtrl.column.customColumnYN == \'Y\'\" ng-model=modalCtrl.column.customColumnYN ng-true-value=\"\'Y\'\" disabled ng-false-value=\"\'N\'\"> 사용자정의 컬럼 여부</label><label><input type=checkbox ng-checked-=\"modalCtrl.column.KeyColumnYN == \'Y\'\" ng-model=modalCtrl.column.keyColumnYN ng-true-value=\"\'Y\'\" disabled ng-false-value=\"\'N\'\"> 정렬가능 여부</label></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>물리컬럼이름</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.columnPhysicalNm></div></div></div><div class=col-lg-4><div class=form-group><label>물리컬럼데이터크기</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.columnPhysicalDataSize></div></div></div><div class=col-lg-4><div class=form-group><label>*물리컬럼데이터유형</label><select class=form-control ng-model=modalCtrl.selectedPhysicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\" disabled></select></div></div><div class=col-lg-4><div class=form-group><label>*논리컬럼데이터유형</label><select class=form-control ng-model=modalCtrl.selectedLogicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\" disabled></select></div></div><div class=col-lg-4><div class=form-group><label>목록화면 텍스트 정렬</label><input type=text class=form-control ng-model=modalCtrl.column.listColumnTextAlign disabled></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>목록화면 표시여부</label><select class=form-control ng-model=modalCtrl.column.listColumnShowYN disabled><option value=Y>표시</option><option value=N>표시안함</option></select></div></div><div class=col-lg-4><div class=form-group><label>목록화면 표시 Level</label><select class=form-control ng-model=modalCtrl.column.listColumnShowLevel disabled><option value=1>1</option><option value=2>2</option><option value=3>3</option></select></div></div><div class=row><div class=col-lg-4><div class=form-group><label>상세화면 컬럼 폭</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.editColumnWidth></div></div></div><div class=col-lg-4><div class=form-group><label>상세화면 컬럼 높이</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.editColumnHeight></div></div></div><div class=col-lg-4><div class=form-group><label>상세화면 표시여부</label><select class=form-control ng-model=modalCtrl.column.editColumnShowYN disabled><option value=Y>표시</option><option value=N>표시안함</option></select></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>속성 설명</label><div class=\"form-control-static txt_view\" ng-bind=modalCtrl.column.columnDesc></div></div></div></div></div></form></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default\" ng-click=modalCtrl.onCancelClick()><i class=\"fa fa-close\"></i> 닫기</button></div></div>");
$templateCache.put("app/boardmng/modal-attr-setup.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=\"modal-title page-header\">{{ modalCtrl.title | translate }}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><form name=metaColumn novalidate><div class=row><div class=col-lg-4><div class=form-group><label>표시섹션</label><input type=text class=\"form-control pre\" ng-model=modalCtrl.column.columnSection></div></div><div class=col-lg-4><div class=form-group><label><input type=checkbox ng-checked-=\"modalCtrl.column.customColumnYN == \'Y\'\" ng-model=modalCtrl.column.customColumnYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> 사용자정의 컬럼 여부</label><label><input type=checkbox ng-checked-=\"modalCtrl.column.KeyColumnYN == \'Y\'\" ng-model=modalCtrl.column.keyColumnYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"> 정렬가능 여부</label></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>물리이름</label><input type=text class=form-control ng-model=modalCtrl.column.columnPhysicalNm required></div></div><div class=col-lg-4><div class=form-group><label ng-show=modalCtrl.isSizableData() style=\"color: red\">*</label><label>물리데이터크기</label><input type=number class=\"form-control pre\" ng-value=0 ng-model=modalCtrl.column.columnPhysicalDataSize ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-required=modalCtrl.isSizableData()></div></div><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>물리데이터유형</label><select class=form-control ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-model=modalCtrl.selectedPhysicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\"></select></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>물리참조이름</label><input type=text class=form-control ng-model=modalCtrl.column.columnPhysicalAsNm></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>논리데이터유형</label><select class=form-control ng-model=modalCtrl.selectedLogicalDataType ng-options=\"code as code.codeValue for code in modalCtrl.codeList track by code.code\"></select></div></div><div class=col-lg-4><div class=form-group><label>상세화면 컬럼 높이</label><input type=text class=\"form-control pre\" ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-model=modalCtrl.column.editColumnHeight></div></div><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>상세화면 폭</label><input type=text class=\"form-control pre\" ng-disabled=\"modalCtrl.column.customColumnYN == \'N\' && modalCtrl.column.type ==\'old\'\" ng-model=modalCtrl.column.editColumnWidth></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>목록표시 방법</label><select class=form-control ng-model=modalCtrl.column.listColumnShowLevel><option value=showlevel1>①항상 표시</option><option value=showlevel2>②768 이상일때 표시</option><option value=showlevel3>③992 이상일때 표시</option><option value=showlevel0>검색영역에만 표시</option></select></div></div><div class=col-lg-4><div class=form-group><label>목록화면 텍스트 정렬</label><input type=text class=form-control ng-model=modalCtrl.column.listColumnTextAlign required></div></div><div class=col-lg-4><div class=form-group><label style=\"color: red\">*</label><label>목록화면 폭</label><input type=text class=form-control ng-model=modalCtrl.column.listColumnWidth required></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>공통코드용 코드타입</label><input type=text class=form-control ng-model=modalCtrl.column.codeType></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>속성 설명</label><textarea class=form-control row=3 cols=50 ng-model=modalCtrl.column.columnDesc></textarea></div></div></div></form></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary\" ng-click=modalCtrl.onAddClick()><i class=\"fa fa-save\"></i> {{ \'Menu.APPLY\' | translate }}</button> <button class=\"btn btn-default\" ng-click=modalCtrl.onCancelClick()><i class=\"fa fa-close\"></i> {{ \'Menu.CLOSE\' | translate}}</button></div></div>");
$templateCache.put("app/boardmng/modal_attr_fieldnamerule.html","<div class=modal-header><h3 class=\"modal-title custom-font\">필드이름 규칙</h3></div><div class=modal-body><div class=tile><span ng-if=doing_async>...loading...</span><div class=\"b-a bg-default lter\"><ol><li>Varchar형 : ExtVarchar01 ~ ExtVarchar10</li><li>Integer형 : ExtInt01 ~ ExtInt10</li><li>Datetime형 : ExtDate01 ~ ExtDate10</li></ol></div></div></div><div class=modal-footer><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=reorderCtrl.onClose()><i class=\"fa fa-times\"></i> {{ \'Menu.CLOSE\' | translate }}</button></div>");
$templateCache.put("app/boardmng/modal_attr_reorder.html","<style>.btn_order_box {\r\n  position: relative;\r\n  height: 17px;\r\n  width: 100%;\r\n  padding: 0 30px;\r\n  margin-top: 0px;\r\n  margin-bottom: 0px;\r\n}\r\n\r\n.btn_order {\r\n  position: absolute;\r\n  height: 17px;\r\n  width: 80px;\r\n  right: 30px;\r\n  z-index: 9;\r\n}\r\n\r\n.btn_order .change_order {\r\n  width: 17px;\r\n  height: 17px;\r\n  display: block;\r\n  float: left;\r\n  background: url(\'/assets/images/icon/btn_change_order.png\') 0 0 no-repeat;\r\n  font-size: 0;\r\n  margin-right: 3px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_first {\r\n  background-position: 0 0;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_pre {\r\n  background-position: 0 -17px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_next {\r\n  background-position: 0 -34px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn_order .go_last {\r\n  background-position: 0 -51px;\r\n  cursor: pointer;\r\n}\r\n\r\nli.selected {\r\n  background: #f5f6f7;\r\n}</style><div class=modal-content><div class=\"modal-header ng-scope\"><h1 class=\"modal-title page-header\" ng-bind=reorderCtrl.title></h1></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"card_cont list_area\"><div class=\"b-a bg-default lter\"><ul><li data-ng-repeat=\"row in reorderCtrl.objModel\" ng-class=\"{selected:(reorderCtrl.selectedIdx == $index)}\" ng-click=reorderCtrl.onSelect($index)><span ng-bind=row.columnLogicalNm ng-if=\"row.dirty!=\'D\'\"></span>(<span ng-bind=row.columnPhysicalNm ng-if=\"row.dirty!=\'D\'\"></span>)</li></ul></div></div></div></div><div class=row><div class=col-lg-12><div class=btn_order_box><div class=btn_order><span class=\"change_order go_first\" ng-click=reorderCtrl.moveTop() translate>BTN.PAGINATION.FIRST</span> <span class=\"change_order go_pre\" ng-click=reorderCtrl.moveUp() translate>BTN.PAGINATION.PREV</span> <span class=\"change_order go_next\" ng-click=reorderCtrl.moveDown() translate>BTN.PAGINATION.NEXT</span> <span class=\"change_order go_last\" ng-click=reorderCtrl.moveBottom() translate>BTN.PAGINATION.LAST</span></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default\" ng-click=reorderCtrl.onClose()><i class=\"fa fa-shield\"></i> {{ \'Menu.CANCEL\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=reorderCtrl.onSave()><i class=\"fa fa-save\"></i> {{ \'Menu.APPLY\' | translate }}</button></div></div>");
$templateCache.put("app/chatting/h0201-chatlist.html","<div class=\"page page-footable\" ng-controller=\"H0201ChatListCtrl as vc\"><!-- page header --><div class=pageheader><h2>{{ \'Menu.CHATCOMMLIST\' | translate }}</h2><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a href=javascript:;>{{ \'Menu.JOBLIST\' | translate }}</a></li><li><a ui-sref=\"app.chatting.h0201-roomlist({ChatUserId:\'\'})\">{{ \'Menu.CHATCOMMLIST\' | translate }}</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.vc.dataloader></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><section class=tile fullscreen=isFullscreen01><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong style=\"letter-spacing: 0.5px\">{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><div class=tile-body><div class=row><div class=col-lg-3><div class=dataTables_length id=DataTables_Table_0_length ng-show=false><label>Search: <input type=text class=form-control ng-model=vc.srch.Title><!-- input id=filter 인 경우 table filtering 됨 --><md-checkbox md-no-ink=\"\" aria-label=내용포함 ng-model=vc.srch.Contents class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>{{ \'Menu.INCLUDECONTENT\' | translate }}</md-checkbox></label></div></div></div><div class=row><div class=col-lg-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ng-click=vc.getList()><i class=\"fa fa-search\"></i> {{ \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button ui-sref=\"app.chatting.h0201-roomedit({FreeChatId:\'\'})\"><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button></div></div></div></div></section></div></div><div><div class=row><div class=col-lg-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.LIST\' | translate }}</strong></h4><div class=pull-right><label>{{ \'Menu.LISTCOUNT\' | translate }} &nbsp;<select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></label></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div id=DataTables_Table_0_wrapper class=\"dataTables_wrapper form-inline no-footer\"><table id=searchTextResults ui-jq=footable data-filter=#filter data-page-size=100 data-pagination=true class=\"footable table table-custom\"><thead><tr><th data-toggle=true class=text-center>{{ \'Menu.NUMBER\' | translate }}</th><th data-toggle=true>{{ \'Menu.TITLE\' | translate }} {{ \'Menu.TALKINGPARTNER\' | translate }}</th><th data-toggle=true class=text-center>{{ \'Menu.RECENTMESSAGE\' | translate }}</th><th style=\"width: 100px\" class=text-center>{{ \'Menu.NEW\' | translate }} {{ \'Menu.MESSAGE\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" ui-sref=\"app.chatting.h0201-roomdetail({FreeChatId:\'{{li.FreeChatId}}\'})\" style=\"cursor: pointer\" my-directive><td class=text-center><span ng-bind=li.FreeChatId></span></td><td><span class=\"badge bg-lightred unread\" ng-show=\"li.NewMsg > 0\">1</span> <span ng-bind=li.Title></span>(<span ng-bind=li.ChatUsers ng-show=\"li.ChatUsers != null\"></span><span ng-show=\"li.ChatUsers == null\">{{ \'Menu.ME\' | translate }}</span>)</td><td class=text-left><div><small ng-bind=li.RegUserNm></small> - <small ng-bind=li.RegDate></small></div><div ng-bind=li.Contents></div></td><td class=text-center><span ng-bind=li.NewMsg></span></td></tr></tbody><tfoot><tr><td colspan=4 class=text-center bgcolor=#FFFFFF><ul class=pagination style=\"display: none\"></ul></td></tr></tfoot></table><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages></ul></div></div></div><!-- /tile body --><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div></div></div>");
$templateCache.put("app/chatting/h0201-roomdetail.html","<style>pre {\r\n    background-color: #fefefe;\r\n    border: 1px solid #efefef;\r\n    margin: 0;\r\n  }</style><div class=\"page page-footable\" ng-controller=\"H0201RoomDetailCtrl as vc\"><!-- FirstId={{vc.F}},LastId={{vc.L}} --><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>대화하기</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.editDetail()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail() ng-show=\"$root.gVariable.UserId == vc.data.RegUser || $root.gVariable.SysAdminYN == \'Y\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><table class=\"table table-togglable table-hover\"><colgroup><col width=127><col width=*></colgroup><tbody><!--tr>\r\n                      <th scope=\"row\">{{ \'Menu.NUMBER\' | translate }}</th>\r\n                      <td><span ng-bind=\"vc.data.FreeChatId\"></span></td>\r\n                    </tr--><tr><th scope=row>{{ \'Menu.TITLE\' | translate }}</th><td><span ng-if=!vc.data.Title ng-bind=\"\'Menu.CONVERSATION\' | translate\"></span> <span ng-if=vc.data.Title ng-bind=vc.data.Title></span></td></tr><tr><th scope=row>{{ \'Menu.REGISTRATIONUSER\' | translate }}</th><td><span ng-bind=vc.data.RegUserNm></span></td></tr><th scope=row>{{ \'Menu.TALKINGPARTNER\' | translate }}</th><td><span class=online ng-repeat=\"li in vc.data.FreeChatUser\"><i class=\"fa fa-user\"></i><span class=\"media-heading ml-5\"><strong ng-bind=li.ContactNm></strong></span><span class=\"badge badge-outline status mr-5\"></span> </span>({{vc.data.FreeChatUser.length}})</td><tr><th scope=row>{{ \'Menu.REGDATE\' | translate }}</th><td><span ng-bind=\"vc.data.RegDate | date:\'yyyy-MM-dd HH:mm\'\"></span></td></tr><tr><th scope=row>{{ \'Menu.ATTACHMENT\' | translate }}</th><td><table class=\"table table-hover table-striped invoice-list datatable dataTable no-footer\" width=100% ng-if=\"vc.data.uploadFileList.length > 0\"><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.data.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table><table ng-if=\"vc.data.uploadFileList.length == 0\"><tbody><tr class=tbnodata><td colspan={{vc.listColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody></table></td></tr></tbody></table></div></div></div></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.MESSAGECNT\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-12><div class=\"text-center mb-10\" ng-click=vc.getPrevComment() ng-if=\"vc.totalItems > vc.comment.lists.length\" style=cursor:pointer><i class=\"fa fa-angle-double-up\"></i> 더보기...</div></div></div><div class=row><div class=col-lg-12><article class=streamline-post ng-repeat=\"li in vc.comment.lists\"><div class=post-container><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\"><span style=\"color:{{li.RegUser == $root.gVariable.UserId ? \'brown\':\'\'}}\">{{li.RegUserNm}}</span> <span class=text-muted><i class=\"fa fa-clock-o mr-5\"></i>{{li.RegDate | utcToLocal: \'yyyy-MM-dd HH:mm\'}}</span> <span class=\"text-muted pull-right\" ng-hide=\"li.FreeChatCommId == vc.comment.editid || li.FreeChatType != \'M\'\"><button class=\"btn btn-default btn-xs\" style=min-height:21px ng-click=vc.deleteComment(li) ng-disabled=\"li.RegUser != $root.gVariable.UserId\" ng-if=\"li.DelYN == \'N\'\"><i class=\"glyphicon glyphicon-trash\"></i></button> </span><span class=\"text-muted pull-right\" ng-show=\"li.FreeChatCommId == vc.comment.editid\"><button class=\"btn btn-primary btn-xs\" ng-click=vc.editCommentAction(li) ng-disabled=\"li.RegUser != $root.gVariable.UserId\"><i class=\"glyphicon glyphicon-ok\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button href=\"\" class=\"btn btn-danger btn-xs\" ng-click=vc.editCommentCancel() ng-disabled=\"li.RegUser != $root.gVariable.UserId\"><i class=\"glyphicon glyphicon-remove\"></i> {{ \'Menu.CANCEL\' | translate }}</button></span></div><div class=panel-body ng-hide=\"li.FreeChatCommId == vc.comment.editid || li.WorkerId == null\">{{ \'Menu.ASSIGNCONTACTPERSON\' | translate }} : {{li.WorkerNm}}</div><div ng-hide=\"li.FreeChatCommId == vc.comment.editid\"><pre ng-if=li.Contents>{{li.Contents | translate}}</pre><a href=\"\" ng-click=vc.openAttachment(li) ng-if=li.PhysicalFileNm><i class=\"fa fa-file-o\" style=margin:5px></i>{{li.LogicalFileNm}}</a></div><div class=panel-body ng-show=\"li.FreeChatCommId == vc.comment.editid\"><md-input-container style=\"margin:5px 0\"><label>{{ \'Menu.ASSIGNCONTACTPERSON\' | translate }}</label><md-select ng-model=vc.comment.WorkerId><md-option ng-repeat=\"li in vc.data.FreeChatUser\" value={{li.UserId}}>{{li.UserNm}}</md-option></md-select></md-input-container><textarea id=strReply rows=10 style=\"width: 90%; height: 40px\" ng-model=vc.comment.editContents></textarea><span ng-show=\"li.AttachmentId != null && li.AttachmentId != \'\'\"><br>{{li.LogicalFileNm}}&nbsp;&nbsp;&nbsp;&nbsp;<a href=\"\" ng-click=vc.setDeleteFileToggle(li)><span ng-show=\"li.delState == \'\' \"><i class=icon-trash>{{ \'Menu.DELETE\' | translate }}</i></span><span ng-show=\"li.delState != \'\'\"><i class=icon-refresh></i> {{ \'Menu.CANCEL\' | translate }}</span></a></span></div></div></div></article><div class=streamline-form id=bottom><form class=\"ng-pristine ng-valid\"><div class=\"col-sm-12 input-group\"><!-- <button class=\"btn btn-default\" type=\"button\" ng-click=\"vc.openDilalog()\">{{ \'Menu.ATTACHMENT\' | translate }}</button> --><select class=\"form-control pull-right\" id=selectCombo name=selectCombo ng-model=vc.srchComment.WorkerId ng-options=\"opt.UserId as opt.UserNm for opt in vc.data.FreeChatUser\" style=max-width:200px;min-width:100px><option value=\"\">--담당자선택--</option></select><!-- <textarea id=\"emoji\" class=\"form-control\" rows=\"3\" placeholder=\"메세지를 입력하세요. (Shift + Enter로 줄바꿈이 가능합니다.)\" ng-model=\"vc.srchComment.Contents\" enter-submit=\"vc.saveComment()\"></textarea> --><textarea id=emoji class=form-control rows=10 placeholder=\"메세지를 입력하세요. (Shift + Enter로 줄바꿈이 가능합니다.)\" ng-model=vc.srchComment.Contents enter-submit=vc.saveComment()></textarea><span class=input-group-btn style=\"vertical-align: bottom\"><button class=\"btn btn-default\" type=button ng-click=vc.saveComment()>{{ \'Menu.SEND\' | translate }}</button> <button class=\"btn btn-default\" type=button ng-click=vc.openDilalog()>{{ \'Menu.ATTACHMENT\' | translate }}</button> --> </span><input id=file-5 style=\"display: none\" class=file type=file data-preview-file-type=any></div><div><table class=\"table table-hover table-striped invoice-list no-footer\" style=width:100%><colgroup><col style=\"width: 30%\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><tbody><tr id=filectl ng-repeat=\"obj in vc.uploadFileListComment\"><td><div ng-show=!obj.isLoaded class=file_list ng-bind=obj.fileName></div><a href={{obj.link}} target=attach ng-show=obj.isLoaded>{{obj.fileName}}</a></td><td align=right><span class=file_size ng-bind=obj.size|filesize></span></td><td><div class=\"progress progress-xs\" style=\"margin-bottom: 0px;height:10px\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div></td><td></td><td align=center><a href=\"\" ng-click=vc.onDelete(obj)><i class=\"fa fa-trash\"></i> {{ \'Menu.DELETE\' | translate }}</a> <a ng-show=\"obj.delState != \'\' \" href=\"\" ng-click=vc.onDeleteCancel(obj)><i class=icon-cancel-square></i> {{ \'Menu.DELETE\' | translate }}</a></td></tr></tbody></table></div></form></div></div></div></div><!-- /tile body --></div></div><!-- /col --></div><!-- /row --><div id=Content bgcolor=#DDDDDD style=width:100%></div></div><!-- /page content --></div>");
$templateCache.put("app/chatting/h0201-roomedit.html","<style>.md-chips {\r\n  display: block;\r\n  font-family: Roboto, \"Helvetica Neue\", sans-serif;\r\n  font-size: 12px;\r\n  padding: 0 0 8px 1px;\r\n  vertical-align: middle;\r\n}\r\n\r\nmd-list-item, md-list-item .md-list-item-inner {\r\n  min-height:40px !important;\r\n  height:40px !important;\r\n}\r\n\r\nmd-list-item .md-avatar {\r\n  width: 30px !important;\r\n  height: 30px !important;\r\n}</style><div class=\"page page-footable\" ng-controller=\"H0201RoomEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>대화내용</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.saveDetail()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.saveDetail()><i class=\"fa fa-times\"></i> {{ \'Menu.CANCEL\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><table class=\"table table-togglable table-hover\"><colgroup><col width=127><col width=*></colgroup><tbody><tr><th scope=row>{{ \'Menu.TITLE\' | translate }}</th><td><input type=text class=form-control ng-model=vc.data.Title placeholder=\"{{ \'Menu.CONVERSATION\' | translate }}\" ng-disabled=\"vc.data.FreeChatId != null && vc.data.RegUser != $root.gVariable.UserId\"></td></tr><tr><th scope=row>{{ \'Menu.REGISTRATIONUSER\' | translate }}</th><td><span ng-bind=vc.data.RegUserNm></span></td></tr><th scope=row>{{ \'Menu.TALKINGPARTNER\' | translate }}</th><td><!-- 채팅상대 선택 --> <span class=online ng-repeat=\"li in vc.data.FreeChatUser\" ng-if=\"vc.data.RegUser != $root.gVariable.UserId\"><i class=\"fa fa-user\"></i><span class=\"media-heading ml-5\"><strong ng-bind=li.ContactNm></strong></span><span class=\"badge badge-outline status mr-5\"></span></span><md-contact-chips ng-model=vc.newFreeChatUser md-contacts=vc.querySearch($query) md-contact-name=ContactNm md-contact-image=image md-contact-email=email md-require-match=true md-highlight-flags=i filter-selected=vc.filterSelected md-on-remove=vc.onRemoveChip($item) placeholder=추가></md-contact-chips><md-input-container md-no-float=\"\" class=md-block style=\"height: 10px\"><input ng-model=opponent placeholder=\"멤버 또는 소속 이름을 검색해주세요.\"></md-input-container><md-list class=fixedRows><md-list-item class=contact-item ng-repeat=\"(index, contact) in vc.listUsers | filter:opponent | limitTo:vc.contactSize()\" ng-if=!vc.IsContact(contact) ng-click=vc.addUser(contact.UserId)><i class=\"fa fa-user\"></i><div class=\"md-list-item-text compact ml-5\" draggable=true>{{contact.ContactNm}}</div></md-list-item></md-list><div class=\"row text-center\"><button class=\"btn btn-primary w100 mb-10\" ng-show=vc.totalContact() ng-click=vc.getMoreContact()><i class=\"fa fa-caret-down\"></i> 더보기</button></div></td><tr ng-if=\"vc.data.RegUser == $root.gVariable.UserId\"><th scope=row>{{ \'Menu.ATTACHMENT\' | translate }}</th><td><!-- 파일첨부 --><file-attach file-data=vc.data.uploadFileList callback=vc.onFileCallback></file-attach></td></tr></tbody></table></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/chatting/h0201-roomlist.html","<div class=\"page page-footable\" ng-controller=\"H0201RoomListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>대화하기<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size={{$root.gVariable.layoutBoardSize}} pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=\"row shop-view\"><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr style=\"padding-right: 0px\"></span> <span class=search-condition-str ng-if=vc.WorkerNm>지정담당자:{{vc.WorkerNm}}</span> <span class=search-condition-str ng-if=vc.ChatUserNm>,대화상대:{{vc.ChatUserNm}}</span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group><input class=\"form-control form-right\" ng-model=vc.WorkerNm placeholder=지정담당자 readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchWorkerModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseWorker() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group><input class=\"form-control form-right\" ng-model=vc.ChatUserNm placeholder=대화상대 readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchUserModal() type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseUser() type=button><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><!-- udc-search meta-list=\"vc.listColumns\" meta-model=\"vc.srch\"></udc-search --><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=pull-right><button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.ADD\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>대화목록</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><thead><tr><th data-toggle=true class=text-center style=width:20%>{{ \'Menu.TITLE\' | translate }}</th><th data-toggle=true class=text-center style=width:20%>{{ \'Menu.TALKINGPARTNER\' | translate }}</th><th data-toggle=true class=text-center style=width:40%>{{ \'Menu.RECENTMESSAGE\' | translate }}</th><th data-toggle=true class=text-center style=width:10%>{{ \'Menu.PERSONINCHARGE\' | translate }}</th><th data-toggle=true class=\"text-center showlevel3\" style=width:10%>{{ \'Menu.REGISTRATIONUSER\' | translate }}</th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goDetail(li.FreeChatId) style=\"cursor: pointer\" my-directive ng-class=\"{\'bg-lightyellow\':li.FreeChatId == selectedRow}\"><td><span class=\"badge bg-lightred unread\" ng-show=\"li.UnReadCnt > 0\">{{li.UnReadCnt}}</span> <span ng-if=!li.Title ng-bind=\"\'Menu.CONVERSATION\' | translate\"></span> <span ng-if=li.Title ng-bind=li.Title></span></td><td><span ng-bind=li.ChatUsers ng-show=\"li.ChatUsers != null\"></span> <span ng-show=\"li.ChatUsers == null\">{{ \'Menu.ME\' | translate }}</span></td><td class=text-left><div><small ng-bind=li.CommRegUserNm></small> - <small ng-bind=\"li.CommRegDate | date:\'yyyy-MM-dd HH:mm\'\"></small></div><div ng-if=li.Contents ng-bind=li.Contents class=onelinetext></div><div ng-if=!li.Contents ng-bind=li.LogicalFileNm class=onelinetext></div></td><td class=text-left><div ng-bind=li.WorkerNm></div></td><td class=\"text-left showlevel3\"><div ng-bind=li.RegUserNm></div></td></tr></tbody></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=app/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/dashboard/dashboard.html","<div class=\"page page-footable\" ng-controller=\"DashboardCtrl as vc\"><!-- 팝업공지 --><div class=szPopup_box><div class=szPopup_cont id=szPopup_cont_event><div ng-if=\"vc.popLink.GoLink != null && vc.popLink.GoLink != \'\'\"><a href={{vc.popLink.GoLink}}><img src={{vc.popLink.ImgSrc}} width={{vc.popLink.ImgW}} height={{vc.popLink.ImgH}}></a></div><div ng-if=\"vc.popLink.GoLink == null || vc.popLink.GoLink == \'\'\"><img src={{vc.popLink.ImgSrc}} width={{vc.popLink.ImgW}} height={{vc.popLink.ImgH}}></div></div><div class=szPopup_btn><a id=chkCloseToday ng-click=vc.closePopupToday(); class=close_day style=cursor:pointer>오늘 하루 그만보기</a> <a ng-click=vc.closePopup(); style=cursor:pointer>닫기</a></div></div><div class=row><div class=col-lg-12><h3 class=page-header>대시보드</h3></div></div><div class=pagecontent><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-body collapse in\"><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4 sz-search mb-0\"><div class=\"col-xs-5 col-sm-5 col-md-5 col-xg-5 col-xl-5\" style=padding:0px><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.CntDateFrom = (vc.CntDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.CntDateFrom ng-required=false placeholder=시작일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"col-xs-5 col-sm-5 col-md-5 col-xg-5 col-xl-5\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.CntDateTo = (vc.CntDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.CntDateTo ng-required=false placeholder=종료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div><div class=\"col-xs-2 col-sm-2 col-md-2 col-xg-2 col-xl-2\" style=padding:0px><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button></div></div><!-- /col --></div><!-- 검색영역 --></form><div class=row style=margin-top:5px><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=valueWrap><!-- 사례관리기관(T) --><ul class=\"ul_h value_t\" ng-if=\"vc.tenantType ==\'TAKETENANT\'\"><li><p><strong>지원신청 사례 수</strong></p><p><span class=num>{{vc.data.RG_Cnt}}</span>건</p></li><li><p><strong>지원확인 사례 수</strong></p><p><span class=num>{{vc.data.SP_Cnt}}</span>건</p></li><li><p><strong>결과보고 대기 중 사례</strong></p><p><span class=num>{{vc.data.RW_Cnt}}</span>건</p></li><li><p><strong>결과보고 완료 사례</strong></p><p><span class=num>{{vc.data.RC_Cnt}}</span>건</p></li></ul><!-- 후원기관 (G) --><ul class=\"ul_h value_g\" ng-if=\"vc.tenantType ==\'GIVETENANT\'\"><li><p><strong>관심 사례 건수</strong></p><p><span class=num>{{vc.data.AT_Cnt}}</span>건</p></li><li><p><strong>논의중인 사례 건수</strong></p><p><span class=num>{{vc.data.AG_Cnt}}</span>건</p></li><li><p><strong>지원확정 사례 건수</strong></p><p><span class=num>{{vc.data.SP_Cnt}}</span>건</p></li><li><p><strong>결과보고 대기 건수</strong></p><p><span class=num>{{vc.data.RW_Cnt}}</span>건</p></li><li><p><strong>결과보고 완료 건수</strong></p><p><span class=num>{{vc.data.RC_Cnt}}</span>건</p></li></ul><!-- 이랜드 재단 (R) --><ul class=\"ul_h value_r\" ng-if=\"vc.tenantType !=\'TAKETENANT\' && vc.tenantType !=\'GIVETENANT\'\"><li><p><strong>지원신청 사례 수</strong></p><p><span class=num>{{vc.data.RG_Cnt}}</span>건</p></li><li><p><strong>관심 사례 건수</strong></p><p><span class=num>{{vc.data.AT_Cnt}}</span>건</p></li><li class=value_r_first><p><strong>논의중인 사례 건수</strong></p><p><span class=num>{{vc.data.AG_Cnt}}</span>건</p></li></ul><ul class=\"ul_h value_r\" ng-if=\"vc.tenantType !=\'TAKETENANT\' && vc.tenantType !=\'GIVETENANT\'\"><li><p><strong>지원확정 사례 건수</strong></p><p><span class=num>{{vc.data.SP_Cnt}}</span>건</p></li><li><p><strong>결과보고 대기 건수</strong></p><p><span class=num>{{vc.data.RW_Cnt}}</span>건</p></li><li><p><strong>결과보고 완료 건수</strong></p><p><span class=num>{{vc.data.RC_Cnt}}</span>건</p></li></ul></div></div></div></div></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{vc.BbsNm}}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Title type=text><label>{{ vc.columnMap[\'Title\'].ColumnLogicalNm | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Contents type=text><label>{{ vc.columnMap[\'Contents\'].ColumnLogicalNm | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'BoardType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'BoardType\'].CodeList\" code-model=vc.srch.BoardType></common-code-custom><label>{{vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.BbsPostId, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.BbsPostId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=40>{{li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd HH:mm\'}}</span> <span ng-switch-when=50>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60>{{$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm]) | html}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></tbody></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label class=list-label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div></div></div>");
$templateCache.put("app/company/company-detail.html","<div class=\"page page-footable\" ng-controller=\"CompanyDetailCtrl as vc\" ng-drop=true><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.DETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit() ng-if=\"vc.isManage && vc.changeable\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goDelete() ng-if=\"vc.isManage && vc.tenantId == 0\"><i class=\"fa fa-edit\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>기관 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Ceo\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.Ceo readonly></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BizRegNo\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=10 ng-model=vc.data.BizRegNo readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><input type=text class=\"form-control form-right\" auto-hyphen ng-model=vc.data.TelNo readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Fax\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" auto-hyphen ng-model=vc.data.Fax readonly></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.Email readonly></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Organization\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><input type=text class=\"form-control form-right\" ng-model=vc.data.organization readonly> <input type=text class=\"form-control form-right\" ng-if=\"vc.data.organization_code == 57\" ng-model=vc.data.organizationSub readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'HomepageUrl\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.HomepageUrl readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>주소<span class=point_red>*</span></label><div class=input-group><input class=form-control id=zipCode maxlength=7 ng-model=vc.data.ZipCode readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.getAddressInfo() type=button><i class=\"fa fa-search\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label></label><input class=form-control id=addr1 maxlength=200 ng-model=vc.data.Addr1 type=text readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><input class=form-control id=addr2 maxlength=200 ng-model=vc.data.Addr2 type=text readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TenantComment\'].ColumnLogicalNm | translate}}</label><textarea type=text class=\"form-control form-right\" ng-model=vc.data.TenantComment readonly></textarea></div></div></div><div class=row ng-if=vc.isManage><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BaseYN\'].ColumnLogicalNm | translate}}</label><common-code-custom code-list=\"vc.columnMap[\'BaseYN\'].CodeList\" code-model=vc.data.BaseYN readonly></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TenantStatusNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantStatusNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\" ng-if=vc.changeable><div class=\"form-group form-inline\"><button class=\"btn btn-default\" ng-click=\"vc.updateTenantStatus(\'Y\')\" ng-disabled=\"vc.TenantStatus == \'Y\'\">승인</button> <button class=\"btn btn-default\" ng-click=\"vc.updateTenantStatus(\'N\')\" ng-disabled=\"vc.TenantStatus == \'N\'\">반려</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ContactUserNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.ContactUserNm readonly></div></div></div></div></div></div></div></div><!-- /row --><!-- row --><div class=\"row mt-10\"><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>임직원 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" width=100%><thead><tr><th class=\"text-center none\">역할</th><th class=\"text-center none\">이름</th><th class=\"text-center none\">아이디</th><th class=\"text-center none\">휴대폰</th><th class=\"text-center none\">Email</th><th class=\"text-center none\" ng-show=vc.isAdminS>수정</th></tr></thead><tr ng-repeat=\"div in vc.lists;\"><td class=\"text-center none\">{{div.RoleNm}}</td><td class=\"text-center none\">{{div.UserNm}}</td><td class=\"text-center none\">{{div.LoginId}}</td><td class=\"text-center none\">{{div.UserMob}}</td><td class=\"text-center none\">{{div.UserEmail}}</td><td class=\"text-center none\" ng-show=vc.isAdminS><button class=\"btn btn-default\" ng-click=vc.goUserEdit(div.UserId)>수정</button> <button class=\"btn btn-default\" ng-click=vc.resetPwd(div.UserId)>비밀번호 초기화</button></td></tr></table></div></div></div><!-- /row --></div><!-- /page content --></div></div>");
$templateCache.put("app/company/company-edit.html","<div class=\"page page-footable\" ng-controller=\"CompanyEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.saveData() ng-if=\"vc.tenantId == vc.data.KeyId || vc.tenantId == 0\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goDetail() ng-if=\"vc.tenantId == vc.data.KeyId || vc.tenantId == 0\"><i class=\"fa fa-times\"></i> {{ \'Menu.CANCEL\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>기관 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Ceo\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.Ceo></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BizRegNo\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><div class=input-group><input type=text class=\"form-control form-right\" maxlength=10 oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\')\" ng-model=vc.data.BizRegNo></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><input type=text class=\"form-control form-right\" auto-hyphen oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\')\" ng-model=vc.data.TelNo></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Fax\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" auto-hyphen oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\')\" ng-model=vc.data.Fax></div></div><div class=\"col-lg-4 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.Email></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'Organization\'].ColumnLogicalNm | translate}}<span class=point_red>*</span></label><common-code-custom code-list=vc.organizationList code-model=vc.data.organization_code></common-code-custom><common-code-custom ng-if=\"vc.data.organization_code == 57\" code-list=vc.organizationSubList code-model=vc.data.organizationSub_code></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'HomepageUrl\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.HomepageUrl></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>주소<span class=point_red>*</span></label><div class=input-group><input class=form-control id=zipCode maxlength=7 ng-model=vc.data.ZipCode disabled type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.getAddressInfo() type=button><i class=\"fa fa-search\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label></label><input class=form-control id=addr1 maxlength=200 ng-model=vc.data.Addr1 disabled type=text></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><input class=form-control id=addr2 maxlength=200 ng-model=vc.data.Addr2 type=text></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TenantComment\'].ColumnLogicalNm | translate}}</label><textarea type=text class=\"form-control form-right\" ng-model=vc.data.TenantComment></textarea></div></div></div><div class=row ng-if=vc.isManage><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'BaseYN\'].ColumnLogicalNm | translate}}</label><common-code-custom code-list=\"vc.columnMap[\'BaseYN\'].CodeList\" code-model=vc.data.BaseYN></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'TenantStatusNm\'].ColumnLogicalNm | translate}}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantStatusNm disabled></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label>{{vc.columnMap[\'ContactUserNm\'].ColumnLogicalNm | translate}}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.ContactUserNm disabled> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchUserModal();><i class=\"fa fa-search\"></i></button></span></div></div></div></div></div></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/company/company-list.html","<div class=\"page page-footable\" ng-controller=\"CompanyListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header><span id=title>{{vc.title}}</span><div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.TenantNm placeholder=\"기관명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'TenantNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.TenantNm type=text><label>{{vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'TenantType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'TenantType\'].CodeList\" code-model=vc.srch.TenantTypeVal></common-code-custom><label>{{vc.columnMap[\'TenantType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ContactUserNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ContactUserNm type=text><label>{{vc.columnMap[\'ContactUserNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ContactUserMob\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ContactUserMob type=text><label>{{vc.columnMap[\'ContactUserMob\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Email\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Email type=text><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'TelNo\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.TelNo type=text><label>{{vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'BaseYN\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'BaseYN\'].CodeList\" code-model=vc.srch.BaseYN></common-code-custom><label>{{vc.columnMap[\'BaseYN\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ParCityCode\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ParCityCode\'].CodeList\" code-model=vc.srch.ParCityCode ng-change=vc.chgParCityCode()></common-code-custom><label>{{vc.columnMap[\'ParCityCode\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'CityCode\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=vc.CityCodeList code-model=vc.srch.CityCode></common-code-custom><label>{{vc.columnMap[\'CityCode\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><!-- <div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\">\r\n                <div class=\"pull-right\">\r\n                  <button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=\"vc.getExcelFile2()\">\r\n                    <i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}\r\n                  </button>\r\n                  <button class=\"btn btn-primary\" ng-if=\"$root.gVariable.srchTenantId == 0\" ng-click=\"vc.goAdd()\">\r\n                    <i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}\r\n                  </button>\r\n                </div>\r\n              </div> --><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><!-- 마이페이지 - 기관관리 또는 재단/시스템관리자 목록 화면 --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" ng-if=\"vc.type == \'Manage\' || (vc.tenantType != \'TAKETENANT\' && vc.tenantType != \'GIVETENANT\')\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goDetail(li.KeyId) ng-repeat=\"liCol in vc.listColumns\" ng-if=\"liCol.ListColumnShowLevel != \'showlevel0\'\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=40 class=onelinetext>{{li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd\'}}</span> <span ng-switch-when=50 class=onelinetext>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60 class=onelinetext><i class=\"fa {{li[liCol.ColumnPhysicalNm]}}\" aria-hidden=true></i> </span><span ng-switch-when=70 class=onelinetext>{{li[liCol.ColumnPhysicalNm] | tel}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></table><!-- 게시판 - 협력기관소개 후원기관/사례관리기관 만 보이는 메뉴  --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" ng-if=\"vc.type == \'Introduce\' && (vc.tenantType == \'TAKETENANT\' || vc.tenantType == \'GIVETENANT\')\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none 3\" data-toggle=\"\'true\'\" ng-click=\"vc.setSortColumn(\'TenantNm\', \'Y\')\">{{ :: \'기관명\' | translate }} <span class=\"{{vc.setSortDirect(\'TenantNm\')}}\"></span></th><th class=\"text-center none 0\" data-toggle=\"\'true\'\" ng-click=\"vc.setSortColumn(\'RegDate\', \'Y\')\">{{ :: \'가입일\' | translate }} <span class=\"{{vc.setSortDirect(\'RegDate\')}}\"></span></th><th class=\"text-center none 3\" data-toggle=\"\'true\'\" ng-click=\"vc.setSortColumn(\'TenantType\', \'Y\')\">{{ :: \'기관구분\' | translate }} <span class=\"{{vc.setSortDirect(\'TenantType\')}}\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"text-center 3\"><span class=onelinetext>{{li.TenantNm}}</span></td><td class=\"text-center 3\"><span class=onelinetext>{{li.RegDate | date:\'yyyy-MM-dd\'}}</span></td><td class=\"text-center 3\"><span class=onelinetext>{{li.TenantTypeNm}}</span></td></tr></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/company/company-take-list.html","<div class=\"page page-footable\" ng-controller=\"CompanyTakeListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>사례 관리</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor=west><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor=west pane-handle=4 pane-max=\"80% + 2px\" pane-min=50% pane-size=50%><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=\"row shop-view\"><div class=\"col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.TargetNm placeholder=\"대상자명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.TargetNm type=text><label>대상자명</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.ApplyCmpDateFrom = (vc.ApplyCmpDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.ApplyCmpDateFrom ng-required=false placeholder=선정일 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.ApplyCmpDateTo = (vc.ApplyCmpDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.ApplyCmpDateTo ng-required=false placeholder=선정일 type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'Status\'].CodeList\" code-model=vc.srch.Status></common-code-custom><label>진행상태</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><select class=form-control ng-model=vc.srch.ResultStatus><option value=\"\">-- 선택 --</option><option value=SAVE>완료</option><option value=RETN>반려</option><option value=N>대기</option></select><label>결과보고 여부</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><select class=form-control ng-model=vc.srch.BestYN><option value=\"\">-- 선택 --</option><option value=Y>Y</option><option value=N>N</option></select><label>우수사례 여부</label></div></div></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center data-toggle=true style=\"width: 10%\">대상자명</th><th class=text-center data-toggle=true style=\"width: 10%\">선정일</th><th class=text-center data-toggle=true style=\"width: 10%\">진행상태</th><th class=text-center data-toggle=true style=\"width: 10%\">결과보고 여부</th><th class=text-center data-toggle=true style=\"width: 10%\">우수사례</th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-click=vc.goDetail(li.TenantId)><td class=text-center><span>{{li.TargetNm}}</span></td><td class=text-center><span>{{li.ApplyCmpDate | date:\'yyyy-MM-dd\'}}</span></td><td class=text-center><span>{{li.StatusNm}}</span></td><td class=text-center><span ng-if=\"li.ResultStatus == \'SAVE\'\">결과보고 완료</span> <span ng-if=\"li.ResultStatus == \'RETN\'\">반려</span> <span ng-if=\" ! li.ResultStatus\">결과보고 대기</span></td><td class=text-center><span ng-if=li.ResultStatus>{{li.BestYN}}</span> <span ng-if=\" ! li.ResultStatus\">-</span></td></tr></table></div><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><div fa-pane pane-min=50%;><ui-view><div class=boardNothing ng-if=!vc.TenantId><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록을 선택하시면 기관 요약 정보를 보실 수 있습니다.</p></div></div><div class=\"panel panel-default tile\" ng-if=vc.TenantId><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>기관 요약 정보</strong></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 30%\"><col style=\"width: 70%\"></colgroup><tbody><tr><th>기관명</th><td>{{vc.data.TenantNm}}</td></tr><tr><th>담당자명</th><td>{{vc.data.UserNm}}</td></tr><tr><th>평가완료 사례 수</th><td><span ng-if=vc.data.MoniCnt>{{vc.data.MoniCnt}}건</span></td></tr><tr><th>평균 점수</th><td><span ng-if=vc.data.TakeTenantSc>{{vc.data.TakeTenantSc}}점</span></td></tr><tr><th>최근 1년 평균 점수</th><td><span ng-if=vc.data.MoniScByYear>{{vc.data.MoniScByYear}}점</span></td></tr><tr><th>최근 평가일</th><td>{{vc.data.MoniDate}}</td></tr><tr><th>우수기관 여부</th><td>{{vc.data.TakeTenantGradeNm}}</td></tr><tr><th>관리필요 여부</th><td><span ng-if=vc.data.TakeTenantGradeNm>{{vc.data.ChkYN}}</span></td></tr></tbody></table></div></div></ui-view></div></div></div></div></div><!-- /page content -->");
$templateCache.put("app/eland-request/take-best-detail.html","<div class=\"page page-footable elandCustom\" ng-controller=\"BestCaseDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=ailoader ng-show=\"vc.ailoader1 ||  vc.ailoader2\"><div class=ailoader_txt ng-show=vc.ailoader1>AI 감동스토리를 생성중입니다.<br>잠시만 기다려주세요.</div><div class=ailoader_txt ng-show=vc.ailoader2>AI 감동스토리 파일을 생성중입니다.<br>잠시만 기다려주세요.</div></div><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>우수사례 등록</h3></div></div><div class=pagecontent><!-- 버튼 영역 --><div class=row><div class=col-md-12><div class=\"pull-right mb-5\"><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- 버튼 영역 끝 --><!----------------------------------------------------------------------------------------------------><!-- 기본 정보 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>기본 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=\"form-group form-inline\"><label><strong>문서제목</strong></label><input type=text class=form-control ng-model=vc.data.Title style=\"text-align: left\" readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>신청일</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.ReqDate readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>대상자명</strong></label><input type=text class=\"form-control form-right\" value=\"{{vc.data.TargetNm}} ({{vc.data.Age}}세)\" readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>지원영역</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.SupportReqNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>최종지원금액</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.FinalSptSum comma readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>사례관리기관</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.TakeTenantNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>후원기관</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.GiveTenantNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>진행상태</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.StatusNm readonly></div></div></div></div></div></div></div><!-- 기본 정보 끝 --><!----------------------------------------------------------------------------------------------------><!--  --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>우수사례</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\">우수사례 여부</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=BestYN ng-model=vc.data.BestYN ng-checked=\"vc.data.BestYN == \'Y\'\" value=Y disabled> 적합</label></li><li><label><input type=radio name=BestYN ng-model=vc.data.BestYN ng-checked=\"vc.data.BestYN == \'N\'\" value=N disabled> 부적합</label></li></ul></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!--  --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>감동스토리</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\" rowspan=2>감동스토리</th><td><button ng-if=!vc.aiStoryEdit class=\"btn-min btn btn-default\" ng-click=vc.downloadFile()><i class=\"glyphicon glyphicon-file\"></i> 다운로드</button> <button ng-if=!vc.aiStoryEdit class=\"btn-min btn btn-default\" ng-click=\"vc.toggleAiEdit(\'\')\"><i class=\"glyphicon glyphicon-edit\"></i> 편집</button> <button ng-if=vc.aiStoryEdit class=\"btn-min btn btn-default\" ng-click=vc.saveAiData(false)><i class=\"glyphicon glyphicon-edit\"></i> 저장</button></td></tr><tr><td><textarea ng-if=vc.aiStoryEdit rows=10 id=aiStory class=\"form-control mt-10 mb-5\" ng-model=vc.data.AiStory></textarea><div ng-if=!vc.aiStoryEdit class=ai_html ng-bind-html=vc.aiView.AiStory></div></td></tr></tbody></table></div></div></div></div><!-- 버튼 영역 --><div class=\"pull-right mb-20\"><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div><!-- 버튼 영역 끝 --></div><!-- /page content --></div>");
$templateCache.put("app/eland-request/take-best-edit.html","<div class=\"page page-footable elandCustom\" ng-controller=\"BestCaseEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>우수사례 등록</h3></div></div><div class=pagecontent><!-- 버튼 영역 --><div class=row><div class=col-md-12><div class=\"pull-right mb-5\"><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData() ng-if=\"vc.tenantId != \'0\'\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- 버튼 영역 끝 --><!----------------------------------------------------------------------------------------------------><!-- 기본 정보 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>기본 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=\"form-group form-inline\"><label><strong>문서제목</strong></label><input type=text class=form-control ng-model=vc.data.Title style=\"text-align: left\" readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>신청일</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.ReqDate readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>대상자명</strong></label><input type=text class=\"form-control form-right\" value=\"{{vc.data.TargetNm}} ({{vc.data.Age}}세)\" readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>지원영역</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.SupportReqNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>최종지원금액</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.FinalSptSum comma readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>사례관리기관</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.TakeTenantNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>후원기관</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.GiveTenantNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>진행상태</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.StatusNm readonly></div></div></div></div></div></div></div><!-- 기본 정보 끝 --><!----------------------------------------------------------------------------------------------------><!--  --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>우수사례</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\">우수사례 여부</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=BestYN ng-model=vc.data.BestYN ng-checked=\"vc.data.BestYN == \'Y\'\" value=Y disabled> 적합</label></li><li><label><input type=radio name=BestYN ng-model=vc.data.BestYN ng-checked=\"vc.data.BestYN == \'N\'\" value=N disabled> 부적합</label></li></ul></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!--  --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>사진/영상 첨부</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><p>※ 이미지파일만 등록 가능합니다.</p><br><table class=\"reportTable tb_report mb-10\" style=width:100%><colgroup><col style=\"width: 30%\"><col style=\"width: 70%\"></colgroup><tbody><tr id=attachFile><th>종류</th><th>파일</th></tr><tr ng-repeat=\"(key, fileObj) in vc.attachRpt\" ng-if=fileObj.ngIf><td ng-if=fileObj.isLoaded>{{ fileObj.label }}</td><td ng-if=fileObj.isLoaded><input class=\"form-control form-right\" type=text ng-model=fileObj.fileName ng-click=vc.downloadFile(key) style=\"cursor: pointer; width: 100%\" readonly></td></tr><tr ng-repeat=\"(key, fileObj) in vc.attach\" ng-if=fileObj.ngIf><td>{{ fileObj.label }}</td><td><div class=input-group><input id=\"{{ key }}\" style=\"display: none\" class=file type=file multiple data-preview-file-type=any data-upload-url=#> <input class=\"form-control form-right\" type=text ng-model=fileObj.fileName ng-click=vc.downloadTemp(key) style=\"cursor: pointer\" readonly><div class=input-group-btn><button ng-show=!fileObj.isLoaded class=\"btn btn-default\" ng-click=vc.openAttachDialog(key)><i class=\"fa fa-save\"></i>찾기</button> <button ng-show=fileObj.isLoaded class=\"btn btn-default\" ng-click=vc.onDelete(key)><i class=\"fa fa-times\"></i>삭제</button></div></div></td></tr></tbody></table><button class=\"btn btn-primary\" ng-click=\"vc.addFile(\'Photo\')\"><i class=\"fa fa-file\"></i> 지원 후 사진 추가</button> <button class=\"btn btn-primary\" ng-click=\"vc.addFile(\'Letter\')\"><i class=\"fa fa-file\"></i> 감사 편지 추가</button></div></div></div></div><!-- 버튼 영역 --><div class=\"pull-right mb-20\"><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData() ng-if=\"vc.tenantId != \'0\'\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div><!-- 버튼 영역 끝 --></div><!-- /page content --></div>");
$templateCache.put("app/eland-request/take-detail.html","<div class=\"page page-footable elandCustom\" ng-controller=\"TakeDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=ailoader ng-show=vc.ailoader1><div class=ailoader_txt ng-show=vc.ailoader1>AI 자동 심사 내용을 분석중입니다.<br>잠시만 기다려주세요.</div></div><nav id=skipGnb><!-- 접혀있을 경우 << --> <button ng-if=\"vc.btnShow == \'0\'\" ng-click=\"vc.btnShow = \'1\'\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button><!-- 펼쳐있을 경우 >> --> <button ng-if=\"vc.btnShow == \'1\'\" ng-click=\"vc.btnShow = \'0\'\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button><!-- 기본 펼침, 버튼 누르면 접힘--><ul ng-if=\"vc.btnShow == \'1\'\"><li class=quickNavFirst ng-if=vc.isAdminSH ng-click=\"vc.scrollMove(\'field0\')\">실행 정보</li><li ng-click=\"vc.scrollMove(\'pn2\')\">-> 대상자 인적사항</li><li ng-click=\"vc.scrollMove(\'pn3\')\">-> 신청내역</li><li ng-click=\"vc.scrollMove(\'pn4\')\" ng-if=\"(vc.data.CohabitCnt != null && vc.data.CohabitCnt > 0)\">-> 가족관계</li><li ng-click=\"vc.scrollMove(\'pn5\')\" ng-if=\"(vc.data.HousTypeValue != null && vc.data.HousTypeValue != \'\')\">-> 경제 상황</li><li ng-click=\"vc.scrollMove(\'pn6\')\">-> 추천기관</li><li ng-click=\"vc.scrollMove(\'pn7\')\">-> 첨부서류</li><li ng-click=\"vc.scrollMove(\'pn9\')\" ng-if=\"vc.isAdminSH || vc.tenantType == \'TAKETENANT\'\">-> 서류심사 체크리스트</li><li ng-click=\"vc.scrollMove(\'pn8\')\">-> 현장실사 가능 일자</li><li ng-click=\"vc.scrollMove(\'pn10\')\" ng-if=\"vc.isAdminAI || vc.tenantType == \'TAKETENANT\'\">-> AI 자동 심사 결과</li><li ng-click=\"vc.scrollMove(\'pn11\')\" ng-if=\"vc.isAdminSH || vc.isCaseB\">-> 현장실사 배치</li><li ng-click=\"vc.scrollMove(\'pn12\')\">-> 최종심사</li><li ng-click=\"vc.scrollMove(\'pn13\')\">-> 외부자원연계</li><li class=quickNavEnd ng-click=\"vc.scrollMove(\'pn14\')\">댓글 정보</li></ul></nav><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>지원사례 관리</h3></div></div><div ng-if=\" ! vc.chkPass\"><div class=pwBox><span>조회 비밀번호 : </span><input type=password class=form-control ng-model=vc.data.chkPasswd maxlength=10> <button class=\"btn btn-primary\" ng-click=vc.doChkPass()><i class=\"fa fa-save\"></i> 확인</button> <button class=\"btn btn-default\" ng-click=vc.goList()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div><div ng-if=vc.chkPass><div class=pagecontent><!-- 버튼 영역 --><div class=row><div class=\"pull-right mb-5 mr-10\"><button class=\"btn btn-default\" ng-click=vc.saveExe() ng-if=vc.isAdminSH ng-disabled=\"vc.disExe1 && vc.disExe2 && vc.disExe3 && vc.disExe4\"><i class=\"fa fa-edit\"></i> 실행정보 저장</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"(vc.isAdminA || vc.data.TenantId == vc.tenantId) && (vc.data.Status == null || vc.data.Status == \'\' || vc.data.Status == \'RG\' || vc.data.Status == \'NO\')\"><i class=\"fa fa-trash\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit() ng-if=\"(vc.tenantId == 0 && ! vc.isAdminB) || ((vc.data.TenantId == vc.tenantId || vc.isAdminB) && (vc.data.Status == null || vc.data.Status == \'\' || vc.data.Status == \'RG\'))\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.reSetData() ng-if=\"vc.tenantId == \'0\' && (vc.data.Status == \'AT\' || vc.data.Status == \'AG\' || vc.data.Status == \'SP\')\"><i class=\"fa fa-check-circle\"></i> 초기화</button> <button class=\"btn btn-primary\" ng-click=\"vc.approval(\'AT\')\" ng-if=\"vc.tenantType == \'GIVETENANT\' && vc.approATShow\"><i class=\"fa fa-check-circle\"></i> 지원신청 하기</button> <button class=\"btn btn-primary\" ng-click=\"vc.approval(\'AG\')\" ng-if=\"vc.tenantType == \'GIVETENANT\' && vc.approAGShow\"><i class=\"fa fa-check-circle\"></i> 논의중 단계 진행</button> <button class=\"btn btn-primary\" ng-click=\"vc.approval(\'SP\')\" ng-if=\"vc.tenantType == \'GIVETENANT\' && vc.approSPShow\" onclick=\"alert(\'댓글에 지원 확정 여부와 금액을 작성해주세요.\')\"><i class=\"fa fa-check-circle\"></i> 지원확정하기</button> <button class=\"btn btn-danger\" ng-click=\"vc.canCelData(\'AT\')\" ng-if=\"vc.tenantType == \'GIVETENANT\' && vc.cancelATShow\"><i class=\"fa fa-ban\"></i> 취소하기</button> <button class=\"btn btn-danger\" ng-click=\"vc.canCelData(\'AG\')\" ng-if=\"vc.tenantType == \'GIVETENANT\' && vc.cancelAGShow\"><i class=\"fa fa-ban\"></i> 취소하기</button> <button class=\"btn btn-default mobile-none\" ng-click=vc.printTake()><i class=\"fa fa-print\"></i> 출력</button> <button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div><!-- 버튼 영역 끝 --><div id=field0 class=\"row mb-30\" ng-if=vc.isAdminSH><div class=\"col-md-12 col-xs-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>실행 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 30%\"><col style=\"width: 55%\"></colgroup><tbody><tr><th>기관추천</th><td><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.ext1Data.RecommTenantNm disabled> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"vc.srchTenantModal(\'R\');\" ng-disabled=vc.disExe1><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.saveTenantRecomm(); ng-disabled=vc.disExe1 style=z-index:1>저장</button></span></div></td><td><ul class=\"ul_h li_mr15\"><li ng-repeat=\"li in vc.ext1Data.list\">[{{li.RecommTenantNm}}<span ng-click=vc.deleteTenantRecomm(li) ng-if=\" ! vc.disExe1\"><i class=\"fa fa-times fa-lg\"></i></span>]</li></ul></td></tr><tr><th>봉사단 지정</th><td><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.ext2Data.UserNm disabled> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchVolunteerModal(); ng-disabled=vc.disExe2><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.saveVolunteer(); ng-disabled=vc.disExe2 style=z-index:1>저장</button></span></div></td><td><ul class=\"ul_h li_mr15\"><li ng-repeat=\"li in vc.ext2Data.list\">[{{li.UserNm}}<span ng-click=vc.deleteVolunteer(li) ng-if=\" ! vc.disExe2\"><i class=\"fa fa-times fa-lg\"></i></span>]</li></ul></td></tr><tr><th>현장확인</th><td><div class=radioWrap><label><input class=mr-5 id=rdoSiteY name=SiteVeriftYN ng-checked=\"vc.data.SiteVeriftYN == \'1\'\" ng-model=vc.data.SiteVeriftYN type=radio value=1 ng-disabled=vc.disExe3> 완료</label><label><input id=rdoSiteN name=SiteVeriftYN ng-checked=\"vc.data.SiteVeriftYN == \'0\'\" ng-model=vc.data.SiteVeriftYN type=radio value=0 ng-disabled=vc.disExe3> 미완료</label></div></td><td></td></tr><tr><th>진행상태</th><td><common-code-custom code-list=\"vc.columnMap[\'Status\'].CodeList\" code-model=vc.data.Status ng-disabled=vc.disExe4></common-code-custom></td><td></td></tr><tr ng-if=\" ! [undefined,null,\'\'].includes(vc.ApplyCmpDate)\"><th>지원확정일 변경</th><td><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.ApplyCmpDate = (vc.ApplyCmpDate | date: \'yyyy-MM-dd\')\" ng-model=vc.ApplyCmpDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></td><td></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>기관추천</label><span ng-repeat=\"li in vc.ext1Data.list\">[{{li.RecommTenantNm}}<span ng-click=vc.deleteTenantRecomm(li) ng-if=\" ! vc.disExe1\"><i class=\"fa fa-times fa-lg\"></i></span>]</span></div><div class=form-group__input-group><input type=text class=\"form-control form-right\" ng-model=vc.ext1Data.RecommTenantNm disabled><div class=form-group__button-group><button class=\"btn btn-default\" type=button ng-click=\"vc.srchTenantModal(\'R\');\" ng-disabled=vc.disExe1><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.saveTenantRecomm(); ng-disabled=vc.disExe1 style=z-index:1>저장</button></div></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>봉사단 지정</label><span ng-repeat=\"li in vc.ext2Data.list\">[{{li.UserNm}}<span ng-click=vc.deleteVolunteer(li) ng-if=\" ! vc.disExe2\"><i class=\"fa fa-times fa-lg\"></i></span>]</span></div><div class=form-group__input-group><input type=text class=\"form-control form-right\" ng-model=vc.ext2Data.UserNm disabled> <span class=form-group__button-group><button class=\"btn btn-default\" type=button ng-click=vc.srchVolunteerModal(); ng-disabled=vc.disExe2><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.saveVolunteer(); ng-disabled=vc.disExe2 style=z-index:1>저장</button></span></div></div><div class=form-group><label class=form-group__label>현장확인</label><div class=form-group__radio-group><label><input class=mr-5 id=rdoSiteY name=SiteVeriftYN ng-checked=\"vc.data.SiteVeriftYN == \'1\'\" ng-model=vc.data.SiteVeriftYN type=radio value=1 ng-disabled=vc.disExe3> 완료</label><label><input id=rdoSiteN name=SiteVeriftYN ng-checked=\"vc.data.SiteVeriftYN == \'0\'\" ng-model=vc.data.SiteVeriftYN type=radio value=0 ng-disabled=vc.disExe3> 미완료</label></div></div><div class=form-group><label class=form-group__label>진행상태</label><common-code-custom code-list=\"vc.columnMap[\'Status\'].CodeList\" code-model=vc.data.Status ng-disabled=vc.disExe4></common-code-custom></div></fieldset></div></div></div></div></div><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>지원사례 보기</h3></div></div><div class=pagecontent id=printDiv><div id=pn1 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>신청 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th>타기관 연계 신청 동의 여부</th><td><strong>{{vc.data.SecretYN_}}</strong></td></tr><tr><th>제목</th><td><strong>{{vc.data.Title}}</strong></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><label class=form-group__label>타기관 연계 신청 동의 여부</label><div class=form-group__wrap><p class=form-group__text>{{vc.data.SecretYN_}}</p></div></div><div class=form-group><label class=form-group__label>제목</label><div class=form-group__wrap><p class=form-group__text>{{vc.data.Title}}</p></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 1. 대상자 인적사항 --><div id=pn2 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>대상자 인적사항</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 15%\"><col style=\"width: 35%\"></colgroup><tbody><tr><th>이름</th><td ng-if=\"vc.tenantId != 0\"><span ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\" ng-bind=vc.data.TargetNm></span> <span ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\" ng-bind=vc.data.TargetNm_></span></td><td ng-if=\"vc.tenantId == 0\"><span ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\" ng-bind=vc.data.TargetNm></span> <span ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\" ng-bind=vc.data.TargetNm_></span></td><th>성별</th><td>{{vc.data.GenderNm}}</td></tr><tr><th>주민등록번호 (나이)</th><td colspan=3><div ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\"><span ng-bind=vc.data.JuminNo></span> ({{vc.data.Age}}세)</div><div ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\"><span>******-******* (**세)</span></div></td></tr><tr><th>연락처</th><td><input type=text auto-hyphen ng-model=vc.data.Mobile readonly></td><th>주소</th><td><div ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\">{{vc.data.Addr1}} {{vc.data.Addr2}} ({{vc.data.ZipCode}})</div><div ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\">{{vc.data.Addr1_}} {{vc.data.Addr2_}} ({{vc.data.ZipCode_}})</div></td></tr><tr><th>세대유형</th><td>{{vc.data.GenTypeValue}} <span ng-if=\"vc.data.GenTypeEtc != null && vc.data.GenTypeEtc != \'\'\">({{vc.data.GenTypeEtc}})</span></td><th>질병 및 질환 여부</th><td>{{vc.data.DiseaseValue}} <span ng-if=\"vc.data.DiseaseNm != null && vc.data.DiseaseNm != \'\'\">({{vc.data.DiseaseNm}})</span></td></tr><tr><th>보호구분</th><td>{{vc.data.ProtTypeValue}} <span ng-if=\"vc.data.HealthIndemValue != null && vc.data.HealthIndemValue != \'\'\">({{vc.data.HealthIndemValue}})</span></td><th>장애 여부</th><td>{{vc.data.ImpairValue}} <span ng-if=\"vc.data.ImpairNm != null && vc.data.ImpairNm != \'\'\">({{vc.data.ImpairNm}})</span></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><label class=form-group__label>이름</label><div class=form-group__wrap ng-if=\"vc.tenantId != 0\"><span ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\" ng-bind=vc.data.TargetNm></span> <span ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\" ng-bind=vc.data.TargetNm_></span></div><div class=form-group__wrap ng-if=\"vc.tenantId == 0\"><span ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\" ng-bind=vc.data.TargetNm></span> <span ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\" ng-bind=vc.data.TargetNm_></span></div></div><div class=form-group><label class=form-group__label>성별</label><div class=form-group__wrap><p class=form-group__text>{{vc.data.GenderNm}}</p></div></div><div class=form-group><label class=form-group__label>주민등록번호 (나이)</label><div class=form-group__wrap><div ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\"><span ng-bind=vc.data.JuminNo></span> ({{vc.data.Age}}세)</div><div ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\"><span>******-******* (**세)</span></div></div></div><div class=form-group><label class=form-group__label>연락처</label><div class=form-group__wrap><input type=text auto-hyphen ng-model=vc.data.Mobile readonly></div></div><div class=form-group><label class=form-group__label>주소</label><div class=form-group__wrap><div ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\">{{vc.data.Addr1}} {{vc.data.Addr2}} ({{vc.data.ZipCode}})</div><div ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\">{{vc.data.Addr1_}} {{vc.data.Addr2_}} ({{vc.data.ZipCode_}})</div></div></div><div class=form-group><label class=form-group__label>세대유형</label><div class=form-group__wrap>{{vc.data.GenTypeValue}} <span ng-if=\"vc.data.GenTypeEtc != null && vc.data.GenTypeEtc != \'\'\">({{vc.data.GenTypeEtc}})</span></div></div><div class=form-group><label class=form-group__label>질병 및 질환 여부</label><div class=form-group__wrap>{{vc.data.DiseaseValue}} <span ng-if=\"vc.data.DiseaseNm != null && vc.data.DiseaseNm != \'\'\">({{vc.data.DiseaseNm}})</span></div></div><div class=form-group><label class=form-group__label>보호구분</label><div class=form-group__wrap>{{vc.data.ProtTypeValue}} <span ng-if=\"vc.data.HealthIndemValue != null && vc.data.HealthIndemValue != \'\'\">({{vc.data.HealthIndemValue}})</span></div></div><div class=form-group><label class=form-group__label>장애 여부</label><div class=form-group__wrap>{{vc.data.ImpairValue}} <span ng-if=\"vc.data.ImpairNm != null && vc.data.ImpairNm != \'\'\">({{vc.data.ImpairNm}})</span></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 2. 신청내역 --><div id=pn3 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>신청내역</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th>신청영역</th><td><span ng-if=\"vc.data.SupportReq01 != null && vc.data.SupportReq01 == 1\">[주거비 : <span ng-bind=vc.data.HousSptAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq02 != null && vc.data.SupportReq02 == 1\">[생계비 : <span ng-bind=vc.data.livingAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq04 != null && vc.data.SupportReq04 == 1\">[치료비 : <span ng-bind=vc.data.CureSptAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq03 != null && vc.data.SupportReq03 == 1\">[자립비 : <span ng-bind=vc.data.EduSptAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq05 != null && vc.data.SupportReq05 == 1\">[기타 : <span ng-bind=vc.data.EtcSptAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq06 != null && vc.data.SupportReq06 == 1\">[물품지원 : <span ng-bind=vc.data.VouSptAmt comma-bind></span>원]</span></td></tr><tr><th>총 지원 합계</th><td><span ng-bind=vc.data.TotalSptSum comma-bind></span>원</td></tr><tr><th>산출근거</th><td>{{vc.data.EtcSptCn}}</td></tr></tbody></table><fieldset class=pc-none><div class=form-group><label class=form-group__label>신청내역</label><div class=form-group__wrap><span ng-if=\"vc.data.SupportReq01 != null && vc.data.SupportReq01 == 1\">[주거비 : <span ng-bind=vc.data.HousSptAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq02 != null && vc.data.SupportReq02 == 1\">[생계비 : <span ng-bind=vc.data.livingAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq04 != null && vc.data.SupportReq04 == 1\">[치료비 : <span ng-bind=vc.data.CureSptAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq03 != null && vc.data.SupportReq03 == 1\">[자립비 : <span ng-bind=vc.data.EduSptAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq05 != null && vc.data.SupportReq05 == 1\">[기타 : <span ng-bind=vc.data.EtcSptAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq06 != null && vc.data.SupportReq06 == 1\">[물품지원 : <span ng-bind=vc.data.VouSptAmt comma-bind></span>원]</span></div></div><div class=form-group><label class=form-group__label>총 지원 합계</label><div class=form-group__wrap><p class=form-group__text><span ng-bind=vc.data.TotalSptSum comma-bind></span>원</p></div></div><div class=form-group><label class=form-group__label>산출근거</label><div class=form-group__wrap><p class=form-group__text>{{vc.data.EtcSptCn}}</p></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 3. 가족관계 --><div id=pn4 class=row ng-if=\"vc.data.CohabitCnt != null && vc.data.CohabitCnt > 0\"><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>가족관계</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th>동거 가구원 수(본인 포함)</th><td>{{vc.data.CohabitCnt}}명</td></tr><tr><td colspan=2><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div id=FrmList><table class=reportTable><thead><tr><th>성명</th><th>관계</th><th>출생연도</th><th>직업</th><th>동거여부</th><th>기타</th></tr></thead><tbody><tr ng-repeat=\"li in vc.data.frmList\"><td class=text-center ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\">{{li.FrNm}}</td><td class=text-center ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\">{{li.FrNm_}}</td><td class=text-center>{{li.Relp}}</td><td class=text-center>{{li.Age}}</td><td class=text-center>{{li.Job}}</td><td class=text-center>{{li.CohabitYN}}</td><td class=text-center>{{li.Remark}}</td></tr></tbody></table></div></div></div></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><label class=form-group__label>동거 가구원 수(본인 포함)</label><div class=form-group__wrap><p class=form-group__text>{{vc.data.CohabitCnt}}명</p></div><div class=\"row mt-2\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div id=FrmList><div class=table-scroll><table class=\"reportTable form-group__table\"><colgroup><col style=\"width: 16.66%\"><col style=\"width: 16.66%\"><col style=\"width: 16.66%\"><col style=\"width: 16.66%\"><col style=\"width: 16.66%\"><col style=\"width: 16.66%\"></colgroup><thead><tr><th>성명</th><th>관계</th><th>출생연도</th><th>직업</th><th>동거여부</th><th>기타</th></tr></thead><tbody><tr ng-repeat=\"li in vc.data.frmList\"><td class=text-center ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\">{{li.FrNm}}</td><td class=text-center ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\">{{li.FrNm_}}</td><td class=text-center>{{li.Relp}}</td><td class=text-center>{{li.Age}}</td><td class=text-center>{{li.Job}}</td><td class=text-center>{{li.CohabitYN}}</td><td class=text-center>{{li.Remark}}</td></tr></tbody></table></div></div></div></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 4. 경제 상황 --><div id=pn5 class=row ng-if=\"vc.data.HousTypeValue != null && vc.data.HousTypeValue != \'\'\"><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>경제 상황</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th>주거형태</th><td>{{vc.data.HousTypeValue}} <span ng-if=\"vc.data.HousType == \'1\'\">(시가 : <span ng-bind=vc.data.JagaAmt comma-bind></span>원 / 대출금 : <span ng-bind=vc.data.JagaLoan comma-bind></span>원)</span> <span ng-if=\"vc.data.HousType == \'2\'\">(보증금 : <span ng-bind=vc.data.JeonseAmt comma-bind></span>원 / 대출금 : <span ng-bind=vc.data.JeonseLoan comma-bind></span>원)</span> <span ng-if=\"vc.data.HousType == \'3\'\">(보증금 : <span ng-bind=vc.data.MonthDep comma-bind></span>원 / 월세 : <span ng-bind=vc.data.MonthAmt comma-bind></span>원)</span> <span ng-if=\"vc.data.HousType == \'4\'\">(보증금 : <span ng-bind=vc.data.AptDep comma-bind></span>원 / 월세 : <span ng-bind=vc.data.AptAmt comma-bind></span>원)</span> <span ng-if=\"vc.data.HousType == \'5\'\">(소유주와의 관계 : {{vc.data.FreeLease}})</span> <span ng-if=\"vc.data.HousType == \'6\'\">({{vc.data.HousEtcCn}})</span></td></tr><tr><th>월 소득 및 자산</th><td><table class=\"reportTable header-bold\"><colgroup><col style=\"width: 30%\"><col style=\"width: 20%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><tbody><tr><th>구분</th><th>금액</th><th>세부내용</th><th>월 소득 합계</th></tr><tr><td>근로소득</td><td class=text-right><span ng-bind=vc.data.WorkInc comma-bind></span> 원</td><td>{{vc.data.WorkIncCn}}</td><td rowspan=4 class=text-right><span ng-bind=vc.data.TotalInc comma-bind></span> 원</td></tr><tr><td>정부보조금</td><td class=text-right><span ng-bind=vc.data.GovtGrant comma-bind></span> 원</td><td>{{vc.data.GovtGrantCn}}</td></tr><tr><td>후원금</td><td class=text-right><span ng-bind=vc.data.Donation comma-bind></span> 원</td><td>{{vc.data.DonationCn}}</td></tr><tr><td>기타</td><td class=text-right><span ng-bind=vc.data.Etc comma-bind></span> 원</td><td>{{vc.data.EtcCn}}</td></tr></tbody></table></td></tr><tr><th>월 지출</th><td><table class=\"reportTable header-bold\"><colgroup><col style=\"width: 30%\"><col style=\"width: 20%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><tbody><tr><th>구분</th><th>금액</th><th>세부내용</th><th>월 지출 합계</th></tr><tr><td>식비</td><td class=text-right><span ng-bind=vc.data.FoodCost comma-bind></span> 원</td><td>{{vc.data.FoodCostCn}}</td><td rowspan=10 class=text-right><span ng-bind=vc.data.TotalCost comma-bind></span> 원</td></tr><tr><td>주거비(월세)</td><td class=text-right><span ng-bind=vc.data.HousCost comma-bind></span> 원</td><td>{{vc.data.HousCostCn}}</td></tr><tr><td>공과금, 관리비</td><td class=text-right><span ng-bind=vc.data.MaintCost comma-bind></span> 원</td><td>{{vc.data.MaintCostCn}}</td></tr><tr><td>의료비</td><td class=text-right><span ng-bind=vc.data.HealthCost comma-bind></span> 원</td><td>{{vc.data.HealthCostCn}}</td></tr><tr ng-repeat=\"(index, li) in vc.data.etcCostList\"><td>본인 작성</td><td class=text-right><span ng-bind=li.EtcCost comma-bind></span> 원</td><td>{{li.EtcCn}}</td></tr></tbody></table></td></tr><tr><th>자산</th><td id=finanList><table class=reportTable><colgroup><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th>종류</th><th>금액</th><th>사용여부</th><th>비고</th></tr></thead><tbody><tr ng-repeat=\"(index, li) in vc.data.finanList\"><td class=text-center>{{li.TypeNm}}</td><td class=text-right><span ng-bind=li.Amount comma-bind></span> 원</td><td class=text-center>{{li.UseYNNm}}</td><td>{{li.Remark}}</td></tr></tbody></table></td></tr><tr><th>부채</th><td>{{vc.data.LiabYN_}} <span ng-if=\"vc.data.LiabYN == \'1\'\"><span ng-if=\"vc.data.LiabType1 == \'1\'\">[은행 : <span ng-bind=vc.data.LiabAmt1 comma-bind></span>원] </span><span ng-if=\"vc.data.LiabType2 == \'1\'\">[카드 : <span ng-bind=vc.data.LiabAmt2 comma-bind></span>원] </span><span ng-if=\"vc.data.LiabType3 == \'1\'\">[지인 : <span ng-bind=vc.data.LiabAmt3 comma-bind></span>원] </span><span ng-if=\"vc.data.LiabType4 == \'1\'\">[기타({{vc.data.LiabType4Cn}}) : <span ng-bind=vc.data.LiabAmt4 comma-bind></span>원] </span><span ng-if=\"vc.data.LiabCn != \'\'\">[사유 : {{vc.data.LiabCn}}]</span></span></td></tr><tr><th>긴급생계비</th><td><p><strong>신청여부 : {{vc.data.EmergWelfareYN_}}</strong></p><table class=\"reportTable mt-10\" ng-if=\"vc.data.EmergWelfareYN == \'1\'\"><colgroup><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th>지원기관</th><th>지원금액</th><th>지원기간</th><th>지원내용</th></tr></thead><tbody><tr ng-repeat=\"li in vc.data.tenantSptList\" ng-if=\"li.Type == \'E\'\"><td>{{li.TenantSptNm}}</td><td class=text-right><span ng-bind=li.SptAmt comma-bind></span>원</td><td class=text-center>{{li.SptStartDate}} ~ {{li.SptEndDate}}</td><td>{{li.SptCn}}</td></tr></tbody></table><table class=\"reportTable mt-10\" ng-if=\"vc.data.EmergWelfareYN != \'1\'\"><thead><tr><th>불가사유</th></tr></thead><tbody><tr><td ng-if=\"vc.data.EmergWelfareYN == \'0\'\">{{vc.data.FailCn}}</td><td ng-if=\"vc.data.EmergWelfareYN == \'2\'\">{{vc.data.NotApplyCN}}</td></tr></tbody></table></td></tr><tr><th>외부 지원</th><td><p><strong>신청여부 : {{vc.data.PrivateSptYN_}}</strong></p><table class=\"reportTable mt-10\" ng-if=\"vc.data.PrivateSptYN == \'1\'\"><colgroup><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th>지원기관</th><th>지원금액</th><th>지원기간</th><th>지원내용</th></tr></thead><tbody><tr ng-repeat=\"li in vc.data.tenantSptList\" ng-if=\"li.Type == \'P\'\"><td>{{li.TenantSptNm}}</td><td class=text-right><span ng-bind=li.SptAmt comma-bind></span>원</td><td class=text-center>{{li.SptStartDate}} ~ {{li.SptEndDate}}</td><td>{{li.SptCn}}</td></tr></tbody></table></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><label class=form-group__label>주거형태</label><div class=form-group__wrap><p class=form-group__text>{{vc.data.HousTypeValue}} <span ng-if=\"vc.data.HousType == \'1\'\">(시가 : <span ng-bind=vc.data.JagaAmt comma-bind></span>원 / 대출금 : <span ng-bind=vc.data.JagaLoan comma-bind></span>원)</span> <span ng-if=\"vc.data.HousType == \'2\'\">(보증금 : <span ng-bind=vc.data.JeonseAmt comma-bind></span>원 / 대출금 : <span ng-bind=vc.data.JeonseLoan comma-bind></span>원)</span> <span ng-if=\"vc.data.HousType == \'3\'\">(보증금 : <span ng-bind=vc.data.MonthDep comma-bind></span>원 / 월세 : <span ng-bind=vc.data.MonthAmt comma-bind></span>원)</span> <span ng-if=\"vc.data.HousType == \'4\'\">(보증금 : <span ng-bind=vc.data.AptDep comma-bind></span>원 / 월세 : <span ng-bind=vc.data.AptAmt comma-bind></span>원)</span> <span ng-if=\"vc.data.HousType == \'5\'\">(소유주와의 관계 : {{vc.data.FreeLease}})</span> <span ng-if=\"vc.data.HousType == \'6\'\">({{vc.data.HousEtcCn}})</span></p></div></div><div class=form-group><label class=form-group__label>월 소득 및 자산</label><div class=table-scroll><table class=\"reportTable header-bold form-group__table\"><colgroup><col style=\"width: 30%\"><col style=\"width: 20%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><colgroup><col style=\"width: 30%\"><col style=\"width: 20%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><tbody><tr><th>구분</th><th>금액</th><th>세부내용</th><th>월 소득 합계</th></tr><tr><td>근로소득</td><td class=text-right><span ng-bind=vc.data.WorkInc comma-bind></span> 원</td><td>{{vc.data.WorkIncCn}}</td><td rowspan=4 class=text-right><span ng-bind=vc.data.TotalInc comma-bind></span> 원</td></tr><tr><td>정부보조금</td><td class=text-right><span ng-bind=vc.data.GovtGrant comma-bind></span> 원</td><td>{{vc.data.GovtGrantCn}}</td></tr><tr><td>후원금</td><td class=text-right><span ng-bind=vc.data.Donation comma-bind></span> 원</td><td>{{vc.data.DonationCn}}</td></tr><tr><td>기타</td><td class=text-right><span ng-bind=vc.data.Etc comma-bind></span> 원</td><td>{{vc.data.EtcCn}}</td></tr></tbody></table></div></div><div class=form-group><label class=form-group__label>월 지출</label><div class=table-scroll><table class=\"reportTable header-bold form-group__table\"><colgroup><col style=\"width: 30%\"><col style=\"width: 20%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><tbody><tr><th>구분</th><th>금액</th><th>세부내용</th><th>월 지출 합계</th></tr><tr><td>식비</td><td class=text-right><span ng-bind=vc.data.FoodCost comma-bind></span> 원</td><td>{{vc.data.FoodCostCn}}</td><td rowspan=10 class=text-right><span ng-bind=vc.data.TotalCost comma-bind></span> 원</td></tr><tr><td>주거비(월세)</td><td class=text-right><span ng-bind=vc.data.HousCost comma-bind></span> 원</td><td>{{vc.data.HousCostCn}}</td></tr><tr><td>공과금, 관리비</td><td class=text-right><span ng-bind=vc.data.MaintCost comma-bind></span> 원</td><td>{{vc.data.MaintCostCn}}</td></tr><tr><td>의료비</td><td class=text-right><span ng-bind=vc.data.HealthCost comma-bind></span> 원</td><td>{{vc.data.HealthCostCn}}</td></tr><tr ng-repeat=\"(index, li) in vc.data.etcCostList\"><td>본인 작성</td><td class=text-right><span ng-bind=li.EtcCost comma-bind></span> 원</td><td>{{li.EtcCn}}</td></tr></tbody></table></div></div><div class=form-group><label class=form-group__label>자산</label><div class=table-scroll><table class=\"reportTable form-group__table\"><colgroup><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th>종류</th><th>금액</th><th>사용여부</th><th>비고</th></tr></thead><tbody><tr ng-repeat=\"(index, li) in vc.data.finanList\"><td class=text-center>{{li.TypeNm}}</td><td class=text-right><span ng-bind=li.Amount comma-bind></span> 원</td><td class=text-center>{{li.UseYNNm}}</td><td>{{li.Remark}}</td></tr></tbody></table></div></div><div class=form-group><label class=form-group__label>부채</label><div class=form-group__wrap><p class=form-group__text>{{vc.data.LiabYN_}} <span ng-if=\"vc.data.LiabYN == \'1\'\"><span ng-if=\"vc.data.LiabType1 == \'1\'\">[은행 : <span ng-bind=vc.data.LiabAmt1 comma-bind></span>원] </span><span ng-if=\"vc.data.LiabType2 == \'1\'\">[카드 : <span ng-bind=vc.data.LiabAmt2 comma-bind></span>원] </span><span ng-if=\"vc.data.LiabType3 == \'1\'\">[지인 : <span ng-bind=vc.data.LiabAmt3 comma-bind></span>원] </span><span ng-if=\"vc.data.LiabType4 == \'1\'\">[기타({{vc.data.LiabType4Cn}}) : <span ng-bind=vc.data.LiabAmt4 comma-bind></span>원] </span><span ng-if=\"vc.data.LiabCn != \'\'\">[사유 : {{vc.data.LiabCn}}]</span></span></p></div></div><div class=form-group><label class=form-group__label>긴급생계비</label><div><p class=form-group__text>신청여부 : {{vc.data.EmergWelfareYN_}}</p><div class=table-scroll><table class=\"reportTable mt-10 form-group__table\" ng-if=\"vc.data.EmergWelfareYN == \'1\'\"><colgroup><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th>지원기관</th><th>지원금액</th><th>지원기간</th><th>지원내용</th></tr></thead><tbody><tr ng-repeat=\"li in vc.data.tenantSptList\" ng-if=\"li.Type == \'E\'\"><td>{{li.TenantSptNm}}</td><td class=text-right><span ng-bind=li.SptAmt comma-bind></span>원</td><td class=text-center>{{li.SptStartDate}} ~ {{li.SptEndDate}}</td><td>{{li.SptCn}}</td></tr></tbody></table><table class=\"reportTable mt-10 form-group__table\" ng-if=\"vc.data.EmergWelfareYN != \'1\'\"><thead><tr><th>불가사유</th></tr></thead><tbody><tr><td ng-if=\"vc.data.EmergWelfareYN == \'0\'\">{{vc.data.FailCn}}</td><td ng-if=\"vc.data.EmergWelfareYN == \'2\'\">{{vc.data.NotApplyCN}}</td></tr></tbody></table></div></div></div><div class=form-group><label class=form-group__label>외부 지원</label><div><p class=form-group__text>신청여부 : {{vc.data.PrivateSptYN_}}</p><table class=\"reportTable mt-10 form-group__table\" ng-if=\"vc.data.PrivateSptYN == \'1\'\"><colgroup><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th>지원기관</th><th>지원금액</th><th>지원기간</th><th>지원내용</th></tr></thead><tbody><tr ng-repeat=\"li in vc.data.tenantSptList\" ng-if=\"li.Type == \'P\'\"><td>{{li.TenantSptNm}}</td><td class=text-right><span ng-bind=li.SptAmt comma-bind></span>원</td><td class=text-center>{{li.SptStartDate}} ~ {{li.SptEndDate}}</td><td>{{li.SptCn}}</td></tr></tbody></table></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 6. 추천기관 --><div id=pn6 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>추천기관</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 20%\"><col style=\"width: 10%\"><col style=\"width: 20%\"><col style=\"width: 10%\"><col style=\"width: 25%\"></colgroup><tbody><tr><th>기관명</th><td>{{vc.tenantData.TenantNm}}</td><th>구분</th><td>{{vc.tenantData.OrganizationNm}}</td><th>대표자명</th><td>{{vc.tenantData.Ceo}}</td></tr><tr><th>대표번호</th><td>{{vc.tenantData.TelNo}}</td><th>팩스</th><td colspan=3>{{vc.tenantData.Fax}}</td></tr><tr><th>담당자명</th><td>{{vc.data.ContactNm}}</td><th>담당자 휴대폰번호</th><td>{{vc.data.ContactMobile}}</td><th>담당자 이메일주소</th><td>{{vc.data.ContactEmail}}</td></tr><tr ng-if=\"vc.data.SupportNec != null && vc.data.SupportNec != \'\'\"><th>대상자 위기상황 요약 및 추천사유</th><td colspan=5><span ng-if=\"vc.data.SupportType1Value != null && vc.data.SupportType1Value != \'\'\">[위기상황 해결] </span><span ng-if=\"vc.data.SupportType2Value != null && vc.data.SupportType2Value != \'\'\">[현상유지] </span><span ng-if=\"vc.data.SupportType3Value != null && vc.data.SupportType3Value != \'\'\">[소득증대 및 개선]</span><textarea rows=10 class=\"form-control mt-10\" ng-model=vc.data.SupportNec readonly></textarea></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><label class=form-group__label>기관명</label><div class=form-group__wrap><p class=form-group__text>{{vc.tenantData.TenantNm}}</p></div></div><div class=form-group><label class=form-group__label>구분</label><div class=form-group__wrap><p class=form-group__text>{{vc.tenantData.OrganizationNm}}</p></div></div><div class=form-group><label class=form-group__label>대표자명</label><div class=form-group__wrap><p class=form-group__text>{{vc.tenantData.Ceo}}</p></div></div><div class=form-group><label class=form-group__label>대표번호</label><div class=form-group__wrap><p class=form-group__text>{{vc.tenantData.TelNo}}</p></div></div><div class=form-group><label class=form-group__label>팩스</label><div class=form-group__wrap><p class=form-group__text>{{vc.tenantData.Fax}}</p></div></div><div class=form-group><label class=form-group__label>담당자명</label><div class=form-group__wrap><p class=form-group__text>{{vc.data.ContactNm}}</p></div></div><div class=form-group><label class=form-group__label>담당자 휴대폰번호</label><div class=form-group__wrap><p class=form-group__text>{{vc.data.ContactMobile}}</p></div></div><div class=form-group><label class=form-group__label>담당자 이메일주소</label><div class=form-group__wrap><p class=form-group__text>{{vc.data.ContactEmail}}</p></div></div><div class=form-group ng-if=\"vc.data.SupportNec != null && vc.data.SupportNec != \'\'\"><label class=form-group__label>대상자 위기상황 요약 및 추천사유</label><div><span ng-if=\"vc.data.SupportType1Value != null && vc.data.SupportType1Value != \'\'\">[위기상황 해결] </span><span ng-if=\"vc.data.SupportType2Value != null && vc.data.SupportType2Value != \'\'\">[현상유지] </span><span ng-if=\"vc.data.SupportType3Value != null && vc.data.SupportType3Value != \'\'\">[소득증대 및 개선]</span><textarea rows=10 class=\"form-control mt-10\" ng-model=vc.data.SupportNec readonly></textarea></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 8. 첨부서류 --><div id=pn7 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>첨부서류</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=table-scroll><table class=tb_report><colgroup><col style=\"width: 15%\"><col><col style=\"width: 20%\"></colgroup><thead><tr><th style=\"text-align: center\">종류</th><th style=\"text-align: center\" ng-attr-colspan=2>파일</th></tr></thead><tbody ng-repeat=\"(key, fileObj) in vc.attach\" ng-if=vc.fileView(key)><tr ng-repeat-start=\"item in [fileObj]\"><th>{{ fileObj.label }}</th><td ng-attr-colspan=\"{{[41,42,43,49,50,56].includes(fileObj.grpId) ? 1 : 2 }}\"><input class=\"form-control form-right\" type=text ng-model=fileObj.fileName ng-click=\"vc.downloadFile(key,\'L\')\" style=\"cursor: pointer; width: 100%\" readonly></td><td ng-if=[41,42,43,49,50,56].includes(fileObj.grpId)><button id=btn_ifrm5 class=\"btn btn-primary\" ng-click=\"vc.downloadFile(key,\'V\')\" ng-show=\"fileObj.viewType != \'\'\"><i class=\"fa fa-file\"></i> 미리보기</button></td></tr><tr ng-repeat-end ng-if=\"[41,42,43,49,50,56].includes(fileObj.grpId) && fileObj.preview && fileObj.viewType != \'\'\"><td ng-show=\" ! vc.isMobile\"></td><td ng-attr-colspan=\"{{vc.isMobile ? 3 : 2 }}\"><img ng-src={{fileObj.view}} style=max-width:100% ng-show=\"fileObj.viewType == \'jpg\'\"><iframe id=\"ifrm_{{ key }}\" style=\"width:100%; height:600px\" frameboarder=0 ng-src={{fileObj.view}} ng-show=\"fileObj.viewType == \'pdf\'\"></iframe></td></tr></tbody></table></div></div></div></div></div><!----------------------------------------------------------------------------------------------------><div id=pn9 class=row ng-if=\"(vc.isAdminSH || vc.tenantType == \'TAKETENANT\')\"><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>서류심사 체크리스트</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th>총점</th><td>{{vc.selfDataResult.totalSc}}점</td></tr><tr><th>지원단계</th><td>{{vc.selfDataResult.stepTxt}}</td></tr><tr><th>권장지원금</th><td>{{vc.selfDataResult.amtTxt}}</td></tr></tbody></table><table class=tb_report ng-if=\"! vc.isPesEtcOnly\"><colgroup><col style=\"width: 15%\"><col style=\"width: 40%\"><col style=\"width: 45%\"></colgroup><thead><tr><th>번호</th><th>AI 질문</th><th>답변</th></tr></thead><tbody><tr ng-repeat=\"qst in vc.selfDataQna\"><th class=text-center>{{qst.no}}</th><td><textarea rows=3 class=form-control ng-model=qst.question readonly></textarea></td><td><textarea rows=3 class=form-control ng-model=qst.answer readonly></textarea></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 9. 현장실사 가능 일자 --><div id=pn8 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>현장실사 가능 일자</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report date-center mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 15%\"><col style=\"width: 35%\"></colgroup><tbody><tr id=SiteVeriftDate><th style=\"text-align: center\">1순위</th><td>{{vc.SiteVeriftDate1}}</td><th style=\"text-align: center\">2순위</th><td>{{vc.SiteVeriftDate2}}</td></tr></tbody></table><fieldset class=pc-none id=SiteVeriftDate><div class=form-group><label class=form-group__label>1순위</label><div class=form-group__wrap><p class=form-group__text>{{vc.SiteVeriftDate1}}</p></div></div><div class=form-group><label class=form-group__label>2순위</label><div class=form-group__wrap><p class=form-group__text>{{vc.SiteVeriftDate2}}</p></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 10. AI 자동 심사 결과 --><div id=pn10 class=row ng-if=\"vc.isAdminAI || vc.tenantType == \'TAKETENANT\'\"><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>AI 자동 심사 결과</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report date-center mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 70%\"></colgroup><tbody><tr ng-if=vc.isAdminAI><th style=\"text-align: center\">현장실사 여부</th><td><common-code-custom code-list=\"vc.columnMap[\'AiSiteVeriftYN\'].CodeList\" code-model=vc.data.AiSiteVeriftYN></common-code-custom></td><td style=\"text-align: right\"><button ng-if=!vc.aiRequestEdit class=\"btn-min btn btn-default\" ng-click=\"vc.toggleAiEdit(\'R\')\"><i class=\"glyphicon glyphicon-edit\"></i> 심사결과 편집</button> <button ng-if=vc.aiRequestEdit class=\"btn-min btn btn-default\" ng-click=vc.saveAiRequestData(false)><i class=\"glyphicon glyphicon-edit\"></i> 심사결과 저장</button></td></tr><tr ng-if=vc.isAdminAI><th style=\"text-align: center\">판단 근거</th><td colspan=2><textarea ng-if=vc.aiRequestEdit rows=10 id=AiRequest class=\"form-control mt-10 mb-5\" ng-model=vc.data.AiRequest></textarea><div ng-if=!vc.aiRequestEdit class=ai_html ng-bind-html=vc.aiView.request></div></td></tr><tr ng-if=vc.isAdminAI><th style=\"text-align: center\">현장심사 체크리스트</th><td colspan=2><textarea ng-if=vc.aiRequestEdit rows=10 id=AiSite class=\"form-control mt-10 mb-5\" ng-model=vc.data.AiSite></textarea><div ng-if=!vc.aiRequestEdit class=ai_html ng-bind-html=vc.aiView.site></div></td></tr><tr ng-if=\"vc.isAdminAI || vc.tenantType == \'TAKETENANT\'\"><th style=\"text-align: center\">외부자원목록</th><td colspan=2><textarea ng-if=vc.aiRequestEdit rows=10 id=AiExternal class=\"form-control mt-10 mb-5\" ng-model=vc.data.AiExternal></textarea><div ng-if=!vc.aiRequestEdit class=ai_html ng-bind-html=vc.aiView.external></div></td></tr></tbody></table><fieldset class=pc-none><div class=form-group ng-if=vc.isAdminAI><label class=form-group__label>현장실사 여부</label><common-code-custom code-list=\"vc.columnMap[\'AiSiteVeriftYN\'].CodeList\" code-model=vc.data.AiSiteVeriftYN></common-code-custom></div><div class=form-group ng-if=vc.isAdminAI><div class=form-group__input-group><button ng-if=!vc.aiRequestEdit class=\"btn-min btn btn-default\" ng-click=\"vc.toggleAiEdit(\'R\')\"><i class=\"glyphicon glyphicon-edit\"></i> 심사결과 편집</button> <button ng-if=vc.aiRequestEdit class=\"btn-min btn btn-default\" ng-click=vc.saveAiRequestData(false)><i class=\"glyphicon glyphicon-edit\"></i> 심사결과 저장</button></div></div><div class=form-group ng-if=vc.isAdminAI><label class=form-group__label>판단 근거</label><textarea ng-if=vc.aiRequestEdit rows=10 id=AiRequest class=\"form-control mt-10 mb-5\" ng-model=vc.data.AiRequest></textarea><div ng-if=!vc.aiRequestEdit class=ai_html ng-bind-html=vc.aiView.request></div></div><div class=form-group ng-if=vc.isAdminAI><label class=form-group__label>체크리스트</label><textarea ng-if=vc.aiRequestEdit rows=10 id=AiSite class=\"form-control mt-10 mb-5\" ng-model=vc.data.AiSite></textarea><div ng-if=!vc.aiRequestEdit class=ai_html ng-bind-html=vc.aiView.site></div></div><div class=form-group ng-if=\"vc.isAdminAI || vc.tenantType == \'TAKETENANT\'\"><label class=form-group__label>외부자원목록</label><textarea ng-if=vc.aiRequestEdit rows=10 id=AiExternal class=\"form-control mt-10 mb-5\" ng-model=vc.data.AiExternal></textarea><div ng-if=!vc.aiRequestEdit class=ai_html ng-bind-html=vc.aiView.external></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 11. 현장실사 배치 --><div id=pn11 class=row ng-if=\"vc.isAdminSH || vc.isCaseB\"><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>현장실사 배치</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report date-center mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 25%\"><col style=\"width: 15%\"><col style=\"width: 25%\"><col style=\"width: 20%\"></colgroup><tbody><tr><th style=\"text-align: center\">실사 담당자</th><td><input type=text class=form-control ng-model=vc.data.SiteVeriftUserTxt maxlength=50 style=text-align:left></td><th style=\"text-align: center\">진행여부</th><td><common-code-custom code-list=\"vc.columnMap[\'SiteVeriftStat\'].CodeList\" code-model=vc.data.SiteVeriftStat></common-code-custom></td><td style=\"text-align: right\"><button class=\"btn-min btn btn-default\" ng-click=vc.saveSiteVeriftData()><i class=\"glyphicon glyphicon-edit\"></i> 현장실사 저장</button></td></tr><tr><th style=\"text-align: center\">현장실사 일시</th><td><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SiteVeriftDate = (vc.SiteVeriftDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SiteVeriftDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><select class=form-control ng-model=vc.data.SiteVeriftTime ng-options=\"t for t in vc.timeList\"></select></div></td><th style=\"text-align: center\">심사자</th><td colspan=2><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.svAdminData.UserNm disabled> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchSiteVeriftAdminModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.addSiteVeriftAdmin();>추가</button></span></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\" style=text-align:left><ul class=\"ul_h li_mr15\"><li ng-repeat=\"(idx, li) in vc.svAdminData.list\">[{{li.UserNm}}<span ng-click=\"vc.delSiteVeriftAdmin(idx, \'E\')\"><i class=\"fa fa-times fa-lg\"></i></span>]</li></ul></div></td></tr><tr><th style=\"text-align: center\">현장실사 내용</th><td colspan=4><textarea rows=10 id=AiSummary class=\"form-control mt-10 mb-5\" ng-model=vc.data.AiSummary></textarea></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><label class=form-group__label>실사 담당자</label><input type=text class=form-control ng-model=vc.data.SiteVeriftUserTxt maxlength=50 style=text-align:left></div><div class=form-group><label class=form-group__label>진행여부</label><div class=form-group__input-group><common-code-custom code-list=\"vc.columnMap[\'SiteVeriftStat\'].CodeList\" code-model=vc.data.SiteVeriftStat></common-code-custom><button class=\"btn-min btn btn-default\" ng-click=vc.saveSiteVeriftData()><i class=\"glyphicon glyphicon-edit\"></i> 현장실사 저장</button></div></div><div class=form-group><label class=form-group__label>현장실사 일시</label><div class=form-group__input-group><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SiteVeriftDate = (vc.SiteVeriftDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SiteVeriftDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><select class=form-group__wrap ng-model=vc.data.SiteVeriftTime ng-options=\"t for t in vc.timeList\"></select></div></div><div class=form-group><label class=form-group__label>심사자</label><div class=form-group__input-group><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.svAdminData.UserNm disabled> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchSiteVeriftAdminModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.addSiteVeriftAdmin();>추가</button></span></div><ul class=\"ul_h li_mr15\"><li ng-repeat=\"(idx, li) in vc.svAdminData.list\">[{{li.UserNm}}<span ng-click=\"vc.delSiteVeriftAdmin(idx, \'E\')\"><i class=\"fa fa-times fa-lg\"></i></span>]</li></ul></div></div><div class=form-group><label class=form-group__label>현장실사 내용</label><textarea rows=10 id=AiSummary class=\"form-control mt-10 mb-5\" ng-model=vc.data.AiSummary></textarea></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 13. 최종심사 --><div id=pn12 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>최종심사</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report date-center mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 20%\"><col style=\"width: 15%\"><col style=\"width: 20%\"><col style=\"width: 30%\"></colgroup><tbody><tr ng-if=vc.isAdminAI><th style=\"text-align: center\">최종심사내용</th><td colspan=4><textarea ng-if=vc.aiFinalEdit rows=10 id=AiFinal class=\"form-control mt-10 mb-5\" ng-model=vc.data.AiFinal></textarea><div ng-if=!vc.aiFinalEdit class=ai_html2 ng-bind-html=vc.aiView.final></div></td></tr><tr><th style=\"text-align: center\">지원영역</th><td colspan=4><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><span class=min-txt>주거비</span> <input type=text class=\"form-control text-right\" ng-model=vc.data.FinalHousSptAmt ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\"> 원</div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><span class=min-txt>생계비</span> <input type=text class=\"form-control text-right\" ng-model=vc.data.FinalLivingAmt ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\"> 원</div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><span class=min-txt>치료비</span> <input type=text class=\"form-control text-right\" ng-model=vc.data.FinalCureSptAmt ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\"> 원</div></div></div><div class=\"row mt-5\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><span class=min-txt>자립비</span> <input type=text class=\"form-control text-right\" ng-model=vc.data.FinalEduSptAmt ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\"> 원</div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><span class=min-txt>물품지원</span> <input type=text class=\"form-control text-right\" ng-model=vc.data.FinalVouSptAmt ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\"> 원</div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><span class=min-txt>기타(의료카드 외)</span> <input type=text class=\"form-control text-right\" ng-model=vc.data.FinalEtcSptAmt ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\" style=width:69%> 원</div></div></div></td></tr><tr><th style=\"text-align: center\">총 지원 합계</th><td><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.data.FinalSptSum comma placeholder=\"합산 금액을 표시합니다\" readonly> 원</div></td><th style=\"text-align: center\">후원기관</th><td><input type=text class=form-control ng-model=vc.data.FinalTenantNm maxlength=50 style=text-align:left style=z-index:1 ng-disabled=\" ! vc.isAdminSH\"></td><td style=\"text-align: right\"><button class=\"btn-min btn btn-default\" ng-click=vc.setAiData() ng-if=\" ! vc.isPesEtcOnly\"><i class=\"glyphicon glyphicon-edit\"></i> AI 분석</button> <button ng-if=!vc.aiFinalEdit class=\"btn-min btn btn-default\" ng-click=\"vc.toggleAiEdit(\'F\')\" ng-if=vc.isAdminAI><i class=\"glyphicon glyphicon-edit\"></i> 최종심사내용 편집</button> <button class=\"btn-min btn btn-default\" ng-click=vc.saveAiFinalSptData(false) ng-if=vc.isAdminAI><i class=\"glyphicon glyphicon-edit\"></i> 최종심사 저장</button></td></tr></tbody></table><fieldset class=pc-none><div class=form-group ng-if=vc.isAdminAI><label class=form-group__label>최종심사내용</label><textarea ng-if=vc.aiFinalEdit rows=10 id=AiFinal class=\"form-control mt-10 mb-5\" ng-model=vc.data.AiFinal></textarea><div ng-if=!vc.aiFinalEdit class=ai_html2 ng-bind-html=vc.aiView.final></div></div><div class=form-group><label class=form-group__label>지원영역</label><div class=form-group__input-group-column><div class=form-group__input-group><span class=min-txt>주거비</span><div class=form-group__input-group style=\"width: 100%\"><input type=text class=\"form-control right-input\" ng-model=vc.data.FinalHousSptAmt ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\">원</div></div><div class=form-group__input-group><span class=min-txt>생계비</span><div class=form-group__input-group style=\"width: 100%\"><input type=text class=\"form-control right-input\" ng-model=vc.data.FinalLivingAmt ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\">원</div></div><div class=form-group__input-group><span class=min-txt>치료비</span><div class=form-group__input-group style=\"width: 100%\"><input type=text class=\"form-control right-input\" ng-model=vc.data.FinalCureSptAmt ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\">원</div></div><div class=form-group__input-group><span class=min-txt>자립비</span><div class=form-group__input-group style=\"width: 100%\"><input type=text class=\"form-control right-input\" ng-model=vc.data.FinalEduSptAmt ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\">원</div></div><div class=form-group__input-group><span class=min-txt>물품지원</span><div class=form-group__input-group style=\"width: 100%\"><input type=text class=\"form-control right-input\" ng-model=vc.data.FinalVouSptAmt ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\">원</div></div><div class=form-group__input-group><span class=min-txt>기타(의료카드 외)</span><div class=form-group__input-group style=\"width: 100%\"><input type=text class=\"form-control right-input\" ng-model=vc.data.FinalEtcSptAmt ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\">원</div></div></div></div><div class=form-group><label class=form-group__label>총 지원 합계</label><div class=form-group__input-group><input type=text class=\"form-control right-input\" ng-model=vc.data.FinalSptSum comma placeholder=\"합산 금액을 표시합니다\" readonly> 원</div></div><div class=form-group><label class=form-group__label>후원기관</label><div class=form-group__input-group><input type=text class=form-control ng-model=vc.data.FinalTenantNm maxlength=50 style=text-align:left style=z-index:1 ng-disabled=\" ! vc.isAdminSH\"></div></div><div class=form-group><button class=\"btn-min btn btn-default\" ng-click=vc.setAiData() ng-if=\" ! vc.isPesEtcOnly \"><i class=\"glyphicon glyphicon-edit\"></i> AI 분석</button> <button ng-if=!vc.aiFinalEdit class=\"btn-min btn btn-default\" ng-click=\"vc.toggleAiEdit(\'F\')\" ng-if=vc.isAdminAI><i class=\"glyphicon glyphicon-edit\"></i> 최종심사내용 편집</button> <button class=\"btn-min btn btn-default\" ng-click=vc.saveAiFinalSptData(false) ng-if=vc.isAdminAI><i class=\"glyphicon glyphicon-edit\"></i> 최종심사 저장</button></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 14. 외부자원연계 --><div id=pn13 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>외부자원연계</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 15%\"><col><col style=\"width: 15%\"></colgroup><tbody><tr><th>지원기관</th><td colspan=2><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div id=ExternalList><p><strong>※ 내용 입력 후 추가버튼 클릭해주셔야 합니다.</strong></p><table class=\"reportTable mt-5 placeholder-center\" style=width:100%><colgroup><col style=\"width: 45%\"><col style=\"width: 45%\"><col style=\"width: 10%\"></colgroup><thead><tr><th>지원기관명</th><th>지원금액</th><th>추가/삭제</th></tr></thead><tbody><tr><td><input type=text class=form-control ng-model=vc.extnData.ExtnNm placeholder=\"기관명을 입력하세요\" maxlength=50 ng-disabled=\" ! vc.isAdminSH\"></td><td><input type=text class=\"form-control text-right\" ng-model=vc.extnData.ExtnAmt comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\"></td><td><!-- 추가 버튼 --> <button class=\"btn btn-default\" ng-click=vc.addExtn() ng-disabled=\" ! vc.isAdminSH\"><i class=\"glyphicon glyphicon-plus\"></i> 추가</button></td></tr><tr ng-repeat=\"(index, li) in vc.extnList\"><td>{{li.ExtnNm}}</td><td>{{li.ExtnAmt}}</td><td><!-- 삭제 버튼 --> <button class=\"btn btn-default\" ng-click=vc.delExtn(index) ng-disabled=\" ! vc.isAdminSH\"><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></td></tr></tbody></table></div></div></div></td></tr><tr><th>총 지원금 합계</th><td><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.TotalExtnSum comma placeholder=\"합산 금액을 표시합니다\" readonly> 원</div></div></td><td style=\"text-align: right\"><button class=\"btn-min btn btn-default\" ng-click=vc.saveExtnData() ng-if=vc.isAdminSH><i class=\"glyphicon glyphicon-edit\"></i> 외부자원연계 저장</button></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><label class=form-group__label>지원기관</label><div class=table-scroll><table class=\"reportTable mt-5 placeholder-center form-group__table\" style=width:100%><colgroup><col style=\"width: 45%\"><col style=\"width: 45%\"><col style=\"width: 10%\"></colgroup><thead><tr><th>지원기관명</th><th>지원금액</th><th>추가/삭제</th></tr></thead><tbody><tr><td><input type=text class=form-control ng-model=vc.extnData.ExtnNm placeholder=\"기관명을 입력하세요\" maxlength=50 ng-disabled=\" ! vc.isAdminSH\" style=\"min-width: 110px\"></td><td><input type=text class=\"form-control text-right\" ng-model=vc.extnData.ExtnAmt comma placeholder=\"숫자만 입력하세요\" maxlength=15 ng-disabled=\" ! vc.isAdminSH\" style=\"min-width: 110px\"></td><td><!-- 추가 버튼 --> <button class=\"btn btn-default\" ng-click=vc.addExtn() ng-disabled=\" ! vc.isAdminSH\"><i class=\"glyphicon glyphicon-plus\"></i> 추가</button></td></tr><tr ng-repeat=\"(index, li) in vc.extnList\"><td>{{li.ExtnNm}}</td><td>{{li.ExtnAmt}}</td><td><!-- 삭제 버튼 --> <button class=\"btn btn-default\" ng-click=vc.delExtn(index) ng-disabled=\" ! vc.isAdminSH\"><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></td></tr></tbody></table></div></div><div class=form-group><label class=form-group__label>총 지원금 합계</label><div class=form-group__input-group><input type=text class=\"form-control right-input\" ng-model=vc.TotalExtnSum comma placeholder=\"합산 금액을 표시합니다\" readonly> 원</div><button class=\"btn-min btn btn-default\" ng-click=vc.saveExtnData() ng-if=vc.isAdminSH><i class=\"glyphicon glyphicon-edit\"></i> 외부자원연계 저장</button></div></fieldset></div></div></div></div></div><!-- print --><!----------------------------------------------------------------------------------------------------><!-- 댓글 --><div id=pn14 class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.COMMENT\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><article class=streamline-post ng-repeat=\"li in vc.comment.list\"><div class=post-container ng-if=li.chkView><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\">{{li.RegUser_}}({{li.TenantNm}}) <span><i class=\"fa fa-clock-o mr-5\"></i> {{li.RegDate}}</span> <span class=\"text-muted pull-right\" ng-if=\"li.TenantId == vc.tenantId && li.CommentId != vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editComment(li)><i class=\"glyphicon glyphicon-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn-min btn btn-default\" ng-click=vc.deleteComment(li)><i class=\"glyphicon glyphicon-trash\"></i> {{ \'Menu.DELETE\' | translate }}</button> </span><span class=\"text-muted pull-right\" ng-if=\"li.TenantId == vc.tenantId && li.CommentId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editCommentAction(li)><i class=\"glyphicon glyphicon-ok\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button href=\"\" class=\"btn-min btn btn-default\" ng-click=vc.editCommentCancel()><i class=\"glyphicon glyphicon-remove\"></i> {{ \'Menu.CANCEL\' | translate }}</button></span></div><div class=\"panel-body pre\" ng-if=\"li.CommentId != vc.comment.editid\"><i class=\"fa fa-lock\" ng-if=\"li.SecretCommYN == \'1\'\"></i> {{li.Content}}</div><!-- <pre class=\"panel-body\"  ng-if=\"li.CommentId != vc.comment.editid\">{{li.Content}}</pre> --><div class=panel-body ng-if=\"li.CommentId == vc.comment.editid\"><textarea class=form-control id=strReply rows=10 style=\"width:100%; height:40px; resize:vertical\" ng-model=vc.comment.editContent></textarea><div class=\"row mt-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><input type=checkbox ng-model=vc.comment.SecretCommYN class=mb-5 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.comment.SecretCommYN == \'1\'\"> 비밀댓글<sapn ng-if=\"vc.comment.SecretCommYN == \'1\'\">(관리자 추가 후 댓글 저장 시 적용됩니다.)</sapn></div><div class=\"col-xs-6 col-sm-6 col-md-3 col-xg-3 col-xl-3\" ng-if=\"vc.comment.SecretCommYN == \'1\'\"><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.commAdminData.UserNm disabled> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"vc.srchCommAdminModal(\'E\');\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=\"vc.addCommAdmin(\'E\');\">추가</button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-9 col-xg-9 col-xl-9\" ng-if=\"vc.comment.SecretCommYN == \'1\'\"><ul class=\"ul_h li_mr15\"><li ng-repeat=\"(idx, li) in vc.comment.AdminData.list\">[{{li.UserNm}}<span ng-click=\"vc.delCommAdmin(idx, \'E\')\"><i class=\"fa fa-times fa-lg\"></i></span>]</li></ul></div></div></div></div></div></article><div class=streamline-form><form class=\"ng-pristine ng-valid\"><div class=\"form-group form-inner-label form-comment\"><div class=input-group><textarea class=form-control id=strReply placeholder=\"댓글 작성...\" rows=10 style=\"width:100%; height:40px; resize: vertical;z-index:1\" ng-model=vc.commentData.Content></textarea><span class=input-group-btn style=\"vertical-align: top\"><button class=\"btn btn-default cm_btn\" type=button ng-click=vc.saveComment() style=z-index:1>{{ \'Menu.SAVE\' | translate }}</button></span></div></div><div class=mt-10><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><input type=checkbox name=chkScretComm ng-model=vc.commentData.SecretCommYN class=mb-5 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.commentData.SecretCommYN == \'1\'\"> 비밀댓글<sapn ng-if=\"vc.commentData.SecretCommYN == \'1\'\">(관리자 추가 후 댓글 저장 시 적용됩니다.)</sapn></div><div class=\"col-xs-6 col-sm-6 col-md-3 col-xg-3 col-xl-3\" ng-if=\"vc.commentData.SecretCommYN == \'1\'\"><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.commAdminData.UserNm disabled> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchCommAdminModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.addCommAdmin();>추가</button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-9 col-xg-9 col-xl-9\" ng-if=\"vc.commentData.SecretCommYN == \'1\'\"><ul class=\"ul_h li_mr15\"><li ng-repeat=\"(idx, li) in vc.commAdminData.list\"><sapn ng-if=\"li.UserNm != null && li.UserNm != \'\'\">[{{li.UserNm}}<span ng-click=vc.delCommAdmin(idx)><i class=\"fa fa-times fa-lg\"></i></span>]</sapn></li></ul></div></div></div></form><div>&nbsp;</div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- 버튼 영역 --><div class=row><div class=\"pull-right mb-5 mr-10\"><button class=\"btn btn-default\" ng-click=vc.saveExe() ng-if=vc.isAdminSH ng-disabled=\"vc.disExe1 && vc.disExe2 && vc.disExe3 && vc.disExe4\"><i class=\"fa fa-edit\"></i> 실행정보 저장</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=\"vc.data.TenantId == vc.tenantId && (vc.data.Status == null || vc.data.Status == \'\' || vc.data.Status == \'RG\')\"><i class=\"fa fa-trash\"></i> {{ \'Menu.DELETE\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.goEdit() ng-if=\"vc.tenantId == 0 || (vc.data.TenantId == vc.tenantId && (vc.data.Status == null || vc.data.Status == \'\' || vc.data.Status == \'RG\'))\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.reSetData() ng-if=\"vc.tenantId == \'0\' && (vc.data.Status == \'AT\' || vc.data.Status == \'AG\' || vc.data.Status == \'SP\')\"><i class=\"fa fa-check-circle\"></i> 초기화</button> <button class=\"btn btn-primary\" ng-click=\"vc.approval(\'AT\')\" ng-if=\"vc.tenantType == \'GIVETENANT\' && vc.approATShow\"><i class=\"fa fa-check-circle\"></i> 지원신청 하기</button> <button class=\"btn btn-primary\" ng-click=\"vc.approval(\'AG\')\" ng-if=\"vc.tenantType == \'GIVETENANT\' && vc.approAGShow\"><i class=\"fa fa-check-circle\"></i> 논의중 단계 진행</button> <button class=\"btn btn-primary\" ng-click=\"vc.approval(\'SP\')\" ng-if=\"vc.tenantType == \'GIVETENANT\' && vc.approSPShow\" onclick=\"alert(\'댓글에 지원 확정 여부와 금액을 작성해주세요.\')\"><i class=\"fa fa-check-circle\"></i> 지원확정하기</button> <button class=\"btn btn-danger\" ng-click=\"vc.canCelData(\'AT\')\" ng-if=\"vc.tenantType == \'GIVETENANT\' && vc.cancelATShow\"><i class=\"fa fa-ban\"></i> 취소하기</button> <button class=\"btn btn-danger\" ng-click=\"vc.canCelData(\'AG\')\" ng-if=\"vc.tenantType == \'GIVETENANT\' && vc.cancelAGShow\"><i class=\"fa fa-ban\"></i> 취소하기</button> <button class=\"btn btn-default mobile-none\" ng-click=vc.printTake()><i class=\"fa fa-print\"></i> 출력</button> <button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div><!-- 버튼 영역 끝 --></div><!-- /page content --></div>");
$templateCache.put("app/eland-request/take-edit.html","<div class=\"page page-footable elandCustom\" ng-controller=\"TakeEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=ailoader ng-show=vc.ailoader1><div class=ailoader_txt ng-show=vc.ailoader1>AI가 신청서 내용을 분석하여 추가 사전 질문을 생성하고 있습니다.<br>약 1분 정도 소요되며, 질문이 표시되면 답변해 주세요.</div></div><nav id=skipGnb><!-- 접혀있을 경우 << --> <button ng-if=\"vc.btnShow == \'0\'\" ng-click=\"vc.btnShow = \'1\'\"><i class=\"glyphicon glyphicon-chevron-left\"></i></button><!-- 펼쳐있을 경우 >> --> <button ng-if=\"vc.btnShow == \'1\'\" ng-click=\"vc.btnShow = \'0\'\"><i class=\"glyphicon glyphicon-chevron-right\"></i></button><!-- 기본 펼침, 버튼 누르면 접힘--><ul ng-if=\"vc.btnShow == \'1\'\"><li ng-click=\"vc.scrollMove(\'pn1\')\">-> 대상자 인적사항</li><li ng-click=\"vc.scrollMove(\'pn2\')\">-> 신청내역</li><li ng-click=\"vc.scrollMove(\'pn3\')\" ng-if=vc.isPesEtcOnly>-> 가족관계</li><li ng-click=\"vc.scrollMove(\'pn4\')\" ng-if=vc.isPesEtcOnly>-> 경제 상황</li><li ng-click=\"vc.scrollMove(\'pn6\')\">-> 추천기관</li><li ng-click=\"vc.scrollMove(\'pn8\')\">-> 첨부서류</li><li ng-click=\"vc.scrollMove(\'pn5\')\" ng-if=\"vc.tenantType == \'TAKETENANT\'\">-> 서류심사 체크리스트</li><li ng-click=\"vc.scrollMove(\'pn9\')\">-> 현장실사 가능 일자</li></ul></nav><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>지원신청 사례 등록</h3></div></div><div class=pagecontent><!-- 버튼 영역 --><div class=row><div class=\"pull-right mb-5 mr-10\"><button class=\"btn btn-highlight\" ng-click=vc.doSelfChk(false) ng-if=vc.selfChk><span ng-if=vc.selfChkResult>신청적합</span> <span ng-if=\" ! vc.selfChkResult\">신청 기준 미충족</span></button> <button class=\"btn btn-primary\" ng-click=vc.doSelfChk(true) ng-if=\"vc.tenantType == \'TAKETENANT\'\">신청 적합성 자가진단</button> <button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.saveTempData()><i class=\"fa fa-save\"></i> 임시저장</button> <button class=\"btn btn-primary\" ng-click=vc.saveData()><i class=\"fa fa-save\"></i> 최종 제출</button></div></div><!-- 버튼 영역 끝 --><!----------------------------------------------------------------------------------------------------><!-- 신청 사례 --><div id=pn0 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-body collapse in\"><p><strong>※ 작성한 사례를 다른 사용자가 확인할 수 없도록 잠금 설정합니다. (관리자, 후원기관은 열람 가능합니다.)</strong></p><table class=\"tb_report mt-5 mobile-none\"><colgroup><col style=\"width: 10%\"><col style=\"width: 40%\"><col style=\"width: 20%\"><col style=\"width: 30%\"></colgroup><tbody><tr><th>조회 비밀번호<span class=tRed>*</span></th><td id=Passwd><input type=password class=form-control ng-model=vc.data.Passwd maxlength=10></td><th>타기관 연계 신청 동의 여부(신청자에게 동의 파악)<span class=tRed>*</span></th><td><div class=radioWrap><input id=rdoScretN name=ScretYN ng-checked=\"vc.data.SecretYN == \'0\'\" ng-model=vc.data.SecretYN type=radio value=0><label for=rdoScretN>동의</label><input id=rdoScretY name=ScretYN ng-checked=\"vc.data.SecretYN == \'1\'\" ng-model=vc.data.SecretYN type=radio value=1><label for=rdoScretY>미동의(비밀글)</label></div></td></tr><tr><th>제목<span class=tRed>*</span></th><td colspan=3 id=Title><input type=text class=form-control ng-model=vc.data.Title maxlength=250></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>조회 비밀번호<span class=tRed>*</span></label></div><input type=password class=form-control id=Passwd ng-model=vc.data.Passwd maxlength=10></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>타기관 연계 신청 동의 여부(신청자에게 동의 파악)<span class=tRed>*</span></label></div><div class=form-group__radio-group><input id=rdoScretN name=ScretYN_m ng-checked=\"vc.data.SecretYN == \'0\'\" ng-model=vc.data.SecretYN type=radio value=0><label for=rdoScretN>동의</label><input id=rdoScretY name=ScretYN_m ng-checked=\"vc.data.SecretYN == \'1\'\" ng-model=vc.data.SecretYN type=radio value=1><label for=rdoScretY>미동의(비밀글)</label></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>제목<span class=tRed>*</span></label></div><input type=text class=form-control ng-model=vc.data.Title maxlength=250></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 1. 대상자 인적사항 --><div id=pn1 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>대상자 인적사항<span class=tRed>*</span></strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 10%\"><col style=\"width: 40%\"><col style=\"width: 10%\"><col style=\"width: 40%\"></colgroup><tbody><tr><th>이름</th><td id=TargetNm><input type=text class=\"form-control form-right\" ng-model=vc.data.TargetNm maxlength=50></td><th>성별</th><td id=Gender><div class=radioWrap><label><input id=rdoGenderM name=Gender ng-checked=\"vc.data.Gender == \'M\'\" ng-model=vc.data.Gender type=radio value=M> 남</label><label><input id=rdoGenderF name=Gender ng-checked=\"vc.data.Gender == \'F\'\" ng-model=vc.data.Gender type=radio value=F> 여</label></div></td></tr><tr><th>주민등록번호</th><td id=JuminNo><input class=\"form-control mr-5\" numberonly id=Jumin1 maxlength=6 ng-model=vc.data.Jumin1 type=text style=\"float:left; width:40%\"> <input class=form-control numberonly id=Jumin2 maxlength=7 ng-model=vc.data.Jumin2 type=text ng-change=vc.chgAge() style=\"float:left; width:40%\"></td><th>나이</th><td id=Age><input type=text class=\"form-control form-right\" ng-model=vc.data.Age maxlength=3></td></tr><tr><th>연락처</th><td id=Mobile><input type=text class=\"form-control form-right\" auto-hyphen ng-model=vc.data.Mobile maxlength=20></td><th>주소</th><td id=ZipCode><div class=\"input-group mr-5\" style=\"float:left; width:18%\"><input class=form-control maxlength=7 ng-model=vc.data.ZipCode readonly type=text style=\"min-width: 60px;z-index:1\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchZipCodeModal() type=button style=z-index:1><i class=\"fa fa-search\"></i></button></span></div><input class=\"form-control mr-5\" id=Addr1 maxlength=200 ng-model=vc.data.Addr1 type=text readonly style=\"float:left; width:40%\"> <input class=form-control id=Addr2 maxlength=200 ng-model=vc.data.Addr2 type=text style=\"float:left; width:40%\"> <input type=hidden id=CityCode ng-model=vc.data.CityCode></td></tr><tr><th>세대유형</th><td id=GenType><common-code-custom code-list=\"vc.columnMap[\'GenType\'].CodeList\" code-model=vc.data.GenType ng-change=vc.chgInit(1)></common-code-custom><input type=text class=\"form-control etc_input mt-5\" ng-model=vc.data.GenTypeEtc ng-if=\"vc.data.GenType ==\'09\'\" ng-disabled=\"vc.data.GenType !=\'09\'\" placeholder=\"기타 유형을 입력하세요\" maxlength=200></td><th>질병 및 질환 여부</th><td id=DiseaseYN><div class=radioWrap><label><input type=radio name=rdDise ng-model=vc.data.DiseaseYN ng-click=vc.chgInit(2) value=0> 무</label><label><input type=radio name=rdDise ng-model=vc.data.DiseaseYN ng-click=vc.chgInit(2) value=1> 유</label></div><input class=\"form-control mt-5\" type=text ng-model=vc.data.DiseaseNm ng-if=\"vc.data.DiseaseYN ==\'1\'\" ng-disabled=\"vc.data.DiseaseYN ==\'0\'\" placeholder=\"질병 및 질환명을 입력하세요\" maxlength=200></td></tr><tr><th>보호구분</th><td id=ProtType><common-code-custom code-list=\"vc.columnMap[\'ProtType\'].CodeList\" code-model=vc.data.ProtType ng-change=vc.chgInit(3)></common-code-custom><ul class=\"radioWrap ul_h mt-5\" ng-if=\"vc.data.ProtType ==\'07\'\"><li ng-repeat=\"li in vc.HealthIndemList1\"><label><input type=radio name=rdHealth ng-model=vc.data.HealthIndem ng-disabled=\"vc.data.ProtType !=\'07\'\" ng-checked=\"vc.data.HealthIndem == li.Code\" value={{li.Code}}> {{li.CodeValue}}</label></li></ul><ul class=\"radioWrap ul_h mt-5\" ng-if=\"vc.data.ProtType ==\'05\'\"><li ng-repeat=\"li in vc.HealthIndemList2\"><label><input type=radio name=rdHealth ng-model=vc.data.HealthIndem ng-disabled=\"vc.data.ProtType !=\'05\'\" ng-checked=\"vc.data.HealthIndem == li.Code\" value={{li.Code}}> {{li.CodeValue}}</label></li></ul></td><th>장애 여부</th><td id=ImpairYN><div class=radioWrap><label><input type=radio name=rdImp ng-model=vc.data.ImpairYN ng-click=vc.chgInit(4) value=0> 무</label><label><input type=radio name=rdImp ng-model=vc.data.ImpairYN ng-click=vc.chgInit(4) value=1> 유</label></div><input class=\"form-control mt-5\" type=text ng-model=vc.data.ImpairNm ng-if=\"vc.data.ImpairYN ==\'1\'\" ng-disabled=\"vc.data.ImpairYN ==\'0\'\" placeholder=\"질병 및 질환명을 입력하세요\" maxlength=200></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>이름</label></div><input type=text class=\"form-control form-right\" id=TargetNm ng-model=vc.data.TargetNm maxlength=50></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>성별</label></div><div class=form-group__radio-group id=Gender><label><input id=rdoGenderM name=Gender_m ng-checked=\"vc.data.Gender == \'M\'\" ng-model=vc.data.Gender type=radio value=M> 남</label><label><input id=rdoGenderF name=Gender_m ng-checked=\"vc.data.Gender == \'F\'\" ng-model=vc.data.Gender type=radio value=F> 여</label></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>주민등록번호</label></div><div class=form-group__input-group id=JuminNo><input class=\"form-control mr-5\" numberonly id=Jumin1 maxlength=6 ng-model=vc.data.Jumin1 type=text> <input class=form-control numberonly id=Jumin2 maxlength=7 ng-model=vc.data.Jumin2 type=text ng-change=vc.chgAge()></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>나이</label></div><input id=Age type=text class=\"form-control form-right\" ng-model=vc.data.Age maxlength=3></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>연락처</label></div><input id=Mobile type=text class=\"form-control form-right\" auto-hyphen ng-model=vc.data.Mobile maxlength=20></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>주소</label></div><div class=\"form-group__input-group form-group__input-group-column\" id=ZipCode><div class=\"input-group mr-5\"><input class=form-control maxlength=7 ng-model=vc.data.ZipCode readonly type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchZipCodeModal() type=button><i class=\"fa fa-search\"></i></button></span></div><input class=\"form-control mr-5\" id=Addr1 maxlength=200 ng-model=vc.data.Addr1 type=text readonly> <input class=form-control id=Addr2 maxlength=200 ng-model=vc.data.Addr2 type=text> <input type=hidden id=CityCode ng-model=vc.data.CityCode></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>세대유형</label></div><div id=GenType><common-code-custom code-list=\"vc.columnMap[\'GenType\'].CodeList\" code-model=vc.data.GenType ng-change=vc.chgInit(1)></common-code-custom><input type=text class=\"form-control etc_input mt-5\" ng-model=vc.data.GenTypeEtc ng-if=\"vc.data.GenType ==\'09\'\" ng-disabled=\"vc.data.GenType !=\'09\'\" placeholder=\"기타 유형을 입력하세요\" maxlength=200></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>질병 및 질환 여부</label></div><div id=DiseaseYN><div class=form-group__radio-group><label><input type=radio name=rdDise_m ng-model=vc.data.DiseaseYN ng-click=vc.chgInit(2) value=0> 무</label><label><input type=radio name=rdDise_m ng-model=vc.data.DiseaseYN ng-click=vc.chgInit(2) value=1> 유</label></div><input class=\"form-control mt-5\" type=text ng-model=vc.data.DiseaseNm ng-if=\"vc.data.DiseaseYN ==\'1\'\" ng-disabled=\"vc.data.DiseaseYN ==\'0\'\" placeholder=\"질병 및 질환명을 입력하세요\" maxlength=200></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>보호구분</label></div><div id=ProtType><common-code-custom code-list=\"vc.columnMap[\'ProtType\'].CodeList\" code-model=vc.data.ProtType ng-change=vc.chgInit(3)></common-code-custom><div class=\"form-group__radio-group mt-4\" ng-if=\"vc.data.ProtType ==\'07\'\" style=\"flex-wrap: wrap\"><div ng-repeat=\"li in vc.HealthIndemList1\"><label><input type=radio name=rdHealth_m ng-model=vc.data.HealthIndem ng-disabled=\"vc.data.ProtType !=\'07\'\" ng-checked=\"vc.data.HealthIndem == li.Code\" value={{li.Code}}> {{li.CodeValue}}</label></div></div><div class=\"form-group__radio-group mt-4\" ng-if=\"vc.data.ProtType ==\'05\'\"><div ng-repeat=\"li in vc.HealthIndemList2\"><label><input type=radio name=rdHealth_m ng-model=vc.data.HealthIndem ng-disabled=\"vc.data.ProtType !=\'05\'\" ng-checked=\"vc.data.HealthIndem == li.Code\" value={{li.Code}}> {{li.CodeValue}}</label></div></div></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>장애 여부</label></div><div id=ImpairYN><div class=form-group__radio-group><label><input type=radio name=rdImp_m ng-model=vc.data.ImpairYN ng-click=vc.chgInit(4) value=0> 무</label><label><input type=radio name=rdImp_m ng-model=vc.data.ImpairYN ng-click=vc.chgInit(4) value=1> 유</label></div><input class=\"form-control mt-5\" type=text ng-model=vc.data.ImpairNm ng-if=\"vc.data.ImpairYN ==\'1\'\" ng-disabled=\"vc.data.ImpairYN ==\'0\'\" placeholder=\"질병 및 질환명을 입력하세요\" maxlength=200></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 2. 신청내역 --><div id=pn2 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>신청내역<span class=tRed>*</span></strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 10%\"><col style=\"width: 90%\"></colgroup><tbody><tr><th>신청영역</th><td id=SupportReq><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><input type=checkbox name=chkSreq ng-model=vc.data.SupportReq01 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.SupportReq01 == \'1\'\" ng-click=\"vc.chgSupport(\'H\', this)\"> <span class=min-txt>주거비</span> <input type=text class=\"form-control text-right\" ng-model=vc.data.HousSptAmt ng-disabled=vc.disabledHous ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><input type=checkbox name=chkSreq ng-model=vc.data.SupportReq02 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.SupportReq02 == \'1\'\" ng-change=\"vc.chgSupport(\'L\')\"> <span class=min-txt>생계비</span> <input type=text class=\"form-control text-right\" ng-model=vc.data.livingAmt ng-disabled=vc.disabledLiving ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></div></div><div class=\"row mt-5\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><input type=checkbox name=chkSreq ng-model=vc.data.SupportReq04 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.SupportReq04 == \'1\'\" ng-change=\"vc.chgSupport(\'C\')\"> <span class=min-txt>치료비</span> <input type=text class=\"form-control text-right\" ng-model=vc.data.CureSptAmt ng-disabled=vc.disabledCure ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><input type=checkbox name=chkSreq ng-model=vc.data.SupportReq03 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.SupportReq03 == \'1\'\" ng-change=\"vc.chgSupport(\'E\')\"> <span class=min-txt>자립비</span> <input type=text class=\"form-control text-right\" ng-model=vc.data.EduSptAmt ng-disabled=vc.disabledEdu ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></div></div><div class=\"row mt-5\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><input type=checkbox name=chkSreq ng-model=vc.data.SupportReq06 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.SupportReq06 == \'1\'\" ng-change=\"vc.chgSupport(\'V\')\"> <span class=min-txt>물품지원</span> <input type=text class=\"form-control text-right\" ng-model=vc.data.VouSptAmt ng-disabled=vc.disabledVou ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><input type=checkbox name=chkSreq ng-model=vc.data.SupportReq05 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.SupportReq05 == \'1\'\" ng-change=\"vc.chgSupport(\'ETC\')\"> <span class=min-txt>기타(의료카드 외)</span> <input type=text class=\"form-control text-right\" ng-model=vc.data.EtcSptAmt ng-disabled=vc.disabledHEtc ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15 style=width:81%> 원</div></div></div></td></tr><tr><th>총 지원 합계</th><td><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.data.TotalSptSum comma placeholder=\"합산 금액을 표시합니다\" readonly> 원</div></div></td></tr><tr><th>산출근거<br><div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'0\')\">작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=\"tip_content tip1\" ng-if=\"vc.tips[0] == \'1\'\"><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'0\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div><table class=reportTable style=width:100%><colgroup><col style=\"width: 10%\"><col style=\"width: 5%\"><col style=\"width: auto\"><col style=\"width: 10%\"><col style=\"width: 20%\"></colgroup><tbody><tr><th>구분</th><th colspan=2>세부 내용</th><th>지원금액</th><th>중복신청</th></tr><tr><th rowspan=2>물품</th><td colspan=2>식품, 생필품, 의류 등 기본 생필품 지원</td><td class=text-center rowspan=2>최대<br>30만원</td><td class=text-center rowspan=10>▶ 치료비 외<br>최대 500만원<br><br>▶ 치료비(치과) 포함<br>최대 700만원</td></tr><tr><td class=text-center>제외<br>항목</td><td>-기호 상품, 생활의 편리성을 위한 물품은 지원항목 아님<br>- 가전제품, 편의성 물품(TV, 컴퓨터, 에어컨, 세탁기, 책상, 청소기 등) 구입 불가<br>*지원항목과 위배되는 물품 구입 시 환수 진행</td></tr><tr><th rowspan=2>주거비</th><td colspan=2>월 임대료, 주거개선을 위한 도배·시설개보수 지원, 임시거주비, 임대보증금</td><td class=text-center rowspan=2>최대<br>300만원</td></tr><tr><td class=text-center>제외<br>항목</td><td>- 주거급여 수급자의 월세 또는 월세 체납분<br>- 단순 집수리 및 편의시설 설치를 위한 환경개선<br>- 보증금 인상, 상향평수 이전 등을 목적으로 한 임대보증금</td></tr><tr><th rowspan=2>생계비</th><td colspan=2>식료품비, 생필품비, 의복비, 수도광열비(전기, 수도, 가스),<br>자녀 교육비(인터넷강의비, 도서구입비, 독서실비, 자격증 취득비)</td><td class=text-center rowspan=2>최대<br>300만원</td></tr><tr><td class=text-center>제외<br>항목</td><td>- 생계급여 수급자의 생계비<br>- 부채, 보험금 미납액, 세금, 과태료 등<br>- 편의성 물품, 사교육비(학원비, 과외비)</td></tr><tr><th rowspan=2>치료비</th><td colspan=2>일반치료비(수술비 및 입원비), 수술시 발생하는 보장구</td><td class=text-center rowspan=2>최대<br>500만원</td></tr><tr><td class=text-center>제외<br>항목</td><td>- 퇴원한 상태 또는 이미 납부된 병원비, 미납된 부채성 의료비<br>- 선천적 장애 및 질병에 대한 치료비, 상급 병실료, 제증명료, 영양제, 보조제 등 건강관리 약제 또는 식품, 건강검진비, 미용·성형비, 정신과치료비, 희귀질환, 장기적인 치료를 요하는 만성질환, 요양성 질환(예: 고혈압, 당뇨병, 비만, 고지혈증, 동맥경화증, 협심증, 심근경색증, 뇌졸중, 만성폐쇄성폐질환, 알코올성 간질환, 퇴행성 관절염, 디스크, 악성 종양 등)<br>- 보험금 지원 한도 내 중복지원</td></tr><tr><th rowspan=2>자립비</th><td colspan=2>① 치과치료비 (보철치료 레진, 인레이크라운, 브릿지, 부분틀니, 완전틀니, 임플란트)<br>② 취업자격취득 교육비, 주부양자 가족에 대한 간병비(동거 가족에 한해 지원), 자녀 돌봄비</td><td class=text-center rowspan=2>① 최대<br>500만원<br><br>② 최대<br>200만원</td></tr><tr><td class=text-center>제외<br>항목</td><td>- 교정치료, 취성패 대상자, 노동부<br>- 자립촉진수당 해당자 중복지원 불가<br>- 친인척, 가족의 간병에 대한 간병비 지원 불가<br>- 공공, 민간 타자원 중복 불가</td></tr></tbody></table></div><!-- tip_btn 클릭 시 나타남 --></div></th><td id=EtcSptCn><textarea rows=5 class=form-control ng-model=vc.data.EtcSptCn placeholder=\"ex) 주거비, 생계비&#13;&#10;[주거비] 월 임대료 : 300,000원 * 2개월 = 600,000원&#13;&#10;[생계비] 수도광열비 : 100,000원 * 3개월 = 300,000원&#13;&#10; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 식료품비 : 100,000원 * 3개월 = 300,000원\"></textarea></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>신청영역</label></div><div class=form-group__input-group-column id=SupportReq><div class=form-group__input-group><div class=form-group__checkbox><input type=checkbox name=chkSreq ng-model=vc.data.SupportReq01 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.SupportReq01 == \'1\'\" ng-click=\"vc.chgSupport(\'H\', this)\"> <span class=min-txt>주거비</span></div><input type=text class=\"form-control right-input\" ng-model=vc.data.HousSptAmt ng-disabled=vc.disabledHous ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div><div class=form-group__input-group><div class=form-group__checkbox><input type=checkbox name=chkSreq ng-model=vc.data.SupportReq02 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.SupportReq02 == \'1\'\" ng-change=\"vc.chgSupport(\'L\')\"> <span class=min-txt>생계비</span></div><input type=text class=\"form-control right-input\" ng-model=vc.data.livingAmt ng-disabled=vc.disabledLiving ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div><div class=form-group__input-group><div class=form-group__checkbox><input type=checkbox name=chkSreq ng-model=vc.data.SupportReq04 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.SupportReq04 == \'1\'\" ng-change=\"vc.chgSupport(\'C\')\"> <span class=min-txt>치료비</span></div><input type=text class=\"form-control right-input\" ng-model=vc.data.CureSptAmt ng-disabled=vc.disabledCure ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div><div class=form-group__input-group><div class=form-group__checkbox><input type=checkbox name=chkSreq ng-model=vc.data.SupportReq03 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.SupportReq03 == \'1\'\" ng-change=\"vc.chgSupport(\'E\')\"> <span class=min-txt>자립비</span></div><input type=text class=\"form-control right-input\" ng-model=vc.data.EduSptAmt ng-disabled=vc.disabledEdu ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div><div class=form-group__input-group><div class=form-group__checkbox><input type=checkbox name=chkSreq ng-model=vc.data.SupportReq06 onclick=\"alert(\'이랜드복지재단 현장위원단만 신청이 가능합니다.\')\" ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.SupportReq06 == \'1\'\" ng-change=\"vc.chgSupport(\'V\')\"> <span class=min-txt>물품지원</span></div><input type=text class=\"form-control right-input\" ng-model=vc.data.VouSptAmt ng-disabled=vc.disabledVou ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div><div class=form-group__input-group><div class=form-group__checkbox><input type=checkbox name=chkSreq ng-model=vc.data.SupportReq05 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.SupportReq05 == \'1\'\" ng-change=\"vc.chgSupport(\'ETC\')\"> <span class=min-txt>기타(의료카드 외)</span></div><input type=text class=\"form-control right-input\" ng-model=vc.data.EtcSptAmt ng-disabled=vc.disabledHEtc ng-change=vc.getTotalSptSum() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>총 지원 합계</label></div><div class=form-group__input-group><input type=text class=\"form-control right-input\" ng-model=vc.data.TotalSptSum comma placeholder=\"합산 금액을 표시합니다\" readonly> 원</div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>산출근거</label><div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'0\')\">작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=\"tip_content tip1\" ng-if=\"vc.tips[0] == \'1\'\"><div class=tip_content_header><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'0\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div><div class=tip_content_body><table class=reportTable style=width:100%><colgroup><col style=\"width: 10%\"><col style=\"width: 5%\"><col style=\"width: auto\"><col style=\"width: 10%\"><col style=\"width: 20%\"></colgroup><tbody><tr><th>구분</th><th colspan=2>세부 내용</th><th>지원금액</th><th>중복신청</th></tr><tr><th rowspan=2>물품</th><td colspan=2>식품, 생필품, 의류 등 기본 생필품 지원</td><td class=text-center rowspan=2>최대<br>30만원</td><td class=text-center rowspan=10>▶ 치료비 외<br>최대 500만원<br><br>▶ 치료비(치과) 포함<br>최대 700만원</td></tr><tr><td class=text-center>제외<br>항목</td><td>-기호 상품, 생활의 편리성을 위한 물품은 지원항목 아님<br>- 가전제품, 편의성 물품(TV, 컴퓨터, 에어컨, 세탁기, 책상, 청소기 등) 구입 불가<br>*지원항목과 위배되는 물품 구입 시 환수 진행</td></tr><tr><th rowspan=2>주거비</th><td colspan=2>월 임대료, 주거개선을 위한 도배·시설개보수 지원, 임시거주비, 임대보증금</td><td class=text-center rowspan=2>최대<br>300만원</td></tr><tr><td class=text-center>제외<br>항목</td><td>- 주거급여 수급자의 월세 또는 월세 체납분<br>- 단순 집수리 및 편의시설 설치를 위한 환경개선<br>- 보증금 인상, 상향평수 이전 등을 목적으로 한 임대보증금</td></tr><tr><th rowspan=2>생계비</th><td colspan=2>식료품비, 생필품비, 의복비, 수도광열비(전기, 수도, 가스),<br>자녀 교육비(인터넷강의비, 도서구입비, 독서실비, 자격증 취득비)</td><td class=text-center rowspan=2>최대<br>300만원</td></tr><tr><td class=text-center>제외<br>항목</td><td>- 생계급여 수급자의 생계비<br>- 부채, 보험금 미납액, 세금, 과태료 등<br>- 편의성 물품, 사교육비(학원비, 과외비)</td></tr><tr><th rowspan=2>치료비</th><td colspan=2>일반치료비(수술비 및 입원비), 수술시 발생하는 보장구</td><td class=text-center rowspan=2>최대<br>500만원</td></tr><tr><td class=text-center>제외<br>항목</td><td>- 퇴원한 상태 또는 이미 납부된 병원비, 미납된 부채성 의료비<br>- 선천적 장애 및 질병에 대한 치료비, 상급 병실료, 제증명료, 영양제, 보조제 등 건강관리 약제 또는 식품, 건강검진비, 미용·성형비, 정신과치료비, 희귀질환, 장기적인 치료를 요하는 만성질환, 요양성 질환(예: 고혈압, 당뇨병, 비만, 고지혈증, 동맥경화증, 협심증, 심근경색증, 뇌졸중, 만성폐쇄성폐질환, 알코올성 간질환, 퇴행성 관절염, 디스크, 악성 종양 등)<br>- 보험금 지원 한도 내 중복지원</td></tr><tr><th rowspan=2>자립비</th><td colspan=2>① 치과치료비 (보철치료 레진, 인레이크라운, 브릿지, 부분틀니, 완전틀니, 임플란트)<br>② 취업자격취득 교육비, 주부양자 가족에 대한 간병비(동거 가족에 한해 지원), 자녀 돌봄비</td><td class=text-center rowspan=2>① 최대<br>500만원<br><br>② 최대<br>200만원</td></tr><tr><td class=text-center>제외<br>항목</td><td>- 교정치료, 취성패 대상자, 노동부<br>- 자립촉진수당 해당자 중복지원 불가<br>- 친인척, 가족의 간병에 대한 간병비 지원 불가<br>- 공공, 민간 타자원 중복 불가</td></tr></tbody></table></div></div><!-- tip_btn 클릭 시 나타남 --></div></div><textarea id=EtcSptCn rows=5 class=form-control ng-model=vc.data.EtcSptCn placeholder=\"ex) 주거비, 생계비&#13;&#10;[주거비] 월 임대료 : 300,000원 * 2개월 = 600,000원&#13;&#10;[생계비] 수도광열비 : 100,000원 * 3개월 = 300,000원&#13;&#10; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; 식료품비 : 100,000원 * 3개월 = 300,000원\"></textarea></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 3. 가족관계 --><div id=pn3 class=row ng-if=vc.isPesEtcOnly><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>가족관계<span class=tRed>*</span></strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th>동거 가구원 수(본인 포함)</th><td id=CohabitCnt><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right short-input\" placeholder=\"숫자만 입력하세요\" ng-model=vc.data.CohabitCnt maxlength=2 oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\')\"> 명</div></td></tr><tr><td colspan=2><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div id=FrmList><p><strong>※ 내용 입력 후 추가버튼 클릭해주셔야 합니다.</strong></p><table class=\"reportTable mt-5 placeholder-center\" style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 20%\"><col style=\"width: 5%\"></colgroup><thead><tr><th>성명</th><th>관계</th><th>출생연도</th><th>직업</th><th>동거여부</th><th>기타</th><th>추가/삭제</th></tr></thead><tbody><tr><td><input type=text class=form-control ng-model=vc.frmData.FrNm placeholder=김길동 maxlength=10></td><td><input type=text class=form-control ng-model=vc.frmData.Relp placeholder=본인 maxlength=10></td><td><input type=text class=form-control ng-model=vc.frmData.Age placeholder=1900 maxlength=4></td><td><input type=text class=form-control ng-model=vc.frmData.Job placeholder=사무직 maxlength=10></td><td><input type=text class=form-control ng-model=vc.frmData.CohabitYN placeholder=동거 maxlength=10></td><td><input type=text class=form-control ng-model=vc.frmData.Remark placeholder=\"\" maxlength=250></td><td><!-- 추가 버튼 --> <button class=\"btn btn-default\" ng-click=vc.addFrm()><i class=\"glyphicon glyphicon-plus\"></i> 추가</button></td></tr><tr ng-repeat=\"(index, li) in vc.data.frmList\"><td>{{li.FrNm}}</td><td>{{li.Relp}}</td><td>{{li.Age}}</td><td>{{li.Job}}</td><td>{{li.CohabitYN}}</td><td>{{li.Remark}}</td><td><!-- 삭제 버튼 --> <button class=\"btn btn-default\" ng-click=vc.delFrm(index)><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></td></tr></tbody></table></div></div></div></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>동거 가구원 수(본인 포함)</label></div><div class=form-group__input-group id=CohabitCnt><input type=text class=\"form-control right-input\" placeholder=\"숫자만 입력하세요\" ng-model=vc.data.CohabitCnt maxlength=2 oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\')\"> 명</div><div id=FrmList><p class=mt-10><strong>※ 내용 입력 후 추가버튼 클릭해주셔야 합니다.</strong></p><div class=table-scroll><table class=\"reportTable mt-5 placeholder-center tb_report\" style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 20%\"><col style=\"width: 5%\"></colgroup><thead><tr><th>성명</th><th>관계</th><th>출생연도</th><th>직업</th><th>동거여부</th><th>기타</th><th>추가/삭제</th></tr></thead><tbody><tr><td><input type=text class=form-control ng-model=vc.frmData.FrNm placeholder=김길동 maxlength=10></td><td><input type=text class=form-control ng-model=vc.frmData.Relp placeholder=본인 maxlength=10></td><td><input type=text class=form-control ng-model=vc.frmData.Age placeholder=1900 maxlength=4></td><td><input type=text class=form-control ng-model=vc.frmData.Job placeholder=사무직 maxlength=10></td><td><input type=text class=form-control ng-model=vc.frmData.CohabitYN placeholder=동거 maxlength=10></td><td><input type=text class=form-control ng-model=vc.frmData.Remark placeholder=\"\" maxlength=250></td><td><!-- 추가 버튼 --> <button class=\"btn btn-default\" ng-click=vc.addFrm()><i class=\"glyphicon glyphicon-plus\"></i> 추가</button></td></tr><tr ng-repeat=\"(index, li) in vc.data.frmList\"><td>{{li.FrNm}}</td><td>{{li.Relp}}</td><td>{{li.Age}}</td><td>{{li.Job}}</td><td>{{li.CohabitYN}}</td><td>{{li.Remark}}</td><td><!-- 삭제 버튼 --> <button class=\"btn btn-default\" ng-click=vc.delFrm(index)><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></td></tr></tbody></table></div></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 4. 경제 상황 --><div id=pn4 class=row ng-if=vc.isPesEtcOnly><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>경제 상황<span class=tRed>*</span></strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 10%\"><col style=\"width: 90%\"></colgroup><tbody><tr><th>주거형태</th><td id=HousType><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3\"><div class=form-group><common-code-custom code-list=\"vc.columnMap[\'HousType\'].CodeList\" code-model=vc.data.HousType ng-change=vc.chgHouseType(vc.data.HousType)></common-code-custom></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-9\"><div class=\"form-group form-inline\" ng-if=\"vc.data.HousType == \'1\'\"><input type=text class=\"form-control text-right\" ng-model=vc.data.JagaAmt ng-disabled=\"vc.data.HousType != \'1\'\" comma placeholder=시가 style=width:40% maxlength=15> 원, <input type=text class=\"form-control text-right\" ng-model=vc.data.JagaLoan ng-disabled=\"vc.data.HousType != \'1\'\" comma placeholder=대출금 style=width:40% maxlength=15> 원</div><div class=\"form-group form-inline\" ng-if=\"vc.data.HousType == \'2\'\"><input type=text class=\"form-control text-right\" ng-model=vc.data.JeonseAmt ng-disabled=\"vc.data.HousType != \'2\'\" comma placeholder=보증금 style=width:40% maxlength=15> 원, <input type=text class=\"form-control text-right\" ng-model=vc.data.JeonseLoan ng-disabled=\"vc.data.HousType != \'2\'\" comma placeholder=대출금 style=width:40% maxlength=15> 원</div><div class=\"form-group form-inline\" ng-if=\"vc.data.HousType == \'3\'\"><input type=text class=\"form-control text-right\" ng-model=vc.data.MonthDep ng-disabled=\"vc.data.HousType != \'3\'\" comma placeholder=보증금 style=width:40% maxlength=15> 원, <input type=text class=\"form-control text-right\" ng-model=vc.data.MonthAmt ng-disabled=\"vc.data.HousType != \'3\'\" comma placeholder=월세 style=width:40% maxlength=15> 원</div><div class=\"form-group form-inline\" ng-if=\"vc.data.HousType == \'4\'\"><input type=text class=\"form-control text-right\" ng-model=vc.data.AptDep ng-disabled=\"vc.data.HousType != \'4\'\" comma placeholder=보증금 style=width:40% maxlength=15> 원, <input type=text class=\"form-control text-right\" ng-model=vc.data.AptAmt ng-disabled=\"vc.data.HousType != \'4\'\" comma placeholder=월세 style=width:40% maxlength=15> 원</div><div class=\"form-group form-inline\" ng-if=\"vc.data.HousType == \'5\'\"><input type=text class=\"form-control etc_input\" ng-model=vc.data.FreeLease ng-disabled=\"vc.data.HousType != \'5\'\" placeholder=\"소유자와의 관계\" maxlength=200></div><div class=\"form-group form-inline\" ng-if=\"vc.data.HousType == \'6\'\"><input type=text class=\"form-control etc_input\" ng-model=vc.data.HousEtcCn ng-disabled=\"vc.data.HousType != \'6\'\" placeholder=기타 maxlength=200></div></div></div></td></tr><tr><th>월 소득 및 자산</th><td><table class=\"reportTable header-bold\" style=width:100%><colgroup><col style=\"width: 25%\"><col style=\"width: 20%\"><col style=\"width: 35%\"><col style=\"width: 20%\"></colgroup><tbody><tr><th>구분</th><th>금액</th><th>세부내용</th><th>월 소득 합계</th></tr><tr><td>근로소득</td><td><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.data.WorkInc ng-change=vc.getTotalInc() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.WorkIncCn maxlength=200></td><td rowspan=4><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.data.TotalInc comma readonly> 원</div></td></tr><tr><td>정부보조금</td><td><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.data.GovtGrant ng-change=vc.getTotalInc() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.GovtGrantCn maxlength=200></td></tr><tr><td>후원금</td><td><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.data.Donation ng-change=vc.getTotalInc() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.DonationCn maxlength=200></td></tr><tr><td>기타</td><td><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.data.Etc ng-change=vc.getTotalInc() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.EtcCn maxlength=200></td></tr></tbody></table></td></tr><tr><th>월 지출</th><td><table class=\"reportTable header-bold\" style=width:100%><colgroup><col style=\"width: 25%\"><col style=\"width: 20%\"><col style=\"width: 30%\"><col style=\"width: 5%\"><col style=\"width: 20%\"></colgroup><tbody><tr><th>구분</th><th>금액</th><th>세부내용</th><th>추가</th><th>월 지출 합계</th></tr><tr><td>식비</td><td><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.data.FoodCost ng-change=vc.getTotalCost() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.FoodCostCn maxlength=200></td><td></td><td rowspan=10><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.data.TotalCost comma readonly> 원</div></td></tr><tr><td>주거비(월세)</td><td><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.data.HousCost ng-change=vc.getTotalCost() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.HousCostCn maxlength=200></td><td></td></tr><tr><td>공과금, 관리비</td><td><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.data.MaintCost ng-change=vc.getTotalCost() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.MaintCostCn maxlength=200></td><td></td></tr><tr><td>의료비</td><td><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.data.HealthCost ng-change=vc.getTotalCost() comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.HealthCostCn maxlength=200></td><td></td></tr><tr><td>본인 작성 (부채상환비, 보험, 교통비 등)</td><td><div class=\"form-group form-inline\"><input type=text class=\"form-control text-right\" ng-model=vc.etcCostData.EtcCost comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.etcCostData.EtcCn maxlength=200></td><td><button class=\"btn btn-default\" ng-click=vc.addEtcCost()><i class=\"glyphicon glyphicon-plus\"></i> 추가</button></td></tr><tr ng-repeat=\"(index, li) in vc.data.etcCostList\"><td></td><td class=text-right><span ng-bind=li.EtcCost comma-bind></span> 원</td><td>{{li.EtcCn}}</td><td><button class=\"btn btn-default\" ng-click=vc.delEtcCost(index)><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></td></tr></tbody></table></td></tr><tr><th>자산</th><td id=finanList><p><strong>※ 내용 입력 후 추가버튼 클릭해주셔야 합니다.</strong></p><table class=\"reportTable mt-5 date-center\" style=width:100%><colgroup><col style=\"width: 20%\"><col style=\"width: 20%\"><col style=\"width: 20%\"><col style=\"width: 30%\"><col style=\"width: 10%\"></colgroup><thead><tr><th>종류</th><th>금액</th><th>사용여부</th><th>비고</th><th>추가</th></tr></thead><tbody><tr><td><common-code-custom code-list=\"vc.columnMap[\'FinanType\'].CodeList\" code-model=vc.finanData.Type></common-code-custom></td><td><input type=text class=\"form-control text-right\" ng-model=vc.finanData.Amount comma ng-disabled=\"vc.finanData.Type == \'5\'\" maxlength=15></td><td><input type=radio name=rdFtype ng-model=vc.finanData.UseYN value=1 ng-disabled=\"vc.finanData.Type == \'5\'\"> 가능 <input type=radio name=rdFtype ng-model=vc.finanData.UseYN value=0 ng-disabled=\"vc.finanData.Type == \'5\'\"> 불가능</td><td><input type=text class=form-control ng-model=vc.finanData.Remark ng-disabled=\"vc.finanData.Type == \'5\'\" maxlength=15></td><td><button class=\"btn btn-default\" ng-click=vc.addFinan()><i class=\"glyphicon glyphicon-plus\"></i> 추가</button></td></tr><tr ng-repeat=\"(index, li) in vc.data.finanList\"><td>{{li.TypeNm}}</td><td class=text-right><span ng-bind=li.Amount comma-bind></span> 원</td><td>{{li.UseYNNm}}</td><td>{{li.Remark}}</td><td><button class=\"btn btn-default\" ng-click=vc.delFinan(index)><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></td></tr></tbody></table></td></tr><tr><th>부채</th><td id=LiabYN><ul class=\"ul_h li_mr15\"><li><label><input type=radio name=rdLiab ng-model=vc.data.LiabYN ng-checked=\"vc.data.LiabYN == \'0\'\" ng-click=vc.chgLiabType(0) value=0> 무</label></li><li><label><input type=radio name=rdLiab ng-model=vc.data.LiabYN ng-checked=\"vc.data.LiabYN == \'1\'\" value=1> 유</label></li><li ng-if=\"vc.data.LiabYN == \'1\'\">사유 :</li><li ng-if=\"vc.data.LiabYN == \'1\'\"><input type=text class=\"form-control etc_input\" ng-model=vc.data.LiabCn style=width:400px maxlength=200></li></ul><ul class=\"checkboxWrap ul_h\" ng-if=\"vc.data.LiabYN == \'1\'\"><li><div class=\"form-group form-inline\"><input type=checkbox name=chkLiab ng-model=vc.data.LiabType1 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.LiabType1 == \'1\'\" ng-change=vc.chgLiabType(1)> 은행 <input type=text class=\"form-control text-right\" ng-model=vc.data.LiabAmt1 ng-disabled=\"vc.data.LiabType1 != \'1\'\" comma maxlength=15> 원</div></li><li><div class=\"form-group form-inline\"><input type=checkbox name=chkLiab ng-model=vc.data.LiabType2 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.LiabType2 == \'1\'\" ng-change=vc.chgLiabType(2)> 카드 <input type=text class=\"form-control text-right\" ng-model=vc.data.LiabAmt2 ng-disabled=\"vc.data.LiabType2 != \'1\'\" comma maxlength=15> 원</div></li><li><div class=\"form-group form-inline\"><input type=checkbox name=chkLiab ng-model=vc.data.LiabType3 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.LiabType3 == \'1\'\" ng-change=vc.chgLiabType(3)> 지인 <input type=text class=\"form-control text-right\" ng-model=vc.data.LiabAmt3 ng-disabled=\"vc.data.LiabType3 != \'1\'\" comma maxlength=15> 원</div></li><li><div class=\"form-group form-inline\"><input type=checkbox name=chkLiab ng-model=vc.data.LiabType4 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.LiabType4 == \'1\'\" ng-change=vc.chgLiabType(4)> 기타 <input type=text class=\"form-control etc_input\" ng-model=vc.data.LiabType4Cn ng-disabled=\"vc.data.LiabType4 != \'1\'\" style=width:40% maxlength=200> <input type=text class=\"form-control text-right\" ng-model=vc.data.LiabAmt4 ng-disabled=\"vc.data.LiabType4 != \'1\'\" comma style=width:40% maxlength=15> 원</div></li></ul></td></tr><tr><th>긴급생계비</th><td id=EmergWelfareYN><p><strong>※ 내용 입력 후 추가버튼 클릭해주셔야 합니다.</strong></p><ul class=\"ul_h li_mr15 mt-5\"><li>신청여부</li><li><label><input type=radio name=rdEmer ng-model=vc.data.EmergWelfareYN ng-checked=\"vc.data.EmergWelfareYN == \'1\'\" ng-click=\"vc.chgTenantSpt(\'emer\')\" value=1> 선정</label></li><li><label><input type=radio name=rdEmer ng-model=vc.data.EmergWelfareYN ng-checked=\"vc.data.EmergWelfareYN == \'0\'\" ng-click=\"vc.chgTenantSpt(\'emer\')\" value=0> 미선정</label></li><li><label><input type=radio name=rdEmer ng-model=vc.data.EmergWelfareYN ng-checked=\"vc.data.EmergWelfareYN == \'2\'\" ng-click=\"vc.chgTenantSpt(\'emer\')\" value=2> 신청하지 않음</label></li></ul><table class=\"reportTable mt-5\" ng-if=\"vc.data.EmergWelfareYN == \'1\'\" style=width:100%><colgroup><col style=\"width: 20%\"><col style=\"width: 20%\"><col style=\"width: 25%\"><col style=\"width: 30%\"><col style=\"width: 5%\"></colgroup><thead><tr><th>지원기관</th><th>지원금액</th><th>지원기간</th><th>지원내용</th><th>추가</th></tr></thead><tbody><tr><td><input type=text class=form-control ng-model=vc.emerTenantSptData.TenantSptNm maxlength=100></td><td><input type=text class=\"form-control text-right\" ng-model=vc.emerTenantSptData.SptAmt comma maxlength=15></td><td><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=input-group ng-controller=DatepickerDemoCtrl style=\"width: 100%\"><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.emerTenantSptData.SptStartDate = (vc.emerSptStartDate | date: \'yyyy-MM-dd\')\" ng-model=vc.emerSptStartDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=input-group ng-controller=DatepickerDemoCtrl style=\"width: 100%\"><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.emerTenantSptData.SptEndDate = (vc.emerSptEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.emerSptEndDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></td><td><input type=text class=form-control ng-model=vc.emerTenantSptData.SptCn maxlength=200></td><td><button class=\"btn btn-default\" ng-click=\"vc.addTenantSptList(\'E\')\"><i class=\"glyphicon glyphicon-plus\"></i> 추가</button></td></tr><tr ng-repeat=\"(index, li) in vc.data.tenantSptList\" ng-if=\"li.Type == \'E\'\"><td>{{li.TenantSptNm}}</td><td class=text-right><span ng-bind=li.SptAmt comma-bind></span></td><td class=text-center>{{li.SptStartDate}} ~ {{li.SptEndDate}}</td><td>{{li.SptCn}}</td><td><button class=\"btn btn-default\" ng-click=vc.delTenantSptList(index)><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></td></tr></tbody></table><table class=reportTable ng-if=\"vc.data.EmergWelfareYN != \'1\'\" style=width:100%><thead><tr><th>불가사유</th></tr></thead><tbody><tr><td><textarea class=form-control rows=5 ng-if=\"vc.data.EmergWelfareYN == \'0\'\" ng-model=vc.data.FailCn placeholder=\"\"></textarea><textarea class=form-control rows=5 ng-if=\"vc.data.EmergWelfareYN == \'2\'\" ng-model=vc.data.NotApplyCN placeholder=\"\"></textarea></td></tr></tbody></table></td></tr><tr><th>외부 지원</th><td id=PrivateSptYN><p><strong>※ 내용 입력 후 추가버튼 클릭해주셔야 합니다.</strong></p><ul class=\"ul_h li_mr15 mt-5\"><li>신청여부</li><li><label><input type=radio name=rdPriv ng-model=vc.data.PrivateSptYN ng-checked=\"vc.data.PrivateSptYN == \'1\'\" ng-click=\"vc.chgTenantSpt(\'priv\')\" value=1> O</label></li><li><label><input type=radio name=rdPriv ng-model=vc.data.PrivateSptYN ng-checked=\"vc.data.PrivateSptYN == \'0\'\" ng-click=\"vc.chgTenantSpt(\'priv\')\" value=0> X (최근 3년 내에 연계된 자원만 기입)</label></li></ul><table class=\"reportTable mt-5 date-center\" ng-if=\"vc.data.PrivateSptYN == \'1\'\" style=width:100%><colgroup><col style=\"width: 20%\"><col style=\"width: 20%\"><col style=\"width: 25%\"><col style=\"width: 30%\"><col style=\"width: 5%\"></colgroup><thead><tr><th>지원기관</th><th>지원금액</th><th>지원기간</th><th>지원내용</th><th>추가</th></tr></thead><tbody><tr><td><input type=text class=\"form-control date-center\" ng-model=vc.privateTenantSptData.TenantSptNm maxlength=100></td><td><input type=text class=\"form-control text-right date-center\" ng-model=vc.privateTenantSptData.SptAmt comma maxlength=15></td><td><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=input-group ng-controller=DatepickerDemoCtrl style=\"width: 100%\"><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.privateTenantSptData.SptStartDate = (vc.privateSptStartDate | date: \'yyyy-MM-dd\')\" ng-model=vc.privateSptStartDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=input-group ng-controller=DatepickerDemoCtrl style=\"width: 100%\"><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.privateTenantSptData.SptEndDate = (vc.privateSptEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.privateSptEndDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></td><td><input type=text class=form-control ng-model=vc.privateTenantSptData.SptCn maxlength=200></td><td><!-- 추가 버튼 --> <button class=\"btn btn-default\" ng-click=\"vc.addTenantSptList(\'P\')\"><i class=\"glyphicon glyphicon-plus\"></i> 추가</button></td></tr><tr ng-repeat=\"(index, li) in vc.data.tenantSptList\" ng-if=\"li.Type == \'P\'\"><td>{{li.TenantSptNm}}</td><td class=text-right><span ng-bind=li.SptAmt comma-bind></span></td><td class=text-center>{{li.SptStartDate}} ~ {{li.SptEndDate}}</td><td>{{li.SptCn}}</td><td><!-- 삭제 버튼 --> <button class=\"btn btn-default\" ng-click=vc.delTenantSptList(index)><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></td></tr></tbody></table></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>주거형태</label></div><div class=form-group__input-group-column id=HousType><common-code-custom code-list=\"vc.columnMap[\'HousType\'].CodeList\" code-model=vc.data.HousType ng-change=vc.chgHouseType(vc.data.HousType)></common-code-custom><div class=form-group__input-group-column><div class=form-group__input-group ng-if=\"vc.data.HousType == \'1\'\"><input type=text class=\"form-control right-input\" ng-model=vc.data.JagaAmt ng-disabled=\"vc.data.HousType != \'1\'\" comma placeholder=시가 maxlength=15> 원, <input type=text class=\"form-control right-input\" ng-model=vc.data.JagaLoan ng-disabled=\"vc.data.HousType != \'1\'\" comma placeholder=대출금 maxlength=15> 원</div><div class=form-group__input-group ng-if=\"vc.data.HousType == \'2\'\"><input type=text class=\"form-control right-input\" ng-model=vc.data.JeonseAmt ng-disabled=\"vc.data.HousType != \'2\'\" comma placeholder=보증금 maxlength=15> 원, <input type=text class=\"form-control right-input\" ng-model=vc.data.JeonseLoan ng-disabled=\"vc.data.HousType != \'2\'\" comma placeholder=대출금 maxlength=15> 원</div><div class=form-group__input-group ng-if=\"vc.data.HousType == \'3\'\"><input type=text class=\"form-control right-input\" ng-model=vc.data.MonthDep ng-disabled=\"vc.data.HousType != \'3\'\" comma placeholder=보증금 maxlength=15> 원, <input type=text class=\"form-control right-input\" ng-model=vc.data.MonthAmt ng-disabled=\"vc.data.HousType != \'3\'\" comma placeholder=월세 maxlength=15> 원</div><div class=form-group__input-group ng-if=\"vc.data.HousType == \'4\'\"><input type=text class=\"form-control right-input\" ng-model=vc.data.AptDep ng-disabled=\"vc.data.HousType != \'4\'\" comma placeholder=보증금 maxlength=15> 원, <input type=text class=\"form-control right-input\" ng-model=vc.data.AptAmt ng-disabled=\"vc.data.HousType != \'4\'\" comma placeholder=월세 maxlength=15> 원</div><div class=form-group__input-group ng-if=\"vc.data.HousType == \'5\'\"><input type=text class=\"form-control etc_input\" ng-model=vc.data.FreeLease ng-disabled=\"vc.data.HousType != \'5\'\" placeholder=\"소유자와의 관계\" maxlength=200></div><div class=form-group__input-group ng-if=\"vc.data.HousType == \'6\'\"><input type=text class=\"form-control etc_input\" ng-model=vc.data.HousEtcCn ng-disabled=\"vc.data.HousType != \'6\'\" placeholder=기타 maxlength=200></div></div></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>월 소득 및 자산</label></div><div class=table-scroll><table class=\"reportTable header-bold tb_report\" style=width:100%><colgroup><col style=\"width: 25%\"><col style=\"width: 20%\"><col style=\"width: 35%\"><col style=\"width: 20%\"></colgroup><tbody><tr><th>구분</th><th>금액</th><th>세부내용</th><th>월 소득 합계</th></tr><tr><td>근로소득</td><td><div class=form-group__input-group><input type=text class=\"form-control text-right\" ng-model=vc.data.WorkInc ng-change=vc.getTotalInc() comma placeholder=\"숫자만 입력하세요\" style=\"min-width: 110px\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.WorkIncCn maxlength=200></td><td rowspan=4><div class=form-group__input-group><input type=text class=\"form-control text-right\" ng-model=vc.data.TotalInc style=\"min-width: 110px\" comma readonly> 원</div></td></tr><tr><td>정부보조금</td><td><div class=form-group__input-group><input type=text class=\"form-control text-right\" ng-model=vc.data.GovtGrant ng-change=vc.getTotalInc() comma placeholder=\"숫자만 입력하세요\" style=\"min-width: 110px\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.GovtGrantCn maxlength=200></td></tr><tr><td>후원금</td><td><div class=form-group__input-group><input type=text class=\"form-control text-right\" ng-model=vc.data.Donation ng-change=vc.getTotalInc() comma placeholder=\"숫자만 입력하세요\" style=\"min-width: 110px\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.DonationCn maxlength=200></td></tr><tr><td>기타</td><td><div class=form-group__input-group><input type=text class=\"form-control text-right\" ng-model=vc.data.Etc ng-change=vc.getTotalInc() comma placeholder=\"숫자만 입력하세요\" style=\"min-width: 110px\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.EtcCn maxlength=200></td></tr></tbody></table></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>월 지출</label></div><div class=table-scroll><table class=\"reportTable header-bold tb_report\" style=width:100%><colgroup><col style=\"width: 25%\"><col style=\"width: 20%\"><col style=\"width: 30%\"><col style=\"width: 5%\"><col style=\"width: 20%\"></colgroup><tbody><tr><th>구분</th><th>금액</th><th>세부내용</th><th>추가</th><th>월 지출 합계</th></tr><tr><td>식비</td><td><div class=form-group__input-group><input type=text class=\"form-control right-input\" ng-model=vc.data.FoodCost ng-change=vc.getTotalCost() comma placeholder=\"숫자만 입력하세요\" maxlength=15 style=\"min-width: 110px\"> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.FoodCostCn maxlength=200></td><td></td><td rowspan=10><div class=form-group__input-group><input type=text class=\"form-control right-input\" ng-model=vc.data.TotalCost style=\"min-width: 110px\" comma readonly> 원</div></td></tr><tr><td>주거비(월세)</td><td><div class=form-group__input-group><input type=text class=\"form-control right-input\" ng-model=vc.data.HousCost ng-change=vc.getTotalCost() comma placeholder=\"숫자만 입력하세요\" maxlength=15 style=\"min-width: 110px\"> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.HousCostCn maxlength=200></td><td></td></tr><tr><td>공과금, 관리비</td><td><div class=form-group__input-group><input type=text class=\"form-control right-input\" ng-model=vc.data.MaintCost ng-change=vc.getTotalCost() comma placeholder=\"숫자만 입력하세요\" maxlength=15 style=\"min-width: 110px\"> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.MaintCostCn maxlength=200></td><td></td></tr><tr><td>의료비</td><td><div class=form-group__input-group><input type=text class=\"form-control right-input\" ng-model=vc.data.HealthCost ng-change=vc.getTotalCost() comma placeholder=\"숫자만 입력하세요\" maxlength=15 style=\"min-width: 110px\"> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.data.HealthCostCn maxlength=200></td><td></td></tr><tr><td>본인 작성 (부채상환비, 보험, 교통비 등)</td><td><div class=form-group__input-group><input type=text class=\"form-control right-input\" ng-model=vc.etcCostData.EtcCost comma placeholder=\"숫자만 입력하세요\" maxlength=15> 원</div></td><td><input type=text class=\"form-control etc_input\" ng-model=vc.etcCostData.EtcCn maxlength=200></td><td><button class=\"btn btn-default\" ng-click=vc.addEtcCost()><i class=\"glyphicon glyphicon-plus\"></i> 추가</button></td></tr><tr ng-repeat=\"(index, li) in vc.data.etcCostList\"><td></td><td class=right-input><span ng-bind=li.EtcCost comma-bind></span> 원</td><td>{{li.EtcCn}}</td><td><button class=\"btn btn-default\" ng-click=vc.delEtcCost(index)><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></td></tr></tbody></table></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>자산</label></div><p><strong>※ 내용 입력 후 추가버튼 클릭해주셔야 합니다.</strong></p><div class=form-group><div class=form-group><div class=form-group__label-wrap><label>종류</label></div><common-code-custom code-list=\"vc.columnMap[\'FinanType\'].CodeList\" code-model=vc.finanData.Type></common-code-custom></div><div class=form-group><div class=form-group__label-wrap><label>금액</label></div><input type=text class=\"form-control right-input\" ng-model=vc.finanData.Amount comma ng-disabled=\"vc.finanData.Type == \'5\'\" maxlength=15></div><div class=form-group><div class=form-group__label-wrap><label>사용여부</label></div><div class=form-group__radio-group><input type=radio name=rdFtype_m ng-model=vc.finanData.UseYN value=1 ng-disabled=\"vc.finanData.Type == \'5\'\"> 가능 <input type=radio name=rdFtype_m ng-model=vc.finanData.UseYN value=0 ng-disabled=\"vc.finanData.Type == \'5\'\"> 불가능</div></div><div class=form-group><div class=form-group__label-wrap><label>비고</label></div><input type=text class=form-control ng-model=vc.finanData.Remark ng-disabled=\"vc.finanData.Type == \'5\'\" maxlength=15></div><button class=\"btn btn-default\" ng-click=vc.addFinan() style=\"width: 100%\"><i class=\"glyphicon glyphicon-plus\"></i> 추가</button><div class=\"form-group__input-group-column mt-10\"><ng-container ng-repeat=\"(index, li) in vc.data.finanList\"><div class=form-group__wrap><div class=form-group__input-group-column style=\"width: 100%\"><p>{{li.TypeNm}}</p><p><span ng-bind=li.Amount comma-bind></span> 원</p><p>{{li.UseYNNm}}</p><p>{{li.Remark}}</p></div></div><button ng-repeat=\"(index, li) in vc.data.finanList\" class=\"btn btn-default mt-4\" ng-click=vc.delFinan(index) style=\"width: 100%\"><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></ng-container></div></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>부채</label></div><div class=form-group__input-group-column id=LiabYN><div class=form-group__radio-group><label><input type=radio name=rdLiab_m ng-model=vc.data.LiabYN ng-checked=\"vc.data.LiabYN == \'0\'\" ng-click=vc.chgLiabType(0) value=0> 무</label><label><input type=radio name=rdLiab_m ng-model=vc.data.LiabYN ng-checked=\"vc.data.LiabYN == \'1\'\" value=1> 유</label></div><div class=form-group__input-group><div class=\"no-wrap min-txt\" ng-if=\"vc.data.LiabYN == \'1\'\">사유</div><input ng-if=\"vc.data.LiabYN == \'1\'\" type=text class=\"form-control etc_input\" ng-model=vc.data.LiabCn maxlength=200></div></div><div class=\"form-group__input-group-column mt-10\" ng-if=\"vc.data.LiabYN == \'1\'\"><div class=form-group__input-group><div class=\"form-group__checkbox no-wrap min-txt\"><input type=checkbox name=chkLiab ng-model=vc.data.LiabType1 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.LiabType1 == \'1\'\" ng-change=vc.chgLiabType(1)> 은행</div><input type=text class=\"form-control right-input\" ng-model=vc.data.LiabAmt1 ng-disabled=\"vc.data.LiabType1 != \'1\'\" comma maxlength=15> 원</div><div class=form-group__input-group><div class=\"form-group__checkbox no-wrap min-txt\"><input type=checkbox name=chkLiab ng-model=vc.data.LiabType2 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.LiabType2 == \'1\'\" ng-change=vc.chgLiabType(2)> 카드</div><input type=text class=\"form-control right-input\" ng-model=vc.data.LiabAmt2 ng-disabled=\"vc.data.LiabType2 != \'1\'\" comma maxlength=15> 원</div><div class=form-group__input-group><div class=\"form-group__checkbox no-wrap min-txt\"><input type=checkbox name=chkLiab ng-model=vc.data.LiabType3 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.LiabType3 == \'1\'\" ng-change=vc.chgLiabType(3)> 지인</div><input type=text class=\"form-control right-input\" ng-model=vc.data.LiabAmt3 ng-disabled=\"vc.data.LiabType3 != \'1\'\" comma maxlength=15> 원</div><div class=form-group__input-group><div class=\"form-group__checkbox no-wrap min-txt\"><input type=checkbox name=chkLiab ng-model=vc.data.LiabType4 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.data.LiabType4 == \'1\'\" ng-change=vc.chgLiabType(4)> 기타</div><input type=text class=\"form-control etc_input mr-5\" ng-model=vc.data.LiabType4Cn ng-disabled=\"vc.data.LiabType4 != \'1\'\" maxlength=200> <input type=text class=\"form-control right-input\" ng-model=vc.data.LiabAmt4 ng-disabled=\"vc.data.LiabType4 != \'1\'\" comma maxlength=15> 원</div></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>긴급생계비</label></div><p><strong>※ 내용 입력 후 추가버튼 클릭해주셔야 합니다.</strong></p><div class=form-group id=EmergWelfareYN><div class=form-group><div class=form-group__label-wrap><label>신청여부</label></div><div class=form-group__input-group-column><div class=form-group__radio-group><label><input type=radio name=rdEmer_m ng-model=vc.data.EmergWelfareYN ng-checked=\"vc.data.EmergWelfareYN == \'1\'\" ng-click=\"vc.chgTenantSpt(\'emer\')\" value=1> 선정</label><label><input type=radio name=rdEmer_m ng-model=vc.data.EmergWelfareYN ng-checked=\"vc.data.EmergWelfareYN == \'0\'\" ng-click=\"vc.chgTenantSpt(\'emer\')\" value=0> 미선정</label><label><input type=radio name=rdEmer_m ng-model=vc.data.EmergWelfareYN ng-checked=\"vc.data.EmergWelfareYN == \'2\'\" ng-click=\"vc.chgTenantSpt(\'emer\')\" value=2> 신청하지 않음</label></div></div></div><div ng-if=\"vc.data.EmergWelfareYN == \'1\'\"><div class=form-group><div class=form-group__label-wrap><label>지원기관</label></div><input type=text class=form-control ng-model=vc.emerTenantSptData.TenantSptNm maxlength=100></div><div class=form-group><div class=form-group__label-wrap><label>지원금액</label></div><input type=text class=\"form-control text-right\" ng-model=vc.emerTenantSptData.SptAmt comma maxlength=15></div><div class=form-group><div class=form-group__label-wrap><label>지원기간</label></div><div class=form-group__input-group><div class=input-group ng-controller=DatepickerDemoCtrl style=\"width: 100%\"><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.emerTenantSptData.SptStartDate = (vc.emerSptStartDate | date: \'yyyy-MM-dd\')\" ng-model=vc.emerSptStartDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=\"input-group ml-5\" ng-controller=DatepickerDemoCtrl style=\"width: 100%\"><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.emerTenantSptData.SptEndDate = (vc.emerSptEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.emerSptEndDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=form-group><div class=form-group__label-wrap><label>지원내용</label></div><input type=text class=form-control ng-model=vc.emerTenantSptData.SptCn maxlength=200></div><button class=\"btn btn-default\" ng-click=\"vc.addTenantSptList(\'E\')\" style=\"width: 100%\"><i class=\"glyphicon glyphicon-plus\"></i> 추가</button><div class=\"form-group__input-group-column mt-10\"><ng-container ng-repeat=\"(index, li) in vc.data.tenantSptList\" ng-if=\"li.Type == \'E\'\"><div class=form-group__wrap><div class=form-group__input-group-column style=\"width: 100%\"><p>{{li.TenantSptNm}}</p><p><span ng-bind=li.SptAmt comma-bind></span> 원</p><p>{{li.SptStartDate}} ~ {{li.SptEndDate}}</p><p>{{li.SptCn}}</p></div></div><button class=\"btn btn-default mt-4\" ng-click=vc.delTenantSptList(index) style=\"width: 100%\"><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></ng-container></div></div></div><div ng-if=\"vc.data.EmergWelfareYN != \'1\'\"><div class=form-group><div class=form-group__label-wrap><label>불가사유</label></div><textarea class=form-control rows=5 ng-if=\"vc.data.EmergWelfareYN == \'0\'\" ng-model=vc.data.FailCn placeholder=\"\"></textarea><textarea class=form-control rows=5 ng-if=\"vc.data.EmergWelfareYN == \'2\'\" ng-model=vc.data.NotApplyCN placeholder=\"\"></textarea></div></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>외부 지원</label></div><p><strong>※ 내용 입력 후 추가버튼 클릭해주셔야 합니다.</strong></p><div class=form-group id=PrivateSptYN><div class=form-group><div class=form-group__label-wrap><label>신청여부</label></div><div class=form-group__input-group-column><div class=form-group__radio-group><label><input type=radio name=rdPriv_m ng-model=vc.data.PrivateSptYN ng-checked=\"vc.data.PrivateSptYN == \'1\'\" ng-click=\"vc.chgTenantSpt(\'priv\')\" value=1> O</label><label><input type=radio name=rdPriv_m ng-model=vc.data.PrivateSptYN ng-checked=\"vc.data.PrivateSptYN == \'0\'\" ng-click=\"vc.chgTenantSpt(\'priv\')\" value=0> X (최근 3년 내에 연계된 자원만 기입)</label></div></div></div><div ng-if=\"vc.data.PrivateSptYN == \'1\'\"><div class=form-group><div class=form-group__label-wrap><label>지원기관</label></div><input type=text class=\"form-control date-center\" ng-model=vc.privateTenantSptData.TenantSptNm maxlength=100></div><div class=form-group><div class=form-group__label-wrap><label>지원금액</label></div><input type=text class=\"form-control text-right date-center\" ng-model=vc.privateTenantSptData.SptAmt comma maxlength=15></div><div class=form-group><div class=form-group__label-wrap><label>지원기간</label></div><div class=form-group__input-group><div class=input-group ng-controller=DatepickerDemoCtrl style=\"width: 100%\"><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.privateTenantSptData.SptStartDate = (vc.privateSptStartDate | date: \'yyyy-MM-dd\')\" ng-model=vc.privateSptStartDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><div class=input-group ng-controller=DatepickerDemoCtrl style=\"width: 100%\"><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.privateTenantSptData.SptEndDate = (vc.privateSptEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.privateSptEndDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=form-group><div class=form-group__label-wrap><label>지원내용</label></div><input type=text class=form-control ng-model=vc.privateTenantSptData.SptCn maxlength=200></div><button class=\"btn btn-default\" ng-click=\"vc.addTenantSptList(\'P\')\" style=\"width: 100%\"><i class=\"glyphicon glyphicon-plus\"></i> 추가</button><div class=\"form-group__input-group-column mt-10\"><ng-container ng-repeat=\"(index, li) in vc.data.tenantSptList\" ng-if=\"li.Type == \'P\'\"><div class=form-group__wrap><div class=form-group__input-group-column style=\"width: 100%\"><p>{{li.TenantSptNm}}</p><p><span ng-bind=li.SptAmt comma-bind></span> 원</p><p>{{li.SptStartDate}} ~ {{li.SptEndDate}}</p><p>{{li.SptCn}}</p></div></div><button class=\"btn btn-default mt-4\" ng-click=vc.delTenantSptList(index) style=\"width: 100%\"><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></ng-container></div></div></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 6. 추천기관 --><div id=pn6 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>추천기관<span class=tRed>*</span></strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 10%\"><col style=\"width: 30%\"><col style=\"width: 10%\"><col style=\"width: 20%\"><col style=\"width: 10%\"><col style=\"width: 20%\"></colgroup><tbody><tr><th>기관명</th><td><input type=text class=\"form-control form-right\" ng-model=vc.tenantData.TenantNm readonly></td><th>구분</th><td><input type=text class=\"form-control form-right\" ng-model=vc.tenantData.OrganizationNm readonly></td><th>대표자명</th><td><input type=text class=\"form-control form-right\" ng-model=vc.tenantData.Ceo readonly></td></tr><tr><th>대표번호</th><td><input type=text class=\"form-control form-right\" ng-model=vc.tenantData.TelNo auto-hyphen readonly></td><th>팩스</th><td colspan=3><input type=text class=\"form-control form-right\" ng-model=vc.tenantData.Fax auto-hyphen readonly></td></tr><tr><th>담당자명</th><td id=ContactNm><input type=text class=\"form-control form-right\" ng-model=vc.data.ContactNm maxlength=50></td><th>담당자 휴대폰번호</th><td id=ContactMobile><input type=text class=\"form-control form-right\" auto-hyphen ng-model=vc.data.ContactMobile maxlength=20></td><th>담당자 이메일주소</th><td id=ContactEmail><input type=text class=\"form-control form-right\" ng-model=vc.data.ContactEmail maxlength=50></td></tr><tr ng-show=vc.isPesEtcOnly><th>대상자<br>위기상황 요약<br>및 추천사유</th><td colspan=5><span><strong>- 기본정보 (대상자 기본정보, 가족구성원, 직업 등 구체적으로 기재)<br>- 주변 지지체계(가족 지지 정도 또는 지지가 어려운 경우에 대한 설명)<br>- 사회적 지지망 (서비스 지원, 연계 여부)<br>- 위기 상황 (위기 심각성 및 대상 가정의 절박성)<br>- 경제 상황(소득 중단 사유, 가족 구성원 소득 상황)</strong></span><textarea rows=10 id=SupportNec class=\"form-control mt-10 mb-5\" ng-model=vc.data.SupportNec minlength=200 placeholder=\"\"></textarea><span id=SupportNec_len>(0 자)</span></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>기관명</label></div><input type=text class=\"form-control form-right\" ng-model=vc.tenantData.TenantNm readonly></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>구분</label></div><input type=text class=\"form-control form-right\" ng-model=vc.tenantData.OrganizationNm readonly></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>대표자명</label></div><input type=text class=\"form-control form-right\" ng-model=vc.tenantData.Ceo readonly></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>대표번호</label></div><input type=text class=\"form-control form-right\" ng-model=vc.tenantData.TelNo auto-hyphen readonly></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>팩스</label></div><input type=text class=\"form-control form-right\" ng-model=vc.tenantData.Fax auto-hyphen readonly></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>담당자명</label></div><input id=ContactNm type=text class=\"form-control form-right\" ng-model=vc.data.ContactNm maxlength=50></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>담당자 휴대폰번호</label></div><input id=ContactMobile type=text class=\"form-control form-right\" auto-hyphen ng-model=vc.data.ContactMobile maxlength=20></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>담당자 이메일주소</label></div><input id=ContactEmail type=text class=\"form-control form-right\" ng-model=vc.data.ContactEmail maxlength=50></div><div class=form-group ng-show=vc.isPesEtcOnly><div class=form-group__label-wrap><label class=form-group__label>대상자 위기상황 요약 및 추천사유</label></div><div class=form-group__input-group-column><p>- 기본정보 (대상자 기본정보, 가족구성원, 직업 등 구체적으로 기재)<br>- 주변 지지체계(가족 지지 정도 또는 지지가 어려운 경우에 대한 설명)<br>- 사회적 지지망 (서비스 지원, 연계 여부)<br>- 위기 상황 (위기 심각성 및 대상 가정의 절박성)<br>- 경제 상황(소득 중단 사유, 가족 구성원 소득 상황)</p><textarea rows=10 id=SupportNec class=\"form-control mt-10 mb-5\" ng-model=vc.data.SupportNec minlength=200 placeholder=\"\"></textarea></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 8. 첨부서류 --><div id=pn8 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>첨부서류[서류제출 예시]</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><p>※ 양식은 공지사항에서도 다운로드 가능합니다.</p><p>※ 하나의 PDF 파일로 제출합니다. (병합이 어려울 경우 첨부파일 추가 버튼을 클릭하여 제출)</p><p>※ 파일명에 특수문자, 기호 등의 사용시 오류 발생합니다.</p><p>※ 모든 파일은 PDF와 이미지로만 업로드가 가능합니다.</p><br><div class=table-scroll><table class=\"reportTable tb_report mb-10\" style=width:100%><colgroup><col style=\"width: 5%\"><col style=\"width: 15%\"><col style=\"width: 30%\"><col style=\"width: 35%\"><col style=\"width: 15%\"></colgroup><tbody><tr id=attachFile><th>잠금</th><th>종류</th><th>파일</th><th>비고</th><th>양식</th></tr><tr ng-repeat=\"(key, fileObj) in vc.attach\" ng-if=vc.fileView(key)><td><button class=\"btn btn-primary\" ng-click=\"vc.setFileLock(key,\'N\')\" ng-if=\"fileObj.fileLock == \'Y\'\"><i class=\"fa fa-lock\"></i></button> <button class=\"btn btn-primary\" ng-click=\"vc.setFileLock(key,\'Y\')\" ng-if=\"fileObj.fileLock == \'N\'\"><i class=\"fa fa-unlock\"></i></button></td><td>{{ fileObj.label }}<span ng-if=\"[\'AttachFile5\',\'AttachFile1\'].includes(key)\" class=tRed>*</span></td><td><div class=input-group><input id=\"{{ key }}\" style=\"display: none\" class=file type=file multiple data-preview-file-type=any data-upload-url=# placeholder=\"\"> <input class=\"form-control form-right\" type=text ng-model=fileObj.fileName ng-click=vc.downloadTemp(key) style=\"cursor: pointer\" readonly><div class=input-group-btn><button ng-show=!fileObj.isLoaded class=\"btn btn-default\" ng-click=vc.openAttachDialog(key)><i class=\"fa fa-save\"></i>찾기</button> <button ng-show=fileObj.isLoaded class=\"btn btn-default\" ng-click=vc.onDelete(key) style=z-index:1><i class=\"fa fa-times\"></i>삭제</button></div></div></td><td>{{ fileObj.txt }}</td><td><button class=\"btn btn-primary\" ng-click=vc.downloadFile(key) ng-if=\"[\'AttachFile5\',\'AttachFile1\',\'AttachFile6\'].includes(key)\"><i class=\"fa fa-file\"></i> 다운로드</button></td></tr></tbody></table></div><button class=\"btn btn-primary\" ng-click=vc.addFile() ng-if=\" !vc.attach[\'AddFile10\'].ngIf && !vc.isPesEtcOnly\"><i class=\"fa fa-file\"></i> 첨부파일 추가</button></div></div></div></div><!----------------------------------------------------------------------------------------------------><div id=pn5 class=row ng-if=\"vc.tenantType == \'TAKETENANT\'\"><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>서류심사 체크리스트</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report ng-if=vc.selfChk><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th>총점</th><td>{{vc.selfDataResult.totalSc}}점</td></tr><tr><th>지원단계</th><td>{{vc.selfDataResult.stepTxt}}</td></tr><tr><th>권장지원금</th><td>{{vc.selfDataResult.amtTxt}}</td></tr></tbody></table><table class=tb_report id=SelfDataQna ng-if=\"! vc.isPesEtcOnly\"><colgroup><col style=\"width: 15%\"><col style=\"width: 40%\"><col style=\"width: 45%\"></colgroup><thead><tr><th>번호</th><th>AI 질문</th><th>답변</th></tr></thead><tbody><tr ng-repeat=\"qst in vc.selfDataQna\"><th class=text-center>{{qst.no}}</th><td><textarea rows=3 class=form-control ng-model=qst.question readonly></textarea></td><td><textarea rows=3 class=form-control ng-model=qst.answer></textarea></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 9. 현장실사 가능 일자 --><div id=pn9 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>현장실사 가능 일자</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report date-center mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 15%\"><col style=\"width: 35%\"></colgroup><tbody><tr id=SiteVeriftDate><th style=\"text-align: center\">1순위</th><td><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened style=z-index:1 ng-change=\"vc.chkSiteVeriftDate(1, vc.SiteVeriftDate1, vc.data.SiteVeriftDate1);\" ng-model=vc.SiteVeriftDate1 ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button style=z-index:1><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><select class=form-control ng-model=vc.data.SiteVeriftTime11 ng-options=\"t for t in vc.timeList\"></select></div></td><th style=\"text-align: center\">2순위</th><td><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened style=z-index:1 ng-change=\"vc.chkSiteVeriftDate(2, vc.SiteVeriftDate2, vc.data.SiteVeriftDate2);\" ng-model=vc.SiteVeriftDate2 ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button style=z-index:1><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><select class=form-control ng-model=vc.data.SiteVeriftTime21 ng-options=\"t for t in vc.timeList\"></select></div></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>1순위</label></div><div class=form-group__input-group><div class=form-group__input-group style=\"width: 100%\"><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.chkSiteVeriftDate(1, vc.SiteVeriftDate1, vc.data.SiteVeriftDate1);\" ng-model=vc.SiteVeriftDate1 ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button style=z-index:1><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><select class=form-control ng-model=vc.data.SiteVeriftTime11 ng-options=\"t for t in vc.timeList\" style=\"width: 100px\"></select></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>2순위</label></div><div class=form-group__input-group><div class=form-group__input-group style=\"width: 100%\"><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened style=z-index:1 ng-change=\"vc.chkSiteVeriftDate(2, vc.SiteVeriftDate2, vc.data.SiteVeriftDate2);\" ng-model=vc.SiteVeriftDate2 ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button style=z-index:1><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><select class=form-control ng-model=vc.data.SiteVeriftTime21 ng-options=\"t for t in vc.timeList\" style=\"width: 100px\"></select></div></div></fieldset></div></div></div></div><!-- 버튼 영역 --><div class=row><div class=\"pull-right mb-20 mr-10\"><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.saveTempData()><i class=\"fa fa-save\"></i> 임시저장</button> <button class=\"btn btn-primary\" ng-click=vc.saveData()><i class=\"fa fa-save\"></i> 최종 제출</button></div></div><!-- 버튼 영역 끝 --></div><!-- /page content --></div><script type=text/javascript>$(document).ready(function () {     \r\n    $(\'#SupportNec\').keyup(function (e){\r\n      var txt = $(this).val();\r\n      $(\'#SupportNec_len\').html(\"(\"+ txt.length +\" 자)\"); \r\n    });    \r\n  });</script>");
$templateCache.put("app/eland-request/take-eval-detail.html","<div class=\"page page-footable elandCustom\" ng-controller=\"TakeEvalDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=ailoader ng-show=vc.ailoader1><div class=ailoader_txt ng-show=vc.ailoader1>AI 총평을 분석중입니다.<br>잠시만 기다려주세요.</div></div><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>지원신청 평가 상세</h3></div></div><div class=pagecontent><!-- 버튼 영역 --><div class=row><div class=\"pull-right mb-5\"><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div><!-- 버튼 영역 끝 --><!----------------------------------------------------------------------------------------------------><!-- 기본 정보 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>기본 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=\"form-group form-inline\"><label><strong>문서제목</strong></label><input type=text class=form-control ng-model=vc.data.Title style=\"text-align: left\" readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>신청일</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.ReqDate readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>대상자명</strong></label><input type=text class=\"form-control form-right\" value=\"{{vc.data.TargetNm}} ({{vc.data.Age}}세)\" readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>지원영역</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.SupportReqNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>최종지원금액</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.FinalSptSum comma readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>사례관리기관</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.TakeTenantNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>후원기관</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.GiveTenantNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>진행상태</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.StatusNm readonly></div></div></div></div></div></div></div><!-- 기본 정보 끝 --><!----------------------------------------------------------------------------------------------------><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>지원적합률 평가</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\" rowspan=2>위기적합성</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=MoniSc1 ng-model=vc.data.MoniSc1 ng-checked=\"vc.data.MoniSc1 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=MoniSc1 ng-model=vc.data.MoniSc1 ng-checked=\"vc.data.MoniSc1 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=MoniSc1 ng-model=vc.data.MoniSc1 ng-checked=\"vc.data.MoniSc1 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=MoniSc1 ng-model=vc.data.MoniSc1 ng-checked=\"vc.data.MoniSc1 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=MoniSc1 ng-model=vc.data.MoniSc1 ng-checked=\"vc.data.MoniSc1 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=MoniSc1 ng-model=vc.data.MoniSc1 ng-checked=\"vc.data.MoniSc1 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.MoniScTxt1 disabled></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>복지사각지대 해당 여부</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=MoniSc2 ng-model=vc.data.MoniSc2 ng-checked=\"vc.data.MoniSc2 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=MoniSc2 ng-model=vc.data.MoniSc2 ng-checked=\"vc.data.MoniSc2 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=MoniSc2 ng-model=vc.data.MoniSc2 ng-checked=\"vc.data.MoniSc2 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=MoniSc2 ng-model=vc.data.MoniSc2 ng-checked=\"vc.data.MoniSc2 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=MoniSc2 ng-model=vc.data.MoniSc2 ng-checked=\"vc.data.MoniSc2 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=MoniSc2 ng-model=vc.data.MoniSc2 ng-checked=\"vc.data.MoniSc2 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.MoniScTxt2 disabled></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>지원 시기의 적절성</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=MoniSc3 ng-model=vc.data.MoniSc3 ng-checked=\"vc.data.MoniSc3 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=MoniSc3 ng-model=vc.data.MoniSc3 ng-checked=\"vc.data.MoniSc3 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=MoniSc3 ng-model=vc.data.MoniSc3 ng-checked=\"vc.data.MoniSc3 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=MoniSc3 ng-model=vc.data.MoniSc3 ng-checked=\"vc.data.MoniSc3 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=MoniSc3 ng-model=vc.data.MoniSc3 ng-checked=\"vc.data.MoniSc3 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=MoniSc3 ng-model=vc.data.MoniSc3 ng-checked=\"vc.data.MoniSc3 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.MoniScTxt3 disabled></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>지원 금액 적정성</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=MoniSc4 ng-model=vc.data.MoniSc4 ng-checked=\"vc.data.MoniSc4 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=MoniSc4 ng-model=vc.data.MoniSc4 ng-checked=\"vc.data.MoniSc4 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=MoniSc4 ng-model=vc.data.MoniSc4 ng-checked=\"vc.data.MoniSc4 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=MoniSc4 ng-model=vc.data.MoniSc4 ng-checked=\"vc.data.MoniSc4 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=MoniSc4 ng-model=vc.data.MoniSc4 ng-checked=\"vc.data.MoniSc4 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=MoniSc4 ng-model=vc.data.MoniSc4 ng-checked=\"vc.data.MoniSc4 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.MoniScTxt4 disabled></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>지원항목 적합성</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=MoniSc5 ng-model=vc.data.MoniSc5 ng-checked=\"vc.data.MoniSc5 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=MoniSc5 ng-model=vc.data.MoniSc5 ng-checked=\"vc.data.MoniSc5 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=MoniSc5 ng-model=vc.data.MoniSc5 ng-checked=\"vc.data.MoniSc5 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=MoniSc5 ng-model=vc.data.MoniSc5 ng-checked=\"vc.data.MoniSc5 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=MoniSc5 ng-model=vc.data.MoniSc5 ng-checked=\"vc.data.MoniSc5 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=MoniSc5 ng-model=vc.data.MoniSc5 ng-checked=\"vc.data.MoniSc5 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.MoniScTxt5 disabled></textarea></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!--  --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>지원 적합 총평</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\">지원 적합 점수</th><td>{{vc.data.MoniSc}}점</td></tr><tr><th style=\"text-align: center\">지원 적합 여부<div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'0\')\">자동환산표</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[0] == \'1\'\" style=position:absolute;top:50px;width:300px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'0\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>지원 적합 자동환산표<table class=tipTable style=width:100%;padding:0px><colgroup><col style=\"width: 50%\"><col style=\"width: 50%\"></colgroup><thead><tr><th>점수</th><th>상태</th></tr></thead><tbody><tr><td>4.5 이상</td><td>매우 적합</td></tr><tr><td>3.5 ~ 4.4</td><td>적합</td></tr><tr><td>2.5 ~ 3.4</td><td>보통</td></tr><tr><td>2.4 이하</td><td>부적합</td></tr></tbody></table></div><!-- tip_btn 클릭 시 나타남 --></div></th><td>{{vc.data.MoniResult}}</td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!--  --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>적합성 종합평가</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 70%\"><col style=\"width: 15%\"></colgroup><tbody><tr><th style=\"text-align: center\" rowspan=2>총평<div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'1\')\">평가기준</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[1] == \'1\'\" style=position:absolute;top:70px;width:400px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'1\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>종합 평가<table class=tipTable style=width:100%;padding:0px><colgroup><col style=\"width: 50%\"><col style=\"width: 50%\"></colgroup><thead><tr><th>점수</th><th>평가 기준</th></tr></thead><tbody><tr><td>0</td><td>사업 취지와 맞지 않음</td></tr><tr><td>1</td><td>매우 미흡</td></tr><tr><td>2</td><td>개선 필요</td></tr><tr><td>3</td><td>보통</td></tr><tr><td>4</td><td>우수</td></tr><tr><td>5</td><td>매우 우수</td></tr></tbody></table></div><!-- tip_btn 클릭 시 나타남 --></div></th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=AiOverallSc ng-model=vc.data.AiOverallSc ng-checked=\"vc.data.AiOverallSc == \'0\'\" value=0 ng-disabled=!vc.aiOverallEdit> 0점</label></li><li><label><input type=radio name=AiOverallSc ng-model=vc.data.AiOverallSc ng-checked=\"vc.data.AiOverallSc == \'1\'\" value=1 ng-disabled=!vc.aiOverallEdit> 1점</label></li><li><label><input type=radio name=AiOverallSc ng-model=vc.data.AiOverallSc ng-checked=\"vc.data.AiOverallSc == \'2\'\" value=2 ng-disabled=!vc.aiOverallEdit> 2점</label></li><li><label><input type=radio name=AiOverallSc ng-model=vc.data.AiOverallSc ng-checked=\"vc.data.AiOverallSc == \'3\'\" value=3 ng-disabled=!vc.aiOverallEdit> 3점</label></li><li><label><input type=radio name=AiOverallSc ng-model=vc.data.AiOverallSc ng-checked=\"vc.data.AiOverallSc == \'4\'\" value=4 ng-disabled=!vc.aiOverallEdit> 4점</label></li><li><label><input type=radio name=AiOverallSc ng-model=vc.data.AiOverallSc ng-checked=\"vc.data.AiOverallSc == \'5\'\" value=5 ng-disabled=!vc.aiOverallEdit> 5점</label></li></ul></td><td style=\"text-align: right\"><button ng-if=!vc.aiOverallEdit class=\"btn-min btn btn-default\" ng-click=\"vc.toggleAiEdit(\'\')\"><i class=\"glyphicon glyphicon-edit\"></i> 편집</button> <button ng-if=vc.aiOverallEdit class=\"btn-min btn btn-default\" ng-click=vc.saveAiData(false)><i class=\"glyphicon glyphicon-edit\"></i> 저장</button></td></tr><tr><td colspan=2><textarea ng-if=vc.aiOverallEdit rows=10 id=aiMoniOverall class=\"form-control mt-10 mb-5\" ng-model=vc.data.AiOverall></textarea><div ng-if=!vc.aiOverallEdit class=ai_html ng-bind-html=vc.aiView.AiOverall></div></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!--  --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>사례관리 기관 평가</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\" rowspan=2>사례관리 적절성</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=TakeTenantSc1 ng-model=vc.data.TakeTenantSc1 ng-checked=\"vc.data.TakeTenantSc1 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=TakeTenantSc1 ng-model=vc.data.TakeTenantSc1 ng-checked=\"vc.data.TakeTenantSc1 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=TakeTenantSc1 ng-model=vc.data.TakeTenantSc1 ng-checked=\"vc.data.TakeTenantSc1 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=TakeTenantSc1 ng-model=vc.data.TakeTenantSc1 ng-checked=\"vc.data.TakeTenantSc1 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=TakeTenantSc1 ng-model=vc.data.TakeTenantSc1 ng-checked=\"vc.data.TakeTenantSc1 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=TakeTenantSc1 ng-model=vc.data.TakeTenantSc1 ng-checked=\"vc.data.TakeTenantSc1 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.TakeTenantScTxt1 disabled></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>결과보고 충실도</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=TakeTenantSc2 ng-model=vc.data.TakeTenantSc2 ng-checked=\"vc.data.TakeTenantSc2 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=TakeTenantSc2 ng-model=vc.data.TakeTenantSc2 ng-checked=\"vc.data.TakeTenantSc2 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=TakeTenantSc2 ng-model=vc.data.TakeTenantSc2 ng-checked=\"vc.data.TakeTenantSc2 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=TakeTenantSc2 ng-model=vc.data.TakeTenantSc2 ng-checked=\"vc.data.TakeTenantSc2 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=TakeTenantSc2 ng-model=vc.data.TakeTenantSc2 ng-checked=\"vc.data.TakeTenantSc2 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=TakeTenantSc2 ng-model=vc.data.TakeTenantSc2 ng-checked=\"vc.data.TakeTenantSc2 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.TakeTenantScTxt2 disabled></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>외부자원연계 적극성</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=TakeTenantSc3 ng-model=vc.data.TakeTenantSc3 ng-checked=\"vc.data.TakeTenantSc3 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=TakeTenantSc3 ng-model=vc.data.TakeTenantSc3 ng-checked=\"vc.data.TakeTenantSc3 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=TakeTenantSc3 ng-model=vc.data.TakeTenantSc3 ng-checked=\"vc.data.TakeTenantSc3 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=TakeTenantSc3 ng-model=vc.data.TakeTenantSc3 ng-checked=\"vc.data.TakeTenantSc3 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=TakeTenantSc3 ng-model=vc.data.TakeTenantSc3 ng-checked=\"vc.data.TakeTenantSc3 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=TakeTenantSc3 ng-model=vc.data.TakeTenantSc3 ng-checked=\"vc.data.TakeTenantSc3 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.TakeTenantScTxt3 disabled></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>위기대응 신속성</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=TakeTenantSc4 ng-model=vc.data.TakeTenantSc4 ng-checked=\"vc.data.TakeTenantSc4 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=TakeTenantSc4 ng-model=vc.data.TakeTenantSc4 ng-checked=\"vc.data.TakeTenantSc4 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=TakeTenantSc4 ng-model=vc.data.TakeTenantSc4 ng-checked=\"vc.data.TakeTenantSc4 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=TakeTenantSc4 ng-model=vc.data.TakeTenantSc4 ng-checked=\"vc.data.TakeTenantSc4 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=TakeTenantSc4 ng-model=vc.data.TakeTenantSc4 ng-checked=\"vc.data.TakeTenantSc4 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=TakeTenantSc4 ng-model=vc.data.TakeTenantSc4 ng-checked=\"vc.data.TakeTenantSc4 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.TakeTenantScTxt4 disabled></textarea></td></tr><tr><th style=\"text-align: center\">최종점수</th><td>{{vc.data.TakeTenantSc}}점</td></tr><tr><th style=\"text-align: center\">기관평가</th><td>{{vc.data.TakeTenantGradeNm}}</td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!--  --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>우수사례</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\">우수사례 여부</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=BestYN ng-model=vc.data.BestYN ng-checked=\"vc.data.BestYN == \'Y\'\" value=Y disabled> 적합</label></li><li><label><input type=radio name=BestYN ng-model=vc.data.BestYN ng-checked=\"vc.data.BestYN == \'N\'\" value=N disabled> 부적합</label></li></ul></td></tr></tbody></table></div></div></div></div><!-- 버튼 영역 --><div class=\"pull-right mb-20\"><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div><!-- 버튼 영역 끝 --></div><!-- /page content --></div>");
$templateCache.put("app/eland-request/take-eval-edit.html","<div class=\"page page-footable elandCustom\" ng-controller=\"TakeEvalditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>지원신청 평가 등록</h3></div></div><div class=pagecontent><!-- 버튼 영역 --><div class=row><div class=col-md-12><div class=\"pull-right mb-5\"><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData() ng-if=\"vc.tenantId != \'0\'\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><!-- 버튼 영역 끝 --><!----------------------------------------------------------------------------------------------------><!-- 기본 정보 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>기본 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-8\"><div class=\"form-group form-inline\"><label><strong>문서제목</strong></label><input type=text class=form-control ng-model=vc.data.Title style=\"text-align: left\" readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>신청일</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.ReqDate readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>대상자명</strong></label><input type=text class=\"form-control form-right\" value=\"{{vc.data.TargetNm}} ({{vc.data.Age}}세)\" readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>지원영역</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.SupportReqNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>최종지원금액</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.FinalSptSum comma readonly></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>사례관리기관</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.TakeTenantNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>후원기관</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.GiveTenantNm readonly></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4\"><div class=\"form-group form-inline\"><label><strong>진행상태</strong></label><input type=text class=\"form-control form-right\" ng-model=vc.data.StatusNm readonly></div></div></div></div></div></div></div><!-- 기본 정보 끝 --><!----------------------------------------------------------------------------------------------------><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>지원적합률 평가</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\" rowspan=2>위기적합성<div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'0\')\">작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[0] == \'1\'\" style=position:absolute;top:70px;width:500px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'0\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>위기적합성<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><thead><tr><th>점수</th><th>기준</th></tr></thead><tbody><tr><td>0</td><td class=td-left>필요사업 대상 기준에 해당하지 않음</td></tr><tr><td>1</td><td class=td-left>위기 수준이 매우 낮아 긴급지원 필요성 낮음</td></tr><tr><td>2</td><td class=td-left>일부 어려움은 있으나 긴급지원 필요성 낮음</td></tr><tr><td>3</td><td class=td-left>위기상황은 인정되나 긴급성 또는 명확성이 보통 수준</td></tr><tr><td>4</td><td class=td-left>명확한 위기상황으로 지원 필요성이 높음</td></tr><tr><td>5</td><td class=td-left>매우 긴급하고 명백한 위기상황으로 즉각 지원 필요</td></tr></tbody></table></div><!-- tip_btn 클릭 시 나타남 --></div></th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=MoniSc1 ng-model=vc.data.MoniSc1 ng-checked=\"vc.data.MoniSc1 == \'0\'\" value=0 ng-change=vc.calc(1);> 0점</label></li><li><label><input type=radio name=MoniSc1 ng-model=vc.data.MoniSc1 ng-checked=\"vc.data.MoniSc1 == \'1\'\" value=1 ng-change=vc.calc(1);> 1점</label></li><li><label><input type=radio name=MoniSc1 ng-model=vc.data.MoniSc1 ng-checked=\"vc.data.MoniSc1 == \'2\'\" value=2 ng-change=vc.calc(1);> 2점</label></li><li><label><input type=radio name=MoniSc1 ng-model=vc.data.MoniSc1 ng-checked=\"vc.data.MoniSc1 == \'3\'\" value=3 ng-change=vc.calc(1);> 3점</label></li><li><label><input type=radio name=MoniSc1 ng-model=vc.data.MoniSc1 ng-checked=\"vc.data.MoniSc1 == \'4\'\" value=4 ng-change=vc.calc(1);> 4점</label></li><li><label><input type=radio name=MoniSc1 ng-model=vc.data.MoniSc1 ng-checked=\"vc.data.MoniSc1 == \'5\'\" value=5 ng-change=vc.calc(1);> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.MoniScTxt1></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>복지사각지대 해당 여부<div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'1\')\">작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[1] == \'1\'\" style=position:absolute;top:220px;width:700px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'1\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>복지사각지대 해당 여부<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><thead><tr><th>점수</th><th>기준</th></tr></thead><tbody><tr><td>0</td><td class=td-left>공적 안전망(기초수급/차상위 등)등로 충분히 지원받고 있는 상황</td></tr><tr><td>1</td><td class=td-left>일부 공적 지원 있으나 사각지대 요소가 소폭 존재</td></tr><tr><td>2</td><td class=td-left>공적 지원 연계 가능하나 접근 장벽 또는 일부 미연계 상태</td></tr><tr><td>3</td><td class=td-left>공적 지원과 병행이 필요한 경계 사례로 사각지대 부분 해당</td></tr><tr><td>4</td><td class=td-left>공적 안전망 밖에 있어 SOS위고 개입이 실질적으로 필요한 사각지대 사례</td></tr><tr><td>5</td><td class=td-left>공적 안전망이 전혀 닿지 않아 SOS위고만이 유일한 지원 수단인 사각지대 핵심 사례</td></tr></tbody></table></div><!-- tip_btn 클릭 시 나타남 --></div></th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=MoniSc2 ng-model=vc.data.MoniSc2 ng-checked=\"vc.data.MoniSc2 == \'0\'\" value=0 ng-change=vc.calc(1);> 0점</label></li><li><label><input type=radio name=MoniSc2 ng-model=vc.data.MoniSc2 ng-checked=\"vc.data.MoniSc2 == \'1\'\" value=1 ng-change=vc.calc(1);> 1점</label></li><li><label><input type=radio name=MoniSc2 ng-model=vc.data.MoniSc2 ng-checked=\"vc.data.MoniSc2 == \'2\'\" value=2 ng-change=vc.calc(1);> 2점</label></li><li><label><input type=radio name=MoniSc2 ng-model=vc.data.MoniSc2 ng-checked=\"vc.data.MoniSc2 == \'3\'\" value=3 ng-change=vc.calc(1);> 3점</label></li><li><label><input type=radio name=MoniSc2 ng-model=vc.data.MoniSc2 ng-checked=\"vc.data.MoniSc2 == \'4\'\" value=4 ng-change=vc.calc(1);> 4점</label></li><li><label><input type=radio name=MoniSc2 ng-model=vc.data.MoniSc2 ng-checked=\"vc.data.MoniSc2 == \'5\'\" value=5 ng-change=vc.calc(1);> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.MoniScTxt2></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>지원 시기의 적절성<div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'2\')\">작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[2] == \'1\'\" style=position:absolute;top:370px;width:500px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'2\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>지원 시기의 적절성<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><thead><tr><th>점수</th><th>기준</th></tr></thead><tbody><tr><td>0</td><td class=td-left>위기 해소 시점 이후 지원되어 실효성 없음</td></tr><tr><td>1</td><td class=td-left>지원이 지연되어 위기 심화 가능성이 높았던 상황</td></tr><tr><td>2</td><td class=td-left>다소 지연이 있었으나 위기 심화 전 지원 완료</td></tr><tr><td>3</td><td class=td-left>위기 진행 중 적절한 시기에 지원됨</td></tr><tr><td>4</td><td class=td-left>위기 초기 단계에 신속하게 개입하여 피해 확산 최소화</td></tr><tr><td>5</td><td class=td-left>위기 발생 직후 즉각 개입하여 피해 발생 전 예방적 지원 완료</td></tr></tbody></table></div><!-- tip_btn 클릭 시 나타남 --></div></th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=MoniSc3 ng-model=vc.data.MoniSc3 ng-checked=\"vc.data.MoniSc3 == \'0\'\" value=0 ng-change=vc.calc(1);> 0점</label></li><li><label><input type=radio name=MoniSc3 ng-model=vc.data.MoniSc3 ng-checked=\"vc.data.MoniSc3 == \'1\'\" value=1 ng-change=vc.calc(1);> 1점</label></li><li><label><input type=radio name=MoniSc3 ng-model=vc.data.MoniSc3 ng-checked=\"vc.data.MoniSc3 == \'2\'\" value=2 ng-change=vc.calc(1);> 2점</label></li><li><label><input type=radio name=MoniSc3 ng-model=vc.data.MoniSc3 ng-checked=\"vc.data.MoniSc3 == \'3\'\" value=3 ng-change=vc.calc(1);> 3점</label></li><li><label><input type=radio name=MoniSc3 ng-model=vc.data.MoniSc3 ng-checked=\"vc.data.MoniSc3 == \'4\'\" value=4 ng-change=vc.calc(1);> 4점</label></li><li><label><input type=radio name=MoniSc3 ng-model=vc.data.MoniSc3 ng-checked=\"vc.data.MoniSc3 == \'5\'\" value=5 ng-change=vc.calc(1);> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.MoniScTxt3></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>지원 금액 적정성<div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'3\')\">작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[3] == \'1\'\" style=position:absolute;top:510px;width:500px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'3\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>지원 금액 적정성<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><thead><tr><th>점수</th><th>기준</th></tr></thead><tbody><tr><td>0</td><td class=td-left>필요 수준과 현저히 불일치하여 과다하거나 부적절함</td></tr><tr><td>1</td><td class=td-left>금액 적정성이 매우 낮음</td></tr><tr><td>2</td><td class=td-left>일부 부적절함, 과소 또는 과다 가능성이 큼</td></tr><tr><td>3</td><td class=td-left>대체로 수용 가능하나 조정 여지 있음</td></tr><tr><td>4</td><td class=td-left>위기 수준과 필요액에 비춰 적절한 금액임</td></tr><tr><td>5</td><td class=td-left>위기 해결에 필요한 최소 충분 수준으로 매우 적정함</td></tr></tbody></table></div><!-- tip_btn 클릭 시 나타남 --></div></th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=MoniSc4 ng-model=vc.data.MoniSc4 ng-checked=\"vc.data.MoniSc4 == \'0\'\" value=0 ng-change=vc.calc(1);> 0점</label></li><li><label><input type=radio name=MoniSc4 ng-model=vc.data.MoniSc4 ng-checked=\"vc.data.MoniSc4 == \'1\'\" value=1 ng-change=vc.calc(1);> 1점</label></li><li><label><input type=radio name=MoniSc4 ng-model=vc.data.MoniSc4 ng-checked=\"vc.data.MoniSc4 == \'2\'\" value=2 ng-change=vc.calc(1);> 2점</label></li><li><label><input type=radio name=MoniSc4 ng-model=vc.data.MoniSc4 ng-checked=\"vc.data.MoniSc4 == \'3\'\" value=3 ng-change=vc.calc(1);> 3점</label></li><li><label><input type=radio name=MoniSc4 ng-model=vc.data.MoniSc4 ng-checked=\"vc.data.MoniSc4 == \'4\'\" value=4 ng-change=vc.calc(1);> 4점</label></li><li><label><input type=radio name=MoniSc4 ng-model=vc.data.MoniSc4 ng-checked=\"vc.data.MoniSc4 == \'5\'\" value=5 ng-change=vc.calc(1);> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.MoniScTxt4></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>지원항목 적합성<div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'4\')\">작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[4] == \'1\'\" style=position:absolute;top:660px;width:500px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'4\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>지원항목 적합성<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><thead><tr><th>점수</th><th>기준</th></tr></thead><tbody><tr><td>0</td><td class=td-left>지원항목이 위기해결과 관련 없음</td></tr><tr><td>1</td><td class=td-left>지원효과가 매우 낮거나 핵심 위기와 거리가 멂</td></tr><tr><td>2</td><td class=td-left>일부 도움은 가능하나 핵심 해결수단은 아님</td></tr><tr><td>3</td><td class=td-left>위기해결에 일정 부분 도움이 됨</td></tr><tr><td>4</td><td class=td-left>핵심 위기해결에 적절한 지원항목임</td></tr><tr><td>5</td><td class=td-left>핵심 위기해결에 가장 적합한 지원항목임</td></tr></tbody></table></div><!-- tip_btn 클릭 시 나타남 --></div></th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=MoniSc5 ng-model=vc.data.MoniSc5 ng-checked=\"vc.data.MoniSc5 == \'0\'\" value=0 ng-change=vc.calc(1);> 0점</label></li><li><label><input type=radio name=MoniSc5 ng-model=vc.data.MoniSc5 ng-checked=\"vc.data.MoniSc5 == \'1\'\" value=1 ng-change=vc.calc(1);> 1점</label></li><li><label><input type=radio name=MoniSc5 ng-model=vc.data.MoniSc5 ng-checked=\"vc.data.MoniSc5 == \'2\'\" value=2 ng-change=vc.calc(1);> 2점</label></li><li><label><input type=radio name=MoniSc5 ng-model=vc.data.MoniSc5 ng-checked=\"vc.data.MoniSc5 == \'3\'\" value=3 ng-change=vc.calc(1);> 3점</label></li><li><label><input type=radio name=MoniSc5 ng-model=vc.data.MoniSc5 ng-checked=\"vc.data.MoniSc5 == \'4\'\" value=4 ng-change=vc.calc(1);> 4점</label></li><li><label><input type=radio name=MoniSc5 ng-model=vc.data.MoniSc5 ng-checked=\"vc.data.MoniSc5 == \'5\'\" value=5 ng-change=vc.calc(1);> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.MoniScTxt5></textarea></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!--  --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>지원 적합 총평</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\">지원 적합 점수</th><td>{{vc.data.MoniSc}}점</td></tr><tr><th style=\"text-align: center\">지원 적합 여부</th><td>{{vc.data.MoniResult}}</td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!--  --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>사례관리 기관 평가</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\" rowspan=2>사례관리 적절성<div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'5\')\">작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[5] == \'1\'\" style=position:absolute;top:70px;width:600px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'5\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>사례관리 적절성<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><thead><tr><th>점수</th><th>기준</th></tr></thead><tbody><tr><td>0</td><td class=td-left>사례관리 미실시</td></tr><tr><td>1</td><td class=td-left>초기 확인만 하였으며 실제 상담/개입이 거의 없음</td></tr><tr><td>2</td><td class=td-left>일부 사례관리를 수행하였으나 위기상황에 비해 개입이 부족함</td></tr><tr><td>3</td><td class=td-left>기본적인 상담, 확인, 점검 등 사례관리를 수행함</td></tr><tr><td>4</td><td class=td-left>대상자의 위기상황에 맞는 적절한 사례관리를 수행함</td></tr><tr><td>5</td><td class=td-left>위기상황 분석, 맞춤형 개입, 지속 점검까지 매우 우수하게 수행함</td></tr></tbody></table></div><!-- tip_btn 클릭 시 나타남 --></div></th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=TakeTenantSc1 ng-model=vc.data.TakeTenantSc1 ng-checked=\"vc.data.TakeTenantSc1 == \'0\'\" value=0 ng-change=vc.calc(2);> 0점</label></li><li><label><input type=radio name=TakeTenantSc1 ng-model=vc.data.TakeTenantSc1 ng-checked=\"vc.data.TakeTenantSc1 == \'1\'\" value=1 ng-change=vc.calc(2);> 1점</label></li><li><label><input type=radio name=TakeTenantSc1 ng-model=vc.data.TakeTenantSc1 ng-checked=\"vc.data.TakeTenantSc1 == \'2\'\" value=2 ng-change=vc.calc(2);> 2점</label></li><li><label><input type=radio name=TakeTenantSc1 ng-model=vc.data.TakeTenantSc1 ng-checked=\"vc.data.TakeTenantSc1 == \'3\'\" value=3 ng-change=vc.calc(2);> 3점</label></li><li><label><input type=radio name=TakeTenantSc1 ng-model=vc.data.TakeTenantSc1 ng-checked=\"vc.data.TakeTenantSc1 == \'4\'\" value=4 ng-change=vc.calc(2);> 4점</label></li><li><label><input type=radio name=TakeTenantSc1 ng-model=vc.data.TakeTenantSc1 ng-checked=\"vc.data.TakeTenantSc1 == \'5\'\" value=5 ng-change=vc.calc(2);> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.TakeTenantScTxt1></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>결과보고 충실도<div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'6\')\">작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[6] == \'1\'\" style=position:absolute;top:220px;width:700px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'6\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>결과보고 충실도<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><thead><tr><th>점수</th><th>기준</th></tr></thead><tbody><tr><td>0</td><td class=td-left>결과보고 미제출</td></tr><tr><td>1</td><td class=td-left>결과보고를 제출했으나 내용이 매우 부실하고 필수항목이 다수 누락됨</td></tr><tr><td>2</td><td class=td-left>결과보고는 제출했으나 내용, 증빙, 변화기록이 일부 부족함</td></tr><tr><td>3</td><td class=td-left>기본적인 결과보고를 제출하였으며 필수사항을 대체로 충족함</td></tr><tr><td>4</td><td class=td-left>결과보고 내용이 충실하고 지원 결과 및 대상자 변화가 비교적 구체적으로 기록됨</td></tr><tr><td>5</td><td class=td-left>결과보고가 매우 충실하며 증빙, 변화내용, 향후 계획까지 명확하게 기록됨</td></tr></tbody></table></div><!-- tip_btn 클릭 시 나타남 --></div></th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=TakeTenantSc2 ng-model=vc.data.TakeTenantSc2 ng-checked=\"vc.data.TakeTenantSc2 == \'0\'\" value=0 ng-change=vc.calc(2);> 0점</label></li><li><label><input type=radio name=TakeTenantSc2 ng-model=vc.data.TakeTenantSc2 ng-checked=\"vc.data.TakeTenantSc2 == \'1\'\" value=1 ng-change=vc.calc(2);> 1점</label></li><li><label><input type=radio name=TakeTenantSc2 ng-model=vc.data.TakeTenantSc2 ng-checked=\"vc.data.TakeTenantSc2 == \'2\'\" value=2 ng-change=vc.calc(2);> 2점</label></li><li><label><input type=radio name=TakeTenantSc2 ng-model=vc.data.TakeTenantSc2 ng-checked=\"vc.data.TakeTenantSc2 == \'3\'\" value=3 ng-change=vc.calc(2);> 3점</label></li><li><label><input type=radio name=TakeTenantSc2 ng-model=vc.data.TakeTenantSc2 ng-checked=\"vc.data.TakeTenantSc2 == \'4\'\" value=4 ng-change=vc.calc(2);> 4점</label></li><li><label><input type=radio name=TakeTenantSc2 ng-model=vc.data.TakeTenantSc2 ng-checked=\"vc.data.TakeTenantSc2 == \'5\'\" value=5 ng-change=vc.calc(2);> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.TakeTenantScTxt2></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>외부자원연계 적극성<div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'7\')\">작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[7] == \'1\'\" style=position:absolute;top:370px;width:600px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'7\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>외부자원연계 적극성<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><thead><tr><th>점수</th><th>기준</th></tr></thead><tbody><tr><td>0</td><td class=td-left>외부자원 연계 시도 없음</td></tr><tr><td>1</td><td class=td-left>외부자원 연계 필요성이 있음에도 연계 노력이 거의 없음</td></tr><tr><td>2</td><td class=td-left>일부 자원 탐색 또는 제한적 연계 시도가 있었음</td></tr><tr><td>3</td><td class=td-left>기본적인 외부자원 탐색 및 연계를 수행함</td></tr><tr><td>4</td><td class=td-left>대상자 상황에 맞는 외부자원을 적극적으로 연계함</td></tr><tr><td>5</td><td class=td-left>공공/민간 자원을 다각도로 연계하여 위기해결 가능성을 크게 높임</td></tr></tbody></table></div><!-- tip_btn 클릭 시 나타남 --></div></th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=TakeTenantSc3 ng-model=vc.data.TakeTenantSc3 ng-checked=\"vc.data.TakeTenantSc3 == \'0\'\" value=0 ng-change=vc.calc(2);> 0점</label></li><li><label><input type=radio name=TakeTenantSc3 ng-model=vc.data.TakeTenantSc3 ng-checked=\"vc.data.TakeTenantSc3 == \'1\'\" value=1 ng-change=vc.calc(2);> 1점</label></li><li><label><input type=radio name=TakeTenantSc3 ng-model=vc.data.TakeTenantSc3 ng-checked=\"vc.data.TakeTenantSc3 == \'2\'\" value=2 ng-change=vc.calc(2);> 2점</label></li><li><label><input type=radio name=TakeTenantSc3 ng-model=vc.data.TakeTenantSc3 ng-checked=\"vc.data.TakeTenantSc3 == \'3\'\" value=3 ng-change=vc.calc(2);> 3점</label></li><li><label><input type=radio name=TakeTenantSc3 ng-model=vc.data.TakeTenantSc3 ng-checked=\"vc.data.TakeTenantSc3 == \'4\'\" value=4 ng-change=vc.calc(2);> 4점</label></li><li><label><input type=radio name=TakeTenantSc3 ng-model=vc.data.TakeTenantSc3 ng-checked=\"vc.data.TakeTenantSc3 == \'5\'\" value=5 ng-change=vc.calc(2);> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.TakeTenantScTxt3></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>위기대응 신속성<div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'8\')\">작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[8] == \'1\'\" style=position:absolute;top:510px;width:500px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'8\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>위기대응 신속성<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><thead><tr><th>점수</th><th>기준</th></tr></thead><tbody><tr><td>0</td><td class=td-left>대응 없음</td></tr><tr><td>1</td><td class=td-left>초기 대응이 매우 지연됨</td></tr><tr><td>2</td><td class=td-left>대응은 있었으나 긴급지원 기준상 다소 지연됨</td></tr><tr><td>3</td><td class=td-left>일반적인 수준으로 대응함</td></tr><tr><td>4</td><td class=td-left>비교적 신속하게 대응함</td></tr><tr><td>5</td><td class=td-left>위기 접수 직후 매우 신속하게 대응함</td></tr></tbody></table></div><!-- tip_btn 클릭 시 나타남 --></div></th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=TakeTenantSc4 ng-model=vc.data.TakeTenantSc4 ng-checked=\"vc.data.TakeTenantSc4 == \'0\'\" value=0 ng-change=vc.calc(2);> 0점</label></li><li><label><input type=radio name=TakeTenantSc4 ng-model=vc.data.TakeTenantSc4 ng-checked=\"vc.data.TakeTenantSc4 == \'1\'\" value=1 ng-change=vc.calc(2);> 1점</label></li><li><label><input type=radio name=TakeTenantSc4 ng-model=vc.data.TakeTenantSc4 ng-checked=\"vc.data.TakeTenantSc4 == \'2\'\" value=2 ng-change=vc.calc(2);> 2점</label></li><li><label><input type=radio name=TakeTenantSc4 ng-model=vc.data.TakeTenantSc4 ng-checked=\"vc.data.TakeTenantSc4 == \'3\'\" value=3 ng-change=vc.calc(2);> 3점</label></li><li><label><input type=radio name=TakeTenantSc4 ng-model=vc.data.TakeTenantSc4 ng-checked=\"vc.data.TakeTenantSc4 == \'4\'\" value=4 ng-change=vc.calc(2);> 4점</label></li><li><label><input type=radio name=TakeTenantSc4 ng-model=vc.data.TakeTenantSc4 ng-checked=\"vc.data.TakeTenantSc4 == \'5\'\" value=5 ng-change=vc.calc(2);> 5점</label></li></ul></td></tr><tr><td><textarea rows=3 class=form-control ng-model=vc.data.TakeTenantScTxt4></textarea></td></tr><tr><th style=\"text-align: center\">최종점수</th><td>{{vc.data.TakeTenantSc}}점</td></tr><tr><th style=\"text-align: center\">기관평가</th><td>{{vc.data.TakeTenantGradeNm}}</td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!--  --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>우수사례</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\">우수사례 여부</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=BestYN ng-model=vc.data.BestYN ng-checked=\"vc.data.BestYN == \'Y\'\" value=Y> 적합</label></li><li><label><input type=radio name=BestYN ng-model=vc.data.BestYN ng-checked=\"vc.data.BestYN == \'N\'\" value=N> 부적합</label></li></ul></td></tr></tbody></table></div></div></div></div><!-- 버튼 영역 --><div class=\"pull-right mb-20\"><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData() ng-if=\"vc.tenantId != \'0\'\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div><!-- 버튼 영역 끝 --></div><!-- /page content --></div>");
$templateCache.put("app/eland-request/take-list.html","<div class=\"page page-footable\" ng-controller=\"TakeListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{vc.title}}</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=\"row shop-view\"><div class=\"col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.TargetNm placeholder=\"대상자 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer(770)\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr title={{vc.SearchConditionStrPlain}}></span><!-- 상세검색 창 --><div class=\"search-detail-wrap search-detail-scroll\" style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><!-- 검색 대상 컬럼  --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.tenantType != \'TAKETENANT\'\"><div class=\"form-group form-inline checkbox-wrap\"><label>세대유형</label><div class=input-group><div class=\"srch-checkbox-inline col-lg-4\" ng-repeat=\"(index, li) in vc.columnMap[\'GenType\'].CodeList\"><label class=custom-checkbox-btn><input type=checkbox ng-model=vc.srch.GenType[index] ng-true-value=\"\'{{li.Code}}\'\" ng-false-value=0 ng-checked=\"vc.srch.GenType[index] == li.Code\"> <span class=helping-el></span> <span class=label-text ng-bind=li.CodeValue></span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.tenantType != \'TAKETENANT\'\"><div class=\"form-group form-inline checkbox-wrap\"><label>보호구분</label><div class=input-group><div class=\"srch-checkbox-inline col-lg-4\" ng-repeat=\"(index, li) in vc.columnMap[\'ProtType\'].CodeList\"><label class=custom-checkbox-btn><input type=checkbox ng-model=vc.srch.ProtType[index] ng-true-value=\"\'{{li.Code}}\'\" ng-false-value=0 ng-checked=\"vc.srch.ProtType[index] == li.Code\"> <span class=helping-el></span> <span class=label-text ng-bind=li.CodeValue></span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.tenantType != \'TAKETENANT\'\"><div class=\"form-group form-inline checkbox-wrap\"><label>의료보장</label><div class=input-group><div class=\"srch-checkbox-inline col-lg-4\" ng-repeat=\"(index, li) in vc.columnMap[\'HealthIndem\'].CodeList\"><label class=custom-checkbox-btn><input type=checkbox ng-model=vc.srch.HealthIndem[index] ng-true-value=\"\'{{li.Code}}\'\" ng-false-value=0 ng-checked=\"vc.srch.HealthIndem[index] == li.Code\"> <span class=helping-el></span> <span class=label-text ng-bind=li.CodeValue></span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.tenantType != \'TAKETENANT\'\"><div class=\"form-group form-inline checkbox-wrap\"><label>신청영역</label><div class=input-group><div class=\"srch-checkbox-inline col-lg-4\"><label class=custom-checkbox-btn><input type=checkbox ng-model=vc.srch.SupportReq01 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.srch.SupportReq01 == \'1\'\"> <span class=helping-el></span> <span class=label-text>주거비</span></label></div><div class=\"srch-checkbox-inline col-lg-4\"><label class=custom-checkbox-btn><input type=checkbox ng-model=vc.srch.SupportReq02 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.srch.SupportReq02 == \'1\'\"> <span class=helping-el></span> <span class=label-text>생계비</span></label></div><div class=\"srch-checkbox-inline col-lg-4\"><label class=custom-checkbox-btn><input type=checkbox ng-model=vc.srch.SupportReq04 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.srch.SupportReq04 == \'1\'\"> <span class=helping-el></span> <span class=label-text>치료비</span></label></div><div class=\"srch-checkbox-inline col-lg-4\"><label class=custom-checkbox-btn><input type=checkbox ng-model=vc.srch.SupportReq03 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.srch.SupportReq03 == \'1\'\"> <span class=helping-el></span> <span class=label-text>자립비</span></label></div><div class=\"srch-checkbox-inline col-lg-4\"><label class=custom-checkbox-btn><input type=checkbox ng-model=vc.srch.SupportReq05 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.srch.SupportReq05 == \'1\'\"> <span class=helping-el></span> <span class=label-text>기타</span></label></div><div class=\"srch-checkbox-inline col-lg-4\"><label class=custom-checkbox-btn><input type=checkbox ng-model=vc.srch.SupportReq06 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.srch.SupportReq06 == \'1\'\"> <span class=helping-el></span> <span class=label-text>물품지원</span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.tenantType != \'TAKETENANT\'\"><div class=\"form-group form-inline checkbox-wrap\"><label>주거형태</label><div class=input-group><div class=\"srch-checkbox-inline col-lg-4\" ng-repeat=\"(index, li) in vc.columnMap[\'HousType\'].CodeList\"><label class=custom-checkbox-btn><input type=checkbox ng-model=vc.srch.HousType[index] ng-true-value=\"\'{{li.Code}}\'\" ng-false-value=0 ng-checked=\"vc.srch.HousType[index] == li.Code\"> <span class=helping-el></span> <span class=label-text ng-bind=li.CodeValue></span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Status\'] && [undefined,null,\'\'].includes(vc.status)\"><div class=\"form-group form-inline checkbox-wrap\"><label>진행상태</label><div class=input-group><div class=\"srch-checkbox-inline col-lg-4\" ng-repeat=\"(index, li) in vc.columnMap[\'Status\'].CodeList\"><label class=custom-checkbox-btn><input type=checkbox ng-model=vc.srch.ChkStatus[index] ng-true-value=\"\'{{li.Code}}\'\" ng-false-value=0 ng-checked=\"vc.srch.ChkStatus[index] == li.Code\"> <span class=helping-el></span> <span class=label-text ng-bind=li.CodeValue></span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-12 col-xl-4\" ng-if=\"vc.tenantType != \'TAKETENANT\'\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ImpairYN\'].CodeList\" code-model=vc.srch.ImpairYN></common-code-custom><label>{{vc.columnMap[\'ImpairYN\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-12 col-xl-4\" ng-if=\"vc.tenantType != \'TAKETENANT\'\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'RiskTime\'].CodeList\" code-model=vc.srch.RiskTime></common-code-custom><label>{{vc.columnMap[\'RiskTime\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-12 col-xl-4\" ng-if=\"vc.tenantType != \'TAKETENANT\'\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'WorkStat\'].CodeList\" code-model=vc.srch.WorkStat></common-code-custom><label>{{vc.columnMap[\'WorkStat\'].ColumnLogicalNm | translate}}</label></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-12 col-xl-4\" ng-if=\"vc.columnMap[\'TargetNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.TargetNm type=text><label>{{vc.columnMap[\'TargetNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-12 col-xl-4\" ng-if=\"vc.columnMap[\'TakeTenantNm\'] && vc.tenantType != \'TAKETENANT\'\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.TakeTenantNm type=text><label>{{vc.columnMap[\'TakeTenantNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-12 col-xl-4\"><div class=\"form-group form-inner-label\"><select class=form-control ng-model=vc.srch.BestYN><option value=\"\">-- 선택 --</option><option value=Y>적합</option><option value=N>부적합</option></select><label>우수사례여부</label></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-12 col-xl-4\" ng-if=\"vc.columnMap[\'ReqDateFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.ReqDateFrom = (vc.ReqDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.ReqDateFrom ng-required=false placeholder=\"{{vc.columnMap[\'ReqDateFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-12 col-xl-4\" ng-if=\"vc.columnMap[\'ReqDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.ReqDateTo = (vc.ReqDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.ReqDateTo ng-required=false placeholder=\"{{vc.columnMap[\'ReqDateTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-12 col-xl-4\" ng-if=\"vc.columnMap[\'ParCityCode\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ParCityCode\'].CodeList\" code-model=vc.srch.ParCityCode ng-change=vc.chgParCityCode(vc.srch.ParCityCode)></common-code-custom><label>{{vc.columnMap[\'ParCityCode\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-12 col-xl-4\" ng-if=\"vc.columnMap[\'CityCode\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=vc.CityCodeList code-model=vc.srch.CityCode></common-code-custom><label>{{vc.columnMap[\'CityCode\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-4 col-xg-12 col-xl-4\" ng-if=\"vc.columnMap[\'CityCode\']\"><div class=\"form-group form-inner-label\"><button class=\"btn btn-default\" ng-click=vc.selCityCode(vc.srch.CityCode) type=button><i class=\"glyphicon glyphicon-plus\"></i> 지역추가</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><ul class=\"ul_h li_mr15 mt-10\"><li ng-repeat=\"(index, li) in vc.srch.selCityCodeList\"><label>[{{li.pName}} {{li.cName}}<span ng-click=vc.delCityCode(index)><i class=\"fa fa-times fa-lg\"></i></span>]</label></li></ul></div></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=pull-right><button class=\"btn btn-default mobile-none\" ng-click=vc.getExcel() ng-if=vc.isAdminSH><i class=\"fa fa-file-excel-o\"></i> 데이터 추출</button> <button class=\"btn btn-default mobile-none\" ng-click=vc.printTake()><i class=\"fa fa-print\"></i> 출력</button> <button class=\"btn btn-primary\" ng-click=vc.goTakeAdd() ng-if=\"vc.tenantType != \'GIVETENANT\' && [undefined,null,\'\'].includes(vc.status)\"><i class=\"fa fa-edit\"></i> 신청하기</button> <button class=\"btn btn-danger\" ng-click=vc.setDelList() ng-if=\"vc.tenantType != \'GIVETENANT\' && [undefined,null,\'\'].includes(vc.status)\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom mobile-none\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- NO DATA --><div ng-if=\"vc.totalItems == 0\"><div class=text-center style=\"padding: 3px; border: 1px solid #ddd; line-height:1.42857143; background:#f9f9f9\">{{ \'MSG.NO_DATA\' | translate }}</div></div><!-- /NO DATA --><!-- Header --><thead ng-if=\"vc.totalItems > 0\"><tr><!-- 체크박스(헤더) --><th class=text-center style=\"vertical-align:middle; width: 3%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg() id=chkHead><label for=chkHead></label></th><!-- 1.최종제출일(헤더) --><th ng-if=vc.v01 class=\"text-center {{vc.columnMap[\'ReqDate\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'ReqDate\'].ColumnPhysicalNm, vc.columnMap[\'ReqDate\'].KeyColumnYN)\" style=\"width: {{vc.columnMap[\'ReqDate\'].ListColumnWidth}}\" role=button tabindex=0>{{ :: vc.columnMap[\'ReqDate\'].ColumnLogicalNm | translate }} <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'ReqDate\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 2.지역(헤더) --><th ng-if=vc.v02 class=\"text-center {{vc.columnMap[\'CityName\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'CityName\'].ColumnPhysicalNm, vc.columnMap[\'CityName\'].KeyColumnYN)\" style=\"width: {{vc.columnMap[\'ReqDate\'].ListColumnWidth}}\" role=button tabindex=0>{{ :: vc.columnMap[\'CityName\'].ColumnLogicalNm | translate }} <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'CityName\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 3.사례기관(헤더) --><th ng-if=vc.v03 class=\"text-center {{vc.columnMap[\'TakeTenantNm\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'TakeTenantNm\'].ColumnPhysicalNm, vc.columnMap[\'TakeTenantNm\'].KeyColumnYN)\" style=\"width: {{vc.columnMap[\'TakeTenantNm\'].ListColumnWidth}}\" role=button tabindex=0>{{ :: vc.columnMap[\'TakeTenantNm\'].ColumnLogicalNm | translate }} <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'TakeTenantNm\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 4.현장확인(헤더) --><th ng-if=vc.v04 class=\"text-center {{vc.columnMap[\'SiteVeriftYN\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'SiteVeriftYN\'].ColumnPhysicalNm, vc.columnMap[\'SiteVeriftYN\'].KeyColumnYN)\" style=\"width: {{vc.columnMap[\'SiteVeriftYN\'].ListColumnWidth}}\" role=button tabindex=0>{{ :: vc.columnMap[\'SiteVeriftYN\'].ColumnLogicalNm | translate }} <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'SiteVeriftYN\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 5.대상자명(헤더) --><th g-if=vc.v05 class=\"text-center {{vc.columnMap[\'TargetNm\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'TargetNm\'].ColumnPhysicalNm, vc.columnMap[\'TargetNm\'].KeyColumnYN)\" style=\"width: {{vc.columnMap[\'TargetNm\'].ListColumnWidth}}\" role=button tabindex=0>{{ :: vc.columnMap[\'TargetNm\'].ColumnLogicalNm | translate }} <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'TargetNm\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 6.제목(헤더) --><th g-if=vc.v06 class=\"text-center {{vc.columnMap[\'Title\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'Title\'].ColumnPhysicalNm, vc.columnMap[\'Title\'].KeyColumnYN)\" style=\"width: {{vc.columnMap[\'Title\'].ListColumnWidth}}\" role=button tabindex=0>{{ :: vc.columnMap[\'Title\'].ColumnLogicalNm | translate }} <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'Title\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 7.생년월일(헤더) --><th ng-if=vc.v07 class=\"text-center {{vc.columnMap[\'BirthDay\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'BirthDay\'].ColumnPhysicalNm, vc.columnMap[\'BirthDay\'].KeyColumnYN)\" style=\"width: {{vc.columnMap[\'BirthDay\'].ListColumnWidth}}\" role=button tabindex=0>{{ :: vc.columnMap[\'BirthDay\'].ColumnLogicalNm | translate }} <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'BirthDay\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 8.지원요청영역(헤더) --><th ng-if=vc.v08 class=\"text-center {{vc.columnMap[\'SupportReq\'].ListColumnShowLevel}}\" data-toggle=true style=\"width: {{vc.columnMap[\'SupportReq\'].ListColumnWidth}}\" role=button tabindex=0>{{ :: vc.columnMap[\'SupportReqNm\'].ColumnLogicalNm | translate }}</th><!-- 9.관심기관수(헤더) --><th ng-if=vc.v09 class=\"text-center {{vc.columnMap[\'GiveTenantCnt\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'GiveTenantCnt\'].ColumnPhysicalNm, vc.columnMap[\'GiveTenantCnt\'].KeyColumnYN)\" style=\"width: {{vc.columnMap[\'GiveTenantCnt\'].ListColumnWidth}}\" role=button tabindex=0>{{ :: vc.columnMap[\'GiveTenantCnt\'].ColumnLogicalNm | translate }} <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'GiveTenantCnt\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 10.지원확정일자(헤더) --><th ng-if=vc.v10 class=\"text-center {{vc.columnMap[\'ApplyCmpDate\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'ApplyCmpDate\'].ColumnPhysicalNm, vc.columnMap[\'ApplyCmpDate\'].KeyColumnYN)\" style=\"width: {{vc.columnMap[\'ApplyCmpDate\'].ListColumnWidth}}\" role=button tabindex=0>{{ :: vc.columnMap[\'ApplyCmpDate\'].ColumnLogicalNm | translate }} <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'ApplyCmpDate\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 11.후원기관(헤더) --><th ng-if=vc.v11 class=\"text-center {{vc.columnMap[\'GiveTenantNm\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'GiveTenantNm\'].ColumnPhysicalNm, vc.columnMap[\'GiveTenantNm\'].KeyColumnYN)\" style=\"width: {{vc.columnMap[\'GiveTenantNm\'].ListColumnWidth}}\" role=button tabindex=0>{{ :: vc.columnMap[\'GiveTenantNm\'].ColumnLogicalNm | translate }} <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'GiveTenantNm\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 12.진행상태(헤더) --><th ng-if=vc.v12 style=\"width: {{vc.columnMap[\'StatusNm\'].ListColumnWidth}}\" class=\"text-center {{vc.columnMap[\'StatusNm\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'StatusNm\'].ColumnPhysicalNm, vc.columnMap[\'StatusNm\'].KeyColumnYN)\" role=button tabindex=0>{{ :: vc.columnMap[\'StatusNm\'].ColumnLogicalNm | translate }} <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'StatusNm\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 13.나의진행상태(헤더) --><th ng-if=vc.v13 class=\"text-center {{vc.columnMap[\'MyStatusNm\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'MyStatusNm\'].ColumnPhysicalNm, vc.columnMap[\'MyStatusNm\'].KeyColumnYN)\" style=\"width: {{vc.columnMap[\'MyStatusNm\'].ListColumnWidth}}\" role=button tabindex=0>나의진행상태 <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'MyStatusNm\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 14.결과보고완료일(헤더) --><th ng-if=vc.v14 class=\"text-center {{vc.columnMap[\'RptDate\'].ListColumnShowLevel}}\" data-toggle=true ng-click=\"vc.setSortColumn(\'T.\'+vc.columnMap[\'RptDate\'].ColumnPhysicalNm, vc.columnMap[\'RptDate\'].KeyColumnYN)\" style=\"width: {{vc.columnMap[\'RptDate\'].ListColumnWidth}}\" role=button tabindex=0>{{ :: vc.columnMap[\'RptDate\'].ColumnLogicalNm | translate }} <span class=\"fa fa-sort\" ng-show=\"vc.columnMap[\'RptDate\'].KeyColumnYN == \'Y\'\" aria-hidden=false></span></th><!-- 15.결과보고(헤더) --><th ng-if=\"vc.v15 && (vc.tenantId != \'0\' || (vc.loginUserAdminType == \'B\'))\" class=text-center style=\"width: 10%\">결과보고</th><!-- 16.모니터링(헤더) --><th ng-if=vc.v16 class=text-center style=\"width: 6%\">모니터링</th><!-- 17.모니터링평가(헤더) --><th ng-if=vc.v17 class=text-center style=\"width: 10%\">평가</th><!-- 18.우수사례(헤더) --><th ng-if=vc.v18 class=text-center style=\"width: 10%\">우수사례</th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.keyId}\"><!-- 체크박스(목록) --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg() id={{li.keyId}}><label for={{li.keyId}}></label></td><!-- 1.최종제출일(목록) --><td ng-if=vc.v01 class=\"{{vc.columnMap[\'ReqDate\'].ListColumnTextAlign}} {{vc.columnMap[\'ReqDate\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span>{{li[vc.columnMap[\'ReqDate\'].ColumnPhysicalNm] | date:\'yyyy-MM-dd\'}}</span></td><!-- 2.지역(목록) --><td ng-if=vc.v02 class=\"{{vc.columnMap[\'CityName\'].ListColumnTextAlign}} {{vc.columnMap[\'CityName\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span>{{li[vc.columnMap[\'CityName\'].ColumnPhysicalNm]}}</span></td><!-- 3.사례기관(목록) --><td ng-if=vc.v03 class=\"{{vc.columnMap[\'TakeTenantNm\'].ListColumnTextAlign}} {{vc.columnMap[\'TakeTenantNm\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span>{{li[vc.columnMap[\'TakeTenantNm\'].ColumnPhysicalNm]}}</span></td><!-- 4.현장확인(목록) --><td ng-if=vc.v04 class=\"{{vc.columnMap[\'SiteVeriftYN\'].ListColumnTextAlign}} {{vc.columnMap[\'SiteVeriftYN\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span>{{li[vc.columnMap[\'SiteVeriftYN\'].ColumnPhysicalNm]}}</span></td><!-- 5.대상자명(목록) --><td ng-if=vc.v05 class=\"{{vc.columnMap[\'TargetNm\'].ListColumnTextAlign}} {{vc.columnMap[\'TargetNm\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && li.TargetNmView_YN == \'Y\')\">{{li[vc.columnMap[\'TargetNm\'].ColumnPhysicalNm]}}</span> <span ng-if=\"vc.tenantType == \'GIVETENANT\' && li.TargetNmView_YN == \'N\'\">{{li.TargetNm_}}</span></td><!-- 6.제목(목록) --><td ng-if=vc.v06 class=\"{{vc.columnMap[\'Title\'].ListColumnTextAlign}} {{vc.columnMap[\'Title\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span>{{li[vc.columnMap[\'Title\'].ColumnPhysicalNm]}}</span></td><!-- 7.생년월일(목록) --><td ng-if=vc.v07 class=\"{{vc.columnMap[\'BirthDay\'].ListColumnTextAlign}} {{vc.columnMap[\'BirthDay\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span>{{li[vc.columnMap[\'BirthDay\'].ColumnPhysicalNm] | date:\'yyyy-MM-dd\'}}</span></td><!-- 8.지원요청영역(목록) --><td ng-if=vc.v08 class=\"{{vc.columnMap[\'SupportReq\'].ListColumnTextAlign}} {{vc.columnMap[\'SupportReq\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span>{{li[vc.columnMap[\'SupportReq\'].ColumnPhysicalNm]}}</span></td><!-- 9.관심기관수(목록) --><td ng-if=vc.v09 class=\"{{vc.columnMap[\'GiveTenantCnt\'].ListColumnTextAlign}} {{vc.columnMap[\'GiveTenantCnt\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span>{{li[vc.columnMap[\'GiveTenantCnt\'].ColumnPhysicalNm]}}</span></td><!-- 10.지원확정일자(목록) --><td ng-if=vc.v10 class=\"{{vc.columnMap[\'ApplyCmpDate\'].ListColumnTextAlign}} {{vc.columnMap[\'ApplyCmpDate\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span>{{li[vc.columnMap[\'ApplyCmpDate\'].ColumnPhysicalNm] | date:\'yyyy-MM-dd\'}}</span></td><!-- 11.후원기관(목록) --><td ng-if=vc.v11 class=\"{{vc.columnMap[\'GiveTenantNm\'].ListColumnTextAlign}} {{vc.columnMap[\'GiveTenantNm\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span ng-repeat=\"sub in li.GiveTenantList\">{{sub}}<br></span></td><!-- 12.진행상태(목록) --><td ng-if=vc.v12 class=\"{{vc.columnMap[\'StatusNm\'].ListColumnTextAlign}} {{vc.columnMap[\'StatusNm\'].ListColumnShowLevel}}\"><span>{{li[vc.columnMap[\'StatusNm\'].ColumnPhysicalNm]}}</span><span ng-if=\"li.ResultStatus == \'RETN\'\">[반려]</span> <button ng-if=\"[\'RC\',\'MC\'].includes(li.Status) && vc.tenantId == 0 && [\'SAVE\'].includes(li.ResultStatus)\" class=\"btn btn-primary\" ng-click=vc.goResultDetail(li.keyId)>결과보고보기</button></td><!-- 13.나의진행상태(목록) --><td ng-if=vc.v13 class=\"{{vc.columnMap[\'MyStatusNm\'].ListColumnTextAlign}} {{vc.columnMap[\'MyStatusNm\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span>{{li[vc.columnMap[\'MyStatusNm\'].ColumnPhysicalNm]}}</span><span ng-if=\"li.ResultStatus == \'RETN\'\">[반려]</span></td><!-- 14.결과보고완료일(목록) --><td ng-if=vc.v14 class=\"{{vc.columnMap[\'RptDate\'].ListColumnTextAlign}} {{vc.columnMap[\'RptDate\'].ListColumnShowLevel}}\" ng-click=vc.goTakeDetail(li.keyId)><span>{{li[vc.columnMap[\'RptDate\'].ColumnPhysicalNm] | date:\'yyyy-MM-dd\'}}</span></td><!-- 15.결과보고(목록) --><td ng-if=\"vc.v15 && (vc.tenantId != 0 || (li.RegUserYN == \'Y\' && vc.loginUserAdminType == \'B\'))\" class=text-center><button ng-if=\"[\'RW\',\'SP\',\'MC\'].includes(li.Status) && (vc.tenantType == \'TAKETENANT\' || (li.RegUserYN == \'Y\' && vc.loginUserAdminType == \'B\')) && ([undefined,null,\'\'].includes(li.ResultReportId) || [\'TEMP\',\'RETN\'].includes(li.ResultStatus))\" class=\"btn btn-primary\" ng-click=vc.goResultAdd(li.keyId)>결과보고작성</button> <button ng-if=\" ![undefined,null,\'\'].includes(li.ResultReportId) && [\'SAVE\'].includes(li.ResultStatus)\" class=\"btn btn-primary\" ng-click=vc.goResultDetail(li.keyId)>결과보고보기</button></td><!-- 16.모니터링(목록) --><td ng-if=vc.v16 class=text-center>{{li.MoniDate}}</td><!-- 17.모니터링평가(목록) --><td ng-if=vc.v17 class=text-center><button ng-if=\"[\'MC\',\'RC\'].includes(li.Status) && ![undefined,null,\'\'].includes(li.EvaluateId)\" class=\"btn btn-primary\" ng-click=vc.goEvalDetail(li.keyId)><span>조회</span></button> <button class=\"btn btn-primary\" ng-click=vc.goEvalAdd(li.keyId)><span ng-if=\"[undefined,null,\'\'].includes(li.EvaluateId)\">등록</span> <span ng-if=\"![undefined,null,\'\'].includes(li.EvaluateId)\">수정</span></button></td><!-- 18.우수사례(헤더) --><td ng-if=vc.v18 class=text-center><button ng-if=\"li.BestYN == \'Y\' && ![undefined,null,\'\'].includes(li.BestCaseId)\" class=\"btn btn-primary\" ng-click=vc.goBestDetail(li.keyId)><span>조회</span></button> <button ng-if=\"li.BestYN == \'Y\'\" class=\"btn btn-primary\" ng-click=vc.goBestAdd(li.keyId)><span ng-if=\"[undefined,null,\'\'].includes(li.BestCaseId)\">등록</span> <span ng-if=\"![undefined,null,\'\'].includes(li.BestCaseId)\">수정</span></button></td></tr></tbody></table><div class=pc-none><ul class=list-card-wrap ng-if=\"vc.totalItems > 0\"><li class=list-card ng-repeat=\"li in vc.lists\"><a class=list-card__list><div class=list-card__title><div class=list-card__info ng-click=vc.goTakeDetail(li.keyId)><p class=list-card__name><span ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && li.TargetNmView_YN == \'Y\')\">{{li[vc.columnMap[\'TargetNm\'].ColumnPhysicalNm]}}</span> <span ng-if=\"vc.tenantType == \'GIVETENANT\' && li.TargetNmView_YN == \'N\'\">{{li.TargetNm_}}</span></p><p class=list-card__center ng-if=\"vc.tenantType != \'TAKETENANT\'\">{{li[vc.columnMap[\'TakeTenantNm\'].ColumnPhysicalNm]}}</p></div><div class=list-card__result><span class=list-card__progress ng-if=vc.v12>{{li[vc.columnMap[\'StatusNm\'].ColumnPhysicalNm]}}</span> <span ng-if=\"li.ResultStatus == \'RETN\'\">[반려]</span><div ng-if=\"vc.v12 && [\'RC\',\'MC\'].includes(li.Status) && vc.tenantId == 0 && [\'SAVE\'].includes(li.ResultStatus) && ! (li.RegUserYN == \'Y\' && vc.loginUserAdminType == \'B\')\"><button class=\"btn btn-primary list-card__button\" ng-click=vc.goResultDetail(li.keyId)>결과보고보기</button></div><div ng-if=\"vc.v15 && (vc.tenantId != 0 || (li.RegUserYN == \'Y\' && vc.loginUserAdminType == \'B\'))\"><button ng-if=\"[\'RW\',\'SP\',\'MC\'].includes(li.Status) && (vc.tenantType == \'TAKETENANT\' || (li.RegUserYN == \'Y\' && vc.loginUserAdminType == \'B\')) && ([undefined,null,\'\'].includes(li.ResultReportId) || [\'TEMP\',\'RETN\'].includes(li.ResultStatus))\" class=\"btn btn-primary list-card__button\" ng-click=vc.goResultAdd(li.keyId)>결과보고작성</button> <button ng-if=\" ![undefined,null,\'\'].includes(li.ResultReportId) && [\'SAVE\'].includes(li.ResultStatus)\" class=\"btn btn-primary list-card__button\" ng-click=vc.goResultDetail(li.keyId)>결과보고보기</button></div><div ng-if=vc.v17><button ng-if=\"[\'MC\',\'RC\'].includes(li.Status) && ![undefined,null,\'\'].includes(li.EvaluateId)\" class=\"btn btn-primary\" ng-click=vc.goEvalDetail(li.keyId)><span>평가조회</span></button> <button class=\"btn btn-primary\" ng-click=vc.goEvalAdd(li.keyId)><span ng-if=\"[undefined,null,\'\'].includes(li.EvaluateId)\">평가등록</span> <span ng-if=\"![undefined,null,\'\'].includes(li.EvaluateId)\">수정</span></button></div><div ng-if=vc.v18><button ng-if=\"li.BestYN == \'Y\' && ![undefined,null,\'\'].includes(li.BestCaseId)\" class=\"btn btn-primary\" ng-click=vc.goBestDetail(li.keyId)><span>우수사례조회</span></button> <button ng-if=\"li.BestYN == \'Y\'\" class=\"btn btn-primary\" ng-click=vc.goBestAdd(li.keyId)><span ng-if=\"[undefined,null,\'\'].includes(li.BestCaseId)\">우수사례등록</span> <span ng-if=\"![undefined,null,\'\'].includes(li.BestCaseId)\">수정</span></button></div></div></div><div class=list-card__bottom><p class=list-card__request>신청 영역 : {{li[vc.columnMap[\'SupportReq\'].ColumnPhysicalNm]}}</p><p class=list-card__date>{{li[vc.columnMap[\'ReqDate\'].ColumnPhysicalNm] | date:\'yyyy-MM-dd\'}}</p></div></a></li></ul></div><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/eland-request/take-result-detail.html","<div class=\"page page-footable elandCustom\" ng-controller=\"TakeResultDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>지원신청 결과 상세</h3></div></div><div class=pagecontent><!-- 버튼 영역 --><div class=row><div class=\"pull-right mb-5\"><button class=\"btn btn-primary\" ng-click=vc.goEdit() ng-if=vc.isAdminSHT><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setReturn() ng-if=vc.isAdminSH><i class=\"fa fa-edit\"></i> 반려</button> <button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div><!-- 버튼 영역 끝 --><!----------------------------------------------------------------------------------------------------><!-- 1. 기관정보 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>1. 기관정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 15%\"><col style=\"width: 35%\"></colgroup><tbody><tr><th style=\"text-align: center\">기관명</th><td>{{vc.data.TenantNm}}</td><th style=\"text-align: center\">기관연락처</th><td><input type=text auto-hyphen ng-model=vc.data.TelNo readonly></td></tr><tr><th style=\"text-align: center\">담당자명</th><td>{{vc.data.ContactNm}}</td><th style=\"text-align: center\">담당자 직통번호</th><td><input type=text auto-hyphen ng-model=vc.data.ContactMobile readonly></td></tr><tr><th style=\"text-align: center\">신청일</th><td>{{vc.ReqDate}}</td><th style=\"text-align: center\">담당자 E-mail</th><td>{{vc.data.ContactEmail}}</td></tr><tr><th style=\"text-align: center\">대상자명</th><td>{{vc.data.TargetNm}}</td><th style=\"text-align: center\">지원기간</th><td>{{vc.SptStartDate}} ~ {{vc.SptEndDate}}</td></tr><tr><th style=\"text-align: center\">지원영역</th><td>{{vc.data.SupportReqNm}}</td><th style=\"text-align: center\">최종지원금액</th><td><span ng-bind=vc.data.FinalSptSum comma-bind></span>원</td></tr></tbody></table><fieldset class=pc-none><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>기관명</label></div><div class=form-group__wrap><p class=form-group__text>{{vc.data.TenantNm}}</p></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>기관연락처</label></div><div class=form-group__wrap><input type=text auto-hyphen ng-model=vc.data.TelNo readonly></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>담당자명</label></div><div class=form-group__wrap><p class=form-group__text>{{vc.data.ContactNm}}</p></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>담당자 직통번호</label></div><div class=form-group__wrap><input type=text auto-hyphen ng-model=vc.data.ContactMobile readonly></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>신청일</label></div><div class=form-group__wrap><p class=form-group__text>{{vc.ReqDate}}</p></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>담당자 E-mail</label></div><div class=form-group__wrap><p class=form-group__text>{{vc.data.ContactEmail}}</p></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>대상자명</label></div><div class=form-group__wrap><p class=form-group__text>{{vc.data.TargetNm}}</p></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>지원기간</label></div><div class=form-group__wrap><p class=form-group__text>{{vc.SptStartDate}} ~ {{vc.SptEndDate}}</p></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>지원영역</label></div><div class=form-group__wrap><p class=form-group__text>{{vc.data.SupportReqNm}}</p></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>최종지원금액</label></div><div class=form-group__wrap><p class=form-group__text><span ng-bind=vc.data.FinalSptSum comma-bind></span>원</p></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 2. 지원 결과 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>2. 지원 결과</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 16%\"><col></colgroup><tbody><tr><th style=\"text-align: center\">신청 시 위기 정도</th><td colspan=2><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'5\'\" value=5 disabled> 5점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'6\'\" value=6 disabled> 6점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'7\'\" value=7 disabled> 7점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'8\'\" value=8 disabled> 8점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'9\'\" value=9 disabled> 9점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'10\'\" value=10 disabled> 10점</label></li></ul></td></tr><tr><th style=\"text-align: center\">지원 후 위기 정도</th><td colspan=2><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'5\'\" value=5 disabled> 5점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'6\'\" value=6 disabled> 6점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'7\'\" value=7 disabled> 7점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'8\'\" value=8 disabled> 8점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'9\'\" value=9 disabled> 9점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'10\'\" value=10 disabled> 10점</label></li></ul></td></tr><tr><th style=\"text-align: center\" rowspan=\"{{vc.chkCnt + 1}}\">영역별 위기해결률 평가</th><th>평균점수 / 위기해결여부 &nbsp;<div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'0\')\">자동환산표</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[0] == \'1\'\" style=position:absolute;top:150px;width:400px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'0\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>평균점수 자동환산표<table class=tipTable style=width:100%;padding:0px><colgroup><col style=\"width: 50%\"><col style=\"width: 50%\"></colgroup><thead><tr><th>평균점수</th><th>상태</th></tr></thead><tbody><tr><td>4.5 이상</td><td>위기 완전 해결</td></tr><tr><td>4.0 ~ 4.4</td><td>위기 해결</td></tr><tr><td>3.0 ~ 3.9</td><td>부분 해결</td></tr><tr><td>2.0 ~ 2.9</td><td>일부 완화</td></tr><tr><td>1.9 이하</td><td>미해결</td></tr></tbody></table></div></div></th><td colspan=2>{{vc.data.SupportSc}}점 / {{vc.data.SupportResult}}</td></tr><tr ng-if=vc.chk1><th>주거 안정 여부</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=SupportSc1 ng-model=vc.data.SupportSc1 ng-checked=\"vc.data.SupportSc1 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=SupportSc1 ng-model=vc.data.SupportSc1 ng-checked=\"vc.data.SupportSc1 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=SupportSc1 ng-model=vc.data.SupportSc1 ng-checked=\"vc.data.SupportSc1 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=SupportSc1 ng-model=vc.data.SupportSc1 ng-checked=\"vc.data.SupportSc1 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=SupportSc1 ng-model=vc.data.SupportSc1 ng-checked=\"vc.data.SupportSc1 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=SupportSc1 ng-model=vc.data.SupportSc1 ng-checked=\"vc.data.SupportSc1 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr ng-if=vc.chk4><th>치료 진행 및 건강 개선</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=SupportSc4 ng-model=vc.data.SupportSc4 ng-checked=\"vc.data.SupportSc4 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=SupportSc4 ng-model=vc.data.SupportSc4 ng-checked=\"vc.data.SupportSc4 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=SupportSc4 ng-model=vc.data.SupportSc4 ng-checked=\"vc.data.SupportSc4 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=SupportSc4 ng-model=vc.data.SupportSc4 ng-checked=\"vc.data.SupportSc4 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=SupportSc4 ng-model=vc.data.SupportSc4 ng-checked=\"vc.data.SupportSc4 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=SupportSc4 ng-model=vc.data.SupportSc4 ng-checked=\"vc.data.SupportSc4 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr ng-if=vc.chk2><th>생계 안정 및 일상 유지</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=SupportSc2 ng-model=vc.data.SupportSc2 ng-checked=\"vc.data.SupportSc2 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=SupportSc2 ng-model=vc.data.SupportSc2 ng-checked=\"vc.data.SupportSc2 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=SupportSc2 ng-model=vc.data.SupportSc2 ng-checked=\"vc.data.SupportSc2 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=SupportSc2 ng-model=vc.data.SupportSc2 ng-checked=\"vc.data.SupportSc2 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=SupportSc2 ng-model=vc.data.SupportSc2 ng-checked=\"vc.data.SupportSc2 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=SupportSc2 ng-model=vc.data.SupportSc2 ng-checked=\"vc.data.SupportSc2 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr ng-if=vc.chk3><th>자립 기반 회복 여부</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=SupportSc3 ng-model=vc.data.SupportSc3 ng-checked=\"vc.data.SupportSc3 == \'0\'\" value=0 disabled> 0점</label></li><li><label><input type=radio name=SupportSc3 ng-model=vc.data.SupportSc3 ng-checked=\"vc.data.SupportSc3 == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=SupportSc3 ng-model=vc.data.SupportSc3 ng-checked=\"vc.data.SupportSc3 == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=SupportSc3 ng-model=vc.data.SupportSc3 ng-checked=\"vc.data.SupportSc3 == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=SupportSc3 ng-model=vc.data.SupportSc3 ng-checked=\"vc.data.SupportSc3 == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=SupportSc3 ng-model=vc.data.SupportSc3 ng-checked=\"vc.data.SupportSc3 == \'5\'\" value=5 disabled> 5점</label></li></ul></td></tr><tr><th style=\"text-align: center\">위기해결 종합평가</th><td colspan=2><textarea rows=5 class=\"form-control mt-10\" ng-model=vc.data.PerSocSpt readonly></textarea></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>신청 시 위기 정도</label></div><div class=form-group__radio-group><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=resultRadio1_m ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=resultRadio1_m ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=resultRadio1_m ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=resultRadio1_m ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=resultRadio1_m ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'5\'\" value=5 disabled> 5점</label></li><li><label><input type=radio name=resultRadio1_m ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'6\'\" value=6 disabled> 6점</label></li><li><label><input type=radio name=resultRadio1_m ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'7\'\" value=7 disabled> 7점</label></li><li><label><input type=radio name=resultRadio1_m ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'8\'\" value=8 disabled> 8점</label></li><li><label><input type=radio name=resultRadio1_m ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'9\'\" value=9 disabled> 9점</label></li><li><label><input type=radio name=resultRadio1_m ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'10\'\" value=10 disabled> 10점</label></li></ul></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>지원 후 위기 정도</label></div><div class=form-group__radio-group><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=resultRadio2_m ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'1\'\" value=1 disabled> 1점</label></li><li><label><input type=radio name=resultRadio2_m ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'2\'\" value=2 disabled> 2점</label></li><li><label><input type=radio name=resultRadio2_m ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'3\'\" value=3 disabled> 3점</label></li><li><label><input type=radio name=resultRadio2_m ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'4\'\" value=4 disabled> 4점</label></li><li><label><input type=radio name=resultRadio2_m ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'5\'\" value=5 disabled> 5점</label></li><li><label><input type=radio name=resultRadio2_m ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'6\'\" value=6 disabled> 6점</label></li><li><label><input type=radio name=resultRadio2_m ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'7\'\" value=7 disabled> 7점</label></li><li><label><input type=radio name=resultRadio2_m ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'8\'\" value=8 disabled> 8점</label></li><li><label><input type=radio name=resultRadio2_m ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'9\'\" value=9 disabled> 9점</label></li><li><label><input type=radio name=resultRadio2_m ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'10\'\" value=10 disabled> 10점</label></li></ul></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>영역별 위기해결률 평가</label></div>1. 주거 안정 여부 : {{vc.data.SupportSc1}}<br>2. 치료 진행 및 건강 개선 : {{vc.data.SupportSc2}}<br>3. 생계 안정 및 일상 유지 : {{vc.data.SupportSc3}}<br>4. 자립 기반 회복 여부 : {{vc.data.SupportSc4}}<br><br>평균점수 : {{vc.data.SupportSc}}<br>위기해결여부 : {{vc.data.SupportResult}}</div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>위기해결 종합평가</label></div><textarea rows=5 class=\"form-control mt-10\" ng-model=vc.data.PerSocSpt readonly></textarea></div></fieldset><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr ng-repeat=\"(key, fileObj) in vc.attach\" ng-if=\"fileObj.ngIf && fileObj.grpId <= 10 \"><th ng-if=fileObj.isLoaded>{{ fileObj.label }}<td ng-if=fileObj.isLoaded><input class=\"form-control form-right\" type=text ng-model=fileObj.fileName ng-click=vc.downloadFile(key) style=\"cursor: pointer; width: 100%\" readonly></td></th></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 3. 사례관리 평가 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>3. 사례관리 평가</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\">사례관리 목표</th><td><textarea rows=5 class=form-control ng-model=vc.data.ManagePlan readonly></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>사례관리 결과</th><td>목표 대비 달성 정도 : {{vc.data.SptResultRate}} %</td></tr><tr><td><textarea rows=5 class=form-control ng-model=vc.data.SptResult readonly></textarea></td></tr><tr><th style=\"text-align: center\">향후 계획</th><td><textarea rows=5 class=\"form-control mt-10\" ng-model=vc.data.AfterPlan readonly></textarea></td></tr></tbody></table><fieldset class=pc-none><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>사례관리 목표</label></div><textarea rows=5 class=form-control ng-model=vc.data.ManagePlan readonly></textarea></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>사례관리 결과</label></div><p>목표 대비 달성 정도 : {{vc.data.SptResultRate}} %</p><textarea rows=5 class=\"form-control mt-5\" ng-model=vc.data.SptResult readonly></textarea></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>향후 계획</label></div><textarea rows=5 class=\"form-control mt-10\" ng-model=vc.data.AfterPlan readonly></textarea></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 4. 예산 집행 내역 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>4. 예산 집행 내역</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=table-scroll><table class=reportTable style=\"width:100%; border-top: 2px solid #9E9E9E\"><colgroup><col style=\"width: 12%\"><col style=\"width: 12%\"><col style=\"width: 12%\"><col style=\"width: 12%\"><col style=\"width: 12%\"><col style=\"width: 12%\"><col></colgroup><thead><tr><th colspan=2>지원내역</th><th>지원금</th><th>집행금</th><th>잔액</th><th>집행률(%)</th><th>이체방식</th></tr></thead><tbody><tr ng-repeat=\"(index, li) in vc.data.budgetExecList\"><td class=text-center>{{li.SptRecordNm}}</td><td>{{li.SptRecordCn}}</td><td class=text-right><span ng-bind=li.SptAmt comma-bind></span> 원</td><td class=text-right><span ng-bind=li.ExecAmt comma-bind></span> 원</td><td class=text-right><span ng-bind=li.Blance comma-bind></span> 원</td><td><span ng-bind=li.Rate></span> %</td><td>{{li.TransTypeNm}}</td></tr></tbody><tfoot><tr><td class=text-center colspan=2><b>합계</b></td><td class=text-right><span ng-bind=vc.data.SptAmtSum comma-bind></span> 원</td><td class=text-right><span ng-bind=vc.data.ExecAmtSum comma-bind>금액</span> 원</td><td class=text-right><span ng-bind=vc.data.BlanceSum comma-bind>금액</span> 원</td><td class=text-center><span ng-bind=vc.data.RateAvg></span> %</td><td></td></tr></tfoot></table><table class=\"tb_report mt-10 mobile-none\" style=\"border-top:0; border-top: 1px solid #ddd\"><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr ng-if=\"vc.data.BlanceSum != \'0\'\"><th style=\"text-align: center\">잔액 사유</th><td><textarea rows=5 class=form-control ng-model=vc.data.BlanceCn ng-disabled=!vc.data.BlanceSum readonly></textarea></td></tr><tr ng-if=\"vc.data.BlanceSum != \'0\'\"><th style=\"text-align: center\">지원금 반환처리</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=BlanceRtnYN ng-model=vc.data.BlanceRtnYN ng-checked=\"vc.data.BlanceRtnYN == \'1\'\" value=1 disabled> 완료</label></li><li><label><input type=radio name=BlanceRtnYN ng-model=vc.data.BlanceRtnYN ng-checked=\"vc.data.BlanceRtnYN == \'0\'\" value=0 disabled> 진행 예정</label></li></ul></td></tr></tbody></table></div><fieldset class=pc-none><div class=form-group ng-if=\"vc.data.BlanceSum != \'0\'\"><div class=form-group__label-wrap><label class=form-group__label>잔액 사유</label></div><textarea rows=5 class=form-control ng-model=vc.data.BlanceCn ng-disabled=!vc.data.BlanceSum readonly></textarea></div><div class=form-group ng-if=\"vc.data.BlanceSum != \'0\'\"><div class=form-group__label-wrap><label class=form-group__label>지원금 반환처리</label></div><div class=\"form-group__radio-group radioWrap ul_h\"><label><input type=radio name=BlanceRtnYN_m ng-model=vc.data.BlanceRtnYN ng-checked=\"vc.data.BlanceRtnYN == \'1\'\" value=1 disabled> 완료</label><label><input type=radio name=BlanceRtnYN_m ng-model=vc.data.BlanceRtnYN ng-checked=\"vc.data.BlanceRtnYN == \'0\'\" value=0 disabled> 진행 예정</label></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 5. 회계 증빙서류 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>5. 회계 증빙서류</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=table-scroll><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\">종류</th><th style=\"text-align: center\">파일</th></tr><tr ng-repeat=\"(key, fileObj) in vc.attach\" ng-if=\"fileObj.ngIf && fileObj.grpId > 10 \"><th ng-if=fileObj.isLoaded>{{ fileObj.label }}<td ng-if=fileObj.isLoaded><input class=\"form-control form-right\" type=text ng-model=fileObj.fileName ng-click=vc.downloadFile(key) style=\"cursor: pointer; width: 100%\" readonly></td></th></tr></tbody></table></div></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 6. 모니터링 가능 일자 --><div id=pn9 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>6. 모니터링 가능 일자</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report mt-5 mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 15%\"><col style=\"width: 35%\"></colgroup><tbody><tr id=MoniDate><th style=\"text-align: center\">1순위</th><td>{{vc.MoniDate1}}</td><th style=\"text-align: center\">2순위</th><td>{{vc.MoniDate2}}</td></tr></tbody></table><fieldset class=pc-none id=MoniDate><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>1순위</label></div><div class=form-group__wrap><p>{{vc.MoniDate1}}</p></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>2순위</label></div><div class=form-group__wrap><p>{{vc.MoniDate2}}</p></div></div></fieldset></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 7. 모니터링 배치 현황 추가 --><div id=pn9 class=row ng-if=vc.isAdminSHB><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>7. 모니터링 배치 현황 추가</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"tb_report date-center mt-5 mobile-none\"><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 15%\"><col style=\"width: 25%\"><col style=\"width: 10%\"></colgroup><tbody><tr id=MoniBat><th style=\"text-align: center\">모니터링 담당자</th><td><input type=text class=form-control ng-model=vc.data.MoniUserTxt maxlength=50 ng-disabled=\" ! vc.isAdminSH\"></td><th style=\"text-align: center\">진행여부</th><td><common-code-custom code-list=\"vc.columnMap[\'MoniStat\'].CodeList\" code-model=vc.data.MoniStat ng-disabled=\" ! vc.isAdminSH\"></common-code-custom></td><td style=\"text-align: center\"><button class=\"btn-min btn btn-default\" ng-click=vc.saveMoniData() ng-if=vc.isAdminSH><i class=\"glyphicon glyphicon-edit\"></i> 모니터링 저장</button></td></tr><tr><th style=\"text-align: center\">모니터링 일시</th><td><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.MoniDate = (vc.MoniDate | date: \'yyyy-MM-dd\')\" ng-model=vc.MoniDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\" ng-disabled=\" ! vc.isAdminSH\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button ng-disabled=\" ! vc.isAdminSH\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><select class=form-control ng-model=vc.data.MoniTime ng-options=\"t for t in vc.timeList\" ng-disabled=\" ! vc.isAdminSH\"></select></div></td><td colspan=3></td></tr></tbody></table><fieldset class=pc-none><div class=form-group id=MoniBat><div class=form-group__label-wrap><label class=form-group__label>진행여부</label></div><input type=text class=form-control ng-model=vc.data.MoniUserTxt maxlength=50 ng-disabled=\" ! vc.isAdminSH\"></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>진행여부</label></div><div class=form-group__input-group><common-code-custom code-list=\"vc.columnMap[\'MoniStat\'].CodeList\" code-model=vc.data.MoniStat ng-disabled=\" ! vc.isAdminSH\"></common-code-custom><button class=\"btn-min btn btn-default\" ng-click=vc.saveMoniData() ng-if=vc.isAdminSH><i class=\"glyphicon glyphicon-edit\"></i> 모니터링 저장</button></div></div><div class=form-group><div class=form-group__label-wrap><label class=form-group__label>모니터링 일시</label></div><div class=form-group__input-group><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 maxlength=10 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.MoniDate = (vc.MoniDate | date: \'yyyy-MM-dd\')\" ng-model=vc.MoniDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\" ng-disabled=\" ! vc.isAdminSH\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button ng-disabled=\" ! vc.isAdminSH\"><i class=\"glyphicon glyphicon-calendar\"></i></button></span><select class=form-control ng-model=vc.data.MoniTime ng-options=\"t for t in vc.timeList\" ng-disabled=\" ! vc.isAdminSH\"></select></div></div></div></fieldset></div></div></div></div><!-- row --><div id=field7 class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.COMMENT\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><article class=streamline-post ng-repeat=\"li in vc.comment.list\"><div class=post-container><div class=\"panel panel-default\"><div class=\"panel-heading bg-white\">{{li.RegUser_}}({{li.TenantNm}}) <span><i class=\"fa fa-clock-o mr-5\"></i> {{li.RegDate}}</span> <span class=\"text-muted pull-right\" ng-if=\"li.TenantId == vc.tenantId && li.ResultReportCommId != vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editComment(li)><i class=\"glyphicon glyphicon-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn-min btn btn-default\" ng-click=vc.deleteComment(li)><i class=\"glyphicon glyphicon-trash\"></i> {{ \'Menu.DELETE\' | translate }}</button> </span><span class=\"text-muted pull-right\" ng-if=\"li.TenantId == vc.tenantId && li.ResultReportCommId == vc.comment.editid\"><button class=\"btn-min btn btn-default\" ng-click=vc.editCommentAction(li)><i class=\"glyphicon glyphicon-ok\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button href=\"\" class=\"btn-min btn btn-default\" ng-click=vc.editCommentCancel()><i class=\"glyphicon glyphicon-remove\"></i> {{ \'Menu.CANCEL\' | translate }}</button></span></div><div class=\"panel-body pre\" ng-if=\"li.ResultReportCommId != vc.comment.editid\"><i class=\"fa fa-lock\" ng-if=\"li.SecretCommYN == \'1\'\"></i> {{li.Content}}</div><div class=panel-body ng-if=\"li.ResultReportCommId == vc.comment.editid\"><textarea class=form-control id=strReply rows=10 style=\"width:100%; height:40px; resize:vertical\" ng-model=vc.comment.editContent></textarea><div class=\"row mt-10\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><input type=checkbox ng-model=vc.comment.SecretCommYN class=mb-5 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.comment.SecretCommYN == \'1\'\"> 비밀댓글<sapn ng-if=\"vc.comment.SecretCommYN == \'1\'\">(관리자 추가 후 댓글 저장 시 적용됩니다.)</sapn></div><div class=\"col-xs-6 col-sm-6 col-md-3 col-xg-3 col-xl-3\" ng-if=\"vc.comment.SecretCommYN == \'1\'\"><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.comment.AdminData.UserNm disabled> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=\"vc.srchCommAdminModal(\'E\');\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=\"vc.addCommAdmin(\'E\');\">추가</button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-9 col-xg-9 col-xl-9\" ng-if=\"vc.comment.SecretCommYN == \'1\'\"><ul class=\"ul_h li_mr15\"><li ng-repeat=\"(idx, li) in vc.comment.AdminData.list\">[{{li.UserNm}}<span ng-click=\"vc.delCommAdmin(idx, \'E\')\"><i class=\"fa fa-times fa-lg\"></i></span>]</li></ul></div></div></div></div></div></article><div class=streamline-form><form class=\"ng-pristine ng-valid\"><div class=\"form-group form-inner-label form-comment\"><div class=input-group><textarea class=form-control id=strReply placeholder=\"댓글 작성...\" rows=10 style=\"width:100%; height:40px; resize: vertical\" ng-model=vc.commentData.Content></textarea><span class=input-group-btn style=\"vertical-align: top\"><button class=\"btn btn-default cm_btn\" type=button ng-click=vc.saveComment()>{{ \'Menu.SAVE\' | translate }}</button></span></div></div><div class=mt-10><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><input type=checkbox name=chkScretComm ng-model=vc.commentData.SecretCommYN class=mb-5 ng-true-value=1 ng-false-value=0 ng-checked=\"vc.commentData.SecretCommYN == \'1\'\"> 비밀댓글<sapn ng-if=\"vc.commentData.SecretCommYN == \'1\'\">(관리자 추가 후 댓글 저장 시 적용됩니다.)</sapn></div><div class=\"col-xs-6 col-sm-6 col-md-3 col-xg-3 col-xl-3\" ng-if=\"vc.commentData.SecretCommYN == \'1\'\"><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.commAdminData.UserNm disabled> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchCommAdminModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.addCommAdmin();>추가</button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-9 col-xg-9 col-xl-9\" ng-if=\"vc.commentData.SecretCommYN == \'1\'\"><ul class=\"ul_h li_mr15\"><li ng-repeat=\"(idx, li) in vc.commAdminData.list\"><sapn ng-if=\"li.UserNm != null && li.UserNm != \'\'\">[{{li.UserNm}}<span ng-click=vc.delCommAdmin(idx)><i class=\"fa fa-times fa-lg\"></i></span>]</sapn></li></ul></div></div></div></form><div>&nbsp;</div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- 버튼 영역 --><div class=\"pull-right mb-20\"><button class=\"btn btn-primary\" ng-click=vc.goEdit() ng-if=vc.isAdminSHT><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setReturn() ng-if=vc.isAdminSH><i class=\"fa fa-edit\"></i> 반려</button> <button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div><!-- 버튼 영역 끝 --></div><!-- /page content --></div>");
$templateCache.put("app/eland-request/take-result-edit.html","<div class=\"page page-footable elandCustom\" ng-controller=\"TakeResultEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>지원신청 결과 등록</h3></div></div><div class=pagecontent><!-- 버튼 영역 --><div class=row><div class=\"pull-right mb-5\"><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=\"vc.saveData(\'TEMP\')\" ng-if=\"vc.data.Status != \'SAVE\'\"><i class=\"fa fa-save\"></i> 임시저장</button> <button class=\"btn btn-primary\" ng-click=\"vc.saveData(\'SAVE\')\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div><!-- 버튼 영역 끝 --><!----------------------------------------------------------------------------------------------------><!-- 1. 기관정보 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>1. 기관정보{{vc.data.RegUserYN}}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 15%\"><col style=\"width: 35%\"></colgroup><tbody><tr><th style=\"text-align: center\">기관명</th><td><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantNm readonly></td><th style=\"text-align: center\">기관연락처</th><td><input type=text class=\"form-control form-right\" auto-hyphen ng-model=vc.data.TelNo readonly></td></tr><tr><th style=\"text-align: center\">담당자명</th><td><input type=text class=\"form-control form-right\" ng-model=vc.data.ContactNm readonly></td><th style=\"text-align: center\">담당자 직통번호<td><input type=text class=\"form-control form-right\" auto-hyphen ng-model=vc.data.ContactMobile readonly></td></th></tr><tr><th style=\"text-align: center\">신청일</th><td><input type=text class=\"form-control form-right\" ng-model=vc.ReqDate readonly></td><th style=\"text-align: center\">담당자 E-mail<td><input type=text class=\"form-control form-right\" ng-model=vc.data.ContactEmail readonly></td></th></tr><tr><th style=\"text-align: center\">대상자이름</th><td><input type=text class=\"form-control form-right\" ng-model=vc.data.TargetNm readonly></td><th style=\"text-align: center\">지원기간</th><td><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SptStartDate = (vc.SptStartDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SptStartDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.SptEndDate = (vc.SptEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.SptEndDate ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></td></tr><tr><th style=\"text-align: center\">지원영역</th><td><input type=text class=\"form-control form-right\" ng-model=vc.data.SupportReqNm readonly></td><th style=\"text-align: center\">최종지원금액</th><td><div class=\"form-group form-inline\"><input type=text class=\"form-control form-right etc_input\" ng-model=vc.data.FinalSptSum comma readonly> 원</div></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 2. 지원 결과 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>2. 지원 결과</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 18%\"><col></colgroup><tbody><tr><th></th><th colspan=2 style=\"font-weight: normal\">※ 대상자의 위기정도 입력 (1점 : 위기정도 낮음 ~ 10점 : 위기정도 높음)</th></tr><tr><th style=\"text-align: center\">신청 시 위기 정도</th><td colspan=2><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'1\'\" value=1> 1점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'2\'\" value=2> 2점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'3\'\" value=3> 3점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'4\'\" value=4> 4점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'5\'\" value=5> 5점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'6\'\" value=6> 6점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'7\'\" value=7> 7점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'8\'\" value=8> 8점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'9\'\" value=9> 9점</label></li><li><label><input type=radio name=resultRadio1 ng-model=vc.data.ApplyRiskLv ng-checked=\"vc.data.ApplyRiskLv == \'10\'\" value=10> 10점</label></li></ul></td></tr><tr><th style=\"text-align: center\">지원 후 위기 정도</th><td colspan=2><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'1\'\" value=1> 1점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'2\'\" value=2> 2점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'3\'\" value=3> 3점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'4\'\" value=4> 4점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'5\'\" value=5> 5점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'6\'\" value=6> 6점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'7\'\" value=7> 7점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'8\'\" value=8> 8점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'9\'\" value=9> 9점</label></li><li><label><input type=radio name=resultRadio2 ng-model=vc.data.SptRiskLv ng-checked=\"vc.data.SptRiskLv == \'10\'\" value=10> 10점</label></li></ul></td></tr><tr><th style=\"text-align: center\" rowspan=\"{{vc.chkCnt + 1}}\">영역별 위기해결률 평가</th><th style=\"text-align: left\" colspan=2>※ 정확한 평가를 위해 각 항목 옆의 <b>[작성 TIP]</b>을 클릭하여 작성 기준을 확인해 주세요.</th></tr><tr ng-if=vc.chk1><th><div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'1\')\">주거비 지원 작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[1] == \'1\'\" style=position:absolute;top:220px;width:500px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'1\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>주거 안정 여부<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 50%\"></colgroup><thead><tr><th>점수</th><th>기준</th><th>판단 예시</th></tr></thead><tbody><tr><td>0</td><td>주거 상황 악화</td><td class=td-left>퇴거, 노숙, 임시거처 전전</td></tr><tr><td>1</td><td>변화 없음</td><td class=td-left>체납/퇴거위험 지속</td></tr><tr><td>2</td><td>일부 개선</td><td class=td-left>일부 체납 해소, 단기 연장</td></tr><tr><td>3</td><td>기본적 안정</td><td class=td-left>당장 퇴거위험은 해소</td></tr><tr><td>4</td><td>안정적 주거 확보</td><td class=td-left>일정 기간 안정 거주 가능</td></tr><tr><td>5</td><td>장기적 안정 확보</td><td class=td-left>재위기 가능성 낮음</td></tr></tbody></table></div></div>&nbsp; 주거 안정 여부</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=SupportSc1 ng-model=vc.data.SupportSc1 ng-checked=\"vc.data.SupportSc1 == \'0\'\" value=0> 0점</label></li><li><label><input type=radio name=SupportSc1 ng-model=vc.data.SupportSc1 ng-checked=\"vc.data.SupportSc1 == \'1\'\" value=1> 1점</label></li><li><label><input type=radio name=SupportSc1 ng-model=vc.data.SupportSc1 ng-checked=\"vc.data.SupportSc1 == \'2\'\" value=2> 2점</label></li><li><label><input type=radio name=SupportSc1 ng-model=vc.data.SupportSc1 ng-checked=\"vc.data.SupportSc1 == \'3\'\" value=3> 3점</label></li><li><label><input type=radio name=SupportSc1 ng-model=vc.data.SupportSc1 ng-checked=\"vc.data.SupportSc1 == \'4\'\" value=4> 4점</label></li><li><label><input type=radio name=SupportSc1 ng-model=vc.data.SupportSc1 ng-checked=\"vc.data.SupportSc1 == \'5\'\" value=5> 5점</label></li></ul></td></tr><tr ng-if=vc.chk4><th><div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'2\')\">치료비 지원 작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[2] == \'1\'\" style=position:absolute;top:220px;width:500px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'2\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>치료 진행 및 건강 개선<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 50%\"></colgroup><thead><tr><th>점수</th><th>기준</th><th>판단 예시</th></tr></thead><tbody><tr><td>0</td><td>치료 불가</td><td class=td-left>치료 시작 못함, 상태 악화</td></tr><tr><td>1</td><td>치료 시작 어려움</td><td class=td-left>필요는 없으나 접근 어려움</td></tr><tr><td>2</td><td>일부 치료 진행</td><td class=td-left>검사/외래/약물 일부 진행</td></tr><tr><td>3</td><td>치료 진행 중</td><td class=td-left>계획된 치료 지속 중</td></tr><tr><td>4</td><td>건강 상태 개선</td><td class=td-left>통증 감소, 기능 회복</td></tr><tr><td>5</td><td>치료 완료</td><td class=td-left>위기상황 사실상 해소</td></tr></tbody></table></div></div>&nbsp; 치료 진행 및 건강 개선</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=SupportSc4 ng-model=vc.data.SupportSc4 ng-checked=\"vc.data.SupportSc4 == \'0\'\" value=0> 0점</label></li><li><label><input type=radio name=SupportSc4 ng-model=vc.data.SupportSc4 ng-checked=\"vc.data.SupportSc4 == \'1\'\" value=1> 1점</label></li><li><label><input type=radio name=SupportSc4 ng-model=vc.data.SupportSc4 ng-checked=\"vc.data.SupportSc4 == \'2\'\" value=2> 2점</label></li><li><label><input type=radio name=SupportSc4 ng-model=vc.data.SupportSc4 ng-checked=\"vc.data.SupportSc4 == \'3\'\" value=3> 3점</label></li><li><label><input type=radio name=SupportSc4 ng-model=vc.data.SupportSc4 ng-checked=\"vc.data.SupportSc4 == \'4\'\" value=4> 4점</label></li><li><label><input type=radio name=SupportSc4 ng-model=vc.data.SupportSc4 ng-checked=\"vc.data.SupportSc4 == \'5\'\" value=5> 5점</label></li></ul></td></tr><tr ng-if=vc.chk2><th><div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'3\')\">생계비 지원 작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[3] == \'1\'\" style=position:absolute;top:220px;width:500px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'3\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>생계 안정 및 일상 유지<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 50%\"></colgroup><thead><tr><th>점수</th><th>기준</th><th>판단 예시</th></tr></thead><tbody><tr><td>0</td><td>생계위기 지속</td><td class=td-left>식생활/공과금/기본생활 곤란</td></tr><tr><td>1</td><td>변화 미미</td><td class=td-left>지원 후에도 생계불안 큼</td></tr><tr><td>2</td><td>일부 완화</td><td class=td-left>단기 생계 공백만 메움</td></tr><tr><td>3</td><td>기본생활 유지</td><td class=td-left>필수생활 유지 가능</td></tr><tr><td>4</td><td>생계 안정</td><td class=td-left>일상 운영이 비교적 안정</td></tr><tr><td>5</td><td>지속가능한 안정</td><td class=td-left>급여/소득/외부자원 연계 완료</td></tr></tbody></table></div></div>&nbsp; 생계 안정 및 일상 유지</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=SupportSc2 ng-model=vc.data.SupportSc2 ng-checked=\"vc.data.SupportSc2 == \'0\'\" value=0> 0점</label></li><li><label><input type=radio name=SupportSc2 ng-model=vc.data.SupportSc2 ng-checked=\"vc.data.SupportSc2 == \'1\'\" value=1> 1점</label></li><li><label><input type=radio name=SupportSc2 ng-model=vc.data.SupportSc2 ng-checked=\"vc.data.SupportSc2 == \'2\'\" value=2> 2점</label></li><li><label><input type=radio name=SupportSc2 ng-model=vc.data.SupportSc2 ng-checked=\"vc.data.SupportSc2 == \'3\'\" value=3> 3점</label></li><li><label><input type=radio name=SupportSc2 ng-model=vc.data.SupportSc2 ng-checked=\"vc.data.SupportSc2 == \'4\'\" value=4> 4점</label></li><li><label><input type=radio name=SupportSc2 ng-model=vc.data.SupportSc2 ng-checked=\"vc.data.SupportSc2 == \'5\'\" value=5> 5점</label></li></ul></td></tr><tr ng-if=vc.chk3><th><div class=tipWrap1><span class=tip_btn ng-click=\"vc.clickTip(\'4\')\">자립비 지원 작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[4] == \'1\'\" style=position:absolute;top:220px;width:500px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=\"vc.clickTip(\'4\')\" activate-button=\"\"><i class=\"fa fa-times\"></i></button></div>자립 기반 회복 여부<table class=tipTable style=width:100%><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 50%\"></colgroup><thead><tr><th>점수</th><th>기준</th><th>판단 예시</th></tr></thead><tbody><tr><td>0</td><td>기능 회복 어려움</td><td class=td-left>일상/근로 모두 어려움</td></tr><tr><td>1</td><td>회복 시작 어려움</td><td class=td-left>치료/돌봄 개입이 미진</td></tr><tr><td>2</td><td>일부 기능 회복</td><td class=td-left>일상 일부 가능, 근로는 어려움</td></tr><tr><td>3</td><td>기본 활동 가능</td><td class=td-left>구직/복귀 준비 가능</td></tr><tr><td>4</td><td>자립 가능성 높아짐</td><td class=td-left>부분 근로, 훈련, 구직 가능</td></tr><tr><td>5</td><td>자립 기반 회복</td><td class=td-left>실제 근로/소득활동 가능</td></tr></tbody></table></div></div>&nbsp; 자립 기반 회복 여부</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=SupportSc3 ng-model=vc.data.SupportSc3 ng-checked=\"vc.data.SupportSc3 == \'0\'\" value=0> 0점</label></li><li><label><input type=radio name=SupportSc3 ng-model=vc.data.SupportSc3 ng-checked=\"vc.data.SupportSc3 == \'1\'\" value=1> 1점</label></li><li><label><input type=radio name=SupportSc3 ng-model=vc.data.SupportSc3 ng-checked=\"vc.data.SupportSc3 == \'2\'\" value=2> 2점</label></li><li><label><input type=radio name=SupportSc3 ng-model=vc.data.SupportSc3 ng-checked=\"vc.data.SupportSc3 == \'3\'\" value=3> 3점</label></li><li><label><input type=radio name=SupportSc3 ng-model=vc.data.SupportSc3 ng-checked=\"vc.data.SupportSc3 == \'4\'\" value=4> 4점</label></li><li><label><input type=radio name=SupportSc3 ng-model=vc.data.SupportSc3 ng-checked=\"vc.data.SupportSc3 == \'5\'\" value=5> 5점</label></li></ul></td></tr><tr><th style=\"text-align: center\">위기해결 종합평가</th><td colspan=2><span><strong>- 위기 상황의 해결 정도를 신청 당시와 비교하여 구체적으로 작성해주세요.<br>※ 지원 후 개인의 삶의 변화<br>※ 가족 및 사회적 변화<br>※ 지원의 만족도 및 반응<br>※ 대상자의 말, 행동, 감정 등에 나타난 변화 등<br>※ 그 외에 의도하지 않았지만 나타난 변화</strong></span><textarea id=PerSocSpt rows=6 class=\"form-control mt-10 mb-5\" ng-model=vc.data.PerSocSpt minlength=300 placeholder=\"사례관리 기관 직접 작성&#13;&#10;대상자 지원 전 후, 변화(위기해결 여부 및 일상회복)을 종합적으로 작성해주세요.&#13;&#10;-지원 전 주요 위기 상황 (주거, 생계, 건강 등 주요 어려움)&#13;&#10;-지원 이후 변화 내용&#13;&#10;-현재 일상 유지 및 회복 수준&#13;&#10;-추가 필요사항&#13;&#10;\"></textarea><span id=PerSocSpt_len>(0 자)</span></td></tr></tbody></table><table class=\"reportTable mb-10\" style=width:100%><colgroup><col style=\"width: 10%\"><col style=\"width: 30%\"><col style=\"width: 30%\"><col style=\"width: 30%\"></colgroup><tbody><tr><th>잠금</th><th>종류</th><th>파일</th><th>비고</th></tr><tr ng-repeat=\"(key, fileObj) in vc.attach\" ng-if=\"fileObj.ngIf && fileObj.grpId <= 10 \"><td><button class=\"btn btn-primary\" ng-click=\"vc.setFileLock(key,\'N\')\" ng-if=\"fileObj.fileLock == \'Y\'\"><i class=\"fa fa-lock\"></i></button> <button class=\"btn btn-primary\" ng-click=\"vc.setFileLock(key,\'Y\')\" ng-if=\"fileObj.fileLock == \'N\'\"><i class=\"fa fa-unlock\"></i></button></td><td>{{ fileObj.label }}</td><td><div class=input-group><input id=\"{{ key }}\" style=\"display: none\" class=file type=file multiple data-preview-file-type=any data-upload-url=# placeholder=\"\"> <input class=\"form-control form-right\" type=text ng-model=fileObj.fileName ng-click=vc.downloadTemp(key) style=\"cursor: pointer\" readonly><div class=input-group-btn><button ng-show=!fileObj.isLoaded class=\"btn btn-default\" ng-click=vc.openAttachDialog(key)><i class=\"fa fa-save\"></i>찾기</button> <button ng-show=fileObj.isLoaded class=\"btn btn-default\" ng-click=vc.onDelete(key) style=z-index:1><i class=\"fa fa-times\"></i>삭제</button></div></div></td><td>{{ fileObj.txt }}</td></tr></tbody></table><button class=\"btn btn-primary\" ng-click=\"vc.addFile(\'Photo\')\"><i class=\"fa fa-file\"></i> 대상자사진 추가</button> <button class=\"btn btn-primary\" ng-click=\"vc.addFile(\'Review\')\"><i class=\"fa fa-file\"></i> 대상자후기 추가</button></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 3. 사례관리 평가 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>3. 사례관리 평가</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th style=\"text-align: center\">사례관리 목표</th><td><textarea rows=5 class=form-control ng-model=vc.data.ManagePlan></textarea></td></tr><tr><th style=\"text-align: center\" rowspan=2>사례관리 결과</th><td><span style=\"float:left; width:160px; margin-top:10px\">목표 대비 달성 정도(%) :</span><select ng-model=vc.data.SptResultRate class=form-control style=\"float:left;  width:50px\" ng-options=\"r for r in vc.rateList\"></select></td></tr><tr><td><textarea rows=5 class=form-control ng-model=vc.data.SptResult></textarea></td></tr><tr><th style=\"text-align: center\">향후 계획</th><td><span><strong>- 대상 가정의 향후 계획 및 사례관리 계획을 구체적으로 작성해주세요<br>※ 앞으로 가정의 삶의 계획<br>※ 사례관리 계획</strong></span><textarea rows=5 class=\"form-control mt-10\" ng-model=vc.data.AfterPlan placeholder=\"- 앞으로 가정의 삶의 계획 :&#13;&#10;- 사례관리 계획 :\"></textarea></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 4. 예산 집행 내역 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>4. 예산 집행 내역</strong><div class=tipWrap1><span class=tip_btn ng-click=vc.clickTip(0)>작성 TIP</span><!-- tip_btn 클릭 시 나타남 --><div class=tip_content ng-if=\"vc.tips[0] == \'1\'\" style=position:absolute;top:10px;width:800px><div class=\"row pull-right mb-5 mr-5\"><button class=\"btn btn-default\" ng-click=vc.clickTip(0) activate-button=\"\"><i class=\"fa fa-times\"></i></button></div><table class=tipTable style=width:100%><thead><tr><th colspan=2>지원내역</th><th>지원금</th><th>집행금</th><th>잔액</th><th>집행률(%)</th><th>이체방식</th><th>추가/삭제</th></tr></thead><tbody><tr class=text-center><td>주거비</td><td>월세</td><td>300,000</td><td>300,000</td><td>0</td><td>100%</td><td>이랜드복지재단에서 직접이체</td><td></td></tr><tr class=text-center><td>생활비</td><td>수도광열비</td><td>150,000</td><td>150,000</td><td>0</td><td>100%</td><td>사례관리기관으로 이체</td><td></td></tr><tr class=text-center><td>생활비</td><td>생필품</td><td>600,000</td><td>600,000</td><td>0</td><td>100%</td><td>체리카드 충전</td><td></td></tr><tr class=text-center><td>생활비</td><td>식료품</td><td>100,000</td><td>100,000</td><td>0</td><td>100%</td><td>체리카드 충전</td><td></td></tr></tbody><tfoot><tr><td class=text-center colspan=2><b>합계</b></td><td class=text-right>1,150,000</td><td class=text-right>1,150,000</td><td class=text-right>0</td><td class=text-center>100%</td><td></td><td></td></tr></tfoot></table></div><!-- tip_btn 클릭 시 나타남 --></div><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><p><strong>※ 이랜드복지재단에서 사례관리기관 외 병원, 임대인 등에 직접 이체한 경우, 지출증빙서류 미제출 사유(예: 이랜드복지재단 직접 이체)를 비고란에 반드시 기재해주시기 바랍니다.<br>※ 지출증빙서류는 첨부파일(회계첨부 서류)에 업로드해주시기 바랍니다.</strong></p><table class=\"reportTable mt-5\" style=\"width:100%; border-top: 2px solid #9E9E9E\"><colgroup><col style=\"width: 12%\"><col style=\"width: 12%\"><col style=\"width: 12%\"><col style=\"width: 12%\"><col style=\"width: 12%\"><col style=\"width: 12%\"><col><col style=\"width: 12%\"></colgroup><thead><tr><th colspan=2>지원내역</th><th>지원금</th><th>집행금</th><th>잔액</th><th>집행률(%)</th><th>이체방식</th><th>추가/삭제</th></tr></thead><tbody><tr><td><common-code-custom code-list=\"vc.columnMap[\'SptRecord\'].CodeList\" code-model=vc.budgetExecData.SptRecord></common-code-custom></td><td><input type=text class=form-control maxlength=20 ng-model=vc.budgetExecData.SptRecordCn></td><td><input type=text class=\"form-control text-right\" maxlength=15 ng-model=vc.budgetExecData.SptAmt comma ng-change=vc.cal();></td><td><input type=text class=\"form-control text-right\" maxlength=15 ng-model=vc.budgetExecData.ExecAmt comma ng-change=vc.cal();></td><td><input type=text class=\"form-control text-right\" maxlength=15 ng-model=vc.budgetExecData.Blance comma></td><td><input type=text class=\"form-control text-right\" maxlength=15 ng-model=vc.budgetExecData.Rate readonly></td><td><common-code-custom code-list=\"vc.columnMap[\'TransType\'].CodeList\" code-model=vc.budgetExecData.TransType></common-code-custom></td><td><button class=\"btn btn-default\" ng-click=vc.addBudgetExec()><i class=\"glyphicon glyphicon-plus\"></i> 추가</button></td></tr><tr ng-repeat=\"(index, li) in vc.data.budgetExecList\"><td class=text-center>{{li.SptRecordNm}}</td><td>{{li.SptRecordCn}}</td><td class=text-right><span ng-bind=li.SptAmt comma-bind></span> 원</td><td class=text-right><span ng-bind=li.ExecAmt comma-bind></span> 원</td><td class=text-right><span ng-bind=li.Blance comma-bind></span> 원</td><td><span ng-bind=li.Rate></span> %</td><td>{{li.TransTypeNm}}</td><td><button class=\"btn btn-default\" ng-click=vc.delBudgetExecList(index)><i class=\"glyphicon glyphicon-minus\"></i> 삭제</button></td></tr></tbody><tfoot><tr><td class=text-center colspan=2><b>합계</b></td><td class=text-right><span ng-bind=vc.data.SptAmtSum comma-bind></span> 원</td><td class=text-right><span ng-bind=vc.data.ExecAmtSum comma-bind></span> 원</td><td class=text-right><span ng-bind=vc.data.BlanceSum comma-bind></span> 원</td><td class=text-center><span ng-bind=vc.data.RateAvg></span> %</td><td></td><td></td></tr></tfoot></table><table class=\"tb_report mt-10 mobile-none\" style=\"border-top:0; border-top: 1px solid #ddd\"><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr ng-if=\"vc.data.BlanceSum != \'0\'\"><th style=\"text-align: center\">잔액 사유</th><td><textarea rows=5 class=form-control placeholder=\"잔액이 있을 시에만 입력해 주세요\" ng-model=vc.data.BlanceCn ng-disabled=!vc.data.BlanceSum></textarea></td></tr><tr ng-if=\"vc.data.BlanceSum != \'0\'\"><th style=\"text-align: center\">지원금 반환처리</th><td><ul class=\"radioWrap ul_h\"><li><label><input type=radio name=BlanceRtnYN ng-model=vc.data.BlanceRtnYN ng-checked=\"vc.data.BlanceRtnYN == \'1\'\" value=1> 완료</label></li><li><label><input type=radio name=BlanceRtnYN ng-model=vc.data.BlanceRtnYN ng-checked=\"vc.data.BlanceRtnYN == \'0\'\" value=0> 진행 예정</label></li></ul></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 5. 회계 증빙서류 --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>5. 회계 증빙서류</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=\"reportTable mb-10\" style=width:100%><colgroup><col style=\"width: 10%\"><col style=\"width: 20%\"><col style=\"width: 30%\"><col style=\"width: 30%\"><col style=\"width: 10%\"></colgroup><tbody><tr><th>잠금</th><th>종류</th><th>파일</th><th>비고</th><th>양식</th></tr><tr ng-repeat=\"(key, fileObj) in vc.attach\" ng-if=\"fileObj.ngIf && fileObj.grpId > 10 \"><td><button class=\"btn btn-primary\" ng-click=\"vc.setFileLock(key,\'N\')\" ng-if=\"fileObj.fileLock == \'Y\'\"><i class=\"fa fa-lock\"></i></button> <button class=\"btn btn-primary\" ng-click=\"vc.setFileLock(key,\'Y\')\" ng-if=\"fileObj.fileLock == \'N\'\"><i class=\"fa fa-unlock\"></i></button></td><td>{{ fileObj.label }}</td><td><div class=input-group><input id=\"{{ key }}\" style=\"display: none\" class=file type=file multiple data-preview-file-type=any data-upload-url=# placeholder=\"\"> <input class=\"form-control form-right\" type=text ng-model=fileObj.fileName ng-click=vc.downloadTemp(key) style=\"cursor: pointer\" readonly><div class=input-group-btn><button ng-show=!fileObj.isLoaded class=\"btn btn-default\" ng-click=vc.openAttachDialog(key)><i class=\"fa fa-save\"></i>찾기</button> <button ng-show=fileObj.isLoaded class=\"btn btn-default\" ng-click=vc.onDelete(key) style=z-index:1><i class=\"fa fa-times\"></i>삭제</button></div></div></td><td>{{ fileObj.txt }}</td><td><button class=\"btn btn-primary\" ng-click=\"vc.downloadFile(\'Account\')\" ng-if=\"key == \'Account1\'\"><i class=\"fa fa-file\"></i> 다운로드</button></td></tr></tbody></table><button class=\"btn btn-primary\" ng-click=\"vc.addFile(\'Account\')\"><i class=\"fa fa-file\"></i> 회계서류 추가</button> <button class=\"btn btn-primary\" ng-click=\"vc.addFile(\'EtcFile\')\"><i class=\"fa fa-file\"></i> 기타서류 추가</button></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 6. 모니터링 가능 일자 --><div id=pn9 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>6. 모니터링 가능 일자</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><p><strong>※ 대상자와 소통해 일정을 조율해주세요.</strong></p><table class=\"tb_report date-center mt-5\"><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 15%\"><col style=\"width: 35%\"></colgroup><tbody><tr id=MoniDate><th style=\"text-align: center\">1순위</th><td><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.chkMoniDate(1, vc.MoniDate1, vc.data.MoniDate1);\" ng-model=vc.MoniDate1 ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><select class=form-control ng-model=vc.data.MoniTime1 ng-options=\"t for t in vc.timeList\"></select></div></td><th style=\"text-align: center\">2순위</th><td><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"input-group datepick\" ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.chkMoniDate(2, vc.MoniDate2, vc.data.MoniDate2);\" ng-model=vc.MoniDate2 ng-required=false placeholder=yyyy-mm-dd type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3\"><select class=form-control ng-model=vc.data.MoniTime2 ng-options=\"t for t in vc.timeList\"></select></div></td></tr></tbody></table></div></div></div></div><!-- 버튼 영역 --><div class=\"pull-right mb-20\"><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=\"vc.saveData(\'TEMP\')\" ng-if=\"vc.data.Status != \'SAVE\'\"><i class=\"fa fa-save\"></i> 임시저장</button> <button class=\"btn btn-primary\" ng-click=\"vc.saveData(\'SAVE\')\"><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div><!-- 버튼 영역 끝 --></div><!-- /page content --></div><script type=text/javascript>$(document).ready(function () {     \r\n    $(\'#PerSocSpt\').keyup(function (e){\r\n      var txt = $(this).val();\r\n      $(\'#PerSocSpt_len\').html(\"(\"+ txt.length +\" 자)\"); \r\n    });    \r\n  });</script>");
$templateCache.put("app/message/campaign-email-customer-detail.html","<div class=\"page page-footable\" ng-controller=\"CampaignEmailCustomerDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>이메일발송 조회</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><div class=form-control>{{vc.data.CmpgnChannel}}</div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송정보</label><div class=form-control>{{vc.data.FromInfo}}</div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>수신자명</label><div class=form-control>{{vc.data.ToNm}}</div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>수신정보</label><div class=form-control>{{vc.data.ToInfo}}</div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송일시</label><div class=form-control>{{ vc.data.RegDate | date: \'yyyy-MM-dd HH:mm\'}}</div></div></div></div><div ng-if=\"vc.data.CmpgnChannel != \'SMS\'\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><div class=form-control>{{vc.data.SendTitle}}</div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><div class=form-control ng-bind=vc.data.SendMessage style=min-height:300px></div><div class=text-right>[{{ vc.data.CmpgnChannel }}] {{ vc.messageLength }} / {{ vc.messageMaxLength }} bytes</div></div></div></div><!-- <div class=\"row\" style=\"margin-top:15px;\"> \r\n              <div class=\"col-xs-12 col-sm-12 col-md-12\">\r\n                <table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=\"100\" id=\"searchTextResults\" width=\"100%\">\r\n                  <tr><th class=\"text-center\">항목</th><th class=\"text-center\">치환문자</th></tr>\r\n                  <tr><td class=\"text-center\">사용자명</td><td class=\"text-center\">{사용자명}</td></tr>\r\n                </table>\r\n              </div>\r\n            </div> --></div></div></div></div></div></div>");
$templateCache.put("app/message/campaign-email-customer-list.html","<div class=\"page page-footable\" ng-controller=\"CampaignEmailCustomerListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>이메일발송 목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SendTitle type=text><label>{{ vc.columnMap[\'SendTitle\'].ColumnLogicalNm | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SendMessage type=text><label>{{ vc.columnMap[\'SendMessage\'].ColumnLogicalNm | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ResultCode\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ResultCode\'].CodeList\" code-model=vc.srch.ResultCode></common-code-custom><label>{{vc.columnMap[\'ResultCode\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'BoardType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'BoardType\'].CodeList\" code-model=vc.srch.BoardType></common-code-custom><label>{{vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch();><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- 검색 영역 --><div class=row><div class=col-lg-12 ui-keypress=\"{13:\'vc.getList()\'}\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>이메일발송 목록</strong><div class=pull-right><p><span><i class=\"fa fa-check\"></i> 대기발송건수: <strong><span comma-bind ng-bind=vc.WaitSms></span></strong>건</span> <span style=\"color:#ccc;margin: 0 5px\">|</span> <span><i class=\"fa fa-circle-o\"></i> 성공발송건수: <strong><span comma-bind ng-bind=vc.SuccessSms></span></strong>건</span> <span style=\"color:#ccc;margin: 0 5px\">|</span> <span style=\"margin-right: 10px\"><i class=\"fa fa-times\"></i> 실패발송건수: <strong><span comma-bind ng-bind=vc.FailSms></span></strong>건</span><!-- <span style=\"color:#ccc;margin: 0 5px;\">|</span>\r\n                      <span><i class=\"fa fa-krw\"></i> 성공합계금액: <strong><span comma-bind ng-bind=\"vc.SumCost\"></span></strong>원</span> --> <a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></p></div></div><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><!-- <th class=\"text-center\" style=\"vertical-align:middle; width: 1%;\"><input type=\"checkbox\" ng-model=\"vc.chkHead\" ng-change=\"chkHeadChg()\"></th> --><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.CmpgnImplCustId, li.CmpgnType)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.CmpgnImplCustId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=40 class=onelinetext>{{li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd HH:mm\'}}</span> <span ng-switch-when=50 class=onelinetext>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60 class=onelinetext>{{$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm]) | html}}</span> <span ng-switch-when=70 class=onelinetext>{{li[liCol.ColumnPhysicalNm] | tel}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></tbody></table><!-- NO DATA --><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><!-- / NO DATA --><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div><!-- /tile body --></div></div></div></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/campaign-sms-customer-detail.html","<div class=\"page page-footable\" ng-controller=\"CampaignSmsCustomerDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>Sms발송 조회</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button></div></div></div><!-- row --><div class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><div class=form-control>{{vc.data.CmpgnChannel}}</div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송정보</label><div class=form-control>{{vc.data.FromInfo}}</div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>수신자명</label><div class=form-control>{{vc.data.ToNm}}</div></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>수신정보</label><div class=form-control>{{vc.data.ToInfo}}</div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송일시</label><div class=form-control>{{ vc.data.RegDate | date: \'yyyy-MM-dd HH:mm\'}}</div></div></div></div><div ng-if=\"vc.data.CmpgnChannel != \'SMS\'\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><div class=form-control>{{vc.data.SendTitle}}</div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><div class=form-control ng-bind=vc.data.SendMessage style=min-height:300px></div><div class=text-right><!-- [{{ vc.data.CmpgnChannel }}] {{ vc.messageLength }} / {{ vc.messageMaxLength }} bytes --></div></div></div></div><!-- <div class=\"row\" style=\"margin-top:15px;\"> \r\n              <div class=\"col-xs-12 col-sm-12 col-md-12\">\r\n                <table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=\"100\" id=\"searchTextResults\" width=\"100%\">\r\n                  <tr><th class=\"text-center\">항목</th><th class=\"text-center\">치환문자</th></tr>\r\n                  <tr><td class=\"text-center\">사용자명</td><td class=\"text-center\">{사용자명}</td></tr>\r\n                </table>\r\n              </div>\r\n            </div> --></div></div></div></div></div></div>");
$templateCache.put("app/message/campaign-sms-customer-list.html","<div class=\"page page-footable\" ng-controller=\"CampaignSmsCustomerListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>SMS발송 목록<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-9 col-sm-9 col-md-9 col-lg-9 col-xl-9 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.searchValue placeholder=\"제목/내용 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr title={{vc.SearchConditionStrPlain}}></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SendTitle type=text><label>{{ vc.columnMap[\'SendTitle\'].ColumnLogicalNm | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SendMessage type=text><label>{{ vc.columnMap[\'SendMessage\'].ColumnLogicalNm | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'ResultCode\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'ResultCode\'].CodeList\" code-model=vc.srch.ResultCode></common-code-custom><label>{{vc.columnMap[\'ResultCode\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'BoardType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'BoardType\'].CodeList\" code-model=vc.srch.BoardType></common-code-custom><label>{{vc.columnMap[\'BoardType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"등록 시작일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"등록 종료일\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"fa fa-calendar\"></i></button></span></div></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch();><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --></div><!-- 검색영역 --></form><!-- 검색 영역 --><div class=row><div class=col-lg-12 ui-keypress=\"{13:\'vc.getList()\'}\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>SMS발송 목록</strong><div class=pull-right><p><span><i class=\"fa fa-check\"></i> 대기발송건수: <strong><span comma-bind ng-bind=vc.WaitSms></span></strong>건</span> <span style=\"color:#ccc;margin: 0 5px\">|</span> <span><i class=\"fa fa-circle-o\"></i> 성공발송건수: <strong><span comma-bind ng-bind=vc.SuccessSms></span></strong>건</span> <span style=\"color:#ccc;margin: 0 5px\">|</span> <span style=\"margin-right: 10px\"><i class=\"fa fa-times\"></i> 실패발송건수: <strong><span comma-bind ng-bind=vc.FailSms></span></strong>건</span><!-- <span style=\"color:#ccc;margin: 0 5px;\">|</span>\r\n                      <span><i class=\"fa fa-krw\"></i> 성공합계금액: <strong><span comma-bind ng-bind=\"vc.SumCost\"></span></strong>원</span> --> <a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></p></div></div><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><!-- <th class=\"text-center\" style=\"vertical-align:middle; width: 1%;\"><input type=\"checkbox\" ng-model=\"vc.chkHead\" ng-change=\"chkHeadChg()\"></th> --><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.CmpgnImplCustId, li.CmpgnType)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.CmpgnImplCustId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=40 class=onelinetext>{{li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd HH:mm\'}}</span> <span ng-switch-when=50 class=onelinetext>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60 class=onelinetext>{{$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm]) | html}}</span> <span ng-switch-when=70 class=onelinetext>{{li[liCol.ColumnPhysicalNm] | tel}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></tbody></table><!-- NO DATA --><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><!-- / NO DATA --><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div><!-- /tile body --></div></div></div></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/sms-send-number-edit.html","<div class=\"page page-footable\" ng-controller=\"SmsSendNumberEditCtrl as vc\"><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setUpdate() ng-if=\"vc.data.CertYN == \'N\'\"><i class=\"fa fa-list\"></i> 인증 승인</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row file-dropzone><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>SMS 발송번호 인증 관리</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'SiteId\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SiteId disabled></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'TenantNm\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.TenantId disabled></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" value=\"{{vc.data.RegDate | utcToLocal:\'yyyy-MM-dd HH:mm\'}}\" disabled></div></div></div><div class=row><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'SendNumber\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.SendNumber disabled></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'CertType\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CertTypeNm disabled></div></div><div class=col-lg-4><div class=\"form-group form-inline\"><label>{{ vc.columnMap[\'CertYN\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CertYNNm disabled></div></div></div><div class=row ng-show=\" vc.data.CertType ==\'MOBILE\' \"><div class=col-lg-6><div class=\"form-group form-inline\"><label style=\"font-size: 11px\">{{ vc.columnMap[\'ImpUid\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.ImpUid disabled></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label style=\"font-size: 11px\">{{ vc.columnMap[\'MerchantUid\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.MerchantUid disabled></div></div></div><!-- file upload--><div class=row ng-show=\" vc.data.CertType ==\'DOCUMENT\' \"><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div><table class=\"table table-hover table-striped invoice-list no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"><col style=\"width: 50px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th><th><span>{{ \'Menu.DELETE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.uploadFileList\"><tr id=filectl_{{fli.id}} ng-if=\"fli.dirtyFlag !=\'D\'\"><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td><td><div class=form-group><md-checkbox md-no-ink=\"\" ng-model=fli.delState ng-true-value=\"\'delete\'\" ng-false-value=\"\'\'\" class=\"md-warn ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox></md-checkbox></div></td></tr></tbody></table></div></div></div><div class=row><!-- 사용자정의 컬럼 등록/수정 --><udc-edit meta-list=vc.allColumns meta-model=vc.data></udc-edit></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div>");
$templateCache.put("app/message/sms-send-number-list.html","<div class=\"page page-footable\" ng-controller=\"SmsSendNumberListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>SMS 발송번호 인증 관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SendNumber placeholder=\"발신번호 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateFrom = (vc.RegDateFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateFrom ng-required=false placeholder=\"{{vc.columnMap[\'RegDateFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'RegDateTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.RegDateTo = (vc.RegDateTo | date: \'yyyy-MM-dd\')\" ng-model=vc.RegDateTo ng-required=false placeholder=\"{{vc.columnMap[\'RegDateTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CertType\'].CodeList\" code-model=vc.srch.CertType></common-code-custom><label>{{vc.columnMap[\'CertType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CertYN\'].CodeList\" code-model=vc.srch.CertYN></common-code-custom><label>{{vc.columnMap[\'CertYN\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-danger\" ng-click=vc.setDelList()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=7>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId,li.FormTypeId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/message/sms-send-number-save.html","<div class=\"page page-footable\" ng-controller=\"SmsSendNumberSaveCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>SMS 발송번호 인증<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=col-lg-12 ui-keypress=\"{13:\'vc.getList()\'}\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>발신번호인증</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><form ng-submit=vc.saveData()><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>발신번호</label><input type=text class=form-control ng-model=vc.data.SendNumber ng-required=true></div></div><div class=col-lg-6><div class=\"form-group form-inline\"><label>인증방법</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\" title=\"휴대폰 본인인증\"><label class=custom-radio-btn title=\"휴대폰 본인인증\"><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-valid-parse ng-touched\" type=radio value=MOBILE ng-model=vc.data.CertType ng-checked=\"vc.data.CertType == \'MOBILE\'\" ng-change=\"vc.setChangeRadioBtn(\'MOBILE\');\" aria-invalid=false checked> <span class=helping-el></span> <span class=\"label-text ng-binding\">휴대폰 본인인증</span></label></div><div class=\"radio-inline ng-scope\" title=\"통신서비스 이용증명원\"><label class=custom-radio-btn title=\"통신서비스 이용증명원\"><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=DOCUMENT ng-model=vc.data.CertType ng-checked=\"vc.data.CertType == \'DOCUMENT\'\" ng-change=\"vc.setChangeRadioBtn(\'DOCUMENT\');\" aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">통신서비스 이용증명원</span></label></div></div></div></div></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><button type=button class=\"btn btn-primary\" activate-button ng-click=vc.setVerifyData();><i class=\"fa fa-edit\"></i> 등록</button> <button type=button class=\"btn btn-danger\" activate-button type=button ng-click=vc.setDelList(); ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><div class=row><div class=\"col-lg-12 text-right\" style=padding-bottom:8px><div class=\"form-group form-inline\" ng-if=vc.showUploader><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div></div></form></div></div></div></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=7>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div></div></div></div><!-- /page content --></div>");
$templateCache.put("components/emailCollection/emailCollection.html","<!-- email --><section id=emailCollection class=\"subPageWrap mtb100 sub_w720\"><!-- section#qna --><div class=\"sp_header mb30\"><div class=eland_content><h2 class=title>이메일무단수집거부</h2><p class=sub_title>[이랜드재단 플랫폼 ‘SOS위고’의 이메일무단수집거부]</p></div></div><div class=sp_container><div class=eland_content><section><p>이메일무단수집거부 시행일 : 2021-06-04<br><br>웹사이트에 게시된 이메일 주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를 위반 시 정보통신망 법에 의해 형사 처벌됨을 유념하시기 바랍니다.</p></section></div></div><!-- // section#qna --></section><!-- // email -->");
$templateCache.put("components/notice/faq.html","<!-- faq --><section id=faq class=\"subPageWrap mtb100\"><!-- section#faq --><div class=\"sp_header mb30\"><div class=eland_content><h2 class=title>자주묻는질문(FAQ)</h2></div></div><div class=sp_container><div class=eland_content><table class=tb_board><colgroup><col width=*><col width=100px></colgroup><thead><tr><th>제목</th><th>등록일</th></tr></thead><tbody><tr ng-repeat=\"item in faq.boardlist\" ng-click=faq.showDetail(item.BbsPostId)><td>{{item.Title}}</td><td class=date>{{item.RegDate | date:\'yyyy-MM-dd\'}}</td></tr></tbody></table></div></div><div class=\"sp_footer mt30\"><div class=eland_content><div class=footerWrap><div class=searchWrap><select name=\"\"><option value=\"\">제목,내용</option></select><input type=text ng-model=faq.srch.searchValue placeholder=\"검색어를 입력해주세요\" ng-keypress=faq.searchValueKeyPress($event);> <button ng-click=faq.getSearch()><i class=\"glyphicon glyphicon-search\"></i></button></div><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=faq.totalItems ng-model=faq.currentPage total-items=faq.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=faq.pageChanged() direction-links=true boundary-links=true num-pages=faq.numPages template-url=components/template/pagination.html rotate=false max-size=faq.maxSize items-per-page=faq.srch.viewSize></ul></div></div></div></div><!-- // section#faq --></section><!-- // faq -->");
$templateCache.put("components/notice/notice.html","<!-- notice --><section id=notice class=\"subPageWrap mtb100\"><!-- section#notice --><div class=\"sp_header mb30\"><div class=eland_content><h2 class=title>공지사항</h2></div></div><div class=sp_container><div class=eland_content><table class=tb_board><colgroup><col width=*><col width=100px></colgroup><thead><tr><th>제목</th><th>등록일</th></tr></thead><tbody><tr ng-repeat=\"item in notice.boardlist\" ng-click=notice.showDetail(item.BbsPostId)><td>{{item.Title}}</td><td class=date>{{item.RegDate | date:\'yyyy-MM-dd\'}}</td></tr></tbody></table></div></div><div class=\"sp_footer mt30\"><div class=eland_content><div class=footerWrap><div class=searchWrap><select name=\"\"><option value=\"\">제목,내용</option></select><input type=text ng-model=notice.srch.searchValue placeholder=\"검색어를 입력해주세요\" ng-keypress=notice.searchValueKeyPress($event);> <button ng-click=notice.getSearch()><i class=\"glyphicon glyphicon-search\"></i></button></div><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=notice.totalItems ng-model=notice.currentPage total-items=notice.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=notice.pageChanged() direction-links=true boundary-links=true num-pages=notice.numPages template-url=components/template/pagination.html rotate=false max-size=notice.maxSize items-per-page=notice.srch.viewSize></ul></div></div></div></div><!-- // section#notice --></section><!-- // notice --><script type=javascript>function entersearch(event) {\r\n    if(event.keyCode == 13) {\r\n			frm.sumit();\r\n		}\r\n  }</script>");
$templateCache.put("components/login/login-footer.html","<!-- footer--><div id=footer><div class=helpMenu><div class=help_content><div class=helpWrap><!--ul class=\"ul_h\">\r\n          <a ui-sref=\"login.notice({srch:\'\'})\" onClick=\"javascript:$(\'.szPopup_box\').hide();\"><li>공지사항</li></a>\r\n          <a ui-sref=\"login.faq({srch:\'\'})\" onClick=\"javascript:$(\'.szPopup_box\').hide();\"><li>자주 묻는 질문</li></a>\r\n          <a ui-sref=\"login.qna\" onClick=\"javascript:$(\'.szPopup_box\').hide();\"><li>1:1 문의하기</li></a>\r\n        </ul--><!--<p class=\"callInfo\">\r\n          <strong>문의 안내</strong>\r\n          <span class=\"red\"><strong>02-2644-0110</strong></span>\r\n          <span class=\"time\">AM 9:00 ~ PM 5:00</span>\r\n        </p>--></div></div></div><div class=footerMenu><div class=help_content><h1 class=\"logo grey\"><img src=../../assets/images/eland_logo_grey.png></h1><ul class=footerMenuWrap><li><ul class=ul_h><li>서울시 금천구 가산디지털 1로 186 204호</li><li>TEL. 02-2644-0110 (070-4241-9629)</li><li>FAX. 02-2644-0116</li></ul></li><li><ul class=ul_h><li>상호명 : 사회복지법인 이랜드복지재단</li><li>대표자명 : 정영일</li><li>고유번호 : 105-82-10361</li><li>soswego@daum.net</li></ul></li><li>COPYRIGHT(c) 2013 BY ELAND GROUP ALL RIGHTS RESERVED</li></ul><ul class=\"ul_h footer_menu\"><a ui-sref=login.termsOfService onclick=\"$(\'.szPopup_box\').hide()\"><li>이용약관</li></a><a ui-sref=login.privacyPolicy style=color:#FF0000 onclick=\"$(\'.szPopup_box\').hide()\"><li>개인정보처리방침</li></a><a ui-sref=login.emailCollection onclick=\"$(\'.szPopup_box\').hide()\"><li>이메일무단수집거부</li></a></ul></div></div></div><!-- // footer-->");
$templateCache.put("components/login/login-header.html","<!-- header--><div id=header class=elandCustom><div class=eland_content_custom><h1 class=logo><img src=../../assets/images/eland_logo.png ui-sref=login></h1><!--\r\n    <span class=\"right-button\"><button type=\"button\" class=\"primary_btn\" ui-sref=\"login\" ng-show=\"loginHeader.stateName != \'login\'\"><strong>로그인/회원가입</strong></button></span>\r\n    <span class=\"right-button\"><button type=\"button\" class=\"primary_btn\" ui-sref=\"{{loginHeader.url}}\" ng-click=\"signupTenant\" ng-show=\"loginHeader.stateName == \'login\'\"><strong>{{loginHeader.title}}</strong></button></span>\r\n    --><div class=eland_content_button-group><button class=primary_btn type=button ng-click=\"loginHeader.showNoticeDetail(\'1F63ENQ6GD\')\" onclick=\"$(\'.szPopup_box\').hide()\"><strong>사업안내</strong></button> <button class=primary_btn type=button ng-click=loginHeader.downloadFile()><strong>서식(신청/결과보고)</strong></button></div></div></div><!-- // header-->");
$templateCache.put("components/login/login.html","<div class=eland_wrapper><login-header></login-header><div id=container_><!-- container --><div ui-view><section id=login><div class=swiper-container><div class=swiper-wrapper><div class=swiper-slide><img class=swiper-slide-pc src=../../assets/images/main-img1.jpg alt=\"\"> <img class=swiper-slide-mb src=../../assets/images/main-img1-mb.jpg alt=\"\"></div><div class=swiper-slide><img class=swiper-slide-pc src=../../assets/images/main-img2.jpg alt=\"\"> <img class=swiper-slide-mb src=../../assets/images/main-img2-mb.jpg alt=\"\"></div></div><div class=swiper-pagination></div><div class=swiper-button-prev></div><div class=swiper-button-next></div></div><!-- section#login --><div class=eland_content_main><!-- 팝업공지 --><div class=szPopup_wrap><div class=szPopup_overlay></div><div class=szPopup_box><div class=szPopup_cont id=szPopup_cont_event><div ng-if=\"login.popLink.GoLink != null && login.popLink.GoLink != \'\'\"><a href={{login.popLink.GoLink}} target=_blank><img src={{login.popLink.ImgSrc}}></a></div><div ng-if=\"login.popLink.GoLink == null || login.popLink.GoLink == \'\'\"><img src={{login.popLink.ImgSrc}}></div></div><div class=szPopup_btn><a id=chkCloseToday ng-click=login.closePopupToday(); class=close_day style=cursor:pointer>오늘 하루 그만보기</a> <a ng-click=login.closePopup(); style=cursor:pointer>닫기</a></div></div></div><!--\r\n          <div class=\"loginBtnWrap\">\r\n            <button type=\"button\" ui-sref=\"login.notice({srch:\'\'})\" onClick=\"javascript:$(\'.szPopup_box\').hide();\"><strong>공지사항</strong></button>\r\n            <button type=\"button\" ui-sref=\"login.faq({srch:\'\'})\" onClick=\"javascript:$(\'.szPopup_box\').hide();\"><strong>자주 묻는 질문</strong></button>\r\n            <button type=\"button\" onClick=\"javascript:$(\'.szPopup_box\').hide();window.open(\'https://pf.kakao.com/_Fixnxgxj\');\"><strong>1:1 문의하기</strong></button>\r\n          </div>--><div class=main-wrap><form ui-keypress=\"{13:\'login.doLogin()\'}\" ng-submit=login.doLogin() class=main-form><div class=loginWrap><div class=loginWrapTitle><strong>SOS위고 신청하기</strong></div><div class=loginInputWrap><input type=text name=txtLoginID title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" maxlength=40 id=loginId placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" ng-model=login.loginInfo.loginId ng-required=true> <input type=password name=txtPassword title=\"{{\'LOGIN.TITLE.I.n-login-bodyNST_PW\'|translate}}\" maxlength=40 id=loginPw placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" maxlength=20 ng-model=login.loginInfo.loginPw ng-required=true> <input type=checkbox name=ckID id=ckID ng-checked=\"login.loginInfo.saveId === \'1\'\" ng-model=login.loginInfo.saveId ng-true-value=\"\'1\'\" ng-false-value=\"\'\'\" tabindex=3><label for=ckID>아이디 저장</label><div class=login-button-wrap><button type=submit><strong>로그인</strong></button> <button type=button ui-sref=signupTenant><strong>회원가입</strong></button></div><p class=loginInfo>회원가입 후 신청 가능합니다</p><ul class=\"login_find ul_h\"><li><span ng-click=\"login.findIdPwd(\'IU\')\">아이디 찾기</span></li><li><span ng-click=\"login.findIdPwd(\'PU\')\">비밀번호 찾기</span></li></ul></div></div></form><div class=\"notice-section main-section\"><div class=main-section-title-wrap><div class=main-section-title><strong>공지사항</strong></div><button class=main-section-more ui-sref=\"login.notice({srch:\'\'})\" onclick=\"$(\'.szPopup_box\').hide()\"><svg xmlns=http://www.w3.org/2000/svg width=32 height=32 viewBox=\"0 0 32 32\" fill=none><path d=\"M16 4V28M4 16H28\" stroke=black stroke-width=1.6 stroke-linecap=round stroke-linejoin=round /></svg></button></div><div class=main-section-list-wrap><ul class=main-section-list><li class=main-section-item ng-repeat=\"item in login.noticeList\" ng-click=\"login.showDetail(item.BbsPostId, \'notice\')\"><!--button class=\"btn-notice btn-xs\">공지</button--><p class=main-section-text>{{item.Title}}</p></li></ul></div></div><div class=\"faq-section main-section\"><div class=main-section-title-wrap><div class=main-section-title><strong>자주 묻는 질문</strong></div><button class=main-section-more ui-sref=\"login.faq({srch:\'\'})\" onclick=\"$(\'.szPopup_box\').hide()\"><svg xmlns=http://www.w3.org/2000/svg width=32 height=32 viewBox=\"0 0 32 32\" fill=none><path d=\"M16 4V28M4 16H28\" stroke=black stroke-width=1.6 stroke-linecap=round stroke-linejoin=round /></svg></button></div><div class=main-section-list-wrap><ul class=main-section-list><li class=main-section-item ng-repeat=\"item in login.faqList\" ng-click=\"login.showDetail(item.BbsPostId, \'faq\')\"><a><p class=main-section-text>{{item.Title}}</p></a></li></ul></div></div></div></div><!-- // section#login --></section></div><!-- // container --></div><login-footer></login-footer></div>");
$templateCache.put("components/login/signup-first-step.html","<div class=\"eland_wrapper elandCustom\"><login-header></login-header><div id=container_><!-- container --><section class=\"joinStepWrap mtb50\"><!-- section.joinStepWrap--><div class=eland_content><h2>회원 가입</h2><span class=now>01. 약관 동의</span></div><!-- // section.joinStepWrap--></section><section class=\"inputInfoWrap mtb50\"><!-- section.joinStep --><div class=eland_content><div class=joinItem><h3>회원 약관</h3><div class=agreeContent><textarea readonly>\r\n시행일 : 2019-11-08\r\n내용 :\r\n1조(목적)\r\n이 약관은 사회복지법인 이랜드복지재단 및 재단법인 이랜드재단(이하 \"이랜드CSR\"이라 함)이 운영하는 홈페이지 (이하 “사이트”라 함)에서 제공하는 인터넷 관련 서비스를 이\r\n용함에 있어 사이트와 이용자의 권리/의무 및 책임사항과 기타 필요한 사항을 규정함을 목적으로 합니다.\r\n제2조(정의)\r\n본 약관에서 사용하는 용어의 정의는 다음과 같습니다.\r\n1.     \"서비스\"라 함은 구현되는 단말기(PC, TV, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 \"이용자\"가 이용할 수 있는 이랜드CSR 및 이랜드CSR 관련 제반 서비스를 의미합니다.\r\n2.     “이용자”란 “사이트”에 접속하여 이 약관에 따라 \"이랜드CSR\"이 제공하는 서비스를 받는 회원 및 비회원을 말합니다.\r\n3.     “홈페이지 회원(이하 \"회원\"이라 함)\"이라 함은 \"이랜드CSR\"의 \"사이트\"에 접속하여 이 약관에 따라 \"이랜드CSR\"과 이용계약을 체결하고 \"이랜드CSR\"이 제공하는 \"사이트\"를 이용하는 이용자ID(아이디)를 부여 받은 자를 말합니다.\r\n4.     “이랜드직원 회원”이라 함은 이랜드CSR의 이삭줍기기금/1%나눔클럽(정기기부)/1%나눔클럽(해외아동양육)에 참여하기 위해 기부금을 정기적으로 납부하는 이랜드 임직원 개인을 말합니다.\r\n5.     “비회원”이라 함은 회원에 가입하지 않고 \"이랜드CSR\"이 제공하는 서비스를 이용하는 자를 말합니다.\r\n6.     \"이용계약\"이라 함은 서비스 이용과 관련하여 \"이랜드CSR\"과 이용자 간에 체결하는 계약을 말합니다.\r\n7.     \"아이디(ID)\"라 함은 \"회원\"의 식별과 \"서비스\" 이용을 위하여 \"회원\"이 정하고 \"이랜드CSR\"이 승인하는 문자와 숫자의 조합을 의미합니다\r\n8.     \"비밀번호\"라 함은 \"회원\"이 부여 받은 \"아이디와 일치되는 \"회원\"임을 확인하고 비밀보호를 위해 \"회원\" 자신이 정한 문자 또는 숫자의 조합을 의미합니다.\r\n9.     \"회원탈퇴(이하 \"탈퇴\"라 함)\"라 함은 \"회사\" 또는 \"회원\"이 홈페이지 이용계약을 해약하는 행위를 말합니다.\r\n10.   “기부해지”라 함은 “이랜드직원”이 홈페이지 회원탈퇴와는 별도로 기부를 중단하는 행위를 말합니다.\r\n11.   \"게시물\"이라 함은 \"회원\"이 \"서비스\"를 이용함에 있어 \"서비스상\"에 게시한 부호ㆍ문자ㆍ음성ㆍ음향ㆍ화상ㆍ동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미합니다.\r\n본 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관계 법령 및 서비스 운영 기준에서 정하는 바에 의합니다.\r\n제3조 (약관의 게시와 개정)\r\n1.     \"이랜드CSR\"은 이 약관의 내용을 \"이용자\"가 쉽게 알 수 있도록 서비스 초기 화면에 게시합니다. 다만, 약관의 내용은 이용자가 연결화면을 통하여 볼 수 있도록 할 수 있습니다.\r\n2.     \"이랜드CSR\"은 약관의 규제에 관한 법률, 정보 통신망 이용 촉진 및 정보보호 등에 관한 법률 등 관련법을 위배하지 않는 범위에서 이 약관을 개정할 수 있습니다.\r\n3.     \"이랜드CSR\"이 약관을 개정할 경우에는 적용일자 및 개정사유를 명시하여 현행약관과 함께 사이트의 초기화면에 그 적용일자 7일 이전부터 적용일자 전일까지 공지합니다.다만, 회원에게 불리한 약관의 개정의 경우에는 공지 외에 일정기간 서비스 내 전자우편, 전자쪽지, 로그인시 동의창 등의 전자적 수단을 통해 따로 명확히 통지하도록 합니다.\r\n4.     \"이랜드CSR\"이 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 7일 기간 내에 의사표시를 하지 않으면 의사표시가 표명된 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.\r\n5.     회원이 개정약관의 적용에 동의하지 않는 경우 \"이랜드CSR\"은 개정 약관의 내용을 적용할 수 없으며, 이 경우 회원은 이용계약을 해지할 수 있습니다. 다만, 기존 약관을 적용할 수 없는 특별한 사정이 있는 경우에는 \"이랜드CSR\"은 이용계약을 해지할 수 있습니다.\r\n제 4조(약관의 해석)\r\n본 약관에서 명시하지 않은 사항은 전기통신사업법 등 관계 법령 또는 상관례에 따릅니다.\r\n제 5조 (이용계약의 성립)\r\n1.     이용계약은 이용자의 본 약관에 대한 동의와 이용신청에 대하여 \"이랜드CSR\"이 이를 승낙함으로써 성립합니다.\r\n2.     이용신청 당시, 이용자가 회원가입 페이지의 \'동의\'버튼을 누름으로써 본 약관에 동의하는 것으로 간주됩니다.\r\n제 6조(이용계약의 체결)\r\n1.     이용계약은 \"회원\"이 되고자 하는 자가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 \"이랜드CSR\"이 이러한 신청에 대하여 승낙함으로써 체결됩니다.\r\n2.     \"이랜드CSR\"은 \"회원\"이 되고자 하는 자의 신청에 대하여 \"서비스\" 이용을 승낙함을 원칙으로 합니다. 다만, \"이랜드CSR\"은 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.\r\n① 실명이 아니거나 타인의 명의를 이용한 경우\r\n② 14세 미만 아동\r\n③ 이용자의 귀책사유로 인하여 승인이 불가능하거나 기타 규정한 제반 사항을 위반하며 신청하는 경우\r\n④ 부정한 용도로 본 서비스를 이용하고자 하는 경우\r\n⑤ 사회의 안녕과 질서, 미풍양속을 저해할 목적으로 신청한 경우\r\n⑥ 허위정보를 기재하거나, \"이랜드CSR\"이 제시하는 내용을 기재하지 않은 경우\r\n3.     \"이랜드CSR\"은 \"회원\"의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.\r\n4.     제2항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, \"이랜드CSR\"은 원칙적으로 이를 가입신청자에게 알리도록 합니다.\r\n5.     이용계약의 성립 시기는 \"이랜드CSR\"이 가입완료를 신청절차 상에서 표시한 시점으로 합니다.\r\n제 7조(회원 탈퇴 및 자격 상실 등-계약 해제, 해지, 회원탈퇴 등)\r\n1.     회원은 \"이랜드CSR\"에 언제든지 탈퇴를 요청할 수 있으며 \"이랜드CSR\"은 즉시 회원탈퇴를 처리합니다.\r\n2.     기부회원인 경우, 홈페이지 회원 이용계약 해지와는 별도로 기부 중단을 원할 경우 중단 의사를 홈페이지를 통하거나 전화 등을 통해 의사를 밝혀야 합니다. 기부 중단의 경우에 추후 각종 증명서 발급 등에 필요한 일부 개인정보는 회원관리 업무를 위해 1년간 보유하며 이미 기부하신 기부금은 반환되지 않습니다.\r\n3.     홈페이지 회원이면서 기부회원인 경우, 홈페이지 탈퇴와 기부 중단을 요청하는 경우에도 추후 각종 증명서 발급 등에 필요한 일부 개인정보는 회원관리 업무를 1년간 보유합니다. 다만 홈페이지 회원 혹은 기부회원이 개인정보 삭제를 요청할 경우 등록되어 있는 개인정보를 폐기하며, 개인정보 폐기 후에는 추후 발생될 수 있는 각종 증명서 발급 등의 회원관리 업무를 지원하지 않습니다.\r\n4.     “회원”이 계약을 해지할 경우, 관련법 및 개인정보처리방침에 따라 “재단”이 회원정보를 보유하는 경우를 제외하고는 해지 즉시 “회원”의 모든 데이터는 소멸됩니다.\r\n5.     “회원”이 계약을 해지하는 경우, “회원”이 게시판에 등록한 “게시물” 등은 삭제되지 않으니 사전에 삭제 후 탈퇴하시기 바랍니다.\r\n6.     회원이 개정 약관의 적용에 동의하지 않는 경우 재단은 개정 약관의 내용을 적용할 수 없으며, 이 경우 회원은 “이용계약”을 해지할 수 있습니다.\r\n7.     회원이 다음 각 호의 사유에 해당하는 경우, \"이랜드CSR\"은 회원자격을 제한 및 정지시킬 수 있습니다.\r\n1)     가입 신청 시에 허위 내용을 등록한 경우\r\n2)     다른 사람의 “사이트” 이용을 방해하거나 그 정보를 도용하는 등 질서를 위협하는 경우\r\n3)     “사이트”를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우\r\n8.     \"이랜드CSR\"이 회원 자격을 제한/정지 시킨 후, 동일한 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 \"이랜드CSR\"은 회원자격을 상실시킬 수 있습니다.\r\n9.     \"이랜드CSR\"이 회원자격을 상실시키는 경우에는 회원등록을 말소합니다. 이 경우 회원에게 이를 통지하고, 회원등록 말소 전에 최소한 30일 이상의 기간을 정하여 소명할 기회를 부여합니다.\r\n제 8조(회원에 대한 통지)\r\n1.     \"이랜드CSR\"이 \"회원\"에 대한 통지를 하는 경우 이 약관에 별도 규정이 없는 한 서비스 내 전자우편주소, 서신우편, 휴대전화, 휴대전화 문자메세지, 유선전화, “서비스” 내 팝업 등으로 할 수 있습니다.\r\n2.     \"이랜드CSR\"은 \"회원\" 전체에 대한 통지의 경우 7일 이상 \"이랜드CSR\"의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.\r\n제 9조(개인정보보호)\r\n1.     \"이랜드CSR\"은 \"정보통신망 이용촉진 및 정보보호 등에 관한 법률(이하 ‘정보통신망법’이라 합니다)” 등 관계 법령이 정하는 바에 따라 \"회원\"의 개인정보를 보호하기 위해 노력합니다. “회원”의 개인정보보호에 관한 사항은 관계법령 및 “이랜드CSR”의 개인정보처리방침에 정한 바에 따릅니다. 다만, \"이랜드CSR\"의 공식 사이트 이외의 링크된 사이트에서는 \"이랜드CSR\"의 개인정보처리방침이 적용되지 않습니다. 또한 \"이랜드CSR\"은 \"회원\"의 귀책사유로 인해 노출된 정보에 대해서 일체의 책임을 지지 않습니다.\r\n제 10조(개인정보변경)\r\n1.     \"회원\"은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 생년월일, 아이디 등은 수정이 불가능합니다.\r\n제 11조(회원의 ID 및 비밀번호에 대한 의무)\r\n1.     회원의 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.\r\n2.     회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안됩니다.\r\n3.     “이랜드CSR”은 “회원”의 “ID”가 개인정보유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 제3자가 “회원”을 “이랜드CSR” 또는 “이랜드CSR”의 운영자로 오인할 우려가 있는 경우, 해당 “ID”의 이용을 제한할 수 있습니다.\r\n4.     회원이 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 \"이랜드CSR\"에 통보하고 \"이랜드CSR\"의 안내가 있는 경우에는 그에 따라야 합니다.\r\n5.     제3항의 경우에 해당 \"회원\"이 \"이랜드CSR\"에 그 사실을 통지하지 않거나, 통지한 경우에도 \"이랜드CSR\"의 안내에 따르지 않아 발생한 불이익에 대하여 \"이랜드CSR\"은 책임지지 않습니다.\r\n제 12조(회원의 의무)\r\n1.     회원은 다음 행위를 하여서는 안됩니다.\r\n1)     회원가입신청 또는 개인정보 변경 시 허위 내용의 등록\r\n2)     타인의 정보 도용\r\n3)     \"이랜드CSR\"에 게시된 정보의 변경\r\n4)     \"이랜드CSR\"의 운영진, 직원 또는 관계자를 사칭하는 행위\r\n5)     \"이랜드CSR\"이 정한 정보 이외의 정보(컴퓨터 프로그램 등) 등의 송신 또는 게시\r\n6)     “회사” 기타 제3자의 저작권 등 지적재산권에 대한 침해\r\n7)     “회사” 기타 제3자의 명예를 손상시키거나 업무를 방해하는 행위\r\n8)     외설 또는 폭력적인 메시지, 화상, 음성, 기타 사회질서에 반하는 정보를 ‘사이트“에 공개 또는 게시하는 행위\r\n9)     \"이랜드CSR\"의 동의 없이 영리를 목적으로 \"서비스\"를 사용하는 행위\r\n10)  기타 불법적이거나 부당한 행위\r\n2.     “회원\"은 관계법, 이 약관의 규정, 이용안내 및 \"서비스\"와 관련하여 공지한 주의사항, \"이랜드CSR\"이 통지하는 사항 등을 준수하여야 하며, 기타 \"이랜드CSR\"의 업무에 방해되는 행위를 하여서는 안 됩니다.\r\n제 13조 (서비스의 제공 등)\r\n1.     이랜드CSR”은 본 “서비스”를 이용하는 “회원”을 등급별로 구분하여 이용시간, 이용횟수, “서비스”메뉴 등의 이용에 차등을 둘 수 있습니다.\r\n2.     \"서비스\"는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.\r\n3.     \"이랜드CSR\"은 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 상당한 이유가 있는 경우 \"서비스\"의 제공을 일시적으로 중단할 수 있습니다. 이 경우 \"이랜드CSR\"은 제8조 [회원에 대한 통지]에 정한 방법으로 \"회원\"에게 통지합니다. 다만, \"이랜드CSR\"이 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.\r\n4.     \"이랜드CSR\"은 서비스의 제공에 필요한 경우 정기점검을 실시할 수 있으며, 정기점검시간은 서비스제공화면에 공지한 바에 따릅니다.\r\n제 14조 (서비스의 변경)\r\n1.     \"이랜드CSR\"은 상당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 \"서비스\"를 변경할 수 있습니다.\r\n2.     \"서비스\"의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경사유, 변경될 서비스의 내용 및 제공일자 등은 그 변경 전 7일 이상 해당 서비스 초기화면에 게시하여야 합니다.\r\n제 15조 (정보의 제공 및 광고의 게재)\r\n1.     \"이랜드CSR\"은 \"회원\"이 \"서비스\" 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편, 휴대전화, 휴대전화 문자메세지 등의 방법으로 \"회원\"에게 제공할 수 있습니다. 다만, \"회원\"은 관련법에 따른 거래관련 정보 및 긴급/필수고지사항 관련정보, 고객문의 등에 대한 답변 등을 제외하고는 언제든지 전자우편 등에 대해서 수신 거절을 할 수 있습니다.\r\n2.     제1항의 정보를 전화 및 팩스에 의하여 전송하려고 하는 경우에는 \"회원\"의 사전 동의를 받아서 전송합니다. 다만, \"회원\"의 고객문의 등에 대한 회신에 있어서는 제외됩니다.\r\n3.     \"이랜드CSR\"은 \"서비스\"의 운영과 관련하여 서비스 화면, 홈페이지, 전자우편 등에 광고를 게재할 수 있습니다. 광고가 게재된 전자우편 등을 수신한 \"회원\"은 수신거절을 \"이랜드CSR\"에게 할 수 있습니다.\r\n제 16조 (게시물의 저작권)\r\n1.     \"회원\"이 \"서비스\" 내에 게시한 \"게시물\"의 저작권은 해당 게시물의 저작자에게 귀속됩니다.\r\n2.     \"회원\"이 \"서비스\" 내에 게시하는 \"게시물\"은 검색결과 내지 \"서비스\" 및 관련 프로모션 등에 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정, 복제, 편집되어 게시될 수 있습니다. 이 경우, \"이랜드CSR\"은 저작권법 규정을 준수하며, \"회원\"은 언제든지 고객센터 또는 \"서비스\" 내 관리기능을 통해 해당 게시물에 대해 삭제, 검색결과 제외, 비공개 등의 조치를 취할 수 있습니다.\r\n3.     \"이랜드CSR\"은 제2항 이외의 방법으로 \"회원\"의 \"게시물\"을 이용하고자 하는 경우에는 전화, 팩스, 전자우편 등을 통해 사전에 \"회원\"의 동의를 얻어야 합니다.\r\n제 17조 (게시물의 관리)\r\n1.     \"회원\"의 \"게시물\"이 \"정보통신망법\" 및 \"저작권법\"등 관련법에 위반되는 내용을 포함하는 경우, 권리자는 관련법이 정한 절차에 따라 해당 \"게시물\"의 게시중단 및 삭제 등을 요청할 수 있으며, \"이랜드CSR\"은 관련법에 따라 조치를 취하여야 합니다.\r\n2.     \"이랜드CSR\"은 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련법에 위반되는 경우 등 다음 각 호에 해당하는 “게시물”에 대해 사전통지 없이 삭제하거나 이동 또는 등록 거부를 할 수 있습니다.\r\n1)     다른 회원 또는 제3자에게 심한 모욕을 주거나 명예를 손상시키는 내용인 경우\r\n2)     공공질서 및 미풍양속에 위반되는 내용을 유포하거나 링크시키는 경우\r\n3)     불법복제 또는 해킹을 조장하는 내용인 경우\r\n4)     영리를 목적으로 하는 광고일 경우\r\n5)     범죄와 결부된다고 객관적으로 인정되는 내용일 경우\r\n6)     다른 이용자 또는 제3자의 저작권 등 기타 권리를 침해하는 내용인 경우\r\n7)     \"이랜드CSR\"에서 규정한 게시물 운영정책에 어긋나거나, 게시판 성격에 부합하지 않는 경우\r\n8)     기타 관계법령에 위배된다고 판단되는 경우\r\n제 18조 (권리의 귀속)\r\n1.     \"서비스\"에 대한 저작권 및 지적재산권은 \"이랜드CSR\"에 귀속됩니다. 단, \"회원\"의 \"게시물\" 및 제휴계약에 따라 제공된 저작물 등은 제외합니다.\r\n2.     \"이랜드CSR\"은 서비스와 관련하여 \"회원\"에게 \"이랜드CSR\"이 정한 이용조건에 따라 계정, \"아이디\", 콘텐츠 등을 이용할 수 있는 이용권만을 부여하며, \"회원\"은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.\r\n제 19조 (이용제한 등)\r\n1.     이랜드CSR\"은 \"회원\"이 이 약관의 의무를 위반하거나 \"서비스\"의 정상적인 운영을 방해한 경우, 경고, 일시정지, 영구이용정지 등으로 \"서비스\" 이용을 단계적으로 제한할 수 있습니다.\r\n2.     \"이랜드CSR\"은 전항에도 불구하고, \"주민등록법\"을 위반한 명의도용 및 결제도용, \"저작권법\" 및 \"컴퓨터프로그램보호법\"을 위반한 불법프로그램의 제공 및 운영방해, \"정보통신망법\"을 위반한 불법통신 및 해킹, 악성프로그램의 배포, 접속권한 초과행위 등과 같이 관련법을 위반한 경우에는 즉시 영구이용정지를 할 수 있습니다. 본 항에 따른 영구이용정지 시 \"서비스\" 이용을 통해 획득한 정보와 혜택 등도 모두 소멸되며, \"이랜드CSR\"은 이에 대해 별도로 보상하지 않습니다.\r\n3.     본 조에 따라 \"서비스\" 이용을 제한하거나 계약을 해지하는 경우에는 \"이랜드CSR\"은 제8조 [회원에 대한 통지]에 따라 통지합니다.\r\n4.     \"회원\"은 본 조에 따른 이용제한 등에 대해 \"이랜드CSR\"이 정한 절차에 따라 이의신청을 할 수 있습니다. 이 때 이의가 정당하다고 \"이랜드CSR\"이 인정하는 경우 \"이랜드CSR\"은 즉시 \"서비스\"의 이용을 재개합니다.\r\n제 20조 (책임제한)\r\n1.     \"이랜드CSR\"은 천재지변 또는 이에 준하는 불가항력으로 인하여 \"서비스\"를 제공할 수 없는 경우에는 \"서비스\" 제공에 관한 책임이 면제됩니다.\r\n2.     \"이랜드CSR\"은 \"회원\"의 귀책사유로 인한 \"서비스\" 이용의 장애에 대하여는 책임을 지지 않습니다.\r\n3.     \"이랜드CSR\"은 \"회원\"이 \"서비스\"와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.\r\n4.     \"이랜드CSR\"은 \"회원\" 간 또는 \"회원\"과 제3자 상호간에 \"서비스\"를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.\r\n5.     \"이랜드CSR\"은 무료로 제공되는 서비스 이용과 관련하여 관련법에 특별한 규정이 없는 한 책임을 지지 않습니다.\r\n6.     \"이랜드CSR\"은 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 발생한 손해에 대한 책임이 면제됩니다.\r\n7.     \"이랜드CSR\"은 이용자의 컴퓨터 오류에 의해 손해가 발생한 경우, 또는 \"회원\"이 신상정보 및 전자우편 주소를 부실하게 기재하여 손해가 발생한 경우 책임을 지지 않습니다.\r\n제 21조(재판권 및 준거법)\r\n1.     \"이랜드CSR\"과 \"회원\" 간 제기된 소송은 대한민국법을 준거법으로 합니다.\r\n2.     \"이랜드CSR\"과 \"회원\" 간 발생한 분쟁에 관한 소송은 민사소송법 상의 관할법원에 제소합니다.\r\n제 22조(기부금의 사용)\r\n1.   기부금은 이랜드CSR을 통해 인큐베이팅, 해외아동양육에 사용됩니다.\r\n2.   기부금 내역은 이랜드CSR 홈페이지-투명경영-기부금내역 페이지에서 피드백하며 이랜드복지재단, 이랜드재단에 문의하시면 개별내역을 확인하실 수 있습니다. *문의 : webmaster@elandwelfare.or.kr\r\n3.     기부금 내역은 인큐베이팅/해외아동양육에 따라 피드백하며 모든 기부금은 100% 지원을 위해 사용됩니다.\r\n4.     이미 기관에 기부하신 기부금은 환불이 되지 않습니다.\r\n\r\n부칙\r\n이 약관은 2019년 11월 8일부터 적용됩니다.\r\n이전내용보기\r\n이용약관(2017-07-06 적용)\r\n              </textarea><div class=agreeWrap><p><input ng-false-value=\"\'N\'\" ng-model=vc.data.agreeYN_1 ng-true-value=\"\'Y\'\" type=checkbox id=chkAgree1><label for=chkAgree1 class=ng-binding>회원 약관에 동의합니다</label></p></div></div></div><div class=joinItem><h3>개인정보 수집 및 이용에 대한 안내</h3><p class=subDesc>이랜드재단(이하 ‘재단’)은 플랫폼 ‘SOS위고’(이하 본 ‘사이트‘)를 통하여 위기가정을 지원하는 기관(이하 ‘후원기관’)과 지원이 필요한 대상자 사례를 제공하는 기관(이하 ‘사례관리기관’)을 연결하고 있습니다. 본 사이트의 운영을 위하여 후원기관과 사례관리기관 및 협력기관 (이하 ‘기관 등‘)의 담당자의 개인정보를 수집ㆍ이용ㆍ제공하고 있으며, 수집한 정보는 본 사이트 운영 목적 외의 용도로 이용하지 않습니다. 아래 사항을 충분히 읽은 후 동의하여 주시기 바랍니다.</p><div class=agreeContent><p class=subTitle>1. 개인정보의 수집·이용 동의</p><textarea readonly>\r\n가. 목적 : ‘기관 등’의 회원 자격 검증, 지원사업(지원대상자 선정, 후원금 모금 및 전달, 후원자 피드백, 부정신청 또는 중복지원 방지, 민원처리 등)을 위한 소통 및 자료 송ㆍ수신\r\n\r\n나. 항목 : ‘기관 등‘의 담당자 정보(성명, ID, 비밀번호, 전자메일주소, 전화번호),  본인인증 (CI,DI)\r\n  소속 기관 정보(기관명, 대표자명, 대표전화번호, 팩스, 주소, 관심대상, 신청분야)\r\n\r\n다. 보유ㆍ이용 기간 : 지원사업 목적 달성 시까지, 관련 법령에서의 보유 의무기간까지\r\n\r\n라. 동의를 거부할 권리가 있으나, 동의 거부시 회원가입이 제한됩니다.\r\n            </textarea><div class=agreeWrap><p><input ng-false-value=\"\'N\'\" ng-model=vc.data.agreeYN_2 ng-true-value=\"\'Y\'\" type=checkbox id=chkAgree2><label for=chkAgree2 class=ng-binding>개인정보 수집·이용에 동의합니다</label></p></div></div><div class=agreeContent><p class=subTitle>2. 개인정보 제3자 제공 동의</p><textarea readonly>\r\n가. 개인정보를 제공받는 자 : 후원기관, 사례관리기관, 지원사업의 협력기관 및 후원처\r\n※ 제공받는 자 명단은 플랫폼 ‘SOS위고’(https://soswego.co.kr)에서 확인가능\r\n\r\n나. 개인정보를 제공받는 자의 개인정보 이용 목적 : 지원사업(지원대상자 선정, 후원금 모금 및 전달, 후원자 피드백, 부정신청 또는 중복지원 방지, 민원처리 등)을 위한 소통 및 자료 송ㆍ수신\r\n\r\n다. 제공하는 개인정보의 항목 : ‘기관 등‘의 담당자 정보(성명, ID, 비밀번호, 전자메일주소, 전화번호),  본인인증 (CI,DI), 소속 기관 정보(기관명, 대표자명, 대표전화번호, 팩스, 주소, 관심대상, 신청분야)\r\n\r\n라. 개인정보를 제공받는 자의 개인정보 보유 및 이용 기간 \r\n            : 제공받은 이용목적 달성 시까지, 관련 법령에서의 보유 의무기간까지\r\n\r\n마. 동의를 거부할 권리가 있으나, 동의 거부시 회원가입이 제한됩니다.\r\n            </textarea><div class=agreeWrap><p><input ng-false-value=\"\'N\'\" ng-model=vc.data.agreeYN_3 ng-true-value=\"\'Y\'\" type=checkbox id=chkAgree3><label for=chkAgree3 class=ng-binding>개인정보 제3자 제공에 동의합니다</label></p></div></div></div><div class=agreeWrap><p><input ng-false-value=\"\'N\'\" ng-model=vc.data.agreeYN ng-true-value=\"\'Y\'\" ng-change=vc.agreeAll() type=checkbox id=chkAgree><label for=chkAgree class=ng-binding>모든 약관에 동의합니다.</label></p></div><div class=\"buttonWrap mtb30\"><button class=cancel_btn ng-click=\"vc.signUpTenant(\'C\')\">취소</button> <button class=primary_btn ng-click=\"vc.signUpTenant(\'N\')\"><strong>다음단계</strong></button></div></div><!-- // section.joinStepWrap --></section><!-- // container --></div><login-footer></login-footer></div>");
$templateCache.put("components/login/signup-second-step.html","<div class=\"eland_wrapper elandCustom\"><login-header></login-header><div id=container_><!-- container --><section class=\"joinStepWrap mtb50\"><!-- section.joinStepWrap --><div class=eland_content><h2>회원 가입</h2><span class=now>02. 정보 입력</span></div><!-- // section.joinStepWrap--></section><section class=inputInfoWrap><!-- section.inputInfoWrap --><div class=eland_content><form name=frm ng-submit=\"vc.signUpTenant(\'R\')\" ng-keypress=keyPressHandler($event)><!-- 담당자 정보 --><div class=joinItem><h3>담당자 정보</h3><div class=itemContent><div><label>담당자 이름</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.UserNm placeholder=\"\" ng-disabled=\"vc.authYN == true\" ng-required=true></div><div><label>휴대폰 번호</label><span class=e>*</span> <input type=text ng-model=vc.data.Mobile auto-hyphen ng-disabled=\"vc.authYN == true\" ng-required=true> <button type=button class=default_btn ng-click=vc.authMob()><span ng-if=\"vc.authYN == false\">본인 인증</span><span ng-if=\"vc.authYN == true\">인증 완료</span></button></div><div><label>이메일</label><span class=e>*</span> <input type=text ng-model=vc.data.Email3 ng-readonly=\"vc.data.TenantStatus == \'R\'\" ng-required=true></div></div></div><!-- 로그인 정보 --><div class=joinItem><h3>로그인 정보</h3><div class=itemContent><div><label>아이디</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.LoginId maxlength=20 placeholder=\"4~20자의 영문, 숫자 조합해 입력\" ng-blur=vc.chkLoginIdDup() ng-required=true><p class=\"desc not_pass\" id=loginid style=\"display: none\"><i class=\"glyphicon glyphicon-remove\"></i><span id=loginidTx>사용할 수 없는 아이디입니다.</span></p></div><div><label>비밀번호</label><span class=e>*</span> <input type=password class=txt_input ng-model=vc.data.Password maxlength=20 placeholder=\"영문, 숫자, 특수문자 포함 8~20자 조합해 입력\" ng-required=true></div><div><label>비밀번호 확인</label><span class=e>*</span> <input type=password class=txt_input ng-model=vc.data.Password2 maxlength=20 placeholder=\"비밀번호 확인\" ng-required=true><p class=\"desc not_pass\" ng-if=\"vc.data.Password2 != \'\' && vc.data.Password2 != null && vc.data.Password != vc.data.Password2\"><i class=\"glyphicon glyphicon-remove\"></i> 비밀번호를 다시 확인해 주세요.</p><p class=\"desc pass\" ng-if=\"vc.data.Password2 != \'\' && vc.data.Password2 != null && vc.data.Password == vc.data.Password2 && vc.chkPassId(\'PWD\')\"><i class=\"glyphicon glyphicon-ok\"></i> 비밀번호가 일치합니다.</p><p class=\"desc not_pass\" ng-if=\"vc.data.Password2 != \'\' && vc.data.Password2 != null && vc.data.Password == vc.data.Password2 && !vc.chkPassId(\'PWD\')\"><i class=\"glyphicon glyphicon-remove\"></i> 비밀번호 형식을 확인해주세요.(영문, 숫자, 특수문자 포함 8~20자 조합해 입력)</p></div></div></div><!-- 기관 정보 --><div class=joinItem><h3>기관 정보</h3><div class=itemContent><div><label>기관명</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.TenantNm placeholder=\"사업자명 입력\" ng-required=true></div><div><label>대표자명</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.Ceo placeholder=\"대표자명 입력\" ng-required=true></div><div><label>등록번호</label><span class=e>*</span> <input type=text class=txt_input maxlength=10 ng-model=vc.data.BizRegNo placeholder=\"사업자 등록번호 입력\" ng-required=true></div><div><label>대표 이메일</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.Email1 ng-required=true></div><div><label>대표 전화번호</label><span class=e>*</span> <input type=text class=txt_input ng-model=vc.data.TelNo auto-hyphen ng-required=true></div><div><label>FAX</label><input type=text class=txt_input ng-model=vc.data.Fax auto-hyphen></div><div><label>기관구분</label><span class=e>*</span><common-code-search code-list=vc.organizationList code-model=vc.data.organization_code></common-code-search></div><div ng-if=\"vc.data.organization_code == 57\"><label></label><common-code-search code-list=vc.organizationSubList code-model=vc.data.organizationSub_code></common-code-search></div><div><label>주소</label><span class=e>*</span><div class=addressWrap><div class=zipcodeWrap><input type=text class=zipcode maxlength=5 ng-model=vc.data.ZipCode readonly ng-required=true> <button type=button class=default_btn ng-click=vc.srchZipCodeModal() ng-if=\"vc.data.TenantStatus != \'R\'\"><i class=\"glyphicon glyphicon-search\"></i></button></div><input type=text ng-model=vc.data.Addr1 placeholder=\"기본 주소\" readonly> <input type=text ng-model=vc.data.Addr2 placeholder=\"상세 주소 입력\" ng-readonly=\"\"></div></div><div><label>설립년월일</label><div class=dateWrap><select class=form-control ng-model=vc.data.Year ng-options=\"option.value as option.year for option in vc.yearList\"><option selected value=\"\">-- 연 --</option></select><select class=form-control ng-model=vc.data.Month ng-options=\"option.value as option.month for option in vc.monthList\"><option selected value=\"\">-- 월 --</option></select><select class=form-control ng-model=vc.data.Day ng-options=\"option.value as option.day for option in vc.dayList\"><option selected value=\"\">-- 일 --</option></select></div></div><div><label>홈페이지</label><input type=text class=txt_input ng-model=vc.data.HomepageUrl placeholder=\"기관 홈페이지 URL 입력\"></div><div><label>기관 소개</label><textarea rows=5 ng-model=vc.data.TenantComment ng-readonly=\"\" placeholder=\"주요사업 중심으로 소개내용을 입력해 주세요.\"></textarea></div></div></div><!-- 후원기관 가입 시에만 출력 --><!-- 관심 정보 --><div class=joinItem ng-if=\"vc.TenantType ==\'G\'\"><h3>관심 정보</h3><div class=itemContent><div class=interestWrap><p><strong>관심대상 가정</strong> <a ng-click=refreshPriority()><i class=\"glyphicon glyphicon-refresh\"></i></a></p><div class=\"rankWrap mtb10\"><ul><li><input type=text id=priority0 ng-model=vc.data.priority0 placeholder=\"1순위 ( 필수입력 )\" readonly></li><li><input type=text id=priority1 ng-model=vc.data.priority1 placeholder=2순위 readonly></li><li><input type=text id=priority2 ng-model=vc.data.priority2 placeholder=3순위 readonly></li><li><input type=text id=priority3 ng-model=vc.data.priority3 placeholder=4순위 readonly></li><li><input type=text id=priority4 ng-model=vc.data.priority4 placeholder=5순위 readonly></li></ul><ul><li><button type=button id=priority_1 ng-click=\"selectPriority(\'0\');\" name=interest0></button></li><li><button type=button id=priority_2 ng-click=\"selectPriority(\'1\');\" name=interest1></button></li><li><button type=button id=priority_3 ng-click=\"selectPriority(\'2\');\" name=interest2></button></li><li><button type=button id=priority_4 ng-click=\"selectPriority(\'3\');\" name=interest3></button></li><li><button type=button id=priority_5 ng-click=\"selectPriority(\'4\');\" name=interest4></button></li></ul></div><div><ul class=\"ul_h li_mr15 etcList\"><li>[기타]</li><li ng-repeat=\"li in vc.etcList\"><label><input type=checkbox data-code={{li.Code}} data-idx={{$index}}> {{li.CodeValue}}</label></li></ul></div><div class=mt30><p><strong>관심설정</strong></p><ul class=\"ul_h mtb10 li_mr15 interestList\"><li ng-repeat=\"li in vc.interestList\"><label><input type=checkbox data-code={{li.Code}} data-idx={{$index}}> {{li.CodeValue}}</label></li></ul></div></div></div></div><!-- // 후원기관 가입 시에만 출력 --><!-- 사례관리기관 가입 시에만 출력 --><!-- 사업신청 경로 --><div class=joinItem ng-if=\"vc.TenantType ==\'T\'\"><div class=itemContent><div><label>사업신청 경로</label><span class=e>*</span><common-code-search code-list=vc.appPathList code-model=vc.data.AppPath></common-code-search></div></div></div><!-- // 사례관리기관 가입 시에만 출력 --><!-- 수신 동의 --><div class=agreeWrap><p ng-if=\"vc.TenantType ==\'T\'\"><label class=ng-binding><input ng-checked-=\"vc.data.BaseYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.BaseYN ng-true-value=\"\'Y\'\" type=checkbox> 우수네트워크 여부</label></p><p><label class=ng-binding><input ng-checked-=\"vc.data.SmsAgreeYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.SmsAgreeYN ng-true-value=\"\'Y\'\" type=checkbox> SMS 수신에 동의합니다</label></p><p><label class=ng-binding><input ng-checked-=\"vc.data.EmailAgreeYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=vc.data.EmailAgreeYN ng-true-value=\"\'Y\'\" type=checkbox> 이메일 수신에 동의합니다</label></p></div><div class=\"buttonWrap mtb30\"><button class=cancel_btn type=button ng-click=\"vc.signUpTenant(\'C\')\">취소</button> <button class=primary_btn type=submit><strong>가입신청</strong></button></div></form></div><!-- // section.inputInfoWrap --></section><!-- // container --></div><login-footer></login-footer></div>");
$templateCache.put("components/login/signup.html","<div class=eland_wrapper><login-header></login-header><div id=container_><!-- container --><section class=\"joinStepWrap mtb100\"><!-- section.joinStep --><div class=eland_content><div class=joinWrap><ul class=explainWrap><li>회원가입 후, 관리자의 승인이 있어야 이용 가능합니다.</li><li>개인은 회원가입이 불가능합니다.</li><li>위기가정지원사업 협약기관만 가입이 가능합니다.</li></ul><ul class=joinTypeWrap><li ng-click=\"vc.signUpTenant(\'T\')\"><p><img src=../../assets/images/join/typeG_btn.png></p><h3>사례관리기관</h3><span>긴급한 위기상황에 있는 대상자를<br>추천할 기관</span></li><li ng-click=\"vc.signUpTenant(\'G\')\"><p><img src=../../assets/images/join/typeT_btn.png></p><h3>후원기관</h3><span>긴급한 위기상황에 있는 대상자를<br>후원할 기관</span></li></ul></div></div><!-- // section.joinStepWrap --></section><!-- // container --></div><login-footer></login-footer></div>");
$templateCache.put("components/print/print-take.html","<div class=\"page page-footable elandCustom elandCustomPrint\"><div class=dataloader ng-show=vc.dataloader></div><div class=pagecontent><!-- 버튼 영역 --><div class=row><div class=\"pull-right mb-5 mr-10\"><button class=\"btn btn-default\" id=btn_print ng-click=vc.printDetail()><i class=\"fa fa-print\"></i> 출력</button></div></div><!-- 버튼 영역 끝 --></div><div class=\"pagecontent ml-15 mr-20 mt-10\" id=printDiv><div id=pn1 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>신청 정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th>타기관 연계 신청 동의 여부</th><td><strong>{{vc.data.SecretYN_}}</strong></td></tr><tr><th>제목</th><td><strong>{{vc.data.Title}}</strong></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 1. 대상자 인적사항 --><div id=pn1 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>대상자 인적사항</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 15%\"><col style=\"width: 35%\"></colgroup><tbody><tr><th>이름</th><td ng-if=\"vc.tenantId != 0\"><span ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\" ng-bind=vc.data.TargetNm></span> <span ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\" ng-bind=vc.data.TargetNm_></span></td><td ng-if=\"vc.tenantId == 0\"><span ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\" ng-bind=vc.data.TargetNm></span> <span ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\" ng-bind=vc.data.TargetNm_></span></td><th>성별</th><td>{{vc.data.GenderNm}}</td></tr><tr><th>주민등록번호 (나이)</th><td colspan=3><div ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\"><span ng-bind=vc.data.Jumin1></span> ({{vc.data.Age}}세)</div><div ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\"><span>******-******* (**세)</span></div></td></tr><tr><th>연락처</th><td><input type=text auto-hyphen ng-model=vc.data.Mobile readonly></td><th>주소</th><td><div ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\">{{vc.data.Addr1}} {{vc.data.Addr2}} ({{vc.data.ZipCode}})</div><div ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\">{{vc.data.Addr1_}} {{vc.data.Addr2_}} ({{vc.data.ZipCode_}})</div></td></tr><tr><th>세대유형</th><td>{{vc.data.GenTypeValue}} <span ng-if=\"vc.data.GenTypeEtc != null && vc.data.GenTypeEtc != \'\'\">({{vc.data.GenTypeEtc}})</span></td><th>질병 및 질환 여부</th><td>{{vc.data.DiseaseValue}} <span ng-if=\"vc.data.DiseaseNm != null && vc.data.DiseaseNm != \'\'\">({{vc.data.DiseaseNm}})</span></td></tr><tr><th>보호구분</th><td>{{vc.data.ProtTypeValue}} <span ng-if=\"vc.data.HealthIndemValue != null && vc.data.HealthIndemValue != \'\'\">({{vc.data.HealthIndemValue}})</span></td><th>장애 여부</th><td>{{vc.data.ImpairValue}} <span ng-if=\"vc.data.ImpairNm != null && vc.data.ImpairNm != \'\'\">({{vc.data.ImpairNm}})</span></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 2. 신청내역 --><div id=pn2 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>신청내역</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th>신청영역</th><td><span ng-if=\"vc.data.SupportReq01 != null && vc.data.SupportReq01 == 1\">[주거비 : <span ng-bind=vc.data.HousSptAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq02 != null && vc.data.SupportReq02 == 1\">[생계비 : <span ng-bind=vc.data.livingAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq04 != null && vc.data.SupportReq04 == 1\">[치료비 : <span ng-bind=vc.data.CureSptAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq03 != null && vc.data.SupportReq03 == 1\">[자립비 : <span ng-bind=vc.data.EduSptAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq05 != null && vc.data.SupportReq05 == 1\">[기타 : <span ng-bind=vc.data.EtcSptAmt comma-bind></span>원] </span><span ng-if=\"vc.data.SupportReq06 != null && vc.data.SupportReq06 == 1\">[물품지원 : <span ng-bind=vc.data.VouSptAmt comma-bind></span>원]</span></td></tr><tr><th>총 지원 합계</th><td><span ng-bind=vc.data.TotalSptSum comma-bind></span>원</td></tr><tr><th>산출근거</th><td>{{vc.data.EtcSptCn}}</td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 3. 가족관계 --><div id=pn3 class=row ng-if=\"vc.data.CohabitCnt != null && vc.data.CohabitCnt > 0\"><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>가족관계</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th>동거 가구원 수(본인 포함)</th><td>{{vc.data.CohabitCnt}}명</td></tr><tr><td colspan=2><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div id=FrmList><table class=reportTable><colgroup><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 15%\"><col style=\"width: 20%\"><col style=\"width: 5%\"></colgroup><thead><tr><th>성명</th><th>관계</th><th>출생연도</th><th>직업</th><th>동거여부</th><th>기타</th></tr></thead><tbody><tr ng-repeat=\"li in vc.data.frmList\"><td class=text-center ng-if=\"vc.tenantType != \'GIVETENANT\' || (vc.tenantType == \'GIVETENANT\' && (vc.recordStatus == \'SP\' || vc.recordStatus == \'RW\' || vc.recordStatus == \'RC\'))\">{{li.FrNm}}</td><td class=text-center ng-if=\"vc.tenantType == \'GIVETENANT\' && (vc.recordStatus != \'SP\' || vc.recordStatus != \'RW\' || vc.recordStatus != \'RC\')\">{{li.FrNm_}}</td><td class=text-center>{{li.Relp}}</td><td class=text-center>{{li.Age}}</td><td class=text-center>{{li.Job}}</td><td class=text-center>{{li.CohabitYN}}</td><td class=text-center>{{li.Remark}}</td></tr></tbody></table></div></div></div></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 4. 경제 상황 --><div id=pn4 class=row ng-if=\"vc.data.HousTypeValue != null && vc.data.HousTypeValue != \'\'\"><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>경제 상황</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 85%\"></colgroup><tbody><tr><th>주거형태</th><td>{{vc.data.HousTypeValue}} <span ng-if=\"vc.data.HousType == \'1\'\">(시가 : <span ng-bind=vc.data.JagaAmt comma-bind></span>원 / 대출금 : <span ng-bind=vc.data.JagaLoan comma-bind></span>원)</span> <span ng-if=\"vc.data.HousType == \'2\'\">(보증금 : <span ng-bind=vc.data.JeonseAmt comma-bind></span>원 / 대출금 : <span ng-bind=vc.data.JeonseLoan comma-bind></span>원)</span> <span ng-if=\"vc.data.HousType == \'3\'\">(보증금 : <span ng-bind=vc.data.MonthDep comma-bind></span>원 / 월세 : <span ng-bind=vc.data.MonthAmt comma-bind></span>원)</span> <span ng-if=\"vc.data.HousType == \'4\'\">(보증금 : <span ng-bind=vc.data.AptDep comma-bind></span>원 / 월세 : <span ng-bind=vc.data.AptAmt comma-bind></span>원)</span> <span ng-if=\"vc.data.HousType == \'5\'\">(소유주와의 관계 : {{vc.data.FreeLease}})</span> <span ng-if=\"vc.data.HousType == \'6\'\">({{vc.data.HousEtcCn}})</span></td></tr><tr><th>월 소득 및 자산</th><td><table class=reportTable><colgroup><col style=\"width: 30%\"><col style=\"width: 20%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><tbody><tr><th>구분</th><th>금액</th><th>세부내용</th><th>월 소득 합계</th></tr><tr><td>근로소득</td><td class=text-right><span ng-bind=vc.data.WorkInc comma-bind></span> 원</td><td>{{vc.data.WorkIncCn}}</td><td rowspan=4 class=text-right><span ng-bind=vc.data.TotalInc comma-bind></span> 원</td></tr><tr><td>정부보조금</td><td class=text-right><span ng-bind=vc.data.GovtGrant comma-bind></span> 원</td><td>{{vc.data.GovtGrantCn}}</td></tr><tr><td>후원금</td><td class=text-right><span ng-bind=vc.data.Donation comma-bind></span> 원</td><td>{{vc.data.DonationCn}}</td></tr><tr><td>기타</td><td class=text-right><span ng-bind=vc.data.Etc comma-bind></span> 원</td><td>{{vc.data.EtcCn}}</td></tr></tbody></table></td></tr><tr><th>월 지출</th><td><table class=reportTable><colgroup><col style=\"width: 30%\"><col style=\"width: 20%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><tbody><tr><th>구분</th><th>금액</th><th>세부내용</th><th>월 지출 합계</th></tr><tr><td>식비</td><td class=text-right><span ng-bind=vc.data.FoodCost comma-bind></span> 원</td><td>{{vc.data.FoodCostCn}}</td><td rowspan=10 class=text-right><span ng-bind=vc.data.TotalCost comma-bind></span> 원</td></tr><tr><td>주거비(월세)</td><td class=text-right><span ng-bind=vc.data.HousCost comma-bind></span> 원</td><td>{{vc.data.HousCostCn}}</td></tr><tr><td>공과금, 관리비</td><td class=text-right><span ng-bind=vc.data.MaintCost comma-bind></span> 원</td><td>{{vc.data.MaintCostCn}}</td></tr><tr><td>의료비</td><td class=text-right><span ng-bind=vc.data.HealthCost comma-bind></span> 원</td><td>{{vc.data.HealthCostCn}}</td></tr><tr ng-repeat=\"(index, li) in vc.data.etcCostList\"><td>본인 작성</td><td class=text-right><span ng-bind=li.EtcCost comma-bind></span> 원</td><td>{{li.EtcCn}}</td></tr></tbody></table></td></tr><tr><th>자산</th><td id=finanList><table class=reportTable><colgroup><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th>종류</th><th>금액</th><th>사용여부</th><th>비고</th></tr></thead><tbody><tr ng-repeat=\"(index, li) in vc.data.finanList\"><td class=text-center>{{li.TypeNm}}</td><td class=text-right><span ng-bind=li.Amount comma-bind></span> 원</td><td class=text-center>{{li.UseYNNm}}</td><td>{{li.Remark}}</td></tr></tbody></table></td></tr><tr><th>부채</th><td>{{vc.data.LiabYN_}} <span ng-if=\"vc.data.LiabYN == \'1\'\"><span ng-if=\"vc.data.LiabType1 == \'1\'\">[은행 : <span ng-bind=vc.data.LiabAmt1 comma-bind></span>원] </span><span ng-if=\"vc.data.LiabType2 == \'1\'\">[카드 : <span ng-bind=vc.data.LiabAmt2 comma-bind></span>원] </span><span ng-if=\"vc.data.LiabType3 == \'1\'\">[지인 : <span ng-bind=vc.data.LiabAmt3 comma-bind></span>원] </span><span ng-if=\"vc.data.LiabType4 == \'1\'\">[기타({{vc.data.LiabType4Cn}}) : <span ng-bind=vc.data.LiabAmt4 comma-bind></span>원] </span><span ng-if=\"vc.data.LiabCn != \'\'\">[사유 : {{vc.data.LiabCn}}]</span></span></td></tr><tr><th>긴급생계비</th><td><p><strong>신청여부 : {{vc.data.EmergWelfareYN_}}</strong></p><table class=\"reportTable mt-10\" ng-if=\"vc.data.EmergWelfareYN == \'1\'\"><colgroup><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th>지원기관</th><th>지원금액</th><th>지원기간</th><th>지원내용</th></tr></thead><tbody><tr ng-repeat=\"li in vc.data.tenantSptList\" ng-if=\"li.Type == \'E\'\"><td>{{li.TenantSptNm}}</td><td class=text-right><span ng-bind=li.SptAmt comma-bind></span>원</td><td class=text-center>{{li.SptStartDate}} ~ {{li.SptEndDate}}</td><td>{{li.SptCn}}</td></tr></tbody></table><table class=\"reportTable mt-10\" ng-if=\"vc.data.EmergWelfareYN != \'1\'\"><thead><tr><th>불가사유</th></tr></thead><tbody><tr><td ng-if=\"vc.data.EmergWelfareYN == \'0\'\">{{vc.data.FailCn}}</td><td ng-if=\"vc.data.EmergWelfareYN == \'2\'\">{{vc.data.NotApplyCN}}</td></tr></tbody></table></td></tr><tr><th>외부 지원</th><td><p><strong>신청여부 : {{vc.data.PrivateSptYN_}}</strong></p><table class=\"reportTable mt-10\" ng-if=\"vc.data.PrivateSptYN == \'1\'\"><colgroup><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"><col style=\"width: 25%\"></colgroup><thead><tr><th>지원기관</th><th>지원금액</th><th>지원기간</th><th>지원내용</th></tr></thead><tbody><tr ng-repeat=\"li in vc.data.tenantSptList\" ng-if=\"li.Type == \'P\'\"><td>{{li.TenantSptNm}}</td><td class=text-right><span ng-bind=li.SptAmt comma-bind></span>원</td><td class=text-center>{{li.SptStartDate}} ~ {{li.SptEndDate}}</td><td>{{li.SptCn}}</td></tr></tbody></table></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 6. 추천기관 --><div id=pn6 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>추천기관</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 20%\"><col style=\"width: 10%\"><col style=\"width: 20%\"><col style=\"width: 10%\"><col style=\"width: 25%\"></colgroup><tbody><tr><th>기관명</th><td>{{vc.tenantData.TenantNm}}</td><th>구분</th><td>{{vc.tenantData.OrganizationNm}}</td><th>대표자명</th><td>{{vc.tenantData.Ceo}}</td></tr><tr><th>대표번호</th><td>{{vc.tenantData.TelNo}}</td><th>팩스</th><td colspan=3>{{vc.tenantData.Fax}}</td></tr><tr><th>담당자명</th><td>{{vc.data.ContactNm}}</td><th>담당자 휴대폰번호</th><td>{{vc.data.ContactMobile}}</td><th>담당자 이메일주소</th><td>{{vc.data.ContactEmail}}</td></tr><tr ng-if=\"vc.data.SupportNec != null && vc.data.SupportNec != \'\'\"><th>대상자 위기상황 요약 및 추천사유</th><td colspan=5><span ng-if=\"vc.data.SupportType1Value != null && vc.data.SupportType1Value != \'\'\">[위기상황 해결] </span><span ng-if=\"vc.data.SupportType2Value != null && vc.data.SupportType2Value != \'\'\">[현상유지] </span><span ng-if=\"vc.data.SupportType3Value != null && vc.data.SupportType3Value != \'\'\">[소득증대 및 개선]</span><textarea rows=10 class=\"form-control mt-10\" ng-model=vc.data.SupportNec readonly></textarea></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 8. 첨부서류 --><div id=pn8 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>첨부서류</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 20%\"><col></colgroup><tbody><tr><th style=\"text-align: center\">종류</th><th style=\"text-align: center\">파일</th></tr><tr ng-repeat=\"(key, fileObj) in vc.attach\" ng-if=vc.fileView(key)><th>{{ fileObj.label }}</th><td><input class=\"form-control form-right\" type=text ng-model=fileObj.fileName style=\"cursor: pointer; width: 100%\" readonly></td></tr></tbody></table></div></div></div></div><!----------------------------------------------------------------------------------------------------><!-- 9. 현장실사 가능 일자 --><div id=pn9 class=row><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>현장실사 가능 일자</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><table class=tb_report><colgroup><col style=\"width: 15%\"><col style=\"width: 35%\"><col style=\"width: 15%\"><col style=\"width: 35%\"></colgroup><tbody><tr id=SiteVeriftDate><th style=\"text-align: center\">1순위</th><td>{{vc.SiteVeriftDate1}}</td><th style=\"text-align: center\">2순위</th><td>{{vc.SiteVeriftDate2}}</td></tr></tbody></table></div></div></div></div><!-- 버튼 영역 --><div class=row><div class=\"pull-right mb-20 mr-10\"><button class=\"btn btn-default\" id=btn_print ng-click=vc.printDetail()><i class=\"fa fa-print\"></i> 출력</button></div></div><!-- 버튼 영역 끝 --></div><!-- /page content --></div>");
$templateCache.put("components/template/pagination.html","<ul class=pagination><li ng-if=::boundaryLinks ng-class=\"{disabled: noPrevious()||ngDisabled}\"><a href class=\"spr first\" ng-click=\"selectPage(1, $event)\"><span class=hide>맨앞으로</span></a></li><li ng-if=::directionLinks ng-class=\"{disabled: noPrevious()||ngDisabled}\"><a href class=\"spr prev\" ng-click=\"selectPage(page - 1, $event)\"><span class=hide>이전</span></a></li><li ng-repeat=\"page in pages track by $index\" ng-class=\"{active: page.active,disabled: ngDisabled&&!page.active}\" class=pagination-page><a href ng-click=\"selectPage(page.number, $event)\">{{page.text}}</a></li><li ng-if=::directionLinks ng-class=\"{disabled: noNext()||ngDisabled}\"><a href class=\"spr next\" ng-click=\"selectPage(page + 1, $event)\"><span class=hide>다음</span></a></li><li ng-if=::boundaryLinks ng-class=\"{disabled: noNext()||ngDisabled}\"><a href class=\"spr last\" ng-click=\"selectPage(totalPages, $event)\"><span class=hide>맨뒤로</span></a></li></ul>");
$templateCache.put("components/privacyPolicy/privacyPolicy.html","<!-- privacyPolicy --><section id=privacyPolicy class=\"subPageWrap mtb100 sub_w720\"><!-- section#privacyPolicy --><div class=\"sp_header mb30\"><div class=eland_content><h2 class=title>개인정보처리방침</h2><p class=sub_title>[이랜드복지재단 플랫폼 ‘SOS위고’의 개인정보처리방침]</p></div></div><div class=sp_container><div class=\"eland_content policy_content\"><section><p>이랜드복지재단(이하 ‘복지재단’)은 플랫폼 ‘SOS위고 사이트’(https://soswego.co.kr) (이하 ‘본 사이트‘)를 이용하시는 기관 및 정보 주체(이하 ‘이용자’)의 개인정보를 매우 소중히 여기며, 이용자의 개인정보가 보호받을 수 있도록 「개인정보보호법」제30조에 따라 [개인정보처리방침]을 제정하고 이를 준수하고 있습니다.</p><p>복지재단은 [개인정보처리방침]을 통하여 이용자가 제공하는 개인정보가 어떠한 용도와 방식으로 이용되고 있으며 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다. 복지재단의 [개인정보처리방침]은 관련 법률이나 복지재단의 내부 방침에 따라 변경될 수 있으므로, 본 사이트(https://soswego.co.kr) 이용 시, 수시로 확인하여 주시기 바랍니다.</p></section><section><p><strong>제1조(개인정보 처리목적)</strong></p><p>복지재단은 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 외의 용도로는 이용되지 않으며 이용 목적이 변경되는 경우에는 「개인정보보호법」 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행합니다</p><p>1. 지원사업 서비스 제공<br>본 사이트를 통한 다양한 지원사업의 신청 및 대상자 연결, 위기가정 지원 및 관리, 협력기관 연계, 신청 및 지원 현황 모니터링, 중복지원 방지 및 부정신청 방지, 후원자 피드백, 만 14세 미만 아동의 개인정보 처리시 법정대리인의 동의여부 확인, 법정대리인 본인 확인 등</p><p>2. 회원관리<ul><li>(1) 본 사이트를 통해, 위기 상황에 있는 대상자에게 도움을 지원하는 기관(이하 ‘후원기관’)과 지원대상자를 관리하는 기관(이하‘사례관리기관’)에 대한 회원자격 유지ㆍ관리.</li><li>(2) 본 사이트를 이용하는 기관(사례관리기관, 후원기관) 및 담당자의 식별ㆍ인증, 서비스 부정이용 방지와 비인가 사용방지, 가입의사 확인, 가입 및 가입 횟수 제한, 분쟁조정을 위한 기록보존, 각종 고지ㆍ통지, 불만ㆍ고충처리</li></ul></p><p>3. 재단 운영과 지원사업 개발 및 관련 법규 준수<br>복지재단 사업의 지속 추진 평가, 플랫폼 지원 결과 보고, 통계자료 작성, 복지재단 정보 활용, 국세청 공시 자료 작성 및 관계 법령에 따른 자료 제출</p><p>4. 법규에서 허용하는 범위 내에서의 이용<br>복지재단은 「개인정보보호법」제15조제3항 또는 제17조제4항에 따라, 당초 수집 목적과 합리적으로 관련된 범위에서 정보주체의 동의 없이 개인정보를 이용 또는 제공 할 수 있습니다. 다만, 개인정보를 동의 없이 추가적으로 이용 또는 제공하는 경우에는 다음의 내용을 고려합니다.<ul><li>(1) 당초 수집 목적과의 관련성이 있는지 여부</li><li>(2) 개인정보 수집정황 또는 처리 관행에 비추어 볼 때 예측 가능성이 있는지 여부</li><li>(3) 정보주체의 이익이 부당하게 침해되는지 여부</li><li>(4) 가명정보 또는 암호화 등 안전성 확보에 필요한 조치를 하였는지 여부</li></ul></p><p>5. 개인정보의 처리에 대한 안내<br>정보주체의 개인정보 중 일부는 복지재단의 홍보(우수사례집, 웹진, 연간보고서 등) 목적으로 공개될 수 있습니다. 다만, 공개되는 개인정보를 익명 또는 가명으로 처리하여도 목적을 달성할 수 있는 경우에는 익명 또는 가명으로 처리합니다.</p></section><section><p><strong>제2조(개인정보의 처리 및 보유 기간)</strong></p><p>1. 복지재단은 법령에서 보관 의무를 정하고 있는 경우 또는 이용자로부터 별도의 동의를 받은 기간 내에서 개인정보를 처리ㆍ보유합니다.</p><p>2. 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.<ul><li>(1) 회원가입 및 관리 : 수집ㆍ이용 목적달성 시 또는 회원탈퇴 시까지 다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지<ul><li>i. 관계 법령 위반에 따른 수사, 조사 등이 진행 중이면 해당 수사, 조사 종료 시까지</li><li>ii. 서비스 이용에 따른 채권, 채무 관계 잔존 시에는 해당 채권, 채무 관계 정산 시까지</li><li>iii. 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따라<ul><li>- 표시ㆍ광고에 관한 기록은 6개월,</li><li>- 계약 또는 청약철회, 대금결제, 재화 등의 공급기록은 5년,</li><li>- 소비자 불만 또는 분쟁처리에 관한 기록은 3년</li></ul></li><li>iv. 「통신비밀 보호법」에 따라<ul><li>- 컴퓨터 통신, 인터넷 로그인 기록자료, 접속지 추적자료는 3개월</li></ul></li></ul></li><li>(2) 서비스 제공 : 서비스 지원, 모니터링 및 중복지원 방지를 위해 관련 법률에 따라 신청일부터 피드백 이후 수집 및 이용 목적달성 시까지. (사업 관련 서류보관 주기(5년))</li></ul></p></section><section><p><strong>제3조(수집하는 개인정보의 항목)</strong></p><p>1. 복지재단은 다음의 개인정보 항목을 처리하고 있습니다.<ul><li>(1) 기관의 회원가입 및 관리를 위한 정보<div class=inbox><dl><dt>[필수항목]</dt><dd>- 기관명, 기관전화번호, 기관 주소, 소속, 연락처</dd><dd>- 담당자 정보 (성명, 아이디, 비밀번호, 전자메일주소, 전화번호), 본인인증 정보(CI, DI)</dd></dl><dl><dt>[선택항목]</dt><dd>- 정보 수신 방법</dd></dl></div></li><li>(2) 지원사업 대상자 정보<div class=inbox><dl><dt>[필수항목]</dt><dd>- 기초정보: 성명, 주민등록번호, 성별, 연락처, 주소, 가정유형, 가족 인적사항(성명, 관계, 생년월일, 직업, 동거 여부), 사진, 후원사업 신청서 작성사항(경제‧주거 등 환경, 타 기관 자원연계 여부 등)<br>※주민등록번호 수집근거: 상속세 및 증여세법 시행령 83조</dd><dd>- 민감정보: 가정상황 및 경제 상황(월수입, 지출, 경제 상황증빙서류), 재산 현황(주거, 금융자산, 부동산, 차량, 부채), 사회보장서비스 수급 현황, 개인신상 내용(제출서류 내), 기타 증빙서류, 지원자가 작성한 관련 정보</dd></dl><dl><dt>[선택항목]</dt><dd>- 모금사연 연계 여부</dd></dl></div></li><li>(3) 온라인 서비스 이용 또는 처리 과정에서 생성/수집되는 정보<div class=inbox><p>서비스 이용기록, 접속 로그, 쿠키, 접속 IP 정보 등</p></div></li></ul></p><p>2. 지원 대상자 및 대상자 가족 등에 관한 개인정보<br>지원대상자에 대한 심사 등을 위하여 지원대상자의 가족이나 친척을 비롯한 제3자(이하 ‘가족 등’)의 개인정보를 ‘복지재단’ 또는 ‘후원기관’에 제공하는 경우, 사례관리기관 또는 지원 대상자는 그에 앞서 ‘가족 등’에게 “그들의 정보를 복지재단 또는 후원기관에 제공 한다”는 점과 제공 항목, 제공 목적(복지재단 또는 후원기관이 이를 다시 제3자에게 제공하는 경우에는 그러한 사항 포함), 보유 및 이용하는 기간을 충분히 설명하고 이에 대한 동의를 받아야 합니다. 사례관리기관이 지원 대상자로부터 관련 내용에 대한 서명이나, 전자적 동의를 받은 경우에는 “ ‘가족 등’에게 그와 같은 설명을 제공하고 ‘가족 등’으로 부터 적법한 동의를 받았음”을 진술합니다.</p></section><section><p><strong>제4조 (개인정보의 제3자 제공)</strong></p><p>1. 복지재단은 이용자의 개인정보를 제1조(개인정보의 처리목적)에서 명시한 범위 내에서만 처리하며, 그 이외의 목적으로는 제3자 제공하지 않습니다. 다만, 아래의 경우에는 예외로 합니다.<ul><li>(1) 이용자 및 정보주체가 사전에 제3자 제공에 동의한 경우<br>※ 단, 동의를 거부하는 경우에도 서비스는 이용하실 수 있습니다.</li><li>(2) 법령의 규정에 따르거나, 수사 목적으로 법령에 정해진 절차와 방법에 따라 수사기관의 요구가 있는 경우<br>※ 그러나 예외사항에서도 본래의 수집목적 및 이용 목적에 반하여 무분별하게 정보가 제공되지 않도록 최대한 노력하겠습니다.</li></ul></p><p>2. 복지재단 또는 후원기관은 지원대상자로부터 직접 개인정보를 수집하거나, 사례관리기관으로 부터 지원대상자의 정보를 제공 받습니다.</p><p>3. 사례관리기관이 복지재단 또는 후원기관에 지원대상자의 정보를 제공하기 위해서는 반드시 사전에 지원대상자로부터 “복지재단 또는 후원기관에 개인정보를 업무위탁이 아닌, 제3자 제공의 방식으로 제공하는 것”에 대해 동의를 받아야 합니다.</p><p>4. 본 사이트의 지원사업을 위한 제3자 제공<table class=reportTable><colgroup><col width=20%><col width=18%><col width=*><col width=15%></colgroup><thead><tr><th>제공받는 자</th><th>이용 목적</th><th>제공되는 개인정보 항목</th><th>이용·보유기간</th></tr></thead><tbody><tr><td>협력기관<br><a href=# class=clickPopup>[후원기관 List]</a></td><!-- clickPopup 누르면 팝업으로 후원기관 리스트 --><td>위기지원사업<br>대상선정 및 관리</td><td>지원 대상자 기초정보(성명, 생년월일, 성별, 연락처, 직업, 주소), 가족인적사항, 가정ㆍ경제 상황에 대한 위기지원사업 신청서 작성 사항, 기타 위기지원사업 신청 관련 사항</td><td>제공목적<br>달성 시까지</td></tr><tr><td>후원처</td><td>후원자 모금 및 피드백</td><td>성별, 나이, 가족 유형, 위기지원사업 신청서 작성사항 (공개되는 개인정보를 익명 또는 가명으로 처리)</td><td>제공목적<br>달성 시까지</td></tr><tr><td>국세청</td><td>국세청 보고</td><td>성명, 주민등록번호, 지원금액</td><td>제공목적<br>달성 시까지</td></tr></tbody></table>※ 주민등록번호 수집근거 : 상속세 및 증여세법 시행령 83조<br>※ 개인정보 제3자 제공에 대하여 거부할 권리가 있으나, 거부하실 경우, 지원사업 신청 및 지원이 어려울 수 있습니다.</p><p>5. 정보 주체의 일반 개인정보 중 일부는 ‘복지재단 및 플랫폼 협력기관’ 홍보(우수사례집, 웹진, 연간보고서 등) 목적으로 공개될 수 있습니다. 다만, 공개되는 개인정보를 익명 또는 가명으로 처리하여도 목적을 달성할 수 있는 경우에는 익명 또는 가명으로 처리합니다.</p></section><section><p><strong>제5조 (개인정보 처리의 위탁)</strong></p><p>1. 복지재단은 서비스 제공 및 서비스 품질의 향상을 위해서 이용자의 개인정보를 필요한 업무 범위 내에서 다음과 같이 위탁하고 있습니다</p><p><table class=reportTable><colgroup><col width=40%><col width=35%><col width=25%></colgroup><thead><tr><th>위탁받는 자(수탁자)</th><th>위탁업무 내용</th><th>보유 및 이용기간</th></tr></thead><tbody><tr><td>후원사업과 관계된 협력기관 심사위원<br>(단, 심사업무의 공정성 확보 및 사전 접촉 방지를 위하여 협력기관 및 위원의 명단을 공개하지 못함을 양해 바랍니다.)</td><td>사례관리기관이 제출한 서류심사,<br>현장 방문을 통한 대상자 선정심사</td><td>위탁 목적<br>달성 시 까지</td></tr><tr><td>소프트자이온</td><td>서버 유지보수 및 관리네트워크 및 보안 / 방화벽관리<br>사이트 운영 및 유지보수</td><td>위탁 목적<br>달성 시 까지</td></tr><tr><td>다날</td><td>본인인증</td><td>위탁 목적<br>달성 시 까지</td></tr><tr><td>CJ대한통운, 한진택배, 우체국,(주)에이디씨항운</td><td>물품 및 선물 발송</td><td>위탁 목적<br>달성 시 까지</td></tr><tr><td>문자천국, 문자박사</td><td>신청자 DM 발송</td><td>위탁 목적<br>달성 시 까지</td></tr></tbody></table></p><p>2. 복지재단은 위탁계약 체결 시 「개인정보보호법」 제26조에 따라 위탁업무 수행목적 외 개인정보 처리금지, 기술적ㆍ관리적 보호조치, 재위탁 제한, 수탁자에 대한 관리ㆍ감독, 손해배상 등 책임에 관한 사항을 계약서 또는 협약서 등 문서에 명시하고, 수탁자가 개인정보를 안전하게 처리하는지를 감독하고 있습니다.</p><p>3. 위탁업무의 내용이나 수탁자가 변경될 때는 본 [개인정보처리방침]을 통하여 공개하도록 하겠습니다.</p></section><section><p><strong>제6조 (이용자와 법정대리인의 권리ㆍ의무 및 행사 방법)</strong></p><p>1. 이용자는 복지재단에 대해 언제든지 다음 각 호의 개인정보보호 관련 권리를 행사할 수 있습니다.<ul><li>(1) 개인정보 열람 요구</li><li>(2) 오류 등이 있을 때 정정 요구</li><li>(3) 삭제 요구</li><li>(4) 처리정지 요구</li></ul></p><p>2. 제1항에 따른 권리 행사는 본 사이트의 ‘회원 정보수정’에서 직접 행사하거나 개인정보보호 담당자에게 전화, E-mail로 연락하시면 지체없이 조치하겠습니다.</p><p>3. 이용자가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 ‘복지재단’은 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.</p><p>4. 제1항에 따른 권리 행사는 이용자의 법정대리인이나 위임을 받은 자 등 대리인을 통하여서 하실 수 있습니다. 이 경우 [개인정보 처리방법에 관한 고시(제2020-7호)]별지 제11호 서식에 따른 위임장을 제출하셔야 합니다.</p><p>5. 개인정보의 열람 요구는 「개인정보보호법」 제35조 제4항에 따라 제한되거나 거절될 수 있으며, 처리정지 요구는 「개인정보보호법」 제37조 제2항의 단서조항에 따라 이용자의 권리가 제한될 수 있습니다.</p><p>6. 개인정보의 정정 및 삭제 요구는 다른 법령에서 그 개인정보가 수집 대상으로 명시되어 있는 경우에는 그 삭제를 요구할 수 없습니다.</p><p>7. 이용자는 「개인정보보호법」 제35조에 따른 개인정보의 열람 청구를 제11조의 담당부서에 할 수 있습니다. 복지재단 정보주체의 개인정보 열람청구가 신속하게 처리되도록 노력 하겠습니다.</p><p>8. 복지재단은 이용자의 권리에 따른 열람의 요구, 정정ㆍ삭제의 요구, 처리정지의 요구 시 열람 등 요구를 한 자가 이용자 본인이거나 정당한 대리인이 맞는지를 확인합니다.</p></section><section><p><strong>제7조 (개인정보 자동수집 장치의 설치, 운영 및 그 거부에 관한 사항)</strong></p><p>1. 복지재단은 이용자에 대한 정보를 임시로 저장하고, 검색할 수 있는 ‘쿠키(cookie)’를 사용합니다. 쿠키는 이용자의 컴퓨터는 식별하되, 컴퓨터 사용자를 개인적으로 식별하지는 않습니다. 또한, 이용자는 쿠키에 대한 선택권이 있으므로, 웹브라우저 옵션에서 모든 쿠키를 다 받아들이거나, 쿠키가 설치될 때 통지를 보내도록 하거나, 아니면 모든 쿠키를 거부할 수 있는 선택권을 가지실 수 있습니다.</p><p>2. 쿠키는 웹사이트를 운영하는데 이용되는 서버가 이용자의 컴퓨터 브라우저로 보내는 소량의 정보이며 이용자들의 PC컴퓨터내의 하드디스크에 저장되기도 합니다.</p><ul><li>(1) 쿠키 사용 목적 : 쿠키는 복지재단의 서버가 이용자의 웹브라우저로 전송하는 정보로, PC의 다른 부분에는 전혀 영향을 주지 않습니다. 이용자가 복지재단 관련 사이트에 접속하면 복지재단의 서버 컴퓨터가 이용자의 브라우저에서 쿠키 내용을 읽음으로써, 추가 입력 없이 서비스를 받으실 수 있도록 하기 위해 사용됩니다. 또한, 접속빈도나 방문시간 등을 분석, 이용자의 취향과 관심 분야 파악 등을 위해 사용 될 수 있습니다.</li><li>(2) 쿠키의 설정거부방법 : 쿠키의 설정을 거부하는 방법으로는 이용자가 사용하는 웹브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나, 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.<br>- 설정 방법 예시 (인터넷 익스플로러의 경우) : 웹브라우저 상당의 [도구] > [인터넷 옵션] > [개인정보] 탭을 클릭하여 [개인정보보호 수준]을 설정하시면 됩니다.</li></ul><p>3. 모바일 서비스에서의 쿠키 설치/운영에 관한 사항<br>복지재단은 PC환경과 동일·유사한 인터넷 환경을 모바일 서비스에서도 제공하기 위해 모바일 기기 (예: 스마트폰, 태블릿PC)에서도 ‘쿠키(cookie)’를 사용할 수 있습니다. 단, 복지재단은 이용자의 명시적인 동의 없이 개인정보를 포함하는 제3자의 쿠키를 임의로 수집하지 않습니다</p><p>4. 모바일 기기에서도 웹브라우저 설정 기능에서 쿠키 허용 여부를 선택할 수 있습니다. 모바일 기기의 운영체제 및 웹브라우저 종류에 따라 다소 상이할 수 있지만, 대부분의 경우 모바일 웹브라우저의 환경 설정을 통해 쿠키허용 여부를 결정하거나, 기존의 쿠키 일체를 삭제할 수 있습니다.</p><p>5. 쿠키의 저장을 거부할 경우, 로그인이 필요한 일부 서비스의 이용에 불편함이 있을 수 있습니다.</p></section><section><p><strong>제8조 (개인정보의 파기절차 및 방법)</strong></p><p>1. 복지재단은 개인정보 보유 기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다.</p><p>2. 정보 주체로부터 동의 받은 개인정보 보유 기간이 경과하거나 처리목적이 달성되었음에도 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관 장소를 달리하여 보존합니다.</p><p>3. 개인정보 파기의 절차 및 방법은 다음과 같습니다.<ul><li>(1) 파기절차<br>복지재단은 파기 사유가 발생한 이용자의 개인정보를 내부 방침 및 기타 관련 법령에 따른 정보보호 사유에 따라 일정 기간 저장된 후 파기합니다.</li><li>(2) 파기방법<br>복지재단은 전자적 파일 형태로 기록ㆍ저장된 개인정보는 기록을 재생할 수 없도록 파기하며 종이 문서에 기록ㆍ저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.</li></ul></p></section><section><p><strong>제9조 (개인정보의 안전성 확보조치)</strong></p><p>1.복지재단은 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.</p><ul><li>(1)관리적 조치 : 내부관리계획 수립ㆍ이행, 정기적 직원 교육 등</li><li>(2)기술적 조치 : 개인정보처리시스템 등의 접근권한 관리, 접근통제시스템 설치, 고유식별정보 등의 암호화, 보안프로그램 설치</li><li>(3)물리적 조치 : 전산실, 자료보관실 등의 접근통제</li></ul><p>2. 이용자는 ID와 비밀번호를 타인에게 알려 주어서는 안되며, 이 사이트에 로그인(login)후, 잠시 자리를 비우거나 이용을 마치신 후에는 반드시 로그아웃 (logout) 해 주시기 바랍니다. 이용자 본인의 부주의나 인터넷상의 문제로 ID, 비밀번호, 연락처 등 개인정보가 유출되거나 그로 인해 발생한 문제에 대해 복지재단은 일체의 책임을 지지 않습니다.</p></section><section><p><strong>제10조 (행태정보의 수집·이용 및 거부 등에 관한 사항)</strong></p><p>1.	복지재단은 서비스 이용과정에서 정보주체에게 최적화 된 맞춤형 서비스 및 혜택, 온라인 맞춤형 안내(광고) 등을 제공하기 위하여 행태정보를 수집·이용하고 있습니다.</p><p>2.	복지재단은 다음과 같이 행태정보를 수집합니다.</p><p><table class=reportTable><colgroup><col width=20%><col width=18%><col width=*><col width=20%></colgroup><thead><tr><th>수집하는<br>행태정보의 항목</th><th>행태정보 수집 방법</th><th>행태정보 수집 목적</th><th>보유·이용기간 및<br>이후 정보처리 방법</th></tr></thead><tbody><tr><td>이용자의 웹사이트/ 앱 서비스 방문이력, 검색이력, 이용이력</td><td>이용자의 웹 사이트 및 앱 방문/실행 시 자동 수집</td><td>이용자의 관심, 성향에 기반한 개인 맞춤형 추천 서비스(광고포함)를 제공</td><td>수집 목적 달성 시<br>까지 보관 후 파기</td></tr></tbody></table></p><p>3.	복지재단은 사상, 신념, 등 개인의 권리·이익이나 사생활을 뚜렷하게 침해할 우려가 있는 민감한 행태정보를 수집하지 않습니다. 다만, 복지 서비스 지원 대상자 선정을 위해 필요한 경우, 일부 민감정보(건강상태, 경제상황, 가정환경 등)를 수집합니다.</p><p>4.	복지재단은 모바일 앱에서 온라인 맞춤형 안내(광고)를 위하여 광고식별자를 수집· 이용합니다. 정보주체는 모바일 단말기의 설정 변경을 통해 앱의 맞춤형 안내(광고)를 차단 또는 허용할 수 있습니다.</p><ul><li>‣ 스마트폰의 광고식별자 차단/허용</li><li>(1) (안드로이드) ① 설정→ ② 개인정보보호→ ③ 광고→ ③ 광고 ID 재설정 또는 광고ID 삭제</li><li>(2) (아이폰) ① 설정→ ② 개인정보보호→ ③ 추적→ ④ 앱이 추적을 요청하도록 허용 끔</li><li>※ 모바일 OS 버전에 따라 메뉴 및 방법이 다소 상이할 수 있습니다.</li></ul><p>5.	정보주체는 웹브라우저의 쿠키 설정 변경 등을 통해 온라인 맞춤형 안내(광고)를 일괄적으로 차단하거나 허용할 수 있습니다. 다만, 쿠키 설정 변경은 웹사이트 자동로그인 등 일부 서비스의 이용에 영향을 미칠 수 있습니다.</p><ul><li>‣ 웹브라우저를 통한 맞춤형 광고 차단/허용</li><li>(1) 인터넷 익스플로러(Windows 10용 Internet Explorer 11)</li><li>- Internet Explorer에서 도구 버튼을 선택한 다음 인터넷 옵션을 선택</li><li>- 개인 정보 탭을 선택하고 설정에서 고급을 선택한 다음 쿠키의 차단 또는 허용을 선택</li><li>(2) Microsoft Edge</li><li>- Edge에서 오른쪽 상단 ‘…’ 표시를 클릭한 후, 설정을 클릭합니다.</li><li>- 설정 페이지 좌측의 ‘개인정보, 검색 및 서비스’를 클릭 후 「추적방지」 섹션에서 ‘추적방지’ 여부 및 수준을 선택합니다.</li><li>- ‘InPrivate를 검색할 때 항상 “엄격” 추적 방지 사용’ 여부를 선택합니다.</li><li>- 아래 「개인정보」 섹션에서 ‘추적 안 함 요청 보내기’ 여부를 선택합니다.</li><li>(3) 크롬 브라우저</li><li>- Chrome에서 오른쪽 상단 ‘⋮’ 표시(chrome 맞춤설정 및 제어)를 클릭한 후, 설정 표시를 클릭합니다.</li><li>- 설정 페이지 하단에 ‘고급 설정 표시’를 클릭하고 「개인정보」 섹션에서 콘텐츠 설정을 클릭합니다.</li><li>- 쿠키 섹션에서 ‘타사 쿠키 및 사이트 데이터 차단’의 체크박스를 선택합니다.</li></ul><p>6.	정보주체는 아래 제11조에 명시된 연락처로 행태정보와 관련하여 궁금한 사항과 거부권 행사, 피해 신고 접수 등을 문의할 수 있습니다.</p></section><section><p><strong>제11조 (개인정보보호 책임자)</strong></p><p>1. 복지재단은 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 이용자의 불만 처리 및 피해구제 등을 위하여 아래와 같이 개인정보보호 책임자를 지정하고 있습니다.</p><dl><dt>[개인정보보호 책임자]</dt><dd>성명/직책 : 이윤정 / 부장</dd><dd>전화번호/이메일 : 02-2644-0110 / elandincubating@daum.net</dd></dl><!-- <dl>\r\n            <dt>[개인정보보호 담당자]</dt>\r\n            <dd>성명/직책 : 이윤정 / 간사</dd>\r\n            <dd>전화번호/이메일 : 02-3142-1900 / incubating@daum.net</dd>\r\n          </dl> --><p>(* 전화번호나 이메일로 연락을 주실 때 실무 담당자에게 연락됩니다.)</p><p></p><p>2. 이용자는 복지재단의 서비스를 이용하시면서 발생한 모든 개인정보보호 관련 문의, 불만 처리, 피해구제 등에 관한 사항을 개인정보보호 책임자 또는 담당 부서로 문의하실 수 있습니다. ‘복지재단’은 정보 주체의 문의에 대해 지체없이 답변 및 처리해 드릴 것입니다.</p></section><section><p><strong>제12조 (가명정보의 처리)</strong></p><p>1. 복지재단은 통계작성, 과학적 연구, 공익적 기록보존 등을 위하여 수집한 개인정보를 특정 개인을 알아볼 수 없도록 가명처리하여 다음과 같이 처리하고 있습니다.</p><p><table class=reportTable><colgroup><col width=20%><col width=18%><col width=*><col width=20%></colgroup><thead><tr><th>구분</th><th>처리 목적</th><th>처리항목</th><th>보유 및 이용기간</th></tr></thead><tbody><tr><td>재단 서비스개발 및 연구</td><td>사이트 이용 분석을 통한 서비스 개발 및 맞춤 서비스 제안</td><td>계정정보, 웹사이트 방문이력, 검색이력, 이용이력(신청정보), 서비스 이용내역</td><td>회원 탈퇴 및 처리<br>목적 달성 시까지</td></tr></tbody></table></p><p>2. 복지재단은 가명정보 사용 시, 「개인정보보호법」 제28조의2(가명정보의 처리 등), 제28조의3(가명정보의 결합제한), 제28조의4(가명정보에 대한 안전조치의무 등)에 따른 관리적ㆍ기술적ㆍ물리적 보호조치 이행 및 제28조의5(가명정보 처리시 금지의무 등) 등 관련 법령을 준수합니다</p></section><section><p><strong>제13조 (만14세 미만 아동의 개인정보보호 대책)</strong></p><p>1. 복지재단은 「개인정보보호법」제22조(동의를 받는 방법) 및 제39조의3에 따라 만 14세 미만 아동의 회원가입시 법정대리인의 동의를 받습니다.</p><p>2. 이용자의 생년월일이 만14세 미만 아동일 경우에는 법정대리인의 동의를 받기 위하여 법정대리인 정보(법정대리인의 성명, 휴대전화번호)를 추가로 수집합니다.</p><p>3. 만 14세 미만 아동(만 14세 미만 아동의 법정대리인)은 복지재단의 본 사이트에 해당 아동의 개인정보 열람, 정정ㆍ삭제, 처리정지 요구를 할 수 있습니다.<br>다만, 각각의 요구사항은 다음의 「개인정보보호법」 각 조항에 따라 거절될 수 있습니다.<ul><li>1) 열람 요구-제35조제4항에 따라 열람금지 등의 사유가 있는 경우.</li><li>2) 정정ㆍ삭제 요구-제36조제1항에 따라 다른 법령에서 수집 대상으로 명시되어 있는 경우.</li><li>3) 처리정지 요구-제37조제2항의 단서조항에 따라 준수 의무를 이행해야 하는 경우.</li></ul></p></section><section><p><strong>제14조 (권익침해 구제방법)</strong></p><p>이용자는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.</p><p>◎ 아래의 기관은 복지재단과는 별개의 기관으로서, ‘복지재단’의 자체적인 개인정보 불만 처리, 피해구제 결과에 만족하지 못하시거나 더욱 자세한 도움이 필요하시면 문의 가능합니다.</p><ul><li>개인정보분쟁조정위원회 1833-6972 https://www.kopico.go.kr</li><li>개인정보침해신고센터 (국번 없이) 118 https://privacy.kisa.or.kr</li><li>대검찰청 사이버수사과 (국번 없이) 1301 https://www.spo.go.kr</li><li>경찰청 사이버수사국 (국번 없이) 182 https://cyberbureau.police.go.kr</li></ul></section><section><p><strong>제15조 (개인정보 처리방침 변경)</strong></p><p>이 개인정보 처리방침은 2023년 01월 02일부터 적용됩니다.</p></section><section><p><strong>이전내용보기</strong></p><p><a ui-sref=login.privacyPolicy2022>개인정보처리방침(2022-10-06 적용)</a></p><p><a ui-sref=login.privacyPolicy2021>개인정보처리방침(2021-05-12 적용)</a></p></section></div></div><!-- // section#privacyPolicy --></section><!-- // privacyPolicy -->");
$templateCache.put("components/qna/qna.html","<!-- qna --><section id=qna class=\"subPageWrap mtb100\"><!-- section#qna --><div class=\"sp_header mb30\"><div class=eland_content><h2 class=title>1:1 문의하기</h2></div></div><div class=sp_container><div class=eland_content><p class=qnaGuide><span class=\"glyphicon glyphicon-phone-alt\"></span><br>더 자세한 문의사항은 <span class=green><strong>02-2644-0110</strong></span>으로<br>문의 주시면 친절하게 답변해 드리겠습니다.</p></div></div><!-- // section#qna --></section><!-- // qna -->");
$templateCache.put("components/termsOfService/termsOfService.html","<!-- privacyPolicy --><section id=privacyPolicy class=\"subPageWrap mtb100 sub_w720\"><!-- section#privacyPolicy --><div class=\"sp_header mb30\"><div class=eland_content><h2 class=title>이용약관</h2><p class=sub_title>[이랜드재단 플랫폼 ‘SOS위고’ 이용약관]</p></div></div><div class=sp_container><div class=\"eland_content policy_content\"><section><p><strong>제1조(목적)</strong></p><p>본 약관은 사회복지법인 이랜드복지재단(이하 \'복지재단\')이 운영하는 플랫폼 ‘SOS위고’ 사이트(https://soswego.co.kr)의 서비스를 이용하는 이용자 및 복지재단의 권리와 의무 및 책임 사항과 기타 필요한 사항을 규정함을 목적으로 합니다.</p></section><section><p><strong>제2조(정의)</strong></p><p>1. 이 약관에서 사용하는 용어의 정의는 다음과 같습니다.<ul><li>① 서비스: 구현되는 단말기(PC, TV, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 플랫폼 ‘SOS위고’에서 시행하는 다양한 지원사업 및 관련 제반 서비스</li><li>②	이용자: 사이트에 접속하여 이 약관에 따라 복지재단이 제공하는 서비스를 받는 회원 또는 비회원</li><li>③	회원: 복지재단의 사이트에 접속하여 이 약관에 따라 복지재단 플랫폼 ‘SOS위고’ 사이트과 이용계약을 체결하고 복지재단 사이트를 이용하는 이용자 ID(아이디)를 부여받은 자</li><li>④	비회원: 회원에 가입하지 않고 복지재단 플랫폼 ‘SOS위고’ 사이트가 제공하는 서비스를 이용하는 자</li><li>⑤ 이용계약: 서비스 이용과 관련하여 복지재단 플랫폼 ‘SOS위고’ 사이트와 이용자 간에 체결하는 계약</li><li>⑥	아이디(ID): 회원의 식별과 서비스 이용을 위하여 회원이 정하고 복지재단 플랫폼 ‘SOS위고’ 사이트가 승인하는 문자와 숫자의 조합을 의미</li><li>⑦	비밀번호: 회원이 부여받은 아이디와 일치되는 회원임을 확인하고 비밀 보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합을 의미</li><li>⑧	회원탈퇴(이하 ‘탈퇴’): 회원이 홈페이지 이용계약을 해약하는 행위</li><li>⑨	게시물: 회원이 서비스를 이용에 있어 서비스상에 게시한 부호ㆍ문자ㆍ음성ㆍ음향ㆍ화상ㆍ동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미</li></ul></p><p>2.	이 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관계 법령 및 서비스별 안내에서 정하는 바에 의합니다.</p></section><section><p><strong>제3조(약관의 효력 및 변경)</strong></p><p>1. 이 약관은 서비스 화면에 게시하거나 기타의 방법으로 공지함으로써 이용자에게 공시하고, 이에 동의한 이용자가 서비스에 가입함으로써 효력이 발생합니다.</p><p>2. 복지재단은 필요하다고 인정되는 경우 ‘약관의 규제에 관한 법률’, ‘「개인정보보호법」’, ‘정보통신망 이용촉진 및 정보보호에 관한 법률(이하 ’정보통신망법‘)’ 등 관련 법을 위배하지 않는 범위에서 본 약관을 개정ㆍ변경할 수 있습니다.</p><p>3. 복지재단이 본 약관을 개정할 경우 적용 일자 및 개정 사유를 명시하여 현행약관과 함께 그 적용 일자 30일 이전부터 적용 일자 전 일까지 제1항과 같은 방법으로 공지 또는 통지하도록 합니다.</p><p>4. 복지재단의 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 30일 기간 내에 의사표시를 하지 않으면 동의한 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.</p><p>5. 복지재단은 변경된 약관에 동의하지 않을 경우, 서비스 이용을 중단하고 탈퇴할 수 있습니다. 약관이 변경된 이후에도 계속하여 의사표시가 표명되지 아니하면, 회원이 약관의 변경 사항에 동의한 것으로 간주합니다.</p></section><section><p><strong>제4조(약관의 해석)</strong></p><p>본 약관에서 명시하지 않은 사항은 전기통신사업법 등 관계 법령 또는 상 관례에 따릅니다.</p></section><section><p><strong>제5조(회원가입)</strong></p><p>1. 이용계약은 회원이 되고자 하는 자가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 복지재단이 이러한 신청에 대하여 승낙함으로써 체결됩니다.</p><p>2. 복지재단은 회원이 되고자 하는 자의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, 복지재단은 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.<ul><li>① 실명이 아니거나 타인의 명의를 이용한 경우</li><li>② 이용자의 귀책사유로 인하여 승인할 수 없거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</li><li>③ 부정한 용도로 본 서비스를 이용하고자 하는 경우</li><li>④ 사회의 안녕과 질서, 미풍양속을 저해할 목적으로 신청한 경우</li><li>⑤ 허위정보를 기재하거나, 복지재단이 제시하는 내용을 기재하지 않은 경우</li></ul></p><p>3. 복지재단은 회원의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.</p><p>4. 제2항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 복지재단은 원칙적으로 이를 가입 신청자에게 알리도록 합니다.</p><p>5. 이용계약의 성립 시기는 복지재단이 가입 완료를 신청절차 상에서 표시한 시점으로 합니다.</p><p>6.「개인정보보호법」 제22조(동의를 받는 방법)에 의거 만 14세 미만 아동의 회원가입 시 법정대리인의 동의가 필요합니다.</p></section><section><p><strong>제6조(회원탈퇴 및 자격 상실 등 계약해제)</strong></p><p>1. 회원은 복지재단에 언제든지 탈퇴를 요청할 수 있으며 복지재단은 즉시 회원탈퇴를 처리합니다.</p><p>2. 회원이 탈퇴를 원하면 회원 본인이 직접 전자메일을 통해 운영자에게 해지 신청을 요청하여 탈퇴할 수 있습니다.</p><p>3. 회원이 계약을 해지할 경우, 관련 법 및 개인정보처리방침에 따라 복지재단이 회원 정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터는 소멸합니다.</p><p>4. 탈퇴 신청과 동시에 가입 시 기재하였던 개인정보는 삭제되나, 지원사업 선정자 정보는 관련 법령에 따라 보유의무기간(5년)과 같이 유지됩니다.</p><p>5. 회원이 계약을 해지하는 경우, 회원이 게시판에 등록한 게시물 등은 삭제되지 않으니 사전에 삭제 후 탈퇴하시기 바랍니다.</p><p>6. 복지재단은 다음 각 호의 사유에 해당하는 회원의 자격을 제한 및 정지시킬 수 있습니다.<ul><li>①	가입신청 시에 허위 내용을 등록한 경우</li><li>②	다른 사람의 사이트 이용을 방해하거나 그 정보를 도용하는 등 질서를 위협하는 경우</li><li>③	사이트를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</li></ul></p><p>7. 복지재단이 회원자격을 제한/정지시킨 후, 같은 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 복지재단은 회원자격을 상실시킬 수 있습니다.</p><p>8. 회원이 탈퇴한 이후에도 제7조 제3항의 손해배상 책임은 그대로 유효합니다.</p></section><section><p><strong>제7조(회원에 대한 통지)</strong></p><p>1. 복지재단이 회원에 대해 통지를 하는 경우 이 약관에 별도 규정이 없는 한 전자우편주소, 서신 우편, 휴대전화, 휴대전화 문자메시지, 유선전화, 서비스 내 팝업 등으로 할 수 있습니다.</p><p>2. 복지재단은 회원 전체에 대한 통지의 경우 7일 이상 복지재단의 플랫폼 사이트의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.</p></section><section><p><strong>제8조(개인정보보호)</strong></p><p>1. 복지재단은 회원 가입 시 회원 서비스 제공 이행에 필요한 최소한의 정보를 수집하고, ‘「개인정보보호법」 ’, ‘정보통신망법’ 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다.</p><p>2. 복지재단은 회원의 개인 식별이 가능한 정보를 수집하는 때에는 반드시 당해 이용자의 동의를 받습니다.</p><p>3. 회원의 개인정보보호에 관한 사항은 관계 법령 및 복지재단 플랫폼 ‘SOS위고’ 사이트의 [개인정보처리방침]에 정한 바에 따릅니다. 다만, 복지재단 플랫폼 ‘SOS위고’ 사이트와 링크된 다른 사이트에서는 복지재단-SOS위고 사이트의 개인정보처리방침이 적용되지 않으므로 링크된 사이트의 개인정보처리방침을 확인하시기 바랍니다. 또한, 복지재단은 회원의 귀책사유로 인해 노출된 정보에 대해서 일체의 책임을 지지 않습니다.</p></section><section><p><strong>제9조(개인정보변경)</strong></p><p>회원은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 생년월일, 아이디(ID) 등은 수정이 불가합니다.</p></section><section><p><strong>제10조(회원의 ID 및 비밀번호에 대한 의무)</strong></p><p>1. 회원의 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.</p><p>2. 회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안 됩니다.</p><p>3. 복지재단은 회원의 ID가 개인정보 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 제3자가 회원을 복지재단 또는 복지재단 플랫폼 ‘SOS위고’ 사이트의 운영자로 오인할 우려가 있는 경우, 해당 ID의 이용을 제한할 수 있습니다.</p><p>4. 회원이 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 복지재단에 통보하고 복지재단의 안내가 있는 경우에는 그에 따라야 합니다.</p><p>5. 제3항의 경우 해당 회원이 복지재단에 그 사실을 통지하지 않거나, 통지한 때도 복지재단의 안내에 따르지 않아 발생한 불이익에 대하여 복지재단은 책임지지 않습니다.</p></section><section><p><strong>제11조(복지재단의 의무)</strong></p><p>1. 복지재단은 특별한 사정이 없으면 회원이 신청한 서비스 제공 및 서비스를 이용할 수 있도록 합니다.</p><p>2. 복지재단은 이 약관에서 정한 바에 따라 계속적, 안정적으로 서비스를 제공할 의무가 있습니다.</p><p>3. 복지재단은 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정할 때는 신속히 처리하여야 합니다. 다만, 신속한 처리가 곤란한 경우에는 회원에게 그 사유와 처리일정을 통보하여야 합니다.</p><p>4. 복지재단은 관련 법령이 정하는 바에 따라서 회원 등록정보를 포함한 회원의 개인정보를 보호하기 위하여 노력합니다.</p></section><section><p><strong>제12조(회원의 의무)</strong></p><p>1. 회원은 본 약관과 복지재단이 적법한 절차에 따라 공지 혹은 통지하는 사항을 준수하여야 하며, 기타 복지재단의 업무에 방해되거나 명예를 훼손케 하는 행위를 하여서는 안 됩니다.</p><p>2. 회원은 서비스 이용을 위해 가입할 경우 현재의 사실과 일치하는 완전한 정보(이하 \"가입정보\"라 한다)를 제공하여야 합니다. 또한, 가입정보에 변경이 발생하면 즉시 갱신하여야 합니다.</p><p>3. 회원은 자신의 ID와 비밀번호를 한 개만을 가질 수 있으며, ID와 비밀번호를 타인에게 제공하거나 대여할 수 없습니다. 또한, ID와 비밀번호에 대해 관리소홀과 부정 사용이 발생하지 않도록 유의하여야 할 책임이 있습니다.</p><p>4. 회원은 서비스를 이용하면서 다음과 같은 행위를 하지 않기로 동의합니다.<ul><li>① 타인의 ID, 비밀번호, 주민등록번호 도용 및 타인으로 가장하는 행위</li><li>② 타인과의 관계를 허위로 명시하는 행위</li><li>③ 타인을 비방할 목적으로 사실 또는 허위의 사실을 적시하여 명예를 훼손하는 행위</li><li>④ 자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 입힐 목적으로 허위의 정보를 유통하는 행위</li><li>⑤ 수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나 화상 또는 영상을 계속하여 상대방에게 도달하게 하여 상대방의 일상적 생활을 방해하는 행위</li><li>⑥ 복지재단의 동의 없이 영리를 목적으로 서비스를 사용하는 행위</li><li>⑦ 복지재단의 운영진, 직원 또는 관계자를 사칭하는 행위</li><li>⑧ 불필요하거나 승인되지 않은 광고, 판촉물을 게재하거나, 스팸, 도배글 등을 게시, 게재하는 행위</li><li>⑨ 복지재단 기타 제3자의 저작권 등 지식재산권에 대한 침해</li><li>⑩ 컴퓨터 소프트웨어, 하드웨어, 전기통신 장비를 파괴, 방해 또는 기능을 제한하기 위한 소프트웨어 바이러스를 게시, 게재 또는 전자우편으로 보내는 행위</li><li>⑪ 다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시, 게재, 전자우편으로 보내는 행위 등 다른 사용자의 개인정보를 수집 또는 저장하는 행위</li><li>⑫ 복지재단 기타 제3자의 명예를 손상하거나 업무를 방해하는 행위</li><li>⑬ 기타 불법적이거나 부당한 행위</li><li>⑭ 외설 또는 폭력적인 메시지, 화상, 음성, 기타 사회질서에 반하는 정보를 사이트에 공개 또는 게시하는 행위</li></ul></p><p>5. 회원은 관계법, 이 약관의 규정, 이용안내 및 서비스와 관련하여 공지한 주의사항, 복지재단이 통지하는 사항 등을 준수하여야 하며, 기타 복지재단의 업무에 방해되는 행위를 하여서는 안 됩니다.</p></section><section><p><strong>제13조(서비스의 제공 등)</strong></p><p>1. 복지재단은 본 서비스를 이용하는 회원을 등급별로 구분하여 이용시간, 이용횟수, 서비스메뉴 등의 이용에 차등을 둘 수 있습니다.</p><p>2. 서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.</p><p>3. 복지재단은 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 타당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 복지재단은 제7조 (회원에 대한 통지)에 정한 방법으로 회원에게 통지합니다. 다만, 복지재단이 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.</p><p>4. 복지재단은 서비스의 제공에 필요한 경우 정기점검을 할 수 있으며, 정기점검 시간은 서비스제공화면에 공지한 바에 따릅니다.</p><p>5. 복지재단은 아래의 경우 서비스 제공을 통지하고 취소할 수 있습니다.<ul><li>① 신청 내용에 허위, 기재누락, 오기가 있는 경우</li><li>② 기타 서비스를 제공하는 것이 복지재단의 현저히 지장이 있다고 판단하는 경우</li></ul></p></section><section><p><strong>제14조(서비스의 변경) </strong></p><p>1. 복지재단은 타당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다.</p><p>2. 서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경 사유, 변경될 서비스의 내용 및 제공 일자 등은 그 변경 전 7일 이상 해당 서비스 초기화면에 게시하여야 합니다.</p></section><section><p><strong>제15조(정보의 제공 및 광고의 게재) </strong></p><p>1. 복지재단은 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편, 휴대전화, 휴대전화 문자메시지 등의 방법으로 회원에게 제공할 수 있습니다. 다만, 회원은 관련 법에 따른 거래 관련 정보 및 긴급/필수고지사항 관련 정보, 고객 문의 등에 대한 답변 등을 제외하고는 언제든지 전자우편 등에 대해서 수신 거절을 할 수 있습니다.</p><p>2. 제1항의 정보를 전화 또는 팩스에 의하여 전송하는 경우에는 회원의 사전 동의를 받아서 전송합니다. 다만, 회원의 고객 문의 등에 대한 회신에서는 제외됩니다.</p><p>3. 복지재단은 서비스의 운영과 관련하여 서비스 화면, 홈페이지, 전자우편 등에 광고를 게재할 수 있습니다. 광고가 게재된 전자우편 등을 수신한 회원은 수신 거절을 복지재단에 할 수 있습니다.</p></section><section><p><strong>제16조(게시물의 저작권)</strong></p><p>1. 회원이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 회원에게 귀속되며, 이는 회원이 정당한 저작권자임을 전제로 합니다.</p><p>2. 회원은 게시물을 게시할 때, 이미지, 사진, 동영상 등 출연하는 인물들의 초상권 사용 동의를 받아 업로드 하도록 하며, 어떤 저작물의 형태를 불문하고 제 3자의 지식재산권을 침해하지 않는 내용만을 게시하여야 합니다. 만일 이와 관련해 제3자로부터 청구 내지 소제기 등이 있을 경우 회원은 복지재단을 면책시켜야 하며, 이로 인하여 복지재단에게 손해가 발생한 경우 회원은 모든 손해를 배상하여야 한다.</p><p>3. 회원이 서비스 내에 게시하는 게시물은 검색결과 또는 서비스 및 관련 홍보 등에 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정∙편집될 수 있으며, 원저작물 또는 편집저작물은 공연, 공중송신, 전시, 복제, 배포 또는 발행되어 게시될 수 있습니다(이하 “사용”이라고 함). 회원은 위 게시물에 대한 무상 사용 권한에 대한 권한을 복지재단에 수여함에 동의합니다. 이 경우, 복지재단은 저작권법 규정을 준수하며, 회원은 언제든지 고객센터 또는 서비스 내 관리기능을 통해 해당 게시물에 대해 삭제, 검색결과 제외, 비공개 등의 조처를 할 수 있습니다.</p><p>4. 복지재단은 제3항 이외의 방법으로 회원의 게시물을 이용하고자 하는 경우 전화, 팩스, 전자우편 등을 통해 사전에 회원의 동의를 얻어야 합니다.</p><p>5. 회원은 서비스를 이용하여 얻은 정보를 발췌, 가공하는 등 상업적으로 사용할 수 없습니다.</p></section><section><p><strong>제17조(게시물의 관리)</strong></p><p>1. 회원의 게시물이 정보통신망법 및 저작권법 등 관련 법에 위반되는 내용을 포함하는 경우, 권리자는 관련 법이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있으며, 복지재단은 관련 법에 따라 조처하여야 합니다.</p><p>2. 복지재단은 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 복지재단 정책 및 관련 법에 위반되는 경우 등 다음 각호에 해당하는 게시물에 대해 사전통지 없이 삭제하거나 이동 또는 등록 거부를 할 수 있습니다.<ul><li>① 다른 회원 또는 제삼자에게 심한 모욕을 주거나 명예를 손상하는 내용인 경우</li><li>② 공공질서 및 미풍양속에 위반되는 내용을 유포하거나 링크시키는 경우</li><li>③ 불법복제 또는 해킹을 조장하는 내용인 경우</li><li>④ 영리를 목적으로 하는 광고일 경우</li><li>⑤ 범죄와 결부된다고 객관적으로 인정되는 내용일 경우</li><li>⑥ 다른 이용자 또는 제삼자의 저작권 등 기타 권리를 침해하는 내용인 경우</li><li>⑦ 복지재단에서 규정한 게시물 운영정책에 어긋나거나, 게시판 성격에 부합하지 않는 경우</li><li>⑧ 기타 관계 법령에 어긋난다고 판단되는 경우</li></ul></p></section><section><p><strong>제18조(권리의 귀속)</strong></p><p>1. 서비스에 대한 저작권 및 지식재산권은 복지재단에 귀속됩니다. 단, 회원의 게시물 및 제휴계약에 따라 제공된 저작물 등은 제외합니다.</p><p>2. 복지재단은 서비스와 관련하여 회원에게 복지재단이 정한 이용 조건에 따라 계정, 아이디, 콘텐츠 등을 이용할 수 있는 이용권만을 부여하며, 회원은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.</p></section><section><p><strong>제19조(이용제한 등)</strong></p><p>1. 복지재단은 회원이 이 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 일시 정지, 영구이용정지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다.</p><p>2. 복지재단은 전항에도 불구하고, 주민등록법을 위반한 명의도용, 저작권법 및 컴퓨터프로그램 보호법을 위반한 불법프로그램의 제공 및 운영 방해, 정보통신망법을 위반한 불법 통신 및 해킹, 악성 프로그램의 배포, 접속 권한 초과행위 등과 같이 관련 법을 위반한 경우에는 즉시 영구 이용정지를 할 수 있습니다. 본 항에 따른 영구 이용 정지 시 서비스 이용을 통해 획득한 정보와 혜택 등도 모두 소멸하며, 복지재단은 이에 대해 별도로 보상하지 않습니다.</p><p>3. 본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우에는 복지재단은 제7조(회원에 대한 통지)에 따라 통지합니다.</p><p>4. 회원은 본 조에 따른 이용제한 등에 대해 복지재단이 정한 절차에 따라 이의신청을 할 수 있습니다. 이때 이의가 정당하다고 복지재단이 인정하는 경우 복지재단은 즉시 서비스의 이용을 재개합니다.</p></section><section><p><strong>제20조(책임 제한)</strong></p><p>1. 복지재단은 천재지변 또는 이에 따르는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</p><p>2. 복지재단은 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</p><p>3. 복지재단 후원사업은 회원이 서비스와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.</p><p>4. 복지재단은 회원 간 또는 회원과 제삼자 상호 간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.</p><p>5. 복지재단은 무료로 제공되는 서비스 이용과 관련하여 관련 법에 특별한 규정이 없는 한 책임을 지지 않습니다.</p><p>6. 복지재단은 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 발생한 손해에 대한 책임이 면제됩니다.</p><p>7. 복지재단은 이용자의 컴퓨터 오류에 의해 손해가 발생한 경우, 또는 회원이 신상정보 및 전자우편 주소를 부실하게 기재하여 손해가 발생한 경우 책임을 지지 않습니다.</p></section><section><p><strong>제21조(분쟁의 해결)</strong></p><p>1. 복지재단과 회원 간 제기된 소송은 대한민국 법을 준거법으로 합니다.</p><p>2. 본 약관에서 정하지 아니한 사항 및 본 약관의 해석에 관하여는 관련 법령에 따릅니다.</p><p>3. 회원과 복지재단 간 분쟁이 발생한 경우에는 이를 원만하게 해결하기 위하여 상호 간 필요한 모든 노력을 하여야 합니다.</p><p>4. 제2항의 규정에도 불구하고, 동 분쟁으로 인하여 소송이 제기될 때 동 소송은 ‘민사소송법상 관할 법원’을 전속 관할 법원으로 합니다.</p></section><section><p>부칙<br>이 약관은 2023년 01월 02일부터 적용됩니다.</p></section><section><p><strong>이전내용보기</strong></p><p><a ui-sref=login.termsOfService2021>개인정보처리방침(2021-05-12 적용)</a></p></section></div></div><!-- // section#termsOfService --></section><!-- // termsOfService -->");
$templateCache.put("components/termsOfService/termsOfService2021.html","<!-- privacyPolicy --><section id=privacyPolicy class=\"subPageWrap mtb100 sub_w720\"><!-- section#privacyPolicy --><div class=\"sp_header mb30\"><div class=eland_content><h2 class=title>이용약관</h2><p class=sub_title>[이랜드재단 플랫폼 ‘SOS위고’ 이용약관]</p></div></div><div class=sp_container><div class=\"eland_content policy_content\"><section><p><strong>제1조(목적)</strong></p><p>본 약관은 재단법인 이랜드재단(이하 \'재단\')이 운영하는 플랫폼 ‘SOS위고’의 서비스를 이용하는 이용자 및 재단의 권리와 의무 및 책임 사항과 기타 필요한 사항을 규정함을 목적으로 합니다.</p></section><section><p><strong>제2조(정의)</strong></p><p>1. 이 약관에서 사용하는 용어의 정의는 다음과 같습니다.<ul><li>①	서비스: 구현되는 단말기(PC, TV, 휴대형단말기 등의 각종 유무선 장치를 포함)와 상관없이 플랫폼 ‘SOS위고’에서 시행하는 다양한 지원사업 및 관련 제반 서비스</li><li>②	이용자: 사이트에 접속하여 이 약관에 따라 이랜드재단이 제공하는 서비스를 받는 회원 또는 비회원</li><li>③	회원: 이랜드재단의 사이트에 접속하여 이 약관에 따라 이랜드재단 플랫폼 ‘SOS위고’ 사이트과 이용계약을 체결하고 이랜드재단 사이트를 이용하는 이용자 ID(아이디)를 부여받은 자</li><li>④	비회원: 회원에 가입하지 않고 이랜드재단 플랫폼 ‘SOS위고’ 사이트가 제공하는 서비스를 이용하는 자</li><li>⑤	이용계약: 서비스 이용과 관련하여 이랜드재단 플랫폼 ‘SOS위고’ 사이트와 이용자 간에 체결하는 계약</li><li>⑥	아이디(ID): 회원의 식별과 서비스 이용을 위하여 회원이 정하고 이랜드재단 플랫폼 ‘SOS위고’ 사이트가 승인하는 문자와 숫자의 조합을 의미</li><li>⑦	비밀번호: 회원이 부여받은 아이디와 일치되는 회원임을 확인하고 비밀 보호를 위해 회원 자신이 정한 문자 또는 숫자의 조합을 의미</li><li>⑧	회원탈퇴(이하 ‘탈퇴’): 회원이 홈페이지 이용계약을 해약하는 행위</li><li>⑨	게시물: 회원이 서비스를 이용에 있어 서비스상에 게시한 부호ㆍ문자ㆍ음성ㆍ음향ㆍ화상ㆍ동영상 등의 정보 형태의 글, 사진, 동영상 및 각종 파일과 링크 등을 의미</li></ul></p><p>2.	이 약관에서 사용하는 용어의 정의는 제1항에서 정하는 것을 제외하고는 관계 법령 및 서비스별 안내에서 정하는 바에 의합니다.</p></section><section><p><strong>제3조(약관의 효력 및 변경)</strong></p><p>1.	이 약관은 서비스 화면에 게시하거나 기타의 방법으로 공지함으로써 이용자에게 공시하고, 이에 동의한 이용자가 서비스에 가입함으로써 효력이 발생합니다.</p><p>2.	재단은 필요하다고 인정되는 경우 ‘약관의 규제에 관한 법률’, ‘개인정보보호법’, ‘정보통신망 이용촉진 및 정보보호에 관한 법률(이하 ’정보통신망법‘)’ 등 관련 법을 위배하지 않는 범위에서 본 약관을 개정ㆍ변경할 수 있습니다.</p><p>3.	재단이 본 약관을 개정할 경우 적용 일자 및 개정 사유를 명시하여 현행약관과 함께 그 적용 일자 30일 이전부터 적용 일자 전 일까지 제1항과 같은 방법으로 공지 또는 통지하도록 합니다.</p><p>4.	재단의 전항에 따라 개정약관을 공지 또는 통지하면서 회원에게 30일 기간 내에 의사표시를 하지 않으면 동의한 것으로 본다는 뜻을 명확하게 공지 또는 통지하였음에도 회원이 명시적으로 거부의 의사표시를 하지 아니한 경우 회원이 개정약관에 동의한 것으로 봅니다.</p><p>5.	재단은 변경된 약관에 동의하지 않을 경우, 서비스 이용을 중단하고 탈퇴할 수 있습니다. 약관이 변경된 이후에도 계속하여 의사표시가 표명되지 아니하면, 회원이 약관의 변경 사항에 동의한 것으로 간주합니다.</p></section><section><p><strong>제4조(약관의 해석)</strong></p><p>본 약관에서 명시하지 않은 사항은 전기통신사업법 등 관계 법령 또는 상 관례에 따릅니다.</p></section><section><p><strong>제5조(회원가입)</strong></p><p>1.	이용계약은 회원이 되고자 하는 자가 약관의 내용에 대하여 동의를 한 다음 회원가입신청을 하고 이랜드재단이 이러한 신청에 대하여 승낙함으로써 체결됩니다.</p><p>2.	재단은 회원이 되고자 하는 자의 신청에 대하여 서비스 이용을 승낙함을 원칙으로 합니다. 다만, 재단은 다음 각 호에 해당하는 신청에 대하여는 승낙을 하지 않거나 사후에 이용계약을 해지할 수 있습니다.<ul><li>①	실명이 아니거나 타인의 명의를 이용한 경우</li><li>②	이용자의 귀책사유로 인하여 승인할 수 없거나 기타 규정한 제반 사항을 위반하며 신청하는 경우</li><li>③	부정한 용도로 본 서비스를 이용하고자 하는 경우</li><li>④	사회의 안녕과 질서, 미풍양속을 저해할 목적으로 신청한 경우</li><li>⑤	허위정보를 기재하거나, 재단이 제시하는 내용을 기재하지 않은 경우</li></ul></p><p>3.	재단은 회원의 종류에 따라 전문기관을 통한 실명확인 및 본인인증을 요청할 수 있습니다.</p><p>4.	제2항에 따라 회원가입신청의 승낙을 하지 아니하거나 유보한 경우, 재단은 원칙적으로 이를 가입 신청자에게 알리도록 합니다.</p><p>5.	이용계약의 성립 시기는 재단이 가입 완료를 신청절차 상에서 표시한 시점으로 합니다.</p><p>6.	개인정보 보호법 제22조(동의를 받는 방법)에 의거 만 14세 미만 아동의 회원가입 시 법정대리인의 동의가 필요합니다.</p></section><section><p><strong>제6조(회원탈퇴 및 자격 상실 등 계약해제)</strong></p><p>1.	회원은 재단에 언제든지 탈퇴를 요청할 수 있으며 재단은 즉시 회원탈퇴를 처리합니다.</p><p>2.	회원이 탈퇴를 원하면 회원 본인이 직접 전자메일을 통해 운영자에게 해지 신청을 요청하여 탈퇴할 수 있습니다.</p><p>3.	회원이 계약을 해지할 경우, 관련 법 및 개인정보처리방침에 따라 재단이 회원 정보를 보유하는 경우를 제외하고는 해지 즉시 회원의 모든 데이터는 소멸합니다.</p><p>4.	탈퇴 신청과 동시에 가입 시 기재하였던 개인정보는 삭제되나, 지원사업 선정자 정보는 관련 법령에 따라 보유의무기간(5년)과 같이 유지됩니다.</p><p>5.	회원이 계약을 해지하는 경우, 회원이 게시판에 등록한 게시물 등은 삭제되지 않으니 사전에 삭제 후 탈퇴하시기 바랍니다.</p><p>6.	재단은 다음 각 호의 사유에 해당하는 회원의 자격을 제한 및 정지시킬 수 있습니다.<ul><li>①	가입신청 시에 허위 내용을 등록한 경우</li><li>②	다른 사람의 사이트 이용을 방해하거나 그 정보를 도용하는 등 질서를 위협하는 경우</li><li>③	사이트를 이용하여 법령 또는 이 약관이 금지하거나 공서양속에 반하는 행위를 하는 경우</li></ul></p><p>7.	재단이 회원자격을 제한/정지시킨 후, 같은 행위가 2회 이상 반복되거나 30일 이내에 그 사유가 시정되지 아니하는 경우 재단은 회원자격을 상실시킬 수 있습니다.</p><p>8.	회원이 탈퇴한 이후에도 제7조 제3항의 손해배상 책임은 그대로 유효합니다.</p></section><section><p><strong>제7조(회원에 대한 통지)</strong></p><p>1.	재단이 회원에 대해 통지를 하는 경우 이 약관에 별도 규정이 없는 한 전자우편주소, 서신 우편, 휴대전화, 휴대전화 문자메시지, 유선전화, 서비스 내 팝업 등으로 할 수 있습니다.</p><p>2.	재단은 회원 전체에 대한 통지의 경우 7일 이상 재단의 플랫폼 사이트의 게시판에 게시함으로써 제1항의 통지에 갈음할 수 있습니다.</p></section><section><p><strong>제8조(개인정보보호)</strong></p><p>1.	재단은 회원 가입 시 회원 서비스 제공 이행에 필요한 최소한의 정보를 수집하고, ‘개인정보 보호법’, ‘정보통신망법’ 등 관계 법령이 정하는 바에 따라 회원의 개인정보를 보호하기 위해 노력합니다.</p><p>2.	재단은 회원의 개인 식별이 가능한 정보를 수집하는 때에는 반드시 당해 이용자의 동의를 받습니다.</p><p>3.	회원의 개인정보보호에 관한 사항은 관계 법령 및 재단 플랫폼 ‘SOS위고’ 사이트의 [개인정보처리방침]에 정한 바에 따릅니다. 다만, 재단 플랫폼 ‘SOS위고’ 사이트와 링크된 사이트에서는 재단 플랫폼 ‘SOS위고’ 사이트의 개인정보처리방침이 적용되지 않습니다. 또한, 재단은 회원의 귀책사유로 인해 노출된 정보에 대해서 일체의 책임을 지지 않습니다.</p></section><section><p><strong>제9조(개인정보변경)</strong></p><p>회원은 개인정보관리화면을 통하여 언제든지 본인의 개인정보를 열람하고 수정할 수 있습니다. 다만, 서비스 관리를 위해 필요한 실명, 생년월일, 아이디(ID) 등은 수정이 불가합니다.</p></section><section><p><strong>제10조(회원의 ID 및 비밀번호에 대한 의무)</strong></p><p>1.	회원의 ID와 비밀번호에 관한 관리책임은 회원에게 있습니다.</p><p>2.	회원은 자신의 ID 및 비밀번호를 제3자에게 이용하게 해서는 안 됩니다.</p><p>3.	재단은 회원의 ID가 개인정보 유출 우려가 있거나, 반사회적 또는 미풍양속에 어긋나거나 제3자가 회원을 이랜드재단 또는 재단 플랫폼 ‘SOS위고’ 사이트의 운영자로 오인할 우려가 있는 경우, 해당 ID의 이용을 제한할 수 있습니다.</p><p>4.	회원이 자신의 ID 및 비밀번호를 도난당하거나 제3자가 사용하고 있음을 인지한 경우에는 바로 재단에 통보하고 재단의 안내가 있는 경우에는 그에 따라야 합니다.</p><p>5.	제3항의 경우 해당 회원이 재단에 그 사실을 통지하지 않거나, 통지한 때도 재단의 안내에 따르지 않아 발생한 불이익에 대하여 재단은 책임지지 않습니다.</p></section><section><p><strong>제11조(이랜드재단의 의무)</strong></p><p>1.	재단은 특별한 사정이 없으면 회원이 신청한 서비스 제공 및 서비스를 이용할 수 있도록 합니다.</p><p>2.	재단은 이 약관에서 정한 바에 따라 계속적, 안정적으로 서비스를 제공할 의무가 있습니다.</p><p>3.	재단은 회원으로부터 제기되는 의견이나 불만이 정당하다고 인정할 때는 신속히 처리하여야 합니다. 다만, 신속한 처리가 곤란한 경우에는 회원에게 그 사유와 처리일정을 통보하여야 합니다.</p><p>4.	재단은 관련 법령이 정하는 바에 따라서 회원 등록정보를 포함한 회원의 개인정보를 보호하기 위하여 노력합니다.</p></section><section><p><strong>제12조(회원의 의무)</strong></p><p>1.	회원은 본 약관과 재단이 적법한 절차에 따라 공지 혹은 통지하는 사항을 준수하여야 하며, 기타 재단의 업무에 방해되거나 명예를 훼손케 하는 행위를 하여서는 안 됩니다.</p><p>2.	회원은 서비스 이용을 위해 가입할 경우 현재의 사실과 일치하는 완전한 정보(이하 \"가입정보\"라 한다)를 제공하여야 합니다. 또한, 가입정보에 변경이 발생하면 즉시 갱신하여야 합니다.</p><p>3.	회원은 자신의 ID와 비밀번호를 한 개만을 가질 수 있으며, ID와 비밀번호를 타인에게 제공하거나 대여할 수 없습니다. 또한, ID와 비밀번호에 대해 관리소홀과 부정 사용이 발생하지 않도록 유의하여야 할 책임이 있습니다.</p><p>4.	회원은 서비스를 이용하면서 다음과 같은 행위를 하지 않기로 동의합니다.<ul><li>①	타인의 ID, 비밀번호, 주민등록번호 도용 및 타인으로 가장하는 행위</li><li>②	타인과의 관계를 허위로 명시하는 행위</li><li>③	타인을 비방할 목적으로 사실 또는 허위의 사실을 적시하여 명예를 훼손하는 행위</li><li>④	자기 또는 타인에게 재산상의 이익을 주거나 타인에게 손해를 입힐 목적으로 허위의 정보를 유통하는 행위</li><li>⑤	수치심이나 혐오감 또는 공포심을 일으키는 말이나 음향, 글이나 화상 또는 영상을 계속하여 상대방에게 도달하게 하여 상대방의 일상적 생활을 방해하는 행위</li><li>⑥	재단의 동의 없이 영리를 목적으로 서비스를 사용하는 행위</li><li>⑦	재단의 운영진, 직원 또는 관계자를 사칭하는 행위</li><li>⑧	불필요하거나 승인되지 않은 광고, 판촉물을 게재하거나, 스팸, 도배글 등을 게시, 게재하는 행위</li><li>⑨	재단 기타 제3자의 저작권 등 지식재산권에 대한 침해</li><li>⑩	컴퓨터 소프트웨어, 하드웨어, 전기통신 장비를 파괴, 방해 또는 기능을 제한하기 위한 소프트웨어 바이러스를 게시, 게재 또는 전자우편으로 보내는 행위</li><li>⑪	다른 컴퓨터 코드, 파일, 프로그램을 포함하고 있는 자료를 게시, 게재, 전자우편으로 보내는 행위 등 다른 사용자의 개인정보를 수집 또는 저장하는 행위</li><li>⑫	회사 기타 제3자의 명예를 손상하거나 업무를 방해하는 행위</li><li>⑬	기타 불법적이거나 부당한 행위</li><li>⑭	외설 또는 폭력적인 메시지, 화상, 음성, 기타 사회질서에 반하는 정보를 사이트에 공개 또는 게시하는 행위</li></ul></p><p>5.	회원은 관계법, 이 약관의 규정, 이용안내 및 서비스와 관련하여 공지한 주의사항, 재단이 통지하는 사항 등을 준수하여야 하며, 기타 재단의 업무에 방해되는 행위를 하여서는 안 됩니다.</p></section><section><p><strong>제13조(서비스의 제공 등)</strong></p><p>1.	재단은 본 서비스를 이용하는 회원을 등급별로 구분하여 이용시간, 이용횟수, 서비스메뉴 등의 이용에 차등을 둘 수 있습니다.</p><p>2.	서비스는 연중무휴, 1일 24시간 제공함을 원칙으로 합니다.</p><p>3.	재단은 컴퓨터 등 정보통신설비의 보수점검, 교체 및 고장, 통신두절 또는 운영상 타당한 이유가 있는 경우 서비스의 제공을 일시적으로 중단할 수 있습니다. 이 경우 재단은 제7조 (회원에 대한 통지)에 정한 방법으로 회원에게 통지합니다. 다만, 재단이 사전에 통지할 수 없는 부득이한 사유가 있는 경우 사후에 통지할 수 있습니다.</p><p>4.	재단은 서비스의 제공에 필요한 경우 정기점검을 할 수 있으며, 정기점검 시간은 서비스제공화면에 공지한 바에 따릅니다.</p><p>5.	재단은 아래의 경우 서비스 제공을 통지하고 취소할 수 있습니다.<ul><li>①	신청 내용에 허위, 기재누락, 오기가 있는 경우</li><li>②	기타 서비스를 제공하는 것이 재단의 현저히 지장이 있다고 판단하는 경우</li></ul></p></section><section><p><strong>제14조(서비스의 변경) </strong></p><p>1.	재단은 타당한 이유가 있는 경우에 운영상, 기술상의 필요에 따라 제공하고 있는 전부 또는 일부 서비스를 변경할 수 있습니다.</p><p>2.	서비스의 내용, 이용방법, 이용시간에 대하여 변경이 있는 경우에는 변경 사유, 변경될 서비스의 내용 및 제공 일자 등은 그 변경 전 7일 이상 해당 서비스 초기화면에 게시하여야 합니다.</p></section><section><p><strong>제15조(정보의 제공 및 광고의 게재) </strong></p><p>1.	재단은 회원이 서비스 이용 중 필요하다고 인정되는 다양한 정보를 공지사항이나 전자우편, 휴대전화, 휴대전화 문자메시지 등의 방법으로 회원에게 제공할 수 있습니다. 다만, 회원은 관련 법에 따른 거래 관련 정보 및 긴급/필수고지사항 관련 정보, 고객 문의 등에 대한 답변 등을 제외하고는 언제든지 전자우편 등에 대해서 수신 거절을 할 수 있습니다.</p><p>2.	제1항의 정보를 전화 또는 팩스에 의하여 전송하는 경우에는 회원의 사전 동의를 받아서 전송합니다. 다만, 회원의 고객 문의 등에 대한 회신에서는 제외됩니다.</p><p>3.	재단은 서비스의 운영과 관련하여 서비스 화면, 홈페이지, 전자우편 등에 광고를 게재할 수 있습니다. 광고가 게재된 전자우편 등을 수신한 회원은 수신 거절을 재단에 할 수 있습니다.</p></section><section><p><strong>제16조(게시물의 저작권)</strong></p><p>1.	회원이 서비스 내에 게시한 게시물의 저작권은 해당 게시물의 회원에게 귀속되며, 이는 회원이 정당한 저작권자임을 전제로 합니다.</p><p>2.	회원은 게시물을 게시할 때, 이미지, 사진, 동영상 등 출연하는 인물들의 초상권 사용 동의를 받아 업로드 하도록 하며, 어떤 저작물의 형태를 불문하고 제 3자의 지식재산권을 침해하지 않는 내용만을 게시하여야 합니다. 만일 이와 관련해 제3자로부터 청구 내지 소제기 등이 있을 경우 회원은 재단을 면책시켜야 하며, 이로 인하여 재단에게 손해가 발생한 경우 회원은 모든 손해를 배상하여야 한다.</p><p>3.	회원이 서비스 내에 게시하는 게시물은 검색결과 또는 서비스 및 관련 홍보 등에 노출될 수 있으며, 해당 노출을 위해 필요한 범위 내에서는 일부 수정∙편집될 수 있으며, 원저작물 또는 편집저작물은 공연, 공중송신, 전시, 복제, 배포 또는 발행되어 게시될 수 있습니다(이하 “사용”이라고 함). 회원은 위 게시물에 대한 무상 사용 권한에 대한 권한을 재단에 수여함에 동의합니다. 이 경우, 재단은 저작권법 규정을 준수하며, 회원은 언제든지 고객센터 또는 서비스 내 관리기능을 통해 해당 게시물에 대해 삭제, 검색결과 제외, 비공개 등의 조처를 할 수 있습니다.</p><p>4.	재단은 제3항 이외의 방법으로 회원의 게시물을 이용하고자 하는 경우 전화, 팩스, 전자우편 등을 통해 사전에 회원의 동의를 얻어야 합니다.</p><p>5.	회원은 서비스를 이용하여 얻은 정보를 발췌, 가공하는 등 상업적으로 사용할 수 없습니다.</p></section><section><p><strong>제17조(게시물의 관리)</strong></p><p>1.	회원의 게시물이 정보통신망법 및 저작권법 등 관련 법에 위반되는 내용을 포함하는 경우, 권리자는 관련 법이 정한 절차에 따라 해당 게시물의 게시중단 및 삭제 등을 요청할 수 있으며, 재단은 관련 법에 따라 조처하여야 합니다.</p><p>2.	재단은 전항에 따른 권리자의 요청이 없는 경우라도 권리침해가 인정될 만한 사유가 있거나 기타 회사 정책 및 관련 법에 위반되는 경우 등 다음 각호에 해당하는 게시물에 대해 사전통지 없이 삭제하거나 이동 또는 등록 거부를 할 수 있습니다.<ul><li>①	다른 회원 또는 제삼자에게 심한 모욕을 주거나 명예를 손상하는 내용인 경우</li><li>②	공공질서 및 미풍양속에 위반되는 내용을 유포하거나 링크시키는 경우</li><li>③	불법복제 또는 해킹을 조장하는 내용인 경우</li><li>④	영리를 목적으로 하는 광고일 경우</li><li>⑤	범죄와 결부된다고 객관적으로 인정되는 내용일 경우</li><li>⑥	다른 이용자 또는 제삼자의 저작권 등 기타 권리를 침해하는 내용인 경우</li><li>⑦	재단에서 규정한 게시물 운영정책에 어긋나거나, 게시판 성격에 부합하지 않는 경우</li><li>⑧	기타 관계 법령에 어긋난다고 판단되는 경우</li></ul></p></section><section><p><strong>제18조(권리의 귀속)</strong></p><p>1.	서비스에 대한 저작권 및 지식재산권은 재단에 귀속됩니다. 단, 회원의 게시물 및 제휴계약에 따라 제공된 저작물 등은 제외합니다.</p><p>2.	재단은 서비스와 관련하여 회원에게 재단이 정한 이용 조건에 따라 계정, 아이디, 콘텐츠 등을 이용할 수 있는 이용권만을 부여하며, 회원은 이를 양도, 판매, 담보제공 등의 처분행위를 할 수 없습니다.</p></section><section><p><strong>제19조(이용제한 등)</strong></p><p>1.	재단은 회원이 이 약관의 의무를 위반하거나 서비스의 정상적인 운영을 방해한 경우, 경고, 일시 정지, 영구이용정지 등으로 서비스 이용을 단계적으로 제한할 수 있습니다.</p><p>2.	재단은 전항에도 불구하고, 주민등록법을 위반한 명의도용, 저작권법 및 컴퓨터프로그램 보호법을 위반한 불법프로그램의 제공 및 운영 방해, 정보통신망법을 위반한 불법 통신 및 해킹, 악성 프로그램의 배포, 접속 권한 초과행위 등과 같이 관련 법을 위반한 경우에는 즉시 영구 이용정지를 할 수 있습니다. 본 항에 따른 영구 이용 정지 시 서비스 이용을 통해 획득한 정보와 혜택 등도 모두 소멸하며, 재단은 이에 대해 별도로 보상하지 않습니다.</p><p>3.	본 조에 따라 서비스 이용을 제한하거나 계약을 해지하는 경우에는 재단은 제7조(회원에 대한 통지)에 따라 통지합니다.</p><p>4.	회원은 본 조에 따른 이용제한 등에 대해 재단이 정한 절차에 따라 이의신청을 할 수 있습니다. 이때 이의가 정당하다고 재단이 인정하는 경우 재단은 즉시 서비스의 이용을 재개합니다.</p></section><section><p><strong>제20조(책임 제한)</strong></p><p>1.	재단은 천재지변 또는 이에 따르는 불가항력으로 인하여 서비스를 제공할 수 없는 경우에는 서비스 제공에 관한 책임이 면제됩니다.</p><p>2.	재단은 회원의 귀책사유로 인한 서비스 이용의 장애에 대하여는 책임을 지지 않습니다.</p><p>3.	재단 후원사업은 회원이 서비스와 관련하여 게재한 정보, 자료, 사실의 신뢰도, 정확성 등의 내용에 관하여는 책임을 지지 않습니다.</p><p>4.	재단은 회원 간 또는 회원과 제삼자 상호 간에 서비스를 매개로 하여 거래 등을 한 경우에는 책임이 면제됩니다.</p><p>5.	재단은 무료로 제공되는 서비스 이용과 관련하여 관련 법에 특별한 규정이 없는 한 책임을 지지 않습니다.</p><p>6.	재단은 서비스용 설비의 보수, 교체, 정기점검, 공사 등 부득이한 사유로 발생한 손해에 대한 책임이 면제됩니다.</p><p>7.	재단은 이용자의 컴퓨터 오류에 의해 손해가 발생한 경우, 또는 회원이 신상정보 및 전자우편 주소를 부실하게 기재하여 손해가 발생한 경우 책임을 지지 않습니다.</p></section><section><p><strong>제21조(분쟁의 해결)</strong></p><p>1.	재단과 회원 간 제기된 소송은 대한민국 법을 준거법으로 합니다.</p><p>2.	본 약관에서 정하지 아니한 사항 및 본 약관의 해석에 관하여는 관련 법령에 따릅니다.</p><p>3.	회원과 재단 간 분쟁이 발생한 경우에는 이를 원만하게 해결하기 위하여 상호 간 필요한 모든 노력을 하여야 합니다.</p><p>4.	제2항의 규정에도 불구하고, 동 분쟁으로 인하여 소송이 제기될 때 동 소송은 ‘민사소송법상 관할 법원’을 전속 관할 법원으로 합니다.</p></section><section><p>부칙<br>이 약관은 2021년 05월 28일부터 적용됩니다.</p></section></div></div><!-- // section#termsOfService --></section><!-- // termsOfService -->");
$templateCache.put("app/dashboard/stats/stats.html","<div class=\"col-lg-3 col-md-6\"><div class=\"panel panel-{{ states.colour }}\"><div class=panel-heading><div class=row><div class=col-xs-3><i class=\"fa fa-{{ states.type }} fa-5x\"></i></div><div class=\"col-xs-9 text-right\"><div class=huge>{{ states.number }}</div><div>{{ states.comments }}</div></div></div></div><a ui-sref=dashboard.home><div class=panel-footer><span class=pull-left>View Details</span> <span class=pull-right><i class=\"fa fa-arrow-circle-right\"></i></span><div class=clearfix></div></div></a></div></div>");
$templateCache.put("app/eland-request/ai/prompt_story.html","<div class=story><div class=txt-section><div class=title style=\"margin: 10px 0 20px 0; font-weight: bold\"><span class=title1 style=\"font-size: xx-large; font-weight: bold\">[인용형 또는 스토리형 제목 — 위기와 변화가 드러나는 문장]</span><div class=title2>[\"SOS위고\"의 지원 사실을 요약한 부제형 문장]</div></div><div class=subtitle style=\"margin: 10px 0 20px 0; font-weight: bold\"><div class=subtitle1>[지원 대상과 위기상황을 압축한 문장]</div><div class=subtitle2>[지원금액과 핵심 성과를 압축한 문장]</div></div><div class=intro><div class=sub-content style=\"margin-bottom: 15px\">[\"SOS위고\"가 누구에게, 어떤 위기를, 무엇을 지원했는지 1~2문장으로 요약]</div></div><div class=sub><div class=sub-title style=\"margin-bottom: 10px; color: navy; font-weight: bold\">◎ [지원 전 위기상황을 압축한 소제목 문장]</div><div class=sub-content style=\"margin-bottom: 15px\">[이 영역은 10문장 이상으로 작성. 주거·경제·건강·가족·고립 등 복합위기를 구체적으로 설명하고, 본인이나 가족의 힘만으로 해결이 어려웠던 이유를 서술하며, 공적 지원이나 기존 제도로 해결되지 않았던 복지사각지대 요소까지 자연스럽게 하나의 이야기 흐름으로 풀어써서 채울 것]</div></div><div class=sub><div class=sub-title style=\"margin-bottom: 10px; color: navy; font-weight: bold\">◎ [지원 내용과 즉각적 변화를 압축한 소제목 문장]</div><div class=sub-content style=\"margin-bottom: 15px\">[이 영역은 10문장 이상으로 작성. 지원금액과 구체적 사용처를 밝히고, 지원 전후를 비교해 안전·주거안정의 변화를 설명하며, 정서적 안정과 일상회복, 가족 및 지역사회의 변화까지 하나의 흐름으로 자연스럽게 풀어써서 채울 것]</div></div><div class=sub><div class=sub-title style=\"margin-bottom: 10px; color: navy; font-weight: bold\">◎ [대상자의 반응과 지원의 의미를 압축한 소제목 문장]</div><div class=sub-content style=\"margin-bottom: 15px\">[이 영역은 10문장 이상으로 작성. 대상자의 실제 말이나 감사편지를 자연스럽게 인용하고, 삶의 희망과 존엄을 회복한 의미, 복지사각지대 지원의 사회적 의미, 기관 관계자 인용문과 재단의 향후 방향(주거지원은 단순 집수리가 아니라 생명·안전·존엄을 지키는 긴급지원이라는 메시지 포함)까지 하나의 흐름으로 자연스럽게 풀어써서 채울 것]</div></div><div class=message><div class=sub-title style=\"margin-bottom: 10px; color: navy; font-weight: bold\">◎ 핵심 메시지</div><div class=sub-content style=\"margin-bottom: 15px\"><div class=say-section>[보도자료 전체를 관통하는 핵심 메시지 1문장]</div></div></div><div class=keyword><div class=sub-title style=\"margin-bottom: 10px; color: navy; font-weight: bold\">◎ 핵심 키워드</div><div class=sub-content style=\"margin-bottom: 15px\">[핵심 키워드 15개 내외, 쉼표로 구분]</div></div></div><div class=img-section><div class=letter-section style=\"margin-bottom: 10px\"><div class=img-title style=\"background-color: navy; color: white; width:150px; text-align:center; margin-bottom: 10px\">감사 편지</div><div class=img-letter><img></div></div><div class=before-section style=\"margin-bottom: 10px\"><div class=img-title style=\"background-color: navy; color: white; width:150px; text-align:center; margin-bottom: 10px\">지원 전 사진</div><div class=img-before><img></div></div><div class=after-section style=\"margin-bottom: 10px\"><div class=img-title style=\"background-color: navy; color: white; width:150px; text-align:center; margin-bottom: 10px\">지원 후 사진</div><div class=img-after><img></div></div></div></div>");
$templateCache.put("app/company/modal/change-status-modal-view.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>반려 의견</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>의견 내용</label><textarea class=form-control ng-model=modalCtrl.data.StatusCn style=\"resize: none; height: 80px\"></textarea></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>저장</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/company/modal/contact-user-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>기관 담당자 검색</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getUserList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-10 col-md-10 col-lg-10 col-xl-10\"><div class=\"form-group form-inline\"><label>이름</label><input type=text class=form-control ng-model=modalCtrl.UserNm placeholder=\"{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getUserList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>이름</th><th data-toggle=true class=text-center>기관명</th></tr></thead><tbody ng-if=\"modalCtrl.totalCount == 0\"><tr class=tbnodata><td class=text-center colspan=2>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.UserList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.UserNm></span></td><td class=text-center><span ng-bind=li.TenantNm></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getUserList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/eland-request/modal/comm-admin-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>비밀댓글 관리자 검색</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getUserList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-10 col-md-10 col-lg-10 col-xl-10\"><div class=\"form-group form-inline\"><label>이름</label><input type=text class=form-control ng-model=modalCtrl.UserNm placeholder=\"{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getUserList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>이름</th><th data-toggle=true class=text-center>기관명</th></tr></thead><tbody ng-if=\"modalCtrl.totalCount == 0\"><tr class=tbnodata><td class=text-center colspan=2>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.UserList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.UserNm_></span></td><td class=text-center><span ng-bind=li.TenantNm></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getUserList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/eland-request/modal/file-view-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>파일 미리보기</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"panel panel-default\">{{modalCtrl.filePath}}//{{modalCtrl.viewType}} <img ng-src={{modalCtrl.filePath}} ng-show=\"modalCtrl.viewType == \'jpg\'\"><iframe style=\"width:100%; height:100%\" frameboarder=0 ng-src={{modalCtrl.filePath}} ng-show=\"modalCtrl.viewType == \'pdf\'\"></iframe></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>닫기</button></div></div>");
$templateCache.put("app/eland-request/modal/recom-tenant-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>추천기관 검색</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-10 col-lg-10 col-xl-10\"><div class=\"form-group form-inline\"><label>기관명</label><input type=text class=form-control ng-model=vc.srch.TenantNm placeholder=\"{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2\" style=\"text-align: right\"><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=50%><col width=50%></colgroup><thead><tr><th class=text-center>회원사명</th><th class=text-center>전화번호</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.tenantlists\" ng-click=vc.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.TenantNm></span></td><td class=text-center><span ng-bind=li.TelNo></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/eland-request/modal/self-chk-modal.html","<script>var msg = \"SOS위고 신청서 작성 전 사전 자가진단을 반드시 진행해 주세요.\\n\"\r\n  msg = msg + \"자가진단 결과 지원 기준에 적합한 경우에만\\n\"\r\n  msg = msg + \"신청서 작성이 가능합니다.\\n\"\r\n  msg = msg + \"※ 최종 지원 여부는 신청서와 증빙자료 심사를 통해 결정됩니다.\\n\\n\"\r\n  msg = msg + \"[자가진단 시작하기]\";\r\n  alert(msg);</script><div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>SOS위고 자가심사표</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><div class=\"modal-footer ng-scope\"><div style=\"width:70%; text-align: left; float: left; margin-top: 10px\">※ 신청서 정보를 기반으로 판단 지표에 해당 시 체크하세요. | 총점 14점 이상 시 1차 선정</div><button class=\"btn btn-primary\" ng-click=modalCtrl.ok()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div><table class=tipTable><colgroup><col style=\"width: 4%\"><col style=\"width: 8%\"><col style=\"width: 16%\"><col><col style=\"width: 20%\"><col style=\"width: 4%\"><col style=\"width: 4%\"><col style=\"width: 4%\"></colgroup><tbody><tr style=height:40px><th>번호</th><th>영역</th><th>판별항목</th><th colspan=2>판단지표</th><th>체크</th><th>배점</th><th>점수</th></tr><tr ng-repeat=\"qst in modalCtrl.selfData\"><td ng-style=\"{\'background-color\': qst.css2}\">{{qst.no}}</td><td ng-style=\"{\'background-color\': qst.css1, \'color\': \'white\'}\">{{qst.sec1}}</td><td class=td-left ng-style=\"{\'background-color\': qst.css2}\">{{qst.sec2}}</td><td class=td-left colspan=2 style=padding:5px>{{qst.txt}}</td><td><input type=checkbox name=chk ng-model=qst.chk ng-true-value=1 ng-false-value=0 ng-checked=\"qst.chk == \'1\'\" ng-click=modalCtrl.calc()></td><td>{{qst.sc}}</td><td>{{qst.chk}}</td></tr></tbody><tfoot><tr style=height:40px><th colspan=5><span style=font-weight:bold>총점 {{modalCtrl.selfDataResult.totalSc}}점</span> | 14점 이상: 1차 선정 / 7~13점: 자원연계 / 6점 이하: 지원 제외</th><th></th><th>29</th><th>{{modalCtrl.selfDataResult.totalSc}}</th></tr><tr style=height:40px><th colspan=4 style=\"text-align:right; padding-right: 10px\">지원단계</th><th colspan=4 style=\"text-align:right; padding-right: 10px\">{{modalCtrl.selfDataResult.stepTxt}}</th></tr><tr style=height:40px><th colspan=4 style=\"text-align:right; padding-right: 10px\">권장지원금</th><th colspan=4 style=\"text-align:right; padding-right: 10px\">{{modalCtrl.selfDataResult.amtTxt}}</th></tr></tfoot></table><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary\" ng-click=modalCtrl.ok()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div><!-- /row --></div></div></div><!-- //modal-body --></div>");
$templateCache.put("app/eland-request/modal/sv-admin-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>현장실사 심사자 검색</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getUserList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-10 col-md-10 col-lg-10 col-xl-10\"><div class=\"form-group form-inline\"><label>이름</label><input type=text class=form-control ng-model=modalCtrl.UserNm placeholder=\"{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getUserList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>이름</th><th data-toggle=true class=text-center>기관명</th></tr></thead><tbody ng-if=\"modalCtrl.totalCount == 0\"><tr class=tbnodata><td class=text-center colspan=2>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.UserList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.UserNm_></span></td><td class=text-center><span ng-bind=li.TenantNm></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getUserList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/eland-request/modal/volunteer-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>봉사단 검색</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getUserList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label><input type=text class=form-control ng-model=modalCtrl.UserNm placeholder=\"{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'WorkStatus\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"modalCtrl.columnMap[\'WorkStatus\'].CodeList\" code-model=modalCtrl.WorkStatus></common-code-custom></div></div><div class=\"col-xs-12 col-sm-2 col-md-2 col-lg-2 col-xl-2\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getUserList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'TenantNm\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'WorkStatus\'].ColumnLogicalNm | translate }}</th></tr></thead><tbody ng-if=\"modalCtrl.totalCount == 0\"><tr class=tbnodata><td class=text-center colspan=3>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.UserList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.UserNm></span></td><td class=text-center><span ng-bind=li.TenantNm></span></td><td class=text-center><span ng-bind=li.WorkStatus></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getUserList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("app/system/department/department-detail.html","<div class=\"page page-footable\" ng-controller=\"DepartmentDetailCtrl as vc\"><!-- page header --><div class=pageheader><h2>{{ \'Menu.DEPTLIST\' | translate }}</h2><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> Salevis</a></li><li><a>{{ \'Menu.MANAGEMENT\' | translate }}</a></li><li><a>{{ \'Menu.DEPTLIST\' | translate }}</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><section class=tile fullscreen=isFullscreen01><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.DEPTLIST\' | translate }} {{ \'Menu.MODIFY\' | translate }}</strong></h4></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" activate-button ui-sref=app.system.department-list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10\" activate-button ui-sref=\"app.system.department-edit({DeptId:\'{{vc.srch.DeptId}}\'})\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div><table class=\"table table-togglable table-hover\"><colgroup><col width=160><col width=*></colgroup><tbody><tr><th scope=row>{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.NAME\' | translate }}</th><td><span ng-bind=vc.data.DeptNm></span></td></tr><tr><th scope=row>{{ \'Menu.PARENT\' | translate }}{{ \'Menu.DEPARTMENT\' | translate }}</th><td><span ng-bind=vc.data.ParentDeptNm></span></td></tr><tr><th scope=row>{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.SORTORDER\' | translate }}</th><td><span ng-bind=vc.data.Sort></span></td></tr><tr><th scope=row>{{ \'Menu.REGISTRATIONDATE\' | translate }}</th><td><span ng-bind=vc.data.RegDate></span></td></tr><tr><th scope=row>{{ \'Menu.REGISTRATIONUSER\' | translate }}</th><td><span ng-bind=vc.data.RegUserNm></span></td></tr></tbody></table></div></section></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/department/department-edit.html","<div class=\"page page-footable\" ng-controller=\"DepartmentEditCtrl as vc\"><!-- page header --><div class=pageheader><h2>{{ \'Menu.DEPTLIST\' | translate }}</h2><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> Salevis</a></li><li><a>{{ \'Menu.MANAGEMENT\' | translate }}</a></li><li><a>{{ \'Menu.DEPTLIST\' | translate }}</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><section class=tile fullscreen=isFullscreen01><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>{{ \'Menu.REGISTRATIONUSER\' | translate }}/{{ \'Menu.EDIT\' | translate }}</strong></h4></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" activate-button ui-sref=app.system.department-list><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.saveDetail()><i class=\"fa fa-check\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div><form class=\"form-horizontal ng-pristine ng-valid\" role=form><div class=form-group><label for=id class=\"col-sm-2 control-label\">{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.NAME\' | translate }} :</label><div class=col-sm-10><input type=text class=form-control ng-model=vc.data.DeptNm></div></div><div class=form-group><label for=id class=\"col-sm-2 control-label\">{{ \'Menu.PARENT\' | translate }}{{ \'Menu.DEPARTMENT\' | translate }} :</label><div class=col-sm-10><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control ng-model=vc.data.ParentDeptNm placeholder=부서> <input type=hidden ng-model=vc.data.ParentDeptId> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchDeptModal(); ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseDept(); ng-disabled=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-eraser\"></i></button></span></div></div></div><div class=form-group><label for=id class=\"col-sm-2 control-label\">{{ \'Menu.DEPARTMENT\' | translate }}{{ \'Menu.SORTORDER\' | translate }} :</label><div class=col-sm-10><input type=number class=form-control ng-model=vc.data.Sort></div></div></form></div><!-- /tile body --></section><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/department/department-list.html","<div class=\"page page-footable\" ng-controller=\"DepartmentListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.DEPTLIST\' | translate }}</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><!-- row --><div class=row><!-- col --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-info title-header\"><div class=panel-heading>{{ \'Menu.SEARCH\' | translate }} {{ \'Menu.CONDITION\' | translate }}<div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\" id=collapse1><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-4 col-xl-4\"><div class=input-group><div class=\"form-group form-inner-label\"><input type=text class=\"form-control form-right\" ng-model=vc.srch.DeptNm><label>{{ \'Menu.DEPARTMENTNAME\' | translate }}</label></div><span class=\"input-group-btn input-group-btn2\"><button class=\"btn btn-default\" activate-button ng-click=vc.nextSearch()><i class=\"fa fa-search\"></i></button></span></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-8 col-xl-8\"><div class=pull-right><button class=\"btn btn-info\" activate-button ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETSEARCH\' | translate }}</button> <button class=\"btn btn-default\" activate-button ng-click=vc.resetList()><i class=\"fa fa-refresh\"></i> {{ \'Menu.RESETLIST\' | translate }}</button></div></div></div><!-- panel-body --></div><!--panel panel-default --></div></div><!-- row --><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>{{ \'Menu.DEPTLIST\' | translate }}</div><div class=\"panel-body collapse in\" id=collapse1><section layout=row flex><md-sidenav class=sidenav-left md-component-id=left md-is-locked-open=true style=min-height:600px><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">{{ \'Menu.ALL\' | translate }}{{ \'Menu.DEPARTMENT\' | translate }}</div><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=2 select-text=vc.srch.DeptNm icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav><md-content flex layout-padding><form class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-submit=vc.saveData()><div class=row><div class=pull-right><button class=\"btn btn-primary\" activate-button type=button ng-click=try_adding_a_branch() ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-edit\"></i>{{ \'Menu.ADD\' | translate }}</button> <button class=\"btn btn-primary\" activate-button type=submit ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-save\"></i>{{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" activate-button type=button ng-click=vc.delNode() ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-trash-o\"></i>{{ \'Menu.DELETE\' | translate }}</button></div></div><div class=row><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.New == \'Y\'\">* 저장되지 않은 새로운 코드입니다.</div><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.Edit == \'Y\'\">* 수정 후 저장되지 않았습니다.</div></div><div class=row><div class=col-lg-4><div class=form-group><label>부서아이디</label><input type=text class=form-control ng-model=vc.data.DeptId ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>부서명</label><input type=text class=form-control ng-change=vc.onChangeDeptNm() ng-model=vc.data.DeptNm ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>DEPTH</label><input type=text class=form-control ng-model=vc.data.Depth ng-required=true></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>SORT</label><input type=text class=form-control ng-model=vc.data.Sort ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>상위부서아이디</label><input type=text class=form-control ng-model=vc.data.ParentDeptId ng-required=true></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>추가1</label><input type=text class=form-control ng-model=vc.data.DeptValue01></div></div><div class=col-lg-4><div class=form-group><label>추가2</label><input type=text class=form-control ng-model=vc.data.DeptValue02></div></div><div class=col-lg-4><div class=form-group><label>추가3</label><input type=text class=form-control ng-model=vc.data.DeptValue03></div></div></div></form></md-content></section><!-- row --></div></div></div></div><!-- row --></div><!-- pagecontent --></div>");
$templateCache.put("app/personal/user/user-edit-tab1.html","<div class=\"page page-footable\" ng-controller=\"PersonalUserEditTab1Ctrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><!-- 버튼 그룹 --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> 추가</button> <button class=\"btn btn-danger\" ng-click=vc.delData()><i class=\"fa fa-trash-o\"></i> 삭제</button></div></div><!-- 버튼 그룹 --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=5>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.editData(li.keyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- / Table row --></div></div><!-- /page content --></div>");
$templateCache.put("app/personal/user/user-edit-tab2.html","<div class=\"page page-footable\" ng-controller=\"PersonalUserEditTab2Ctrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><!-- 버튼 그룹 --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> 추가</button> <button class=\"btn btn-danger\" ng-click=vc.delData()><i class=\"fa fa-trash-o\"></i> 삭제</button></div></div><!-- 버튼 그룹 --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=5>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.editData(li.keyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- / Table row --></div></div><!-- /page content --></div>");
$templateCache.put("app/personal/user/user-edit-tab3.html","<div class=\"page page-footable\" ng-controller=\"PersonalUserEditTab3Ctrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><!-- 버튼 그룹 --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-edit\"></i> 추가</button> <button class=\"btn btn-danger\" ng-click=vc.delData()><i class=\"fa fa-trash-o\"></i> 삭제</button></div></div><!-- 버튼 그룹 --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{vc.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=4>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.editData(li.keyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\">{{liCol.ColumnLogicalDataType != \'40\' ? (li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- / Table row --></div></div><!-- /page content --></div>");
$templateCache.put("app/personal/user/user-edit.html","<style>#userPhoto {\r\n    width: 225px;\r\n    height: 230px;\r\n    margin: 0 auto;\r\n    border:solid 1px #EEE;\r\n    margin-bottom: 18px;\r\n    background-size: cover;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n  }\r\n\r\n  .fa-pane-handle {\r\n    border:none !important;\r\n  }</style><div class=\"page page-footable\" ng-controller=\"PersonalUserEditCtrl as vc\"><form class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-submit=vc.setData()><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><h3 class=page-header ng-if=\"vc.layout == \'N\'\">{{ vc.titleNm }}<div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.comUserYN == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goBack() ng-if=\"vc.comUserYN == \'Y\'\"><i class=\"fa fa-list\"></i> 취소</button> <button activate-button class=\"btn btn-primary\" type=submit ng-if=\"vc.changeable && vc.keyId == null && vc.comUserYN == \'N\'\"><i class=\"fa fa-save\"></i> 등록</button> <button activate-button class=\"btn btn-primary\" ng-click=vc.editData() ng-if=\"vc.changeable && vc.keyId != null\"><i class=\"fa fa-save\"></i> 정보수정</button> <button activate-button class=\"btn btn-danger\" ng-click=vc.delData() ng-if=\"vc.isAdminS && vc.keyId != null\"><i class=\"fa fa-times\"></i> 삭제</button></div></h3><div class=pull-right ng-if=\"vc.layout != \'N\'\"><button activate-button class=\"btn btn-primary\" type=submit ng-if=\"vc.changeable && vc.keyId == null && vc.comUserYN == \'N\'\"><i class=\"fa fa-save\"></i> 등록</button> <button activate-button class=\"btn btn-primary\" ng-click=vc.editData() ng-if=\"vc.changeable && vc.keyId != null\"><i class=\"fa fa-save\"></i> 정보수정</button> <button activate-button class=\"btn btn-danger\" ng-click=vc.delData() ng-if=\"vc.isAdminS && vc.keyId != null\"><i class=\"fa fa-times\"></i> 삭제</button></div></div></div><div class=row file-dropzone><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">기본정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><!-- 이름 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>이름</label><input type=text class=\"form-control form-right\" ng-model=vc.data.UserNm ng-disabled=!vc.changeable ng-required=true></div></div></div><!-- 아이디 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>* 아이디</label><input ng-if=\"vc.data.KeyId != null && vc.data.KeyId != \'\'\" type=text class=\"form-control form-right\" ng-model=vc.data.LoginId disabled><div class=input-group><input ng-if=\"vc.data.KeyId== null || vc.data.KeyId == \'\'\" type=text class=\"form-control form-right\" ng-model=vc.data.LoginId maxlength=20> <span class=input-group-btn ng-if=\"vc.data.KeyId == null || vc.data.KeyId == \'\'\"><button class=\"btn btn-default\" ng-click=vc.getIsDupLoginId() type=button><i class=\"glyphicon glyphicon glyphicon-ok\"></i></button></span></div></div></div></div><!-- 비밀번호 --><div class=row ng-if=vc.changeable><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>＊ 비밀번호</label><input type=password class=\"form-control form-right\" maxlength=20 ng-model=vc.data.Password required></div></div></div><div class=row ng-if=vc.changeable><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>＊ 비밀번호확인</label><input type=password class=\"form-control form-right\" maxlength=20 ng-model=vc.data.Password2 required></div></div></div><!-- 이메일 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>* {{ vc.columnMap[\'Email\'].ColumnLogicalNm | translate }}</label><input type=text class=\"form-control form-right\" maxlength=255 ng-model=vc.data.Email ng-disabled=!vc.changeable></div></div></div><!-- 전화번호/핸드폰 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline xs-mb10\"><label>＊ {{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" auto-hyphen oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\')\" ng-model=vc.data.Mobile ng-disabled=!vc.changeable required></div></div></div></div><!-- 주소--><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline sm-mb0\"><label>주소</label><div class=input-group><input class=form-control id=ZipCode maxlength=7 ng-model=vc.data.ZipCode disabled type=text> <span class=input-group-btn><button class=\"btn btn-default\" ng-disabled=!vc.changeable ng-click=vc.srchZipCodeModal() type=button><i class=\"fa fa-search\"></i></button></span></div></div></div></div><!-- 주소1 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline sm-mb0\"><label></label><input class=form-control id=Addr1 maxlength=200 ng-model=vc.data.Addr1 type=text disabled></div></div></div><!-- 주소2 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline sm-mb0\"><label></label><input class=form-control id=Addr2 maxlength=200 ng-model=vc.data.Addr2 type=text ng-disabled=!vc.changeable></div></div></div><!-- 재직여부/소속 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-2\"><div class=\"form-group form-inline\"><label>＊ 재직여부</label><common-code-custom code-list=\"vc.columnMap[\'WorkStatus\'].CodeList\" code-model=vc.data.WorkStatus ng-disabled=!vc.changeable></common-code-custom></div></div></div><!-- 역할 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>* {{ \'Menu.ROLE\' | translate }}</label><div class=input-group><input type=text class=\"form-control form-right\" ng-model=vc.data.UserRoleNms disabled> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=vc.srchUserroleModal(); ng-disabled=!vc.changeable><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=vc.eraseUserRole(); ng-disabled=!vc.changeable><i class=\"fa fa-eraser\"></i></button></span></div></div></div></div><!-- 관리자구분 --><div class=row ng-if=vc.chkAdmin><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-2\"><div class=\"form-group form-inline\"><label>* 관리자구분</label><common-code-custom code-list=\"vc.columnMap[\'AdminType\'].CodeList\" code-model=vc.data.AdminType ng-disabled=!vc.changeable></common-code-custom></div></div></div><!-- 현장간사 지역 --><div class=row ng-if=vc.chkAdminH><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group form-inline\"><label>현장간사 지역</label><div style=margin-left:105px ng-if=vc.changeable><common-code-custom style=\"width:20% !Important; margin:0 !Important\" code-list=\"vc.columnMap[\'ParCityCode\'].CodeList\" code-model=vc.cityDataH.pCode ng-change=\"vc.chgParCityCode(\'H\',vc.cityDataH.pCode)\"></common-code-custom><common-code-custom style=\"width:20% !Important; margin:0 !Important\" code-list=vc.cityDataH.cCodeList code-model=vc.cityDataH.cCode></common-code-custom><button class=\"btn btn-default\" ng-click=\"vc.selCityCode(\'H\',vc.cityDataH.cCode)\" type=button><i class=\"glyphicon glyphicon-plus\"></i> 추가</button><ul class=\"ul_h li_mr15 mt-10\"><li ng-repeat=\"(index, li) in vc.cityDataH.selCityCodeList\"><label>[{{li.pName}} {{li.cName}}<span ng-click=\"vc.delCityCode(\'H\',index)\"><i class=\"fa fa-times fa-lg\"></i></span>]</label></li></ul></div><div ng-if=!vc.changeable><input type=text class=\"form-control form-right\" ng-model=vc.cityDataH.selCityNameList disabled></div></div></div></div><!-- AI담당 여부 --><div class=row ng-if=vc.isAdminSHB><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-2\"><div class=\"form-group form-inline\"><label>＊ AI담당 여부</label><common-code-custom code-list=\"vc.columnMap[\'AiAdminYN\'].CodeList\" code-model=vc.data.AiAdminYN ng-disabled=!vc.changeable></common-code-custom></div></div></div><!-- AI담당 지역 --><!--div class=\"row\" ng-if=\"vc.chkAdmin\">\r\n                  <div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-6\">\r\n                    <div class=\"form-group form-inline\">\r\n                      <label>AI담당 지역</label>\r\n                      <div style=\"margin-left:105px;\" ng-if=\"vc.changeable\">\r\n                        <common-code-custom style=\"width:20% !Important; margin:0 !Important;\" code-list=\"vc.columnMap[\'ParCityCode\'].CodeList\" code-model=\"vc.cityDataAi.pCode\" ng-change=\"vc.chgParCityCode(\'A\',vc.cityDataAi.pCode)\"></common-code-custom>\r\n                        <common-code-custom style=\"width:20% !Important; margin:0 !Important;\" code-list=\"vc.cityDataAi.cCodeList\" code-model=\"vc.cityDataAi.cCode\"></common-code-custom>\r\n                        <button class=\"btn btn-default\" ng-click=\"vc.selCityCode(\'A\',vc.cityDataAi.cCode)\" type=\"button\"><i class=\"glyphicon glyphicon-plus\"></i> 추가</button>                        \r\n                        <ul class=\"ul_h li_mr15 mt-10\">\r\n                          <li ng-repeat=\"(index, li) in vc.cityDataAi.selCityCodeList\">\r\n                            <label>\r\n                              [{{li.pName}} {{li.cName}}<span ng-click=\"vc.delCityCode(\'A\',index)\"><i class=\"fa fa-times fa-lg\"></i></span>]\r\n                            </label>                                                \r\n                          </li>\r\n                        </ul>\r\n                      </div>\r\n                      <div ng-if=\"!vc.changeable\">\r\n                        <input type=\"text\" class=\"form-control form-right\" ng-model=\"vc.cityDataAi.selCityNameList\" disabled>\r\n                      </div>\r\n                    </div>\r\n                  </div>\r\n                </div--><!-- 비밀댓글 --><div class=row><div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-2\"><div class=\"form-group form-inline\"><label>비밀댓글 조회</label><common-code-custom code-list=\"vc.columnMap[\'CommentAdminYN\'].CodeList\" code-model=vc.data.CommentAdminYN ng-disabled=!vc.changeable></common-code-custom></div></div></div><!--div class=\"row\" ng-if=\" ! vc.chkAdminAS\">\r\n                  <div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-2\">\r\n                    <div class=\"form-group form-inline\">\r\n                      <label>평가하기 권한</label> \r\n                      <common-code-custom code-list=\"vc.columnMap[\'EvalAdminYN\'].CodeList\" code-model=\"vc.data.EvalAdminYN\" ng-disabled=\"!vc.changeable\"></common-code-custom>  \r\n                    </div>\r\n                  </div>\r\n                </div--></div></div></div></div></div></form></div>");
$templateCache.put("app/personal/user/user-list.html","<div class=\"page page-footable\" ng-controller=\"PersonalUserListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>임직원관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=\"row shop-view\"><div class=\"col-xs-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.UserNm placeholder=\"이름 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'LoginId\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.LoginId type=text><label>{{vc.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UserNm\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.UserNm type=text><label>{{vc.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'EntryDtFrom\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.EntryDtFrom = (vc.EntryDtFrom | date: \'yyyy-MM-dd\')\" ng-model=vc.EntryDtFrom ng-required=false placeholder=\"{{vc.columnMap[\'EntryDtFrom\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'EntryDtTo\']\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.srch.EntryDtTo = (vc.EntryDtTo | date: \'yyyy-MM-dd\')\" ng-model=vc.EntryDtTo ng-required=false placeholder=\"{{vc.columnMap[\'EntryDtTo\'].ColumnLogicalNm | translate}}\" type=text datepicker-append-to-body=true uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Mobile\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" auto-hyphen ng-model=vc.srch.Mobile type=text><label>{{vc.columnMap[\'Mobile\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'WorkStatus\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'WorkStatus\'].CodeList\" code-model=vc.srch.WorkStatus></common-code-custom><label>{{vc.columnMap[\'WorkStatus\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UserType\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UserType\'].CodeList\" code-model=vc.srch.UserType></common-code-custom><label>{{vc.columnMap[\'UserType\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'DeptNm\']\"><div class=input-group><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.DeptNm readonly type=text><label>{{vc.columnMap[\'DeptNm\'].ColumnLogicalNm | translate}}</label></div><span class=input-group-btn><button class=\"btn btn-default\" ng-click=vc.srchDeptModal(); ng-disabled=\"gVariable.TenantId == \'0\'\" type=button><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" ng-click=vc.eraseDept(); ng-disabled=\"gVariable.TenantId == \'0\'\" type=button><i class=\"fa fa-eraser\"></i></button></span></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'TelNo\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.TelNo type=text><label>{{vc.columnMap[\'TelNo\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'Email\']\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.Email type=text><label>{{vc.columnMap[\'Email\'].ColumnLogicalNm | translate}}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\" ng-if=\"vc.columnMap[\'UseYN\']\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'UseYN\'].CodeList\" code-model=vc.srch.UseYN></common-code-custom><label>{{vc.columnMap[\'UseYN\'].ColumnLogicalNm | translate}}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-4 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=pull-right><!-- <button class=\"btn btn-default\" ng-if=\"vc.totalItems != 0\" ng-click=\"vc.getExcelFile()\">\r\n                    <i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}\r\n                  </button> --> <button class=\"btn btn-primary\" ng-click=vc.goAdd() ng-if=vc.changeable><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><!-- <tbody ng-if=\"vc.totalItems == 0\">\r\n                    <tr class=\"tbnodata\">\r\n                      <td class=\"text-center\" colspan=\"{{vc.listColumns.length+1}}\">{{ \'MSG.NO_DATA\' | translate }}</td>\r\n                    </tr>\r\n                    </tbody> --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':vc.keyId == li.KeyId}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-click=vc.goEdit(li.KeyId) ng-repeat=\"liCol in vc.listColumns  | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=40>{{li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd HH:mm\'}}</span> <span ng-switch-when=50>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60><i class=\"fa {{li[liCol.ColumnPhysicalNm]}}\" aria-hidden=true></i> </span><span ng-switch-when=70>{{li[liCol.ColumnPhysicalNm] | tel}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></table><div><div ng-if=\"vc.totalItems == 0\" class=text-center style=\"padding: 3px; border: 1px solid #ddd; line-height:1.42857143; background:#f9f9f9\">{{ \'MSG.NO_DATA\' | translate }}</div></div><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/common-code/common-properties.html","<div class=\"page page-footable\" ng-controller=\"CommonPropertiesCtrl as vc\"><!-- page header --><div class=\"row row-header\"><div class=col-lg-12><h1 class=page-header>공통설정관리</h1></div></div><!-- page content --><div class=pagecontent><form id=form1 name=form1><!-- row --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-if=\"$root.gVariable.SysAdminYN == \'Y\'\" ng-click=vc.addNew()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.ADD\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.saveListComment()><i class=\"fa fa-edit\"></i> {{ :: \'Menu.SAVE\' | translate }}</button></div></div></div><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>공통설정관리</div><div class=\"panel-body collapse in\" id=collapse1><!-- Search Result --><div class=pull-right><span>※ Background 색상이 <i class=\"fa fa-square\" style=color:#fde8e8></i>인 항목은 커스텀코드입니다.</span></div><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><colgroup><col style=\"width: 10%\"><col style=\"width: 10%\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><col style=\"width: 10%\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><col style=\"width: 10%\"><col style=\"width: 10%\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><col style=\"width: 10%\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"><col style=\"width: 10%\"></colgroup><thead><tr><th class=text-center>항목명</th><th class=text-center ng-if=\"$root.gVariable.srchTenantId == \'0\'\">코드타입</th><th class=text-center ng-if=\"$root.gVariable.srchTenantId == \'0\'\">코드</th><th class=text-center>코드값</th><th class=\"text-center showlevel3\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\">공통코드타입</th><th class=\"text-center showlevel3\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\">정렬순서</th><th class=\"text-center showlevel3\">등록일</th><th class=\"text-center showlevel3\">수정일</th><th class=text-center>{{$root.gVariable.srchTenantId != \'0\' ? \'커스텀코드삭제\' : \'삭제\'}}</th><th class=text-center>커스텀코드생성</th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" style=\"cursor: pointer\" my-directive><!-- Result Items --><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\"><input class=form-control type=text ng-model=li.Remark ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\" required></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><input class=form-control type=text ng-model=li.CodeType ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\" required></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><input class=form-control type=text ng-model=li.Code ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\" required></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\"><input class=form-control type=text ng-model=li.CodeValue required ng-if=\"li.CodeList == null || $root.gVariable.srchTenantId == \'0\'\"><common-code-custom code-list=li.CodeList code-model=li.CodeValue ng-if=\"li.CodeList != null && $root.gVariable.srchTenantId != \'0\'\"></common-code-custom></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}} showlevel3\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><input class=form-control type=text ng-model=li.CommonCodeType ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\'\"></td><td class=\"{{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}} showlevel3\" ng-if=\"$root.gVariable.srchTenantId == \'0\'\"><input class=form-control type=text ng-model=li.Sort required></td><td class=\"text-center {{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}} showlevel3\"><span>{{li.RegDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span></td><td class=\"text-center {{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}} showlevel3\"><span>{{li.EdtDate | utcToLocal:\'yyyy-MM-dd h:mm a\'}}</span></td><td class=\"text-center {{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\"><input type=checkbox ng-show=\"(li.TenantId == $root.gVariable.srchTenantId) && (li.TenantId != \'0\' || $root.gVariable.SysAdminYN == \'Y\')\" ng-model=li.DelYN ng-change=vc.checkChanged(li) ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=\"text-center {{li.TenantId != \'0\' ? \'form-control-custom\' : \'\'}}\"><input type=checkbox ng-show=\"(li.TenantId == \'0\' && $root.gVariable.srchTenantId != \'0\') || (li.TenantId != \'0\')\" ng-disabled=\"li.isNew == \'Y\' || li.TenantId != \'0\' || $root.gVariable.SysAdminYN != \'Y\'\" ng-model=li.makeCustomYN ng-change=vc.checkChanged(li) ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td></tr></table></div></div></div></div><!-- row --></form></div><!-- /page content --></div>");
$templateCache.put("app/system/common-code/commoncode-list.html","<div class=\"page page-footable\" ng-controller=\"CommoncodeListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ \'Menu.EM660\' | translate }}</div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div class=pane-root fa-pane=\"\"><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.CodeValue placeholder=코드명 type=text><div class=\"search_layer mb-2\" ng-click=vc.nextSearch() style=\"width:45px !important\"><span class=cursor id=btn_layer_detail_search_open><i class=\"fa fa-search\"></i></span></div></div><!-- /col --></div><!-- 검색영역 --></form><!-- row --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>{{ \'Menu.EM660\' | translate }}</div><div class=\"panel-body collapse in\" id=collapse1><section layout=row flex><md-sidenav class=sidenav-left md-component-id=left md-is-locked-open=true style=max-height:600px><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">{{ \'Menu.ALL\' | translate }}{{ \'Menu.COMMON_CODE\' | translate }}</div><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=1 select-text=vc.srch.CodeValue icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav><md-content flex layout-padding><form class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-submit=vc.saveData()><div class=row><div class=col-lg-2><div class=form-group><md-checkbox md-no-ink=\"\" ng-disabled=\"$root.gVariable.srchTenantId == \'0\' || vc.data.Code == \'000\' || vc.data.CodeType != \'000\' || vc.data.New == \'Y\' || vc.data.SysCodeYN == \'Y\'\" ng-click=vc.ChangeCustomCode() ng-checked=\"vc.data.CustomCode == 0 ? false:true\" class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>커스텀코드</md-checkbox></div></div><div class=col-lg-2><div class=form-group><md-checkbox md-no-ink=\"\" ng-disabled=\"$root.gVariable.SysAdminYN != \'Y\' || $root.gVariable.srchTenantId != \'0\' || vc.data.TenantId != \'0\'\" ng-model=vc.data.SysCodeYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\" class=\"md-primary ng-untouched ng-valid ng-dirty ng-valid-parse ng-empty\" role=checkbox>시스템코드</md-checkbox></div></div><div class=pull-right><button class=\"btn btn-primary\" activate-button type=button ng-click=try_adding_a_branch() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-edit\"></i>{{ \'Menu.ADD\' | translate }}</button> <button class=\"btn btn-primary\" activate-button type=submit ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\" ng-show=\"vc.data.DelYN != \'Y\'\"><i class=\"fa fa-save\"></i>{{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" activate-button type=button ng-click=vc.delNode() ng-show=\"vc.data.DelYN != \'Y\'\" ng-disabled=\"$root.gVariable.srchTenantId != \'0\' && vc.data.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i>{{ \'Menu.DELETE\' | translate }}</button></div></div><div class=row><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.New == \'Y\'\">* 저장되지 않은 새로운 코드입니다.</div><div class=\"col-lg-12 text-danger\" ng-show=\"vc.data.Edit == \'Y\'\">* 수정 후 저장되지 않았습니다.</div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT01\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CommonCodeId ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT02\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue ng-change=vc.onChangeCodeValue() ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT03\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Code ng-change=vc.onChangeCode() ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT04\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeLevel ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT05\' | translate }}</label><input type=text class=form-control ng-model=vc.data.ParentCommonCodeId ng-required=true ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.CODETYPE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeType ng-required=true ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT07\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Sort ng-required=true ng-change=vc.onChanged()></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT10\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue01></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT11\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue02></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT12\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue03></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT13\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue04></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT14\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue05></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT15\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue06></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT16\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue07></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT17\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue08></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT18\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue09></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.EM660DT19\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CodeValue10></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.ORNOTTOUSE\' | translate }}</label><common-code param-data=vc.UseYNData callback=vc.onSelectCallback choose-message=\"\'Menu.CHOOSE\'\"></common-code></div></div></div><div class=row><div class=col-lg-12><ul><li>* 분류로 사용되는 항목 : 코드 = \'000\', 코드타입 = \'000\'</li><li>* 코드명으로 사용되는 항목 : 코드 = 코드타입, 코드타입 = \'000\'</li><li>* 코드의 각항목 사용되는 항목 : 코드 = 코드값, 코드타입 = 코드타입</li></ul></div></div></form></md-content></section><!-- row --></div></div></div></div><!-- row --></div></div></div></div><!-- pagecontent --></div>");
$templateCache.put("app/system/make-query/makequery-list.html","<div class=\"page page-footable\" ng-controller=\"MakeQueryListCtrl as vc\" data-ng-init=init() id=toastContainer><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>쿼리생성기</div></div></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>Mapper ID</div><div class=\"panel-body collapse in\"><input type=text style=\"border :solid 1px #EEE; width:100%; padding: 3px\" ng-model=vc.mapperId ng-change=vc.changeMapperId()></div></div></div></div><!-- row --><div class=row><style>table th, table td {padding: 3px;}\r\n        #queryView span {display: block;}</style><div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 col-xl-3\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>Table</div><div class=\"panel-body collapse in\"><table><colgroup><col style=width:30%><col style=width:30%></colgroup><thead><tr><th class=text-center>Table</th><th class=text-center>Alias</th><th class=text-center>M</th><th class=text-center>IJ</th><th class=text-center>LJ</th></tr></thead><tbody><tr ng-repeat=\"li in vc.tables\"><!-- Result Items --><td class=text-left><span ng-bind=li.tbNm></span></td><td class=text-center><input type=text ng-model=li.aliasNm ng-blur=vc.blurAlis(li) ng-change=vc.changeAlis(li) style=\"border :solid 1px #EEE; width:100%; padding: 3px\"></td><td class=text-center><input type=checkbox ng-model=li.mChecked ng-click=vc.setMainTable(li)></td><td class=text-center><input type=checkbox ng-model=li.ijChecked ng-click=vc.setJoinTable(li)></td><td class=text-center><input type=checkbox ng-model=li.ljChecked ng-click=vc.setJoinTable(li)></td></tr></tbody></table></div></div></div><div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 col-xl-2\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>Column</div><div class=\"panel-body collapse in\"><table><colgroup><col style=width:10%><col style=width:90%></colgroup><thead><tr><th class=text-center>V</th><th class=text-center>Column</th></tr></thead><tbody><tr ng-repeat=\"li in vc.cols\"><!-- Result Items --><td class=text-center><input type=checkbox ng-model=li.checkedYn ng-click=vc.setChangeCols(li)></td><td class=text-left>{{li.aliasNm}}.{{ li.colNm}}</td></tr></tbody></table></div></div></div><div class=\"col-xs-7 col-sm-7 col-md-7 col-lg-7 col-xl-7\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>Query <span ng-click=vc.copyFn()>(복사하기)</span></div><div class=\"panel-body collapse in\" id=queryView ng-if=vc.checkDrawView><span>&lt;?xml version=\"1.0\" encoding=\"UTF-8\" ?></span> <span>&lt;!DOCTYPE mapper PUBLIC \"-//mybatis.org//DTD Mapper 3.0//EN\" \"/usr/local/dtd/mybatis-3-mapper.dtd\"></span><br><span ng-bind-html=vc.namespace></span><br><span>&nbsp;&nbsp;&lt;sql id=\"whereSampleQuery\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;where&gt;</span><div ng-repeat=\"li in vc.cols\" ng-if=li.checkedYn><span style=\"display: inline-block\" ng-if=\"li.dataType==\'char\' && li.colNm !=\'DelYN\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = #{ {{li.colNm}} } &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'char\' && li.colNm ==\'DelYN\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = \'N\' </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'int\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = #{ {{li.colNm}} } &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'decimal\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = #{ {{li.colNm}} } &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'varchar\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} LIKE CONCAT(\'%\', #{ {{li.colNm}} }, \'%\') &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'text\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} LIKE CONCAT(\'%\', #{ {{li.colNm}} }, \'%\') &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'date\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = #{ {{li.colNm}} } &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'datetime\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} &lt;![CDATA[&gt;=]]&gt; STR_TO_DATE( #{ {{li.colNm}} } , \'%Y-%m-%d %H:%i:%s\') &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'timestamp\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} &lt;![CDATA[&gt;=]]&gt; STR_TO_DATE( #{ {{li.colNm}} } , \'%Y-%m-%d %H:%i:%s\') &lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.dataType==\'bigint\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = CONV(#{ {{li.colNm}} }, 36, 10) &lt;/if&gt; </span><!-- <span style=\"display: block;\" ng-if=\"li.dataType==\'bigint\' && li.priYn == \'N\'\">\r\n                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = CONV(#{ {{li.colNm}} }, 36, 10) &lt;/if&gt;\r\n              </span> --> <span style=\"display: inline-block;\" ng-if=\"li.dataType==\'bigint\' && li.priYn == \'Y\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'KeyId != null and KeyId != \"\"\'&gt;&nbsp;&nbsp;AND {{li.aliasNm}}.{{li.colNm}} = CONV(#{ KeyId }, 36, 10) &lt;/if&gt;</span></div><span style=\"display: inline-block\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'SESSION_LOGINTYPE != null and SESSION_LOGINTYPE != \"\"\'></span> <span style=\"display: inline-block\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'SESSION_LOGINTYPE == \"C\"\'>AND SC.RegUser = CONV(#{SESSION_USERID}, 36, 10)&lt;/if&gt;</span><br><span style=\"display: inline-block\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'SESSION_LOGINTYPE != \"C\"\'>AND SC.TenantId = CONV(#{ srchTenantId }, 36, 10)&lt;/if&gt;</span><br><span style=\"display: inline-block\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;/if></span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/where&gt;</span> <span>&nbsp;&nbsp;&lt;/sql&gt;</span><br><span>&nbsp;&nbsp;&lt;sql id=\"where{{vc.tbMain.tableNm}}Data\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;where&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/where&gt;</span> <span>&nbsp;&nbsp;&lt;/sql&gt;</span><br><span>&nbsp;&nbsp;&lt;select id=\"get{{vc.tbMain.tableNm}}ListCnt\" parameterType=\"map\" resultType=\"int\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SELECT</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;count(*) as totalItems</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;FROM {{vc.tbMain.tableNm}} {{vc.tbMain.aliasNm}}</span><div ng-repeat=\"li in vc.tbJoins\"><span ng-if=li.ijChecked>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;INNER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span> <span ng-if=li.ljChecked>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LEFT OUTER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;include refid=\"where{{vc.tbMain.tableNm}}Data\"/&gt; </span><span>&nbsp;&nbsp;&lt;/select&gt;</span><br><span>&nbsp;&nbsp;&lt;select id=\"get{{vc.tbMain.tableNm}}List\" parameterType=\"map\" resultType=\"map\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;SELECT</span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.checkedYn && li.colNm != \'DelUser\' && li.colNm != \'DelDate\' && li.colNm != \'DelYN\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"$index == 0 && li.dataType != \'bigint\'\">T.{{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"$index == 0 && li.dataType == \'bigint\'\">CONV(T.{{li.colNm}},10,36) AS KeyId </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType != \'bigint\'\">, T.{{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType == \'bigint\'\">, CONV(T.{{li.colNm}},10,36) AS {{li.colNm}}</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;FROM (</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SELECT</span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.checkedYn && li.colNm != \'DelUser\' && li.colNm != \'DelDate\' && li.colNm != \'DelYN\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"$index == 0\">&nbsp;&nbsp;{{li.aliasNm}}.{{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"$index != 0\">&nbsp;&nbsp;, {{li.aliasNm}}.{{li.colNm}}</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;FROM {{vc.tbMain.tableNm}} {{vc.tbMain.aliasNm}}</span><div ng-repeat=\"li in vc.tbJoins\"><span ng-if=li.ijChecked>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;INNER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span> <span ng-if=li.ljChecked>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LEFT OUTER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;include refid=\"where{{vc.tbMain.tableNm}}Data\"/&gt; </span><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ORDER BY {{vc.tbMain.aliasNm}}.RegDate DESC <span>&nbsp;&nbsp;&nbsp;&nbsp;) T</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;INNER JOIN (SELECT @rowNum:=0) T2</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;choose></span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;when test=\"sortColumn != null and sortColumn != \'\'\"></span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ORDER BY ${sortColumn} ${sortDirect}</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;/when></span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;otherwise></span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;ORDER BY T.RegDate Desc</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;/otherwise></span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/choose></span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;if test=\'viewSize != null and viewSize != 0 and page != null\'&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LIMIT #{offSet}, #{viewSize}</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/if&gt; <span>&nbsp;&nbsp;&lt;/select&gt;</span><br><span>&nbsp;&nbsp;&lt;select id=\"get{{vc.tbMain.tableNm}}Detail\" parameterType=\"map\" resultType=\"map\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;SELECT</span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.checkedYn && li.colNm != \'DelUser\' && li.colNm != \'DelDate\' && li.colNm != \'DelYN\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"$index == 0 && li.dataType == \'bigint\'\">&nbsp;&nbsp;CONV({{li.aliasNm}}.{{li.colNm}},10,36) AS KeyId </span><span style=\"display: inline-block\" ng-if=\"$index == 0 && li.dataType != \'bigint\'\">&nbsp;&nbsp;{{li.aliasNm}}.{{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType != \'bigint\'\">&nbsp;&nbsp;, {{li.aliasNm}}.{{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType == \'bigint\'\">&nbsp;&nbsp;, CONV({{li.aliasNm}}.{{li.colNm}},10,36) AS {{li.colNm}}</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;FROM {{vc.tbMain.tableNm}} {{vc.tbMain.aliasNm}}</span><div ng-repeat=\"li in vc.tbJoins\"><span ng-if=li.ijChecked>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;INNER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span> <span ng-if=li.ljChecked>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;LEFT OUTER JOIN {{li.tbNm}} {{li.aliasNm}} ON {{li.aliasNm}}.{{li.pk}} = {{vc.tbMain.aliasNm}}.{{li.pk}}</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;include refid=\"where{{vc.tbMain.tableNm}}Data\"/&gt; </span><span>&nbsp;&nbsp;&lt;/select&gt;</span><br><span>&nbsp;&nbsp;&lt;insert id=\"insert{{vc.tbMain.tableNm}}\" parameterType=\"map\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;selectKey keyProperty=\"RelateDataId\" resultType=\"java.lang.String\" order=\"BEFORE\"&gt;<br><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;SELECT conv(FLOOR(100000000000000 + RAND() * 899999999999999), 10, 36) AS RelateDataId<br><span>&nbsp;&nbsp;&nbsp;&nbsp;&lt;/selectKey&gt;<br><br><span>&nbsp;&nbsp;&nbsp;&nbsp;INSERT INTO {{vc.tbMain.tableNm}} </span><span>&nbsp;&nbsp;&nbsp;&nbsp;(</span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.selectType == \'m\' && li.checkedYn && li.colNm.toLowerCase() != \'edtdate\' && li.colNm.toLowerCase() != \'deldate\' && li.colNm.toLowerCase() != \'edtuser\' && li.colNm.toLowerCase() != \'deluser\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"$index == 0\">&lt;if test=\'RelateDataId != null\'&gt;&nbsp;&nbsp;{{li.colNm}}&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType != \'bigint\' && li.colNm.toLowerCase() != \'delyn\' && li.colNm.toLowerCase() != \'regdate\' && li.colNm.toLowerCase() != \'useyn\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;, {{li.colNm}}&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType == \'bigint\' && li.colNm.toLowerCase() != \'delyn\' && li.colNm.toLowerCase() != \'reguser\' && li.colNm.toLowerCase() != \'tenantid\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;, {{li.colNm}}&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType == \'bigint\' && li.colNm.toLowerCase() == \'reguser\'\">, {{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType != \'bigint\' && li.colNm.toLowerCase() == \'regdate\'\">, {{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'delyn\'\">, {{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'tenantid\'\">, {{li.colNm}} </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'useyn\'\">, UseYN</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;) VALUES (</span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.selectType == \'m\' && li.checkedYn && li.colNm.toLowerCase() != \'edtdate\' && li.colNm.toLowerCase() != \'deldate\' && li.colNm.toLowerCase() != \'edtuser\' && li.colNm.toLowerCase() != \'deluser\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"$index == 0\">&lt;if test=\'RelateDataId != null\'&gt;&nbsp;&nbsp;CONV(#{RelateDataId}, 36, 10)&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType != \'bigint\' && li.colNm.toLowerCase() != \'delyn\' && li.colNm.toLowerCase() != \'regdate\'  && li.colNm.toLowerCase() != \'useyn\' \">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;,#{ {{li.colNm}} }&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"$index != 0 && li.dataType == \'bigint\' && li.colNm.toLowerCase() != \'reguser\' && li.colNm.toLowerCase() != \'tenantid\'\">&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'&gt;&nbsp;&nbsp;,CONV(#{ {{li.colNm}} }, 36, 10)&lt;/if&gt; </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'regdate\'\">, NOW() </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'reguser\'\">, CONV(#{ SESSION_USERID }, 36, 10) </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'delyn\'\">, \'N\' </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'useyn\'\">, \'Y\' </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'tenantid\'\">, CONV(#{ srchTenantId }, 36, 10)</span></div><span>&nbsp;&nbsp;&nbsp;&nbsp;)</span> <span>&nbsp;&nbsp;&lt;/insert&gt;</span><br><!-- <set>\r\n              <if test=\'CustId != null\'>CustId = CONV(#{CustId}, 36, 10),</if>\r\n              <if test=\'CustNm != null\'>CustNm = #{CustNm},</if>\r\n              <if test=\'AprvStatus != null\'>AprvStatus = #{AprvStatus},</if>\r\n              <if test=\'PurchDate != null\'>PurchDate = #{PurchDate},</if>\r\n              <if test=\'SalesType != null\'>SalesType = #{SalesType},</if>\r\n              <if test=\'PurchType != null\'>PurchType = #{PurchType},</if>\r\n              <if test=\'CareTktId != null\'>CareTktId = CONV(#{CareTktId}, 36, 10),</if>\r\n              <if test=\'CareTktQty != null\'>CareTktQty = #{CareTktQty},</if>\r\n              <if test=\'CareTktUnitPrc != null\'>CareTktUnitPrc = #{CareTktUnitPrc},</if>\r\n              <if test=\'CareTktAmt != null\'>CareTktAmt = #{CareTktAmt},</if>\r\n              <if test=\'ProductId != null\'>ProductId = #{ProductId},</if>\r\n              <if test=\'ProductQty != null\'>ProductQty = #{ProductQty},</if>\r\n              <if test=\'ProductUnitPrc != null\'>ProductUnitPrc = #{ProductUnitPrc},</if>\r\n              <if test=\'ProductAmt != null\'>ProductAmt = #{ProductAmt},</if>\r\n              <if test=\'SellType != null\'>SellType = #{SellType},</if>\r\n              <if test=\'Cntct != null\'>Cntct = #{Cntct},</if>\r\n              <if test=\'InflowPath != null\'>InflowPath = #{InflowPath},</if>\r\n              <if test=\'PayMeth != null\'>PayMeth = #{PayMeth},</if>\r\n              <if test=\'SellerId != null\'>SellerId = CONV(#{SellerId}, 36, 10),</if>\r\n              <if test=\'SptUserId != null\'>SptUserId = CONV(#{SptUserId}, 36, 10),</if>\r\n              <if test=\'ProductBarCdNo != null\'>ProductBarCdNo = #{ProductBarCdNo},</if>\r\n              <if test=\'PayAprvNo != null\'>PayAprvNo = #{PayAprvNo},</if>\r\n              <if test=\'CardNo4Digits != null\'>CardNo4Digits = #{CardNo4Digits},</if>\r\n              <if test=\'SESSION_SYSADMIN == \"Y\" and TenantId != null and TenantId != \"\"\'>\r\n                  TenantId = conv(#{TenantId}, 36, 10),\r\n              </if>\r\n              EdtDate = CURRENT_TIMESTAMP,\r\n              EdtUser = CONV(#{SESSION_USERID}, 36, 10)\r\n          </set> --> <span>&nbsp;&nbsp;&lt;update id=\"update{{vc.tbMain.tableNm}}\" parameterType=\"map\"&gt;</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;UPDATE {{vc.tbMain.tableNm}}</span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;set></span><div ng-repeat=\"li in vc.cols\" ng-if=\"li.priYn != \'Y\' && li.selectType == \'m\' && li.checkedYn && li.colNm.toLowerCase() != \'regdate\' && li.colNm.toLowerCase() != \'reguser\' && li.colNm.toLowerCase() != \'tenantid\' && li.colNm.toLowerCase() != \'deldate\' && li.colNm.toLowerCase() != \'deluser\'\">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <span style=\"display: inline-block\" ng-if=\"li.dataType == \'bigint\' && li.colNm.toLowerCase() != \'tenantid\' && li.colNm.toLowerCase() != \'edtuser\' && li.colNm.toLowerCase() != \'deluser\' && li.priYn != \'Y\'\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'>{{li.colNm}} = CONV(#{ {{li.colNm}} }, 36, 10),&lt;/if> </span><span style=\"display: inline-block\" ng-if=\"li.dataType != \'bigint\' && li.colNm.toLowerCase() != \'edtdate\' && li.colNm.toLowerCase() != \'deldate\' && li.colNm.toLowerCase() != \'delyn\' && li.colNm.toLowerCase() != \'edtuser\'\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'>{{li.colNm}} = #{ {{li.colNm}} },&lt;/if> </span><!-- <span style=\"display: inline-block;\" ng-if=\"li.colNm.toLowerCase() == \'tenantid\'\">\r\n                &nbsp;&nbsp;{{li.colNm}} = CONV(#{srchTenantId}, 36, 10),\r\n              </span> --> <span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'edtdate\'\">&nbsp;&nbsp;{{li.colNm}} = NOW(), </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'edtuser\'\">&nbsp;&nbsp;{{li.colNm}} = CONV(#{ SESSION_USERID }, 36, 10), </span><span style=\"display: inline-block\" ng-if=\"li.colNm.toLowerCase() == \'delyn\'\">&nbsp;&nbsp;&lt;if test=\'{{li.colNm}} != null and {{li.colNm}} != \"\"\'>{{li.colNm}} = #{ {{li.colNm}} },&lt;/if><br>&nbsp;&nbsp;&lt;if test=\'DelYN != null and {{li.colNm}} == \"Y\"\'>DelDate = NOW(), DelUser =CONV(#{ SESSION_USERID }, 36, 10), &lt;/if> </span><!-- <span style=\"display: inline-block;\" ng-if=\"li.colNm.toLowerCase() == \'deldate\'\">\r\n                &nbsp;&nbsp;{{li.colNm}} = NOW(),&lt;/if>\r\n              </span> --></div><span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;/set></span> <span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&lt;include refid=\"where{{vc.tbMain.tableNm}}Data\"/&gt; </span><span>&nbsp;&nbsp;&lt;/update&gt;</span><br><span ng-bind-html=vc.mapperend></span></span></span></span></span></span></div></div></div></div><!-- row --></div><!-- pagecontent --></div>");
$templateCache.put("app/system/menu/menu-manage-list.html","<style>.left-context, .right-context {\r\n  padding-top:5px;\r\n}\r\n\r\n.left-context .panel-body{\r\n  background:#e7edf3;\r\n}\r\n.left-context .panel-default {\r\n  margin-top:0px;\r\n  margin-bottom:0px;\r\n}\r\n.left-context .no-style {padding:0px; border:none;}\r\n.as-sortable-item {\r\n  -ms-touch-action: none;\r\n  touch-action: none;\r\n  /* to disable context menu on iOS devices */\r\n  -webkit-touch-callout: none;\r\n  /* margin-top: 2px; */\r\n  position:relative;\r\n}\r\n.as-sortable-item, .as-sortable-placeholder {\r\n    display: block;\r\n}\r\n.as-sortable-item-text {\r\n    -ms-touch-action: none;\r\n    touch-action: none;\r\n    /* to disable context menu on iOS devices */\r\n    -webkit-touch-callout: none;\r\n    position:relative;\r\n    border: solid 1px #c5cdd7;\r\n    padding : 6px 0px 6px 6px;\r\n}\r\n.as-sortable-item-handle {\r\n    cursor: move;\r\n    cursor: -webkit-grab;\r\n    cursor: -moz-grab;\r\n}\r\n.subTextmenu {\r\n  position: absolute;\r\n  right: 7px;\r\n  top: 7px;\r\n  font-size: 12px;\r\n  color : #bdbdbd;\r\n  display: none;\r\n}\r\n.subTextmenu span:hover {\r\n  color: #378AD8\r\n}\r\n.as-sortable-placeholder {}\r\n.as-sortable-drag {\r\n    position: absolute;\r\n    pointer-events: none;\r\n    z-index: 9999;\r\n}\r\n.as-sortable-hidden {\r\n    display: none !important;\r\n}\r\n.as-sortable-un-selectable {\r\n    -webkit-touch-callout: none;\r\n    -webkit-user-select: none;\r\n    -khtml-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n}\r\n.left-context *:focus {\r\n    outline: none;\r\n}\r\n#sortableOptions1 {\r\n  padding:5px;\r\n}\r\n.edit-layout {\r\n  display: none;\r\n  position:relative;\r\n  border: solid 1px #c5cdd7;\r\n  padding : 4px 0px 4px 15px;\r\n}\r\n.edit-layout input {\r\n  width: 100%;\r\n  padding : 4px 0px 4px 3px;\r\n  border : solid 1px #d8d8d8;\r\n}\r\n.edit-layout input:focus {\r\n  border : solid 1px #64aef8;\r\n}\r\n.edit-layout .subBtnWrap {\r\n  position:absolute;\r\n  right : 3px;\r\n  top : 9px;\r\n}\r\n.edit-layout .subBtnWrap span {\r\n  color : #999;\r\n  border: solid 1px #ccc;\r\n  padding:5px 10px 5px 10px;\r\n}\r\n.edit-layout .subBtnWrap span.okBtn {\r\n  border: solid 1px #EC5621;\r\n  background : #EC5621;\r\n  color : #FFF;\r\n}\r\n.edit-layout .subBtnWrap span.disable {\r\n  color : #ccc;\r\n  border: solid 1px #eee;\r\n  background : #EEE;\r\n}\r\n\r\n.importantHidden {display: none !important;}\r\n\r\n#iconWrap .active { color :#0000FF; -webkit-tap-highlight-color: rgba(255, 255, 255, 0)}\r\n\r\n.disable-master {\r\n  background:#c9c9c9 !important;\r\n  color :#999;\r\n}\r\n\r\n.right-context .panel {box-shadow: none; margin-bottom: 1px;}\r\n\r\n.depth-two {display: none;}\r\n.depth-three {display: none;}\r\n\r\n\r\n.right-panel-fixed-size-top {\r\n  position:fixed;\r\n  top: 60px;\r\n  padding-right:15px !important;\r\n}\r\n\r\n.right-panel-fixed-size-bottom {\r\n  position:fixed;\r\n  bottom: 0px;\r\n  padding-right:15px !important;\r\n  bottom:0px;\r\n}\r\n\r\n.visible-use-group {\r\n  background:#FFF  !important;\r\n}\r\n.visible-group {\r\n  /* background:#c6e2ff  !important; */\r\n}\r\n\r\n.visible-group .as-sortable-item-text {\r\n  background:#c6e2ff  !important;\r\n  display: block;\r\n}\r\n\r\n.invisible-group {\r\n  display: none !important;\r\n}\r\n\r\n.visible {\r\n  display:block;\r\n}\r\n\r\n#mapperWrap input {\r\n  border: solid 1px #d8d8d8;\r\n  padding : 3px 8px;\r\n  width: 100%;\r\n}\r\n\r\n#roleTable input[type=text] {\r\n  border: solid 1px #d8d8d8;\r\n  padding : 3px 8px;\r\n  width: 100%;\r\n}\r\n\r\n#conditionsTable input[type=text] {\r\n  border: solid 1px #d8d8d8;\r\n  padding : 3px 8px;\r\n  width: 100%;\r\n}\r\n\r\n.menu-name-tx {cursor:pointer;}\r\n.depth-three i {cursor:pointer;}\r\n\r\n.noti-pre {\r\n  border:solid 1px #EEE;\r\n  margin-top:8px;\r\n  background:#EEE;\r\n  padding: 8px;\r\n}\r\n\r\n.noti-pre span {\r\n  display:block;\r\n}</style><div ng-controller=\"MenuManageCtrl as vc\" class=menuManageView><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><h1 class=page-header style=\"margin-top: 12px\">메뉴 관리</h1></div></div><div class=row><div class=\"col-xs-12 col-sm-5 col-md-6 col-lg-4 col-xl-3 left-context\"><div class=panel-default><div class=panel-body id=sortableOptions style=\"padding:3px 0px\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-if=false style=\"padding: 0 3px\"><select class=form-control ng-model=vc.selectedGroupOptions ng-options=\"option.commonCodeId as option.codeNm for option in vc.radioMenuType\" ng-change=vc.onChamgeGroupView(vc.selectedGroupOptions)><option value=\"\">전체메뉴</option></select></div><div id=sortableContainer><!-- as-sortable : is-disabled=\"true\" --><div class=\"sortable-row col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=\"padding: 0 3px\" as-sortable=vc.sortableOptions ng-model=vc.menuList><div style=background:#FFF ng-mouseover=\"vc.showSubMenu(\'menutreeTopSubMenu\')\" ng-mouseleave=\"vc.hiddenSubMenu(\'menutreeTopSubMenu\')\"><div is-disabled=false class=as-sortable-item-text>{{ vc.menuTitle }}<div class=subTextmenu style=\"color:#378adb; top:7px\" id=menutreeTopSubMenu><div ng-if=\"vc.SysAdmin && vc.viewMode == \'A\'\"><span ng-click=\"vc.addChild(0,\'menutreeTopSubMenu\')\">추가</span></div></div></div></div><!-- Start Menu Tree --><div ng-repeat=\"item in vc.menuList\" as-sortable-item=vc.sortableOptions style=\"padding:0px; border:none; margin-left:15px\" class={{item.extendGroupClass}}><div as-sortable-item-handle=\"\"><div class=\"as-sortable-item-text {{item.disableClass}} depth-one\" style=background:#FFF ng-click=vc.setDetailView(item) ng-mouseover=\"vc.showSubMenu(\'subMenu_\'+item.menuId)\" ng-mouseleave=\"vc.hiddenSubMenu(\'subMenu_\'+item.menuId)\" menu-sort={{item.sort}} menu-sortpath={{item.sortPath}} ng-if=\"item.delYn!=\'Y\'\" id=\"{{\'atMenu_\' + item.menuId }}\"><i class=\"extend-btn fa fa-fw fa-plus\" ng-if=\"item.child.length > 0\" ng-click=\"vc.extendMenu(\'atMenu_\' + item.menuId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item.child.length == 0\"></i> <i class=\"fa fa-fw {{ item.icon }}\"></i> <span class=menu-name-tx>{{item.menuNm}}</span><div class=subTextmenu id=subMenu_{{item.menuId}} menu-sort={{item.sort}} menu-sortpath={{item.sortPath}}><div ng-if=\"vc.SysAdmin && vc.viewMode == \'A\'\"><span ng-if=\"item.useYn == \'\' || item.useYn == \'N\'\" ng-click=\"vc.setTenantEnable(1, item)\" style=color:#496887>활성 | </span><span ng-if=\"item.useYn == \'Y\'\" ng-click=\"vc.setTenantEnable(1, item)\" style=color:#496887>비활성 | </span><span ng-click=\"vc.addChild(1, item.menuId)\">추가</span> | <span ng-click=\"vc.delChild(1, item)\">삭제</span></div><div ng-if=\"vc.SysAdmin && vc.viewMode == \'T\'\"><div ng-if=\"item.useYn == \'N\'\"><span ng-click=\"vc.setTenantEnable(1, item)\" style=color:#496887>활성</span></div><div ng-if=\"item.useYn == \'Y\'\"><span ng-click=\"vc.setTenantEnable(1, item)\" style=color:#496887>비활성</span></div></div><!-- <span ng-click=\"vc.editChild(1, item)\">Edit</span> --></div></div></div><div class=sortable-row as-sortable=vc.sortableOptions ng-model=item.child style=margin-left:15px><div ng-repeat=\"item2 in item.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF><div class=\"as-sortable-item-text {{item2.disableClass}} depth-two\" style=background:#FFF ng-click=vc.setDetailView(item2) ng-mouseover=\"vc.showSubMenu(\'subMenu_\'+item2.menuId)\" ng-mouseleave=\"vc.hiddenSubMenu(\'subMenu_\'+item2.menuId)\" menu-sort={{item2.sort}} menu-sortpath={{item2.sortPath}} ng-if=\"item2.delYn!=\'Y\'\" id=\"{{\'atMenu_\' + item2.menuId }}\"><i class=\"extend-btn fa fa-fw fa-plus\" ng-if=\"item2.child.length > 0\" ng-click=\"vc.extendMenu(\'atMenu_\' + item2.menuId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item2.child.length == 0\"></i> <i class=\"fa fa-fw {{ item2.icon }}\"></i> <span class=menu-name-tx>{{item2.menuNm}}</span><div class=subTextmenu id=subMenu_{{item2.menuId}} menu-sort={{item2.sort}} menu-sortpath={{item2.sortPath}}><div ng-if=\"vc.SysAdmin && vc.viewMode == \'A\'\"><span ng-if=\"item2.useYn == \'\' || item2.useYn == \'N\'\" ng-click=\"vc.setTenantEnable(2, item2)\" style=color:#496887>활성 | </span><span ng-if=\"item2.useYn == \'Y\'\" ng-click=\"vc.setTenantEnable(2, item2)\" style=color:#496887>비활성 | </span><span ng-click=\"vc.addChild(2, item2.menuId)\">추가</span> | <span ng-click=\"vc.delChild(2, item2)\">삭제</span></div><div ng-if=\"vc.SysAdmin && vc.viewMode == \'T\'\"><div ng-if=\"item2.useYn == \'N\'\"><span ng-click=\"vc.setTenantEnable(2, item2)\" style=color:#496887>활성</span></div><div ng-if=\"item2.useYn == \'Y\'\"><span ng-click=\"vc.setTenantEnable(2, item2)\" style=color:#496887>비활성</span></div></div><!-- <span ng-click=\"vc.editChild(2, item2)\">Edit</span> --></div></div></div><div class=sortable-row as-sortable=vc.sortableOptions ng-model=item2.child style=margin-left:30px><div ng-repeat=\"item3 in item2.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF ng-click=vc.setDetailView(item3) ng-mouseover=\"vc.showSubMenu(\'subMenu_\'+item3.menuId)\" ng-mouseleave=\"vc.hiddenSubMenu(\'subMenu_\'+item3.menuId)\" menu-sort={{item3.sort}} menu-sortpath={{item3.sortPath}} ng-if=\"item3.delYn!=\'Y\'\"><div class=\"as-sortable-item-text {{item3.disableClass}} depth-three\" id=\"{{\'atMenu_\' + item3.menuId }}\"><i class=\"fa fa-fw {{ item3.icon }}\"></i> <span class=menu-name-tx>{{item3.menuNm}}</span><div class=subTextmenu id=subMenu_{{item3.menuId}} menu-sort={{item3.sort}} menu-sortpath={{item3.sortPath}}><div ng-if=\"vc.SysAdmin && vc.viewMode == \'A\'\"><span ng-if=\"item3.useYn == \'\' || item3.useYn == \'N\'\" ng-click=\"vc.setTenantEnable(3, item3)\" style=color:#496887>활성 | </span><span ng-if=\"item3.useYn == \'Y\'\" ng-click=\"vc.setTenantEnable(3, item3)\" style=color:#496887>비활성 | </span><span ng-click=\"vc.delChild(3, item3)\">삭제</span></div><div ng-if=\"vc.SysAdmin && vc.viewMode == \'T\'\"><div ng-if=\"item3.useYn == \'N\'\"><span ng-click=\"vc.setTenantEnable(3, item3)\" style=color:#496887>활성</span></div><div ng-if=\"item3.useYn == \'Y\'\"><span ng-click=\"vc.setTenantEnable(3, item3)\" style=color:#496887>비활성</span></div></div><!-- <span ng-click=\"vc.editChild(3, item3)\">Edit</span> --></div></div></div></div><div><div class=edit-layout style=background:#FFF id=editor{{item2.menuId}} menu-path={{item2.path}} menu-sort={{item2.sort}} menu-sortpath={{item2.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=vc.menuTitleChange() ng-model=vc.depth03title input-enter=\"vc.addMenuItem(3, \'editor\'+item2.menuId))\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=cancelBtn ng-click=\"vc.cancelMenuItem(3, \'editor\'+item2.menuId)\">취소</span> <span class=\"okBtn disable\" ng-click=\"vc.addMenuItem(3, \'editor\'+item2.menuId)\">확인</span></div><div style=clear:both></div></div></div></div></div><div><div class=edit-layout style=background:#FFF id=editor{{item.menuId}} menu-path={{item.path}} menu-sort={{item.sort}} menu-sortpath={{item.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=vc.menuTitleChange() ng-model=vc.depth02title input-enter=\"vc.addMenuItem(2, \'editor\'+item.menuId))\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=cancelBtn ng-click=\"vc.cancelMenuItem(2, \'editor\'+item.menuId)\">취소</span> <span class=\"okBtn disable\" ng-click=\"vc.addMenuItem(2, \'editor\'+item.menuId)\">확인</span></div><div style=clear:both></div></div></div></div></div><div><div class=edit-layout style=\"background:#FFF; margin-left:15px\" id=editorDepth01><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=vc.menuTitleChange() ng-model=vc.depth01title input-enter=\"vc.addMenuItem(1, \'editorDepth01\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=cancelBtn ng-click=\"vc.cancelMenuItem(1, \'editorDepth01\')\">취소</span> <span class=\"okBtn disable\" ng-click=\"vc.addMenuItem(1, \'editorDepth01\')\">확인</span></div><div style=clear:both></div></div></div><!-- End Menu Tree --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=\"padding: 0px\"><button class=\"btn btn-primary ng-binding\" activate-button=\"\" ng-click=vc.setChangeMenuList(); style=\"width:100%; margin-top:6px; height:35px\"><i class=\"fa fa-edit\"></i> 리스트 순서 변경</button></div></div></div></div></div></div><div class=\"col-xs-12 col-sm-7 col-md-6 col-lg-8 col-xl-9 right-context\"><div class=\"panel panel-default\" style=border:none><div class=\"panel-body root-panel-body\" style=padding:0px><ul class=\"nav nav-tabs\"><li class=active><a ng-click=vc.setChangeTab(0); data-toggle=tab style=\"cursor: pointer\">기본정보</a></li><li><a ng-click=vc.setChangeTab(1); data-toggle=tab style=\"cursor: pointer\">권한정보</a></li></ul><div class=tab-content><!-- Start First Tab Content --><div class=\"tab-pane fade {{ vc.showTabView[0] }}\"><!-- Start 메뉴그룹 --><div class=row ng-if=\"vc.SysAdmin \"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>메뉴그룹</div><div class=panel-body style=padding:8px><!-- Start Body --><div class=\"form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><label class=\"radio-inline pl-0 pr-15\" ng-repeat=\"mt in vc.radioMenuType\"><input type=checkbox class=clr ng-model=mt.checked ng-disabled=\"vc.mSrchTenentID != \'0\'\"> {{ mt.codeNm}}</label></div><!-- End Body --></div></div></div></div><!-- End 메뉴그룹 --><!-- Start 메뉴정보 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>메뉴정보</div><div class=panel-body><!-- Start Body --><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-4 col-xl-4\"><div class=form-group><label class=ng-binding>메뉴명</label><div><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vc.menuInfo.menuNm aria-invalid=false></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-4 col-xl-4\" ng-if=vc.SysAdmin><div class=form-group><label class=ng-binding>다국어 키</label><div><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vc.menuInfo.translateCode aria-invalid=false></div></div></div><div class=\"col-xs-12 col-sm-6 col-md-12 col-lg-4 col-xl-4\" ng-if=vc.menuInfo.levelYn><div class=form-group><label class=ng-binding>접근권한등급</label><div><select class=form-control ng-model=vc.menuInfo.roleLevel ng-options=\"option.commonCodeId as option.codeNm for option in vc.roleLevelList\"><option value=\"\">권한등급</option></select></div></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" ng-if=vc.menuInfo.levelYn><div class=noti-pre><span>* 접근권한등급이 Level 0일 경우 권한정보에 영향을 받지않고 활성화 됩니다.</span> <span>* 접근권한등급이 지정되지 않을경우 사용자의 기본 등급인 1의 값으로 설정됩니다.</span></div></div><!-- End Body --></div></div></div></div><!-- End 메뉴정보 --><!-- Start 연관페이지 --><div class=row ng-if=\"vc.SysAdmin  && vc.mSrchTenentID == \'0\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>연관페이지</div><div class=panel-body><!-- Start Body --><table id=searchTextResults class=\"table table-custom minWidth-1200\"><thead><tr><th data-toggle=true class=tx-center style=width:50px>메인</th><th data-toggle=true class=tx-center>페이지명</th><th data-toggle=true class=tx-center>페이지URL</th><th data-toggle=true class=tx-center ng-if=\"vc.viewMode == \'A\'\">매개변수</th><!-- <th data-toggle=\"true\" class=\"tx-center\">새창여부</th> --><th data-toggle=true class=tx-center ng-if=\"vc.viewMode == \'A\'\">삭제</th></tr></thead><tbody ng-if=vc.menuInfo.pages><tr ng-repeat=\"li in vc.menuInfo.pages\" style=\"cursor: pointer\"><td class=text-center><div class=\"form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=margin-top:-8px><label class=radio-inline><input type=radio name=pageMain id=page ng-model=li.mainYn value={{$index}} ng-checked=\"li.mainYn == \'Y\'\"></label></div></td><td class=text-center><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=li.screenNm aria-invalid=false></td><td class=text-left><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=li.pageUrl aria-invalid=false></td><td class=text-left ng-if=\"vc.viewMode == \'A\'\"><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=li.pageUrlParam aria-invalid=false></td><!-- <td class=\"tx-center\">\r\n                              <select class=\"form-control\"\r\n                                ng-model=\"li.newWindowYn\"\r\n                                ng-options=\"option.value as option.codeNm for option in vc.selectNewWindowYn\"\r\n                                ng-change=\"vc.onChangeNewWindowYn(li)\">\r\n                              </select>\r\n                            </td> --><td class=tx-center ng-if=\"vc.viewMode == \'A\'\"><span ng-if=\"li.delYn == \'N\'\" ng-click=\"vc.delPage(li, $index)\">삭제</span> <span ng-if=\"li.delYn == \'Y\'\" ng-click=\"vc.delPage(li, $index)\">취소</span></td></tr></tbody><tbody ng-if=\"vc.menuInfo.length == 0 || vc.menuInfo.pages.length == 0\"><tr><td colspan=5 class=tx-center style=padding:8px>연관페이지가 있을 경우 등록하세요.</td></tr></tbody></table><!-- End Body --></div><div class=\"panel-footer tx-right\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.addPage()><i class=\"fa fa-edit\"></i> 페이지 추가</button></div></div></div></div><!-- End 연관페이지 --><!-- Start 연관설문 --><div class=row ng-if=\"vc.SysAdmin  && vc.mSrchTenentID == \'0\' && vc.mobileOnlyYN == \'Y\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>연관설문</div><div class=panel-body><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=vc.menuSvyChkHead ng-change=menuSvyChkHeadChg()></th><th class=\"text-center none\" style=width:10%>제목</th><th class=\"text-center none\" style=width:10%>구분</th><th class=\"text-center none\" style=width:10%>통과점수</th><th class=\"text-center none\" style=width:10%>신규가입표시여부</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"vc.menuSvyTotalItems == 0\"><tr class=tbnodata><td class=text-center colspan=5>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in vc.menuSvyLists\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.menuSvyChkRow ng-change=menuSvyChkRowChg()></td><td class=text-center style=vertical-align:middle>{{li.SvyNm}}</td><td class=text-center style=vertical-align:middle>{{li.SvyType_}}</td><td class=text-center style=vertical-align:middle>{{li.PassScore}}</td><td class=text-center style=vertical-align:middle>{{li.JoinShowYN}}</td></tr></table></div><div class=\"panel-footer tx-right\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.addMenuSvyModal()><i class=\"fa fa-edit\"></i> 설문 추가</button> <button class=\"btn btn-danger\" ng-click=vc.deleteMenuSvyList()><i class=\"fa fa-trash-o\"></i> 설문 삭제</button></div></div></div></div><!-- End 연관설문 --><!-- Start 아이콘 --><div class=row id=iconWrap><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>아이콘 <a href=http://fa2png.io/r/font-awesome/ target=_blank><i class=\"fa fa-info\"></i></a></div><div class=panel-body><!-- Start Body --><div ng-repeat=\"item in vc.fontList\" class=\"col-xs-6 col-sm-6 col-md-6 col-lg-3 col-xl-3 {{item.active}}\"><span ng-click=vc.setChangeIcon(item.name);><i class=\"fa {{ item.name }}\"></i> {{item.name}}</span></div><!-- End Body --></div><div class=panel-footer ng-if=vc.SysAdmin><div class=\"col-xs-11 col-sm-11 col-md-11 col-lg-6 col-xl-5\" style=\"padding-top:3px; padding-right:0px\"><input type=text class=\"form-control ng-pristine ng-untouched ng-valid ng-empty\" ng-model=vc.addInputFa aria-invalid=false></div><div class=\"col-xs-1 col-sm-1 col-md-1 col-lg-1 col-xl-1\" style=padding-top:3px><i id=viewFontIcon class=\"fa {{vc.addInputFa}}\" style=font-size:30px></i></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-6 tx-right\" style=\"padding-top:3px; padding-right:3px\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.setFa()><i class=\"fa fa-edit\"></i> Font Awesome 추가</button></div><div style=clear:both></div></div></div></div></div><!-- End 아이콘 --><!-- Start 메모 --><div class=row id=iconWrap><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>메뉴 설명</div><div class=panel-body><textarea class=form-control row=3 cols=50 ng-model=vc.menuInfo.remark></textarea></div></div></div></div><!-- End 메모 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=margin-top:8px><button class=\"btn btn-primary ng-binding\" activate-button=\"\" ng-click=vc.invalidBaseInfo()><i class=\"fa fa-edit\"></i> 저장</button></div></div><!-- End First Tab Content --></div><div class=\"tab-pane fade {{ vc.showTabView[1] }}\"><!-- Start 연관페이지 선택 --><div class=row ng-if=vc.SysAdmin><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>연관 페이지 선택</div><div class=panel-body><!-- Start Body --><div class=\"form-group col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><label class=radio-inline ng-repeat=\"pi in vc.menuInfo.pages\"><input type=radio name=optionMenuType id=tenantPageType ng-model=pi.choicePage value={{pi.menuPageId}} ng-click=vc.loadPageData(pi)> {{ pi.screenNm}}({{ pi.pageUrl}})</label></div><!-- End Body --></div></div></div></div><!-- END 연관페이지 선택 --><!-- Start SQLMapper 관리 --><div class=row ng-if=\"vc.SysAdmin  && vc.mSrchTenentID == \'0\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>SQL Mapper 관리</div><div class=panel-body><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=\"padding-top:3px; padding-right:3px\" ng-if=\"vc.choiceRolePage != \'\'\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.getLoadSqlMapper()><i class=\"fa fa-edit\"></i> File 불러오기</button> <button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.addSqlMapper()><i class=\"fa fa-edit\"></i> Mapper 추가</button></div><table class=\"footable table\" id=mapperWrap><thead><tr><th class=tx-center>SQLMapper</th><th class=tx-center style=width:80px>사용여부</th><th class=tx-center style=width:80px>삭제</th></tr></thead><tbody><tr ng-repeat=\"li in vc.rolesInfo.sqlMapper\"><td class=text-left style=padding-left:5px><input type=text ng-model=li.sqlCode></td><td class=text-center><input type=checkbox ng-model=li.useYn></td><td class=text-center><span ng-if=\"li.delYn == \'N\'\" ng-click=\"li.delYn = \'Y\'\">삭제</span> <span ng-if=\"li.delYn == \'Y\'\" ng-click=\"li.delYn = \'N\'\">취소</span></td></tr></tbody></table><div class=noti-pre>* 페이지 추가 : 해당 페이지의 ctrl.js 파일을 로드시 postApi로 지정된 SqlMapper를 불러올 수 있습니다.</div><!-- Start Body --><!-- End Body --></div></div></div></div><!-- END SQLMapper 관리 --><!-- Start 프로그램 관리 --><div class=row ng-if=\"vc.SysAdmin && vc.mSrchTenentID == \'0\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>상세조건 관리</div><div class=panel-body><!-- Start Body --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=\"padding-top:3px; padding-right:3px\" ng-if=\"vc.choiceRolePage != \'\'\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.addCondition()><i class=\"fa fa-edit\"></i> 조건 추가히기</button></div><table id=conditionsTable class=\"footable table table-custom\"><thead><tr><th data-toggle=true class=tx-center style=width:30%>조건</th><th data-toggle=true class=tx-center style=width:30%>비교값</th><th data-toggle=true class=tx-center style=width:30%>패스여부</th><th data-toggle=true class=tx-center style=width:30%>삭제</th></tr></thead><tbody><tr ng-repeat=\"li in vc.rolesInfo.conditions\" style=\"cursor: pointer\"><td class=text-center><input type=text ng-model=li.condition></td><td class=text-center><input type=text ng-model=li.value></td><td class=text-center><input type=checkbox ng-model=li.useYn></td><td class=text-center><span ng-if=\"li.delYn == \'N\'\" ng-click=\"li.delYn = \'Y\'\">삭제</span> <span ng-if=\"li.delYn == \'Y\'\" ng-click=\"li.delYn = \'N\'\">취소</span></td></tr></tbody></table><div class=noti-pre><span>* \'조건 = 비교값\' 혹은 \'조건 ≠ 비교값\' 의 설정은 패스여부의 체크박스를 통하여 수정할 수 있습니다.</span> <span>* SESSION, srchTenantId 혹은 기타 전달 값을 통하여 비교연산을 하실 수 있습니다.</span></div><!-- End Body --></div></div></div></div><!-- END 프로그램 관리 --><!-- Start 역할관리 --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=padding-top:8px><div class=\"panel panel-default\"><div class=panel-heading>화면권한관리</div><div class=panel-body><!-- Start Body --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=\"padding-top:3px; padding-right:3px\" ng-if=\"vc.choiceRolePage != \'\'\"><button class=\"btn btn-info ng-binding\" activate-button=\"\" ng-click=vc.setChangeEdtLabel()><i class=\"fa fa-edit\"></i> {{vc.checkEdtLabelText}}</button></div><table id=roleTable class=\"footable table table-custom\" style=\"table-layout: fixed\"><thead><tr><th class=tx-center>역할명</th><th class=tx-center>조회</th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn01Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn01Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn02Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn02Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn03Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn03Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn04Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn04Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn05Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn05Text ng-if=vc.checkEdtLabel></th><th class=tx-center><span ng-if=!vc.checkEdtLabel>{{vc.rolesInfo.Btn06Text}}</span> <input type=text ng-model=vc.rolesInfo.Btn06Text ng-if=vc.checkEdtLabel></th></tr></thead><tbody><tr ng-repeat=\"li in vc.rolesInfo.screen\"><td class=text-left><span>{{li.RoleNm}}</span></td><td class=text-center><input type=checkbox ng-model=li.ViewYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn01YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn02YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn03YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn04YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn05YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-center><input type=checkbox ng-model=li.Btn06YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td></tr></tbody></table><!-- End Body --></div></div></div></div><!-- End 역할관리 --><div class=row ng-if=\"vc.choiceRolePage != \'\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12 tx-right\" style=margin-top:8px><button class=\"btn btn-primary ng-binding\" activate-button=\"\" ng-click=vc.setRoleData();><i class=\"fa fa-edit\"></i> 저장</button></div></div></div></div></div></div></div></div></div>");
$templateCache.put("app/system/notice/sys-notice-edit-view.html","<script type=text/javascript src=assets/app/SE2.9/js/service/HuskyEZCreator.js charset=utf-8></script><!-- 페이지 스타일 정의 시작 --><style>.imageBox {\r\n    width: 275px;\r\n    height: 170px;\r\n    margin: 0 auto;\r\n    border:solid 1px #EEE;\r\n    margin-bottom: 18px;\r\n    background-size: contain;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    max-width: 100%;\r\n  }\r\n  #emptyPhoto {\r\n    background-image: url(/assets/images/icon/gift-box.png);\r\n    background-size: 80% auto;\r\n  }\r\n \r\n .addShipOptionbtn {\r\n   display: inline-block;\r\n   background: #f4f4f4;\r\n   padding: 3px 5px;\r\n   border: solid 1px #CCC;\r\n }</style><!-- 페이지 스타일 정의 종료 --><!-- Html Editor --><div class=\"page page-footable\" ng-controller=\"SysNoticEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><div class=row><div class=col-lg-12><h3 class=page-header>{{ vc.titleNm }}</h3></div></div><!-- page content --><div class=pagecontent><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.setDelData() ng-if=vc.keyId><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong class=ng-binding style=\"letter-spacing: 0.5px\">공지사항 상세</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" id=inputWrap></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><textarea id=strHtml rows=10 style=\"width: 100%; height: 300px; display: \'none\'\" ng-model=vc.notice.Contents></textarea></div></div></div></div></div></div></div><!-- /page content --></div><script type=text/javascript>var oEditors = [];\r\n\r\n  var sLang = \"en_US\"; // 언어 (ko_KR/ en_US/ ja_JP/ zh_CN/ zh_TW), default = ko_KR\r\n\r\n  // 추가 글꼴 목록\r\n  //var aAdditionalFontSet = [[\"MS UI Gothic\", \"MS UI Gothic\"], [\"Comic Sans MS\", \"Comic Sans MS\"],[\"TEST\",\"TEST\"]];\r\n\r\n  nhn.husky.EZCreator.createInIFrame({\r\n    oAppRef : oEditors,\r\n    elPlaceHolder : \"strHtml\",\r\n    sSkinURI : \"assets/app/SE2.9/SmartEditor2Skin.html\",\r\n    htParams : {\r\n      bUseToolbar : true, // 툴바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseVerticalResizer : true, // 입력창 크기 조절바 사용 여부 (true:사용/ false:사용하지 않음)\r\n      bUseModeChanger : true, // 모드 탭(Editor | HTML | TEXT) 사용 여부 (true:사용/ false:사용하지 않음)\r\n      //bSkipXssFilter : true,    // client-side xss filter 무시 여부 (true:사용하지 않음 / 그외:사용)\r\n      //aAdditionalFontList : aAdditionalFontSet,   // 추가 글꼴 목록\r\n      fOnBeforeUnload : function() {\r\n        //alert(\"완료!\");\r\n       \r\n      },\r\n      I18N_LOCALE : sLang\r\n    }, //boolean\r\n    fOnAppLoad : function() {\r\n      //예제 코드\r\n      //oEditors.getById[\"ir1\"].exec(\"PASTE_HTML\", [\"로딩이 완료된 후에 본문에 삽입되는 text입니다.\"]);\r\n      //$(\"iframe\").css(\"height\", \'600px\')\r\n    },\r\n    fCreator : \"createSEditor2\"\r\n  });</script>");
$templateCache.put("app/system/notice/sys-notice-list-view.html","<div class=\"page page-footable\" ng-controller=\"SysNoticListCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><page-header></page-header><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}} class=thumbnail-list><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.Title placeholder=\"타이틀 검색\" type=text ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><!-- 상세검색 창 --><div class=search-detail-wrap id=searchDetailWrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row id=searchWrap></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.goAdd()><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><list-table></list-table><!-- / Table row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/role/role-detail.html","<div class=\"page page-footable\" ng-controller=\"RoleDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.EM630\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC01\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RoleId></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC02\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RoleNm></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC04\' | translate }}</label><div class=\"form-control txt_view\">{{vc.data.RegDate | date:\'yyyy-MM-dd\'}}</div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.MAINPAGE\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.MainPage></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.SORTORDER\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Sort></div></div></div><div class=\"col-lg-12 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Remark></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/role/role-edit.html","<div class=\"page page-footable\" ng-controller=\"RoleEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>{{ \'Menu.EM630\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=col-lg-3><ul class=\"ul_h li_mr15\"><li><label><input type=radio name=RoleType value=ROOT ng-model=vc.data.RoleType checked> 재단</label></li><li><label><input type=radio name=RoleType value=TAKETENANT ng-model=vc.data.RoleType> 사례기관</label></li><li><label><input type=radio name=RoleType value=GIVETENANT ng-model=vc.data.RoleType> 후원기관</label></li></ul></div></div><div class=row><div class=col-lg-6><div class=form-group><label>{{ \'Menu.EM630DC01\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RoleId readonly></div></div><div class=col-lg-6><div class=form-group><label>{{ \'Menu.EM630DC02\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RoleNm></div></div><div class=col-lg-6><div class=form-group><label>{{ \'Menu.EM630DC03\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RegUserNm readonly></div></div><div class=col-lg-6><div class=form-group><label>{{ \'Menu.EM630DC04\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.RegDate readonly></div></div><div class=col-lg-6><div class=form-group><label>{{ \'Menu.MAINPAGE\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.MainPage></div></div><div class=col-lg-6><div class=form-group><label>{{ \'Menu.SORTORDER\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Sort></div></div><div class=col-lg-12><div class=form-group><label>{{ \'Menu.REMARKS\' | translate }}</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Remark></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/role/role-list.html","<div class=\"page page-footable\" ng-controller=\"RoleListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>{{ :: \'Menu.EM630\' | translate }}<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-size={{$root.gVariable.layoutBoardSize}} pane-min={{vc.paneMin}} pane-max=\"80% + 2px\" pane-handle=4><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.RoleNm placeholder=\"역할명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getSearch()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.RoleNm type=text><label>{{ :: \'Menu.EM630DT01\' | translate }}</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.getExcel()><i class=\"fa fa-file-excel-o\"></i> {{\'Menu.EXCEL\' | translate}}</button> <button class=\"btn btn-primary\" ng-click=\"vc.goEdit(\'\')\"><i class=\"fa fa-edit\"></i> {{\'Menu.ADD\' | translate}}</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.EM630\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><!--  <th ng-click=\"vc.tablesort(\'X.RoleId\')\" data-toggle=\"true\" class=\"text-center\">{{ \'Menu.EM630DC01\' | translate }}  <span class=\"{{vc.sortClass(\'X.RoleId\')}}\"></span></th>--><th ng-click=\"vc.tablesort(\'X.RoleType\')\" data-toggle=true class=text-center>소속 <span class=\"{{vc.sortClass(\'X.RoleNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.RoleNm\')\" data-toggle=true class=text-center>{{ \'Menu.EM630DC02\' | translate }} <span class=\"{{vc.sortClass(\'X.RoleNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.RegUserNm\')\" data-toggle=true class=text-center>{{ \'Menu.EM630DC03\' | translate }} <span class=\"{{vc.sortClass(\'X.RegUserNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.RegDate\')\" data-toggle=true class=text-center>{{ \'Menu.EM630DC04\' | translate }} <span class=\"{{vc.sortClass(\'X.RegDate\')}}\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goEdit(li.RoleId) style=\"cursor: pointer\" my-directive ng-class=\"{\'bg-lightyellow\':selectedRow == li.RoleId}\"><!-- Result Items --><!-- <td class=\"text-center\"><span ng-bind=\"li.RoleId\"></span></td>--><td class=text-center><span ng-bind=li.RoleType></span></td><td class=text-center><span ng-bind=li.RoleNm></span></td><td class=text-center><span ng-bind=li.RegUserNm></span></td><td class=text-center><span>{{li.RegDate | utcToLocal:\'yyyy-MM-dd\'}}</span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/role-screen/rolescreen-detail.html","<div class=\"page page-footable\" ng-controller=\"RolescreenDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>메뉴권한관리</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a>{{ \'Menu.SYSTEM\' | translate }}</a></li><li><a ui-sref=app.system.rolescreen-list>메뉴권한관리</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>메뉴권한관리 {{ \'Menu.DETAIL\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10\" activate-button ui-sref=app.system.rolescreen-list() ng-show=\"vc.stateParams.TenantId != \'\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10\" activate-button ui-sref=\"app.system.rolescreen-edit({TenantId:\'{{vc.stateParams.TenantId}}\'})\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail() ng-show=\"gVariable.TenantId == \'0\'\"><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.COMPANY\' | translate }} {{ \'Menu.ID\' | translate }}</label><input type=text class=form-control ng-readonly=\"vc.data.TenantId != \'\'\" ng-model=vc.data.TenantId ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.COMPANY\' | translate }}{{ \'Menu.NAME\' | translate }}</label><input type=text class=form-control ng-model=vc.data.TenantNm ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.PERSONINCHARGE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Contact ng-required=true readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.CEO\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CEO ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.TENANTDIR\' | translate }}</label><input type=text class=form-control ng-model=vc.data.TenantDir ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label></label><input type=text class=form-control ng-required=true readonly></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.REMARKS\' | translate }}</label><textarea class=form-control row=3 cols=50 ng-model=vc.data.Remark readonly></textarea></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><table class=\"table table-hover table-striped invoice-list datatable dataTable no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th><th><span>{{ \'Menu.NUMBERDOWNLOADS\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in vc.data.uploadFileList\"><tr id=filectl_{{obj.id}} ng-if=\"obj.dirtyFlag!=\'D\'\"><td><span ng-show=fli.isLoaded class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td><td align=right><span class=file_size ng-bind=fli.downloadCnt|number></span></td></tr></tbody></table></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div></div>");
$templateCache.put("app/system/role-screen/rolescreen-edit.html","<div class=\"page page-footable\" ng-controller=\"RolescreenEditCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>메뉴권한관리</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a>{{ \'Menu.SYSTEM\' | translate }}</a></li><li><a ui-sref=app.system.rolescreen-list>메뉴권한관리</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm\"><h4 class=custom-font><strong>메뉴권한관리 {{ \'Menu.ADD\' | translate }}/{{ \'Menu.EDIT\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><form id=form ng-submit=vc.setData()><div class=row><div class=col-sm-12><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.system.rolescreen-list() ng-show=\"vc.stateParams.TenantId != \'\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary btn-ef btn-ef-7b mb-10\" activate-button type=submit><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.COMPANY\' | translate }} {{ \'Menu.ID\' | translate }}</label><input type=text class=form-control ng-readonly=\"vc.data.TenantId != \'\'\" ng-model=vc.data.TenantId ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.COMPANY\' | translate }}{{ \'Menu.NAME\' | translate }}</label><input type=text class=form-control ng-model=vc.data.TenantNm ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.PERSONINCHARGE\' | translate }}</label><input type=text class=form-control ng-model=vc.data.Contact ng-required=true></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>{{ \'Menu.CEO\' | translate }}</label><input type=text class=form-control ng-model=vc.data.CEO ng-required=true></div></div><div class=col-lg-4><div class=form-group><label>{{ \'Menu.TENANTDIR\' | translate }}</label><input type=text class=form-control ng-model=vc.data.TenantDir ng-required=true></div></div><div class=col-lg-4><div class=form-group><label></label><input type=text class=form-control></div></div></div><div class=row><div class=col-lg-12><div class=form-group><label>{{ \'Menu.ATTACHEDFILE\' | translate }} : {{ \'Menu.USERIMAGE\' | translate }} 100 * 130 px [ {{ \'Menu.MAX\' | translate }} 300MB, {{ \'Menu.NO_ENROLLMENT_COUNT\' | translate }}]</label><file-attach file-data=vc.uploadFileList callback=vc.onFileCallback></file-attach></div></div></div><!-- /tile body --></form></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div></div>");
$templateCache.put("app/system/role-screen/rolescreen-list.html","<div class=\"page page-footable\" ng-controller=\"RolescreenListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>역할별 화면권한관리</div></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><div class=dataloader ng-show=vc.dataloader></div><div class=col-lg-12><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.ScreenNm placeholder=\"화면명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><select class=form-control ng-model=vc.srch.role ng-options=\"opt.RoleId as opt.RoleNm for opt in vc.roleList\"><option value=\"\">---- {{ \'Menu.ALL\' | translate }} ----</option></select><label>{{ \'Menu.ROLEGROUP\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ScreenNm type=text><label>{{ \'Menu.SCREENNAME\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.PageUrl type=text><label>프로그램명</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.saveList()><i class=\"fa fa-save\"></i> 저장</button></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\">권한별 화면목록</strong><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><div class=\"panel-body collapse in\" id=collapse1><div class=row><div class=col-lg-12><table id=searchTextResults class=\"table table-custom table-hover\"><thead><tr><th data-toggle=true class=text-center>{{ \'Menu.ROLEGROUP\' | translate }} {{ \'Menu.NAME\' | translate }}</th><th data-toggle=true class=text-center>메뉴명</th><th data-toggle=true class=text-center>{{ \'Menu.SCREENNAME\' | translate }}</th><th class=text-left><label><input type=checkbox ng-change=\"vc.checkBtn(\'ViewYN\')\" ng-model=vc.checkAllBtn.ViewYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">조회</label></th><th class=text-left><label><input type=checkbox ng-change=\"vc.checkBtn(\'Btn01YN\')\" ng-model=vc.checkAllBtn.Btn01YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button01</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn02YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button02</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn03YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button03</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn04YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button04</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn05YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button05</label></th><th data-toggle=true class=text-left><label><input type=checkbox ng-model=vc.checkAllBtn.Btn06YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">Button06</label></th></tr></thead><tbody><tr ng-repeat=\"li in vc.lists\" my-directive><input type=hidden ng-model=li.RoleScrId><td class=text-left><span ng-bind=li.RoleNm></span></td><td class=text-left><span ng-bind=li.MenuNm title={{li.Sort}} ng-if=\"li.MainYN == \'Y\'\" ng-class=\"\'menudepth\' + li.Depth\"></span></td><td class=text-left><span ng-bind=li.ScreenNm title={{li.PageUrl}}></span></td><td class=text-left><input type=checkbox ng-model=li.ViewYN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\"></td><td class=text-left><label><input type=checkbox ng-model=li.Btn01YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn01Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn02YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn02Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn03YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn03Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn04YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn04Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn05YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn05Text}}</label></td><td class=text-left><label><input type=checkbox ng-model=li.Btn06YN ng-true-value=\"\'Y\'\" ng-false-value=\"\'N\'\">{{li.Btn06Text}}</label></td></tr></tbody></table></div></div></div></div><!-- // table  --></div></div></div></div></div></div>");
$templateCache.put("app/system/sms/sms-auto-edit.html","<div class=\"page page-footable\" ng-controller=\"SmsAutoEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>SMS 자동발송 상세정보</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button><!--button class=\"btn btn-danger\" ng-click=\"vc.delData()\">\r\n            <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n          </button--></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>SMS 자동발송 상세정보</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=col-lg-12><form class=\"ng-pristine ng-valid\" role=form><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=상황명>상황명</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.SituationTitl></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=발신자>발신자</label><common-code-custom code-list=\"vc.columnMap[\'Caller\'].CodeList\" code-model=vc.data.Caller></common-code-custom></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=수신자>수신자</label><common-code-custom code-list=\"vc.columnMap[\'Receiver\'].CodeList\" code-model=vc.data.Receiver></common-code-custom></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=금액차감유형>금액차감유형</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.CostType></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=테넌트아이디>테넌트아이디</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.TenantId></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=발송유형>발송유형</label><common-code-custom code-list=\"vc.columnMap[\'CmpgnChannel\'].CodeList\" code-model=vc.data.CmpgnChannel></common-code-custom></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=알림톡템플릿키>알림톡템플릿키</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.KakaoTemplateKey></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"매칭조건(json string 형식)\">매칭조건(json string 형식)</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.ActionCondition></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"스케줄러 조회용쿼리\">스케줄러 조회용쿼리</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.AutoCondition></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"실행할 API키\">실행할 API키</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.SqlQueryId></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"보내는사람 전화번호\">보내는사람 이름</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.FromNm></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"보내는사람 전화번호\">보내는사람 정보</label><input type=text class=\"form-control form-right\" maxlength=200 ng-model=vc.data.FromTelNo></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"받는사람 전화번호\">받는사람 정보</label><textarea rows=5 class=\"form-control form-right\" style=width:100% ng-model=vc.data.ToTelNo></textarea><ul class=form-control-no-border><li>* 이름, 수신정보(Mobile 또는 Email), 아이디, 테넌트아이디</li><li>* {UserNm}은 UserNm으로 치환, {TenantNm}은 TenantNm으로 치환됨</li></ul></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"보내는 메시지 제목\">보내는 메시지 제목</label><input type=text class=\"form-control form-right\" maxlength=100 ng-model=vc.data.SendTitle></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label uib-tooltip=\"발송 내용\">발송 내용</label><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=vc.data.SendMessage ng-change=vc.chkSendMessage()></textarea><div class=text-right>[SMS] {{vc.messageLength}} / {{vc.messageMaxLength}} bytes</div><ul class=form-control-no-border><li>* 받는 사람정보에 지정된 쿼리에 의해 가져온 값으로 치환 : {UserNm}은 UserNm으로 치환, {TenantNm}은 TenantNm으로 치환됨</li><li>* 웹에서 요청한 정보에 있는 값으로 치환 : #{UserNm}은 웹에서 요청한 정보에 UserNm 값이 포함되어 있으면 UserNm 으로 치환됨</li></ul></div></div></div><div class=row><div class=col-lg-2><div class=\"form-group form-inline\"><label uib-tooltip=사용여부>사용여부</label><common-code-custom code-list=\"vc.columnMap[\'SendMessageYN\'].CodeList\" code-model=vc.data.SendMessageYN></common-code-custom></div></div></div><div class=row><div class=col-lg-12><div class=\"form-group form-inline\"><div class=form-control-no-border></div></div></div></div></form></div></div></div></div></div><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button><!--button class=\"btn btn-danger\" ng-click=\"vc.delData()\">\r\n            <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n          </button--></div></div></div></div></div>");
$templateCache.put("app/system/sms/sms-auto-list.html","<div class=\"page page-footable\" ng-controller=\"SmsAutoListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>SMS 자동발송<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.setChangeLayout(\'N\')\"><img alt=\"\" src=assets/images/icon-sp-list.png></span><span ng-click=\"vc.setChangeLayout(\'V\')\"><img alt=\"\" src=assets/images/icon-sp-rl.png></span><span ng-click=\"vc.setChangeLayout(\'H\')\"><img alt=\"\" src=assets/images/icon-sp-tb.png></span></div></div></div></div><!-- /page header --><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.SituationTitl placeholder=\"상황명 검색\" type=text><div class=\"search_action mb-5\" ng-click=vc.getList()><span class=cursor><i class=\"fa fa-search\"></i></span></div><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- <div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\">\r\n                          <div class=\"form-group form-inner-label\">\r\n                            <common-code-custom code-list=\"vc.columnMap[\'FormType\'].CodeList\"\r\n                                                code-model=\"vc.srch.FormType\"></common-code-custom>\r\n                            <label>{{vc.columnMap[\'FormType\'].ColumnLogicalNm | translate}}</label>\r\n                          </div>\r\n                        </div> --><!-- 사용자정의 컬럼 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=\"vc.columnMap[\'CmpgnChannel\'].CodeList\" code-model=vc.srch.CmpgnChannel></common-code-custom><label>{{vc.columnMap[\'CmpgnChannel\'].ColumnLogicalNm | translate}}</label></div></div><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.setResetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right><button class=\"btn btn-primary\" ng-click=\"vc.goEdit(\'\')\"><i class=\"fa fa-edit\"></i> 추가</button><!--button class=\"btn btn-danger\" ng-click=\"vc.setDelList()\">\r\n                    <i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}\r\n                  </button--></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><!--                 <div class=\"panel-heading tile-header\">\r\n                  <strong>{{ :: \'Menu.USER\' | translate }}</strong>\r\n                  <div class=\"pull-right\">\r\n                    <a ng-href tile-control-toggle> <i class=\"fa fa-minus fa-lg\"></i>\r\n                    </a>\r\n                  </div>\r\n                </div> --><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"vc.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ ::liCol.ColumnLogicalNm | translate }} <span class=\"{{vc.sortClass(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tbody ng-if=\"vc.totalItems > 0\"><tr ng-repeat=\"li in vc.lists\" ng-click=\"vc.goDetail(li.KeyId, $index)\" style=\"cursor: pointer\" ng-class=\"{\'bg-lightyellow\':li.KeyId == selectedRow}\"><!-- Result Items --><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}}\" ng-repeat=\"liCol in vc.listColumns | filter: $root.listColumFilter\"><span ng-switch=liCol.ColumnLogicalDataType><span ng-switch-when=40>{{li[liCol.ColumnPhysicalNm] | date:\'yyyy-MM-dd HH:mm\'}}</span> <span ng-switch-when=50>{{$root.getCodeValue(vc.columnMap[liCol.ColumnPhysicalNm].CodeList, li[liCol.ColumnPhysicalNm])}}</span> <span ng-switch-when=60>{{$rootScope.getImageUrl(li[liCol.ColumnPhysicalNm]) | html}}</span> <span ng-switch-default class=onelinetext><button class=\"btn btn-notice btn-xs mr-2\" style=min-height:20px ng-if=\"liCol.ColumnPhysicalNm == \'Title\' && li.NoticeYN == \'Y\'\">공지</button> {{li[liCol.ColumnPhysicalAsNm] ? li[liCol.ColumnPhysicalAsNm] : li[liCol.ColumnPhysicalNm]}}</span></span></td></tr></tbody></table><div ng-if=\"vc.totalItems == 0\" class=\"text-center form-control\">{{ \'MSG.NO_DATA\' | translate }}</div><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=vc.setChangeViewSize() ng-model=vc.srch.viewSize ng-options=\"c for c in vc.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=vc.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=vc.setPageChanged() ng-model=vc.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=vc.totalItems uib-pagination boundary-links=true items-per-page=vc.viewSize max-size=vc.maxSize num-pages=vc.numPages rotate=false template-url=components/template/pagination.html></ul></div><span>개정된 정보통신망법 제50조 3항 영리목적의 광고성 정보 전송 제한을 준수하여 <strong style=\"color: red\">월~금(토,일 제외) 오전10시에 발송합니다.</strong></span></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/screen/screen-detail.html","<div class=\"page page-footable\" ng-controller=\"ScreenDetailCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>메뉴관리 {{ \'Menu.DETAIL\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.DETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><div class=row><div class=col-lg-6><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC01\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RoleId></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC02\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RoleNm></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC03\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.RegUserNm></div></div></div><div class=\"col-lg-6 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.EM630DC04\' | translate }}</label><div class=\"form-control txt_view\">{{vc.data.RegDate | date:\'yyyy-MM-dd\'}}</div></div></div><div class=\"col-lg-12 col-md-6\"><div class=\"form-group form-inline\"><label>{{ \'Menu.REMARKS\' | translate }}</label><div class=\"form-control txt_view\" ng-bind=vc.data.Remark></div></div></div></div></div></div></div></div><div class=row><!-- Action Buttons --><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-outline btn-default\" ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-outline btn-default\" ng-click=vc.goEdit()><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteData()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- /row --></div><!-- /page content --></div><div class=\"page page-footable\" ng-controller=\"ScreenDetailCtrl as vc\"><!-- page header --><div class=pageheader><!-- Page Title --><h2>메뉴관리</h2><!-- Navigation Bar --><div class=page-bar><ul class=page-breadcrumb><li><a ui-sref=app.dashboard><i class=\"fa fa-home\"></i> {{ \'Menu.SALEVIS\' | translate }}</a></li><li><a>{{ \'Menu.SYSTEM\' | translate }}</a></li><li><a ui-sref=app.system.screen-list>메뉴관리</a></li></ul></div></div><!-- /page header --><!-- page content --><div class=pagecontent><!-- row --><div class=row><!-- col --><div class=col-md-12><div class=tile><!-- tile header --><div class=\"tile-header dvd dvd-btm b-l5\"><h4 class=custom-font><strong>메뉴관리 {{ \'Menu.DETAIL\' | translate }}</strong></h4><div class=pull-right><a href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=tile-body><div class=row><div class=\"col-sm-12 text-right\"><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=app.system.screen-list()><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-success btn-ef btn-ef-7b mb-10 mr-5\" activate-button ui-sref=\"app.system.screen-edit({ScreenId:\'{{vc.data.ScreenId}}\'})\"><i class=\"fa fa-edit\"></i> {{ \'Menu.MODIFY\' | translate }}</button> <button class=\"btn btn-lightred btn-ef btn-ef-7b mb-10\" activate-button ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>아이디</label><input type=text class=form-control ng-model=vc.data.ScreenId ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>구분</label><input type=text class=form-control ng-model=vc.data.ModuleType ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>이름</label><input type=text class=form-control ng-model=vc.data.ScreenNm ng-required=true readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>페이지명</label><input type=text class=form-control ng-model=vc.data.PageFileNm ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>코드</label><input type=text class=form-control ng-model=vc.data.ScreenCd ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>메뉴구분</label><input type=text class=form-control ng-model=vc.data.ScreenType ng-required=true readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>등록일</label><input type=text class=form-control ng-model=vc.data.RegDate ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>등록자</label><input type=text class=form-control ng-model=vc.data.RegUserNm ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>수정일</label><input type=text class=form-control ng-model=vc.data.EdtDate ng-required=true readonly></div></div></div><div class=row><div class=col-lg-4><div class=form-group><label>수정자</label><input type=text class=form-control ng-model=vc.data.EdtUserNm ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>메뉴번호</label><input type=text class=form-control ng-model=vc.data.MenuNo ng-required=true readonly></div></div><div class=col-lg-4><div class=form-group><label>아이콘</label><input type=text class=form-control ng-model=vc.data.IconType ng-required=true readonly></div></div></div></div><!-- /tile-body --></div><!-- /title --></div><!-- /col --></div><!-- /row --></div><!-- /page content --></div>");
$templateCache.put("app/system/screen/screen-edit.html","<div class=\"page page-footable\" ng-controller=\"ScreenEditCtrl as vc\"><div class=dataloader ng-show=vc.dataloader></div><!-- page header --><div class=row ng-if=\"vc.layout == \'N\'\"><div class=col-lg-12><h3 class=page-header>메뉴관리 {{ \'Menu.ADD\' | translate }}/{{ \'Menu.EDIT\' | translate }}</h3></div><!-- /.col-lg-12 --></div><!-- /page header --><!-- page content --><div class=pagecontent file-dropzone><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong style=\"letter-spacing: 0.5px\" class=ng-binding>{{ \'Menu.EDITDETAILINFORMATION\' | translate }}</strong><div class=pull-right><a href=\"\" tile-control-toggle=\"\"><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><form id=form ng-submit=vc.setData()><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>화면명</label><input type=text class=form-control ng-model=vc.data.ScreenNm ng-required=true></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>페이지명</label><input type=text class=form-control ng-model=vc.data.PageUrl ng-required=true></div></div></div><div class=row><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>파라메터</label><input type=text class=form-control ng-model=vc.data.PageUrlParam></div></div><div class=\"col-lg-6 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>아이콘</label><input type=text class=form-control ng-model=vc.data.IconType></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>SQLMapper</label><input type=text class=form-control ng-model=vc.data.SqlId></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>허용파라메터</label><input type=text class=form-control ng-model=vc.data.ParamPass></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>거부파라메터</label><input type=text class=form-control ng-model=vc.data.ParamRefuse></div></div></div><div class=row><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button01 설명</label><input type=text class=form-control ng-model=vc.data.Btn01Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button02 설명</label><input type=text class=form-control ng-model=vc.data.Btn02Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button03 설명</label><input type=text class=form-control ng-model=vc.data.Btn03Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button04 설명</label><input type=text class=form-control ng-model=vc.data.Btn04Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button05 설명</label><input type=text class=form-control ng-model=vc.data.Btn05Text></div></div><div class=\"col-lg-4 col-md-6 col-sm-12 col-xs-12\"><div class=form-group><label>Button06 설명</label><input type=text class=form-control ng-model=vc.data.Btn06Text></div></div></div><div class=row><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=form-group><label>등록일</label><input type=text class=form-control value=\"{{vc.data.RegDate | date:\'yyyy-MM-dd h:mm a\':\'UTC\'}}\" readonly></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=form-group><label>등록자</label><input type=text class=form-control ng-model=vc.data.RegUserNm readonly></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=form-group><label>수정일</label><input type=text class=form-control value=\"{{vc.data.EdtDate | date:\'yyyy-MM-dd h:mm a\':\'UTC\'}}\" readonly></div></div><div class=\"col-lg-3 col-md-3 col-sm-6 col-xs-6\"><div class=form-group><label>수정자</label><input type=text class=form-control ng-model=vc.data.EdtUserNm readonly></div></div></div></form></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --><!-- Action Buttons --><div class=row><div class=\"col-lg-12 col-md-12 col-sm-12 col-xs-12 btn-bottom btn-group\"><div class=pull-right><button class=\"btn btn-default\" activate-button ng-click=vc.goList() ng-if=\"vc.layout == \'N\'\"><i class=\"fa fa-list\"></i> {{ \'Menu.LIST\' | translate }}</button> <button class=\"btn btn-primary\" activate-button ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'Menu.SAVE\' | translate }}</button> <button class=\"btn btn-danger\" ng-click=vc.deleteDetail()><i class=\"fa fa-trash-o\"></i> {{ \'Menu.DELETE\' | translate }}</button></div></div></div></div><!-- /page content --></div>");
$templateCache.put("app/system/screen/screen-list.html","<div class=\"page page-footable\" ng-controller=\"ScreenListCtrl as vc\"><!-- page header --><div class=row><div class=col-lg-12><div class=page-header>화면관리<div class=\"pull-right dock-header-tx list-split\"><span ng-click=\"vc.changeLayout(\'N\')\"><img src=assets/images/icon-sp-list.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'V\')\"><img src=assets/images/icon-sp-rl.png alt=\"\"></span><span ng-click=\"vc.changeLayout(\'H\')\"><img src=assets/images/icon-sp-tb.png alt=\"\"></span></div></div></div></div><!-- page content --><div class=row><div class=\"pagecontent fa-pane-wrap\" pane-wrap-anchor={{vc.anchor}}><div fa-pane=\"\" class=pane-root><div fa-pane fa-pane pane-anchor={{vc.anchor}} pane-handle=4 pane-max=\"80% + 2px\" pane-min={{vc.paneMin}} pane-size={{$root.gVariable.layoutBoardSize}}><div class=dataloader ng-show=vc.dataloader></div><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=vc.srch.ScreenNm placeholder=\"화면명 검색\" type=text><div class=\"search_layer mb-5\" onclick=\"return fnOpenLayer()\"><span class=cursor id=btn_layer_detail_search_open>상세<i class=\"fa fa-caret-down\"></i></span></div><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span><!-- 상세검색 창 --><div class=search-detail-wrap style=\"display: none\"><div class=\"panel panel-default\"><div class=panel-heading>상세검색 <button activate-button=\"\" class=\"btn btn-default mt-2 mr--2 pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i></button></div><div class=panel-body><div class=row><!-- 검색 대상 컬럼  --><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.ScreenNm type=text><label>{{ \'Menu.SCREENNAME\' | translate }}</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.PageUrl type=text><label>프로그램명</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><input class=\"form-control form-right\" ng-model=vc.srch.SqlId type=text><label>SQLMapper</label></div></div><!-- 사용자정의 컬럼 검색 대상 컬럼  --><udc-search meta-list=vc.listColumns meta-model=vc.srch></udc-search><!-- 검색 대상 컬럼  --></div><!-- /row --><div class=row><!-- 검색 버튼   --><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 mt-20 mb-10\"><button activate-button class=\"btn btn-info\" ng-click=vc.getSearch()><i class=\"glyphicon glyphicon-search\"></i> {{ :: \'Menu.SEARCH\' | translate }}</button> <button class=\"btn btn-default\" ng-click=vc.resetSearch()><i class=\"fa fa-refresh\"></i> {{ :: \'Menu.RESETSEARCH\' | translate }}</button> <button activate-button=\"\" class=\"btn btn-default ng-binding pull-right\" onclick=\"return fnCloseLayer()\"><i class=\"fa fa-times\"></i> {{ :: \'Menu.CLOSE\' | translate }}</button></div></div></div><!-- /panel-body --></div><!-- /panel --></div><!-- 상세검색 창 --></div><!-- /col --><!-- 버튼 그룹 --><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6\"><div class=pull-right></div></div><!-- 버튼 그룹 --></div><!-- 검색영역 --></form><!-- row --><div class=row><!-- col --><div class=col-md-12><!-- tile --><div class=\"panel panel-default tile\"><!-- tile header --><div class=\"panel-heading tile-header\"><strong>{{ :: \'Menu.EM630\' | translate }}</strong><div class=pull-right><a ng-href tile-control-toggle><i class=\"fa fa-minus fa-lg\"></i></a></div></div><!-- /tile header --><!-- tile body --><div class=\"panel-body collapse in\"><!-- Search Result --><table id=searchTextResults data-filter=#filter class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 width=100%><!-- Header --><thead><tr><th ng-click=\"vc.tablesort(\'X.ScreenNm\')\" data-toggle=true class=text-center>화면명 <span class=\"{{vc.sortClass(\'X.ScreenNm\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.PageUrl\')\" data-toggle=true class=text-center>프로그램명 <span class=\"{{vc.sortClass(\'X.PageUrl\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.PageUrlParam\')\" data-toggle=true class=text-center>파라메터 <span class=\"{{vc.sortClass(\'X.PageUrlParam\')}}\"></span></th><th ng-click=\"vc.tablesort(\'X.SqlId\')\" data-toggle=true class=text-center>SQLMapper <span class=\"{{vc.sortClass(\'X.SqlId\')}}\"></span></th></tr></thead><!-- /Header --><!-- Result Rows --><tr ng-repeat=\"li in vc.lists\" ng-click=vc.goEdit(li.ScreenId) style=\"cursor: pointer\" my-directive ng-class=\"{\'bg-lightyellow\':selectedRow == li.ScreenId}\"><!-- Result Items --><td><span ng-bind=li.ScreenNm></span></td><td><span ng-bind=li.PageUrl></span></td><td><span ng-bind=li.PageUrlParam></span></td><td><span ng-bind=li.SqlId></span></td></tr></table><div class=row><div class=\"col-xl-4 col-lg-4 col-md-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.srch.viewSize ng-change=vc.changeViewSize() ng-options=\"c for c in vc.listSize\" class=input-sm></select></div></div><!-- Paging Bar --><div class=\"col-xl-8 col-lg-8 col-md-8 col-sm-12 col-xs-12 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul uib-pagination name=pagination data-ng-if=vc.totalItems ng-model=vc.currentPage total-items=vc.totalItems previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" ng-change=vc.pageChanged() direction-links=true boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html rotate=false max-size=vc.maxSize items-per-page=vc.viewSize></ul></div></div></div></div><!-- /tile body --></div><!-- /tile --></div><!-- /col --></div><!-- /row --></div><div fa-pane pane-min=600px ng-if=\"vc.layout != \'N\'\" style=\"min-width: 600px\"><ui-view><div class=boardNothing><div class=inner><img src=assets/images/icon-write-line.svg alt=\"\" style=\"width: 70px; height:70px; text-align:center\"><p>목록에서 해당 제목을 선택하시면 내용을 보실 수 있습니다.</p></div></div></ui-view></div></div></div></div><!-- /page content --></div>");
$templateCache.put("components/modal/add-photo/addphoto-modal.html","<style>.vault-block{\r\n    margin: 0;\r\n    width: 100%;\r\n  }\r\n  .dhx-file-icon, .dhx-file-info{\r\n    display: none;\r\n  }\r\n  .dhx-file-title{\r\n    line-height: 30px;\r\n  }\r\n  .dxi-delete-forever:before {\r\n    color: #a8f !important;\r\n  }\r\n  \r\n  .vault.dhx_widget .dhx-file-item{\r\n    background-color: #aaaaaa;\r\n    margin: 5px;\r\n    border-radius: 5px;\r\n  }</style><div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header><h3>{{vc.title}}사진 첨부</h3></div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-5><div><label>{{vc.title}}명</label><input type=text class=form-control id=activityNm ng-model=vc.data.activityNm></div></div></div><div class=row><div class=col-lg-12><div class=\"drop_zone pagecontent\" file-dropzone><div class=row><div class=col-lg-12><div class=\"form-group form-inline\" ng-if=vc.showUploader><form id=form1 runat=server method=post enctype=Multipart/Form-Data><label>{{ \'Menu.ATTACHEDFILE\' | translate }}</label><div id={{vc.id}} class=vault-block vault-company></div></form></div></div></div></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/add-photo/image-extension-modal.html","<div class=modal-content style=\"text-align: center\"><img src={{link}} alt=\"\" style=\"width: 595px\"><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>닫기</button></div></div>");
$templateCache.put("components/biz-component/buttons/buttons.html","<div class=row><div class=col-lg-12><h1 class=page-header>Buttons</h1></div><!-- /.col-lg-12 --></div><!-- /.row --><div class=row><div class=col-lg-6><div class=\"panel panel-default\"><div class=panel-heading>Default Buttons</div><!-- /.panel-heading --><div class=panel-body><h4>Normal Buttons</h4><p><button type=button class=\"btn btn-default\">Default</button> <button type=button class=\"btn btn-primary\">Primary</button> <button type=button class=\"btn btn-success\">Success</button> <button type=button class=\"btn btn-info\">Info</button> <button type=button class=\"btn btn-warning\">Warning</button> <button type=button class=\"btn btn-danger\">Danger</button> <button type=button class=\"btn btn-link\">Link</button></p><br><h4>Disabled Buttons</h4><p><button type=button class=\"btn btn-default disabled\">Default</button> <button type=button class=\"btn btn-primary disabled\">Primary</button> <button type=button class=\"btn btn-success disabled\">Success</button> <button type=button class=\"btn btn-info disabled\">Info</button> <button type=button class=\"btn btn-warning disabled\">Warning</button> <button type=button class=\"btn btn-danger disabled\">Danger</button> <button type=button class=\"btn btn-link disabled\">Link</button></p><br><h4>Button Sizes</h4><p><button type=button class=\"btn btn-primary btn-lg\">Large button</button> <button type=button class=\"btn btn-primary\">Default button</button> <button type=button class=\"btn btn-primary btn-sm\">Small button</button> <button type=button class=\"btn btn-primary btn-xs\">Mini button</button><br><br><button type=button class=\"btn btn-primary btn-lg btn-block\">Block level button</button></p></div><!-- /.panel-body --></div><!-- /.panel --><div class=\"panel panel-default\"><div class=panel-heading>Circle Icon Buttons with Font Awesome Icons</div><!-- /.panel-heading --><div class=panel-body><h4>Normal Circle Buttons</h4><button type=button class=\"btn btn-default btn-circle\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-primary btn-circle\"><i class=\"fa fa-list\"></i></button> <button type=button class=\"btn btn-success btn-circle\"><i class=\"fa fa-link\"></i></button> <button type=button class=\"btn btn-info btn-circle\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-warning btn-circle\"><i class=\"fa fa-times\"></i></button> <button type=button class=\"btn btn-danger btn-circle\"><i class=\"fa fa-heart\"></i></button><br><br><h4>Large Circle Buttons</h4><button type=button class=\"btn btn-default btn-circle btn-lg\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-primary btn-circle btn-lg\"><i class=\"fa fa-list\"></i></button> <button type=button class=\"btn btn-success btn-circle btn-lg\"><i class=\"fa fa-link\"></i></button> <button type=button class=\"btn btn-info btn-circle btn-lg\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-warning btn-circle btn-lg\"><i class=\"fa fa-times\"></i></button> <button type=button class=\"btn btn-danger btn-circle btn-lg\"><i class=\"fa fa-heart\"></i></button><br><br><h4>Extra Large Circle Buttons</h4><button type=button class=\"btn btn-default btn-circle btn-xl\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-primary btn-circle btn-xl\"><i class=\"fa fa-list\"></i></button> <button type=button class=\"btn btn-success btn-circle btn-xl\"><i class=\"fa fa-link\"></i></button> <button type=button class=\"btn btn-info btn-circle btn-xl\"><i class=\"fa fa-check\"></i></button> <button type=button class=\"btn btn-warning btn-circle btn-xl\"><i class=\"fa fa-times\"></i></button> <button type=button class=\"btn btn-danger btn-circle btn-xl\"><i class=\"fa fa-heart\"></i></button></div><!-- /.panel-body --></div><!-- /.panel --></div><!-- /.col-lg-6 --><div class=col-lg-6><div class=\"panel panel-default\"><div class=panel-heading>Outline Buttons with Smooth Transition</div><!-- /.panel-heading --><div class=panel-body><h4>Outline Buttons</h4><p><button type=button class=\"btn btn-outline btn-default\">Default</button> <button type=button class=\"btn btn-outline btn-primary\">Primary</button> <button type=button class=\"btn btn-outline btn-success\">Success</button> <button type=button class=\"btn btn-outline btn-info\">Info</button> <button type=button class=\"btn btn-outline btn-warning\">Warning</button> <button type=button class=\"btn btn-outline btn-danger\">Danger</button> <button type=button class=\"btn btn-outline btn-link\">Link</button></p><br><h4>Outline Button Sizes</h4><p><button type=button class=\"btn btn-outline btn-primary btn-lg\">Large button</button> <button type=button class=\"btn btn-outline btn-primary\">Default button</button> <button type=button class=\"btn btn-outline btn-primary btn-sm\">Small button</button> <button type=button class=\"btn btn-outline btn-primary btn-xs\">Mini button</button><br><br><button type=button class=\"btn btn-outline btn-primary btn-lg btn-block\">Block level button</button></p></div><!-- /.panel-body --></div><!-- /.panel --><div class=\"panel panel-default\"><div class=panel-heading>Social Buttons with Font Awesome Icons</div><!-- /.panel-heading --><div class=panel-body><h4>Social Buttons</h4><a class=\"btn btn-block btn-social btn-bitbucket\"><i class=\"fa fa-bitbucket\"></i> Sign in with Bitbucket </a><a class=\"btn btn-block btn-social btn-dropbox\"><i class=\"fa fa-dropbox\"></i> Sign in with Dropbox </a><a class=\"btn btn-block btn-social btn-facebook\"><i class=\"fa fa-facebook\"></i> Sign in with Facebook </a><a class=\"btn btn-block btn-social btn-flickr\"><i class=\"fa fa-flickr\"></i> Sign in with Flickr </a><a class=\"btn btn-block btn-social btn-github\"><i class=\"fa fa-github\"></i> Sign in with GitHub </a><a class=\"btn btn-block btn-social btn-google-plus\"><i class=\"fa fa-google-plus\"></i> Sign in with Google </a><a class=\"btn btn-block btn-social btn-instagram\"><i class=\"fa fa-instagram\"></i> Sign in with Instagram </a><a class=\"btn btn-block btn-social btn-linkedin\"><i class=\"fa fa-linkedin\"></i> Sign in with LinkedIn </a><a class=\"btn btn-block btn-social btn-pinterest\"><i class=\"fa fa-pinterest\"></i> Sign in with Pinterest </a><a class=\"btn btn-block btn-social btn-tumblr\"><i class=\"fa fa-tumblr\"></i> Sign in with Tumblr </a><a class=\"btn btn-block btn-social btn-twitter\"><i class=\"fa fa-twitter\"></i> Sign in with Twitter </a><a class=\"btn btn-block btn-social btn-vk\"><i class=\"fa fa-vk\"></i> Sign in with VK</a><hr><div class=text-center><a class=\"btn btn-social-icon btn-bitbucket\"><i class=\"fa fa-bitbucket\"></i></a> <a class=\"btn btn-social-icon btn-dropbox\"><i class=\"fa fa-dropbox\"></i></a> <a class=\"btn btn-social-icon btn-facebook\"><i class=\"fa fa-facebook\"></i></a> <a class=\"btn btn-social-icon btn-flickr\"><i class=\"fa fa-flickr\"></i></a> <a class=\"btn btn-social-icon btn-github\"><i class=\"fa fa-github\"></i></a> <a class=\"btn btn-social-icon btn-google-plus\"><i class=\"fa fa-google-plus\"></i></a> <a class=\"btn btn-social-icon btn-instagram\"><i class=\"fa fa-instagram\"></i></a> <a class=\"btn btn-social-icon btn-linkedin\"><i class=\"fa fa-linkedin\"></i></a> <a class=\"btn btn-social-icon btn-pinterest\"><i class=\"fa fa-pinterest\"></i></a> <a class=\"btn btn-social-icon btn-tumblr\"><i class=\"fa fa-tumblr\"></i></a> <a class=\"btn btn-social-icon btn-twitter\"><i class=\"fa fa-twitter\"></i></a> <a class=\"btn btn-social-icon btn-vk\"><i class=\"fa fa-vk\"></i></a></div></div><!-- /.panel-body --></div><!-- /.panel --></div><!-- /.col-lg-6 --></div>");
$templateCache.put("components/modal/approval/approval-modal-view.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>{{modalCtrl.title}} 의견</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>의견 내용</label><textarea class=form-control ng-model=modalCtrl.data.StatusCn style=\"resize: none; height: 80px\"></textarea></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>저장</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/contents/contents-modal.html","<div class=\"modal-content faq-modal-content\" style=\"width: 100%; min-width: 320px; display: table; border-radius:6px\"><div class=\"modal-header ng-scope\" style=border-radius:6px><h3 class=page-header ng-if=modalCtrl.Title>{{modalCtrl.Title}}</h3><h3 class=page-header ng-if=!modalCtrl.Title>컨텐츠 미리보기</h3></div><div class=\"modal-body ng-scope faq-modal-body\"><div class=row><div class=col-lg-12 ng-if=modalCtrl.VideoLink><div class=form-group><iframe style=\"display:block; width:100%; height:auto; min-height:500px\" ng-src={{modalCtrl.VideoLink}} frameborder=0 allow=\"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture\" allowfullscreen></iframe></div></div><div class=col-lg-12><div class=form-control-no-border style=height:100%><table class=\"table table-hover table-striped no-footer\" width=100%><colgroup><col style=\"width: *\"><col style=\"width: 140px\"></colgroup><thead><tr><th><span>{{ \'Menu.FILENAME\' | translate }}</span></th><th><span>{{ \'Menu.FILESIZE\' | translate }}</span></th></tr></thead><tbody ng-repeat=\"fli in modalCtrl.FileList\"><tr id=filectl_{{fli.id}}><td><span class=file_list><a href={{fli.link}} target=attach>{{fli.fileName}}</a></span></td><td align=right><span class=file_size ng-bind=fli.size|filesize></span></td></tr></tbody></table></div></div><div class=col-lg-12><div class=form-group><span class=txt_view ng-bind-html=modalCtrl.Contents|htmlString style=\"overflow: auto; max-width:1000px; min-height: 100px\"></span></div></div></div><!-- //modal-body --></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div>");
$templateCache.put("components/modal/findIdPwd/findIdPwd-modal.html","<div class=modal-content><div class=dataloader ng-show=modalCtrl.dataloader></div><div class=\"modal-header ng-scope\"><h3 class=page-header ng-if=\"modalCtrl.type == \'IU\'\">아이디 찾기</h3><h3 class=page-header ng-if=\"modalCtrl.type == \'PU\'\">비밀번호 찾기</h3></div><ul class=\"nav nav-tabs\" ng-if=!modalCtrl.success><li class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" style=\"padding: 0\" ng-class=\"{\'active\': modalCtrl.findType == \'Phone\'}\"><a ng-click=\"changeFindType(\'Phone\')\" data-toggle=tab style=\"cursor: pointer; margin-right: 0\">휴대폰번호로 찾기</a></li><li class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" style=\"padding: 0\" ng-class=\"{\'active\': modalCtrl.findType == \'Email\'}\"><a ng-click=\"changeFindType(\'Email\')\" data-toggle=tab style=\"cursor: pointer\">이메일로 찾기</a></li></ul><div class=\"modal-body ng-scope\" ng-if=!modalCtrl.success><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\">이름</label><input type=text class=form-control ng-model=modalCtrl.UserNm maxlength=20 placeholder=이름></div></div></div><div class=row ng-if=\"modalCtrl.type == \'PU\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\">아이디</label><input type=text class=form-control ng-model=modalCtrl.LoginId maxlength=20 placeholder=아이디></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" ng-if=\"modalCtrl.findType == \'Phone\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\">휴대폰번호</label><input type=text class=form-control auto-hyphen ng-model=modalCtrl.Mobile maxlength=20 placeholder=휴대폰번호></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" ng-if=\"modalCtrl.findType == \'Email\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\">이메일</label><input type=text class=form-control ng-model=modalCtrl.Email maxlength=50 placeholder=이메일></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" style=\"padding-top: 6px; padding-left: 0px\"><button class=\"btn btn-primary\" ng-click=modalCtrl.auth()>인증번호 발송</button></div></div><div class=row ng-if=\"modalCtrl.type == \'IU\'\"><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" ng-if=\"modalCtrl.findType == \'Phone\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\">인증번호</label><input type=text class=form-control ng-model=modalCtrl.CetificationNum1 numbers-only maxlength=10 placeholder=인증번호 ng-disabled=\"modalCtrl.disabled1 == \'1\'\"></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\" ng-if=\"modalCtrl.findType == \'Email\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\">인증번호</label><input type=text class=form-control ng-model=modalCtrl.CetificationNum2 numbers-only maxlength=10 placeholder=인증번호 ng-disabled=\"modalCtrl.disabled2 == \'1\'\"></div></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6\"><div class=\"form-group form-inline\" style=\"padding-top: 3px\">* 인증번호 입력 후 다음을 선택해 주세요.</div></div></div><div class=row ng-if=\"modalCtrl.type == \'PU\'\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\" style=\"padding-top: 3px\">* 인증번호 발송 후 다음을 선택해 주세요.</div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.submit() ng-disabled=\"(modalCtrl.findType == \'Phone\' && modalCtrl.disabled1 == \'1\') || (modalCtrl.findType == \'Email\' && modalCtrl.disabled2 == \'1\')\"><i class=\"fa fa-check\"></i> 다음</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div><div class=\"modal-body ng-scope\" ng-if=modalCtrl.success><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"modalCtrl.type == \'IU\'\"><label>회원님의 아이디는 {{modalCtrl.data.LoginId}} 입니다.</label></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"modalCtrl.type == \'PU\'\"><label>* 휴대폰 또는 이메일로 수신된 인증번호를 입력 후 비밀번호를 변경해 주세요.</label></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"modalCtrl.type == \'PU\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\"><span class=e>*</span> 인증번호</label><input type=text class=form-control ng-model=modalCtrl.data.CetificationNum numbers-only maxlength=10 placeholder=인증번호></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"modalCtrl.type == \'PU\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\"><span class=e>*</span> 비밀번호</label><input type=password class=form-control maxlength=40 ng-model=modalCtrl.data.Password maxlength=20 placeholder=\"영문, 숫자, 특수문자 포함 8~20자 조합해 입력\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\" ng-if=\"modalCtrl.type == \'PU\'\"><div class=\"form-group form-inline\"><label style=\"padding-top: 3px\"><span class=e>*</span> 비밀번호 확인</label><input type=password class=form-control maxlength=40 ng-model=modalCtrl.data.RePassword maxlength=20 placeholder=\"비밀번호 확인\"><p class=\"desc not_pass\" ng-if=\"modalCtrl.data.RePassword != \'\' && modalCtrl.data.RePassword != null && modalCtrl.data.Password != modalCtrl.data.RePassword\"><i class=\"glyphicon glyphicon-remove\"></i> 비밀번호를 다시 확인해 주세요.</p><p class=\"desc pass\" ng-if=\"modalCtrl.data.RePassword != \'\' && modalCtrl.data.RePassword != null && modalCtrl.data.Password == modalCtrl.data.RePassword && modalCtrl.chkPassId(\'PWD\')\"><i class=\"glyphicon glyphicon-ok\"></i> 비밀번호가 일치합니다.</p><p class=\"desc not_pass\" ng-if=\"modalCtrl.data.RePassword != \'\' && modalCtrl.data.RePassword != null && modalCtrl.data.Password == modalCtrl.data.RePassword && !modalCtrl.chkPassId(\'PWD\')\"><i class=\"glyphicon glyphicon-remove\"></i> 비밀번호 형식을 확인해주세요.(영문, 숫자, 특수문자 포함 8~20자 조합해 입력)</p></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.submit2() ng-if=\"modalCtrl.type == \'PU\'\"><i class=\"fa fa-check\"></i> 확인</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div></div>");
$templateCache.put("components/modal/excel/upload-excel-user-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>{{ \'Menu.EXCEL\' | translate }} {{ \'Menu.FILE_UPLOAD\' | translate }}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-7><div class=\"form-group form-inline\"><label>{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}</label><input type=text class=form-control ng-model=vc.srch.TenantNm placeholder=\"{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}\"></div></div><div class=col-lg-5><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th></th><th>{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}</th><th>{{ \'Menu.PERSONINCHARGE\' | translate }}</th><th>{{ \'Menu.TEL\' | translate }}</th><th>{{ \'Menu.EMAIL\' | translate }}</th><th>{{ \'Menu.COMPANYSTATUS\' | translate }}</th><th>{{ \'Menu.JOINDATE\' | translate }}</th><th>{{ \'Menu.WITHDRAWALDATE\' | translate }}</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.tenantlists\" ng-click=vc.ok(li); style=\"cursor: pointer\"><td><i class=\"fa fa-check-square-o\" ng-show=\"li.TenantId == vc.selectedTenantId\" style=color:red></td><td><span ng-bind=li.TenantNm></span></td><td><span ng-bind=li.Contact></span></td><td><span ng-bind=li.TelNo></span></td><td><span ng-bind=li.Email></span></td><td><span ng-bind=li.TenantStatus></span></td><td><span ng-bind=li.JoinDate></span></td><td><span ng-bind=li.ExitDate></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/mypage/mypage-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>회원 정보 변경</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>성명</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.UserNm ng-if=\"modalCtrl.data.KeyId!= null && modalCtrl.data.KeyId != \'\'\" readonly></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>아이디</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.LoginId ng-if=\"modalCtrl.data.KeyId!= null && modalCtrl.data.KeyId != \'\'\" readonly></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>비밀번호</label><input type=password class=\"form-control form-right\" ng-model=modalCtrl.data.Password placeholder=\"영문, 숫자, 특수문자 포함 8~20자 조합해 입력\"><p class=\"desc not_match\" ng-if=\"modalCtrl.data.Password2 != null && modalCtrl.data.Password != modalCtrl.data.Password2\"><i class=\"glyphicon glyphicon-remove\"></i> 비밀번호를 다시 확인해 주세요.</p><p class=\"desc match\" ng-if=\"modalCtrl.data.Password2 != null && modalCtrl.data.Password == modalCtrl.data.Password2\"><i class=\"glyphicon glyphicon-ok\"></i> 비밀번호가 일치합니다.</p></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>비밀번호 확인</label><input type=password class=\"form-control form-right\" ng-model=modalCtrl.data.Password2 placeholder=\"영문, 숫자, 특수문자 포함 8~20자 조합해 입력\"></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>휴대폰 번호</label><input type=text class=\"form-control form-right\" auto-hyphen oninput=\"this.value = this.value.replace(/[^0-9.]/g, \'\').replace(/(\\..*)\\./g, \'$1\')\" ng-model=modalCtrl.data.Mobile required></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>E-mail</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.Email3 ng-readonly=\"modalCtrl.data.TenantStatus == \'R\'\"></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"modalCtrl.data.SmsAgreeYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=modalCtrl.data.SmsAgreeYN ng-true-value=\"\'Y\'\" type=checkbox>SMS 수신에 동의합니다</label></div></div><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"modalCtrl.data.EmailAgreeYN == \'Y\'\" ng-false-value=\"\'N\'\" ng-model=modalCtrl.data.EmailAgreeYN ng-true-value=\"\'Y\'\" type=checkbox>이메일 수신에 동의합니다</label></div></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.chkMobileEmailDup()><i class=\"fa fa-check\"></i>{{ \'수정\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/form-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>서식 {{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-5 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}</label><input type=text class=form-control ng-model=modalCtrl.FormNm placeholder=\"{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-4 col-md-4 col-lg-4 col-xl-4\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'FormType\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"modalCtrl.columnMap[\'FormType\'].CodeList\" code-model=modalCtrl.FormType is-disabled=false></common-code-custom></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getFormList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'FormNm\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'RegDate\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'RegUser\'].ColumnLogicalNm | translate }}</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.FormList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.FormNm></span></td><td class=text-center><span ng-bind=\"li.RegDate | date:\'yyyy-MM-dd\':\'UTC\'\"></span></td><td class=text-center><span ng-bind=li.RegUser></span></td></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getFormList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/group-edit-modal.html","<div class=\"modal-content wd80p\"><div class=\"modal-header ng-scope\"><h3 class=page-header>대상자 추가/수정</h3></div><form id=form1 name=form1><input type=hidden class=\"form-control form-right\" readonly><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>이름</label><input type=text class=\"form-control form-right\" ng-model=vc.data.CustNm maxlength=100></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-6 col-lg-6\"><div class=\"form-group form-inline\"><label>핸드폰</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Mobile maxlength=255></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"><div class=\"form-group form-inline\"><label>이메일</label><input type=text class=\"form-control form-right\" ng-model=vc.data.Email maxlength=255></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.setData()><i class=\"fa fa-check\"></i> 저장</button> <button class=\"btn btn-default mb-10\" ng-click=vc.closeWin()><i class=\"fa fa-times\"></i> 닫기</button></div></form></div>");
$templateCache.put("components/modal/message/sms-cust-send-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>문자발송</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"max-height:200px; overflow:auto\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>고객명</th><th class=text-center>핸드폰번호</th></tr><tr ng-repeat=\"li in modalCtrl.data.CustIdList\" style=\"cursor: pointer\"><td class=text-center>{{li.CustNm}}</td><td class=text-center>{{li.Mobile}}</td></tr></table><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getCustInfo() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><select class=form-control disabled><option value=\"\">SMS</option></select></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><select class=form-control ng-model=modalCtrl.data.CmpgnChannel ng-change=modalCtrl.chkSendType(vc.data.SmsType)><option value=\"\">-- 선택 --</option><option value=SMS>SMS(단문)</option><option value=LMS>MMS(장문)</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송번호</label><common-code-custom code-list=modalCtrl.sendNumberVerifyList code-model=modalCtrl.data.FromInfo is-disabled=false></common-code-custom></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>현재포인트</label><input type=text class=\"form-control form-right\" disabled ng-model=modalCtrl.tenantInfo.ServPoint></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>사용포인트</label><input type=text class=\"form-control form-right\" disabled ng-bind=modalCtrl.Point comma-bind></div></div><!--         <div class=\"col-lg-3\"> --><!--           <div class=\"form-group form-inline\"> --><!--             <label>현재잔액</label> --><!--             <input type=\"text\" class=\"form-control form-right\" disabled=\"disabled\" value=\"10,000\"> --><!--           </div> --><!--         </div> --></div><div ng-switch on=modalCtrl.data.CmpgnChannel><div ng-switch-when=LMS><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.SendTitle ng-required=true></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=modalCtrl.data.SendMessage ng-required=true ng-change=modalCtrl.chkSendMessage()></textarea><div class=text-right>[{{ modalCtrl.data.CmpgnChannel }}] {{ modalCtrl.messageLength }} / {{ modalCtrl.messageMaxLength }} bytes</div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"modalCtrl.addADTxtYN == \'Y\'\" ng-change=modalCtrl.chkADTxt() ng-false-value=\"\'N\'\" ng-model=modalCtrl.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox>광고문구 추가(최상단 삽입)</label></div></div><div class=\"form-group sm-mb0\" ng-if=\"vc.tenantInfo.SMSDenyNum == \'\'\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.addDenyTxtYN == \'Y\'\" ng-change=vc.chkDenyTxt() ng-false-value=\"\'N\'\" ng-model=vc.addDenyTxtYN ng-true-value=\"\'Y\'\" type=checkbox>수신거부문구 추가(최하단 삽입) - {{vc.tenantInfo.SMSDenyNum}}</label></div></div></div></div><div class=row style=margin-top:15px><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>항목</th><th class=text-center>치환문자</th></tr><tr><td class=text-center>고객명</td><td class=text-center>{CustNm}</td></tr><tr><td class=text-center>상품명</td><td class=text-center>{ProdNm}</td></tr><tr><td class=text-center>월</td><td class=text-center>{M}</td></tr><tr><td class=text-center>일</td><td class=text-center>{D}</td></tr><tr><td class=text-center>시</td><td class=text-center>{HH}}</td></tr><tr><td class=text-center>분</td><td class=text-center>{MM}</td></tr></table></div></div></form></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'전송\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/sms-expiration-gx-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>문자발송</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"max-height:200px; overflow:auto\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>고객명</th><th class=text-center>핸드폰번호</th></tr><tr ng-repeat=\"li in modalCtrl.data.CustIdList\" style=\"cursor: pointer\"><td class=text-center>{{li.CustNm}}</td><td class=text-center>{{li.Mobile}}</td></tr></table><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getCustInfo() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><select class=form-control disabled><option value=\"\">SMS</option></select></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><select class=form-control ng-model=modalCtrl.data.CmpgnChannel ng-change=modalCtrl.chkSendType(vc.data.SmsType)><option value=\"\">-- 선택 --</option><option value=SMS>SMS(단문)</option><option value=LMS>MMS(장문)</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송번호</label><common-code-custom code-list=modalCtrl.sendNumberVerifyList code-model=modalCtrl.data.FromInfo is-disabled=false></common-code-custom></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>현재포인트</label><input type=text class=\"form-control form-right\" disabled ng-model=modalCtrl.tenantInfo.ServPoint></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>사용포인트</label><input type=text class=\"form-control form-right\" disabled ng-bind=modalCtrl.Point comma-bind></div></div><!--         <div class=\"col-lg-3\"> --><!--           <div class=\"form-group form-inline\"> --><!--             <label>현재잔액</label> --><!--             <input type=\"text\" class=\"form-control form-right\" disabled=\"disabled\" value=\"10,000\"> --><!--           </div> --><!--         </div> --></div><div ng-switch on=modalCtrl.data.CmpgnChannel><div ng-switch-when=LMS><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.SendTitle ng-required=true></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=modalCtrl.data.SendMessage ng-required=true ng-change=modalCtrl.chkSendMessage()></textarea><div class=text-right>[{{ modalCtrl.data.CmpgnChannel }}] {{ modalCtrl.messageLength }} / {{ modalCtrl.messageMaxLength }} bytes</div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"modalCtrl.addADTxtYN == \'Y\'\" ng-change=modalCtrl.chkADTxt() ng-false-value=\"\'N\'\" ng-model=modalCtrl.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox>광고문구 추가(최상단 삽입)</label></div></div><div class=\"form-group sm-mb0\" ng-if=\"vc.tenantInfo.SMSDenyNum == \'\'\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.addDenyTxtYN == \'Y\'\" ng-change=vc.chkDenyTxt() ng-false-value=\"\'N\'\" ng-model=vc.addDenyTxtYN ng-true-value=\"\'Y\'\" type=checkbox>수신거부문구 추가(최하단 삽입) - {{vc.tenantInfo.SMSDenyNum}}</label></div></div></div></div><div class=row style=margin-top:15px><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>항목</th><th class=text-center>치환문자</th></tr><tr><td class=text-center>고객명</td><td class=text-center>{CustNm}</td></tr><tr><td class=text-center>상품명</td><td class=text-center>{ProdNm}</td></tr><tr><td class=text-center>월</td><td class=text-center>{M}</td></tr><tr><td class=text-center>일</td><td class=text-center>{D}</td></tr><tr><td class=text-center>시</td><td class=text-center>{HH}}</td></tr><tr><td class=text-center>분</td><td class=text-center>{MM}</td></tr></table></div></div></form></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'전송\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/sms-expiration-item-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>문자발송</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"max-height:200px; overflow:auto\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>고객명</th><th class=text-center>핸드폰번호</th></tr><tr ng-repeat=\"li in modalCtrl.data.CustIdList\" style=\"cursor: pointer\"><td class=text-center>{{li.CustNm}}</td><td class=text-center>{{li.Mobile}}</td></tr></table><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getCustInfo() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><select class=form-control disabled><option value=\"\">SMS</option></select></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><select class=form-control ng-model=modalCtrl.data.CmpgnChannel ng-change=modalCtrl.chkSendType(vc.data.SmsType)><option value=\"\">-- 선택 --</option><option value=SMS>SMS(단문)</option><option value=LMS>MMS(장문)</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송번호</label><common-code-custom code-list=modalCtrl.sendNumberVerifyList code-model=modalCtrl.data.FromInfo is-disabled=false></common-code-custom></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>현재포인트</label><input type=text class=\"form-control form-right\" disabled ng-model=modalCtrl.tenantInfo.ServPoint></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>사용포인트</label><input type=text class=\"form-control form-right\" disabled ng-bind=modalCtrl.Point comma-bind></div></div><!--         <div class=\"col-lg-3\"> --><!--           <div class=\"form-group form-inline\"> --><!--             <label>현재잔액</label> --><!--             <input type=\"text\" class=\"form-control form-right\" disabled=\"disabled\" value=\"10,000\"> --><!--           </div> --><!--         </div> --></div><div ng-switch on=modalCtrl.data.CmpgnChannel><div ng-switch-when=LMS><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.SendTitle ng-required=true></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=modalCtrl.data.SendMessage ng-required=true ng-change=modalCtrl.chkSendMessage()></textarea><div class=text-right>[{{ modalCtrl.data.CmpgnChannel }}] {{ modalCtrl.messageLength }} / {{ modalCtrl.messageMaxLength }} bytes</div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"modalCtrl.addADTxtYN == \'Y\'\" ng-change=modalCtrl.chkADTxt() ng-false-value=\"\'N\'\" ng-model=modalCtrl.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox>광고문구 추가(최상단 삽입)</label></div></div><div class=\"form-group sm-mb0\" ng-if=\"vc.tenantInfo.SMSDenyNum == \'\'\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.addDenyTxtYN == \'Y\'\" ng-change=vc.chkDenyTxt() ng-false-value=\"\'N\'\" ng-model=vc.addDenyTxtYN ng-true-value=\"\'Y\'\" type=checkbox>수신거부문구 추가(최하단 삽입) - {{vc.tenantInfo.SMSDenyNum}}</label></div></div></div></div><div class=row style=margin-top:15px><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>항목</th><th class=text-center>치환문자</th></tr><tr><td class=text-center>고객명</td><td class=text-center>{CustNm}</td></tr><tr><td class=text-center>상품명</td><td class=text-center>{ProdNm}</td></tr><tr><td class=text-center>월</td><td class=text-center>{M}</td></tr><tr><td class=text-center>일</td><td class=text-center>{D}</td></tr><tr><td class=text-center>시</td><td class=text-center>{HH}}</td></tr><tr><td class=text-center>분</td><td class=text-center>{MM}</td></tr></table></div></div></form></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'전송\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/sms-expiration-locker-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>문자발송</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"max-height:200px; overflow:auto\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>고객명</th><th class=text-center>핸드폰번호</th></tr><tr ng-repeat=\"li in modalCtrl.data.CustIdList\" style=\"cursor: pointer\"><td class=text-center>{{li.CustNm}}</td><td class=text-center>{{li.Mobile}}</td></tr></table><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getCustInfo() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><select class=form-control disabled><option value=\"\">SMS</option></select></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><select class=form-control ng-model=modalCtrl.data.CmpgnChannel ng-change=modalCtrl.chkSendType(vc.data.SmsType)><option value=\"\">-- 선택 --</option><option value=SMS>SMS(단문)</option><option value=LMS>MMS(장문)</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송번호</label><common-code-custom code-list=modalCtrl.sendNumberVerifyList code-model=modalCtrl.data.FromInfo is-disabled=false></common-code-custom></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>현재포인트</label><input type=text class=\"form-control form-right\" disabled ng-model=modalCtrl.tenantInfo.ServPoint></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>사용포인트</label><input type=text class=\"form-control form-right\" disabled ng-bind=modalCtrl.Point comma-bind></div></div><!--         <div class=\"col-lg-3\"> --><!--           <div class=\"form-group form-inline\"> --><!--             <label>현재잔액</label> --><!--             <input type=\"text\" class=\"form-control form-right\" disabled=\"disabled\" value=\"10,000\"> --><!--           </div> --><!--         </div> --></div><div ng-switch on=modalCtrl.data.CmpgnChannel><div ng-switch-when=LMS><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.SendTitle ng-required=true></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=modalCtrl.data.SendMessage ng-required=true ng-change=modalCtrl.chkSendMessage()></textarea><div class=text-right>[{{ modalCtrl.data.CmpgnChannel }}] {{ modalCtrl.messageLength }} / {{ modalCtrl.messageMaxLength }} bytes</div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"modalCtrl.addADTxtYN == \'Y\'\" ng-change=modalCtrl.chkADTxt() ng-false-value=\"\'N\'\" ng-model=modalCtrl.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox>광고문구 추가(최상단 삽입)</label></div></div><div class=\"form-group sm-mb0\" ng-if=\"vc.tenantInfo.SMSDenyNum == \'\'\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.addDenyTxtYN == \'Y\'\" ng-change=vc.chkDenyTxt() ng-false-value=\"\'N\'\" ng-model=vc.addDenyTxtYN ng-true-value=\"\'Y\'\" type=checkbox>수신거부문구 추가(최하단 삽입) - {{vc.tenantInfo.SMSDenyNum}}</label></div></div></div></div><div class=row style=margin-top:15px><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>항목</th><th class=text-center>치환문자</th></tr><tr><td class=text-center>고객명</td><td class=text-center>{CustNm}</td></tr><tr><td class=text-center>상품명</td><td class=text-center>{ProdNm}</td></tr><tr><td class=text-center>월</td><td class=text-center>{M}</td></tr><tr><td class=text-center>일</td><td class=text-center>{D}</td></tr><tr><td class=text-center>시</td><td class=text-center>{HH}}</td></tr><tr><td class=text-center>분</td><td class=text-center>{MM}</td></tr></table></div></div></form></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'전송\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/sms-expiration-membership-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>문자발송</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getFormList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\" style=\"max-height:200px; overflow:auto\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>고객명</th><th class=text-center>핸드폰번호</th></tr><tr ng-repeat=\"li in modalCtrl.data.CustIdList\" style=\"cursor: pointer\"><td class=text-center>{{li.CustNm}}</td><td class=text-center>{{li.Mobile}}</td></tr></table><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalItems total-items=modalCtrl.totalItems items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getCustInfo() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>발송채널</label><select class=form-control disabled><option value=\"\">SMS</option></select></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><select class=form-control ng-model=modalCtrl.data.CmpgnChannel ng-change=modalCtrl.chkSendType(vc.data.SmsType)><option value=\"\">-- 선택 --</option><option value=SMS>SMS(단문)</option><option value=LMS>MMS(장문)</option></select></div></div><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>발송번호</label><common-code-custom code-list=modalCtrl.sendNumberVerifyList code-model=modalCtrl.data.FromInfo is-disabled=false></common-code-custom></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>현재포인트</label><input type=text class=\"form-control form-right\" disabled ng-model=modalCtrl.tenantInfo.ServPoint></div></div><div class=\"col-xs-6 col-sm-6 col-md-6\"><div class=\"form-group form-inline\"><label>사용포인트</label><input type=text class=\"form-control form-right\" disabled ng-bind=modalCtrl.Point comma-bind></div></div><!--         <div class=\"col-lg-3\"> --><!--           <div class=\"form-group form-inline\"> --><!--             <label>현재잔액</label> --><!--             <input type=\"text\" class=\"form-control form-right\" disabled=\"disabled\" value=\"10,000\"> --><!--           </div> --><!--         </div> --></div><div ng-switch on=modalCtrl.data.CmpgnChannel><div ng-switch-when=LMS><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 제목</label><input type=text class=\"form-control form-right\" ng-model=modalCtrl.data.SendTitle ng-required=true></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group form-inline\"><label>메세지 내용</label><textarea id=strHtml rows=10 class=\"form-control form-right\" style=width:100% ng-model=modalCtrl.data.SendMessage ng-required=true ng-change=modalCtrl.chkSendMessage()></textarea><div class=text-right>[{{ modalCtrl.data.CmpgnChannel }}] {{ modalCtrl.messageLength }} / {{ modalCtrl.messageMaxLength }} bytes</div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12\"><div class=\"form-group sm-mb0\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"modalCtrl.addADTxtYN == \'Y\'\" ng-change=modalCtrl.chkADTxt() ng-false-value=\"\'N\'\" ng-model=modalCtrl.addADTxtYN ng-true-value=\"\'Y\'\" type=checkbox>광고문구 추가(최상단 삽입)</label></div></div><div class=\"form-group sm-mb0\" ng-if=\"vc.tenantInfo.SMSDenyNum == \'\'\"><label class=ng-binding></label><div class=checkbox><label class=ng-binding><input ng-checked-=\"vc.addDenyTxtYN == \'Y\'\" ng-change=vc.chkDenyTxt() ng-false-value=\"\'N\'\" ng-model=vc.addDenyTxtYN ng-true-value=\"\'Y\'\" type=checkbox>수신거부문구 추가(최하단 삽입) - {{vc.tenantInfo.SMSDenyNum}}</label></div></div></div></div><div class=row style=margin-top:15px><div class=\"col-xs-12 col-sm-12 col-md-12\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-page-size=100 id=searchTextResults width=100%><tr><th class=text-center>항목</th><th class=text-center>치환문자</th></tr><tr><td class=text-center>고객명</td><td class=text-center>{CustNm}</td></tr><tr><td class=text-center>상품명</td><td class=text-center>{ProdNm}</td></tr><tr><td class=text-center>월</td><td class=text-center>{M}</td></tr><tr><td class=text-center>일</td><td class=text-center>{D}</td></tr><tr><td class=text-center>시</td><td class=text-center>{HH}}</td></tr><tr><td class=text-center>분</td><td class=text-center>{MM}</td></tr></table></div></div></form></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'전송\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/srch-cust-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>수신자그룹 추가</div></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'vc.getSearch()\'}\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>회원구분</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\" title=전체><label class=custom-radio-btn title=전체><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=A ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">전체</span></label></div><div class=\"radio-inline ng-scope\" title=신규><label class=custom-radio-btn title=신규><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=N ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">신규</span></label></div><div class=\"radio-inline ng-scope\" title=유효><label class=custom-radio-btn title=유효><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=C ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">유효</span></label></div><div class=\"radio-inline ng-scope\" title=만기><label class=custom-radio-btn title=만기><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=E ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">만기</span></label></div><div class=\"radio-inline ng-scope\" title=락커만기><label class=custom-radio-btn title=락커만기><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=L ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">락커만기</span></label></div><div class=\"radio-inline ng-scope\" title=미수금><label class=custom-radio-btn title=미수금><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=R ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">미수금</span></label></div><div class=\"radio-inline ng-scope\" title=홀딩/연기><label class=custom-radio-btn title=홀딩/연기><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=H ng-model=modalCtrl.srch.memberType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">홀딩/연기</span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3\"><div class=\"form-group form-inner-label\"><input type=text class=form-control ng-model=modalCtrl.srch.CustCode placeholder=회원코드></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3\"><div class=\"form-group form-inner-label\"><input type=text class=form-control ng-model=modalCtrl.srch.CustNm placeholder=회원명></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=modalCtrl.manageList code-model=modalCtrl.srch.RegManage is-disabled=false></common-code-custom><label title=접수담당자>접수담당자</label></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-3 col-xl-3\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=modalCtrl.manageList code-model=modalCtrl.srch.Manager is-disabled=false></common-code-custom><label title=진행담당자>진행담당자</label></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inner-label\"><common-code-custom code-list=modalCtrl.mcl code-model=modalCtrl.srch.MCL is-disabled=false></common-code-custom><label title=수강권>수강권</label></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>회원권종류</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\" title=전체><label class=custom-radio-btn title=전체><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-valid-parse ng-touched\" type=radio ng-model=modalCtrl.srch.AttendanceType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">전체</span></label></div><div class=\"radio-inline ng-scope\" title=기간제><label class=custom-radio-btn title=기간제><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=T ng-model=modalCtrl.srch.AttendanceType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">기간제</span></label></div><div class=\"radio-inline ng-scope\" title=횟수제><label class=custom-radio-btn title=횟수제><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=F ng-model=modalCtrl.srch.AttendanceType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">횟수제</span></label></div><div class=\"radio-inline ng-scope\" title=GX><label class=custom-radio-btn title=GX><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=G ng-model=modalCtrl.srch.AttendanceType aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">GX</span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>성별</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\" title=전체><label class=custom-radio-btn title=전체><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio ng-model=modalCtrl.srch.Gender aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">전체</span></label></div><div class=\"radio-inline ng-scope\" title=남성><label class=custom-radio-btn title=남성><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=M ng-model=modalCtrl.srch.Gender aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">남성</span></label></div><div class=\"radio-inline ng-scope\" title=여성><label class=custom-radio-btn title=여성><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=F ng-model=modalCtrl.srch.Gender aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">여성</span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\"><div class=\"form-group form-inline\"><label>연령별</label><div class=\"input-group input-radio-custom-group\"><div class=\"radio-inline ng-scope\" title=전체><label class=custom-radio-btn title=전체><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">전체</span></label></div><div class=\"radio-inline ng-scope\" title=10대><label class=custom-radio-btn title=10대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=10 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">10대</span></label></div><div class=\"radio-inline ng-scope\" title=20대><label class=custom-radio-btn title=20대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=20 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">20대</span></label></div><div class=\"radio-inline ng-scope\" title=30대><label class=custom-radio-btn title=30대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=30 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">30대</span></label></div><div class=\"radio-inline ng-scope\" title=40대><label class=custom-radio-btn title=40대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=40 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">40대</span></label></div><div class=\"radio-inline ng-scope\" title=50대><label class=custom-radio-btn title=50대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=50 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">50대</span></label></div><div class=\"radio-inline ng-scope\" title=60대><label class=custom-radio-btn title=60대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=60 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">60대</span></label></div><div class=\"radio-inline ng-scope\" title=70대><label class=custom-radio-btn title=70대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=70 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">70대</span></label></div><div class=\"radio-inline ng-scope\" title=80대><label class=custom-radio-btn title=80대><input class=\"clr form-right ng-valid ng-not-empty ng-dirty ng-touched\" type=radio value=80 ng-model=modalCtrl.srch.Age aria-invalid=false> <span class=helping-el></span> <span class=\"label-text ng-binding\">80대</span></label></div></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inner-label\"><form-group class=form-inner-label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.ExpirdDate_Str = (modalCtrl.ExpirdDate_Str | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.ExpirdDate_Str ng-required=false placeholder=회원권만료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></form-group></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.ExpirdDate_End = (modalCtrl.ExpirdDate_End | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.ExpirdDate_End ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inner-label\"><form-group class=form-inner-label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.LockerDate_Str = (modalCtrl.LockerDate_Str | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.LockerDate_Str ng-required=false placeholder=락커만료일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></form-group></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.LockerDate_End = (modalCtrl.LockerDate_End | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.LockerDate_End ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inner-label\"><form-group class=form-inner-label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.PayDate_Str = (modalCtrl.PayDate_Str | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.PayDate_Str ng-required=false placeholder=결제일 type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></form-group></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\"><div class=\"form-group form-inner-label\"><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"modalCtrl.srch.PayDate_End = (modalCtrl.PayDate_End | date: \'yyyy-MM-dd\')\" ng-model=modalCtrl.PayDate_End ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\"> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div></div><!-- <div class=\"row\">\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n        <div class=\"form-group form-inner-label\">\r\n        <form-group class=\"form-inner-label\">\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                    current-text=\"오늘\"\r\n                    datepicker-options=\"dateOptions\"\r\n                    is-open=\"opened\"\r\n                    ng-change=\"modalCtrl.srch.SignDate_Str = (modalCtrl.SignDate_Str | date: \'yyyy-MM-dd\')\"\r\n                    ng-model=\"modalCtrl.SignDate_Str\"\r\n                    ng-required=\"false\" placeholder=\"최근방문일\" type=\"text\"\r\n                    uib-datepicker-popup=\"{{ :: format}}\"/>\r\n            <span class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </form-group>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n        <div class=\"form-group form-inner-label\">\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                    current-text=\"오늘\"\r\n                    datepicker-options=\"dateOptions\"\r\n                    is-open=\"opened\"\r\n                    ng-change=\"modalCtrl.srch.SignDate_End = (modalCtrl.SignDate_End | date: \'yyyy-MM-dd\')\"\r\n                    ng-model=\"modalCtrl.SignDate_End\"\r\n                    ng-required=\"false\" placeholder=\"\" type=\"text\"\r\n                    uib-datepicker-popup=\"{{ :: format}}\"/>\r\n            <span class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div> --><div class=row><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4\"><div class=\"form-group form-inner-label\"><input type=text class=form-control ng-model=modalCtrl.srch.TermCount placeholder=잔여횟수></div></div><div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4\"><div class=\"form-group form-inner-label\"><select class=form-control ng-model=modalCtrl.srch.TermCountType><option value=\"\">-- 선택 --</option><option value=U>이상</option><option value=D>이하</option></select></div></div></div><!-- 고객구분 및 고객등급 미사용으로 주석처리 2020-06-24 이기훈\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <common-code-custom code-list=\"modalCtrl.columnMap[\'SalesType\'].CodeList\"\r\n                              code-model=\"modalCtrl.srch.SalesType\"></common-code-custom>\r\n          <label>고객구분</label>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <common-code-custom code-list=\"modalCtrl.columnMap[\'CustGrade\'].CodeList\"\r\n                              code-model=\"modalCtrl.srch.CustGrade\"></common-code-custom>\r\n          <label>고객등급</label>\r\n        </div>\r\n      </div>\r\n    </div>--><!-- //row --><!-- <div class=\"row\">\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <label>생년월일</label>\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                    current-text=\"오늘\"\r\n                    datepicker-options=\"dateOptions\"\r\n                    is-open=\"opened\"\r\n                    ng-change=\"modalCtrl.srch.BirthDayFrom = (modalCtrl.BirthDayFrom | date: \'yyyy-MM-dd\')\"\r\n                    ng-model=\"modalCtrl.BirthDayFrom\"\r\n                    ng-required=\"false\" placeholder=\"yyyy-mm-dd\" type=\"text\"\r\n                    uib-datepicker-popup=\"{{ :: format}}\"/>\r\n            <span class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <label style=\"text-align:center;\">~</label>\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                    current-text=\"오늘\"\r\n                    datepicker-options=\"dateOptions\"\r\n                    is-open=\"opened\"\r\n                    ng-change=\"modalCtrl.srch.BirthDayTo = (modalCtrl.BirthDayTo | date: \'yyyy-MM-dd\')\"\r\n                    ng-model=\"modalCtrl.BirthDayTo\"\r\n                    ng-required=\"false\" placeholder=\"yyyy-mm-dd\" type=\"text\"\r\n                    uib-datepicker-popup=\"{{ :: format}}\"/>\r\n            <span class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div>\r\n\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <common-code-custom code-list=\"modalCtrl.columnMap[\'Gender\'].CodeList\"\r\n                              code-model=\"modalCtrl.srch.Gender\"></common-code-custom>\r\n          <label>성별</label>\r\n        </div>\r\n      </div>\r\n      \r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <common-code-custom code-list=\"modalCtrl.columnMap[\'AgeRange\'].CodeList\"\r\n                              code-model=\"modalCtrl.srch.AgeRange\"></common-code-custom>\r\n          <label>연령대</label>\r\n        </div>\r\n      </div>\r\n    </div>\r\n    <div class=\"row\">\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <label>등록시작일</label>\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                    current-text=\"오늘\"\r\n                    datepicker-options=\"dateOptions\"\r\n                    is-open=\"opened\"\r\n                    ng-change=\"modalCtrl.srch.CustRegDtFrom = (modalCtrl.CustRegDtFrom | date: \'yyyy-MM-dd\')\"\r\n                    ng-model=\"modalCtrl.CustRegDtFrom\"\r\n                    ng-required=\"false\" placeholder=\"yyyy-mm-dd\" type=\"text\"\r\n                    uib-datepicker-popup=\"{{ :: format}}\"/>\r\n            <span class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n      <div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-6\">\r\n        <div class=\"form-group form-inline\">\r\n          <label>등록종료일</label>\r\n          <div class=\"input-group\" ng-controller=\"DatepickerDemoCtrl\">\r\n            <input class=\"form-control\" clear-text=\"취소\" close-text=\"닫기\"\r\n                    current-text=\"오늘\"\r\n                    datepicker-options=\"dateOptions\"\r\n                    is-open=\"opened\"\r\n                    ng-change=\"modalCtrl.srch.CustRegDtTo = (modalCtrl.CustRegDtTo | date: \'yyyy-MM-dd\')\"\r\n                    ng-model=\"modalCtrl.CustRegDtTo\"\r\n                    ng-required=\"false\" placeholder=\"yyyy-mm-dd\" type=\"text\"\r\n                    uib-datepicker-popup=\"{{ :: format}}\"/>\r\n            <span class=\"input-group-btn\">\r\n              <button class=\"btn btn-default\" ng-click=\"open($event)\" type=\"button\">\r\n                <i class=\"glyphicon glyphicon-calendar\"></i>\r\n              </button>\r\n            </span>\r\n          </div>\r\n        </div>\r\n      </div>\r\n    </div> --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><span class=search-condition-str ng-bind-html=vc.SearchConditionStr></span></div><div class=\"col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6\"><div class=\"form-group pull-right\"><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getList()><i class=\"fa fa-search\"></i> 검색</button> <button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.setResetSearch()><i class=\"fa fa-refresh\"></i> 초기화</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 1%\"><input type=checkbox ng-model=modalCtrl.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none {{liCol.ListColumnShowLevel}}\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"modalCtrl.setSortColumn(\'T.\'+liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in modalCtrl.listColumns | filter: $root.listColumFilter\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class=\"{{modalCtrl.setSortDirect(\'T.\'+liCol.ColumnPhysicalNm)}}\" ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"modalCtrl.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=6>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.lists \"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=\"{{liCol.ListColumnTextAlign}} {{liCol.ListColumnShowLevel}} {{li.newItemClass}}\" ng-repeat=\"liCol in modalCtrl.listColumns | filter: $root.listColumFilter\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd\')}}</span> <span ng-if=\"liCol.ColumnPhysicalNm == \'UseYN\'\"><i class=\"fa fa-check-square-o\" ng-show=\"li[liCol.ColumnPhysicalNm] == \'Y\'\" style=color:red aria-hidden=false></i></span></td></tr></table></div></div></div><!-- /row --><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=modalCtrl.setChangeViewSize() ng-model=modalCtrl.srch.viewSize ng-options=\"c for c in modalCtrl.listSize\"></select></div></div><!-- Paging Bar --><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=modalCtrl.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=modalCtrl.setPageChanged() ng-model=modalCtrl.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=modalCtrl.totalItems uib-pagination boundary-links=true items-per-page=modalCtrl.viewSize max-size=modalCtrl.maxSize num-pages=modalCtrl.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-danger mb-10\" activate-button ng-click=\"modalCtrl.addGrpcust(\'\')\"><i class=\"fa fa-check\"></i> 선택회원추가</button> <button class=\"btn btn-danger mb-10\" activate-button ng-click=\"modalCtrl.addGrpcust(\'ALL\')\"><i class=\"fa fa-check\"></i> 전체회원추가(조회조건)</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/srch-cust-modal2.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>발송 대상자 편집</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12><div class=\"row pb-5\"><div class=\"col-lg-12 text-right\"><button class=\"btn btn-primary\" activate-button ng-click=modalCtrl.GroupCustEditModal()><i class=\"fa fa-user\"></i> 개별 입력 추가</button> <button class=\"btn btn-danger\" activate-button ng-click=\"modalCtrl.deleteGrpcust(\'\')\"><i class=\"fa fa-trash-o\"></i> 선택 제외</button> <button class=\"btn btn-danger\" activate-button ng-click=\"modalCtrl.deleteGrpcust(\'ALL\')\"><i class=\"fa fa-trash-o\"></i> 전체 제외</button></div></div><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=text-center style=\"vertical-align:middle; width: 3%\"><input type=checkbox ng-model=modalCtrl.chkHead ng-change=chkHeadChg()></th><th class=\"text-center none\" ng-repeat=\"liCol in modalCtrl.grpcustListColumns\">{{liCol.ColumnLogicalNm | translate }}</th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"modalCtrl.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan={{modalCtrl.grpcustListColumns.length+1}}>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"(liIndex, li) in modalCtrl.viewList\" style=\"cursor: pointer\"><!-- Result Items --><td class=text-center style=vertical-align:middle><input type=checkbox ng-model=li.chkRow ng-change=chkRowChg()></td><td class=text-center ng-repeat=\"liCol in modalCtrl.grpcustListColumns\" ng-click=\"modalCtrl.GroupCustEditModal(liIndex, li.SvyTgtId)\">{{li[liCol.ColumnPhysicalNm]}}</td></tr></table></div></div><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=modalCtrl.setChangeViewSize() ng-model=modalCtrl.srch.viewSize ng-options=\"c for c in modalCtrl.listSize\"></select></div></div><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=modalCtrl.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=modalCtrl.setPageChanged() ng-model=modalCtrl.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=modalCtrl.totalItems uib-pagination boundary-links=true items-per-page=modalCtrl.viewSize max-size=modalCtrl.maxSize num-pages=modalCtrl.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>확인</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/srch-cust-modal3.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>발송 대상자 조회</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-12 ui-keypress=\"{13:\'modalCtrl.getList()\'}\"><!-- 검색영역 --><div class=row><div class=\"col-xs-6 col-sm-6 col-md-6 col-xg-6 col-xl-6 sz-search mb-0\"><input class=mb5 ng-model=modalCtrl.srch.CustNm placeholder=\"회원명 검색\" type=text><div class=\"search_layer mb-5\" ng-click=modalCtrl.getList() style=\"width:45px !important\"><span class=cursor id=btn_layer_detail_search_open></span><i class=\"fa fa-search\"></i></div><span class=search-condition-str ng-bind-html=modalCtrl.SearchConditionStr></span></div></div><!-- Search Result --><table class=\"table table-striped table-bordered table-hover data_table table-custom\" data-filter=#filter data-page-size=100 id=searchTextResults width=100%><!-- Header --><thead><tr><th class=\"text-center none\" data-toggle=\"{{liCol.KeyColumnYN == \'Y\'? \'true\' : \'false\'}}\" ng-click=\"modalCtrl.setSortColumn(liCol.ColumnPhysicalNm, liCol.KeyColumnYN)\" ng-repeat=\"liCol in modalCtrl.listColumns\" style=\"width: {{liCol.ListColumnWidth}}\">{{ :: liCol.ColumnLogicalNm | translate }} <span class={{modalCtrl.setSortDirect(liCol.ColumnPhysicalNm)}} ng-show=\"liCol.KeyColumnYN == \'Y\'\"></span></th></tr></thead><!-- /Header --><!-- NO DATA --><tbody ng-if=\"modalCtrl.totalItems == 0\"><tr class=tbnodata><td class=text-center colspan=4>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><!-- Result Rows --><tr my-directive ng-repeat=\"li in modalCtrl.lists\" style=\"cursor: pointer\"><!-- Result Items --><td class={{liCol.ListColumnTextAlign}} ng-repeat=\"liCol in modalCtrl.listColumns\" style=\"max-width: 100px;overflow: hidden;text-overflow:ellipsis;white-space: nowrap\"><span ng-if=\"liCol.ColumnPhysicalNm != \'UseYN\'\">{{liCol.ColumnLogicalDataType != \'40\' ? (liCol.ColumnLogicalDataType == \'20\' ? (li[liCol.ColumnPhysicalNm] | number) : li[liCol.ColumnPhysicalNm]) : (li[liCol.ColumnPhysicalNm] | utcToLocal:\'yyyy-MM-dd HH:mm\')}}</span></td></tr></table></div></div><div class=row><div class=\"col-lg-4 col-sm-hidden col-xs-hidden paging_pad\"><div class=\"form-group form-inline select-size-list\"><label>{{ :: \'Menu.LIST\' | translate }}</label><select aria-controls=DataTables_Table_0 class=input-sm name=DataTables_Table_0_length ng-change=modalCtrl.setChangeViewSize() ng-model=modalCtrl.srch.viewSize ng-options=\"c for c in modalCtrl.listSize\"></select></div></div><div class=\"col-lg-8 paging_pad\"><div class=\"paging dataTables_paginate pull-right\"><ul data-ng-if=modalCtrl.totalItems direction-links=true first-text=\"{{\'BTN.PAGINATION.FIRST\'|translate}}\" last-text=\"{{\'BTN.PAGINATION.LAST\'|translate}}\" name=pagination next-text=\"{{\'BTN.PAGINATION.NEXT\'|translate}}\" ng-change=modalCtrl.setPageChanged() ng-model=modalCtrl.currentPage previous-text=\"{{\'BTN.PAGINATION.PREV\'|translate}}\" total-items=modalCtrl.totalItems uib-pagination boundary-links=true items-per-page=modalCtrl.viewSize max-size=modalCtrl.maxSize num-pages=modalCtrl.numPages rotate=false template-url=components/template/pagination.html></ul></div></div></div></div><div class=\"modal-footer ng-scope\"><button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CLOSE\' | translate }}</button></div></div>");
$templateCache.put("components/modal/message/tree-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>수신자 {{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><md-sidenav md-component-id=left md-is-locked-open=true style=min-height:600px><div class=panel-heading style=\"padding-left:15px; border-bottom: 1px solid #eee\">수신자그룹 목록</div><md-content layout-padding-sm ng-controller=mtSidenavLeftCtrl><abn-tree tree-data=my_data tree-control=my_tree on-select=my_tree_handler(branch) expand-level=1 select-text=vc.srch.GrpNm icon-leaf=\"fa fa-file-o\" icon-expand=\"fa fa-plus\" icon-collapse=\"fa fa-minus\"></abn-tree></md-content></md-sidenav></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/userRole/userrole-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>{{\'Menu.ROLE\' | translate}} {{\'Menu.SEARCH\' | translate}}</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-4><div class=form-group><select class=form-control name=searchFieldType id=searchFieldType ng-model=vc.searchFieldType ng-options=\"item[\'optionId\'] as item[\'optionName\'] for item in vc.searchFieldTypeList\" ng-init=vc.selSearchType></select></div></div><div class=col-lg-4><input type=text class=form-control ng-model=vc.searchValue placeholder=검색어></div><div class=col-lg-2><div class=pull-right><button class=\"btn btn-slategray btn-ef btn-ef-7b mb-10 mr-5\" activate-button=\"\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div><div class=col-lg-2><div class=pull-right><select name=DataTables_Table_0_length aria-controls=DataTables_Table_0 ng-model=vc.viewSizePerPage ng-change=vc.changeViewSize() ng-options=\"c for c in vc.viewSizePerPageList\" class=input-sm></select></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><md-contact-chips ng-model=vc.UserRoles md-contacts=vc.querySearch($query) md-contact-name=RoleNm md-contact-image=image md-contact-email=email md-require-match=true md-highlight-flags=i filter-selected=vc.filterSelected md-on-remove=vc.onRemoveChip($item) placeholder=역할></md-contact-chips><md-list class=fixedRows><md-subheader class=md-no-sticky>**추가할 역할을 선택하세요**</md-subheader><md-list-item class=contact-item ng-repeat=\"(index, role) in vc.data.list\" ng-if=!vc.IsRole(role) ng-click=vc.addRole(role.RoleId)><div class=\"md-list-item-text compact\" draggable=true>{{role.RoleNm}}</div></md-list-item></md-list></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/tenant/tenant-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><div class=page-header>회원사 검색</div></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>회원사명</label><input type=text class=form-control ng-model=vc.srch.TenantNm placeholder=\"{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}\"></div></div><div class=\"col-xs-12 col-sm-12 col-md-5 col-lg-5 col-xl-5\"><div class=\"form-group form-inline\"><label>법인대표자</label><input type=text class=form-control ng-model=vc.srch.Ceo placeholder=법인대표자></div></div><div class=\"col-xs-12 col-sm-12 col-md-2 col-lg-2 col-xl-2\" style=\"text-align: right\"><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th></th><th>회원사명</th><th>지역구분</th><th>법인대표자</th><th>전화번호</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.tenantlists\" ng-click=vc.ok(li); style=\"cursor: pointer\"><td><i class=\"fa fa-check-square-o\" ng-show=\"li.TenantId == vc.selectedTenantId\" style=color:red></td><td><span ng-bind=li.TenantNm></span></td><td><span ng-bind=li.Addr1></span></td><td><span ng-bind=li.Ceo></span></td><td><span ng-bind=li.TelNo></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/tenant/tenant2-modal-view.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>{{ \'Menu.MEMBERCOMPANY\' | translate }}{{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=col-lg-7><div class=\"form-group form-inline\"><label>{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}</label><input type=text class=form-control ng-model=vc.srch.TenantNm placeholder=\"{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}\"></div></div><div class=col-lg-5><div class=form-group><label>&nbsp;</label><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" style=margin-left:-24px ng-click=vc.getList()><i class=\"fa fa-search\"></i> 조회</button></div></div></div><!-- //row --><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><colgroup><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"><col width=\"\"></colgroup><thead><tr><th>{{ \'Menu.MEMBERCOMPANYNAME\' | translate }}</th><th>{{ \'Menu.PERSONINCHARGE\' | translate }}</th><th>{{ \'Menu.TEL\' | translate }}</th><th>{{ \'Menu.EMAIL\' | translate }}</th><th>{{ \'Menu.COMPANYSTATUS\' | translate }}</th><th>{{ \'Menu.JOINDATE\' | translate }}</th><th>{{ \'Menu.WITHDRAWALDATE\' | translate }}</th></tr></thead><tbody><!-- Result Rows --><tr ng-repeat=\"li in vc.tenantlists\" ng-click=vc.ok(li); style=\"cursor: pointer\"><td><span ng-bind=li.TenantNm></span></td><td><span ng-bind=li.Contact></span></td><td><span ng-bind=li.TelNo></span></td><td><span ng-bind=li.Email></span></td><td><span ng-bind=li.TenantStatus></span></td><td><span ng-bind=li.JoinDate></span></td><td><span ng-bind=li.ExitDate></span></td></tr></tbody></table></div></div></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=vc.totalItems total-items=vc.totalItems items-per-page=vc.srch.viewSize ng-model=vc.currentPage ng-change=vc.pageChanged() max-size=vc.maxSize boundary-links=true num-pages=vc.numPages template-url=components/template/pagination.html></ul></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=vc.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default btn-ef btn-ef-6 btn-ef-6a mb-10\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/modal/users/user-modal.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>담당자 {{ \'Menu.SEARCH\' | translate }}</h3></div><div class=\"modal-body ng-scope\"><form ui-keypress=\"{13:\'modalCtrl.getUserList()\'}\"><div class=row><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}</label><input type=text class=form-control ng-model=modalCtrl.LoginId placeholder=\"{{modalCtrl.columnMap[\'LoginId\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}</label><input type=text class=form-control ng-model=modalCtrl.UserNm placeholder=\"{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate}}\"></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>{{modalCtrl.columnMap[\'WorkStatus\'].ColumnLogicalNm | translate }}</label><common-code-custom code-list=\"modalCtrl.columnMap[\'WorkStatus\'].CodeList\" code-model=modalCtrl.WorkStatus></common-code-custom></div></div><div class=\"col-xs-12 col-sm-3 col-md-3 col-lg-3 col-xl-3\"><div class=\"form-group pull-right\"><button class=\"btn btn-default btn-ef btn-ef-1 btn-ef-1a\" ng-click=modalCtrl.getUserList()><i class=\"fa fa-search\"></i> 검색</button></div></div></div></form><div class=row><div class=col-lg-12><div class=\"panel panel-default\"><table id=searchTextResults data-filter=#filter data-page-size=10 class=\"table table-hover\"><!-- Header --><thead><tr><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'LoginId\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'UserNm\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'Mobile\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center ng-if=!modalCtrl.MobileYn>{{modalCtrl.columnMap[\'EntryDt\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center ng-if=!modalCtrl.MobileYn>{{modalCtrl.columnMap[\'WorkStyle\'].ColumnLogicalNm | translate }}</th><th data-toggle=true class=text-center>{{modalCtrl.columnMap[\'WorkStatus\'].ColumnLogicalNm | translate }}</th><!-- <th data-toggle=\"true\" class=\"text-center\" ng-if=\"!modalCtrl.MobileYn\">{{modalCtrl.columnMap[\'UserGrade\'].ColumnLogicalNm | translate }}</th> --></tr></thead><tbody ng-if=\"modalCtrl.totalCount == 0\"><tr class=tbnodata><td class=text-center colspan=6>{{ \'MSG.NO_DATA\' | translate }}</td></tr></tbody><tbody><!-- Result Rows --><tr ng-repeat=\"li in modalCtrl.UserList\" ng-click=modalCtrl.ok(li); style=\"cursor: pointer\"><td class=text-center><span ng-bind=li.LoginId></span></td><td class=text-center><span ng-bind=li.UserNm></span></td><td class=text-center><span ng-bind=li.Mobile></span></td><td class=text-center ng-if=!modalCtrl.MobileYn><span ng-bind=\"li.EntryDt | date:\'yyyy-MM-dd\':\'UTC\'\"></span></td><td class=text-center ng-if=!modalCtrl.MobileYn><span ng-bind=li.WorkStyle></span></td><td class=text-center><span ng-bind=li.WorkStatus></span></td><!-- <td class=\"text-center\" ng-if=\"!modalCtrl.MobileYn\"><span ng-bind=\"li.UserGrade\" ></span></td> --></tr></tbody></table></div><!-- /row --><div class=paging><ul uib-pagination data-ng-if=modalCtrl.totalCount total-items=modalCtrl.totalCount items-per-page=modalCtrl.viewSizePerPage ng-model=modalCtrl.currentPageNum ng-change=modalCtrl.getUserList() max-size=modalCtrl.maxSize boundary-links=true num-pages=modalCtrl.numPages template-url=components/template/pagination.html></ul></div></div></div></div><!-- //modal-body --><div class=\"modal-footer ng-scope\"><button class=\"btn btn-primary mb-10\" ng-click=modalCtrl.ok()><i class=\"fa fa-check\"></i>{{ \'Menu.CHOOSE\' | translate }}</button> <button class=\"btn btn-default mb-10\" ng-click=modalCtrl.cancel()><i class=\"fa fa-times\"></i>{{ \'Menu.CANCEL\' | translate }}</button></div></div>");
$templateCache.put("components/login/modal/login-view-modal.html","<div class=modal-content><div class=\"modal-body ng-scope\"><div class=n-login-box><a class=\"btn-example btn btn-outline btn-danger\" href=#Notice id=notice style=\"display: none\"></a><div class=box-top-deco><p class=deco-text>THEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODYTHEBODY</p></div><div class=n-login-body><form class=login_box id=login_box ng-submit=vm..doLogin()><div class=\"title mb-30\">THE BODY</div><div class=idpw-box-input style=\"margin-top: 45px\"><div class=id><input name=txtLoginID title=\"{{\'LOGIN.TITLE.INST_ID\'|translate}}\" type=text maxlength=20 id=txtLoginID class=form-control placeholder=\"{{\'LOGIN.LABEL.ID\'|translate}}\" style=\"ime-mode: inactive; margin-bottom: 10px\" ng-model=login.loginInfo.loginId ng-required=true></div><div class=pw><input name=txtPassword title=\"{{\'LOGIN.TITLE.I.n-login-bodyNST_PW\'|translate}}\" type=password maxlength=20 id=txtPassword class=form-control placeholder=\"{{\'LOGIN.LABEL.PW\'|translate}}\" ng-model=vm.loginInfo.loginPw ng-required=true></div></div><div class=idpw-text-box><div class=checkbox><input id=ckID type=checkbox name=ckID ng-checked=\"vm.loginInfo.saveId === \'1\'\" ng-model=vm.loginInfo.saveId ng-true-value=\"\'1\'\" ng-false-value=\"\'\'\" tabindex=3><label for=ckID>아이디 저장</label></div></div><div class=n-login-btn><button class=\"bts btn btn-lg btn-primary btn-block\" type=submit>Login</button></div><div class=mt-30><ul class=n-login-ui-find><li><span ng-click=\"vm.findIdPwd(\'id\')\">아이디 찾기</span></li><li><span ng-click=\"vm.findIdPwd(\'pwd\')\">비밀번호 찾기</span></li></ul></div></form></div></div></div></div>");
$templateCache.put("components/ui-component/factory/galert-factory.html","<md-dialog md-theme=default ng-class=dialog.css class=\"md-default-theme md-transition-in\" role=alertdialog tabindex=-1 aria-describedby=dialogContent_8 style=\"min-width: 350px\"><md-dialog-content class=md-dialog-content role=document tabindex=-1 id=dialogContent_8 style=text-align:center><img ng-src=assets/images/{{alertIco}}.png><div class=\"md-dialog-content-body ng-scope\" style=\"text-align: left;margin-top:25px\"><p class=ng-binding ng-bind-html=alertMessage></p></div></md-dialog-content><md-dialog-actions style=\"text-align: center; border-top:solid 1px #DDD\"><button class=\"md-primary md-button md-default-theme md-ink-ripple md-autofocus\" type=button ng-click=onClose() md-autofocus=true aria-label=\"Got it!\" style=\"margin: 0 auto; width:100%\"><span ng-bind=closeBtn style=\"color:#{{alertColor}}; font-size:15px; font-weight:800\"></span></button></md-dialog-actions></md-dialog>");
$templateCache.put("components/ui-component/factory/gconfirm-factory.html","<md-dialog class=\"md-default-theme md-transition-in\" role=dialog tabindex=-1 aria-describedby=dialogContent_9 style=\"min-width: 550px\"><md-dialog-content class=md-dialog-content role=document tabindex=-1 id=dialogContent_9 style=text-align:center><img ng-src=assets/images/{{alertIco}}.png><div class=\"md-dialog-content-body ng-scope\" style=\"text-align: left;margin-top:25px\"><p class=ng-binding ng-bind-html=alertMessage></p></div></md-dialog-content><md-dialog-actions style=\"text-align: center; border-top:solid 1px #DDD\"><button class=\"md-primary md-button md-default-theme md-ink-ripple\" type=button ng-click=onOk() md-autofocus=true style=width:50%><span class=\"ng-binding ng-scope\" ng-bind=okBtn style=\"color:#{{alertColor}}; font-size:15px; font-weight:800\"></span></button> <button class=\"md-primary md-button ng-scope md-default-theme md-ink-ripple\" type=button ng-click=onClose() style=width:50%><span class=\"ng-binding ng-scope\" ng-bind=closeBtn style=\"color:#333; font-size:15px; font-weight:800\"></span></button></md-dialog-actions></md-dialog>");
$templateCache.put("components/ui-component/factory/gselect-factory.html","<style>md-radio-button {\r\n    margin-bottom: 5px !important;\r\n  }</style><md-dialog class=\"md-default-theme md-transition-in\" role=dialog tabindex=-1 aria-describedby=dialogContent_9 style=\"min-width: 550px\"><md-dialog-content class=md-dialog-content role=document tabindex=-1 id=dialogContent_9 style=text-align:center><img ng-src=assets/images/{{alertIco}}.png><div class=\"md-dialog-content-body ng-scope\" style=\"text-align: left;margin-top:25px\"><p class=ng-binding ng-bind-html=alertMessage></p></div><md-radio-group ng-model=mode><md-radio-button ng-repeat=\"item in items\" ng-value=item.value aria-label={{item.label}} class=text-left><label>{{ item.label }}</label></md-radio-button></md-radio-group></md-dialog-content><md-dialog-actions style=\"text-align: center; border-top:solid 1px #DDD\"><button class=\"md-primary md-button md-default-theme md-ink-ripple\" type=button ng-click=onOk() md-autofocus=true style=width:50%><span class=\"ng-binding ng-scope\" ng-bind=okBtn style=\"color:#{{alertColor}}; font-size:15px; font-weight:800\"></span></button> <button class=\"md-primary md-button ng-scope md-default-theme md-ink-ripple\" type=button ng-click=onClose() style=width:50%><span class=\"ng-binding ng-scope\" ng-bind=closeBtn style=\"color:#333; font-size:15px; font-weight:800\"></span></button></md-dialog-actions></md-dialog>");
$templateCache.put("components/ui-component/timeline/timeline.html","<div class=panel-body><ul class=timeline><li><div class=timeline-badge><i class=\"fa fa-check\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4><p><small class=text-muted><i class=\"fa fa-clock-o\"></i> 11 hours ago via Twitter</small></p></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Libero laboriosam dolor perspiciatis omnis exercitationem. Beatae, officia pariatur? Est cum veniam excepturi. Maiores praesentium, porro voluptas suscipit facere rem dicta, debitis.</p></div></div></li><li class=timeline-inverted><div class=\"timeline-badge warning\"><i class=\"fa fa-credit-card\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Autem dolorem quibusdam, tenetur commodi provident cumque magni voluptatem libero, quis rerum. Fugiat esse debitis optio, tempore. Animi officiis alias, officia repellendus.</p><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium maiores odit qui est tempora eos, nostrum provident explicabo dignissimos debitis vel! Adipisci eius voluptates, ad aut recusandae minus eaque facere.</p></div></div></li><li><div class=\"timeline-badge danger\"><i class=\"fa fa-bomb\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Repellendus numquam facilis enim eaque, tenetur nam id qui vel velit similique nihil iure molestias aliquam, voluptatem totam quaerat, magni commodi quisquam.</p></div></div></li><li class=timeline-inverted><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Voluptates est quaerat asperiores sapiente, eligendi, nihil. Itaque quos, alias sapiente rerum quas odit! Aperiam officiis quidem delectus libero, omnis ut debitis!</p></div></div></li><li><div class=\"timeline-badge info\"><i class=\"fa fa-save\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nobis minus modi quam ipsum alias at est molestiae excepturi delectus nesciunt, quibusdam debitis amet, beatae consequuntur impedit nulla qui! Laborum, atque.</p><hr><div class=btn-group><button type=button class=\"btn btn-primary btn-sm dropdown-toggle\" data-toggle=dropdown><i class=\"fa fa-gear\"></i> <span class=caret></span></button><ul class=dropdown-menu role=menu><li><a href=#>Action</a></li><li><a href=#>Another action</a></li><li><a href=#>Something else here</a></li><li class=divider></li><li><a href=#>Separated link</a></li></ul></div></div></div></li><li><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sequi fuga odio quibusdam. Iure expedita, incidunt unde quis nam! Quod, quisquam. Officia quam qui adipisci quas consequuntur nostrum sequi. Consequuntur, commodi.</p></div></div></li><li class=timeline-inverted><div class=\"timeline-badge success\"><i class=\"fa fa-graduation-cap\"></i></div><div class=timeline-panel><div class=timeline-heading><h4 class=timeline-title>Lorem ipsum dolor</h4></div><div class=timeline-body><p>Lorem ipsum dolor sit amet, consectetur adipisicing elit. Deserunt obcaecati, quaerat tempore officia voluptas debitis consectetur culpa amet, accusamus dolorum fugiat, animi dicta aperiam, enim incidunt quisquam maxime neque eaque.</p></div></div></li></ul></div>");
$templateCache.put("scripts/directives/common-code/common-code.html","<select class=form-control id=selectCombo ng-change=ccCtrl.onChangeHandler() name=selectCombo ng-model=ccCtrl.data ng-options=\"opt.CodeValue for opt in ccCtrl.list track by opt.Code\" ng-disabled=ccCtrl.isDisabled style=min-width:100px ng-required=ccCtrl.isRequired><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select>");
$templateCache.put("scripts/directives/common-code-custom/common-code-custom.html","<select class=form-control name=selectCombo ng-change=ccCtrl.onChangeHandler() ng-model=ccCtrl.codeModel ng-options=\"opt.Code as opt.CodeValue for opt in ccCtrl.list\" style=min-width:100px ng-disabled=ccCtrl.isDisabled><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select>");
$templateCache.put("scripts/directives/common-code-search/common-code-search.html","<select class=form-control name=selectCombo ng-change=ccCtrl.onChangeHandler() ng-model=ccCtrl.codeModel ng-options=\"opt.Code as opt.CodeValue for opt in ccCtrl.list\" ng-disabled=ccCtrl.isDisabled><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select>");
$templateCache.put("scripts/directives/common-code-tree/common-code-food.html","<div class=\"form-group form-inner-label pull-left mt-0 mr-10\"><select ng-disabled=\"ccCtrl.list[0].length == 0\" class=form-control id=selectCombo ng-change=ccCtrl.onChangeHandler(0) name=selectCombo ng-model=ccCtrl.CommonCode[0] ng-options=\"opt.CodeValue for opt in ccCtrl.list[0] track by opt.Code\" ng-disabled=ccCtrl.isDisabled style=min-width:150px><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select></div><div class=\"form-group form-inner-label pull-left mt-0\"><select ng-disabled=\"ccCtrl.list[1].length == 0\" class=form-control id=selectCombo ng-change=ccCtrl.onChangeHandler(1) name=selectCombo ng-model=ccCtrl.CommonCode[1] ng-options=\"opt.CodeValue for opt in ccCtrl.list[1] track by opt.Code\" ng-disabled=ccCtrl.isDisabled style=min-width:150px><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select></div>");
$templateCache.put("scripts/directives/common-code-tree/common-code-project.html","<span style=float:left ng-if=\"ccCtrl.preventChanging === false\"><select class=form-control id=selectCombo ng-change=ccCtrl.onChangeHandlerYear() name=selectCombo ng-model=ccCtrl.prmYear ng-options=\"opt.Code as opt.CodeValue for opt in ccCtrl.listYear\" ng-disabled=ccCtrl.isDisabled style=min-width:150px><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select></span><span style=float:left ng-if=\"ccCtrl.preventChanging === false\"><select class=\"form-control ml-5\" id=selectCombo ng-change=ccCtrl.onChangeHandlerId() name=selectCombo ng-model=ccCtrl.prmId ng-options=\"opt.PrmId as opt.PrmNm for opt in ccCtrl.listPrm\" ng-disabled=ccCtrl.isDisabled style=min-width:150px><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select></span><span ng-if=\"ccCtrl.preventChanging === true\">{{ccCtrl.data.PrmYear}} {{ccCtrl.data.PrmNm}} </span>");
$templateCache.put("scripts/directives/common-code-tree/common-code-tree.html","<div class=\"form-group form-inner-label\"><span style=float:left ng-repeat=\"li in ccCtrl.CodeLevel\"><select ng-disabled=\"ccCtrl.list[$index].length == 0\" class=form-control id=selectCombo ng-change=ccCtrl.onChangeHandler($index) name=selectCombo ng-model=ccCtrl.CommonCode[$index] ng-options=\"opt.CodeValue for opt in ccCtrl.list[$index] track by opt.Code\" ng-disabled=ccCtrl.isDisabled ng-required=ccCtrl.isRequired style=min-width:150px><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select></span></div>");
$templateCache.put("scripts/directives/common-code-signup/common-code-signup.html","<select class=form-control id=selectCombo ng-change=ccCtrl.onChangeHandler() name=selectCombo ng-model=ccCtrl.data ng-options=\"opt.CodeValue for opt in ccCtrl.list track by opt.Code\" ng-disabled=ccCtrl.isDisabled style=\"min-width:100px; width: {{ccCtrl.selectWidth}}px\"><option value=\"\">--{{ ccCtrl.chooseMessage | translate }}--</option></select>");
$templateCache.put("scripts/directives/search-condition/search-condition.html","<span class=search-condition-str><b>검색결과 <font color=red>{{ccCtrl.countStr}}</font>건</b> {{ccCtrl.searchConditionStr}}</span>");
$templateCache.put("scripts/directives/select-data-group/select-data-group.html","<span class=data-group-str ng-click=ccCtrl.changeDatagroup()><b>:::: 데이터그룹 <font color=red>{{ccCtrl.DatagroupNm}}</font> &gt; 작업명 <font color=red>{{ccCtrl.ActionNm}}</font> <i class=\"fa fa-search\"></i></b></span>");
$templateCache.put("scripts/directives/sortable-container/sortable-container.html","<style>.left-context, .right-context {\r\n    padding-top:5px;\r\n  }\r\n  \r\n  .left-context .panel-body{\r\n    background:#e7edf3;\r\n  }\r\n  .left-context .panel-default {\r\n    margin-top:0px;\r\n    margin-bottom:0px;\r\n  }\r\n  .left-context .no-style {padding:0px; border:none;}\r\n  .as-sortable-item {\r\n    -ms-touch-action: none;\r\n    touch-action: none;\r\n    /* to disable context menu on iOS devices */\r\n    -webkit-touch-callout: none;\r\n    /* margin-top: 2px; */\r\n    position:relative;\r\n  }\r\n  .as-sortable-item, .as-sortable-placeholder {\r\n      display: block;\r\n  }\r\n  .as-sortable-item-text {\r\n      -ms-touch-action: none;\r\n      touch-action: none;\r\n      /* to disable context menu on iOS devices */\r\n      -webkit-touch-callout: none;\r\n      position:relative;\r\n      border: solid 1px #c5cdd7;\r\n      padding : 6px 0px 6px 6px;\r\n  }\r\n  .as-sortable-item-handle {\r\n      cursor: move;\r\n      cursor: -webkit-grab;\r\n      cursor: -moz-grab;\r\n  }\r\n  .subTextmenu {\r\n    position: absolute;\r\n    right: 7px;\r\n    top: 7px;\r\n    font-size: 12px;\r\n    color : #bdbdbd;\r\n    display: none;\r\n  }\r\n  .subTextmenu span:hover {\r\n    color: #378AD8\r\n  }\r\n  .as-sortable-placeholder {}\r\n  .as-sortable-drag {\r\n      position: absolute;\r\n      pointer-events: none;\r\n      z-index: 9999;\r\n  }\r\n  .as-sortable-hidden {\r\n      display: none !important;\r\n  }\r\n  .as-sortable-un-selectable {\r\n      -webkit-touch-callout: none;\r\n      -webkit-user-select: none;\r\n      -khtml-user-select: none;\r\n      -moz-user-select: none;\r\n      -ms-user-select: none;\r\n      user-select: none;\r\n  }\r\n  .left-context *:focus {\r\n      outline: none;\r\n  }\r\n  #sortableOptions1 {\r\n    padding:5px;\r\n  }\r\n  .edit-layout {\r\n    display: none;\r\n    position:relative;\r\n    border: solid 1px #c5cdd7;\r\n    padding : 4px 0px 4px 15px;\r\n  }\r\n  .edit-layout input {\r\n    width: 100%;\r\n    padding : 4px 0px 4px 3px;\r\n    border : solid 1px #d8d8d8;\r\n  }\r\n  .edit-layout input:focus {\r\n    border : solid 1px #64aef8;\r\n  }\r\n  .edit-layout .subBtnWrap {\r\n    position:absolute;\r\n    right : 3px;\r\n    top : 9px;\r\n  }\r\n  .edit-layout .subBtnWrap span {\r\n    color : #999;\r\n    border: solid 1px #ccc;\r\n    padding:5px 10px 5px 10px;\r\n  }\r\n  .edit-layout .subBtnWrap span.okBtn {\r\n    border: solid 1px #EC5621;\r\n    background : #EC5621;\r\n    color : #FFF;\r\n  }\r\n  .edit-layout .subBtnWrap span.disable {\r\n    color : #ccc;\r\n    border: solid 1px #eee;\r\n    background : #EEE;\r\n  }\r\n  \r\n  .importantHidden {display: none !important;}\r\n  \r\n  #iconWrap .active { color :#0000FF; -webkit-tap-highlight-color: rgba(255, 255, 255, 0)}\r\n  \r\n  .disable-master {\r\n    background:#c9c9c9 !important;\r\n    color :#999;\r\n  }\r\n  \r\n  .right-context .panel {box-shadow: none; margin-bottom: 1px;}\r\n  \r\n  .depth-two {display: none;}\r\n  .depth-three {display: none;}\r\n  \r\n  \r\n  .right-panel-fixed-size-top {\r\n    position:fixed;\r\n    top: 60px;\r\n    padding-right:15px !important;\r\n  }\r\n  \r\n  .right-panel-fixed-size-bottom {\r\n    position:fixed;\r\n    bottom: 0px;\r\n    padding-right:15px !important;\r\n    bottom:0px;\r\n  }\r\n  \r\n  .visible-use-group {\r\n    background:#FFF  !important;\r\n  }\r\n  .visible-group {\r\n    /* background:#c6e2ff  !important; */\r\n  }\r\n  \r\n  .visible-group .as-sortable-item-text {\r\n    background:#c6e2ff  !important;\r\n    display: block;\r\n  }\r\n  \r\n  .invisible-group {\r\n    display: none !important;\r\n  }\r\n  \r\n  .visible {\r\n    display:block;\r\n  }\r\n  \r\n  #mapperWrap input {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #roleTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  #conditionsTable input[type=text] {\r\n    border: solid 1px #d8d8d8;\r\n    padding : 3px 8px;\r\n    width: 100%;\r\n  }\r\n  \r\n  .menu-name-tx {\r\n    cursor: pointer;\r\n    display: block;\r\n    position: absolute;\r\n    top: 5px;\r\n    left: 30px;\r\n    width: calc(100% - 145px);\r\n    word-break: break-all;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n  .depth-three i {cursor:pointer;}\r\n  \r\n  .noti-pre {\r\n    border:solid 1px #EEE;\r\n    margin-top:8px;\r\n    background:#EEE;\r\n    padding: 8px;\r\n  }\r\n  \r\n  .noti-pre span {\r\n    display:block;\r\n  }\r\n\r\n  .sortable-root-scope {\r\n    border:solid 1px#EEE;\r\n  }\r\n  \r\n  .root-add-top .subTextmenu {\r\n    display: block !important;\r\n  }</style><script>var offset = $(\".sortable-root-scope\").offset();\r\n  var height = $(document).height() - offset.top - 15;\r\n  $(\".sortable-root-scope\").css(\"min-height\", height);</script><div class=sortableContainer><div class=dataloader ng-show=vc.dataloader></div><!-- as-sortable : is-disabled=\"true\" --><div class=\"sortable-row sortable-root-scope col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12\" style=\"padding: 0 3px; background:#f7f7f7; border:solid 1px #CCC\" as-sortable=scVc.sortableOptions ng-model=scVc.bindData><div class=root-add-top style=background:#FFF ng-mouseover=\"scVc.showSubMenu(\'menutreeTopSubMenu\')\" ng-mouseleave=\"scVc.hiddenSubMenu(\'menutreeTopSubMenu\')\"><div is-disabled=false class=as-sortable-item-text>{{ scVc.rootTitle }}<div class=subTextmenu style=\"color:#378adb; top:7px\" id=menutreeTopSubMenu><div><span ng-click=\"scVc.addChild(0,\'menutreeTopSubMenu\')\">추가</span></div></div></div></div><!-- Start Menu Tree --><div ng-repeat=\"item in scVc.bindData\" as-sortable-item=scVc.sortableOptions style=\"padding:0px; border:none; margin-left:15px\" class={{item.extendGroupClass}}><!-- 1 dpeth --><div as-sortable-item-handle=\"\"><div class=\"as-sortable-item-text {{item.disableClass}} depth-one\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item.tempId)\" menu-sort={{item.Sort}} menu-sortpath={{item.SortPath}} ng-if=\"item.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item.tempId }}\"><i class=\"fa fa-fw fa-angle-down extend-btn\" ng-if=\"item.child.length > 0\" ng-click=\"scVc.extendMenu(\'atMenu_\' + item.tempId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item.child.length == 0\"></i> <i class=\"fa fa-fw {{ item.icon }}\"></i> <span class=menu-name-tx>{{item.ItemNm}}</span><div class=subTextmenu id=subMenu_{{item.tempId}} menu-sort={{item.Sort}} menu-sortpath={{item.sortPath}}><div><span ng-if=\"item.UseYN == \'\' || item.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(1, item)\" style=color:#496887>활성 | </span><span ng-if=\"item.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(1, item)\" style=color:#496887>비활성 | </span><span ng-click=\"scVc.addChild(1, item.tempId)\" ng-if=\"scVc.maxDepth > 1\" style=color:#496887>추가 |</span> <span ng-click=\"scVc.delChild(1, item)\" style=color:#496887>삭제</span></div></div></div></div><!-- /1 dpeth --><!-- 2 dpeth --><div class=sortable-row as-sortable=scVc.sortableOptions ng-model=item.child style=margin-left:15px><!-- 3 dpeth --><div ng-repeat=\"item2 in item.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF><div class=\"as-sortable-item-text {{item2.disableClass}} depth-two\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item2) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item2.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item2.tempId)\" menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}} ng-if=\"item2.DelYN!=\'Y\'\" id=\"{{\'atMenu_\' + item2.tempId }}\"><i class=\"fa fa-fw fa-angle-down extend-btn\" ng-if=\"item2.child.length > 0\" ng-click=\"scVc.extendMenu(\'atMenu_\' + item2.tempId)\"></i> <i class=\"fa fa-fw\" ng-if=\"item2.child.length == 0\"></i> <i class=\"fa fa-fw {{ item2.icon }}\"></i> <span class=menu-name-tx>{{item2.ItemNm}}</span><div class=subTextmenu id=subMenu_{{item2.tempId}} menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}}><div><span ng-if=\"item2.UseYN == \'\' || item2.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(2, item2)\" style=color:#496887>활성 | </span><span ng-if=\"item2.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(2, item2)\" style=color:#496887>비활성 | </span><span ng-click=\"scVc.addChild(2, item2.tempId)\" ng-if=\"scVc.maxDepth > 2\" style=color:#496887>추가</span> | <span ng-click=\"scVc.delChild(2, item2)\" style=color:#496887>삭제</span></div></div></div></div><div class=sortable-row as-sortable=scVc.sortableOptions ng-model=item2.child style=margin-left:30px><div ng-repeat=\"item3 in item2.child\" as-sortable-item=\"\" class=no-style><div as-sortable-item-handle=\"\" style=background:#FFF ng-click=scVc.setCtrlDetailView(item3) ng-mouseover=\"scVc.showSubMenu(\'subMenu_\'+item3.tempId)\" ng-mouseleave=\"scVc.hiddenSubMenu(\'subMenu_\'+item3.tempId)\" menu-sort={{item3.Sort}} menu-sortpath={{item3.sortPath}} ng-if=\"item3.DelYN!=\'Y\'\"><div class=\"as-sortable-item-text {{item3.disableClass}} depth-three\" id=\"{{\'atMenu_\' + item3.tempId }}\"><i class=\"fa fa-fw {{ item3.icon }}\"></i> <span class=menu-name-tx>{{item3.ItemNm}}</span><div class=subTextmenu id=subMenu_{{item3.tempId}} menu-sort={{item3.Sort}} menu-sortpath={{item3.sortPath}}><div><span ng-if=\"item3.UseYN == \'\' || item3.UseYN == \'N\'\" ng-click=\"scVc.setAtListEnable(3, item3)\" style=color:#496887>활성 | </span><span ng-if=\"item3.UseYN == \'Y\'\" ng-click=\"scVc.setAtListEnable(3, item3)\" style=color:#496887>비활성 | </span><span ng-click=\"scVc.delChild(3, item3)\" style=color:#496887>삭제</span></div></div></div></div></div><div><div class=edit-layout style=background:#FFF id=editor{{item2.tempId}} menu-path={{item2.path}} menu-sort={{item2.Sort}} menu-sortpath={{item2.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth03title input-enter=\"scVc.addMenuItem(3, \'editor{{item2.tempId}}\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(3, \'editor\'+item2.tempId)\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(3, \'editor\'+item2.tempId)\">취소</span></div><div style=clear:both></div></div></div></div></div><!-- /3 dpeth --><div><div class=edit-layout style=background:#FFF id=editor{{item.tempId}} menu-path={{item.path}} menu-sort={{item.Sort}} menu-sortpath={{item.sortPath}}><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth02title input-enter=\"scVc.addMenuItem(2, \'editor{{item.tempId}}\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(2, \'editor\'+item.tempId)\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(2, \'editor\'+item.tempId)\">취소</span></div><div style=clear:both></div></div></div></div><!-- /2 dpeth --></div><div><div class=edit-layout style=\"background:#FFF; margin-left:15px\" id=editorDepth01><div class=\"col-xs-8 col-sm-8 col-md-5 col-lg-6 col-xl-7\" style=padding-left:0px><input type=text ng-focus=focusCallback($event) ng-change=scVc.menuTitleChange() ng-model=scVc.depth01title input-enter=\"scVc.addMenuItem(1, \'editorDepth01\')\"></div><div class=\"subBtnWrap col-xs-4 col-sm-4 col-md-7 col-lg-6 col-xl-5 tx-right\"><span class=\"okBtn disable\" ng-click=\"scVc.addMenuItem(1, \'editorDepth01\')\">확인</span> <span class=cancelBtn ng-click=\"scVc.cancelMenuItem(1, \'editorDepth01\')\">취소</span></div><div style=clear:both></div></div></div></div></div>");
$templateCache.put("scripts/directives/udc/udc-detail.html","<div ng-repeat=\"li in vc.metaList\" class={{li.EditColumnWidth}} ng-if=\"li.CustomColumnYN == \'Y\'\"><div class=\"form-group form-inline\"><label title=\"{{ li.ColumnLogicalNm }}\">{{ li.ColumnLogicalNm }}</label><div class=\"form-control txt_view\" ng-switch=li.ColumnLogicalDataType><span ng-switch-when=40>{{vc.metaModel[li.ColumnPhysicalNm] | date:\'yyyy-MM-dd\'}}</span> <span ng-switch-when=50>{{vc.getCodeValue(li.ColumnPhysicalNm)}}</span> <span ng-switch-when=60><i class=\"fa {{vc.metaModel[li.ColumnPhysicalNm]}}\" aria-hidden=true></i></span> <span ng-switch-default>{{vc.metaModel[li.ColumnPhysicalAsNm] ? vc.metaModel[li.ColumnPhysicalAsNm] : vc.metaModel[li.ColumnPhysicalNm]}}</span></div></div></div>");
$templateCache.put("scripts/directives/udc/udc-edit.html","<div ng-repeat=\"li in vc.metaList\" class={{li.EditColumnWidth}} ng-if=\"li.CustomColumnYN == \'Y\'\"><div class=\"form-group form-inline\"><label title=\"{{ li.ColumnLogicalNm }}\">{{ li.ColumnLogicalNm }}</label><input ng-if=\"li.ColumnLogicalDataType == \'10\'\" type=text class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.metaModel[li.ColumnPhysicalNm]> <input ng-if=\"li.ColumnLogicalDataType == \'20\'\" type=number class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.metaModel[li.ColumnPhysicalNm]><div ng-if=\"li.ColumnLogicalDataType == \'40\'\" class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-init=\"vc.RegDate[$index] = $root.getDate(vc.metaModel[li.ColumnPhysicalNm])\" ng-model=vc.RegDate[$index] ng-change=\"vc.onDateChanged(li.ColumnPhysicalNm, $index);\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><common-code-custom ng-if=\"li.ColumnLogicalDataType == \'50\'\" code-list=li.CodeList code-model=vc.metaModel[li.ColumnPhysicalNm] callback=vc.onModelChanged></common-code-custom></div></div>");
$templateCache.put("scripts/directives/udc/udc-search.html","<div ng-repeat=\"li in vc.metaList\" class=\"col-lg-4 col-md-4 col-sm-8 col-xs-8\" ng-if=\"li.CustomColumnYN == \'Y\'\"><div class=\"form-group form-inner-label\"><input ng-if=\"li.ColumnLogicalDataType == \'10\'\" type=text class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.metaModel[li.ColumnPhysicalNm]> <input ng-if=\"li.ColumnLogicalDataType == \'20\'\" type=number class=\"form-control form-right\" ng-change=vc.onModelChanged() ng-model=vc.metaModel[li.ColumnPhysicalNm]><div ng-if=\"li.ColumnLogicalDataType == \'40\'\" class=input-group ng-controller=DatepickerDemoCtrl><input type=text class=form-control uib-datepicker-popup=\"{{ :: format}}\" ng-init=\"vc.RegDate[$index] = $root.getDate(vc.metaModel[li.ColumnPhysicalNm])\" ng-model=vc.RegDate[$index] ng-change=\"vc.onDateChanged(li.ColumnPhysicalNm, $index);\" is-open=opened datepicker-options=dateOptions ng-required=false current-text=오늘 clear-text=취소 close-text=닫기> <span class=input-group-btn><button type=button class=\"btn btn-default\" ng-click=open($event)><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div><common-code-custom ng-if=\"li.ColumnLogicalDataType == \'50\'\" code-list=li.CodeList code-model=vc.metaModel[li.ColumnPhysicalNm] callback=vc.onModelChanged></common-code-custom><label title=\"{{ li.ColumnLogicalNm }}\">{{ li.ColumnLogicalNm }}</label></div></div>");
$templateCache.put("scripts/file-attach/directive/file-attach.html","<div class=form-right><table class=\"table b-a b-solid bg-white\"><thead><tr><th width=50%>Name</th><th>Size</th><th>Progress</th><th>Status</th><th>Actions</th></tr></thead><tbody><tr id=filectl_{{obj.id}} ng-repeat=\"obj in faCtrl.fileData\" ng-if=!obj.delStatus><td><span ng-show=!obj.isLoaded class=file_list ng-bind=obj.fileName></span> <a href={{obj.link}} target=attach ng-show=obj.isLoaded><span class=file_list ng-bind=obj.fileName></span></a></td><td align=right><span class=file_size ng-bind=obj.size|filesize></span></td><td><div class=\"progress progress-xs\" style=\"margin-bottom: 0px;height:10px\"><div class=\"progress-bar progress-bar-primary\" style=\"width: 0%\"></div></div></td><td></td><td align=center><a href=\"\" ng-click=faCtrl.onDelete(obj)><span ng-show=\"obj.delState == \'\'\"><i class=icon-trash></i> {{ \'Menu.DELETE\' | translate }}</span><span ng-show=\"obj.delState == \'delete\'\"><i class=icon-refresh></i> {{ \'Menu.CANCEL\' | translate }}</span></a></td></tr></tbody></table><div tabindex=500 class=\"btn btn-info btn-file pull-right\" ng-click=faCtrl.openDilalog()><i class=icon-file-plus></i>{{ \'Menu.ATTACHMENT\' | translate }}</div><input id=file-5 style=\"display: none\" class=file type=file multiple data-preview-file-type=any data-upload-url=# placeholder=\"\"></div>");
$templateCache.put("app/personal/user/modal/userscareer-modal-view.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>경력사항 등록</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"from-group col-xs-3 col-sm-3 col-md-3 col-xg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>입사일자</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.TermStartDate = (vc.TermStartDate | date: \'yyyy-MM-dd\')\" ng-model=vc.TermStartDate ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"from-group col-xs-3 col-sm-3 col-md-3 col-xg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>퇴사일자</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.TermEndDate = (vc.TermEndDate | date: \'yyyy-MM-dd\')\" ng-model=vc.TermEndDate ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-5\"><div class=\"form-group form-inline\"><label>근무처</label><input type=text class=form-control ng-model=vc.data.Company></div></div><div class=\"col-xs-col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-5\"><div class=\"form-group form-inline\"><label>직급</label><input type=text class=form-control ng-model=vc.data.JobTitle></div></div></div><div class=\"row ng-scope\" ng-if=vc.checkSave style=\"text-align: right; margin-top:8px\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><button activate-button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'저장\' | translate }}</button> <button activate-button class=\"btn btn-default\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div><div class=\"row ng-scope\" ng-if=vc.checkEdit style=\"text-align: right; margin-top:8px\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><button activate-button class=\"btn btn-primary\" ng-click=vc.editData() ng-if=!vc.enableSystemYn><i class=\"fa fa-save\"></i> {{ \'수정\' | translate }}</button> <button activate-button class=\"btn btn-default\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div></div></div>");
$templateCache.put("app/personal/user/modal/userseduhistory-modal-view.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>학력사항 등록</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-5\"><div class=\"form-group form-inline\"><label>학교구분</label><select class=form-control ng-model=vc.data.Degree><option value=\"\" selected disabled hidden>-- 선택 --</option><option value=고등학교>고등학교</option><option value=대학(2,3년)>대학(2,3년)</option><option value=대학교(4년)>대학교(4년)</option><option value=대학원>대학원</option></select></div></div><div class=\"col-xs-col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-5\"><div class=\"form-group form-inline\"><label>학교명</label><input type=text class=form-control ng-model=vc.data.SchoolNm></div></div><div class=\"col-xs-col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-5\"><div class=\"form-group form-inline\"><label>소재지</label><select class=form-control ng-model=vc.data.Location><option value=\"\" selected disabled hidden>-- 선택 --</option><option value=서울>서울</option><option value=경기>경기</option><option value=광주>광주</option><option value=대구>대구</option><option value=대전>대전</option><option value=부산>부산</option><option value=울산>울산</option><option value=인천>인천</option><option value=강원>강원</option><option value=경남>경남</option><option value=경북>경북</option><option value=전남>전남</option><option value=전북>전북</option><option value=충북>충북</option><option value=충남>충남</option><option value=충남>충남</option><option value=제주>제주</option><option value=세종>세종</option><option value=아시아·중동>아시아·중동</option><option value=북·중미>북·중미</option><option value=남미>남미</option><option value=유럽>유럽</option><option value=오세아니아>오세아니아</option><option value=아프리카>아프리카</option><option value=남극대륙>남극대륙</option><option value=기타해외>기타해외</option></select></div></div><div class=\"col-xs-col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-5\"><div class=\"form-group form-inline\"><label>전공명</label><input type=text class=form-control ng-model=vc.data.MajorNm></div></div></div><div class=row><div class=\"from-group col-xs-3 col-sm-3 col-md-3 col-xg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>입학년월</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.AdmissionDate = (vc.AdmissionDate | date: \'yyyy-MM-dd\')\" ng-model=vc.AdmissionDate ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"from-group col-xs-3 col-sm-3 col-md-3 col-xg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>졸업년월</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.GraduatedDate = (vc.GraduatedDate | date: \'yyyy-MM-dd\')\" ng-model=vc.GraduatedDate ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"from-group col-xs-3 col-sm-3 col-md-3 col-xg-3 col-xl-3\"><div class=\"form-group form-inline\"><label>졸업상태</label><select class=form-control ng-model=vc.data.Status><option value=\"\" selected disabled hidden>-- 선택 --</option><option value=졸업>졸업</option><option value=재학중>재학중</option><option value=중퇴>중퇴</option><option value=수료>수료</option><option value=휴학>휴학</option></select><div></div></div><div class=\"row ng-scope\" ng-if=vc.checkSave style=\"text-align: right; margin-top:8px\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><button activate-button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'저장\' | translate }}</button> <button activate-button class=\"btn btn-default\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div><div class=\"row ng-scope\" ng-if=vc.checkEdit style=\"text-align: right; margin-top:8px\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><button activate-button class=\"btn btn-primary\" ng-click=vc.editData() ng-if=!vc.enableSystemYn><i class=\"fa fa-save\"></i> {{ \'수정\' | translate }}</button> <button activate-button class=\"btn btn-default\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div></div></div></div></div>");
$templateCache.put("app/personal/user/modal/usersquali-modal-view.html","<div class=modal-content><div class=\"modal-header ng-scope\"><h3 class=page-header>자격사항 등록</h3></div><div class=\"modal-body ng-scope\"><div class=row><div class=\"col-xs-col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-5\"><div class=\"form-group form-inline\"><label>자격증명</label><input type=text class=form-control ng-model=vc.data.LicenseNm></div></div><div class=\"col-xs-col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-5\"><div class=\"form-group form-inline\"><label>자격번호</label><input type=text class=form-control ng-model=vc.data.LicenseNo></div></div><div class=\"col-xs-col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-5\"><div class=\"form-group form-inline\"><label>취득일</label><div class=input-group ng-controller=DatepickerDemoCtrl><input class=form-control clear-text=취소 close-text=닫기 current-text=오늘 datepicker-options=dateOptions is-open=opened ng-change=\"vc.data.QualiDate = (vc.QualiDate | date: \'yyyy-MM-dd\')\" ng-model=vc.QualiDate ng-required=false placeholder=\"\" type=text uib-datepicker-popup=\"{{ :: format}}\" readonly> <span class=input-group-btn><button class=\"btn btn-default\" ng-click=open($event) type=button><i class=\"glyphicon glyphicon-calendar\"></i></button></span></div></div></div><div class=\"col-xs-col-sm-3 col-md-3 col-lg-3 col-xl-3 mt-5\"><div class=\"form-group form-inline\"><label>발행처</label><input type=text class=form-control ng-model=vc.data.LicenseOffice></div></div></div><div class=\"row ng-scope\" ng-if=vc.checkSave style=\"text-align: right; margin-top:8px\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><button activate-button class=\"btn btn-primary\" ng-click=vc.setData()><i class=\"fa fa-save\"></i> {{ \'저장\' | translate }}</button> <button activate-button class=\"btn btn-default\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div><div class=\"row ng-scope\" ng-if=vc.checkEdit style=\"text-align: right; margin-top:8px\"><div class=\"col-xs-12 col-sm-12 col-md-12 col-xg-12 col-xl-12\"><button activate-button class=\"btn btn-primary\" ng-click=vc.editData() ng-if=!vc.enableSystemYn><i class=\"fa fa-save\"></i> {{ \'수정\' | translate }}</button> <button activate-button class=\"btn btn-default\" ng-click=vc.cancel()><i class=\"fa fa-times\"></i> 닫기</button></div></div></div></div>");
$templateCache.put("components/ui-component/layout/header/header.html","<nav class=\"navbar navbar-default navbar-static-top\" role=navigation style=\"margin-bottom: 0\"><div class=navbar-header><!-- <button type=\"button\" class=\"navbar-toggle\" data-toggle=\"collapse\" data-target=\".navbar-collapse\"> --><div class=\"navbar-toggle sz-custom-navbar-toggle\"><a href=\"\"><i class=\"fa fa-outdent\"></i></a></div><div class=sz-custom-select-tenant><section class=tile fullscreen=isFullscreen06><div class=\"form-group dp_none__560\" ng-if=header.checkUse><div class=\"input-group custom-search-form\"><input type=text readonly class=form-control ng-model=header.TENANTNAME ng-click=header.srchTenantModal();> <input type=hidden ng-model=header.TENANTID> <span class=input-group-btn><button class=\"btn btn-default\" type=button ng-click=header.srchTenantModal();><i class=\"fa fa-search\"></i></button> <button class=\"btn btn-default\" type=button ng-click=header.eraseTenant();><i class=\"fa fa-eraser\"></i></button></span></div></div></section></div><!-- <a class=\"navbar-brand\" href=\"/#/app/dashboard\">{{\'PRODUCT.COMPANY\'|translate}}</a> --> <a class=navbar-brand href=/#/app/dashboard>{{header.headerTitle}}</a><div style=clear:both></div><header-notification></header-notification></div><!-- /.navbar-header --></nav>");
$templateCache.put("components/ui-component/layout/sidebar/sidebar.html","<div class=\"navbar-default sidebar side_wrapper\" role=navigation id=navigationListWrap data-mcs-theme=light-thick><div class=\"sidebar-nav navbar-collapse\"><ul class=\"nav in\" id=side-menu><li ng-repeat=\"item in sidebar.menuList\" ng-class=\"{active: sidebar.collapseVar==item.idx}\"><a ui-sref={{item.pageUrl}}{{item.pageUrlParam}} ui-sref-opts=\"{reload:\'{{item.pageUrl}}\'}\" ng-if=\"item.child.length == 0\" ng-click=sidebar.check(item.idx)><i class=\"fa {{item.icon}} fa-fw\"></i> <span class=menuTx>{{item.name}}</span> </a><a ng-if=\"item.child.length > 0\" ng-click=sidebar.check(item.idx) ui-sref=\"{{item.child[0].pageUrl}}{{ item.child[0].pageUrlParam }}\" ui-sref-opts=\"{reload:\'{{item.child[0].pageUrl}}\'}\"><i class=\"fa {{item.icon}} fa-fw\"></i> <span class=menuTx>{{item.name}}</span> <span class=\"fa arrow\"></span></a><ul ng-if=\"item.child.length > 0\" class=\"nav nav-second-level\" uib-collapse=\"sidebar.collapseVar!={{item.idx}}\"><li ng-repeat=\"item2 in item.child\" ng-class=\"{active: sidebar.secondCollapseVar==item2.idx}\"><a ui-sref=\"{{item2.pageUrl}}{{ item2.pageUrlParam }}\" ui-sref-opts=\"{reload:\'{{item2.pageUrl}}\'}\" ng-if=\"item2.child.length == 0\" ng-click=sidebar.secondCheck(item2.idx)><i class=\"fa {{item2.icon}}\"></i> <span class=menuTx></span>{{item2.name}} </a><a ng-if=\"item2.child.length > 0\" ng-click=sidebar.secondCheck(item2.idx)><i class=\"fa {{item2.icon}}\"></i> <span class=menuTx>{{item2.name}}</span> <span class=\"fa arrow\"></span></a><ul ng-if=\"item2.child.length > 0\" class=\"nav nav-third-level\" uib-collapse=\"sidebar.secondCollapseVar!={{item2.idx}}\"><li ng-repeat=\"item3 in item2.child\" ng-class=\"{active: sidebar.threeCollapseVar==item3.idx}\"><a ui-sref={{item3.pageUrl}}{{item3.pageUrlParam}} ui-sref-opts=\"{reload:\'{{item3.pageUrl}}\'}\" ng-click=sidebar.threeCheck(item3.idx)><i class=\"fa {{item3.icon}}\"></i> <span class=menuTx>{{item3.name}}</span></a></li></ul></li></ul></li></ul><style>.side_bookmark{\r\n          border: 1px solid #aaa;\r\n          border-radius: 1em;\r\n          text-align: center;\r\n          background-color: #ffffff;\r\n          margin: 10px;\r\n          margin-top: 30px;\r\n          color: #000;\r\n          padding-bottom: 15px;\r\n        }\r\n        .sidebar_txt1 {\r\n          padding-top:10px;\r\n          font-size: medium;\r\n          font-weight: bold;\r\n        }\r\n        .sidebar_txt2 {\r\n          padding-top:15px;\r\n          padding-bottom:10px;\r\n          font-size: 8pt;\r\n          font-weight: bold;\r\n        }\r\n        .sidebar_txt3 {\r\n          padding:5px 0px 0px 13px;\r\n          text-align: left;\r\n          font-size: x-small;\r\n        }\r\n        .sidebar_txt4 {\r\n          padding:10px 0px 15px 15px;\r\n          text-align: left;\r\n          font-size: small;\r\n        }</style><div class=side_bookmark ng-if=\"sidebar.navMenuMdSizeState == \'l\'\"><div class=sidebar_txt1>상담 문의</div><div class=sidebar_txt2>유선상담시간 : 평일 10:00~16:00</div><div><div class=sidebar_txt3>서울, 경기, 수도권<br>02) 2644-0110 / 070-4241-9629</div><div class=sidebar_txt3>충청, 대전, 전라, 광주, 제주<br>010-2845-0151</div><div class=sidebar_txt3>부산, 경북, 경남, 울산, 대구<br>010-2844-0150</div></div><div class=sidebar_txt4>soswego@daum.net</div></div></div><!-- /.sidebar-collapse --></div>");
$templateCache.put("components/ui-component/layout/header/header-notification/header-notification.html","<ul class=\"nav navbar-top-links navbar-right\"><li class=dropdown><a href=\"\" ng-click=vc.goPage()><i class=\"fa fa-book fa-fw\"></i> 사례관리</a></li><li class=\"dropdown pull-right\"><a class=dropdown-toggle data-toggle=dropdown><i class=\"fa fa-user fa-fw\"></i> {{vc.user.UserName}} <i class=\"fa fa-caret-down\"></i></a><ul class=\"dropdown-menu dropdown-user\"><li ng-if=\"vc.tenantId != \'8LETQJJ81A\'\"><a href=\"\" ng-click=vc.myPage()><i class=\"fa fa-user fa-fw\"></i> 내 정보</a></li><li class=divider></li><li><a href=\"\" ng-click=vc.doLogout()><i class=\"fa fa-sign-out fa-fw\"></i> Logout</a></li></ul><!-- /.dropdown-user --></li><!-- /.dropdown --></ul>");
$templateCache.put("components/ui-component/layout/sidebar/sidebar-search/sidebar-search.html","<li class=sidebar-search><div class=\"input-group custom-search-form\"><input type=text class=form-control placeholder=Search...> <span class=input-group-btn><button class=\"btn btn-default\" type=button><i class=\"fa fa-search\"></i></button></span></div></li>");}]);